import * as React from "react";
import React__default, { useRef, useMemo as useMemo$1, useDebugValue, createElement, useContext, useEffect, createContext, Component, useState, isValidElement, useLayoutEffect as useLayoutEffect$1, forwardRef, Children, useCallback, useImperativeHandle } from "react";
import { useConfig as useConfig$1, QuotaMgtService, CWElementsI18NProvider, useTranslation, i18nInstance, CWElementsConfig, CWElementsSharedService, loadPackageTranslations, request } from "@cw-elements/config";
import { openMfe, useMfe, DYNAMIC_SLOT_CHANGE_PROPS, MFE_OPENED } from "@cw-elements/mfe-dynamic-slot";
import * as ReactDOM from "react-dom";
import ReactDOM__default, { createPortal, unstable_batchedUpdates, flushSync } from "react-dom";
const global$2 = typeof global < "u" ? global : typeof self < "u" ? self : typeof window < "u" ? window : {};
function defaultSetTimout() {
  throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
  throw new Error("clearTimeout has not been defined");
}
var cachedSetTimeout = defaultSetTimout, cachedClearTimeout = defaultClearTimeout;
typeof global$2.setTimeout == "function" && (cachedSetTimeout = setTimeout);
typeof global$2.clearTimeout == "function" && (cachedClearTimeout = clearTimeout);
function runTimeout(_t) {
  if (cachedSetTimeout === setTimeout)
    return setTimeout(_t, 0);
  if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout)
    return cachedSetTimeout = setTimeout, setTimeout(_t, 0);
  try {
    return cachedSetTimeout(_t, 0);
  } catch {
    try {
      return cachedSetTimeout.call(null, _t, 0);
    } catch {
      return cachedSetTimeout.call(this, _t, 0);
    }
  }
}
function runClearTimeout(_t) {
  if (cachedClearTimeout === clearTimeout)
    return clearTimeout(_t);
  if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout)
    return cachedClearTimeout = clearTimeout, clearTimeout(_t);
  try {
    return cachedClearTimeout(_t);
  } catch {
    try {
      return cachedClearTimeout.call(null, _t);
    } catch {
      return cachedClearTimeout.call(this, _t);
    }
  }
}
var queue = [], draining = !1, currentQueue, queueIndex = -1;
function cleanUpNextTick() {
  !draining || !currentQueue || (draining = !1, currentQueue.length ? queue = currentQueue.concat(queue) : queueIndex = -1, queue.length && drainQueue());
}
function drainQueue() {
  if (!draining) {
    var _t = runTimeout(cleanUpNextTick);
    draining = !0;
    for (var Et = queue.length; Et; ) {
      for (currentQueue = queue, queue = []; ++queueIndex < Et; )
        currentQueue && currentQueue[queueIndex].run();
      queueIndex = -1, Et = queue.length;
    }
    currentQueue = null, draining = !1, runClearTimeout(_t);
  }
}
function nextTick(_t) {
  var Et = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var Pt = 1; Pt < arguments.length; Pt++)
      Et[Pt - 1] = arguments[Pt];
  queue.push(new Item$1(_t, Et)), queue.length === 1 && !draining && runTimeout(drainQueue);
}
function Item$1(_t, Et) {
  this.fun = _t, this.array = Et;
}
Item$1.prototype.run = function() {
  this.fun.apply(null, this.array);
};
var title = "browser", platform$2 = "browser", browser = !0, env = {}, argv = [], version$2 = "", versions = {}, release = {}, config$2 = {};
function noop$5() {
}
var on = noop$5, addListener = noop$5, once = noop$5, off = noop$5, removeListener = noop$5, removeAllListeners = noop$5, emit = noop$5;
function binding(_t) {
  throw new Error("process.binding is not supported");
}
function cwd() {
  return "/";
}
function chdir(_t) {
  throw new Error("process.chdir is not supported");
}
function umask() {
  return 0;
}
var performance$1 = global$2.performance || {}, performanceNow = performance$1.now || performance$1.mozNow || performance$1.msNow || performance$1.oNow || performance$1.webkitNow || function() {
  return (/* @__PURE__ */ new Date()).getTime();
};
function hrtime(_t) {
  var Et = performanceNow.call(performance$1) * 1e-3, Pt = Math.floor(Et), $t = Math.floor(Et % 1 * 1e9);
  return _t && (Pt = Pt - _t[0], $t = $t - _t[1], $t < 0 && (Pt--, $t += 1e9)), [Pt, $t];
}
var startTime = /* @__PURE__ */ new Date();
function uptime() {
  var _t = /* @__PURE__ */ new Date(), Et = _t - startTime;
  return Et / 1e3;
}
var browser$1 = {
  nextTick,
  title,
  browser,
  env,
  argv,
  version: version$2,
  versions,
  on,
  addListener,
  once,
  off,
  removeListener,
  removeAllListeners,
  emit,
  binding,
  cwd,
  chdir,
  umask,
  hrtime,
  platform: platform$2,
  release,
  config: config$2,
  uptime
}, commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs(_t) {
  return _t && _t.__esModule && Object.prototype.hasOwnProperty.call(_t, "default") ? _t.default : _t;
}
var jsxRuntime = { exports: {} }, reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min)
    return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var _t = React__default, Et = Symbol.for("react.element"), Pt = Symbol.for("react.fragment"), $t = Object.prototype.hasOwnProperty, Mt = _t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, Bt = { key: !0, ref: !0, __self: !0, __source: !0 };
  function Vt(zt, Ht, Wt) {
    var Gt, qt = {}, Kt = null, Qt = null;
    Wt !== void 0 && (Kt = "" + Wt), Ht.key !== void 0 && (Kt = "" + Ht.key), Ht.ref !== void 0 && (Qt = Ht.ref);
    for (Gt in Ht)
      $t.call(Ht, Gt) && !Bt.hasOwnProperty(Gt) && (qt[Gt] = Ht[Gt]);
    if (zt && zt.defaultProps)
      for (Gt in Ht = zt.defaultProps, Ht)
        qt[Gt] === void 0 && (qt[Gt] = Ht[Gt]);
    return { $$typeof: Et, type: zt, key: Kt, ref: Qt, props: qt, _owner: Mt.current };
  }
  return reactJsxRuntime_production_min.Fragment = Pt, reactJsxRuntime_production_min.jsx = Vt, reactJsxRuntime_production_min.jsxs = Vt, reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {}, hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  return hasRequiredReactJsxRuntime_development || (hasRequiredReactJsxRuntime_development = 1, browser$1.env.NODE_ENV !== "production" && function() {
    var _t = React__default, Et = Symbol.for("react.element"), Pt = Symbol.for("react.portal"), $t = Symbol.for("react.fragment"), Mt = Symbol.for("react.strict_mode"), Bt = Symbol.for("react.profiler"), Vt = Symbol.for("react.provider"), zt = Symbol.for("react.context"), Ht = Symbol.for("react.forward_ref"), Wt = Symbol.for("react.suspense"), Gt = Symbol.for("react.suspense_list"), qt = Symbol.for("react.memo"), Kt = Symbol.for("react.lazy"), Qt = Symbol.for("react.offscreen"), Xt = Symbol.iterator, Zt = "@@iterator";
    function Yt(wr) {
      if (wr === null || typeof wr != "object")
        return null;
      var Vr = Xt && wr[Xt] || wr[Zt];
      return typeof Vr == "function" ? Vr : null;
    }
    var Jt = _t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function er(wr) {
      {
        for (var Vr = arguments.length, Yr = new Array(Vr > 1 ? Vr - 1 : 0), cn = 1; cn < Vr; cn++)
          Yr[cn - 1] = arguments[cn];
        tr("error", wr, Yr);
      }
    }
    function tr(wr, Vr, Yr) {
      {
        var cn = Jt.ReactDebugCurrentFrame, hn = cn.getStackAddendum();
        hn !== "" && (Vr += "%s", Yr = Yr.concat([hn]));
        var wn = Yr.map(function(pn) {
          return String(pn);
        });
        wn.unshift("Warning: " + Vr), Function.prototype.apply.call(console[wr], console, wn);
      }
    }
    var nr = !1, rr = !1, ir = !1, ar = !1, or = !1, sr;
    sr = Symbol.for("react.module.reference");
    function lr(wr) {
      return !!(typeof wr == "string" || typeof wr == "function" || wr === $t || wr === Bt || or || wr === Mt || wr === Wt || wr === Gt || ar || wr === Qt || nr || rr || ir || typeof wr == "object" && wr !== null && (wr.$$typeof === Kt || wr.$$typeof === qt || wr.$$typeof === Vt || wr.$$typeof === zt || wr.$$typeof === Ht || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      wr.$$typeof === sr || wr.getModuleId !== void 0));
    }
    function cr(wr, Vr, Yr) {
      var cn = wr.displayName;
      if (cn)
        return cn;
      var hn = Vr.displayName || Vr.name || "";
      return hn !== "" ? Yr + "(" + hn + ")" : Yr;
    }
    function hr(wr) {
      return wr.displayName || "Context";
    }
    function pr(wr) {
      if (wr == null)
        return null;
      if (typeof wr.tag == "number" && er("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof wr == "function")
        return wr.displayName || wr.name || null;
      if (typeof wr == "string")
        return wr;
      switch (wr) {
        case $t:
          return "Fragment";
        case Pt:
          return "Portal";
        case Bt:
          return "Profiler";
        case Mt:
          return "StrictMode";
        case Wt:
          return "Suspense";
        case Gt:
          return "SuspenseList";
      }
      if (typeof wr == "object")
        switch (wr.$$typeof) {
          case zt:
            var Vr = wr;
            return hr(Vr) + ".Consumer";
          case Vt:
            var Yr = wr;
            return hr(Yr._context) + ".Provider";
          case Ht:
            return cr(wr, wr.render, "ForwardRef");
          case qt:
            var cn = wr.displayName || null;
            return cn !== null ? cn : pr(wr.type) || "Memo";
          case Kt: {
            var hn = wr, wn = hn._payload, pn = hn._init;
            try {
              return pr(pn(wn));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var mr = Object.assign, Er = 0, _r, yr, ur, vr, dr, br, Cr;
    function Pr() {
    }
    Pr.__reactDisabledLog = !0;
    function xr() {
      {
        if (Er === 0) {
          _r = console.log, yr = console.info, ur = console.warn, vr = console.error, dr = console.group, br = console.groupCollapsed, Cr = console.groupEnd;
          var wr = {
            configurable: !0,
            enumerable: !0,
            value: Pr,
            writable: !0
          };
          Object.defineProperties(console, {
            info: wr,
            log: wr,
            warn: wr,
            error: wr,
            group: wr,
            groupCollapsed: wr,
            groupEnd: wr
          });
        }
        Er++;
      }
    }
    function kr() {
      {
        if (Er--, Er === 0) {
          var wr = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: mr({}, wr, {
              value: _r
            }),
            info: mr({}, wr, {
              value: yr
            }),
            warn: mr({}, wr, {
              value: ur
            }),
            error: mr({}, wr, {
              value: vr
            }),
            group: mr({}, wr, {
              value: dr
            }),
            groupCollapsed: mr({}, wr, {
              value: br
            }),
            groupEnd: mr({}, wr, {
              value: Cr
            })
          });
        }
        Er < 0 && er("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ir = Jt.ReactCurrentDispatcher, Ar;
    function Mr(wr, Vr, Yr) {
      {
        if (Ar === void 0)
          try {
            throw Error();
          } catch (hn) {
            var cn = hn.stack.trim().match(/\n( *(at )?)/);
            Ar = cn && cn[1] || "";
          }
        return `
` + Ar + wr;
      }
    }
    var Fr = !1, Dr;
    {
      var zr = typeof WeakMap == "function" ? WeakMap : Map;
      Dr = new zr();
    }
    function Tr(wr, Vr) {
      if (!wr || Fr)
        return "";
      {
        var Yr = Dr.get(wr);
        if (Yr !== void 0)
          return Yr;
      }
      var cn;
      Fr = !0;
      var hn = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var wn;
      wn = Ir.current, Ir.current = null, xr();
      try {
        if (Vr) {
          var pn = function() {
            throw Error();
          };
          if (Object.defineProperty(pn.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(pn, []);
            } catch (bn) {
              cn = bn;
            }
            Reflect.construct(wr, [], pn);
          } else {
            try {
              pn.call();
            } catch (bn) {
              cn = bn;
            }
            wr.call(pn.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (bn) {
            cn = bn;
          }
          wr();
        }
      } catch (bn) {
        if (bn && cn && typeof bn.stack == "string") {
          for (var fn = bn.stack.split(`
`), Bn = cn.stack.split(`
`), Rn = fn.length - 1, Sn = Bn.length - 1; Rn >= 1 && Sn >= 0 && fn[Rn] !== Bn[Sn]; )
            Sn--;
          for (; Rn >= 1 && Sn >= 0; Rn--, Sn--)
            if (fn[Rn] !== Bn[Sn]) {
              if (Rn !== 1 || Sn !== 1)
                do
                  if (Rn--, Sn--, Sn < 0 || fn[Rn] !== Bn[Sn]) {
                    var Kn = `
` + fn[Rn].replace(" at new ", " at ");
                    return wr.displayName && Kn.includes("<anonymous>") && (Kn = Kn.replace("<anonymous>", wr.displayName)), typeof wr == "function" && Dr.set(wr, Kn), Kn;
                  }
                while (Rn >= 1 && Sn >= 0);
              break;
            }
        }
      } finally {
        Fr = !1, Ir.current = wn, kr(), Error.prepareStackTrace = hn;
      }
      var Pn = wr ? wr.displayName || wr.name : "", sn = Pn ? Mr(Pn) : "";
      return typeof wr == "function" && Dr.set(wr, sn), sn;
    }
    function Gr(wr, Vr, Yr) {
      return Tr(wr, !1);
    }
    function $r(wr) {
      var Vr = wr.prototype;
      return !!(Vr && Vr.isReactComponent);
    }
    function Rr(wr, Vr, Yr) {
      if (wr == null)
        return "";
      if (typeof wr == "function")
        return Tr(wr, $r(wr));
      if (typeof wr == "string")
        return Mr(wr);
      switch (wr) {
        case Wt:
          return Mr("Suspense");
        case Gt:
          return Mr("SuspenseList");
      }
      if (typeof wr == "object")
        switch (wr.$$typeof) {
          case Ht:
            return Gr(wr.render);
          case qt:
            return Rr(wr.type, Vr, Yr);
          case Kt: {
            var cn = wr, hn = cn._payload, wn = cn._init;
            try {
              return Rr(wn(hn), Vr, Yr);
            } catch {
            }
          }
        }
      return "";
    }
    var Or = Object.prototype.hasOwnProperty, Lr = {}, Hr = Jt.ReactDebugCurrentFrame;
    function Wr(wr) {
      if (wr) {
        var Vr = wr._owner, Yr = Rr(wr.type, wr._source, Vr ? Vr.type : null);
        Hr.setExtraStackFrame(Yr);
      } else
        Hr.setExtraStackFrame(null);
    }
    function Kr(wr, Vr, Yr, cn, hn) {
      {
        var wn = Function.call.bind(Or);
        for (var pn in wr)
          if (wn(wr, pn)) {
            var fn = void 0;
            try {
              if (typeof wr[pn] != "function") {
                var Bn = Error((cn || "React class") + ": " + Yr + " type `" + pn + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof wr[pn] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Bn.name = "Invariant Violation", Bn;
              }
              fn = wr[pn](Vr, pn, cn, Yr, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Rn) {
              fn = Rn;
            }
            fn && !(fn instanceof Error) && (Wr(hn), er("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", cn || "React class", Yr, pn, typeof fn), Wr(null)), fn instanceof Error && !(fn.message in Lr) && (Lr[fn.message] = !0, Wr(hn), er("Failed %s type: %s", Yr, fn.message), Wr(null));
          }
      }
    }
    var Ur = Array.isArray;
    function Zr(wr) {
      return Ur(wr);
    }
    function Xr(wr) {
      {
        var Vr = typeof Symbol == "function" && Symbol.toStringTag, Yr = Vr && wr[Symbol.toStringTag] || wr.constructor.name || "Object";
        return Yr;
      }
    }
    function mn(wr) {
      try {
        return an(wr), !1;
      } catch {
        return !0;
      }
    }
    function an(wr) {
      return "" + wr;
    }
    function nn(wr) {
      if (mn(wr))
        return er("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Xr(wr)), an(wr);
    }
    var $n = Jt.ReactCurrentOwner, En = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, xn, qr, tn;
    tn = {};
    function gr(wr) {
      if (Or.call(wr, "ref")) {
        var Vr = Object.getOwnPropertyDescriptor(wr, "ref").get;
        if (Vr && Vr.isReactWarning)
          return !1;
      }
      return wr.ref !== void 0;
    }
    function Sr(wr) {
      if (Or.call(wr, "key")) {
        var Vr = Object.getOwnPropertyDescriptor(wr, "key").get;
        if (Vr && Vr.isReactWarning)
          return !1;
      }
      return wr.key !== void 0;
    }
    function Nr(wr, Vr) {
      if (typeof wr.ref == "string" && $n.current && Vr && $n.current.stateNode !== Vr) {
        var Yr = pr($n.current.type);
        tn[Yr] || (er('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', pr($n.current.type), wr.ref), tn[Yr] = !0);
      }
    }
    function jr(wr, Vr) {
      {
        var Yr = function() {
          xn || (xn = !0, er("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Vr));
        };
        Yr.isReactWarning = !0, Object.defineProperty(wr, "key", {
          get: Yr,
          configurable: !0
        });
      }
    }
    function Br(wr, Vr) {
      {
        var Yr = function() {
          qr || (qr = !0, er("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Vr));
        };
        Yr.isReactWarning = !0, Object.defineProperty(wr, "ref", {
          get: Yr,
          configurable: !0
        });
      }
    }
    var Qr = function(wr, Vr, Yr, cn, hn, wn, pn) {
      var fn = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: Et,
        // Built-in properties that belong on the element
        type: wr,
        key: Vr,
        ref: Yr,
        props: pn,
        // Record the component responsible for creating this element.
        _owner: wn
      };
      return fn._store = {}, Object.defineProperty(fn._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(fn, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: cn
      }), Object.defineProperty(fn, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: hn
      }), Object.freeze && (Object.freeze(fn.props), Object.freeze(fn)), fn;
    };
    function Jr(wr, Vr, Yr, cn, hn) {
      {
        var wn, pn = {}, fn = null, Bn = null;
        Yr !== void 0 && (nn(Yr), fn = "" + Yr), Sr(Vr) && (nn(Vr.key), fn = "" + Vr.key), gr(Vr) && (Bn = Vr.ref, Nr(Vr, hn));
        for (wn in Vr)
          Or.call(Vr, wn) && !En.hasOwnProperty(wn) && (pn[wn] = Vr[wn]);
        if (wr && wr.defaultProps) {
          var Rn = wr.defaultProps;
          for (wn in Rn)
            pn[wn] === void 0 && (pn[wn] = Rn[wn]);
        }
        if (fn || Bn) {
          var Sn = typeof wr == "function" ? wr.displayName || wr.name || "Unknown" : wr;
          fn && jr(pn, Sn), Bn && Br(pn, Sn);
        }
        return Qr(wr, fn, Bn, hn, cn, $n.current, pn);
      }
    }
    var gn = Jt.ReactCurrentOwner, yn = Jt.ReactDebugCurrentFrame;
    function _n(wr) {
      if (wr) {
        var Vr = wr._owner, Yr = Rr(wr.type, wr._source, Vr ? Vr.type : null);
        yn.setExtraStackFrame(Yr);
      } else
        yn.setExtraStackFrame(null);
    }
    var In;
    In = !1;
    function Tn(wr) {
      return typeof wr == "object" && wr !== null && wr.$$typeof === Et;
    }
    function kn() {
      {
        if (gn.current) {
          var wr = pr(gn.current.type);
          if (wr)
            return `

Check the render method of \`` + wr + "`.";
        }
        return "";
      }
    }
    function jn(wr) {
      return "";
    }
    var An = {};
    function un(wr) {
      {
        var Vr = kn();
        if (!Vr) {
          var Yr = typeof wr == "string" ? wr : wr.displayName || wr.name;
          Yr && (Vr = `

Check the top-level render call using <` + Yr + ">.");
        }
        return Vr;
      }
    }
    function rn(wr, Vr) {
      {
        if (!wr._store || wr._store.validated || wr.key != null)
          return;
        wr._store.validated = !0;
        var Yr = un(Vr);
        if (An[Yr])
          return;
        An[Yr] = !0;
        var cn = "";
        wr && wr._owner && wr._owner !== gn.current && (cn = " It was passed a child from " + pr(wr._owner.type) + "."), _n(wr), er('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Yr, cn), _n(null);
      }
    }
    function dn(wr, Vr) {
      {
        if (typeof wr != "object")
          return;
        if (Zr(wr))
          for (var Yr = 0; Yr < wr.length; Yr++) {
            var cn = wr[Yr];
            Tn(cn) && rn(cn, Vr);
          }
        else if (Tn(wr))
          wr._store && (wr._store.validated = !0);
        else if (wr) {
          var hn = Yt(wr);
          if (typeof hn == "function" && hn !== wr.entries)
            for (var wn = hn.call(wr), pn; !(pn = wn.next()).done; )
              Tn(pn.value) && rn(pn.value, Vr);
        }
      }
    }
    function Mn(wr) {
      {
        var Vr = wr.type;
        if (Vr == null || typeof Vr == "string")
          return;
        var Yr;
        if (typeof Vr == "function")
          Yr = Vr.propTypes;
        else if (typeof Vr == "object" && (Vr.$$typeof === Ht || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        Vr.$$typeof === qt))
          Yr = Vr.propTypes;
        else
          return;
        if (Yr) {
          var cn = pr(Vr);
          Kr(Yr, wr.props, "prop", cn, wr);
        } else if (Vr.PropTypes !== void 0 && !In) {
          In = !0;
          var hn = pr(Vr);
          er("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", hn || "Unknown");
        }
        typeof Vr.getDefaultProps == "function" && !Vr.getDefaultProps.isReactClassApproved && er("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function On(wr) {
      {
        for (var Vr = Object.keys(wr.props), Yr = 0; Yr < Vr.length; Yr++) {
          var cn = Vr[Yr];
          if (cn !== "children" && cn !== "key") {
            _n(wr), er("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", cn), _n(null);
            break;
          }
        }
        wr.ref !== null && (_n(wr), er("Invalid attribute `ref` supplied to `React.Fragment`."), _n(null));
      }
    }
    var Dn = {};
    function Yn(wr, Vr, Yr, cn, hn, wn) {
      {
        var pn = lr(wr);
        if (!pn) {
          var fn = "";
          (wr === void 0 || typeof wr == "object" && wr !== null && Object.keys(wr).length === 0) && (fn += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Bn = jn();
          Bn ? fn += Bn : fn += kn();
          var Rn;
          wr === null ? Rn = "null" : Zr(wr) ? Rn = "array" : wr !== void 0 && wr.$$typeof === Et ? (Rn = "<" + (pr(wr.type) || "Unknown") + " />", fn = " Did you accidentally export a JSX literal instead of a component?") : Rn = typeof wr, er("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Rn, fn);
        }
        var Sn = Jr(wr, Vr, Yr, hn, wn);
        if (Sn == null)
          return Sn;
        if (pn) {
          var Kn = Vr.children;
          if (Kn !== void 0)
            if (cn)
              if (Zr(Kn)) {
                for (var Pn = 0; Pn < Kn.length; Pn++)
                  dn(Kn[Pn], wr);
                Object.freeze && Object.freeze(Kn);
              } else
                er("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              dn(Kn, wr);
        }
        if (Or.call(Vr, "key")) {
          var sn = pr(wr), bn = Object.keys(Vr).filter(function(qn) {
            return qn !== "key";
          }), Ln = bn.length > 0 ? "{key: someKey, " + bn.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Dn[sn + Ln]) {
            var Wn = bn.length > 0 ? "{" + bn.join(": ..., ") + ": ...}" : "{}";
            er(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ln, sn, Wn, sn), Dn[sn + Ln] = !0;
          }
        }
        return wr === $t ? On(Sn) : Mn(Sn), Sn;
      }
    }
    function ra(wr, Vr, Yr) {
      return Yn(wr, Vr, Yr, !0);
    }
    function Fn(wr, Vr, Yr) {
      return Yn(wr, Vr, Yr, !1);
    }
    var Nn = Fn, Hn = ra;
    reactJsxRuntime_development.Fragment = $t, reactJsxRuntime_development.jsx = Nn, reactJsxRuntime_development.jsxs = Hn;
  }()), reactJsxRuntime_development;
}
browser$1.env.NODE_ENV === "production" ? jsxRuntime.exports = requireReactJsxRuntime_production_min() : jsxRuntime.exports = requireReactJsxRuntime_development();
var jsxRuntimeExports = jsxRuntime.exports, extendStatics$1 = function(_t, Et) {
  return extendStatics$1 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Pt, $t) {
    Pt.__proto__ = $t;
  } || function(Pt, $t) {
    for (var Mt in $t)
      Object.prototype.hasOwnProperty.call($t, Mt) && (Pt[Mt] = $t[Mt]);
  }, extendStatics$1(_t, Et);
};
function __extends$1(_t, Et) {
  if (typeof Et != "function" && Et !== null)
    throw new TypeError("Class extends value " + String(Et) + " is not a constructor or null");
  extendStatics$1(_t, Et);
  function Pt() {
    this.constructor = _t;
  }
  _t.prototype = Et === null ? Object.create(Et) : (Pt.prototype = Et.prototype, new Pt());
}
var __assign$3 = function() {
  return __assign$3 = Object.assign || function(Et) {
    for (var Pt, $t = 1, Mt = arguments.length; $t < Mt; $t++) {
      Pt = arguments[$t];
      for (var Bt in Pt)
        Object.prototype.hasOwnProperty.call(Pt, Bt) && (Et[Bt] = Pt[Bt]);
    }
    return Et;
  }, __assign$3.apply(this, arguments);
};
function __rest$g(_t, Et) {
  var Pt = {};
  for (var $t in _t)
    Object.prototype.hasOwnProperty.call(_t, $t) && Et.indexOf($t) < 0 && (Pt[$t] = _t[$t]);
  if (_t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var Mt = 0, $t = Object.getOwnPropertySymbols(_t); Mt < $t.length; Mt++)
      Et.indexOf($t[Mt]) < 0 && Object.prototype.propertyIsEnumerable.call(_t, $t[Mt]) && (Pt[$t[Mt]] = _t[$t[Mt]]);
  return Pt;
}
function __awaiter$1(_t, Et, Pt, $t) {
  function Mt(Bt) {
    return Bt instanceof Pt ? Bt : new Pt(function(Vt) {
      Vt(Bt);
    });
  }
  return new (Pt || (Pt = Promise))(function(Bt, Vt) {
    function zt(Gt) {
      try {
        Wt($t.next(Gt));
      } catch (qt) {
        Vt(qt);
      }
    }
    function Ht(Gt) {
      try {
        Wt($t.throw(Gt));
      } catch (qt) {
        Vt(qt);
      }
    }
    function Wt(Gt) {
      Gt.done ? Bt(Gt.value) : Mt(Gt.value).then(zt, Ht);
    }
    Wt(($t = $t.apply(_t, Et || [])).next());
  });
}
function __generator$1(_t, Et) {
  var Pt = { label: 0, sent: function() {
    if (Bt[0] & 1)
      throw Bt[1];
    return Bt[1];
  }, trys: [], ops: [] }, $t, Mt, Bt, Vt;
  return Vt = { next: zt(0), throw: zt(1), return: zt(2) }, typeof Symbol == "function" && (Vt[Symbol.iterator] = function() {
    return this;
  }), Vt;
  function zt(Wt) {
    return function(Gt) {
      return Ht([Wt, Gt]);
    };
  }
  function Ht(Wt) {
    if ($t)
      throw new TypeError("Generator is already executing.");
    for (; Vt && (Vt = 0, Wt[0] && (Pt = 0)), Pt; )
      try {
        if ($t = 1, Mt && (Bt = Wt[0] & 2 ? Mt.return : Wt[0] ? Mt.throw || ((Bt = Mt.return) && Bt.call(Mt), 0) : Mt.next) && !(Bt = Bt.call(Mt, Wt[1])).done)
          return Bt;
        switch (Mt = 0, Bt && (Wt = [Wt[0] & 2, Bt.value]), Wt[0]) {
          case 0:
          case 1:
            Bt = Wt;
            break;
          case 4:
            return Pt.label++, { value: Wt[1], done: !1 };
          case 5:
            Pt.label++, Mt = Wt[1], Wt = [0];
            continue;
          case 7:
            Wt = Pt.ops.pop(), Pt.trys.pop();
            continue;
          default:
            if (Bt = Pt.trys, !(Bt = Bt.length > 0 && Bt[Bt.length - 1]) && (Wt[0] === 6 || Wt[0] === 2)) {
              Pt = 0;
              continue;
            }
            if (Wt[0] === 3 && (!Bt || Wt[1] > Bt[0] && Wt[1] < Bt[3])) {
              Pt.label = Wt[1];
              break;
            }
            if (Wt[0] === 6 && Pt.label < Bt[1]) {
              Pt.label = Bt[1], Bt = Wt;
              break;
            }
            if (Bt && Pt.label < Bt[2]) {
              Pt.label = Bt[2], Pt.ops.push(Wt);
              break;
            }
            Bt[2] && Pt.ops.pop(), Pt.trys.pop();
            continue;
        }
        Wt = Et.call(_t, Pt);
      } catch (Gt) {
        Wt = [6, Gt], Mt = 0;
      } finally {
        $t = Bt = 0;
      }
    if (Wt[0] & 5)
      throw Wt[1];
    return { value: Wt[0] ? Wt[1] : void 0, done: !0 };
  }
}
function __values(_t) {
  var Et = typeof Symbol == "function" && Symbol.iterator, Pt = Et && _t[Et], $t = 0;
  if (Pt)
    return Pt.call(_t);
  if (_t && typeof _t.length == "number")
    return {
      next: function() {
        return _t && $t >= _t.length && (_t = void 0), { value: _t && _t[$t++], done: !_t };
      }
    };
  throw new TypeError(Et ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(_t, Et) {
  var Pt = typeof Symbol == "function" && _t[Symbol.iterator];
  if (!Pt)
    return _t;
  var $t = Pt.call(_t), Mt, Bt = [], Vt;
  try {
    for (; (Et === void 0 || Et-- > 0) && !(Mt = $t.next()).done; )
      Bt.push(Mt.value);
  } catch (zt) {
    Vt = { error: zt };
  } finally {
    try {
      Mt && !Mt.done && (Pt = $t.return) && Pt.call($t);
    } finally {
      if (Vt)
        throw Vt.error;
    }
  }
  return Bt;
}
function __spreadArray$1(_t, Et, Pt) {
  if (Pt || arguments.length === 2)
    for (var $t = 0, Mt = Et.length, Bt; $t < Mt; $t++)
      (Bt || !($t in Et)) && (Bt || (Bt = Array.prototype.slice.call(Et, 0, $t)), Bt[$t] = Et[$t]);
  return _t.concat(Bt || Array.prototype.slice.call(Et));
}
function __await(_t) {
  return this instanceof __await ? (this.v = _t, this) : new __await(_t);
}
function __asyncGenerator(_t, Et, Pt) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var $t = Pt.apply(_t, Et || []), Mt, Bt = [];
  return Mt = {}, zt("next"), zt("throw"), zt("return", Vt), Mt[Symbol.asyncIterator] = function() {
    return this;
  }, Mt;
  function Vt(Qt) {
    return function(Xt) {
      return Promise.resolve(Xt).then(Qt, qt);
    };
  }
  function zt(Qt, Xt) {
    $t[Qt] && (Mt[Qt] = function(Zt) {
      return new Promise(function(Yt, Jt) {
        Bt.push([Qt, Zt, Yt, Jt]) > 1 || Ht(Qt, Zt);
      });
    }, Xt && (Mt[Qt] = Xt(Mt[Qt])));
  }
  function Ht(Qt, Xt) {
    try {
      Wt($t[Qt](Xt));
    } catch (Zt) {
      Kt(Bt[0][3], Zt);
    }
  }
  function Wt(Qt) {
    Qt.value instanceof __await ? Promise.resolve(Qt.value.v).then(Gt, qt) : Kt(Bt[0][2], Qt);
  }
  function Gt(Qt) {
    Ht("next", Qt);
  }
  function qt(Qt) {
    Ht("throw", Qt);
  }
  function Kt(Qt, Xt) {
    Qt(Xt), Bt.shift(), Bt.length && Ht(Bt[0][0], Bt[0][1]);
  }
}
function __asyncValues(_t) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var Et = _t[Symbol.asyncIterator], Pt;
  return Et ? Et.call(_t) : (_t = typeof __values == "function" ? __values(_t) : _t[Symbol.iterator](), Pt = {}, $t("next"), $t("throw"), $t("return"), Pt[Symbol.asyncIterator] = function() {
    return this;
  }, Pt);
  function $t(Bt) {
    Pt[Bt] = _t[Bt] && function(Vt) {
      return new Promise(function(zt, Ht) {
        Vt = _t[Bt](Vt), Mt(zt, Ht, Vt.done, Vt.value);
      });
    };
  }
  function Mt(Bt, Vt, zt, Ht) {
    Promise.resolve(Ht).then(function(Wt) {
      Bt({ value: Wt, done: zt });
    }, Vt);
  }
}
typeof SuppressedError == "function" && SuppressedError;
var SUCCESS_MESSAGE = "Event tracked successfully", UNEXPECTED_ERROR_MESSAGE$1 = "Unexpected error occurred", MAX_RETRIES_EXCEEDED_MESSAGE$1 = "Event rejected due to exceeded retry count", OPT_OUT_MESSAGE = "Event skipped due to optOut config", MISSING_API_KEY_MESSAGE = "Event rejected due to missing API key", INVALID_API_KEY = "Invalid API key", CLIENT_NOT_INITIALIZED = "Client not initialized", IdentifyOperation;
(function(_t) {
  _t.SET = "$set", _t.SET_ONCE = "$setOnce", _t.ADD = "$add", _t.APPEND = "$append", _t.PREPEND = "$prepend", _t.REMOVE = "$remove", _t.PREINSERT = "$preInsert", _t.POSTINSERT = "$postInsert", _t.UNSET = "$unset", _t.CLEAR_ALL = "$clearAll";
})(IdentifyOperation || (IdentifyOperation = {}));
var RevenueProperty;
(function(_t) {
  _t.REVENUE_PRODUCT_ID = "$productId", _t.REVENUE_QUANTITY = "$quantity", _t.REVENUE_PRICE = "$price", _t.REVENUE_TYPE = "$revenueType", _t.REVENUE = "$revenue";
})(RevenueProperty || (RevenueProperty = {}));
var SpecialEventType;
(function(_t) {
  _t.IDENTIFY = "$identify", _t.GROUP_IDENTIFY = "$groupidentify", _t.REVENUE = "revenue_amount";
})(SpecialEventType || (SpecialEventType = {}));
var LogLevel;
(function(_t) {
  _t[_t.None = 0] = "None", _t[_t.Error = 1] = "Error", _t[_t.Warn = 2] = "Warn", _t[_t.Verbose = 3] = "Verbose", _t[_t.Debug = 4] = "Debug";
})(LogLevel || (LogLevel = {}));
var ServerZone;
(function(_t) {
  _t.US = "US", _t.EU = "EU";
})(ServerZone || (ServerZone = {}));
var Status;
(function(_t) {
  _t.Unknown = "unknown", _t.Skipped = "skipped", _t.Success = "success", _t.RateLimit = "rate_limit", _t.PayloadTooLarge = "payload_too_large", _t.Invalid = "invalid", _t.Failed = "failed", _t.Timeout = "Timeout", _t.SystemError = "SystemError";
})(Status || (Status = {}));
var OfflineDisabled = null, DEFAULT_CSS_SELECTOR_ALLOWLIST = [
  "a",
  "button",
  "input",
  "select",
  "textarea",
  "label",
  "video",
  "audio",
  '[contenteditable="true" i]',
  "[data-amp-default-track]",
  ".amp-default-track"
], DEFAULT_DATA_ATTRIBUTE_PREFIX = "data-amp-track-", DEFAULT_ACTION_CLICK_ALLOWLIST = ["div", "span", "h1", "h2", "h3", "h4", "h5", "h6"], buildResult = function(_t, Et, Pt) {
  return Et === void 0 && (Et = 0), Pt === void 0 && (Pt = Status.Unknown), { event: _t, code: Et, message: Pt };
}, UUID = function(_t) {
  return _t ? (
    // a random number from 0 to 15
    (_t ^ // unless b is 8,
    Math.random() * // in which case
    16 >> // a random number from
    _t / 4).toString(16)
  ) : (
    // or otherwise a concatenated string:
    (String(1e7) + // 10000000 +
    String(-1e3) + // -1000 +
    String(-4e3) + // -4000 +
    String(-8e3) + // -80000000 +
    String(-1e11)).replace(
      // replacing
      /[018]/g,
      // zeroes, ones, and eights with
      UUID
    )
  );
}, Timeline = (
  /** @class */
  function() {
    function _t(Et) {
      this.client = Et, this.queue = [], this.applying = !1, this.plugins = [];
    }
    return _t.prototype.register = function(Et, Pt) {
      var $t, Mt;
      return __awaiter$1(this, void 0, void 0, function() {
        return __generator$1(this, function(Bt) {
          switch (Bt.label) {
            case 0:
              return this.plugins.some(function(Vt) {
                return Vt.name === Et.name;
              }) ? (Pt.loggerProvider.warn("Plugin with name ".concat(Et.name, " already exists, skipping registration")), [
                2
                /*return*/
              ]) : (Et.name === void 0 && (Et.name = UUID(), Pt.loggerProvider.warn(`Plugin name is undefined. 
      Generating a random UUID for plugin name: `.concat(Et.name, `. 
      Set a name for the plugin to prevent it from being added multiple times.`))), Et.type = ($t = Et.type) !== null && $t !== void 0 ? $t : "enrichment", [4, (Mt = Et.setup) === null || Mt === void 0 ? void 0 : Mt.call(Et, Pt, this.client)]);
            case 1:
              return Bt.sent(), this.plugins.push(Et), [
                2
                /*return*/
              ];
          }
        });
      });
    }, _t.prototype.deregister = function(Et) {
      var Pt;
      return __awaiter$1(this, void 0, void 0, function() {
        var $t, Mt;
        return __generator$1(this, function(Bt) {
          switch (Bt.label) {
            case 0:
              return $t = this.plugins.findIndex(function(Vt) {
                return Vt.name === Et;
              }), Mt = this.plugins[$t], this.plugins.splice($t, 1), [4, (Pt = Mt.teardown) === null || Pt === void 0 ? void 0 : Pt.call(Mt)];
            case 1:
              return Bt.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, _t.prototype.reset = function(Et) {
      this.applying = !1;
      var Pt = this.plugins;
      Pt.map(function($t) {
        var Mt;
        return (Mt = $t.teardown) === null || Mt === void 0 ? void 0 : Mt.call($t);
      }), this.plugins = [], this.client = Et;
    }, _t.prototype.push = function(Et) {
      var Pt = this;
      return new Promise(function($t) {
        Pt.queue.push([Et, $t]), Pt.scheduleApply(0);
      });
    }, _t.prototype.scheduleApply = function(Et) {
      var Pt = this;
      this.applying || (this.applying = !0, setTimeout(function() {
        Pt.apply(Pt.queue.shift()).then(function() {
          Pt.applying = !1, Pt.queue.length > 0 && Pt.scheduleApply(0);
        });
      }, Et));
    }, _t.prototype.apply = function(Et) {
      return __awaiter$1(this, void 0, void 0, function() {
        var Pt, $t, Mt, Bt, Vt, zt, Ht, Qt, Xt, Wt, Gt, qt, Kt, Qt, Xt, Zt, Yt, Jt, er, tr, nr, rr;
        return __generator$1(this, function(ir) {
          switch (ir.label) {
            case 0:
              if (!Et)
                return [
                  2
                  /*return*/
                ];
              Pt = __read(Et, 1), $t = Pt[0], Mt = __read(Et, 2), Bt = Mt[1], Vt = this.plugins.filter(function(ar) {
                return ar.type === "before";
              }), ir.label = 1;
            case 1:
              ir.trys.push([1, 6, 7, 8]), zt = __values(Vt), Ht = zt.next(), ir.label = 2;
            case 2:
              return Ht.done ? [3, 5] : (Qt = Ht.value, Qt.execute ? [4, Qt.execute(__assign$3({}, $t))] : [3, 4]);
            case 3:
              if (Xt = ir.sent(), Xt === null)
                return Bt({ event: $t, code: 0, message: "" }), [
                  2
                  /*return*/
                ];
              $t = Xt, ir.label = 4;
            case 4:
              return Ht = zt.next(), [3, 2];
            case 5:
              return [3, 8];
            case 6:
              return Wt = ir.sent(), er = { error: Wt }, [3, 8];
            case 7:
              try {
                Ht && !Ht.done && (tr = zt.return) && tr.call(zt);
              } finally {
                if (er)
                  throw er.error;
              }
              return [
                7
                /*endfinally*/
              ];
            case 8:
              Gt = this.plugins.filter(function(ar) {
                return ar.type === "enrichment" || ar.type === void 0;
              }), ir.label = 9;
            case 9:
              ir.trys.push([9, 14, 15, 16]), qt = __values(Gt), Kt = qt.next(), ir.label = 10;
            case 10:
              return Kt.done ? [3, 13] : (Qt = Kt.value, Qt.execute ? [4, Qt.execute(__assign$3({}, $t))] : [3, 12]);
            case 11:
              if (Xt = ir.sent(), Xt === null)
                return Bt({ event: $t, code: 0, message: "" }), [
                  2
                  /*return*/
                ];
              $t = Xt, ir.label = 12;
            case 12:
              return Kt = qt.next(), [3, 10];
            case 13:
              return [3, 16];
            case 14:
              return Zt = ir.sent(), nr = { error: Zt }, [3, 16];
            case 15:
              try {
                Kt && !Kt.done && (rr = qt.return) && rr.call(qt);
              } finally {
                if (nr)
                  throw nr.error;
              }
              return [
                7
                /*endfinally*/
              ];
            case 16:
              return Yt = this.plugins.filter(function(ar) {
                return ar.type === "destination";
              }), Jt = Yt.map(function(ar) {
                var or = __assign$3({}, $t);
                return ar.execute(or).catch(function(sr) {
                  return buildResult(or, 0, String(sr));
                });
              }), Promise.all(Jt).then(function(ar) {
                var or = __read(ar, 1), sr = or[0], lr = sr || buildResult($t, 100, "Event not tracked, no destination plugins on the instance");
                Bt(lr);
              }), [
                2
                /*return*/
              ];
          }
        });
      });
    }, _t.prototype.flush = function() {
      return __awaiter$1(this, void 0, void 0, function() {
        var Et, Pt, $t, Mt = this;
        return __generator$1(this, function(Bt) {
          switch (Bt.label) {
            case 0:
              return Et = this.queue, this.queue = [], [4, Promise.all(Et.map(function(Vt) {
                return Mt.apply(Vt);
              }))];
            case 1:
              return Bt.sent(), Pt = this.plugins.filter(function(Vt) {
                return Vt.type === "destination";
              }), $t = Pt.map(function(Vt) {
                return Vt.flush && Vt.flush();
              }), [4, Promise.all($t)];
            case 2:
              return Bt.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, _t;
  }()
), UNSET_VALUE = "-", AMPLITUDE_PREFIX = "AMP", STORAGE_PREFIX = "".concat(AMPLITUDE_PREFIX, "_unsent"), AMPLITUDE_SERVER_URL = "https://api2.amplitude.com/2/httpapi", EU_AMPLITUDE_SERVER_URL = "https://api.eu.amplitude.com/2/httpapi", AMPLITUDE_BATCH_SERVER_URL = "https://api2.amplitude.com/batch", EU_AMPLITUDE_BATCH_SERVER_URL = "https://api.eu.amplitude.com/batch", MAX_PROPERTY_KEYS = 1e3, isValidObject = function(_t) {
  if (Object.keys(_t).length > MAX_PROPERTY_KEYS)
    return !1;
  for (var Et in _t) {
    var Pt = _t[Et];
    if (!isValidProperties(Et, Pt))
      return !1;
  }
  return !0;
}, isValidProperties = function(_t, Et) {
  var Pt, $t;
  if (typeof _t != "string")
    return !1;
  if (Array.isArray(Et)) {
    var Mt = !0;
    try {
      for (var Bt = __values(Et), Vt = Bt.next(); !Vt.done; Vt = Bt.next()) {
        var zt = Vt.value;
        if (Array.isArray(zt))
          return !1;
        if (typeof zt == "object")
          Mt = Mt && isValidObject(zt);
        else if (!["number", "string"].includes(typeof zt))
          return !1;
        if (!Mt)
          return !1;
      }
    } catch (Ht) {
      Pt = { error: Ht };
    } finally {
      try {
        Vt && !Vt.done && ($t = Bt.return) && $t.call(Bt);
      } finally {
        if (Pt)
          throw Pt.error;
      }
    }
  } else {
    if (Et == null)
      return !1;
    if (typeof Et == "object")
      return isValidObject(Et);
    if (!["number", "string", "boolean"].includes(typeof Et))
      return !1;
  }
  return !0;
}, Identify = (
  /** @class */
  function() {
    function _t() {
      this._propertySet = /* @__PURE__ */ new Set(), this._properties = {};
    }
    return _t.prototype.getUserProperties = function() {
      return __assign$3({}, this._properties);
    }, _t.prototype.set = function(Et, Pt) {
      return this._safeSet(IdentifyOperation.SET, Et, Pt), this;
    }, _t.prototype.setOnce = function(Et, Pt) {
      return this._safeSet(IdentifyOperation.SET_ONCE, Et, Pt), this;
    }, _t.prototype.append = function(Et, Pt) {
      return this._safeSet(IdentifyOperation.APPEND, Et, Pt), this;
    }, _t.prototype.prepend = function(Et, Pt) {
      return this._safeSet(IdentifyOperation.PREPEND, Et, Pt), this;
    }, _t.prototype.postInsert = function(Et, Pt) {
      return this._safeSet(IdentifyOperation.POSTINSERT, Et, Pt), this;
    }, _t.prototype.preInsert = function(Et, Pt) {
      return this._safeSet(IdentifyOperation.PREINSERT, Et, Pt), this;
    }, _t.prototype.remove = function(Et, Pt) {
      return this._safeSet(IdentifyOperation.REMOVE, Et, Pt), this;
    }, _t.prototype.add = function(Et, Pt) {
      return this._safeSet(IdentifyOperation.ADD, Et, Pt), this;
    }, _t.prototype.unset = function(Et) {
      return this._safeSet(IdentifyOperation.UNSET, Et, UNSET_VALUE), this;
    }, _t.prototype.clearAll = function() {
      return this._properties = {}, this._properties[IdentifyOperation.CLEAR_ALL] = UNSET_VALUE, this;
    }, _t.prototype._safeSet = function(Et, Pt, $t) {
      if (this._validate(Et, Pt, $t)) {
        var Mt = this._properties[Et];
        return Mt === void 0 && (Mt = {}, this._properties[Et] = Mt), Mt[Pt] = $t, this._propertySet.add(Pt), !0;
      }
      return !1;
    }, _t.prototype._validate = function(Et, Pt, $t) {
      return this._properties[IdentifyOperation.CLEAR_ALL] !== void 0 || this._propertySet.has(Pt) ? !1 : Et === IdentifyOperation.ADD ? typeof $t == "number" : Et !== IdentifyOperation.UNSET && Et !== IdentifyOperation.REMOVE ? isValidProperties(Pt, $t) : !0;
    }, _t;
  }()
), createTrackEvent = function(_t, Et, Pt) {
  var $t = typeof _t == "string" ? { event_type: _t } : _t;
  return __assign$3(__assign$3(__assign$3({}, $t), Pt), Et && { event_properties: Et });
}, createIdentifyEvent = function(_t, Et) {
  var Pt = __assign$3(__assign$3({}, Et), { event_type: SpecialEventType.IDENTIFY, user_properties: _t.getUserProperties() });
  return Pt;
}, createGroupIdentifyEvent = function(_t, Et, Pt, $t) {
  var Mt, Bt = __assign$3(__assign$3({}, $t), { event_type: SpecialEventType.GROUP_IDENTIFY, group_properties: Pt.getUserProperties(), groups: (Mt = {}, Mt[_t] = Et, Mt) });
  return Bt;
}, createGroupEvent = function(_t, Et, Pt) {
  var $t, Mt = new Identify();
  Mt.set(_t, Et);
  var Bt = __assign$3(__assign$3({}, Pt), { event_type: SpecialEventType.IDENTIFY, user_properties: Mt.getUserProperties(), groups: ($t = {}, $t[_t] = Et, $t) });
  return Bt;
}, createRevenueEvent = function(_t, Et) {
  return __assign$3(__assign$3({}, Et), { event_type: SpecialEventType.REVENUE, event_properties: _t.getEventProperties() });
}, returnWrapper = function(_t) {
  return {
    promise: _t || Promise.resolve()
  };
}, AmplitudeCore = (
  /** @class */
  function() {
    function _t(Et) {
      Et === void 0 && (Et = "$default"), this.initializing = !1, this.isReady = !1, this.q = [], this.dispatchQ = [], this.logEvent = this.track.bind(this), this.timeline = new Timeline(this), this.name = Et;
    }
    return _t.prototype._init = function(Et) {
      return __awaiter$1(this, void 0, void 0, function() {
        return __generator$1(this, function(Pt) {
          switch (Pt.label) {
            case 0:
              return this.config = Et, this.timeline.reset(this), [4, this.runQueuedFunctions("q")];
            case 1:
              return Pt.sent(), this.isReady = !0, [
                2
                /*return*/
              ];
          }
        });
      });
    }, _t.prototype.runQueuedFunctions = function(Et) {
      return __awaiter$1(this, void 0, void 0, function() {
        var Pt, $t, Mt, Bt, Vt, zt, Ht, Wt;
        return __generator$1(this, function(Gt) {
          switch (Gt.label) {
            case 0:
              Pt = this[Et], this[Et] = [], Gt.label = 1;
            case 1:
              Gt.trys.push([1, 8, 9, 10]), $t = __values(Pt), Mt = $t.next(), Gt.label = 2;
            case 2:
              return Mt.done ? [3, 7] : (Bt = Mt.value, Vt = Bt(), Vt && "promise" in Vt ? [4, Vt.promise] : [3, 4]);
            case 3:
              return Gt.sent(), [3, 6];
            case 4:
              return [4, Vt];
            case 5:
              Gt.sent(), Gt.label = 6;
            case 6:
              return Mt = $t.next(), [3, 2];
            case 7:
              return [3, 10];
            case 8:
              return zt = Gt.sent(), Ht = { error: zt }, [3, 10];
            case 9:
              try {
                Mt && !Mt.done && (Wt = $t.return) && Wt.call($t);
              } finally {
                if (Ht)
                  throw Ht.error;
              }
              return [
                7
                /*endfinally*/
              ];
            case 10:
              return this[Et].length ? [4, this.runQueuedFunctions(Et)] : [3, 12];
            case 11:
              Gt.sent(), Gt.label = 12;
            case 12:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, _t.prototype.track = function(Et, Pt, $t) {
      var Mt = createTrackEvent(Et, Pt, $t);
      return returnWrapper(this.dispatch(Mt));
    }, _t.prototype.identify = function(Et, Pt) {
      var $t = createIdentifyEvent(Et, Pt);
      return returnWrapper(this.dispatch($t));
    }, _t.prototype.groupIdentify = function(Et, Pt, $t, Mt) {
      var Bt = createGroupIdentifyEvent(Et, Pt, $t, Mt);
      return returnWrapper(this.dispatch(Bt));
    }, _t.prototype.setGroup = function(Et, Pt, $t) {
      var Mt = createGroupEvent(Et, Pt, $t);
      return returnWrapper(this.dispatch(Mt));
    }, _t.prototype.revenue = function(Et, Pt) {
      var $t = createRevenueEvent(Et, Pt);
      return returnWrapper(this.dispatch($t));
    }, _t.prototype.add = function(Et) {
      return this.isReady ? this._addPlugin(Et) : (this.q.push(this._addPlugin.bind(this, Et)), returnWrapper());
    }, _t.prototype._addPlugin = function(Et) {
      return returnWrapper(this.timeline.register(Et, this.config));
    }, _t.prototype.remove = function(Et) {
      return this.isReady ? this._removePlugin(Et) : (this.q.push(this._removePlugin.bind(this, Et)), returnWrapper());
    }, _t.prototype._removePlugin = function(Et) {
      return returnWrapper(this.timeline.deregister(Et));
    }, _t.prototype.dispatchWithCallback = function(Et, Pt) {
      if (!this.isReady)
        return Pt(buildResult(Et, 0, CLIENT_NOT_INITIALIZED));
      this.process(Et).then(Pt);
    }, _t.prototype.dispatch = function(Et) {
      return __awaiter$1(this, void 0, void 0, function() {
        var Pt = this;
        return __generator$1(this, function($t) {
          return this.isReady ? [2, this.process(Et)] : [2, new Promise(function(Mt) {
            Pt.dispatchQ.push(Pt.dispatchWithCallback.bind(Pt, Et, Mt));
          })];
        });
      });
    }, _t.prototype.process = function(Et) {
      return __awaiter$1(this, void 0, void 0, function() {
        var Mt, Pt, $t, Mt;
        return __generator$1(this, function(Bt) {
          switch (Bt.label) {
            case 0:
              return Bt.trys.push([0, 2, , 3]), this.config.optOut ? [2, buildResult(Et, 0, OPT_OUT_MESSAGE)] : [4, this.timeline.push(Et)];
            case 1:
              return Mt = Bt.sent(), Mt.code === 200 ? this.config.loggerProvider.log(Mt.message) : Mt.code === 100 ? this.config.loggerProvider.warn(Mt.message) : this.config.loggerProvider.error(Mt.message), [2, Mt];
            case 2:
              return Pt = Bt.sent(), $t = String(Pt), this.config.loggerProvider.error($t), Mt = buildResult(Et, 0, $t), [2, Mt];
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, _t.prototype.setOptOut = function(Et) {
      if (!this.isReady) {
        this.q.push(this._setOptOut.bind(this, !!Et));
        return;
      }
      this._setOptOut(Et);
    }, _t.prototype._setOptOut = function(Et) {
      this.config.optOut = !!Et;
    }, _t.prototype.flush = function() {
      return returnWrapper(this.timeline.flush());
    }, _t;
  }()
), Revenue = (
  /** @class */
  function() {
    function _t() {
      this.productId = "", this.quantity = 1, this.price = 0;
    }
    return _t.prototype.setProductId = function(Et) {
      return this.productId = Et, this;
    }, _t.prototype.setQuantity = function(Et) {
      return Et > 0 && (this.quantity = Et), this;
    }, _t.prototype.setPrice = function(Et) {
      return this.price = Et, this;
    }, _t.prototype.setRevenueType = function(Et) {
      return this.revenueType = Et, this;
    }, _t.prototype.setRevenue = function(Et) {
      return this.revenue = Et, this;
    }, _t.prototype.setEventProperties = function(Et) {
      return isValidObject(Et) && (this.properties = Et), this;
    }, _t.prototype.getEventProperties = function() {
      var Et = this.properties ? __assign$3({}, this.properties) : {};
      return Et[RevenueProperty.REVENUE_PRODUCT_ID] = this.productId, Et[RevenueProperty.REVENUE_QUANTITY] = this.quantity, Et[RevenueProperty.REVENUE_PRICE] = this.price, Et[RevenueProperty.REVENUE_TYPE] = this.revenueType, Et[RevenueProperty.REVENUE] = this.revenue, Et;
    }, _t;
  }()
), chunk = function(_t, Et) {
  var Pt = Math.max(Et, 1);
  return _t.reduce(function($t, Mt, Bt) {
    var Vt = Math.floor(Bt / Pt);
    return $t[Vt] || ($t[Vt] = []), $t[Vt].push(Mt), $t;
  }, []);
}, PREFIX = "Amplitude Logger ", Logger = (
  /** @class */
  function() {
    function _t() {
      this.logLevel = LogLevel.None;
    }
    return _t.prototype.disable = function() {
      this.logLevel = LogLevel.None;
    }, _t.prototype.enable = function(Et) {
      Et === void 0 && (Et = LogLevel.Warn), this.logLevel = Et;
    }, _t.prototype.log = function() {
      for (var Et = [], Pt = 0; Pt < arguments.length; Pt++)
        Et[Pt] = arguments[Pt];
      this.logLevel < LogLevel.Verbose || console.log("".concat(PREFIX, "[Log]: ").concat(Et.join(" ")));
    }, _t.prototype.warn = function() {
      for (var Et = [], Pt = 0; Pt < arguments.length; Pt++)
        Et[Pt] = arguments[Pt];
      this.logLevel < LogLevel.Warn || console.warn("".concat(PREFIX, "[Warn]: ").concat(Et.join(" ")));
    }, _t.prototype.error = function() {
      for (var Et = [], Pt = 0; Pt < arguments.length; Pt++)
        Et[Pt] = arguments[Pt];
      this.logLevel < LogLevel.Error || console.error("".concat(PREFIX, "[Error]: ").concat(Et.join(" ")));
    }, _t.prototype.debug = function() {
      for (var Et = [], Pt = 0; Pt < arguments.length; Pt++)
        Et[Pt] = arguments[Pt];
      this.logLevel < LogLevel.Debug || console.log("".concat(PREFIX, "[Debug]: ").concat(Et.join(" ")));
    }, _t;
  }()
), getDefaultConfig = function() {
  return {
    flushMaxRetries: 12,
    flushQueueSize: 200,
    flushIntervalMillis: 1e4,
    instanceName: "$default_instance",
    logLevel: LogLevel.Warn,
    loggerProvider: new Logger(),
    offline: !1,
    optOut: !1,
    serverUrl: AMPLITUDE_SERVER_URL,
    serverZone: "US",
    useBatch: !1
  };
}, Config = (
  /** @class */
  function() {
    function _t(Et) {
      var Pt, $t, Mt, Bt;
      this._optOut = !1;
      var Vt = getDefaultConfig();
      this.apiKey = Et.apiKey, this.flushIntervalMillis = (Pt = Et.flushIntervalMillis) !== null && Pt !== void 0 ? Pt : Vt.flushIntervalMillis, this.flushMaxRetries = Et.flushMaxRetries || Vt.flushMaxRetries, this.flushQueueSize = Et.flushQueueSize || Vt.flushQueueSize, this.instanceName = Et.instanceName || Vt.instanceName, this.loggerProvider = Et.loggerProvider || Vt.loggerProvider, this.logLevel = ($t = Et.logLevel) !== null && $t !== void 0 ? $t : Vt.logLevel, this.minIdLength = Et.minIdLength, this.plan = Et.plan, this.ingestionMetadata = Et.ingestionMetadata, this.offline = Et.offline !== void 0 ? Et.offline : Vt.offline, this.optOut = (Mt = Et.optOut) !== null && Mt !== void 0 ? Mt : Vt.optOut, this.serverUrl = Et.serverUrl, this.serverZone = Et.serverZone || Vt.serverZone, this.storageProvider = Et.storageProvider, this.transportProvider = Et.transportProvider, this.useBatch = (Bt = Et.useBatch) !== null && Bt !== void 0 ? Bt : Vt.useBatch, this.loggerProvider.enable(this.logLevel);
      var zt = createServerConfig(Et.serverUrl, Et.serverZone, Et.useBatch);
      this.serverZone = zt.serverZone, this.serverUrl = zt.serverUrl;
    }
    return Object.defineProperty(_t.prototype, "optOut", {
      get: function() {
        return this._optOut;
      },
      set: function(Et) {
        this._optOut = Et;
      },
      enumerable: !1,
      configurable: !0
    }), _t;
  }()
), getServerUrl = function(_t, Et) {
  return _t === "EU" ? Et ? EU_AMPLITUDE_BATCH_SERVER_URL : EU_AMPLITUDE_SERVER_URL : Et ? AMPLITUDE_BATCH_SERVER_URL : AMPLITUDE_SERVER_URL;
}, createServerConfig = function(_t, Et, Pt) {
  if (_t === void 0 && (_t = ""), Et === void 0 && (Et = getDefaultConfig().serverZone), Pt === void 0 && (Pt = getDefaultConfig().useBatch), _t)
    return { serverUrl: _t, serverZone: void 0 };
  var $t = ["US", "EU"].includes(Et) ? Et : getDefaultConfig().serverZone;
  return {
    serverZone: $t,
    serverUrl: getServerUrl($t, Pt)
  };
}, RequestMetadata = (
  /** @class */
  function() {
    function _t() {
      this.sdk = {
        metrics: {
          histogram: {}
        }
      };
    }
    return _t.prototype.recordHistogram = function(Et, Pt) {
      this.sdk.metrics.histogram[Et] = Pt;
    }, _t;
  }()
);
function getErrorMessage(_t) {
  return _t instanceof Error ? _t.message : String(_t);
}
function getResponseBodyString(_t) {
  var Et = "";
  try {
    "body" in _t && (Et = JSON.stringify(_t.body, null, 2));
  } catch {
  }
  return Et;
}
var Destination = (
  /** @class */
  function() {
    function _t() {
      this.name = "amplitude", this.type = "destination", this.retryTimeout = 1e3, this.throttleTimeout = 3e4, this.storageKey = "", this.scheduled = null, this.queue = [];
    }
    return _t.prototype.setup = function(Et) {
      var Pt;
      return __awaiter$1(this, void 0, void 0, function() {
        var $t, Mt = this;
        return __generator$1(this, function(Bt) {
          switch (Bt.label) {
            case 0:
              return this.config = Et, this.storageKey = "".concat(STORAGE_PREFIX, "_").concat(this.config.apiKey.substring(0, 10)), [4, (Pt = this.config.storageProvider) === null || Pt === void 0 ? void 0 : Pt.get(this.storageKey)];
            case 1:
              return $t = Bt.sent(), $t && $t.length > 0 && Promise.all($t.map(function(Vt) {
                return Mt.execute(Vt);
              })).catch(), [2, Promise.resolve(void 0)];
          }
        });
      });
    }, _t.prototype.execute = function(Et) {
      var Pt = this;
      return Et.insert_id || (Et.insert_id = UUID()), new Promise(function($t) {
        var Mt = {
          event: Et,
          attempts: 0,
          callback: function(Bt) {
            return $t(Bt);
          },
          timeout: 0
        };
        Pt.addToQueue(Mt);
      });
    }, _t.prototype.getTryableList = function(Et) {
      var Pt = this;
      return Et.filter(function($t) {
        return $t.attempts < Pt.config.flushMaxRetries ? ($t.attempts += 1, !0) : (Pt.fulfillRequest([$t], 500, MAX_RETRIES_EXCEEDED_MESSAGE$1), !1);
      });
    }, _t.prototype.scheduleTryable = function(Et, Pt) {
      var $t = this;
      Pt === void 0 && (Pt = !1), Et.forEach(function(Mt) {
        if (Pt && ($t.queue = $t.queue.concat(Mt)), Mt.timeout === 0) {
          $t.schedule($t.config.flushIntervalMillis);
          return;
        }
        setTimeout(function() {
          Mt.timeout = 0, $t.schedule(0);
        }, Mt.timeout);
      });
    }, _t.prototype.addToQueue = function() {
      for (var Et = [], Pt = 0; Pt < arguments.length; Pt++)
        Et[Pt] = arguments[Pt];
      var $t = this.getTryableList(Et);
      this.scheduleTryable($t, !0), this.saveEvents();
    }, _t.prototype.schedule = function(Et) {
      var Pt = this;
      this.scheduled || this.config.offline || (this.scheduled = setTimeout(function() {
        Pt.flush(!0).then(function() {
          Pt.queue.length > 0 && Pt.schedule(Et);
        });
      }, Et));
    }, _t.prototype.flush = function(Et) {
      return Et === void 0 && (Et = !1), __awaiter$1(this, void 0, void 0, function() {
        var Pt, $t, Mt, Bt = this;
        return __generator$1(this, function(Vt) {
          switch (Vt.label) {
            case 0:
              return this.config.offline ? (this.config.loggerProvider.debug("Skipping flush while offline."), [
                2
                /*return*/
              ]) : (Pt = [], $t = [], this.queue.forEach(function(zt) {
                return zt.timeout === 0 ? Pt.push(zt) : $t.push(zt);
              }), this.scheduled && (clearTimeout(this.scheduled), this.scheduled = null), Mt = chunk(Pt, this.config.flushQueueSize), [4, Promise.all(Mt.map(function(zt) {
                return Bt.send(zt, Et);
              }))]);
            case 1:
              return Vt.sent(), this.scheduleTryable($t), [
                2
                /*return*/
              ];
          }
        });
      });
    }, _t.prototype.send = function(Et, Pt) {
      return Pt === void 0 && (Pt = !0), __awaiter$1(this, void 0, void 0, function() {
        var $t, Mt, Bt, Vt, zt;
        return __generator$1(this, function(Ht) {
          switch (Ht.label) {
            case 0:
              if (!this.config.apiKey)
                return [2, this.fulfillRequest(Et, 400, MISSING_API_KEY_MESSAGE)];
              $t = {
                api_key: this.config.apiKey,
                events: Et.map(function(Wt) {
                  var Gt = Wt.event;
                  Gt.extra;
                  var qt = __rest$g(Gt, ["extra"]);
                  return qt;
                }),
                options: {
                  min_id_length: this.config.minIdLength
                },
                client_upload_time: (/* @__PURE__ */ new Date()).toISOString(),
                request_metadata: this.config.requestMetadata
              }, this.config.requestMetadata = new RequestMetadata(), Ht.label = 1;
            case 1:
              return Ht.trys.push([1, 3, , 4]), Mt = createServerConfig(this.config.serverUrl, this.config.serverZone, this.config.useBatch).serverUrl, [4, this.config.transportProvider.send(Mt, $t)];
            case 2:
              return Bt = Ht.sent(), Bt === null ? (this.fulfillRequest(Et, 0, UNEXPECTED_ERROR_MESSAGE$1), [
                2
                /*return*/
              ]) : Pt ? (this.handleResponse(Bt, Et), [3, 4]) : ("body" in Bt ? this.fulfillRequest(Et, Bt.statusCode, "".concat(Bt.status, ": ").concat(getResponseBodyString(Bt))) : this.fulfillRequest(Et, Bt.statusCode, Bt.status), [
                2
                /*return*/
              ]);
            case 3:
              return Vt = Ht.sent(), zt = getErrorMessage(Vt), this.config.loggerProvider.error(zt), this.handleResponse({ status: Status.Failed, statusCode: 0 }, Et), [3, 4];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, _t.prototype.handleResponse = function(Et, Pt) {
      var $t = Et.status;
      switch ($t) {
        case Status.Success: {
          this.handleSuccessResponse(Et, Pt);
          break;
        }
        case Status.Invalid: {
          this.handleInvalidResponse(Et, Pt);
          break;
        }
        case Status.PayloadTooLarge: {
          this.handlePayloadTooLargeResponse(Et, Pt);
          break;
        }
        case Status.RateLimit: {
          this.handleRateLimitResponse(Et, Pt);
          break;
        }
        default: {
          this.config.loggerProvider.warn(`{code: 0, error: "Status '`.concat($t, "' provided for ").concat(Pt.length, ' events"}')), this.handleOtherResponse(Pt);
          break;
        }
      }
    }, _t.prototype.handleSuccessResponse = function(Et, Pt) {
      this.fulfillRequest(Pt, Et.statusCode, SUCCESS_MESSAGE);
    }, _t.prototype.handleInvalidResponse = function(Et, Pt) {
      var $t = this;
      if (Et.body.missingField || Et.body.error.startsWith(INVALID_API_KEY)) {
        this.fulfillRequest(Pt, Et.statusCode, Et.body.error);
        return;
      }
      var Mt = __spreadArray$1(__spreadArray$1(__spreadArray$1(__spreadArray$1([], __read(Object.values(Et.body.eventsWithInvalidFields)), !1), __read(Object.values(Et.body.eventsWithMissingFields)), !1), __read(Object.values(Et.body.eventsWithInvalidIdLengths)), !1), __read(Et.body.silencedEvents), !1).flat(), Bt = new Set(Mt), Vt = Pt.filter(function(Ht, Wt) {
        if (Bt.has(Wt)) {
          $t.fulfillRequest([Ht], Et.statusCode, Et.body.error);
          return;
        }
        return !0;
      });
      Vt.length > 0 && this.config.loggerProvider.warn(getResponseBodyString(Et));
      var zt = this.getTryableList(Vt);
      this.scheduleTryable(zt);
    }, _t.prototype.handlePayloadTooLargeResponse = function(Et, Pt) {
      if (Pt.length === 1) {
        this.fulfillRequest(Pt, Et.statusCode, Et.body.error);
        return;
      }
      this.config.loggerProvider.warn(getResponseBodyString(Et)), this.config.flushQueueSize /= 2;
      var $t = this.getTryableList(Pt);
      this.scheduleTryable($t);
    }, _t.prototype.handleRateLimitResponse = function(Et, Pt) {
      var $t = this, Mt = Object.keys(Et.body.exceededDailyQuotaUsers), Bt = Object.keys(Et.body.exceededDailyQuotaDevices), Vt = Et.body.throttledEvents, zt = new Set(Mt), Ht = new Set(Bt), Wt = new Set(Vt), Gt = Pt.filter(function(Kt, Qt) {
        if (Kt.event.user_id && zt.has(Kt.event.user_id) || Kt.event.device_id && Ht.has(Kt.event.device_id)) {
          $t.fulfillRequest([Kt], Et.statusCode, Et.body.error);
          return;
        }
        return Wt.has(Qt) && (Kt.timeout = $t.throttleTimeout), !0;
      });
      Gt.length > 0 && this.config.loggerProvider.warn(getResponseBodyString(Et));
      var qt = this.getTryableList(Gt);
      this.scheduleTryable(qt);
    }, _t.prototype.handleOtherResponse = function(Et) {
      var Pt = this, $t = Et.map(function(Bt) {
        return Bt.timeout = Bt.attempts * Pt.retryTimeout, Bt;
      }), Mt = this.getTryableList($t);
      this.scheduleTryable(Mt);
    }, _t.prototype.fulfillRequest = function(Et, Pt, $t) {
      this.removeEvents(Et), Et.forEach(function(Mt) {
        return Mt.callback(buildResult(Mt.event, Pt, $t));
      });
    }, _t.prototype.saveEvents = function() {
      if (this.config.storageProvider) {
        var Et = this.queue.map(function(Pt) {
          return Pt.event;
        });
        this.config.storageProvider.set(this.storageKey, Et);
      }
    }, _t.prototype.removeEvents = function(Et) {
      this.queue = this.queue.filter(function(Pt) {
        return !Et.some(function($t) {
          return $t.event.insert_id === Pt.event.insert_id;
        });
      }), this.saveEvents();
    }, _t;
  }()
), getStacktrace = function(_t) {
  var Et = new Error().stack || "";
  return Et.split(`
`).slice(2 + _t).map(function(Pt) {
    return Pt.trim();
  });
}, getClientLogConfig = function(_t) {
  return function() {
    var Et = __assign$3({}, _t.config), Pt = Et.loggerProvider, $t = Et.logLevel;
    return {
      logger: Pt,
      logLevel: $t
    };
  };
}, getValueByStringPath = function(_t, Et) {
  var Pt, $t;
  Et = Et.replace(/\[(\w+)\]/g, ".$1"), Et = Et.replace(/^\./, "");
  try {
    for (var Mt = __values(Et.split(".")), Bt = Mt.next(); !Bt.done; Bt = Mt.next()) {
      var Vt = Bt.value;
      if (Vt in _t)
        _t = _t[Vt];
      else
        return;
    }
  } catch (zt) {
    Pt = { error: zt };
  } finally {
    try {
      Bt && !Bt.done && ($t = Mt.return) && $t.call(Mt);
    } finally {
      if (Pt)
        throw Pt.error;
    }
  }
  return _t;
}, getClientStates = function(_t, Et) {
  return function() {
    var Pt, $t, Mt = {};
    try {
      for (var Bt = __values(Et), Vt = Bt.next(); !Vt.done; Vt = Bt.next()) {
        var zt = Vt.value;
        Mt[zt] = getValueByStringPath(_t, zt);
      }
    } catch (Ht) {
      Pt = { error: Ht };
    } finally {
      try {
        Vt && !Vt.done && ($t = Bt.return) && $t.call(Bt);
      } finally {
        if (Pt)
          throw Pt.error;
      }
    }
    return Mt;
  };
}, debugWrapper = function(_t, Et, Pt, $t, Mt) {
  return Mt === void 0 && (Mt = null), function() {
    for (var Bt = [], Vt = 0; Vt < arguments.length; Vt++)
      Bt[Vt] = arguments[Vt];
    var zt = Pt(), Ht = zt.logger, Wt = zt.logLevel;
    if (Wt && Wt < LogLevel.Debug || !Wt || !Ht)
      return _t.apply(Mt, Bt);
    var Gt = {
      type: "invoke public method",
      name: Et,
      args: Bt,
      stacktrace: getStacktrace(1),
      time: {
        start: (/* @__PURE__ */ new Date()).toISOString()
      },
      states: {}
    };
    $t && Gt.states && (Gt.states.before = $t());
    var qt = _t.apply(Mt, Bt);
    return qt && qt.promise ? qt.promise.then(function() {
      $t && Gt.states && (Gt.states.after = $t()), Gt.time && (Gt.time.end = (/* @__PURE__ */ new Date()).toISOString()), Ht.debug(JSON.stringify(Gt, null, 2));
    }) : ($t && Gt.states && (Gt.states.after = $t()), Gt.time && (Gt.time.end = (/* @__PURE__ */ new Date()).toISOString()), Ht.debug(JSON.stringify(Gt, null, 2))), qt;
  };
}, MemoryStorage = (
  /** @class */
  function() {
    function _t() {
      this.memoryStorage = /* @__PURE__ */ new Map();
    }
    return _t.prototype.isEnabled = function() {
      return __awaiter$1(this, void 0, void 0, function() {
        return __generator$1(this, function(Et) {
          return [2, !0];
        });
      });
    }, _t.prototype.get = function(Et) {
      return __awaiter$1(this, void 0, void 0, function() {
        return __generator$1(this, function(Pt) {
          return [2, this.memoryStorage.get(Et)];
        });
      });
    }, _t.prototype.getRaw = function(Et) {
      return __awaiter$1(this, void 0, void 0, function() {
        var Pt;
        return __generator$1(this, function($t) {
          switch ($t.label) {
            case 0:
              return [4, this.get(Et)];
            case 1:
              return Pt = $t.sent(), [2, Pt ? JSON.stringify(Pt) : void 0];
          }
        });
      });
    }, _t.prototype.set = function(Et, Pt) {
      return __awaiter$1(this, void 0, void 0, function() {
        return __generator$1(this, function($t) {
          return this.memoryStorage.set(Et, Pt), [
            2
            /*return*/
          ];
        });
      });
    }, _t.prototype.remove = function(Et) {
      return __awaiter$1(this, void 0, void 0, function() {
        return __generator$1(this, function(Pt) {
          return this.memoryStorage.delete(Et), [
            2
            /*return*/
          ];
        });
      });
    }, _t.prototype.reset = function() {
      return __awaiter$1(this, void 0, void 0, function() {
        return __generator$1(this, function(Et) {
          return this.memoryStorage.clear(), [
            2
            /*return*/
          ];
        });
      });
    }, _t;
  }()
), BaseTransport = (
  /** @class */
  function() {
    function _t() {
    }
    return _t.prototype.send = function(Et, Pt) {
      return Promise.resolve(null);
    }, _t.prototype.buildResponse = function(Et) {
      var Pt, $t, Mt, Bt, Vt, zt, Ht, Wt, Gt, qt, Kt, Qt, Xt, Zt, Yt, Jt, er, tr, nr, rr, ir, ar;
      if (typeof Et != "object")
        return null;
      var or = Et.code || 0, sr = this.buildStatus(or);
      switch (sr) {
        case Status.Success:
          return {
            status: sr,
            statusCode: or,
            body: {
              eventsIngested: (Pt = Et.events_ingested) !== null && Pt !== void 0 ? Pt : 0,
              payloadSizeBytes: ($t = Et.payload_size_bytes) !== null && $t !== void 0 ? $t : 0,
              serverUploadTime: (Mt = Et.server_upload_time) !== null && Mt !== void 0 ? Mt : 0
            }
          };
        case Status.Invalid:
          return {
            status: sr,
            statusCode: or,
            body: {
              error: (Bt = Et.error) !== null && Bt !== void 0 ? Bt : "",
              missingField: (Vt = Et.missing_field) !== null && Vt !== void 0 ? Vt : "",
              eventsWithInvalidFields: (zt = Et.events_with_invalid_fields) !== null && zt !== void 0 ? zt : {},
              eventsWithMissingFields: (Ht = Et.events_with_missing_fields) !== null && Ht !== void 0 ? Ht : {},
              eventsWithInvalidIdLengths: (Wt = Et.events_with_invalid_id_lengths) !== null && Wt !== void 0 ? Wt : {},
              epsThreshold: (Gt = Et.eps_threshold) !== null && Gt !== void 0 ? Gt : 0,
              exceededDailyQuotaDevices: (qt = Et.exceeded_daily_quota_devices) !== null && qt !== void 0 ? qt : {},
              silencedDevices: (Kt = Et.silenced_devices) !== null && Kt !== void 0 ? Kt : [],
              silencedEvents: (Qt = Et.silenced_events) !== null && Qt !== void 0 ? Qt : [],
              throttledDevices: (Xt = Et.throttled_devices) !== null && Xt !== void 0 ? Xt : {},
              throttledEvents: (Zt = Et.throttled_events) !== null && Zt !== void 0 ? Zt : []
            }
          };
        case Status.PayloadTooLarge:
          return {
            status: sr,
            statusCode: or,
            body: {
              error: (Yt = Et.error) !== null && Yt !== void 0 ? Yt : ""
            }
          };
        case Status.RateLimit:
          return {
            status: sr,
            statusCode: or,
            body: {
              error: (Jt = Et.error) !== null && Jt !== void 0 ? Jt : "",
              epsThreshold: (er = Et.eps_threshold) !== null && er !== void 0 ? er : 0,
              throttledDevices: (tr = Et.throttled_devices) !== null && tr !== void 0 ? tr : {},
              throttledUsers: (nr = Et.throttled_users) !== null && nr !== void 0 ? nr : {},
              exceededDailyQuotaDevices: (rr = Et.exceeded_daily_quota_devices) !== null && rr !== void 0 ? rr : {},
              exceededDailyQuotaUsers: (ir = Et.exceeded_daily_quota_users) !== null && ir !== void 0 ? ir : {},
              throttledEvents: (ar = Et.throttled_events) !== null && ar !== void 0 ? ar : []
            }
          };
        case Status.Timeout:
        default:
          return {
            status: sr,
            statusCode: or
          };
      }
    }, _t.prototype.buildStatus = function(Et) {
      return Et >= 200 && Et < 300 ? Status.Success : Et === 429 ? Status.RateLimit : Et === 413 ? Status.PayloadTooLarge : Et === 408 ? Status.Timeout : Et >= 400 && Et < 500 ? Status.Invalid : Et >= 500 ? Status.Failed : Status.Unknown;
    }, _t;
  }()
), getGlobalScope = function() {
  var _t = "ampIntegrationContext";
  if (typeof globalThis < "u" && typeof globalThis[_t] < "u")
    return globalThis[_t];
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof window < "u")
    return window;
  if (typeof self < "u")
    return self;
  if (typeof global$2 < "u")
    return global$2;
}, getQueryParams = function() {
  var _t, Et = getGlobalScope();
  if (!(!((_t = Et == null ? void 0 : Et.location) === null || _t === void 0) && _t.search))
    return {};
  var Pt = Et.location.search.substring(1).split("&").filter(Boolean), $t = Pt.reduce(function(Mt, Bt) {
    var Vt = Bt.split("=", 2), zt = tryDecodeURIComponent(Vt[0]), Ht = tryDecodeURIComponent(Vt[1]);
    return Ht && (Mt[zt] = Ht), Mt;
  }, {});
  return $t;
}, tryDecodeURIComponent = function(_t) {
  _t === void 0 && (_t = "");
  try {
    return decodeURIComponent(_t);
  } catch {
    return "";
  }
}, UTM_CAMPAIGN = "utm_campaign", UTM_CONTENT = "utm_content", UTM_ID = "utm_id", UTM_MEDIUM = "utm_medium", UTM_SOURCE = "utm_source", UTM_TERM = "utm_term", DCLID = "dclid", FBCLID = "fbclid", GBRAID = "gbraid", GCLID = "gclid", KO_CLICK_ID = "ko_click_id", LI_FAT_ID = "li_fat_id", MSCLKID = "msclkid", RDT_CID = "rtd_cid", TTCLID = "ttclid", TWCLID = "twclid", WBRAID = "wbraid", BASE_CAMPAIGN = {
  utm_campaign: void 0,
  utm_content: void 0,
  utm_id: void 0,
  utm_medium: void 0,
  utm_source: void 0,
  utm_term: void 0,
  referrer: void 0,
  referring_domain: void 0,
  dclid: void 0,
  gbraid: void 0,
  gclid: void 0,
  fbclid: void 0,
  ko_click_id: void 0,
  li_fat_id: void 0,
  msclkid: void 0,
  rtd_cid: void 0,
  ttclid: void 0,
  twclid: void 0,
  wbraid: void 0
}, CampaignParser = (
  /** @class */
  function() {
    function _t() {
    }
    return _t.prototype.parse = function() {
      return __awaiter$1(this, void 0, void 0, function() {
        return __generator$1(this, function(Et) {
          return [2, __assign$3(__assign$3(__assign$3(__assign$3({}, BASE_CAMPAIGN), this.getUtmParam()), this.getReferrer()), this.getClickIds())];
        });
      });
    }, _t.prototype.getUtmParam = function() {
      var Et = getQueryParams(), Pt = Et[UTM_CAMPAIGN], $t = Et[UTM_CONTENT], Mt = Et[UTM_ID], Bt = Et[UTM_MEDIUM], Vt = Et[UTM_SOURCE], zt = Et[UTM_TERM];
      return {
        utm_campaign: Pt,
        utm_content: $t,
        utm_id: Mt,
        utm_medium: Bt,
        utm_source: Vt,
        utm_term: zt
      };
    }, _t.prototype.getReferrer = function() {
      var Et, Pt, $t = {
        referrer: void 0,
        referring_domain: void 0
      };
      try {
        $t.referrer = document.referrer || void 0, $t.referring_domain = (Pt = (Et = $t.referrer) === null || Et === void 0 ? void 0 : Et.split("/")[2]) !== null && Pt !== void 0 ? Pt : void 0;
      } catch {
      }
      return $t;
    }, _t.prototype.getClickIds = function() {
      var Et, Pt = getQueryParams();
      return Et = {}, Et[DCLID] = Pt[DCLID], Et[FBCLID] = Pt[FBCLID], Et[GBRAID] = Pt[GBRAID], Et[GCLID] = Pt[GCLID], Et[KO_CLICK_ID] = Pt[KO_CLICK_ID], Et[LI_FAT_ID] = Pt[LI_FAT_ID], Et[MSCLKID] = Pt[MSCLKID], Et[RDT_CID] = Pt[RDT_CID], Et[TTCLID] = Pt[TTCLID], Et[TWCLID] = Pt[TWCLID], Et[WBRAID] = Pt[WBRAID], Et;
    }, _t;
  }()
), getCookieName = function(_t, Et, Pt) {
  return Et === void 0 && (Et = ""), Pt === void 0 && (Pt = 10), [AMPLITUDE_PREFIX, Et, _t.substring(0, Pt)].filter(Boolean).join("_");
}, getOldCookieName = function(_t) {
  return "".concat(AMPLITUDE_PREFIX.toLowerCase(), "_").concat(_t.substring(0, 6));
}, domainWithoutSubdomain = function(_t) {
  var Et = _t.split(".");
  return Et.length <= 2 ? _t : Et.slice(Et.length - 2, Et.length).join(".");
}, isDirectTraffic = function(_t) {
  return Object.values(_t).every(function(Et) {
    return !Et;
  });
}, isNewCampaign = function(_t, Et, Pt, $t) {
  $t === void 0 && ($t = !0), _t.referrer;
  var Mt = _t.referring_domain, Bt = __rest$g(_t, ["referrer", "referring_domain"]), Vt = Et || {};
  Vt.referrer;
  var zt = Vt.referring_domain, Ht = __rest$g(Vt, ["referrer", "referring_domain"]);
  if (isExcludedReferrer(Pt.excludeReferrers, _t.referring_domain) || !$t && isDirectTraffic(_t) && Et)
    return !1;
  var Wt = JSON.stringify(Bt) !== JSON.stringify(Ht), Gt = domainWithoutSubdomain(Mt || "") !== domainWithoutSubdomain(zt || "");
  return !Et || Wt || Gt;
}, isExcludedReferrer = function(_t, Et) {
  return _t === void 0 && (_t = []), Et === void 0 && (Et = ""), _t.some(function(Pt) {
    return Pt instanceof RegExp ? Pt.test(Et) : Pt === Et;
  });
}, createCampaignEvent = function(_t, Et) {
  var Pt = __assign$3(__assign$3({}, BASE_CAMPAIGN), _t), $t = Object.entries(Pt).reduce(function(Mt, Bt) {
    var Vt, zt = __read(Bt, 2), Ht = zt[0], Wt = zt[1];
    return Mt.setOnce("initial_".concat(Ht), (Vt = Wt ?? Et.initialEmptyValue) !== null && Vt !== void 0 ? Vt : "EMPTY"), Wt ? Mt.set(Ht, Wt) : Mt.unset(Ht);
  }, new Identify());
  return createIdentifyEvent($t);
}, getDefaultExcludedReferrers = function(_t) {
  var Et = _t;
  return Et ? (Et.startsWith(".") && (Et = Et.substring(1)), [new RegExp("".concat(Et.replace(".", "\\."), "$"))]) : [];
}, getStorageKey = function(_t, Et, Pt) {
  return Pt === void 0 && (Pt = 10), [AMPLITUDE_PREFIX, Et, _t.substring(0, Pt)].filter(Boolean).join("_");
}, isNewSession = function(_t, Et) {
  Et === void 0 && (Et = Date.now());
  var Pt = Date.now(), $t = Pt - Et;
  return $t > _t;
}, WebAttribution = (
  /** @class */
  function() {
    function _t(Et, Pt) {
      var $t;
      this.shouldTrackNewCampaign = !1, this.options = __assign$3({ initialEmptyValue: "EMPTY", resetSessionOnNewCampaign: !1, excludeReferrers: getDefaultExcludedReferrers(($t = Pt.cookieOptions) === null || $t === void 0 ? void 0 : $t.domain) }, Et), this.storage = Pt.cookieStorage, this.storageKey = getStorageKey(Pt.apiKey, "MKTG"), this.currentCampaign = BASE_CAMPAIGN, this.sessionTimeout = Pt.sessionTimeout, this.lastEventTime = Pt.lastEventTime, Pt.loggerProvider.log("Installing web attribution tracking.");
    }
    return _t.prototype.init = function() {
      return __awaiter$1(this, void 0, void 0, function() {
        var Et, Pt;
        return __generator$1(this, function($t) {
          switch ($t.label) {
            case 0:
              return [4, this.fetchCampaign()];
            case 1:
              return Pt = __read.apply(void 0, [$t.sent(), 2]), this.currentCampaign = Pt[0], this.previousCampaign = Pt[1], Et = this.lastEventTime ? isNewSession(this.sessionTimeout, this.lastEventTime) : !0, isNewCampaign(this.currentCampaign, this.previousCampaign, this.options, Et) ? (this.shouldTrackNewCampaign = !0, [4, this.storage.set(this.storageKey, this.currentCampaign)]) : [3, 3];
            case 2:
              $t.sent(), $t.label = 3;
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, _t.prototype.fetchCampaign = function() {
      return __awaiter$1(this, void 0, void 0, function() {
        return __generator$1(this, function(Et) {
          switch (Et.label) {
            case 0:
              return [4, Promise.all([new CampaignParser().parse(), this.storage.get(this.storageKey)])];
            case 1:
              return [2, Et.sent()];
          }
        });
      });
    }, _t.prototype.generateCampaignEvent = function(Et) {
      this.shouldTrackNewCampaign = !1;
      var Pt = createCampaignEvent(this.currentCampaign, this.options);
      return Et && (Pt.event_id = Et), Pt;
    }, _t.prototype.shouldSetSessionIdOnNewCampaign = function() {
      return this.shouldTrackNewCampaign && !!this.options.resetSessionOnNewCampaign;
    }, _t;
  }()
), CookieStorage = (
  /** @class */
  function() {
    function _t(Et) {
      this.options = __assign$3({}, Et);
    }
    return _t.prototype.isEnabled = function() {
      return __awaiter$1(this, void 0, void 0, function() {
        var Et, Pt, $t;
        return __generator$1(this, function(Mt) {
          switch (Mt.label) {
            case 0:
              if (!getGlobalScope())
                return [2, !1];
              _t.testValue = String(Date.now()), Et = new _t(this.options), Pt = "AMP_TEST", Mt.label = 1;
            case 1:
              return Mt.trys.push([1, 4, 5, 7]), [4, Et.set(Pt, _t.testValue)];
            case 2:
              return Mt.sent(), [4, Et.get(Pt)];
            case 3:
              return $t = Mt.sent(), [2, $t === _t.testValue];
            case 4:
              return Mt.sent(), [2, !1];
            case 5:
              return [4, Et.remove(Pt)];
            case 6:
              return Mt.sent(), [
                7
                /*endfinally*/
              ];
            case 7:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, _t.prototype.get = function(Et) {
      var Pt;
      return __awaiter$1(this, void 0, void 0, function() {
        var $t, Mt;
        return __generator$1(this, function(Bt) {
          switch (Bt.label) {
            case 0:
              return [4, this.getRaw(Et)];
            case 1:
              if ($t = Bt.sent(), !$t)
                return [2, void 0];
              try {
                return Mt = (Pt = decodeCookiesAsDefault($t)) !== null && Pt !== void 0 ? Pt : decodeCookiesWithDoubleUrlEncoding($t), Mt === void 0 ? (console.error("Amplitude Logger [Error]: Failed to decode cookie value for key: ".concat(Et, ", value: ").concat($t)), [2, void 0]) : [2, JSON.parse(Mt)];
              } catch {
                return console.error("Amplitude Logger [Error]: Failed to parse cookie value for key: ".concat(Et, ", value: ").concat($t)), [2, void 0];
              }
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, _t.prototype.getRaw = function(Et) {
      var Pt, $t;
      return __awaiter$1(this, void 0, void 0, function() {
        var Mt, Bt, Vt;
        return __generator$1(this, function(zt) {
          return Mt = getGlobalScope(), Bt = ($t = (Pt = Mt == null ? void 0 : Mt.document) === null || Pt === void 0 ? void 0 : Pt.cookie.split("; ")) !== null && $t !== void 0 ? $t : [], Vt = Bt.find(function(Ht) {
            return Ht.indexOf(Et + "=") === 0;
          }), Vt ? [2, Vt.substring(Et.length + 1)] : [2, void 0];
        });
      });
    }, _t.prototype.set = function(Et, Pt) {
      var $t;
      return __awaiter$1(this, void 0, void 0, function() {
        var Mt, Bt, Vt, zt, Ht, Wt, Gt;
        return __generator$1(this, function(qt) {
          try {
            Mt = ($t = this.options.expirationDays) !== null && $t !== void 0 ? $t : 0, Bt = Pt !== null ? Mt : -1, Vt = void 0, Bt && (zt = /* @__PURE__ */ new Date(), zt.setTime(zt.getTime() + Bt * 24 * 60 * 60 * 1e3), Vt = zt), Ht = "".concat(Et, "=").concat(btoa(encodeURIComponent(JSON.stringify(Pt)))), Vt && (Ht += "; expires=".concat(Vt.toUTCString())), Ht += "; path=/", this.options.domain && (Ht += "; domain=".concat(this.options.domain)), this.options.secure && (Ht += "; Secure"), this.options.sameSite && (Ht += "; SameSite=".concat(this.options.sameSite)), Wt = getGlobalScope(), Wt && (Wt.document.cookie = Ht);
          } catch (Kt) {
            Gt = Kt instanceof Error ? Kt.message : String(Kt), console.error("Amplitude Logger [Error]: Failed to set cookie for key: ".concat(Et, ". Error: ").concat(Gt));
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, _t.prototype.remove = function(Et) {
      return __awaiter$1(this, void 0, void 0, function() {
        return __generator$1(this, function(Pt) {
          switch (Pt.label) {
            case 0:
              return [4, this.set(Et, null)];
            case 1:
              return Pt.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, _t.prototype.reset = function() {
      return __awaiter$1(this, void 0, void 0, function() {
        return __generator$1(this, function(Et) {
          return [
            2
            /*return*/
          ];
        });
      });
    }, _t;
  }()
), decodeCookiesAsDefault = function(_t) {
  try {
    return decodeURIComponent(atob(_t));
  } catch {
    return;
  }
}, decodeCookiesWithDoubleUrlEncoding = function(_t) {
  try {
    return decodeURIComponent(atob(decodeURIComponent(_t)));
  } catch {
    return;
  }
}, FetchTransport = (
  /** @class */
  function(_t) {
    __extends$1(Et, _t);
    function Et() {
      return _t !== null && _t.apply(this, arguments) || this;
    }
    return Et.prototype.send = function(Pt, $t) {
      return __awaiter$1(this, void 0, void 0, function() {
        var Mt, Bt, Vt;
        return __generator$1(this, function(zt) {
          switch (zt.label) {
            case 0:
              if (typeof fetch > "u")
                throw new Error("FetchTransport is not supported");
              return Mt = {
                headers: {
                  "Content-Type": "application/json",
                  Accept: "*/*"
                },
                body: JSON.stringify($t),
                method: "POST"
              }, [4, fetch(Pt, Mt)];
            case 1:
              return Bt = zt.sent(), [4, Bt.text()];
            case 2:
              Vt = zt.sent();
              try {
                return [2, this.buildResponse(JSON.parse(Vt))];
              } catch {
                return [2, this.buildResponse({ code: Bt.status })];
              }
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, Et;
  }(BaseTransport)
), ApplicationContextProviderImpl = (
  /** @class */
  function() {
    function _t() {
    }
    return _t.prototype.getApplicationContext = function() {
      return {
        versionName: this.versionName,
        language: getLanguage$1(),
        platform: "Web",
        os: void 0,
        deviceModel: void 0
      };
    }, _t;
  }()
), getLanguage$1 = function() {
  return typeof navigator < "u" && (navigator.languages && navigator.languages[0] || navigator.language) || "";
}, EventBridgeImpl = (
  /** @class */
  function() {
    function _t() {
      this.queue = [];
    }
    return _t.prototype.logEvent = function(Et) {
      this.receiver ? this.receiver(Et) : this.queue.length < 512 && this.queue.push(Et);
    }, _t.prototype.setEventReceiver = function(Et) {
      this.receiver = Et, this.queue.length > 0 && (this.queue.forEach(function(Pt) {
        Et(Pt);
      }), this.queue = []);
    }, _t;
  }()
), __assign$2 = function() {
  return __assign$2 = Object.assign || function(Et) {
    for (var Pt, $t = 1, Mt = arguments.length; $t < Mt; $t++) {
      Pt = arguments[$t];
      for (var Bt in Pt)
        Object.prototype.hasOwnProperty.call(Pt, Bt) && (Et[Bt] = Pt[Bt]);
    }
    return Et;
  }, __assign$2.apply(this, arguments);
}, isEqual$1 = function(_t, Et) {
  var Pt = ["string", "number", "boolean", "undefined"], $t = typeof _t, Mt = typeof Et;
  if ($t !== Mt)
    return !1;
  for (var Bt = 0, Vt = Pt; Bt < Vt.length; Bt++) {
    var zt = Vt[Bt];
    if (zt === $t)
      return _t === Et;
  }
  if (_t == null && Et == null)
    return !0;
  if (_t == null || Et == null || _t.length !== Et.length)
    return !1;
  var Ht = Array.isArray(_t), Wt = Array.isArray(Et);
  if (Ht !== Wt)
    return !1;
  if (Ht && Wt) {
    for (var Gt = 0; Gt < _t.length; Gt++)
      if (!isEqual$1(_t[Gt], Et[Gt]))
        return !1;
  } else {
    var qt = Object.keys(_t).sort(), Kt = Object.keys(Et).sort();
    if (!isEqual$1(qt, Kt))
      return !1;
    var Qt = !0;
    return Object.keys(_t).forEach(function(Xt) {
      isEqual$1(_t[Xt], Et[Xt]) || (Qt = !1);
    }), Qt;
  }
  return !0;
}, ID_OP_SET = "$set", ID_OP_UNSET = "$unset", ID_OP_CLEAR_ALL = "$clearAll";
Object.entries || (Object.entries = function(_t) {
  for (var Et = Object.keys(_t), Pt = Et.length, $t = new Array(Pt); Pt--; )
    $t[Pt] = [Et[Pt], _t[Et[Pt]]];
  return $t;
});
var IdentityStoreImpl = (
  /** @class */
  function() {
    function _t() {
      this.identity = { userProperties: {} }, this.listeners = /* @__PURE__ */ new Set();
    }
    return _t.prototype.editIdentity = function() {
      var Et = this, Pt = __assign$2({}, this.identity.userProperties), $t = __assign$2(__assign$2({}, this.identity), { userProperties: Pt });
      return {
        setUserId: function(Mt) {
          return $t.userId = Mt, this;
        },
        setDeviceId: function(Mt) {
          return $t.deviceId = Mt, this;
        },
        setUserProperties: function(Mt) {
          return $t.userProperties = Mt, this;
        },
        setOptOut: function(Mt) {
          return $t.optOut = Mt, this;
        },
        updateUserProperties: function(Mt) {
          for (var Bt = $t.userProperties || {}, Vt = 0, zt = Object.entries(Mt); Vt < zt.length; Vt++) {
            var Ht = zt[Vt], Wt = Ht[0], Gt = Ht[1];
            switch (Wt) {
              case ID_OP_SET:
                for (var qt = 0, Kt = Object.entries(Gt); qt < Kt.length; qt++) {
                  var Qt = Kt[qt], Xt = Qt[0], Zt = Qt[1];
                  Bt[Xt] = Zt;
                }
                break;
              case ID_OP_UNSET:
                for (var Yt = 0, Jt = Object.keys(Gt); Yt < Jt.length; Yt++) {
                  var Xt = Jt[Yt];
                  delete Bt[Xt];
                }
                break;
              case ID_OP_CLEAR_ALL:
                Bt = {};
                break;
            }
          }
          return $t.userProperties = Bt, this;
        },
        commit: function() {
          return Et.setIdentity($t), this;
        }
      };
    }, _t.prototype.getIdentity = function() {
      return __assign$2({}, this.identity);
    }, _t.prototype.setIdentity = function(Et) {
      var Pt = __assign$2({}, this.identity);
      this.identity = __assign$2({}, Et), isEqual$1(Pt, this.identity) || this.listeners.forEach(function($t) {
        $t(Et);
      });
    }, _t.prototype.addIdentityListener = function(Et) {
      this.listeners.add(Et);
    }, _t.prototype.removeIdentityListener = function(Et) {
      this.listeners.delete(Et);
    }, _t;
  }()
), safeGlobal = typeof globalThis < "u" ? globalThis : typeof global$2 < "u" ? global$2 : self, AnalyticsConnector = (
  /** @class */
  function() {
    function _t() {
      this.identityStore = new IdentityStoreImpl(), this.eventBridge = new EventBridgeImpl(), this.applicationContextProvider = new ApplicationContextProviderImpl();
    }
    return _t.getInstance = function(Et) {
      return safeGlobal.analyticsConnectorInstances || (safeGlobal.analyticsConnectorInstances = {}), safeGlobal.analyticsConnectorInstances[Et] || (safeGlobal.analyticsConnectorInstances[Et] = new _t()), safeGlobal.analyticsConnectorInstances[Et];
    }, _t;
  }()
), getAnalyticsConnector = function(_t) {
  return _t === void 0 && (_t = "$default_instance"), AnalyticsConnector.getInstance(_t);
}, setConnectorUserId = function(_t, Et) {
  getAnalyticsConnector(Et).identityStore.editIdentity().setUserId(_t).commit();
}, setConnectorDeviceId = function(_t, Et) {
  getAnalyticsConnector(Et).identityStore.editIdentity().setDeviceId(_t).commit();
}, IdentityEventSender = (
  /** @class */
  function() {
    function _t() {
      this.name = "identity", this.type = "before", this.identityStore = getAnalyticsConnector().identityStore;
    }
    return _t.prototype.execute = function(Et) {
      return __awaiter$1(this, void 0, void 0, function() {
        var Pt;
        return __generator$1(this, function($t) {
          return Pt = Et.user_properties, Pt && this.identityStore.editIdentity().updateUserProperties(Pt).commit(), [2, Et];
        });
      });
    }, _t.prototype.setup = function(Et) {
      return __awaiter$1(this, void 0, void 0, function() {
        return __generator$1(this, function(Pt) {
          return Et.instanceName && (this.identityStore = getAnalyticsConnector(Et.instanceName).identityStore), [
            2
            /*return*/
          ];
        });
      });
    }, _t;
  }()
), getLanguage = function() {
  var _t, Et, Pt, $t;
  if (typeof navigator > "u")
    return "";
  var Mt = navigator.userLanguage;
  return ($t = (Pt = (Et = (_t = navigator.languages) === null || _t === void 0 ? void 0 : _t[0]) !== null && Et !== void 0 ? Et : navigator.language) !== null && Pt !== void 0 ? Pt : Mt) !== null && $t !== void 0 ? $t : "";
}, isTrackingEnabled = function(_t, Et) {
  return typeof _t == "boolean" ? _t : (_t == null ? void 0 : _t[Et]) !== !1;
}, isAttributionTrackingEnabled = function(_t) {
  return isTrackingEnabled(_t, "attribution");
}, isFileDownloadTrackingEnabled = function(_t) {
  return isTrackingEnabled(_t, "fileDownloads");
}, isFormInteractionTrackingEnabled = function(_t) {
  return isTrackingEnabled(_t, "formInteractions");
}, isPageViewTrackingEnabled = function(_t) {
  return isTrackingEnabled(_t, "pageViews");
}, isSessionTrackingEnabled = function(_t) {
  return isTrackingEnabled(_t, "sessions");
}, isElementInteractionsEnabled = function(_t) {
  return typeof _t == "boolean" ? _t : typeof _t == "object" && (_t.elementInteractions === !0 || typeof _t.elementInteractions == "object");
}, getElementInteractionsConfig = function(_t) {
  if (isElementInteractionsEnabled(_t.autocapture) && typeof _t.autocapture == "object" && typeof _t.autocapture.elementInteractions == "object")
    return _t.autocapture.elementInteractions;
}, getPageViewTrackingConfig = function(_t) {
  var Et = function() {
    return !1;
  }, Pt = void 0, $t, Mt = _t.pageCounter, Bt = isPageViewTrackingEnabled(_t.defaultTracking);
  return Bt && (Et = void 0, $t = void 0, _t.defaultTracking && typeof _t.defaultTracking == "object" && _t.defaultTracking.pageViews && typeof _t.defaultTracking.pageViews == "object" && ("trackOn" in _t.defaultTracking.pageViews && (Et = _t.defaultTracking.pageViews.trackOn), "trackHistoryChanges" in _t.defaultTracking.pageViews && (Pt = _t.defaultTracking.pageViews.trackHistoryChanges), "eventType" in _t.defaultTracking.pageViews && _t.defaultTracking.pageViews.eventType && ($t = _t.defaultTracking.pageViews.eventType))), {
    trackOn: Et,
    trackHistoryChanges: Pt,
    eventType: $t,
    pageCounter: Mt
  };
}, getAttributionTrackingConfig = function(_t) {
  return isAttributionTrackingEnabled(_t.defaultTracking) && _t.defaultTracking && typeof _t.defaultTracking == "object" && _t.defaultTracking.attribution && typeof _t.defaultTracking.attribution == "object" ? __assign$3({}, _t.defaultTracking.attribution) : {};
}, convertProxyObjectToRealObject = function(_t, Et) {
  for (var Pt = 0; Pt < Et.length; Pt++) {
    var $t = Et[Pt], Mt = $t.name, Bt = $t.args, Vt = $t.resolve, zt = _t && _t[Mt];
    if (typeof zt == "function") {
      var Ht = zt.apply(_t, Bt);
      typeof Vt == "function" && Vt(Ht == null ? void 0 : Ht.promise);
    }
  }
  return _t;
}, isInstanceProxy = function(_t) {
  var Et = _t;
  return Et && Et._q !== void 0;
}, VERSION$1 = "2.11.7", BROWSER_PLATFORM = "Web", IP_ADDRESS = "$remote", Context$2 = (
  /** @class */
  function() {
    function _t() {
      this.name = "@amplitude/plugin-context-browser", this.type = "before", this.library = "amplitude-ts/".concat(VERSION$1), typeof navigator < "u" && (this.userAgent = navigator.userAgent);
    }
    return _t.prototype.setup = function(Et) {
      return this.config = Et, Promise.resolve(void 0);
    }, _t.prototype.execute = function(Et) {
      var Pt, $t;
      return __awaiter$1(this, void 0, void 0, function() {
        var Mt, Bt, Vt, zt;
        return __generator$1(this, function(Ht) {
          return Mt = (/* @__PURE__ */ new Date()).getTime(), Bt = (Pt = this.config.lastEventId) !== null && Pt !== void 0 ? Pt : -1, Vt = ($t = Et.event_id) !== null && $t !== void 0 ? $t : Bt + 1, this.config.lastEventId = Vt, Et.time || (this.config.lastEventTime = Mt), zt = __assign$3(__assign$3(__assign$3(__assign$3(__assign$3(__assign$3(__assign$3(__assign$3({ user_id: this.config.userId, device_id: this.config.deviceId, session_id: this.config.sessionId, time: Mt }, this.config.appVersion && { app_version: this.config.appVersion }), this.config.trackingOptions.platform && { platform: BROWSER_PLATFORM }), this.config.trackingOptions.language && { language: getLanguage() }), this.config.trackingOptions.ipAddress && { ip: IP_ADDRESS }), { insert_id: UUID(), partner_id: this.config.partnerId, plan: this.config.plan }), this.config.ingestionMetadata && {
            ingestion_metadata: {
              source_name: this.config.ingestionMetadata.sourceName,
              source_version: this.config.ingestionMetadata.sourceVersion
            }
          }), Et), { event_id: Vt, library: this.library, user_agent: this.userAgent }), [2, zt];
        });
      });
    }, _t;
  }()
), BrowserStorage = (
  /** @class */
  function() {
    function _t(Et) {
      this.storage = Et;
    }
    return _t.prototype.isEnabled = function() {
      return __awaiter$1(this, void 0, void 0, function() {
        var Et, Pt, $t, Mt;
        return __generator$1(this, function(Bt) {
          switch (Bt.label) {
            case 0:
              if (!this.storage)
                return [2, !1];
              Et = String(Date.now()), Pt = new _t(this.storage), $t = "AMP_TEST", Bt.label = 1;
            case 1:
              return Bt.trys.push([1, 4, 5, 7]), [4, Pt.set($t, Et)];
            case 2:
              return Bt.sent(), [4, Pt.get($t)];
            case 3:
              return Mt = Bt.sent(), [2, Mt === Et];
            case 4:
              return Bt.sent(), [2, !1];
            case 5:
              return [4, Pt.remove($t)];
            case 6:
              return Bt.sent(), [
                7
                /*endfinally*/
              ];
            case 7:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, _t.prototype.get = function(Et) {
      return __awaiter$1(this, void 0, void 0, function() {
        var Pt;
        return __generator$1(this, function($t) {
          switch ($t.label) {
            case 0:
              return $t.trys.push([0, 2, , 3]), [4, this.getRaw(Et)];
            case 1:
              return Pt = $t.sent(), Pt ? [2, JSON.parse(Pt)] : [2, void 0];
            case 2:
              return $t.sent(), console.error("[Amplitude] Error: Could not get value from storage"), [2, void 0];
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, _t.prototype.getRaw = function(Et) {
      var Pt;
      return __awaiter$1(this, void 0, void 0, function() {
        return __generator$1(this, function($t) {
          return [2, ((Pt = this.storage) === null || Pt === void 0 ? void 0 : Pt.getItem(Et)) || void 0];
        });
      });
    }, _t.prototype.set = function(Et, Pt) {
      var $t;
      return __awaiter$1(this, void 0, void 0, function() {
        return __generator$1(this, function(Mt) {
          try {
            ($t = this.storage) === null || $t === void 0 || $t.setItem(Et, JSON.stringify(Pt));
          } catch {
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, _t.prototype.remove = function(Et) {
      var Pt;
      return __awaiter$1(this, void 0, void 0, function() {
        return __generator$1(this, function($t) {
          try {
            (Pt = this.storage) === null || Pt === void 0 || Pt.removeItem(Et);
          } catch {
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, _t.prototype.reset = function() {
      var Et;
      return __awaiter$1(this, void 0, void 0, function() {
        return __generator$1(this, function(Pt) {
          try {
            (Et = this.storage) === null || Et === void 0 || Et.clear();
          } catch {
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, _t;
  }()
), MAX_ARRAY_LENGTH = 1e3, LocalStorage = (
  /** @class */
  function(_t) {
    __extends$1(Et, _t);
    function Et(Pt) {
      var $t = this, Mt;
      return $t = _t.call(this, (Mt = getGlobalScope()) === null || Mt === void 0 ? void 0 : Mt.localStorage) || this, $t.loggerProvider = Pt == null ? void 0 : Pt.loggerProvider, $t;
    }
    return Et.prototype.set = function(Pt, $t) {
      var Mt;
      return __awaiter$1(this, void 0, void 0, function() {
        var Bt;
        return __generator$1(this, function(Vt) {
          switch (Vt.label) {
            case 0:
              return Array.isArray($t) && $t.length > MAX_ARRAY_LENGTH ? (Bt = $t.length - MAX_ARRAY_LENGTH, [4, _t.prototype.set.call(this, Pt, $t.slice(0, MAX_ARRAY_LENGTH))]) : [3, 2];
            case 1:
              return Vt.sent(), (Mt = this.loggerProvider) === null || Mt === void 0 || Mt.error("Failed to save ".concat(Bt, " events because the queue length exceeded ").concat(MAX_ARRAY_LENGTH, ".")), [3, 4];
            case 2:
              return [4, _t.prototype.set.call(this, Pt, $t)];
            case 3:
              Vt.sent(), Vt.label = 4;
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, Et;
  }(BrowserStorage)
), SessionStorage = (
  /** @class */
  function(_t) {
    __extends$1(Et, _t);
    function Et() {
      var Pt;
      return _t.call(this, (Pt = getGlobalScope()) === null || Pt === void 0 ? void 0 : Pt.sessionStorage) || this;
    }
    return Et;
  }(BrowserStorage)
), XHRTransport = (
  /** @class */
  function(_t) {
    __extends$1(Et, _t);
    function Et() {
      var Pt = _t !== null && _t.apply(this, arguments) || this;
      return Pt.state = {
        done: 4
      }, Pt;
    }
    return Et.prototype.send = function(Pt, $t) {
      return __awaiter$1(this, void 0, void 0, function() {
        var Mt = this;
        return __generator$1(this, function(Bt) {
          return [2, new Promise(function(Vt, zt) {
            typeof XMLHttpRequest > "u" && zt(new Error("XHRTransport is not supported."));
            var Ht = new XMLHttpRequest();
            Ht.open("POST", Pt, !0), Ht.onreadystatechange = function() {
              if (Ht.readyState === Mt.state.done) {
                var Wt = Ht.responseText;
                try {
                  Vt(Mt.buildResponse(JSON.parse(Wt)));
                } catch {
                  Vt(Mt.buildResponse({ code: Ht.status }));
                }
              }
            }, Ht.setRequestHeader("Content-Type", "application/json"), Ht.setRequestHeader("Accept", "*/*"), Ht.send(JSON.stringify($t));
          })];
        });
      });
    }, Et;
  }(BaseTransport)
), SendBeaconTransport = (
  /** @class */
  function(_t) {
    __extends$1(Et, _t);
    function Et() {
      return _t !== null && _t.apply(this, arguments) || this;
    }
    return Et.prototype.send = function(Pt, $t) {
      return __awaiter$1(this, void 0, void 0, function() {
        var Mt = this;
        return __generator$1(this, function(Bt) {
          return [2, new Promise(function(Vt, zt) {
            var Ht = getGlobalScope();
            if (!(Ht != null && Ht.navigator.sendBeacon))
              throw new Error("SendBeaconTransport is not supported");
            try {
              var Wt = JSON.stringify($t), Gt = Ht.navigator.sendBeacon(Pt, JSON.stringify($t));
              return Vt(Gt ? Mt.buildResponse({
                code: 200,
                events_ingested: $t.events.length,
                payload_size_bytes: Wt.length,
                server_upload_time: Date.now()
              }) : Mt.buildResponse({ code: 500 }));
            } catch (qt) {
              zt(qt);
            }
          })];
        });
      });
    }, Et;
  }(BaseTransport)
), parseLegacyCookies = function(_t, Et, Pt) {
  return Pt === void 0 && (Pt = !0), __awaiter$1(void 0, void 0, void 0, function() {
    var $t, Mt, Bt, Vt, zt, Ht, Wt, Gt, qt;
    return __generator$1(this, function(Kt) {
      switch (Kt.label) {
        case 0:
          return $t = getOldCookieName(_t), [4, Et.getRaw($t)];
        case 1:
          return Mt = Kt.sent(), Mt ? Pt ? [4, Et.remove($t)] : [3, 3] : [2, {
            optOut: !1
          }];
        case 2:
          Kt.sent(), Kt.label = 3;
        case 3:
          return Bt = __read(Mt.split("."), 6), Vt = Bt[0], zt = Bt[1], Ht = Bt[2], Wt = Bt[3], Gt = Bt[4], qt = Bt[5], [2, {
            deviceId: Vt,
            userId: decode(zt),
            sessionId: parseTime(Wt),
            lastEventId: parseTime(qt),
            lastEventTime: parseTime(Gt),
            optOut: !!Ht
          }];
      }
    });
  });
}, parseTime = function(_t) {
  var Et = parseInt(_t, 32);
  if (!isNaN(Et))
    return Et;
}, decode = function(_t) {
  if (!(!atob || !escape || !_t))
    try {
      return decodeURIComponent(escape(atob(_t)));
    } catch {
      return;
    }
}, DEFAULT_EVENT_PREFIX = "[Amplitude]", DEFAULT_FORM_START_EVENT = "".concat(DEFAULT_EVENT_PREFIX, " Form Started"), DEFAULT_FORM_SUBMIT_EVENT = "".concat(DEFAULT_EVENT_PREFIX, " Form Submitted"), DEFAULT_FILE_DOWNLOAD_EVENT = "".concat(DEFAULT_EVENT_PREFIX, " File Downloaded"), DEFAULT_SESSION_START_EVENT = "session_start", DEFAULT_SESSION_END_EVENT = "session_end", FILE_EXTENSION = "".concat(DEFAULT_EVENT_PREFIX, " File Extension"), FILE_NAME = "".concat(DEFAULT_EVENT_PREFIX, " File Name"), LINK_ID = "".concat(DEFAULT_EVENT_PREFIX, " Link ID"), LINK_TEXT = "".concat(DEFAULT_EVENT_PREFIX, " Link Text"), LINK_URL = "".concat(DEFAULT_EVENT_PREFIX, " Link URL"), FORM_ID = "".concat(DEFAULT_EVENT_PREFIX, " Form ID"), FORM_NAME = "".concat(DEFAULT_EVENT_PREFIX, " Form Name"), FORM_DESTINATION = "".concat(DEFAULT_EVENT_PREFIX, " Form Destination"), DEFAULT_IDENTITY_STORAGE = "cookie", DEFAULT_SERVER_ZONE = "US", BrowserConfig = (
  /** @class */
  function(_t) {
    __extends$1(Et, _t);
    function Et(Pt, $t, Mt, Bt, Vt, zt, Ht, Wt, Gt, qt, Kt, Qt, Xt, Zt, Yt, Jt, er, tr, nr, rr, ir, ar, or, sr, lr, cr, hr, pr, mr, Er, _r, yr, ur, vr) {
      Mt === void 0 && (Mt = new MemoryStorage()), Bt === void 0 && (Bt = {
        domain: "",
        expiration: 365,
        sameSite: "Lax",
        secure: !1,
        upgrade: !0
      }), Wt === void 0 && (Wt = 1e3), Gt === void 0 && (Gt = 5), qt === void 0 && (qt = 30), Kt === void 0 && (Kt = DEFAULT_IDENTITY_STORAGE), Jt === void 0 && (Jt = new Logger()), er === void 0 && (er = LogLevel.Warn), nr === void 0 && (nr = !1), rr === void 0 && (rr = !1), or === void 0 && (or = ""), sr === void 0 && (sr = DEFAULT_SERVER_ZONE), cr === void 0 && (cr = 30 * 60 * 1e3), hr === void 0 && (hr = new LocalStorage({ loggerProvider: Jt })), pr === void 0 && (pr = {
        ipAddress: !0,
        language: !0,
        platform: !0
      }), mr === void 0 && (mr = "fetch"), Er === void 0 && (Er = !1), _r === void 0 && (_r = !1);
      var dr = _t.call(this, { apiKey: Pt, storageProvider: hr, transportProvider: createTransport(mr) }) || this;
      return dr.apiKey = Pt, dr.appVersion = $t, dr.cookieOptions = Bt, dr.defaultTracking = Vt, dr.autocapture = zt, dr.flushIntervalMillis = Wt, dr.flushMaxRetries = Gt, dr.flushQueueSize = qt, dr.identityStorage = Kt, dr.ingestionMetadata = Qt, dr.instanceName = Xt, dr.loggerProvider = Jt, dr.logLevel = er, dr.minIdLength = tr, dr.offline = nr, dr.partnerId = ir, dr.plan = ar, dr.serverUrl = or, dr.serverZone = sr, dr.sessionTimeout = cr, dr.storageProvider = hr, dr.trackingOptions = pr, dr.transport = mr, dr.useBatch = Er, dr.fetchRemoteConfig = _r, dr._optOut = !1, dr._cookieStorage = Mt, dr.deviceId = Ht, dr.lastEventId = Zt, dr.lastEventTime = Yt, dr.optOut = rr, dr.sessionId = lr, dr.pageCounter = ur, dr.userId = yr, dr.debugLogsEnabled = vr, dr.loggerProvider.enable(vr ? LogLevel.Debug : dr.logLevel), dr;
    }
    return Object.defineProperty(Et.prototype, "cookieStorage", {
      get: function() {
        return this._cookieStorage;
      },
      set: function(Pt) {
        this._cookieStorage !== Pt && (this._cookieStorage = Pt, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(Et.prototype, "deviceId", {
      get: function() {
        return this._deviceId;
      },
      set: function(Pt) {
        this._deviceId !== Pt && (this._deviceId = Pt, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(Et.prototype, "userId", {
      get: function() {
        return this._userId;
      },
      set: function(Pt) {
        this._userId !== Pt && (this._userId = Pt, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(Et.prototype, "sessionId", {
      get: function() {
        return this._sessionId;
      },
      set: function(Pt) {
        this._sessionId !== Pt && (this._sessionId = Pt, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(Et.prototype, "optOut", {
      get: function() {
        return this._optOut;
      },
      set: function(Pt) {
        this._optOut !== Pt && (this._optOut = Pt, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(Et.prototype, "lastEventTime", {
      get: function() {
        return this._lastEventTime;
      },
      set: function(Pt) {
        this._lastEventTime !== Pt && (this._lastEventTime = Pt, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(Et.prototype, "lastEventId", {
      get: function() {
        return this._lastEventId;
      },
      set: function(Pt) {
        this._lastEventId !== Pt && (this._lastEventId = Pt, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(Et.prototype, "pageCounter", {
      get: function() {
        return this._pageCounter;
      },
      set: function(Pt) {
        this._pageCounter !== Pt && (this._pageCounter = Pt, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(Et.prototype, "debugLogsEnabled", {
      set: function(Pt) {
        this._debugLogsEnabled !== Pt && (this._debugLogsEnabled = Pt, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Et.prototype.updateStorage = function() {
      var Pt = {
        deviceId: this._deviceId,
        userId: this._userId,
        sessionId: this._sessionId,
        optOut: this._optOut,
        lastEventTime: this._lastEventTime,
        lastEventId: this._lastEventId,
        pageCounter: this._pageCounter,
        debugLogsEnabled: this._debugLogsEnabled
      };
      this.cookieStorage.set(getCookieName(this.apiKey), Pt);
    }, Et;
  }(Config)
), useBrowserConfig = function(_t, Et, Pt) {
  return Et === void 0 && (Et = {}), __awaiter$1(void 0, void 0, void 0, function() {
    var $t, Mt, Bt, Vt, zt, Ht, Wt, Gt, qt, Kt, Qt, Xt, Zt, Yt, Jt, er, tr, nr, rr, ir, ar, or, sr, lr, cr, hr, pr, mr, Er, _r, yr, ur, vr, dr, br, Cr, Pr, xr, kr, Ir, Ar, Mr, Fr;
    return __generator$1(this, function(Dr) {
      switch (Dr.label) {
        case 0:
          return $t = Et.identityStorage || DEFAULT_IDENTITY_STORAGE, rr = {}, $t === DEFAULT_IDENTITY_STORAGE ? [3, 1] : (Bt = "", [3, 5]);
        case 1:
          return (ar = (ir = Et.cookieOptions) === null || ir === void 0 ? void 0 : ir.domain) !== null && ar !== void 0 ? (Vt = ar, [3, 4]) : [3, 2];
        case 2:
          return [4, getTopLevelDomain()];
        case 3:
          Vt = Dr.sent(), Dr.label = 4;
        case 4:
          Bt = Vt, Dr.label = 5;
        case 5:
          return Mt = __assign$3.apply(void 0, [(rr.domain = Bt, rr.expiration = 365, rr.sameSite = "Lax", rr.secure = !1, rr.upgrade = !0, rr), Et.cookieOptions]), zt = createCookieStorage(Et.identityStorage, Mt), [4, parseLegacyCookies(_t, zt, (sr = (or = Et.cookieOptions) === null || or === void 0 ? void 0 : or.upgrade) !== null && sr !== void 0 ? sr : !0)];
        case 6:
          return Ht = Dr.sent(), [4, zt.get(getCookieName(_t))];
        case 7:
          return Wt = Dr.sent(), Gt = getQueryParams(), qt = (mr = (pr = (hr = (cr = (lr = Et.deviceId) !== null && lr !== void 0 ? lr : Gt.ampDeviceId) !== null && cr !== void 0 ? cr : Gt.deviceId) !== null && hr !== void 0 ? hr : Wt == null ? void 0 : Wt.deviceId) !== null && pr !== void 0 ? pr : Ht.deviceId) !== null && mr !== void 0 ? mr : UUID(), Kt = (Er = Wt == null ? void 0 : Wt.lastEventId) !== null && Er !== void 0 ? Er : Ht.lastEventId, Qt = (_r = Wt == null ? void 0 : Wt.lastEventTime) !== null && _r !== void 0 ? _r : Ht.lastEventTime, Xt = (ur = (yr = Et.optOut) !== null && yr !== void 0 ? yr : Wt == null ? void 0 : Wt.optOut) !== null && ur !== void 0 ? ur : Ht.optOut, Zt = (vr = Wt == null ? void 0 : Wt.sessionId) !== null && vr !== void 0 ? vr : Ht.sessionId, Yt = (br = (dr = Et.userId) !== null && dr !== void 0 ? dr : Wt == null ? void 0 : Wt.userId) !== null && br !== void 0 ? br : Ht.userId, Pt.previousSessionDeviceId = (Cr = Wt == null ? void 0 : Wt.deviceId) !== null && Cr !== void 0 ? Cr : Ht.deviceId, Pt.previousSessionUserId = (Pr = Wt == null ? void 0 : Wt.userId) !== null && Pr !== void 0 ? Pr : Ht.userId, Jt = {
            ipAddress: (kr = (xr = Et.trackingOptions) === null || xr === void 0 ? void 0 : xr.ipAddress) !== null && kr !== void 0 ? kr : !0,
            language: (Ar = (Ir = Et.trackingOptions) === null || Ir === void 0 ? void 0 : Ir.language) !== null && Ar !== void 0 ? Ar : !0,
            platform: (Fr = (Mr = Et.trackingOptions) === null || Mr === void 0 ? void 0 : Mr.platform) !== null && Fr !== void 0 ? Fr : !0
          }, er = Wt == null ? void 0 : Wt.pageCounter, tr = Wt == null ? void 0 : Wt.debugLogsEnabled, Et.autocapture !== void 0 && (Et.defaultTracking = Et.autocapture), nr = new BrowserConfig(_t, Et.appVersion, zt, Mt, Et.defaultTracking, Et.autocapture, qt, Et.flushIntervalMillis, Et.flushMaxRetries, Et.flushQueueSize, $t, Et.ingestionMetadata, Et.instanceName, Kt, Qt, Et.loggerProvider, Et.logLevel, Et.minIdLength, Et.offline, Xt, Et.partnerId, Et.plan, Et.serverUrl, Et.serverZone, Zt, Et.sessionTimeout, Et.storageProvider, Jt, Et.transport, Et.useBatch, Et.fetchRemoteConfig, Yt, er, tr), [4, nr.storageProvider.isEnabled()];
        case 8:
          return Dr.sent() || (nr.loggerProvider.warn("Storage provider ".concat(nr.storageProvider.constructor.name, " is not enabled. Falling back to MemoryStorage.")), nr.storageProvider = new MemoryStorage()), [2, nr];
      }
    });
  });
}, createCookieStorage = function(_t, Et) {
  switch (_t === void 0 && (_t = DEFAULT_IDENTITY_STORAGE), Et === void 0 && (Et = {}), _t) {
    case "localStorage":
      return new LocalStorage();
    case "sessionStorage":
      return new SessionStorage();
    case "none":
      return new MemoryStorage();
    case "cookie":
    default:
      return new CookieStorage(__assign$3(__assign$3({}, Et), { expirationDays: Et.expiration }));
  }
}, createTransport = function(_t) {
  return _t === "xhr" ? new XHRTransport() : _t === "beacon" ? new SendBeaconTransport() : new FetchTransport();
}, getTopLevelDomain = function(_t) {
  return __awaiter$1(void 0, void 0, void 0, function() {
    var Et, Pt, $t, Mt, Bt, Bt, Vt, zt, Ht, Wt;
    return __generator$1(this, function(Gt) {
      switch (Gt.label) {
        case 0:
          return [4, new CookieStorage().isEnabled()];
        case 1:
          if (!Gt.sent() || typeof location > "u" || !location.hostname)
            return [2, ""];
          for (Et = location.hostname, Pt = Et.split("."), $t = [], Mt = "AMP_TLDTEST", Bt = Pt.length - 2; Bt >= 0; --Bt)
            $t.push(Pt.slice(Bt).join("."));
          Bt = 0, Gt.label = 2;
        case 2:
          return Bt < $t.length ? (Vt = $t[Bt], zt = { domain: "." + Vt }, Ht = new CookieStorage(zt), [4, Ht.set(Mt, 1)]) : [3, 7];
        case 3:
          return Gt.sent(), [4, Ht.get(Mt)];
        case 4:
          return Wt = Gt.sent(), Wt ? [4, Ht.remove(Mt)] : [3, 6];
        case 5:
          return Gt.sent(), [2, "." + Vt];
        case 6:
          return Bt++, [3, 2];
        case 7:
          return [2, ""];
      }
    });
  });
}, omitUndefined = function(_t) {
  var Et = {};
  for (var Pt in _t) {
    var $t = _t[Pt];
    $t && (Et[Pt] = $t);
  }
  return Et;
}, defaultPageViewEvent = "[Amplitude] Page Viewed", pageViewTrackingPlugin = function(_t) {
  _t === void 0 && (_t = {});
  var Et, Pt = getGlobalScope(), $t = void 0, Mt, Bt, Vt = _t.trackOn, zt = _t.trackHistoryChanges, Ht = _t.eventType, Wt = Ht === void 0 ? defaultPageViewEvent : Ht, Gt = function(Jt) {
    var er = Jt;
    try {
      er = decodeURI(Jt);
    } catch (tr) {
      $t == null || $t.error("Malformed URI sequence: ", tr);
    }
    return er;
  }, qt = function() {
    return __awaiter$1(void 0, void 0, void 0, function() {
      var Jt, er, tr;
      return __generator$1(this, function(nr) {
        switch (nr.label) {
          case 0:
            return Jt = Gt(typeof location < "u" && location.href || ""), tr = {
              event_type: Wt
            }, er = [{}], [4, getCampaignParams()];
          case 1:
            return [2, (tr.event_properties = __assign$3.apply(void 0, [__assign$3.apply(void 0, er.concat([nr.sent()])), { "[Amplitude] Page Domain": (
              /* istanbul ignore next */
              typeof location < "u" && location.hostname || ""
            ), "[Amplitude] Page Location": Jt, "[Amplitude] Page Path": (
              /* istanbul ignore next */
              typeof location < "u" && Gt(location.pathname) || ""
            ), "[Amplitude] Page Title": (
              /* istanbul ignore next */
              typeof document < "u" && document.title || ""
            ), "[Amplitude] Page URL": Jt.split("?")[0] }]), tr)];
        }
      });
    });
  }, Kt = function() {
    return typeof Vt > "u" || typeof Vt == "function" && Vt();
  }, Qt = typeof location < "u" ? location.href : null, Xt = function() {
    return __awaiter$1(void 0, void 0, void 0, function() {
      var Jt, er, tr, nr;
      return __generator$1(this, function(rr) {
        switch (rr.label) {
          case 0:
            return Jt = location.href, er = shouldTrackHistoryPageView(zt, Jt, Qt || "") && Kt(), Qt = Jt, er ? ($t == null || $t.log("Tracking page view event"), Et != null ? [3, 1] : [3, 3]) : [3, 4];
          case 1:
            return nr = (tr = Et).track, [4, qt()];
          case 2:
            nr.apply(tr, [rr.sent()]), rr.label = 3;
          case 3:
            rr.label = 4;
          case 4:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }, Zt = function() {
    Xt();
  }, Yt = {
    name: "@amplitude/plugin-page-view-tracking-browser",
    type: "enrichment",
    setup: function(Jt, er) {
      return __awaiter$1(void 0, void 0, void 0, function() {
        var tr, nr;
        return __generator$1(this, function(rr) {
          switch (rr.label) {
            case 0:
              return Et = er, Bt = Jt, $t = Jt.loggerProvider, $t.log("Installing @amplitude/plugin-page-view-tracking-browser"), Pt && (Pt.addEventListener("popstate", Zt), Mt = Pt.history.pushState, Pt.history.pushState = new Proxy(Pt.history.pushState, {
                apply: function(ir, ar, or) {
                  var sr = __read(or, 3), lr = sr[0], cr = sr[1], hr = sr[2];
                  ir.apply(ar, [lr, cr, hr]), Xt();
                }
              })), Kt() ? ($t.log("Tracking page view event"), nr = (tr = Et).track, [4, qt()]) : [3, 2];
            case 1:
              nr.apply(tr, [rr.sent()]), rr.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    },
    execute: function(Jt) {
      return __awaiter$1(void 0, void 0, void 0, function() {
        var er;
        return __generator$1(this, function(tr) {
          switch (tr.label) {
            case 0:
              return Vt === "attribution" && isCampaignEvent(Jt) ? ($t == null || $t.log("Enriching campaign event to page view event with campaign parameters"), [4, qt()]) : [3, 2];
            case 1:
              er = tr.sent(), Jt.event_type = er.event_type, Jt.event_properties = __assign$3(__assign$3({}, Jt.event_properties), er.event_properties), tr.label = 2;
            case 2:
              return Bt && Jt.event_type === Wt && (Bt.pageCounter = Bt.pageCounter ? Bt.pageCounter + 1 : 1, Jt.event_properties = __assign$3(__assign$3({}, Jt.event_properties), { "[Amplitude] Page Counter": Bt.pageCounter })), [2, Jt];
          }
        });
      });
    },
    teardown: function() {
      return __awaiter$1(void 0, void 0, void 0, function() {
        return __generator$1(this, function(Jt) {
          return Pt && (Pt.removeEventListener("popstate", Zt), Mt && (Pt.history.pushState = Mt)), [
            2
            /*return*/
          ];
        });
      });
    }
  };
  return Yt;
}, getCampaignParams = function() {
  return __awaiter$1(void 0, void 0, void 0, function() {
    var _t;
    return __generator$1(this, function(Et) {
      switch (Et.label) {
        case 0:
          return _t = omitUndefined, [4, new CampaignParser().parse()];
        case 1:
          return [2, _t.apply(void 0, [Et.sent()])];
      }
    });
  });
}, isCampaignEvent = function(_t) {
  if (_t.event_type === "$identify" && _t.user_properties) {
    var Et = _t.user_properties, Pt = Et[IdentifyOperation.SET] || {}, $t = Et[IdentifyOperation.UNSET] || {}, Mt = __spreadArray$1(__spreadArray$1([], __read(Object.keys(Pt)), !1), __read(Object.keys($t)), !1);
    return Object.keys(BASE_CAMPAIGN).every(function(Bt) {
      return Mt.includes(Bt);
    });
  }
  return !1;
}, shouldTrackHistoryPageView = function(_t, Et, Pt) {
  switch (_t) {
    case "pathOnly": {
      if (Pt == "")
        return !0;
      var $t = new URL(Et), Mt = new URL(Pt), Bt = $t.origin + $t.pathname, Vt = Mt.origin + Mt.pathname;
      return Bt !== Vt;
    }
    default:
      return Et !== Pt;
  }
}, formInteractionTracking = function() {
  var _t, Et = [], Pt = function(Wt, Gt, qt) {
    Wt.addEventListener(Gt, qt), Et.push({
      element: Wt,
      type: Gt,
      handler: qt
    });
  }, $t = function() {
    Et.forEach(function(Wt) {
      var Gt = Wt.element, qt = Wt.type, Kt = Wt.handler;
      Gt == null || Gt.removeEventListener(qt, Kt);
    }), Et = [];
  }, Mt = "@amplitude/plugin-form-interaction-tracking-browser", Bt = "enrichment", Vt = function(Wt, Gt) {
    return __awaiter$1(void 0, void 0, void 0, function() {
      var qt;
      return __generator$1(this, function(Kt) {
        return (qt = getGlobalScope()) === null || qt === void 0 || qt.addEventListener("load", function() {
          if (!Gt) {
            Wt.loggerProvider.warn("Form interaction tracking requires a later version of @amplitude/analytics-browser. Form interaction events are not tracked.");
            return;
          }
          if (!(typeof document > "u")) {
            var Qt = function(Zt) {
              var Yt = !1;
              Pt(Zt, "change", function() {
                var Jt;
                Yt || Gt.track(DEFAULT_FORM_START_EVENT, (Jt = {}, Jt[FORM_ID] = stringOrUndefined(Zt.id), Jt[FORM_NAME] = stringOrUndefined(Zt.name), Jt[FORM_DESTINATION] = Zt.action, Jt)), Yt = !0;
              }), Pt(Zt, "submit", function() {
                var Jt, er;
                Yt || Gt.track(DEFAULT_FORM_START_EVENT, (Jt = {}, Jt[FORM_ID] = stringOrUndefined(Zt.id), Jt[FORM_NAME] = stringOrUndefined(Zt.name), Jt[FORM_DESTINATION] = Zt.action, Jt)), Gt.track(DEFAULT_FORM_SUBMIT_EVENT, (er = {}, er[FORM_ID] = stringOrUndefined(Zt.id), er[FORM_NAME] = stringOrUndefined(Zt.name), er[FORM_DESTINATION] = Zt.action, er)), Yt = !1;
              });
            }, Xt = Array.from(document.getElementsByTagName("form"));
            Xt.forEach(Qt), typeof MutationObserver < "u" && (_t = new MutationObserver(function(Zt) {
              Zt.forEach(function(Yt) {
                Yt.addedNodes.forEach(function(Jt) {
                  Jt.nodeName === "FORM" && Qt(Jt), "querySelectorAll" in Jt && typeof Jt.querySelectorAll == "function" && Array.from(Jt.querySelectorAll("form")).map(Qt);
                });
              });
            }), _t.observe(document.body, {
              subtree: !0,
              childList: !0
            }));
          }
        }), [
          2
          /*return*/
        ];
      });
    });
  }, zt = function(Wt) {
    return __awaiter$1(void 0, void 0, void 0, function() {
      return __generator$1(this, function(Gt) {
        return [2, Wt];
      });
    });
  }, Ht = function() {
    return __awaiter$1(void 0, void 0, void 0, function() {
      return __generator$1(this, function(Wt) {
        return _t == null || _t.disconnect(), $t(), [
          2
          /*return*/
        ];
      });
    });
  };
  return {
    name: Mt,
    type: Bt,
    setup: Vt,
    execute: zt,
    teardown: Ht
  };
}, stringOrUndefined = function(_t) {
  if (typeof _t == "string")
    return _t;
}, fileDownloadTracking = function() {
  var _t, Et = [], Pt = function(Wt, Gt, qt) {
    Wt.addEventListener(Gt, qt), Et.push({
      element: Wt,
      type: Gt,
      handler: qt
    });
  }, $t = function() {
    Et.forEach(function(Wt) {
      var Gt = Wt.element, qt = Wt.type, Kt = Wt.handler;
      Gt == null || Gt.removeEventListener(qt, Kt);
    }), Et = [];
  }, Mt = "@amplitude/plugin-file-download-tracking-browser", Bt = "enrichment", Vt = function(Wt, Gt) {
    return __awaiter$1(void 0, void 0, void 0, function() {
      var qt;
      return __generator$1(this, function(Kt) {
        return (qt = getGlobalScope()) === null || qt === void 0 || qt.addEventListener("load", function() {
          if (!Gt) {
            Wt.loggerProvider.warn("File download tracking requires a later version of @amplitude/analytics-browser. File download events are not tracked.");
            return;
          }
          if (!(typeof document > "u")) {
            var Qt = function(Yt) {
              var Jt;
              try {
                Jt = new URL(Yt.href, window.location.href);
              } catch {
                return;
              }
              var er = Xt.exec(Jt.href), tr = er == null ? void 0 : er[1];
              tr && Pt(Yt, "click", function() {
                var nr;
                tr && Gt.track(DEFAULT_FILE_DOWNLOAD_EVENT, (nr = {}, nr[FILE_EXTENSION] = tr, nr[FILE_NAME] = Jt.pathname, nr[LINK_ID] = Yt.id, nr[LINK_TEXT] = Yt.text, nr[LINK_URL] = Yt.href, nr));
              });
            }, Xt = /\.(pdf|xlsx?|docx?|txt|rtf|csv|exe|key|pp(s|t|tx)|7z|pkg|rar|gz|zip|avi|mov|mp4|mpe?g|wmv|midi?|mp3|wav|wma)$/, Zt = Array.from(document.getElementsByTagName("a"));
            Zt.forEach(Qt), typeof MutationObserver < "u" && (_t = new MutationObserver(function(Yt) {
              Yt.forEach(function(Jt) {
                Jt.addedNodes.forEach(function(er) {
                  er.nodeName === "A" && Qt(er), "querySelectorAll" in er && typeof er.querySelectorAll == "function" && Array.from(er.querySelectorAll("a")).map(Qt);
                });
              });
            }), _t.observe(document.body, {
              subtree: !0,
              childList: !0
            }));
          }
        }), [
          2
          /*return*/
        ];
      });
    });
  }, zt = function(Wt) {
    return __awaiter$1(void 0, void 0, void 0, function() {
      return __generator$1(this, function(Gt) {
        return [2, Wt];
      });
    });
  }, Ht = function() {
    return __awaiter$1(void 0, void 0, void 0, function() {
      return __generator$1(this, function(Wt) {
        return _t == null || _t.disconnect(), $t(), [
          2
          /*return*/
        ];
      });
    });
  };
  return {
    name: Mt,
    type: Bt,
    setup: Vt,
    execute: zt,
    teardown: Ht
  };
}, notified = !1, detNotify = function(_t) {
  if (!(notified || _t.defaultTracking !== void 0)) {
    var Et = `\`options.defaultTracking\` is set to undefined. This implicitly configures your Amplitude instance to track Page Views, Sessions, File Downloads, and Form Interactions. You can suppress this warning by explicitly setting a value to \`options.defaultTracking\`. The value must either be a boolean, to enable and disable all default events, or an object, for advanced configuration. For example:

amplitude.init(<YOUR_API_KEY>, {
  defaultTracking: true,
});

Visit https://www.docs.developers.amplitude.com/data/sdks/browser-2/#tracking-default-events for more details.`;
    _t.loggerProvider.warn(Et), notified = !0;
  }
}, networkConnectivityCheckerPlugin = function() {
  var _t = "@amplitude/plugin-network-checker-browser", Et = "before", Pt = getGlobalScope(), $t = [], Mt = function(Ht, Wt) {
    Pt && (Pt.addEventListener(Ht, Wt), $t.push({
      type: Ht,
      handler: Wt
    }));
  }, Bt = function() {
    $t.forEach(function(Ht) {
      var Wt = Ht.type, Gt = Ht.handler;
      Pt && Pt.removeEventListener(Wt, Gt);
    }), $t = [];
  }, Vt = function(Ht, Wt) {
    return __awaiter$1(void 0, void 0, void 0, function() {
      return __generator$1(this, function(Gt) {
        return typeof navigator > "u" ? (Ht.loggerProvider.debug("Network connectivity checker plugin is disabled because navigator is not available."), Ht.offline = !1, [
          2
          /*return*/
        ]) : (Ht.offline = !navigator.onLine, Mt("online", function() {
          Ht.loggerProvider.debug("Network connectivity changed to online."), Ht.offline = !1, setTimeout(function() {
            Wt.flush();
          }, Ht.flushIntervalMillis);
        }), Mt("offline", function() {
          Ht.loggerProvider.debug("Network connectivity changed to offline."), Ht.offline = !0;
        }), [
          2
          /*return*/
        ]);
      });
    });
  }, zt = function() {
    return __awaiter$1(void 0, void 0, void 0, function() {
      return __generator$1(this, function(Ht) {
        return Bt(), [
          2
          /*return*/
        ];
      });
    });
  };
  return {
    name: _t,
    type: Et,
    setup: Vt,
    teardown: zt
  };
}, UNEXPECTED_NETWORK_ERROR_MESSAGE = "Network error occurred, remote config fetch failed", SUCCESS_REMOTE_CONFIG = "Remote config successfully fetched", MAX_RETRIES_EXCEEDED_MESSAGE = "Remote config fetch rejected due to exceeded retry count", TIMEOUT_MESSAGE = "Remote config fetch rejected due to timeout after 5 seconds", UNEXPECTED_ERROR_MESSAGE = "Unexpected error occurred", REMOTE_CONFIG_SERVER_URL = "https://sr-client-cfg.amplitude.com/config", REMOTE_CONFIG_SERVER_URL_STAGING = "https://sr-client-cfg.stag2.amplitude.com/config", REMOTE_CONFIG_SERVER_URL_EU = "https://sr-client-cfg.eu.amplitude.com/config", RemoteConfigFetch = (
  /** @class */
  function() {
    function _t(Et) {
      var Pt = Et.localConfig, $t = Et.configKeys, Mt = this;
      this.retryTimeout = 1e3, this.attempts = 0, this.sessionTargetingMatch = !1, this.metrics = {}, this.getRemoteConfig = function(Bt, Vt, zt) {
        return __awaiter$1(Mt, void 0, void 0, function() {
          var Ht, Wt, Gt;
          return __generator$1(this, function(qt) {
            switch (qt.label) {
              case 0:
                return Ht = Date.now(), [4, this.fetchWithTimeout(zt)];
              case 1:
                return Wt = qt.sent(), Wt && (Gt = Wt.configs && Wt.configs[Bt], Gt) ? (this.metrics.fetchTimeAPISuccess = Date.now() - Ht, [2, Gt[Vt]]) : (this.metrics.fetchTimeAPIFail = Date.now() - Ht, [2, void 0]);
            }
          });
        });
      }, this.fetchWithTimeout = function(Bt) {
        return __awaiter$1(Mt, void 0, void 0, function() {
          var Vt, zt, Ht;
          return __generator$1(this, function(Wt) {
            switch (Wt.label) {
              case 0:
                return Vt = new AbortController(), zt = setTimeout(function() {
                  return Vt.abort();
                }, 5e3), [4, this.fetchRemoteConfig(Vt.signal, Bt)];
              case 1:
                return Ht = Wt.sent(), clearTimeout(zt), [2, Ht];
            }
          });
        });
      }, this.fetchRemoteConfig = function(Bt, Vt) {
        return __awaiter$1(Mt, void 0, void 0, function() {
          var zt, Ht, Wt, Gt, qt, Kt, Qt, Xt, Zt, Yt, Jt, er;
          return __generator$1(this, function(tr) {
            switch (tr.label) {
              case 0:
                if (Vt === this.lastFetchedSessionId && this.attempts >= this.localConfig.flushMaxRetries)
                  return [2, this.completeRequest({ err: MAX_RETRIES_EXCEEDED_MESSAGE })];
                if (Bt.aborted)
                  return [2, this.completeRequest({ err: TIMEOUT_MESSAGE })];
                Vt !== this.lastFetchedSessionId && (this.lastFetchedSessionId = Vt, this.attempts = 0), tr.label = 1;
              case 1:
                tr.trys.push([1, 3, , 4]), zt = new URLSearchParams({
                  api_key: this.localConfig.apiKey
                });
                try {
                  for (Ht = __values(this.configKeys), Wt = Ht.next(); !Wt.done; Wt = Ht.next())
                    Gt = Wt.value, zt.append("config_keys", Gt);
                } catch (nr) {
                  Jt = { error: nr };
                } finally {
                  try {
                    Wt && !Wt.done && (er = Ht.return) && er.call(Ht);
                  } finally {
                    if (Jt)
                      throw Jt.error;
                  }
                }
                return Vt && zt.set("session_id", String(Vt)), qt = {
                  headers: {
                    Accept: "*/*"
                  },
                  method: "GET"
                }, Kt = "".concat(this.getServerUrl(), "?").concat(zt.toString()), this.attempts += 1, [4, fetch(Kt, __assign$3(__assign$3({}, qt), { signal: Bt }))];
              case 2:
                if (Qt = tr.sent(), Qt === null)
                  return [2, this.completeRequest({ err: UNEXPECTED_ERROR_MESSAGE })];
                switch (Xt = new BaseTransport().buildStatus(Qt.status), Xt) {
                  case Status.Success:
                    return this.attempts = 0, [2, this.parseAndStoreConfig(Qt)];
                  case Status.Failed:
                    return [2, this.retryFetch(Bt, Vt)];
                  default:
                    return [2, this.completeRequest({ err: UNEXPECTED_NETWORK_ERROR_MESSAGE })];
                }
              case 3:
                return Zt = tr.sent(), Yt = Zt, Bt.aborted ? [2, this.completeRequest({ err: TIMEOUT_MESSAGE })] : [2, this.completeRequest({ err: Yt.message })];
              case 4:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, this.retryFetch = function(Bt, Vt) {
        return __awaiter$1(Mt, void 0, void 0, function() {
          var zt = this;
          return __generator$1(this, function(Ht) {
            switch (Ht.label) {
              case 0:
                return [4, new Promise(function(Wt) {
                  return setTimeout(Wt, zt.attempts * zt.retryTimeout);
                })];
              case 1:
                return Ht.sent(), [2, this.fetchRemoteConfig(Bt, Vt)];
            }
          });
        });
      }, this.parseAndStoreConfig = function(Bt) {
        return __awaiter$1(Mt, void 0, void 0, function() {
          var Vt;
          return __generator$1(this, function(zt) {
            switch (zt.label) {
              case 0:
                return [4, Bt.json()];
              case 1:
                return Vt = zt.sent(), this.completeRequest({ success: SUCCESS_REMOTE_CONFIG }), [2, Vt];
            }
          });
        });
      }, this.localConfig = Pt, this.configKeys = $t;
    }
    return _t.prototype.getServerUrl = function() {
      return this.localConfig.serverZone === ServerZone.STAGING ? REMOTE_CONFIG_SERVER_URL_STAGING : this.localConfig.serverZone === ServerZone.EU ? REMOTE_CONFIG_SERVER_URL_EU : REMOTE_CONFIG_SERVER_URL;
    }, _t.prototype.completeRequest = function(Et) {
      var Pt = Et.err, $t = Et.success;
      if (Pt)
        throw new Error(Pt);
      $t && this.localConfig.loggerProvider.log($t);
    }, _t;
  }()
), createRemoteConfigFetch$1 = function(_t) {
  var Et = _t.localConfig, Pt = _t.configKeys;
  return __awaiter$1(void 0, void 0, void 0, function() {
    return __generator$1(this, function($t) {
      return [2, new RemoteConfigFetch({ localConfig: Et, configKeys: Pt })];
    });
  });
}, createRemoteConfigFetch = createRemoteConfigFetch$1, BrowserJoinedConfigGenerator = (
  /** @class */
  function() {
    function _t(Et) {
      this.config = Et, this.config.loggerProvider.debug("Local configuration before merging with remote config", JSON.stringify(this.config, null, 2));
    }
    return _t.prototype.initialize = function() {
      return __awaiter$1(this, void 0, void 0, function() {
        var Et;
        return __generator$1(this, function(Pt) {
          switch (Pt.label) {
            case 0:
              return Et = this, [4, createRemoteConfigFetch({
                localConfig: this.config,
                configKeys: ["analyticsSDK"]
              })];
            case 1:
              return Et.remoteConfigFetch = Pt.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, _t.prototype.generateJoinedConfig = function() {
      var Et, Pt, $t, Mt;
      return __awaiter$1(this, void 0, void 0, function() {
        var Bt, Vt, zt;
        return __generator$1(this, function(Ht) {
          switch (Ht.label) {
            case 0:
              return Ht.trys.push([0, 3, , 4]), Vt = this.remoteConfigFetch, Vt ? [4, this.remoteConfigFetch.getRemoteConfig("analyticsSDK", "browserSDK", this.config.sessionId)] : [3, 2];
            case 1:
              Vt = Ht.sent(), Ht.label = 2;
            case 2:
              return Bt = Vt, this.config.loggerProvider.debug("Remote configuration:", JSON.stringify(Bt, null, 2)), Bt && "autocapture" in Bt && (typeof Bt.autocapture == "boolean" && (this.config.autocapture = Bt.autocapture), typeof Bt.autocapture == "object" && (this.config.autocapture === void 0 && (this.config.autocapture = Bt.autocapture), typeof this.config.autocapture == "boolean" && (this.config.autocapture = __assign$3({ attribution: this.config.autocapture, fileDownloads: this.config.autocapture, formInteractions: this.config.autocapture, pageViews: this.config.autocapture, sessions: this.config.autocapture, elementInteractions: this.config.autocapture }, Bt.autocapture)), typeof this.config.autocapture == "object" && (this.config.autocapture = __assign$3(__assign$3({}, this.config.autocapture), Bt.autocapture))), this.config.defaultTracking = this.config.autocapture), this.config.loggerProvider.debug("Joined configuration: ", JSON.stringify(this.config, null, 2)), (Et = (Mt = this.config).requestMetadata) !== null && Et !== void 0 || (Mt.requestMetadata = new RequestMetadata()), !((Pt = this.remoteConfigFetch) === null || Pt === void 0) && Pt.metrics.fetchTimeAPISuccess && this.config.requestMetadata.recordHistogram("remote_config_fetch_time_API_success", this.remoteConfigFetch.metrics.fetchTimeAPISuccess), !(($t = this.remoteConfigFetch) === null || $t === void 0) && $t.metrics.fetchTimeAPIFail && this.config.requestMetadata.recordHistogram("remote_config_fetch_time_API_fail", this.remoteConfigFetch.metrics.fetchTimeAPIFail), [3, 4];
            case 3:
              return zt = Ht.sent(), this.config.loggerProvider.error("Failed to fetch remote configuration because of error: ", zt), [3, 4];
            case 4:
              return [2, this.config];
          }
        });
      });
    }, _t;
  }()
), createBrowserJoinedConfigGenerator = function(_t) {
  return __awaiter$1(void 0, void 0, void 0, function() {
    var Et;
    return __generator$1(this, function(Pt) {
      switch (Pt.label) {
        case 0:
          return Et = new BrowserJoinedConfigGenerator(_t), [4, Et.initialize()];
        case 1:
          return Pt.sent(), [2, Et];
      }
    });
  });
}, PLUGIN_NAME = "@amplitude/plugin-autocapture-browser", AMPLITUDE_ELEMENT_CLICKED_EVENT = "[Amplitude] Element Clicked", AMPLITUDE_ELEMENT_CHANGED_EVENT = "[Amplitude] Element Changed", AMPLITUDE_EVENT_PROP_ELEMENT_ID = "[Amplitude] Element ID", AMPLITUDE_EVENT_PROP_ELEMENT_CLASS = "[Amplitude] Element Class", AMPLITUDE_EVENT_PROP_ELEMENT_TAG = "[Amplitude] Element Tag", AMPLITUDE_EVENT_PROP_ELEMENT_TEXT = "[Amplitude] Element Text", AMPLITUDE_EVENT_PROP_ELEMENT_HIERARCHY = "[Amplitude] Element Hierarchy", AMPLITUDE_EVENT_PROP_ELEMENT_HREF = "[Amplitude] Element Href", AMPLITUDE_EVENT_PROP_ELEMENT_POSITION_LEFT = "[Amplitude] Element Position Left", AMPLITUDE_EVENT_PROP_ELEMENT_POSITION_TOP = "[Amplitude] Element Position Top", AMPLITUDE_EVENT_PROP_ELEMENT_ARIA_LABEL = "[Amplitude] Element Aria Label", AMPLITUDE_EVENT_PROP_ELEMENT_ATTRIBUTES = "[Amplitude] Element Attributes", AMPLITUDE_EVENT_PROP_ELEMENT_SELECTOR = "[Amplitude] Element Selector", AMPLITUDE_EVENT_PROP_ELEMENT_PARENT_LABEL = "[Amplitude] Element Parent Label", AMPLITUDE_EVENT_PROP_PAGE_URL = "[Amplitude] Page URL", AMPLITUDE_EVENT_PROP_PAGE_TITLE = "[Amplitude] Page Title", AMPLITUDE_EVENT_PROP_VIEWPORT_HEIGHT = "[Amplitude] Viewport Height", AMPLITUDE_EVENT_PROP_VIEWPORT_WIDTH = "[Amplitude] Viewport Width", AMPLITUDE_ORIGIN = "https://app.amplitude.com", AMPLITUDE_ORIGIN_EU = "https://app.eu.amplitude.com", AMPLITUDE_ORIGIN_STAGING = "https://apps.stag2.amplitude.com", AMPLITUDE_ORIGINS_MAP = {
  US: AMPLITUDE_ORIGIN,
  EU: AMPLITUDE_ORIGIN_EU,
  STAGING: AMPLITUDE_ORIGIN_STAGING
}, AMPLITUDE_VISUAL_TAGGING_SELECTOR_SCRIPT_URL = "https://cdn.amplitude.com/libs/visual-tagging-selector-1.0.0-alpha.js.gz", AMPLITUDE_VISUAL_TAGGING_HIGHLIGHT_CLASS = "amp-visual-tagging-selector-highlight";
function isFunction$2(_t) {
  return typeof _t == "function";
}
function createErrorClass(_t) {
  var Et = function($t) {
    Error.call($t), $t.stack = new Error().stack;
  }, Pt = _t(Et);
  return Pt.prototype = Object.create(Error.prototype), Pt.prototype.constructor = Pt, Pt;
}
var UnsubscriptionError = createErrorClass(function(_t) {
  return function(Pt) {
    _t(this), this.message = Pt ? Pt.length + ` errors occurred during unsubscription:
` + Pt.map(function($t, Mt) {
      return Mt + 1 + ") " + $t.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = Pt;
  };
});
function arrRemove(_t, Et) {
  if (_t) {
    var Pt = _t.indexOf(Et);
    0 <= Pt && _t.splice(Pt, 1);
  }
}
var Subscription = function() {
  function _t(Et) {
    this.initialTeardown = Et, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return _t.prototype.unsubscribe = function() {
    var Et, Pt, $t, Mt, Bt;
    if (!this.closed) {
      this.closed = !0;
      var Vt = this._parentage;
      if (Vt)
        if (this._parentage = null, Array.isArray(Vt))
          try {
            for (var zt = __values(Vt), Ht = zt.next(); !Ht.done; Ht = zt.next()) {
              var Wt = Ht.value;
              Wt.remove(this);
            }
          } catch (Zt) {
            Et = { error: Zt };
          } finally {
            try {
              Ht && !Ht.done && (Pt = zt.return) && Pt.call(zt);
            } finally {
              if (Et)
                throw Et.error;
            }
          }
        else
          Vt.remove(this);
      var Gt = this.initialTeardown;
      if (isFunction$2(Gt))
        try {
          Gt();
        } catch (Zt) {
          Bt = Zt instanceof UnsubscriptionError ? Zt.errors : [Zt];
        }
      var qt = this._finalizers;
      if (qt) {
        this._finalizers = null;
        try {
          for (var Kt = __values(qt), Qt = Kt.next(); !Qt.done; Qt = Kt.next()) {
            var Xt = Qt.value;
            try {
              execFinalizer(Xt);
            } catch (Zt) {
              Bt = Bt ?? [], Zt instanceof UnsubscriptionError ? Bt = __spreadArray$1(__spreadArray$1([], __read(Bt)), __read(Zt.errors)) : Bt.push(Zt);
            }
          }
        } catch (Zt) {
          $t = { error: Zt };
        } finally {
          try {
            Qt && !Qt.done && (Mt = Kt.return) && Mt.call(Kt);
          } finally {
            if ($t)
              throw $t.error;
          }
        }
      }
      if (Bt)
        throw new UnsubscriptionError(Bt);
    }
  }, _t.prototype.add = function(Et) {
    var Pt;
    if (Et && Et !== this)
      if (this.closed)
        execFinalizer(Et);
      else {
        if (Et instanceof _t) {
          if (Et.closed || Et._hasParent(this))
            return;
          Et._addParent(this);
        }
        (this._finalizers = (Pt = this._finalizers) !== null && Pt !== void 0 ? Pt : []).push(Et);
      }
  }, _t.prototype._hasParent = function(Et) {
    var Pt = this._parentage;
    return Pt === Et || Array.isArray(Pt) && Pt.includes(Et);
  }, _t.prototype._addParent = function(Et) {
    var Pt = this._parentage;
    this._parentage = Array.isArray(Pt) ? (Pt.push(Et), Pt) : Pt ? [Pt, Et] : Et;
  }, _t.prototype._removeParent = function(Et) {
    var Pt = this._parentage;
    Pt === Et ? this._parentage = null : Array.isArray(Pt) && arrRemove(Pt, Et);
  }, _t.prototype.remove = function(Et) {
    var Pt = this._finalizers;
    Pt && arrRemove(Pt, Et), Et instanceof _t && Et._removeParent(this);
  }, _t.EMPTY = function() {
    var Et = new _t();
    return Et.closed = !0, Et;
  }(), _t;
}();
Subscription.EMPTY;
function isSubscription(_t) {
  return _t instanceof Subscription || _t && "closed" in _t && isFunction$2(_t.remove) && isFunction$2(_t.add) && isFunction$2(_t.unsubscribe);
}
function execFinalizer(_t) {
  isFunction$2(_t) ? _t() : _t.unsubscribe();
}
var config$1 = {
  onUnhandledError: null,
  onStoppedNotification: null,
  Promise: void 0,
  useDeprecatedSynchronousErrorHandling: !1,
  useDeprecatedNextContext: !1
}, timeoutProvider = {
  setTimeout: function(_t, Et) {
    for (var Pt = [], $t = 2; $t < arguments.length; $t++)
      Pt[$t - 2] = arguments[$t];
    return setTimeout.apply(void 0, __spreadArray$1([_t, Et], __read(Pt)));
  },
  clearTimeout: function(_t) {
    var Et = timeoutProvider.delegate;
    return ((Et == null ? void 0 : Et.clearTimeout) || clearTimeout)(_t);
  },
  delegate: void 0
};
function reportUnhandledError(_t) {
  timeoutProvider.setTimeout(function() {
    throw _t;
  });
}
function noop$4() {
}
function errorContext(_t) {
  _t();
}
var Subscriber = function(_t) {
  __extends$1(Et, _t);
  function Et(Pt) {
    var $t = _t.call(this) || this;
    return $t.isStopped = !1, Pt ? ($t.destination = Pt, isSubscription(Pt) && Pt.add($t)) : $t.destination = EMPTY_OBSERVER, $t;
  }
  return Et.create = function(Pt, $t, Mt) {
    return new SafeSubscriber(Pt, $t, Mt);
  }, Et.prototype.next = function(Pt) {
    this.isStopped || this._next(Pt);
  }, Et.prototype.error = function(Pt) {
    this.isStopped || (this.isStopped = !0, this._error(Pt));
  }, Et.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, Et.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, _t.prototype.unsubscribe.call(this), this.destination = null);
  }, Et.prototype._next = function(Pt) {
    this.destination.next(Pt);
  }, Et.prototype._error = function(Pt) {
    try {
      this.destination.error(Pt);
    } finally {
      this.unsubscribe();
    }
  }, Et.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, Et;
}(Subscription), _bind = Function.prototype.bind;
function bind$1(_t, Et) {
  return _bind.call(_t, Et);
}
var ConsumerObserver = function() {
  function _t(Et) {
    this.partialObserver = Et;
  }
  return _t.prototype.next = function(Et) {
    var Pt = this.partialObserver;
    if (Pt.next)
      try {
        Pt.next(Et);
      } catch ($t) {
        handleUnhandledError($t);
      }
  }, _t.prototype.error = function(Et) {
    var Pt = this.partialObserver;
    if (Pt.error)
      try {
        Pt.error(Et);
      } catch ($t) {
        handleUnhandledError($t);
      }
    else
      handleUnhandledError(Et);
  }, _t.prototype.complete = function() {
    var Et = this.partialObserver;
    if (Et.complete)
      try {
        Et.complete();
      } catch (Pt) {
        handleUnhandledError(Pt);
      }
  }, _t;
}(), SafeSubscriber = function(_t) {
  __extends$1(Et, _t);
  function Et(Pt, $t, Mt) {
    var Bt = _t.call(this) || this, Vt;
    if (isFunction$2(Pt) || !Pt)
      Vt = {
        next: Pt ?? void 0,
        error: $t ?? void 0,
        complete: Mt ?? void 0
      };
    else {
      var zt;
      Bt && config$1.useDeprecatedNextContext ? (zt = Object.create(Pt), zt.unsubscribe = function() {
        return Bt.unsubscribe();
      }, Vt = {
        next: Pt.next && bind$1(Pt.next, zt),
        error: Pt.error && bind$1(Pt.error, zt),
        complete: Pt.complete && bind$1(Pt.complete, zt)
      }) : Vt = Pt;
    }
    return Bt.destination = new ConsumerObserver(Vt), Bt;
  }
  return Et;
}(Subscriber);
function handleUnhandledError(_t) {
  reportUnhandledError(_t);
}
function defaultErrorHandler(_t) {
  throw _t;
}
var EMPTY_OBSERVER = {
  closed: !0,
  next: noop$4,
  error: defaultErrorHandler,
  complete: noop$4
}, observable = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function identity(_t) {
  return _t;
}
function pipeFromArray(_t) {
  return _t.length === 0 ? identity : _t.length === 1 ? _t[0] : function(Pt) {
    return _t.reduce(function($t, Mt) {
      return Mt($t);
    }, Pt);
  };
}
var Observable = function() {
  function _t(Et) {
    Et && (this._subscribe = Et);
  }
  return _t.prototype.lift = function(Et) {
    var Pt = new _t();
    return Pt.source = this, Pt.operator = Et, Pt;
  }, _t.prototype.subscribe = function(Et, Pt, $t) {
    var Mt = this, Bt = isSubscriber(Et) ? Et : new SafeSubscriber(Et, Pt, $t);
    return errorContext(function() {
      var Vt = Mt, zt = Vt.operator, Ht = Vt.source;
      Bt.add(zt ? zt.call(Bt, Ht) : Ht ? Mt._subscribe(Bt) : Mt._trySubscribe(Bt));
    }), Bt;
  }, _t.prototype._trySubscribe = function(Et) {
    try {
      return this._subscribe(Et);
    } catch (Pt) {
      Et.error(Pt);
    }
  }, _t.prototype.forEach = function(Et, Pt) {
    var $t = this;
    return Pt = getPromiseCtor(Pt), new Pt(function(Mt, Bt) {
      var Vt = new SafeSubscriber({
        next: function(zt) {
          try {
            Et(zt);
          } catch (Ht) {
            Bt(Ht), Vt.unsubscribe();
          }
        },
        error: Bt,
        complete: Mt
      });
      $t.subscribe(Vt);
    });
  }, _t.prototype._subscribe = function(Et) {
    var Pt;
    return (Pt = this.source) === null || Pt === void 0 ? void 0 : Pt.subscribe(Et);
  }, _t.prototype[observable] = function() {
    return this;
  }, _t.prototype.pipe = function() {
    for (var Et = [], Pt = 0; Pt < arguments.length; Pt++)
      Et[Pt] = arguments[Pt];
    return pipeFromArray(Et)(this);
  }, _t.prototype.toPromise = function(Et) {
    var Pt = this;
    return Et = getPromiseCtor(Et), new Et(function($t, Mt) {
      var Bt;
      Pt.subscribe(function(Vt) {
        return Bt = Vt;
      }, function(Vt) {
        return Mt(Vt);
      }, function() {
        return $t(Bt);
      });
    });
  }, _t.create = function(Et) {
    return new _t(Et);
  }, _t;
}();
function getPromiseCtor(_t) {
  var Et;
  return (Et = _t ?? config$1.Promise) !== null && Et !== void 0 ? Et : Promise;
}
function isObserver(_t) {
  return _t && isFunction$2(_t.next) && isFunction$2(_t.error) && isFunction$2(_t.complete);
}
function isSubscriber(_t) {
  return _t && _t instanceof Subscriber || isObserver(_t) && isSubscription(_t);
}
function hasLift(_t) {
  return isFunction$2(_t == null ? void 0 : _t.lift);
}
function operate(_t) {
  return function(Et) {
    if (hasLift(Et))
      return Et.lift(function(Pt) {
        try {
          return _t(Pt, this);
        } catch ($t) {
          this.error($t);
        }
      });
    throw new TypeError("Unable to lift unknown Observable type");
  };
}
function createOperatorSubscriber(_t, Et, Pt, $t, Mt) {
  return new OperatorSubscriber(_t, Et, Pt, $t, Mt);
}
var OperatorSubscriber = function(_t) {
  __extends$1(Et, _t);
  function Et(Pt, $t, Mt, Bt, Vt, zt) {
    var Ht = _t.call(this, Pt) || this;
    return Ht.onFinalize = Vt, Ht.shouldUnsubscribe = zt, Ht._next = $t ? function(Wt) {
      try {
        $t(Wt);
      } catch (Gt) {
        Pt.error(Gt);
      }
    } : _t.prototype._next, Ht._error = Bt ? function(Wt) {
      try {
        Bt(Wt);
      } catch (Gt) {
        Pt.error(Gt);
      } finally {
        this.unsubscribe();
      }
    } : _t.prototype._error, Ht._complete = Mt ? function() {
      try {
        Mt();
      } catch (Wt) {
        Pt.error(Wt);
      } finally {
        this.unsubscribe();
      }
    } : _t.prototype._complete, Ht;
  }
  return Et.prototype.unsubscribe = function() {
    var Pt;
    if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
      var $t = this.closed;
      _t.prototype.unsubscribe.call(this), !$t && ((Pt = this.onFinalize) === null || Pt === void 0 || Pt.call(this));
    }
  }, Et;
}(Subscriber), dateTimestampProvider = {
  now: function() {
    return Date.now();
  },
  delegate: void 0
}, Action = function(_t) {
  __extends$1(Et, _t);
  function Et(Pt, $t) {
    return _t.call(this) || this;
  }
  return Et.prototype.schedule = function(Pt, $t) {
    return this;
  }, Et;
}(Subscription), intervalProvider = {
  setInterval: function(_t, Et) {
    for (var Pt = [], $t = 2; $t < arguments.length; $t++)
      Pt[$t - 2] = arguments[$t];
    return setInterval.apply(void 0, __spreadArray$1([_t, Et], __read(Pt)));
  },
  clearInterval: function(_t) {
    var Et = intervalProvider.delegate;
    return ((Et == null ? void 0 : Et.clearInterval) || clearInterval)(_t);
  },
  delegate: void 0
}, AsyncAction = function(_t) {
  __extends$1(Et, _t);
  function Et(Pt, $t) {
    var Mt = _t.call(this, Pt, $t) || this;
    return Mt.scheduler = Pt, Mt.work = $t, Mt.pending = !1, Mt;
  }
  return Et.prototype.schedule = function(Pt, $t) {
    var Mt;
    if ($t === void 0 && ($t = 0), this.closed)
      return this;
    this.state = Pt;
    var Bt = this.id, Vt = this.scheduler;
    return Bt != null && (this.id = this.recycleAsyncId(Vt, Bt, $t)), this.pending = !0, this.delay = $t, this.id = (Mt = this.id) !== null && Mt !== void 0 ? Mt : this.requestAsyncId(Vt, this.id, $t), this;
  }, Et.prototype.requestAsyncId = function(Pt, $t, Mt) {
    return Mt === void 0 && (Mt = 0), intervalProvider.setInterval(Pt.flush.bind(Pt, this), Mt);
  }, Et.prototype.recycleAsyncId = function(Pt, $t, Mt) {
    if (Mt === void 0 && (Mt = 0), Mt != null && this.delay === Mt && this.pending === !1)
      return $t;
    $t != null && intervalProvider.clearInterval($t);
  }, Et.prototype.execute = function(Pt, $t) {
    if (this.closed)
      return new Error("executing a cancelled action");
    this.pending = !1;
    var Mt = this._execute(Pt, $t);
    if (Mt)
      return Mt;
    this.pending === !1 && this.id != null && (this.id = this.recycleAsyncId(this.scheduler, this.id, null));
  }, Et.prototype._execute = function(Pt, $t) {
    var Mt = !1, Bt;
    try {
      this.work(Pt);
    } catch (Vt) {
      Mt = !0, Bt = Vt || new Error("Scheduled action threw falsy error");
    }
    if (Mt)
      return this.unsubscribe(), Bt;
  }, Et.prototype.unsubscribe = function() {
    if (!this.closed) {
      var Pt = this, $t = Pt.id, Mt = Pt.scheduler, Bt = Mt.actions;
      this.work = this.state = this.scheduler = null, this.pending = !1, arrRemove(Bt, this), $t != null && (this.id = this.recycleAsyncId(Mt, $t, null)), this.delay = null, _t.prototype.unsubscribe.call(this);
    }
  }, Et;
}(Action), Scheduler = function() {
  function _t(Et, Pt) {
    Pt === void 0 && (Pt = _t.now), this.schedulerActionCtor = Et, this.now = Pt;
  }
  return _t.prototype.schedule = function(Et, Pt, $t) {
    return Pt === void 0 && (Pt = 0), new this.schedulerActionCtor(this, Et).schedule($t, Pt);
  }, _t.now = dateTimestampProvider.now, _t;
}(), AsyncScheduler = function(_t) {
  __extends$1(Et, _t);
  function Et(Pt, $t) {
    $t === void 0 && ($t = Scheduler.now);
    var Mt = _t.call(this, Pt, $t) || this;
    return Mt.actions = [], Mt._active = !1, Mt;
  }
  return Et.prototype.flush = function(Pt) {
    var $t = this.actions;
    if (this._active) {
      $t.push(Pt);
      return;
    }
    var Mt;
    this._active = !0;
    do
      if (Mt = Pt.execute(Pt.state, Pt.delay))
        break;
    while (Pt = $t.shift());
    if (this._active = !1, Mt) {
      for (; Pt = $t.shift(); )
        Pt.unsubscribe();
      throw Mt;
    }
  }, Et;
}(Scheduler), asyncScheduler = new AsyncScheduler(AsyncAction), async = asyncScheduler, EMPTY = new Observable(function(_t) {
  return _t.complete();
});
function isScheduler(_t) {
  return _t && isFunction$2(_t.schedule);
}
function last(_t) {
  return _t[_t.length - 1];
}
function popScheduler(_t) {
  return isScheduler(last(_t)) ? _t.pop() : void 0;
}
function popNumber(_t, Et) {
  return typeof last(_t) == "number" ? _t.pop() : Et;
}
var isArrayLike = function(_t) {
  return _t && typeof _t.length == "number" && typeof _t != "function";
};
function isPromise(_t) {
  return isFunction$2(_t == null ? void 0 : _t.then);
}
function isInteropObservable(_t) {
  return isFunction$2(_t[observable]);
}
function isAsyncIterable(_t) {
  return Symbol.asyncIterator && isFunction$2(_t == null ? void 0 : _t[Symbol.asyncIterator]);
}
function createInvalidObservableTypeError(_t) {
  return new TypeError("You provided " + (_t !== null && typeof _t == "object" ? "an invalid object" : "'" + _t + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}
function getSymbolIterator() {
  return typeof Symbol != "function" || !Symbol.iterator ? "@@iterator" : Symbol.iterator;
}
var iterator = getSymbolIterator();
function isIterable(_t) {
  return isFunction$2(_t == null ? void 0 : _t[iterator]);
}
function readableStreamLikeToAsyncGenerator(_t) {
  return __asyncGenerator(this, arguments, function() {
    var Pt, $t, Mt, Bt;
    return __generator$1(this, function(Vt) {
      switch (Vt.label) {
        case 0:
          Pt = _t.getReader(), Vt.label = 1;
        case 1:
          Vt.trys.push([1, , 9, 10]), Vt.label = 2;
        case 2:
          return [4, __await(Pt.read())];
        case 3:
          return $t = Vt.sent(), Mt = $t.value, Bt = $t.done, Bt ? [4, __await(void 0)] : [3, 5];
        case 4:
          return [2, Vt.sent()];
        case 5:
          return [4, __await(Mt)];
        case 6:
          return [4, Vt.sent()];
        case 7:
          return Vt.sent(), [3, 2];
        case 8:
          return [3, 10];
        case 9:
          return Pt.releaseLock(), [7];
        case 10:
          return [2];
      }
    });
  });
}
function isReadableStreamLike(_t) {
  return isFunction$2(_t == null ? void 0 : _t.getReader);
}
function innerFrom(_t) {
  if (_t instanceof Observable)
    return _t;
  if (_t != null) {
    if (isInteropObservable(_t))
      return fromInteropObservable(_t);
    if (isArrayLike(_t))
      return fromArrayLike$1(_t);
    if (isPromise(_t))
      return fromPromise(_t);
    if (isAsyncIterable(_t))
      return fromAsyncIterable(_t);
    if (isIterable(_t))
      return fromIterable(_t);
    if (isReadableStreamLike(_t))
      return fromReadableStreamLike(_t);
  }
  throw createInvalidObservableTypeError(_t);
}
function fromInteropObservable(_t) {
  return new Observable(function(Et) {
    var Pt = _t[observable]();
    if (isFunction$2(Pt.subscribe))
      return Pt.subscribe(Et);
    throw new TypeError("Provided object does not correctly implement Symbol.observable");
  });
}
function fromArrayLike$1(_t) {
  return new Observable(function(Et) {
    for (var Pt = 0; Pt < _t.length && !Et.closed; Pt++)
      Et.next(_t[Pt]);
    Et.complete();
  });
}
function fromPromise(_t) {
  return new Observable(function(Et) {
    _t.then(function(Pt) {
      Et.closed || (Et.next(Pt), Et.complete());
    }, function(Pt) {
      return Et.error(Pt);
    }).then(null, reportUnhandledError);
  });
}
function fromIterable(_t) {
  return new Observable(function(Et) {
    var Pt, $t;
    try {
      for (var Mt = __values(_t), Bt = Mt.next(); !Bt.done; Bt = Mt.next()) {
        var Vt = Bt.value;
        if (Et.next(Vt), Et.closed)
          return;
      }
    } catch (zt) {
      Pt = { error: zt };
    } finally {
      try {
        Bt && !Bt.done && ($t = Mt.return) && $t.call(Mt);
      } finally {
        if (Pt)
          throw Pt.error;
      }
    }
    Et.complete();
  });
}
function fromAsyncIterable(_t) {
  return new Observable(function(Et) {
    process$1(_t, Et).catch(function(Pt) {
      return Et.error(Pt);
    });
  });
}
function fromReadableStreamLike(_t) {
  return fromAsyncIterable(readableStreamLikeToAsyncGenerator(_t));
}
function process$1(_t, Et) {
  var Pt, $t, Mt, Bt;
  return __awaiter$1(this, void 0, void 0, function() {
    var Vt, zt;
    return __generator$1(this, function(Ht) {
      switch (Ht.label) {
        case 0:
          Ht.trys.push([0, 5, 6, 11]), Pt = __asyncValues(_t), Ht.label = 1;
        case 1:
          return [4, Pt.next()];
        case 2:
          if ($t = Ht.sent(), !!$t.done)
            return [3, 4];
          if (Vt = $t.value, Et.next(Vt), Et.closed)
            return [2];
          Ht.label = 3;
        case 3:
          return [3, 1];
        case 4:
          return [3, 11];
        case 5:
          return zt = Ht.sent(), Mt = { error: zt }, [3, 11];
        case 6:
          return Ht.trys.push([6, , 9, 10]), $t && !$t.done && (Bt = Pt.return) ? [4, Bt.call(Pt)] : [3, 8];
        case 7:
          Ht.sent(), Ht.label = 8;
        case 8:
          return [3, 10];
        case 9:
          if (Mt)
            throw Mt.error;
          return [7];
        case 10:
          return [7];
        case 11:
          return Et.complete(), [2];
      }
    });
  });
}
function executeSchedule(_t, Et, Pt, $t, Mt) {
  $t === void 0 && ($t = 0), Mt === void 0 && (Mt = !1);
  var Bt = Et.schedule(function() {
    Pt(), Mt ? _t.add(this.schedule(null, $t)) : this.unsubscribe();
  }, $t);
  if (_t.add(Bt), !Mt)
    return Bt;
}
function observeOn(_t, Et) {
  return Et === void 0 && (Et = 0), operate(function(Pt, $t) {
    Pt.subscribe(createOperatorSubscriber($t, function(Mt) {
      return executeSchedule($t, _t, function() {
        return $t.next(Mt);
      }, Et);
    }, function() {
      return executeSchedule($t, _t, function() {
        return $t.complete();
      }, Et);
    }, function(Mt) {
      return executeSchedule($t, _t, function() {
        return $t.error(Mt);
      }, Et);
    }));
  });
}
function subscribeOn(_t, Et) {
  return Et === void 0 && (Et = 0), operate(function(Pt, $t) {
    $t.add(_t.schedule(function() {
      return Pt.subscribe($t);
    }, Et));
  });
}
function scheduleObservable(_t, Et) {
  return innerFrom(_t).pipe(subscribeOn(Et), observeOn(Et));
}
function schedulePromise(_t, Et) {
  return innerFrom(_t).pipe(subscribeOn(Et), observeOn(Et));
}
function scheduleArray(_t, Et) {
  return new Observable(function(Pt) {
    var $t = 0;
    return Et.schedule(function() {
      $t === _t.length ? Pt.complete() : (Pt.next(_t[$t++]), Pt.closed || this.schedule());
    });
  });
}
function scheduleIterable(_t, Et) {
  return new Observable(function(Pt) {
    var $t;
    return executeSchedule(Pt, Et, function() {
      $t = _t[iterator](), executeSchedule(Pt, Et, function() {
        var Mt, Bt, Vt;
        try {
          Mt = $t.next(), Bt = Mt.value, Vt = Mt.done;
        } catch (zt) {
          Pt.error(zt);
          return;
        }
        Vt ? Pt.complete() : Pt.next(Bt);
      }, 0, !0);
    }), function() {
      return isFunction$2($t == null ? void 0 : $t.return) && $t.return();
    };
  });
}
function scheduleAsyncIterable(_t, Et) {
  if (!_t)
    throw new Error("Iterable cannot be null");
  return new Observable(function(Pt) {
    executeSchedule(Pt, Et, function() {
      var $t = _t[Symbol.asyncIterator]();
      executeSchedule(Pt, Et, function() {
        $t.next().then(function(Mt) {
          Mt.done ? Pt.complete() : Pt.next(Mt.value);
        });
      }, 0, !0);
    });
  });
}
function scheduleReadableStreamLike(_t, Et) {
  return scheduleAsyncIterable(readableStreamLikeToAsyncGenerator(_t), Et);
}
function scheduled(_t, Et) {
  if (_t != null) {
    if (isInteropObservable(_t))
      return scheduleObservable(_t, Et);
    if (isArrayLike(_t))
      return scheduleArray(_t, Et);
    if (isPromise(_t))
      return schedulePromise(_t, Et);
    if (isAsyncIterable(_t))
      return scheduleAsyncIterable(_t, Et);
    if (isIterable(_t))
      return scheduleIterable(_t, Et);
    if (isReadableStreamLike(_t))
      return scheduleReadableStreamLike(_t, Et);
  }
  throw createInvalidObservableTypeError(_t);
}
function from$4(_t, Et) {
  return Et ? scheduled(_t, Et) : innerFrom(_t);
}
function isValidDate(_t) {
  return _t instanceof Date && !isNaN(_t);
}
var TimeoutError = createErrorClass(function(_t) {
  return function(Pt) {
    Pt === void 0 && (Pt = null), _t(this), this.message = "Timeout has occurred", this.name = "TimeoutError", this.info = Pt;
  };
});
function timeout(_t, Et) {
  var Pt = isValidDate(_t) ? { first: _t } : typeof _t == "number" ? { each: _t } : _t, $t = Pt.first, Mt = Pt.each, Bt = Pt.with, Vt = Bt === void 0 ? timeoutErrorFactory : Bt, zt = Pt.scheduler, Ht = zt === void 0 ? asyncScheduler : zt, Wt = Pt.meta, Gt = Wt === void 0 ? null : Wt;
  if ($t == null && Mt == null)
    throw new TypeError("No timeout provided.");
  return operate(function(qt, Kt) {
    var Qt, Xt, Zt = null, Yt = 0, Jt = function(er) {
      Xt = executeSchedule(Kt, Ht, function() {
        try {
          Qt.unsubscribe(), innerFrom(Vt({
            meta: Gt,
            lastValue: Zt,
            seen: Yt
          })).subscribe(Kt);
        } catch (tr) {
          Kt.error(tr);
        }
      }, er);
    };
    Qt = qt.subscribe(createOperatorSubscriber(Kt, function(er) {
      Xt == null || Xt.unsubscribe(), Yt++, Kt.next(Zt = er), Mt > 0 && Jt(Mt);
    }, void 0, void 0, function() {
      Xt != null && Xt.closed || Xt == null || Xt.unsubscribe(), Zt = null;
    })), !Yt && Jt($t != null ? typeof $t == "number" ? $t : +$t - Ht.now() : Mt);
  });
}
function timeoutErrorFactory(_t) {
  throw new TimeoutError(_t);
}
function map$1(_t, Et) {
  return operate(function(Pt, $t) {
    var Mt = 0;
    Pt.subscribe(createOperatorSubscriber($t, function(Bt) {
      $t.next(_t.call(Et, Bt, Mt++));
    }));
  });
}
var isArray$3 = Array.isArray;
function callOrApply(_t, Et) {
  return isArray$3(Et) ? _t.apply(void 0, __spreadArray$1([], __read(Et))) : _t(Et);
}
function mapOneOrManyArgs(_t) {
  return map$1(function(Et) {
    return callOrApply(_t, Et);
  });
}
function mergeInternals(_t, Et, Pt, $t, Mt, Bt, Vt, zt) {
  var Ht = [], Wt = 0, Gt = 0, qt = !1, Kt = function() {
    qt && !Ht.length && !Wt && Et.complete();
  }, Qt = function(Zt) {
    return Wt < $t ? Xt(Zt) : Ht.push(Zt);
  }, Xt = function(Zt) {
    Wt++;
    var Yt = !1;
    innerFrom(Pt(Zt, Gt++)).subscribe(createOperatorSubscriber(Et, function(Jt) {
      Et.next(Jt);
    }, function() {
      Yt = !0;
    }, void 0, function() {
      if (Yt)
        try {
          Wt--;
          for (var Jt = function() {
            var er = Ht.shift();
            Vt || Xt(er);
          }; Ht.length && Wt < $t; )
            Jt();
          Kt();
        } catch (er) {
          Et.error(er);
        }
    }));
  };
  return _t.subscribe(createOperatorSubscriber(Et, Qt, function() {
    qt = !0, Kt();
  })), function() {
  };
}
function mergeMap(_t, Et, Pt) {
  return Pt === void 0 && (Pt = 1 / 0), isFunction$2(Et) ? mergeMap(function($t, Mt) {
    return map$1(function(Bt, Vt) {
      return Et($t, Bt, Mt, Vt);
    })(innerFrom(_t($t, Mt)));
  }, Pt) : (typeof Et == "number" && (Pt = Et), operate(function($t, Mt) {
    return mergeInternals($t, Mt, _t, Pt);
  }));
}
function mergeAll(_t) {
  return _t === void 0 && (_t = 1 / 0), mergeMap(identity, _t);
}
var nodeEventEmitterMethods = ["addListener", "removeListener"], eventTargetMethods = ["addEventListener", "removeEventListener"], jqueryMethods = ["on", "off"];
function fromEvent(_t, Et, Pt, $t) {
  if (isFunction$2(Pt) && ($t = Pt, Pt = void 0), $t)
    return fromEvent(_t, Et, Pt).pipe(mapOneOrManyArgs($t));
  var Mt = __read(isEventTarget(_t) ? eventTargetMethods.map(function(zt) {
    return function(Ht) {
      return _t[zt](Et, Ht, Pt);
    };
  }) : isNodeStyleEventEmitter(_t) ? nodeEventEmitterMethods.map(toCommonHandlerRegistry(_t, Et)) : isJQueryStyleEventEmitter(_t) ? jqueryMethods.map(toCommonHandlerRegistry(_t, Et)) : [], 2), Bt = Mt[0], Vt = Mt[1];
  if (!Bt && isArrayLike(_t))
    return mergeMap(function(zt) {
      return fromEvent(zt, Et, Pt);
    })(innerFrom(_t));
  if (!Bt)
    throw new TypeError("Invalid event target");
  return new Observable(function(zt) {
    var Ht = function() {
      for (var Wt = [], Gt = 0; Gt < arguments.length; Gt++)
        Wt[Gt] = arguments[Gt];
      return zt.next(1 < Wt.length ? Wt : Wt[0]);
    };
    return Bt(Ht), function() {
      return Vt(Ht);
    };
  });
}
function toCommonHandlerRegistry(_t, Et) {
  return function(Pt) {
    return function($t) {
      return _t[Pt](Et, $t);
    };
  };
}
function isNodeStyleEventEmitter(_t) {
  return isFunction$2(_t.addListener) && isFunction$2(_t.removeListener);
}
function isJQueryStyleEventEmitter(_t) {
  return isFunction$2(_t.on) && isFunction$2(_t.off);
}
function isEventTarget(_t) {
  return isFunction$2(_t.addEventListener) && isFunction$2(_t.removeEventListener);
}
function timer(_t, Et, Pt) {
  Pt === void 0 && (Pt = async);
  var $t = -1;
  return Et != null && (isScheduler(Et) ? Pt = Et : $t = Et), new Observable(function(Mt) {
    var Bt = isValidDate(_t) ? +_t - Pt.now() : _t;
    Bt < 0 && (Bt = 0);
    var Vt = 0;
    return Pt.schedule(function() {
      Mt.closed || (Mt.next(Vt++), 0 <= $t ? this.schedule(void 0, $t) : Mt.complete());
    }, Bt);
  });
}
function merge$3() {
  for (var _t = [], Et = 0; Et < arguments.length; Et++)
    _t[Et] = arguments[Et];
  var Pt = popScheduler(_t), $t = popNumber(_t, 1 / 0), Mt = _t;
  return Mt.length ? Mt.length === 1 ? innerFrom(Mt[0]) : mergeAll($t)(from$4(Mt, Pt)) : EMPTY;
}
function filter$2(_t, Et) {
  return operate(function(Pt, $t) {
    var Mt = 0;
    Pt.subscribe(createOperatorSubscriber($t, function(Bt) {
      return _t.call(Et, Bt, Mt++) && $t.next(Bt);
    }));
  });
}
function buffer(_t) {
  return operate(function(Et, Pt) {
    var $t = [];
    return Et.subscribe(createOperatorSubscriber(Pt, function(Mt) {
      return $t.push(Mt);
    }, function() {
      Pt.next($t), Pt.complete();
    })), innerFrom(_t).subscribe(createOperatorSubscriber(Pt, function() {
      var Mt = $t;
      $t = [], Pt.next(Mt);
    }, noop$4)), function() {
      $t = null;
    };
  });
}
function debounceTime(_t, Et) {
  return Et === void 0 && (Et = asyncScheduler), operate(function(Pt, $t) {
    var Mt = null, Bt = null, Vt = null, zt = function() {
      if (Mt) {
        Mt.unsubscribe(), Mt = null;
        var Wt = Bt;
        Bt = null, $t.next(Wt);
      }
    };
    function Ht() {
      var Wt = Vt + _t, Gt = Et.now();
      if (Gt < Wt) {
        Mt = this.schedule(void 0, Wt - Gt), $t.add(Mt);
        return;
      }
      zt();
    }
    Pt.subscribe(createOperatorSubscriber($t, function(Wt) {
      Bt = Wt, Vt = Et.now(), Mt || (Mt = Et.schedule(Ht, _t), $t.add(Mt));
    }, function() {
      zt(), $t.complete();
    }, void 0, function() {
      Bt = Mt = null;
    }));
  });
}
function take(_t) {
  return _t <= 0 ? function() {
    return EMPTY;
  } : operate(function(Et, Pt) {
    var $t = 0;
    Et.subscribe(createOperatorSubscriber(Pt, function(Mt) {
      ++$t <= _t && (Pt.next(Mt), _t <= $t && Pt.complete());
    }));
  });
}
function mapTo(_t) {
  return map$1(function() {
    return _t;
  });
}
function delayWhen(_t, Et) {
  return mergeMap(function(Pt, $t) {
    return innerFrom(_t(Pt, $t)).pipe(take(1), mapTo(Pt));
  });
}
function delay(_t, Et) {
  Et === void 0 && (Et = asyncScheduler);
  var Pt = timer(_t, Et);
  return delayWhen(function() {
    return Pt;
  });
}
function pairwise() {
  return operate(function(_t, Et) {
    var Pt, $t = !1;
    _t.subscribe(createOperatorSubscriber(Et, function(Mt) {
      var Bt = Pt;
      Pt = Mt, $t && Et.next([Bt, Mt]), $t = !0;
    }));
  });
}
function switchMap(_t, Et) {
  return operate(function(Pt, $t) {
    var Mt = null, Bt = 0, Vt = !1, zt = function() {
      return Vt && !Mt && $t.complete();
    };
    Pt.subscribe(createOperatorSubscriber($t, function(Ht) {
      Mt == null || Mt.unsubscribe();
      var Wt = 0, Gt = Bt++;
      innerFrom(_t(Ht, Gt)).subscribe(Mt = createOperatorSubscriber($t, function(qt) {
        return $t.next(Et ? Et(Ht, qt, Gt, Wt++) : qt);
      }, function() {
        Mt = null, zt();
      }));
    }, function() {
      Vt = !0, zt();
    }));
  });
}
var config, rootDocument;
function finder(_t, Et) {
  if (_t.nodeType !== Node.ELEMENT_NODE)
    throw new Error("Can't generate CSS selector for non-element node type.");
  if (_t.tagName.toLowerCase() === "html")
    return "html";
  var Pt = {
    root: document.body,
    idName: function(Bt) {
      return !0;
    },
    className: function(Bt) {
      return !0;
    },
    tagName: function(Bt) {
      return !0;
    },
    attr: function(Bt, Vt) {
      return !1;
    },
    seedMinLength: 1,
    optimizedMinLength: 2,
    threshold: 1e3,
    maxNumberOfTries: 1e4
  };
  config = __assign$3(__assign$3({}, Pt), Et), rootDocument = findRootDocument(config.root, Pt);
  var $t = bottomUpSearch(_t, "all", function() {
    return bottomUpSearch(_t, "two", function() {
      return bottomUpSearch(_t, "one", function() {
        return bottomUpSearch(_t, "none");
      });
    });
  });
  if ($t) {
    var Mt = sort(optimize($t, _t));
    return Mt.length > 0 && ($t = Mt[0]), selector($t);
  } else
    throw new Error("Selector was not found.");
}
function findRootDocument(_t, Et) {
  return _t.nodeType === Node.DOCUMENT_NODE ? _t : _t === Et.root ? _t.ownerDocument : _t;
}
function bottomUpSearch(_t, Et, Pt) {
  for (var $t = null, Mt = [], Bt = _t, Vt = 0, zt = function() {
    var Wt, Gt, qt = maybe(id(Bt)) || maybe.apply(void 0, __spreadArray$1([], __read(attr(Bt)), !1)) || maybe.apply(void 0, __spreadArray$1([], __read(classNames$1(Bt)), !1)) || maybe(tagName(Bt)) || [any$1()], Kt = index$1(Bt);
    if (Et == "all")
      Kt && (qt = qt.concat(qt.filter(dispensableNth).map(function(Jt) {
        return nthChild(Jt, Kt);
      })));
    else if (Et == "two")
      qt = qt.slice(0, 1), Kt && (qt = qt.concat(qt.filter(dispensableNth).map(function(Jt) {
        return nthChild(Jt, Kt);
      })));
    else if (Et == "one") {
      var Qt = __read(qt = qt.slice(0, 1), 1), Xt = Qt[0];
      Kt && dispensableNth(Xt) && (qt = [nthChild(Xt, Kt)]);
    } else
      Et == "none" && (qt = [any$1()], Kt && (qt = [nthChild(qt[0], Kt)]));
    try {
      for (var Zt = (Wt = void 0, __values(qt)), Yt = Zt.next(); !Yt.done; Yt = Zt.next()) {
        var Xt = Yt.value;
        Xt.level = Vt;
      }
    } catch (Jt) {
      Wt = { error: Jt };
    } finally {
      try {
        Yt && !Yt.done && (Gt = Zt.return) && Gt.call(Zt);
      } finally {
        if (Wt)
          throw Wt.error;
      }
    }
    if (Mt.push(qt), Mt.length >= config.seedMinLength && ($t = findUniquePath(Mt, Pt), $t))
      return "break";
    Bt = Bt.parentElement, Vt++;
  }; Bt; ) {
    var Ht = zt();
    if (Ht === "break")
      break;
  }
  return $t || ($t = findUniquePath(Mt, Pt)), !$t && Pt ? Pt() : $t;
}
function findUniquePath(_t, Et) {
  var Pt, $t, Mt = _t.reduce(function(Wt, Gt) {
    return Wt * Gt.length;
  }, 1);
  if (Mt > config.threshold)
    return Et ? Et() : null;
  var Bt = sort(combinations(_t));
  try {
    for (var Vt = __values(Bt), zt = Vt.next(); !zt.done; zt = Vt.next()) {
      var Ht = zt.value;
      if (unique(Ht))
        return Ht;
    }
  } catch (Wt) {
    Pt = { error: Wt };
  } finally {
    try {
      zt && !zt.done && ($t = Vt.return) && $t.call(Vt);
    } finally {
      if (Pt)
        throw Pt.error;
    }
  }
  return null;
}
function selector(_t) {
  for (var Et = _t[0], Pt = Et.name, $t = 1; $t < _t.length; $t++) {
    var Mt = _t[$t].level || 0;
    Et.level === Mt - 1 ? Pt = "".concat(_t[$t].name, " > ").concat(Pt) : Pt = "".concat(_t[$t].name, " ").concat(Pt), Et = _t[$t];
  }
  return Pt;
}
function penalty(_t) {
  return _t.map(function(Et) {
    return Et.penalty;
  }).reduce(function(Et, Pt) {
    return Et + Pt;
  }, 0);
}
function unique(_t) {
  var Et = selector(_t);
  switch (rootDocument.querySelectorAll(Et).length) {
    case 0:
      throw new Error("Can't select any node with this selector: ".concat(Et));
    case 1:
      return !0;
    default:
      return !1;
  }
}
function id(_t) {
  var Et = _t.getAttribute("id");
  return Et && config.idName(Et) ? {
    name: "#" + CSS.escape(Et),
    penalty: 0
  } : null;
}
function attr(_t) {
  var Et = Array.from(_t.attributes).filter(function(Pt) {
    return config.attr(Pt.name, Pt.value);
  });
  return Et.map(function(Pt) {
    return {
      name: "[".concat(CSS.escape(Pt.name), '="').concat(CSS.escape(Pt.value), '"]'),
      penalty: 0.5
    };
  });
}
function classNames$1(_t) {
  var Et = Array.from(_t.classList).filter(config.className);
  return Et.map(function(Pt) {
    return {
      name: "." + CSS.escape(Pt),
      penalty: 1
    };
  });
}
function tagName(_t) {
  var Et = _t.tagName.toLowerCase();
  return config.tagName(Et) ? {
    name: Et,
    penalty: 2
  } : null;
}
function any$1() {
  return {
    name: "*",
    penalty: 3
  };
}
function index$1(_t) {
  var Et = _t.parentNode;
  if (!Et)
    return null;
  var Pt = Et.firstChild;
  if (!Pt)
    return null;
  for (var $t = 0; Pt && (Pt.nodeType === Node.ELEMENT_NODE && $t++, Pt !== _t); )
    Pt = Pt.nextSibling;
  return $t;
}
function nthChild(_t, Et) {
  return {
    name: _t.name + ":nth-child(".concat(Et, ")"),
    penalty: _t.penalty + 1
  };
}
function dispensableNth(_t) {
  return _t.name !== "html" && !_t.name.startsWith("#");
}
function maybe() {
  for (var _t = [], Et = 0; Et < arguments.length; Et++)
    _t[Et] = arguments[Et];
  var Pt = _t.filter(notEmpty);
  return Pt.length > 0 ? Pt : null;
}
function notEmpty(_t) {
  return _t != null;
}
function combinations(_t, Et) {
  var Pt, $t, Mt, Bt, Vt, zt;
  return Et === void 0 && (Et = []), __generator$1(this, function(Ht) {
    switch (Ht.label) {
      case 0:
        if (!(_t.length > 0))
          return [3, 9];
        Ht.label = 1;
      case 1:
        Ht.trys.push([1, 6, 7, 8]), Pt = __values(_t[0]), $t = Pt.next(), Ht.label = 2;
      case 2:
        return $t.done ? [3, 5] : (Mt = $t.value, [5, __values(combinations(_t.slice(1, _t.length), Et.concat(Mt)))]);
      case 3:
        Ht.sent(), Ht.label = 4;
      case 4:
        return $t = Pt.next(), [3, 2];
      case 5:
        return [3, 8];
      case 6:
        return Bt = Ht.sent(), Vt = { error: Bt }, [3, 8];
      case 7:
        try {
          $t && !$t.done && (zt = Pt.return) && zt.call(Pt);
        } finally {
          if (Vt)
            throw Vt.error;
        }
        return [
          7
          /*endfinally*/
        ];
      case 8:
        return [3, 11];
      case 9:
        return [4, Et];
      case 10:
        Ht.sent(), Ht.label = 11;
      case 11:
        return [
          2
          /*return*/
        ];
    }
  });
}
function sort(_t) {
  return __spreadArray$1([], __read(_t), !1).sort(function(Et, Pt) {
    return penalty(Et) - penalty(Pt);
  });
}
function optimize(_t, Et, Pt) {
  var $t, Mt, Bt;
  return Pt === void 0 && (Pt = {
    counter: 0,
    visited: /* @__PURE__ */ new Map()
  }), __generator$1(this, function(Vt) {
    switch (Vt.label) {
      case 0:
        if (!(_t.length > 2 && _t.length > config.optimizedMinLength))
          return [3, 5];
        $t = 1, Vt.label = 1;
      case 1:
        return $t < _t.length - 1 ? Pt.counter > config.maxNumberOfTries ? [
          2
          /*return*/
        ] : (Pt.counter += 1, Mt = __spreadArray$1([], __read(_t), !1), Mt.splice($t, 1), Bt = selector(Mt), Pt.visited.has(Bt) ? [
          2
          /*return*/
        ] : unique(Mt) && same(Mt, Et) ? [4, Mt] : [3, 4]) : [3, 5];
      case 2:
        return Vt.sent(), Pt.visited.set(Bt, !0), [5, __values(optimize(Mt, Et, Pt))];
      case 3:
        Vt.sent(), Vt.label = 4;
      case 4:
        return $t++, [3, 1];
      case 5:
        return [
          2
          /*return*/
        ];
    }
  });
}
function same(_t, Et) {
  return rootDocument.querySelector(selector(_t)) === Et;
}
var SENSITIVE_TAGS = ["input", "select", "textarea"], createShouldTrackEvent = function(_t, Et) {
  return function(Pt, $t) {
    var Mt, Bt, Vt, zt = _t.pageUrlAllowlist, Ht = _t.shouldTrackEventResolver, Wt = (Bt = (Mt = $t == null ? void 0 : $t.tagName) === null || Mt === void 0 ? void 0 : Mt.toLowerCase) === null || Bt === void 0 ? void 0 : Bt.call(Mt);
    if (!Wt)
      return !1;
    if (Ht)
      return Ht(Pt, $t);
    if (!isPageUrlAllowed(window.location.href, zt))
      return !1;
    var Gt = String($t == null ? void 0 : $t.getAttribute("type")) || "";
    if (typeof Gt == "string")
      switch (Gt.toLowerCase()) {
        case "hidden":
          return !1;
        case "password":
          return !1;
      }
    if (Et) {
      var qt = Et.some(function(Qt) {
        var Xt;
        return !!(!((Xt = $t == null ? void 0 : $t.matches) === null || Xt === void 0) && Xt.call($t, Qt));
      });
      if (!qt)
        return !1;
    }
    switch (Wt) {
      case "input":
      case "select":
      case "textarea":
        return Pt === "change" || Pt === "click";
      default: {
        var Kt = (Vt = window == null ? void 0 : window.getComputedStyle) === null || Vt === void 0 ? void 0 : Vt.call(window, $t);
        return Kt && Kt.getPropertyValue("cursor") === "pointer" && Pt === "click" ? !0 : Pt === "click";
      }
    }
  };
}, isNonSensitiveString = function(_t) {
  if (_t == null)
    return !1;
  if (typeof _t == "string") {
    var Et = /^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/;
    if (Et.test((_t || "").replace(/[- ]/g, "")))
      return !1;
    var Pt = /(^\d{3}-?\d{2}-?\d{4}$)/;
    if (Pt.test(_t))
      return !1;
  }
  return !0;
}, isTextNode = function(_t) {
  return !!_t && _t.nodeType === 3;
}, isNonSensitiveElement = function(_t) {
  var Et, Pt, $t, Mt = (Pt = (Et = _t == null ? void 0 : _t.tagName) === null || Et === void 0 ? void 0 : Et.toLowerCase) === null || Pt === void 0 ? void 0 : Pt.call(Et), Bt = _t instanceof HTMLElement ? (($t = _t.getAttribute("contenteditable")) === null || $t === void 0 ? void 0 : $t.toLowerCase()) === "true" : !1;
  return !SENSITIVE_TAGS.includes(Mt) && !Bt;
}, getText = function(_t) {
  var Et = "";
  return isNonSensitiveElement(_t) && _t.childNodes && _t.childNodes.length && _t.childNodes.forEach(function(Pt) {
    var $t = "";
    isTextNode(Pt) ? Pt.textContent && ($t = Pt.textContent) : $t = getText(Pt), Et += $t.split(/(\s+)/).filter(isNonSensitiveString).join("").replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ").substring(0, 255);
  }), Et;
}, getSelector = function(_t, Et) {
  var Pt, $t, Mt = "";
  try {
    return Mt = finder(_t, {
      className: function(Gt) {
        return Gt !== AMPLITUDE_VISUAL_TAGGING_HIGHLIGHT_CLASS;
      },
      maxNumberOfTries: 1e3
    }), Mt;
  } catch (Gt) {
    if (Et) {
      var Bt = Gt;
      Et.warn("Failed to get selector with finder, use fallback strategy instead: ".concat(Bt.toString()));
    }
  }
  var Vt = ($t = (Pt = _t == null ? void 0 : _t.tagName) === null || Pt === void 0 ? void 0 : Pt.toLowerCase) === null || $t === void 0 ? void 0 : $t.call(Pt);
  Vt && (Mt = Vt);
  var zt = _t.getAttribute("id"), Ht = _t.getAttribute("class");
  if (zt)
    Mt = "#".concat(zt);
  else if (Ht) {
    var Wt = Ht.split(" ").filter(function(Gt) {
      return Gt !== AMPLITUDE_VISUAL_TAGGING_HIGHLIGHT_CLASS;
    }).join(".");
    Wt && (Mt = "".concat(Mt, ".").concat(Wt));
  }
  return Mt;
}, isPageUrlAllowed = function(_t, Et) {
  return !Et || !Et.length ? !0 : Et.some(function(Pt) {
    return typeof Pt == "string" ? _t === Pt : _t.match(Pt);
  });
}, getAttributesWithPrefix = function(_t, Et) {
  return _t.getAttributeNames().reduce(function(Pt, $t) {
    if ($t.startsWith(Et)) {
      var Mt = $t.replace(Et, ""), Bt = _t.getAttribute($t);
      Mt && (Pt[Mt] = Bt || "");
    }
    return Pt;
  }, {});
}, isEmpty = function(_t) {
  return _t == null || typeof _t == "object" && Object.keys(_t).length === 0 || typeof _t == "string" && _t.trim().length === 0;
}, removeEmptyProperties = function(_t) {
  return Object.keys(_t).reduce(function(Et, Pt) {
    var $t = _t[Pt];
    return isEmpty($t) || (Et[Pt] = $t), Et;
  }, {});
}, getNearestLabel = function(_t) {
  var Et = _t.parentElement;
  if (!Et)
    return "";
  var Pt;
  try {
    Pt = Et.querySelector(":scope>span,h1,h2,h3,h4,h5,h6");
  } catch {
    Pt = null;
  }
  if (Pt) {
    var $t = Pt.textContent || "";
    return isNonSensitiveString($t) ? $t : "";
  }
  return getNearestLabel(Et);
}, getClosestElement = function(_t, Et) {
  return _t ? Et.some(function(Pt) {
    var $t;
    return ($t = _t == null ? void 0 : _t.matches) === null || $t === void 0 ? void 0 : $t.call(_t, Pt);
  }) ? _t : getClosestElement(_t == null ? void 0 : _t.parentElement, Et) : null;
}, getEventTagProps = function(_t, Et) {
  var Pt, $t, Mt;
  if (!_t)
    return {};
  var Bt = (Mt = ($t = _t == null ? void 0 : _t.tagName) === null || $t === void 0 ? void 0 : $t.toLowerCase) === null || Mt === void 0 ? void 0 : Mt.call($t), Vt = getSelector(_t, Et), zt = (Pt = {}, Pt[AMPLITUDE_EVENT_PROP_ELEMENT_TAG] = Bt, Pt[AMPLITUDE_EVENT_PROP_ELEMENT_TEXT] = getText(_t), Pt[AMPLITUDE_EVENT_PROP_ELEMENT_SELECTOR] = Vt, Pt[AMPLITUDE_EVENT_PROP_PAGE_URL] = window.location.href.split("?")[0], Pt);
  return removeEmptyProperties(zt);
}, asyncLoadScript = function(_t) {
  return new Promise(function(Et, Pt) {
    var $t;
    try {
      var Mt = document.createElement("script");
      Mt.type = "text/javascript", Mt.async = !0, Mt.src = _t, Mt.addEventListener("load", function() {
        Et({ status: !0 });
      }, { once: !0 }), Mt.addEventListener("error", function() {
        Pt({
          status: !1,
          message: "Failed to load the script ".concat(_t)
        });
      }), ($t = document.head) === null || $t === void 0 || $t.appendChild(Mt);
    } catch (Bt) {
      Pt(Bt);
    }
  });
};
function generateUniqueId() {
  return "".concat(Date.now(), "-").concat(Math.random().toString(36).substr(2, 9));
}
var filterOutNonTrackableEvents = function(_t) {
  return !(_t.event.target === null || !_t.closestTrackedAncestor);
}, WindowMessenger = (
  /** @class */
  function() {
    function _t(Et) {
      var Pt = Et === void 0 ? {} : Et, $t = Pt.origin, Mt = $t === void 0 ? AMPLITUDE_ORIGIN : $t, Bt = this;
      this.endpoint = AMPLITUDE_ORIGIN, this.requestCallbacks = {}, this.onSelect = function(Vt) {
        Bt.notify({ action: "element-selected", data: Vt });
      }, this.onTrack = function(Vt, zt) {
        Vt === "selector-mode-changed" ? Bt.notify({ action: "track-selector-mode-changed", data: zt }) : Vt === "selector-moved" && Bt.notify({ action: "track-selector-moved", data: zt });
      }, this.endpoint = Mt;
    }
    return _t.prototype.notify = function(Et) {
      var Pt, $t, Mt, Bt;
      ($t = (Pt = this.logger) === null || Pt === void 0 ? void 0 : Pt.debug) === null || $t === void 0 || $t.call(Pt, "Message sent: ", JSON.stringify(Et)), (Bt = (Mt = window.opener) === null || Mt === void 0 ? void 0 : Mt.postMessage) === null || Bt === void 0 || Bt.call(Mt, Et, this.endpoint);
    }, _t.prototype.sendRequest = function(Et, Pt, $t) {
      var Mt = this;
      $t === void 0 && ($t = { timeout: 15e3 });
      var Bt = generateUniqueId(), Vt = {
        id: Bt,
        action: Et,
        args: Pt
      }, zt = new Promise(function(Ht, Wt) {
        Mt.requestCallbacks[Bt] = { resolve: Ht, reject: Wt }, Mt.notify(Vt), ($t == null ? void 0 : $t.timeout) > 0 && setTimeout(function() {
          Wt(new Error("".concat(Et, " timed out (id: ").concat(Bt, ")"))), delete Mt.requestCallbacks[Bt];
        }, $t.timeout);
      });
      return zt;
    }, _t.prototype.handleResponse = function(Et) {
      var Pt;
      if (!this.requestCallbacks[Et.id]) {
        (Pt = this.logger) === null || Pt === void 0 || Pt.warn("No callback found for request id: ".concat(Et.id));
        return;
      }
      this.requestCallbacks[Et.id].resolve(Et.responseData), delete this.requestCallbacks[Et.id];
    }, _t.prototype.setup = function(Et) {
      var Pt = this, $t = Et === void 0 ? {} : Et, Mt = $t.logger, Bt = $t.endpoint, Vt = $t.isElementSelectable, zt = $t.cssSelectorAllowlist, Ht = $t.actionClickAllowlist;
      this.logger = Mt, Bt && this.endpoint === AMPLITUDE_ORIGIN && (this.endpoint = Bt);
      var Wt = null;
      window.addEventListener("message", function(Gt) {
        var qt, Kt, Qt, Xt, Zt;
        if ((Kt = (qt = Pt.logger) === null || qt === void 0 ? void 0 : qt.debug) === null || Kt === void 0 || Kt.call(qt, "Message received: ", JSON.stringify(Gt)), Pt.endpoint === Gt.origin) {
          var Yt = Gt == null ? void 0 : Gt.data, Jt = Yt == null ? void 0 : Yt.action;
          if (Jt)
            if ("id" in Yt)
              (Xt = (Qt = Pt.logger) === null || Qt === void 0 ? void 0 : Qt.debug) === null || Xt === void 0 || Xt.call(Qt, "Received Response to previous request: ", JSON.stringify(Gt)), Pt.handleResponse(Yt);
            else if (Jt === "ping")
              Pt.notify({ action: "pong" });
            else if (Jt === "initialize-visual-tagging-selector") {
              var er = Yt == null ? void 0 : Yt.data;
              asyncLoadScript(AMPLITUDE_VISUAL_TAGGING_SELECTOR_SCRIPT_URL).then(function() {
                var tr;
                Wt = (tr = window == null ? void 0 : window.amplitudeVisualTaggingSelector) === null || tr === void 0 ? void 0 : tr.call(window, {
                  getEventTagProps,
                  isElementSelectable: function(nr) {
                    return Vt ? Vt((er == null ? void 0 : er.actionType) || "click", nr) : !0;
                  },
                  onTrack: Pt.onTrack,
                  onSelect: Pt.onSelect,
                  visualHighlightClass: AMPLITUDE_VISUAL_TAGGING_HIGHLIGHT_CLASS,
                  messenger: Pt,
                  cssSelectorAllowlist: zt,
                  actionClickAllowlist: Ht
                }), Pt.notify({ action: "selector-loaded" });
              }).catch(function() {
                var tr;
                (tr = Pt.logger) === null || tr === void 0 || tr.warn("Failed to initialize visual tagging selector");
              });
            } else
              Jt === "close-visual-tagging-selector" && ((Zt = Wt == null ? void 0 : Wt.close) === null || Zt === void 0 || Zt.call(Wt));
        }
      }), this.notify({ action: "page-loaded" });
    }, _t;
  }()
), BLOCKED_ATTRIBUTES = [
  // Already captured elsewhere in the hierarchy object
  "id",
  "class",
  // non-useful and potentially large attribute
  "style",
  // sensitive as prefilled form data may populate this attribute
  "value",
  // DOM events
  "onclick",
  "onchange",
  "oninput",
  "onblur",
  "onsubmit",
  "onfocus",
  "onkeydown",
  "onkeyup",
  "onkeypress",
  // React specific
  "data-reactid",
  "data-react-checksum",
  "data-reactroot"
], SENSITIVE_ELEMENT_ATTRIBUTE_ALLOWLIST = ["type"], SVG_TAGS = ["svg", "path", "g"], HIGHLY_SENSITIVE_INPUT_TYPES = ["password", "hidden"], MAX_ATTRIBUTE_LENGTH = 128, MAX_HIERARCHY_LENGTH = 1024;
function getElementProperties(_t) {
  var Et, Pt, $t, Mt, Bt, Vt;
  if (_t === null)
    return null;
  var zt = String(_t.tagName).toLowerCase(), Ht = {
    tag: zt
  }, Wt = Array.from((Mt = ($t = _t.parentElement) === null || $t === void 0 ? void 0 : $t.children) !== null && Mt !== void 0 ? Mt : []);
  Wt.length && (Ht.index = Wt.indexOf(_t), Ht.indexOfType = Wt.filter(function(nr) {
    return nr.tagName === _t.tagName;
  }).indexOf(_t));
  var Gt = (Vt = (Bt = _t.previousElementSibling) === null || Bt === void 0 ? void 0 : Bt.tagName) === null || Vt === void 0 ? void 0 : Vt.toLowerCase();
  Gt && (Ht.prevSib = String(Gt));
  var qt = _t.getAttribute("id");
  qt && (Ht.id = String(qt));
  var Kt = Array.from(_t.classList);
  Kt.length && (Ht.classes = Kt);
  var Qt = {}, Xt = Array.from(_t.attributes), Zt = Xt.filter(function(nr) {
    return !BLOCKED_ATTRIBUTES.includes(nr.name);
  }), Yt = !isNonSensitiveElement(_t);
  if (!HIGHLY_SENSITIVE_INPUT_TYPES.includes(String(_t.getAttribute("type"))) && !SVG_TAGS.includes(zt))
    try {
      for (var Jt = __values(Zt), er = Jt.next(); !er.done; er = Jt.next()) {
        var tr = er.value;
        Yt && !SENSITIVE_ELEMENT_ATTRIBUTE_ALLOWLIST.includes(tr.name) || (Qt[tr.name] = String(tr.value).substring(0, MAX_ATTRIBUTE_LENGTH));
      }
    } catch (nr) {
      Et = { error: nr };
    } finally {
      try {
        er && !er.done && (Pt = Jt.return) && Pt.call(Jt);
      } finally {
        if (Et)
          throw Et.error;
      }
    }
  return Object.keys(Qt).length && (Ht.attrs = Qt), Ht;
}
function getAncestors(_t) {
  var Et = [];
  if (!_t)
    return Et;
  Et.push(_t);
  for (var Pt = _t.parentElement; Pt && Pt.tagName !== "HTML"; )
    Et.push(Pt), Pt = Pt.parentElement;
  return Et;
}
var getHierarchy = function(_t) {
  var Et = [];
  if (!_t)
    return [];
  var Pt = getAncestors(_t);
  return Et = ensureListUnderLimit(Pt.map(function($t) {
    return getElementProperties($t);
  }), MAX_HIERARCHY_LENGTH), Et;
};
function ensureListUnderLimit(_t, Et) {
  for (var Pt = 0, $t = 0; $t < _t.length; $t++) {
    var Mt = _t[$t];
    if (Mt === null)
      Pt += 4;
    else {
      var Bt = ensureUnicodePythonCompatible(Mt);
      Pt += Bt ? Array.from(Bt).length : 4;
    }
    if (Pt > Et)
      return _t.slice(0, $t);
  }
  return _t;
}
function ensureUnicodePythonCompatible(_t, Et) {
  Et === void 0 && (Et = !1);
  try {
    if (_t == null)
      return Et ? "None" : null;
    if (typeof _t == "string")
      return Et ? (_t = _t.replace(/\\/g, "\\\\").replace(/\n/g, "\\n").replace(/\t/g, "\\t").replace(/\r/g, "\\r"), _t.includes('"') ? "'".concat(_t, "'") : _t.includes("'") ? '"'.concat(_t.replace(/'/g, "\\'"), '"') : "'".concat(_t, "'")) : _t;
    if (typeof _t == "boolean")
      return _t ? "True" : "False";
    if (Array.isArray(_t)) {
      var Pt = _t.map(function(Bt) {
        return ensureUnicodePythonCompatible(Bt, !0);
      });
      return "[".concat(Pt.join(", "), "]");
    } else if (typeof _t == "object") {
      var $t = Object.entries(_t).filter(function(Bt) {
        var Vt = __read(Bt, 1), zt = Vt[0];
        return zt != null;
      }).map(function(Bt) {
        var Vt = __read(Bt, 2), zt = Vt[0], Ht = Vt[1];
        return "".concat(String(ensureUnicodePythonCompatible(zt, !0)), ": ").concat(String(ensureUnicodePythonCompatible(Ht, !0)));
      }), Mt = "{".concat($t.join(", "), "}");
      return Mt.includes("\\'") && (Mt = Mt.replace(/'/g, "'").replace(/'/g, "\\'")), Mt;
    }
    return _t.toString();
  } catch {
    return null;
  }
}
var RAGE_CLICK_THRESHOLD = 5;
function trackClicks(_t) {
  var Et = _t.amplitude, Pt = _t.allObservables, $t = _t.options, Mt = _t.shouldTrackEvent, Bt = Pt.clickObservable, Vt = Bt.pipe(pairwise(), filter$2(function(Gt) {
    var qt = __read(Gt, 2), Kt = qt[0], Qt = qt[1], Xt = Kt.event.target !== Qt.event.target, Zt = Math.abs(Qt.event.screenX - Kt.event.screenX) <= 20 && Math.abs(Qt.event.screenY - Kt.event.screenY) <= 20;
    return Xt && !Zt;
  })), zt = Bt.pipe(debounceTime($t.debounceTime), map$1(function() {
    return "timeout";
  })), Ht = merge$3(Vt, zt), Wt = Bt.pipe(delay(0), filter$2(filterOutNonTrackableEvents), filter$2(function(Gt) {
    return Mt("click", Gt.closestTrackedAncestor);
  }), buffer(Ht));
  return Wt.subscribe(function(Gt) {
    var qt, Kt, Qt = (Gt.length >= RAGE_CLICK_THRESHOLD, AMPLITUDE_ELEMENT_CLICKED_EVENT);
    try {
      for (var Xt = __values(Gt), Zt = Xt.next(); !Zt.done; Zt = Xt.next()) {
        var Yt = Zt.value;
        Et == null || Et.track(Qt, Yt.targetElementProperties, {
          time: Yt.timestamp
        });
      }
    } catch (Jt) {
      qt = { error: Jt };
    } finally {
      try {
        Zt && !Zt.done && (Kt = Xt.return) && Kt.call(Xt);
      } finally {
        if (qt)
          throw qt.error;
      }
    }
  });
}
function trackChange(_t) {
  var Et = _t.amplitude, Pt = _t.allObservables, $t = _t.getEventProperties, Mt = _t.shouldTrackEvent, Bt = Pt.changeObservable, Vt = Bt.pipe(filter$2(filterOutNonTrackableEvents), filter$2(function(zt) {
    return Mt("change", zt.closestTrackedAncestor);
  }));
  return Vt.subscribe(function(zt) {
    Et == null || Et.track(AMPLITUDE_ELEMENT_CHANGED_EVENT, $t("change", zt.closestTrackedAncestor));
  });
}
function trackActionClick(_t) {
  var Et = _t.amplitude, Pt = _t.allObservables, $t = _t.options, Mt = _t.getEventProperties, Bt = _t.shouldTrackEvent, Vt = _t.shouldTrackActionClick, zt = Pt.clickObservable, Ht = Pt.mutationObservable, Wt = Pt.navigateObservable, Gt = zt.pipe(filter$2(function(Xt) {
    return !Bt("click", Xt.closestTrackedAncestor);
  }), map$1(function(Xt) {
    var Zt = getClosestElement(Xt.event.target, $t.actionClickAllowlist);
    return Xt.closestTrackedAncestor = Zt, Xt.closestTrackedAncestor !== null && (Xt.targetElementProperties = Mt(Xt.type, Xt.closestTrackedAncestor)), Xt;
  }), filter$2(filterOutNonTrackableEvents), filter$2(function(Xt) {
    return Vt("click", Xt.closestTrackedAncestor);
  })), qt = [Ht];
  Wt && qt.push(Wt);
  var Kt = merge$3.apply(void 0, __spreadArray$1([], __read(qt), !1)), Qt = Gt.pipe(
    // If a mutation occurs within 0.5 seconds of a click event (timeout({ first: 500 })), it emits the original first click event.
    // take 1 to only limit the action events in case there are multiple
    switchMap(function(Xt) {
      return Kt.pipe(
        take(1),
        timeout({ first: 500, with: function() {
          return EMPTY;
        } }),
        // in case of timeout, map to empty to prevent any click from being emitted
        map$1(function() {
          return Xt;
        })
      );
    })
  );
  return Qt.subscribe(function(Xt) {
    Et == null || Et.track(AMPLITUDE_ELEMENT_CLICKED_EVENT, Mt("click", Xt.closestTrackedAncestor), {
      time: Xt.timestamp
    });
  });
}
var ObservablesEnum;
(function(_t) {
  _t.ClickObservable = "clickObservable", _t.ChangeObservable = "changeObservable", _t.NavigateObservable = "navigateObservable", _t.MutationObservable = "mutationObservable";
})(ObservablesEnum || (ObservablesEnum = {}));
function isElementBasedEvent(_t) {
  return _t.type === "click" || _t.type === "change";
}
var autocapturePlugin = function(_t) {
  var Et, Pt, $t;
  _t === void 0 && (_t = {});
  var Mt = _t.dataAttributePrefix, Bt = Mt === void 0 ? DEFAULT_DATA_ATTRIBUTE_PREFIX : Mt, Vt = _t.visualTaggingOptions, zt = Vt === void 0 ? {
    enabled: !0,
    messenger: new WindowMessenger()
  } : Vt;
  _t.cssSelectorAllowlist = (Et = _t.cssSelectorAllowlist) !== null && Et !== void 0 ? Et : DEFAULT_CSS_SELECTOR_ALLOWLIST, _t.actionClickAllowlist = (Pt = _t.actionClickAllowlist) !== null && Pt !== void 0 ? Pt : DEFAULT_ACTION_CLICK_ALLOWLIST, _t.debounceTime = ($t = _t.debounceTime) !== null && $t !== void 0 ? $t : 0;
  var Ht = PLUGIN_NAME, Wt = "enrichment", Gt = [], qt = void 0, Kt = function() {
    var er, tr = fromEvent(document, "click", { capture: !0 }).pipe(map$1(function(ar) {
      return Xt(ar, "click");
    })), nr = fromEvent(document, "change", { capture: !0 }).pipe(map$1(function(ar) {
      return Xt(ar, "change");
    })), rr;
    window.navigation && (rr = fromEvent(window.navigation, "navigate").pipe(map$1(function(ar) {
      return Xt(ar, "navigate");
    })));
    var ir = new Observable(function(ar) {
      var or = new MutationObserver(function(sr) {
        ar.next(sr);
      });
      return or.observe(document.body, {
        childList: !0,
        attributes: !0,
        characterData: !0,
        subtree: !0
      }), function() {
        return or.disconnect();
      };
    }).pipe(map$1(function(ar) {
      return Xt(ar, "mutation");
    }));
    return er = {}, er[ObservablesEnum.ClickObservable] = tr, er[ObservablesEnum.ChangeObservable] = nr, // [ObservablesEnum.ErrorObservable]: errorObservable,
    er[ObservablesEnum.NavigateObservable] = rr, er[ObservablesEnum.MutationObservable] = ir, er;
  }, Qt = function(er, tr) {
    var nr, rr, ir, ar = (ir = (rr = tr == null ? void 0 : tr.tagName) === null || rr === void 0 ? void 0 : rr.toLowerCase) === null || ir === void 0 ? void 0 : ir.call(rr), or = typeof tr.getBoundingClientRect == "function" ? tr.getBoundingClientRect() : { left: null, top: null }, sr = tr.getAttribute("aria-label"), lr = getAttributesWithPrefix(tr, Bt), cr = getNearestLabel(tr), hr = getSelector(tr, qt), pr = (nr = {}, nr[AMPLITUDE_EVENT_PROP_ELEMENT_ID] = tr.getAttribute("id") || "", nr[AMPLITUDE_EVENT_PROP_ELEMENT_CLASS] = tr.getAttribute("class"), nr[AMPLITUDE_EVENT_PROP_ELEMENT_HIERARCHY] = getHierarchy(tr), nr[AMPLITUDE_EVENT_PROP_ELEMENT_TAG] = ar, nr[AMPLITUDE_EVENT_PROP_ELEMENT_TEXT] = getText(tr), nr[AMPLITUDE_EVENT_PROP_ELEMENT_POSITION_LEFT] = or.left == null ? null : Math.round(or.left), nr[AMPLITUDE_EVENT_PROP_ELEMENT_POSITION_TOP] = or.top == null ? null : Math.round(or.top), nr[AMPLITUDE_EVENT_PROP_ELEMENT_ARIA_LABEL] = sr, nr[AMPLITUDE_EVENT_PROP_ELEMENT_ATTRIBUTES] = lr, nr[AMPLITUDE_EVENT_PROP_ELEMENT_SELECTOR] = hr, nr[AMPLITUDE_EVENT_PROP_ELEMENT_PARENT_LABEL] = cr, nr[AMPLITUDE_EVENT_PROP_PAGE_URL] = window.location.href.split("?")[0], nr[AMPLITUDE_EVENT_PROP_PAGE_TITLE] = typeof document < "u" && document.title || "", nr[AMPLITUDE_EVENT_PROP_VIEWPORT_HEIGHT] = window.innerHeight, nr[AMPLITUDE_EVENT_PROP_VIEWPORT_WIDTH] = window.innerWidth, nr);
    return ar === "a" && er === "click" && tr instanceof HTMLAnchorElement && (pr[AMPLITUDE_EVENT_PROP_ELEMENT_HREF] = tr.href), removeEmptyProperties(pr);
  }, Xt = function(er, tr) {
    var nr = {
      event: er,
      timestamp: Date.now(),
      type: tr
    };
    if (isElementBasedEvent(nr) && nr.event.target !== null) {
      var rr = getClosestElement(nr.event.target, _t.cssSelectorAllowlist);
      return rr && (nr.closestTrackedAncestor = rr, nr.targetElementProperties = Qt(nr.type, rr)), nr;
    }
    return nr;
  }, Zt = function(er, tr) {
    return __awaiter$1(void 0, void 0, void 0, function() {
      var nr, rr, ir, ar, or, sr, lr, cr, hr, pr;
      return __generator$1(this, function(mr) {
        return qt = er.loggerProvider, typeof document > "u" ? [
          2
          /*return*/
        ] : (nr = createShouldTrackEvent(_t, _t.cssSelectorAllowlist), rr = createShouldTrackEvent(_t, _t.actionClickAllowlist), ir = Kt(), ar = trackClicks({
          allObservables: ir,
          options: _t,
          amplitude: tr,
          shouldTrackEvent: nr
        }), Gt.push(ar), or = trackChange({
          allObservables: ir,
          getEventProperties: Qt,
          amplitude: tr,
          shouldTrackEvent: nr
        }), Gt.push(or), sr = trackActionClick({
          allObservables: ir,
          options: _t,
          getEventProperties: Qt,
          amplitude: tr,
          shouldTrackEvent: nr,
          shouldTrackActionClick: rr
        }), Gt.push(sr), (hr = er == null ? void 0 : er.loggerProvider) === null || hr === void 0 || hr.log("".concat(Ht, " has been successfully added.")), window.opener && zt.enabled && (lr = _t.cssSelectorAllowlist, cr = _t.actionClickAllowlist, (pr = zt.messenger) === null || pr === void 0 || pr.setup(__assign$3(__assign$3({ logger: er == null ? void 0 : er.loggerProvider }, (er == null ? void 0 : er.serverZone) && { endpoint: AMPLITUDE_ORIGINS_MAP[er.serverZone] }), { isElementSelectable: createShouldTrackEvent(_t, __spreadArray$1(__spreadArray$1([], __read(lr), !1), __read(cr), !1)), cssSelectorAllowlist: lr, actionClickAllowlist: cr }))), [
          2
          /*return*/
        ]);
      });
    });
  }, Yt = function(er) {
    return __awaiter$1(void 0, void 0, void 0, function() {
      return __generator$1(this, function(tr) {
        return [2, er];
      });
    });
  }, Jt = function() {
    return __awaiter$1(void 0, void 0, void 0, function() {
      var er, tr, nr, rr, ir;
      return __generator$1(this, function(ar) {
        try {
          for (er = __values(Gt), tr = er.next(); !tr.done; tr = er.next())
            nr = tr.value, nr.unsubscribe();
        } catch (or) {
          rr = { error: or };
        } finally {
          try {
            tr && !tr.done && (ir = er.return) && ir.call(er);
          } finally {
            if (rr)
              throw rr.error;
          }
        }
        return [
          2
          /*return*/
        ];
      });
    });
  };
  return {
    name: Ht,
    type: Wt,
    setup: Zt,
    execute: Yt,
    teardown: Jt
  };
}, AmplitudeBrowser = (
  /** @class */
  function(_t) {
    __extends$1(Et, _t);
    function Et() {
      return _t !== null && _t.apply(this, arguments) || this;
    }
    return Et.prototype.init = function(Pt, $t, Mt) {
      Pt === void 0 && (Pt = "");
      var Bt, Vt;
      return arguments.length > 2 ? (Bt = $t, Vt = Mt) : typeof $t == "string" ? (Bt = $t, Vt = void 0) : (Bt = $t == null ? void 0 : $t.userId, Vt = $t), returnWrapper(this._init(__assign$3(__assign$3({}, Vt), { userId: Bt, apiKey: Pt })));
    }, Et.prototype._init = function(Pt) {
      var $t, Mt, Bt;
      return __awaiter$1(this, void 0, void 0, function() {
        var Vt, zt, Ht, Wt, Gt, qt, Kt = this;
        return __generator$1(this, function(Qt) {
          switch (Qt.label) {
            case 0:
              return this.initializing ? [
                2
                /*return*/
              ] : (this.initializing = !0, [4, useBrowserConfig(Pt.apiKey, Pt, this)]);
            case 1:
              return Vt = Qt.sent(), Pt.fetchRemoteConfig ? [4, createBrowserJoinedConfigGenerator(Vt)] : [3, 4];
            case 2:
              return zt = Qt.sent(), [4, zt.generateJoinedConfig()];
            case 3:
              Vt = Qt.sent(), Qt.label = 4;
            case 4:
              return [4, _t.prototype._init.call(this, Vt)];
            case 5:
              return Qt.sent(), this.logBrowserOptions(Vt), isAttributionTrackingEnabled(this.config.defaultTracking) ? (Ht = getAttributionTrackingConfig(this.config), this.webAttribution = new WebAttribution(Ht, this.config), [4, this.webAttribution.init()]) : [3, 7];
            case 6:
              Qt.sent(), Qt.label = 7;
            case 7:
              return Wt = getQueryParams(), Gt = Number.isNaN(Number(Wt.ampSessionId)) ? void 0 : Number(Wt.ampSessionId), this.setSessionId((Bt = (Mt = ($t = Pt.sessionId) !== null && $t !== void 0 ? $t : Gt) !== null && Mt !== void 0 ? Mt : this.config.sessionId) !== null && Bt !== void 0 ? Bt : Date.now()), qt = getAnalyticsConnector(Pt.instanceName), qt.identityStore.setIdentity({
                userId: this.config.userId,
                deviceId: this.config.deviceId
              }), this.config.offline === OfflineDisabled ? [3, 9] : [4, this.add(networkConnectivityCheckerPlugin()).promise];
            case 8:
              Qt.sent(), Qt.label = 9;
            case 9:
              return [4, this.add(new Destination()).promise];
            case 10:
              return Qt.sent(), [4, this.add(new Context$2()).promise];
            case 11:
              return Qt.sent(), [4, this.add(new IdentityEventSender()).promise];
            case 12:
              return Qt.sent(), detNotify(this.config), isFileDownloadTrackingEnabled(this.config.defaultTracking) ? (this.config.loggerProvider.debug("Adding file download tracking plugin"), [4, this.add(fileDownloadTracking()).promise]) : [3, 14];
            case 13:
              Qt.sent(), Qt.label = 14;
            case 14:
              return isFormInteractionTrackingEnabled(this.config.defaultTracking) ? (this.config.loggerProvider.debug("Adding form interaction plugin"), [4, this.add(formInteractionTracking()).promise]) : [3, 16];
            case 15:
              Qt.sent(), Qt.label = 16;
            case 16:
              return isPageViewTrackingEnabled(this.config.defaultTracking) ? (this.config.loggerProvider.debug("Adding page view tracking plugin"), [4, this.add(pageViewTrackingPlugin(getPageViewTrackingConfig(this.config))).promise]) : [3, 18];
            case 17:
              Qt.sent(), Qt.label = 18;
            case 18:
              return isElementInteractionsEnabled(this.config.autocapture) ? (this.config.loggerProvider.debug("Adding user interactions plugin (autocapture plugin)"), [4, this.add(autocapturePlugin(getElementInteractionsConfig(this.config))).promise]) : [3, 20];
            case 19:
              Qt.sent(), Qt.label = 20;
            case 20:
              return this.initializing = !1, [4, this.runQueuedFunctions("dispatchQ")];
            case 21:
              return Qt.sent(), qt.eventBridge.setEventReceiver(function(Xt) {
                Kt.track(Xt.eventType, Xt.eventProperties);
              }), [
                2
                /*return*/
              ];
          }
        });
      });
    }, Et.prototype.getUserId = function() {
      var Pt;
      return (Pt = this.config) === null || Pt === void 0 ? void 0 : Pt.userId;
    }, Et.prototype.setUserId = function(Pt) {
      if (!this.config) {
        this.q.push(this.setUserId.bind(this, Pt));
        return;
      }
      this.config.loggerProvider.debug("function setUserId: ", Pt), (Pt !== this.config.userId || Pt === void 0) && (this.config.userId = Pt, setConnectorUserId(Pt, this.config.instanceName));
    }, Et.prototype.getDeviceId = function() {
      var Pt;
      return (Pt = this.config) === null || Pt === void 0 ? void 0 : Pt.deviceId;
    }, Et.prototype.setDeviceId = function(Pt) {
      if (!this.config) {
        this.q.push(this.setDeviceId.bind(this, Pt));
        return;
      }
      this.config.loggerProvider.debug("function setDeviceId: ", Pt), this.config.deviceId = Pt, setConnectorDeviceId(Pt, this.config.instanceName);
    }, Et.prototype.reset = function() {
      this.setDeviceId(UUID()), this.setUserId(void 0);
    }, Et.prototype.getSessionId = function() {
      var Pt;
      return (Pt = this.config) === null || Pt === void 0 ? void 0 : Pt.sessionId;
    }, Et.prototype.setSessionId = function(Pt) {
      var $t, Mt = [];
      if (!this.config)
        return this.q.push(this.setSessionId.bind(this, Pt)), returnWrapper(Promise.resolve());
      if (Pt === this.config.sessionId)
        return returnWrapper(Promise.resolve());
      this.config.loggerProvider.debug("function setSessionId: ", Pt);
      var Bt = this.getSessionId(), Vt = this.config.lastEventTime, zt = ($t = this.config.lastEventId) !== null && $t !== void 0 ? $t : -1;
      this.config.sessionId = Pt, this.config.lastEventTime = void 0, this.config.pageCounter = 0, isSessionTrackingEnabled(this.config.defaultTracking) && (Bt && Vt && Mt.push(this.track(DEFAULT_SESSION_END_EVENT, void 0, {
        device_id: this.previousSessionDeviceId,
        event_id: ++zt,
        session_id: Bt,
        time: Vt + 1,
        user_id: this.previousSessionUserId
      }).promise), this.config.lastEventTime = this.config.sessionId);
      var Ht = this.trackCampaignEventIfNeeded(++zt, Mt);
      return isSessionTrackingEnabled(this.config.defaultTracking) && Mt.push(this.track(DEFAULT_SESSION_START_EVENT, void 0, {
        event_id: Ht ? ++zt : zt,
        session_id: this.config.sessionId,
        time: this.config.lastEventTime
      }).promise), this.previousSessionDeviceId = this.config.deviceId, this.previousSessionUserId = this.config.userId, returnWrapper(Promise.all(Mt));
    }, Et.prototype.extendSession = function() {
      if (!this.config) {
        this.q.push(this.extendSession.bind(this));
        return;
      }
      this.config.lastEventTime = Date.now();
    }, Et.prototype.setTransport = function(Pt) {
      if (!this.config) {
        this.q.push(this.setTransport.bind(this, Pt));
        return;
      }
      this.config.transportProvider = createTransport(Pt);
    }, Et.prototype.identify = function(Pt, $t) {
      if (isInstanceProxy(Pt)) {
        var Mt = Pt._q;
        Pt._q = [], Pt = convertProxyObjectToRealObject(new Identify(), Mt);
      }
      return $t != null && $t.user_id && this.setUserId($t.user_id), $t != null && $t.device_id && this.setDeviceId($t.device_id), _t.prototype.identify.call(this, Pt, $t);
    }, Et.prototype.groupIdentify = function(Pt, $t, Mt, Bt) {
      if (isInstanceProxy(Mt)) {
        var Vt = Mt._q;
        Mt._q = [], Mt = convertProxyObjectToRealObject(new Identify(), Vt);
      }
      return _t.prototype.groupIdentify.call(this, Pt, $t, Mt, Bt);
    }, Et.prototype.revenue = function(Pt, $t) {
      if (isInstanceProxy(Pt)) {
        var Mt = Pt._q;
        Pt._q = [], Pt = convertProxyObjectToRealObject(new Revenue(), Mt);
      }
      return _t.prototype.revenue.call(this, Pt, $t);
    }, Et.prototype.trackCampaignEventIfNeeded = function(Pt, $t) {
      if (!this.webAttribution || !this.webAttribution.shouldTrackNewCampaign)
        return !1;
      var Mt = this.webAttribution.generateCampaignEvent(Pt);
      return $t ? $t.push(this.track(Mt).promise) : this.track(Mt), this.config.loggerProvider.log("Tracking attribution."), !0;
    }, Et.prototype.process = function(Pt) {
      return __awaiter$1(this, void 0, void 0, function() {
        var $t, Mt, Bt;
        return __generator$1(this, function(Vt) {
          return $t = Date.now(), Mt = isNewSession(this.config.sessionTimeout, this.config.lastEventTime), Bt = this.webAttribution && this.webAttribution.shouldSetSessionIdOnNewCampaign(), Pt.event_type !== DEFAULT_SESSION_START_EVENT && Pt.event_type !== DEFAULT_SESSION_END_EVENT && (!Pt.session_id || Pt.session_id === this.getSessionId()) && (Mt || Bt ? (this.setSessionId($t), Bt && this.config.loggerProvider.log("Created a new session for new campaign.")) : Mt || this.trackCampaignEventIfNeeded()), [2, _t.prototype.process.call(this, Pt)];
        });
      });
    }, Et.prototype.logBrowserOptions = function(Pt) {
      try {
        var $t = __assign$3(__assign$3({}, Pt), { apiKey: Pt.apiKey.substring(0, 10) + "********" });
        this.config.loggerProvider.debug("Initialized Amplitude with BrowserConfig:", JSON.stringify($t));
      } catch (Mt) {
        this.config.loggerProvider.error("Error logging browser config", Mt);
      }
    }, Et;
  }(AmplitudeCore)
), createInstance$1 = function() {
  var _t = new AmplitudeBrowser();
  return {
    init: debugWrapper(_t.init.bind(_t), "init", getClientLogConfig(_t), getClientStates(_t, ["config"])),
    add: debugWrapper(_t.add.bind(_t), "add", getClientLogConfig(_t), getClientStates(_t, ["config.apiKey", "timeline.plugins"])),
    remove: debugWrapper(_t.remove.bind(_t), "remove", getClientLogConfig(_t), getClientStates(_t, ["config.apiKey", "timeline.plugins"])),
    track: debugWrapper(_t.track.bind(_t), "track", getClientLogConfig(_t), getClientStates(_t, ["config.apiKey", "timeline.queue.length"])),
    logEvent: debugWrapper(_t.logEvent.bind(_t), "logEvent", getClientLogConfig(_t), getClientStates(_t, ["config.apiKey", "timeline.queue.length"])),
    identify: debugWrapper(_t.identify.bind(_t), "identify", getClientLogConfig(_t), getClientStates(_t, ["config.apiKey", "timeline.queue.length"])),
    groupIdentify: debugWrapper(_t.groupIdentify.bind(_t), "groupIdentify", getClientLogConfig(_t), getClientStates(_t, ["config.apiKey", "timeline.queue.length"])),
    setGroup: debugWrapper(_t.setGroup.bind(_t), "setGroup", getClientLogConfig(_t), getClientStates(_t, ["config.apiKey", "timeline.queue.length"])),
    revenue: debugWrapper(_t.revenue.bind(_t), "revenue", getClientLogConfig(_t), getClientStates(_t, ["config.apiKey", "timeline.queue.length"])),
    flush: debugWrapper(_t.flush.bind(_t), "flush", getClientLogConfig(_t), getClientStates(_t, ["config.apiKey", "timeline.queue.length"])),
    getUserId: debugWrapper(_t.getUserId.bind(_t), "getUserId", getClientLogConfig(_t), getClientStates(_t, ["config", "config.userId"])),
    setUserId: debugWrapper(_t.setUserId.bind(_t), "setUserId", getClientLogConfig(_t), getClientStates(_t, ["config", "config.userId"])),
    getDeviceId: debugWrapper(_t.getDeviceId.bind(_t), "getDeviceId", getClientLogConfig(_t), getClientStates(_t, ["config", "config.deviceId"])),
    setDeviceId: debugWrapper(_t.setDeviceId.bind(_t), "setDeviceId", getClientLogConfig(_t), getClientStates(_t, ["config", "config.deviceId"])),
    reset: debugWrapper(_t.reset.bind(_t), "reset", getClientLogConfig(_t), getClientStates(_t, ["config", "config.userId", "config.deviceId"])),
    getSessionId: debugWrapper(_t.getSessionId.bind(_t), "getSessionId", getClientLogConfig(_t), getClientStates(_t, ["config"])),
    setSessionId: debugWrapper(_t.setSessionId.bind(_t), "setSessionId", getClientLogConfig(_t), getClientStates(_t, ["config"])),
    extendSession: debugWrapper(_t.extendSession.bind(_t), "extendSession", getClientLogConfig(_t), getClientStates(_t, ["config"])),
    setOptOut: debugWrapper(_t.setOptOut.bind(_t), "setOptOut", getClientLogConfig(_t), getClientStates(_t, ["config"])),
    setTransport: debugWrapper(_t.setTransport.bind(_t), "setTransport", getClientLogConfig(_t), getClientStates(_t, ["config"]))
  };
};
const client$1 = createInstance$1();
var add$2 = client$1.add, identify = client$1.identify, init$1 = client$1.init, setUserId$1 = client$1.setUserId, track = client$1.track, U$2 = function() {
  function _t() {
  }
  return _t.prototype.getApplicationContext = function() {
    return { versionName: this.versionName, language: q$2(), platform: "Web", os: void 0, deviceModel: void 0 };
  }, _t;
}(), q$2 = function() {
  return typeof navigator < "u" && (navigator.languages && navigator.languages[0] || navigator.language) || "";
}, B$2 = function() {
  function _t() {
    this.queue = [];
  }
  return _t.prototype.logEvent = function(Et) {
    this.receiver ? this.receiver(Et) : this.queue.length < 512 && this.queue.push(Et);
  }, _t.prototype.setEventReceiver = function(Et) {
    this.receiver = Et, this.queue.length > 0 && (this.queue.forEach(function(Pt) {
      Et(Pt);
    }), this.queue = []);
  }, _t;
}(), h$3 = function() {
  return h$3 = Object.assign || function(_t) {
    for (var Et, Pt = 1, $t = arguments.length; Pt < $t; Pt++) {
      Et = arguments[Pt];
      for (var Mt in Et)
        Object.prototype.hasOwnProperty.call(Et, Mt) && (_t[Mt] = Et[Mt]);
    }
    return _t;
  }, h$3.apply(this, arguments);
};
function A$2(_t) {
  var Et = typeof Symbol == "function" && Symbol.iterator, Pt = Et && _t[Et], $t = 0;
  if (Pt)
    return Pt.call(_t);
  if (_t && typeof _t.length == "number")
    return { next: function() {
      return _t && $t >= _t.length && (_t = void 0), { value: _t && _t[$t++], done: !_t };
    } };
  throw new TypeError(Et ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function K$3(_t, Et) {
  var Pt = typeof Symbol == "function" && _t[Symbol.iterator];
  if (!Pt)
    return _t;
  var $t = Pt.call(_t), Mt, Bt = [], Vt;
  try {
    for (; (Et === void 0 || Et-- > 0) && !(Mt = $t.next()).done; )
      Bt.push(Mt.value);
  } catch (zt) {
    Vt = { error: zt };
  } finally {
    try {
      Mt && !Mt.done && (Pt = $t.return) && Pt.call($t);
    } finally {
      if (Vt)
        throw Vt.error;
    }
  }
  return Bt;
}
var _$2 = function(_t, Et) {
  var Pt, $t, Mt = ["string", "number", "boolean", "undefined"], Bt = typeof _t, Vt = typeof Et;
  if (Bt !== Vt)
    return !1;
  try {
    for (var zt = A$2(Mt), Ht = zt.next(); !Ht.done; Ht = zt.next()) {
      var Wt = Ht.value;
      if (Wt === Bt)
        return _t === Et;
    }
  } catch (Yt) {
    Pt = { error: Yt };
  } finally {
    try {
      Ht && !Ht.done && ($t = zt.return) && $t.call(zt);
    } finally {
      if (Pt)
        throw Pt.error;
    }
  }
  if (_t == null && Et == null)
    return !0;
  if (_t == null || Et == null || _t.length !== Et.length)
    return !1;
  var Gt = Array.isArray(_t), qt = Array.isArray(Et);
  if (Gt !== qt)
    return !1;
  if (Gt && qt) {
    for (var Kt = 0; Kt < _t.length; Kt++)
      if (!_$2(_t[Kt], Et[Kt]))
        return !1;
  } else {
    var Qt = Object.keys(_t).sort(), Xt = Object.keys(Et).sort();
    if (!_$2(Qt, Xt))
      return !1;
    var Zt = !0;
    return Object.keys(_t).forEach(function(Yt) {
      _$2(_t[Yt], Et[Yt]) || (Zt = !1);
    }), Zt;
  }
  return !0;
}, N$2 = "$set", T$2 = "$unset", $$2 = "$clearAll";
Object.entries || (Object.entries = function(_t) {
  for (var Et = Object.keys(_t), Pt = Et.length, $t = new Array(Pt); Pt--; )
    $t[Pt] = [Et[Pt], _t[Et[Pt]]];
  return $t;
});
var M$2 = function() {
  function _t() {
    this.identity = { userProperties: {} }, this.listeners = /* @__PURE__ */ new Set();
  }
  return _t.prototype.editIdentity = function() {
    var Et = this, Pt = h$3({}, this.identity.userProperties), $t = h$3(h$3({}, this.identity), { userProperties: Pt });
    return { setUserId: function(Mt) {
      return $t.userId = Mt, this;
    }, setDeviceId: function(Mt) {
      return $t.deviceId = Mt, this;
    }, setUserProperties: function(Mt) {
      return $t.userProperties = Mt, this;
    }, setOptOut: function(Mt) {
      return $t.optOut = Mt, this;
    }, updateUserProperties: function(Mt) {
      var Bt, Vt, zt, Ht, Wt, Gt, qt = $t.userProperties || {};
      try {
        for (var Kt = A$2(Object.entries(Mt)), Qt = Kt.next(); !Qt.done; Qt = Kt.next()) {
          var Xt = K$3(Qt.value, 2), Zt = Xt[0], Yt = Xt[1];
          switch (Zt) {
            case N$2:
              try {
                for (var Jt = (zt = void 0, A$2(Object.entries(Yt))), er = Jt.next(); !er.done; er = Jt.next()) {
                  var tr = K$3(er.value, 2), nr = tr[0], rr = tr[1];
                  qt[nr] = rr;
                }
              } catch (or) {
                zt = { error: or };
              } finally {
                try {
                  er && !er.done && (Ht = Jt.return) && Ht.call(Jt);
                } finally {
                  if (zt)
                    throw zt.error;
                }
              }
              break;
            case T$2:
              try {
                for (var ir = (Wt = void 0, A$2(Object.keys(Yt))), ar = ir.next(); !ar.done; ar = ir.next()) {
                  var nr = ar.value;
                  delete qt[nr];
                }
              } catch (or) {
                Wt = { error: or };
              } finally {
                try {
                  ar && !ar.done && (Gt = ir.return) && Gt.call(ir);
                } finally {
                  if (Wt)
                    throw Wt.error;
                }
              }
              break;
            case $$2:
              qt = {};
              break;
          }
        }
      } catch (or) {
        Bt = { error: or };
      } finally {
        try {
          Qt && !Qt.done && (Vt = Kt.return) && Vt.call(Kt);
        } finally {
          if (Bt)
            throw Bt.error;
        }
      }
      return $t.userProperties = qt, this;
    }, commit: function() {
      return Et.setIdentity($t), this;
    } };
  }, _t.prototype.getIdentity = function() {
    return h$3({}, this.identity);
  }, _t.prototype.setIdentity = function(Et) {
    var Pt = h$3({}, this.identity);
    this.identity = h$3({}, Et), _$2(Pt, this.identity) || this.listeners.forEach(function($t) {
      $t(Et);
    });
  }, _t.prototype.addIdentityListener = function(Et) {
    this.listeners.add(Et);
  }, _t.prototype.removeIdentityListener = function(Et) {
    this.listeners.delete(Et);
  }, _t;
}(), E$3 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : self, O$3 = function() {
  function _t() {
    this.identityStore = new M$2(), this.eventBridge = new B$2(), this.applicationContextProvider = new U$2();
  }
  return _t.getInstance = function(Et) {
    return E$3.analyticsConnectorInstances || (E$3.analyticsConnectorInstances = {}), E$3.analyticsConnectorInstances[Et] || (E$3.analyticsConnectorInstances[Et] = new _t()), E$3.analyticsConnectorInstances[Et];
  }, _t;
}(), Z$2 = ["boot"], R$2 = "$default_instance";
function k$3(_t) {
  var Et, Pt, $t, Mt, Bt, Vt, zt;
  let Ht = window.engagement, Wt = { _q: (Et = Ht == null ? void 0 : Ht._q) != null ? Et : [], _configuration: { apiKey: ($t = (Pt = Ht == null ? void 0 : Ht._configuration) == null ? void 0 : Pt.apiKey) != null ? $t : "", serverUrl: (Mt = Ht == null ? void 0 : Ht._configuration) == null ? void 0 : Mt.serverUrl, serverZone: (Vt = (Bt = Ht == null ? void 0 : Ht._configuration) == null ? void 0 : Bt.serverZone) != null ? Vt : "US", options: { ...(zt = Ht == null ? void 0 : Ht._configuration) == null ? void 0 : zt.options } }, _sentry: void 0, init(qt, Kt) {
    var Qt, Xt, Zt;
    if (Wt._configuration.apiKey) {
      console.log("Engagement SDK has already been initialized. Ignoring additional init call.");
      return;
    }
    Wt._configuration = { ...Wt._configuration, ...Kt, apiKey: qt, options: { ...Wt._configuration.options, ...Kt == null ? void 0 : Kt.options } }, (Xt = (Qt = Wt._configuration) == null ? void 0 : Qt.options) != null && Xt.logger && Wt._configuration.options.logger.enable((Zt = Wt._configuration.options.logLevel) != null ? Zt : 2), _t();
  }, plugin(qt) {
    let Kt = Wt.init;
    return { name: "@amplitude/engagement-browser", type: "enrichment", async setup(Qt, Xt) {
      var Zt;
      let Yt = (Zt = Qt.instanceName) != null ? Zt : R$2, Jt = O$3.getInstance(Yt).identityStore;
      Kt(Qt.apiKey, { options: { logLevel: Qt.logLevel }, ...qt, serverZone: Qt.serverZone }), await window.engagement.boot({ user: () => {
        let er = Jt.getIdentity();
        return { user_id: Xt.getUserId(), device_id: Xt.getDeviceId(), user_properties: er.userProperties, getSessionId: Xt.getSessionId };
      }, integrations: [{ track: (er) => {
        Xt.track(er);
      } }] }), Jt.addIdentityListener((er) => {
        window.engagement._setUserProperties(er.userProperties);
      });
    }, async execute(Qt) {
      return window.engagement.forwardEvent(Qt), Qt;
    } };
  } }, Gt = Wt;
  return new Proxy(Wt, { get: function(qt, Kt) {
    if (Kt in Gt)
      return Gt[Kt];
    if (Kt !== "then")
      return Kt === "gs" ? new Proxy({}, { get: function(Qt, Xt) {
        return function() {
          let Zt = Array.from(arguments), Yt = `${Kt}.${Xt}`;
          Zt.unshift(Yt), Wt._q.push(Zt);
        };
      } }) : Z$2.includes(Kt) ? function() {
        let Qt = Array.prototype.slice.call(arguments);
        return new Promise((Xt, Zt) => {
          Qt.unshift(Kt, Xt, Zt), Wt._q.push(Qt);
        });
      } : function() {
        let Qt = Array.prototype.slice.call(arguments);
        Qt.unshift(Kt), Wt._q.push(Qt);
      };
  } });
}
var b$2 = () => {
  function _t(Et) {
    for (let Pt of Et) {
      let $t = document.createElement("script");
      $t.src = Pt, $t.id = "engagement-sdk-bundle";
      let Mt = document.querySelector("[nonce]");
      Mt && $t.setAttribute("nonce", Mt.nonce || Mt.getAttribute("nonce")), document.getElementsByTagName("head")[0].appendChild($t);
    }
  }
  return k$3(() => _t(["https://cdn.amplitude.com/engagement-browser/prod/index.min.js.gz"]));
};
window.engagement = b$2();
var x$3 = b$2();
window.engagement = x$3;
var { init: J$2, plugin: Q$2 } = x$3;
const isContextualTracking = (_t) => typeof _t.__arguments__ < "u", mergeProperties = async (_t, Et = {}) => {
  const Pt = {};
  for (const $t of _t) {
    const Mt = await $t();
    Object.assign(Pt, Mt);
  }
  return {
    ...Pt,
    ...Et
  };
}, recursiveFlatMapArguments = (_t) => _t.flatMap((Et) => isContextualTracking(Et) ? recursiveFlatMapArguments(Et.__arguments__) : Et), initAnalytics = ({
  clientId: _t,
  autocapture: Et = !1,
  engagement: Pt = !1
}) => {
  _t && init$1(_t, {
    autocapture: Et
  }), Pt && add$2(Q$2());
}, setUserId = (_t) => {
  _t && setUserId$1(_t);
}, setUserProperties = (_t) => {
  const Et = new Identify();
  for (const [Pt, $t] of Object.entries(_t))
    Et.set(Pt, $t);
  identify(Et);
}, useAnalytics = (..._t) => useRef((Pt, $t) => {
  mergeProperties(_t, $t).then((Mt) => {
    track(Pt, Mt);
  });
}).current, createAnalyticsHook = (..._t) => {
  const Et = (...Pt) => {
    const $t = recursiveFlatMapArguments(_t);
    return useAnalytics(...$t, ...Pt);
  };
  return Et.__arguments__ = _t, Et;
};
function ButtonIcon({
  fill: _t = "#696F88"
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "19", height: "18", viewBox: "0 0 19 18", fill: "none", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.25 3.75V14.25H14.75V9H16.25V14.25C16.25 15.075 15.575 15.75 14.75 15.75H4.25C3.4175 15.75 2.75 15.075 2.75 14.25V3.75C2.75 2.925 3.4175 2.25 4.25 2.25H9.5V3.75H4.25ZM11 3.75V2.25H16.25V7.5H14.75V4.8075L7.3775 12.18L6.32 11.1225L13.6925 3.75H11Z", fill: _t }) });
}
function OpenInNewTab({
  dark: _t,
  className: Et
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: Et, children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.33333 1.33333V10.6667H10.6667V6H12V10.6667C12 11.4 11.4 12 10.6667 12H1.33333C0.593333 12 0 11.4 0 10.6667V1.33333C0 0.6 0.593333 0 1.33333 0H6V1.33333H1.33333ZM7.33333 1.33333V0H12V4.66667H10.6667V2.27333L4.11333 8.82667L3.17333 7.88667L9.72667 1.33333H7.33333Z", fill: _t ? "#A3A9B9" : "#696F88" }) });
}
function QuotaSet() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "474", height: "145", viewBox: "0 0 474 145", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M261.344 32.5352L231.995 37.2194L202.647 32.5352L173.299 37.2194V119.363L202.647 114.68L231.995 119.363L261.344 114.68L290.692 119.363V37.2194L261.344 32.5352Z", fill: "#DFE2E7" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M178 54.5V32.5L200.5 29L206.5 28L236.5 32.5L263 28.5L265.5 28L295 33V114.5L266 110L256 111.5L236.5 114.5L221.5 112.5L207 110L200.5 111L178 114.5V54.5Z", fill: "#F3F4F6", stroke: "#00004B", strokeWidth: "1.5" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M226.5 96L221.5 112L236.5 114.5L256 111.5L248.5 86L226.5 96Z", fill: "#DFFBE8", stroke: "#00004B", strokeWidth: "1.5" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M186.5 91L200.5 111L178 114.5V55L194.5 62.5L186.5 91Z", fill: "#DFFBE8", stroke: "#00004B", strokeWidth: "1.5" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M200.5 29L178 32.5V54.5L188 59.5L203 34.5L200.5 29Z", stroke: "#00004B", strokeWidth: "1.5" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M225 53.5L207.5 68L226.5 96L236.5 93.5L248.5 86V62.5L236.5 68L225 53.5Z", fill: "#DFFBE8", stroke: "#00004B", strokeWidth: "1.5" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M207.5 68L194.5 62.5L188 59.5L203 34.5L200.5 29L206.5 28L225 53.5L207.5 68Z", stroke: "#00004B", strokeWidth: "1.5" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M284 77.5L278 57L265.5 58.5L248.5 62.5V86L253 101.5L266 94H278L284 77.5Z", fill: "#DFFBE8", stroke: "#00004B", strokeWidth: "1.5" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M278 94L284 77.5H295V114.5L266 110L256 111.5L253 101.5L266 94H278Z", fill: "#DFFBE8", stroke: "#00004B", strokeWidth: "1.5" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M194.5 62.5L207.5 68L226.5 96L221.5 112.5L207 110L200.5 111L186.5 91L194.5 62.5Z", fill: "#DFFBE8", stroke: "#00004B", strokeWidth: "1.5" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M248.5 62.5L236.5 68L224.5 53.5L206.5 28L236.5 32.5L263 28.5L254.5 61L248.5 62.5Z", stroke: "#00004B", strokeWidth: "1.5", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M254.5 61L263 28.5L265.5 28L295 33V77.5H284L278 57L265.5 58.5L254.5 61Z", fill: "#F3F4F6", stroke: "#00004B", strokeWidth: "1.5" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M178 54.5V32.5L200.5 29L206.5 28L236.5 32.5L263 28.5L265.5 28L295 33V114.5L266 110L256 111.5L236.5 114.5L221.5 112.5L207 110L200.5 111L178 114.5V54.5Z", stroke: "#00004B", strokeWidth: "1.5" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("line", { opacity: "0.2", x1: "206.75", y1: "29", x2: "206.75", y2: "110", stroke: "#00004B", strokeWidth: "1.5" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("line", { opacity: "0.2", x1: "265.75", y1: "28", x2: "265.75", y2: "110", stroke: "#00004B", strokeWidth: "1.5" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M149 55H325", stroke: "#31B4F2", strokeWidth: "4", strokeLinecap: "round", strokeDasharray: "0.1 6" })
  ] });
}
function CropCycles({
  dark: _t
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M9.38626 3.79599C9.38626 5.15679 7.97829 6.25994 7.97829 6.25994C7.97829 6.25994 6.57031 5.15679 6.57031 3.79599C6.57031 2.43518 7.97829 1.33203 7.97829 1.33203C7.97829 1.33203 9.38626 2.43518 9.38626 3.79599Z", stroke: _t ? "#A3A9B9" : "#0071CD", strokeWidth: "1.5", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M11.1073 7.60455C10.1451 8.56679 8.36943 8.35124 8.36943 8.35124C8.36943 8.35124 8.15388 6.57561 9.11612 5.61337C10.0784 4.65114 11.854 4.86668 11.854 4.86668C11.854 4.86668 12.0695 6.64232 11.1073 7.60455Z", stroke: _t ? "#A3A9B9" : "#0071CD", strokeWidth: "1.5", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M11.1073 11.1163C10.1451 12.0785 8.36943 11.863 8.36943 11.863C8.36943 11.863 8.15388 10.0873 9.11612 9.12509C10.0784 8.16286 11.854 8.3784 11.854 8.3784C11.854 8.3784 12.0695 10.154 11.1073 11.1163Z", stroke: _t ? "#A3A9B9" : "#0071CD", strokeWidth: "1.5", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M4.8927 7.60455C5.85494 8.56679 7.63057 8.35124 7.63057 8.35124C7.63057 8.35124 7.84612 6.57561 6.88388 5.61337C5.92165 4.65114 4.14601 4.86668 4.14601 4.86668C4.14601 4.86668 3.93047 6.64232 4.8927 7.60455Z", stroke: _t ? "#A3A9B9" : "#0071CD", strokeWidth: "1.5", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M4.8927 11.1163C5.85494 12.0785 7.63057 11.863 7.63057 11.863C7.63057 11.863 7.84612 10.0873 6.88388 9.12509C5.92165 8.16286 4.14601 8.3784 4.14601 8.3784C4.14601 8.3784 3.93047 10.154 4.8927 11.1163Z", stroke: _t ? "#A3A9B9" : "#0071CD", strokeWidth: "1.5", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M7.97852 6.96094L7.97852 14.7048", stroke: _t ? "#A3A9B9" : "#0071CD", strokeWidth: "1.5", strokeLinecap: "round" })
  ] });
}
function Field$1({
  dark: _t
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.33333 2H4.66667V3.33333L11.3333 3.33333V2H12.6667V3.33333L14 3.33333V4.66667H12.6667V11.3333H14V12.6667H12.6667V14H11.3333V12.6667L4.66667 12.6667V14H3.33333V12.6667H2V11.3333H3.33333V4.66667H2V3.33333L3.33333 3.33333V2ZM4.66667 11.3333V4.66667L11.3333 4.66667V11.3333L4.66667 11.3333Z", fill: _t ? "#A3A9B9" : "#0071CD" }) });
}
const SvgCwSettingsInputsicon = (_t) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", ..._t }, /* @__PURE__ */ React.createElement("path", { d: "M5.02633 13.666C4.6018 13.666 4.23624 13.5221 3.92963 13.2344C3.62303 12.9467 3.46973 12.5905 3.46973 12.166V4.26979C3.46973 3.9113 3.58058 3.59054 3.80227 3.30753C4.02397 3.02451 4.31407 2.84526 4.67256 2.76979L10.2622 1.66602V10.7226L4.89897 11.7981C4.81407 11.817 4.74331 11.8618 4.68671 11.9325C4.6301 12.0033 4.6018 12.0811 4.6018 12.166C4.6018 12.2698 4.64425 12.3571 4.72916 12.4278C4.81407 12.4986 4.91312 12.5339 5.02633 12.5339H11.3943V3.47734H12.5263V13.666H5.02633ZM6.29992 10.3688L9.1301 9.81696V3.05281L6.29992 3.60469V10.3688ZM5.16784 10.5953V3.83111L4.95558 3.87356C4.8518 3.89243 4.7669 3.93724 4.70086 4.008C4.63482 4.07875 4.6018 4.16602 4.6018 4.26979V10.7368C4.64897 10.7179 4.6985 10.7014 4.75039 10.6872C4.80227 10.6731 4.8518 10.6613 4.89897 10.6519L5.16784 10.5953Z", fill: "currentColor" })), SvgCwSettingsManageQuotasicon = (_t) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", ..._t }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.35059 8.00052C3.35059 10.3472 5.09059 12.2872 7.35059 12.6139V14.6339C3.98392 14.3005 1.35059 11.4605 1.35059 8.00052C1.35059 4.54052 3.98392 1.70052 7.35059 1.36719V3.38719C5.09059 3.71385 3.35059 5.65385 3.35059 8.00052ZM8.68392 3.38719C10.7239 3.68052 12.3373 5.29385 12.6306 7.33385H14.6506C14.3373 4.18719 11.8306 1.68052 8.68392 1.36719V3.38719ZM12.6306 8.66667C12.3373 10.7067 10.7239 12.32 8.68392 12.6133V14.6333C11.8306 14.32 14.3373 11.8133 14.6506 8.66667H12.6306Z", fill: "currentColor" })), SvgCwSettingsPersonAddicon = (_t) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", ..._t }, /* @__PURE__ */ React.createElement("path", { d: "M13.3332 6.0013V4.0013H11.9998V6.0013H9.99984V7.33464H11.9998V9.33463H13.3332V7.33464H15.3332V6.0013H13.3332ZM5.99984 8.0013C7.47317 8.0013 8.6665 6.80797 8.6665 5.33464C8.6665 3.8613 7.47317 2.66797 5.99984 2.66797C4.5265 2.66797 3.33317 3.8613 3.33317 5.33464C3.33317 6.80797 4.5265 8.0013 5.99984 8.0013ZM5.99984 4.0013C6.73317 4.0013 7.33317 4.6013 7.33317 5.33464C7.33317 6.06797 6.73317 6.66797 5.99984 6.66797C5.2665 6.66797 4.6665 6.06797 4.6665 5.33464C4.6665 4.6013 5.2665 4.0013 5.99984 4.0013ZM10.2598 9.70797C9.13984 9.13464 7.6865 8.66797 5.99984 8.66797C4.31317 8.66797 2.85984 9.13464 1.73984 9.70797C1.07317 10.048 0.666504 10.7346 0.666504 11.4813V13.3346H11.3332V11.4813C11.3332 10.7346 10.9265 10.048 10.2598 9.70797ZM9.99984 12.0013H1.99984V11.4813C1.99984 11.228 2.13317 11.0013 2.3465 10.8946C3.13984 10.488 4.41984 10.0013 5.99984 10.0013C7.57984 10.0013 8.85984 10.488 9.65317 10.8946C9.8665 11.0013 9.99984 11.228 9.99984 11.4813V12.0013Z", fill: "currentColor" }));
function Products({
  dark: _t
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.00021 7.9987H9.00021L9.91828 10.4298C10.0829 10.8659 9.76072 11.332 9.2946 11.332H6.70651C6.24046 11.332 5.91823 10.866 6.08277 10.43L7.00021 7.9987ZM7.66688 9.33203L7.33354 9.9987H8.66688L8.33354 9.33203H7.66688Z", fill: _t ? "#A3A9B9" : "#0071CD" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.33354 15.332L7.33354 12.6654H8.66688V15.332H7.33354Z", fill: _t ? "#A3A9B9" : "#0071CD" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.5549 14.0326L9.44552 12.3685L10.5549 11.6289L11.6643 13.293L10.5549 14.0326Z", fill: _t ? "#A3A9B9" : "#0071CD" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.33612 13.293L5.44552 11.6289L6.55492 12.3685L5.44552 14.0326L4.33612 13.293Z", fill: _t ? "#A3A9B9" : "#0071CD" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.45976 2.38678C3.14391 1.94561 3.45925 1.33203 4.00183 1.33203H11.9984C12.541 1.33203 12.8563 1.94559 12.5405 2.38677L9.00021 7.33203H7.00021L3.45976 2.38678ZM5.29556 2.66536L7.67651 5.9987H8.32368L10.7046 2.66536H5.29556Z", fill: _t ? "#A3A9B9" : "#0071CD" })
  ] });
}
const SvgDataMatchingicon = (_t) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ..._t }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 8C8.895 8 8 8.895 8 10C8 11.105 8.895 12 10 12C11.105 12 12 11.105 12 10C12 8.895 11.105 8 10 8ZM10.6667 10C10.6667 10.3682 10.3682 10.6667 10 10.6667C9.63181 10.6667 9.33333 10.3682 9.33333 10C9.33333 9.63181 9.63181 9.33333 10 9.33333C10.3682 9.33333 10.6667 9.63181 10.6667 10ZM9.33333 6.66667C10.8061 6.66667 12 5.47276 12 4C12 2.52724 10.8061 1.33333 9.33333 1.33333L4.66667 1.33333V2.66667L9.33333 2.66667C10.0697 2.66667 10.6667 3.26361 10.6667 4C10.6667 4.73639 10.0697 5.33333 9.33333 5.33333L2.66667 5.33333C1.19391 5.33333 5.96046e-08 6.52724 0 8C0 9.47276 1.19391 10.6667 2.66667 10.6667L7.33333 10.6667V9.33333L2.66667 9.33333C1.93029 9.33333 1.33333 8.73639 1.33333 8C1.33333 7.26361 1.93029 6.66667 2.66667 6.66667L9.33333 6.66667ZM4 0H4.17233e-07L2.38419e-07 4L4 4L4 0ZM2.66667 1.33333H1.33333L1.33333 2.66667H2.66667L2.66667 1.33333Z", fill: "#0071CD" })), SvgFileUploadicon = (_t) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 12 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ..._t }, /* @__PURE__ */ React.createElement("path", { d: "M7.33317 0.333984H1.99984C1.2665 0.333984 0.673171 0.933984 0.673171 1.66732L0.666504 12.334C0.666504 13.0673 1.25984 13.6673 1.99317 13.6673H9.99984C10.7332 13.6673 11.3332 13.0673 11.3332 12.334V4.33398L7.33317 0.333984ZM9.99984 12.334H1.99984V1.66732H6.6665V5.00065H9.99984V12.334ZM3.33317 9.00732L4.27317 9.94732L5.33317 8.89398V11.6673H6.6665V8.89398L7.7265 9.95399L8.6665 9.00732L6.0065 6.33398L3.33317 9.00732Z", fill: "currentColor" })), SvgIntegrationicon = (_t) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ..._t }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.0002 10.334H11.6668C12.7714 10.334 13.6668 9.43855 13.6668 8.33398C13.6668 7.22941 12.7714 6.33398 11.6668 6.33398H11.0002V4.33398C11.0002 3.5976 10.4032 3.00065 9.66683 3.00065H7.66683V2.33398C7.66683 1.22941 6.7714 0.333984 5.66683 0.333984C4.56226 0.333984 3.66683 1.22941 3.66683 2.33398V3.00065H1.66683C0.93045 3.00065 0.333496 3.5976 0.333496 4.33398V7.66732H2.3335C2.70169 7.66732 3.00016 7.96579 3.00016 8.33398C3.00016 8.70218 2.70169 9.00065 2.3335 9.00065H0.333496V12.334C0.333496 13.0704 0.93045 13.6673 1.66683 13.6673H5.00016V11.6673C5.00016 11.2991 5.29864 11.0007 5.66683 11.0007C6.03502 11.0007 6.3335 11.2991 6.3335 11.6673V13.6673H9.66683C10.4032 13.6673 11.0002 13.0704 11.0002 12.334V10.334ZM7.66683 12.334H9.66683V9.00065H11.6668C12.035 9.00065 12.3335 8.70218 12.3335 8.33398C12.3335 7.96579 12.035 7.66732 11.6668 7.66732H9.66683V4.33398H6.3335V2.33398C6.3335 1.96579 6.03502 1.66732 5.66683 1.66732C5.29864 1.66732 5.00016 1.96579 5.00016 2.33398V4.33398H1.66683V6.33398H2.3335C3.43807 6.33398 4.3335 7.22941 4.3335 8.33398C4.3335 9.43855 3.43807 10.334 2.3335 10.334H1.66683V12.334H3.66683V11.6673C3.66683 10.5627 4.56226 9.66732 5.66683 9.66732C6.7714 9.66732 7.66683 10.5627 7.66683 11.6673V12.334Z", fill: "currentColor" })), SvgPlusicon = (_t) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 18 18", fill: "none", ..._t }, /* @__PURE__ */ React.createElement("path", { d: "M14.25 9.75H9.75V14.25H8.25V9.75H3.75V8.25H8.25V3.75H9.75V8.25H14.25V9.75Z", fill: "currentColor" }));
var __assign$1 = function() {
  return __assign$1 = Object.assign || function(Et) {
    for (var Pt, $t = 1, Mt = arguments.length; $t < Mt; $t++) {
      Pt = arguments[$t];
      for (var Bt in Pt)
        Object.prototype.hasOwnProperty.call(Pt, Bt) && (Et[Bt] = Pt[Bt]);
    }
    return Et;
  }, __assign$1.apply(this, arguments);
};
function __spreadArray(_t, Et, Pt) {
  if (Pt || arguments.length === 2)
    for (var $t = 0, Mt = Et.length, Bt; $t < Mt; $t++)
      (Bt || !($t in Et)) && (Bt || (Bt = Array.prototype.slice.call(Et, 0, $t)), Bt[$t] = Et[$t]);
  return _t.concat(Bt || Array.prototype.slice.call(Et));
}
typeof SuppressedError == "function" && SuppressedError;
function memoize(_t) {
  var Et = /* @__PURE__ */ Object.create(null);
  return function(Pt) {
    return Et[Pt] === void 0 && (Et[Pt] = _t(Pt)), Et[Pt];
  };
}
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, isPropValid = /* @__PURE__ */ memoize(
  function(_t) {
    return reactPropsRegex.test(_t) || _t.charCodeAt(0) === 111 && _t.charCodeAt(1) === 110 && _t.charCodeAt(2) < 91;
  }
  /* Z+1 */
), MS = "-ms-", MOZ = "-moz-", WEBKIT = "-webkit-", COMMENT$1 = "comm", RULESET$1 = "rule", DECLARATION$1 = "decl", IMPORT$1 = "@import", KEYFRAMES$1 = "@keyframes", LAYER$1 = "@layer", abs$3 = Math.abs, from$3 = String.fromCharCode, assign = Object.assign;
function hash(_t, Et) {
  return charat$1(_t, 0) ^ 45 ? (((Et << 2 ^ charat$1(_t, 0)) << 2 ^ charat$1(_t, 1)) << 2 ^ charat$1(_t, 2)) << 2 ^ charat$1(_t, 3) : 0;
}
function trim$2(_t) {
  return _t.trim();
}
function match$1(_t, Et) {
  return (_t = Et.exec(_t)) ? _t[0] : _t;
}
function replace$1(_t, Et, Pt) {
  return _t.replace(Et, Pt);
}
function indexof$1(_t, Et, Pt) {
  return _t.indexOf(Et, Pt);
}
function charat$1(_t, Et) {
  return _t.charCodeAt(Et) | 0;
}
function substr$1(_t, Et, Pt) {
  return _t.slice(Et, Pt);
}
function strlen$1(_t) {
  return _t.length;
}
function sizeof$1(_t) {
  return _t.length;
}
function append$1(_t, Et) {
  return Et.push(_t), _t;
}
function combine(_t, Et) {
  return _t.map(Et).join("");
}
function filter$1(_t, Et) {
  return _t.filter(function(Pt) {
    return !match$1(Pt, Et);
  });
}
var line$1 = 1, column$1 = 1, length$1 = 0, position$1 = 0, character$1 = 0, characters$1 = "";
function node$1(_t, Et, Pt, $t, Mt, Bt, Vt, zt) {
  return { value: _t, root: Et, parent: Pt, type: $t, props: Mt, children: Bt, line: line$1, column: column$1, length: Vt, return: "", siblings: zt };
}
function copy(_t, Et) {
  return assign(node$1("", null, null, "", null, null, 0, _t.siblings), _t, { length: -_t.length }, Et);
}
function lift(_t) {
  for (; _t.root; )
    _t = copy(_t.root, { children: [_t] });
  append$1(_t, _t.siblings);
}
function char$1() {
  return character$1;
}
function prev$1() {
  return character$1 = position$1 > 0 ? charat$1(characters$1, --position$1) : 0, column$1--, character$1 === 10 && (column$1 = 1, line$1--), character$1;
}
function next$1() {
  return character$1 = position$1 < length$1 ? charat$1(characters$1, position$1++) : 0, column$1++, character$1 === 10 && (column$1 = 1, line$1++), character$1;
}
function peek$1() {
  return charat$1(characters$1, position$1);
}
function caret$1() {
  return position$1;
}
function slice$1(_t, Et) {
  return substr$1(characters$1, _t, Et);
}
function token$2(_t) {
  switch (_t) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc$2(_t) {
  return line$1 = column$1 = 1, length$1 = strlen$1(characters$1 = _t), position$1 = 0, [];
}
function dealloc$1(_t) {
  return characters$1 = "", _t;
}
function delimit$1(_t) {
  return trim$2(slice$1(position$1 - 1, delimiter$1(_t === 91 ? _t + 2 : _t === 40 ? _t + 1 : _t)));
}
function whitespace$2(_t) {
  for (; (character$1 = peek$1()) && character$1 < 33; )
    next$1();
  return token$2(_t) > 2 || token$2(character$1) > 3 ? "" : " ";
}
function escaping$1(_t, Et) {
  for (; --Et && next$1() && !(character$1 < 48 || character$1 > 102 || character$1 > 57 && character$1 < 65 || character$1 > 70 && character$1 < 97); )
    ;
  return slice$1(_t, caret$1() + (Et < 6 && peek$1() == 32 && next$1() == 32));
}
function delimiter$1(_t) {
  for (; next$1(); )
    switch (character$1) {
      case _t:
        return position$1;
      case 34:
      case 39:
        _t !== 34 && _t !== 39 && delimiter$1(character$1);
        break;
      case 40:
        _t === 41 && delimiter$1(_t);
        break;
      case 92:
        next$1();
        break;
    }
  return position$1;
}
function commenter$1(_t, Et) {
  for (; next$1() && _t + character$1 !== 57; )
    if (_t + character$1 === 84 && peek$1() === 47)
      break;
  return "/*" + slice$1(Et, position$1 - 1) + "*" + from$3(_t === 47 ? _t : next$1());
}
function identifier$1(_t) {
  for (; !token$2(peek$1()); )
    next$1();
  return slice$1(_t, position$1);
}
function compile$1(_t) {
  return dealloc$1(parse$1("", null, null, null, [""], _t = alloc$2(_t), 0, [0], _t));
}
function parse$1(_t, Et, Pt, $t, Mt, Bt, Vt, zt, Ht) {
  for (var Wt = 0, Gt = 0, qt = Vt, Kt = 0, Qt = 0, Xt = 0, Zt = 1, Yt = 1, Jt = 1, er = 0, tr = "", nr = Mt, rr = Bt, ir = $t, ar = tr; Yt; )
    switch (Xt = er, er = next$1()) {
      case 40:
        if (Xt != 108 && charat$1(ar, qt - 1) == 58) {
          indexof$1(ar += replace$1(delimit$1(er), "&", "&\f"), "&\f", abs$3(Wt ? zt[Wt - 1] : 0)) != -1 && (Jt = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        ar += delimit$1(er);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        ar += whitespace$2(Xt);
        break;
      case 92:
        ar += escaping$1(caret$1() - 1, 7);
        continue;
      case 47:
        switch (peek$1()) {
          case 42:
          case 47:
            append$1(comment$1(commenter$1(next$1(), caret$1()), Et, Pt, Ht), Ht);
            break;
          default:
            ar += "/";
        }
        break;
      case 123 * Zt:
        zt[Wt++] = strlen$1(ar) * Jt;
      case 125 * Zt:
      case 59:
      case 0:
        switch (er) {
          case 0:
          case 125:
            Yt = 0;
          case 59 + Gt:
            Jt == -1 && (ar = replace$1(ar, /\f/g, "")), Qt > 0 && strlen$1(ar) - qt && append$1(Qt > 32 ? declaration$1(ar + ";", $t, Pt, qt - 1, Ht) : declaration$1(replace$1(ar, " ", "") + ";", $t, Pt, qt - 2, Ht), Ht);
            break;
          case 59:
            ar += ";";
          default:
            if (append$1(ir = ruleset$1(ar, Et, Pt, Wt, Gt, Mt, zt, tr, nr = [], rr = [], qt, Bt), Bt), er === 123)
              if (Gt === 0)
                parse$1(ar, Et, ir, ir, nr, Bt, qt, zt, rr);
              else
                switch (Kt === 99 && charat$1(ar, 3) === 110 ? 100 : Kt) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    parse$1(_t, ir, ir, $t && append$1(ruleset$1(_t, ir, ir, 0, 0, Mt, zt, tr, Mt, nr = [], qt, rr), rr), Mt, rr, qt, zt, $t ? nr : rr);
                    break;
                  default:
                    parse$1(ar, ir, ir, ir, [""], rr, 0, zt, rr);
                }
        }
        Wt = Gt = Qt = 0, Zt = Jt = 1, tr = ar = "", qt = Vt;
        break;
      case 58:
        qt = 1 + strlen$1(ar), Qt = Xt;
      default:
        if (Zt < 1) {
          if (er == 123)
            --Zt;
          else if (er == 125 && Zt++ == 0 && prev$1() == 125)
            continue;
        }
        switch (ar += from$3(er), er * Zt) {
          case 38:
            Jt = Gt > 0 ? 1 : (ar += "\f", -1);
            break;
          case 44:
            zt[Wt++] = (strlen$1(ar) - 1) * Jt, Jt = 1;
            break;
          case 64:
            peek$1() === 45 && (ar += delimit$1(next$1())), Kt = peek$1(), Gt = qt = strlen$1(tr = ar += identifier$1(caret$1())), er++;
            break;
          case 45:
            Xt === 45 && strlen$1(ar) == 2 && (Zt = 0);
        }
    }
  return Bt;
}
function ruleset$1(_t, Et, Pt, $t, Mt, Bt, Vt, zt, Ht, Wt, Gt, qt) {
  for (var Kt = Mt - 1, Qt = Mt === 0 ? Bt : [""], Xt = sizeof$1(Qt), Zt = 0, Yt = 0, Jt = 0; Zt < $t; ++Zt)
    for (var er = 0, tr = substr$1(_t, Kt + 1, Kt = abs$3(Yt = Vt[Zt])), nr = _t; er < Xt; ++er)
      (nr = trim$2(Yt > 0 ? Qt[er] + " " + tr : replace$1(tr, /&\f/g, Qt[er]))) && (Ht[Jt++] = nr);
  return node$1(_t, Et, Pt, Mt === 0 ? RULESET$1 : zt, Ht, Wt, Gt, qt);
}
function comment$1(_t, Et, Pt, $t) {
  return node$1(_t, Et, Pt, COMMENT$1, from$3(char$1()), substr$1(_t, 2, -2), 0, $t);
}
function declaration$1(_t, Et, Pt, $t, Mt) {
  return node$1(_t, Et, Pt, DECLARATION$1, substr$1(_t, 0, $t), substr$1(_t, $t + 1, -1), $t, Mt);
}
function prefix(_t, Et, Pt) {
  switch (hash(_t, Et)) {
    case 5103:
      return WEBKIT + "print-" + _t + _t;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + _t + _t;
    case 4789:
      return MOZ + _t + _t;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + _t + MOZ + _t + MS + _t + _t;
    case 5936:
      switch (charat$1(_t, Et + 11)) {
        case 114:
          return WEBKIT + _t + MS + replace$1(_t, /[svh]\w+-[tblr]{2}/, "tb") + _t;
        case 108:
          return WEBKIT + _t + MS + replace$1(_t, /[svh]\w+-[tblr]{2}/, "tb-rl") + _t;
        case 45:
          return WEBKIT + _t + MS + replace$1(_t, /[svh]\w+-[tblr]{2}/, "lr") + _t;
      }
    case 6828:
    case 4268:
    case 2903:
      return WEBKIT + _t + MS + _t + _t;
    case 6165:
      return WEBKIT + _t + MS + "flex-" + _t + _t;
    case 5187:
      return WEBKIT + _t + replace$1(_t, /(\w+).+(:[^]+)/, WEBKIT + "box-$1$2" + MS + "flex-$1$2") + _t;
    case 5443:
      return WEBKIT + _t + MS + "flex-item-" + replace$1(_t, /flex-|-self/g, "") + (match$1(_t, /flex-|baseline/) ? "" : MS + "grid-row-" + replace$1(_t, /flex-|-self/g, "")) + _t;
    case 4675:
      return WEBKIT + _t + MS + "flex-line-pack" + replace$1(_t, /align-content|flex-|-self/g, "") + _t;
    case 5548:
      return WEBKIT + _t + MS + replace$1(_t, "shrink", "negative") + _t;
    case 5292:
      return WEBKIT + _t + MS + replace$1(_t, "basis", "preferred-size") + _t;
    case 6060:
      return WEBKIT + "box-" + replace$1(_t, "-grow", "") + WEBKIT + _t + MS + replace$1(_t, "grow", "positive") + _t;
    case 4554:
      return WEBKIT + replace$1(_t, /([^-])(transform)/g, "$1" + WEBKIT + "$2") + _t;
    case 6187:
      return replace$1(replace$1(replace$1(_t, /(zoom-|grab)/, WEBKIT + "$1"), /(image-set)/, WEBKIT + "$1"), _t, "") + _t;
    case 5495:
    case 3959:
      return replace$1(_t, /(image-set\([^]*)/, WEBKIT + "$1$`$1");
    case 4968:
      return replace$1(replace$1(_t, /(.+:)(flex-)?(.*)/, WEBKIT + "box-pack:$3" + MS + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + WEBKIT + _t + _t;
    case 4200:
      if (!match$1(_t, /flex-|baseline/))
        return MS + "grid-column-align" + substr$1(_t, Et) + _t;
      break;
    case 2592:
    case 3360:
      return MS + replace$1(_t, "template-", "") + _t;
    case 4384:
    case 3616:
      return Pt && Pt.some(function($t, Mt) {
        return Et = Mt, match$1($t.props, /grid-\w+-end/);
      }) ? ~indexof$1(_t + (Pt = Pt[Et].value), "span", 0) ? _t : MS + replace$1(_t, "-start", "") + _t + MS + "grid-row-span:" + (~indexof$1(Pt, "span", 0) ? match$1(Pt, /\d+/) : +match$1(Pt, /\d+/) - +match$1(_t, /\d+/)) + ";" : MS + replace$1(_t, "-start", "") + _t;
    case 4896:
    case 4128:
      return Pt && Pt.some(function($t) {
        return match$1($t.props, /grid-\w+-start/);
      }) ? _t : MS + replace$1(replace$1(_t, "-end", "-span"), "span ", "") + _t;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace$1(_t, /(.+)-inline(.+)/, WEBKIT + "$1$2") + _t;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (strlen$1(_t) - 1 - Et > 6)
        switch (charat$1(_t, Et + 1)) {
          case 109:
            if (charat$1(_t, Et + 4) !== 45)
              break;
          case 102:
            return replace$1(_t, /(.+:)(.+)-([^]+)/, "$1" + WEBKIT + "$2-$3$1" + MOZ + (charat$1(_t, Et + 3) == 108 ? "$3" : "$2-$3")) + _t;
          case 115:
            return ~indexof$1(_t, "stretch", 0) ? prefix(replace$1(_t, "stretch", "fill-available"), Et, Pt) + _t : _t;
        }
      break;
    case 5152:
    case 5920:
      return replace$1(_t, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function($t, Mt, Bt, Vt, zt, Ht, Wt) {
        return MS + Mt + ":" + Bt + Wt + (Vt ? MS + Mt + "-span:" + (zt ? Ht : +Ht - +Bt) + Wt : "") + _t;
      });
    case 4949:
      if (charat$1(_t, Et + 6) === 121)
        return replace$1(_t, ":", ":" + WEBKIT) + _t;
      break;
    case 6444:
      switch (charat$1(_t, charat$1(_t, 14) === 45 ? 18 : 11)) {
        case 120:
          return replace$1(_t, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + WEBKIT + (charat$1(_t, 14) === 45 ? "inline-" : "") + "box$3$1" + WEBKIT + "$2$3$1" + MS + "$2box$3") + _t;
        case 100:
          return replace$1(_t, ":", ":" + MS) + _t;
      }
      break;
    case 5719:
    case 2647:
    case 2135:
    case 3927:
    case 2391:
      return replace$1(_t, "scroll-", "scroll-snap-") + _t;
  }
  return _t;
}
function serialize$1(_t, Et) {
  for (var Pt = "", $t = 0; $t < _t.length; $t++)
    Pt += Et(_t[$t], $t, _t, Et) || "";
  return Pt;
}
function stringify$3(_t, Et, Pt, $t) {
  switch (_t.type) {
    case LAYER$1:
      if (_t.children.length)
        break;
    case IMPORT$1:
    case DECLARATION$1:
      return _t.return = _t.return || _t.value;
    case COMMENT$1:
      return "";
    case KEYFRAMES$1:
      return _t.return = _t.value + "{" + serialize$1(_t.children, $t) + "}";
    case RULESET$1:
      if (!strlen$1(_t.value = _t.props.join(",")))
        return "";
  }
  return strlen$1(Pt = serialize$1(_t.children, $t)) ? _t.return = _t.value + "{" + Pt + "}" : "";
}
function middleware(_t) {
  var Et = sizeof$1(_t);
  return function(Pt, $t, Mt, Bt) {
    for (var Vt = "", zt = 0; zt < Et; zt++)
      Vt += _t[zt](Pt, $t, Mt, Bt) || "";
    return Vt;
  };
}
function rulesheet(_t) {
  return function(Et) {
    Et.root || (Et = Et.return) && _t(Et);
  };
}
function prefixer(_t, Et, Pt, $t) {
  if (_t.length > -1 && !_t.return)
    switch (_t.type) {
      case DECLARATION$1:
        _t.return = prefix(_t.value, _t.length, Pt);
        return;
      case KEYFRAMES$1:
        return serialize$1([copy(_t, { value: replace$1(_t.value, "@", "@" + WEBKIT) })], $t);
      case RULESET$1:
        if (_t.length)
          return combine(Pt = _t.props, function(Mt) {
            switch (match$1(Mt, $t = /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                lift(copy(_t, { props: [replace$1(Mt, /:(read-\w+)/, ":" + MOZ + "$1")] })), lift(copy(_t, { props: [Mt] })), assign(_t, { props: filter$1(Pt, $t) });
                break;
              case "::placeholder":
                lift(copy(_t, { props: [replace$1(Mt, /:(plac\w+)/, ":" + WEBKIT + "input-$1")] })), lift(copy(_t, { props: [replace$1(Mt, /:(plac\w+)/, ":" + MOZ + "$1")] })), lift(copy(_t, { props: [replace$1(Mt, /:(plac\w+)/, MS + "input-$1")] })), lift(copy(_t, { props: [Mt] })), assign(_t, { props: filter$1(Pt, $t) });
                break;
            }
            return "";
          });
    }
}
var unitlessKeys$1 = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, f$2 = typeof browser$1 < "u" && browser$1.env !== void 0 && (browser$1.env.REACT_APP_SC_ATTR || browser$1.env.SC_ATTR) || "data-styled", m$2 = "active", y$2 = "data-styled-version", v$3 = "6.1.12", g$2 = `/*!sc*/
`, S$2 = typeof window < "u" && "HTMLElement" in window, w$3 = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : typeof browser$1 < "u" && browser$1.env !== void 0 && browser$1.env.REACT_APP_SC_DISABLE_SPEEDY !== void 0 && browser$1.env.REACT_APP_SC_DISABLE_SPEEDY !== "" ? browser$1.env.REACT_APP_SC_DISABLE_SPEEDY !== "false" && browser$1.env.REACT_APP_SC_DISABLE_SPEEDY : typeof browser$1 < "u" && browser$1.env !== void 0 && browser$1.env.SC_DISABLE_SPEEDY !== void 0 && browser$1.env.SC_DISABLE_SPEEDY !== "" ? browser$1.env.SC_DISABLE_SPEEDY !== "false" && browser$1.env.SC_DISABLE_SPEEDY : browser$1.env.NODE_ENV !== "production"), E$2 = /invalid hook call/i, N$1 = /* @__PURE__ */ new Set(), P$2 = function(_t, Et) {
  if (browser$1.env.NODE_ENV !== "production") {
    var Pt = Et ? ' with the id of "'.concat(Et, '"') : "", $t = "The component ".concat(_t).concat(Pt, ` has been created dynamically.
`) + `You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.`, Mt = console.error;
    try {
      var Bt = !0;
      console.error = function(Vt) {
        for (var zt = [], Ht = 1; Ht < arguments.length; Ht++)
          zt[Ht - 1] = arguments[Ht];
        E$2.test(Vt) ? (Bt = !1, N$1.delete($t)) : Mt.apply(void 0, __spreadArray([Vt], zt, !1));
      }, useRef(), Bt && !N$1.has($t) && (console.warn($t), N$1.add($t));
    } catch (Vt) {
      E$2.test(Vt.message) && N$1.delete($t);
    } finally {
      console.error = Mt;
    }
  }
}, _$1 = Object.freeze([]), C$2 = Object.freeze({});
function I$2(_t, Et, Pt) {
  return Pt === void 0 && (Pt = C$2), _t.theme !== Pt.theme && _t.theme || Et || Pt.theme;
}
var A$1 = /* @__PURE__ */ new Set(["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "u", "ul", "use", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"]), O$2 = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, D$2 = /(^-|-$)/g;
function R$1(_t) {
  return _t.replace(O$2, "-").replace(D$2, "");
}
var T$1 = /(a)(d)/gi, k$2 = 52, j$2 = function(_t) {
  return String.fromCharCode(_t + (_t > 25 ? 39 : 97));
};
function x$2(_t) {
  var Et, Pt = "";
  for (Et = Math.abs(_t); Et > k$2; Et = Et / k$2 | 0)
    Pt = j$2(Et % k$2) + Pt;
  return (j$2(Et % k$2) + Pt).replace(T$1, "$1-$2");
}
var V$1, F$2 = 5381, M$1 = function(_t, Et) {
  for (var Pt = Et.length; Pt; )
    _t = 33 * _t ^ Et.charCodeAt(--Pt);
  return _t;
}, z$1 = function(_t) {
  return M$1(F$2, _t);
};
function $$1(_t) {
  return x$2(z$1(_t) >>> 0);
}
function B$1(_t) {
  return browser$1.env.NODE_ENV !== "production" && typeof _t == "string" && _t || _t.displayName || _t.name || "Component";
}
function L$1(_t) {
  return typeof _t == "string" && (browser$1.env.NODE_ENV === "production" || _t.charAt(0) === _t.charAt(0).toLowerCase());
}
var G$1 = typeof Symbol == "function" && Symbol.for, Y$1 = G$1 ? Symbol.for("react.memo") : 60115, W$1 = G$1 ? Symbol.for("react.forward_ref") : 60112, q$1 = { childContextTypes: !0, contextType: !0, contextTypes: !0, defaultProps: !0, displayName: !0, getDefaultProps: !0, getDerivedStateFromError: !0, getDerivedStateFromProps: !0, mixins: !0, propTypes: !0, type: !0 }, H$1 = { name: !0, length: !0, prototype: !0, caller: !0, callee: !0, arguments: !0, arity: !0 }, U$1 = { $$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0 }, J$1 = ((V$1 = {})[W$1] = { $$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0 }, V$1[Y$1] = U$1, V$1);
function X$1(_t) {
  return ("type" in (Et = _t) && Et.type.$$typeof) === Y$1 ? U$1 : "$$typeof" in _t ? J$1[_t.$$typeof] : q$1;
  var Et;
}
var Z$1 = Object.defineProperty, K$2 = Object.getOwnPropertyNames, Q$1 = Object.getOwnPropertySymbols, ee$1 = Object.getOwnPropertyDescriptor, te$1 = Object.getPrototypeOf, ne$1 = Object.prototype;
function oe$1(_t, Et, Pt) {
  if (typeof Et != "string") {
    if (ne$1) {
      var $t = te$1(Et);
      $t && $t !== ne$1 && oe$1(_t, $t, Pt);
    }
    var Mt = K$2(Et);
    Q$1 && (Mt = Mt.concat(Q$1(Et)));
    for (var Bt = X$1(_t), Vt = X$1(Et), zt = 0; zt < Mt.length; ++zt) {
      var Ht = Mt[zt];
      if (!(Ht in H$1 || Pt && Pt[Ht] || Vt && Ht in Vt || Bt && Ht in Bt)) {
        var Wt = ee$1(Et, Ht);
        try {
          Z$1(_t, Ht, Wt);
        } catch {
        }
      }
    }
  }
  return _t;
}
function re$1(_t) {
  return typeof _t == "function";
}
function se$2(_t) {
  return typeof _t == "object" && "styledComponentId" in _t;
}
function ie$2(_t, Et) {
  return _t && Et ? "".concat(_t, " ").concat(Et) : _t || Et || "";
}
function ae$1(_t, Et) {
  if (_t.length === 0)
    return "";
  for (var Pt = _t[0], $t = 1; $t < _t.length; $t++)
    Pt += _t[$t];
  return Pt;
}
function ce$1(_t) {
  return _t !== null && typeof _t == "object" && _t.constructor.name === Object.name && !("props" in _t && _t.$$typeof);
}
function le$1(_t, Et, Pt) {
  if (Pt === void 0 && (Pt = !1), !Pt && !ce$1(_t) && !Array.isArray(_t))
    return Et;
  if (Array.isArray(Et))
    for (var $t = 0; $t < Et.length; $t++)
      _t[$t] = le$1(_t[$t], Et[$t]);
  else if (ce$1(Et))
    for (var $t in Et)
      _t[$t] = le$1(_t[$t], Et[$t]);
  return _t;
}
function ue$1(_t, Et) {
  Object.defineProperty(_t, "toString", { value: Et });
}
var pe$1 = browser$1.env.NODE_ENV !== "production" ? { 1: `Cannot create styled-component for component: %s.

`, 2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`, 3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`, 4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`, 5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`, 6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`, 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: `ThemeProvider: Please make your "theme" prop an object.

`, 9: "Missing document `<head>`\n\n", 10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`, 11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`, 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n", 13: `%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.

`, 14: `ThemeProvider: "theme" prop is required.

`, 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`, 17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?
`, 18: "ThemeProvider: Please make sure your useTheme hook is within a `<ThemeProvider>`" } : {};
function de$2() {
  for (var _t = [], Et = 0; Et < arguments.length; Et++)
    _t[Et] = arguments[Et];
  for (var Pt = _t[0], $t = [], Mt = 1, Bt = _t.length; Mt < Bt; Mt += 1)
    $t.push(_t[Mt]);
  return $t.forEach(function(Vt) {
    Pt = Pt.replace(/%[a-z]/, Vt);
  }), Pt;
}
function he$1(_t) {
  for (var Et = [], Pt = 1; Pt < arguments.length; Pt++)
    Et[Pt - 1] = arguments[Pt];
  return browser$1.env.NODE_ENV === "production" ? new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(_t, " for more information.").concat(Et.length > 0 ? " Args: ".concat(Et.join(", ")) : "")) : new Error(de$2.apply(void 0, __spreadArray([pe$1[_t]], Et, !1)).trim());
}
var fe$1 = function() {
  function _t(Et) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = Et;
  }
  return _t.prototype.indexOfGroup = function(Et) {
    for (var Pt = 0, $t = 0; $t < Et; $t++)
      Pt += this.groupSizes[$t];
    return Pt;
  }, _t.prototype.insertRules = function(Et, Pt) {
    if (Et >= this.groupSizes.length) {
      for (var $t = this.groupSizes, Mt = $t.length, Bt = Mt; Et >= Bt; )
        if ((Bt <<= 1) < 0)
          throw he$1(16, "".concat(Et));
      this.groupSizes = new Uint32Array(Bt), this.groupSizes.set($t), this.length = Bt;
      for (var Vt = Mt; Vt < Bt; Vt++)
        this.groupSizes[Vt] = 0;
    }
    for (var zt = this.indexOfGroup(Et + 1), Ht = (Vt = 0, Pt.length); Vt < Ht; Vt++)
      this.tag.insertRule(zt, Pt[Vt]) && (this.groupSizes[Et]++, zt++);
  }, _t.prototype.clearGroup = function(Et) {
    if (Et < this.length) {
      var Pt = this.groupSizes[Et], $t = this.indexOfGroup(Et), Mt = $t + Pt;
      this.groupSizes[Et] = 0;
      for (var Bt = $t; Bt < Mt; Bt++)
        this.tag.deleteRule($t);
    }
  }, _t.prototype.getGroup = function(Et) {
    var Pt = "";
    if (Et >= this.length || this.groupSizes[Et] === 0)
      return Pt;
    for (var $t = this.groupSizes[Et], Mt = this.indexOfGroup(Et), Bt = Mt + $t, Vt = Mt; Vt < Bt; Vt++)
      Pt += "".concat(this.tag.getRule(Vt)).concat(g$2);
    return Pt;
  }, _t;
}(), me$1 = 1 << 30, ye$1 = /* @__PURE__ */ new Map(), ve$1 = /* @__PURE__ */ new Map(), ge$1 = 1, Se$1 = function(_t) {
  if (ye$1.has(_t))
    return ye$1.get(_t);
  for (; ve$1.has(ge$1); )
    ge$1++;
  var Et = ge$1++;
  if (browser$1.env.NODE_ENV !== "production" && ((0 | Et) < 0 || Et > me$1))
    throw he$1(16, "".concat(Et));
  return ye$1.set(_t, Et), ve$1.set(Et, _t), Et;
}, we$1 = function(_t, Et) {
  ge$1 = Et + 1, ye$1.set(_t, Et), ve$1.set(Et, _t);
}, be$1 = "style[".concat(f$2, "][").concat(y$2, '="').concat(v$3, '"]'), Ee$1 = new RegExp("^".concat(f$2, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), Ne$1 = function(_t, Et, Pt) {
  for (var $t, Mt = Pt.split(","), Bt = 0, Vt = Mt.length; Bt < Vt; Bt++)
    ($t = Mt[Bt]) && _t.registerName(Et, $t);
}, Pe$1 = function(_t, Et) {
  for (var Pt, $t = ((Pt = Et.textContent) !== null && Pt !== void 0 ? Pt : "").split(g$2), Mt = [], Bt = 0, Vt = $t.length; Bt < Vt; Bt++) {
    var zt = $t[Bt].trim();
    if (zt) {
      var Ht = zt.match(Ee$1);
      if (Ht) {
        var Wt = 0 | parseInt(Ht[1], 10), Gt = Ht[2];
        Wt !== 0 && (we$1(Gt, Wt), Ne$1(_t, Gt, Ht[3]), _t.getTag().insertRules(Wt, Mt)), Mt.length = 0;
      } else
        Mt.push(zt);
    }
  }
}, _e$1 = function(_t) {
  for (var Et = document.querySelectorAll(be$1), Pt = 0, $t = Et.length; Pt < $t; Pt++) {
    var Mt = Et[Pt];
    Mt && Mt.getAttribute(f$2) !== m$2 && (Pe$1(_t, Mt), Mt.parentNode && Mt.parentNode.removeChild(Mt));
  }
};
function Ce$1() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : null;
}
var Ie$1 = function(_t) {
  var Et = document.head, Pt = _t || Et, $t = document.createElement("style"), Mt = function(zt) {
    var Ht = Array.from(zt.querySelectorAll("style[".concat(f$2, "]")));
    return Ht[Ht.length - 1];
  }(Pt), Bt = Mt !== void 0 ? Mt.nextSibling : null;
  $t.setAttribute(f$2, m$2), $t.setAttribute(y$2, v$3);
  var Vt = Ce$1();
  return Vt && $t.setAttribute("nonce", Vt), Pt.insertBefore($t, Bt), $t;
}, Ae$1 = function() {
  function _t(Et) {
    this.element = Ie$1(Et), this.element.appendChild(document.createTextNode("")), this.sheet = function(Pt) {
      if (Pt.sheet)
        return Pt.sheet;
      for (var $t = document.styleSheets, Mt = 0, Bt = $t.length; Mt < Bt; Mt++) {
        var Vt = $t[Mt];
        if (Vt.ownerNode === Pt)
          return Vt;
      }
      throw he$1(17);
    }(this.element), this.length = 0;
  }
  return _t.prototype.insertRule = function(Et, Pt) {
    try {
      return this.sheet.insertRule(Pt, Et), this.length++, !0;
    } catch {
      return !1;
    }
  }, _t.prototype.deleteRule = function(Et) {
    this.sheet.deleteRule(Et), this.length--;
  }, _t.prototype.getRule = function(Et) {
    var Pt = this.sheet.cssRules[Et];
    return Pt && Pt.cssText ? Pt.cssText : "";
  }, _t;
}(), Oe$1 = function() {
  function _t(Et) {
    this.element = Ie$1(Et), this.nodes = this.element.childNodes, this.length = 0;
  }
  return _t.prototype.insertRule = function(Et, Pt) {
    if (Et <= this.length && Et >= 0) {
      var $t = document.createTextNode(Pt);
      return this.element.insertBefore($t, this.nodes[Et] || null), this.length++, !0;
    }
    return !1;
  }, _t.prototype.deleteRule = function(Et) {
    this.element.removeChild(this.nodes[Et]), this.length--;
  }, _t.prototype.getRule = function(Et) {
    return Et < this.length ? this.nodes[Et].textContent : "";
  }, _t;
}(), De$1 = function() {
  function _t(Et) {
    this.rules = [], this.length = 0;
  }
  return _t.prototype.insertRule = function(Et, Pt) {
    return Et <= this.length && (this.rules.splice(Et, 0, Pt), this.length++, !0);
  }, _t.prototype.deleteRule = function(Et) {
    this.rules.splice(Et, 1), this.length--;
  }, _t.prototype.getRule = function(Et) {
    return Et < this.length ? this.rules[Et] : "";
  }, _t;
}(), Re$1 = S$2, Te$1 = { isServer: !S$2, useCSSOMInjection: !w$3 }, ke$1 = function() {
  function _t(Et, Pt, $t) {
    Et === void 0 && (Et = C$2), Pt === void 0 && (Pt = {});
    var Mt = this;
    this.options = __assign$1(__assign$1({}, Te$1), Et), this.gs = Pt, this.names = new Map($t), this.server = !!Et.isServer, !this.server && S$2 && Re$1 && (Re$1 = !1, _e$1(this)), ue$1(this, function() {
      return function(Bt) {
        for (var Vt = Bt.getTag(), zt = Vt.length, Ht = "", Wt = function(qt) {
          var Kt = function(Jt) {
            return ve$1.get(Jt);
          }(qt);
          if (Kt === void 0)
            return "continue";
          var Qt = Bt.names.get(Kt), Xt = Vt.getGroup(qt);
          if (Qt === void 0 || !Qt.size || Xt.length === 0)
            return "continue";
          var Zt = "".concat(f$2, ".g").concat(qt, '[id="').concat(Kt, '"]'), Yt = "";
          Qt !== void 0 && Qt.forEach(function(Jt) {
            Jt.length > 0 && (Yt += "".concat(Jt, ","));
          }), Ht += "".concat(Xt).concat(Zt, '{content:"').concat(Yt, '"}').concat(g$2);
        }, Gt = 0; Gt < zt; Gt++)
          Wt(Gt);
        return Ht;
      }(Mt);
    });
  }
  return _t.registerId = function(Et) {
    return Se$1(Et);
  }, _t.prototype.rehydrate = function() {
    !this.server && S$2 && _e$1(this);
  }, _t.prototype.reconstructWithOptions = function(Et, Pt) {
    return Pt === void 0 && (Pt = !0), new _t(__assign$1(__assign$1({}, this.options), Et), this.gs, Pt && this.names || void 0);
  }, _t.prototype.allocateGSInstance = function(Et) {
    return this.gs[Et] = (this.gs[Et] || 0) + 1;
  }, _t.prototype.getTag = function() {
    return this.tag || (this.tag = (Et = function(Pt) {
      var $t = Pt.useCSSOMInjection, Mt = Pt.target;
      return Pt.isServer ? new De$1(Mt) : $t ? new Ae$1(Mt) : new Oe$1(Mt);
    }(this.options), new fe$1(Et)));
    var Et;
  }, _t.prototype.hasNameForId = function(Et, Pt) {
    return this.names.has(Et) && this.names.get(Et).has(Pt);
  }, _t.prototype.registerName = function(Et, Pt) {
    if (Se$1(Et), this.names.has(Et))
      this.names.get(Et).add(Pt);
    else {
      var $t = /* @__PURE__ */ new Set();
      $t.add(Pt), this.names.set(Et, $t);
    }
  }, _t.prototype.insertRules = function(Et, Pt, $t) {
    this.registerName(Et, Pt), this.getTag().insertRules(Se$1(Et), $t);
  }, _t.prototype.clearNames = function(Et) {
    this.names.has(Et) && this.names.get(Et).clear();
  }, _t.prototype.clearRules = function(Et) {
    this.getTag().clearGroup(Se$1(Et)), this.clearNames(Et);
  }, _t.prototype.clearTag = function() {
    this.tag = void 0;
  }, _t;
}(), je$1 = /&/g, xe$1 = /^\s*\/\/.*$/gm;
function Ve$1(_t, Et) {
  return _t.map(function(Pt) {
    return Pt.type === "rule" && (Pt.value = "".concat(Et, " ").concat(Pt.value), Pt.value = Pt.value.replaceAll(",", ",".concat(Et, " ")), Pt.props = Pt.props.map(function($t) {
      return "".concat(Et, " ").concat($t);
    })), Array.isArray(Pt.children) && Pt.type !== "@keyframes" && (Pt.children = Ve$1(Pt.children, Et)), Pt;
  });
}
function Fe$1(_t) {
  var Et, Pt, $t, Mt = C$2, Bt = Mt.options, Vt = Bt === void 0 ? C$2 : Bt, zt = Mt.plugins, Ht = zt === void 0 ? _$1 : zt, Wt = function(Kt, Qt, Xt) {
    return Xt.startsWith(Pt) && Xt.endsWith(Pt) && Xt.replaceAll(Pt, "").length > 0 ? ".".concat(Et) : Kt;
  }, Gt = Ht.slice();
  Gt.push(function(Kt) {
    Kt.type === RULESET$1 && Kt.value.includes("&") && (Kt.props[0] = Kt.props[0].replace(je$1, Pt).replace($t, Wt));
  }), Vt.prefix && Gt.push(prefixer), Gt.push(stringify$3);
  var qt = function(Kt, Qt, Xt, Zt) {
    Qt === void 0 && (Qt = ""), Xt === void 0 && (Xt = ""), Zt === void 0 && (Zt = "&"), Et = Zt, Pt = Qt, $t = new RegExp("\\".concat(Pt, "\\b"), "g");
    var Yt = Kt.replace(xe$1, ""), Jt = compile$1(Xt || Qt ? "".concat(Xt, " ").concat(Qt, " { ").concat(Yt, " }") : Yt);
    Vt.namespace && (Jt = Ve$1(Jt, Vt.namespace));
    var er = [];
    return serialize$1(Jt, middleware(Gt.concat(rulesheet(function(tr) {
      return er.push(tr);
    })))), er;
  };
  return qt.hash = Ht.length ? Ht.reduce(function(Kt, Qt) {
    return Qt.name || he$1(15), M$1(Kt, Qt.name);
  }, F$2).toString() : "", qt;
}
var Me$1 = new ke$1(), ze$1 = Fe$1(), $e$1 = React__default.createContext({ shouldForwardProp: void 0, styleSheet: Me$1, stylis: ze$1 });
$e$1.Consumer;
React__default.createContext(void 0);
function Ge$1() {
  return useContext($e$1);
}
var We$1 = function() {
  function _t(Et, Pt) {
    var $t = this;
    this.inject = function(Mt, Bt) {
      Bt === void 0 && (Bt = ze$1);
      var Vt = $t.name + Bt.hash;
      Mt.hasNameForId($t.id, Vt) || Mt.insertRules($t.id, Vt, Bt($t.rules, Vt, "@keyframes"));
    }, this.name = Et, this.id = "sc-keyframes-".concat(Et), this.rules = Pt, ue$1(this, function() {
      throw he$1(12, String($t.name));
    });
  }
  return _t.prototype.getName = function(Et) {
    return Et === void 0 && (Et = ze$1), this.name + Et.hash;
  }, _t;
}(), qe$1 = function(_t) {
  return _t >= "A" && _t <= "Z";
};
function He$1(_t) {
  for (var Et = "", Pt = 0; Pt < _t.length; Pt++) {
    var $t = _t[Pt];
    if (Pt === 1 && $t === "-" && _t[0] === "-")
      return _t;
    qe$1($t) ? Et += "-" + $t.toLowerCase() : Et += $t;
  }
  return Et.startsWith("ms-") ? "-" + Et : Et;
}
var Ue$1 = function(_t) {
  return _t == null || _t === !1 || _t === "";
}, Je$1 = function(_t) {
  var Et, Pt, $t = [];
  for (var Mt in _t) {
    var Bt = _t[Mt];
    _t.hasOwnProperty(Mt) && !Ue$1(Bt) && (Array.isArray(Bt) && Bt.isCss || re$1(Bt) ? $t.push("".concat(He$1(Mt), ":"), Bt, ";") : ce$1(Bt) ? $t.push.apply($t, __spreadArray(__spreadArray(["".concat(Mt, " {")], Je$1(Bt), !1), ["}"], !1)) : $t.push("".concat(He$1(Mt), ": ").concat((Et = Mt, (Pt = Bt) == null || typeof Pt == "boolean" || Pt === "" ? "" : typeof Pt != "number" || Pt === 0 || Et in unitlessKeys$1 || Et.startsWith("--") ? String(Pt).trim() : "".concat(Pt, "px")), ";")));
  }
  return $t;
};
function Xe$1(_t, Et, Pt, $t) {
  if (Ue$1(_t))
    return [];
  if (se$2(_t))
    return [".".concat(_t.styledComponentId)];
  if (re$1(_t)) {
    if (!re$1(Bt = _t) || Bt.prototype && Bt.prototype.isReactComponent || !Et)
      return [_t];
    var Mt = _t(Et);
    return browser$1.env.NODE_ENV === "production" || typeof Mt != "object" || Array.isArray(Mt) || Mt instanceof We$1 || ce$1(Mt) || Mt === null || console.error("".concat(B$1(_t), " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.")), Xe$1(Mt, Et, Pt, $t);
  }
  var Bt;
  return _t instanceof We$1 ? Pt ? (_t.inject(Pt, $t), [_t.getName($t)]) : [_t] : ce$1(_t) ? Je$1(_t) : Array.isArray(_t) ? Array.prototype.concat.apply(_$1, _t.map(function(Vt) {
    return Xe$1(Vt, Et, Pt, $t);
  })) : [_t.toString()];
}
function Ze$1(_t) {
  for (var Et = 0; Et < _t.length; Et += 1) {
    var Pt = _t[Et];
    if (re$1(Pt) && !se$2(Pt))
      return !1;
  }
  return !0;
}
var Ke$1 = z$1(v$3), Qe$1 = function() {
  function _t(Et, Pt, $t) {
    this.rules = Et, this.staticRulesId = "", this.isStatic = browser$1.env.NODE_ENV === "production" && ($t === void 0 || $t.isStatic) && Ze$1(Et), this.componentId = Pt, this.baseHash = M$1(Ke$1, Pt), this.baseStyle = $t, ke$1.registerId(Pt);
  }
  return _t.prototype.generateAndInjectStyles = function(Et, Pt, $t) {
    var Mt = this.baseStyle ? this.baseStyle.generateAndInjectStyles(Et, Pt, $t) : "";
    if (this.isStatic && !$t.hash)
      if (this.staticRulesId && Pt.hasNameForId(this.componentId, this.staticRulesId))
        Mt = ie$2(Mt, this.staticRulesId);
      else {
        var Bt = ae$1(Xe$1(this.rules, Et, Pt, $t)), Vt = x$2(M$1(this.baseHash, Bt) >>> 0);
        if (!Pt.hasNameForId(this.componentId, Vt)) {
          var zt = $t(Bt, ".".concat(Vt), void 0, this.componentId);
          Pt.insertRules(this.componentId, Vt, zt);
        }
        Mt = ie$2(Mt, Vt), this.staticRulesId = Vt;
      }
    else {
      for (var Ht = M$1(this.baseHash, $t.hash), Wt = "", Gt = 0; Gt < this.rules.length; Gt++) {
        var qt = this.rules[Gt];
        if (typeof qt == "string")
          Wt += qt, browser$1.env.NODE_ENV !== "production" && (Ht = M$1(Ht, qt));
        else if (qt) {
          var Kt = ae$1(Xe$1(qt, Et, Pt, $t));
          Ht = M$1(Ht, Kt + Gt), Wt += Kt;
        }
      }
      if (Wt) {
        var Qt = x$2(Ht >>> 0);
        Pt.hasNameForId(this.componentId, Qt) || Pt.insertRules(this.componentId, Qt, $t(Wt, ".".concat(Qt), void 0, this.componentId)), Mt = ie$2(Mt, Qt);
      }
    }
    return Mt;
  }, _t;
}(), et$1 = React__default.createContext(void 0);
et$1.Consumer;
function ot$1(_t) {
  var Et = React__default.useContext(et$1), Pt = useMemo$1(function() {
    return function($t, Mt) {
      if (!$t)
        throw he$1(14);
      if (re$1($t)) {
        var Bt = $t(Mt);
        if (browser$1.env.NODE_ENV !== "production" && (Bt === null || Array.isArray(Bt) || typeof Bt != "object"))
          throw he$1(7);
        return Bt;
      }
      if (Array.isArray($t) || typeof $t != "object")
        throw he$1(8);
      return Mt ? __assign$1(__assign$1({}, Mt), $t) : $t;
    }(_t.theme, Et);
  }, [_t.theme, Et]);
  return _t.children ? React__default.createElement(et$1.Provider, { value: Pt }, _t.children) : null;
}
var rt$1 = {}, st$1 = /* @__PURE__ */ new Set();
function it$2(_t, Et, Pt) {
  var $t = se$2(_t), Mt = _t, Bt = !L$1(_t), Vt = Et.attrs, zt = Vt === void 0 ? _$1 : Vt, Ht = Et.componentId, Wt = Ht === void 0 ? function(nr, rr) {
    var ir = typeof nr != "string" ? "sc" : R$1(nr);
    rt$1[ir] = (rt$1[ir] || 0) + 1;
    var ar = "".concat(ir, "-").concat($$1(v$3 + ir + rt$1[ir]));
    return rr ? "".concat(rr, "-").concat(ar) : ar;
  }(Et.displayName, Et.parentComponentId) : Ht, Gt = Et.displayName, qt = Gt === void 0 ? function(nr) {
    return L$1(nr) ? "styled.".concat(nr) : "Styled(".concat(B$1(nr), ")");
  }(_t) : Gt, Kt = Et.displayName && Et.componentId ? "".concat(R$1(Et.displayName), "-").concat(Et.componentId) : Et.componentId || Wt, Qt = $t && Mt.attrs ? Mt.attrs.concat(zt).filter(Boolean) : zt, Xt = Et.shouldForwardProp;
  if ($t && Mt.shouldForwardProp) {
    var Zt = Mt.shouldForwardProp;
    if (Et.shouldForwardProp) {
      var Yt = Et.shouldForwardProp;
      Xt = function(nr, rr) {
        return Zt(nr, rr) && Yt(nr, rr);
      };
    } else
      Xt = Zt;
  }
  var Jt = new Qe$1(Pt, Kt, $t ? Mt.componentStyle : void 0);
  function er(nr, rr) {
    return function(ir, ar, or) {
      var sr = ir.attrs, lr = ir.componentStyle, cr = ir.defaultProps, hr = ir.foldedComponentIds, pr = ir.styledComponentId, mr = ir.target, Er = React__default.useContext(et$1), _r = Ge$1(), yr = ir.shouldForwardProp || _r.shouldForwardProp;
      browser$1.env.NODE_ENV !== "production" && useDebugValue(pr);
      var ur = I$2(ar, Er, cr) || C$2, vr = function(kr, Ir, Ar) {
        for (var Mr, Fr = __assign$1(__assign$1({}, Ir), { className: void 0, theme: Ar }), Dr = 0; Dr < kr.length; Dr += 1) {
          var zr = re$1(Mr = kr[Dr]) ? Mr(Fr) : Mr;
          for (var Tr in zr)
            Fr[Tr] = Tr === "className" ? ie$2(Fr[Tr], zr[Tr]) : Tr === "style" ? __assign$1(__assign$1({}, Fr[Tr]), zr[Tr]) : zr[Tr];
        }
        return Ir.className && (Fr.className = ie$2(Fr.className, Ir.className)), Fr;
      }(sr, ar, ur), dr = vr.as || mr, br = {};
      for (var Cr in vr)
        vr[Cr] === void 0 || Cr[0] === "$" || Cr === "as" || Cr === "theme" && vr.theme === ur || (Cr === "forwardedAs" ? br.as = vr.forwardedAs : yr && !yr(Cr, dr) || (br[Cr] = vr[Cr], yr || browser$1.env.NODE_ENV !== "development" || isPropValid(Cr) || st$1.has(Cr) || !A$1.has(dr) || (st$1.add(Cr), console.warn('styled-components: it looks like an unknown prop "'.concat(Cr, '" is being sent through to the DOM, which will likely trigger a React console error. If you would like automatic filtering of unknown props, you can opt-into that behavior via `<StyleSheetManager shouldForwardProp={...}>` (connect an API like `@emotion/is-prop-valid`) or consider using transient props (`$` prefix for automatic filtering.)')))));
      var Pr = function(kr, Ir) {
        var Ar = Ge$1(), Mr = kr.generateAndInjectStyles(Ir, Ar.styleSheet, Ar.stylis);
        return browser$1.env.NODE_ENV !== "production" && useDebugValue(Mr), Mr;
      }(lr, vr);
      browser$1.env.NODE_ENV !== "production" && ir.warnTooManyClasses && ir.warnTooManyClasses(Pr);
      var xr = ie$2(hr, pr);
      return Pr && (xr += " " + Pr), vr.className && (xr += " " + vr.className), br[L$1(dr) && !A$1.has(dr) ? "class" : "className"] = xr, br.ref = or, createElement(dr, br);
    }(tr, nr, rr);
  }
  er.displayName = qt;
  var tr = React__default.forwardRef(er);
  return tr.attrs = Qt, tr.componentStyle = Jt, tr.displayName = qt, tr.shouldForwardProp = Xt, tr.foldedComponentIds = $t ? ie$2(Mt.foldedComponentIds, Mt.styledComponentId) : "", tr.styledComponentId = Kt, tr.target = $t ? Mt.target : _t, Object.defineProperty(tr, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(nr) {
    this._foldedDefaultProps = $t ? function(rr) {
      for (var ir = [], ar = 1; ar < arguments.length; ar++)
        ir[ar - 1] = arguments[ar];
      for (var or = 0, sr = ir; or < sr.length; or++)
        le$1(rr, sr[or], !0);
      return rr;
    }({}, Mt.defaultProps, nr) : nr;
  } }), browser$1.env.NODE_ENV !== "production" && (P$2(qt, Kt), tr.warnTooManyClasses = /* @__PURE__ */ function(nr, rr) {
    var ir = {}, ar = !1;
    return function(or) {
      if (!ar && (ir[or] = !0, Object.keys(ir).length >= 200)) {
        var sr = rr ? ' with the id of "'.concat(rr, '"') : "";
        console.warn("Over ".concat(200, " classes were generated for component ").concat(nr).concat(sr, `.
`) + `Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), ar = !0, ir = {};
      }
    };
  }(qt, Kt)), ue$1(tr, function() {
    return ".".concat(tr.styledComponentId);
  }), Bt && oe$1(tr, _t, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0 }), tr;
}
function at$1(_t, Et) {
  for (var Pt = [_t[0]], $t = 0, Mt = Et.length; $t < Mt; $t += 1)
    Pt.push(Et[$t], _t[$t + 1]);
  return Pt;
}
var ct$1 = function(_t) {
  return Object.assign(_t, { isCss: !0 });
};
function lt$1(_t) {
  for (var Et = [], Pt = 1; Pt < arguments.length; Pt++)
    Et[Pt - 1] = arguments[Pt];
  if (re$1(_t) || ce$1(_t))
    return ct$1(Xe$1(at$1(_$1, __spreadArray([_t], Et, !0))));
  var $t = _t;
  return Et.length === 0 && $t.length === 1 && typeof $t[0] == "string" ? Xe$1($t) : ct$1(Xe$1(at$1($t, Et)));
}
function ut$1(_t, Et, Pt) {
  if (Pt === void 0 && (Pt = C$2), !Et)
    throw he$1(1, Et);
  var $t = function(Mt) {
    for (var Bt = [], Vt = 1; Vt < arguments.length; Vt++)
      Bt[Vt - 1] = arguments[Vt];
    return _t(Et, Pt, lt$1.apply(void 0, __spreadArray([Mt], Bt, !1)));
  };
  return $t.attrs = function(Mt) {
    return ut$1(_t, Et, __assign$1(__assign$1({}, Pt), { attrs: Array.prototype.concat(Pt.attrs, Mt).filter(Boolean) }));
  }, $t.withConfig = function(Mt) {
    return ut$1(_t, Et, __assign$1(__assign$1({}, Pt), Mt));
  }, $t;
}
var pt$1 = function(_t) {
  return ut$1(it$2, _t);
}, dt$1 = pt$1;
A$1.forEach(function(_t) {
  dt$1[_t] = pt$1(_t);
});
browser$1.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://www.styled-components.com/docs/basics#react-native`);
var St = "__sc-".concat(f$2, "__");
browser$1.env.NODE_ENV !== "production" && browser$1.env.NODE_ENV !== "test" && typeof window < "u" && (window[St] || (window[St] = 0), window[St] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.

See https://s-c.sh/2BAXzed for more info.`), window[St] += 1);
const Blue = {
  10: "#EAF6FF",
  20: "#C6E6FF",
  30: "#82CFFF",
  40: "#31B4F2",
  50: "#0092E4",
  60: "#0071CD",
  70: "#005693",
  80: "#003B69",
  90: "#002747",
  100: "#00172D"
}, Green = {
  10: "#DFFBE8",
  20: "#C3EAD1",
  30: "#90D6AA",
  40: "#5EBB7F",
  50: "#19A04B",
  60: "#14803C",
  70: "#0C612C",
  80: "#06431C",
  90: "#032D10",
  100: "#011B07"
}, Red = {
  10: "#FFF1F1",
  20: "#FFD9D9",
  30: "#FFB3B3",
  40: "#F98989",
  50: "#EB4B4B",
  60: "#CF3537",
  70: "#9C2628",
  80: "#70191A",
  90: "#4C0E0F",
  100: "#300606"
}, Neutral = {
  0: "#FFFFFF",
  10: "#F3F4F6",
  20: "#DFE2E7",
  30: "#C2C7D0",
  40: "#A3A9B9",
  50: "#868CA2",
  60: "#696F88",
  70: "#4D5165",
  80: "#363948",
  90: "#232630",
  100: "#14151C"
}, BorderRadius = {
  Big: 16,
  Medium: 12,
  Default: 8,
  Small: 4,
  XSmall: 2
}, FontSize = {
  Title1: 56,
  Title2: 46,
  Title3: 36,
  Title4: 30,
  Title5: 24,
  Title6: 20,
  Body1: 16,
  Body2: 14,
  Subtitle1: 16,
  Subtitle2: 14,
  Button1: 14,
  Button2: 14,
  Caption: 12
}, SyngentaTheme = {
  BorderRadius: {
    Big: `${BorderRadius.Big}px`,
    Medium: `${BorderRadius.Medium}px`,
    Default: `${BorderRadius.Default}px`,
    Small: `${BorderRadius.Small}px`
  },
  FontSize: {
    Title1: `${FontSize.Title1}px`,
    Title2: `${FontSize.Title2}px`,
    Title3: `${FontSize.Title3}px`,
    Title4: `${FontSize.Title4}px`,
    Title5: `${FontSize.Title5}px`,
    Title6: `${FontSize.Title6}px`,
    Body1: `${FontSize.Body1}px`,
    Body2: `${FontSize.Body2}px`,
    Subtitle1: `${FontSize.Subtitle1}px`,
    Subtitle2: `${FontSize.Subtitle2}px`,
    Button1: `${FontSize.Button1}px`,
    Button2: `${FontSize.Button2}px`,
    Caption: `${FontSize.Caption}px`
  },
  FontWeight: {
    Regular: 400,
    Bold: 600
  }
}, buttonPadding = {
  default: "6px 12px",
  small: "2px 8px",
  large: "10px 16px",
  icon: "2px"
}, disabled = lt$1`
  background-color: ${Neutral[10]};
  border: solid 1px ${Neutral[20]};
  color: ${Neutral[30]};
  cursor: not-allowed;
`, normal = lt$1`
  background-color: ${Neutral[0]};
  border: solid 1px ${Neutral[30]};

  &:hover {
    background-color: ${Neutral[10]};
  }

  &:focus {
    background-color: ${Neutral[20]};
    box-shadow: 0px 0px 0px 3px rgba(0, 146, 228, 0.25);
  }

  &:active {
    background-color: ${Neutral[30]};
  }

  &:disabled {
    ${disabled}
  }
`, primary = lt$1`
  background-color: ${Green[60]};
  color: ${Neutral[0]};
  border: solid 1px ${Green[60]};

  &:hover {
    background-color: ${Green[50]};
  }

  &:focus {
    background-color: ${Green[60]};
    box-shadow: 0px 0px 0px 3px rgba(25, 160, 75, 0.25);
  }

  &:active {
    background-color: ${Green[70]};
  }

  &:disabled {
    ${disabled}
  }
`, danger = lt$1`
  background-color: ${Red[60]};
  color: ${Neutral[0]};
  border: solid 1px ${Red[60]};

  &:hover {
    background-color: ${Red[50]};
  }

  &:focus {
    background-color: ${Red[60]};
    box-shadow: 0px 0px 0px 3px rgba(25, 160, 75, 0.25);
  }

  &:active {
    background-color: ${Red[70]};
  }

  &:disabled {
    ${disabled}
  }
`, icon = lt$1`
  background-color: ${Neutral[0]};
  border: 0;
  padding: 3px;
  line-height: 0;

  &:hover {
    background-color: ${Neutral[10]};
  }

  &:focus {
    background-color: ${Neutral[20]};
  }

  &:active {
    background-color: ${Neutral[30]};
  }
  &:disabled {
    color: ${Neutral[30]};
    background-color: ${Neutral[0]};
    cursor: not-allowed;
  }
`, text = lt$1`
  background-color: ${Neutral[0]};
  border: 0;

  &:hover {
    background-color: ${Neutral[10]};
  }

  &:focus {
    background-color: ${Neutral[20]};
  }

  &:active {
    background-color: ${Neutral[30]};
  }

  &:disabled {
    ${disabled}
  }
`, link = lt$1`
  white-space: nowrap;
  background-color: transparent !important;
  color: ${Blue[60]};
  border: 0;
  padding: 0;
  height: fit-content;
  line-height: inherit;

  &:hover,
  &:focus {
    color: ${Blue[50]};
  }

  &:active {
    color: ${Blue[70]};
  }

  &:disabled {
    ${disabled}
    border: 0;
  }
`, action = lt$1`
  background-color: ${Blue[60]};
  color: ${Neutral[0]};
  border: 0;

  &:hover,
  &:focus {
    background-color: ${Blue[50]};
  }

  &:active {
    background-color: ${Blue[70]};
  }

  &:disabled {
    ${disabled}
    color: ${Neutral[40]};
  }
`, outlineDanger = lt$1`
  background-color: transparent;
  color: ${Red[60]};

  &:hover {
    background-color: ${Red[20]};
  }

  &:focus {
    background-color: ${Red[30]};
    box-shadow: 0px 0px 0px 3px rgba(25, 160, 75, 0.25);
  }
`, ghost = lt$1`
  background-color: transparent;
  color: ${Neutral[0]};
  border: 1px solid ${Neutral[0]};
  cursor: pointer;

  path {
    fill: ${Neutral[0]};
  }

  &:hover {
    background-color: ${Neutral[70]};
  }

  &:focus {
    background-color: ${Neutral[20]};
    box-shadow: 0px 0px 0px 3px rgba(25, 160, 75, 0.25);
  }
`, outlineButtons = {
  danger: outlineDanger
}, buttonStyles = {
  normal,
  primary,
  danger,
  icon,
  text,
  link,
  action,
  ghost
}, loadingStyles = lt$1`
  pointer-events: none;

  .is-loading {
    display: block;
    color: inherit;
    width: 18px;
    height: 18px;
    z-index: 3;
    animation: spin 1s infinite linear;
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;
dt$1.button`
  position: relative;
  padding: ${({
  $size: _t
}) => buttonPadding[_t ?? "default"]};
  width: ${({
  $full: _t,
  $width: Et
}) => _t ? "100%" : Et ?? ""};
  border-radius: ${SyngentaTheme.BorderRadius.Small};
  font-size: ${SyngentaTheme.FontSize.Button2};
  text-align: center;
  display: inline-flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  gap: 4px;

  ${({
  $type: _t
}) => buttonStyles[_t ?? "normal"]}
  ${({
  $outline: _t,
  $type: Et
}) => _t && Et ? outlineButtons[Et] : {}}
  ${({
  $isLoading: _t
}) => _t ? loadingStyles : null};

  &:focus {
    outline: none;
  }
`;
dt$1.div`
  border: solid 1px ${Blue[30]};
  border-radius: ${SyngentaTheme.BorderRadius.Default};
  padding: 12px 20px 0;
  display: flex;
  flex-direction: column;
  gap: ${({
  $isOpen: _t
}) => _t ? "18px" : "12px"};

  & ~ & {
    margin-top: 8px;
  }
`;
dt$1.div`
  position: relative;
  cursor: pointer;

  .icon {
    position: absolute;
    top: calc(50% - 9px);
    right: 0;
    color: ${Neutral[60]};
    transform: rotate(180deg);
    transition: transform 0.4s ease-in-out;
    cursor: pointer;

    ${({
  $isOpen: _t
}) => _t && lt$1`
        transform: rotate(0deg);
      `};
  }
`;
dt$1.div`
  display: grid;
  grid-template-rows: 0fr;
  opacity: 0;
  transition:
    grid-template-rows 0.4s ease-in-out,
    opacity 0.4s ease-in-out;

  ${({
  $isOpen: _t
}) => _t && lt$1`
      grid-template-rows: 1fr;
      opacity: 1;
    `}
`;
dt$1.div`
  overflow: hidden;
`;
dt$1.div`
  h3 {
    margin: 0;
    font-weight: ${SyngentaTheme.FontWeight.Bold};
    font-size: ${SyngentaTheme.FontSize.Body1};
  }

  p {
    margin: 0;
    color: ${Neutral[60]};
    font-size: ${SyngentaTheme.FontSize.Body2};
  }
`;
var InputsEventsEnum = /* @__PURE__ */ ((_t) => (_t.OPEN_DRAWER = "CW-ONBOARDING-OPEN-INPUTS-DRAWER", _t))(InputsEventsEnum || {}), SettingsMenuEventsEnum = /* @__PURE__ */ ((_t) => (_t.CLOSE_MENU = "CW-CLOSE-SETTINGS-MENU", _t))(SettingsMenuEventsEnum || {});
const createAnalyticsHookWithAppAndComponent = (_t) => createAnalyticsHook(async () => {
  const Et = useConfig$1();
  async function Pt() {
    var $t;
    try {
      return ($t = await Et.getAppDetails()) == null ? void 0 : $t.name;
    } catch {
      return Et.getHostAppId();
    }
  }
  return {
    app: await Pt(),
    component: _t
  };
});
function useInitAnalytics() {
  const _t = useConfig$1();
  useEffect(() => {
    initAnalytics({
      clientId: _t.getAnalyticsKey(),
      engagement: !0
    }), _t.addCallbackAfterSetToken(() => {
      _t.getCurrentUser().then((Et) => {
        Et != null && Et.id && setUserId(Et.id), Et != null && Et.job_title && setUserProperties({
          "job title": Et.job_title
        });
      });
    });
  }, [_t]);
}
function e(_t) {
  function Et(Pt, $t) {
    Error.captureStackTrace && Error.captureStackTrace(this, this.constructor), this.message = Pt, this.code = $t;
  }
  return Et.prototype = new Error(), Et.prototype.name = _t, Et.prototype.constructor = Et, Et;
}
const t = e("LaunchDarklyUnexpectedResponseError"), n = e("LaunchDarklyInvalidEnvironmentIdError"), r = e("LaunchDarklyInvalidUserError"), o = e("LaunchDarklyInvalidEventKeyError"), i$1 = e("LaunchDarklyInvalidArgumentError"), a = e("LaunchDarklyFlagFetchError");
for (var s = { LDUnexpectedResponseError: t, LDInvalidEnvironmentIdError: n, LDInvalidUserError: r, LDInvalidEventKeyError: o, LDInvalidArgumentError: i$1, LDInvalidDataError: e("LaunchDarklyInvalidDataError"), LDFlagFetchError: a, LDTimeoutError: e("LaunchDarklyTimeoutError"), isHttpErrorRecoverable: function(_t) {
  return !(_t >= 400 && _t < 500) || _t === 400 || _t === 408 || _t === 429;
} }, c = function(_t) {
  var Et = m$1(_t), Pt = Et[0], $t = Et[1];
  return 3 * (Pt + $t) / 4 - $t;
}, u$1 = function(_t) {
  var Et, Pt, $t = m$1(_t), Mt = $t[0], Bt = $t[1], Vt = new g$1(function(Wt, Gt, qt) {
    return 3 * (Gt + qt) / 4 - qt;
  }(0, Mt, Bt)), zt = 0, Ht = Bt > 0 ? Mt - 4 : Mt;
  for (Pt = 0; Pt < Ht; Pt += 4)
    Et = f$1[_t.charCodeAt(Pt)] << 18 | f$1[_t.charCodeAt(Pt + 1)] << 12 | f$1[_t.charCodeAt(Pt + 2)] << 6 | f$1[_t.charCodeAt(Pt + 3)], Vt[zt++] = Et >> 16 & 255, Vt[zt++] = Et >> 8 & 255, Vt[zt++] = 255 & Et;
  return Bt === 2 && (Et = f$1[_t.charCodeAt(Pt)] << 2 | f$1[_t.charCodeAt(Pt + 1)] >> 4, Vt[zt++] = 255 & Et), Bt === 1 && (Et = f$1[_t.charCodeAt(Pt)] << 10 | f$1[_t.charCodeAt(Pt + 1)] << 4 | f$1[_t.charCodeAt(Pt + 2)] >> 2, Vt[zt++] = Et >> 8 & 255, Vt[zt++] = 255 & Et), Vt;
}, l$1 = function(_t) {
  for (var Et, Pt = _t.length, $t = Pt % 3, Mt = [], Bt = 16383, Vt = 0, zt = Pt - $t; Vt < zt; Vt += Bt)
    Mt.push(h$2(_t, Vt, Vt + Bt > zt ? zt : Vt + Bt));
  return $t === 1 ? (Et = _t[Pt - 1], Mt.push(d$1[Et >> 2] + d$1[Et << 4 & 63] + "==")) : $t === 2 && (Et = (_t[Pt - 2] << 8) + _t[Pt - 1], Mt.push(d$1[Et >> 10] + d$1[Et >> 4 & 63] + d$1[Et << 2 & 63] + "=")), Mt.join("");
}, d$1 = [], f$1 = [], g$1 = typeof Uint8Array < "u" ? Uint8Array : Array, v$2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", p$1 = 0; p$1 < 64; ++p$1)
  d$1[p$1] = v$2[p$1], f$1[v$2.charCodeAt(p$1)] = p$1;
function m$1(_t) {
  var Et = _t.length;
  if (Et % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var Pt = _t.indexOf("=");
  return Pt === -1 && (Pt = Et), [Pt, Pt === Et ? 0 : 4 - Pt % 4];
}
function h$2(_t, Et, Pt) {
  for (var $t, Mt, Bt = [], Vt = Et; Vt < Pt; Vt += 3)
    $t = (_t[Vt] << 16 & 16711680) + (_t[Vt + 1] << 8 & 65280) + (255 & _t[Vt + 2]), Bt.push(d$1[(Mt = $t) >> 18 & 63] + d$1[Mt >> 12 & 63] + d$1[Mt >> 6 & 63] + d$1[63 & Mt]);
  return Bt.join("");
}
f$1[45] = 62, f$1[95] = 63;
var y$1 = { byteLength: c, toByteArray: u$1, fromByteArray: l$1 }, w$2 = Array.isArray, b$1 = Object.keys, k$1 = Object.prototype.hasOwnProperty, E$1 = function _t(Et, Pt) {
  if (Et === Pt)
    return !0;
  if (Et && Pt && typeof Et == "object" && typeof Pt == "object") {
    var $t, Mt, Bt, Vt = w$2(Et), zt = w$2(Pt);
    if (Vt && zt) {
      if ((Mt = Et.length) != Pt.length)
        return !1;
      for ($t = Mt; $t-- != 0; )
        if (!_t(Et[$t], Pt[$t]))
          return !1;
      return !0;
    }
    if (Vt != zt)
      return !1;
    var Ht = Et instanceof Date, Wt = Pt instanceof Date;
    if (Ht != Wt)
      return !1;
    if (Ht && Wt)
      return Et.getTime() == Pt.getTime();
    var Gt = Et instanceof RegExp, qt = Pt instanceof RegExp;
    if (Gt != qt)
      return !1;
    if (Gt && qt)
      return Et.toString() == Pt.toString();
    var Kt = b$1(Et);
    if ((Mt = Kt.length) !== b$1(Pt).length)
      return !1;
    for ($t = Mt; $t-- != 0; )
      if (!k$1.call(Pt, Kt[$t]))
        return !1;
    for ($t = Mt; $t-- != 0; )
      if (!_t(Et[Bt = Kt[$t]], Pt[Bt]))
        return !1;
    return !0;
  }
  return Et != Et && Pt != Pt;
};
const D$1 = ["key", "ip", "country", "email", "firstName", "lastName", "avatar", "name"];
function x$1(_t) {
  const Et = unescape(encodeURIComponent(_t));
  return y$1.fromByteArray(function(Pt) {
    const $t = [];
    for (let Mt = 0; Mt < Pt.length; Mt++)
      $t.push(Pt.charCodeAt(Mt));
    return $t;
  }(Et));
}
function C$1(_t, Et) {
  return Object.prototype.hasOwnProperty.call(_t, Et);
}
var P$1, S$1 = { appendUrlPath: function(_t, Et) {
  return (_t.endsWith("/") ? _t.substring(0, _t.length - 1) : _t) + (Et.startsWith("/") ? "" : "/") + Et;
}, base64URLEncode: function(_t) {
  return x$1(_t).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}, btoa: x$1, clone: function(_t) {
  return JSON.parse(JSON.stringify(_t));
}, deepEquals: function(_t, Et) {
  return E$1(_t, Et);
}, extend: function(..._t) {
  return _t.reduce((Et, Pt) => ({ ...Et, ...Pt }), {});
}, getLDUserAgentString: function(_t) {
  const Et = _t.version || "?";
  return _t.userAgent + "/" + Et;
}, objectHasOwnProperty: C$1, onNextTick: function(_t) {
  setTimeout(_t, 0);
}, sanitizeContext: function(_t) {
  if (!_t)
    return _t;
  let Et;
  return _t.kind !== null && _t.kind !== void 0 || D$1.forEach((Pt) => {
    const $t = _t[Pt];
    $t !== void 0 && typeof $t != "string" && (Et = Et || { ..._t }, Et[Pt] = String($t));
  }), Et || _t;
}, transformValuesToVersionedValues: function(_t) {
  const Et = {};
  for (const Pt in _t)
    C$1(_t, Pt) && (Et[Pt] = { value: _t[Pt], version: 0 });
  return Et;
}, transformVersionedValuesToValues: function(_t) {
  const Et = {};
  for (const Pt in _t)
    C$1(_t, Pt) && (Et[Pt] = _t[Pt].value);
  return Et;
}, wrapPromiseCallback: function(_t, Et) {
  const Pt = _t.then(($t) => (Et && setTimeout(() => {
    Et(null, $t);
  }, 0), $t), ($t) => {
    if (!Et)
      return Promise.reject($t);
    setTimeout(() => {
      Et($t, null);
    }, 0);
  });
  return Et ? void 0 : Pt;
} }, I$1 = new Uint8Array(16);
function O$1() {
  if (!P$1 && !(P$1 = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto)))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return P$1(I$1);
}
var T = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function L(_t) {
  return typeof _t == "string" && T.test(_t);
}
for (var U, R, A = [], j$1 = 0; j$1 < 256; ++j$1)
  A.push((j$1 + 256).toString(16).substr(1));
function F$1(_t) {
  var Et = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, Pt = (A[_t[Et + 0]] + A[_t[Et + 1]] + A[_t[Et + 2]] + A[_t[Et + 3]] + "-" + A[_t[Et + 4]] + A[_t[Et + 5]] + "-" + A[_t[Et + 6]] + A[_t[Et + 7]] + "-" + A[_t[Et + 8]] + A[_t[Et + 9]] + "-" + A[_t[Et + 10]] + A[_t[Et + 11]] + A[_t[Et + 12]] + A[_t[Et + 13]] + A[_t[Et + 14]] + A[_t[Et + 15]]).toLowerCase();
  if (!L(Pt))
    throw TypeError("Stringified UUID is invalid");
  return Pt;
}
var N = 0, $ = 0;
function V(_t) {
  if (!L(_t))
    throw TypeError("Invalid UUID");
  var Et, Pt = new Uint8Array(16);
  return Pt[0] = (Et = parseInt(_t.slice(0, 8), 16)) >>> 24, Pt[1] = Et >>> 16 & 255, Pt[2] = Et >>> 8 & 255, Pt[3] = 255 & Et, Pt[4] = (Et = parseInt(_t.slice(9, 13), 16)) >>> 8, Pt[5] = 255 & Et, Pt[6] = (Et = parseInt(_t.slice(14, 18), 16)) >>> 8, Pt[7] = 255 & Et, Pt[8] = (Et = parseInt(_t.slice(19, 23), 16)) >>> 8, Pt[9] = 255 & Et, Pt[10] = (Et = parseInt(_t.slice(24, 36), 16)) / 1099511627776 & 255, Pt[11] = Et / 4294967296 & 255, Pt[12] = Et >>> 24 & 255, Pt[13] = Et >>> 16 & 255, Pt[14] = Et >>> 8 & 255, Pt[15] = 255 & Et, Pt;
}
function M(_t, Et, Pt) {
  function $t(Mt, Bt, Vt, zt) {
    if (typeof Mt == "string" && (Mt = function(Gt) {
      Gt = unescape(encodeURIComponent(Gt));
      for (var qt = [], Kt = 0; Kt < Gt.length; ++Kt)
        qt.push(Gt.charCodeAt(Kt));
      return qt;
    }(Mt)), typeof Bt == "string" && (Bt = V(Bt)), Bt.length !== 16)
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    var Ht = new Uint8Array(16 + Mt.length);
    if (Ht.set(Bt), Ht.set(Mt, Bt.length), (Ht = Pt(Ht))[6] = 15 & Ht[6] | Et, Ht[8] = 63 & Ht[8] | 128, Vt) {
      zt = zt || 0;
      for (var Wt = 0; Wt < 16; ++Wt)
        Vt[zt + Wt] = Ht[Wt];
      return Vt;
    }
    return F$1(Ht);
  }
  try {
    $t.name = _t;
  } catch {
  }
  return $t.DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", $t.URL = "6ba7b811-9dad-11d1-80b4-00c04fd430c8", $t;
}
function H(_t) {
  return 14 + (_t + 64 >>> 9 << 4) + 1;
}
function q(_t, Et) {
  var Pt = (65535 & _t) + (65535 & Et);
  return (_t >> 16) + (Et >> 16) + (Pt >> 16) << 16 | 65535 & Pt;
}
function z(_t, Et, Pt, $t, Mt, Bt) {
  return q((Vt = q(q(Et, _t), q($t, Bt))) << (zt = Mt) | Vt >>> 32 - zt, Pt);
  var Vt, zt;
}
function K$1(_t, Et, Pt, $t, Mt, Bt, Vt) {
  return z(Et & Pt | ~Et & $t, _t, Et, Mt, Bt, Vt);
}
function _(_t, Et, Pt, $t, Mt, Bt, Vt) {
  return z(Et & $t | Pt & ~$t, _t, Et, Mt, Bt, Vt);
}
function J(_t, Et, Pt, $t, Mt, Bt, Vt) {
  return z(Et ^ Pt ^ $t, _t, Et, Mt, Bt, Vt);
}
function B(_t, Et, Pt, $t, Mt, Bt, Vt) {
  return z(Pt ^ (Et | ~$t), _t, Et, Mt, Bt, Vt);
}
var G = M("v3", 48, function(_t) {
  if (typeof _t == "string") {
    var Et = unescape(encodeURIComponent(_t));
    _t = new Uint8Array(Et.length);
    for (var Pt = 0; Pt < Et.length; ++Pt)
      _t[Pt] = Et.charCodeAt(Pt);
  }
  return function($t) {
    for (var Mt = [], Bt = 32 * $t.length, Vt = "0123456789abcdef", zt = 0; zt < Bt; zt += 8) {
      var Ht = $t[zt >> 5] >>> zt % 32 & 255, Wt = parseInt(Vt.charAt(Ht >>> 4 & 15) + Vt.charAt(15 & Ht), 16);
      Mt.push(Wt);
    }
    return Mt;
  }(function($t, Mt) {
    $t[Mt >> 5] |= 128 << Mt % 32, $t[H(Mt) - 1] = Mt;
    for (var Bt = 1732584193, Vt = -271733879, zt = -1732584194, Ht = 271733878, Wt = 0; Wt < $t.length; Wt += 16) {
      var Gt = Bt, qt = Vt, Kt = zt, Qt = Ht;
      Bt = K$1(Bt, Vt, zt, Ht, $t[Wt], 7, -680876936), Ht = K$1(Ht, Bt, Vt, zt, $t[Wt + 1], 12, -389564586), zt = K$1(zt, Ht, Bt, Vt, $t[Wt + 2], 17, 606105819), Vt = K$1(Vt, zt, Ht, Bt, $t[Wt + 3], 22, -1044525330), Bt = K$1(Bt, Vt, zt, Ht, $t[Wt + 4], 7, -176418897), Ht = K$1(Ht, Bt, Vt, zt, $t[Wt + 5], 12, 1200080426), zt = K$1(zt, Ht, Bt, Vt, $t[Wt + 6], 17, -1473231341), Vt = K$1(Vt, zt, Ht, Bt, $t[Wt + 7], 22, -45705983), Bt = K$1(Bt, Vt, zt, Ht, $t[Wt + 8], 7, 1770035416), Ht = K$1(Ht, Bt, Vt, zt, $t[Wt + 9], 12, -1958414417), zt = K$1(zt, Ht, Bt, Vt, $t[Wt + 10], 17, -42063), Vt = K$1(Vt, zt, Ht, Bt, $t[Wt + 11], 22, -1990404162), Bt = K$1(Bt, Vt, zt, Ht, $t[Wt + 12], 7, 1804603682), Ht = K$1(Ht, Bt, Vt, zt, $t[Wt + 13], 12, -40341101), zt = K$1(zt, Ht, Bt, Vt, $t[Wt + 14], 17, -1502002290), Bt = _(Bt, Vt = K$1(Vt, zt, Ht, Bt, $t[Wt + 15], 22, 1236535329), zt, Ht, $t[Wt + 1], 5, -165796510), Ht = _(Ht, Bt, Vt, zt, $t[Wt + 6], 9, -1069501632), zt = _(zt, Ht, Bt, Vt, $t[Wt + 11], 14, 643717713), Vt = _(Vt, zt, Ht, Bt, $t[Wt], 20, -373897302), Bt = _(Bt, Vt, zt, Ht, $t[Wt + 5], 5, -701558691), Ht = _(Ht, Bt, Vt, zt, $t[Wt + 10], 9, 38016083), zt = _(zt, Ht, Bt, Vt, $t[Wt + 15], 14, -660478335), Vt = _(Vt, zt, Ht, Bt, $t[Wt + 4], 20, -405537848), Bt = _(Bt, Vt, zt, Ht, $t[Wt + 9], 5, 568446438), Ht = _(Ht, Bt, Vt, zt, $t[Wt + 14], 9, -1019803690), zt = _(zt, Ht, Bt, Vt, $t[Wt + 3], 14, -187363961), Vt = _(Vt, zt, Ht, Bt, $t[Wt + 8], 20, 1163531501), Bt = _(Bt, Vt, zt, Ht, $t[Wt + 13], 5, -1444681467), Ht = _(Ht, Bt, Vt, zt, $t[Wt + 2], 9, -51403784), zt = _(zt, Ht, Bt, Vt, $t[Wt + 7], 14, 1735328473), Bt = J(Bt, Vt = _(Vt, zt, Ht, Bt, $t[Wt + 12], 20, -1926607734), zt, Ht, $t[Wt + 5], 4, -378558), Ht = J(Ht, Bt, Vt, zt, $t[Wt + 8], 11, -2022574463), zt = J(zt, Ht, Bt, Vt, $t[Wt + 11], 16, 1839030562), Vt = J(Vt, zt, Ht, Bt, $t[Wt + 14], 23, -35309556), Bt = J(Bt, Vt, zt, Ht, $t[Wt + 1], 4, -1530992060), Ht = J(Ht, Bt, Vt, zt, $t[Wt + 4], 11, 1272893353), zt = J(zt, Ht, Bt, Vt, $t[Wt + 7], 16, -155497632), Vt = J(Vt, zt, Ht, Bt, $t[Wt + 10], 23, -1094730640), Bt = J(Bt, Vt, zt, Ht, $t[Wt + 13], 4, 681279174), Ht = J(Ht, Bt, Vt, zt, $t[Wt], 11, -358537222), zt = J(zt, Ht, Bt, Vt, $t[Wt + 3], 16, -722521979), Vt = J(Vt, zt, Ht, Bt, $t[Wt + 6], 23, 76029189), Bt = J(Bt, Vt, zt, Ht, $t[Wt + 9], 4, -640364487), Ht = J(Ht, Bt, Vt, zt, $t[Wt + 12], 11, -421815835), zt = J(zt, Ht, Bt, Vt, $t[Wt + 15], 16, 530742520), Bt = B(Bt, Vt = J(Vt, zt, Ht, Bt, $t[Wt + 2], 23, -995338651), zt, Ht, $t[Wt], 6, -198630844), Ht = B(Ht, Bt, Vt, zt, $t[Wt + 7], 10, 1126891415), zt = B(zt, Ht, Bt, Vt, $t[Wt + 14], 15, -1416354905), Vt = B(Vt, zt, Ht, Bt, $t[Wt + 5], 21, -57434055), Bt = B(Bt, Vt, zt, Ht, $t[Wt + 12], 6, 1700485571), Ht = B(Ht, Bt, Vt, zt, $t[Wt + 3], 10, -1894986606), zt = B(zt, Ht, Bt, Vt, $t[Wt + 10], 15, -1051523), Vt = B(Vt, zt, Ht, Bt, $t[Wt + 1], 21, -2054922799), Bt = B(Bt, Vt, zt, Ht, $t[Wt + 8], 6, 1873313359), Ht = B(Ht, Bt, Vt, zt, $t[Wt + 15], 10, -30611744), zt = B(zt, Ht, Bt, Vt, $t[Wt + 6], 15, -1560198380), Vt = B(Vt, zt, Ht, Bt, $t[Wt + 13], 21, 1309151649), Bt = B(Bt, Vt, zt, Ht, $t[Wt + 4], 6, -145523070), Ht = B(Ht, Bt, Vt, zt, $t[Wt + 11], 10, -1120210379), zt = B(zt, Ht, Bt, Vt, $t[Wt + 2], 15, 718787259), Vt = B(Vt, zt, Ht, Bt, $t[Wt + 9], 21, -343485551), Bt = q(Bt, Gt), Vt = q(Vt, qt), zt = q(zt, Kt), Ht = q(Ht, Qt);
    }
    return [Bt, Vt, zt, Ht];
  }(function($t) {
    if ($t.length === 0)
      return [];
    for (var Mt = 8 * $t.length, Bt = new Uint32Array(H(Mt)), Vt = 0; Vt < Mt; Vt += 8)
      Bt[Vt >> 5] |= (255 & $t[Vt / 8]) << Vt % 32;
    return Bt;
  }(_t), 8 * _t.length));
}), W = G;
function X(_t, Et, Pt, $t) {
  switch (_t) {
    case 0:
      return Et & Pt ^ ~Et & $t;
    case 1:
    case 3:
      return Et ^ Pt ^ $t;
    case 2:
      return Et & Pt ^ Et & $t ^ Pt & $t;
  }
}
function Q(_t, Et) {
  return _t << Et | _t >>> 32 - Et;
}
var Y = M("v5", 80, function(_t) {
  var Et = [1518500249, 1859775393, 2400959708, 3395469782], Pt = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof _t == "string") {
    var $t = unescape(encodeURIComponent(_t));
    _t = [];
    for (var Mt = 0; Mt < $t.length; ++Mt)
      _t.push($t.charCodeAt(Mt));
  } else
    Array.isArray(_t) || (_t = Array.prototype.slice.call(_t));
  _t.push(128);
  for (var Bt = _t.length / 4 + 2, Vt = Math.ceil(Bt / 16), zt = new Array(Vt), Ht = 0; Ht < Vt; ++Ht) {
    for (var Wt = new Uint32Array(16), Gt = 0; Gt < 16; ++Gt)
      Wt[Gt] = _t[64 * Ht + 4 * Gt] << 24 | _t[64 * Ht + 4 * Gt + 1] << 16 | _t[64 * Ht + 4 * Gt + 2] << 8 | _t[64 * Ht + 4 * Gt + 3];
    zt[Ht] = Wt;
  }
  zt[Vt - 1][14] = 8 * (_t.length - 1) / Math.pow(2, 32), zt[Vt - 1][14] = Math.floor(zt[Vt - 1][14]), zt[Vt - 1][15] = 8 * (_t.length - 1) & 4294967295;
  for (var qt = 0; qt < Vt; ++qt) {
    for (var Kt = new Uint32Array(80), Qt = 0; Qt < 16; ++Qt)
      Kt[Qt] = zt[qt][Qt];
    for (var Xt = 16; Xt < 80; ++Xt)
      Kt[Xt] = Q(Kt[Xt - 3] ^ Kt[Xt - 8] ^ Kt[Xt - 14] ^ Kt[Xt - 16], 1);
    for (var Zt = Pt[0], Yt = Pt[1], Jt = Pt[2], er = Pt[3], tr = Pt[4], nr = 0; nr < 80; ++nr) {
      var rr = Math.floor(nr / 20), ir = Q(Zt, 5) + X(rr, Yt, Jt, er) + tr + Et[rr] + Kt[nr] >>> 0;
      tr = er, er = Jt, Jt = Q(Yt, 30) >>> 0, Yt = Zt, Zt = ir;
    }
    Pt[0] = Pt[0] + Zt >>> 0, Pt[1] = Pt[1] + Yt >>> 0, Pt[2] = Pt[2] + Jt >>> 0, Pt[3] = Pt[3] + er >>> 0, Pt[4] = Pt[4] + tr >>> 0;
  }
  return [Pt[0] >> 24 & 255, Pt[0] >> 16 & 255, Pt[0] >> 8 & 255, 255 & Pt[0], Pt[1] >> 24 & 255, Pt[1] >> 16 & 255, Pt[1] >> 8 & 255, 255 & Pt[1], Pt[2] >> 24 & 255, Pt[2] >> 16 & 255, Pt[2] >> 8 & 255, 255 & Pt[2], Pt[3] >> 24 & 255, Pt[3] >> 16 & 255, Pt[3] >> 8 & 255, 255 & Pt[3], Pt[4] >> 24 & 255, Pt[4] >> 16 & 255, Pt[4] >> 8 & 255, 255 & Pt[4]];
}), Z = Y, ee = Object.freeze({ __proto__: null, v1: function(_t, Et, Pt) {
  var $t = Et && Pt || 0, Mt = Et || new Array(16), Bt = (_t = _t || {}).node || U, Vt = _t.clockseq !== void 0 ? _t.clockseq : R;
  if (Bt == null || Vt == null) {
    var zt = _t.random || (_t.rng || O$1)();
    Bt == null && (Bt = U = [1 | zt[0], zt[1], zt[2], zt[3], zt[4], zt[5]]), Vt == null && (Vt = R = 16383 & (zt[6] << 8 | zt[7]));
  }
  var Ht = _t.msecs !== void 0 ? _t.msecs : Date.now(), Wt = _t.nsecs !== void 0 ? _t.nsecs : $ + 1, Gt = Ht - N + (Wt - $) / 1e4;
  if (Gt < 0 && _t.clockseq === void 0 && (Vt = Vt + 1 & 16383), (Gt < 0 || Ht > N) && _t.nsecs === void 0 && (Wt = 0), Wt >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  N = Ht, $ = Wt, R = Vt;
  var qt = (1e4 * (268435455 & (Ht += 122192928e5)) + Wt) % 4294967296;
  Mt[$t++] = qt >>> 24 & 255, Mt[$t++] = qt >>> 16 & 255, Mt[$t++] = qt >>> 8 & 255, Mt[$t++] = 255 & qt;
  var Kt = Ht / 4294967296 * 1e4 & 268435455;
  Mt[$t++] = Kt >>> 8 & 255, Mt[$t++] = 255 & Kt, Mt[$t++] = Kt >>> 24 & 15 | 16, Mt[$t++] = Kt >>> 16 & 255, Mt[$t++] = Vt >>> 8 | 128, Mt[$t++] = 255 & Vt;
  for (var Qt = 0; Qt < 6; ++Qt)
    Mt[$t + Qt] = Bt[Qt];
  return Et || F$1(Mt);
}, v3: W, v4: function(_t, Et, Pt) {
  var $t = (_t = _t || {}).random || (_t.rng || O$1)();
  if ($t[6] = 15 & $t[6] | 64, $t[8] = 63 & $t[8] | 128, Et) {
    Pt = Pt || 0;
    for (var Mt = 0; Mt < 16; ++Mt)
      Et[Pt + Mt] = $t[Mt];
    return Et;
  }
  return F$1($t);
}, v5: Z, NIL: "00000000-0000-0000-0000-000000000000", version: function(_t) {
  if (!L(_t))
    throw TypeError("Invalid UUID");
  return parseInt(_t.substr(14, 1), 16);
}, validate: L, stringify: F$1, parse: V });
const te = ["debug", "info", "warn", "error", "none"];
var ne = { commonBasicLogger: function(_t, Et) {
  if (_t && _t.destination && typeof _t.destination != "function")
    throw new Error("destination for basicLogger was set to a non-function");
  function Pt(Wt) {
    return function(Gt) {
      console && console[Wt] && console[Wt].call(console, Gt);
    };
  }
  const $t = _t && _t.destination ? [_t.destination, _t.destination, _t.destination, _t.destination] : [Pt("log"), Pt("info"), Pt("warn"), Pt("error")], Mt = !(!_t || !_t.destination), Bt = _t && _t.prefix !== void 0 && _t.prefix !== null ? _t.prefix : "[LaunchDarkly] ";
  let Vt = 1;
  if (_t && _t.level)
    for (let Wt = 0; Wt < te.length; Wt++)
      te[Wt] === _t.level && (Vt = Wt);
  function zt(Wt, Gt, qt) {
    if (qt.length < 1)
      return;
    let Kt;
    const Qt = Mt ? Gt + ": " + Bt : Bt;
    if (qt.length !== 1 && Et) {
      const Xt = [...qt];
      Xt[0] = Qt + Xt[0], Kt = Et(...Xt);
    } else
      Kt = Qt + qt[0];
    try {
      $t[Wt](Kt);
    } catch (Xt) {
      console && console.log && console.log("[LaunchDarkly] Configured logger's " + Gt + " method threw an exception: " + Xt);
    }
  }
  const Ht = {};
  for (let Wt = 0; Wt < te.length; Wt++) {
    const Gt = te[Wt];
    if (Gt !== "none")
      if (Wt < Vt)
        Ht[Gt] = () => {
        };
      else {
        const qt = Wt;
        Ht[Gt] = function() {
          zt(qt, Gt, arguments);
        };
      }
  }
  return Ht;
}, validateLogger: function(_t) {
  te.forEach((Et) => {
    if (Et !== "none" && (!_t[Et] || typeof _t[Et] != "function"))
      throw new Error("Provided logger instance must support logger." + Et + "(...) method");
  });
} };
function re(_t) {
  return _t && _t.message ? _t.message : typeof _t == "string" || _t instanceof String ? _t : JSON.stringify(_t);
}
const oe = " Please see https://docs.launchdarkly.com/sdk/client-side/javascript#initialize-the-client for instructions on SDK initialization.";
var ie$1 = { bootstrapInvalid: function() {
  return "LaunchDarkly bootstrap data is not available because the back end could not read the flags.";
}, bootstrapOldFormat: function() {
  return "LaunchDarkly client was initialized with bootstrap data that did not include flag metadata. Events may not be sent correctly." + oe;
}, clientInitialized: function() {
  return "LaunchDarkly client initialized";
}, clientNotReady: function() {
  return "LaunchDarkly client is not ready";
}, debugEnqueueingEvent: function(_t) {
  return 'enqueueing "' + _t + '" event';
}, debugPostingDiagnosticEvent: function(_t) {
  return "sending diagnostic event (" + _t.kind + ")";
}, debugPostingEvents: function(_t) {
  return "sending " + _t + " events";
}, debugStreamDelete: function(_t) {
  return 'received streaming deletion for flag "' + _t + '"';
}, debugStreamDeleteIgnored: function(_t) {
  return 'received streaming deletion for flag "' + _t + '" but ignored due to version check';
}, debugStreamPatch: function(_t) {
  return 'received streaming update for flag "' + _t + '"';
}, debugStreamPatchIgnored: function(_t) {
  return 'received streaming update for flag "' + _t + '" but ignored due to version check';
}, debugStreamPing: function() {
  return "received ping message from stream";
}, debugPolling: function(_t) {
  return "polling for feature flags at " + _t;
}, debugStreamPut: function() {
  return "received streaming update for all flags";
}, deprecated: function(_t, Et) {
  return Et ? '"' + _t + '" is deprecated, please use "' + Et + '"' : '"' + _t + '" is deprecated';
}, environmentNotFound: function() {
  return "Environment not found. Double check that you specified a valid environment/client-side ID." + oe;
}, environmentNotSpecified: function() {
  return "No environment/client-side ID was specified." + oe;
}, errorFetchingFlags: function(_t) {
  return "Error fetching flag settings: " + re(_t);
}, eventCapacityExceeded: function() {
  return "Exceeded event queue capacity. Increase capacity to avoid dropping events.";
}, eventWithoutContext: function() {
  return "Be sure to call `identify` in the LaunchDarkly client: https://docs.launchdarkly.com/sdk/features/identify#javascript";
}, httpErrorMessage: function(_t, Et, Pt) {
  return "Received error " + _t + (_t === 401 ? " (invalid SDK key)" : "") + " for " + Et + " - " + (s.isHttpErrorRecoverable(_t) ? Pt : "giving up permanently");
}, httpUnavailable: function() {
  return "Cannot make HTTP requests in this environment." + oe;
}, identifyDisabled: function() {
  return "identify() has no effect here; it must be called on the main client instance";
}, inspectorMethodError: (_t, Et) => `an inspector: "${Et}" of type: "${_t}" generated an exception`, invalidContentType: function(_t) {
  return 'Expected application/json content type but got "' + _t + '"';
}, invalidData: function() {
  return "Invalid data received from LaunchDarkly; connection may have been interrupted";
}, invalidInspector: (_t, Et) => `an inspector: "${Et}" of an invalid type (${_t}) was configured`, invalidKey: function() {
  return "Event key must be a string";
}, invalidMetricValue: (_t) => `The track function was called with a non-numeric "metricValue" (${_t}), only numeric metric values are supported.`, invalidContext: function() {
  return "Invalid context specified." + oe;
}, invalidTagValue: (_t) => `Config option "${_t}" must only contain letters, numbers, ., _ or -.`, localStorageUnavailable: function(_t) {
  return "local storage is unavailable: " + re(_t);
}, networkError: (_t) => "network error" + (_t ? " (" + _t + ")" : ""), optionBelowMinimum: (_t, Et, Pt) => 'Config option "' + _t + '" was set to ' + Et + ", changing to minimum value of " + Pt, streamClosing: function() {
  return "Closing stream connection";
}, streamConnecting: function(_t) {
  return "Opening stream connection to " + _t;
}, streamError: function(_t, Et) {
  return "Error on stream connection: " + re(_t) + ", will continue retrying after " + Et + " milliseconds.";
}, tagValueTooLong: (_t) => `Value of "${_t}" was longer than 64 characters and was discarded.`, unknownCustomEventKey: function(_t) {
  return 'Custom event "' + _t + '" does not exist';
}, unknownOption: (_t) => 'Ignoring unknown config option "' + _t + '"', contextNotSpecified: function() {
  return "No context specified." + oe;
}, unrecoverableStreamError: (_t) => `Error on stream connection ${re(_t)}, giving up permanently`, wrongOptionType: (_t, Et, Pt) => 'Config option "' + _t + '" should be of type ' + Et + ", got " + Pt + ", using default value", wrongOptionTypeBoolean: (_t, Et) => 'Config option "' + _t + '" should be a boolean, got ' + Et + ", converting to boolean" };
const { validateLogger: ae } = ne, se$1 = { baseUrl: { default: "https://app.launchdarkly.com" }, streamUrl: { default: "https://clientstream.launchdarkly.com" }, eventsUrl: { default: "https://events.launchdarkly.com" }, sendEvents: { default: !0 }, streaming: { type: "boolean" }, sendLDHeaders: { default: !0 }, requestHeaderTransform: { type: "function" }, sendEventsOnlyForVariation: { default: !1 }, useReport: { default: !1 }, evaluationReasons: { default: !1 }, eventCapacity: { default: 100, minimum: 1 }, flushInterval: { default: 2e3, minimum: 2e3 }, samplingInterval: { default: 0, minimum: 0 }, streamReconnectDelay: { default: 1e3, minimum: 0 }, allAttributesPrivate: { default: !1 }, privateAttributes: { default: [] }, bootstrap: { type: "string|object" }, diagnosticRecordingInterval: { default: 9e5, minimum: 2e3 }, diagnosticOptOut: { default: !1 }, wrapperName: { type: "string" }, wrapperVersion: { type: "string" }, stateProvider: { type: "object" }, application: { validator: function(_t, Et, Pt) {
  const $t = {};
  return Et.id && ($t.id = le(`${_t}.id`, Et.id, Pt)), Et.version && ($t.version = le(`${_t}.version`, Et.version, Pt)), $t;
} }, inspectors: { default: [] } }, ce = /^(\w|\.|-)+$/;
function ue(_t) {
  return _t && _t.replace(/\/+$/, "");
}
function le(_t, Et, Pt) {
  if (typeof Et == "string" && Et.match(ce)) {
    if (!(Et.length > 64))
      return Et;
    Pt.warn(ie$1.tagValueTooLong(_t));
  } else
    Pt.warn(ie$1.invalidTagValue(_t));
}
var de$1 = { baseOptionDefs: se$1, validate: function(_t, Et, Pt, $t) {
  const Mt = S$1.extend({ logger: { default: $t } }, se$1, Pt), Bt = {};
  function Vt(Ht) {
    S$1.onNextTick(() => {
      Et && Et.maybeReportError(new s.LDInvalidArgumentError(Ht));
    });
  }
  let zt = S$1.extend({}, _t || {});
  return function(Ht) {
    const Wt = Ht;
    Object.keys(Bt).forEach((Gt) => {
      if (Wt[Gt] !== void 0) {
        const qt = Bt[Gt];
        $t && $t.warn(ie$1.deprecated(Gt, qt)), qt && (Wt[qt] === void 0 && (Wt[qt] = Wt[Gt]), delete Wt[Gt]);
      }
    });
  }(zt), zt = function(Ht) {
    const Wt = S$1.extend({}, Ht);
    return Object.keys(Mt).forEach((Gt) => {
      Wt[Gt] !== void 0 && Wt[Gt] !== null || (Wt[Gt] = Mt[Gt] && Mt[Gt].default);
    }), Wt;
  }(zt), zt = function(Ht) {
    const Wt = S$1.extend({}, Ht), Gt = (qt) => {
      if (qt === null)
        return "any";
      if (qt === void 0)
        return;
      if (Array.isArray(qt))
        return "array";
      const Kt = typeof qt;
      return Kt === "boolean" || Kt === "string" || Kt === "number" || Kt === "function" ? Kt : "object";
    };
    return Object.keys(Ht).forEach((qt) => {
      const Kt = Ht[qt];
      if (Kt != null) {
        const Qt = Mt[qt];
        if (Qt === void 0)
          Vt(ie$1.unknownOption(qt));
        else {
          const Xt = Qt.type || Gt(Qt.default), Zt = Qt.validator;
          if (Zt) {
            const Yt = Zt(qt, Ht[qt], $t);
            Yt !== void 0 ? Wt[qt] = Yt : delete Wt[qt];
          } else if (Xt !== "any") {
            const Yt = Xt.split("|"), Jt = Gt(Kt);
            Yt.indexOf(Jt) < 0 ? Xt === "boolean" ? (Wt[qt] = !!Kt, Vt(ie$1.wrongOptionTypeBoolean(qt, Jt))) : (Vt(ie$1.wrongOptionType(qt, Xt, Jt)), Wt[qt] = Qt.default) : Jt === "number" && Qt.minimum !== void 0 && Kt < Qt.minimum && (Vt(ie$1.optionBelowMinimum(qt, Kt, Qt.minimum)), Wt[qt] = Qt.minimum);
          }
        }
      }
    }), Wt.baseUrl = ue(Wt.baseUrl), Wt.streamUrl = ue(Wt.streamUrl), Wt.eventsUrl = ue(Wt.eventsUrl), Wt;
  }(zt), ae(zt.logger), zt;
}, getTags: function(_t) {
  const Et = {};
  return _t && (_t.application && _t.application.id !== void 0 && _t.application.id !== null && (Et["application-id"] = [_t.application.id]), _t.application && _t.application.version !== void 0 && _t.application.id !== null && (Et["application-version"] = [_t.application.version])), Et;
} };
const { getLDUserAgentString: fe } = S$1;
var ge = { getLDHeaders: function(_t, Et) {
  if (Et && !Et.sendLDHeaders)
    return {};
  const Pt = {};
  Pt[_t.userAgentHeaderName || "User-Agent"] = fe(_t), Et && Et.wrapperName && (Pt["X-LaunchDarkly-Wrapper"] = Et.wrapperVersion ? Et.wrapperName + "/" + Et.wrapperVersion : Et.wrapperName);
  const $t = de$1.getTags(Et), Mt = Object.keys($t);
  return Mt.length && (Pt["x-launchdarkly-tags"] = Mt.sort().map((Bt) => Array.isArray($t[Bt]) ? $t[Bt].sort().map((Vt) => `${Bt}/${Vt}`) : [`${Bt}/${$t[Bt]}`]).reduce((Bt, Vt) => Bt.concat(Vt), []).join(" ")), Pt;
}, transformHeaders: function(_t, Et) {
  return Et && Et.requestHeaderTransform ? Et.requestHeaderTransform({ ..._t }) : _t;
} };
const { v1: ve } = ee, { getLDHeaders: pe, transformHeaders: me } = ge;
var he = function(_t, Et, Pt) {
  const $t = S$1.extend({ "Content-Type": "application/json" }, pe(_t, Pt)), Mt = {};
  return Mt.sendEvents = (Bt, Vt, zt) => {
    if (!_t.httpRequest)
      return Promise.resolve();
    const Ht = JSON.stringify(Bt), Wt = zt ? null : ve();
    return function Gt(qt) {
      const Kt = zt ? $t : S$1.extend({}, $t, { "X-LaunchDarkly-Event-Schema": "4", "X-LaunchDarkly-Payload-ID": Wt });
      return _t.httpRequest("POST", Vt, me(Kt, Pt), Ht).promise.then((Qt) => {
        if (Qt)
          return Qt.status >= 400 && s.isHttpErrorRecoverable(Qt.status) && qt ? Gt(!1) : function(Xt) {
            const Zt = { status: Xt.status }, Yt = Xt.header("date");
            if (Yt) {
              const Jt = Date.parse(Yt);
              Jt && (Zt.serverTime = Jt);
            }
            return Zt;
          }(Qt);
      }).catch(() => qt ? Gt(!1) : Promise.reject());
    }(!0).catch(() => {
    });
  }, Mt;
};
const { commonBasicLogger: ye } = ne;
function we(_t) {
  return typeof _t == "string" && _t !== "kind" && _t.match(/^(\w|\.|-)+$/);
}
function be(_t) {
  return _t.includes("%") || _t.includes(":") ? _t.replace(/%/g, "%25").replace(/:/g, "%3A") : _t;
}
var ke = { checkContext: function(_t, Et) {
  if (_t) {
    if (Et && (_t.kind === void 0 || _t.kind === null))
      return _t.key !== void 0 && _t.key !== null;
    const Pt = _t.key, $t = _t.kind === void 0 ? "user" : _t.kind, Mt = we($t), Bt = $t === "multi" || Pt != null && Pt !== "";
    if ($t === "multi") {
      const Vt = Object.keys(_t).filter((zt) => zt !== "kind");
      return Bt && Vt.every((zt) => we(zt)) && Vt.every((zt) => {
        const Ht = _t[zt].key;
        return Ht != null && Ht !== "";
      });
    }
    return Bt && Mt;
  }
  return !1;
}, getContextKeys: function(_t, Et = ye()) {
  if (!_t)
    return;
  const Pt = {}, { kind: $t, key: Mt } = _t;
  switch ($t) {
    case void 0:
      Pt.user = `${Mt}`;
      break;
    case "multi":
      Object.entries(_t).filter(([Bt]) => Bt !== "kind").forEach(([Bt, Vt]) => {
        Vt && Vt.key && (Pt[Bt] = Vt.key);
      });
      break;
    case null:
      Et.warn(`null is not a valid context kind: ${_t}`);
      break;
    case "":
      Et.warn(`'' is not a valid context kind: ${_t}`);
      break;
    default:
      Pt[$t] = `${Mt}`;
  }
  return Pt;
}, getContextKinds: function(_t) {
  return _t ? _t.kind === null || _t.kind === void 0 ? ["user"] : _t.kind !== "multi" ? [_t.kind] : Object.keys(_t).filter((Et) => Et !== "kind") : [];
}, getCanonicalKey: function(_t) {
  if (_t) {
    if ((_t.kind === void 0 || _t.kind === null || _t.kind === "user") && _t.key)
      return _t.key;
    if (_t.kind !== "multi" && _t.key)
      return `${_t.kind}:${be(_t.key)}`;
    if (_t.kind === "multi")
      return Object.keys(_t).sort().filter((Et) => Et !== "kind").map((Et) => `${Et}:${be(_t[Et].key)}`).join(":");
  }
} };
const { getContextKinds: Ee } = ke;
var De = function() {
  const _t = {};
  let Et = 0, Pt = 0, $t = {}, Mt = {};
  return _t.summarizeEvent = (Bt) => {
    if (Bt.kind === "feature") {
      const Vt = Bt.key + ":" + (Bt.variation !== null && Bt.variation !== void 0 ? Bt.variation : "") + ":" + (Bt.version !== null && Bt.version !== void 0 ? Bt.version : ""), zt = $t[Vt];
      let Ht = Mt[Bt.key];
      Ht || (Ht = /* @__PURE__ */ new Set(), Mt[Bt.key] = Ht), function(Wt) {
        return Wt.context ? Ee(Wt.context) : Wt.contextKeys ? Object.keys(Wt.contextKeys) : [];
      }(Bt).forEach((Wt) => Ht.add(Wt)), zt ? zt.count = zt.count + 1 : $t[Vt] = { count: 1, key: Bt.key, version: Bt.version, variation: Bt.variation, value: Bt.value, default: Bt.default }, (Et === 0 || Bt.creationDate < Et) && (Et = Bt.creationDate), Bt.creationDate > Pt && (Pt = Bt.creationDate);
    }
  }, _t.getSummary = () => {
    const Bt = {};
    let Vt = !0;
    for (const zt of Object.values($t)) {
      let Ht = Bt[zt.key];
      Ht || (Ht = { default: zt.default, counters: [], contextKinds: [...Mt[zt.key]] }, Bt[zt.key] = Ht);
      const Wt = { value: zt.value, count: zt.count };
      zt.variation !== void 0 && zt.variation !== null && (Wt.variation = zt.variation), zt.version !== void 0 && zt.version !== null ? Wt.version = zt.version : Wt.unknown = !0, Ht.counters.push(Wt), Vt = !1;
    }
    return Vt ? null : { startDate: Et, endDate: Pt, features: Bt };
  }, _t.clearSummary = () => {
    Et = 0, Pt = 0, $t = {}, Mt = {};
  }, _t;
};
function xe(_t) {
  return _t.replace(/~/g, "~0").replace(/\//g, "~1");
}
function Ce(_t) {
  return (_t.startsWith("/") ? _t.substring(1) : _t).split("/").map((Et) => Et.indexOf("~") >= 0 ? Et.replace(/~1/g, "/").replace(/~0/g, "~") : Et);
}
function Pe(_t) {
  return !_t.startsWith("/");
}
function Se(_t, Et) {
  const Pt = Pe(_t), $t = Pe(Et);
  if (Pt && $t)
    return _t === Et;
  if (Pt) {
    const Mt = Ce(Et);
    return Mt.length === 1 && _t === Mt[0];
  }
  if ($t) {
    const Mt = Ce(_t);
    return Mt.length === 1 && Et === Mt[0];
  }
  return _t === Et;
}
function Ie(_t) {
  return `/${xe(_t)}`;
}
var Oe = { cloneExcluding: function(_t, Et) {
  const Pt = [], $t = {}, Mt = [];
  for (Pt.push(...Object.keys(_t).map((Bt) => ({ key: Bt, ptr: Ie(Bt), source: _t, parent: $t, visited: [_t] }))); Pt.length; ) {
    const Bt = Pt.pop();
    if (Et.some((Vt) => Se(Vt, Bt.ptr)))
      Mt.push(Bt.ptr);
    else {
      const Vt = Bt.source[Bt.key];
      if (Vt === null)
        Bt.parent[Bt.key] = Vt;
      else if (Array.isArray(Vt))
        Bt.parent[Bt.key] = [...Vt];
      else if (typeof Vt == "object") {
        if (Bt.visited.includes(Vt))
          continue;
        Bt.parent[Bt.key] = {}, Pt.push(...Object.keys(Vt).map((zt) => {
          return { key: zt, ptr: (Ht = Bt.ptr, Wt = xe(zt), `${Ht}/${Wt}`), source: Vt, parent: Bt.parent[Bt.key], visited: [...Bt.visited, Vt] };
          var Ht, Wt;
        }));
      } else
        Bt.parent[Bt.key] = Vt;
    }
  }
  return { cloned: $t, excluded: Mt.sort() };
}, compare: Se, literalToReference: Ie }, Te = function(_t) {
  const Et = {}, Pt = _t.allAttributesPrivate, $t = _t.privateAttributes || [], Mt = ["key", "kind", "_meta", "anonymous"], Bt = ["name", "ip", "firstName", "lastName", "email", "avatar", "country"], Vt = (zt, Ht) => {
    if (typeof zt != "object" || zt === null || Array.isArray(zt))
      return;
    const { cloned: Wt, excluded: Gt } = Oe.cloneExcluding(zt, ((qt, Kt) => (Pt || Kt && qt.anonymous ? Object.keys(qt) : [...$t, ...qt._meta && qt._meta.privateAttributes || []]).filter((Qt) => !Mt.some((Xt) => Oe.compare(Qt, Xt))))(zt, Ht));
    return Wt.key = String(Wt.key), Gt.length && (Wt._meta || (Wt._meta = {}), Wt._meta.redactedAttributes = Gt), Wt._meta && (delete Wt._meta.privateAttributes, Object.keys(Wt._meta).length === 0 && delete Wt._meta), Wt.anonymous !== void 0 && (Wt.anonymous = !!Wt.anonymous), Wt;
  };
  return Et.filter = (zt, Ht = !1) => zt.kind === void 0 || zt.kind === null ? Vt(((Wt) => {
    const Gt = { ...Wt.custom || {}, kind: "user", key: Wt.key };
    Wt.anonymous !== void 0 && (Gt.anonymous = !!Wt.anonymous);
    for (const qt of Bt)
      delete Gt[qt], Wt[qt] !== void 0 && Wt[qt] !== null && (Gt[qt] = String(Wt[qt]));
    return Wt.privateAttributeNames !== void 0 && Wt.privateAttributeNames !== null && (Gt._meta = Gt._meta || {}, Gt._meta.privateAttributes = Wt.privateAttributeNames.map((qt) => qt.startsWith("/") ? Oe.literalToReference(qt) : qt)), Gt;
  })(zt), Ht) : zt.kind === "multi" ? ((Wt, Gt) => {
    const qt = { kind: Wt.kind }, Kt = Object.keys(Wt);
    for (const Qt of Kt)
      if (Qt !== "kind") {
        const Xt = Vt(Wt[Qt], Gt);
        Xt && (qt[Qt] = Xt);
      }
    return qt;
  })(zt, Ht) : Vt(zt, Ht), Et;
};
const { getContextKeys: Le } = ke;
var Ue = function(_t, Et, Pt, $t = null, Mt = null, Bt = null) {
  const Vt = {}, zt = Bt || he(_t, Pt, Et), Ht = S$1.appendUrlPath(Et.eventsUrl, "/events/bulk/" + Pt), Wt = De(), Gt = Te(Et), qt = Et.samplingInterval, Kt = Et.eventCapacity, Qt = Et.flushInterval, Xt = Et.logger;
  let Zt, Yt = [], Jt = 0, er = !1, tr = !1;
  function nr() {
    return qt === 0 || Math.floor(Math.random() * qt) === 0;
  }
  function rr(ar) {
    const or = S$1.extend({}, ar);
    return ar.kind === "identify" ? or.context = Gt.filter(ar.context) : ar.kind === "feature" ? or.context = Gt.filter(ar.context, !0) : (or.contextKeys = Le(ar.context, Xt), delete or.context), ar.kind === "feature" && (delete or.trackEvents, delete or.debugEventsUntilDate), or;
  }
  function ir(ar) {
    Yt.length < Kt ? (Yt.push(ar), tr = !1) : (tr || (tr = !0, Xt.warn(ie$1.eventCapacityExceeded())), $t && $t.incrementDroppedEvents());
  }
  return Vt.enqueue = function(ar) {
    if (er)
      return;
    let or = !1, sr = !1;
    var lr;
    if (Wt.summarizeEvent(ar), ar.kind === "feature" ? nr() && (or = !!ar.trackEvents, sr = !!(lr = ar).debugEventsUntilDate && lr.debugEventsUntilDate > Jt && lr.debugEventsUntilDate > (/* @__PURE__ */ new Date()).getTime()) : or = nr(), or && ir(rr(ar)), sr) {
      const cr = S$1.extend({}, ar, { kind: "debug" });
      cr.context = Gt.filter(cr.context), delete cr.trackEvents, delete cr.debugEventsUntilDate, ir(cr);
    }
  }, Vt.flush = function() {
    if (er)
      return Promise.resolve();
    const ar = Yt, or = Wt.getSummary();
    return Wt.clearSummary(), or && (or.kind = "summary", ar.push(or)), $t && $t.setEventsInLastBatch(ar.length), ar.length === 0 ? Promise.resolve() : (Yt = [], Xt.debug(ie$1.debugPostingEvents(ar.length)), zt.sendEvents(ar, Ht).then((sr) => {
      sr && (sr.serverTime && (Jt = sr.serverTime), s.isHttpErrorRecoverable(sr.status) || (er = !0), sr.status >= 400 && S$1.onNextTick(() => {
        Mt.maybeReportError(new s.LDUnexpectedResponseError(ie$1.httpErrorMessage(sr.status, "event posting", "some events were dropped")));
      }));
    }));
  }, Vt.start = function() {
    const ar = () => {
      Vt.flush(), Zt = setTimeout(ar, Qt);
    };
    Zt = setTimeout(ar, Qt);
  }, Vt.stop = function() {
    clearTimeout(Zt);
  }, Vt;
}, Re = function(_t) {
  const Et = {}, Pt = {};
  return Et.on = function($t, Mt, Bt) {
    Pt[$t] = Pt[$t] || [], Pt[$t] = Pt[$t].concat({ handler: Mt, context: Bt });
  }, Et.off = function($t, Mt, Bt) {
    if (Pt[$t])
      for (let Vt = 0; Vt < Pt[$t].length; Vt++)
        Pt[$t][Vt].handler === Mt && Pt[$t][Vt].context === Bt && (Pt[$t] = Pt[$t].slice(0, Vt).concat(Pt[$t].slice(Vt + 1)));
  }, Et.emit = function($t) {
    if (!Pt[$t])
      return;
    const Mt = Pt[$t].slice(0);
    for (let Bt = 0; Bt < Mt.length; Bt++)
      Mt[Bt].handler.apply(Mt[Bt].context, Array.prototype.slice.call(arguments, 1));
  }, Et.getEvents = function() {
    return Object.keys(Pt);
  }, Et.getEventListenerCount = function($t) {
    return Pt[$t] ? Pt[$t].length : 0;
  }, Et.maybeReportError = function($t) {
    $t && (Pt.error ? this.emit("error", $t) : (_t || console).error($t.message));
  }, Et;
};
const Ae = "ready", je = "initialized", Fe = "failed";
var Ne = function(_t) {
  let Et = !1, Pt = !1, $t = null, Mt = null;
  const Bt = new Promise((Vt) => {
    const zt = () => {
      _t.off(Ae, zt), Vt();
    };
    _t.on(Ae, zt);
  }).catch(() => {
  });
  return { getInitializationPromise: () => Mt || (Et ? Promise.resolve() : Pt ? Promise.reject($t) : (Mt = new Promise((Vt, zt) => {
    const Ht = () => {
      _t.off(je, Ht), Vt();
    }, Wt = (Gt) => {
      _t.off(Fe, Wt), zt(Gt);
    };
    _t.on(je, Ht), _t.on(Fe, Wt);
  }), Mt)), getReadyPromise: () => Bt, signalSuccess: () => {
    Et || Pt || (Et = !0, _t.emit(je), _t.emit(Ae));
  }, signalFailure: (Vt) => {
    Et || Pt || (Pt = !0, $t = Vt, _t.emit(Fe, Vt), _t.emit(Ae)), _t.maybeReportError(Vt);
  } };
}, $e = function(_t, Et, Pt, $t) {
  const Mt = {};
  function Bt() {
    let Vt = "";
    const zt = $t.getContext();
    return zt && (Vt = Pt || S$1.btoa(JSON.stringify(zt))), "ld:" + Et + ":" + Vt;
  }
  return Mt.loadFlags = () => _t.get(Bt()).then((Vt) => {
    if (Vt == null)
      return null;
    try {
      let zt = JSON.parse(Vt);
      if (zt) {
        const Ht = zt.$schema;
        Ht === void 0 || Ht < 1 ? zt = S$1.transformValuesToVersionedValues(zt) : delete zt.$schema;
      }
      return zt;
    } catch {
      return Mt.clearFlags().then(() => null);
    }
  }), Mt.saveFlags = (Vt) => {
    const zt = S$1.extend({}, Vt, { $schema: 1 });
    return _t.set(Bt(), JSON.stringify(zt));
  }, Mt.clearFlags = () => _t.clear(Bt()), Mt;
}, Ve = function(_t, Et) {
  const Pt = {};
  let $t = !1;
  const Mt = (Bt) => {
    $t || ($t = !0, Et.warn(ie$1.localStorageUnavailable(Bt)));
  };
  return Pt.isEnabled = () => !!_t, Pt.get = (Bt) => new Promise((Vt) => {
    _t ? _t.get(Bt).then(Vt).catch((zt) => {
      Mt(zt), Vt(void 0);
    }) : Vt(void 0);
  }), Pt.set = (Bt, Vt) => new Promise((zt) => {
    _t ? _t.set(Bt, Vt).then(() => zt(!0)).catch((Ht) => {
      Mt(Ht), zt(!1);
    }) : zt(!1);
  }), Pt.clear = (Bt) => new Promise((Vt) => {
    _t ? _t.clear(Bt).then(() => Vt(!0)).catch((zt) => {
      Mt(zt), Vt(!1);
    }) : Vt(!1);
  }), Pt;
};
const { appendUrlPath: Me, base64URLEncode: He, objectHasOwnProperty: qe } = S$1, { getLDHeaders: ze, transformHeaders: Ke } = ge, { isHttpErrorRecoverable: _e } = s;
var Je = function(_t, Et, Pt, $t) {
  const Mt = Et.streamUrl, Bt = Et.logger, Vt = {}, zt = Me(Mt, "/eval/" + Pt), Ht = Et.useReport, Wt = Et.evaluationReasons, Gt = Et.streamReconnectDelay, qt = ze(_t, Et);
  let Kt, Qt = !1, Xt = null, Zt = null, Yt = null, Jt = null, er = null, tr = 0;
  function nr() {
    const lr = (cr = function() {
      const hr = Gt * Math.pow(2, tr);
      return hr > 3e4 ? 3e4 : hr;
    }(), cr - Math.trunc(0.5 * Math.random() * cr));
    var cr;
    return tr += 1, lr;
  }
  function rr(lr) {
    if (lr.status && typeof lr.status == "number" && !_e(lr.status))
      return or(), Bt.error(ie$1.unrecoverableStreamError(lr)), void (Zt && (clearTimeout(Zt), Zt = null));
    const cr = nr();
    Qt || (Bt.warn(ie$1.streamError(lr, cr)), Qt = !0), sr(!1), or(), ir(cr);
  }
  function ir(lr) {
    Zt || (lr ? Zt = setTimeout(ar, lr) : ar());
  }
  function ar() {
    let lr;
    Zt = null;
    let cr = "";
    const hr = { headers: qt, readTimeoutMillis: 3e5 };
    if (_t.eventSourceFactory) {
      Jt != null && (cr = "h=" + Jt), Ht ? _t.eventSourceAllowsReport ? (lr = zt, hr.method = "REPORT", hr.headers["Content-Type"] = "application/json", hr.body = JSON.stringify(Yt)) : (lr = Me(Mt, "/ping/" + Pt), cr = "") : lr = zt + "/" + He(JSON.stringify(Yt)), hr.headers = Ke(hr.headers, Et), Wt && (cr = cr + (cr ? "&" : "") + "withReasons=true"), lr = lr + (cr ? "?" : "") + cr, or(), Bt.info(ie$1.streamConnecting(lr)), Kt = (/* @__PURE__ */ new Date()).getTime(), Xt = _t.eventSourceFactory(lr, hr);
      for (const pr in er)
        qe(er, pr) && Xt.addEventListener(pr, er[pr]);
      Xt.onerror = rr, Xt.onopen = () => {
        tr = 0;
      };
    }
  }
  function or() {
    Xt && (Bt.info(ie$1.streamClosing()), Xt.close(), Xt = null);
  }
  function sr(lr) {
    Kt && $t && $t.recordStreamInit(Kt, !lr, (/* @__PURE__ */ new Date()).getTime() - Kt), Kt = null;
  }
  return Vt.connect = function(lr, cr, hr) {
    Yt = lr, Jt = cr, er = {};
    for (const pr in hr || {})
      er[pr] = function(mr) {
        Qt = !1, sr(!0), hr[pr] && hr[pr](mr);
      };
    ir();
  }, Vt.disconnect = function() {
    clearTimeout(Zt), Zt = null, or();
  }, Vt.isConnected = function() {
    return !!(Xt && _t.eventSourceIsActive && _t.eventSourceIsActive(Xt));
  }, Vt;
}, Be = function(_t) {
  let Et, Pt, $t, Mt;
  const Bt = { addPromise: (Vt, zt) => {
    Et = Vt, Pt && Pt(), Pt = zt, Vt.then((Ht) => {
      Et === Vt && ($t(Ht), _t && _t());
    }, (Ht) => {
      Et === Vt && (Mt(Ht), _t && _t());
    });
  } };
  return Bt.resultPromise = new Promise((Vt, zt) => {
    $t = Vt, Mt = zt;
  }), Bt;
};
const { transformHeaders: Ge, getLDHeaders: We } = ge, Xe = "application/json";
var Qe = function(_t, Et, Pt) {
  const $t = Et.baseUrl, Mt = Et.useReport, Bt = Et.evaluationReasons, Vt = Et.logger, zt = {}, Ht = {};
  function Wt(Gt, qt) {
    if (!_t.httpRequest)
      return new Promise((Jt, er) => {
        er(new s.LDFlagFetchError(ie$1.httpUnavailable()));
      });
    const Kt = qt ? "REPORT" : "GET", Qt = We(_t, Et);
    qt && (Qt["Content-Type"] = Xe);
    let Xt = Ht[Gt];
    Xt || (Xt = Be(() => {
      delete Ht[Gt];
    }), Ht[Gt] = Xt);
    const Zt = _t.httpRequest(Kt, Gt, Ge(Qt, Et), qt), Yt = Zt.promise.then((Jt) => {
      if (Jt.status === 200) {
        if (Jt.header("content-type") && Jt.header("content-type").substring(0, 16) === Xe)
          return JSON.parse(Jt.body);
        {
          const er = ie$1.invalidContentType(Jt.header("content-type") || "");
          return Promise.reject(new s.LDFlagFetchError(er));
        }
      }
      return Promise.reject(function(er) {
        return er.status === 404 ? new s.LDInvalidEnvironmentIdError(ie$1.environmentNotFound()) : new s.LDFlagFetchError(ie$1.errorFetchingFlags(er.statusText || String(er.status)));
      }(Jt));
    }, (Jt) => Promise.reject(new s.LDFlagFetchError(ie$1.networkError(Jt))));
    return Xt.addPromise(Yt, () => {
      Zt.cancel && Zt.cancel();
    }), Xt.resultPromise;
  }
  return zt.fetchJSON = function(Gt) {
    return Wt(S$1.appendUrlPath($t, Gt), null);
  }, zt.fetchFlagSettings = function(Gt, qt) {
    let Kt, Qt, Xt, Zt = "";
    return Mt ? (Qt = [$t, "/sdk/evalx/", Pt, "/context"].join(""), Xt = JSON.stringify(Gt)) : (Kt = S$1.base64URLEncode(JSON.stringify(Gt)), Qt = [$t, "/sdk/evalx/", Pt, "/contexts/", Kt].join("")), qt && (Zt = "h=" + qt), Bt && (Zt = Zt + (Zt ? "&" : "") + "withReasons=true"), Qt = Qt + (Zt ? "?" : "") + Zt, Vt.debug(ie$1.debugPolling(Qt)), Wt(Qt, Xt);
  }, zt;
}, Ye = function(_t, Et) {
  const Pt = {};
  let $t;
  return Pt.setContext = function(Mt) {
    $t = S$1.sanitizeContext(Mt), $t && Et && Et(S$1.clone($t));
  }, Pt.getContext = function() {
    return $t ? S$1.clone($t) : null;
  }, Pt;
};
const { v1: Ze } = ee, { getContextKinds: et } = ke;
var tt = function(_t) {
  function Et($t) {
    return $t == null || $t === "user" ? "ld:$anonUserId" : `ld:$contextKey:${$t}`;
  }
  function Pt($t, Mt) {
    return Mt.key !== null && Mt.key !== void 0 ? (Mt.key = Mt.key.toString(), Promise.resolve(Mt)) : Mt.anonymous ? function(Bt) {
      return _t.get(Et(Bt));
    }($t).then((Bt) => {
      if (Bt)
        return Mt.key = Bt, Mt;
      {
        const Vt = Ze();
        return Mt.key = Vt, function(zt, Ht) {
          return _t.set(Et(Ht), zt);
        }(Vt, $t).then(() => Mt);
      }
    }) : Promise.reject(new s.LDInvalidUserError(ie$1.invalidContext()));
  }
  this.processContext = ($t) => {
    if (!$t)
      return Promise.reject(new s.LDInvalidUserError(ie$1.contextNotSpecified()));
    const Mt = S$1.clone($t);
    if ($t.kind === "multi") {
      const Bt = et(Mt);
      return Promise.all(Bt.map((Vt) => Pt(Vt, Mt[Vt]))).then(() => Mt);
    }
    return Pt($t.kind, Mt);
  };
};
const { v1: nt } = ee, { baseOptionDefs: rt } = de$1, { appendUrlPath: ot } = S$1;
var it$1 = { DiagnosticId: function(_t) {
  const Et = { diagnosticId: nt() };
  return _t && (Et.sdkKeySuffix = _t.length > 6 ? _t.substring(_t.length - 6) : _t), Et;
}, DiagnosticsAccumulator: function(_t) {
  let Et, Pt, $t, Mt;
  function Bt(Vt) {
    Et = Vt, Pt = 0, $t = 0, Mt = [];
  }
  return Bt(_t), { getProps: () => ({ dataSinceDate: Et, droppedEvents: Pt, eventsInLastBatch: $t, streamInits: Mt }), setProps: (Vt) => {
    Et = Vt.dataSinceDate, Pt = Vt.droppedEvents || 0, $t = Vt.eventsInLastBatch || 0, Mt = Vt.streamInits || [];
  }, incrementDroppedEvents: () => {
    Pt++;
  }, setEventsInLastBatch: (Vt) => {
    $t = Vt;
  }, recordStreamInit: (Vt, zt, Ht) => {
    const Wt = { timestamp: Vt, failed: zt, durationMillis: Ht };
    Mt.push(Wt);
  }, reset: Bt };
}, DiagnosticsManager: function(_t, Et, Pt, $t, Mt, Bt, Vt) {
  const zt = !!_t.diagnosticUseCombinedEvent, Ht = "ld:" + Mt + ":$diagnostics", Wt = ot(Bt.eventsUrl, "/events/diagnostic/" + Mt), Gt = Bt.diagnosticRecordingInterval, qt = Pt;
  let Kt, Qt, Xt = !!Bt.streaming;
  const Zt = {};
  function Yt() {
    return { sdk: tr(), configuration: nr(), platform: _t.diagnosticPlatformData };
  }
  function Jt(rr) {
    Bt.logger && Bt.logger.debug(ie$1.debugPostingDiagnosticEvent(rr)), $t.sendEvents(rr, Wt, !0).then(() => {
    }).catch(() => {
    });
  }
  function er() {
    Jt(function() {
      const rr = (/* @__PURE__ */ new Date()).getTime();
      let ir = { kind: zt ? "diagnostic-combined" : "diagnostic", id: Vt, creationDate: rr, ...qt.getProps() };
      return zt && (ir = { ...ir, ...Yt() }), qt.reset(rr), ir;
    }()), Qt = setTimeout(er, Gt), Kt = (/* @__PURE__ */ new Date()).getTime(), zt && function() {
      if (Et.isEnabled()) {
        const rr = { ...qt.getProps() };
        Et.set(Ht, JSON.stringify(rr));
      }
    }();
  }
  function tr() {
    const rr = { ..._t.diagnosticSdkData };
    return Bt.wrapperName && (rr.wrapperName = Bt.wrapperName), Bt.wrapperVersion && (rr.wrapperVersion = Bt.wrapperVersion), rr;
  }
  function nr() {
    return { customBaseURI: Bt.baseUrl !== rt.baseUrl.default, customStreamURI: Bt.streamUrl !== rt.streamUrl.default, customEventsURI: Bt.eventsUrl !== rt.eventsUrl.default, eventsCapacity: Bt.eventCapacity, eventsFlushIntervalMillis: Bt.flushInterval, reconnectTimeMillis: Bt.streamReconnectDelay, streamingDisabled: !Xt, allAttributesPrivate: !!Bt.allAttributesPrivate, diagnosticRecordingIntervalMillis: Bt.diagnosticRecordingInterval, usingSecureMode: !!Bt.hash, bootstrapMode: !!Bt.bootstrap, fetchGoalsDisabled: !Bt.fetchGoals, sendEventsOnlyForVariation: !!Bt.sendEventsOnlyForVariation };
  }
  return Zt.start = () => {
    zt ? function(rr) {
      if (!Et.isEnabled())
        return rr(!1);
      Et.get(Ht).then((ir) => {
        if (ir)
          try {
            const ar = JSON.parse(ir);
            qt.setProps(ar), Kt = ar.dataSinceDate;
          } catch {
          }
        rr(!0);
      }).catch(() => {
        rr(!1);
      });
    }((rr) => {
      if (rr) {
        const ir = (Kt || 0) + Gt, ar = (/* @__PURE__ */ new Date()).getTime();
        ar >= ir ? er() : Qt = setTimeout(er, ir - ar);
      } else
        Math.floor(4 * Math.random()) === 0 ? er() : Qt = setTimeout(er, Gt);
    }) : (Jt({ kind: "diagnostic-init", id: Vt, creationDate: qt.getProps().dataSinceDate, ...Yt() }), Qt = setTimeout(er, Gt));
  }, Zt.stop = () => {
    Qt && clearTimeout(Qt);
  }, Zt.setStreaming = (rr) => {
    Xt = rr;
  }, Zt;
} }, at = function(_t, Et) {
  let Pt = !1;
  const $t = { type: _t.type, name: _t.name, synchronous: _t.synchronous, method: (...Mt) => {
    try {
      _t.method(...Mt);
    } catch {
      Pt || (Pt = !0, Et.warn(ie$1.inspectorMethodError($t.type, $t.name)));
    }
  } };
  return $t;
};
const { onNextTick: st } = S$1, ct = { flagUsed: "flag-used", flagDetailsChanged: "flag-details-changed", flagDetailChanged: "flag-detail-changed", clientIdentityChanged: "client-identity-changed" };
Object.freeze(ct);
var ut = { InspectorTypes: ct, InspectorManager: function(_t, Et) {
  const Pt = {}, $t = { [ct.flagUsed]: [], [ct.flagDetailsChanged]: [], [ct.flagDetailChanged]: [], [ct.clientIdentityChanged]: [] }, Mt = { [ct.flagUsed]: [], [ct.flagDetailsChanged]: [], [ct.flagDetailChanged]: [], [ct.clientIdentityChanged]: [] }, Bt = _t && _t.map((Vt) => at(Vt, Et));
  return Bt && Bt.forEach((Vt) => {
    Object.prototype.hasOwnProperty.call($t, Vt.type) && !Vt.synchronous ? $t[Vt.type].push(Vt) : Object.prototype.hasOwnProperty.call(Mt, Vt.type) && Vt.synchronous ? Mt[Vt.type].push(Vt) : Et.warn(ie$1.invalidInspector(Vt.type, Vt.name));
  }), Pt.hasListeners = (Vt) => $t[Vt] && $t[Vt].length || Mt[Vt] && Mt[Vt].length, Pt.onFlagUsed = (Vt, zt, Ht) => {
    const Wt = ct.flagUsed;
    Mt[Wt].length && Mt[Wt].forEach((Gt) => Gt.method(Vt, zt, Ht)), $t[Wt].length && st(() => {
      $t[Wt].forEach((Gt) => Gt.method(Vt, zt, Ht));
    });
  }, Pt.onFlags = (Vt) => {
    const zt = ct.flagDetailsChanged;
    Mt[zt].length && Mt[zt].forEach((Ht) => Ht.method(Vt)), $t[zt].length && st(() => {
      $t[zt].forEach((Ht) => Ht.method(Vt));
    });
  }, Pt.onFlagChanged = (Vt, zt) => {
    const Ht = ct.flagDetailChanged;
    Mt[Ht].length && Mt[Ht].forEach((Wt) => Wt.method(Vt, zt)), $t[Ht].length && st(() => {
      $t[Ht].forEach((Wt) => Wt.method(Vt, zt));
    });
  }, Pt.onIdentityChanged = (Vt) => {
    const zt = ct.clientIdentityChanged;
    Mt[zt].length && Mt[zt].forEach((Ht) => Ht.method(Vt)), $t[zt].length && st(() => {
      $t[zt].forEach((Ht) => Ht.method(Vt));
    });
  }, Pt;
} };
const { LDTimeoutError: lt } = s;
var dt = function(_t, Et) {
  return new Promise((Pt, $t) => {
    setTimeout(() => {
      $t(new lt(`${Et} timed out after ${_t} seconds.`));
    }, 1e3 * _t);
  });
};
const { commonBasicLogger: ft } = ne, { checkContext: gt, getContextKeys: vt } = ke, { InspectorTypes: pt, InspectorManager: mt } = ut, ht = "change", yt = "internal-change";
var wt = { initialize: function(_t, Et, Pt, $t, Mt) {
  const Bt = function() {
    return Pt && Pt.logger ? Pt.logger : Mt && Mt.logger && Mt.logger.default || ft("warn");
  }(), Vt = Re(Bt), zt = Ne(Vt), Ht = de$1.validate(Pt, Vt, Mt, Bt), Wt = mt(Ht.inspectors, Bt), Gt = Ht.sendEvents;
  let qt = _t, Kt = Ht.hash;
  const Qt = Ve($t.localStorage, Bt), Xt = he($t, qt, Ht), Zt = Ht.sendEvents && !Ht.diagnosticOptOut, Yt = Zt ? it$1.DiagnosticId(qt) : null, Jt = Zt ? it$1.DiagnosticsAccumulator((/* @__PURE__ */ new Date()).getTime()) : null, er = Zt ? it$1.DiagnosticsManager($t, Qt, Jt, Xt, qt, Ht, Yt) : null, tr = Je($t, Ht, qt, Jt), nr = Ht.eventProcessor || Ue($t, Ht, qt, Jt, Vt, Xt), rr = Qe($t, Ht, qt);
  let ir, ar, or, sr = {}, lr = Ht.streaming, cr = !1, hr = !1, pr = !0;
  const mr = Ht.stateProvider, Er = Ye(null, function(Rr) {
    (function(Or) {
      mr || Or && ur({ kind: "identify", context: Or, creationDate: (/* @__PURE__ */ new Date()).getTime() });
    })(Rr), Wt.hasListeners(pt.clientIdentityChanged) && Wt.onIdentityChanged(Er.getContext());
  }), _r = new tt(Qt), yr = Qt.isEnabled() ? $e(Qt, qt, Kt, Er) : null;
  function ur(Rr) {
    qt && (mr && mr.enqueueEvent && mr.enqueueEvent(Rr) || (Rr.context ? (pr = !1, !Gt || hr || $t.isDoNotTrack() || (Bt.debug(ie$1.debugEnqueueingEvent(Rr.kind)), nr.enqueue(Rr))) : pr && (Bt.warn(ie$1.eventWithoutContext()), pr = !1)));
  }
  function vr(Rr, Or) {
    Wt.hasListeners(pt.flagDetailChanged) && Wt.onFlagChanged(Rr.key, xr(Or));
  }
  function dr() {
    Wt.hasListeners(pt.flagDetailsChanged) && Wt.onFlags(Object.entries(sr).map(([Rr, Or]) => ({ key: Rr, detail: xr(Or) })).reduce((Rr, Or) => (Rr[Or.key] = Or.detail, Rr), {}));
  }
  function br(Rr, Or, Lr, Hr) {
    const Wr = Er.getContext(), Kr = /* @__PURE__ */ new Date(), Ur = { kind: "feature", key: Rr, context: Wr, value: Or ? Or.value : null, variation: Or ? Or.variationIndex : null, default: Lr, creationDate: Kr.getTime() }, Zr = sr[Rr];
    Zr && (Ur.version = Zr.flagVersion ? Zr.flagVersion : Zr.version, Ur.trackEvents = Zr.trackEvents, Ur.debugEventsUntilDate = Zr.debugEventsUntilDate), (Hr || Zr && Zr.trackReason) && Or && (Ur.reason = Or.reason), ur(Ur);
  }
  function Cr(Rr) {
    return gt(Rr, !1) ? Promise.resolve(Rr) : Promise.reject(new s.LDInvalidUserError(ie$1.invalidContext()));
  }
  function Pr(Rr, Or, Lr, Hr, Wr) {
    let Kr;
    if (sr && S$1.objectHasOwnProperty(sr, Rr) && sr[Rr] && !sr[Rr].deleted) {
      const Ur = sr[Rr];
      Kr = xr(Ur), Ur.value !== null && Ur.value !== void 0 || (Kr.value = Or);
    } else
      Kr = { value: Or, variationIndex: null, reason: { kind: "ERROR", errorKind: "FLAG_NOT_FOUND" } };
    return Lr && br(Rr, Kr, Or, Hr), Wr || function(Ur, Zr) {
      Wt.hasListeners(pt.flagUsed) && Wt.onFlagUsed(Ur, Zr, Er.getContext());
    }(Rr, Kr), Kr;
  }
  function xr(Rr) {
    return { value: Rr.value, variationIndex: Rr.variation === void 0 ? null : Rr.variation, reason: Rr.reason || null };
  }
  function kr() {
    if (ar = !0, !Er.getContext())
      return;
    const Rr = (Or) => {
      try {
        return JSON.parse(Or);
      } catch {
        return void Vt.maybeReportError(new s.LDInvalidDataError(ie$1.invalidData()));
      }
    };
    tr.connect(Er.getContext(), Kt, { ping: function() {
      Bt.debug(ie$1.debugStreamPing());
      const Or = Er.getContext();
      rr.fetchFlagSettings(Or, Kt).then((Lr) => {
        S$1.deepEquals(Or, Er.getContext()) && Ar(Lr || {});
      }).catch((Lr) => {
        Vt.maybeReportError(new s.LDFlagFetchError(ie$1.errorFetchingFlags(Lr)));
      });
    }, put: function(Or) {
      const Lr = Rr(Or.data);
      Lr && (Bt.debug(ie$1.debugStreamPut()), Ar(Lr));
    }, patch: function(Or) {
      const Lr = Rr(Or.data);
      if (!Lr)
        return;
      const Hr = sr[Lr.key];
      if (!Hr || !Hr.version || !Lr.version || Hr.version < Lr.version) {
        Bt.debug(ie$1.debugStreamPatch(Lr.key));
        const Wr = {}, Kr = S$1.extend({}, Lr);
        delete Kr.key, sr[Lr.key] = Kr;
        const Ur = xr(Kr);
        Wr[Lr.key] = Hr ? { previous: Hr.value, current: Ur } : { current: Ur }, vr(Lr, Kr), Mr(Wr);
      } else
        Bt.debug(ie$1.debugStreamPatchIgnored(Lr.key));
    }, delete: function(Or) {
      const Lr = Rr(Or.data);
      if (Lr)
        if (!sr[Lr.key] || sr[Lr.key].version < Lr.version) {
          Bt.debug(ie$1.debugStreamDelete(Lr.key));
          const Hr = {};
          sr[Lr.key] && !sr[Lr.key].deleted && (Hr[Lr.key] = { previous: sr[Lr.key].value }), sr[Lr.key] = { version: Lr.version, deleted: !0 }, vr(Lr, sr[Lr.key]), Mr(Hr);
        } else
          Bt.debug(ie$1.debugStreamDeleteIgnored(Lr.key));
    } });
  }
  function Ir() {
    ar && (tr.disconnect(), ar = !1);
  }
  function Ar(Rr) {
    const Or = {};
    if (!Rr)
      return Promise.resolve();
    for (const Lr in sr)
      S$1.objectHasOwnProperty(sr, Lr) && sr[Lr] && (Rr[Lr] && !S$1.deepEquals(Rr[Lr].value, sr[Lr].value) ? Or[Lr] = { previous: sr[Lr].value, current: xr(Rr[Lr]) } : Rr[Lr] && !Rr[Lr].deleted || (Or[Lr] = { previous: sr[Lr].value }));
    for (const Lr in Rr)
      S$1.objectHasOwnProperty(Rr, Lr) && Rr[Lr] && (!sr[Lr] || sr[Lr].deleted) && (Or[Lr] = { current: xr(Rr[Lr]) });
    return sr = { ...Rr }, dr(), Mr(Or).catch(() => {
    });
  }
  function Mr(Rr) {
    const Or = Object.keys(Rr);
    if (Or.length > 0) {
      const Lr = {};
      Or.forEach((Hr) => {
        const Wr = Rr[Hr].current, Kr = Wr ? Wr.value : void 0, Ur = Rr[Hr].previous;
        Vt.emit(ht + ":" + Hr, Kr, Ur), Lr[Hr] = Wr ? { current: Kr, previous: Ur } : { previous: Ur };
      }), Vt.emit(ht, Lr), Vt.emit(yt, sr), Ht.sendEventsOnlyForVariation || mr || Or.forEach((Hr) => {
        br(Hr, Rr[Hr].current);
      });
    }
    return ir && yr ? yr.saveFlags(sr) : Promise.resolve();
  }
  function Fr() {
    const Rr = lr || or && lr === void 0;
    Rr && !ar ? kr() : !Rr && ar && Ir(), er && er.setStreaming(Rr);
  }
  function Dr(Rr) {
    return Rr === ht || Rr.substr(0, 7) === ht + ":";
  }
  if (typeof Ht.bootstrap == "string" && Ht.bootstrap.toUpperCase() === "LOCALSTORAGE" && (yr ? ir = !0 : Bt.warn(ie$1.localStorageUnavailable())), typeof Ht.bootstrap == "object" && (sr = function(Rr) {
    const Or = Object.keys(Rr), Lr = "$flagsState", Hr = "$valid", Wr = Rr[Lr];
    !Wr && Or.length && Bt.warn(ie$1.bootstrapOldFormat()), Rr[Hr] === !1 && Bt.warn(ie$1.bootstrapInvalid());
    const Kr = {};
    return Or.forEach((Ur) => {
      if (Ur !== Lr && Ur !== Hr) {
        let Zr = { value: Rr[Ur] };
        Wr && Wr[Ur] ? Zr = S$1.extend(Zr, Wr[Ur]) : Zr.version = 0, Kr[Ur] = Zr;
      }
    }), Kr;
  }(Ht.bootstrap)), mr) {
    const Rr = mr.getInitialState();
    Rr ? zr(Rr) : mr.on("init", zr), mr.on("update", function(Or) {
      Or.context && Er.setContext(Or.context), Or.flags && Ar(Or.flags);
    });
  } else
    (function() {
      return _t ? _r.processContext(Et).then(Cr).then((Rr) => (Er.setContext(Rr), typeof Ht.bootstrap == "object" ? Tr() : ir ? yr.loadFlags().then((Or) => Or == null ? (sr = {}, rr.fetchFlagSettings(Er.getContext(), Kt).then((Lr) => Ar(Lr || {})).then(Tr).catch((Lr) => {
        Gr(new s.LDFlagFetchError(ie$1.errorFetchingFlags(Lr)));
      })) : (sr = Or, S$1.onNextTick(Tr), rr.fetchFlagSettings(Er.getContext(), Kt).then((Lr) => Ar(Lr)).catch((Lr) => Vt.maybeReportError(Lr)))) : rr.fetchFlagSettings(Er.getContext(), Kt).then((Or) => {
        sr = Or || {}, dr(), Tr();
      }).catch((Or) => {
        sr = {}, Gr(Or);
      }))) : Promise.reject(new s.LDInvalidEnvironmentIdError(ie$1.environmentNotSpecified()));
    })().catch(Gr);
  function zr(Rr) {
    qt = Rr.environment, Er.setContext(Rr.context), sr = { ...Rr.flags }, S$1.onNextTick(Tr);
  }
  function Tr() {
    Bt.info(ie$1.clientInitialized()), cr = !0, Fr(), zt.signalSuccess();
  }
  function Gr(Rr) {
    zt.signalFailure(Rr);
  }
  return { client: { waitForInitialization: function(Rr = void 0) {
    if (Rr != null) {
      if (typeof Rr == "number")
        return function(Or) {
          Or > 5 && Bt.warn("The waitForInitialization function was called with a timeout greater than 5 seconds. We recommend a timeout of 5 seconds or less.");
          const Lr = zt.getInitializationPromise(), Hr = dt(Or, "waitForInitialization");
          return Promise.race([Hr, Lr]).catch((Wr) => {
            throw Wr instanceof s.LDTimeoutError && Bt.error(`waitForInitialization error: ${Wr}`), Wr;
          });
        }(Rr);
      Bt.warn("The waitForInitialization method was provided with a non-numeric timeout.");
    }
    return Bt.warn("The waitForInitialization function was called without a timeout specified. In a future version a default timeout will be applied."), zt.getInitializationPromise();
  }, waitUntilReady: () => zt.getReadyPromise(), identify: function(Rr, Or, Lr) {
    if (hr)
      return S$1.wrapPromiseCallback(Promise.resolve({}), Lr);
    if (mr)
      return Bt.warn(ie$1.identifyDisabled()), S$1.wrapPromiseCallback(Promise.resolve(S$1.transformVersionedValuesToValues(sr)), Lr);
    const Hr = ir && yr ? yr.clearFlags() : Promise.resolve();
    return S$1.wrapPromiseCallback(Hr.then(() => _r.processContext(Rr)).then(Cr).then((Wr) => rr.fetchFlagSettings(Wr, Or).then((Kr) => {
      const Ur = S$1.transformVersionedValuesToValues(Kr);
      return Er.setContext(Wr), Kt = Or, Kr ? Ar(Kr).then(() => Ur) : Ur;
    })).then((Wr) => (ar && kr(), Wr)).catch((Wr) => (Vt.maybeReportError(Wr), Promise.reject(Wr))), Lr);
  }, getContext: function() {
    return Er.getContext();
  }, variation: function(Rr, Or) {
    return Pr(Rr, Or, !0, !1, !1).value;
  }, variationDetail: function(Rr, Or) {
    return Pr(Rr, Or, !0, !0, !1);
  }, track: function(Rr, Or, Lr) {
    if (typeof Rr != "string")
      return void Vt.maybeReportError(new s.LDInvalidEventKeyError(ie$1.unknownCustomEventKey(Rr)));
    Lr !== void 0 && typeof Lr != "number" && Bt.warn(ie$1.invalidMetricValue(typeof Lr)), $t.customEventFilter && !$t.customEventFilter(Rr) && Bt.warn(ie$1.unknownCustomEventKey(Rr));
    const Hr = Er.getContext(), Wr = { kind: "custom", key: Rr, context: Hr, url: $t.getCurrentUrl(), creationDate: (/* @__PURE__ */ new Date()).getTime() };
    Hr && Hr.anonymous && (Wr.contextKind = Hr.anonymous ? "anonymousUser" : "user"), Or != null && (Wr.data = Or), Lr != null && (Wr.metricValue = Lr), ur(Wr);
  }, on: function(Rr, Or, Lr) {
    Dr(Rr) ? (or = !0, cr && Fr(), Vt.on(Rr, Or, Lr)) : Vt.on(...arguments);
  }, off: function(Rr) {
    if (Vt.off(...arguments), Dr(Rr)) {
      let Or = !1;
      Vt.getEvents().forEach((Lr) => {
        Dr(Lr) && Vt.getEventListenerCount(Lr) > 0 && (Or = !0);
      }), Or || (or = !1, ar && lr === void 0 && Ir());
    }
  }, setStreaming: function(Rr) {
    const Or = Rr === null ? void 0 : Rr;
    Or !== lr && (lr = Or, Fr());
  }, flush: function(Rr) {
    return S$1.wrapPromiseCallback(Gt ? nr.flush() : Promise.resolve(), Rr);
  }, allFlags: function() {
    const Rr = {};
    if (!sr)
      return Rr;
    for (const Or in sr)
      S$1.objectHasOwnProperty(sr, Or) && !sr[Or].deleted && (Rr[Or] = Pr(Or, null, !Ht.sendEventsOnlyForVariation, !1, !0).value);
    return Rr;
  }, close: function(Rr) {
    if (hr)
      return S$1.wrapPromiseCallback(Promise.resolve(), Rr);
    const Or = () => {
      hr = !0, sr = {};
    }, Lr = Promise.resolve().then(() => {
      if (Ir(), er && er.stop(), Gt)
        return nr.stop(), nr.flush();
    }).then(Or).catch(Or);
    return S$1.wrapPromiseCallback(Lr, Rr);
  } }, options: Ht, emitter: Vt, ident: Er, logger: Bt, requestor: rr, start: function() {
    Gt && (er && er.start(), nr.start());
  }, enqueueEvent: ur, getFlagsInternal: function() {
    return sr;
  }, getEnvironmentId: () => qt, internalChangeEventName: yt };
}, commonBasicLogger: ft, errors: s, messages: ie$1, utils: S$1, getContextKeys: vt }, bt = wt.initialize, kt = wt.errors;
function Dt(_t, Et, Pt) {
  return (Et = function($t) {
    var Mt = function(Bt, Vt) {
      if (typeof Bt != "object" || !Bt)
        return Bt;
      var zt = Bt[Symbol.toPrimitive];
      if (zt !== void 0) {
        var Ht = zt.call(Bt, Vt || "default");
        if (typeof Ht != "object")
          return Ht;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (Vt === "string" ? String : Number)(Bt);
    }($t, "string");
    return typeof Mt == "symbol" ? Mt : Mt + "";
  }(Et)) in _t ? Object.defineProperty(_t, Et, { value: Pt, enumerable: !0, configurable: !0, writable: !0 }) : _t[Et] = Pt, _t;
}
function xt(_t, Et) {
  var Pt = Object.keys(_t);
  if (Object.getOwnPropertySymbols) {
    var $t = Object.getOwnPropertySymbols(_t);
    Et && ($t = $t.filter(function(Mt) {
      return Object.getOwnPropertyDescriptor(_t, Mt).enumerable;
    })), Pt.push.apply(Pt, $t);
  }
  return Pt;
}
function Ct(_t) {
  for (var Et = 1; Et < arguments.length; Et++) {
    var Pt = arguments[Et] != null ? arguments[Et] : {};
    Et % 2 ? xt(Object(Pt), !0).forEach(function($t) {
      Dt(_t, $t, Pt[$t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(_t, Object.getOwnPropertyDescriptors(Pt)) : xt(Object(Pt)).forEach(function($t) {
      Object.defineProperty(_t, $t, Object.getOwnPropertyDescriptor(Pt, $t));
    });
  }
  return _t;
}
var It = { promise: Promise.resolve({ status: 200, header: function() {
  return null;
}, body: null }) };
function Ot(_t, Et, Pt, $t, Mt) {
  if (Mt && !function() {
    var Wt = window.navigator && window.navigator.userAgent;
    if (Wt) {
      var Gt = Wt.match(/Chrom(e|ium)\/([0-9]+)\./);
      if (Gt)
        return parseInt(Gt[2], 10) < 73;
    }
    return !0;
  }())
    return It;
  var Bt = new window.XMLHttpRequest();
  for (var Vt in Bt.open(_t, Et, !Mt), Pt || {})
    Object.prototype.hasOwnProperty.call(Pt, Vt) && Bt.setRequestHeader(Vt, Pt[Vt]);
  if (Mt) {
    try {
      Bt.send($t);
    } catch {
    }
    return It;
  }
  var zt, Ht = new Promise(function(Wt, Gt) {
    Bt.addEventListener("load", function() {
      zt || Wt({ status: Bt.status, header: function(qt) {
        return Bt.getResponseHeader(qt);
      }, body: Bt.responseText });
    }), Bt.addEventListener("error", function() {
      zt || Gt(new Error());
    }), Bt.send($t);
  });
  return { promise: Ht, cancel: function() {
    zt = !0, Bt.abort();
  } };
}
var Tt = (_t) => {
  if (typeof _t != "string")
    throw new TypeError("Expected a string");
  return _t.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
};
function Lt(_t, Et, Pt, $t) {
  var Mt, Bt, Vt = ((_t.kind === "substring" || _t.kind === "regex") && $t.includes("/") ? Et : Et.replace($t, "")).replace(Pt, "");
  switch (_t.kind) {
    case "exact":
      Bt = Et, Mt = new RegExp("^" + Tt(_t.url) + "/?$");
      break;
    case "canonical":
      Bt = Vt, Mt = new RegExp("^" + Tt(_t.url) + "/?$");
      break;
    case "substring":
      Bt = Vt, Mt = new RegExp(".*" + Tt(_t.substring) + ".*$");
      break;
    case "regex":
      Bt = Vt, Mt = new RegExp(_t.pattern);
      break;
    default:
      return !1;
  }
  return Mt.test(Bt);
}
function Ut(_t, Et) {
  for (var Pt = {}, $t = null, Mt = [], Bt = 0; Bt < _t.length; Bt++)
    for (var Vt = _t[Bt], zt = Vt.urls || [], Ht = 0; Ht < zt.length; Ht++)
      if (Lt(zt[Ht], window.location.href, window.location.search, window.location.hash)) {
        Vt.kind === "pageview" ? Et("pageview", Vt) : (Mt.push(Vt), Et("click_pageview", Vt));
        break;
      }
  return Mt.length > 0 && ($t = function(Wt) {
    for (var Gt = function(Kt, Qt) {
      for (var Xt = [], Zt = 0; Zt < Qt.length; Zt++)
        for (var Yt = Kt.target, Jt = Qt[Zt], er = Jt.selector, tr = document.querySelectorAll(er); Yt && tr.length > 0; ) {
          for (var nr = 0; nr < tr.length; nr++)
            Yt === tr[nr] && Xt.push(Jt);
          Yt = Yt.parentNode;
        }
      return Xt;
    }(Wt, Mt), qt = 0; qt < Gt.length; qt++)
      Et("click", Gt[qt]);
  }, document.addEventListener("click", $t)), Pt.dispose = function() {
    document.removeEventListener("click", $t);
  }, Pt;
}
var Rt = 300;
function At(_t, Et) {
  var Pt, $t;
  function Mt() {
    $t && $t.dispose(), Pt && Pt.length && ($t = Ut(Pt, Bt));
  }
  function Bt(Vt, zt) {
    var Ht = _t.ident.getContext(), Wt = { kind: Vt, key: zt.key, data: null, url: window.location.href, creationDate: (/* @__PURE__ */ new Date()).getTime(), context: Ht };
    return Vt === "click" && (Wt.selector = zt.selector), _t.enqueueEvent(Wt);
  }
  return _t.requestor.fetchJSON("/sdk/goals/" + _t.getEnvironmentId()).then(function(Vt) {
    Vt && Vt.length > 0 && ($t = Ut(Pt = Vt, Bt), function(zt, Ht) {
      var Wt, Gt = window.location.href;
      function qt() {
        (Wt = window.location.href) !== Gt && (Gt = Wt, Ht());
      }
      (function Kt(Qt, Xt) {
        Qt(), setTimeout(function() {
          Kt(Qt, Xt);
        }, Xt);
      })(qt, zt), window.history && window.history.pushState ? window.addEventListener("popstate", qt) : window.addEventListener("hashchange", qt);
    }(Rt, Mt)), Et();
  }).catch(function(Vt) {
    _t.emitter.maybeReportError(new kt.LDUnexpectedResponseError((Vt && Vt.message, Vt.message))), Et();
  }), {};
}
var jt = "goalsReady", Ft = { fetchGoals: { default: !0 }, hash: { type: "string" }, eventProcessor: { type: "object" }, eventUrlTransformer: { type: "function" }, disableSyncEventPost: { default: !1 } };
function Nt(_t, Et) {
  var Pt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, $t = function(Gt) {
    var qt, Kt = { userAgentHeaderName: "X-LaunchDarkly-User-Agent", synchronousFlush: !1 };
    if (window.XMLHttpRequest) {
      var Qt = Gt && Gt.disableSyncEventPost;
      Kt.httpRequest = function(Jt, er, tr, nr) {
        var rr = Kt.synchronousFlush & !Qt;
        return Kt.synchronousFlush = !1, Ot(Jt, er, tr, nr, rr);
      };
    }
    Kt.httpAllowsPost = function() {
      return qt === void 0 && (qt = !!window.XMLHttpRequest && "withCredentials" in new window.XMLHttpRequest()), qt;
    }, Kt.httpFallbackPing = function(Jt) {
      new window.Image().src = Jt;
    };
    var Xt, Zt = Gt && Gt.eventUrlTransformer;
    Kt.getCurrentUrl = function() {
      return Zt ? Zt(window.location.href) : window.location.href;
    }, Kt.isDoNotTrack = function() {
      var Jt;
      return (Jt = window.navigator && window.navigator.doNotTrack !== void 0 ? window.navigator.doNotTrack : window.navigator && window.navigator.msDoNotTrack !== void 0 ? window.navigator.msDoNotTrack : window.doNotTrack) === 1 || Jt === !0 || Jt === "1" || Jt === "yes";
    };
    try {
      window.localStorage && (Kt.localStorage = { get: function(Jt) {
        return new Promise(function(er) {
          er(window.localStorage.getItem(Jt));
        });
      }, set: function(Jt, er) {
        return new Promise(function(tr) {
          window.localStorage.setItem(Jt, er), tr();
        });
      }, clear: function(Jt) {
        return new Promise(function(er) {
          window.localStorage.removeItem(Jt), er();
        });
      } });
    } catch {
      Kt.localStorage = null;
    }
    if (Gt && Gt.useReport && typeof window.EventSourcePolyfill == "function" && window.EventSourcePolyfill.supportedOptions && window.EventSourcePolyfill.supportedOptions.method ? (Kt.eventSourceAllowsReport = !0, Xt = window.EventSourcePolyfill) : (Kt.eventSourceAllowsReport = !1, Xt = window.EventSource), window.EventSource) {
      var Yt = 3e5;
      Kt.eventSourceFactory = function(Jt, er) {
        var tr = Ct(Ct({}, { heartbeatTimeout: Yt, silentTimeout: Yt, skipDefaultHeaders: !0 }), er);
        return new Xt(Jt, tr);
      }, Kt.eventSourceIsActive = function(Jt) {
        return Jt.readyState === window.EventSource.OPEN || Jt.readyState === window.EventSource.CONNECTING;
      };
    }
    return Kt.userAgent = "JSClient", Kt.version = "3.4.0", Kt.diagnosticSdkData = { name: "js-client-sdk", version: "3.4.0" }, Kt.diagnosticPlatformData = { name: "JS" }, Kt.diagnosticUseCombinedEvent = !0, Kt;
  }(Pt), Mt = bt(_t, Et, Pt, $t, Ft), Bt = Mt.client, Vt = Mt.options, zt = Mt.emitter, Ht = new Promise(function(Gt) {
    var qt = zt.on(jt, function() {
      zt.off(jt, qt), Gt();
    });
  });
  Bt.waitUntilGoalsReady = function() {
    return Ht;
  }, Vt.fetchGoals ? At(Mt, function() {
    return zt.emit(jt);
  }) : zt.emit(jt), document.readyState !== "complete" ? window.addEventListener("load", Mt.start) : Mt.start();
  var Wt = function() {
    $t.synchronousFlush = !0, Bt.flush().catch(function() {
    }), $t.synchronousFlush = !1;
  };
  return document.addEventListener("visibilitychange", function() {
    document.visibilityState === "hidden" && Wt();
  }), window.addEventListener("pagehide", Wt), Bt;
}
var INFINITY = 1 / 0, symbolTag = "[object Symbol]", reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f\\ufe20-\\ufe23", rsComboSymbolsRange = "\\u20d0-\\u20f0", rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange, rsApos = "['’]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboMarksRange + rsComboSymbolsRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d", rsLowerMisc = "(?:" + rsLower + "|" + rsMisc + ")", rsUpperMisc = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptLowerContr = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptUpperContr = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")", reApos = RegExp(rsApos, "g"), reComboMark = RegExp(rsCombo, "g"), reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g"), reUnicodeWord = RegExp([
  rsUpper + "?" + rsLower + "+" + rsOptLowerContr + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
  rsUpperMisc + "+" + rsOptUpperContr + "(?=" + [rsBreak, rsUpper + rsLowerMisc, "$"].join("|") + ")",
  rsUpper + "?" + rsLowerMisc + "+" + rsOptLowerContr,
  rsUpper + "+" + rsOptUpperContr,
  rsDigits,
  rsEmoji
].join("|"), "g"), reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + "]"), reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, deburredLetters = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "ss"
}, freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal, freeSelf = typeof self == "object" && self && self.Object === Object && self, root = freeGlobal || freeSelf || Function("return this")();
function arrayReduce(_t, Et, Pt, $t) {
  for (var Mt = -1, Bt = _t ? _t.length : 0; ++Mt < Bt; )
    Pt = Et(Pt, _t[Mt], Mt, _t);
  return Pt;
}
function asciiToArray(_t) {
  return _t.split("");
}
function asciiWords(_t) {
  return _t.match(reAsciiWord) || [];
}
function basePropertyOf(_t) {
  return function(Et) {
    return _t == null ? void 0 : _t[Et];
  };
}
var deburrLetter = basePropertyOf(deburredLetters);
function hasUnicode(_t) {
  return reHasUnicode.test(_t);
}
function hasUnicodeWord(_t) {
  return reHasUnicodeWord.test(_t);
}
function stringToArray(_t) {
  return hasUnicode(_t) ? unicodeToArray(_t) : asciiToArray(_t);
}
function unicodeToArray(_t) {
  return _t.match(reUnicode) || [];
}
function unicodeWords(_t) {
  return _t.match(reUnicodeWord) || [];
}
var objectProto = Object.prototype, objectToString = objectProto.toString, Symbol$1 = root.Symbol, symbolProto = Symbol$1 ? Symbol$1.prototype : void 0, symbolToString = symbolProto ? symbolProto.toString : void 0;
function baseSlice(_t, Et, Pt) {
  var $t = -1, Mt = _t.length;
  Et < 0 && (Et = -Et > Mt ? 0 : Mt + Et), Pt = Pt > Mt ? Mt : Pt, Pt < 0 && (Pt += Mt), Mt = Et > Pt ? 0 : Pt - Et >>> 0, Et >>>= 0;
  for (var Bt = Array(Mt); ++$t < Mt; )
    Bt[$t] = _t[$t + Et];
  return Bt;
}
function baseToString(_t) {
  if (typeof _t == "string")
    return _t;
  if (isSymbol(_t))
    return symbolToString ? symbolToString.call(_t) : "";
  var Et = _t + "";
  return Et == "0" && 1 / _t == -INFINITY ? "-0" : Et;
}
function castSlice(_t, Et, Pt) {
  var $t = _t.length;
  return Pt = Pt === void 0 ? $t : Pt, !Et && Pt >= $t ? _t : baseSlice(_t, Et, Pt);
}
function createCaseFirst(_t) {
  return function(Et) {
    Et = toString$3(Et);
    var Pt = hasUnicode(Et) ? stringToArray(Et) : void 0, $t = Pt ? Pt[0] : Et.charAt(0), Mt = Pt ? castSlice(Pt, 1).join("") : Et.slice(1);
    return $t[_t]() + Mt;
  };
}
function createCompounder(_t) {
  return function(Et) {
    return arrayReduce(words(deburr(Et).replace(reApos, "")), _t, "");
  };
}
function isObjectLike(_t) {
  return !!_t && typeof _t == "object";
}
function isSymbol(_t) {
  return typeof _t == "symbol" || isObjectLike(_t) && objectToString.call(_t) == symbolTag;
}
function toString$3(_t) {
  return _t == null ? "" : baseToString(_t);
}
var camelCase$1 = createCompounder(function(_t, Et, Pt) {
  return Et = Et.toLowerCase(), _t + (Pt ? capitalize$1(Et) : Et);
});
function capitalize$1(_t) {
  return upperFirst(toString$3(_t).toLowerCase());
}
function deburr(_t) {
  return _t = toString$3(_t), _t && _t.replace(reLatin, deburrLetter).replace(reComboMark, "");
}
var upperFirst = createCaseFirst("toUpperCase");
function words(_t, Et, Pt) {
  return _t = toString$3(_t), Et = Et, Et === void 0 ? hasUnicodeWord(_t) ? unicodeWords(_t) : asciiWords(_t) : _t.match(Et) || [];
}
var lodash_camelcase = camelCase$1;
const l = /* @__PURE__ */ getDefaultExportFromCjs(lodash_camelcase);
var reactIs$3 = { exports: {} }, reactIs_production_min$2 = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min$2;
function requireReactIs_production_min$2() {
  if (hasRequiredReactIs_production_min$2)
    return reactIs_production_min$2;
  hasRequiredReactIs_production_min$2 = 1;
  var _t = typeof Symbol == "function" && Symbol.for, Et = _t ? Symbol.for("react.element") : 60103, Pt = _t ? Symbol.for("react.portal") : 60106, $t = _t ? Symbol.for("react.fragment") : 60107, Mt = _t ? Symbol.for("react.strict_mode") : 60108, Bt = _t ? Symbol.for("react.profiler") : 60114, Vt = _t ? Symbol.for("react.provider") : 60109, zt = _t ? Symbol.for("react.context") : 60110, Ht = _t ? Symbol.for("react.async_mode") : 60111, Wt = _t ? Symbol.for("react.concurrent_mode") : 60111, Gt = _t ? Symbol.for("react.forward_ref") : 60112, qt = _t ? Symbol.for("react.suspense") : 60113, Kt = _t ? Symbol.for("react.suspense_list") : 60120, Qt = _t ? Symbol.for("react.memo") : 60115, Xt = _t ? Symbol.for("react.lazy") : 60116, Zt = _t ? Symbol.for("react.block") : 60121, Yt = _t ? Symbol.for("react.fundamental") : 60117, Jt = _t ? Symbol.for("react.responder") : 60118, er = _t ? Symbol.for("react.scope") : 60119;
  function tr(rr) {
    if (typeof rr == "object" && rr !== null) {
      var ir = rr.$$typeof;
      switch (ir) {
        case Et:
          switch (rr = rr.type, rr) {
            case Ht:
            case Wt:
            case $t:
            case Bt:
            case Mt:
            case qt:
              return rr;
            default:
              switch (rr = rr && rr.$$typeof, rr) {
                case zt:
                case Gt:
                case Xt:
                case Qt:
                case Vt:
                  return rr;
                default:
                  return ir;
              }
          }
        case Pt:
          return ir;
      }
    }
  }
  function nr(rr) {
    return tr(rr) === Wt;
  }
  return reactIs_production_min$2.AsyncMode = Ht, reactIs_production_min$2.ConcurrentMode = Wt, reactIs_production_min$2.ContextConsumer = zt, reactIs_production_min$2.ContextProvider = Vt, reactIs_production_min$2.Element = Et, reactIs_production_min$2.ForwardRef = Gt, reactIs_production_min$2.Fragment = $t, reactIs_production_min$2.Lazy = Xt, reactIs_production_min$2.Memo = Qt, reactIs_production_min$2.Portal = Pt, reactIs_production_min$2.Profiler = Bt, reactIs_production_min$2.StrictMode = Mt, reactIs_production_min$2.Suspense = qt, reactIs_production_min$2.isAsyncMode = function(rr) {
    return nr(rr) || tr(rr) === Ht;
  }, reactIs_production_min$2.isConcurrentMode = nr, reactIs_production_min$2.isContextConsumer = function(rr) {
    return tr(rr) === zt;
  }, reactIs_production_min$2.isContextProvider = function(rr) {
    return tr(rr) === Vt;
  }, reactIs_production_min$2.isElement = function(rr) {
    return typeof rr == "object" && rr !== null && rr.$$typeof === Et;
  }, reactIs_production_min$2.isForwardRef = function(rr) {
    return tr(rr) === Gt;
  }, reactIs_production_min$2.isFragment = function(rr) {
    return tr(rr) === $t;
  }, reactIs_production_min$2.isLazy = function(rr) {
    return tr(rr) === Xt;
  }, reactIs_production_min$2.isMemo = function(rr) {
    return tr(rr) === Qt;
  }, reactIs_production_min$2.isPortal = function(rr) {
    return tr(rr) === Pt;
  }, reactIs_production_min$2.isProfiler = function(rr) {
    return tr(rr) === Bt;
  }, reactIs_production_min$2.isStrictMode = function(rr) {
    return tr(rr) === Mt;
  }, reactIs_production_min$2.isSuspense = function(rr) {
    return tr(rr) === qt;
  }, reactIs_production_min$2.isValidElementType = function(rr) {
    return typeof rr == "string" || typeof rr == "function" || rr === $t || rr === Wt || rr === Bt || rr === Mt || rr === qt || rr === Kt || typeof rr == "object" && rr !== null && (rr.$$typeof === Xt || rr.$$typeof === Qt || rr.$$typeof === Vt || rr.$$typeof === zt || rr.$$typeof === Gt || rr.$$typeof === Yt || rr.$$typeof === Jt || rr.$$typeof === er || rr.$$typeof === Zt);
  }, reactIs_production_min$2.typeOf = tr, reactIs_production_min$2;
}
var reactIs_development$2 = {}, hasRequiredReactIs_development$2;
function requireReactIs_development$2() {
  return hasRequiredReactIs_development$2 || (hasRequiredReactIs_development$2 = 1, browser$1.env.NODE_ENV !== "production" && function() {
    var _t = typeof Symbol == "function" && Symbol.for, Et = _t ? Symbol.for("react.element") : 60103, Pt = _t ? Symbol.for("react.portal") : 60106, $t = _t ? Symbol.for("react.fragment") : 60107, Mt = _t ? Symbol.for("react.strict_mode") : 60108, Bt = _t ? Symbol.for("react.profiler") : 60114, Vt = _t ? Symbol.for("react.provider") : 60109, zt = _t ? Symbol.for("react.context") : 60110, Ht = _t ? Symbol.for("react.async_mode") : 60111, Wt = _t ? Symbol.for("react.concurrent_mode") : 60111, Gt = _t ? Symbol.for("react.forward_ref") : 60112, qt = _t ? Symbol.for("react.suspense") : 60113, Kt = _t ? Symbol.for("react.suspense_list") : 60120, Qt = _t ? Symbol.for("react.memo") : 60115, Xt = _t ? Symbol.for("react.lazy") : 60116, Zt = _t ? Symbol.for("react.block") : 60121, Yt = _t ? Symbol.for("react.fundamental") : 60117, Jt = _t ? Symbol.for("react.responder") : 60118, er = _t ? Symbol.for("react.scope") : 60119;
    function tr(Tr) {
      return typeof Tr == "string" || typeof Tr == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      Tr === $t || Tr === Wt || Tr === Bt || Tr === Mt || Tr === qt || Tr === Kt || typeof Tr == "object" && Tr !== null && (Tr.$$typeof === Xt || Tr.$$typeof === Qt || Tr.$$typeof === Vt || Tr.$$typeof === zt || Tr.$$typeof === Gt || Tr.$$typeof === Yt || Tr.$$typeof === Jt || Tr.$$typeof === er || Tr.$$typeof === Zt);
    }
    function nr(Tr) {
      if (typeof Tr == "object" && Tr !== null) {
        var Gr = Tr.$$typeof;
        switch (Gr) {
          case Et:
            var $r = Tr.type;
            switch ($r) {
              case Ht:
              case Wt:
              case $t:
              case Bt:
              case Mt:
              case qt:
                return $r;
              default:
                var Rr = $r && $r.$$typeof;
                switch (Rr) {
                  case zt:
                  case Gt:
                  case Xt:
                  case Qt:
                  case Vt:
                    return Rr;
                  default:
                    return Gr;
                }
            }
          case Pt:
            return Gr;
        }
      }
    }
    var rr = Ht, ir = Wt, ar = zt, or = Vt, sr = Et, lr = Gt, cr = $t, hr = Xt, pr = Qt, mr = Pt, Er = Bt, _r = Mt, yr = qt, ur = !1;
    function vr(Tr) {
      return ur || (ur = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), dr(Tr) || nr(Tr) === Ht;
    }
    function dr(Tr) {
      return nr(Tr) === Wt;
    }
    function br(Tr) {
      return nr(Tr) === zt;
    }
    function Cr(Tr) {
      return nr(Tr) === Vt;
    }
    function Pr(Tr) {
      return typeof Tr == "object" && Tr !== null && Tr.$$typeof === Et;
    }
    function xr(Tr) {
      return nr(Tr) === Gt;
    }
    function kr(Tr) {
      return nr(Tr) === $t;
    }
    function Ir(Tr) {
      return nr(Tr) === Xt;
    }
    function Ar(Tr) {
      return nr(Tr) === Qt;
    }
    function Mr(Tr) {
      return nr(Tr) === Pt;
    }
    function Fr(Tr) {
      return nr(Tr) === Bt;
    }
    function Dr(Tr) {
      return nr(Tr) === Mt;
    }
    function zr(Tr) {
      return nr(Tr) === qt;
    }
    reactIs_development$2.AsyncMode = rr, reactIs_development$2.ConcurrentMode = ir, reactIs_development$2.ContextConsumer = ar, reactIs_development$2.ContextProvider = or, reactIs_development$2.Element = sr, reactIs_development$2.ForwardRef = lr, reactIs_development$2.Fragment = cr, reactIs_development$2.Lazy = hr, reactIs_development$2.Memo = pr, reactIs_development$2.Portal = mr, reactIs_development$2.Profiler = Er, reactIs_development$2.StrictMode = _r, reactIs_development$2.Suspense = yr, reactIs_development$2.isAsyncMode = vr, reactIs_development$2.isConcurrentMode = dr, reactIs_development$2.isContextConsumer = br, reactIs_development$2.isContextProvider = Cr, reactIs_development$2.isElement = Pr, reactIs_development$2.isForwardRef = xr, reactIs_development$2.isFragment = kr, reactIs_development$2.isLazy = Ir, reactIs_development$2.isMemo = Ar, reactIs_development$2.isPortal = Mr, reactIs_development$2.isProfiler = Fr, reactIs_development$2.isStrictMode = Dr, reactIs_development$2.isSuspense = zr, reactIs_development$2.isValidElementType = tr, reactIs_development$2.typeOf = nr;
  }()), reactIs_development$2;
}
browser$1.env.NODE_ENV === "production" ? reactIs$3.exports = requireReactIs_production_min$2() : reactIs$3.exports = requireReactIs_development$2();
var reactIsExports$1 = reactIs$3.exports, reactIs$2 = reactIsExports$1, FORWARD_REF_STATICS = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, MEMO_STATICS = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, TYPE_STATICS = {};
TYPE_STATICS[reactIs$2.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs$2.Memo] = MEMO_STATICS;
const p = { useCamelCaseFlagKeys: !0, sendEventsOnFlagRead: !0 }, u = createContext({ flags: {}, flagKeyMap: {}, ldClient: void 0 }), { Provider: f, Consumer: d } = u, y = (_t) => {
  var Et;
  return (Et = _t.context) != null ? Et : _t.user;
}, h$1 = (_t) => {
  const Et = {};
  for (const Pt in _t)
    Pt.indexOf("$") !== 0 && (Et[l(Pt)] = _t[Pt]);
  return Et;
}, g = (_t, Et) => {
  const Pt = {};
  for (const $t in _t)
    Et && Et[$t] === void 0 || (Pt[$t] = _t[$t].current);
  return Pt;
}, O = (_t, Et) => {
  const Pt = _t.allFlags();
  return Et ? Object.keys(Et).reduce(($t, Mt) => ($t[Mt] = Object.prototype.hasOwnProperty.call(Pt, Mt) ? Pt[Mt] : Et[Mt], $t), {}) : Pt;
};
function b(_t, Et, Pt = p, $t) {
  const Mt = function(Ht, Wt) {
    return Wt === void 0 ? Ht : Object.keys(Wt).reduce((Gt, qt) => (m(Ht, qt) && (Gt[qt] = Ht[qt]), Gt), {});
  }(Et, $t), { useCamelCaseFlagKeys: Bt = !0 } = Pt, [Vt, zt = {}] = Bt ? function(Ht) {
    const Wt = {}, Gt = {};
    for (const qt in Ht) {
      if (qt.indexOf("$") === 0)
        continue;
      const Kt = l(qt);
      Wt[Kt] = Ht[qt], Gt[Kt] = qt;
    }
    return [Wt, Gt];
  }(Mt) : [Mt];
  return { flags: Pt.sendEventsOnFlagRead ? v$1(_t, Vt, zt, Bt) : Vt, flagKeyMap: zt };
}
function m(_t, Et) {
  return Object.prototype.hasOwnProperty.call(_t, Et);
}
function v$1(_t, Et, Pt, $t) {
  return new Proxy(Et, { get(Mt, Bt, Vt) {
    const zt = Reflect.get(Mt, Bt, Vt), Ht = $t && m(Pt, Bt) || m(Mt, Bt);
    if (typeof Bt == "symbol" || !Ht)
      return zt;
    if (zt === void 0)
      return;
    const Wt = $t ? Pt[Bt] : Bt;
    return _t.variation(Wt, zt);
  } });
}
h$1.camelCaseKeys = h$1;
const j = { wrapperName: "react-client-sdk", wrapperVersion: "3.4.0", sendEventsOnlyForVariation: !0 };
var w$1 = Object.defineProperty, C = Object.defineProperties, P = Object.getOwnPropertyDescriptors, x = Object.getOwnPropertySymbols, F = Object.prototype.hasOwnProperty, E = Object.prototype.propertyIsEnumerable, S = (_t, Et, Pt) => Et in _t ? w$1(_t, Et, { enumerable: !0, configurable: !0, writable: !0, value: Pt }) : _t[Et] = Pt, k = (_t, Et) => {
  for (var Pt in Et || (Et = {}))
    F.call(Et, Pt) && S(_t, Pt, Et[Pt]);
  if (x)
    for (var Pt of x(Et))
      E.call(Et, Pt) && S(_t, Pt, Et[Pt]);
  return _t;
}, D = (_t, Et) => C(_t, P(Et)), I = (_t, Et, Pt) => new Promise(($t, Mt) => {
  var Bt = (Ht) => {
    try {
      zt(Pt.next(Ht));
    } catch (Wt) {
      Mt(Wt);
    }
  }, Vt = (Ht) => {
    try {
      zt(Pt.throw(Ht));
    } catch (Wt) {
      Mt(Wt);
    }
  }, zt = (Ht) => Ht.done ? $t(Ht.value) : Promise.resolve(Ht.value).then(Bt, Vt);
  zt((Pt = Pt.apply(_t, Et)).next());
});
class K extends Component {
  constructor(Et) {
    super(Et), this.getReactOptions = () => k(k({}, p), this.props.reactOptions), this.subscribeToChanges = ($t) => {
      const { flags: Mt } = this.props;
      $t.on("change", (Bt) => {
        const Vt = this.getReactOptions(), zt = g(Bt, Mt), Ht = k(k({}, this.state.unproxiedFlags), zt);
        Object.keys(zt).length > 0 && this.setState((Wt) => k(D(k({}, Wt), { unproxiedFlags: Ht }), b($t, Ht, Vt, Mt)));
      });
    }, this.onFailed = ($t, Mt) => {
      this.setState((Bt) => D(k({}, Bt), { error: Mt }));
    }, this.onReady = ($t, Mt, Bt) => {
      const Vt = O($t, Bt);
      this.setState((zt) => k(D(k({}, zt), { unproxiedFlags: Vt }), b($t, Vt, Mt, Bt)));
    }, this.prepareLDClient = () => I(this, null, function* () {
      var $t;
      const { clientSideID: Mt, flags: Bt, options: Vt } = this.props;
      let zt = yield this.props.ldClient;
      const Ht = this.getReactOptions();
      let Wt, Gt = this.state.unproxiedFlags;
      if (zt)
        Gt = O(zt, Bt);
      else {
        const qt = ($t = y(this.props)) != null ? $t : { anonymous: !0, kind: "user" };
        zt = Nt(Mt, qt, k(k({}, j), Vt));
        try {
          yield zt.waitForInitialization(this.props.timeout), Gt = O(zt, Bt);
        } catch (Kt) {
          Wt = Kt, Wt != null && Wt.name.toLowerCase().includes("timeout") && (zt.on("failed", this.onFailed), zt.on("ready", () => {
            this.onReady(zt, Ht, Bt);
          }));
        }
      }
      this.setState((qt) => D(k(D(k({}, qt), { unproxiedFlags: Gt }), b(zt, Gt, Ht, Bt)), { ldClient: zt, error: Wt })), this.subscribeToChanges(zt);
    });
    const { options: Pt } = Et;
    if (this.state = { flags: {}, unproxiedFlags: {}, flagKeyMap: {} }, Pt) {
      const { bootstrap: $t } = Pt;
      if ($t && $t !== "localStorage") {
        const { useCamelCaseFlagKeys: Mt } = this.getReactOptions();
        this.state = { flags: Mt ? h$1($t) : $t, unproxiedFlags: $t, flagKeyMap: {} };
      }
    }
  }
  componentDidMount() {
    return I(this, null, function* () {
      const { deferInitialization: Et } = this.props;
      Et && !y(this.props) || (yield this.prepareLDClient());
    });
  }
  componentDidUpdate(Et) {
    return I(this, null, function* () {
      const { deferInitialization: Pt } = this.props, $t = !y(Et) && y(this.props);
      Pt && $t && (yield this.prepareLDClient());
    });
  }
  render() {
    const { flags: Et, flagKeyMap: Pt, ldClient: $t, error: Mt } = this.state;
    return React__default.createElement(f, { value: { flags: Et, flagKeyMap: Pt, ldClient: $t, error: Mt } }, this.props.children);
  }
}
const ie = () => {
  const { flags: _t } = useContext(u);
  return _t;
}, se = () => {
  const { ldClient: _t } = useContext(u);
  return _t;
}, useInitLaunchDarkly = (_t) => {
  const [Et, Pt] = useState(!1), $t = se();
  return useEffect(() => {
    const Mt = async () => {
      _t.getCurrentUser().then((Bt) => {
        Bt && $t && ($t.identify({
          kind: "user",
          key: Bt.id,
          email: Bt.email
        }), Pt(!0));
      }).catch(console.error);
    };
    _t.addCallbackAfterSetToken(() => Mt());
  }, [_t, $t]), Et;
};
class Subscribable {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(Et) {
    const Pt = {
      listener: Et
    };
    return this.listeners.add(Pt), this.onSubscribe(), () => {
      this.listeners.delete(Pt), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}
const isServer = typeof window > "u" || "Deno" in window;
function noop$3() {
}
function functionalUpdate(_t, Et) {
  return typeof _t == "function" ? _t(Et) : _t;
}
function isValidTimeout(_t) {
  return typeof _t == "number" && _t >= 0 && _t !== 1 / 0;
}
function timeUntilStale(_t, Et) {
  return Math.max(_t + (Et || 0) - Date.now(), 0);
}
function parseQueryArgs(_t, Et, Pt) {
  return isQueryKey(_t) ? typeof Et == "function" ? {
    ...Pt,
    queryKey: _t,
    queryFn: Et
  } : {
    ...Et,
    queryKey: _t
  } : _t;
}
function parseFilterArgs(_t, Et, Pt) {
  return isQueryKey(_t) ? [{
    ...Et,
    queryKey: _t
  }, Pt] : [_t || {}, Et];
}
function matchQuery(_t, Et) {
  const {
    type: Pt = "all",
    exact: $t,
    fetchStatus: Mt,
    predicate: Bt,
    queryKey: Vt,
    stale: zt
  } = _t;
  if (isQueryKey(Vt)) {
    if ($t) {
      if (Et.queryHash !== hashQueryKeyByOptions(Vt, Et.options))
        return !1;
    } else if (!partialMatchKey(Et.queryKey, Vt))
      return !1;
  }
  if (Pt !== "all") {
    const Ht = Et.isActive();
    if (Pt === "active" && !Ht || Pt === "inactive" && Ht)
      return !1;
  }
  return !(typeof zt == "boolean" && Et.isStale() !== zt || typeof Mt < "u" && Mt !== Et.state.fetchStatus || Bt && !Bt(Et));
}
function matchMutation(_t, Et) {
  const {
    exact: Pt,
    fetching: $t,
    predicate: Mt,
    mutationKey: Bt
  } = _t;
  if (isQueryKey(Bt)) {
    if (!Et.options.mutationKey)
      return !1;
    if (Pt) {
      if (hashQueryKey(Et.options.mutationKey) !== hashQueryKey(Bt))
        return !1;
    } else if (!partialMatchKey(Et.options.mutationKey, Bt))
      return !1;
  }
  return !(typeof $t == "boolean" && Et.state.status === "loading" !== $t || Mt && !Mt(Et));
}
function hashQueryKeyByOptions(_t, Et) {
  return ((Et == null ? void 0 : Et.queryKeyHashFn) || hashQueryKey)(_t);
}
function hashQueryKey(_t) {
  return JSON.stringify(_t, (Et, Pt) => isPlainObject$1(Pt) ? Object.keys(Pt).sort().reduce(($t, Mt) => ($t[Mt] = Pt[Mt], $t), {}) : Pt);
}
function partialMatchKey(_t, Et) {
  return partialDeepEqual(_t, Et);
}
function partialDeepEqual(_t, Et) {
  return _t === Et ? !0 : typeof _t != typeof Et ? !1 : _t && Et && typeof _t == "object" && typeof Et == "object" ? !Object.keys(Et).some((Pt) => !partialDeepEqual(_t[Pt], Et[Pt])) : !1;
}
function replaceEqualDeep(_t, Et) {
  if (_t === Et)
    return _t;
  const Pt = isPlainArray(_t) && isPlainArray(Et);
  if (Pt || isPlainObject$1(_t) && isPlainObject$1(Et)) {
    const $t = Pt ? _t.length : Object.keys(_t).length, Mt = Pt ? Et : Object.keys(Et), Bt = Mt.length, Vt = Pt ? [] : {};
    let zt = 0;
    for (let Ht = 0; Ht < Bt; Ht++) {
      const Wt = Pt ? Ht : Mt[Ht];
      Vt[Wt] = replaceEqualDeep(_t[Wt], Et[Wt]), Vt[Wt] === _t[Wt] && zt++;
    }
    return $t === Bt && zt === $t ? _t : Vt;
  }
  return Et;
}
function shallowEqualObjects(_t, Et) {
  if (_t && !Et || Et && !_t)
    return !1;
  for (const Pt in _t)
    if (_t[Pt] !== Et[Pt])
      return !1;
  return !0;
}
function isPlainArray(_t) {
  return Array.isArray(_t) && _t.length === Object.keys(_t).length;
}
function isPlainObject$1(_t) {
  if (!hasObjectPrototype(_t))
    return !1;
  const Et = _t.constructor;
  if (typeof Et > "u")
    return !0;
  const Pt = Et.prototype;
  return !(!hasObjectPrototype(Pt) || !Pt.hasOwnProperty("isPrototypeOf"));
}
function hasObjectPrototype(_t) {
  return Object.prototype.toString.call(_t) === "[object Object]";
}
function isQueryKey(_t) {
  return Array.isArray(_t);
}
function sleep(_t) {
  return new Promise((Et) => {
    setTimeout(Et, _t);
  });
}
function scheduleMicrotask(_t) {
  sleep(0).then(_t);
}
function getAbortController() {
  if (typeof AbortController == "function")
    return new AbortController();
}
function replaceData(_t, Et, Pt) {
  return Pt.isDataEqual != null && Pt.isDataEqual(_t, Et) ? _t : typeof Pt.structuralSharing == "function" ? Pt.structuralSharing(_t, Et) : Pt.structuralSharing !== !1 ? replaceEqualDeep(_t, Et) : Et;
}
class FocusManager extends Subscribable {
  constructor() {
    super(), this.setup = (Et) => {
      if (!isServer && window.addEventListener) {
        const Pt = () => Et();
        return window.addEventListener("visibilitychange", Pt, !1), window.addEventListener("focus", Pt, !1), () => {
          window.removeEventListener("visibilitychange", Pt), window.removeEventListener("focus", Pt);
        };
      }
    };
  }
  onSubscribe() {
    this.cleanup || this.setEventListener(this.setup);
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var Et;
      (Et = this.cleanup) == null || Et.call(this), this.cleanup = void 0;
    }
  }
  setEventListener(Et) {
    var Pt;
    this.setup = Et, (Pt = this.cleanup) == null || Pt.call(this), this.cleanup = Et(($t) => {
      typeof $t == "boolean" ? this.setFocused($t) : this.onFocus();
    });
  }
  setFocused(Et) {
    this.focused !== Et && (this.focused = Et, this.onFocus());
  }
  onFocus() {
    this.listeners.forEach(({
      listener: Et
    }) => {
      Et();
    });
  }
  isFocused() {
    return typeof this.focused == "boolean" ? this.focused : typeof document > "u" ? !0 : [void 0, "visible", "prerender"].includes(document.visibilityState);
  }
}
const focusManager = new FocusManager(), onlineEvents = ["online", "offline"];
class OnlineManager extends Subscribable {
  constructor() {
    super(), this.setup = (Et) => {
      if (!isServer && window.addEventListener) {
        const Pt = () => Et();
        return onlineEvents.forEach(($t) => {
          window.addEventListener($t, Pt, !1);
        }), () => {
          onlineEvents.forEach(($t) => {
            window.removeEventListener($t, Pt);
          });
        };
      }
    };
  }
  onSubscribe() {
    this.cleanup || this.setEventListener(this.setup);
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var Et;
      (Et = this.cleanup) == null || Et.call(this), this.cleanup = void 0;
    }
  }
  setEventListener(Et) {
    var Pt;
    this.setup = Et, (Pt = this.cleanup) == null || Pt.call(this), this.cleanup = Et(($t) => {
      typeof $t == "boolean" ? this.setOnline($t) : this.onOnline();
    });
  }
  setOnline(Et) {
    this.online !== Et && (this.online = Et, this.onOnline());
  }
  onOnline() {
    this.listeners.forEach(({
      listener: Et
    }) => {
      Et();
    });
  }
  isOnline() {
    return typeof this.online == "boolean" ? this.online : typeof navigator > "u" || typeof navigator.onLine > "u" ? !0 : navigator.onLine;
  }
}
const onlineManager = new OnlineManager();
function defaultRetryDelay(_t) {
  return Math.min(1e3 * 2 ** _t, 3e4);
}
function canFetch(_t) {
  return (_t ?? "online") === "online" ? onlineManager.isOnline() : !0;
}
class CancelledError {
  constructor(Et) {
    this.revert = Et == null ? void 0 : Et.revert, this.silent = Et == null ? void 0 : Et.silent;
  }
}
function isCancelledError(_t) {
  return _t instanceof CancelledError;
}
function createRetryer(_t) {
  let Et = !1, Pt = 0, $t = !1, Mt, Bt, Vt;
  const zt = new Promise((Yt, Jt) => {
    Bt = Yt, Vt = Jt;
  }), Ht = (Yt) => {
    $t || (Qt(new CancelledError(Yt)), _t.abort == null || _t.abort());
  }, Wt = () => {
    Et = !0;
  }, Gt = () => {
    Et = !1;
  }, qt = () => !focusManager.isFocused() || _t.networkMode !== "always" && !onlineManager.isOnline(), Kt = (Yt) => {
    $t || ($t = !0, _t.onSuccess == null || _t.onSuccess(Yt), Mt == null || Mt(), Bt(Yt));
  }, Qt = (Yt) => {
    $t || ($t = !0, _t.onError == null || _t.onError(Yt), Mt == null || Mt(), Vt(Yt));
  }, Xt = () => new Promise((Yt) => {
    Mt = (Jt) => {
      const er = $t || !qt();
      return er && Yt(Jt), er;
    }, _t.onPause == null || _t.onPause();
  }).then(() => {
    Mt = void 0, $t || _t.onContinue == null || _t.onContinue();
  }), Zt = () => {
    if ($t)
      return;
    let Yt;
    try {
      Yt = _t.fn();
    } catch (Jt) {
      Yt = Promise.reject(Jt);
    }
    Promise.resolve(Yt).then(Kt).catch((Jt) => {
      var er, tr;
      if ($t)
        return;
      const nr = (er = _t.retry) != null ? er : 3, rr = (tr = _t.retryDelay) != null ? tr : defaultRetryDelay, ir = typeof rr == "function" ? rr(Pt, Jt) : rr, ar = nr === !0 || typeof nr == "number" && Pt < nr || typeof nr == "function" && nr(Pt, Jt);
      if (Et || !ar) {
        Qt(Jt);
        return;
      }
      Pt++, _t.onFail == null || _t.onFail(Pt, Jt), sleep(ir).then(() => {
        if (qt())
          return Xt();
      }).then(() => {
        Et ? Qt(Jt) : Zt();
      });
    });
  };
  return canFetch(_t.networkMode) ? Zt() : Xt().then(Zt), {
    promise: zt,
    cancel: Ht,
    continue: () => (Mt == null ? void 0 : Mt()) ? zt : Promise.resolve(),
    cancelRetry: Wt,
    continueRetry: Gt
  };
}
const defaultLogger = console;
function createNotifyManager() {
  let _t = [], Et = 0, Pt = (Gt) => {
    Gt();
  }, $t = (Gt) => {
    Gt();
  };
  const Mt = (Gt) => {
    let qt;
    Et++;
    try {
      qt = Gt();
    } finally {
      Et--, Et || zt();
    }
    return qt;
  }, Bt = (Gt) => {
    Et ? _t.push(Gt) : scheduleMicrotask(() => {
      Pt(Gt);
    });
  }, Vt = (Gt) => (...qt) => {
    Bt(() => {
      Gt(...qt);
    });
  }, zt = () => {
    const Gt = _t;
    _t = [], Gt.length && scheduleMicrotask(() => {
      $t(() => {
        Gt.forEach((qt) => {
          Pt(qt);
        });
      });
    });
  };
  return {
    batch: Mt,
    batchCalls: Vt,
    schedule: Bt,
    setNotifyFunction: (Gt) => {
      Pt = Gt;
    },
    setBatchNotifyFunction: (Gt) => {
      $t = Gt;
    }
  };
}
const notifyManager = createNotifyManager();
class Removable {
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), isValidTimeout(this.cacheTime) && (this.gcTimeout = setTimeout(() => {
      this.optionalRemove();
    }, this.cacheTime));
  }
  updateCacheTime(Et) {
    this.cacheTime = Math.max(this.cacheTime || 0, Et ?? (isServer ? 1 / 0 : 5 * 60 * 1e3));
  }
  clearGcTimeout() {
    this.gcTimeout && (clearTimeout(this.gcTimeout), this.gcTimeout = void 0);
  }
}
class Query extends Removable {
  constructor(Et) {
    super(), this.abortSignalConsumed = !1, this.defaultOptions = Et.defaultOptions, this.setOptions(Et.options), this.observers = [], this.cache = Et.cache, this.logger = Et.logger || defaultLogger, this.queryKey = Et.queryKey, this.queryHash = Et.queryHash, this.initialState = Et.state || getDefaultState$1(this.options), this.state = this.initialState, this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  setOptions(Et) {
    this.options = {
      ...this.defaultOptions,
      ...Et
    }, this.updateCacheTime(this.options.cacheTime);
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && this.cache.remove(this);
  }
  setData(Et, Pt) {
    const $t = replaceData(this.state.data, Et, this.options);
    return this.dispatch({
      data: $t,
      type: "success",
      dataUpdatedAt: Pt == null ? void 0 : Pt.updatedAt,
      manual: Pt == null ? void 0 : Pt.manual
    }), $t;
  }
  setState(Et, Pt) {
    this.dispatch({
      type: "setState",
      state: Et,
      setStateOptions: Pt
    });
  }
  cancel(Et) {
    var Pt;
    const $t = this.promise;
    return (Pt = this.retryer) == null || Pt.cancel(Et), $t ? $t.then(noop$3).catch(noop$3) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({
      silent: !0
    });
  }
  reset() {
    this.destroy(), this.setState(this.initialState);
  }
  isActive() {
    return this.observers.some((Et) => Et.options.enabled !== !1);
  }
  isDisabled() {
    return this.getObserversCount() > 0 && !this.isActive();
  }
  isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((Et) => Et.getCurrentResult().isStale);
  }
  isStaleByTime(Et = 0) {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || !timeUntilStale(this.state.dataUpdatedAt, Et);
  }
  onFocus() {
    var Et;
    const Pt = this.observers.find(($t) => $t.shouldFetchOnWindowFocus());
    Pt && Pt.refetch({
      cancelRefetch: !1
    }), (Et = this.retryer) == null || Et.continue();
  }
  onOnline() {
    var Et;
    const Pt = this.observers.find(($t) => $t.shouldFetchOnReconnect());
    Pt && Pt.refetch({
      cancelRefetch: !1
    }), (Et = this.retryer) == null || Et.continue();
  }
  addObserver(Et) {
    this.observers.includes(Et) || (this.observers.push(Et), this.clearGcTimeout(), this.cache.notify({
      type: "observerAdded",
      query: this,
      observer: Et
    }));
  }
  removeObserver(Et) {
    this.observers.includes(Et) && (this.observers = this.observers.filter((Pt) => Pt !== Et), this.observers.length || (this.retryer && (this.abortSignalConsumed ? this.retryer.cancel({
      revert: !0
    }) : this.retryer.cancelRetry()), this.scheduleGc()), this.cache.notify({
      type: "observerRemoved",
      query: this,
      observer: Et
    }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || this.dispatch({
      type: "invalidate"
    });
  }
  fetch(Et, Pt) {
    var $t, Mt;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.dataUpdatedAt && Pt != null && Pt.cancelRefetch)
        this.cancel({
          silent: !0
        });
      else if (this.promise) {
        var Bt;
        return (Bt = this.retryer) == null || Bt.continueRetry(), this.promise;
      }
    }
    if (Et && this.setOptions(Et), !this.options.queryFn) {
      const Qt = this.observers.find((Xt) => Xt.options.queryFn);
      Qt && this.setOptions(Qt.options);
    }
    process.env.NODE_ENV !== "production" && (Array.isArray(this.options.queryKey) || this.logger.error("As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']"));
    const Vt = getAbortController(), zt = {
      queryKey: this.queryKey,
      pageParam: void 0,
      meta: this.meta
    }, Ht = (Qt) => {
      Object.defineProperty(Qt, "signal", {
        enumerable: !0,
        get: () => {
          if (Vt)
            return this.abortSignalConsumed = !0, Vt.signal;
        }
      });
    };
    Ht(zt);
    const Wt = () => this.options.queryFn ? (this.abortSignalConsumed = !1, this.options.queryFn(zt)) : Promise.reject("Missing queryFn for queryKey '" + this.options.queryHash + "'"), Gt = {
      fetchOptions: Pt,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn: Wt
    };
    if (Ht(Gt), ($t = this.options.behavior) == null || $t.onFetch(Gt), this.revertState = this.state, this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((Mt = Gt.fetchOptions) == null ? void 0 : Mt.meta)) {
      var qt;
      this.dispatch({
        type: "fetch",
        meta: (qt = Gt.fetchOptions) == null ? void 0 : qt.meta
      });
    }
    const Kt = (Qt) => {
      if (isCancelledError(Qt) && Qt.silent || this.dispatch({
        type: "error",
        error: Qt
      }), !isCancelledError(Qt)) {
        var Xt, Zt, Yt, Jt;
        (Xt = (Zt = this.cache.config).onError) == null || Xt.call(Zt, Qt, this), (Yt = (Jt = this.cache.config).onSettled) == null || Yt.call(Jt, this.state.data, Qt, this), process.env.NODE_ENV !== "production" && this.logger.error(Qt);
      }
      this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
    };
    return this.retryer = createRetryer({
      fn: Gt.fetchFn,
      abort: Vt == null ? void 0 : Vt.abort.bind(Vt),
      onSuccess: (Qt) => {
        var Xt, Zt, Yt, Jt;
        if (typeof Qt > "u") {
          process.env.NODE_ENV !== "production" && this.logger.error("Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: " + this.queryHash), Kt(new Error(this.queryHash + " data is undefined"));
          return;
        }
        this.setData(Qt), (Xt = (Zt = this.cache.config).onSuccess) == null || Xt.call(Zt, Qt, this), (Yt = (Jt = this.cache.config).onSettled) == null || Yt.call(Jt, Qt, this.state.error, this), this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
      },
      onError: Kt,
      onFail: (Qt, Xt) => {
        this.dispatch({
          type: "failed",
          failureCount: Qt,
          error: Xt
        });
      },
      onPause: () => {
        this.dispatch({
          type: "pause"
        });
      },
      onContinue: () => {
        this.dispatch({
          type: "continue"
        });
      },
      retry: Gt.options.retry,
      retryDelay: Gt.options.retryDelay,
      networkMode: Gt.options.networkMode
    }), this.promise = this.retryer.promise, this.promise;
  }
  dispatch(Et) {
    const Pt = ($t) => {
      var Mt, Bt;
      switch (Et.type) {
        case "failed":
          return {
            ...$t,
            fetchFailureCount: Et.failureCount,
            fetchFailureReason: Et.error
          };
        case "pause":
          return {
            ...$t,
            fetchStatus: "paused"
          };
        case "continue":
          return {
            ...$t,
            fetchStatus: "fetching"
          };
        case "fetch":
          return {
            ...$t,
            fetchFailureCount: 0,
            fetchFailureReason: null,
            fetchMeta: (Mt = Et.meta) != null ? Mt : null,
            fetchStatus: canFetch(this.options.networkMode) ? "fetching" : "paused",
            ...!$t.dataUpdatedAt && {
              error: null,
              status: "loading"
            }
          };
        case "success":
          return {
            ...$t,
            data: Et.data,
            dataUpdateCount: $t.dataUpdateCount + 1,
            dataUpdatedAt: (Bt = Et.dataUpdatedAt) != null ? Bt : Date.now(),
            error: null,
            isInvalidated: !1,
            status: "success",
            ...!Et.manual && {
              fetchStatus: "idle",
              fetchFailureCount: 0,
              fetchFailureReason: null
            }
          };
        case "error":
          const Vt = Et.error;
          return isCancelledError(Vt) && Vt.revert && this.revertState ? {
            ...this.revertState,
            fetchStatus: "idle"
          } : {
            ...$t,
            error: Vt,
            errorUpdateCount: $t.errorUpdateCount + 1,
            errorUpdatedAt: Date.now(),
            fetchFailureCount: $t.fetchFailureCount + 1,
            fetchFailureReason: Vt,
            fetchStatus: "idle",
            status: "error"
          };
        case "invalidate":
          return {
            ...$t,
            isInvalidated: !0
          };
        case "setState":
          return {
            ...$t,
            ...Et.state
          };
      }
    };
    this.state = Pt(this.state), notifyManager.batch(() => {
      this.observers.forEach(($t) => {
        $t.onQueryUpdate(Et);
      }), this.cache.notify({
        query: this,
        type: "updated",
        action: Et
      });
    });
  }
}
function getDefaultState$1(_t) {
  const Et = typeof _t.initialData == "function" ? _t.initialData() : _t.initialData, Pt = typeof Et < "u", $t = Pt ? typeof _t.initialDataUpdatedAt == "function" ? _t.initialDataUpdatedAt() : _t.initialDataUpdatedAt : 0;
  return {
    data: Et,
    dataUpdateCount: 0,
    dataUpdatedAt: Pt ? $t ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: Pt ? "success" : "loading",
    fetchStatus: "idle"
  };
}
class QueryCache extends Subscribable {
  constructor(Et) {
    super(), this.config = Et || {}, this.queries = [], this.queriesMap = {};
  }
  build(Et, Pt, $t) {
    var Mt;
    const Bt = Pt.queryKey, Vt = (Mt = Pt.queryHash) != null ? Mt : hashQueryKeyByOptions(Bt, Pt);
    let zt = this.get(Vt);
    return zt || (zt = new Query({
      cache: this,
      logger: Et.getLogger(),
      queryKey: Bt,
      queryHash: Vt,
      options: Et.defaultQueryOptions(Pt),
      state: $t,
      defaultOptions: Et.getQueryDefaults(Bt)
    }), this.add(zt)), zt;
  }
  add(Et) {
    this.queriesMap[Et.queryHash] || (this.queriesMap[Et.queryHash] = Et, this.queries.push(Et), this.notify({
      type: "added",
      query: Et
    }));
  }
  remove(Et) {
    const Pt = this.queriesMap[Et.queryHash];
    Pt && (Et.destroy(), this.queries = this.queries.filter(($t) => $t !== Et), Pt === Et && delete this.queriesMap[Et.queryHash], this.notify({
      type: "removed",
      query: Et
    }));
  }
  clear() {
    notifyManager.batch(() => {
      this.queries.forEach((Et) => {
        this.remove(Et);
      });
    });
  }
  get(Et) {
    return this.queriesMap[Et];
  }
  getAll() {
    return this.queries;
  }
  find(Et, Pt) {
    const [$t] = parseFilterArgs(Et, Pt);
    return typeof $t.exact > "u" && ($t.exact = !0), this.queries.find((Mt) => matchQuery($t, Mt));
  }
  findAll(Et, Pt) {
    const [$t] = parseFilterArgs(Et, Pt);
    return Object.keys($t).length > 0 ? this.queries.filter((Mt) => matchQuery($t, Mt)) : this.queries;
  }
  notify(Et) {
    notifyManager.batch(() => {
      this.listeners.forEach(({
        listener: Pt
      }) => {
        Pt(Et);
      });
    });
  }
  onFocus() {
    notifyManager.batch(() => {
      this.queries.forEach((Et) => {
        Et.onFocus();
      });
    });
  }
  onOnline() {
    notifyManager.batch(() => {
      this.queries.forEach((Et) => {
        Et.onOnline();
      });
    });
  }
}
class Mutation extends Removable {
  constructor(Et) {
    super(), this.defaultOptions = Et.defaultOptions, this.mutationId = Et.mutationId, this.mutationCache = Et.mutationCache, this.logger = Et.logger || defaultLogger, this.observers = [], this.state = Et.state || getDefaultState(), this.setOptions(Et.options), this.scheduleGc();
  }
  setOptions(Et) {
    this.options = {
      ...this.defaultOptions,
      ...Et
    }, this.updateCacheTime(this.options.cacheTime);
  }
  get meta() {
    return this.options.meta;
  }
  setState(Et) {
    this.dispatch({
      type: "setState",
      state: Et
    });
  }
  addObserver(Et) {
    this.observers.includes(Et) || (this.observers.push(Et), this.clearGcTimeout(), this.mutationCache.notify({
      type: "observerAdded",
      mutation: this,
      observer: Et
    }));
  }
  removeObserver(Et) {
    this.observers = this.observers.filter((Pt) => Pt !== Et), this.scheduleGc(), this.mutationCache.notify({
      type: "observerRemoved",
      mutation: this,
      observer: Et
    });
  }
  optionalRemove() {
    this.observers.length || (this.state.status === "loading" ? this.scheduleGc() : this.mutationCache.remove(this));
  }
  continue() {
    var Et, Pt;
    return (Et = (Pt = this.retryer) == null ? void 0 : Pt.continue()) != null ? Et : this.execute();
  }
  async execute() {
    const Et = () => {
      var ar;
      return this.retryer = createRetryer({
        fn: () => this.options.mutationFn ? this.options.mutationFn(this.state.variables) : Promise.reject("No mutationFn found"),
        onFail: (or, sr) => {
          this.dispatch({
            type: "failed",
            failureCount: or,
            error: sr
          });
        },
        onPause: () => {
          this.dispatch({
            type: "pause"
          });
        },
        onContinue: () => {
          this.dispatch({
            type: "continue"
          });
        },
        retry: (ar = this.options.retry) != null ? ar : 0,
        retryDelay: this.options.retryDelay,
        networkMode: this.options.networkMode
      }), this.retryer.promise;
    }, Pt = this.state.status === "loading";
    try {
      var $t, Mt, Bt, Vt, zt, Ht, Wt, Gt;
      if (!Pt) {
        var qt, Kt, Qt, Xt;
        this.dispatch({
          type: "loading",
          variables: this.options.variables
        }), await ((qt = (Kt = this.mutationCache.config).onMutate) == null ? void 0 : qt.call(Kt, this.state.variables, this));
        const or = await ((Qt = (Xt = this.options).onMutate) == null ? void 0 : Qt.call(Xt, this.state.variables));
        or !== this.state.context && this.dispatch({
          type: "loading",
          context: or,
          variables: this.state.variables
        });
      }
      const ar = await Et();
      return await (($t = (Mt = this.mutationCache.config).onSuccess) == null ? void 0 : $t.call(Mt, ar, this.state.variables, this.state.context, this)), await ((Bt = (Vt = this.options).onSuccess) == null ? void 0 : Bt.call(Vt, ar, this.state.variables, this.state.context)), await ((zt = (Ht = this.mutationCache.config).onSettled) == null ? void 0 : zt.call(Ht, ar, null, this.state.variables, this.state.context, this)), await ((Wt = (Gt = this.options).onSettled) == null ? void 0 : Wt.call(Gt, ar, null, this.state.variables, this.state.context)), this.dispatch({
        type: "success",
        data: ar
      }), ar;
    } catch (ar) {
      try {
        var Zt, Yt, Jt, er, tr, nr, rr, ir;
        throw await ((Zt = (Yt = this.mutationCache.config).onError) == null ? void 0 : Zt.call(Yt, ar, this.state.variables, this.state.context, this)), process.env.NODE_ENV !== "production" && this.logger.error(ar), await ((Jt = (er = this.options).onError) == null ? void 0 : Jt.call(er, ar, this.state.variables, this.state.context)), await ((tr = (nr = this.mutationCache.config).onSettled) == null ? void 0 : tr.call(nr, void 0, ar, this.state.variables, this.state.context, this)), await ((rr = (ir = this.options).onSettled) == null ? void 0 : rr.call(ir, void 0, ar, this.state.variables, this.state.context)), ar;
      } finally {
        this.dispatch({
          type: "error",
          error: ar
        });
      }
    }
  }
  dispatch(Et) {
    const Pt = ($t) => {
      switch (Et.type) {
        case "failed":
          return {
            ...$t,
            failureCount: Et.failureCount,
            failureReason: Et.error
          };
        case "pause":
          return {
            ...$t,
            isPaused: !0
          };
        case "continue":
          return {
            ...$t,
            isPaused: !1
          };
        case "loading":
          return {
            ...$t,
            context: Et.context,
            data: void 0,
            failureCount: 0,
            failureReason: null,
            error: null,
            isPaused: !canFetch(this.options.networkMode),
            status: "loading",
            variables: Et.variables
          };
        case "success":
          return {
            ...$t,
            data: Et.data,
            failureCount: 0,
            failureReason: null,
            error: null,
            status: "success",
            isPaused: !1
          };
        case "error":
          return {
            ...$t,
            data: void 0,
            error: Et.error,
            failureCount: $t.failureCount + 1,
            failureReason: Et.error,
            isPaused: !1,
            status: "error"
          };
        case "setState":
          return {
            ...$t,
            ...Et.state
          };
      }
    };
    this.state = Pt(this.state), notifyManager.batch(() => {
      this.observers.forEach(($t) => {
        $t.onMutationUpdate(Et);
      }), this.mutationCache.notify({
        mutation: this,
        type: "updated",
        action: Et
      });
    });
  }
}
function getDefaultState() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0
  };
}
class MutationCache extends Subscribable {
  constructor(Et) {
    super(), this.config = Et || {}, this.mutations = [], this.mutationId = 0;
  }
  build(Et, Pt, $t) {
    const Mt = new Mutation({
      mutationCache: this,
      logger: Et.getLogger(),
      mutationId: ++this.mutationId,
      options: Et.defaultMutationOptions(Pt),
      state: $t,
      defaultOptions: Pt.mutationKey ? Et.getMutationDefaults(Pt.mutationKey) : void 0
    });
    return this.add(Mt), Mt;
  }
  add(Et) {
    this.mutations.push(Et), this.notify({
      type: "added",
      mutation: Et
    });
  }
  remove(Et) {
    this.mutations = this.mutations.filter((Pt) => Pt !== Et), this.notify({
      type: "removed",
      mutation: Et
    });
  }
  clear() {
    notifyManager.batch(() => {
      this.mutations.forEach((Et) => {
        this.remove(Et);
      });
    });
  }
  getAll() {
    return this.mutations;
  }
  find(Et) {
    return typeof Et.exact > "u" && (Et.exact = !0), this.mutations.find((Pt) => matchMutation(Et, Pt));
  }
  findAll(Et) {
    return this.mutations.filter((Pt) => matchMutation(Et, Pt));
  }
  notify(Et) {
    notifyManager.batch(() => {
      this.listeners.forEach(({
        listener: Pt
      }) => {
        Pt(Et);
      });
    });
  }
  resumePausedMutations() {
    var Et;
    return this.resuming = ((Et = this.resuming) != null ? Et : Promise.resolve()).then(() => {
      const Pt = this.mutations.filter(($t) => $t.state.isPaused);
      return notifyManager.batch(() => Pt.reduce(($t, Mt) => $t.then(() => Mt.continue().catch(noop$3)), Promise.resolve()));
    }).then(() => {
      this.resuming = void 0;
    }), this.resuming;
  }
}
function infiniteQueryBehavior() {
  return {
    onFetch: (_t) => {
      _t.fetchFn = () => {
        var Et, Pt, $t, Mt, Bt, Vt;
        const zt = (Et = _t.fetchOptions) == null || (Pt = Et.meta) == null ? void 0 : Pt.refetchPage, Ht = ($t = _t.fetchOptions) == null || (Mt = $t.meta) == null ? void 0 : Mt.fetchMore, Wt = Ht == null ? void 0 : Ht.pageParam, Gt = (Ht == null ? void 0 : Ht.direction) === "forward", qt = (Ht == null ? void 0 : Ht.direction) === "backward", Kt = ((Bt = _t.state.data) == null ? void 0 : Bt.pages) || [], Qt = ((Vt = _t.state.data) == null ? void 0 : Vt.pageParams) || [];
        let Xt = Qt, Zt = !1;
        const Yt = (ir) => {
          Object.defineProperty(ir, "signal", {
            enumerable: !0,
            get: () => {
              var ar;
              if ((ar = _t.signal) != null && ar.aborted)
                Zt = !0;
              else {
                var or;
                (or = _t.signal) == null || or.addEventListener("abort", () => {
                  Zt = !0;
                });
              }
              return _t.signal;
            }
          });
        }, Jt = _t.options.queryFn || (() => Promise.reject("Missing queryFn for queryKey '" + _t.options.queryHash + "'")), er = (ir, ar, or, sr) => (Xt = sr ? [ar, ...Xt] : [...Xt, ar], sr ? [or, ...ir] : [...ir, or]), tr = (ir, ar, or, sr) => {
          if (Zt)
            return Promise.reject("Cancelled");
          if (typeof or > "u" && !ar && ir.length)
            return Promise.resolve(ir);
          const lr = {
            queryKey: _t.queryKey,
            pageParam: or,
            meta: _t.options.meta
          };
          Yt(lr);
          const cr = Jt(lr);
          return Promise.resolve(cr).then((pr) => er(ir, or, pr, sr));
        };
        let nr;
        if (!Kt.length)
          nr = tr([]);
        else if (Gt) {
          const ir = typeof Wt < "u", ar = ir ? Wt : getNextPageParam(_t.options, Kt);
          nr = tr(Kt, ir, ar);
        } else if (qt) {
          const ir = typeof Wt < "u", ar = ir ? Wt : getPreviousPageParam(_t.options, Kt);
          nr = tr(Kt, ir, ar, !0);
        } else {
          Xt = [];
          const ir = typeof _t.options.getNextPageParam > "u";
          nr = (zt && Kt[0] ? zt(Kt[0], 0, Kt) : !0) ? tr([], ir, Qt[0]) : Promise.resolve(er([], Qt[0], Kt[0]));
          for (let or = 1; or < Kt.length; or++)
            nr = nr.then((sr) => {
              if (zt && Kt[or] ? zt(Kt[or], or, Kt) : !0) {
                const cr = ir ? Qt[or] : getNextPageParam(_t.options, sr);
                return tr(sr, ir, cr);
              }
              return Promise.resolve(er(sr, Qt[or], Kt[or]));
            });
        }
        return nr.then((ir) => ({
          pages: ir,
          pageParams: Xt
        }));
      };
    }
  };
}
function getNextPageParam(_t, Et) {
  return _t.getNextPageParam == null ? void 0 : _t.getNextPageParam(Et[Et.length - 1], Et);
}
function getPreviousPageParam(_t, Et) {
  return _t.getPreviousPageParam == null ? void 0 : _t.getPreviousPageParam(Et[0], Et);
}
class QueryClient {
  constructor(Et = {}) {
    this.queryCache = Et.queryCache || new QueryCache(), this.mutationCache = Et.mutationCache || new MutationCache(), this.logger = Et.logger || defaultLogger, this.defaultOptions = Et.defaultOptions || {}, this.queryDefaults = [], this.mutationDefaults = [], this.mountCount = 0, process.env.NODE_ENV !== "production" && Et.logger && this.logger.error("Passing a custom logger has been deprecated and will be removed in the next major version.");
  }
  mount() {
    this.mountCount++, this.mountCount === 1 && (this.unsubscribeFocus = focusManager.subscribe(() => {
      focusManager.isFocused() && (this.resumePausedMutations(), this.queryCache.onFocus());
    }), this.unsubscribeOnline = onlineManager.subscribe(() => {
      onlineManager.isOnline() && (this.resumePausedMutations(), this.queryCache.onOnline());
    }));
  }
  unmount() {
    var Et, Pt;
    this.mountCount--, this.mountCount === 0 && ((Et = this.unsubscribeFocus) == null || Et.call(this), this.unsubscribeFocus = void 0, (Pt = this.unsubscribeOnline) == null || Pt.call(this), this.unsubscribeOnline = void 0);
  }
  isFetching(Et, Pt) {
    const [$t] = parseFilterArgs(Et, Pt);
    return $t.fetchStatus = "fetching", this.queryCache.findAll($t).length;
  }
  isMutating(Et) {
    return this.mutationCache.findAll({
      ...Et,
      fetching: !0
    }).length;
  }
  getQueryData(Et, Pt) {
    var $t;
    return ($t = this.queryCache.find(Et, Pt)) == null ? void 0 : $t.state.data;
  }
  ensureQueryData(Et, Pt, $t) {
    const Mt = parseQueryArgs(Et, Pt, $t), Bt = this.getQueryData(Mt.queryKey);
    return Bt ? Promise.resolve(Bt) : this.fetchQuery(Mt);
  }
  getQueriesData(Et) {
    return this.getQueryCache().findAll(Et).map(({
      queryKey: Pt,
      state: $t
    }) => {
      const Mt = $t.data;
      return [Pt, Mt];
    });
  }
  setQueryData(Et, Pt, $t) {
    const Mt = this.queryCache.find(Et), Bt = Mt == null ? void 0 : Mt.state.data, Vt = functionalUpdate(Pt, Bt);
    if (typeof Vt > "u")
      return;
    const zt = parseQueryArgs(Et), Ht = this.defaultQueryOptions(zt);
    return this.queryCache.build(this, Ht).setData(Vt, {
      ...$t,
      manual: !0
    });
  }
  setQueriesData(Et, Pt, $t) {
    return notifyManager.batch(() => this.getQueryCache().findAll(Et).map(({
      queryKey: Mt
    }) => [Mt, this.setQueryData(Mt, Pt, $t)]));
  }
  getQueryState(Et, Pt) {
    var $t;
    return ($t = this.queryCache.find(Et, Pt)) == null ? void 0 : $t.state;
  }
  removeQueries(Et, Pt) {
    const [$t] = parseFilterArgs(Et, Pt), Mt = this.queryCache;
    notifyManager.batch(() => {
      Mt.findAll($t).forEach((Bt) => {
        Mt.remove(Bt);
      });
    });
  }
  resetQueries(Et, Pt, $t) {
    const [Mt, Bt] = parseFilterArgs(Et, Pt, $t), Vt = this.queryCache, zt = {
      type: "active",
      ...Mt
    };
    return notifyManager.batch(() => (Vt.findAll(Mt).forEach((Ht) => {
      Ht.reset();
    }), this.refetchQueries(zt, Bt)));
  }
  cancelQueries(Et, Pt, $t) {
    const [Mt, Bt = {}] = parseFilterArgs(Et, Pt, $t);
    typeof Bt.revert > "u" && (Bt.revert = !0);
    const Vt = notifyManager.batch(() => this.queryCache.findAll(Mt).map((zt) => zt.cancel(Bt)));
    return Promise.all(Vt).then(noop$3).catch(noop$3);
  }
  invalidateQueries(Et, Pt, $t) {
    const [Mt, Bt] = parseFilterArgs(Et, Pt, $t);
    return notifyManager.batch(() => {
      var Vt, zt;
      if (this.queryCache.findAll(Mt).forEach((Wt) => {
        Wt.invalidate();
      }), Mt.refetchType === "none")
        return Promise.resolve();
      const Ht = {
        ...Mt,
        type: (Vt = (zt = Mt.refetchType) != null ? zt : Mt.type) != null ? Vt : "active"
      };
      return this.refetchQueries(Ht, Bt);
    });
  }
  refetchQueries(Et, Pt, $t) {
    const [Mt, Bt] = parseFilterArgs(Et, Pt, $t), Vt = notifyManager.batch(() => this.queryCache.findAll(Mt).filter((Ht) => !Ht.isDisabled()).map((Ht) => {
      var Wt;
      return Ht.fetch(void 0, {
        ...Bt,
        cancelRefetch: (Wt = Bt == null ? void 0 : Bt.cancelRefetch) != null ? Wt : !0,
        meta: {
          refetchPage: Mt.refetchPage
        }
      });
    }));
    let zt = Promise.all(Vt).then(noop$3);
    return Bt != null && Bt.throwOnError || (zt = zt.catch(noop$3)), zt;
  }
  fetchQuery(Et, Pt, $t) {
    const Mt = parseQueryArgs(Et, Pt, $t), Bt = this.defaultQueryOptions(Mt);
    typeof Bt.retry > "u" && (Bt.retry = !1);
    const Vt = this.queryCache.build(this, Bt);
    return Vt.isStaleByTime(Bt.staleTime) ? Vt.fetch(Bt) : Promise.resolve(Vt.state.data);
  }
  prefetchQuery(Et, Pt, $t) {
    return this.fetchQuery(Et, Pt, $t).then(noop$3).catch(noop$3);
  }
  fetchInfiniteQuery(Et, Pt, $t) {
    const Mt = parseQueryArgs(Et, Pt, $t);
    return Mt.behavior = infiniteQueryBehavior(), this.fetchQuery(Mt);
  }
  prefetchInfiniteQuery(Et, Pt, $t) {
    return this.fetchInfiniteQuery(Et, Pt, $t).then(noop$3).catch(noop$3);
  }
  resumePausedMutations() {
    return this.mutationCache.resumePausedMutations();
  }
  getQueryCache() {
    return this.queryCache;
  }
  getMutationCache() {
    return this.mutationCache;
  }
  getLogger() {
    return this.logger;
  }
  getDefaultOptions() {
    return this.defaultOptions;
  }
  setDefaultOptions(Et) {
    this.defaultOptions = Et;
  }
  setQueryDefaults(Et, Pt) {
    const $t = this.queryDefaults.find((Mt) => hashQueryKey(Et) === hashQueryKey(Mt.queryKey));
    $t ? $t.defaultOptions = Pt : this.queryDefaults.push({
      queryKey: Et,
      defaultOptions: Pt
    });
  }
  getQueryDefaults(Et) {
    if (!Et)
      return;
    const Pt = this.queryDefaults.find(($t) => partialMatchKey(Et, $t.queryKey));
    return process.env.NODE_ENV !== "production" && this.queryDefaults.filter((Mt) => partialMatchKey(Et, Mt.queryKey)).length > 1 && this.logger.error("[QueryClient] Several query defaults match with key '" + JSON.stringify(Et) + "'. The first matching query defaults are used. Please check how query defaults are registered. Order does matter here. cf. https://react-query.tanstack.com/reference/QueryClient#queryclientsetquerydefaults."), Pt == null ? void 0 : Pt.defaultOptions;
  }
  setMutationDefaults(Et, Pt) {
    const $t = this.mutationDefaults.find((Mt) => hashQueryKey(Et) === hashQueryKey(Mt.mutationKey));
    $t ? $t.defaultOptions = Pt : this.mutationDefaults.push({
      mutationKey: Et,
      defaultOptions: Pt
    });
  }
  getMutationDefaults(Et) {
    if (!Et)
      return;
    const Pt = this.mutationDefaults.find(($t) => partialMatchKey(Et, $t.mutationKey));
    return process.env.NODE_ENV !== "production" && this.mutationDefaults.filter((Mt) => partialMatchKey(Et, Mt.mutationKey)).length > 1 && this.logger.error("[QueryClient] Several mutation defaults match with key '" + JSON.stringify(Et) + "'. The first matching mutation defaults are used. Please check how mutation defaults are registered. Order does matter here. cf. https://react-query.tanstack.com/reference/QueryClient#queryclientsetmutationdefaults."), Pt == null ? void 0 : Pt.defaultOptions;
  }
  defaultQueryOptions(Et) {
    if (Et != null && Et._defaulted)
      return Et;
    const Pt = {
      ...this.defaultOptions.queries,
      ...this.getQueryDefaults(Et == null ? void 0 : Et.queryKey),
      ...Et,
      _defaulted: !0
    };
    return !Pt.queryHash && Pt.queryKey && (Pt.queryHash = hashQueryKeyByOptions(Pt.queryKey, Pt)), typeof Pt.refetchOnReconnect > "u" && (Pt.refetchOnReconnect = Pt.networkMode !== "always"), typeof Pt.useErrorBoundary > "u" && (Pt.useErrorBoundary = !!Pt.suspense), Pt;
  }
  defaultMutationOptions(Et) {
    return Et != null && Et._defaulted ? Et : {
      ...this.defaultOptions.mutations,
      ...this.getMutationDefaults(Et == null ? void 0 : Et.mutationKey),
      ...Et,
      _defaulted: !0
    };
  }
  clear() {
    this.queryCache.clear(), this.mutationCache.clear();
  }
}
class QueryObserver extends Subscribable {
  constructor(Et, Pt) {
    super(), this.client = Et, this.options = Pt, this.trackedProps = /* @__PURE__ */ new Set(), this.selectError = null, this.bindMethods(), this.setOptions(Pt);
  }
  bindMethods() {
    this.remove = this.remove.bind(this), this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.size === 1 && (this.currentQuery.addObserver(this), shouldFetchOnMount(this.currentQuery, this.options) && this.executeFetch(), this.updateTimers());
  }
  onUnsubscribe() {
    this.hasListeners() || this.destroy();
  }
  shouldFetchOnReconnect() {
    return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
  }
  shouldFetchOnWindowFocus() {
    return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), this.clearStaleTimeout(), this.clearRefetchInterval(), this.currentQuery.removeObserver(this);
  }
  setOptions(Et, Pt) {
    const $t = this.options, Mt = this.currentQuery;
    if (this.options = this.client.defaultQueryOptions(Et), process.env.NODE_ENV !== "production" && typeof (Et == null ? void 0 : Et.isDataEqual) < "u" && this.client.getLogger().error("The isDataEqual option has been deprecated and will be removed in the next major version. You can achieve the same functionality by passing a function as the structuralSharing option"), shallowEqualObjects($t, this.options) || this.client.getQueryCache().notify({
      type: "observerOptionsUpdated",
      query: this.currentQuery,
      observer: this
    }), typeof this.options.enabled < "u" && typeof this.options.enabled != "boolean")
      throw new Error("Expected enabled to be a boolean");
    this.options.queryKey || (this.options.queryKey = $t.queryKey), this.updateQuery();
    const Bt = this.hasListeners();
    Bt && shouldFetchOptionally(this.currentQuery, Mt, this.options, $t) && this.executeFetch(), this.updateResult(Pt), Bt && (this.currentQuery !== Mt || this.options.enabled !== $t.enabled || this.options.staleTime !== $t.staleTime) && this.updateStaleTimeout();
    const Vt = this.computeRefetchInterval();
    Bt && (this.currentQuery !== Mt || this.options.enabled !== $t.enabled || Vt !== this.currentRefetchInterval) && this.updateRefetchInterval(Vt);
  }
  getOptimisticResult(Et) {
    const Pt = this.client.getQueryCache().build(this.client, Et), $t = this.createResult(Pt, Et);
    return shouldAssignObserverCurrentProperties(this, $t, Et) && (this.currentResult = $t, this.currentResultOptions = this.options, this.currentResultState = this.currentQuery.state), $t;
  }
  getCurrentResult() {
    return this.currentResult;
  }
  trackResult(Et) {
    const Pt = {};
    return Object.keys(Et).forEach(($t) => {
      Object.defineProperty(Pt, $t, {
        configurable: !1,
        enumerable: !0,
        get: () => (this.trackedProps.add($t), Et[$t])
      });
    }), Pt;
  }
  getCurrentQuery() {
    return this.currentQuery;
  }
  remove() {
    this.client.getQueryCache().remove(this.currentQuery);
  }
  refetch({
    refetchPage: Et,
    ...Pt
  } = {}) {
    return this.fetch({
      ...Pt,
      meta: {
        refetchPage: Et
      }
    });
  }
  fetchOptimistic(Et) {
    const Pt = this.client.defaultQueryOptions(Et), $t = this.client.getQueryCache().build(this.client, Pt);
    return $t.isFetchingOptimistic = !0, $t.fetch().then(() => this.createResult($t, Pt));
  }
  fetch(Et) {
    var Pt;
    return this.executeFetch({
      ...Et,
      cancelRefetch: (Pt = Et.cancelRefetch) != null ? Pt : !0
    }).then(() => (this.updateResult(), this.currentResult));
  }
  executeFetch(Et) {
    this.updateQuery();
    let Pt = this.currentQuery.fetch(this.options, Et);
    return Et != null && Et.throwOnError || (Pt = Pt.catch(noop$3)), Pt;
  }
  updateStaleTimeout() {
    if (this.clearStaleTimeout(), isServer || this.currentResult.isStale || !isValidTimeout(this.options.staleTime))
      return;
    const Pt = timeUntilStale(this.currentResult.dataUpdatedAt, this.options.staleTime) + 1;
    this.staleTimeoutId = setTimeout(() => {
      this.currentResult.isStale || this.updateResult();
    }, Pt);
  }
  computeRefetchInterval() {
    var Et;
    return typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (Et = this.options.refetchInterval) != null ? Et : !1;
  }
  updateRefetchInterval(Et) {
    this.clearRefetchInterval(), this.currentRefetchInterval = Et, !(isServer || this.options.enabled === !1 || !isValidTimeout(this.currentRefetchInterval) || this.currentRefetchInterval === 0) && (this.refetchIntervalId = setInterval(() => {
      (this.options.refetchIntervalInBackground || focusManager.isFocused()) && this.executeFetch();
    }, this.currentRefetchInterval));
  }
  updateTimers() {
    this.updateStaleTimeout(), this.updateRefetchInterval(this.computeRefetchInterval());
  }
  clearStaleTimeout() {
    this.staleTimeoutId && (clearTimeout(this.staleTimeoutId), this.staleTimeoutId = void 0);
  }
  clearRefetchInterval() {
    this.refetchIntervalId && (clearInterval(this.refetchIntervalId), this.refetchIntervalId = void 0);
  }
  createResult(Et, Pt) {
    const $t = this.currentQuery, Mt = this.options, Bt = this.currentResult, Vt = this.currentResultState, zt = this.currentResultOptions, Ht = Et !== $t, Wt = Ht ? Et.state : this.currentQueryInitialState, Gt = Ht ? this.currentResult : this.previousQueryResult, {
      state: qt
    } = Et;
    let {
      dataUpdatedAt: Kt,
      error: Qt,
      errorUpdatedAt: Xt,
      fetchStatus: Zt,
      status: Yt
    } = qt, Jt = !1, er = !1, tr;
    if (Pt._optimisticResults) {
      const or = this.hasListeners(), sr = !or && shouldFetchOnMount(Et, Pt), lr = or && shouldFetchOptionally(Et, $t, Pt, Mt);
      (sr || lr) && (Zt = canFetch(Et.options.networkMode) ? "fetching" : "paused", Kt || (Yt = "loading")), Pt._optimisticResults === "isRestoring" && (Zt = "idle");
    }
    if (Pt.keepPreviousData && !qt.dataUpdatedAt && Gt != null && Gt.isSuccess && Yt !== "error")
      tr = Gt.data, Kt = Gt.dataUpdatedAt, Yt = Gt.status, Jt = !0;
    else if (Pt.select && typeof qt.data < "u")
      if (Bt && qt.data === (Vt == null ? void 0 : Vt.data) && Pt.select === this.selectFn)
        tr = this.selectResult;
      else
        try {
          this.selectFn = Pt.select, tr = Pt.select(qt.data), tr = replaceData(Bt == null ? void 0 : Bt.data, tr, Pt), this.selectResult = tr, this.selectError = null;
        } catch (or) {
          process.env.NODE_ENV !== "production" && this.client.getLogger().error(or), this.selectError = or;
        }
    else
      tr = qt.data;
    if (typeof Pt.placeholderData < "u" && typeof tr > "u" && Yt === "loading") {
      let or;
      if (Bt != null && Bt.isPlaceholderData && Pt.placeholderData === (zt == null ? void 0 : zt.placeholderData))
        or = Bt.data;
      else if (or = typeof Pt.placeholderData == "function" ? Pt.placeholderData() : Pt.placeholderData, Pt.select && typeof or < "u")
        try {
          or = Pt.select(or), this.selectError = null;
        } catch (sr) {
          process.env.NODE_ENV !== "production" && this.client.getLogger().error(sr), this.selectError = sr;
        }
      typeof or < "u" && (Yt = "success", tr = replaceData(Bt == null ? void 0 : Bt.data, or, Pt), er = !0);
    }
    this.selectError && (Qt = this.selectError, tr = this.selectResult, Xt = Date.now(), Yt = "error");
    const nr = Zt === "fetching", rr = Yt === "loading", ir = Yt === "error";
    return {
      status: Yt,
      fetchStatus: Zt,
      isLoading: rr,
      isSuccess: Yt === "success",
      isError: ir,
      isInitialLoading: rr && nr,
      data: tr,
      dataUpdatedAt: Kt,
      error: Qt,
      errorUpdatedAt: Xt,
      failureCount: qt.fetchFailureCount,
      failureReason: qt.fetchFailureReason,
      errorUpdateCount: qt.errorUpdateCount,
      isFetched: qt.dataUpdateCount > 0 || qt.errorUpdateCount > 0,
      isFetchedAfterMount: qt.dataUpdateCount > Wt.dataUpdateCount || qt.errorUpdateCount > Wt.errorUpdateCount,
      isFetching: nr,
      isRefetching: nr && !rr,
      isLoadingError: ir && qt.dataUpdatedAt === 0,
      isPaused: Zt === "paused",
      isPlaceholderData: er,
      isPreviousData: Jt,
      isRefetchError: ir && qt.dataUpdatedAt !== 0,
      isStale: isStale(Et, Pt),
      refetch: this.refetch,
      remove: this.remove
    };
  }
  updateResult(Et) {
    const Pt = this.currentResult, $t = this.createResult(this.currentQuery, this.options);
    if (this.currentResultState = this.currentQuery.state, this.currentResultOptions = this.options, shallowEqualObjects($t, Pt))
      return;
    this.currentResult = $t;
    const Mt = {
      cache: !0
    }, Bt = () => {
      if (!Pt)
        return !0;
      const {
        notifyOnChangeProps: Vt
      } = this.options, zt = typeof Vt == "function" ? Vt() : Vt;
      if (zt === "all" || !zt && !this.trackedProps.size)
        return !0;
      const Ht = new Set(zt ?? this.trackedProps);
      return this.options.useErrorBoundary && Ht.add("error"), Object.keys(this.currentResult).some((Wt) => {
        const Gt = Wt;
        return this.currentResult[Gt] !== Pt[Gt] && Ht.has(Gt);
      });
    };
    (Et == null ? void 0 : Et.listeners) !== !1 && Bt() && (Mt.listeners = !0), this.notify({
      ...Mt,
      ...Et
    });
  }
  updateQuery() {
    const Et = this.client.getQueryCache().build(this.client, this.options);
    if (Et === this.currentQuery)
      return;
    const Pt = this.currentQuery;
    this.currentQuery = Et, this.currentQueryInitialState = Et.state, this.previousQueryResult = this.currentResult, this.hasListeners() && (Pt == null || Pt.removeObserver(this), Et.addObserver(this));
  }
  onQueryUpdate(Et) {
    const Pt = {};
    Et.type === "success" ? Pt.onSuccess = !Et.manual : Et.type === "error" && !isCancelledError(Et.error) && (Pt.onError = !0), this.updateResult(Pt), this.hasListeners() && this.updateTimers();
  }
  notify(Et) {
    notifyManager.batch(() => {
      if (Et.onSuccess) {
        var Pt, $t, Mt, Bt;
        (Pt = ($t = this.options).onSuccess) == null || Pt.call($t, this.currentResult.data), (Mt = (Bt = this.options).onSettled) == null || Mt.call(Bt, this.currentResult.data, null);
      } else if (Et.onError) {
        var Vt, zt, Ht, Wt;
        (Vt = (zt = this.options).onError) == null || Vt.call(zt, this.currentResult.error), (Ht = (Wt = this.options).onSettled) == null || Ht.call(Wt, void 0, this.currentResult.error);
      }
      Et.listeners && this.listeners.forEach(({
        listener: Gt
      }) => {
        Gt(this.currentResult);
      }), Et.cache && this.client.getQueryCache().notify({
        query: this.currentQuery,
        type: "observerResultsUpdated"
      });
    });
  }
}
function shouldLoadOnMount(_t, Et) {
  return Et.enabled !== !1 && !_t.state.dataUpdatedAt && !(_t.state.status === "error" && Et.retryOnMount === !1);
}
function shouldFetchOnMount(_t, Et) {
  return shouldLoadOnMount(_t, Et) || _t.state.dataUpdatedAt > 0 && shouldFetchOn(_t, Et, Et.refetchOnMount);
}
function shouldFetchOn(_t, Et, Pt) {
  if (Et.enabled !== !1) {
    const $t = typeof Pt == "function" ? Pt(_t) : Pt;
    return $t === "always" || $t !== !1 && isStale(_t, Et);
  }
  return !1;
}
function shouldFetchOptionally(_t, Et, Pt, $t) {
  return Pt.enabled !== !1 && (_t !== Et || $t.enabled === !1) && (!Pt.suspense || _t.state.status !== "error") && isStale(_t, Pt);
}
function isStale(_t, Et) {
  return _t.isStaleByTime(Et.staleTime);
}
function shouldAssignObserverCurrentProperties(_t, Et, Pt) {
  return Pt.keepPreviousData ? !1 : Pt.placeholderData !== void 0 ? Et.isPlaceholderData : !shallowEqualObjects(_t.getCurrentResult(), Et);
}
var shim = { exports: {} }, useSyncExternalStoreShim_production_min = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredUseSyncExternalStoreShim_production_min;
function requireUseSyncExternalStoreShim_production_min() {
  if (hasRequiredUseSyncExternalStoreShim_production_min)
    return useSyncExternalStoreShim_production_min;
  hasRequiredUseSyncExternalStoreShim_production_min = 1;
  var _t = React__default;
  function Et(qt, Kt) {
    return qt === Kt && (qt !== 0 || 1 / qt === 1 / Kt) || qt !== qt && Kt !== Kt;
  }
  var Pt = typeof Object.is == "function" ? Object.is : Et, $t = _t.useState, Mt = _t.useEffect, Bt = _t.useLayoutEffect, Vt = _t.useDebugValue;
  function zt(qt, Kt) {
    var Qt = Kt(), Xt = $t({ inst: { value: Qt, getSnapshot: Kt } }), Zt = Xt[0].inst, Yt = Xt[1];
    return Bt(function() {
      Zt.value = Qt, Zt.getSnapshot = Kt, Ht(Zt) && Yt({ inst: Zt });
    }, [qt, Qt, Kt]), Mt(function() {
      return Ht(Zt) && Yt({ inst: Zt }), qt(function() {
        Ht(Zt) && Yt({ inst: Zt });
      });
    }, [qt]), Vt(Qt), Qt;
  }
  function Ht(qt) {
    var Kt = qt.getSnapshot;
    qt = qt.value;
    try {
      var Qt = Kt();
      return !Pt(qt, Qt);
    } catch {
      return !0;
    }
  }
  function Wt(qt, Kt) {
    return Kt();
  }
  var Gt = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? Wt : zt;
  return useSyncExternalStoreShim_production_min.useSyncExternalStore = _t.useSyncExternalStore !== void 0 ? _t.useSyncExternalStore : Gt, useSyncExternalStoreShim_production_min;
}
var useSyncExternalStoreShim_development = {}, hasRequiredUseSyncExternalStoreShim_development;
function requireUseSyncExternalStoreShim_development() {
  return hasRequiredUseSyncExternalStoreShim_development || (hasRequiredUseSyncExternalStoreShim_development = 1, browser$1.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var _t = React__default, Et = _t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function Pt(tr) {
      {
        for (var nr = arguments.length, rr = new Array(nr > 1 ? nr - 1 : 0), ir = 1; ir < nr; ir++)
          rr[ir - 1] = arguments[ir];
        $t("error", tr, rr);
      }
    }
    function $t(tr, nr, rr) {
      {
        var ir = Et.ReactDebugCurrentFrame, ar = ir.getStackAddendum();
        ar !== "" && (nr += "%s", rr = rr.concat([ar]));
        var or = rr.map(function(sr) {
          return String(sr);
        });
        or.unshift("Warning: " + nr), Function.prototype.apply.call(console[tr], console, or);
      }
    }
    function Mt(tr, nr) {
      return tr === nr && (tr !== 0 || 1 / tr === 1 / nr) || tr !== tr && nr !== nr;
    }
    var Bt = typeof Object.is == "function" ? Object.is : Mt, Vt = _t.useState, zt = _t.useEffect, Ht = _t.useLayoutEffect, Wt = _t.useDebugValue, Gt = !1, qt = !1;
    function Kt(tr, nr, rr) {
      Gt || _t.startTransition !== void 0 && (Gt = !0, Pt("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var ir = nr();
      if (!qt) {
        var ar = nr();
        Bt(ir, ar) || (Pt("The result of getSnapshot should be cached to avoid an infinite loop"), qt = !0);
      }
      var or = Vt({
        inst: {
          value: ir,
          getSnapshot: nr
        }
      }), sr = or[0].inst, lr = or[1];
      return Ht(function() {
        sr.value = ir, sr.getSnapshot = nr, Qt(sr) && lr({
          inst: sr
        });
      }, [tr, ir, nr]), zt(function() {
        Qt(sr) && lr({
          inst: sr
        });
        var cr = function() {
          Qt(sr) && lr({
            inst: sr
          });
        };
        return tr(cr);
      }, [tr]), Wt(ir), ir;
    }
    function Qt(tr) {
      var nr = tr.getSnapshot, rr = tr.value;
      try {
        var ir = nr();
        return !Bt(rr, ir);
      } catch {
        return !0;
      }
    }
    function Xt(tr, nr, rr) {
      return nr();
    }
    var Zt = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", Yt = !Zt, Jt = Yt ? Xt : Kt, er = _t.useSyncExternalStore !== void 0 ? _t.useSyncExternalStore : Jt;
    useSyncExternalStoreShim_development.useSyncExternalStore = er, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), useSyncExternalStoreShim_development;
}
browser$1.env.NODE_ENV === "production" ? shim.exports = requireUseSyncExternalStoreShim_production_min() : shim.exports = requireUseSyncExternalStoreShim_development();
var shimExports = shim.exports;
const useSyncExternalStore = shimExports.useSyncExternalStore, defaultContext = /* @__PURE__ */ React.createContext(void 0), QueryClientSharingContext = /* @__PURE__ */ React.createContext(!1);
function getQueryClientContext(_t, Et) {
  return _t || (Et && typeof window < "u" ? (window.ReactQueryClientContext || (window.ReactQueryClientContext = defaultContext), window.ReactQueryClientContext) : defaultContext);
}
const useQueryClient = ({
  context: _t
} = {}) => {
  const Et = React.useContext(getQueryClientContext(_t, React.useContext(QueryClientSharingContext)));
  if (!Et)
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  return Et;
}, QueryClientProvider = ({
  client: _t,
  children: Et,
  context: Pt,
  contextSharing: $t = !1
}) => {
  React.useEffect(() => (_t.mount(), () => {
    _t.unmount();
  }), [_t]), process.env.NODE_ENV !== "production" && $t && _t.getLogger().error("The contextSharing option has been deprecated and will be removed in the next major version");
  const Mt = getQueryClientContext(Pt, $t);
  return /* @__PURE__ */ React.createElement(QueryClientSharingContext.Provider, {
    value: !Pt && $t
  }, /* @__PURE__ */ React.createElement(Mt.Provider, {
    value: _t
  }, Et));
}, IsRestoringContext = /* @__PURE__ */ React.createContext(!1), useIsRestoring = () => React.useContext(IsRestoringContext);
IsRestoringContext.Provider;
function createValue() {
  let _t = !1;
  return {
    clearReset: () => {
      _t = !1;
    },
    reset: () => {
      _t = !0;
    },
    isReset: () => _t
  };
}
const QueryErrorResetBoundaryContext = /* @__PURE__ */ React.createContext(createValue()), useQueryErrorResetBoundary = () => React.useContext(QueryErrorResetBoundaryContext);
function shouldThrowError(_t, Et) {
  return typeof _t == "function" ? _t(...Et) : !!_t;
}
const ensurePreventErrorBoundaryRetry = (_t, Et) => {
  (_t.suspense || _t.useErrorBoundary) && (Et.isReset() || (_t.retryOnMount = !1));
}, useClearResetErrorBoundary = (_t) => {
  React.useEffect(() => {
    _t.clearReset();
  }, [_t]);
}, getHasError = ({
  result: _t,
  errorResetBoundary: Et,
  useErrorBoundary: Pt,
  query: $t
}) => _t.isError && !Et.isReset() && !_t.isFetching && shouldThrowError(Pt, [_t.error, $t]), ensureStaleTime = (_t) => {
  _t.suspense && typeof _t.staleTime != "number" && (_t.staleTime = 1e3);
}, willFetch = (_t, Et) => _t.isLoading && _t.isFetching && !Et, shouldSuspend = (_t, Et, Pt) => (_t == null ? void 0 : _t.suspense) && willFetch(Et, Pt), fetchOptimistic = (_t, Et, Pt) => Et.fetchOptimistic(_t).then(({
  data: $t
}) => {
  _t.onSuccess == null || _t.onSuccess($t), _t.onSettled == null || _t.onSettled($t, null);
}).catch(($t) => {
  Pt.clearReset(), _t.onError == null || _t.onError($t), _t.onSettled == null || _t.onSettled(void 0, $t);
});
function useBaseQuery(_t, Et) {
  const Pt = useQueryClient({
    context: _t.context
  }), $t = useIsRestoring(), Mt = useQueryErrorResetBoundary(), Bt = Pt.defaultQueryOptions(_t);
  Bt._optimisticResults = $t ? "isRestoring" : "optimistic", Bt.onError && (Bt.onError = notifyManager.batchCalls(Bt.onError)), Bt.onSuccess && (Bt.onSuccess = notifyManager.batchCalls(Bt.onSuccess)), Bt.onSettled && (Bt.onSettled = notifyManager.batchCalls(Bt.onSettled)), ensureStaleTime(Bt), ensurePreventErrorBoundaryRetry(Bt, Mt), useClearResetErrorBoundary(Mt);
  const [Vt] = React.useState(() => new Et(Pt, Bt)), zt = Vt.getOptimisticResult(Bt);
  if (useSyncExternalStore(React.useCallback((Ht) => {
    const Wt = $t ? () => {
    } : Vt.subscribe(notifyManager.batchCalls(Ht));
    return Vt.updateResult(), Wt;
  }, [Vt, $t]), () => Vt.getCurrentResult(), () => Vt.getCurrentResult()), React.useEffect(() => {
    Vt.setOptions(Bt, {
      listeners: !1
    });
  }, [Bt, Vt]), shouldSuspend(Bt, zt, $t))
    throw fetchOptimistic(Bt, Vt, Mt);
  if (getHasError({
    result: zt,
    errorResetBoundary: Mt,
    useErrorBoundary: Bt.useErrorBoundary,
    query: Vt.getCurrentQuery()
  }))
    throw zt.error;
  return Bt.notifyOnChangeProps ? zt : Vt.trackResult(zt);
}
function useQuery(_t, Et, Pt) {
  const $t = parseQueryArgs(_t, Et, Pt);
  return useBaseQuery($t, QueryObserver);
}
const useMenuURLS = ({
  workspaceId: _t,
  orgId: Et
}) => {
  const Pt = useConfig$1(), $t = useMemo$1(() => `${Pt.getFarmSettingsURL()}/app/deep-actions/invite-members?workspace=${_t}&invite_level=workspace&callback_uri=${window.location.href}`, [Pt, _t]), Mt = useMemo$1(() => `${Pt.getAccountsURL()}/app/workspaces/members?workspace=${_t}&organization=${Et}`, [Pt, Et, _t]), Bt = useMemo$1(() => `${Pt.getAccountsURL()}/app/quota?workspace=${_t}&organization=${Et}`, [Pt, Et, _t]);
  return {
    inviteMembersDeepActionURL: $t,
    membersAndContantURL: Mt,
    quotaMgtURL: Bt
  };
};
var IconContext = /* @__PURE__ */ createContext({});
function _extends$2() {
  return _extends$2 = Object.assign ? Object.assign.bind() : function(_t) {
    for (var Et = 1; Et < arguments.length; Et++) {
      var Pt = arguments[Et];
      for (var $t in Pt)
        ({}).hasOwnProperty.call(Pt, $t) && (_t[$t] = Pt[$t]);
    }
    return _t;
  }, _extends$2.apply(null, arguments);
}
function _arrayWithHoles(_t) {
  if (Array.isArray(_t))
    return _t;
}
function _iterableToArrayLimit(_t, Et) {
  var Pt = _t == null ? null : typeof Symbol < "u" && _t[Symbol.iterator] || _t["@@iterator"];
  if (Pt != null) {
    var $t, Mt, Bt, Vt, zt = [], Ht = !0, Wt = !1;
    try {
      if (Bt = (Pt = Pt.call(_t)).next, Et === 0) {
        if (Object(Pt) !== Pt)
          return;
        Ht = !1;
      } else
        for (; !(Ht = ($t = Bt.call(Pt)).done) && (zt.push($t.value), zt.length !== Et); Ht = !0)
          ;
    } catch (Gt) {
      Wt = !0, Mt = Gt;
    } finally {
      try {
        if (!Ht && Pt.return != null && (Vt = Pt.return(), Object(Vt) !== Vt))
          return;
      } finally {
        if (Wt)
          throw Mt;
      }
    }
    return zt;
  }
}
function _arrayLikeToArray(_t, Et) {
  (Et == null || Et > _t.length) && (Et = _t.length);
  for (var Pt = 0, $t = Array(Et); Pt < Et; Pt++)
    $t[Pt] = _t[Pt];
  return $t;
}
function _unsupportedIterableToArray(_t, Et) {
  if (_t) {
    if (typeof _t == "string")
      return _arrayLikeToArray(_t, Et);
    var Pt = {}.toString.call(_t).slice(8, -1);
    return Pt === "Object" && _t.constructor && (Pt = _t.constructor.name), Pt === "Map" || Pt === "Set" ? Array.from(_t) : Pt === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Pt) ? _arrayLikeToArray(_t, Et) : void 0;
  }
}
function _nonIterableRest() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _slicedToArray(_t, Et) {
  return _arrayWithHoles(_t) || _iterableToArrayLimit(_t, Et) || _unsupportedIterableToArray(_t, Et) || _nonIterableRest();
}
function _typeof(_t) {
  "@babel/helpers - typeof";
  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Et) {
    return typeof Et;
  } : function(Et) {
    return Et && typeof Symbol == "function" && Et.constructor === Symbol && Et !== Symbol.prototype ? "symbol" : typeof Et;
  }, _typeof(_t);
}
function toPrimitive(_t, Et) {
  if (_typeof(_t) != "object" || !_t)
    return _t;
  var Pt = _t[Symbol.toPrimitive];
  if (Pt !== void 0) {
    var $t = Pt.call(_t, Et || "default");
    if (_typeof($t) != "object")
      return $t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (Et === "string" ? String : Number)(_t);
}
function toPropertyKey(_t) {
  var Et = toPrimitive(_t, "string");
  return _typeof(Et) == "symbol" ? Et : Et + "";
}
function _defineProperty(_t, Et, Pt) {
  return (Et = toPropertyKey(Et)) in _t ? Object.defineProperty(_t, Et, {
    value: Pt,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : _t[Et] = Pt, _t;
}
function _objectWithoutPropertiesLoose(_t, Et) {
  if (_t == null)
    return {};
  var Pt = {};
  for (var $t in _t)
    if ({}.hasOwnProperty.call(_t, $t)) {
      if (Et.includes($t))
        continue;
      Pt[$t] = _t[$t];
    }
  return Pt;
}
function _objectWithoutProperties$2(_t, Et) {
  if (_t == null)
    return {};
  var Pt, $t, Mt = _objectWithoutPropertiesLoose(_t, Et);
  if (Object.getOwnPropertySymbols) {
    var Bt = Object.getOwnPropertySymbols(_t);
    for ($t = 0; $t < Bt.length; $t++)
      Pt = Bt[$t], Et.includes(Pt) || {}.propertyIsEnumerable.call(_t, Pt) && (Mt[Pt] = _t[Pt]);
  }
  return Mt;
}
var classnames = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(_t) {
  (function() {
    var Et = {}.hasOwnProperty;
    function Pt() {
      for (var Bt = "", Vt = 0; Vt < arguments.length; Vt++) {
        var zt = arguments[Vt];
        zt && (Bt = Mt(Bt, $t(zt)));
      }
      return Bt;
    }
    function $t(Bt) {
      if (typeof Bt == "string" || typeof Bt == "number")
        return Bt;
      if (typeof Bt != "object")
        return "";
      if (Array.isArray(Bt))
        return Pt.apply(null, Bt);
      if (Bt.toString !== Object.prototype.toString && !Bt.toString.toString().includes("[native code]"))
        return Bt.toString();
      var Vt = "";
      for (var zt in Bt)
        Et.call(Bt, zt) && Bt[zt] && (Vt = Mt(Vt, zt));
      return Vt;
    }
    function Mt(Bt, Vt) {
      return Vt ? Bt ? Bt + " " + Vt : Bt + Vt : Bt;
    }
    _t.exports ? (Pt.default = Pt, _t.exports = Pt) : window.classNames = Pt;
  })();
})(classnames);
var classnamesExports = classnames.exports;
const classNames = /* @__PURE__ */ getDefaultExportFromCjs(classnamesExports), round$1 = Math.round;
function splitColorStr(_t, Et) {
  const Pt = _t.replace(/^[^(]*\((.*)/, "$1").replace(/\).*/, "").match(/\d*\.?\d+%?/g) || [], $t = Pt.map((Mt) => parseFloat(Mt));
  for (let Mt = 0; Mt < 3; Mt += 1)
    $t[Mt] = Et($t[Mt] || 0, Pt[Mt] || "", Mt);
  return Pt[3] ? $t[3] = Pt[3].includes("%") ? $t[3] / 100 : $t[3] : $t[3] = 1, $t;
}
const parseHSVorHSL = (_t, Et, Pt) => Pt === 0 ? _t : _t / 100;
function limitRange(_t, Et) {
  const Pt = Et || 255;
  return _t > Pt ? Pt : _t < 0 ? 0 : _t;
}
class FastColor {
  constructor(Et) {
    _defineProperty(this, "isValid", !0), _defineProperty(this, "r", 0), _defineProperty(this, "g", 0), _defineProperty(this, "b", 0), _defineProperty(this, "a", 1), _defineProperty(this, "_h", void 0), _defineProperty(this, "_s", void 0), _defineProperty(this, "_l", void 0), _defineProperty(this, "_v", void 0), _defineProperty(this, "_max", void 0), _defineProperty(this, "_min", void 0), _defineProperty(this, "_brightness", void 0);
    function Pt($t) {
      return $t[0] in Et && $t[1] in Et && $t[2] in Et;
    }
    if (Et)
      if (typeof Et == "string") {
        let Mt = function(Bt) {
          return $t.startsWith(Bt);
        };
        const $t = Et.trim();
        /^#?[A-F\d]{3,8}$/i.test($t) ? this.fromHexString($t) : Mt("rgb") ? this.fromRgbString($t) : Mt("hsl") ? this.fromHslString($t) : (Mt("hsv") || Mt("hsb")) && this.fromHsvString($t);
      } else if (Et instanceof FastColor)
        this.r = Et.r, this.g = Et.g, this.b = Et.b, this.a = Et.a, this._h = Et._h, this._s = Et._s, this._l = Et._l, this._v = Et._v;
      else if (Pt("rgb"))
        this.r = limitRange(Et.r), this.g = limitRange(Et.g), this.b = limitRange(Et.b), this.a = typeof Et.a == "number" ? limitRange(Et.a, 1) : 1;
      else if (Pt("hsl"))
        this.fromHsl(Et);
      else if (Pt("hsv"))
        this.fromHsv(Et);
      else
        throw new Error("@ant-design/fast-color: unsupported input " + JSON.stringify(Et));
  }
  // ======================= Setter =======================
  setR(Et) {
    return this._sc("r", Et);
  }
  setG(Et) {
    return this._sc("g", Et);
  }
  setB(Et) {
    return this._sc("b", Et);
  }
  setA(Et) {
    return this._sc("a", Et, 1);
  }
  setHue(Et) {
    const Pt = this.toHsv();
    return Pt.h = Et, this._c(Pt);
  }
  // ======================= Getter =======================
  /**
   * Returns the perceived luminance of a color, from 0-1.
   * @see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
   */
  getLuminance() {
    function Et(Bt) {
      const Vt = Bt / 255;
      return Vt <= 0.03928 ? Vt / 12.92 : Math.pow((Vt + 0.055) / 1.055, 2.4);
    }
    const Pt = Et(this.r), $t = Et(this.g), Mt = Et(this.b);
    return 0.2126 * Pt + 0.7152 * $t + 0.0722 * Mt;
  }
  getHue() {
    if (typeof this._h > "u") {
      const Et = this.getMax() - this.getMin();
      Et === 0 ? this._h = 0 : this._h = round$1(60 * (this.r === this.getMax() ? (this.g - this.b) / Et + (this.g < this.b ? 6 : 0) : this.g === this.getMax() ? (this.b - this.r) / Et + 2 : (this.r - this.g) / Et + 4));
    }
    return this._h;
  }
  getSaturation() {
    if (typeof this._s > "u") {
      const Et = this.getMax() - this.getMin();
      Et === 0 ? this._s = 0 : this._s = Et / this.getMax();
    }
    return this._s;
  }
  getLightness() {
    return typeof this._l > "u" && (this._l = (this.getMax() + this.getMin()) / 510), this._l;
  }
  getValue() {
    return typeof this._v > "u" && (this._v = this.getMax() / 255), this._v;
  }
  /**
   * Returns the perceived brightness of the color, from 0-255.
   * Note: this is not the b of HSB
   * @see http://www.w3.org/TR/AERT#color-contrast
   */
  getBrightness() {
    return typeof this._brightness > "u" && (this._brightness = (this.r * 299 + this.g * 587 + this.b * 114) / 1e3), this._brightness;
  }
  // ======================== Func ========================
  darken(Et = 10) {
    const Pt = this.getHue(), $t = this.getSaturation();
    let Mt = this.getLightness() - Et / 100;
    return Mt < 0 && (Mt = 0), this._c({
      h: Pt,
      s: $t,
      l: Mt,
      a: this.a
    });
  }
  lighten(Et = 10) {
    const Pt = this.getHue(), $t = this.getSaturation();
    let Mt = this.getLightness() + Et / 100;
    return Mt > 1 && (Mt = 1), this._c({
      h: Pt,
      s: $t,
      l: Mt,
      a: this.a
    });
  }
  /**
   * Mix the current color a given amount with another color, from 0 to 100.
   * 0 means no mixing (return current color).
   */
  mix(Et, Pt = 50) {
    const $t = this._c(Et), Mt = Pt / 100, Bt = (zt) => ($t[zt] - this[zt]) * Mt + this[zt], Vt = {
      r: round$1(Bt("r")),
      g: round$1(Bt("g")),
      b: round$1(Bt("b")),
      a: round$1(Bt("a") * 100) / 100
    };
    return this._c(Vt);
  }
  /**
   * Mix the color with pure white, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return white.
   */
  tint(Et = 10) {
    return this.mix({
      r: 255,
      g: 255,
      b: 255,
      a: 1
    }, Et);
  }
  /**
   * Mix the color with pure black, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return black.
   */
  shade(Et = 10) {
    return this.mix({
      r: 0,
      g: 0,
      b: 0,
      a: 1
    }, Et);
  }
  onBackground(Et) {
    const Pt = this._c(Et), $t = this.a + Pt.a * (1 - this.a), Mt = (Bt) => round$1((this[Bt] * this.a + Pt[Bt] * Pt.a * (1 - this.a)) / $t);
    return this._c({
      r: Mt("r"),
      g: Mt("g"),
      b: Mt("b"),
      a: $t
    });
  }
  // ======================= Status =======================
  isDark() {
    return this.getBrightness() < 128;
  }
  isLight() {
    return this.getBrightness() >= 128;
  }
  // ======================== MISC ========================
  equals(Et) {
    return this.r === Et.r && this.g === Et.g && this.b === Et.b && this.a === Et.a;
  }
  clone() {
    return this._c(this);
  }
  // ======================= Format =======================
  toHexString() {
    let Et = "#";
    const Pt = (this.r || 0).toString(16);
    Et += Pt.length === 2 ? Pt : "0" + Pt;
    const $t = (this.g || 0).toString(16);
    Et += $t.length === 2 ? $t : "0" + $t;
    const Mt = (this.b || 0).toString(16);
    if (Et += Mt.length === 2 ? Mt : "0" + Mt, typeof this.a == "number" && this.a >= 0 && this.a < 1) {
      const Bt = round$1(this.a * 255).toString(16);
      Et += Bt.length === 2 ? Bt : "0" + Bt;
    }
    return Et;
  }
  /** CSS support color pattern */
  toHsl() {
    return {
      h: this.getHue(),
      s: this.getSaturation(),
      l: this.getLightness(),
      a: this.a
    };
  }
  /** CSS support color pattern */
  toHslString() {
    const Et = this.getHue(), Pt = round$1(this.getSaturation() * 100), $t = round$1(this.getLightness() * 100);
    return this.a !== 1 ? `hsla(${Et},${Pt}%,${$t}%,${this.a})` : `hsl(${Et},${Pt}%,${$t}%)`;
  }
  /** Same as toHsb */
  toHsv() {
    return {
      h: this.getHue(),
      s: this.getSaturation(),
      v: this.getValue(),
      a: this.a
    };
  }
  toRgb() {
    return {
      r: this.r,
      g: this.g,
      b: this.b,
      a: this.a
    };
  }
  toRgbString() {
    return this.a !== 1 ? `rgba(${this.r},${this.g},${this.b},${this.a})` : `rgb(${this.r},${this.g},${this.b})`;
  }
  toString() {
    return this.toRgbString();
  }
  // ====================== Privates ======================
  /** Return a new FastColor object with one channel changed */
  _sc(Et, Pt, $t) {
    const Mt = this.clone();
    return Mt[Et] = limitRange(Pt, $t), Mt;
  }
  _c(Et) {
    return new this.constructor(Et);
  }
  getMax() {
    return typeof this._max > "u" && (this._max = Math.max(this.r, this.g, this.b)), this._max;
  }
  getMin() {
    return typeof this._min > "u" && (this._min = Math.min(this.r, this.g, this.b)), this._min;
  }
  fromHexString(Et) {
    const Pt = Et.replace("#", "");
    function $t(Mt, Bt) {
      return parseInt(Pt[Mt] + Pt[Bt || Mt], 16);
    }
    Pt.length < 6 ? (this.r = $t(0), this.g = $t(1), this.b = $t(2), this.a = Pt[3] ? $t(3) / 255 : 1) : (this.r = $t(0, 1), this.g = $t(2, 3), this.b = $t(4, 5), this.a = Pt[6] ? $t(6, 7) / 255 : 1);
  }
  fromHsl({
    h: Et,
    s: Pt,
    l: $t,
    a: Mt
  }) {
    if (this._h = Et % 360, this._s = Pt, this._l = $t, this.a = typeof Mt == "number" ? Mt : 1, Pt <= 0) {
      const Kt = round$1($t * 255);
      this.r = Kt, this.g = Kt, this.b = Kt;
    }
    let Bt = 0, Vt = 0, zt = 0;
    const Ht = Et / 60, Wt = (1 - Math.abs(2 * $t - 1)) * Pt, Gt = Wt * (1 - Math.abs(Ht % 2 - 1));
    Ht >= 0 && Ht < 1 ? (Bt = Wt, Vt = Gt) : Ht >= 1 && Ht < 2 ? (Bt = Gt, Vt = Wt) : Ht >= 2 && Ht < 3 ? (Vt = Wt, zt = Gt) : Ht >= 3 && Ht < 4 ? (Vt = Gt, zt = Wt) : Ht >= 4 && Ht < 5 ? (Bt = Gt, zt = Wt) : Ht >= 5 && Ht < 6 && (Bt = Wt, zt = Gt);
    const qt = $t - Wt / 2;
    this.r = round$1((Bt + qt) * 255), this.g = round$1((Vt + qt) * 255), this.b = round$1((zt + qt) * 255);
  }
  fromHsv({
    h: Et,
    s: Pt,
    v: $t,
    a: Mt
  }) {
    this._h = Et % 360, this._s = Pt, this._v = $t, this.a = typeof Mt == "number" ? Mt : 1;
    const Bt = round$1($t * 255);
    if (this.r = Bt, this.g = Bt, this.b = Bt, Pt <= 0)
      return;
    const Vt = Et / 60, zt = Math.floor(Vt), Ht = Vt - zt, Wt = round$1($t * (1 - Pt) * 255), Gt = round$1($t * (1 - Pt * Ht) * 255), qt = round$1($t * (1 - Pt * (1 - Ht)) * 255);
    switch (zt) {
      case 0:
        this.g = qt, this.b = Wt;
        break;
      case 1:
        this.r = Gt, this.b = Wt;
        break;
      case 2:
        this.r = Wt, this.b = qt;
        break;
      case 3:
        this.r = Wt, this.g = Gt;
        break;
      case 4:
        this.r = qt, this.g = Wt;
        break;
      case 5:
      default:
        this.g = Wt, this.b = Gt;
        break;
    }
  }
  fromHsvString(Et) {
    const Pt = splitColorStr(Et, parseHSVorHSL);
    this.fromHsv({
      h: Pt[0],
      s: Pt[1],
      v: Pt[2],
      a: Pt[3]
    });
  }
  fromHslString(Et) {
    const Pt = splitColorStr(Et, parseHSVorHSL);
    this.fromHsl({
      h: Pt[0],
      s: Pt[1],
      l: Pt[2],
      a: Pt[3]
    });
  }
  fromRgbString(Et) {
    const Pt = splitColorStr(Et, ($t, Mt) => (
      // Convert percentage to number. e.g. 50% -> 128
      Mt.includes("%") ? round$1($t / 100 * 255) : $t
    ));
    this.r = Pt[0], this.g = Pt[1], this.b = Pt[2], this.a = Pt[3];
  }
}
var hueStep = 2, saturationStep = 0.16, saturationStep2 = 0.05, brightnessStep1 = 0.05, brightnessStep2 = 0.15, lightColorCount = 5, darkColorCount = 4, darkColorMap = [{
  index: 7,
  amount: 15
}, {
  index: 6,
  amount: 25
}, {
  index: 5,
  amount: 30
}, {
  index: 5,
  amount: 45
}, {
  index: 5,
  amount: 65
}, {
  index: 5,
  amount: 85
}, {
  index: 4,
  amount: 90
}, {
  index: 3,
  amount: 95
}, {
  index: 2,
  amount: 97
}, {
  index: 1,
  amount: 98
}];
function getHue(_t, Et, Pt) {
  var $t;
  return Math.round(_t.h) >= 60 && Math.round(_t.h) <= 240 ? $t = Pt ? Math.round(_t.h) - hueStep * Et : Math.round(_t.h) + hueStep * Et : $t = Pt ? Math.round(_t.h) + hueStep * Et : Math.round(_t.h) - hueStep * Et, $t < 0 ? $t += 360 : $t >= 360 && ($t -= 360), $t;
}
function getSaturation(_t, Et, Pt) {
  if (_t.h === 0 && _t.s === 0)
    return _t.s;
  var $t;
  return Pt ? $t = _t.s - saturationStep * Et : Et === darkColorCount ? $t = _t.s + saturationStep : $t = _t.s + saturationStep2 * Et, $t > 1 && ($t = 1), Pt && Et === lightColorCount && $t > 0.1 && ($t = 0.1), $t < 0.06 && ($t = 0.06), Math.round($t * 100) / 100;
}
function getValue$1(_t, Et, Pt) {
  var $t;
  return Pt ? $t = _t.v + brightnessStep1 * Et : $t = _t.v - brightnessStep2 * Et, $t = Math.max(0, Math.min(1, $t)), Math.round($t * 100) / 100;
}
function generate$1(_t) {
  for (var Et = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Pt = [], $t = new FastColor(_t), Mt = $t.toHsv(), Bt = lightColorCount; Bt > 0; Bt -= 1) {
    var Vt = new FastColor({
      h: getHue(Mt, Bt, !0),
      s: getSaturation(Mt, Bt, !0),
      v: getValue$1(Mt, Bt, !0)
    });
    Pt.push(Vt);
  }
  Pt.push($t);
  for (var zt = 1; zt <= darkColorCount; zt += 1) {
    var Ht = new FastColor({
      h: getHue(Mt, zt),
      s: getSaturation(Mt, zt),
      v: getValue$1(Mt, zt)
    });
    Pt.push(Ht);
  }
  return Et.theme === "dark" ? darkColorMap.map(function(Wt) {
    var Gt = Wt.index, qt = Wt.amount;
    return new FastColor(Et.backgroundColor || "#141414").mix(Pt[Gt], qt).toHexString();
  }) : Pt.map(function(Wt) {
    return Wt.toHexString();
  });
}
var presetPrimaryColors = {
  red: "#F5222D",
  volcano: "#FA541C",
  orange: "#FA8C16",
  gold: "#FAAD14",
  yellow: "#FADB14",
  lime: "#A0D911",
  green: "#52C41A",
  cyan: "#13C2C2",
  blue: "#1677FF",
  geekblue: "#2F54EB",
  purple: "#722ED1",
  magenta: "#EB2F96",
  grey: "#666666"
}, red = ["#fff1f0", "#ffccc7", "#ffa39e", "#ff7875", "#ff4d4f", "#f5222d", "#cf1322", "#a8071a", "#820014", "#5c0011"];
red.primary = red[5];
var volcano = ["#fff2e8", "#ffd8bf", "#ffbb96", "#ff9c6e", "#ff7a45", "#fa541c", "#d4380d", "#ad2102", "#871400", "#610b00"];
volcano.primary = volcano[5];
var orange = ["#fff7e6", "#ffe7ba", "#ffd591", "#ffc069", "#ffa940", "#fa8c16", "#d46b08", "#ad4e00", "#873800", "#612500"];
orange.primary = orange[5];
var gold = ["#fffbe6", "#fff1b8", "#ffe58f", "#ffd666", "#ffc53d", "#faad14", "#d48806", "#ad6800", "#874d00", "#613400"];
gold.primary = gold[5];
var yellow = ["#feffe6", "#ffffb8", "#fffb8f", "#fff566", "#ffec3d", "#fadb14", "#d4b106", "#ad8b00", "#876800", "#614700"];
yellow.primary = yellow[5];
var lime = ["#fcffe6", "#f4ffb8", "#eaff8f", "#d3f261", "#bae637", "#a0d911", "#7cb305", "#5b8c00", "#3f6600", "#254000"];
lime.primary = lime[5];
var green = ["#f6ffed", "#d9f7be", "#b7eb8f", "#95de64", "#73d13d", "#52c41a", "#389e0d", "#237804", "#135200", "#092b00"];
green.primary = green[5];
var cyan = ["#e6fffb", "#b5f5ec", "#87e8de", "#5cdbd3", "#36cfc9", "#13c2c2", "#08979c", "#006d75", "#00474f", "#002329"];
cyan.primary = cyan[5];
var blue = ["#e6f4ff", "#bae0ff", "#91caff", "#69b1ff", "#4096ff", "#1677ff", "#0958d9", "#003eb3", "#002c8c", "#001d66"];
blue.primary = blue[5];
var geekblue = ["#f0f5ff", "#d6e4ff", "#adc6ff", "#85a5ff", "#597ef7", "#2f54eb", "#1d39c4", "#10239e", "#061178", "#030852"];
geekblue.primary = geekblue[5];
var purple = ["#f9f0ff", "#efdbff", "#d3adf7", "#b37feb", "#9254de", "#722ed1", "#531dab", "#391085", "#22075e", "#120338"];
purple.primary = purple[5];
var magenta = ["#fff0f6", "#ffd6e7", "#ffadd2", "#ff85c0", "#f759ab", "#eb2f96", "#c41d7f", "#9e1068", "#780650", "#520339"];
magenta.primary = magenta[5];
var grey = ["#a6a6a6", "#999999", "#8c8c8c", "#808080", "#737373", "#666666", "#404040", "#1a1a1a", "#000000", "#000000"];
grey.primary = grey[5];
var presetPalettes = {
  red,
  volcano,
  orange,
  gold,
  yellow,
  lime,
  green,
  cyan,
  blue,
  geekblue,
  purple,
  magenta,
  grey
};
function ownKeys(_t, Et) {
  var Pt = Object.keys(_t);
  if (Object.getOwnPropertySymbols) {
    var $t = Object.getOwnPropertySymbols(_t);
    Et && ($t = $t.filter(function(Mt) {
      return Object.getOwnPropertyDescriptor(_t, Mt).enumerable;
    })), Pt.push.apply(Pt, $t);
  }
  return Pt;
}
function _objectSpread2(_t) {
  for (var Et = 1; Et < arguments.length; Et++) {
    var Pt = arguments[Et] != null ? arguments[Et] : {};
    Et % 2 ? ownKeys(Object(Pt), !0).forEach(function($t) {
      _defineProperty(_t, $t, Pt[$t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(_t, Object.getOwnPropertyDescriptors(Pt)) : ownKeys(Object(Pt)).forEach(function($t) {
      Object.defineProperty(_t, $t, Object.getOwnPropertyDescriptor(Pt, $t));
    });
  }
  return _t;
}
function canUseDom() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function contains(_t, Et) {
  if (!_t)
    return !1;
  if (_t.contains)
    return _t.contains(Et);
  for (var Pt = Et; Pt; ) {
    if (Pt === _t)
      return !0;
    Pt = Pt.parentNode;
  }
  return !1;
}
var APPEND_ORDER = "data-rc-order", APPEND_PRIORITY = "data-rc-priority", MARK_KEY = "rc-util-key", containerCache = /* @__PURE__ */ new Map();
function getMark() {
  var _t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, Et = _t.mark;
  return Et ? Et.startsWith("data-") ? Et : "data-".concat(Et) : MARK_KEY;
}
function getContainer(_t) {
  if (_t.attachTo)
    return _t.attachTo;
  var Et = document.querySelector("head");
  return Et || document.body;
}
function getOrder(_t) {
  return _t === "queue" ? "prependQueue" : _t ? "prepend" : "append";
}
function findStyles(_t) {
  return Array.from((containerCache.get(_t) || _t).children).filter(function(Et) {
    return Et.tagName === "STYLE";
  });
}
function injectCSS(_t) {
  var Et = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!canUseDom())
    return null;
  var Pt = Et.csp, $t = Et.prepend, Mt = Et.priority, Bt = Mt === void 0 ? 0 : Mt, Vt = getOrder($t), zt = Vt === "prependQueue", Ht = document.createElement("style");
  Ht.setAttribute(APPEND_ORDER, Vt), zt && Bt && Ht.setAttribute(APPEND_PRIORITY, "".concat(Bt)), Pt != null && Pt.nonce && (Ht.nonce = Pt == null ? void 0 : Pt.nonce), Ht.innerHTML = _t;
  var Wt = getContainer(Et), Gt = Wt.firstChild;
  if ($t) {
    if (zt) {
      var qt = (Et.styles || findStyles(Wt)).filter(function(Kt) {
        if (!["prepend", "prependQueue"].includes(Kt.getAttribute(APPEND_ORDER)))
          return !1;
        var Qt = Number(Kt.getAttribute(APPEND_PRIORITY) || 0);
        return Bt >= Qt;
      });
      if (qt.length)
        return Wt.insertBefore(Ht, qt[qt.length - 1].nextSibling), Ht;
    }
    Wt.insertBefore(Ht, Gt);
  } else
    Wt.appendChild(Ht);
  return Ht;
}
function findExistNode(_t) {
  var Et = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Pt = getContainer(Et);
  return (Et.styles || findStyles(Pt)).find(function($t) {
    return $t.getAttribute(getMark(Et)) === _t;
  });
}
function removeCSS(_t) {
  var Et = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Pt = findExistNode(_t, Et);
  if (Pt) {
    var $t = getContainer(Et);
    $t.removeChild(Pt);
  }
}
function syncRealContainer(_t, Et) {
  var Pt = containerCache.get(_t);
  if (!Pt || !contains(document, Pt)) {
    var $t = injectCSS("", Et), Mt = $t.parentNode;
    containerCache.set(_t, Mt), _t.removeChild($t);
  }
}
function updateCSS(_t, Et) {
  var Pt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, $t = getContainer(Pt), Mt = findStyles($t), Bt = _objectSpread2(_objectSpread2({}, Pt), {}, {
    styles: Mt
  });
  syncRealContainer($t, Bt);
  var Vt = findExistNode(Et, Bt);
  if (Vt) {
    var zt, Ht;
    if ((zt = Bt.csp) !== null && zt !== void 0 && zt.nonce && Vt.nonce !== ((Ht = Bt.csp) === null || Ht === void 0 ? void 0 : Ht.nonce)) {
      var Wt;
      Vt.nonce = (Wt = Bt.csp) === null || Wt === void 0 ? void 0 : Wt.nonce;
    }
    return Vt.innerHTML !== _t && (Vt.innerHTML = _t), Vt;
  }
  var Gt = injectCSS(_t, Bt);
  return Gt.setAttribute(getMark(Bt), Et), Gt;
}
function getRoot(_t) {
  var Et;
  return _t == null || (Et = _t.getRootNode) === null || Et === void 0 ? void 0 : Et.call(_t);
}
function inShadow(_t) {
  return getRoot(_t) instanceof ShadowRoot;
}
function getShadowRoot(_t) {
  return inShadow(_t) ? getRoot(_t) : null;
}
var warned = {}, preWarningFns = [], preMessage = function(Et) {
  preWarningFns.push(Et);
};
function warning$3(_t, Et) {
  if (browser$1.env.NODE_ENV !== "production" && !_t && console !== void 0) {
    var Pt = preWarningFns.reduce(function($t, Mt) {
      return Mt($t ?? "", "warning");
    }, Et);
    Pt && console.error("Warning: ".concat(Pt));
  }
}
function note(_t, Et) {
  if (browser$1.env.NODE_ENV !== "production" && !_t && console !== void 0) {
    var Pt = preWarningFns.reduce(function($t, Mt) {
      return Mt($t ?? "", "note");
    }, Et);
    Pt && console.warn("Note: ".concat(Pt));
  }
}
function resetWarned$1() {
  warned = {};
}
function call(_t, Et, Pt) {
  !Et && !warned[Pt] && (_t(!1, Pt), warned[Pt] = !0);
}
function warningOnce(_t, Et) {
  call(warning$3, _t, Et);
}
function noteOnce(_t, Et) {
  call(note, _t, Et);
}
warningOnce.preMessage = preMessage;
warningOnce.resetWarned = resetWarned$1;
warningOnce.noteOnce = noteOnce;
function camelCase(_t) {
  return _t.replace(/-(.)/g, function(Et, Pt) {
    return Pt.toUpperCase();
  });
}
function warning$2(_t, Et) {
  warningOnce(_t, "[@ant-design/icons] ".concat(Et));
}
function isIconDefinition(_t) {
  return _typeof(_t) === "object" && typeof _t.name == "string" && typeof _t.theme == "string" && (_typeof(_t.icon) === "object" || typeof _t.icon == "function");
}
function normalizeAttrs() {
  var _t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return Object.keys(_t).reduce(function(Et, Pt) {
    var $t = _t[Pt];
    switch (Pt) {
      case "class":
        Et.className = $t, delete Et.class;
        break;
      default:
        delete Et[Pt], Et[camelCase(Pt)] = $t;
    }
    return Et;
  }, {});
}
function generate(_t, Et, Pt) {
  return Pt ? /* @__PURE__ */ React__default.createElement(_t.tag, _objectSpread2(_objectSpread2({
    key: Et
  }, normalizeAttrs(_t.attrs)), Pt), (_t.children || []).map(function($t, Mt) {
    return generate($t, "".concat(Et, "-").concat(_t.tag, "-").concat(Mt));
  })) : /* @__PURE__ */ React__default.createElement(_t.tag, _objectSpread2({
    key: Et
  }, normalizeAttrs(_t.attrs)), (_t.children || []).map(function($t, Mt) {
    return generate($t, "".concat(Et, "-").concat(_t.tag, "-").concat(Mt));
  }));
}
function getSecondaryColor(_t) {
  return generate$1(_t)[0];
}
function normalizeTwoToneColors(_t) {
  return _t ? Array.isArray(_t) ? _t : [_t] : [];
}
var iconStyles = `
.anticon {
  display: inline-flex;
  align-items: center;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin::before,
.anticon-spin {
  display: inline-block;
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`, useInsertStyles = function(Et) {
  var Pt = useContext(IconContext), $t = Pt.csp, Mt = Pt.prefixCls, Bt = Pt.layer, Vt = iconStyles;
  Mt && (Vt = Vt.replace(/anticon/g, Mt)), Bt && (Vt = "@layer ".concat(Bt, ` {
`).concat(Vt, `
}`)), useEffect(function() {
    var zt = Et.current, Ht = getShadowRoot(zt);
    updateCSS(Vt, "@ant-design-icons", {
      prepend: !0,
      csp: $t,
      attachTo: Ht
    });
  }, []);
}, _excluded$q = ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"], twoToneColorPalette = {
  primaryColor: "#333",
  secondaryColor: "#E6E6E6",
  calculated: !1
};
function setTwoToneColors(_t) {
  var Et = _t.primaryColor, Pt = _t.secondaryColor;
  twoToneColorPalette.primaryColor = Et, twoToneColorPalette.secondaryColor = Pt || getSecondaryColor(Et), twoToneColorPalette.calculated = !!Pt;
}
function getTwoToneColors() {
  return _objectSpread2({}, twoToneColorPalette);
}
var IconBase = function(Et) {
  var Pt = Et.icon, $t = Et.className, Mt = Et.onClick, Bt = Et.style, Vt = Et.primaryColor, zt = Et.secondaryColor, Ht = _objectWithoutProperties$2(Et, _excluded$q), Wt = React.useRef(), Gt = twoToneColorPalette;
  if (Vt && (Gt = {
    primaryColor: Vt,
    secondaryColor: zt || getSecondaryColor(Vt)
  }), useInsertStyles(Wt), warning$2(isIconDefinition(Pt), "icon should be icon definiton, but got ".concat(Pt)), !isIconDefinition(Pt))
    return null;
  var qt = Pt;
  return qt && typeof qt.icon == "function" && (qt = _objectSpread2(_objectSpread2({}, qt), {}, {
    icon: qt.icon(Gt.primaryColor, Gt.secondaryColor)
  })), generate(qt.icon, "svg-".concat(qt.name), _objectSpread2(_objectSpread2({
    className: $t,
    onClick: Mt,
    style: Bt,
    "data-icon": qt.name,
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, Ht), {}, {
    ref: Wt
  }));
};
IconBase.displayName = "IconReact";
IconBase.getTwoToneColors = getTwoToneColors;
IconBase.setTwoToneColors = setTwoToneColors;
function setTwoToneColor(_t) {
  var Et = normalizeTwoToneColors(_t), Pt = _slicedToArray(Et, 2), $t = Pt[0], Mt = Pt[1];
  return IconBase.setTwoToneColors({
    primaryColor: $t,
    secondaryColor: Mt
  });
}
function getTwoToneColor() {
  var _t = IconBase.getTwoToneColors();
  return _t.calculated ? [_t.primaryColor, _t.secondaryColor] : _t.primaryColor;
}
var _excluded$p = ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"];
setTwoToneColor(blue.primary);
var Icon$1 = /* @__PURE__ */ React.forwardRef(function(_t, Et) {
  var Pt = _t.className, $t = _t.icon, Mt = _t.spin, Bt = _t.rotate, Vt = _t.tabIndex, zt = _t.onClick, Ht = _t.twoToneColor, Wt = _objectWithoutProperties$2(_t, _excluded$p), Gt = React.useContext(IconContext), qt = Gt.prefixCls, Kt = qt === void 0 ? "anticon" : qt, Qt = Gt.rootClassName, Xt = classNames(Qt, Kt, _defineProperty(_defineProperty({}, "".concat(Kt, "-").concat($t.name), !!$t.name), "".concat(Kt, "-spin"), !!Mt || $t.name === "loading"), Pt), Zt = Vt;
  Zt === void 0 && zt && (Zt = -1);
  var Yt = Bt ? {
    msTransform: "rotate(".concat(Bt, "deg)"),
    transform: "rotate(".concat(Bt, "deg)")
  } : void 0, Jt = normalizeTwoToneColors(Ht), er = _slicedToArray(Jt, 2), tr = er[0], nr = er[1];
  return /* @__PURE__ */ React.createElement("span", _extends$2({
    role: "img",
    "aria-label": $t.name
  }, Wt, {
    ref: Et,
    tabIndex: Zt,
    onClick: zt,
    className: Xt
  }), /* @__PURE__ */ React.createElement(IconBase, {
    icon: $t,
    primaryColor: tr,
    secondaryColor: nr,
    style: Yt
  }));
});
Icon$1.displayName = "AntdIcon";
Icon$1.getTwoToneColor = getTwoToneColor;
Icon$1.setTwoToneColor = setTwoToneColor;
var CheckCircleFilled$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z" } }] }, name: "check-circle", theme: "filled" }, CheckCircleFilled = function(Et, Pt) {
  return /* @__PURE__ */ React.createElement(Icon$1, _extends$2({}, Et, {
    ref: Pt,
    icon: CheckCircleFilled$1
  }));
}, RefIcon$9 = /* @__PURE__ */ React.forwardRef(CheckCircleFilled);
browser$1.env.NODE_ENV !== "production" && (RefIcon$9.displayName = "CheckCircleFilled");
var CheckOutlined$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" } }] }, name: "check", theme: "outlined" }, CheckOutlined = function(Et, Pt) {
  return /* @__PURE__ */ React.createElement(Icon$1, _extends$2({}, Et, {
    ref: Pt,
    icon: CheckOutlined$1
  }));
}, RefIcon$8 = /* @__PURE__ */ React.forwardRef(CheckOutlined);
browser$1.env.NODE_ENV !== "production" && (RefIcon$8.displayName = "CheckOutlined");
var CloseCircleFilled$1 = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z" } }] }, name: "close-circle", theme: "filled" }, CloseCircleFilled = function(Et, Pt) {
  return /* @__PURE__ */ React.createElement(Icon$1, _extends$2({}, Et, {
    ref: Pt,
    icon: CloseCircleFilled$1
  }));
}, RefIcon$7 = /* @__PURE__ */ React.forwardRef(CloseCircleFilled);
browser$1.env.NODE_ENV !== "production" && (RefIcon$7.displayName = "CloseCircleFilled");
var CloseOutlined$1 = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z" } }] }, name: "close", theme: "outlined" }, CloseOutlined = function(Et, Pt) {
  return /* @__PURE__ */ React.createElement(Icon$1, _extends$2({}, Et, {
    ref: Pt,
    icon: CloseOutlined$1
  }));
}, RefIcon$6 = /* @__PURE__ */ React.forwardRef(CloseOutlined);
browser$1.env.NODE_ENV !== "production" && (RefIcon$6.displayName = "CloseOutlined");
var EllipsisOutlined$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, name: "ellipsis", theme: "outlined" }, EllipsisOutlined = function(Et, Pt) {
  return /* @__PURE__ */ React.createElement(Icon$1, _extends$2({}, Et, {
    ref: Pt,
    icon: EllipsisOutlined$1
  }));
}, RefIcon$5 = /* @__PURE__ */ React.forwardRef(EllipsisOutlined);
browser$1.env.NODE_ENV !== "production" && (RefIcon$5.displayName = "EllipsisOutlined");
var ExclamationCircleFilled$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, name: "exclamation-circle", theme: "filled" }, ExclamationCircleFilled = function(Et, Pt) {
  return /* @__PURE__ */ React.createElement(Icon$1, _extends$2({}, Et, {
    ref: Pt,
    icon: ExclamationCircleFilled$1
  }));
}, RefIcon$4 = /* @__PURE__ */ React.forwardRef(ExclamationCircleFilled);
browser$1.env.NODE_ENV !== "production" && (RefIcon$4.displayName = "ExclamationCircleFilled");
var InfoCircleFilled$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, name: "info-circle", theme: "filled" }, InfoCircleFilled = function(Et, Pt) {
  return /* @__PURE__ */ React.createElement(Icon$1, _extends$2({}, Et, {
    ref: Pt,
    icon: InfoCircleFilled$1
  }));
}, RefIcon$3 = /* @__PURE__ */ React.forwardRef(InfoCircleFilled);
browser$1.env.NODE_ENV !== "production" && (RefIcon$3.displayName = "InfoCircleFilled");
var InfoCircleOutlined$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { tag: "path", attrs: { d: "M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z" } }] }, name: "info-circle", theme: "outlined" }, InfoCircleOutlined = function(Et, Pt) {
  return /* @__PURE__ */ React.createElement(Icon$1, _extends$2({}, Et, {
    ref: Pt,
    icon: InfoCircleOutlined$1
  }));
}, RefIcon$2 = /* @__PURE__ */ React.forwardRef(InfoCircleOutlined);
browser$1.env.NODE_ENV !== "production" && (RefIcon$2.displayName = "InfoCircleOutlined");
var LoadingOutlined$1 = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z" } }] }, name: "loading", theme: "outlined" }, LoadingOutlined = function(Et, Pt) {
  return /* @__PURE__ */ React.createElement(Icon$1, _extends$2({}, Et, {
    ref: Pt,
    icon: LoadingOutlined$1
  }));
}, RefIcon$1 = /* @__PURE__ */ React.forwardRef(LoadingOutlined);
browser$1.env.NODE_ENV !== "production" && (RefIcon$1.displayName = "LoadingOutlined");
var PlusOutlined$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z" } }, { tag: "path", attrs: { d: "M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z" } }] }, name: "plus", theme: "outlined" }, PlusOutlined = function(Et, Pt) {
  return /* @__PURE__ */ React.createElement(Icon$1, _extends$2({}, Et, {
    ref: Pt,
    icon: PlusOutlined$1
  }));
}, RefIcon = /* @__PURE__ */ React.forwardRef(PlusOutlined);
browser$1.env.NODE_ENV !== "production" && (RefIcon.displayName = "PlusOutlined");
var reactIs$1 = { exports: {} }, reactIs_production_min$1 = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min$1;
function requireReactIs_production_min$1() {
  if (hasRequiredReactIs_production_min$1)
    return reactIs_production_min$1;
  hasRequiredReactIs_production_min$1 = 1;
  var _t = Symbol.for("react.element"), Et = Symbol.for("react.portal"), Pt = Symbol.for("react.fragment"), $t = Symbol.for("react.strict_mode"), Mt = Symbol.for("react.profiler"), Bt = Symbol.for("react.provider"), Vt = Symbol.for("react.context"), zt = Symbol.for("react.server_context"), Ht = Symbol.for("react.forward_ref"), Wt = Symbol.for("react.suspense"), Gt = Symbol.for("react.suspense_list"), qt = Symbol.for("react.memo"), Kt = Symbol.for("react.lazy"), Qt = Symbol.for("react.offscreen"), Xt;
  Xt = Symbol.for("react.module.reference");
  function Zt(Yt) {
    if (typeof Yt == "object" && Yt !== null) {
      var Jt = Yt.$$typeof;
      switch (Jt) {
        case _t:
          switch (Yt = Yt.type, Yt) {
            case Pt:
            case Mt:
            case $t:
            case Wt:
            case Gt:
              return Yt;
            default:
              switch (Yt = Yt && Yt.$$typeof, Yt) {
                case zt:
                case Vt:
                case Ht:
                case Kt:
                case qt:
                case Bt:
                  return Yt;
                default:
                  return Jt;
              }
          }
        case Et:
          return Jt;
      }
    }
  }
  return reactIs_production_min$1.ContextConsumer = Vt, reactIs_production_min$1.ContextProvider = Bt, reactIs_production_min$1.Element = _t, reactIs_production_min$1.ForwardRef = Ht, reactIs_production_min$1.Fragment = Pt, reactIs_production_min$1.Lazy = Kt, reactIs_production_min$1.Memo = qt, reactIs_production_min$1.Portal = Et, reactIs_production_min$1.Profiler = Mt, reactIs_production_min$1.StrictMode = $t, reactIs_production_min$1.Suspense = Wt, reactIs_production_min$1.SuspenseList = Gt, reactIs_production_min$1.isAsyncMode = function() {
    return !1;
  }, reactIs_production_min$1.isConcurrentMode = function() {
    return !1;
  }, reactIs_production_min$1.isContextConsumer = function(Yt) {
    return Zt(Yt) === Vt;
  }, reactIs_production_min$1.isContextProvider = function(Yt) {
    return Zt(Yt) === Bt;
  }, reactIs_production_min$1.isElement = function(Yt) {
    return typeof Yt == "object" && Yt !== null && Yt.$$typeof === _t;
  }, reactIs_production_min$1.isForwardRef = function(Yt) {
    return Zt(Yt) === Ht;
  }, reactIs_production_min$1.isFragment = function(Yt) {
    return Zt(Yt) === Pt;
  }, reactIs_production_min$1.isLazy = function(Yt) {
    return Zt(Yt) === Kt;
  }, reactIs_production_min$1.isMemo = function(Yt) {
    return Zt(Yt) === qt;
  }, reactIs_production_min$1.isPortal = function(Yt) {
    return Zt(Yt) === Et;
  }, reactIs_production_min$1.isProfiler = function(Yt) {
    return Zt(Yt) === Mt;
  }, reactIs_production_min$1.isStrictMode = function(Yt) {
    return Zt(Yt) === $t;
  }, reactIs_production_min$1.isSuspense = function(Yt) {
    return Zt(Yt) === Wt;
  }, reactIs_production_min$1.isSuspenseList = function(Yt) {
    return Zt(Yt) === Gt;
  }, reactIs_production_min$1.isValidElementType = function(Yt) {
    return typeof Yt == "string" || typeof Yt == "function" || Yt === Pt || Yt === Mt || Yt === $t || Yt === Wt || Yt === Gt || Yt === Qt || typeof Yt == "object" && Yt !== null && (Yt.$$typeof === Kt || Yt.$$typeof === qt || Yt.$$typeof === Bt || Yt.$$typeof === Vt || Yt.$$typeof === Ht || Yt.$$typeof === Xt || Yt.getModuleId !== void 0);
  }, reactIs_production_min$1.typeOf = Zt, reactIs_production_min$1;
}
var reactIs_development$1 = {}, hasRequiredReactIs_development$1;
function requireReactIs_development$1() {
  return hasRequiredReactIs_development$1 || (hasRequiredReactIs_development$1 = 1, browser$1.env.NODE_ENV !== "production" && function() {
    var _t = Symbol.for("react.element"), Et = Symbol.for("react.portal"), Pt = Symbol.for("react.fragment"), $t = Symbol.for("react.strict_mode"), Mt = Symbol.for("react.profiler"), Bt = Symbol.for("react.provider"), Vt = Symbol.for("react.context"), zt = Symbol.for("react.server_context"), Ht = Symbol.for("react.forward_ref"), Wt = Symbol.for("react.suspense"), Gt = Symbol.for("react.suspense_list"), qt = Symbol.for("react.memo"), Kt = Symbol.for("react.lazy"), Qt = Symbol.for("react.offscreen"), Xt = !1, Zt = !1, Yt = !1, Jt = !1, er = !1, tr;
    tr = Symbol.for("react.module.reference");
    function nr($r) {
      return !!(typeof $r == "string" || typeof $r == "function" || $r === Pt || $r === Mt || er || $r === $t || $r === Wt || $r === Gt || Jt || $r === Qt || Xt || Zt || Yt || typeof $r == "object" && $r !== null && ($r.$$typeof === Kt || $r.$$typeof === qt || $r.$$typeof === Bt || $r.$$typeof === Vt || $r.$$typeof === Ht || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      $r.$$typeof === tr || $r.getModuleId !== void 0));
    }
    function rr($r) {
      if (typeof $r == "object" && $r !== null) {
        var Rr = $r.$$typeof;
        switch (Rr) {
          case _t:
            var Or = $r.type;
            switch (Or) {
              case Pt:
              case Mt:
              case $t:
              case Wt:
              case Gt:
                return Or;
              default:
                var Lr = Or && Or.$$typeof;
                switch (Lr) {
                  case zt:
                  case Vt:
                  case Ht:
                  case Kt:
                  case qt:
                  case Bt:
                    return Lr;
                  default:
                    return Rr;
                }
            }
          case Et:
            return Rr;
        }
      }
    }
    var ir = Vt, ar = Bt, or = _t, sr = Ht, lr = Pt, cr = Kt, hr = qt, pr = Et, mr = Mt, Er = $t, _r = Wt, yr = Gt, ur = !1, vr = !1;
    function dr($r) {
      return ur || (ur = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function br($r) {
      return vr || (vr = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function Cr($r) {
      return rr($r) === Vt;
    }
    function Pr($r) {
      return rr($r) === Bt;
    }
    function xr($r) {
      return typeof $r == "object" && $r !== null && $r.$$typeof === _t;
    }
    function kr($r) {
      return rr($r) === Ht;
    }
    function Ir($r) {
      return rr($r) === Pt;
    }
    function Ar($r) {
      return rr($r) === Kt;
    }
    function Mr($r) {
      return rr($r) === qt;
    }
    function Fr($r) {
      return rr($r) === Et;
    }
    function Dr($r) {
      return rr($r) === Mt;
    }
    function zr($r) {
      return rr($r) === $t;
    }
    function Tr($r) {
      return rr($r) === Wt;
    }
    function Gr($r) {
      return rr($r) === Gt;
    }
    reactIs_development$1.ContextConsumer = ir, reactIs_development$1.ContextProvider = ar, reactIs_development$1.Element = or, reactIs_development$1.ForwardRef = sr, reactIs_development$1.Fragment = lr, reactIs_development$1.Lazy = cr, reactIs_development$1.Memo = hr, reactIs_development$1.Portal = pr, reactIs_development$1.Profiler = mr, reactIs_development$1.StrictMode = Er, reactIs_development$1.Suspense = _r, reactIs_development$1.SuspenseList = yr, reactIs_development$1.isAsyncMode = dr, reactIs_development$1.isConcurrentMode = br, reactIs_development$1.isContextConsumer = Cr, reactIs_development$1.isContextProvider = Pr, reactIs_development$1.isElement = xr, reactIs_development$1.isForwardRef = kr, reactIs_development$1.isFragment = Ir, reactIs_development$1.isLazy = Ar, reactIs_development$1.isMemo = Mr, reactIs_development$1.isPortal = Fr, reactIs_development$1.isProfiler = Dr, reactIs_development$1.isStrictMode = zr, reactIs_development$1.isSuspense = Tr, reactIs_development$1.isSuspenseList = Gr, reactIs_development$1.isValidElementType = nr, reactIs_development$1.typeOf = rr;
  }()), reactIs_development$1;
}
browser$1.env.NODE_ENV === "production" ? reactIs$1.exports = requireReactIs_production_min$1() : reactIs$1.exports = requireReactIs_development$1();
var reactIsExports = reactIs$1.exports;
function useMemo(_t, Et, Pt) {
  var $t = React.useRef({});
  return (!("value" in $t.current) || Pt($t.current.condition, Et)) && ($t.current.value = _t(), $t.current.condition = Et), $t.current.value;
}
var REACT_ELEMENT_TYPE_18 = Symbol.for("react.element"), REACT_ELEMENT_TYPE_19 = Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function isFragment$1(_t) {
  return (
    // Base object type
    _t && _typeof(_t) === "object" && // React Element type
    (_t.$$typeof === REACT_ELEMENT_TYPE_18 || _t.$$typeof === REACT_ELEMENT_TYPE_19) && // React Fragment type
    _t.type === REACT_FRAGMENT_TYPE
  );
}
var fillRef = function(Et, Pt) {
  typeof Et == "function" ? Et(Pt) : _typeof(Et) === "object" && Et && "current" in Et && (Et.current = Pt);
}, composeRef = function() {
  for (var Et = arguments.length, Pt = new Array(Et), $t = 0; $t < Et; $t++)
    Pt[$t] = arguments[$t];
  var Mt = Pt.filter(Boolean);
  return Mt.length <= 1 ? Mt[0] : function(Bt) {
    Pt.forEach(function(Vt) {
      fillRef(Vt, Bt);
    });
  };
}, useComposeRef = function() {
  for (var Et = arguments.length, Pt = new Array(Et), $t = 0; $t < Et; $t++)
    Pt[$t] = arguments[$t];
  return useMemo(function() {
    return composeRef.apply(void 0, Pt);
  }, Pt, function(Mt, Bt) {
    return Mt.length !== Bt.length || Mt.every(function(Vt, zt) {
      return Vt !== Bt[zt];
    });
  });
}, supportRef = function(Et) {
  var Pt, $t;
  if (!Et)
    return !1;
  if (isReactElement(Et) && Et.props.propertyIsEnumerable("ref"))
    return !0;
  var Mt = reactIsExports.isMemo(Et) ? Et.type.type : Et.type;
  return !(typeof Mt == "function" && !((Pt = Mt.prototype) !== null && Pt !== void 0 && Pt.render) && Mt.$$typeof !== reactIsExports.ForwardRef || typeof Et == "function" && !(($t = Et.prototype) !== null && $t !== void 0 && $t.render) && Et.$$typeof !== reactIsExports.ForwardRef);
};
function isReactElement(_t) {
  return /* @__PURE__ */ isValidElement(_t) && !isFragment$1(_t);
}
var getNodeRef = function(Et) {
  if (Et && isReactElement(Et)) {
    var Pt = Et;
    return Pt.props.propertyIsEnumerable("ref") ? Pt.props.ref : Pt.ref;
  }
  return null;
};
function toArray$4(_t) {
  var Et = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Pt = [];
  return React__default.Children.forEach(_t, function($t) {
    $t == null && !Et.keepEmpty || (Array.isArray($t) ? Pt = Pt.concat(toArray$4($t)) : isFragment$1($t) && $t.props ? Pt = Pt.concat(toArray$4($t.props.children, Et)) : Pt.push($t));
  }), Pt;
}
function isDOM(_t) {
  return _t instanceof HTMLElement || _t instanceof SVGElement;
}
function getDOM(_t) {
  return _t && _typeof(_t) === "object" && isDOM(_t.nativeElement) ? _t.nativeElement : isDOM(_t) ? _t : null;
}
function findDOMNode(_t) {
  var Et = getDOM(_t);
  if (Et)
    return Et;
  if (_t instanceof React__default.Component) {
    var Pt;
    return (Pt = ReactDOM__default.findDOMNode) === null || Pt === void 0 ? void 0 : Pt.call(ReactDOM__default, _t);
  }
  return null;
}
var CollectionContext = /* @__PURE__ */ React.createContext(null);
function Collection(_t) {
  var Et = _t.children, Pt = _t.onBatchResize, $t = React.useRef(0), Mt = React.useRef([]), Bt = React.useContext(CollectionContext), Vt = React.useCallback(function(zt, Ht, Wt) {
    $t.current += 1;
    var Gt = $t.current;
    Mt.current.push({
      size: zt,
      element: Ht,
      data: Wt
    }), Promise.resolve().then(function() {
      Gt === $t.current && (Pt == null || Pt(Mt.current), Mt.current = []);
    }), Bt == null || Bt(zt, Ht, Wt);
  }, [Pt, Bt]);
  return /* @__PURE__ */ React.createElement(CollectionContext.Provider, {
    value: Vt
  }, Et);
}
var MapShim = function() {
  if (typeof Map < "u")
    return Map;
  function _t(Et, Pt) {
    var $t = -1;
    return Et.some(function(Mt, Bt) {
      return Mt[0] === Pt ? ($t = Bt, !0) : !1;
    }), $t;
  }
  return (
    /** @class */
    function() {
      function Et() {
        this.__entries__ = [];
      }
      return Object.defineProperty(Et.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), Et.prototype.get = function(Pt) {
        var $t = _t(this.__entries__, Pt), Mt = this.__entries__[$t];
        return Mt && Mt[1];
      }, Et.prototype.set = function(Pt, $t) {
        var Mt = _t(this.__entries__, Pt);
        ~Mt ? this.__entries__[Mt][1] = $t : this.__entries__.push([Pt, $t]);
      }, Et.prototype.delete = function(Pt) {
        var $t = this.__entries__, Mt = _t($t, Pt);
        ~Mt && $t.splice(Mt, 1);
      }, Et.prototype.has = function(Pt) {
        return !!~_t(this.__entries__, Pt);
      }, Et.prototype.clear = function() {
        this.__entries__.splice(0);
      }, Et.prototype.forEach = function(Pt, $t) {
        $t === void 0 && ($t = null);
        for (var Mt = 0, Bt = this.__entries__; Mt < Bt.length; Mt++) {
          var Vt = Bt[Mt];
          Pt.call($t, Vt[1], Vt[0]);
        }
      }, Et;
    }()
  );
}(), isBrowser = typeof window < "u" && typeof document < "u" && window.document === document, global$1 = function() {
  return typeof global$2 < "u" && global$2.Math === Math ? global$2 : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
}(), requestAnimationFrame$1 = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(global$1) : function(_t) {
    return setTimeout(function() {
      return _t(Date.now());
    }, 1e3 / 60);
  };
}(), trailingTimeout = 2;
function throttle$1(_t, Et) {
  var Pt = !1, $t = !1, Mt = 0;
  function Bt() {
    Pt && (Pt = !1, _t()), $t && zt();
  }
  function Vt() {
    requestAnimationFrame$1(Bt);
  }
  function zt() {
    var Ht = Date.now();
    if (Pt) {
      if (Ht - Mt < trailingTimeout)
        return;
      $t = !0;
    } else
      Pt = !0, $t = !1, setTimeout(Vt, Et);
    Mt = Ht;
  }
  return zt;
}
var REFRESH_DELAY = 20, transitionKeys = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], mutationObserverSupported = typeof MutationObserver < "u", ResizeObserverController = (
  /** @class */
  function() {
    function _t() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = throttle$1(this.refresh.bind(this), REFRESH_DELAY);
    }
    return _t.prototype.addObserver = function(Et) {
      ~this.observers_.indexOf(Et) || this.observers_.push(Et), this.connected_ || this.connect_();
    }, _t.prototype.removeObserver = function(Et) {
      var Pt = this.observers_, $t = Pt.indexOf(Et);
      ~$t && Pt.splice($t, 1), !Pt.length && this.connected_ && this.disconnect_();
    }, _t.prototype.refresh = function() {
      var Et = this.updateObservers_();
      Et && this.refresh();
    }, _t.prototype.updateObservers_ = function() {
      var Et = this.observers_.filter(function(Pt) {
        return Pt.gatherActive(), Pt.hasActive();
      });
      return Et.forEach(function(Pt) {
        return Pt.broadcastActive();
      }), Et.length > 0;
    }, _t.prototype.connect_ = function() {
      !isBrowser || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), mutationObserverSupported ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, _t.prototype.disconnect_ = function() {
      !isBrowser || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, _t.prototype.onTransitionEnd_ = function(Et) {
      var Pt = Et.propertyName, $t = Pt === void 0 ? "" : Pt, Mt = transitionKeys.some(function(Bt) {
        return !!~$t.indexOf(Bt);
      });
      Mt && this.refresh();
    }, _t.getInstance = function() {
      return this.instance_ || (this.instance_ = new _t()), this.instance_;
    }, _t.instance_ = null, _t;
  }()
), defineConfigurable = function(_t, Et) {
  for (var Pt = 0, $t = Object.keys(Et); Pt < $t.length; Pt++) {
    var Mt = $t[Pt];
    Object.defineProperty(_t, Mt, {
      value: Et[Mt],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return _t;
}, getWindowOf = function(_t) {
  var Et = _t && _t.ownerDocument && _t.ownerDocument.defaultView;
  return Et || global$1;
}, emptyRect = createRectInit(0, 0, 0, 0);
function toFloat(_t) {
  return parseFloat(_t) || 0;
}
function getBordersSize(_t) {
  for (var Et = [], Pt = 1; Pt < arguments.length; Pt++)
    Et[Pt - 1] = arguments[Pt];
  return Et.reduce(function($t, Mt) {
    var Bt = _t["border-" + Mt + "-width"];
    return $t + toFloat(Bt);
  }, 0);
}
function getPaddings(_t) {
  for (var Et = ["top", "right", "bottom", "left"], Pt = {}, $t = 0, Mt = Et; $t < Mt.length; $t++) {
    var Bt = Mt[$t], Vt = _t["padding-" + Bt];
    Pt[Bt] = toFloat(Vt);
  }
  return Pt;
}
function getSVGContentRect(_t) {
  var Et = _t.getBBox();
  return createRectInit(0, 0, Et.width, Et.height);
}
function getHTMLElementContentRect(_t) {
  var Et = _t.clientWidth, Pt = _t.clientHeight;
  if (!Et && !Pt)
    return emptyRect;
  var $t = getWindowOf(_t).getComputedStyle(_t), Mt = getPaddings($t), Bt = Mt.left + Mt.right, Vt = Mt.top + Mt.bottom, zt = toFloat($t.width), Ht = toFloat($t.height);
  if ($t.boxSizing === "border-box" && (Math.round(zt + Bt) !== Et && (zt -= getBordersSize($t, "left", "right") + Bt), Math.round(Ht + Vt) !== Pt && (Ht -= getBordersSize($t, "top", "bottom") + Vt)), !isDocumentElement(_t)) {
    var Wt = Math.round(zt + Bt) - Et, Gt = Math.round(Ht + Vt) - Pt;
    Math.abs(Wt) !== 1 && (zt -= Wt), Math.abs(Gt) !== 1 && (Ht -= Gt);
  }
  return createRectInit(Mt.left, Mt.top, zt, Ht);
}
var isSVGGraphicsElement = /* @__PURE__ */ function() {
  return typeof SVGGraphicsElement < "u" ? function(_t) {
    return _t instanceof getWindowOf(_t).SVGGraphicsElement;
  } : function(_t) {
    return _t instanceof getWindowOf(_t).SVGElement && typeof _t.getBBox == "function";
  };
}();
function isDocumentElement(_t) {
  return _t === getWindowOf(_t).document.documentElement;
}
function getContentRect(_t) {
  return isBrowser ? isSVGGraphicsElement(_t) ? getSVGContentRect(_t) : getHTMLElementContentRect(_t) : emptyRect;
}
function createReadOnlyRect(_t) {
  var Et = _t.x, Pt = _t.y, $t = _t.width, Mt = _t.height, Bt = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, Vt = Object.create(Bt.prototype);
  return defineConfigurable(Vt, {
    x: Et,
    y: Pt,
    width: $t,
    height: Mt,
    top: Pt,
    right: Et + $t,
    bottom: Mt + Pt,
    left: Et
  }), Vt;
}
function createRectInit(_t, Et, Pt, $t) {
  return { x: _t, y: Et, width: Pt, height: $t };
}
var ResizeObservation = (
  /** @class */
  function() {
    function _t(Et) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = createRectInit(0, 0, 0, 0), this.target = Et;
    }
    return _t.prototype.isActive = function() {
      var Et = getContentRect(this.target);
      return this.contentRect_ = Et, Et.width !== this.broadcastWidth || Et.height !== this.broadcastHeight;
    }, _t.prototype.broadcastRect = function() {
      var Et = this.contentRect_;
      return this.broadcastWidth = Et.width, this.broadcastHeight = Et.height, Et;
    }, _t;
  }()
), ResizeObserverEntry = (
  /** @class */
  /* @__PURE__ */ function() {
    function _t(Et, Pt) {
      var $t = createReadOnlyRect(Pt);
      defineConfigurable(this, { target: Et, contentRect: $t });
    }
    return _t;
  }()
), ResizeObserverSPI = (
  /** @class */
  function() {
    function _t(Et, Pt, $t) {
      if (this.activeObservations_ = [], this.observations_ = new MapShim(), typeof Et != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = Et, this.controller_ = Pt, this.callbackCtx_ = $t;
    }
    return _t.prototype.observe = function(Et) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(Et instanceof getWindowOf(Et).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var Pt = this.observations_;
        Pt.has(Et) || (Pt.set(Et, new ResizeObservation(Et)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, _t.prototype.unobserve = function(Et) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(Et instanceof getWindowOf(Et).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var Pt = this.observations_;
        Pt.has(Et) && (Pt.delete(Et), Pt.size || this.controller_.removeObserver(this));
      }
    }, _t.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, _t.prototype.gatherActive = function() {
      var Et = this;
      this.clearActive(), this.observations_.forEach(function(Pt) {
        Pt.isActive() && Et.activeObservations_.push(Pt);
      });
    }, _t.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var Et = this.callbackCtx_, Pt = this.activeObservations_.map(function($t) {
          return new ResizeObserverEntry($t.target, $t.broadcastRect());
        });
        this.callback_.call(Et, Pt, Et), this.clearActive();
      }
    }, _t.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, _t.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, _t;
  }()
), observers = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new MapShim(), ResizeObserver$2 = (
  /** @class */
  /* @__PURE__ */ function() {
    function _t(Et) {
      if (!(this instanceof _t))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var Pt = ResizeObserverController.getInstance(), $t = new ResizeObserverSPI(Et, Pt, this);
      observers.set(this, $t);
    }
    return _t;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(_t) {
  ResizeObserver$2.prototype[_t] = function() {
    var Et;
    return (Et = observers.get(this))[_t].apply(Et, arguments);
  };
});
var index = function() {
  return typeof global$1.ResizeObserver < "u" ? global$1.ResizeObserver : ResizeObserver$2;
}(), elementListeners = /* @__PURE__ */ new Map();
function onResize(_t) {
  _t.forEach(function(Et) {
    var Pt, $t = Et.target;
    (Pt = elementListeners.get($t)) === null || Pt === void 0 || Pt.forEach(function(Mt) {
      return Mt($t);
    });
  });
}
var resizeObserver = new index(onResize);
browser$1.env.NODE_ENV;
browser$1.env.NODE_ENV;
function observe(_t, Et) {
  elementListeners.has(_t) || (elementListeners.set(_t, /* @__PURE__ */ new Set()), resizeObserver.observe(_t)), elementListeners.get(_t).add(Et);
}
function unobserve(_t, Et) {
  elementListeners.has(_t) && (elementListeners.get(_t).delete(Et), elementListeners.get(_t).size || (resizeObserver.unobserve(_t), elementListeners.delete(_t)));
}
function _classCallCheck(_t, Et) {
  if (!(_t instanceof Et))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(_t, Et) {
  for (var Pt = 0; Pt < Et.length; Pt++) {
    var $t = Et[Pt];
    $t.enumerable = $t.enumerable || !1, $t.configurable = !0, "value" in $t && ($t.writable = !0), Object.defineProperty(_t, toPropertyKey($t.key), $t);
  }
}
function _createClass(_t, Et, Pt) {
  return Et && _defineProperties(_t.prototype, Et), Pt && _defineProperties(_t, Pt), Object.defineProperty(_t, "prototype", {
    writable: !1
  }), _t;
}
function _setPrototypeOf(_t, Et) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(Pt, $t) {
    return Pt.__proto__ = $t, Pt;
  }, _setPrototypeOf(_t, Et);
}
function _inherits(_t, Et) {
  if (typeof Et != "function" && Et !== null)
    throw new TypeError("Super expression must either be null or a function");
  _t.prototype = Object.create(Et && Et.prototype, {
    constructor: {
      value: _t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(_t, "prototype", {
    writable: !1
  }), Et && _setPrototypeOf(_t, Et);
}
function _getPrototypeOf(_t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(Et) {
    return Et.__proto__ || Object.getPrototypeOf(Et);
  }, _getPrototypeOf(_t);
}
function _isNativeReflectConstruct() {
  try {
    var _t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct = function() {
    return !!_t;
  })();
}
function _assertThisInitialized(_t) {
  if (_t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return _t;
}
function _possibleConstructorReturn(_t, Et) {
  if (Et && (_typeof(Et) == "object" || typeof Et == "function"))
    return Et;
  if (Et !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(_t);
}
function _createSuper(_t) {
  var Et = _isNativeReflectConstruct();
  return function() {
    var Pt, $t = _getPrototypeOf(_t);
    if (Et) {
      var Mt = _getPrototypeOf(this).constructor;
      Pt = Reflect.construct($t, arguments, Mt);
    } else
      Pt = $t.apply(this, arguments);
    return _possibleConstructorReturn(this, Pt);
  };
}
var DomWrapper$1 = /* @__PURE__ */ function(_t) {
  _inherits(Pt, _t);
  var Et = _createSuper(Pt);
  function Pt() {
    return _classCallCheck(this, Pt), Et.apply(this, arguments);
  }
  return _createClass(Pt, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), Pt;
}(React.Component);
function SingleObserver(_t, Et) {
  var Pt = _t.children, $t = _t.disabled, Mt = React.useRef(null), Bt = React.useRef(null), Vt = React.useContext(CollectionContext), zt = typeof Pt == "function", Ht = zt ? Pt(Mt) : Pt, Wt = React.useRef({
    width: -1,
    height: -1,
    offsetWidth: -1,
    offsetHeight: -1
  }), Gt = !zt && /* @__PURE__ */ React.isValidElement(Ht) && supportRef(Ht), qt = Gt ? getNodeRef(Ht) : null, Kt = useComposeRef(qt, Mt), Qt = function() {
    var Jt;
    return findDOMNode(Mt.current) || // Support `nativeElement` format
    (Mt.current && _typeof(Mt.current) === "object" ? findDOMNode((Jt = Mt.current) === null || Jt === void 0 ? void 0 : Jt.nativeElement) : null) || findDOMNode(Bt.current);
  };
  React.useImperativeHandle(Et, function() {
    return Qt();
  });
  var Xt = React.useRef(_t);
  Xt.current = _t;
  var Zt = React.useCallback(function(Yt) {
    var Jt = Xt.current, er = Jt.onResize, tr = Jt.data, nr = Yt.getBoundingClientRect(), rr = nr.width, ir = nr.height, ar = Yt.offsetWidth, or = Yt.offsetHeight, sr = Math.floor(rr), lr = Math.floor(ir);
    if (Wt.current.width !== sr || Wt.current.height !== lr || Wt.current.offsetWidth !== ar || Wt.current.offsetHeight !== or) {
      var cr = {
        width: sr,
        height: lr,
        offsetWidth: ar,
        offsetHeight: or
      };
      Wt.current = cr;
      var hr = ar === Math.round(rr) ? rr : ar, pr = or === Math.round(ir) ? ir : or, mr = _objectSpread2(_objectSpread2({}, cr), {}, {
        offsetWidth: hr,
        offsetHeight: pr
      });
      Vt == null || Vt(mr, Yt, tr), er && Promise.resolve().then(function() {
        er(mr, Yt);
      });
    }
  }, []);
  return React.useEffect(function() {
    var Yt = Qt();
    return Yt && !$t && observe(Yt, Zt), function() {
      return unobserve(Yt, Zt);
    };
  }, [Mt.current, $t]), /* @__PURE__ */ React.createElement(DomWrapper$1, {
    ref: Bt
  }, Gt ? /* @__PURE__ */ React.cloneElement(Ht, {
    ref: Kt
  }) : Ht);
}
var RefSingleObserver = /* @__PURE__ */ React.forwardRef(SingleObserver);
browser$1.env.NODE_ENV !== "production" && (RefSingleObserver.displayName = "SingleObserver");
var INTERNAL_PREFIX_KEY = "rc-observer-key";
function ResizeObserver$1(_t, Et) {
  var Pt = _t.children, $t = typeof Pt == "function" ? [Pt] : toArray$4(Pt);
  return browser$1.env.NODE_ENV !== "production" && ($t.length > 1 ? warning$3(!1, "Find more than one child node with `children` in ResizeObserver. Please use ResizeObserver.Collection instead.") : $t.length === 0 && warning$3(!1, "`children` of ResizeObserver is empty. Nothing is in observe.")), $t.map(function(Mt, Bt) {
    var Vt = (Mt == null ? void 0 : Mt.key) || "".concat(INTERNAL_PREFIX_KEY, "-").concat(Bt);
    return /* @__PURE__ */ React.createElement(RefSingleObserver, _extends$2({}, _t, {
      key: Vt,
      ref: Bt === 0 ? Et : void 0
    }), Mt);
  });
}
var RefResizeObserver = /* @__PURE__ */ React.forwardRef(ResizeObserver$1);
browser$1.env.NODE_ENV !== "production" && (RefResizeObserver.displayName = "ResizeObserver");
RefResizeObserver.Collection = Collection;
function omit(_t, Et) {
  var Pt = Object.assign({}, _t);
  return Array.isArray(Et) && Et.forEach(function($t) {
    delete Pt[$t];
  }), Pt;
}
function _arrayWithoutHoles(_t) {
  if (Array.isArray(_t))
    return _arrayLikeToArray(_t);
}
function _iterableToArray(_t) {
  if (typeof Symbol < "u" && _t[Symbol.iterator] != null || _t["@@iterator"] != null)
    return Array.from(_t);
}
function _nonIterableSpread() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _toConsumableArray(_t) {
  return _arrayWithoutHoles(_t) || _iterableToArray(_t) || _unsupportedIterableToArray(_t) || _nonIterableSpread();
}
var raf = function(Et) {
  return +setTimeout(Et, 16);
}, caf = function(Et) {
  return clearTimeout(Et);
};
typeof window < "u" && "requestAnimationFrame" in window && (raf = function(Et) {
  return window.requestAnimationFrame(Et);
}, caf = function(Et) {
  return window.cancelAnimationFrame(Et);
});
var rafUUID = 0, rafIds = /* @__PURE__ */ new Map();
function cleanup(_t) {
  rafIds.delete(_t);
}
var wrapperRaf = function(Et) {
  var Pt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  rafUUID += 1;
  var $t = rafUUID;
  function Mt(Bt) {
    if (Bt === 0)
      cleanup($t), Et();
    else {
      var Vt = raf(function() {
        Mt(Bt - 1);
      });
      rafIds.set($t, Vt);
    }
  }
  return Mt(Pt), $t;
};
wrapperRaf.cancel = function(_t) {
  var Et = rafIds.get(_t);
  return cleanup(_t), caf(Et);
};
browser$1.env.NODE_ENV !== "production" && (wrapperRaf.ids = function() {
  return rafIds;
});
function murmur2(_t) {
  for (var Et = 0, Pt, $t = 0, Mt = _t.length; Mt >= 4; ++$t, Mt -= 4)
    Pt = _t.charCodeAt($t) & 255 | (_t.charCodeAt(++$t) & 255) << 8 | (_t.charCodeAt(++$t) & 255) << 16 | (_t.charCodeAt(++$t) & 255) << 24, Pt = /* Math.imul(k, m): */
    (Pt & 65535) * 1540483477 + ((Pt >>> 16) * 59797 << 16), Pt ^= /* k >>> r: */
    Pt >>> 24, Et = /* Math.imul(k, m): */
    (Pt & 65535) * 1540483477 + ((Pt >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (Et & 65535) * 1540483477 + ((Et >>> 16) * 59797 << 16);
  switch (Mt) {
    case 3:
      Et ^= (_t.charCodeAt($t + 2) & 255) << 16;
    case 2:
      Et ^= (_t.charCodeAt($t + 1) & 255) << 8;
    case 1:
      Et ^= _t.charCodeAt($t) & 255, Et = /* Math.imul(h, m): */
      (Et & 65535) * 1540483477 + ((Et >>> 16) * 59797 << 16);
  }
  return Et ^= Et >>> 13, Et = /* Math.imul(h, m): */
  (Et & 65535) * 1540483477 + ((Et >>> 16) * 59797 << 16), ((Et ^ Et >>> 15) >>> 0).toString(36);
}
function isEqual(_t, Et) {
  var Pt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, $t = /* @__PURE__ */ new Set();
  function Mt(Bt, Vt) {
    var zt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, Ht = $t.has(Bt);
    if (warningOnce(!Ht, "Warning: There may be circular references"), Ht)
      return !1;
    if (Bt === Vt)
      return !0;
    if (Pt && zt > 1)
      return !1;
    $t.add(Bt);
    var Wt = zt + 1;
    if (Array.isArray(Bt)) {
      if (!Array.isArray(Vt) || Bt.length !== Vt.length)
        return !1;
      for (var Gt = 0; Gt < Bt.length; Gt++)
        if (!Mt(Bt[Gt], Vt[Gt], Wt))
          return !1;
      return !0;
    }
    if (Bt && Vt && _typeof(Bt) === "object" && _typeof(Vt) === "object") {
      var qt = Object.keys(Bt);
      return qt.length !== Object.keys(Vt).length ? !1 : qt.every(function(Kt) {
        return Mt(Bt[Kt], Vt[Kt], Wt);
      });
    }
    return !1;
  }
  return Mt(_t, Et);
}
var SPLIT$1 = "%";
function pathKey(_t) {
  return _t.join(SPLIT$1);
}
var Entity = /* @__PURE__ */ function() {
  function _t(Et) {
    _classCallCheck(this, _t), _defineProperty(this, "instanceId", void 0), _defineProperty(this, "cache", /* @__PURE__ */ new Map()), this.instanceId = Et;
  }
  return _createClass(_t, [{
    key: "get",
    value: function(Pt) {
      return this.opGet(pathKey(Pt));
    }
    /** A fast get cache with `get` concat. */
  }, {
    key: "opGet",
    value: function(Pt) {
      return this.cache.get(Pt) || null;
    }
  }, {
    key: "update",
    value: function(Pt, $t) {
      return this.opUpdate(pathKey(Pt), $t);
    }
    /** A fast get cache with `get` concat. */
  }, {
    key: "opUpdate",
    value: function(Pt, $t) {
      var Mt = this.cache.get(Pt), Bt = $t(Mt);
      Bt === null ? this.cache.delete(Pt) : this.cache.set(Pt, Bt);
    }
  }]), _t;
}(), ATTR_TOKEN = "data-token-hash", ATTR_MARK = "data-css-hash", ATTR_CACHE_PATH = "data-cache-path", CSS_IN_JS_INSTANCE = "__cssinjs_instance__";
function createCache() {
  var _t = Math.random().toString(12).slice(2);
  if (typeof document < "u" && document.head && document.body) {
    var Et = document.body.querySelectorAll("style[".concat(ATTR_MARK, "]")) || [], Pt = document.head.firstChild;
    Array.from(Et).forEach(function(Mt) {
      Mt[CSS_IN_JS_INSTANCE] = Mt[CSS_IN_JS_INSTANCE] || _t, Mt[CSS_IN_JS_INSTANCE] === _t && document.head.insertBefore(Mt, Pt);
    });
    var $t = {};
    Array.from(document.querySelectorAll("style[".concat(ATTR_MARK, "]"))).forEach(function(Mt) {
      var Bt = Mt.getAttribute(ATTR_MARK);
      if ($t[Bt]) {
        if (Mt[CSS_IN_JS_INSTANCE] === _t) {
          var Vt;
          (Vt = Mt.parentNode) === null || Vt === void 0 || Vt.removeChild(Mt);
        }
      } else
        $t[Bt] = !0;
    });
  }
  return new Entity(_t);
}
var StyleContext = /* @__PURE__ */ React.createContext({
  hashPriority: "low",
  cache: createCache(),
  defaultCache: !0
});
function sameDerivativeOption(_t, Et) {
  if (_t.length !== Et.length)
    return !1;
  for (var Pt = 0; Pt < _t.length; Pt++)
    if (_t[Pt] !== Et[Pt])
      return !1;
  return !0;
}
var ThemeCache = /* @__PURE__ */ function() {
  function _t() {
    _classCallCheck(this, _t), _defineProperty(this, "cache", void 0), _defineProperty(this, "keys", void 0), _defineProperty(this, "cacheCallTimes", void 0), this.cache = /* @__PURE__ */ new Map(), this.keys = [], this.cacheCallTimes = 0;
  }
  return _createClass(_t, [{
    key: "size",
    value: function() {
      return this.keys.length;
    }
  }, {
    key: "internalGet",
    value: function(Pt) {
      var $t, Mt, Bt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, Vt = {
        map: this.cache
      };
      return Pt.forEach(function(zt) {
        if (!Vt)
          Vt = void 0;
        else {
          var Ht;
          Vt = (Ht = Vt) === null || Ht === void 0 || (Ht = Ht.map) === null || Ht === void 0 ? void 0 : Ht.get(zt);
        }
      }), ($t = Vt) !== null && $t !== void 0 && $t.value && Bt && (Vt.value[1] = this.cacheCallTimes++), (Mt = Vt) === null || Mt === void 0 ? void 0 : Mt.value;
    }
  }, {
    key: "get",
    value: function(Pt) {
      var $t;
      return ($t = this.internalGet(Pt, !0)) === null || $t === void 0 ? void 0 : $t[0];
    }
  }, {
    key: "has",
    value: function(Pt) {
      return !!this.internalGet(Pt);
    }
  }, {
    key: "set",
    value: function(Pt, $t) {
      var Mt = this;
      if (!this.has(Pt)) {
        if (this.size() + 1 > _t.MAX_CACHE_SIZE + _t.MAX_CACHE_OFFSET) {
          var Bt = this.keys.reduce(function(Wt, Gt) {
            var qt = _slicedToArray(Wt, 2), Kt = qt[1];
            return Mt.internalGet(Gt)[1] < Kt ? [Gt, Mt.internalGet(Gt)[1]] : Wt;
          }, [this.keys[0], this.cacheCallTimes]), Vt = _slicedToArray(Bt, 1), zt = Vt[0];
          this.delete(zt);
        }
        this.keys.push(Pt);
      }
      var Ht = this.cache;
      Pt.forEach(function(Wt, Gt) {
        if (Gt === Pt.length - 1)
          Ht.set(Wt, {
            value: [$t, Mt.cacheCallTimes++]
          });
        else {
          var qt = Ht.get(Wt);
          qt ? qt.map || (qt.map = /* @__PURE__ */ new Map()) : Ht.set(Wt, {
            map: /* @__PURE__ */ new Map()
          }), Ht = Ht.get(Wt).map;
        }
      });
    }
  }, {
    key: "deleteByPath",
    value: function(Pt, $t) {
      var Mt = Pt.get($t[0]);
      if ($t.length === 1) {
        var Bt;
        return Mt.map ? Pt.set($t[0], {
          map: Mt.map
        }) : Pt.delete($t[0]), (Bt = Mt.value) === null || Bt === void 0 ? void 0 : Bt[0];
      }
      var Vt = this.deleteByPath(Mt.map, $t.slice(1));
      return (!Mt.map || Mt.map.size === 0) && !Mt.value && Pt.delete($t[0]), Vt;
    }
  }, {
    key: "delete",
    value: function(Pt) {
      if (this.has(Pt))
        return this.keys = this.keys.filter(function($t) {
          return !sameDerivativeOption($t, Pt);
        }), this.deleteByPath(this.cache, Pt);
    }
  }]), _t;
}();
_defineProperty(ThemeCache, "MAX_CACHE_SIZE", 20);
_defineProperty(ThemeCache, "MAX_CACHE_OFFSET", 5);
var uuid$4 = 0, Theme = /* @__PURE__ */ function() {
  function _t(Et) {
    _classCallCheck(this, _t), _defineProperty(this, "derivatives", void 0), _defineProperty(this, "id", void 0), this.derivatives = Array.isArray(Et) ? Et : [Et], this.id = uuid$4, Et.length === 0 && warning$3(Et.length > 0, "[Ant Design CSS-in-JS] Theme should have at least one derivative function."), uuid$4 += 1;
  }
  return _createClass(_t, [{
    key: "getDerivativeToken",
    value: function(Pt) {
      return this.derivatives.reduce(function($t, Mt) {
        return Mt(Pt, $t);
      }, void 0);
    }
  }]), _t;
}(), cacheThemes = new ThemeCache();
function createTheme(_t) {
  var Et = Array.isArray(_t) ? _t : [_t];
  return cacheThemes.has(Et) || cacheThemes.set(Et, new Theme(Et)), cacheThemes.get(Et);
}
var resultCache = /* @__PURE__ */ new WeakMap(), RESULT_VALUE = {};
function memoResult(_t, Et) {
  for (var Pt = resultCache, $t = 0; $t < Et.length; $t += 1) {
    var Mt = Et[$t];
    Pt.has(Mt) || Pt.set(Mt, /* @__PURE__ */ new WeakMap()), Pt = Pt.get(Mt);
  }
  return Pt.has(RESULT_VALUE) || Pt.set(RESULT_VALUE, _t()), Pt.get(RESULT_VALUE);
}
var flattenTokenCache = /* @__PURE__ */ new WeakMap();
function flattenToken(_t) {
  var Et = flattenTokenCache.get(_t) || "";
  return Et || (Object.keys(_t).forEach(function(Pt) {
    var $t = _t[Pt];
    Et += Pt, $t instanceof Theme ? Et += $t.id : $t && _typeof($t) === "object" ? Et += flattenToken($t) : Et += $t;
  }), Et = murmur2(Et), flattenTokenCache.set(_t, Et)), Et;
}
function token2key(_t, Et) {
  return murmur2("".concat(Et, "_").concat(flattenToken(_t)));
}
var isClientSide = canUseDom();
function unit$1(_t) {
  return typeof _t == "number" ? "".concat(_t, "px") : _t;
}
function toStyleStr(_t, Et, Pt) {
  var $t, Mt = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, Bt = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1;
  if (Bt)
    return _t;
  var Vt = _objectSpread2(_objectSpread2({}, Mt), {}, ($t = {}, _defineProperty($t, ATTR_TOKEN, Et), _defineProperty($t, ATTR_MARK, Pt), $t)), zt = Object.keys(Vt).map(function(Ht) {
    var Wt = Vt[Ht];
    return Wt ? "".concat(Ht, '="').concat(Wt, '"') : null;
  }).filter(function(Ht) {
    return Ht;
  }).join(" ");
  return "<style ".concat(zt, ">").concat(_t, "</style>");
}
var token2CSSVar = function(Et) {
  var Pt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return "--".concat(Pt ? "".concat(Pt, "-") : "").concat(Et).replace(/([a-z0-9])([A-Z])/g, "$1-$2").replace(/([A-Z]+)([A-Z][a-z0-9]+)/g, "$1-$2").replace(/([a-z])([A-Z0-9])/g, "$1-$2").toLowerCase();
}, serializeCSSVar = function(Et, Pt, $t) {
  return Object.keys(Et).length ? ".".concat(Pt).concat($t != null && $t.scope ? ".".concat($t.scope) : "", "{").concat(Object.entries(Et).map(function(Mt) {
    var Bt = _slicedToArray(Mt, 2), Vt = Bt[0], zt = Bt[1];
    return "".concat(Vt, ":").concat(zt, ";");
  }).join(""), "}") : "";
}, transformToken = function(Et, Pt, $t) {
  var Mt = {}, Bt = {};
  return Object.entries(Et).forEach(function(Vt) {
    var zt, Ht, Wt = _slicedToArray(Vt, 2), Gt = Wt[0], qt = Wt[1];
    if ($t != null && (zt = $t.preserve) !== null && zt !== void 0 && zt[Gt])
      Bt[Gt] = qt;
    else if ((typeof qt == "string" || typeof qt == "number") && !($t != null && (Ht = $t.ignore) !== null && Ht !== void 0 && Ht[Gt])) {
      var Kt, Qt = token2CSSVar(Gt, $t == null ? void 0 : $t.prefix);
      Mt[Qt] = typeof qt == "number" && !($t != null && (Kt = $t.unitless) !== null && Kt !== void 0 && Kt[Gt]) ? "".concat(qt, "px") : String(qt), Bt[Gt] = "var(".concat(Qt, ")");
    }
  }), [Bt, serializeCSSVar(Mt, Pt, {
    scope: $t == null ? void 0 : $t.scope
  })];
}, useInternalLayoutEffect = browser$1.env.NODE_ENV !== "test" && canUseDom() ? React.useLayoutEffect : React.useEffect, useLayoutEffect = function(Et, Pt) {
  var $t = React.useRef(!0);
  useInternalLayoutEffect(function() {
    return Et($t.current);
  }, Pt), useInternalLayoutEffect(function() {
    return $t.current = !1, function() {
      $t.current = !0;
    };
  }, []);
}, useLayoutUpdateEffect = function(Et, Pt) {
  useLayoutEffect(function($t) {
    if (!$t)
      return Et();
  }, Pt);
}, fullClone$3 = _objectSpread2({}, React), useInsertionEffect$1 = fullClone$3.useInsertionEffect, useInsertionEffectPolyfill = function(Et, Pt, $t) {
  React.useMemo(Et, $t), useLayoutEffect(function() {
    return Pt(!0);
  }, $t);
}, useCompatibleInsertionEffect = useInsertionEffect$1 ? function(_t, Et, Pt) {
  return useInsertionEffect$1(function() {
    return _t(), Et();
  }, Pt);
} : useInsertionEffectPolyfill, fullClone$2 = _objectSpread2({}, React), useInsertionEffect = fullClone$2.useInsertionEffect, useCleanupRegister = function(Et) {
  var Pt = [], $t = !1;
  function Mt(Bt) {
    if ($t) {
      browser$1.env.NODE_ENV !== "production" && warning$3(!1, "[Ant Design CSS-in-JS] You are registering a cleanup function after unmount, which will not have any effect.");
      return;
    }
    Pt.push(Bt);
  }
  return React.useEffect(function() {
    return $t = !1, function() {
      $t = !0, Pt.length && Pt.forEach(function(Bt) {
        return Bt();
      });
    };
  }, Et), Mt;
}, useRun = function() {
  return function(Et) {
    Et();
  };
}, useEffectCleanupRegister = typeof useInsertionEffect < "u" ? useCleanupRegister : useRun;
function useProdHMR() {
  return !1;
}
var webpackHMR = !1;
function useDevHMR() {
  return webpackHMR;
}
const useHMR = browser$1.env.NODE_ENV === "production" ? useProdHMR : useDevHMR;
if (browser$1.env.NODE_ENV !== "production" && typeof module < "u" && module && module.hot && typeof window < "u") {
  var win = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : null;
  if (win && typeof win.webpackHotUpdate == "function") {
    var originWebpackHotUpdate = win.webpackHotUpdate;
    win.webpackHotUpdate = function() {
      return webpackHMR = !0, setTimeout(function() {
        webpackHMR = !1;
      }, 0), originWebpackHotUpdate.apply(void 0, arguments);
    };
  }
}
function useGlobalCache(_t, Et, Pt, $t, Mt) {
  var Bt = React.useContext(StyleContext), Vt = Bt.cache, zt = [_t].concat(_toConsumableArray(Et)), Ht = pathKey(zt), Wt = useEffectCleanupRegister([Ht]), Gt = useHMR(), qt = function(Zt) {
    Vt.opUpdate(Ht, function(Yt) {
      var Jt = Yt || [void 0, void 0], er = _slicedToArray(Jt, 2), tr = er[0], nr = tr === void 0 ? 0 : tr, rr = er[1], ir = rr;
      browser$1.env.NODE_ENV !== "production" && rr && Gt && ($t == null || $t(ir, Gt), ir = null);
      var ar = ir || Pt(), or = [nr, ar];
      return Zt ? Zt(or) : or;
    });
  };
  React.useMemo(
    function() {
      qt();
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [Ht]
    /* eslint-enable */
  );
  var Kt = Vt.opGet(Ht);
  browser$1.env.NODE_ENV !== "production" && !Kt && (qt(), Kt = Vt.opGet(Ht));
  var Qt = Kt[1];
  return useCompatibleInsertionEffect(function() {
    Mt == null || Mt(Qt);
  }, function(Xt) {
    return qt(function(Zt) {
      var Yt = _slicedToArray(Zt, 2), Jt = Yt[0], er = Yt[1];
      return Xt && Jt === 0 && (Mt == null || Mt(Qt)), [Jt + 1, er];
    }), function() {
      Vt.opUpdate(Ht, function(Zt) {
        var Yt = Zt || [], Jt = _slicedToArray(Yt, 2), er = Jt[0], tr = er === void 0 ? 0 : er, nr = Jt[1], rr = tr - 1;
        return rr === 0 ? (Wt(function() {
          (Xt || !Vt.opGet(Ht)) && ($t == null || $t(nr, !1));
        }), null) : [tr - 1, nr];
      });
    };
  }, [Ht]), Qt;
}
var EMPTY_OVERRIDE = {}, hashPrefix = browser$1.env.NODE_ENV !== "production" ? "css-dev-only-do-not-override" : "css", tokenKeys = /* @__PURE__ */ new Map();
function recordCleanToken(_t) {
  tokenKeys.set(_t, (tokenKeys.get(_t) || 0) + 1);
}
function removeStyleTags(_t, Et) {
  if (typeof document < "u") {
    var Pt = document.querySelectorAll("style[".concat(ATTR_TOKEN, '="').concat(_t, '"]'));
    Pt.forEach(function($t) {
      if ($t[CSS_IN_JS_INSTANCE] === Et) {
        var Mt;
        (Mt = $t.parentNode) === null || Mt === void 0 || Mt.removeChild($t);
      }
    });
  }
}
var TOKEN_THRESHOLD = 0;
function cleanTokenStyle(_t, Et) {
  tokenKeys.set(_t, (tokenKeys.get(_t) || 0) - 1);
  var Pt = Array.from(tokenKeys.keys()), $t = Pt.filter(function(Mt) {
    var Bt = tokenKeys.get(Mt) || 0;
    return Bt <= 0;
  });
  Pt.length - $t.length > TOKEN_THRESHOLD && $t.forEach(function(Mt) {
    removeStyleTags(Mt, Et), tokenKeys.delete(Mt);
  });
}
var getComputedToken$1 = function(Et, Pt, $t, Mt) {
  var Bt = $t.getDerivativeToken(Et), Vt = _objectSpread2(_objectSpread2({}, Bt), Pt);
  return Mt && (Vt = Mt(Vt)), Vt;
}, TOKEN_PREFIX = "token";
function useCacheToken(_t, Et) {
  var Pt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, $t = useContext(StyleContext), Mt = $t.cache.instanceId, Bt = $t.container, Vt = Pt.salt, zt = Vt === void 0 ? "" : Vt, Ht = Pt.override, Wt = Ht === void 0 ? EMPTY_OVERRIDE : Ht, Gt = Pt.formatToken, qt = Pt.getComputedToken, Kt = Pt.cssVar, Qt = memoResult(function() {
    return Object.assign.apply(Object, [{}].concat(_toConsumableArray(Et)));
  }, Et), Xt = flattenToken(Qt), Zt = flattenToken(Wt), Yt = Kt ? flattenToken(Kt) : "", Jt = useGlobalCache(TOKEN_PREFIX, [zt, _t.id, Xt, Zt, Yt], function() {
    var er, tr = qt ? qt(Qt, Wt, _t) : getComputedToken$1(Qt, Wt, _t, Gt), nr = _objectSpread2({}, tr), rr = "";
    if (Kt) {
      var ir = transformToken(tr, Kt.key, {
        prefix: Kt.prefix,
        ignore: Kt.ignore,
        unitless: Kt.unitless,
        preserve: Kt.preserve
      }), ar = _slicedToArray(ir, 2);
      tr = ar[0], rr = ar[1];
    }
    var or = token2key(tr, zt);
    tr._tokenKey = or, nr._tokenKey = token2key(nr, zt);
    var sr = (er = Kt == null ? void 0 : Kt.key) !== null && er !== void 0 ? er : or;
    tr._themeKey = sr, recordCleanToken(sr);
    var lr = "".concat(hashPrefix, "-").concat(murmur2(or));
    return tr._hashId = lr, [tr, lr, nr, rr, (Kt == null ? void 0 : Kt.key) || ""];
  }, function(er) {
    cleanTokenStyle(er[0]._themeKey, Mt);
  }, function(er) {
    var tr = _slicedToArray(er, 4), nr = tr[0], rr = tr[3];
    if (Kt && rr) {
      var ir = updateCSS(rr, murmur2("css-variables-".concat(nr._themeKey)), {
        mark: ATTR_MARK,
        prepend: "queue",
        attachTo: Bt,
        priority: -999
      });
      ir[CSS_IN_JS_INSTANCE] = Mt, ir.setAttribute(ATTR_TOKEN, nr._themeKey);
    }
  });
  return Jt;
}
var extract$2 = function(Et, Pt, $t) {
  var Mt = _slicedToArray(Et, 5), Bt = Mt[2], Vt = Mt[3], zt = Mt[4], Ht = $t || {}, Wt = Ht.plain;
  if (!Vt)
    return null;
  var Gt = Bt._tokenKey, qt = -999, Kt = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(qt)
  }, Qt = toStyleStr(Vt, zt, Gt, Kt, Wt);
  return [qt, Gt, Qt];
}, unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, COMMENT = "comm", RULESET = "rule", DECLARATION = "decl", IMPORT = "@import", KEYFRAMES = "@keyframes", LAYER = "@layer", abs$2 = Math.abs, from$2 = String.fromCharCode;
function trim$1(_t) {
  return _t.trim();
}
function replace(_t, Et, Pt) {
  return _t.replace(Et, Pt);
}
function indexof(_t, Et, Pt) {
  return _t.indexOf(Et, Pt);
}
function charat(_t, Et) {
  return _t.charCodeAt(Et) | 0;
}
function substr(_t, Et, Pt) {
  return _t.slice(Et, Pt);
}
function strlen(_t) {
  return _t.length;
}
function sizeof(_t) {
  return _t.length;
}
function append(_t, Et) {
  return Et.push(_t), _t;
}
var line = 1, column = 1, length = 0, position = 0, character = 0, characters = "";
function node(_t, Et, Pt, $t, Mt, Bt, Vt, zt) {
  return { value: _t, root: Et, parent: Pt, type: $t, props: Mt, children: Bt, line, column, length: Vt, return: "", siblings: zt };
}
function char() {
  return character;
}
function prev() {
  return character = position > 0 ? charat(characters, --position) : 0, column--, character === 10 && (column = 1, line--), character;
}
function next() {
  return character = position < length ? charat(characters, position++) : 0, column++, character === 10 && (column = 1, line++), character;
}
function peek() {
  return charat(characters, position);
}
function caret() {
  return position;
}
function slice(_t, Et) {
  return substr(characters, _t, Et);
}
function token$1(_t) {
  switch (_t) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc$1(_t) {
  return line = column = 1, length = strlen(characters = _t), position = 0, [];
}
function dealloc(_t) {
  return characters = "", _t;
}
function delimit(_t) {
  return trim$1(slice(position - 1, delimiter(_t === 91 ? _t + 2 : _t === 40 ? _t + 1 : _t)));
}
function whitespace$1(_t) {
  for (; (character = peek()) && character < 33; )
    next();
  return token$1(_t) > 2 || token$1(character) > 3 ? "" : " ";
}
function escaping(_t, Et) {
  for (; --Et && next() && !(character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97); )
    ;
  return slice(_t, caret() + (Et < 6 && peek() == 32 && next() == 32));
}
function delimiter(_t) {
  for (; next(); )
    switch (character) {
      case _t:
        return position;
      case 34:
      case 39:
        _t !== 34 && _t !== 39 && delimiter(character);
        break;
      case 40:
        _t === 41 && delimiter(_t);
        break;
      case 92:
        next();
        break;
    }
  return position;
}
function commenter(_t, Et) {
  for (; next() && _t + character !== 57; )
    if (_t + character === 84 && peek() === 47)
      break;
  return "/*" + slice(Et, position - 1) + "*" + from$2(_t === 47 ? _t : next());
}
function identifier(_t) {
  for (; !token$1(peek()); )
    next();
  return slice(_t, position);
}
function compile(_t) {
  return dealloc(parse("", null, null, null, [""], _t = alloc$1(_t), 0, [0], _t));
}
function parse(_t, Et, Pt, $t, Mt, Bt, Vt, zt, Ht) {
  for (var Wt = 0, Gt = 0, qt = Vt, Kt = 0, Qt = 0, Xt = 0, Zt = 1, Yt = 1, Jt = 1, er = 0, tr = "", nr = Mt, rr = Bt, ir = $t, ar = tr; Yt; )
    switch (Xt = er, er = next()) {
      case 40:
        if (Xt != 108 && charat(ar, qt - 1) == 58) {
          indexof(ar += replace(delimit(er), "&", "&\f"), "&\f", abs$2(Wt ? zt[Wt - 1] : 0)) != -1 && (Jt = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        ar += delimit(er);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        ar += whitespace$1(Xt);
        break;
      case 92:
        ar += escaping(caret() - 1, 7);
        continue;
      case 47:
        switch (peek()) {
          case 42:
          case 47:
            append(comment(commenter(next(), caret()), Et, Pt, Ht), Ht), (token$1(Xt || 1) == 5 || token$1(peek() || 1) == 5) && strlen(ar) && substr(ar, -1, void 0) !== " " && (ar += " ");
            break;
          default:
            ar += "/";
        }
        break;
      case 123 * Zt:
        zt[Wt++] = strlen(ar) * Jt;
      case 125 * Zt:
      case 59:
      case 0:
        switch (er) {
          case 0:
          case 125:
            Yt = 0;
          case 59 + Gt:
            Jt == -1 && (ar = replace(ar, /\f/g, "")), Qt > 0 && (strlen(ar) - qt || Zt === 0 && Xt === 47) && append(Qt > 32 ? declaration(ar + ";", $t, Pt, qt - 1, Ht) : declaration(replace(ar, " ", "") + ";", $t, Pt, qt - 2, Ht), Ht);
            break;
          case 59:
            ar += ";";
          default:
            if (append(ir = ruleset(ar, Et, Pt, Wt, Gt, Mt, zt, tr, nr = [], rr = [], qt, Bt), Bt), er === 123)
              if (Gt === 0)
                parse(ar, Et, ir, ir, nr, Bt, qt, zt, rr);
              else {
                switch (Kt) {
                  case 99:
                    if (charat(ar, 3) === 110)
                      break;
                  case 108:
                    if (charat(ar, 2) === 97)
                      break;
                  default:
                    Gt = 0;
                  case 100:
                  case 109:
                  case 115:
                }
                Gt ? parse(_t, ir, ir, $t && append(ruleset(_t, ir, ir, 0, 0, Mt, zt, tr, Mt, nr = [], qt, rr), rr), Mt, rr, qt, zt, $t ? nr : rr) : parse(ar, ir, ir, ir, [""], rr, 0, zt, rr);
              }
        }
        Wt = Gt = Qt = 0, Zt = Jt = 1, tr = ar = "", qt = Vt;
        break;
      case 58:
        qt = 1 + strlen(ar), Qt = Xt;
      default:
        if (Zt < 1) {
          if (er == 123)
            --Zt;
          else if (er == 125 && Zt++ == 0 && prev() == 125)
            continue;
        }
        switch (ar += from$2(er), er * Zt) {
          case 38:
            Jt = Gt > 0 ? 1 : (ar += "\f", -1);
            break;
          case 44:
            zt[Wt++] = (strlen(ar) - 1) * Jt, Jt = 1;
            break;
          case 64:
            peek() === 45 && (ar += delimit(next())), Kt = peek(), Gt = qt = strlen(tr = ar += identifier(caret())), er++;
            break;
          case 45:
            Xt === 45 && strlen(ar) == 2 && (Zt = 0);
        }
    }
  return Bt;
}
function ruleset(_t, Et, Pt, $t, Mt, Bt, Vt, zt, Ht, Wt, Gt, qt) {
  for (var Kt = Mt - 1, Qt = Mt === 0 ? Bt : [""], Xt = sizeof(Qt), Zt = 0, Yt = 0, Jt = 0; Zt < $t; ++Zt)
    for (var er = 0, tr = substr(_t, Kt + 1, Kt = abs$2(Yt = Vt[Zt])), nr = _t; er < Xt; ++er)
      (nr = trim$1(Yt > 0 ? Qt[er] + " " + tr : replace(tr, /&\f/g, Qt[er]))) && (Ht[Jt++] = nr);
  return node(_t, Et, Pt, Mt === 0 ? RULESET : zt, Ht, Wt, Gt, qt);
}
function comment(_t, Et, Pt, $t) {
  return node(_t, Et, Pt, COMMENT, from$2(char()), substr(_t, 2, -2), 0, $t);
}
function declaration(_t, Et, Pt, $t, Mt) {
  return node(_t, Et, Pt, DECLARATION, substr(_t, 0, $t), substr(_t, $t + 1, -1), $t, Mt);
}
function serialize(_t, Et) {
  for (var Pt = "", $t = 0; $t < _t.length; $t++)
    Pt += Et(_t[$t], $t, _t, Et) || "";
  return Pt;
}
function stringify$2(_t, Et, Pt, $t) {
  switch (_t.type) {
    case LAYER:
      if (_t.children.length)
        break;
    case IMPORT:
    case DECLARATION:
      return _t.return = _t.return || _t.value;
    case COMMENT:
      return "";
    case KEYFRAMES:
      return _t.return = _t.value + "{" + serialize(_t.children, $t) + "}";
    case RULESET:
      if (!strlen(_t.value = _t.props.join(",")))
        return "";
  }
  return strlen(Pt = serialize(_t.children, $t)) ? _t.return = _t.value + "{" + Pt + "}" : "";
}
function lintWarning(_t, Et) {
  var Pt = Et.path, $t = Et.parentSelectors;
  warningOnce(!1, "[Ant Design CSS-in-JS] ".concat(Pt ? "Error in ".concat(Pt, ": ") : "").concat(_t).concat($t.length ? " Selector: ".concat($t.join(" | ")) : ""));
}
var linter$1 = function(Et, Pt, $t) {
  if (Et === "content") {
    var Mt = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, Bt = ["normal", "none", "initial", "inherit", "unset"];
    (typeof Pt != "string" || Bt.indexOf(Pt) === -1 && !Mt.test(Pt) && (Pt.charAt(0) !== Pt.charAt(Pt.length - 1) || Pt.charAt(0) !== '"' && Pt.charAt(0) !== "'")) && lintWarning("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"".concat(Pt, "\"'`."), $t);
  }
}, linter = function(Et, Pt, $t) {
  Et === "animation" && $t.hashId && Pt !== "none" && lintWarning("You seem to be using hashed animation '".concat(Pt, "', in which case 'animationName' with Keyframe as value is recommended."), $t);
}, ATTR_CACHE_MAP = "data-ant-cssinjs-cache-path", CSS_FILE_STYLE = "_FILE_STYLE__", cachePathMap, fromCSSFile = !0;
function prepare() {
  if (!cachePathMap && (cachePathMap = {}, canUseDom())) {
    var _t = document.createElement("div");
    _t.className = ATTR_CACHE_MAP, _t.style.position = "fixed", _t.style.visibility = "hidden", _t.style.top = "-9999px", document.body.appendChild(_t);
    var Et = getComputedStyle(_t).content || "";
    Et = Et.replace(/^"/, "").replace(/"$/, ""), Et.split(";").forEach(function(Mt) {
      var Bt = Mt.split(":"), Vt = _slicedToArray(Bt, 2), zt = Vt[0], Ht = Vt[1];
      cachePathMap[zt] = Ht;
    });
    var Pt = document.querySelector("style[".concat(ATTR_CACHE_MAP, "]"));
    if (Pt) {
      var $t;
      fromCSSFile = !1, ($t = Pt.parentNode) === null || $t === void 0 || $t.removeChild(Pt);
    }
    document.body.removeChild(_t);
  }
}
function existPath(_t) {
  return prepare(), !!cachePathMap[_t];
}
function getStyleAndHash(_t) {
  var Et = cachePathMap[_t], Pt = null;
  if (Et && canUseDom())
    if (fromCSSFile)
      Pt = CSS_FILE_STYLE;
    else {
      var $t = document.querySelector("style[".concat(ATTR_MARK, '="').concat(cachePathMap[_t], '"]'));
      $t ? Pt = $t.innerHTML : delete cachePathMap[_t];
    }
  return [Pt, Et];
}
var SKIP_CHECK = "_skip_check_", MULTI_VALUE = "_multi_value_";
function normalizeStyle(_t) {
  var Et = serialize(compile(_t), stringify$2);
  return Et.replace(/\{%%%\:[^;];}/g, ";");
}
function isCompoundCSSProperty(_t) {
  return _typeof(_t) === "object" && _t && (SKIP_CHECK in _t || MULTI_VALUE in _t);
}
function injectSelectorHash(_t, Et, Pt) {
  if (!Et)
    return _t;
  var $t = ".".concat(Et), Mt = Pt === "low" ? ":where(".concat($t, ")") : $t, Bt = _t.split(",").map(function(Vt) {
    var zt, Ht = Vt.trim().split(/\s+/), Wt = Ht[0] || "", Gt = ((zt = Wt.match(/^\w+/)) === null || zt === void 0 ? void 0 : zt[0]) || "";
    return Wt = "".concat(Gt).concat(Mt).concat(Wt.slice(Gt.length)), [Wt].concat(_toConsumableArray(Ht.slice(1))).join(" ");
  });
  return Bt.join(",");
}
var parseStyle = function _t(Et) {
  var Pt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, $t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    root: !0,
    parentSelectors: []
  }, Mt = $t.root, Bt = $t.injectHash, Vt = $t.parentSelectors, zt = Pt.hashId, Ht = Pt.layer, Wt = Pt.path, Gt = Pt.hashPriority, qt = Pt.transformers, Kt = qt === void 0 ? [] : qt, Qt = Pt.linters, Xt = Qt === void 0 ? [] : Qt, Zt = "", Yt = {};
  function Jt(nr) {
    var rr = nr.getName(zt);
    if (!Yt[rr]) {
      var ir = _t(nr.style, Pt, {
        root: !1,
        parentSelectors: Vt
      }), ar = _slicedToArray(ir, 1), or = ar[0];
      Yt[rr] = "@keyframes ".concat(nr.getName(zt)).concat(or);
    }
  }
  function er(nr) {
    var rr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return nr.forEach(function(ir) {
      Array.isArray(ir) ? er(ir, rr) : ir && rr.push(ir);
    }), rr;
  }
  var tr = er(Array.isArray(Et) ? Et : [Et]);
  return tr.forEach(function(nr) {
    var rr = typeof nr == "string" && !Mt ? {} : nr;
    if (typeof rr == "string")
      Zt += "".concat(rr, `
`);
    else if (rr._keyframe)
      Jt(rr);
    else {
      var ir = Kt.reduce(function(ar, or) {
        var sr;
        return (or == null || (sr = or.visit) === null || sr === void 0 ? void 0 : sr.call(or, ar)) || ar;
      }, rr);
      Object.keys(ir).forEach(function(ar) {
        var or = ir[ar];
        if (_typeof(or) === "object" && or && (ar !== "animationName" || !or._keyframe) && !isCompoundCSSProperty(or)) {
          var sr = !1, lr = ar.trim(), cr = !1;
          (Mt || Bt) && zt ? lr.startsWith("@") ? sr = !0 : lr === "&" ? lr = injectSelectorHash("", zt, Gt) : lr = injectSelectorHash(ar, zt, Gt) : Mt && !zt && (lr === "&" || lr === "") && (lr = "", cr = !0);
          var hr = _t(or, Pt, {
            root: cr,
            injectHash: sr,
            parentSelectors: [].concat(_toConsumableArray(Vt), [lr])
          }), pr = _slicedToArray(hr, 2), mr = pr[0], Er = pr[1];
          Yt = _objectSpread2(_objectSpread2({}, Yt), Er), Zt += "".concat(lr).concat(mr);
        } else {
          let ur = function(vr, dr) {
            browser$1.env.NODE_ENV !== "production" && (_typeof(or) !== "object" || !(or != null && or[SKIP_CHECK])) && [linter$1, linter].concat(_toConsumableArray(Xt)).forEach(function(Pr) {
              return Pr(vr, dr, {
                path: Wt,
                hashId: zt,
                parentSelectors: Vt
              });
            });
            var br = vr.replace(/[A-Z]/g, function(Pr) {
              return "-".concat(Pr.toLowerCase());
            }), Cr = dr;
            !unitlessKeys[vr] && typeof Cr == "number" && Cr !== 0 && (Cr = "".concat(Cr, "px")), vr === "animationName" && dr !== null && dr !== void 0 && dr._keyframe && (Jt(dr), Cr = dr.getName(zt)), Zt += "".concat(br, ":").concat(Cr, ";");
          };
          var _r, yr = (_r = or == null ? void 0 : or.value) !== null && _r !== void 0 ? _r : or;
          _typeof(or) === "object" && or !== null && or !== void 0 && or[MULTI_VALUE] && Array.isArray(yr) ? yr.forEach(function(vr) {
            ur(ar, vr);
          }) : ur(ar, yr);
        }
      });
    }
  }), Mt ? Ht && (Zt && (Zt = "@layer ".concat(Ht.name, " {").concat(Zt, "}")), Ht.dependencies && (Yt["@layer ".concat(Ht.name)] = Ht.dependencies.map(function(nr) {
    return "@layer ".concat(nr, ", ").concat(Ht.name, ";");
  }).join(`
`))) : Zt = "{".concat(Zt, "}"), [Zt, Yt];
};
function uniqueHash(_t, Et) {
  return murmur2("".concat(_t.join("%")).concat(Et));
}
function Empty$1() {
  return null;
}
var STYLE_PREFIX = "style";
function useStyleRegister(_t, Et) {
  var Pt = _t.token, $t = _t.path, Mt = _t.hashId, Bt = _t.layer, Vt = _t.nonce, zt = _t.clientOnly, Ht = _t.order, Wt = Ht === void 0 ? 0 : Ht, Gt = React.useContext(StyleContext), qt = Gt.autoClear, Kt = Gt.mock, Qt = Gt.defaultCache, Xt = Gt.hashPriority, Zt = Gt.container, Yt = Gt.ssrInline, Jt = Gt.transformers, er = Gt.linters, tr = Gt.cache, nr = Gt.layer, rr = Pt._tokenKey, ir = [rr];
  nr && ir.push("layer"), ir.push.apply(ir, _toConsumableArray($t));
  var ar = isClientSide;
  browser$1.env.NODE_ENV !== "production" && Kt !== void 0 && (ar = Kt === "client");
  var or = useGlobalCache(
    STYLE_PREFIX,
    ir,
    // Create cache if needed
    function() {
      var pr = ir.join("|");
      if (existPath(pr)) {
        var mr = getStyleAndHash(pr), Er = _slicedToArray(mr, 2), _r = Er[0], yr = Er[1];
        if (_r)
          return [_r, rr, yr, {}, zt, Wt];
      }
      var ur = Et(), vr = parseStyle(ur, {
        hashId: Mt,
        hashPriority: Xt,
        layer: nr ? Bt : void 0,
        path: $t.join("-"),
        transformers: Jt,
        linters: er
      }), dr = _slicedToArray(vr, 2), br = dr[0], Cr = dr[1], Pr = normalizeStyle(br), xr = uniqueHash(ir, Pr);
      return [Pr, rr, xr, Cr, zt, Wt];
    },
    // Remove cache if no need
    function(pr, mr) {
      var Er = _slicedToArray(pr, 3), _r = Er[2];
      (mr || qt) && isClientSide && removeCSS(_r, {
        mark: ATTR_MARK
      });
    },
    // Effect: Inject style here
    function(pr) {
      var mr = _slicedToArray(pr, 4), Er = mr[0];
      mr[1];
      var _r = mr[2], yr = mr[3];
      if (ar && Er !== CSS_FILE_STYLE) {
        var ur = {
          mark: ATTR_MARK,
          prepend: nr ? !1 : "queue",
          attachTo: Zt,
          priority: Wt
        }, vr = typeof Vt == "function" ? Vt() : Vt;
        vr && (ur.csp = {
          nonce: vr
        });
        var dr = [], br = [];
        Object.keys(yr).forEach(function(Pr) {
          Pr.startsWith("@layer") ? dr.push(Pr) : br.push(Pr);
        }), dr.forEach(function(Pr) {
          updateCSS(normalizeStyle(yr[Pr]), "_layer-".concat(Pr), _objectSpread2(_objectSpread2({}, ur), {}, {
            prepend: !0
          }));
        });
        var Cr = updateCSS(Er, _r, ur);
        Cr[CSS_IN_JS_INSTANCE] = tr.instanceId, Cr.setAttribute(ATTR_TOKEN, rr), browser$1.env.NODE_ENV !== "production" && Cr.setAttribute(ATTR_CACHE_PATH, ir.join("|")), br.forEach(function(Pr) {
          updateCSS(normalizeStyle(yr[Pr]), "_effect-".concat(Pr), ur);
        });
      }
    }
  ), sr = _slicedToArray(or, 3), lr = sr[0], cr = sr[1], hr = sr[2];
  return function(pr) {
    var mr;
    if (!Yt || ar || !Qt)
      mr = /* @__PURE__ */ React.createElement(Empty$1, null);
    else {
      var Er;
      mr = /* @__PURE__ */ React.createElement("style", _extends$2({}, (Er = {}, _defineProperty(Er, ATTR_TOKEN, cr), _defineProperty(Er, ATTR_MARK, hr), Er), {
        dangerouslySetInnerHTML: {
          __html: lr
        }
      }));
    }
    return /* @__PURE__ */ React.createElement(React.Fragment, null, mr, pr);
  };
}
var extract$1 = function(Et, Pt, $t) {
  var Mt = _slicedToArray(Et, 6), Bt = Mt[0], Vt = Mt[1], zt = Mt[2], Ht = Mt[3], Wt = Mt[4], Gt = Mt[5], qt = $t || {}, Kt = qt.plain;
  if (Wt)
    return null;
  var Qt = Bt, Xt = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(Gt)
  };
  return Qt = toStyleStr(Bt, Vt, zt, Xt, Kt), Ht && Object.keys(Ht).forEach(function(Zt) {
    if (!Pt[Zt]) {
      Pt[Zt] = !0;
      var Yt = normalizeStyle(Ht[Zt]), Jt = toStyleStr(Yt, Vt, "_effect-".concat(Zt), Xt, Kt);
      Zt.startsWith("@layer") ? Qt = Jt + Qt : Qt += Jt;
    }
  }), [Gt, zt, Qt];
}, CSS_VAR_PREFIX = "cssVar", useCSSVarRegister = function(Et, Pt) {
  var $t = Et.key, Mt = Et.prefix, Bt = Et.unitless, Vt = Et.ignore, zt = Et.token, Ht = Et.scope, Wt = Ht === void 0 ? "" : Ht, Gt = useContext(StyleContext), qt = Gt.cache.instanceId, Kt = Gt.container, Qt = zt._tokenKey, Xt = [].concat(_toConsumableArray(Et.path), [$t, Wt, Qt]), Zt = useGlobalCache(CSS_VAR_PREFIX, Xt, function() {
    var Yt = Pt(), Jt = transformToken(Yt, $t, {
      prefix: Mt,
      unitless: Bt,
      ignore: Vt,
      scope: Wt
    }), er = _slicedToArray(Jt, 2), tr = er[0], nr = er[1], rr = uniqueHash(Xt, nr);
    return [tr, nr, rr, $t];
  }, function(Yt) {
    var Jt = _slicedToArray(Yt, 3), er = Jt[2];
    isClientSide && removeCSS(er, {
      mark: ATTR_MARK
    });
  }, function(Yt) {
    var Jt = _slicedToArray(Yt, 3), er = Jt[1], tr = Jt[2];
    if (er) {
      var nr = updateCSS(er, tr, {
        mark: ATTR_MARK,
        prepend: "queue",
        attachTo: Kt,
        priority: -999
      });
      nr[CSS_IN_JS_INSTANCE] = qt, nr.setAttribute(ATTR_TOKEN, $t);
    }
  });
  return Zt;
}, extract = function(Et, Pt, $t) {
  var Mt = _slicedToArray(Et, 4), Bt = Mt[1], Vt = Mt[2], zt = Mt[3], Ht = $t || {}, Wt = Ht.plain;
  if (!Bt)
    return null;
  var Gt = -999, qt = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(Gt)
  }, Kt = toStyleStr(Bt, zt, Vt, qt, Wt);
  return [Gt, Vt, Kt];
}, _ExtractStyleFns;
_ExtractStyleFns = {}, _defineProperty(_ExtractStyleFns, STYLE_PREFIX, extract$1), _defineProperty(_ExtractStyleFns, TOKEN_PREFIX, extract$2), _defineProperty(_ExtractStyleFns, CSS_VAR_PREFIX, extract);
var Keyframe = /* @__PURE__ */ function() {
  function _t(Et, Pt) {
    _classCallCheck(this, _t), _defineProperty(this, "name", void 0), _defineProperty(this, "style", void 0), _defineProperty(this, "_keyframe", !0), this.name = Et, this.style = Pt;
  }
  return _createClass(_t, [{
    key: "getName",
    value: function() {
      var Pt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
      return Pt ? "".concat(Pt, "-").concat(this.name) : this.name;
    }
  }]), _t;
}();
function noSplit(_t) {
  return _t.notSplit = !0, _t;
}
noSplit(["borderTop", "borderBottom"]), noSplit(["borderTop"]), noSplit(["borderBottom"]), noSplit(["borderLeft", "borderRight"]), noSplit(["borderLeft"]), noSplit(["borderRight"]);
function _toArray(_t) {
  return _arrayWithHoles(_t) || _iterableToArray(_t) || _unsupportedIterableToArray(_t) || _nonIterableRest();
}
function get$3(_t, Et) {
  for (var Pt = _t, $t = 0; $t < Et.length; $t += 1) {
    if (Pt == null)
      return;
    Pt = Pt[Et[$t]];
  }
  return Pt;
}
function internalSet(_t, Et, Pt, $t) {
  if (!Et.length)
    return Pt;
  var Mt = _toArray(Et), Bt = Mt[0], Vt = Mt.slice(1), zt;
  return !_t && typeof Bt == "number" ? zt = [] : Array.isArray(_t) ? zt = _toConsumableArray(_t) : zt = _objectSpread2({}, _t), $t && Pt === void 0 && Vt.length === 1 ? delete zt[Bt][Vt[0]] : zt[Bt] = internalSet(zt[Bt], Vt, Pt, $t), zt;
}
function set$2(_t, Et, Pt) {
  var $t = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  return Et.length && $t && Pt === void 0 && !get$3(_t, Et.slice(0, -1)) ? _t : internalSet(_t, Et, Pt, $t);
}
function isObject$2(_t) {
  return _typeof(_t) === "object" && _t !== null && Object.getPrototypeOf(_t) === Object.prototype;
}
function createEmpty(_t) {
  return Array.isArray(_t) ? [] : {};
}
var keys$1 = typeof Reflect > "u" ? Object.keys : Reflect.ownKeys;
function merge$2() {
  for (var _t = arguments.length, Et = new Array(_t), Pt = 0; Pt < _t; Pt++)
    Et[Pt] = arguments[Pt];
  var $t = createEmpty(Et[0]);
  return Et.forEach(function(Mt) {
    function Bt(Vt, zt) {
      var Ht = new Set(zt), Wt = get$3(Mt, Vt), Gt = Array.isArray(Wt);
      if (Gt || isObject$2(Wt)) {
        if (!Ht.has(Wt)) {
          Ht.add(Wt);
          var qt = get$3($t, Vt);
          Gt ? $t = set$2($t, Vt, []) : (!qt || _typeof(qt) !== "object") && ($t = set$2($t, Vt, createEmpty(Wt))), keys$1(Wt).forEach(function(Kt) {
            Bt([].concat(_toConsumableArray(Vt), [Kt]), Ht);
          });
        }
      } else
        $t = set$2($t, Vt, Wt);
    }
    Bt([]);
  }), $t;
}
function noop$2() {
}
let deprecatedWarnList = null;
function resetWarned() {
  deprecatedWarnList = null, resetWarned$1();
}
let warning$1 = noop$2;
browser$1.env.NODE_ENV !== "production" && (warning$1 = (_t, Et, Pt) => {
  warningOnce(_t, `[antd: ${Et}] ${Pt}`), browser$1.env.NODE_ENV === "test" && resetWarned();
});
const WarningContext = /* @__PURE__ */ React.createContext({}), devUseWarning = browser$1.env.NODE_ENV !== "production" ? (_t) => {
  const {
    strict: Et
  } = React.useContext(WarningContext), Pt = ($t, Mt, Bt) => {
    if (!$t)
      if (Et === !1 && Mt === "deprecated") {
        const Vt = deprecatedWarnList;
        deprecatedWarnList || (deprecatedWarnList = {}), deprecatedWarnList[_t] = deprecatedWarnList[_t] || [], deprecatedWarnList[_t].includes(Bt || "") || deprecatedWarnList[_t].push(Bt || ""), Vt || console.warn("[antd] There exists deprecated usage in your code:", deprecatedWarnList);
      } else
        browser$1.env.NODE_ENV !== "production" && warning$1($t, _t, Bt);
  };
  return Pt.deprecated = ($t, Mt, Bt, Vt) => {
    Pt($t, "deprecated", `\`${Mt}\` is deprecated. Please use \`${Bt}\` instead.${Vt ? ` ${Vt}` : ""}`);
  }, Pt;
} : () => {
  const _t = () => {
  };
  return _t.deprecated = noop$2, _t;
}, ValidateMessagesContext = /* @__PURE__ */ createContext(void 0);
var locale$4 = {
  // Options
  items_per_page: "/ page",
  jump_to: "Go to",
  jump_to_confirm: "confirm",
  page: "Page",
  // Pagination
  prev_page: "Previous Page",
  next_page: "Next Page",
  prev_5: "Previous 5 Pages",
  next_5: "Next 5 Pages",
  prev_3: "Previous 3 Pages",
  next_3: "Next 3 Pages",
  page_size: "Page Size"
}, commonLocale = {
  yearFormat: "YYYY",
  dayFormat: "D",
  cellMeridiemFormat: "A",
  monthBeforeYear: !0
}, locale$3 = _objectSpread2(_objectSpread2({}, commonLocale), {}, {
  locale: "en_US",
  today: "Today",
  now: "Now",
  backToToday: "Back to today",
  ok: "OK",
  clear: "Clear",
  month: "Month",
  year: "Year",
  timeSelect: "select time",
  dateSelect: "select date",
  weekSelect: "Choose a week",
  monthSelect: "Choose a month",
  yearSelect: "Choose a year",
  decadeSelect: "Choose a decade",
  dateFormat: "M/D/YYYY",
  dateTimeFormat: "M/D/YYYY HH:mm:ss",
  previousMonth: "Previous month (PageUp)",
  nextMonth: "Next month (PageDown)",
  previousYear: "Last year (Control + left)",
  nextYear: "Next year (Control + right)",
  previousDecade: "Last decade",
  nextDecade: "Next decade",
  previousCentury: "Last century",
  nextCentury: "Next century"
});
const locale$2 = {
  placeholder: "Select time",
  rangePlaceholder: ["Start time", "End time"]
}, locale$1 = {
  lang: Object.assign({
    placeholder: "Select date",
    yearPlaceholder: "Select year",
    quarterPlaceholder: "Select quarter",
    monthPlaceholder: "Select month",
    weekPlaceholder: "Select week",
    rangePlaceholder: ["Start date", "End date"],
    rangeYearPlaceholder: ["Start year", "End year"],
    rangeQuarterPlaceholder: ["Start quarter", "End quarter"],
    rangeMonthPlaceholder: ["Start month", "End month"],
    rangeWeekPlaceholder: ["Start week", "End week"]
  }, locale$3),
  timePickerLocale: Object.assign({}, locale$2)
}, typeTemplate$1 = "${label} is not a valid ${type}", localeValues = {
  locale: "en",
  Pagination: locale$4,
  DatePicker: locale$1,
  TimePicker: locale$2,
  Calendar: locale$1,
  global: {
    placeholder: "Please select"
  },
  Table: {
    filterTitle: "Filter menu",
    filterConfirm: "OK",
    filterReset: "Reset",
    filterEmptyText: "No filters",
    filterCheckall: "Select all items",
    filterSearchPlaceholder: "Search in filters",
    emptyText: "No data",
    selectAll: "Select current page",
    selectInvert: "Invert current page",
    selectNone: "Clear all data",
    selectionAll: "Select all data",
    sortTitle: "Sort",
    expand: "Expand row",
    collapse: "Collapse row",
    triggerDesc: "Click to sort descending",
    triggerAsc: "Click to sort ascending",
    cancelSort: "Click to cancel sorting"
  },
  Tour: {
    Next: "Next",
    Previous: "Previous",
    Finish: "Finish"
  },
  Modal: {
    okText: "OK",
    cancelText: "Cancel",
    justOkText: "OK"
  },
  Popconfirm: {
    okText: "OK",
    cancelText: "Cancel"
  },
  Transfer: {
    titles: ["", ""],
    searchPlaceholder: "Search here",
    itemUnit: "item",
    itemsUnit: "items",
    remove: "Remove",
    selectCurrent: "Select current page",
    removeCurrent: "Remove current page",
    selectAll: "Select all data",
    deselectAll: "Deselect all data",
    removeAll: "Remove all data",
    selectInvert: "Invert current page"
  },
  Upload: {
    uploading: "Uploading...",
    removeFile: "Remove file",
    uploadError: "Upload error",
    previewFile: "Preview file",
    downloadFile: "Download file"
  },
  Empty: {
    description: "No data"
  },
  Icon: {
    icon: "icon"
  },
  Text: {
    edit: "Edit",
    copy: "Copy",
    copied: "Copied",
    expand: "Expand",
    collapse: "Collapse"
  },
  Form: {
    optional: "(optional)",
    defaultValidateMessages: {
      default: "Field validation error for ${label}",
      required: "Please enter ${label}",
      enum: "${label} must be one of [${enum}]",
      whitespace: "${label} cannot be a blank character",
      date: {
        format: "${label} date format is invalid",
        parse: "${label} cannot be converted to a date",
        invalid: "${label} is an invalid date"
      },
      types: {
        string: typeTemplate$1,
        method: typeTemplate$1,
        array: typeTemplate$1,
        object: typeTemplate$1,
        number: typeTemplate$1,
        date: typeTemplate$1,
        boolean: typeTemplate$1,
        integer: typeTemplate$1,
        float: typeTemplate$1,
        regexp: typeTemplate$1,
        email: typeTemplate$1,
        url: typeTemplate$1,
        hex: typeTemplate$1
      },
      string: {
        len: "${label} must be ${len} characters",
        min: "${label} must be at least ${min} characters",
        max: "${label} must be up to ${max} characters",
        range: "${label} must be between ${min}-${max} characters"
      },
      number: {
        len: "${label} must be equal to ${len}",
        min: "${label} must be minimum ${min}",
        max: "${label} must be maximum ${max}",
        range: "${label} must be between ${min}-${max}"
      },
      array: {
        len: "Must be ${len} ${label}",
        min: "At least ${min} ${label}",
        max: "At most ${max} ${label}",
        range: "The amount of ${label} must be between ${min}-${max}"
      },
      pattern: {
        mismatch: "${label} does not match the pattern ${pattern}"
      }
    }
  },
  Image: {
    preview: "Preview"
  },
  QRCode: {
    expired: "QR code expired",
    refresh: "Refresh",
    scanned: "Scanned"
  },
  ColorPicker: {
    presetEmpty: "Empty",
    transparent: "Transparent",
    singleColor: "Single",
    gradientColor: "Gradient"
  }
};
let runtimeLocale = Object.assign({}, localeValues.Modal), localeList = [];
const generateLocale = () => localeList.reduce((_t, Et) => Object.assign(Object.assign({}, _t), Et), localeValues.Modal);
function changeConfirmLocale(_t) {
  if (_t) {
    const Et = Object.assign({}, _t);
    return localeList.push(Et), runtimeLocale = generateLocale(), () => {
      localeList = localeList.filter((Pt) => Pt !== Et), runtimeLocale = generateLocale();
    };
  }
  runtimeLocale = Object.assign({}, localeValues.Modal);
}
function getConfirmLocale() {
  return runtimeLocale;
}
const LocaleContext = /* @__PURE__ */ createContext(void 0), useLocale = (_t, Et) => {
  const Pt = React.useContext(LocaleContext), $t = React.useMemo(() => {
    var Bt;
    const Vt = Et || localeValues[_t], zt = (Bt = Pt == null ? void 0 : Pt[_t]) !== null && Bt !== void 0 ? Bt : {};
    return Object.assign(Object.assign({}, typeof Vt == "function" ? Vt() : Vt), zt || {});
  }, [_t, Et, Pt]), Mt = React.useMemo(() => {
    const Bt = Pt == null ? void 0 : Pt.locale;
    return Pt != null && Pt.exist && !Bt ? localeValues.locale : Bt;
  }, [Pt]);
  return [$t, Mt];
}, ANT_MARK = "internalMark", LocaleProvider = (_t) => {
  const {
    locale: Et = {},
    children: Pt,
    _ANT_MARK__: $t
  } = _t;
  if (browser$1.env.NODE_ENV !== "production") {
    const Bt = devUseWarning("LocaleProvider");
    browser$1.env.NODE_ENV !== "production" && Bt($t === ANT_MARK, "deprecated", "`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead: http://u.ant.design/locale");
  }
  React.useEffect(() => changeConfirmLocale(Et == null ? void 0 : Et.Modal), [Et]);
  const Mt = React.useMemo(() => Object.assign(Object.assign({}, Et), {
    exist: !0
  }), [Et]);
  return /* @__PURE__ */ React.createElement(LocaleContext.Provider, {
    value: Mt
  }, Pt);
};
browser$1.env.NODE_ENV !== "production" && (LocaleProvider.displayName = "LocaleProvider");
const defaultPresetColors = {
  blue: "#1677FF",
  purple: "#722ED1",
  cyan: "#13C2C2",
  green: "#52C41A",
  magenta: "#EB2F96",
  /**
   * @deprecated Use magenta instead
   */
  pink: "#EB2F96",
  red: "#F5222D",
  orange: "#FA8C16",
  yellow: "#FADB14",
  volcano: "#FA541C",
  geekblue: "#2F54EB",
  gold: "#FAAD14",
  lime: "#A0D911"
}, seedToken = Object.assign(Object.assign({}, defaultPresetColors), {
  // Color
  colorPrimary: "#1677ff",
  colorSuccess: "#52c41a",
  colorWarning: "#faad14",
  colorError: "#ff4d4f",
  colorInfo: "#1677ff",
  colorLink: "",
  colorTextBase: "",
  colorBgBase: "",
  // Font
  fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
'Noto Color Emoji'`,
  fontFamilyCode: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  fontSize: 14,
  // Line
  lineWidth: 1,
  lineType: "solid",
  // Motion
  motionUnit: 0.1,
  motionBase: 0,
  motionEaseOutCirc: "cubic-bezier(0.08, 0.82, 0.17, 1)",
  motionEaseInOutCirc: "cubic-bezier(0.78, 0.14, 0.15, 0.86)",
  motionEaseOut: "cubic-bezier(0.215, 0.61, 0.355, 1)",
  motionEaseInOut: "cubic-bezier(0.645, 0.045, 0.355, 1)",
  motionEaseOutBack: "cubic-bezier(0.12, 0.4, 0.29, 1.46)",
  motionEaseInBack: "cubic-bezier(0.71, -0.46, 0.88, 0.6)",
  motionEaseInQuint: "cubic-bezier(0.755, 0.05, 0.855, 0.06)",
  motionEaseOutQuint: "cubic-bezier(0.23, 1, 0.32, 1)",
  // Radius
  borderRadius: 6,
  // Size
  sizeUnit: 4,
  sizeStep: 4,
  sizePopupArrow: 16,
  // Control Base
  controlHeight: 32,
  // zIndex
  zIndexBase: 0,
  zIndexPopupBase: 1e3,
  // Image
  opacityImage: 1,
  // Wireframe
  wireframe: !1,
  // Motion
  motion: !0
});
function genColorMapToken(_t, Et) {
  let {
    generateColorPalettes: Pt,
    generateNeutralColorPalettes: $t
  } = Et;
  const {
    colorSuccess: Mt,
    colorWarning: Bt,
    colorError: Vt,
    colorInfo: zt,
    colorPrimary: Ht,
    colorBgBase: Wt,
    colorTextBase: Gt
  } = _t, qt = Pt(Ht), Kt = Pt(Mt), Qt = Pt(Bt), Xt = Pt(Vt), Zt = Pt(zt), Yt = $t(Wt, Gt), Jt = _t.colorLink || _t.colorInfo, er = Pt(Jt), tr = new FastColor(Xt[1]).mix(new FastColor(Xt[3]), 50).toHexString();
  return Object.assign(Object.assign({}, Yt), {
    colorPrimaryBg: qt[1],
    colorPrimaryBgHover: qt[2],
    colorPrimaryBorder: qt[3],
    colorPrimaryBorderHover: qt[4],
    colorPrimaryHover: qt[5],
    colorPrimary: qt[6],
    colorPrimaryActive: qt[7],
    colorPrimaryTextHover: qt[8],
    colorPrimaryText: qt[9],
    colorPrimaryTextActive: qt[10],
    colorSuccessBg: Kt[1],
    colorSuccessBgHover: Kt[2],
    colorSuccessBorder: Kt[3],
    colorSuccessBorderHover: Kt[4],
    colorSuccessHover: Kt[4],
    colorSuccess: Kt[6],
    colorSuccessActive: Kt[7],
    colorSuccessTextHover: Kt[8],
    colorSuccessText: Kt[9],
    colorSuccessTextActive: Kt[10],
    colorErrorBg: Xt[1],
    colorErrorBgHover: Xt[2],
    colorErrorBgFilledHover: tr,
    colorErrorBgActive: Xt[3],
    colorErrorBorder: Xt[3],
    colorErrorBorderHover: Xt[4],
    colorErrorHover: Xt[5],
    colorError: Xt[6],
    colorErrorActive: Xt[7],
    colorErrorTextHover: Xt[8],
    colorErrorText: Xt[9],
    colorErrorTextActive: Xt[10],
    colorWarningBg: Qt[1],
    colorWarningBgHover: Qt[2],
    colorWarningBorder: Qt[3],
    colorWarningBorderHover: Qt[4],
    colorWarningHover: Qt[4],
    colorWarning: Qt[6],
    colorWarningActive: Qt[7],
    colorWarningTextHover: Qt[8],
    colorWarningText: Qt[9],
    colorWarningTextActive: Qt[10],
    colorInfoBg: Zt[1],
    colorInfoBgHover: Zt[2],
    colorInfoBorder: Zt[3],
    colorInfoBorderHover: Zt[4],
    colorInfoHover: Zt[4],
    colorInfo: Zt[6],
    colorInfoActive: Zt[7],
    colorInfoTextHover: Zt[8],
    colorInfoText: Zt[9],
    colorInfoTextActive: Zt[10],
    colorLinkHover: er[4],
    colorLink: er[6],
    colorLinkActive: er[7],
    colorBgMask: new FastColor("#000").setA(0.45).toRgbString(),
    colorWhite: "#fff"
  });
}
const genRadius = (_t) => {
  let Et = _t, Pt = _t, $t = _t, Mt = _t;
  return _t < 6 && _t >= 5 ? Et = _t + 1 : _t < 16 && _t >= 6 ? Et = _t + 2 : _t >= 16 && (Et = 16), _t < 7 && _t >= 5 ? Pt = 4 : _t < 8 && _t >= 7 ? Pt = 5 : _t < 14 && _t >= 8 ? Pt = 6 : _t < 16 && _t >= 14 ? Pt = 7 : _t >= 16 && (Pt = 8), _t < 6 && _t >= 2 ? $t = 1 : _t >= 6 && ($t = 2), _t > 4 && _t < 8 ? Mt = 4 : _t >= 8 && (Mt = 6), {
    borderRadius: _t,
    borderRadiusXS: $t,
    borderRadiusSM: Pt,
    borderRadiusLG: Et,
    borderRadiusOuter: Mt
  };
};
function genCommonMapToken(_t) {
  const {
    motionUnit: Et,
    motionBase: Pt,
    borderRadius: $t,
    lineWidth: Mt
  } = _t;
  return Object.assign({
    // motion
    motionDurationFast: `${(Pt + Et).toFixed(1)}s`,
    motionDurationMid: `${(Pt + Et * 2).toFixed(1)}s`,
    motionDurationSlow: `${(Pt + Et * 3).toFixed(1)}s`,
    // line
    lineWidthBold: Mt + 1
  }, genRadius($t));
}
const genControlHeight = (_t) => {
  const {
    controlHeight: Et
  } = _t;
  return {
    controlHeightSM: Et * 0.75,
    controlHeightXS: Et * 0.5,
    controlHeightLG: Et * 1.25
  };
};
function getLineHeight(_t) {
  return (_t + 8) / _t;
}
function getFontSizes(_t) {
  const Et = new Array(10).fill(null).map((Pt, $t) => {
    const Mt = $t - 1, Bt = _t * Math.pow(Math.E, Mt / 5), Vt = $t > 1 ? Math.floor(Bt) : Math.ceil(Bt);
    return Math.floor(Vt / 2) * 2;
  });
  return Et[1] = _t, Et.map((Pt) => ({
    size: Pt,
    lineHeight: getLineHeight(Pt)
  }));
}
const genFontMapToken = (_t) => {
  const Et = getFontSizes(_t), Pt = Et.map((Gt) => Gt.size), $t = Et.map((Gt) => Gt.lineHeight), Mt = Pt[1], Bt = Pt[0], Vt = Pt[2], zt = $t[1], Ht = $t[0], Wt = $t[2];
  return {
    fontSizeSM: Bt,
    fontSize: Mt,
    fontSizeLG: Vt,
    fontSizeXL: Pt[3],
    fontSizeHeading1: Pt[6],
    fontSizeHeading2: Pt[5],
    fontSizeHeading3: Pt[4],
    fontSizeHeading4: Pt[3],
    fontSizeHeading5: Pt[2],
    lineHeight: zt,
    lineHeightLG: Wt,
    lineHeightSM: Ht,
    fontHeight: Math.round(zt * Mt),
    fontHeightLG: Math.round(Wt * Vt),
    fontHeightSM: Math.round(Ht * Bt),
    lineHeightHeading1: $t[6],
    lineHeightHeading2: $t[5],
    lineHeightHeading3: $t[4],
    lineHeightHeading4: $t[3],
    lineHeightHeading5: $t[2]
  };
};
function genSizeMapToken(_t) {
  const {
    sizeUnit: Et,
    sizeStep: Pt
  } = _t;
  return {
    sizeXXL: Et * (Pt + 8),
    // 48
    sizeXL: Et * (Pt + 4),
    // 32
    sizeLG: Et * (Pt + 2),
    // 24
    sizeMD: Et * (Pt + 1),
    // 20
    sizeMS: Et * Pt,
    // 16
    size: Et * Pt,
    // 16
    sizeSM: Et * (Pt - 1),
    // 12
    sizeXS: Et * (Pt - 2),
    // 8
    sizeXXS: Et * (Pt - 3)
    // 4
  };
}
const getAlphaColor$1 = (_t, Et) => new FastColor(_t).setA(Et).toRgbString(), getSolidColor = (_t, Et) => new FastColor(_t).darken(Et).toHexString(), generateColorPalettes = (_t) => {
  const Et = generate$1(_t);
  return {
    1: Et[0],
    2: Et[1],
    3: Et[2],
    4: Et[3],
    5: Et[4],
    6: Et[5],
    7: Et[6],
    8: Et[4],
    9: Et[5],
    10: Et[6]
    // 8: colors[7],
    // 9: colors[8],
    // 10: colors[9],
  };
}, generateNeutralColorPalettes = (_t, Et) => {
  const Pt = _t || "#fff", $t = Et || "#000";
  return {
    colorBgBase: Pt,
    colorTextBase: $t,
    colorText: getAlphaColor$1($t, 0.88),
    colorTextSecondary: getAlphaColor$1($t, 0.65),
    colorTextTertiary: getAlphaColor$1($t, 0.45),
    colorTextQuaternary: getAlphaColor$1($t, 0.25),
    colorFill: getAlphaColor$1($t, 0.15),
    colorFillSecondary: getAlphaColor$1($t, 0.06),
    colorFillTertiary: getAlphaColor$1($t, 0.04),
    colorFillQuaternary: getAlphaColor$1($t, 0.02),
    colorBgSolid: getAlphaColor$1($t, 1),
    colorBgSolidHover: getAlphaColor$1($t, 0.75),
    colorBgSolidActive: getAlphaColor$1($t, 0.95),
    colorBgLayout: getSolidColor(Pt, 4),
    colorBgContainer: getSolidColor(Pt, 0),
    colorBgElevated: getSolidColor(Pt, 0),
    colorBgSpotlight: getAlphaColor$1($t, 0.85),
    colorBgBlur: "transparent",
    colorBorder: getSolidColor(Pt, 15),
    colorBorderSecondary: getSolidColor(Pt, 6)
  };
};
function derivative(_t) {
  presetPrimaryColors.pink = presetPrimaryColors.magenta, presetPalettes.pink = presetPalettes.magenta;
  const Et = Object.keys(defaultPresetColors).map((Pt) => {
    const $t = _t[Pt] === presetPrimaryColors[Pt] ? presetPalettes[Pt] : generate$1(_t[Pt]);
    return new Array(10).fill(1).reduce((Mt, Bt, Vt) => (Mt[`${Pt}-${Vt + 1}`] = $t[Vt], Mt[`${Pt}${Vt + 1}`] = $t[Vt], Mt), {});
  }).reduce((Pt, $t) => (Pt = Object.assign(Object.assign({}, Pt), $t), Pt), {});
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, _t), Et), genColorMapToken(_t, {
    generateColorPalettes,
    generateNeutralColorPalettes
  })), genFontMapToken(_t.fontSize)), genSizeMapToken(_t)), genControlHeight(_t)), genCommonMapToken(_t));
}
const defaultTheme = createTheme(derivative), defaultConfig = {
  token: seedToken,
  override: {
    override: seedToken
  },
  hashed: !0
}, DesignTokenContext = /* @__PURE__ */ React__default.createContext(defaultConfig), defaultPrefixCls = "ant", defaultIconPrefixCls = "anticon", defaultGetPrefixCls = (_t, Et) => Et || (_t ? `${defaultPrefixCls}-${_t}` : defaultPrefixCls), ConfigContext = /* @__PURE__ */ React.createContext({
  // We provide a default function for Context without provider
  getPrefixCls: defaultGetPrefixCls,
  iconPrefixCls: defaultIconPrefixCls
}), dynamicStyleMark = `-ant-${Date.now()}-${Math.random()}`;
function getStyle(_t, Et) {
  const Pt = {}, $t = (Vt, zt) => {
    let Ht = Vt.clone();
    return Ht = (zt == null ? void 0 : zt(Ht)) || Ht, Ht.toRgbString();
  }, Mt = (Vt, zt) => {
    const Ht = new FastColor(Vt), Wt = generate$1(Ht.toRgbString());
    Pt[`${zt}-color`] = $t(Ht), Pt[`${zt}-color-disabled`] = Wt[1], Pt[`${zt}-color-hover`] = Wt[4], Pt[`${zt}-color-active`] = Wt[6], Pt[`${zt}-color-outline`] = Ht.clone().setA(0.2).toRgbString(), Pt[`${zt}-color-deprecated-bg`] = Wt[0], Pt[`${zt}-color-deprecated-border`] = Wt[2];
  };
  if (Et.primaryColor) {
    Mt(Et.primaryColor, "primary");
    const Vt = new FastColor(Et.primaryColor), zt = generate$1(Vt.toRgbString());
    zt.forEach((Wt, Gt) => {
      Pt[`primary-${Gt + 1}`] = Wt;
    }), Pt["primary-color-deprecated-l-35"] = $t(Vt, (Wt) => Wt.lighten(35)), Pt["primary-color-deprecated-l-20"] = $t(Vt, (Wt) => Wt.lighten(20)), Pt["primary-color-deprecated-t-20"] = $t(Vt, (Wt) => Wt.tint(20)), Pt["primary-color-deprecated-t-50"] = $t(Vt, (Wt) => Wt.tint(50)), Pt["primary-color-deprecated-f-12"] = $t(Vt, (Wt) => Wt.setA(Wt.a * 0.12));
    const Ht = new FastColor(zt[0]);
    Pt["primary-color-active-deprecated-f-30"] = $t(Ht, (Wt) => Wt.setA(Wt.a * 0.3)), Pt["primary-color-active-deprecated-d-02"] = $t(Ht, (Wt) => Wt.darken(2));
  }
  return Et.successColor && Mt(Et.successColor, "success"), Et.warningColor && Mt(Et.warningColor, "warning"), Et.errorColor && Mt(Et.errorColor, "error"), Et.infoColor && Mt(Et.infoColor, "info"), `
  :root {
    ${Object.keys(Pt).map((Vt) => `--${_t}-${Vt}: ${Pt[Vt]};`).join(`
`)}
  }
  `.trim();
}
function registerTheme(_t, Et) {
  const Pt = getStyle(_t, Et);
  canUseDom() ? updateCSS(Pt, `${dynamicStyleMark}-dynamic-theme`) : browser$1.env.NODE_ENV !== "production" && warning$1(!1, "ConfigProvider", "SSR do not support dynamic theme with css variables.");
}
const DisabledContext = /* @__PURE__ */ React.createContext(!1), DisabledContextProvider = (_t) => {
  let {
    children: Et,
    disabled: Pt
  } = _t;
  const $t = React.useContext(DisabledContext);
  return /* @__PURE__ */ React.createElement(DisabledContext.Provider, {
    value: Pt ?? $t
  }, Et);
}, SizeContext = /* @__PURE__ */ React.createContext(void 0), SizeContextProvider = (_t) => {
  let {
    children: Et,
    size: Pt
  } = _t;
  const $t = React.useContext(SizeContext);
  return /* @__PURE__ */ React.createElement(SizeContext.Provider, {
    value: Pt || $t
  }, Et);
};
function useConfig() {
  const _t = useContext(DisabledContext), Et = useContext(SizeContext);
  return {
    componentDisabled: _t,
    componentSize: Et
  };
}
var AbstractCalculator = /* @__PURE__ */ _createClass(function _t() {
  _classCallCheck(this, _t);
}), CALC_UNIT = "CALC_UNIT", regexp$1 = new RegExp(CALC_UNIT, "g");
function unit(_t) {
  return typeof _t == "number" ? "".concat(_t).concat(CALC_UNIT) : _t;
}
var CSSCalculator = /* @__PURE__ */ function(_t) {
  _inherits(Pt, _t);
  var Et = _createSuper(Pt);
  function Pt($t, Mt) {
    var Bt;
    _classCallCheck(this, Pt), Bt = Et.call(this), _defineProperty(_assertThisInitialized(Bt), "result", ""), _defineProperty(_assertThisInitialized(Bt), "unitlessCssVar", void 0), _defineProperty(_assertThisInitialized(Bt), "lowPriority", void 0);
    var Vt = _typeof($t);
    return Bt.unitlessCssVar = Mt, $t instanceof Pt ? Bt.result = "(".concat($t.result, ")") : Vt === "number" ? Bt.result = unit($t) : Vt === "string" && (Bt.result = $t), Bt;
  }
  return _createClass(Pt, [{
    key: "add",
    value: function(Mt) {
      return Mt instanceof Pt ? this.result = "".concat(this.result, " + ").concat(Mt.getResult()) : (typeof Mt == "number" || typeof Mt == "string") && (this.result = "".concat(this.result, " + ").concat(unit(Mt))), this.lowPriority = !0, this;
    }
  }, {
    key: "sub",
    value: function(Mt) {
      return Mt instanceof Pt ? this.result = "".concat(this.result, " - ").concat(Mt.getResult()) : (typeof Mt == "number" || typeof Mt == "string") && (this.result = "".concat(this.result, " - ").concat(unit(Mt))), this.lowPriority = !0, this;
    }
  }, {
    key: "mul",
    value: function(Mt) {
      return this.lowPriority && (this.result = "(".concat(this.result, ")")), Mt instanceof Pt ? this.result = "".concat(this.result, " * ").concat(Mt.getResult(!0)) : (typeof Mt == "number" || typeof Mt == "string") && (this.result = "".concat(this.result, " * ").concat(Mt)), this.lowPriority = !1, this;
    }
  }, {
    key: "div",
    value: function(Mt) {
      return this.lowPriority && (this.result = "(".concat(this.result, ")")), Mt instanceof Pt ? this.result = "".concat(this.result, " / ").concat(Mt.getResult(!0)) : (typeof Mt == "number" || typeof Mt == "string") && (this.result = "".concat(this.result, " / ").concat(Mt)), this.lowPriority = !1, this;
    }
  }, {
    key: "getResult",
    value: function(Mt) {
      return this.lowPriority || Mt ? "(".concat(this.result, ")") : this.result;
    }
  }, {
    key: "equal",
    value: function(Mt) {
      var Bt = this, Vt = Mt || {}, zt = Vt.unit, Ht = !0;
      return typeof zt == "boolean" ? Ht = zt : Array.from(this.unitlessCssVar).some(function(Wt) {
        return Bt.result.includes(Wt);
      }) && (Ht = !1), this.result = this.result.replace(regexp$1, Ht ? "px" : ""), typeof this.lowPriority < "u" ? "calc(".concat(this.result, ")") : this.result;
    }
  }]), Pt;
}(AbstractCalculator), NumCalculator = /* @__PURE__ */ function(_t) {
  _inherits(Pt, _t);
  var Et = _createSuper(Pt);
  function Pt($t) {
    var Mt;
    return _classCallCheck(this, Pt), Mt = Et.call(this), _defineProperty(_assertThisInitialized(Mt), "result", 0), $t instanceof Pt ? Mt.result = $t.result : typeof $t == "number" && (Mt.result = $t), Mt;
  }
  return _createClass(Pt, [{
    key: "add",
    value: function(Mt) {
      return Mt instanceof Pt ? this.result += Mt.result : typeof Mt == "number" && (this.result += Mt), this;
    }
  }, {
    key: "sub",
    value: function(Mt) {
      return Mt instanceof Pt ? this.result -= Mt.result : typeof Mt == "number" && (this.result -= Mt), this;
    }
  }, {
    key: "mul",
    value: function(Mt) {
      return Mt instanceof Pt ? this.result *= Mt.result : typeof Mt == "number" && (this.result *= Mt), this;
    }
  }, {
    key: "div",
    value: function(Mt) {
      return Mt instanceof Pt ? this.result /= Mt.result : typeof Mt == "number" && (this.result /= Mt), this;
    }
  }, {
    key: "equal",
    value: function() {
      return this.result;
    }
  }]), Pt;
}(AbstractCalculator), genCalc = function(Et, Pt) {
  var $t = Et === "css" ? CSSCalculator : NumCalculator;
  return function(Mt) {
    return new $t(Mt, Pt);
  };
}, getCompVarPrefix = function(Et, Pt) {
  return "".concat([Pt, Et.replace(/([A-Z]+)([A-Z][a-z]+)/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2")].filter(Boolean).join("-"));
};
function useEvent(_t) {
  var Et = React.useRef();
  Et.current = _t;
  var Pt = React.useCallback(function() {
    for (var $t, Mt = arguments.length, Bt = new Array(Mt), Vt = 0; Vt < Mt; Vt++)
      Bt[Vt] = arguments[Vt];
    return ($t = Et.current) === null || $t === void 0 ? void 0 : $t.call.apply($t, [Et].concat(Bt));
  }, []);
  return Pt;
}
function useSafeState(_t) {
  var Et = React.useRef(!1), Pt = React.useState(_t), $t = _slicedToArray(Pt, 2), Mt = $t[0], Bt = $t[1];
  React.useEffect(function() {
    return Et.current = !1, function() {
      Et.current = !0;
    };
  }, []);
  function Vt(zt, Ht) {
    Ht && Et.current || Bt(zt);
  }
  return [Mt, Vt];
}
function hasValue(_t) {
  return _t !== void 0;
}
function useMergedState(_t, Et) {
  var Pt = Et || {}, $t = Pt.defaultValue, Mt = Pt.value, Bt = Pt.onChange, Vt = Pt.postState, zt = useSafeState(function() {
    return hasValue(Mt) ? Mt : hasValue($t) ? typeof $t == "function" ? $t() : $t : typeof _t == "function" ? _t() : _t;
  }), Ht = _slicedToArray(zt, 2), Wt = Ht[0], Gt = Ht[1], qt = Mt !== void 0 ? Mt : Wt, Kt = Vt ? Vt(qt) : qt, Qt = useEvent(Bt), Xt = useSafeState([qt]), Zt = _slicedToArray(Xt, 2), Yt = Zt[0], Jt = Zt[1];
  useLayoutUpdateEffect(function() {
    var tr = Yt[0];
    Wt !== tr && Qt(Wt, tr);
  }, [Yt]), useLayoutUpdateEffect(function() {
    hasValue(Mt) || Gt(Mt);
  }, [Mt]);
  var er = useEvent(function(tr, nr) {
    Gt(tr, nr), Jt([qt], nr);
  });
  return [Kt, er];
}
function getComponentToken(_t, Et, Pt, $t) {
  var Mt = _objectSpread2({}, Et[_t]);
  if ($t != null && $t.deprecatedTokens) {
    var Bt = $t.deprecatedTokens;
    Bt.forEach(function(zt) {
      var Ht = _slicedToArray(zt, 2), Wt = Ht[0], Gt = Ht[1];
      if (browser$1.env.NODE_ENV !== "production" && warningOnce(!(Mt != null && Mt[Wt]), "Component Token `".concat(String(Wt), "` of ").concat(String(_t), " is deprecated. Please use `").concat(String(Gt), "` instead.")), Mt != null && Mt[Wt] || Mt != null && Mt[Gt]) {
        var qt;
        (qt = Mt[Gt]) !== null && qt !== void 0 || (Mt[Gt] = Mt == null ? void 0 : Mt[Wt]);
      }
    });
  }
  var Vt = _objectSpread2(_objectSpread2({}, Pt), Mt);
  return Object.keys(Vt).forEach(function(zt) {
    Vt[zt] === Et[zt] && delete Vt[zt];
  }), Vt;
}
var enableStatistic = browser$1.env.NODE_ENV !== "production" || typeof CSSINJS_STATISTIC < "u", recording = !0;
function merge$1() {
  for (var _t = arguments.length, Et = new Array(_t), Pt = 0; Pt < _t; Pt++)
    Et[Pt] = arguments[Pt];
  if (!enableStatistic)
    return Object.assign.apply(Object, [{}].concat(Et));
  recording = !1;
  var $t = {};
  return Et.forEach(function(Mt) {
    if (_typeof(Mt) === "object") {
      var Bt = Object.keys(Mt);
      Bt.forEach(function(Vt) {
        Object.defineProperty($t, Vt, {
          configurable: !0,
          enumerable: !0,
          get: function() {
            return Mt[Vt];
          }
        });
      });
    }
  }), recording = !0, $t;
}
var statistic = {};
function noop$1() {
}
var statisticToken = function(Et) {
  var Pt, $t = Et, Mt = noop$1;
  return enableStatistic && typeof Proxy < "u" && (Pt = /* @__PURE__ */ new Set(), $t = new Proxy(Et, {
    get: function(Vt, zt) {
      if (recording) {
        var Ht;
        (Ht = Pt) === null || Ht === void 0 || Ht.add(zt);
      }
      return Vt[zt];
    }
  }), Mt = function(Vt, zt) {
    var Ht;
    statistic[Vt] = {
      global: Array.from(Pt),
      component: _objectSpread2(_objectSpread2({}, (Ht = statistic[Vt]) === null || Ht === void 0 ? void 0 : Ht.component), zt)
    };
  }), {
    token: $t,
    keys: Pt,
    flush: Mt
  };
};
function getDefaultComponentToken(_t, Et, Pt) {
  if (typeof Pt == "function") {
    var $t;
    return Pt(merge$1(Et, ($t = Et[_t]) !== null && $t !== void 0 ? $t : {}));
  }
  return Pt ?? {};
}
function genMaxMin(_t) {
  return _t === "js" ? {
    max: Math.max,
    min: Math.min
  } : {
    max: function() {
      for (var Pt = arguments.length, $t = new Array(Pt), Mt = 0; Mt < Pt; Mt++)
        $t[Mt] = arguments[Mt];
      return "max(".concat($t.map(function(Bt) {
        return unit$1(Bt);
      }).join(","), ")");
    },
    min: function() {
      for (var Pt = arguments.length, $t = new Array(Pt), Mt = 0; Mt < Pt; Mt++)
        $t[Mt] = arguments[Mt];
      return "min(".concat($t.map(function(Bt) {
        return unit$1(Bt);
      }).join(","), ")");
    }
  };
}
var BEAT_LIMIT = 1e3 * 60 * 10, ArrayKeyMap = /* @__PURE__ */ function() {
  function _t() {
    _classCallCheck(this, _t), _defineProperty(this, "map", /* @__PURE__ */ new Map()), _defineProperty(this, "objectIDMap", /* @__PURE__ */ new WeakMap()), _defineProperty(this, "nextID", 0), _defineProperty(this, "lastAccessBeat", /* @__PURE__ */ new Map()), _defineProperty(this, "accessBeat", 0);
  }
  return _createClass(_t, [{
    key: "set",
    value: function(Pt, $t) {
      this.clear();
      var Mt = this.getCompositeKey(Pt);
      this.map.set(Mt, $t), this.lastAccessBeat.set(Mt, Date.now());
    }
  }, {
    key: "get",
    value: function(Pt) {
      var $t = this.getCompositeKey(Pt), Mt = this.map.get($t);
      return this.lastAccessBeat.set($t, Date.now()), this.accessBeat += 1, Mt;
    }
  }, {
    key: "getCompositeKey",
    value: function(Pt) {
      var $t = this, Mt = Pt.map(function(Bt) {
        return Bt && _typeof(Bt) === "object" ? "obj_".concat($t.getObjectID(Bt)) : "".concat(_typeof(Bt), "_").concat(Bt);
      });
      return Mt.join("|");
    }
  }, {
    key: "getObjectID",
    value: function(Pt) {
      if (this.objectIDMap.has(Pt))
        return this.objectIDMap.get(Pt);
      var $t = this.nextID;
      return this.objectIDMap.set(Pt, $t), this.nextID += 1, $t;
    }
  }, {
    key: "clear",
    value: function() {
      var Pt = this;
      if (this.accessBeat > 1e4) {
        var $t = Date.now();
        this.lastAccessBeat.forEach(function(Mt, Bt) {
          $t - Mt > BEAT_LIMIT && (Pt.map.delete(Bt), Pt.lastAccessBeat.delete(Bt));
        }), this.accessBeat = 0;
      }
    }
  }]), _t;
}(), uniqueMap = new ArrayKeyMap();
function useUniqueMemo(_t, Et) {
  return React__default.useMemo(function() {
    var Pt = uniqueMap.get(Et);
    if (Pt)
      return Pt;
    var $t = _t();
    return uniqueMap.set(Et, $t), $t;
  }, Et);
}
var useDefaultCSP = function() {
  return {};
};
function genStyleUtils(_t) {
  var Et = _t.useCSP, Pt = Et === void 0 ? useDefaultCSP : Et, $t = _t.useToken, Mt = _t.usePrefix, Bt = _t.getResetStyles, Vt = _t.getCommonStyle, zt = _t.getCompUnitless;
  function Ht(Kt, Qt, Xt, Zt) {
    var Yt = Array.isArray(Kt) ? Kt[0] : Kt;
    function Jt(or) {
      return "".concat(String(Yt)).concat(or.slice(0, 1).toUpperCase()).concat(or.slice(1));
    }
    var er = (Zt == null ? void 0 : Zt.unitless) || {}, tr = typeof zt == "function" ? zt(Kt) : {}, nr = _objectSpread2(_objectSpread2({}, tr), {}, _defineProperty({}, Jt("zIndexPopup"), !0));
    Object.keys(er).forEach(function(or) {
      nr[Jt(or)] = er[or];
    });
    var rr = _objectSpread2(_objectSpread2({}, Zt), {}, {
      unitless: nr,
      prefixToken: Jt
    }), ir = Gt(Kt, Qt, Xt, rr), ar = Wt(Yt, Xt, rr);
    return function(or) {
      var sr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : or, lr = ir(or, sr), cr = _slicedToArray(lr, 2), hr = cr[1], pr = ar(sr), mr = _slicedToArray(pr, 2), Er = mr[0], _r = mr[1];
      return [Er, hr, _r];
    };
  }
  function Wt(Kt, Qt, Xt) {
    var Zt = Xt.unitless, Yt = Xt.injectStyle, Jt = Yt === void 0 ? !0 : Yt, er = Xt.prefixToken, tr = Xt.ignore, nr = function(ar) {
      var or = ar.rootCls, sr = ar.cssVar, lr = sr === void 0 ? {} : sr, cr = $t(), hr = cr.realToken;
      return useCSSVarRegister({
        path: [Kt],
        prefix: lr.prefix,
        key: lr.key,
        unitless: Zt,
        ignore: tr,
        token: hr,
        scope: or
      }, function() {
        var pr = getDefaultComponentToken(Kt, hr, Qt), mr = getComponentToken(Kt, hr, pr, {
          deprecatedTokens: Xt == null ? void 0 : Xt.deprecatedTokens
        });
        return Object.keys(pr).forEach(function(Er) {
          mr[er(Er)] = mr[Er], delete mr[Er];
        }), mr;
      }), null;
    }, rr = function(ar) {
      var or = $t(), sr = or.cssVar;
      return [function(lr) {
        return Jt && sr ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(nr, {
          rootCls: ar,
          cssVar: sr,
          component: Kt
        }), lr) : lr;
      }, sr == null ? void 0 : sr.key];
    };
    return rr;
  }
  function Gt(Kt, Qt, Xt) {
    var Zt = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, Yt = Array.isArray(Kt) ? Kt : [Kt, Kt], Jt = _slicedToArray(Yt, 1), er = Jt[0], tr = Yt.join("-"), nr = _t.layer || {
      name: "antd"
    };
    return function(rr) {
      var ir = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : rr, ar = $t(), or = ar.theme, sr = ar.realToken, lr = ar.hashId, cr = ar.token, hr = ar.cssVar, pr = Mt(), mr = pr.rootPrefixCls, Er = pr.iconPrefixCls, _r = Pt(), yr = hr ? "css" : "js", ur = useUniqueMemo(function() {
        var xr = /* @__PURE__ */ new Set();
        return hr && Object.keys(Zt.unitless || {}).forEach(function(kr) {
          xr.add(token2CSSVar(kr, hr.prefix)), xr.add(token2CSSVar(kr, getCompVarPrefix(er, hr.prefix)));
        }), genCalc(yr, xr);
      }, [yr, er, hr == null ? void 0 : hr.prefix]), vr = genMaxMin(yr), dr = vr.max, br = vr.min, Cr = {
        theme: or,
        token: cr,
        hashId: lr,
        nonce: function() {
          return _r.nonce;
        },
        clientOnly: Zt.clientOnly,
        layer: nr,
        // antd is always at top of styles
        order: Zt.order || -999
      };
      typeof Bt == "function" && useStyleRegister(_objectSpread2(_objectSpread2({}, Cr), {}, {
        clientOnly: !1,
        path: ["Shared", mr]
      }), function() {
        return Bt(cr, {
          prefix: {
            rootPrefixCls: mr,
            iconPrefixCls: Er
          },
          csp: _r
        });
      });
      var Pr = useStyleRegister(_objectSpread2(_objectSpread2({}, Cr), {}, {
        path: [tr, rr, Er]
      }), function() {
        if (Zt.injectStyle === !1)
          return [];
        var xr = statisticToken(cr), kr = xr.token, Ir = xr.flush, Ar = getDefaultComponentToken(er, sr, Xt), Mr = ".".concat(rr), Fr = getComponentToken(er, sr, Ar, {
          deprecatedTokens: Zt.deprecatedTokens
        });
        hr && Ar && _typeof(Ar) === "object" && Object.keys(Ar).forEach(function(Gr) {
          Ar[Gr] = "var(".concat(token2CSSVar(Gr, getCompVarPrefix(er, hr.prefix)), ")");
        });
        var Dr = merge$1(kr, {
          componentCls: Mr,
          prefixCls: rr,
          iconCls: ".".concat(Er),
          antCls: ".".concat(mr),
          calc: ur,
          // @ts-ignore
          max: dr,
          // @ts-ignore
          min: br
        }, hr ? Ar : Fr), zr = Qt(Dr, {
          hashId: lr,
          prefixCls: rr,
          rootPrefixCls: mr,
          iconPrefixCls: Er
        });
        Ir(er, Fr);
        var Tr = typeof Vt == "function" ? Vt(Dr, rr, ir, Zt.resetFont) : null;
        return [Zt.resetStyle === !1 ? null : Tr, zr];
      });
      return [Pr, lr];
    };
  }
  function qt(Kt, Qt, Xt) {
    var Zt = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, Yt = Gt(Kt, Qt, Xt, _objectSpread2({
      resetStyle: !1,
      // Sub Style should default after root one
      order: -998
    }, Zt)), Jt = function(tr) {
      var nr = tr.prefixCls, rr = tr.rootCls, ir = rr === void 0 ? nr : rr;
      return Yt(nr, ir), null;
    };
    return browser$1.env.NODE_ENV !== "production" && (Jt.displayName = "SubStyle_".concat(String(Array.isArray(Kt) ? Kt.join(".") : Kt))), Jt;
  }
  return {
    genStyleHooks: Ht,
    genSubStyleComponent: qt,
    genComponentStyleHook: Gt
  };
}
const PresetColors = ["blue", "purple", "cyan", "green", "magenta", "pink", "red", "orange", "yellow", "volcano", "geekblue", "lime", "gold"], version$1 = "5.23.2";
function isStableColor(_t) {
  return _t >= 0 && _t <= 255;
}
function getAlphaColor(_t, Et) {
  const {
    r: Pt,
    g: $t,
    b: Mt,
    a: Bt
  } = new FastColor(_t).toRgb();
  if (Bt < 1)
    return _t;
  const {
    r: Vt,
    g: zt,
    b: Ht
  } = new FastColor(Et).toRgb();
  for (let Wt = 0.01; Wt <= 1; Wt += 0.01) {
    const Gt = Math.round((Pt - Vt * (1 - Wt)) / Wt), qt = Math.round(($t - zt * (1 - Wt)) / Wt), Kt = Math.round((Mt - Ht * (1 - Wt)) / Wt);
    if (isStableColor(Gt) && isStableColor(qt) && isStableColor(Kt))
      return new FastColor({
        r: Gt,
        g: qt,
        b: Kt,
        a: Math.round(Wt * 100) / 100
      }).toRgbString();
  }
  return new FastColor({
    r: Pt,
    g: $t,
    b: Mt,
    a: 1
  }).toRgbString();
}
var __rest$f = function(_t, Et) {
  var Pt = {};
  for (var $t in _t)
    Object.prototype.hasOwnProperty.call(_t, $t) && Et.indexOf($t) < 0 && (Pt[$t] = _t[$t]);
  if (_t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var Mt = 0, $t = Object.getOwnPropertySymbols(_t); Mt < $t.length; Mt++)
      Et.indexOf($t[Mt]) < 0 && Object.prototype.propertyIsEnumerable.call(_t, $t[Mt]) && (Pt[$t[Mt]] = _t[$t[Mt]]);
  return Pt;
};
function formatToken(_t) {
  const {
    override: Et
  } = _t, Pt = __rest$f(_t, ["override"]), $t = Object.assign({}, Et);
  Object.keys(seedToken).forEach((Kt) => {
    delete $t[Kt];
  });
  const Mt = Object.assign(Object.assign({}, Pt), $t), Bt = 480, Vt = 576, zt = 768, Ht = 992, Wt = 1200, Gt = 1600;
  if (Mt.motion === !1) {
    const Kt = "0s";
    Mt.motionDurationFast = Kt, Mt.motionDurationMid = Kt, Mt.motionDurationSlow = Kt;
  }
  return Object.assign(Object.assign(Object.assign({}, Mt), {
    // ============== Background ============== //
    colorFillContent: Mt.colorFillSecondary,
    colorFillContentHover: Mt.colorFill,
    colorFillAlter: Mt.colorFillQuaternary,
    colorBgContainerDisabled: Mt.colorFillTertiary,
    // ============== Split ============== //
    colorBorderBg: Mt.colorBgContainer,
    colorSplit: getAlphaColor(Mt.colorBorderSecondary, Mt.colorBgContainer),
    // ============== Text ============== //
    colorTextPlaceholder: Mt.colorTextQuaternary,
    colorTextDisabled: Mt.colorTextQuaternary,
    colorTextHeading: Mt.colorText,
    colorTextLabel: Mt.colorTextSecondary,
    colorTextDescription: Mt.colorTextTertiary,
    colorTextLightSolid: Mt.colorWhite,
    colorHighlight: Mt.colorError,
    colorBgTextHover: Mt.colorFillSecondary,
    colorBgTextActive: Mt.colorFill,
    colorIcon: Mt.colorTextTertiary,
    colorIconHover: Mt.colorText,
    colorErrorOutline: getAlphaColor(Mt.colorErrorBg, Mt.colorBgContainer),
    colorWarningOutline: getAlphaColor(Mt.colorWarningBg, Mt.colorBgContainer),
    // Font
    fontSizeIcon: Mt.fontSizeSM,
    // Line
    lineWidthFocus: Mt.lineWidth * 3,
    // Control
    lineWidth: Mt.lineWidth,
    controlOutlineWidth: Mt.lineWidth * 2,
    // Checkbox size and expand icon size
    controlInteractiveSize: Mt.controlHeight / 2,
    controlItemBgHover: Mt.colorFillTertiary,
    controlItemBgActive: Mt.colorPrimaryBg,
    controlItemBgActiveHover: Mt.colorPrimaryBgHover,
    controlItemBgActiveDisabled: Mt.colorFill,
    controlTmpOutline: Mt.colorFillQuaternary,
    controlOutline: getAlphaColor(Mt.colorPrimaryBg, Mt.colorBgContainer),
    lineType: Mt.lineType,
    borderRadius: Mt.borderRadius,
    borderRadiusXS: Mt.borderRadiusXS,
    borderRadiusSM: Mt.borderRadiusSM,
    borderRadiusLG: Mt.borderRadiusLG,
    fontWeightStrong: 600,
    opacityLoading: 0.65,
    linkDecoration: "none",
    linkHoverDecoration: "none",
    linkFocusDecoration: "none",
    controlPaddingHorizontal: 12,
    controlPaddingHorizontalSM: 8,
    paddingXXS: Mt.sizeXXS,
    paddingXS: Mt.sizeXS,
    paddingSM: Mt.sizeSM,
    padding: Mt.size,
    paddingMD: Mt.sizeMD,
    paddingLG: Mt.sizeLG,
    paddingXL: Mt.sizeXL,
    paddingContentHorizontalLG: Mt.sizeLG,
    paddingContentVerticalLG: Mt.sizeMS,
    paddingContentHorizontal: Mt.sizeMS,
    paddingContentVertical: Mt.sizeSM,
    paddingContentHorizontalSM: Mt.size,
    paddingContentVerticalSM: Mt.sizeXS,
    marginXXS: Mt.sizeXXS,
    marginXS: Mt.sizeXS,
    marginSM: Mt.sizeSM,
    margin: Mt.size,
    marginMD: Mt.sizeMD,
    marginLG: Mt.sizeLG,
    marginXL: Mt.sizeXL,
    marginXXL: Mt.sizeXXL,
    boxShadow: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowSecondary: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTertiary: `
      0 1px 2px 0 rgba(0, 0, 0, 0.03),
      0 1px 6px -1px rgba(0, 0, 0, 0.02),
      0 2px 4px 0 rgba(0, 0, 0, 0.02)
    `,
    screenXS: Bt,
    screenXSMin: Bt,
    screenXSMax: Vt - 1,
    screenSM: Vt,
    screenSMMin: Vt,
    screenSMMax: zt - 1,
    screenMD: zt,
    screenMDMin: zt,
    screenMDMax: Ht - 1,
    screenLG: Ht,
    screenLGMin: Ht,
    screenLGMax: Wt - 1,
    screenXL: Wt,
    screenXLMin: Wt,
    screenXLMax: Gt - 1,
    screenXXL: Gt,
    screenXXLMin: Gt,
    boxShadowPopoverArrow: "2px 2px 5px rgba(0, 0, 0, 0.05)",
    boxShadowCard: `
      0 1px 2px -2px ${new FastColor("rgba(0, 0, 0, 0.16)").toRgbString()},
      0 3px 6px 0 ${new FastColor("rgba(0, 0, 0, 0.12)").toRgbString()},
      0 5px 12px 4px ${new FastColor("rgba(0, 0, 0, 0.09)").toRgbString()}
    `,
    boxShadowDrawerRight: `
      -6px 0 16px 0 rgba(0, 0, 0, 0.08),
      -3px 0 6px -4px rgba(0, 0, 0, 0.12),
      -9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerLeft: `
      6px 0 16px 0 rgba(0, 0, 0, 0.08),
      3px 0 6px -4px rgba(0, 0, 0, 0.12),
      9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerUp: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerDown: `
      0 -6px 16px 0 rgba(0, 0, 0, 0.08),
      0 -3px 6px -4px rgba(0, 0, 0, 0.12),
      0 -9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTabsOverflowLeft: "inset 10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowRight: "inset -10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowTop: "inset 0 10px 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowBottom: "inset 0 -10px 8px -8px rgba(0, 0, 0, 0.08)"
  }), $t);
}
var __rest$e = function(_t, Et) {
  var Pt = {};
  for (var $t in _t)
    Object.prototype.hasOwnProperty.call(_t, $t) && Et.indexOf($t) < 0 && (Pt[$t] = _t[$t]);
  if (_t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var Mt = 0, $t = Object.getOwnPropertySymbols(_t); Mt < $t.length; Mt++)
      Et.indexOf($t[Mt]) < 0 && Object.prototype.propertyIsEnumerable.call(_t, $t[Mt]) && (Pt[$t[Mt]] = _t[$t[Mt]]);
  return Pt;
};
const unitless = {
  lineHeight: !0,
  lineHeightSM: !0,
  lineHeightLG: !0,
  lineHeightHeading1: !0,
  lineHeightHeading2: !0,
  lineHeightHeading3: !0,
  lineHeightHeading4: !0,
  lineHeightHeading5: !0,
  opacityLoading: !0,
  fontWeightStrong: !0,
  zIndexPopupBase: !0,
  zIndexBase: !0,
  opacityImage: !0
}, ignore = {
  size: !0,
  sizeSM: !0,
  sizeLG: !0,
  sizeMD: !0,
  sizeXS: !0,
  sizeXXS: !0,
  sizeMS: !0,
  sizeXL: !0,
  sizeXXL: !0,
  sizeUnit: !0,
  sizeStep: !0,
  motionBase: !0,
  motionUnit: !0
}, preserve = {
  screenXS: !0,
  screenXSMin: !0,
  screenXSMax: !0,
  screenSM: !0,
  screenSMMin: !0,
  screenSMMax: !0,
  screenMD: !0,
  screenMDMin: !0,
  screenMDMax: !0,
  screenLG: !0,
  screenLGMin: !0,
  screenLGMax: !0,
  screenXL: !0,
  screenXLMin: !0,
  screenXLMax: !0,
  screenXXL: !0,
  screenXXLMin: !0
}, getComputedToken = (_t, Et, Pt) => {
  const $t = Pt.getDerivativeToken(_t), {
    override: Mt
  } = Et, Bt = __rest$e(Et, ["override"]);
  let Vt = Object.assign(Object.assign({}, $t), {
    override: Mt
  });
  return Vt = formatToken(Vt), Bt && Object.entries(Bt).forEach((zt) => {
    let [Ht, Wt] = zt;
    const {
      theme: Gt
    } = Wt, qt = __rest$e(Wt, ["theme"]);
    let Kt = qt;
    Gt && (Kt = getComputedToken(Object.assign(Object.assign({}, Vt), qt), {
      override: qt
    }, Gt)), Vt[Ht] = Kt;
  }), Vt;
};
function useToken() {
  const {
    token: _t,
    hashed: Et,
    theme: Pt,
    override: $t,
    cssVar: Mt
  } = React__default.useContext(DesignTokenContext), Bt = `${version$1}-${Et || ""}`, Vt = Pt || defaultTheme, [zt, Ht, Wt] = useCacheToken(Vt, [seedToken, _t], {
    salt: Bt,
    override: $t,
    getComputedToken,
    // formatToken will not be consumed after 1.15.0 with getComputedToken.
    // But token will break if @ant-design/cssinjs is under 1.15.0 without it
    formatToken,
    cssVar: Mt && {
      prefix: Mt.prefix,
      key: Mt.key,
      unitless,
      ignore,
      preserve
    }
  });
  return [Vt, Wt, Et ? Ht : "", zt, Mt];
}
const textEllipsis = {
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis"
}, resetComponent = function(_t) {
  let Et = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  return {
    boxSizing: "border-box",
    margin: 0,
    padding: 0,
    color: _t.colorText,
    fontSize: _t.fontSize,
    // font-variant: @font-variant-base;
    lineHeight: _t.lineHeight,
    listStyle: "none",
    // font-feature-settings: @font-feature-settings-base;
    fontFamily: Et ? "inherit" : _t.fontFamily
  };
}, resetIcon = () => ({
  display: "inline-flex",
  alignItems: "center",
  color: "inherit",
  fontStyle: "normal",
  lineHeight: 0,
  textAlign: "center",
  textTransform: "none",
  // for SVG icon, see https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
  verticalAlign: "-0.125em",
  textRendering: "optimizeLegibility",
  "-webkit-font-smoothing": "antialiased",
  "-moz-osx-font-smoothing": "grayscale",
  "> *": {
    lineHeight: 1
  },
  svg: {
    display: "inline-block"
  }
}), clearFix = () => ({
  // https://github.com/ant-design/ant-design/issues/21301#issuecomment-583955229
  "&::before": {
    display: "table",
    content: '""'
  },
  "&::after": {
    // https://github.com/ant-design/ant-design/issues/21864
    display: "table",
    clear: "both",
    content: '""'
  }
}), genLinkStyle = (_t) => ({
  a: {
    color: _t.colorLink,
    textDecoration: _t.linkDecoration,
    backgroundColor: "transparent",
    // remove the gray background on active links in IE 10.
    outline: "none",
    cursor: "pointer",
    transition: `color ${_t.motionDurationSlow}`,
    "-webkit-text-decoration-skip": "objects",
    // remove gaps in links underline in iOS 8+ and Safari 8+.
    "&:hover": {
      color: _t.colorLinkHover
    },
    "&:active": {
      color: _t.colorLinkActive
    },
    "&:active, &:hover": {
      textDecoration: _t.linkHoverDecoration,
      outline: 0
    },
    // https://github.com/ant-design/ant-design/issues/22503
    "&:focus": {
      textDecoration: _t.linkFocusDecoration,
      outline: 0
    },
    "&[disabled]": {
      color: _t.colorTextDisabled,
      cursor: "not-allowed"
    }
  }
}), genCommonStyle = (_t, Et, Pt, $t) => {
  const Mt = `[class^="${Et}"], [class*=" ${Et}"]`, Bt = Pt ? `.${Pt}` : Mt, Vt = {
    boxSizing: "border-box",
    "&::before, &::after": {
      boxSizing: "border-box"
    }
  };
  let zt = {};
  return $t !== !1 && (zt = {
    fontFamily: _t.fontFamily,
    fontSize: _t.fontSize
  }), {
    [Bt]: Object.assign(Object.assign(Object.assign({}, zt), Vt), {
      [Mt]: Vt
    })
  };
}, genFocusOutline = (_t, Et) => ({
  outline: `${unit$1(_t.lineWidthFocus)} solid ${_t.colorPrimaryBorder}`,
  outlineOffset: Et ?? 1,
  transition: "outline-offset 0s, outline 0s"
}), genFocusStyle = (_t, Et) => ({
  "&:focus-visible": Object.assign({}, genFocusOutline(_t, Et))
}), genIconStyle = (_t) => ({
  [`.${_t}`]: Object.assign(Object.assign({}, resetIcon()), {
    [`.${_t} .${_t}-icon`]: {
      display: "block"
    }
  })
}), {
  genStyleHooks,
  genComponentStyleHook,
  genSubStyleComponent
} = genStyleUtils({
  usePrefix: () => {
    const {
      getPrefixCls: _t,
      iconPrefixCls: Et
    } = useContext(ConfigContext);
    return {
      rootPrefixCls: _t(),
      iconPrefixCls: Et
    };
  },
  useToken: () => {
    const [_t, Et, Pt, $t, Mt] = useToken();
    return {
      theme: _t,
      realToken: Et,
      hashId: Pt,
      token: $t,
      cssVar: Mt
    };
  },
  useCSP: () => {
    const {
      csp: _t
    } = useContext(ConfigContext);
    return _t ?? {};
  },
  getResetStyles: (_t, Et) => {
    var Pt;
    return [{
      "&": genLinkStyle(_t)
    }, genIconStyle((Pt = Et == null ? void 0 : Et.prefix.iconPrefixCls) !== null && Pt !== void 0 ? Pt : defaultIconPrefixCls)];
  },
  getCommonStyle: genCommonStyle,
  getCompUnitless: () => unitless
});
function genPresetColor(_t, Et) {
  return PresetColors.reduce((Pt, $t) => {
    const Mt = _t[`${$t}1`], Bt = _t[`${$t}3`], Vt = _t[`${$t}6`], zt = _t[`${$t}7`];
    return Object.assign(Object.assign({}, Pt), Et($t, {
      lightColor: Mt,
      lightBorderColor: Bt,
      darkColor: Vt,
      textColor: zt
    }));
  }, {});
}
const useResetIconStyle = (_t, Et) => {
  const [Pt, $t] = useToken();
  return useStyleRegister({
    theme: Pt,
    token: $t,
    hashId: "",
    path: ["ant-design-icons", _t],
    nonce: () => Et == null ? void 0 : Et.nonce,
    layer: {
      name: "antd"
    }
  }, () => [genIconStyle(_t)]);
}, fullClone$1 = Object.assign({}, React), {
  useId: useId$1
} = fullClone$1, useEmptyId = () => "", useThemeKey = typeof useId$1 > "u" ? useEmptyId : useId$1;
function useTheme(_t, Et, Pt) {
  var $t, Mt;
  const Bt = devUseWarning("ConfigProvider"), Vt = _t || {}, zt = Vt.inherit === !1 || !Et ? Object.assign(Object.assign({}, defaultConfig), {
    hashed: ($t = Et == null ? void 0 : Et.hashed) !== null && $t !== void 0 ? $t : defaultConfig.hashed,
    cssVar: Et == null ? void 0 : Et.cssVar
  }) : Et, Ht = useThemeKey();
  if (browser$1.env.NODE_ENV !== "production") {
    const Wt = Vt.cssVar || zt.cssVar, Gt = !!(typeof Vt.cssVar == "object" && (!((Mt = Vt.cssVar) === null || Mt === void 0) && Mt.key) || Ht);
    browser$1.env.NODE_ENV !== "production" && Bt(!Wt || Gt, "breaking", "Missing key in `cssVar` config. Please upgrade to React 18 or set `cssVar.key` manually in each ConfigProvider inside `cssVar` enabled ConfigProvider.");
  }
  return useMemo(() => {
    var Wt, Gt;
    if (!_t)
      return Et;
    const qt = Object.assign({}, zt.components);
    Object.keys(_t.components || {}).forEach((Xt) => {
      qt[Xt] = Object.assign(Object.assign({}, qt[Xt]), _t.components[Xt]);
    });
    const Kt = `css-var-${Ht.replace(/:/g, "")}`, Qt = ((Wt = Vt.cssVar) !== null && Wt !== void 0 ? Wt : zt.cssVar) && Object.assign(Object.assign(Object.assign({
      prefix: Pt == null ? void 0 : Pt.prefixCls
    }, typeof zt.cssVar == "object" ? zt.cssVar : {}), typeof Vt.cssVar == "object" ? Vt.cssVar : {}), {
      key: typeof Vt.cssVar == "object" && ((Gt = Vt.cssVar) === null || Gt === void 0 ? void 0 : Gt.key) || Kt
    });
    return Object.assign(Object.assign(Object.assign({}, zt), Vt), {
      token: Object.assign(Object.assign({}, zt.token), Vt.token),
      components: qt,
      cssVar: Qt
    });
  }, [Vt, zt], (Wt, Gt) => Wt.some((qt, Kt) => {
    const Qt = Gt[Kt];
    return !isEqual(qt, Qt, !0);
  }));
}
var _excluded$o = ["children"], Context$1 = /* @__PURE__ */ React.createContext({});
function MotionProvider(_t) {
  var Et = _t.children, Pt = _objectWithoutProperties$2(_t, _excluded$o);
  return /* @__PURE__ */ React.createElement(Context$1.Provider, {
    value: Pt
  }, Et);
}
var DomWrapper = /* @__PURE__ */ function(_t) {
  _inherits(Pt, _t);
  var Et = _createSuper(Pt);
  function Pt() {
    return _classCallCheck(this, Pt), Et.apply(this, arguments);
  }
  return _createClass(Pt, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), Pt;
}(React.Component);
function useSyncState$1(_t) {
  var Et = React.useReducer(function(zt) {
    return zt + 1;
  }, 0), Pt = _slicedToArray(Et, 2), $t = Pt[1], Mt = React.useRef(_t), Bt = useEvent(function() {
    return Mt.current;
  }), Vt = useEvent(function(zt) {
    Mt.current = typeof zt == "function" ? zt(Mt.current) : zt, $t();
  });
  return [Bt, Vt];
}
var STATUS_NONE = "none", STATUS_APPEAR = "appear", STATUS_ENTER = "enter", STATUS_LEAVE = "leave", STEP_NONE = "none", STEP_PREPARE = "prepare", STEP_START = "start", STEP_ACTIVE = "active", STEP_ACTIVATED = "end", STEP_PREPARED = "prepared";
function makePrefixMap(_t, Et) {
  var Pt = {};
  return Pt[_t.toLowerCase()] = Et.toLowerCase(), Pt["Webkit".concat(_t)] = "webkit".concat(Et), Pt["Moz".concat(_t)] = "moz".concat(Et), Pt["ms".concat(_t)] = "MS".concat(Et), Pt["O".concat(_t)] = "o".concat(Et.toLowerCase()), Pt;
}
function getVendorPrefixes(_t, Et) {
  var Pt = {
    animationend: makePrefixMap("Animation", "AnimationEnd"),
    transitionend: makePrefixMap("Transition", "TransitionEnd")
  };
  return _t && ("AnimationEvent" in Et || delete Pt.animationend.animation, "TransitionEvent" in Et || delete Pt.transitionend.transition), Pt;
}
var vendorPrefixes = getVendorPrefixes(canUseDom(), typeof window < "u" ? window : {}), style = {};
if (canUseDom()) {
  var _document$createEleme = document.createElement("div");
  style = _document$createEleme.style;
}
var prefixedEventNames = {};
function getVendorPrefixedEventName(_t) {
  if (prefixedEventNames[_t])
    return prefixedEventNames[_t];
  var Et = vendorPrefixes[_t];
  if (Et)
    for (var Pt = Object.keys(Et), $t = Pt.length, Mt = 0; Mt < $t; Mt += 1) {
      var Bt = Pt[Mt];
      if (Object.prototype.hasOwnProperty.call(Et, Bt) && Bt in style)
        return prefixedEventNames[_t] = Et[Bt], prefixedEventNames[_t];
    }
  return "";
}
var internalAnimationEndName = getVendorPrefixedEventName("animationend"), internalTransitionEndName = getVendorPrefixedEventName("transitionend"), supportTransition = !!(internalAnimationEndName && internalTransitionEndName), animationEndName = internalAnimationEndName || "animationend", transitionEndName = internalTransitionEndName || "transitionend";
function getTransitionName$1(_t, Et) {
  if (!_t)
    return null;
  if (_typeof(_t) === "object") {
    var Pt = Et.replace(/-\w/g, function($t) {
      return $t[1].toUpperCase();
    });
    return _t[Pt];
  }
  return "".concat(_t, "-").concat(Et);
}
const useDomMotionEvents = function(_t) {
  var Et = useRef();
  function Pt(Mt) {
    Mt && (Mt.removeEventListener(transitionEndName, _t), Mt.removeEventListener(animationEndName, _t));
  }
  function $t(Mt) {
    Et.current && Et.current !== Mt && Pt(Et.current), Mt && Mt !== Et.current && (Mt.addEventListener(transitionEndName, _t), Mt.addEventListener(animationEndName, _t), Et.current = Mt);
  }
  return React.useEffect(function() {
    return function() {
      Pt(Et.current);
    };
  }, []), [$t, Pt];
};
var useIsomorphicLayoutEffect = canUseDom() ? useLayoutEffect$1 : useEffect;
const useNextFrame = function() {
  var _t = React.useRef(null);
  function Et() {
    wrapperRaf.cancel(_t.current);
  }
  function Pt($t) {
    var Mt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    Et();
    var Bt = wrapperRaf(function() {
      Mt <= 1 ? $t({
        isCanceled: function() {
          return Bt !== _t.current;
        }
      }) : Pt($t, Mt - 1);
    });
    _t.current = Bt;
  }
  return React.useEffect(function() {
    return function() {
      Et();
    };
  }, []), [Pt, Et];
};
var FULL_STEP_QUEUE = [STEP_PREPARE, STEP_START, STEP_ACTIVE, STEP_ACTIVATED], SIMPLE_STEP_QUEUE = [STEP_PREPARE, STEP_PREPARED], SkipStep = !1, DoStep = !0;
function isActive(_t) {
  return _t === STEP_ACTIVE || _t === STEP_ACTIVATED;
}
const useStepQueue = function(_t, Et, Pt) {
  var $t = useSafeState(STEP_NONE), Mt = _slicedToArray($t, 2), Bt = Mt[0], Vt = Mt[1], zt = useNextFrame(), Ht = _slicedToArray(zt, 2), Wt = Ht[0], Gt = Ht[1];
  function qt() {
    Vt(STEP_PREPARE, !0);
  }
  var Kt = Et ? SIMPLE_STEP_QUEUE : FULL_STEP_QUEUE;
  return useIsomorphicLayoutEffect(function() {
    if (Bt !== STEP_NONE && Bt !== STEP_ACTIVATED) {
      var Qt = Kt.indexOf(Bt), Xt = Kt[Qt + 1], Zt = Pt(Bt);
      Zt === SkipStep ? Vt(Xt, !0) : Xt && Wt(function(Yt) {
        function Jt() {
          Yt.isCanceled() || Vt(Xt, !0);
        }
        Zt === !0 ? Jt() : Promise.resolve(Zt).then(Jt);
      });
    }
  }, [_t, Bt]), React.useEffect(function() {
    return function() {
      Gt();
    };
  }, []), [qt, Bt];
};
function useStatus(_t, Et, Pt, $t) {
  var Mt = $t.motionEnter, Bt = Mt === void 0 ? !0 : Mt, Vt = $t.motionAppear, zt = Vt === void 0 ? !0 : Vt, Ht = $t.motionLeave, Wt = Ht === void 0 ? !0 : Ht, Gt = $t.motionDeadline, qt = $t.motionLeaveImmediately, Kt = $t.onAppearPrepare, Qt = $t.onEnterPrepare, Xt = $t.onLeavePrepare, Zt = $t.onAppearStart, Yt = $t.onEnterStart, Jt = $t.onLeaveStart, er = $t.onAppearActive, tr = $t.onEnterActive, nr = $t.onLeaveActive, rr = $t.onAppearEnd, ir = $t.onEnterEnd, ar = $t.onLeaveEnd, or = $t.onVisibleChanged, sr = useSafeState(), lr = _slicedToArray(sr, 2), cr = lr[0], hr = lr[1], pr = useSyncState$1(STATUS_NONE), mr = _slicedToArray(pr, 2), Er = mr[0], _r = mr[1], yr = useSafeState(null), ur = _slicedToArray(yr, 2), vr = ur[0], dr = ur[1], br = Er(), Cr = useRef(!1), Pr = useRef(null);
  function xr() {
    return Pt();
  }
  var kr = useRef(!1);
  function Ir() {
    _r(STATUS_NONE), dr(null, !0);
  }
  var Ar = useEvent(function(Ur) {
    var Zr = Er();
    if (Zr !== STATUS_NONE) {
      var Xr = xr();
      if (!(Ur && !Ur.deadline && Ur.target !== Xr)) {
        var mn = kr.current, an;
        Zr === STATUS_APPEAR && mn ? an = rr == null ? void 0 : rr(Xr, Ur) : Zr === STATUS_ENTER && mn ? an = ir == null ? void 0 : ir(Xr, Ur) : Zr === STATUS_LEAVE && mn && (an = ar == null ? void 0 : ar(Xr, Ur)), mn && an !== !1 && Ir();
      }
    }
  }), Mr = useDomMotionEvents(Ar), Fr = _slicedToArray(Mr, 1), Dr = Fr[0], zr = function(Zr) {
    switch (Zr) {
      case STATUS_APPEAR:
        return _defineProperty(_defineProperty(_defineProperty({}, STEP_PREPARE, Kt), STEP_START, Zt), STEP_ACTIVE, er);
      case STATUS_ENTER:
        return _defineProperty(_defineProperty(_defineProperty({}, STEP_PREPARE, Qt), STEP_START, Yt), STEP_ACTIVE, tr);
      case STATUS_LEAVE:
        return _defineProperty(_defineProperty(_defineProperty({}, STEP_PREPARE, Xt), STEP_START, Jt), STEP_ACTIVE, nr);
      default:
        return {};
    }
  }, Tr = React.useMemo(function() {
    return zr(br);
  }, [br]), Gr = useStepQueue(br, !_t, function(Ur) {
    if (Ur === STEP_PREPARE) {
      var Zr = Tr[STEP_PREPARE];
      return Zr ? Zr(xr()) : SkipStep;
    }
    if (Or in Tr) {
      var Xr;
      dr(((Xr = Tr[Or]) === null || Xr === void 0 ? void 0 : Xr.call(Tr, xr(), null)) || null);
    }
    return Or === STEP_ACTIVE && br !== STATUS_NONE && (Dr(xr()), Gt > 0 && (clearTimeout(Pr.current), Pr.current = setTimeout(function() {
      Ar({
        deadline: !0
      });
    }, Gt))), Or === STEP_PREPARED && Ir(), DoStep;
  }), $r = _slicedToArray(Gr, 2), Rr = $r[0], Or = $r[1], Lr = isActive(Or);
  kr.current = Lr;
  var Hr = useRef(null);
  useIsomorphicLayoutEffect(function() {
    if (!(Cr.current && Hr.current === Et)) {
      hr(Et);
      var Ur = Cr.current;
      Cr.current = !0;
      var Zr;
      !Ur && Et && zt && (Zr = STATUS_APPEAR), Ur && Et && Bt && (Zr = STATUS_ENTER), (Ur && !Et && Wt || !Ur && qt && !Et && Wt) && (Zr = STATUS_LEAVE);
      var Xr = zr(Zr);
      Zr && (_t || Xr[STEP_PREPARE]) ? (_r(Zr), Rr()) : _r(STATUS_NONE), Hr.current = Et;
    }
  }, [Et]), useEffect(function() {
    // Cancel appear
    (br === STATUS_APPEAR && !zt || // Cancel enter
    br === STATUS_ENTER && !Bt || // Cancel leave
    br === STATUS_LEAVE && !Wt) && _r(STATUS_NONE);
  }, [zt, Bt, Wt]), useEffect(function() {
    return function() {
      Cr.current = !1, clearTimeout(Pr.current);
    };
  }, []);
  var Wr = React.useRef(!1);
  useEffect(function() {
    cr && (Wr.current = !0), cr !== void 0 && br === STATUS_NONE && ((Wr.current || cr) && (or == null || or(cr)), Wr.current = !0);
  }, [cr, br]);
  var Kr = vr;
  return Tr[STEP_PREPARE] && Or === STEP_START && (Kr = _objectSpread2({
    transition: "none"
  }, Kr)), [br, Or, Kr, cr ?? Et];
}
function genCSSMotion(_t) {
  var Et = _t;
  _typeof(_t) === "object" && (Et = _t.transitionSupport);
  function Pt(Mt, Bt) {
    return !!(Mt.motionName && Et && Bt !== !1);
  }
  var $t = /* @__PURE__ */ React.forwardRef(function(Mt, Bt) {
    var Vt = Mt.visible, zt = Vt === void 0 ? !0 : Vt, Ht = Mt.removeOnLeave, Wt = Ht === void 0 ? !0 : Ht, Gt = Mt.forceRender, qt = Mt.children, Kt = Mt.motionName, Qt = Mt.leavedClassName, Xt = Mt.eventProps, Zt = React.useContext(Context$1), Yt = Zt.motion, Jt = Pt(Mt, Yt), er = useRef(), tr = useRef();
    function nr() {
      try {
        return er.current instanceof HTMLElement ? er.current : findDOMNode(tr.current);
      } catch {
        return null;
      }
    }
    var rr = useStatus(Jt, zt, nr, Mt), ir = _slicedToArray(rr, 4), ar = ir[0], or = ir[1], sr = ir[2], lr = ir[3], cr = React.useRef(lr);
    lr && (cr.current = !0);
    var hr = React.useCallback(function(ur) {
      er.current = ur, fillRef(Bt, ur);
    }, [Bt]), pr, mr = _objectSpread2(_objectSpread2({}, Xt), {}, {
      visible: zt
    });
    if (!qt)
      pr = null;
    else if (ar === STATUS_NONE)
      lr ? pr = qt(_objectSpread2({}, mr), hr) : !Wt && cr.current && Qt ? pr = qt(_objectSpread2(_objectSpread2({}, mr), {}, {
        className: Qt
      }), hr) : Gt || !Wt && !Qt ? pr = qt(_objectSpread2(_objectSpread2({}, mr), {}, {
        style: {
          display: "none"
        }
      }), hr) : pr = null;
    else {
      var Er;
      or === STEP_PREPARE ? Er = "prepare" : isActive(or) ? Er = "active" : or === STEP_START && (Er = "start");
      var _r = getTransitionName$1(Kt, "".concat(ar, "-").concat(Er));
      pr = qt(_objectSpread2(_objectSpread2({}, mr), {}, {
        className: classNames(getTransitionName$1(Kt, ar), _defineProperty(_defineProperty({}, _r, _r && Er), Kt, typeof Kt == "string")),
        style: sr
      }), hr);
    }
    if (/* @__PURE__ */ React.isValidElement(pr) && supportRef(pr)) {
      var yr = getNodeRef(pr);
      yr || (pr = /* @__PURE__ */ React.cloneElement(pr, {
        ref: hr
      }));
    }
    return /* @__PURE__ */ React.createElement(DomWrapper, {
      ref: tr
    }, pr);
  });
  return $t.displayName = "CSSMotion", $t;
}
const CSSMotion = genCSSMotion(supportTransition);
var STATUS_ADD = "add", STATUS_KEEP = "keep", STATUS_REMOVE = "remove", STATUS_REMOVED = "removed";
function wrapKeyToObject(_t) {
  var Et;
  return _t && _typeof(_t) === "object" && "key" in _t ? Et = _t : Et = {
    key: _t
  }, _objectSpread2(_objectSpread2({}, Et), {}, {
    key: String(Et.key)
  });
}
function parseKeys() {
  var _t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  return _t.map(wrapKeyToObject);
}
function diffKeys() {
  var _t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], Et = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], Pt = [], $t = 0, Mt = Et.length, Bt = parseKeys(_t), Vt = parseKeys(Et);
  Bt.forEach(function(Wt) {
    for (var Gt = !1, qt = $t; qt < Mt; qt += 1) {
      var Kt = Vt[qt];
      if (Kt.key === Wt.key) {
        $t < qt && (Pt = Pt.concat(Vt.slice($t, qt).map(function(Qt) {
          return _objectSpread2(_objectSpread2({}, Qt), {}, {
            status: STATUS_ADD
          });
        })), $t = qt), Pt.push(_objectSpread2(_objectSpread2({}, Kt), {}, {
          status: STATUS_KEEP
        })), $t += 1, Gt = !0;
        break;
      }
    }
    Gt || Pt.push(_objectSpread2(_objectSpread2({}, Wt), {}, {
      status: STATUS_REMOVE
    }));
  }), $t < Mt && (Pt = Pt.concat(Vt.slice($t).map(function(Wt) {
    return _objectSpread2(_objectSpread2({}, Wt), {}, {
      status: STATUS_ADD
    });
  })));
  var zt = {};
  Pt.forEach(function(Wt) {
    var Gt = Wt.key;
    zt[Gt] = (zt[Gt] || 0) + 1;
  });
  var Ht = Object.keys(zt).filter(function(Wt) {
    return zt[Wt] > 1;
  });
  return Ht.forEach(function(Wt) {
    Pt = Pt.filter(function(Gt) {
      var qt = Gt.key, Kt = Gt.status;
      return qt !== Wt || Kt !== STATUS_REMOVE;
    }), Pt.forEach(function(Gt) {
      Gt.key === Wt && (Gt.status = STATUS_KEEP);
    });
  }), Pt;
}
var _excluded$n = ["component", "children", "onVisibleChanged", "onAllRemoved"], _excluded2$5 = ["status"], MOTION_PROP_NAMES = ["eventProps", "visible", "children", "motionName", "motionAppear", "motionEnter", "motionLeave", "motionLeaveImmediately", "motionDeadline", "removeOnLeave", "leavedClassName", "onAppearPrepare", "onAppearStart", "onAppearActive", "onAppearEnd", "onEnterStart", "onEnterActive", "onEnterEnd", "onLeaveStart", "onLeaveActive", "onLeaveEnd"];
function genCSSMotionList(_t) {
  var Et = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CSSMotion, Pt = /* @__PURE__ */ function($t) {
    _inherits(Bt, $t);
    var Mt = _createSuper(Bt);
    function Bt() {
      var Vt;
      _classCallCheck(this, Bt);
      for (var zt = arguments.length, Ht = new Array(zt), Wt = 0; Wt < zt; Wt++)
        Ht[Wt] = arguments[Wt];
      return Vt = Mt.call.apply(Mt, [this].concat(Ht)), _defineProperty(_assertThisInitialized(Vt), "state", {
        keyEntities: []
      }), _defineProperty(_assertThisInitialized(Vt), "removeKey", function(Gt) {
        Vt.setState(function(qt) {
          var Kt = qt.keyEntities.map(function(Qt) {
            return Qt.key !== Gt ? Qt : _objectSpread2(_objectSpread2({}, Qt), {}, {
              status: STATUS_REMOVED
            });
          });
          return {
            keyEntities: Kt
          };
        }, function() {
          var qt = Vt.state.keyEntities, Kt = qt.filter(function(Qt) {
            var Xt = Qt.status;
            return Xt !== STATUS_REMOVED;
          }).length;
          Kt === 0 && Vt.props.onAllRemoved && Vt.props.onAllRemoved();
        });
      }), Vt;
    }
    return _createClass(Bt, [{
      key: "render",
      value: function() {
        var zt = this, Ht = this.state.keyEntities, Wt = this.props, Gt = Wt.component, qt = Wt.children, Kt = Wt.onVisibleChanged;
        Wt.onAllRemoved;
        var Qt = _objectWithoutProperties$2(Wt, _excluded$n), Xt = Gt || React.Fragment, Zt = {};
        return MOTION_PROP_NAMES.forEach(function(Yt) {
          Zt[Yt] = Qt[Yt], delete Qt[Yt];
        }), delete Qt.keys, /* @__PURE__ */ React.createElement(Xt, Qt, Ht.map(function(Yt, Jt) {
          var er = Yt.status, tr = _objectWithoutProperties$2(Yt, _excluded2$5), nr = er === STATUS_ADD || er === STATUS_KEEP;
          return /* @__PURE__ */ React.createElement(Et, _extends$2({}, Zt, {
            key: tr.key,
            visible: nr,
            eventProps: tr,
            onVisibleChanged: function(ir) {
              Kt == null || Kt(ir, {
                key: tr.key
              }), ir || zt.removeKey(tr.key);
            }
          }), function(rr, ir) {
            return qt(_objectSpread2(_objectSpread2({}, rr), {}, {
              index: Jt
            }), ir);
          });
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(zt, Ht) {
        var Wt = zt.keys, Gt = Ht.keyEntities, qt = parseKeys(Wt), Kt = diffKeys(Gt, qt);
        return {
          keyEntities: Kt.filter(function(Qt) {
            var Xt = Gt.find(function(Zt) {
              var Yt = Zt.key;
              return Qt.key === Yt;
            });
            return !(Xt && Xt.status === STATUS_REMOVED && Qt.status === STATUS_REMOVE);
          })
        };
      }
    }]), Bt;
  }(React.Component);
  return _defineProperty(Pt, "defaultProps", {
    component: "div"
  }), Pt;
}
const CSSMotionList = genCSSMotionList(supportTransition);
function MotionWrapper(_t) {
  const {
    children: Et
  } = _t, [, Pt] = useToken(), {
    motion: $t
  } = Pt, Mt = React.useRef(!1);
  return Mt.current = Mt.current || $t === !1, Mt.current ? /* @__PURE__ */ React.createElement(MotionProvider, {
    motion: $t
  }, Et) : Et;
}
const PropWarning = /* @__PURE__ */ React.memo((_t) => {
  let {
    dropdownMatchSelectWidth: Et
  } = _t;
  return devUseWarning("ConfigProvider").deprecated(Et === void 0, "dropdownMatchSelectWidth", "popupMatchSelectWidth"), null;
});
browser$1.env.NODE_ENV !== "production" && (PropWarning.displayName = "PropWarning");
const PropWarning$1 = browser$1.env.NODE_ENV !== "production" ? PropWarning : () => null;
var __rest$d = function(_t, Et) {
  var Pt = {};
  for (var $t in _t)
    Object.prototype.hasOwnProperty.call(_t, $t) && Et.indexOf($t) < 0 && (Pt[$t] = _t[$t]);
  if (_t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var Mt = 0, $t = Object.getOwnPropertySymbols(_t); Mt < $t.length; Mt++)
      Et.indexOf($t[Mt]) < 0 && Object.prototype.propertyIsEnumerable.call(_t, $t[Mt]) && (Pt[$t[Mt]] = _t[$t[Mt]]);
  return Pt;
};
let existThemeConfig = !1;
const warnContext = browser$1.env.NODE_ENV !== "production" ? (_t) => {
  browser$1.env.NODE_ENV !== "production" && warning$1(!existThemeConfig, _t, "Static function can not consume context like dynamic theme. Please use 'App' component instead.");
} : (
  /* istanbul ignore next */
  null
), PASSED_PROPS = ["getTargetContainer", "getPopupContainer", "renderEmpty", "input", "pagination", "form", "select", "button"];
let globalPrefixCls, globalIconPrefixCls, globalTheme, globalHolderRender;
function getGlobalPrefixCls() {
  return globalPrefixCls || defaultPrefixCls;
}
function getGlobalIconPrefixCls() {
  return globalIconPrefixCls || defaultIconPrefixCls;
}
function isLegacyTheme(_t) {
  return Object.keys(_t).some((Et) => Et.endsWith("Color"));
}
const setGlobalConfig = (_t) => {
  const {
    prefixCls: Et,
    iconPrefixCls: Pt,
    theme: $t,
    holderRender: Mt
  } = _t;
  Et !== void 0 && (globalPrefixCls = Et), Pt !== void 0 && (globalIconPrefixCls = Pt), "holderRender" in _t && (globalHolderRender = Mt), $t && (isLegacyTheme($t) ? (browser$1.env.NODE_ENV !== "production" && warning$1(!1, "ConfigProvider", "`config` of css variable theme is not work in v5. Please use new `theme` config instead."), registerTheme(getGlobalPrefixCls(), $t)) : globalTheme = $t);
}, globalConfig = () => ({
  getPrefixCls: (_t, Et) => Et || (_t ? `${getGlobalPrefixCls()}-${_t}` : getGlobalPrefixCls()),
  getIconPrefixCls: getGlobalIconPrefixCls,
  getRootPrefixCls: () => globalPrefixCls || getGlobalPrefixCls(),
  getTheme: () => globalTheme,
  holderRender: globalHolderRender
}), ProviderChildren = (_t) => {
  const {
    children: Et,
    csp: Pt,
    autoInsertSpaceInButton: $t,
    alert: Mt,
    anchor: Bt,
    form: Vt,
    locale: zt,
    componentSize: Ht,
    direction: Wt,
    space: Gt,
    splitter: qt,
    virtual: Kt,
    dropdownMatchSelectWidth: Qt,
    popupMatchSelectWidth: Xt,
    popupOverflow: Zt,
    legacyLocale: Yt,
    parentContext: Jt,
    iconPrefixCls: er,
    theme: tr,
    componentDisabled: nr,
    segmented: rr,
    statistic: ir,
    spin: ar,
    calendar: or,
    carousel: sr,
    cascader: lr,
    collapse: cr,
    typography: hr,
    checkbox: pr,
    descriptions: mr,
    divider: Er,
    drawer: _r,
    skeleton: yr,
    steps: ur,
    image: vr,
    layout: dr,
    list: br,
    mentions: Cr,
    modal: Pr,
    progress: xr,
    result: kr,
    slider: Ir,
    breadcrumb: Ar,
    menu: Mr,
    pagination: Fr,
    input: Dr,
    textArea: zr,
    empty: Tr,
    badge: Gr,
    radio: $r,
    rate: Rr,
    switch: Or,
    transfer: Lr,
    avatar: Hr,
    message: Wr,
    tag: Kr,
    table: Ur,
    card: Zr,
    tabs: Xr,
    timeline: mn,
    timePicker: an,
    upload: nn,
    notification: $n,
    tree: En,
    colorPicker: xn,
    datePicker: qr,
    rangePicker: tn,
    flex: gr,
    wave: Sr,
    dropdown: Nr,
    warning: jr,
    tour: Br,
    tooltip: Qr,
    popover: Jr,
    popconfirm: gn,
    floatButtonGroup: yn,
    variant: _n,
    inputNumber: In,
    treeSelect: Tn
  } = _t, kn = React.useCallback((Fn, Nn) => {
    const {
      prefixCls: Hn
    } = _t;
    if (Nn)
      return Nn;
    const wr = Hn || Jt.getPrefixCls("");
    return Fn ? `${wr}-${Fn}` : wr;
  }, [Jt.getPrefixCls, _t.prefixCls]), jn = er || Jt.iconPrefixCls || defaultIconPrefixCls, An = Pt || Jt.csp;
  useResetIconStyle(jn, An);
  const un = useTheme(tr, Jt.theme, {
    prefixCls: kn("")
  });
  browser$1.env.NODE_ENV !== "production" && (existThemeConfig = existThemeConfig || !!un);
  const rn = {
    csp: An,
    autoInsertSpaceInButton: $t,
    alert: Mt,
    anchor: Bt,
    locale: zt || Yt,
    direction: Wt,
    space: Gt,
    splitter: qt,
    virtual: Kt,
    popupMatchSelectWidth: Xt ?? Qt,
    popupOverflow: Zt,
    getPrefixCls: kn,
    iconPrefixCls: jn,
    theme: un,
    segmented: rr,
    statistic: ir,
    spin: ar,
    calendar: or,
    carousel: sr,
    cascader: lr,
    collapse: cr,
    typography: hr,
    checkbox: pr,
    descriptions: mr,
    divider: Er,
    drawer: _r,
    skeleton: yr,
    steps: ur,
    image: vr,
    input: Dr,
    textArea: zr,
    layout: dr,
    list: br,
    mentions: Cr,
    modal: Pr,
    progress: xr,
    result: kr,
    slider: Ir,
    breadcrumb: Ar,
    menu: Mr,
    pagination: Fr,
    empty: Tr,
    badge: Gr,
    radio: $r,
    rate: Rr,
    switch: Or,
    transfer: Lr,
    avatar: Hr,
    message: Wr,
    tag: Kr,
    table: Ur,
    card: Zr,
    tabs: Xr,
    timeline: mn,
    timePicker: an,
    upload: nn,
    notification: $n,
    tree: En,
    colorPicker: xn,
    datePicker: qr,
    rangePicker: tn,
    flex: gr,
    wave: Sr,
    dropdown: Nr,
    warning: jr,
    tour: Br,
    tooltip: Qr,
    popover: Jr,
    popconfirm: gn,
    floatButtonGroup: yn,
    variant: _n,
    inputNumber: In,
    treeSelect: Tn
  };
  browser$1.env.NODE_ENV !== "production" && devUseWarning("ConfigProvider")(!("autoInsertSpaceInButton" in _t), "deprecated", "`autoInsertSpaceInButton` is deprecated. Please use `{ button: { autoInsertSpace: boolean }}` instead.");
  const dn = Object.assign({}, Jt);
  Object.keys(rn).forEach((Fn) => {
    rn[Fn] !== void 0 && (dn[Fn] = rn[Fn]);
  }), PASSED_PROPS.forEach((Fn) => {
    const Nn = _t[Fn];
    Nn && (dn[Fn] = Nn);
  }), typeof $t < "u" && (dn.button = Object.assign({
    autoInsertSpace: $t
  }, dn.button));
  const Mn = useMemo(() => dn, dn, (Fn, Nn) => {
    const Hn = Object.keys(Fn), wr = Object.keys(Nn);
    return Hn.length !== wr.length || Hn.some((Vr) => Fn[Vr] !== Nn[Vr]);
  }), On = React.useMemo(() => ({
    prefixCls: jn,
    csp: An
  }), [jn, An]);
  let Dn = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(PropWarning$1, {
    dropdownMatchSelectWidth: Qt
  }), Et);
  const Yn = React.useMemo(() => {
    var Fn, Nn, Hn, wr;
    return merge$2(((Fn = localeValues.Form) === null || Fn === void 0 ? void 0 : Fn.defaultValidateMessages) || {}, ((Hn = (Nn = Mn.locale) === null || Nn === void 0 ? void 0 : Nn.Form) === null || Hn === void 0 ? void 0 : Hn.defaultValidateMessages) || {}, ((wr = Mn.form) === null || wr === void 0 ? void 0 : wr.validateMessages) || {}, (Vt == null ? void 0 : Vt.validateMessages) || {});
  }, [Mn, Vt == null ? void 0 : Vt.validateMessages]);
  Object.keys(Yn).length > 0 && (Dn = /* @__PURE__ */ React.createElement(ValidateMessagesContext.Provider, {
    value: Yn
  }, Dn)), zt && (Dn = /* @__PURE__ */ React.createElement(LocaleProvider, {
    locale: zt,
    _ANT_MARK__: ANT_MARK
  }, Dn)), (jn || An) && (Dn = /* @__PURE__ */ React.createElement(IconContext.Provider, {
    value: On
  }, Dn)), Ht && (Dn = /* @__PURE__ */ React.createElement(SizeContextProvider, {
    size: Ht
  }, Dn)), Dn = /* @__PURE__ */ React.createElement(MotionWrapper, null, Dn);
  const ra = React.useMemo(() => {
    const Fn = un || {}, {
      algorithm: Nn,
      token: Hn,
      components: wr,
      cssVar: Vr
    } = Fn, Yr = __rest$d(Fn, ["algorithm", "token", "components", "cssVar"]), cn = Nn && (!Array.isArray(Nn) || Nn.length > 0) ? createTheme(Nn) : defaultTheme, hn = {};
    Object.entries(wr || {}).forEach((pn) => {
      let [fn, Bn] = pn;
      const Rn = Object.assign({}, Bn);
      "algorithm" in Rn && (Rn.algorithm === !0 ? Rn.theme = cn : (Array.isArray(Rn.algorithm) || typeof Rn.algorithm == "function") && (Rn.theme = createTheme(Rn.algorithm)), delete Rn.algorithm), hn[fn] = Rn;
    });
    const wn = Object.assign(Object.assign({}, seedToken), Hn);
    return Object.assign(Object.assign({}, Yr), {
      theme: cn,
      token: wn,
      components: hn,
      override: Object.assign({
        override: wn
      }, hn),
      cssVar: Vr
    });
  }, [un]);
  return tr && (Dn = /* @__PURE__ */ React.createElement(DesignTokenContext.Provider, {
    value: ra
  }, Dn)), Mn.warning && (Dn = /* @__PURE__ */ React.createElement(WarningContext.Provider, {
    value: Mn.warning
  }, Dn)), nr !== void 0 && (Dn = /* @__PURE__ */ React.createElement(DisabledContextProvider, {
    disabled: nr
  }, Dn)), /* @__PURE__ */ React.createElement(ConfigContext.Provider, {
    value: Mn
  }, Dn);
}, ConfigProvider = (_t) => {
  const Et = React.useContext(ConfigContext), Pt = React.useContext(LocaleContext);
  return /* @__PURE__ */ React.createElement(ProviderChildren, Object.assign({
    parentContext: Et,
    legacyLocale: Pt
  }, _t));
};
ConfigProvider.ConfigContext = ConfigContext;
ConfigProvider.SizeContext = SizeContext;
ConfigProvider.config = setGlobalConfig;
ConfigProvider.useConfig = useConfig;
Object.defineProperty(ConfigProvider, "SizeContext", {
  get: () => (browser$1.env.NODE_ENV !== "production" && warning$1(!1, "ConfigProvider", "ConfigProvider.SizeContext is deprecated. Please use `ConfigProvider.useConfig().componentSize` instead."), SizeContext)
});
browser$1.env.NODE_ENV !== "production" && (ConfigProvider.displayName = "ConfigProvider");
var attributes = `accept acceptCharset accessKey action allowFullScreen allowTransparency
    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge
    charSet checked classID className colSpan cols content contentEditable contextMenu
    controls coords crossOrigin data dateTime default defer dir disabled download draggable
    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder
    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity
    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media
    mediaGroup method min minLength multiple muted name noValidate nonce open
    optimum pattern placeholder poster preload radioGroup readOnly rel required
    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected
    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style
    summary tabIndex target title type useMap value width wmode wrap`, eventsName = `onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown
    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick
    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown
    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel
    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough
    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata
    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError`, propList = "".concat(attributes, " ").concat(eventsName).split(/[\s\n]+/), ariaPrefix = "aria-", dataPrefix = "data-";
function match(_t, Et) {
  return _t.indexOf(Et) === 0;
}
function pickAttrs(_t) {
  var Et = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, Pt;
  Et === !1 ? Pt = {
    aria: !0,
    data: !0,
    attr: !0
  } : Et === !0 ? Pt = {
    aria: !0
  } : Pt = _objectSpread2({}, Et);
  var $t = {};
  return Object.keys(_t).forEach(function(Mt) {
    // Aria
    (Pt.aria && (Mt === "role" || match(Mt, ariaPrefix)) || // Data
    Pt.data && match(Mt, dataPrefix) || // Attr
    Pt.attr && propList.includes(Mt)) && ($t[Mt] = _t[Mt]);
  }), $t;
}
function isFragment(_t) {
  return _t && /* @__PURE__ */ React__default.isValidElement(_t) && _t.type === React__default.Fragment;
}
const replaceElement = (_t, Et, Pt) => /* @__PURE__ */ React__default.isValidElement(_t) ? /* @__PURE__ */ React__default.cloneElement(_t, typeof Pt == "function" ? Pt(_t.props || {}) : Pt) : Et;
function cloneElement(_t, Et) {
  return replaceElement(_t, _t, Et);
}
const useCSSVarCls = (_t) => {
  const [, , , , Et] = useToken();
  return Et ? `${_t}-css-var` : "";
};
var KeyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,
  // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33,
  // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,
  // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35,
  // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36,
  // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST
  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40,
  // also NUM_SOUTH
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45,
  // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46,
  // also NUM_DELETE
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,
  // needs localization
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91,
  // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  // needs localization
  /**
   * DASH
   */
  DASH: 189,
  // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187,
  // needs localization
  /**
   * COMMA
   */
  COMMA: 188,
  // needs localization
  /**
   * PERIOD
   */
  PERIOD: 190,
  // needs localization
  /**
   * SLASH
   */
  SLASH: 191,
  // needs localization
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,
  // needs localization
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,
  // needs localization
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,
  // needs localization
  /**
   * BACKSLASH
   */
  BACKSLASH: 220,
  // needs localization
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,
  // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,
  // Firefox (Gecko) fires this for the meta key instead of 91
  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================
  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function(Et) {
    var Pt = Et.keyCode;
    if (Et.altKey && !Et.ctrlKey || Et.metaKey || // Function keys don't generate text
    Pt >= KeyCode.F1 && Pt <= KeyCode.F12)
      return !1;
    switch (Pt) {
      case KeyCode.ALT:
      case KeyCode.CAPS_LOCK:
      case KeyCode.CONTEXT_MENU:
      case KeyCode.CTRL:
      case KeyCode.DOWN:
      case KeyCode.END:
      case KeyCode.ESC:
      case KeyCode.HOME:
      case KeyCode.INSERT:
      case KeyCode.LEFT:
      case KeyCode.MAC_FF_META:
      case KeyCode.META:
      case KeyCode.NUMLOCK:
      case KeyCode.NUM_CENTER:
      case KeyCode.PAGE_DOWN:
      case KeyCode.PAGE_UP:
      case KeyCode.PAUSE:
      case KeyCode.PRINT_SCREEN:
      case KeyCode.RIGHT:
      case KeyCode.SHIFT:
      case KeyCode.UP:
      case KeyCode.WIN_KEY:
      case KeyCode.WIN_KEY_RIGHT:
        return !1;
      default:
        return !0;
    }
  },
  /**
   * whether character is entered.
   */
  isCharacterKey: function(Et) {
    if (Et >= KeyCode.ZERO && Et <= KeyCode.NINE || Et >= KeyCode.NUM_ZERO && Et <= KeyCode.NUM_MULTIPLY || Et >= KeyCode.A && Et <= KeyCode.Z || window.navigator.userAgent.indexOf("WebKit") !== -1 && Et === 0)
      return !0;
    switch (Et) {
      case KeyCode.SPACE:
      case KeyCode.QUESTION_MARK:
      case KeyCode.NUM_PLUS:
      case KeyCode.NUM_MINUS:
      case KeyCode.NUM_PERIOD:
      case KeyCode.NUM_DIVISION:
      case KeyCode.SEMICOLON:
      case KeyCode.DASH:
      case KeyCode.EQUALS:
      case KeyCode.COMMA:
      case KeyCode.PERIOD:
      case KeyCode.SLASH:
      case KeyCode.APOSTROPHE:
      case KeyCode.SINGLE_QUOTE:
      case KeyCode.OPEN_SQUARE_BRACKET:
      case KeyCode.BACKSLASH:
      case KeyCode.CLOSE_SQUARE_BRACKET:
        return !0;
      default:
        return !1;
    }
  }
}, Notify = /* @__PURE__ */ React.forwardRef(function(_t, Et) {
  var Pt = _t.prefixCls, $t = _t.style, Mt = _t.className, Bt = _t.duration, Vt = Bt === void 0 ? 4.5 : Bt, zt = _t.showProgress, Ht = _t.pauseOnHover, Wt = Ht === void 0 ? !0 : Ht, Gt = _t.eventKey, qt = _t.content, Kt = _t.closable, Qt = _t.closeIcon, Xt = Qt === void 0 ? "x" : Qt, Zt = _t.props, Yt = _t.onClick, Jt = _t.onNoticeClose, er = _t.times, tr = _t.hovering, nr = React.useState(!1), rr = _slicedToArray(nr, 2), ir = rr[0], ar = rr[1], or = React.useState(0), sr = _slicedToArray(or, 2), lr = sr[0], cr = sr[1], hr = React.useState(0), pr = _slicedToArray(hr, 2), mr = pr[0], Er = pr[1], _r = tr || ir, yr = Vt > 0 && zt, ur = function() {
    Jt(Gt);
  }, vr = function(kr) {
    (kr.key === "Enter" || kr.code === "Enter" || kr.keyCode === KeyCode.ENTER) && ur();
  };
  React.useEffect(function() {
    if (!_r && Vt > 0) {
      var xr = Date.now() - mr, kr = setTimeout(function() {
        ur();
      }, Vt * 1e3 - mr);
      return function() {
        Wt && clearTimeout(kr), Er(Date.now() - xr);
      };
    }
  }, [Vt, _r, er]), React.useEffect(function() {
    if (!_r && yr && (Wt || mr === 0)) {
      var xr = performance.now(), kr, Ir = function Ar() {
        cancelAnimationFrame(kr), kr = requestAnimationFrame(function(Mr) {
          var Fr = Mr + mr - xr, Dr = Math.min(Fr / (Vt * 1e3), 1);
          cr(Dr * 100), Dr < 1 && Ar();
        });
      };
      return Ir(), function() {
        Wt && cancelAnimationFrame(kr);
      };
    }
  }, [Vt, mr, _r, yr, er]);
  var dr = React.useMemo(function() {
    return _typeof(Kt) === "object" && Kt !== null ? Kt : Kt ? {
      closeIcon: Xt
    } : {};
  }, [Kt, Xt]), br = pickAttrs(dr, !0), Cr = 100 - (!lr || lr < 0 ? 0 : lr > 100 ? 100 : lr), Pr = "".concat(Pt, "-notice");
  return /* @__PURE__ */ React.createElement("div", _extends$2({}, Zt, {
    ref: Et,
    className: classNames(Pr, Mt, _defineProperty({}, "".concat(Pr, "-closable"), Kt)),
    style: $t,
    onMouseEnter: function(kr) {
      var Ir;
      ar(!0), Zt == null || (Ir = Zt.onMouseEnter) === null || Ir === void 0 || Ir.call(Zt, kr);
    },
    onMouseLeave: function(kr) {
      var Ir;
      ar(!1), Zt == null || (Ir = Zt.onMouseLeave) === null || Ir === void 0 || Ir.call(Zt, kr);
    },
    onClick: Yt
  }), /* @__PURE__ */ React.createElement("div", {
    className: "".concat(Pr, "-content")
  }, qt), Kt && /* @__PURE__ */ React.createElement("a", _extends$2({
    tabIndex: 0,
    className: "".concat(Pr, "-close"),
    onKeyDown: vr,
    "aria-label": "Close"
  }, br, {
    onClick: function(kr) {
      kr.preventDefault(), kr.stopPropagation(), ur();
    }
  }), dr.closeIcon), yr && /* @__PURE__ */ React.createElement("progress", {
    className: "".concat(Pr, "-progress"),
    max: "100",
    value: Cr
  }, Cr + "%"));
}), NotificationContext = /* @__PURE__ */ React__default.createContext({}), NotificationProvider = function(Et) {
  var Pt = Et.children, $t = Et.classNames;
  return /* @__PURE__ */ React__default.createElement(NotificationContext.Provider, {
    value: {
      classNames: $t
    }
  }, Pt);
}, DEFAULT_OFFSET$1 = 8, DEFAULT_THRESHOLD = 3, DEFAULT_GAP = 16, useStack = function(Et) {
  var Pt = {
    offset: DEFAULT_OFFSET$1,
    threshold: DEFAULT_THRESHOLD,
    gap: DEFAULT_GAP
  };
  if (Et && _typeof(Et) === "object") {
    var $t, Mt, Bt;
    Pt.offset = ($t = Et.offset) !== null && $t !== void 0 ? $t : DEFAULT_OFFSET$1, Pt.threshold = (Mt = Et.threshold) !== null && Mt !== void 0 ? Mt : DEFAULT_THRESHOLD, Pt.gap = (Bt = Et.gap) !== null && Bt !== void 0 ? Bt : DEFAULT_GAP;
  }
  return [!!Et, Pt];
}, _excluded$m = ["className", "style", "classNames", "styles"], NoticeList = function(Et) {
  var Pt = Et.configList, $t = Et.placement, Mt = Et.prefixCls, Bt = Et.className, Vt = Et.style, zt = Et.motion, Ht = Et.onAllNoticeRemoved, Wt = Et.onNoticeClose, Gt = Et.stack, qt = useContext(NotificationContext), Kt = qt.classNames, Qt = useRef({}), Xt = useState(null), Zt = _slicedToArray(Xt, 2), Yt = Zt[0], Jt = Zt[1], er = useState([]), tr = _slicedToArray(er, 2), nr = tr[0], rr = tr[1], ir = Pt.map(function(_r) {
    return {
      config: _r,
      key: String(_r.key)
    };
  }), ar = useStack(Gt), or = _slicedToArray(ar, 2), sr = or[0], lr = or[1], cr = lr.offset, hr = lr.threshold, pr = lr.gap, mr = sr && (nr.length > 0 || ir.length <= hr), Er = typeof zt == "function" ? zt($t) : zt;
  return useEffect(function() {
    sr && nr.length > 1 && rr(function(_r) {
      return _r.filter(function(yr) {
        return ir.some(function(ur) {
          var vr = ur.key;
          return yr === vr;
        });
      });
    });
  }, [nr, ir, sr]), useEffect(function() {
    var _r;
    if (sr && Qt.current[(_r = ir[ir.length - 1]) === null || _r === void 0 ? void 0 : _r.key]) {
      var yr;
      Jt(Qt.current[(yr = ir[ir.length - 1]) === null || yr === void 0 ? void 0 : yr.key]);
    }
  }, [ir, sr]), /* @__PURE__ */ React__default.createElement(CSSMotionList, _extends$2({
    key: $t,
    className: classNames(Mt, "".concat(Mt, "-").concat($t), Kt == null ? void 0 : Kt.list, Bt, _defineProperty(_defineProperty({}, "".concat(Mt, "-stack"), !!sr), "".concat(Mt, "-stack-expanded"), mr)),
    style: Vt,
    keys: ir,
    motionAppear: !0
  }, Er, {
    onAllRemoved: function() {
      Ht($t);
    }
  }), function(_r, yr) {
    var ur = _r.config, vr = _r.className, dr = _r.style, br = _r.index, Cr = ur, Pr = Cr.key, xr = Cr.times, kr = String(Pr), Ir = ur, Ar = Ir.className, Mr = Ir.style, Fr = Ir.classNames, Dr = Ir.styles, zr = _objectWithoutProperties$2(Ir, _excluded$m), Tr = ir.findIndex(function(mn) {
      return mn.key === kr;
    }), Gr = {};
    if (sr) {
      var $r = ir.length - 1 - (Tr > -1 ? Tr : br - 1), Rr = $t === "top" || $t === "bottom" ? "-50%" : "0";
      if ($r > 0) {
        var Or, Lr, Hr;
        Gr.height = mr ? (Or = Qt.current[kr]) === null || Or === void 0 ? void 0 : Or.offsetHeight : Yt == null ? void 0 : Yt.offsetHeight;
        for (var Wr = 0, Kr = 0; Kr < $r; Kr++) {
          var Ur;
          Wr += ((Ur = Qt.current[ir[ir.length - 1 - Kr].key]) === null || Ur === void 0 ? void 0 : Ur.offsetHeight) + pr;
        }
        var Zr = (mr ? Wr : $r * cr) * ($t.startsWith("top") ? 1 : -1), Xr = !mr && Yt !== null && Yt !== void 0 && Yt.offsetWidth && (Lr = Qt.current[kr]) !== null && Lr !== void 0 && Lr.offsetWidth ? ((Yt == null ? void 0 : Yt.offsetWidth) - cr * 2 * ($r < 3 ? $r : 3)) / ((Hr = Qt.current[kr]) === null || Hr === void 0 ? void 0 : Hr.offsetWidth) : 1;
        Gr.transform = "translate3d(".concat(Rr, ", ").concat(Zr, "px, 0) scaleX(").concat(Xr, ")");
      } else
        Gr.transform = "translate3d(".concat(Rr, ", 0, 0)");
    }
    return /* @__PURE__ */ React__default.createElement("div", {
      ref: yr,
      className: classNames("".concat(Mt, "-notice-wrapper"), vr, Fr == null ? void 0 : Fr.wrapper),
      style: _objectSpread2(_objectSpread2(_objectSpread2({}, dr), Gr), Dr == null ? void 0 : Dr.wrapper),
      onMouseEnter: function() {
        return rr(function(an) {
          return an.includes(kr) ? an : [].concat(_toConsumableArray(an), [kr]);
        });
      },
      onMouseLeave: function() {
        return rr(function(an) {
          return an.filter(function(nn) {
            return nn !== kr;
          });
        });
      }
    }, /* @__PURE__ */ React__default.createElement(Notify, _extends$2({}, zr, {
      ref: function(an) {
        Tr > -1 ? Qt.current[kr] = an : delete Qt.current[kr];
      },
      prefixCls: Mt,
      classNames: Fr,
      styles: Dr,
      className: classNames(Ar, Kt == null ? void 0 : Kt.notice),
      style: Mr,
      times: xr,
      key: Pr,
      eventKey: Pr,
      onNoticeClose: Wt,
      hovering: sr && nr.length > 0
    })));
  });
};
browser$1.env.NODE_ENV !== "production" && (NoticeList.displayName = "NoticeList");
var Notifications = /* @__PURE__ */ React.forwardRef(function(_t, Et) {
  var Pt = _t.prefixCls, $t = Pt === void 0 ? "rc-notification" : Pt, Mt = _t.container, Bt = _t.motion, Vt = _t.maxCount, zt = _t.className, Ht = _t.style, Wt = _t.onAllRemoved, Gt = _t.stack, qt = _t.renderNotifications, Kt = React.useState([]), Qt = _slicedToArray(Kt, 2), Xt = Qt[0], Zt = Qt[1], Yt = function(sr) {
    var lr, cr = Xt.find(function(hr) {
      return hr.key === sr;
    });
    cr == null || (lr = cr.onClose) === null || lr === void 0 || lr.call(cr), Zt(function(hr) {
      return hr.filter(function(pr) {
        return pr.key !== sr;
      });
    });
  };
  React.useImperativeHandle(Et, function() {
    return {
      open: function(sr) {
        Zt(function(lr) {
          var cr = _toConsumableArray(lr), hr = cr.findIndex(function(Er) {
            return Er.key === sr.key;
          }), pr = _objectSpread2({}, sr);
          if (hr >= 0) {
            var mr;
            pr.times = (((mr = lr[hr]) === null || mr === void 0 ? void 0 : mr.times) || 0) + 1, cr[hr] = pr;
          } else
            pr.times = 0, cr.push(pr);
          return Vt > 0 && cr.length > Vt && (cr = cr.slice(-Vt)), cr;
        });
      },
      close: function(sr) {
        Yt(sr);
      },
      destroy: function() {
        Zt([]);
      }
    };
  });
  var Jt = React.useState({}), er = _slicedToArray(Jt, 2), tr = er[0], nr = er[1];
  React.useEffect(function() {
    var or = {};
    Xt.forEach(function(sr) {
      var lr = sr.placement, cr = lr === void 0 ? "topRight" : lr;
      cr && (or[cr] = or[cr] || [], or[cr].push(sr));
    }), Object.keys(tr).forEach(function(sr) {
      or[sr] = or[sr] || [];
    }), nr(or);
  }, [Xt]);
  var rr = function(sr) {
    nr(function(lr) {
      var cr = _objectSpread2({}, lr), hr = cr[sr] || [];
      return hr.length || delete cr[sr], cr;
    });
  }, ir = React.useRef(!1);
  if (React.useEffect(function() {
    Object.keys(tr).length > 0 ? ir.current = !0 : ir.current && (Wt == null || Wt(), ir.current = !1);
  }, [tr]), !Mt)
    return null;
  var ar = Object.keys(tr);
  return /* @__PURE__ */ createPortal(/* @__PURE__ */ React.createElement(React.Fragment, null, ar.map(function(or) {
    var sr = tr[or], lr = /* @__PURE__ */ React.createElement(NoticeList, {
      key: or,
      configList: sr,
      placement: or,
      prefixCls: $t,
      className: zt == null ? void 0 : zt(or),
      style: Ht == null ? void 0 : Ht(or),
      motion: Bt,
      onNoticeClose: Yt,
      onAllNoticeRemoved: rr,
      stack: Gt
    });
    return qt ? qt(lr, {
      prefixCls: $t,
      key: or
    }) : lr;
  })), Mt);
});
browser$1.env.NODE_ENV !== "production" && (Notifications.displayName = "Notifications");
var _excluded$l = ["getContainer", "motion", "prefixCls", "maxCount", "className", "style", "onAllRemoved", "stack", "renderNotifications"], defaultGetContainer = function() {
  return document.body;
}, uniqueKey = 0;
function mergeConfig$1() {
  for (var _t = {}, Et = arguments.length, Pt = new Array(Et), $t = 0; $t < Et; $t++)
    Pt[$t] = arguments[$t];
  return Pt.forEach(function(Mt) {
    Mt && Object.keys(Mt).forEach(function(Bt) {
      var Vt = Mt[Bt];
      Vt !== void 0 && (_t[Bt] = Vt);
    });
  }), _t;
}
function useNotification$1() {
  var _t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, Et = _t.getContainer, Pt = Et === void 0 ? defaultGetContainer : Et, $t = _t.motion, Mt = _t.prefixCls, Bt = _t.maxCount, Vt = _t.className, zt = _t.style, Ht = _t.onAllRemoved, Wt = _t.stack, Gt = _t.renderNotifications, qt = _objectWithoutProperties$2(_t, _excluded$l), Kt = React.useState(), Qt = _slicedToArray(Kt, 2), Xt = Qt[0], Zt = Qt[1], Yt = React.useRef(), Jt = /* @__PURE__ */ React.createElement(Notifications, {
    container: Xt,
    ref: Yt,
    prefixCls: Mt,
    motion: $t,
    maxCount: Bt,
    className: Vt,
    style: zt,
    onAllRemoved: Ht,
    stack: Wt,
    renderNotifications: Gt
  }), er = React.useState([]), tr = _slicedToArray(er, 2), nr = tr[0], rr = tr[1], ir = React.useMemo(function() {
    return {
      open: function(or) {
        var sr = mergeConfig$1(qt, or);
        (sr.key === null || sr.key === void 0) && (sr.key = "rc-notification-".concat(uniqueKey), uniqueKey += 1), rr(function(lr) {
          return [].concat(_toConsumableArray(lr), [{
            type: "open",
            config: sr
          }]);
        });
      },
      close: function(or) {
        rr(function(sr) {
          return [].concat(_toConsumableArray(sr), [{
            type: "close",
            key: or
          }]);
        });
      },
      destroy: function() {
        rr(function(or) {
          return [].concat(_toConsumableArray(or), [{
            type: "destroy"
          }]);
        });
      }
    };
  }, []);
  return React.useEffect(function() {
    Zt(Pt());
  }), React.useEffect(function() {
    Yt.current && nr.length && (nr.forEach(function(ar) {
      switch (ar.type) {
        case "open":
          Yt.current.open(ar.config);
          break;
        case "close":
          Yt.current.close(ar.key);
          break;
        case "destroy":
          Yt.current.destroy();
          break;
      }
    }), rr(function(ar) {
      return ar.filter(function(or) {
        return !nr.includes(or);
      });
    }));
  }, [nr]), [ir, Jt];
}
const zIndexContext = /* @__PURE__ */ React__default.createContext(void 0);
browser$1.env.NODE_ENV !== "production" && (zIndexContext.displayName = "zIndexContext");
const CONTAINER_OFFSET = 100, CONTAINER_OFFSET_MAX_COUNT = 10, CONTAINER_MAX_OFFSET = CONTAINER_OFFSET * CONTAINER_OFFSET_MAX_COUNT, CONTAINER_MAX_OFFSET_WITH_CHILDREN = CONTAINER_MAX_OFFSET + CONTAINER_OFFSET, containerBaseZIndexOffset = {
  Modal: CONTAINER_OFFSET,
  Drawer: CONTAINER_OFFSET,
  Popover: CONTAINER_OFFSET,
  Popconfirm: CONTAINER_OFFSET,
  Tooltip: CONTAINER_OFFSET,
  Tour: CONTAINER_OFFSET,
  FloatButton: CONTAINER_OFFSET
}, consumerBaseZIndexOffset = {
  SelectLike: 50,
  Dropdown: 50,
  DatePicker: 50,
  Menu: 50,
  ImagePreview: 1
};
function isContainerType(_t) {
  return _t in containerBaseZIndexOffset;
}
const useZIndex = (_t, Et) => {
  const [, Pt] = useToken(), $t = React__default.useContext(zIndexContext), Mt = isContainerType(_t);
  let Bt;
  if (Et !== void 0)
    Bt = [Et, Et];
  else {
    let Vt = $t ?? 0;
    Mt ? Vt += // Use preset token zIndex by default but not stack when has parent container
    ($t ? 0 : Pt.zIndexPopupBase) + // Container offset
    containerBaseZIndexOffset[_t] : Vt += consumerBaseZIndexOffset[_t], Bt = [$t === void 0 ? Et : Vt, Vt];
  }
  if (browser$1.env.NODE_ENV !== "production") {
    const Vt = devUseWarning(_t), zt = Pt.zIndexPopupBase + CONTAINER_MAX_OFFSET_WITH_CHILDREN, Ht = Bt[0] || 0;
    browser$1.env.NODE_ENV !== "production" && Vt(Et !== void 0 || Ht <= zt, "usage", "`zIndex` is over design token `zIndexPopupBase` too much. It may cause unexpected override.");
  }
  return Bt;
};
function usePatchElement() {
  const [_t, Et] = React.useState([]), Pt = React.useCallback(($t) => (Et((Mt) => [].concat(_toConsumableArray(Mt), [$t])), () => {
    Et((Mt) => Mt.filter((Bt) => Bt !== $t));
  }), []);
  return [_t, Pt];
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function() {
    return Et;
  };
  var _t, Et = {}, Pt = Object.prototype, $t = Pt.hasOwnProperty, Mt = Object.defineProperty || function(_r, yr, ur) {
    _r[yr] = ur.value;
  }, Bt = typeof Symbol == "function" ? Symbol : {}, Vt = Bt.iterator || "@@iterator", zt = Bt.asyncIterator || "@@asyncIterator", Ht = Bt.toStringTag || "@@toStringTag";
  function Wt(_r, yr, ur) {
    return Object.defineProperty(_r, yr, {
      value: ur,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), _r[yr];
  }
  try {
    Wt({}, "");
  } catch {
    Wt = function(ur, vr, dr) {
      return ur[vr] = dr;
    };
  }
  function Gt(_r, yr, ur, vr) {
    var dr = yr && yr.prototype instanceof Jt ? yr : Jt, br = Object.create(dr.prototype), Cr = new mr(vr || []);
    return Mt(br, "_invoke", {
      value: lr(_r, ur, Cr)
    }), br;
  }
  function qt(_r, yr, ur) {
    try {
      return {
        type: "normal",
        arg: _r.call(yr, ur)
      };
    } catch (vr) {
      return {
        type: "throw",
        arg: vr
      };
    }
  }
  Et.wrap = Gt;
  var Kt = "suspendedStart", Qt = "suspendedYield", Xt = "executing", Zt = "completed", Yt = {};
  function Jt() {
  }
  function er() {
  }
  function tr() {
  }
  var nr = {};
  Wt(nr, Vt, function() {
    return this;
  });
  var rr = Object.getPrototypeOf, ir = rr && rr(rr(Er([])));
  ir && ir !== Pt && $t.call(ir, Vt) && (nr = ir);
  var ar = tr.prototype = Jt.prototype = Object.create(nr);
  function or(_r) {
    ["next", "throw", "return"].forEach(function(yr) {
      Wt(_r, yr, function(ur) {
        return this._invoke(yr, ur);
      });
    });
  }
  function sr(_r, yr) {
    function ur(dr, br, Cr, Pr) {
      var xr = qt(_r[dr], _r, br);
      if (xr.type !== "throw") {
        var kr = xr.arg, Ir = kr.value;
        return Ir && _typeof(Ir) == "object" && $t.call(Ir, "__await") ? yr.resolve(Ir.__await).then(function(Ar) {
          ur("next", Ar, Cr, Pr);
        }, function(Ar) {
          ur("throw", Ar, Cr, Pr);
        }) : yr.resolve(Ir).then(function(Ar) {
          kr.value = Ar, Cr(kr);
        }, function(Ar) {
          return ur("throw", Ar, Cr, Pr);
        });
      }
      Pr(xr.arg);
    }
    var vr;
    Mt(this, "_invoke", {
      value: function(br, Cr) {
        function Pr() {
          return new yr(function(xr, kr) {
            ur(br, Cr, xr, kr);
          });
        }
        return vr = vr ? vr.then(Pr, Pr) : Pr();
      }
    });
  }
  function lr(_r, yr, ur) {
    var vr = Kt;
    return function(dr, br) {
      if (vr === Xt)
        throw Error("Generator is already running");
      if (vr === Zt) {
        if (dr === "throw")
          throw br;
        return {
          value: _t,
          done: !0
        };
      }
      for (ur.method = dr, ur.arg = br; ; ) {
        var Cr = ur.delegate;
        if (Cr) {
          var Pr = cr(Cr, ur);
          if (Pr) {
            if (Pr === Yt)
              continue;
            return Pr;
          }
        }
        if (ur.method === "next")
          ur.sent = ur._sent = ur.arg;
        else if (ur.method === "throw") {
          if (vr === Kt)
            throw vr = Zt, ur.arg;
          ur.dispatchException(ur.arg);
        } else
          ur.method === "return" && ur.abrupt("return", ur.arg);
        vr = Xt;
        var xr = qt(_r, yr, ur);
        if (xr.type === "normal") {
          if (vr = ur.done ? Zt : Qt, xr.arg === Yt)
            continue;
          return {
            value: xr.arg,
            done: ur.done
          };
        }
        xr.type === "throw" && (vr = Zt, ur.method = "throw", ur.arg = xr.arg);
      }
    };
  }
  function cr(_r, yr) {
    var ur = yr.method, vr = _r.iterator[ur];
    if (vr === _t)
      return yr.delegate = null, ur === "throw" && _r.iterator.return && (yr.method = "return", yr.arg = _t, cr(_r, yr), yr.method === "throw") || ur !== "return" && (yr.method = "throw", yr.arg = new TypeError("The iterator does not provide a '" + ur + "' method")), Yt;
    var dr = qt(vr, _r.iterator, yr.arg);
    if (dr.type === "throw")
      return yr.method = "throw", yr.arg = dr.arg, yr.delegate = null, Yt;
    var br = dr.arg;
    return br ? br.done ? (yr[_r.resultName] = br.value, yr.next = _r.nextLoc, yr.method !== "return" && (yr.method = "next", yr.arg = _t), yr.delegate = null, Yt) : br : (yr.method = "throw", yr.arg = new TypeError("iterator result is not an object"), yr.delegate = null, Yt);
  }
  function hr(_r) {
    var yr = {
      tryLoc: _r[0]
    };
    1 in _r && (yr.catchLoc = _r[1]), 2 in _r && (yr.finallyLoc = _r[2], yr.afterLoc = _r[3]), this.tryEntries.push(yr);
  }
  function pr(_r) {
    var yr = _r.completion || {};
    yr.type = "normal", delete yr.arg, _r.completion = yr;
  }
  function mr(_r) {
    this.tryEntries = [{
      tryLoc: "root"
    }], _r.forEach(hr, this), this.reset(!0);
  }
  function Er(_r) {
    if (_r || _r === "") {
      var yr = _r[Vt];
      if (yr)
        return yr.call(_r);
      if (typeof _r.next == "function")
        return _r;
      if (!isNaN(_r.length)) {
        var ur = -1, vr = function dr() {
          for (; ++ur < _r.length; )
            if ($t.call(_r, ur))
              return dr.value = _r[ur], dr.done = !1, dr;
          return dr.value = _t, dr.done = !0, dr;
        };
        return vr.next = vr;
      }
    }
    throw new TypeError(_typeof(_r) + " is not iterable");
  }
  return er.prototype = tr, Mt(ar, "constructor", {
    value: tr,
    configurable: !0
  }), Mt(tr, "constructor", {
    value: er,
    configurable: !0
  }), er.displayName = Wt(tr, Ht, "GeneratorFunction"), Et.isGeneratorFunction = function(_r) {
    var yr = typeof _r == "function" && _r.constructor;
    return !!yr && (yr === er || (yr.displayName || yr.name) === "GeneratorFunction");
  }, Et.mark = function(_r) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(_r, tr) : (_r.__proto__ = tr, Wt(_r, Ht, "GeneratorFunction")), _r.prototype = Object.create(ar), _r;
  }, Et.awrap = function(_r) {
    return {
      __await: _r
    };
  }, or(sr.prototype), Wt(sr.prototype, zt, function() {
    return this;
  }), Et.AsyncIterator = sr, Et.async = function(_r, yr, ur, vr, dr) {
    dr === void 0 && (dr = Promise);
    var br = new sr(Gt(_r, yr, ur, vr), dr);
    return Et.isGeneratorFunction(yr) ? br : br.next().then(function(Cr) {
      return Cr.done ? Cr.value : br.next();
    });
  }, or(ar), Wt(ar, Ht, "Generator"), Wt(ar, Vt, function() {
    return this;
  }), Wt(ar, "toString", function() {
    return "[object Generator]";
  }), Et.keys = function(_r) {
    var yr = Object(_r), ur = [];
    for (var vr in yr)
      ur.push(vr);
    return ur.reverse(), function dr() {
      for (; ur.length; ) {
        var br = ur.pop();
        if (br in yr)
          return dr.value = br, dr.done = !1, dr;
      }
      return dr.done = !0, dr;
    };
  }, Et.values = Er, mr.prototype = {
    constructor: mr,
    reset: function(yr) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = _t, this.done = !1, this.delegate = null, this.method = "next", this.arg = _t, this.tryEntries.forEach(pr), !yr)
        for (var ur in this)
          ur.charAt(0) === "t" && $t.call(this, ur) && !isNaN(+ur.slice(1)) && (this[ur] = _t);
    },
    stop: function() {
      this.done = !0;
      var yr = this.tryEntries[0].completion;
      if (yr.type === "throw")
        throw yr.arg;
      return this.rval;
    },
    dispatchException: function(yr) {
      if (this.done)
        throw yr;
      var ur = this;
      function vr(kr, Ir) {
        return Cr.type = "throw", Cr.arg = yr, ur.next = kr, Ir && (ur.method = "next", ur.arg = _t), !!Ir;
      }
      for (var dr = this.tryEntries.length - 1; dr >= 0; --dr) {
        var br = this.tryEntries[dr], Cr = br.completion;
        if (br.tryLoc === "root")
          return vr("end");
        if (br.tryLoc <= this.prev) {
          var Pr = $t.call(br, "catchLoc"), xr = $t.call(br, "finallyLoc");
          if (Pr && xr) {
            if (this.prev < br.catchLoc)
              return vr(br.catchLoc, !0);
            if (this.prev < br.finallyLoc)
              return vr(br.finallyLoc);
          } else if (Pr) {
            if (this.prev < br.catchLoc)
              return vr(br.catchLoc, !0);
          } else {
            if (!xr)
              throw Error("try statement without catch or finally");
            if (this.prev < br.finallyLoc)
              return vr(br.finallyLoc);
          }
        }
      }
    },
    abrupt: function(yr, ur) {
      for (var vr = this.tryEntries.length - 1; vr >= 0; --vr) {
        var dr = this.tryEntries[vr];
        if (dr.tryLoc <= this.prev && $t.call(dr, "finallyLoc") && this.prev < dr.finallyLoc) {
          var br = dr;
          break;
        }
      }
      br && (yr === "break" || yr === "continue") && br.tryLoc <= ur && ur <= br.finallyLoc && (br = null);
      var Cr = br ? br.completion : {};
      return Cr.type = yr, Cr.arg = ur, br ? (this.method = "next", this.next = br.finallyLoc, Yt) : this.complete(Cr);
    },
    complete: function(yr, ur) {
      if (yr.type === "throw")
        throw yr.arg;
      return yr.type === "break" || yr.type === "continue" ? this.next = yr.arg : yr.type === "return" ? (this.rval = this.arg = yr.arg, this.method = "return", this.next = "end") : yr.type === "normal" && ur && (this.next = ur), Yt;
    },
    finish: function(yr) {
      for (var ur = this.tryEntries.length - 1; ur >= 0; --ur) {
        var vr = this.tryEntries[ur];
        if (vr.finallyLoc === yr)
          return this.complete(vr.completion, vr.afterLoc), pr(vr), Yt;
      }
    },
    catch: function(yr) {
      for (var ur = this.tryEntries.length - 1; ur >= 0; --ur) {
        var vr = this.tryEntries[ur];
        if (vr.tryLoc === yr) {
          var dr = vr.completion;
          if (dr.type === "throw") {
            var br = dr.arg;
            pr(vr);
          }
          return br;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function(yr, ur, vr) {
      return this.delegate = {
        iterator: Er(yr),
        resultName: ur,
        nextLoc: vr
      }, this.method === "next" && (this.arg = _t), Yt;
    }
  }, Et;
}
function asyncGeneratorStep(_t, Et, Pt, $t, Mt, Bt, Vt) {
  try {
    var zt = _t[Bt](Vt), Ht = zt.value;
  } catch (Wt) {
    return void Pt(Wt);
  }
  zt.done ? Et(Ht) : Promise.resolve(Ht).then($t, Mt);
}
function _asyncToGenerator(_t) {
  return function() {
    var Et = this, Pt = arguments;
    return new Promise(function($t, Mt) {
      var Bt = _t.apply(Et, Pt);
      function Vt(Ht) {
        asyncGeneratorStep(Bt, $t, Mt, Vt, zt, "next", Ht);
      }
      function zt(Ht) {
        asyncGeneratorStep(Bt, $t, Mt, Vt, zt, "throw", Ht);
      }
      Vt(void 0);
    });
  };
}
var fullClone = _objectSpread2({}, ReactDOM), version = fullClone.version, reactRender = fullClone.render, unmountComponentAtNode = fullClone.unmountComponentAtNode, createRoot;
try {
  var mainVersion = Number((version || "").split(".")[0]);
  mainVersion >= 18 && (createRoot = fullClone.createRoot);
} catch {
}
function toggleWarning(_t) {
  var Et = fullClone.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  Et && _typeof(Et) === "object" && (Et.usingClientEntryPoint = _t);
}
var MARK = "__rc_react_root__";
function modernRender(_t, Et) {
  toggleWarning(!0);
  var Pt = Et[MARK] || createRoot(Et);
  toggleWarning(!1), Pt.render(_t), Et[MARK] = Pt;
}
function legacyRender(_t, Et) {
  reactRender == null || reactRender(_t, Et);
}
function render(_t, Et) {
  if (createRoot) {
    modernRender(_t, Et);
    return;
  }
  legacyRender(_t, Et);
}
function modernUnmount(_t) {
  return _modernUnmount.apply(this, arguments);
}
function _modernUnmount() {
  return _modernUnmount = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _t(Et) {
    return _regeneratorRuntime().wrap(function($t) {
      for (; ; )
        switch ($t.prev = $t.next) {
          case 0:
            return $t.abrupt("return", Promise.resolve().then(function() {
              var Mt;
              (Mt = Et[MARK]) === null || Mt === void 0 || Mt.unmount(), delete Et[MARK];
            }));
          case 1:
          case "end":
            return $t.stop();
        }
    }, _t);
  })), _modernUnmount.apply(this, arguments);
}
function legacyUnmount(_t) {
  unmountComponentAtNode(_t);
}
function unmount(_t) {
  return _unmount.apply(this, arguments);
}
function _unmount() {
  return _unmount = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _t(Et) {
    return _regeneratorRuntime().wrap(function($t) {
      for (; ; )
        switch ($t.prev = $t.next) {
          case 0:
            if (createRoot === void 0) {
              $t.next = 2;
              break;
            }
            return $t.abrupt("return", modernUnmount(Et));
          case 2:
            legacyUnmount(Et);
          case 3:
          case "end":
            return $t.stop();
        }
    }, _t);
  })), _unmount.apply(this, arguments);
}
const defaultReactRender = (_t, Et) => {
  if (browser$1.env.NODE_ENV !== "production") {
    const Pt = parseInt(React.version.split(".")[0], 10), $t = Object.keys(ReactDOM);
    browser$1.env.NODE_ENV !== "production" && warning$1(Pt < 19 || $t.includes("createRoot"), "compatible", "antd v5 support React is 16 ~ 18. see https://u.ant.design/v5-for-19 for compatible.");
  }
  return render(_t, Et), () => unmount(Et);
};
let unstableRender = defaultReactRender;
function getReactRender() {
  return unstableRender;
}
const getTransitionName = (_t, Et, Pt) => Pt !== void 0 ? Pt : `${_t}-${Et}`, isVisible = function(_t) {
  if (!_t)
    return !1;
  if (_t instanceof Element) {
    if (_t.offsetParent)
      return !0;
    if (_t.getBBox) {
      var Et = _t.getBBox(), Pt = Et.width, $t = Et.height;
      if (Pt || $t)
        return !0;
    }
    if (_t.getBoundingClientRect) {
      var Mt = _t.getBoundingClientRect(), Bt = Mt.width, Vt = Mt.height;
      if (Bt || Vt)
        return !0;
    }
  }
  return !1;
}, genWaveStyle = (_t) => {
  const {
    componentCls: Et,
    colorPrimary: Pt
  } = _t;
  return {
    [Et]: {
      position: "absolute",
      background: "transparent",
      pointerEvents: "none",
      boxSizing: "border-box",
      color: `var(--wave-color, ${Pt})`,
      boxShadow: "0 0 0 0 currentcolor",
      opacity: 0.2,
      // =================== Motion ===================
      "&.wave-motion-appear": {
        transition: [`box-shadow 0.4s ${_t.motionEaseOutCirc}`, `opacity 2s ${_t.motionEaseOutCirc}`].join(","),
        "&-active": {
          boxShadow: "0 0 0 6px currentcolor",
          opacity: 0
        },
        "&.wave-quick": {
          transition: [`box-shadow ${_t.motionDurationSlow} ${_t.motionEaseInOut}`, `opacity ${_t.motionDurationSlow} ${_t.motionEaseInOut}`].join(",")
        }
      }
    }
  };
}, useStyle$7 = genComponentStyleHook("Wave", (_t) => [genWaveStyle(_t)]), TARGET_CLS = `${defaultPrefixCls}-wave-target`;
function isValidWaveColor(_t) {
  return _t && _t !== "#fff" && _t !== "#ffffff" && _t !== "rgb(255, 255, 255)" && _t !== "rgba(255, 255, 255, 1)" && !/rgba\((?:\d*, ){3}0\)/.test(_t) && // any transparent rgba color
  _t !== "transparent";
}
function getTargetWaveColor(_t) {
  const {
    borderTopColor: Et,
    borderColor: Pt,
    backgroundColor: $t
  } = getComputedStyle(_t);
  return isValidWaveColor(Et) ? Et : isValidWaveColor(Pt) ? Pt : isValidWaveColor($t) ? $t : null;
}
function validateNum(_t) {
  return Number.isNaN(_t) ? 0 : _t;
}
const WaveEffect = (_t) => {
  const {
    className: Et,
    target: Pt,
    component: $t,
    registerUnmount: Mt
  } = _t, Bt = React.useRef(null), Vt = React.useRef(null);
  React.useEffect(() => {
    Vt.current = Mt();
  }, []);
  const [zt, Ht] = React.useState(null), [Wt, Gt] = React.useState([]), [qt, Kt] = React.useState(0), [Qt, Xt] = React.useState(0), [Zt, Yt] = React.useState(0), [Jt, er] = React.useState(0), [tr, nr] = React.useState(!1), rr = {
    left: qt,
    top: Qt,
    width: Zt,
    height: Jt,
    borderRadius: Wt.map((or) => `${or}px`).join(" ")
  };
  zt && (rr["--wave-color"] = zt);
  function ir() {
    const or = getComputedStyle(Pt);
    Ht(getTargetWaveColor(Pt));
    const sr = or.position === "static", {
      borderLeftWidth: lr,
      borderTopWidth: cr
    } = or;
    Kt(sr ? Pt.offsetLeft : validateNum(-parseFloat(lr))), Xt(sr ? Pt.offsetTop : validateNum(-parseFloat(cr))), Yt(Pt.offsetWidth), er(Pt.offsetHeight);
    const {
      borderTopLeftRadius: hr,
      borderTopRightRadius: pr,
      borderBottomLeftRadius: mr,
      borderBottomRightRadius: Er
    } = or;
    Gt([hr, pr, Er, mr].map((_r) => validateNum(parseFloat(_r))));
  }
  if (React.useEffect(() => {
    if (Pt) {
      const or = wrapperRaf(() => {
        ir(), nr(!0);
      });
      let sr;
      return typeof ResizeObserver < "u" && (sr = new ResizeObserver(ir), sr.observe(Pt)), () => {
        wrapperRaf.cancel(or), sr == null || sr.disconnect();
      };
    }
  }, []), !tr)
    return null;
  const ar = ($t === "Checkbox" || $t === "Radio") && (Pt == null ? void 0 : Pt.classList.contains(TARGET_CLS));
  return /* @__PURE__ */ React.createElement(CSSMotion, {
    visible: !0,
    motionAppear: !0,
    motionName: "wave-motion",
    motionDeadline: 5e3,
    onAppearEnd: (or, sr) => {
      var lr, cr;
      if (sr.deadline || sr.propertyName === "opacity") {
        const hr = (lr = Bt.current) === null || lr === void 0 ? void 0 : lr.parentElement;
        (cr = Vt.current) === null || cr === void 0 || cr.call(Vt).then(() => {
          hr == null || hr.remove();
        });
      }
      return !1;
    }
  }, (or, sr) => {
    let {
      className: lr
    } = or;
    return /* @__PURE__ */ React.createElement("div", {
      ref: composeRef(Bt, sr),
      className: classNames(Et, lr, {
        "wave-quick": ar
      }),
      style: rr
    });
  });
}, showWaveEffect = (_t, Et) => {
  var Pt;
  const {
    component: $t
  } = Et;
  if ($t === "Checkbox" && !(!((Pt = _t.querySelector("input")) === null || Pt === void 0) && Pt.checked))
    return;
  const Mt = document.createElement("div");
  Mt.style.position = "absolute", Mt.style.left = "0px", Mt.style.top = "0px", _t == null || _t.insertBefore(Mt, _t == null ? void 0 : _t.firstChild);
  const Bt = getReactRender();
  let Vt = null;
  function zt() {
    return Vt;
  }
  Vt = Bt(/* @__PURE__ */ React.createElement(WaveEffect, Object.assign({}, Et, {
    target: _t,
    registerUnmount: zt
  })), Mt);
}, useWave = (_t, Et, Pt) => {
  const {
    wave: $t
  } = React.useContext(ConfigContext), [, Mt, Bt] = useToken(), Vt = useEvent((Wt) => {
    const Gt = _t.current;
    if ($t != null && $t.disabled || !Gt)
      return;
    const qt = Gt.querySelector(`.${TARGET_CLS}`) || Gt, {
      showEffect: Kt
    } = $t || {};
    (Kt || showWaveEffect)(qt, {
      className: Et,
      token: Mt,
      component: Pt,
      event: Wt,
      hashId: Bt
    });
  }), zt = React.useRef(null);
  return (Wt) => {
    wrapperRaf.cancel(zt.current), zt.current = wrapperRaf(() => {
      Vt(Wt);
    });
  };
}, Wave = (_t) => {
  const {
    children: Et,
    disabled: Pt,
    component: $t
  } = _t, {
    getPrefixCls: Mt
  } = useContext(ConfigContext), Bt = useRef(null), Vt = Mt("wave"), [, zt] = useStyle$7(Vt), Ht = useWave(Bt, classNames(Vt, zt), $t);
  if (React__default.useEffect(() => {
    const Gt = Bt.current;
    if (!Gt || Gt.nodeType !== 1 || Pt)
      return;
    const qt = (Kt) => {
      !isVisible(Kt.target) || // No need wave
      !Gt.getAttribute || Gt.getAttribute("disabled") || Gt.disabled || Gt.className.includes("disabled") || Gt.className.includes("-leave") || Ht(Kt);
    };
    return Gt.addEventListener("click", qt, !0), () => {
      Gt.removeEventListener("click", qt, !0);
    };
  }, [Pt]), !/* @__PURE__ */ React__default.isValidElement(Et))
    return Et ?? null;
  const Wt = supportRef(Et) ? composeRef(getNodeRef(Et), Bt) : Bt;
  return cloneElement(Et, {
    ref: Wt
  });
};
browser$1.env.NODE_ENV !== "production" && (Wave.displayName = "Wave");
const useSize = (_t) => {
  const Et = React__default.useContext(SizeContext);
  return React__default.useMemo(() => _t ? typeof _t == "string" ? _t ?? Et : _t instanceof Function ? _t(Et) : Et : Et, [_t, Et]);
}, SpaceCompactItemContext = /* @__PURE__ */ React.createContext(null), useCompactItemContext = (_t, Et) => {
  const Pt = React.useContext(SpaceCompactItemContext), $t = React.useMemo(() => {
    if (!Pt)
      return "";
    const {
      compactDirection: Mt,
      isFirstItem: Bt,
      isLastItem: Vt
    } = Pt, zt = Mt === "vertical" ? "-vertical-" : "-";
    return classNames(`${_t}-compact${zt}item`, {
      [`${_t}-compact${zt}first-item`]: Bt,
      [`${_t}-compact${zt}last-item`]: Vt,
      [`${_t}-compact${zt}item-rtl`]: Et === "rtl"
    });
  }, [_t, Et, Pt]);
  return {
    compactSize: Pt == null ? void 0 : Pt.compactSize,
    compactDirection: Pt == null ? void 0 : Pt.compactDirection,
    compactItemClassnames: $t
  };
}, NoCompactStyle = (_t) => {
  let {
    children: Et
  } = _t;
  return /* @__PURE__ */ React.createElement(SpaceCompactItemContext.Provider, {
    value: null
  }, Et);
};
var __rest$c = function(_t, Et) {
  var Pt = {};
  for (var $t in _t)
    Object.prototype.hasOwnProperty.call(_t, $t) && Et.indexOf($t) < 0 && (Pt[$t] = _t[$t]);
  if (_t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var Mt = 0, $t = Object.getOwnPropertySymbols(_t); Mt < $t.length; Mt++)
      Et.indexOf($t[Mt]) < 0 && Object.prototype.propertyIsEnumerable.call(_t, $t[Mt]) && (Pt[$t[Mt]] = _t[$t[Mt]]);
  return Pt;
};
const GroupSizeContext = /* @__PURE__ */ React.createContext(void 0), ButtonGroup = (_t) => {
  const {
    getPrefixCls: Et,
    direction: Pt
  } = React.useContext(ConfigContext), {
    prefixCls: $t,
    size: Mt,
    className: Bt
  } = _t, Vt = __rest$c(_t, ["prefixCls", "size", "className"]), zt = Et("btn-group", $t), [, , Ht] = useToken();
  let Wt = "";
  switch (Mt) {
    case "large":
      Wt = "lg";
      break;
    case "small":
      Wt = "sm";
      break;
  }
  if (browser$1.env.NODE_ENV !== "production") {
    const qt = devUseWarning("Button.Group");
    browser$1.env.NODE_ENV !== "production" && qt(!Mt || ["large", "small", "middle"].includes(Mt), "usage", "Invalid prop `size`.");
  }
  const Gt = classNames(zt, {
    [`${zt}-${Wt}`]: Wt,
    [`${zt}-rtl`]: Pt === "rtl"
  }, Bt, Ht);
  return /* @__PURE__ */ React.createElement(GroupSizeContext.Provider, {
    value: Mt
  }, /* @__PURE__ */ React.createElement("div", Object.assign({}, Vt, {
    className: Gt
  })));
}, rxTwoCNChar = /^[\u4E00-\u9FA5]{2}$/, isTwoCNChar = rxTwoCNChar.test.bind(rxTwoCNChar);
function convertLegacyProps(_t) {
  return _t === "danger" ? {
    danger: !0
  } : {
    type: _t
  };
}
function isString$2(_t) {
  return typeof _t == "string";
}
function isUnBorderedButtonVariant(_t) {
  return _t === "text" || _t === "link";
}
function splitCNCharsBySpace(_t, Et) {
  if (_t == null)
    return;
  const Pt = Et ? " " : "";
  return typeof _t != "string" && typeof _t != "number" && isString$2(_t.type) && isTwoCNChar(_t.props.children) ? cloneElement(_t, {
    children: _t.props.children.split("").join(Pt)
  }) : isString$2(_t) ? isTwoCNChar(_t) ? /* @__PURE__ */ React__default.createElement("span", null, _t.split("").join(Pt)) : /* @__PURE__ */ React__default.createElement("span", null, _t) : isFragment(_t) ? /* @__PURE__ */ React__default.createElement("span", null, _t) : _t;
}
function spaceChildren(_t, Et) {
  let Pt = !1;
  const $t = [];
  return React__default.Children.forEach(_t, (Mt) => {
    const Bt = typeof Mt, Vt = Bt === "string" || Bt === "number";
    if (Pt && Vt) {
      const zt = $t.length - 1, Ht = $t[zt];
      $t[zt] = `${Ht}${Mt}`;
    } else
      $t.push(Mt);
    Pt = Vt;
  }), React__default.Children.map($t, (Mt) => splitCNCharsBySpace(Mt, Et));
}
["default", "primary", "danger"].concat(_toConsumableArray(PresetColors));
const IconWrapper = /* @__PURE__ */ forwardRef((_t, Et) => {
  const {
    className: Pt,
    style: $t,
    children: Mt,
    prefixCls: Bt
  } = _t, Vt = classNames(`${Bt}-icon`, Pt);
  return /* @__PURE__ */ React__default.createElement("span", {
    ref: Et,
    className: Vt,
    style: $t
  }, Mt);
}), InnerLoadingIcon = /* @__PURE__ */ forwardRef((_t, Et) => {
  const {
    prefixCls: Pt,
    className: $t,
    style: Mt,
    iconClassName: Bt
  } = _t, Vt = classNames(`${Pt}-loading-icon`, $t);
  return /* @__PURE__ */ React__default.createElement(IconWrapper, {
    prefixCls: Pt,
    className: Vt,
    style: Mt,
    ref: Et
  }, /* @__PURE__ */ React__default.createElement(RefIcon$1, {
    className: Bt
  }));
}), getCollapsedWidth = () => ({
  width: 0,
  opacity: 0,
  transform: "scale(0)"
}), getRealWidth = (_t) => ({
  width: _t.scrollWidth,
  opacity: 1,
  transform: "scale(1)"
}), DefaultLoadingIcon = (_t) => {
  const {
    prefixCls: Et,
    loading: Pt,
    existIcon: $t,
    className: Mt,
    style: Bt,
    mount: Vt
  } = _t, zt = !!Pt;
  return $t ? /* @__PURE__ */ React__default.createElement(InnerLoadingIcon, {
    prefixCls: Et,
    className: Mt,
    style: Bt
  }) : /* @__PURE__ */ React__default.createElement(CSSMotion, {
    visible: zt,
    // Used for minus flex gap style only
    motionName: `${Et}-loading-icon-motion`,
    motionAppear: !Vt,
    motionEnter: !Vt,
    motionLeave: !Vt,
    removeOnLeave: !0,
    onAppearStart: getCollapsedWidth,
    onAppearActive: getRealWidth,
    onEnterStart: getCollapsedWidth,
    onEnterActive: getRealWidth,
    onLeaveStart: getRealWidth,
    onLeaveActive: getCollapsedWidth
  }, (Ht, Wt) => {
    let {
      className: Gt,
      style: qt
    } = Ht;
    const Kt = Object.assign(Object.assign({}, Bt), qt);
    return /* @__PURE__ */ React__default.createElement(InnerLoadingIcon, {
      prefixCls: Et,
      className: classNames(Mt, Gt),
      style: Kt,
      ref: Wt
    });
  });
}, genButtonBorderStyle = (_t, Et) => ({
  // Border
  [`> span, > ${_t}`]: {
    "&:not(:last-child)": {
      [`&, & > ${_t}`]: {
        "&:not(:disabled)": {
          borderInlineEndColor: Et
        }
      }
    },
    "&:not(:first-child)": {
      [`&, & > ${_t}`]: {
        "&:not(:disabled)": {
          borderInlineStartColor: Et
        }
      }
    }
  }
}), genGroupStyle = (_t) => {
  const {
    componentCls: Et,
    fontSize: Pt,
    lineWidth: $t,
    groupBorderColor: Mt,
    colorErrorHover: Bt
  } = _t;
  return {
    [`${Et}-group`]: [
      {
        position: "relative",
        display: "inline-flex",
        // Border
        [`> span, > ${Et}`]: {
          "&:not(:last-child)": {
            [`&, & > ${Et}`]: {
              borderStartEndRadius: 0,
              borderEndEndRadius: 0
            }
          },
          "&:not(:first-child)": {
            marginInlineStart: _t.calc($t).mul(-1).equal(),
            [`&, & > ${Et}`]: {
              borderStartStartRadius: 0,
              borderEndStartRadius: 0
            }
          }
        },
        [Et]: {
          position: "relative",
          zIndex: 1,
          "&:hover, &:focus, &:active": {
            zIndex: 2
          },
          "&[disabled]": {
            zIndex: 0
          }
        },
        [`${Et}-icon-only`]: {
          fontSize: Pt
        }
      },
      // Border Color
      genButtonBorderStyle(`${Et}-primary`, Mt),
      genButtonBorderStyle(`${Et}-danger`, Bt)
    ]
  };
};
var _excluded$k = ["b"], _excluded2$4 = ["v"], getRoundNumber = function(Et) {
  return Math.round(Number(Et || 0));
}, convertHsb2Hsv = function(Et) {
  if (Et instanceof FastColor)
    return Et;
  if (Et && _typeof(Et) === "object" && "h" in Et && "b" in Et) {
    var Pt = Et, $t = Pt.b, Mt = _objectWithoutProperties$2(Pt, _excluded$k);
    return _objectSpread2(_objectSpread2({}, Mt), {}, {
      v: $t
    });
  }
  return typeof Et == "string" && /hsb/.test(Et) ? Et.replace(/hsb/, "hsv") : Et;
}, Color = /* @__PURE__ */ function(_t) {
  _inherits(Pt, _t);
  var Et = _createSuper(Pt);
  function Pt($t) {
    return _classCallCheck(this, Pt), Et.call(this, convertHsb2Hsv($t));
  }
  return _createClass(Pt, [{
    key: "toHsbString",
    value: function() {
      var Mt = this.toHsb(), Bt = getRoundNumber(Mt.s * 100), Vt = getRoundNumber(Mt.b * 100), zt = getRoundNumber(Mt.h), Ht = Mt.a, Wt = "hsb(".concat(zt, ", ").concat(Bt, "%, ").concat(Vt, "%)"), Gt = "hsba(".concat(zt, ", ").concat(Bt, "%, ").concat(Vt, "%, ").concat(Ht.toFixed(Ht === 0 ? 0 : 2), ")");
      return Ht === 1 ? Wt : Gt;
    }
  }, {
    key: "toHsb",
    value: function() {
      var Mt = this.toHsv(), Bt = Mt.v, Vt = _objectWithoutProperties$2(Mt, _excluded2$4);
      return _objectSpread2(_objectSpread2({}, Vt), {}, {
        b: Bt,
        a: this.a
      });
    }
  }]), Pt;
}(FastColor), ColorPickerPrefixCls = "rc-color-picker", generateColor = function(Et) {
  return Et instanceof Color ? Et : new Color(Et);
}, defaultColor = generateColor("#1677ff"), calculateColor = function(Et) {
  var Pt = Et.offset, $t = Et.targetRef, Mt = Et.containerRef, Bt = Et.color, Vt = Et.type, zt = Mt.current.getBoundingClientRect(), Ht = zt.width, Wt = zt.height, Gt = $t.current.getBoundingClientRect(), qt = Gt.width, Kt = Gt.height, Qt = qt / 2, Xt = Kt / 2, Zt = (Pt.x + Qt) / Ht, Yt = 1 - (Pt.y + Xt) / Wt, Jt = Bt.toHsb(), er = Zt, tr = (Pt.x + Qt) / Ht * 360;
  if (Vt)
    switch (Vt) {
      case "hue":
        return generateColor(_objectSpread2(_objectSpread2({}, Jt), {}, {
          h: tr <= 0 ? 0 : tr
        }));
      case "alpha":
        return generateColor(_objectSpread2(_objectSpread2({}, Jt), {}, {
          a: er <= 0 ? 0 : er
        }));
    }
  return generateColor({
    h: Jt.h,
    s: Zt <= 0 ? 0 : Zt,
    b: Yt >= 1 ? 1 : Yt,
    a: Jt.a
  });
}, calcOffset = function(Et, Pt) {
  var $t = Et.toHsb();
  switch (Pt) {
    case "hue":
      return {
        x: $t.h / 360 * 100,
        y: 50
      };
    case "alpha":
      return {
        x: Et.a * 100,
        y: 50
      };
    default:
      return {
        x: $t.s * 100,
        y: (1 - $t.b) * 100
      };
  }
}, ColorBlock = function(Et) {
  var Pt = Et.color, $t = Et.prefixCls, Mt = Et.className, Bt = Et.style, Vt = Et.onClick, zt = "".concat($t, "-color-block");
  return /* @__PURE__ */ React__default.createElement("div", {
    className: classNames(zt, Mt),
    style: Bt,
    onClick: Vt
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "".concat(zt, "-inner"),
    style: {
      background: Pt
    }
  }));
};
function getPosition(_t) {
  var Et = "touches" in _t ? _t.touches[0] : _t, Pt = document.documentElement.scrollLeft || document.body.scrollLeft || window.pageXOffset, $t = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
  return {
    pageX: Et.pageX - Pt,
    pageY: Et.pageY - $t
  };
}
function useColorDrag(_t) {
  var Et = _t.targetRef, Pt = _t.containerRef, $t = _t.direction, Mt = _t.onDragChange, Bt = _t.onDragChangeComplete, Vt = _t.calculate, zt = _t.color, Ht = _t.disabledDrag, Wt = useState({
    x: 0,
    y: 0
  }), Gt = _slicedToArray(Wt, 2), qt = Gt[0], Kt = Gt[1], Qt = useRef(null), Xt = useRef(null);
  useEffect(function() {
    Kt(Vt());
  }, [zt]), useEffect(function() {
    return function() {
      document.removeEventListener("mousemove", Qt.current), document.removeEventListener("mouseup", Xt.current), document.removeEventListener("touchmove", Qt.current), document.removeEventListener("touchend", Xt.current), Qt.current = null, Xt.current = null;
    };
  }, []);
  var Zt = function(nr) {
    var rr = getPosition(nr), ir = rr.pageX, ar = rr.pageY, or = Pt.current.getBoundingClientRect(), sr = or.x, lr = or.y, cr = or.width, hr = or.height, pr = Et.current.getBoundingClientRect(), mr = pr.width, Er = pr.height, _r = mr / 2, yr = Er / 2, ur = Math.max(0, Math.min(ir - sr, cr)) - _r, vr = Math.max(0, Math.min(ar - lr, hr)) - yr, dr = {
      x: ur,
      y: $t === "x" ? qt.y : vr
    };
    if (mr === 0 && Er === 0 || mr !== Er)
      return !1;
    Mt == null || Mt(dr);
  }, Yt = function(nr) {
    nr.preventDefault(), Zt(nr);
  }, Jt = function(nr) {
    nr.preventDefault(), document.removeEventListener("mousemove", Qt.current), document.removeEventListener("mouseup", Xt.current), document.removeEventListener("touchmove", Qt.current), document.removeEventListener("touchend", Xt.current), Qt.current = null, Xt.current = null, Bt == null || Bt();
  }, er = function(nr) {
    document.removeEventListener("mousemove", Qt.current), document.removeEventListener("mouseup", Xt.current), !Ht && (Zt(nr), document.addEventListener("mousemove", Yt), document.addEventListener("mouseup", Jt), document.addEventListener("touchmove", Yt), document.addEventListener("touchend", Jt), Qt.current = Yt, Xt.current = Jt);
  };
  return [qt, er];
}
var Handler = function(Et) {
  var Pt = Et.size, $t = Pt === void 0 ? "default" : Pt, Mt = Et.color, Bt = Et.prefixCls;
  return /* @__PURE__ */ React__default.createElement("div", {
    className: classNames("".concat(Bt, "-handler"), _defineProperty({}, "".concat(Bt, "-handler-sm"), $t === "small")),
    style: {
      backgroundColor: Mt
    }
  });
}, Palette = function(Et) {
  var Pt = Et.children, $t = Et.style, Mt = Et.prefixCls;
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "".concat(Mt, "-palette"),
    style: _objectSpread2({
      position: "relative"
    }, $t)
  }, Pt);
}, Transform = /* @__PURE__ */ forwardRef(function(_t, Et) {
  var Pt = _t.children, $t = _t.x, Mt = _t.y;
  return /* @__PURE__ */ React__default.createElement("div", {
    ref: Et,
    style: {
      position: "absolute",
      left: "".concat($t, "%"),
      top: "".concat(Mt, "%"),
      zIndex: 1,
      transform: "translate(-50%, -50%)"
    }
  }, Pt);
}), Picker = function(Et) {
  var Pt = Et.color, $t = Et.onChange, Mt = Et.prefixCls, Bt = Et.onChangeComplete, Vt = Et.disabled, zt = useRef(), Ht = useRef(), Wt = useRef(Pt), Gt = useEvent(function(Zt) {
    var Yt = calculateColor({
      offset: Zt,
      targetRef: Ht,
      containerRef: zt,
      color: Pt
    });
    Wt.current = Yt, $t(Yt);
  }), qt = useColorDrag({
    color: Pt,
    containerRef: zt,
    targetRef: Ht,
    calculate: function() {
      return calcOffset(Pt);
    },
    onDragChange: Gt,
    onDragChangeComplete: function() {
      return Bt == null ? void 0 : Bt(Wt.current);
    },
    disabledDrag: Vt
  }), Kt = _slicedToArray(qt, 2), Qt = Kt[0], Xt = Kt[1];
  return /* @__PURE__ */ React__default.createElement("div", {
    ref: zt,
    className: "".concat(Mt, "-select"),
    onMouseDown: Xt,
    onTouchStart: Xt
  }, /* @__PURE__ */ React__default.createElement(Palette, {
    prefixCls: Mt
  }, /* @__PURE__ */ React__default.createElement(Transform, {
    x: Qt.x,
    y: Qt.y,
    ref: Ht
  }, /* @__PURE__ */ React__default.createElement(Handler, {
    color: Pt.toRgbString(),
    prefixCls: Mt
  })), /* @__PURE__ */ React__default.createElement("div", {
    className: "".concat(Mt, "-saturation"),
    style: {
      backgroundColor: "hsl(".concat(Pt.toHsb().h, ",100%, 50%)"),
      backgroundImage: "linear-gradient(0deg, #000, transparent),linear-gradient(90deg, #fff, hsla(0, 0%, 100%, 0))"
    }
  })));
}, useColorState = function(Et, Pt) {
  var $t = useMergedState(Et, {
    value: Pt
  }), Mt = _slicedToArray($t, 2), Bt = Mt[0], Vt = Mt[1], zt = useMemo$1(function() {
    return generateColor(Bt);
  }, [Bt]);
  return [zt, Vt];
}, Gradient = function(Et) {
  var Pt = Et.colors, $t = Et.children, Mt = Et.direction, Bt = Mt === void 0 ? "to right" : Mt, Vt = Et.type, zt = Et.prefixCls, Ht = useMemo$1(function() {
    return Pt.map(function(Wt, Gt) {
      var qt = generateColor(Wt);
      return Vt === "alpha" && Gt === Pt.length - 1 && (qt = new Color(qt.setA(1))), qt.toRgbString();
    }).join(",");
  }, [Pt, Vt]);
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "".concat(zt, "-gradient"),
    style: {
      position: "absolute",
      inset: 0,
      background: "linear-gradient(".concat(Bt, ", ").concat(Ht, ")")
    }
  }, $t);
}, Slider = function(Et) {
  var Pt = Et.prefixCls, $t = Et.colors, Mt = Et.disabled, Bt = Et.onChange, Vt = Et.onChangeComplete, zt = Et.color, Ht = Et.type, Wt = useRef(), Gt = useRef(), qt = useRef(zt), Kt = function(rr) {
    return Ht === "hue" ? rr.getHue() : rr.a * 100;
  }, Qt = useEvent(function(nr) {
    var rr = calculateColor({
      offset: nr,
      targetRef: Gt,
      containerRef: Wt,
      color: zt,
      type: Ht
    });
    qt.current = rr, Bt(Kt(rr));
  }), Xt = useColorDrag({
    color: zt,
    targetRef: Gt,
    containerRef: Wt,
    calculate: function() {
      return calcOffset(zt, Ht);
    },
    onDragChange: Qt,
    onDragChangeComplete: function() {
      Vt(Kt(qt.current));
    },
    direction: "x",
    disabledDrag: Mt
  }), Zt = _slicedToArray(Xt, 2), Yt = Zt[0], Jt = Zt[1], er = React__default.useMemo(function() {
    if (Ht === "hue") {
      var nr = zt.toHsb();
      nr.s = 1, nr.b = 1, nr.a = 1;
      var rr = new Color(nr);
      return rr;
    }
    return zt;
  }, [zt, Ht]), tr = React__default.useMemo(function() {
    return $t.map(function(nr) {
      return "".concat(nr.color, " ").concat(nr.percent, "%");
    });
  }, [$t]);
  return /* @__PURE__ */ React__default.createElement("div", {
    ref: Wt,
    className: classNames("".concat(Pt, "-slider"), "".concat(Pt, "-slider-").concat(Ht)),
    onMouseDown: Jt,
    onTouchStart: Jt
  }, /* @__PURE__ */ React__default.createElement(Palette, {
    prefixCls: Pt
  }, /* @__PURE__ */ React__default.createElement(Transform, {
    x: Yt.x,
    y: Yt.y,
    ref: Gt
  }, /* @__PURE__ */ React__default.createElement(Handler, {
    size: "small",
    color: er.toHexString(),
    prefixCls: Pt
  })), /* @__PURE__ */ React__default.createElement(Gradient, {
    colors: tr,
    type: Ht,
    prefixCls: Pt
  })));
};
function useComponent(_t) {
  return React.useMemo(function() {
    var Et = _t || {}, Pt = Et.slider;
    return [Pt || Slider];
  }, [_t]);
}
var HUE_COLORS = [{
  color: "rgb(255, 0, 0)",
  percent: 0
}, {
  color: "rgb(255, 255, 0)",
  percent: 17
}, {
  color: "rgb(0, 255, 0)",
  percent: 33
}, {
  color: "rgb(0, 255, 255)",
  percent: 50
}, {
  color: "rgb(0, 0, 255)",
  percent: 67
}, {
  color: "rgb(255, 0, 255)",
  percent: 83
}, {
  color: "rgb(255, 0, 0)",
  percent: 100
}], ColorPicker$1 = /* @__PURE__ */ forwardRef(function(_t, Et) {
  var Pt = _t.value, $t = _t.defaultValue, Mt = _t.prefixCls, Bt = Mt === void 0 ? ColorPickerPrefixCls : Mt, Vt = _t.onChange, zt = _t.onChangeComplete, Ht = _t.className, Wt = _t.style, Gt = _t.panelRender, qt = _t.disabledAlpha, Kt = qt === void 0 ? !1 : qt, Qt = _t.disabled, Xt = Qt === void 0 ? !1 : Qt, Zt = _t.components, Yt = useComponent(Zt), Jt = _slicedToArray(Yt, 1), er = Jt[0], tr = useColorState($t || defaultColor, Pt), nr = _slicedToArray(tr, 2), rr = nr[0], ir = nr[1], ar = useMemo$1(function() {
    return rr.setA(1).toRgbString();
  }, [rr]), or = function(vr, dr) {
    Pt || ir(vr), Vt == null || Vt(vr, dr);
  }, sr = function(vr) {
    return new Color(rr.setHue(vr));
  }, lr = function(vr) {
    return new Color(rr.setA(vr / 100));
  }, cr = function(vr) {
    or(sr(vr), {
      type: "hue",
      value: vr
    });
  }, hr = function(vr) {
    or(lr(vr), {
      type: "alpha",
      value: vr
    });
  }, pr = function(vr) {
    zt && zt(sr(vr));
  }, mr = function(vr) {
    zt && zt(lr(vr));
  }, Er = classNames("".concat(Bt, "-panel"), Ht, _defineProperty({}, "".concat(Bt, "-panel-disabled"), Xt)), _r = {
    prefixCls: Bt,
    disabled: Xt,
    color: rr
  }, yr = /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Picker, _extends$2({
    onChange: or
  }, _r, {
    onChangeComplete: zt
  })), /* @__PURE__ */ React__default.createElement("div", {
    className: "".concat(Bt, "-slider-container")
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: classNames("".concat(Bt, "-slider-group"), _defineProperty({}, "".concat(Bt, "-slider-group-disabled-alpha"), Kt))
  }, /* @__PURE__ */ React__default.createElement(er, _extends$2({}, _r, {
    type: "hue",
    colors: HUE_COLORS,
    min: 0,
    max: 359,
    value: rr.getHue(),
    onChange: cr,
    onChangeComplete: pr
  })), !Kt && /* @__PURE__ */ React__default.createElement(er, _extends$2({}, _r, {
    type: "alpha",
    colors: [{
      percent: 0,
      color: "rgba(255, 0, 4, 0)"
    }, {
      percent: 100,
      color: ar
    }],
    min: 0,
    max: 100,
    value: rr.a * 100,
    onChange: hr,
    onChangeComplete: mr
  }))), /* @__PURE__ */ React__default.createElement(ColorBlock, {
    color: rr.toRgbString(),
    prefixCls: Bt
  })));
  return /* @__PURE__ */ React__default.createElement("div", {
    className: Er,
    style: Wt,
    ref: Et
  }, typeof Gt == "function" ? Gt(yr) : yr);
});
browser$1.env.NODE_ENV !== "production" && (ColorPicker$1.displayName = "ColorPicker");
const toHexFormat = (_t, Et) => (_t == null ? void 0 : _t.replace(/[^\w/]/g, "").slice(0, Et ? 8 : 6)) || "", getHex = (_t, Et) => _t ? toHexFormat(_t, Et) : "";
let AggregationColor = /* @__PURE__ */ function() {
  function _t(Et) {
    _classCallCheck(this, _t);
    var Pt;
    if (this.cleared = !1, Et instanceof _t) {
      this.metaColor = Et.metaColor.clone(), this.colors = (Pt = Et.colors) === null || Pt === void 0 ? void 0 : Pt.map((Mt) => ({
        color: new _t(Mt.color),
        percent: Mt.percent
      })), this.cleared = Et.cleared;
      return;
    }
    const $t = Array.isArray(Et);
    $t && Et.length ? (this.colors = Et.map((Mt) => {
      let {
        color: Bt,
        percent: Vt
      } = Mt;
      return {
        color: new _t(Bt),
        percent: Vt
      };
    }), this.metaColor = new Color(this.colors[0].color.metaColor)) : this.metaColor = new Color($t ? "" : Et), (!Et || $t && !this.colors) && (this.metaColor = this.metaColor.setA(0), this.cleared = !0);
  }
  return _createClass(_t, [{
    key: "toHsb",
    value: function() {
      return this.metaColor.toHsb();
    }
  }, {
    key: "toHsbString",
    value: function() {
      return this.metaColor.toHsbString();
    }
  }, {
    key: "toHex",
    value: function() {
      return getHex(this.toHexString(), this.metaColor.a < 1);
    }
  }, {
    key: "toHexString",
    value: function() {
      return this.metaColor.toHexString();
    }
  }, {
    key: "toRgb",
    value: function() {
      return this.metaColor.toRgb();
    }
  }, {
    key: "toRgbString",
    value: function() {
      return this.metaColor.toRgbString();
    }
  }, {
    key: "isGradient",
    value: function() {
      return !!this.colors && !this.cleared;
    }
  }, {
    key: "getColors",
    value: function() {
      return this.colors || [{
        color: this,
        percent: 0
      }];
    }
  }, {
    key: "toCssString",
    value: function() {
      const {
        colors: Pt
      } = this;
      return Pt ? `linear-gradient(90deg, ${Pt.map((Mt) => `${Mt.color.toRgbString()} ${Mt.percent}%`).join(", ")})` : this.metaColor.toRgbString();
    }
  }, {
    key: "equals",
    value: function(Pt) {
      return !Pt || this.isGradient() !== Pt.isGradient() ? !1 : this.isGradient() ? this.colors.length === Pt.colors.length && this.colors.every(($t, Mt) => {
        const Bt = Pt.colors[Mt];
        return $t.percent === Bt.percent && $t.color.equals(Bt.color);
      }) : this.toHexString() === Pt.toHexString();
    }
  }]);
}();
const initMotionCommon = (_t) => ({
  animationDuration: _t,
  animationFillMode: "both"
}), initMotionCommonLeave = (_t) => ({
  animationDuration: _t,
  animationFillMode: "both"
}), initMotion = function(_t, Et, Pt, $t) {
  const Bt = (arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1) ? "&" : "";
  return {
    [`
      ${Bt}${_t}-enter,
      ${Bt}${_t}-appear
    `]: Object.assign(Object.assign({}, initMotionCommon($t)), {
      animationPlayState: "paused"
    }),
    [`${Bt}${_t}-leave`]: Object.assign(Object.assign({}, initMotionCommonLeave($t)), {
      animationPlayState: "paused"
    }),
    [`
      ${Bt}${_t}-enter${_t}-enter-active,
      ${Bt}${_t}-appear${_t}-appear-active
    `]: {
      animationName: Et,
      animationPlayState: "running"
    },
    [`${Bt}${_t}-leave${_t}-leave-active`]: {
      animationName: Pt,
      animationPlayState: "running",
      pointerEvents: "none"
    }
  };
}, fadeIn = new Keyframe("antFadeIn", {
  "0%": {
    opacity: 0
  },
  "100%": {
    opacity: 1
  }
}), fadeOut = new Keyframe("antFadeOut", {
  "0%": {
    opacity: 1
  },
  "100%": {
    opacity: 0
  }
}), initFadeMotion = function(_t) {
  let Et = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  const {
    antCls: Pt
  } = _t, $t = `${Pt}-fade`, Mt = Et ? "&" : "";
  return [initMotion($t, fadeIn, fadeOut, _t.motionDurationMid, Et), {
    [`
        ${Mt}${$t}-enter,
        ${Mt}${$t}-appear
      `]: {
      opacity: 0,
      animationTimingFunction: "linear"
    },
    [`${Mt}${$t}-leave`]: {
      animationTimingFunction: "linear"
    }
  }];
}, slideUpIn = new Keyframe("antSlideUpIn", {
  "0%": {
    transform: "scaleY(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleY(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  }
}), slideUpOut = new Keyframe("antSlideUpOut", {
  "0%": {
    transform: "scaleY(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleY(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  }
}), slideDownIn = new Keyframe("antSlideDownIn", {
  "0%": {
    transform: "scaleY(0.8)",
    transformOrigin: "100% 100%",
    opacity: 0
  },
  "100%": {
    transform: "scaleY(1)",
    transformOrigin: "100% 100%",
    opacity: 1
  }
}), slideDownOut = new Keyframe("antSlideDownOut", {
  "0%": {
    transform: "scaleY(1)",
    transformOrigin: "100% 100%",
    opacity: 1
  },
  "100%": {
    transform: "scaleY(0.8)",
    transformOrigin: "100% 100%",
    opacity: 0
  }
}), slideLeftIn = new Keyframe("antSlideLeftIn", {
  "0%": {
    transform: "scaleX(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleX(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  }
}), slideLeftOut = new Keyframe("antSlideLeftOut", {
  "0%": {
    transform: "scaleX(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleX(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  }
}), slideRightIn = new Keyframe("antSlideRightIn", {
  "0%": {
    transform: "scaleX(0.8)",
    transformOrigin: "100% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleX(1)",
    transformOrigin: "100% 0%",
    opacity: 1
  }
}), slideRightOut = new Keyframe("antSlideRightOut", {
  "0%": {
    transform: "scaleX(1)",
    transformOrigin: "100% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleX(0.8)",
    transformOrigin: "100% 0%",
    opacity: 0
  }
}), slideMotion = {
  "slide-up": {
    inKeyframes: slideUpIn,
    outKeyframes: slideUpOut
  },
  "slide-down": {
    inKeyframes: slideDownIn,
    outKeyframes: slideDownOut
  },
  "slide-left": {
    inKeyframes: slideLeftIn,
    outKeyframes: slideLeftOut
  },
  "slide-right": {
    inKeyframes: slideRightIn,
    outKeyframes: slideRightOut
  }
}, initSlideMotion = (_t, Et) => {
  const {
    antCls: Pt
  } = _t, $t = `${Pt}-${Et}`, {
    inKeyframes: Mt,
    outKeyframes: Bt
  } = slideMotion[Et];
  return [initMotion($t, Mt, Bt, _t.motionDurationMid), {
    [`
      ${$t}-enter,
      ${$t}-appear
    `]: {
      transform: "scale(0)",
      transformOrigin: "0% 0%",
      opacity: 0,
      animationTimingFunction: _t.motionEaseOutQuint,
      "&-prepare": {
        transform: "scale(1)"
      }
    },
    [`${$t}-leave`]: {
      animationTimingFunction: _t.motionEaseInQuint
    }
  }];
}, zoomIn = new Keyframe("antZoomIn", {
  "0%": {
    transform: "scale(0.2)",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    opacity: 1
  }
}), zoomOut = new Keyframe("antZoomOut", {
  "0%": {
    transform: "scale(1)"
  },
  "100%": {
    transform: "scale(0.2)",
    opacity: 0
  }
}), zoomBigIn = new Keyframe("antZoomBigIn", {
  "0%": {
    transform: "scale(0.8)",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    opacity: 1
  }
}), zoomBigOut = new Keyframe("antZoomBigOut", {
  "0%": {
    transform: "scale(1)"
  },
  "100%": {
    transform: "scale(0.8)",
    opacity: 0
  }
}), zoomUpIn = new Keyframe("antZoomUpIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "50% 0%"
  }
}), zoomUpOut = new Keyframe("antZoomUpOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "50% 0%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 0%",
    opacity: 0
  }
}), zoomLeftIn = new Keyframe("antZoomLeftIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "0% 50%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "0% 50%"
  }
}), zoomLeftOut = new Keyframe("antZoomLeftOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "0% 50%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "0% 50%",
    opacity: 0
  }
}), zoomRightIn = new Keyframe("antZoomRightIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "100% 50%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "100% 50%"
  }
}), zoomRightOut = new Keyframe("antZoomRightOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "100% 50%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "100% 50%",
    opacity: 0
  }
}), zoomDownIn = new Keyframe("antZoomDownIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 100%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "50% 100%"
  }
}), zoomDownOut = new Keyframe("antZoomDownOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "50% 100%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 100%",
    opacity: 0
  }
}), zoomMotion = {
  zoom: {
    inKeyframes: zoomIn,
    outKeyframes: zoomOut
  },
  "zoom-big": {
    inKeyframes: zoomBigIn,
    outKeyframes: zoomBigOut
  },
  "zoom-big-fast": {
    inKeyframes: zoomBigIn,
    outKeyframes: zoomBigOut
  },
  "zoom-left": {
    inKeyframes: zoomLeftIn,
    outKeyframes: zoomLeftOut
  },
  "zoom-right": {
    inKeyframes: zoomRightIn,
    outKeyframes: zoomRightOut
  },
  "zoom-up": {
    inKeyframes: zoomUpIn,
    outKeyframes: zoomUpOut
  },
  "zoom-down": {
    inKeyframes: zoomDownIn,
    outKeyframes: zoomDownOut
  }
}, initZoomMotion = (_t, Et) => {
  const {
    antCls: Pt
  } = _t, $t = `${Pt}-${Et}`, {
    inKeyframes: Mt,
    outKeyframes: Bt
  } = zoomMotion[Et];
  return [initMotion($t, Mt, Bt, Et === "zoom-big-fast" ? _t.motionDurationFast : _t.motionDurationMid), {
    [`
        ${$t}-enter,
        ${$t}-appear
      `]: {
      transform: "scale(0)",
      opacity: 0,
      animationTimingFunction: _t.motionEaseOutCirc,
      "&-prepare": {
        transform: "none"
      }
    },
    [`${$t}-leave`]: {
      animationTimingFunction: _t.motionEaseInOutCirc
    }
  }];
}, isBright = (_t, Et) => {
  const {
    r: Pt,
    g: $t,
    b: Mt,
    a: Bt
  } = _t.toRgb(), Vt = new Color(_t.toRgbString()).onBackground(Et).toHsv();
  return Bt <= 0.5 ? Vt.v > 0.5 : Pt * 0.299 + $t * 0.587 + Mt * 0.114 > 192;
}, prepareToken$2 = (_t) => {
  const {
    paddingInline: Et,
    onlyIconSize: Pt
  } = _t;
  return merge$1(_t, {
    buttonPaddingHorizontal: Et,
    buttonPaddingVertical: 0,
    buttonIconOnlyFontSize: Pt
  });
}, prepareComponentToken$6 = (_t) => {
  var Et, Pt, $t, Mt, Bt, Vt;
  const zt = (Et = _t.contentFontSize) !== null && Et !== void 0 ? Et : _t.fontSize, Ht = (Pt = _t.contentFontSizeSM) !== null && Pt !== void 0 ? Pt : _t.fontSize, Wt = ($t = _t.contentFontSizeLG) !== null && $t !== void 0 ? $t : _t.fontSizeLG, Gt = (Mt = _t.contentLineHeight) !== null && Mt !== void 0 ? Mt : getLineHeight(zt), qt = (Bt = _t.contentLineHeightSM) !== null && Bt !== void 0 ? Bt : getLineHeight(Ht), Kt = (Vt = _t.contentLineHeightLG) !== null && Vt !== void 0 ? Vt : getLineHeight(Wt), Qt = isBright(new AggregationColor(_t.colorBgSolid), "#fff") ? "#000" : "#fff";
  return {
    fontWeight: 400,
    defaultShadow: `0 ${_t.controlOutlineWidth}px 0 ${_t.controlTmpOutline}`,
    primaryShadow: `0 ${_t.controlOutlineWidth}px 0 ${_t.controlOutline}`,
    dangerShadow: `0 ${_t.controlOutlineWidth}px 0 ${_t.colorErrorOutline}`,
    primaryColor: _t.colorTextLightSolid,
    dangerColor: _t.colorTextLightSolid,
    borderColorDisabled: _t.colorBorder,
    defaultGhostColor: _t.colorBgContainer,
    ghostBg: "transparent",
    defaultGhostBorderColor: _t.colorBgContainer,
    paddingInline: _t.paddingContentHorizontal - _t.lineWidth,
    paddingInlineLG: _t.paddingContentHorizontal - _t.lineWidth,
    paddingInlineSM: 8 - _t.lineWidth,
    onlyIconSize: "inherit",
    onlyIconSizeSM: "inherit",
    onlyIconSizeLG: "inherit",
    groupBorderColor: _t.colorPrimaryHover,
    linkHoverBg: "transparent",
    textTextColor: _t.colorText,
    textTextHoverColor: _t.colorText,
    textTextActiveColor: _t.colorText,
    textHoverBg: _t.colorFillTertiary,
    defaultColor: _t.colorText,
    defaultBg: _t.colorBgContainer,
    defaultBorderColor: _t.colorBorder,
    defaultBorderColorDisabled: _t.colorBorder,
    defaultHoverBg: _t.colorBgContainer,
    defaultHoverColor: _t.colorPrimaryHover,
    defaultHoverBorderColor: _t.colorPrimaryHover,
    defaultActiveBg: _t.colorBgContainer,
    defaultActiveColor: _t.colorPrimaryActive,
    defaultActiveBorderColor: _t.colorPrimaryActive,
    solidTextColor: Qt,
    contentFontSize: zt,
    contentFontSizeSM: Ht,
    contentFontSizeLG: Wt,
    contentLineHeight: Gt,
    contentLineHeightSM: qt,
    contentLineHeightLG: Kt,
    paddingBlock: Math.max((_t.controlHeight - zt * Gt) / 2 - _t.lineWidth, 0),
    paddingBlockSM: Math.max((_t.controlHeightSM - Ht * qt) / 2 - _t.lineWidth, 0),
    paddingBlockLG: Math.max((_t.controlHeightLG - Wt * Kt) / 2 - _t.lineWidth, 0)
  };
}, genSharedButtonStyle = (_t) => {
  const {
    componentCls: Et,
    iconCls: Pt,
    fontWeight: $t,
    opacityLoading: Mt,
    motionDurationSlow: Bt,
    motionEaseInOut: Vt,
    marginXS: zt,
    calc: Ht
  } = _t;
  return {
    [Et]: {
      outline: "none",
      position: "relative",
      display: "inline-flex",
      gap: _t.marginXS,
      alignItems: "center",
      justifyContent: "center",
      fontWeight: $t,
      whiteSpace: "nowrap",
      textAlign: "center",
      backgroundImage: "none",
      background: "transparent",
      border: `${unit$1(_t.lineWidth)} ${_t.lineType} transparent`,
      cursor: "pointer",
      transition: `all ${_t.motionDurationMid} ${_t.motionEaseInOut}`,
      userSelect: "none",
      touchAction: "manipulation",
      color: _t.colorText,
      "&:disabled > *": {
        pointerEvents: "none"
      },
      // https://github.com/ant-design/ant-design/issues/51380
      [`${Et}-icon > svg`]: resetIcon(),
      "> a": {
        color: "currentColor"
      },
      "&:not(:disabled)": genFocusStyle(_t),
      [`&${Et}-two-chinese-chars::first-letter`]: {
        letterSpacing: "0.34em"
      },
      [`&${Et}-two-chinese-chars > *:not(${Pt})`]: {
        marginInlineEnd: "-0.34em",
        letterSpacing: "0.34em"
      },
      [`&${Et}-icon-only`]: {
        paddingInline: 0,
        // make `btn-icon-only` not too narrow
        [`&${Et}-compact-item`]: {
          flex: "none"
        },
        [`&${Et}-round`]: {
          width: "auto"
        }
      },
      // Loading
      [`&${Et}-loading`]: {
        opacity: Mt,
        cursor: "default"
      },
      [`${Et}-loading-icon`]: {
        transition: ["width", "opacity", "margin"].map((Wt) => `${Wt} ${Bt} ${Vt}`).join(",")
      },
      // iconPosition
      [`&:not(${Et}-icon-end)`]: {
        [`${Et}-loading-icon-motion`]: {
          "&-appear-start, &-enter-start": {
            marginInlineEnd: Ht(zt).mul(-1).equal()
          },
          "&-appear-active, &-enter-active": {
            marginInlineEnd: 0
          },
          "&-leave-start": {
            marginInlineEnd: 0
          },
          "&-leave-active": {
            marginInlineEnd: Ht(zt).mul(-1).equal()
          }
        }
      },
      "&-icon-end": {
        flexDirection: "row-reverse",
        [`${Et}-loading-icon-motion`]: {
          "&-appear-start, &-enter-start": {
            marginInlineStart: Ht(zt).mul(-1).equal()
          },
          "&-appear-active, &-enter-active": {
            marginInlineStart: 0
          },
          "&-leave-start": {
            marginInlineStart: 0
          },
          "&-leave-active": {
            marginInlineStart: Ht(zt).mul(-1).equal()
          }
        }
      }
    }
  };
}, genHoverActiveButtonStyle = (_t, Et, Pt) => ({
  [`&:not(:disabled):not(${_t}-disabled)`]: {
    "&:hover": Et,
    "&:active": Pt
  }
}), genCircleButtonStyle = (_t) => ({
  minWidth: _t.controlHeight,
  paddingInlineStart: 0,
  paddingInlineEnd: 0,
  borderRadius: "50%"
}), genRoundButtonStyle = (_t) => ({
  borderRadius: _t.controlHeight,
  paddingInlineStart: _t.calc(_t.controlHeight).div(2).equal(),
  paddingInlineEnd: _t.calc(_t.controlHeight).div(2).equal()
}), genDisabledStyle = (_t) => ({
  cursor: "not-allowed",
  borderColor: _t.borderColorDisabled,
  color: _t.colorTextDisabled,
  background: _t.colorBgContainerDisabled,
  boxShadow: "none"
}), genGhostButtonStyle = (_t, Et, Pt, $t, Mt, Bt, Vt, zt) => ({
  [`&${_t}-background-ghost`]: Object.assign(Object.assign({
    color: Pt || void 0,
    background: Et,
    borderColor: $t || void 0,
    boxShadow: "none"
  }, genHoverActiveButtonStyle(_t, Object.assign({
    background: Et
  }, Vt), Object.assign({
    background: Et
  }, zt))), {
    "&:disabled": {
      cursor: "not-allowed",
      color: Mt || void 0,
      borderColor: Bt || void 0
    }
  })
}), genSolidDisabledButtonStyle = (_t) => ({
  [`&:disabled, &${_t.componentCls}-disabled`]: Object.assign({}, genDisabledStyle(_t))
}), genPureDisabledButtonStyle = (_t) => ({
  [`&:disabled, &${_t.componentCls}-disabled`]: {
    cursor: "not-allowed",
    color: _t.colorTextDisabled
  }
}), genVariantButtonStyle = (_t, Et, Pt, $t) => {
  const Bt = $t && ["link", "text"].includes($t) ? genPureDisabledButtonStyle : genSolidDisabledButtonStyle;
  return Object.assign(Object.assign({}, Bt(_t)), genHoverActiveButtonStyle(_t.componentCls, Et, Pt));
}, genSolidButtonStyle = (_t, Et, Pt, $t, Mt) => ({
  [`&${_t.componentCls}-variant-solid`]: Object.assign({
    color: Et,
    background: Pt
  }, genVariantButtonStyle(_t, $t, Mt))
}), genOutlinedDashedButtonStyle = (_t, Et, Pt, $t, Mt) => ({
  [`&${_t.componentCls}-variant-outlined, &${_t.componentCls}-variant-dashed`]: Object.assign({
    borderColor: Et,
    background: Pt
  }, genVariantButtonStyle(_t, $t, Mt))
}), genDashedButtonStyle = (_t) => ({
  [`&${_t.componentCls}-variant-dashed`]: {
    borderStyle: "dashed"
  }
}), genFilledButtonStyle = (_t, Et, Pt, $t) => ({
  [`&${_t.componentCls}-variant-filled`]: Object.assign({
    boxShadow: "none",
    background: Et
  }, genVariantButtonStyle(_t, Pt, $t))
}), genTextLinkButtonStyle = (_t, Et, Pt, $t, Mt) => ({
  [`&${_t.componentCls}-variant-${Pt}`]: Object.assign({
    color: Et,
    boxShadow: "none"
  }, genVariantButtonStyle(_t, $t, Mt, Pt))
}), genPresetColorStyle = (_t) => {
  const {
    componentCls: Et
  } = _t;
  return PresetColors.reduce((Pt, $t) => {
    const Mt = _t[`${$t}6`], Bt = _t[`${$t}1`], Vt = _t[`${$t}5`], zt = _t[`${$t}2`], Ht = _t[`${$t}3`], Wt = _t[`${$t}7`], Gt = `0 ${unit$1(_t.controlOutlineWidth)} 0 ${_t[`${$t}1`]}`;
    return Object.assign(Object.assign({}, Pt), {
      [`&${Et}-color-${$t}`]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
        color: Mt,
        boxShadow: Gt
      }, genSolidButtonStyle(_t, _t.colorTextLightSolid, Mt, {
        background: Vt
      }, {
        background: Wt
      })), genOutlinedDashedButtonStyle(_t, Mt, _t.colorBgContainer, {
        color: Vt,
        borderColor: Vt,
        background: _t.colorBgContainer
      }, {
        color: Wt,
        borderColor: Wt,
        background: _t.colorBgContainer
      })), genDashedButtonStyle(_t)), genFilledButtonStyle(_t, Bt, {
        background: zt
      }, {
        background: Ht
      })), genTextLinkButtonStyle(_t, Mt, "link", {
        color: Vt
      }, {
        color: Wt
      })), genTextLinkButtonStyle(_t, Mt, "text", {
        color: Vt,
        background: Bt
      }, {
        color: Wt,
        background: Ht
      }))
    });
  }, {});
}, genDefaultButtonStyle = (_t) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
  color: _t.defaultColor,
  boxShadow: _t.defaultShadow
}, genSolidButtonStyle(_t, _t.solidTextColor, _t.colorBgSolid, {
  color: _t.solidTextColor,
  background: _t.colorBgSolidHover
}, {
  color: _t.solidTextColor,
  background: _t.colorBgSolidActive
})), genDashedButtonStyle(_t)), genFilledButtonStyle(_t, _t.colorFillTertiary, {
  background: _t.colorFillSecondary
}, {
  background: _t.colorFill
})), genTextLinkButtonStyle(_t, _t.textTextColor, "link", {
  color: _t.colorLinkHover,
  background: _t.linkHoverBg
}, {
  color: _t.colorLinkActive
})), genGhostButtonStyle(_t.componentCls, _t.ghostBg, _t.defaultGhostColor, _t.defaultGhostBorderColor, _t.colorTextDisabled, _t.colorBorder)), genPrimaryButtonStyle = (_t) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
  color: _t.colorPrimary,
  boxShadow: _t.primaryShadow
}, genOutlinedDashedButtonStyle(_t, _t.colorPrimary, _t.colorBgContainer, {
  color: _t.colorPrimaryTextHover,
  borderColor: _t.colorPrimaryHover,
  background: _t.colorBgContainer
}, {
  color: _t.colorPrimaryTextActive,
  borderColor: _t.colorPrimaryActive,
  background: _t.colorBgContainer
})), genDashedButtonStyle(_t)), genFilledButtonStyle(_t, _t.colorPrimaryBg, {
  background: _t.colorPrimaryBgHover
}, {
  background: _t.colorPrimaryBorder
})), genTextLinkButtonStyle(_t, _t.colorLink, "text", {
  color: _t.colorPrimaryTextHover,
  background: _t.colorPrimaryBg
}, {
  color: _t.colorPrimaryTextActive,
  background: _t.colorPrimaryBorder
})), genGhostButtonStyle(_t.componentCls, _t.ghostBg, _t.colorPrimary, _t.colorPrimary, _t.colorTextDisabled, _t.colorBorder, {
  color: _t.colorPrimaryHover,
  borderColor: _t.colorPrimaryHover
}, {
  color: _t.colorPrimaryActive,
  borderColor: _t.colorPrimaryActive
})), genDangerousStyle = (_t) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
  color: _t.colorError,
  boxShadow: _t.dangerShadow
}, genSolidButtonStyle(_t, _t.dangerColor, _t.colorError, {
  background: _t.colorErrorHover
}, {
  background: _t.colorErrorActive
})), genOutlinedDashedButtonStyle(_t, _t.colorError, _t.colorBgContainer, {
  color: _t.colorErrorHover,
  borderColor: _t.colorErrorBorderHover
}, {
  color: _t.colorErrorActive,
  borderColor: _t.colorErrorActive
})), genDashedButtonStyle(_t)), genFilledButtonStyle(_t, _t.colorErrorBg, {
  background: _t.colorErrorBgFilledHover
}, {
  background: _t.colorErrorBgActive
})), genTextLinkButtonStyle(_t, _t.colorError, "text", {
  color: _t.colorErrorHover,
  background: _t.colorErrorBg
}, {
  color: _t.colorErrorHover,
  background: _t.colorErrorBgActive
})), genTextLinkButtonStyle(_t, _t.colorError, "link", {
  color: _t.colorErrorHover
}, {
  color: _t.colorErrorActive
})), genGhostButtonStyle(_t.componentCls, _t.ghostBg, _t.colorError, _t.colorError, _t.colorTextDisabled, _t.colorBorder, {
  color: _t.colorErrorHover,
  borderColor: _t.colorErrorHover
}, {
  color: _t.colorErrorActive,
  borderColor: _t.colorErrorActive
})), genColorButtonStyle = (_t) => {
  const {
    componentCls: Et
  } = _t;
  return Object.assign({
    [`${Et}-color-default`]: genDefaultButtonStyle(_t),
    [`${Et}-color-primary`]: genPrimaryButtonStyle(_t),
    [`${Et}-color-dangerous`]: genDangerousStyle(_t)
  }, genPresetColorStyle(_t));
}, genCompatibleButtonStyle = (_t) => Object.assign(Object.assign(Object.assign(Object.assign({}, genOutlinedDashedButtonStyle(_t, _t.defaultBorderColor, _t.defaultBg, {
  color: _t.defaultHoverColor,
  borderColor: _t.defaultHoverBorderColor,
  background: _t.defaultHoverBg
}, {
  color: _t.defaultActiveColor,
  borderColor: _t.defaultActiveBorderColor,
  background: _t.defaultActiveBg
})), genTextLinkButtonStyle(_t, _t.textTextColor, "text", {
  color: _t.textTextHoverColor,
  background: _t.textHoverBg
}, {
  color: _t.textTextActiveColor,
  background: _t.colorBgTextActive
})), genSolidButtonStyle(_t, _t.primaryColor, _t.colorPrimary, {
  background: _t.colorPrimaryHover,
  color: _t.primaryColor
}, {
  background: _t.colorPrimaryActive,
  color: _t.primaryColor
})), genTextLinkButtonStyle(_t, _t.colorLink, "link", {
  color: _t.colorLinkHover,
  background: _t.linkHoverBg
}, {
  color: _t.colorLinkActive
})), genButtonStyle = function(_t) {
  let Et = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  const {
    componentCls: Pt,
    controlHeight: $t,
    fontSize: Mt,
    borderRadius: Bt,
    buttonPaddingHorizontal: Vt,
    iconCls: zt,
    buttonPaddingVertical: Ht,
    buttonIconOnlyFontSize: Wt
  } = _t;
  return [
    {
      [Et]: {
        fontSize: Mt,
        height: $t,
        padding: `${unit$1(Ht)} ${unit$1(Vt)}`,
        borderRadius: Bt,
        [`&${Pt}-icon-only`]: {
          width: $t,
          [zt]: {
            fontSize: Wt
          }
        }
      }
    },
    // Shape - patch prefixCls again to override solid border radius style
    {
      [`${Pt}${Pt}-circle${Et}`]: genCircleButtonStyle(_t)
    },
    {
      [`${Pt}${Pt}-round${Et}`]: genRoundButtonStyle(_t)
    }
  ];
}, genSizeBaseButtonStyle = (_t) => {
  const Et = merge$1(_t, {
    fontSize: _t.contentFontSize
  });
  return genButtonStyle(Et, _t.componentCls);
}, genSizeSmallButtonStyle = (_t) => {
  const Et = merge$1(_t, {
    controlHeight: _t.controlHeightSM,
    fontSize: _t.contentFontSizeSM,
    padding: _t.paddingXS,
    buttonPaddingHorizontal: _t.paddingInlineSM,
    buttonPaddingVertical: 0,
    borderRadius: _t.borderRadiusSM,
    buttonIconOnlyFontSize: _t.onlyIconSizeSM
  });
  return genButtonStyle(Et, `${_t.componentCls}-sm`);
}, genSizeLargeButtonStyle = (_t) => {
  const Et = merge$1(_t, {
    controlHeight: _t.controlHeightLG,
    fontSize: _t.contentFontSizeLG,
    buttonPaddingHorizontal: _t.paddingInlineLG,
    buttonPaddingVertical: 0,
    borderRadius: _t.borderRadiusLG,
    buttonIconOnlyFontSize: _t.onlyIconSizeLG
  });
  return genButtonStyle(Et, `${_t.componentCls}-lg`);
}, genBlockButtonStyle = (_t) => {
  const {
    componentCls: Et
  } = _t;
  return {
    [Et]: {
      [`&${Et}-block`]: {
        width: "100%"
      }
    }
  };
}, useStyle$6 = genStyleHooks("Button", (_t) => {
  const Et = prepareToken$2(_t);
  return [
    // Shared
    genSharedButtonStyle(Et),
    // Size
    genSizeBaseButtonStyle(Et),
    genSizeSmallButtonStyle(Et),
    genSizeLargeButtonStyle(Et),
    // Block
    genBlockButtonStyle(Et),
    // Color
    genColorButtonStyle(Et),
    // https://github.com/ant-design/ant-design/issues/50969
    genCompatibleButtonStyle(Et),
    // Button Group
    genGroupStyle(Et)
  ];
}, prepareComponentToken$6, {
  unitless: {
    fontWeight: !0,
    contentLineHeight: !0,
    contentLineHeightSM: !0,
    contentLineHeightLG: !0
  }
});
function compactItemBorder(_t, Et, Pt) {
  const {
    focusElCls: $t,
    focus: Mt,
    borderElCls: Bt
  } = Pt, Vt = Bt ? "> *" : "", zt = ["hover", Mt ? "focus" : null, "active"].filter(Boolean).map((Ht) => `&:${Ht} ${Vt}`).join(",");
  return {
    [`&-item:not(${Et}-last-item)`]: {
      marginInlineEnd: _t.calc(_t.lineWidth).mul(-1).equal()
    },
    "&-item": Object.assign(Object.assign({
      [zt]: {
        zIndex: 2
      }
    }, $t ? {
      [`&${$t}`]: {
        zIndex: 2
      }
    } : {}), {
      [`&[disabled] ${Vt}`]: {
        zIndex: 0
      }
    })
  };
}
function compactItemBorderRadius(_t, Et, Pt) {
  const {
    borderElCls: $t
  } = Pt, Mt = $t ? `> ${$t}` : "";
  return {
    [`&-item:not(${Et}-first-item):not(${Et}-last-item) ${Mt}`]: {
      borderRadius: 0
    },
    [`&-item:not(${Et}-last-item)${Et}-first-item`]: {
      [`& ${Mt}, &${_t}-sm ${Mt}, &${_t}-lg ${Mt}`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`&-item:not(${Et}-first-item)${Et}-last-item`]: {
      [`& ${Mt}, &${_t}-sm ${Mt}, &${_t}-lg ${Mt}`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    }
  };
}
function genCompactItemStyle(_t) {
  let Et = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    focus: !0
  };
  const {
    componentCls: Pt
  } = _t, $t = `${Pt}-compact`;
  return {
    [$t]: Object.assign(Object.assign({}, compactItemBorder(_t, $t, Et)), compactItemBorderRadius(Pt, $t, Et))
  };
}
function compactItemVerticalBorder(_t, Et) {
  return {
    // border collapse
    [`&-item:not(${Et}-last-item)`]: {
      marginBottom: _t.calc(_t.lineWidth).mul(-1).equal()
    },
    "&-item": {
      "&:hover,&:focus,&:active": {
        zIndex: 2
      },
      "&[disabled]": {
        zIndex: 0
      }
    }
  };
}
function compactItemBorderVerticalRadius(_t, Et) {
  return {
    [`&-item:not(${Et}-first-item):not(${Et}-last-item)`]: {
      borderRadius: 0
    },
    [`&-item${Et}-first-item:not(${Et}-last-item)`]: {
      [`&, &${_t}-sm, &${_t}-lg`]: {
        borderEndEndRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`&-item${Et}-last-item:not(${Et}-first-item)`]: {
      [`&, &${_t}-sm, &${_t}-lg`]: {
        borderStartStartRadius: 0,
        borderStartEndRadius: 0
      }
    }
  };
}
function genCompactItemVerticalStyle(_t) {
  const Et = `${_t.componentCls}-compact-vertical`;
  return {
    [Et]: Object.assign(Object.assign({}, compactItemVerticalBorder(_t, Et)), compactItemBorderVerticalRadius(_t.componentCls, Et))
  };
}
const genButtonCompactStyle = (_t) => {
  const {
    componentCls: Et,
    colorPrimaryHover: Pt,
    lineWidth: $t,
    calc: Mt
  } = _t, Bt = Mt($t).mul(-1).equal(), Vt = (zt) => {
    const Ht = `${Et}-compact${zt ? "-vertical" : ""}-item${Et}-primary:not([disabled])`;
    return {
      [`${Ht} + ${Ht}::before`]: {
        position: "absolute",
        top: zt ? Bt : 0,
        insetInlineStart: zt ? 0 : Bt,
        backgroundColor: Pt,
        content: '""',
        width: zt ? "100%" : $t,
        height: zt ? $t : "100%"
      }
    };
  };
  return Object.assign(Object.assign({}, Vt()), Vt(!0));
}, Compact = genSubStyleComponent(["Button", "compact"], (_t) => {
  const Et = prepareToken$2(_t);
  return [
    // Space Compact
    genCompactItemStyle(Et),
    genCompactItemVerticalStyle(Et),
    genButtonCompactStyle(Et)
  ];
}, prepareComponentToken$6);
var __rest$b = function(_t, Et) {
  var Pt = {};
  for (var $t in _t)
    Object.prototype.hasOwnProperty.call(_t, $t) && Et.indexOf($t) < 0 && (Pt[$t] = _t[$t]);
  if (_t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var Mt = 0, $t = Object.getOwnPropertySymbols(_t); Mt < $t.length; Mt++)
      Et.indexOf($t[Mt]) < 0 && Object.prototype.propertyIsEnumerable.call(_t, $t[Mt]) && (Pt[$t[Mt]] = _t[$t[Mt]]);
  return Pt;
};
function getLoadingConfig(_t) {
  if (typeof _t == "object" && _t) {
    let Et = _t == null ? void 0 : _t.delay;
    return Et = !Number.isNaN(Et) && typeof Et == "number" ? Et : 0, {
      loading: Et <= 0,
      delay: Et
    };
  }
  return {
    loading: !!_t,
    delay: 0
  };
}
const ButtonTypeMap = {
  default: ["default", "outlined"],
  primary: ["primary", "solid"],
  dashed: ["default", "dashed"],
  link: ["primary", "link"],
  text: ["default", "text"]
}, InternalCompoundedButton = /* @__PURE__ */ React__default.forwardRef((_t, Et) => {
  var Pt, $t, Mt, Bt;
  const {
    loading: Vt = !1,
    prefixCls: zt,
    color: Ht,
    variant: Wt,
    type: Gt,
    danger: qt = !1,
    shape: Kt = "default",
    size: Qt,
    styles: Xt,
    disabled: Zt,
    className: Yt,
    rootClassName: Jt,
    children: er,
    icon: tr,
    iconPosition: nr = "start",
    ghost: rr = !1,
    block: ir = !1,
    // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
    htmlType: ar = "button",
    classNames: or,
    style: sr = {},
    autoInsertSpace: lr,
    autoFocus: cr
  } = _t, hr = __rest$b(_t, ["loading", "prefixCls", "color", "variant", "type", "danger", "shape", "size", "styles", "disabled", "className", "rootClassName", "children", "icon", "iconPosition", "ghost", "block", "htmlType", "classNames", "style", "autoInsertSpace", "autoFocus"]), pr = Gt || "default", [mr, Er] = useMemo$1(() => {
    if (Ht && Wt)
      return [Ht, Wt];
    const Sr = ButtonTypeMap[pr] || [];
    return qt ? ["danger", Sr[1]] : Sr;
  }, [Gt, Ht, Wt, qt]), yr = mr === "danger" ? "dangerous" : mr, {
    getPrefixCls: ur,
    direction: vr,
    button: dr
  } = useContext(ConfigContext), br = (Pt = lr ?? (dr == null ? void 0 : dr.autoInsertSpace)) !== null && Pt !== void 0 ? Pt : !0, Cr = ur("btn", zt), [Pr, xr, kr] = useStyle$6(Cr), Ir = useContext(DisabledContext), Ar = Zt ?? Ir, Mr = useContext(GroupSizeContext), Fr = useMemo$1(() => getLoadingConfig(Vt), [Vt]), [Dr, zr] = useState(Fr.loading), [Tr, Gr] = useState(!1), $r = useRef(null), Rr = useComposeRef(Et, $r), Or = Children.count(er) === 1 && !tr && !isUnBorderedButtonVariant(Er), Lr = useRef(!0);
  React__default.useEffect(() => (Lr.current = !1, () => {
    Lr.current = !0;
  }), []), useEffect(() => {
    let Sr = null;
    Fr.delay > 0 ? Sr = setTimeout(() => {
      Sr = null, zr(!0);
    }, Fr.delay) : zr(Fr.loading);
    function Nr() {
      Sr && (clearTimeout(Sr), Sr = null);
    }
    return Nr;
  }, [Fr]), useEffect(() => {
    if (!$r.current || !br)
      return;
    const Sr = $r.current.textContent || "";
    Or && isTwoCNChar(Sr) ? Tr || Gr(!0) : Tr && Gr(!1);
  }), useEffect(() => {
    cr && $r.current && $r.current.focus();
  }, []);
  const Hr = React__default.useCallback((Sr) => {
    var Nr;
    if (Dr || Ar) {
      Sr.preventDefault();
      return;
    }
    (Nr = _t.onClick) === null || Nr === void 0 || Nr.call(_t, Sr);
  }, [_t.onClick, Dr, Ar]);
  if (browser$1.env.NODE_ENV !== "production") {
    const Sr = devUseWarning("Button");
    browser$1.env.NODE_ENV !== "production" && Sr(!(typeof tr == "string" && tr.length > 2), "breaking", `\`icon\` is using ReactNode instead of string naming in v4. Please check \`${tr}\` at https://ant.design/components/icon`), browser$1.env.NODE_ENV !== "production" && Sr(!(rr && isUnBorderedButtonVariant(Er)), "usage", "`link` or `text` button can't be a `ghost` button.");
  }
  const {
    compactSize: Wr,
    compactItemClassnames: Kr
  } = useCompactItemContext(Cr, vr), Ur = {
    large: "lg",
    small: "sm",
    middle: void 0
  }, Zr = useSize((Sr) => {
    var Nr, jr;
    return (jr = (Nr = Qt ?? Wr) !== null && Nr !== void 0 ? Nr : Mr) !== null && jr !== void 0 ? jr : Sr;
  }), Xr = Zr && ($t = Ur[Zr]) !== null && $t !== void 0 ? $t : "", mn = Dr ? "loading" : tr, an = omit(hr, ["navigate"]), nn = classNames(Cr, xr, kr, {
    [`${Cr}-${Kt}`]: Kt !== "default" && Kt,
    // line(253 - 254): Compatible with versions earlier than 5.21.0
    [`${Cr}-${pr}`]: pr,
    [`${Cr}-dangerous`]: qt,
    [`${Cr}-color-${yr}`]: yr,
    [`${Cr}-variant-${Er}`]: Er,
    [`${Cr}-${Xr}`]: Xr,
    [`${Cr}-icon-only`]: !er && er !== 0 && !!mn,
    [`${Cr}-background-ghost`]: rr && !isUnBorderedButtonVariant(Er),
    [`${Cr}-loading`]: Dr,
    [`${Cr}-two-chinese-chars`]: Tr && br && !Dr,
    [`${Cr}-block`]: ir,
    [`${Cr}-rtl`]: vr === "rtl",
    [`${Cr}-icon-end`]: nr === "end"
  }, Kr, Yt, Jt, dr == null ? void 0 : dr.className), $n = Object.assign(Object.assign({}, dr == null ? void 0 : dr.style), sr), En = classNames(or == null ? void 0 : or.icon, (Mt = dr == null ? void 0 : dr.classNames) === null || Mt === void 0 ? void 0 : Mt.icon), xn = Object.assign(Object.assign({}, (Xt == null ? void 0 : Xt.icon) || {}), ((Bt = dr == null ? void 0 : dr.styles) === null || Bt === void 0 ? void 0 : Bt.icon) || {}), qr = tr && !Dr ? /* @__PURE__ */ React__default.createElement(IconWrapper, {
    prefixCls: Cr,
    className: En,
    style: xn
  }, tr) : typeof Vt == "object" && Vt.icon ? /* @__PURE__ */ React__default.createElement(IconWrapper, {
    prefixCls: Cr,
    className: En,
    style: xn
  }, Vt.icon) : /* @__PURE__ */ React__default.createElement(DefaultLoadingIcon, {
    existIcon: !!tr,
    prefixCls: Cr,
    loading: Dr,
    mount: Lr.current
  }), tn = er || er === 0 ? spaceChildren(er, Or && br) : null;
  if (an.href !== void 0)
    return Pr(/* @__PURE__ */ React__default.createElement("a", Object.assign({}, an, {
      className: classNames(nn, {
        [`${Cr}-disabled`]: Ar
      }),
      href: Ar ? void 0 : an.href,
      style: $n,
      onClick: Hr,
      ref: Rr,
      tabIndex: Ar ? -1 : 0
    }), qr, tn));
  let gr = /* @__PURE__ */ React__default.createElement("button", Object.assign({}, hr, {
    type: ar,
    className: nn,
    style: $n,
    onClick: Hr,
    disabled: Ar,
    ref: Rr
  }), qr, tn, Kr && /* @__PURE__ */ React__default.createElement(Compact, {
    prefixCls: Cr
  }));
  return isUnBorderedButtonVariant(Er) || (gr = /* @__PURE__ */ React__default.createElement(Wave, {
    component: "Button",
    disabled: Dr
  }, gr)), Pr(gr);
}), Button = InternalCompoundedButton;
Button.Group = ButtonGroup;
Button.__ANT_BUTTON = !0;
browser$1.env.NODE_ENV !== "production" && (Button.displayName = "Button");
function isThenable$1(_t) {
  return !!(_t != null && _t.then);
}
const ActionButton = (_t) => {
  const {
    type: Et,
    children: Pt,
    prefixCls: $t,
    buttonProps: Mt,
    close: Bt,
    autoFocus: Vt,
    emitEvent: zt,
    isSilent: Ht,
    quitOnNullishReturnValue: Wt,
    actionFn: Gt
  } = _t, qt = React.useRef(!1), Kt = React.useRef(null), [Qt, Xt] = useSafeState(!1), Zt = function() {
    Bt == null || Bt.apply(void 0, arguments);
  };
  React.useEffect(() => {
    let er = null;
    return Vt && (er = setTimeout(() => {
      var tr;
      (tr = Kt.current) === null || tr === void 0 || tr.focus({
        preventScroll: !0
      });
    })), () => {
      er && clearTimeout(er);
    };
  }, []);
  const Yt = (er) => {
    isThenable$1(er) && (Xt(!0), er.then(function() {
      Xt(!1, !0), Zt.apply(void 0, arguments), qt.current = !1;
    }, (tr) => {
      if (Xt(!1, !0), qt.current = !1, !(Ht != null && Ht()))
        return Promise.reject(tr);
    }));
  }, Jt = (er) => {
    if (qt.current)
      return;
    if (qt.current = !0, !Gt) {
      Zt();
      return;
    }
    let tr;
    if (zt) {
      if (tr = Gt(er), Wt && !isThenable$1(tr)) {
        qt.current = !1, Zt(er);
        return;
      }
    } else if (Gt.length)
      tr = Gt(Bt), qt.current = !1;
    else if (tr = Gt(), !isThenable$1(tr)) {
      Zt();
      return;
    }
    Yt(tr);
  };
  return /* @__PURE__ */ React.createElement(Button, Object.assign({}, convertLegacyProps(Et), {
    onClick: Jt,
    loading: Qt,
    prefixCls: $t
  }, Mt, {
    ref: Kt
  }), Pt);
}, ModalContext = /* @__PURE__ */ React__default.createContext({}), {
  Provider: ModalContextProvider
} = ModalContext, ConfirmCancelBtn = () => {
  const {
    autoFocusButton: _t,
    cancelButtonProps: Et,
    cancelTextLocale: Pt,
    isSilent: $t,
    mergedOkCancel: Mt,
    rootPrefixCls: Bt,
    close: Vt,
    onCancel: zt,
    onConfirm: Ht
  } = useContext(ModalContext);
  return Mt ? /* @__PURE__ */ React__default.createElement(ActionButton, {
    isSilent: $t,
    actionFn: zt,
    close: function() {
      Vt == null || Vt.apply(void 0, arguments), Ht == null || Ht(!1);
    },
    autoFocus: _t === "cancel",
    buttonProps: Et,
    prefixCls: `${Bt}-btn`
  }, Pt) : null;
}, ConfirmOkBtn = () => {
  const {
    autoFocusButton: _t,
    close: Et,
    isSilent: Pt,
    okButtonProps: $t,
    rootPrefixCls: Mt,
    okTextLocale: Bt,
    okType: Vt,
    onConfirm: zt,
    onOk: Ht
  } = useContext(ModalContext);
  return /* @__PURE__ */ React__default.createElement(ActionButton, {
    isSilent: Pt,
    type: Vt || "primary",
    actionFn: Ht,
    close: function() {
      Et == null || Et.apply(void 0, arguments), zt == null || zt(!0);
    },
    autoFocus: _t === "ok",
    buttonProps: $t,
    prefixCls: `${Mt}-btn`
  }, Bt);
};
var OrderContext = /* @__PURE__ */ React.createContext(null), EMPTY_LIST$1 = [];
function useDom(_t, Et) {
  var Pt = React.useState(function() {
    if (!canUseDom())
      return null;
    var Xt = document.createElement("div");
    return browser$1.env.NODE_ENV !== "production" && Et && Xt.setAttribute("data-debug", Et), Xt;
  }), $t = _slicedToArray(Pt, 1), Mt = $t[0], Bt = React.useRef(!1), Vt = React.useContext(OrderContext), zt = React.useState(EMPTY_LIST$1), Ht = _slicedToArray(zt, 2), Wt = Ht[0], Gt = Ht[1], qt = Vt || (Bt.current ? void 0 : function(Xt) {
    Gt(function(Zt) {
      var Yt = [Xt].concat(_toConsumableArray(Zt));
      return Yt;
    });
  });
  function Kt() {
    Mt.parentElement || document.body.appendChild(Mt), Bt.current = !0;
  }
  function Qt() {
    var Xt;
    (Xt = Mt.parentElement) === null || Xt === void 0 || Xt.removeChild(Mt), Bt.current = !1;
  }
  return useLayoutEffect(function() {
    return _t ? Vt ? Vt(Kt) : Kt() : Qt(), Qt;
  }, [_t]), useLayoutEffect(function() {
    Wt.length && (Wt.forEach(function(Xt) {
      return Xt();
    }), Gt(EMPTY_LIST$1));
  }, [Wt]), [Mt, qt];
}
function measureScrollbarSize(_t) {
  var Et = "rc-scrollbar-measure-".concat(Math.random().toString(36).substring(7)), Pt = document.createElement("div");
  Pt.id = Et;
  var $t = Pt.style;
  $t.position = "absolute", $t.left = "0", $t.top = "0", $t.width = "100px", $t.height = "100px", $t.overflow = "scroll";
  var Mt, Bt;
  if (_t) {
    var Vt = getComputedStyle(_t);
    $t.scrollbarColor = Vt.scrollbarColor, $t.scrollbarWidth = Vt.scrollbarWidth;
    var zt = getComputedStyle(_t, "::-webkit-scrollbar"), Ht = parseInt(zt.width, 10), Wt = parseInt(zt.height, 10);
    try {
      var Gt = Ht ? "width: ".concat(zt.width, ";") : "", qt = Wt ? "height: ".concat(zt.height, ";") : "";
      updateCSS(`
#`.concat(Et, `::-webkit-scrollbar {
`).concat(Gt, `
`).concat(qt, `
}`), Et);
    } catch (Xt) {
      console.error(Xt), Mt = Ht, Bt = Wt;
    }
  }
  document.body.appendChild(Pt);
  var Kt = _t && Mt && !isNaN(Mt) ? Mt : Pt.offsetWidth - Pt.clientWidth, Qt = _t && Bt && !isNaN(Bt) ? Bt : Pt.offsetHeight - Pt.clientHeight;
  return document.body.removeChild(Pt), removeCSS(Et), {
    width: Kt,
    height: Qt
  };
}
function getTargetScrollBarSize(_t) {
  return typeof document > "u" || !_t || !(_t instanceof Element) ? {
    width: 0,
    height: 0
  } : measureScrollbarSize(_t);
}
function isBodyOverflowing() {
  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}
var UNIQUE_ID = "rc-util-locker-".concat(Date.now()), uuid$3 = 0;
function useScrollLocker(_t) {
  var Et = !!_t, Pt = React.useState(function() {
    return uuid$3 += 1, "".concat(UNIQUE_ID, "_").concat(uuid$3);
  }), $t = _slicedToArray(Pt, 1), Mt = $t[0];
  useLayoutEffect(function() {
    if (Et) {
      var Bt = getTargetScrollBarSize(document.body).width, Vt = isBodyOverflowing();
      updateCSS(`
html body {
  overflow-y: hidden;
  `.concat(Vt ? "width: calc(100% - ".concat(Bt, "px);") : "", `
}`), Mt);
    } else
      removeCSS(Mt);
    return function() {
      removeCSS(Mt);
    };
  }, [Et, Mt]);
}
var inline = !1;
function inlineMock(_t) {
  return inline;
}
var getPortalContainer = function(Et) {
  return Et === !1 ? !1 : !canUseDom() || !Et ? null : typeof Et == "string" ? document.querySelector(Et) : typeof Et == "function" ? Et() : Et;
}, Portal = /* @__PURE__ */ React.forwardRef(function(_t, Et) {
  var Pt = _t.open, $t = _t.autoLock, Mt = _t.getContainer, Bt = _t.debug, Vt = _t.autoDestroy, zt = Vt === void 0 ? !0 : Vt, Ht = _t.children, Wt = React.useState(Pt), Gt = _slicedToArray(Wt, 2), qt = Gt[0], Kt = Gt[1], Qt = qt || Pt;
  browser$1.env.NODE_ENV !== "production" && warningOnce(canUseDom() || !Pt, "Portal only work in client side. Please call 'useEffect' to show Portal instead default render in SSR."), React.useEffect(function() {
    (zt || Pt) && Kt(Pt);
  }, [Pt, zt]);
  var Xt = React.useState(function() {
    return getPortalContainer(Mt);
  }), Zt = _slicedToArray(Xt, 2), Yt = Zt[0], Jt = Zt[1];
  React.useEffect(function() {
    var hr = getPortalContainer(Mt);
    Jt(hr ?? null);
  });
  var er = useDom(Qt && !Yt, Bt), tr = _slicedToArray(er, 2), nr = tr[0], rr = tr[1], ir = Yt ?? nr;
  useScrollLocker($t && Pt && canUseDom() && (ir === nr || ir === document.body));
  var ar = null;
  if (Ht && supportRef(Ht) && Et) {
    var or = Ht;
    ar = or.ref;
  }
  var sr = useComposeRef(ar, Et);
  if (!Qt || !canUseDom() || Yt === void 0)
    return null;
  var lr = ir === !1 || inlineMock(), cr = Ht;
  return Et && (cr = /* @__PURE__ */ React.cloneElement(Ht, {
    ref: sr
  })), /* @__PURE__ */ React.createElement(OrderContext.Provider, {
    value: rr
  }, lr ? cr : /* @__PURE__ */ createPortal(cr, ir));
});
browser$1.env.NODE_ENV !== "production" && (Portal.displayName = "Portal");
var RefContext = /* @__PURE__ */ React.createContext({});
function getUseId() {
  var _t = _objectSpread2({}, React);
  return _t.useId;
}
var uuid$2 = 0, useOriginId = getUseId();
const useId = useOriginId ? (
  // Use React `useId`
  function(Et) {
    var Pt = useOriginId();
    return Et || (browser$1.env.NODE_ENV === "test" ? "test-id" : Pt);
  }
) : (
  // Use compatible of `useId`
  function(Et) {
    var Pt = React.useState("ssr-id"), $t = _slicedToArray(Pt, 2), Mt = $t[0], Bt = $t[1];
    return React.useEffect(function() {
      var Vt = uuid$2;
      uuid$2 += 1, Bt("rc_unique_".concat(Vt));
    }, []), Et || (browser$1.env.NODE_ENV === "test" ? "test-id" : Mt);
  }
);
function getMotionName(_t, Et, Pt) {
  var $t = Et;
  return !$t && Pt && ($t = "".concat(_t, "-").concat(Pt)), $t;
}
function getScroll(_t, Et) {
  var Pt = _t["page".concat(Et ? "Y" : "X", "Offset")], $t = "scroll".concat(Et ? "Top" : "Left");
  if (typeof Pt != "number") {
    var Mt = _t.document;
    Pt = Mt.documentElement[$t], typeof Pt != "number" && (Pt = Mt.body[$t]);
  }
  return Pt;
}
function offset$1(_t) {
  var Et = _t.getBoundingClientRect(), Pt = {
    left: Et.left,
    top: Et.top
  }, $t = _t.ownerDocument, Mt = $t.defaultView || $t.parentWindow;
  return Pt.left += getScroll(Mt), Pt.top += getScroll(Mt, !0), Pt;
}
const MemoChildren = /* @__PURE__ */ React.memo(function(_t) {
  var Et = _t.children;
  return Et;
}, function(_t, Et) {
  var Pt = Et.shouldUpdate;
  return !Pt;
});
var sentinelStyle = {
  width: 0,
  height: 0,
  overflow: "hidden",
  outline: "none"
}, entityStyle = {
  outline: "none"
}, Panel = /* @__PURE__ */ React__default.forwardRef(function(_t, Et) {
  var Pt = _t.prefixCls, $t = _t.className, Mt = _t.style, Bt = _t.title, Vt = _t.ariaId, zt = _t.footer, Ht = _t.closable, Wt = _t.closeIcon, Gt = _t.onClose, qt = _t.children, Kt = _t.bodyStyle, Qt = _t.bodyProps, Xt = _t.modalRender, Zt = _t.onMouseDown, Yt = _t.onMouseUp, Jt = _t.holderRef, er = _t.visible, tr = _t.forceRender, nr = _t.width, rr = _t.height, ir = _t.classNames, ar = _t.styles, or = React__default.useContext(RefContext), sr = or.panel, lr = useComposeRef(Jt, sr), cr = useRef(), hr = useRef();
  React__default.useImperativeHandle(Et, function() {
    return {
      focus: function() {
        var Cr;
        (Cr = cr.current) === null || Cr === void 0 || Cr.focus({
          preventScroll: !0
        });
      },
      changeActive: function(Cr) {
        var Pr = document, xr = Pr.activeElement;
        Cr && xr === hr.current ? cr.current.focus({
          preventScroll: !0
        }) : !Cr && xr === cr.current && hr.current.focus({
          preventScroll: !0
        });
      }
    };
  });
  var pr = {};
  nr !== void 0 && (pr.width = nr), rr !== void 0 && (pr.height = rr);
  var mr = zt ? /* @__PURE__ */ React__default.createElement("div", {
    className: classNames("".concat(Pt, "-footer"), ir == null ? void 0 : ir.footer),
    style: _objectSpread2({}, ar == null ? void 0 : ar.footer)
  }, zt) : null, Er = Bt ? /* @__PURE__ */ React__default.createElement("div", {
    className: classNames("".concat(Pt, "-header"), ir == null ? void 0 : ir.header),
    style: _objectSpread2({}, ar == null ? void 0 : ar.header)
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "".concat(Pt, "-title"),
    id: Vt
  }, Bt)) : null, _r = useMemo$1(function() {
    return _typeof(Ht) === "object" && Ht !== null ? Ht : Ht ? {
      closeIcon: Wt ?? /* @__PURE__ */ React__default.createElement("span", {
        className: "".concat(Pt, "-close-x")
      })
    } : {};
  }, [Ht, Wt, Pt]), yr = pickAttrs(_r, !0), ur = _typeof(Ht) === "object" && Ht.disabled, vr = Ht ? /* @__PURE__ */ React__default.createElement("button", _extends$2({
    type: "button",
    onClick: Gt,
    "aria-label": "Close"
  }, yr, {
    className: "".concat(Pt, "-close"),
    disabled: ur
  }), _r.closeIcon) : null, dr = /* @__PURE__ */ React__default.createElement("div", {
    className: classNames("".concat(Pt, "-content"), ir == null ? void 0 : ir.content),
    style: ar == null ? void 0 : ar.content
  }, vr, Er, /* @__PURE__ */ React__default.createElement("div", _extends$2({
    className: classNames("".concat(Pt, "-body"), ir == null ? void 0 : ir.body),
    style: _objectSpread2(_objectSpread2({}, Kt), ar == null ? void 0 : ar.body)
  }, Qt), qt), mr);
  return /* @__PURE__ */ React__default.createElement("div", {
    key: "dialog-element",
    role: "dialog",
    "aria-labelledby": Bt ? Vt : null,
    "aria-modal": "true",
    ref: lr,
    style: _objectSpread2(_objectSpread2({}, Mt), pr),
    className: classNames(Pt, $t),
    onMouseDown: Zt,
    onMouseUp: Yt
  }, /* @__PURE__ */ React__default.createElement("div", {
    ref: cr,
    tabIndex: 0,
    style: entityStyle
  }, /* @__PURE__ */ React__default.createElement(MemoChildren, {
    shouldUpdate: er || tr
  }, Xt ? Xt(dr) : dr)), /* @__PURE__ */ React__default.createElement("div", {
    tabIndex: 0,
    ref: hr,
    style: sentinelStyle
  }));
});
browser$1.env.NODE_ENV !== "production" && (Panel.displayName = "Panel");
var Content = /* @__PURE__ */ React.forwardRef(function(_t, Et) {
  var Pt = _t.prefixCls, $t = _t.title, Mt = _t.style, Bt = _t.className, Vt = _t.visible, zt = _t.forceRender, Ht = _t.destroyOnClose, Wt = _t.motionName, Gt = _t.ariaId, qt = _t.onVisibleChanged, Kt = _t.mousePosition, Qt = useRef(), Xt = React.useState(), Zt = _slicedToArray(Xt, 2), Yt = Zt[0], Jt = Zt[1], er = {};
  Yt && (er.transformOrigin = Yt);
  function tr() {
    var nr = offset$1(Qt.current);
    Jt(Kt && (Kt.x || Kt.y) ? "".concat(Kt.x - nr.left, "px ").concat(Kt.y - nr.top, "px") : "");
  }
  return /* @__PURE__ */ React.createElement(CSSMotion, {
    visible: Vt,
    onVisibleChanged: qt,
    onAppearPrepare: tr,
    onEnterPrepare: tr,
    forceRender: zt,
    motionName: Wt,
    removeOnLeave: Ht,
    ref: Qt
  }, function(nr, rr) {
    var ir = nr.className, ar = nr.style;
    return /* @__PURE__ */ React.createElement(Panel, _extends$2({}, _t, {
      ref: Et,
      title: $t,
      ariaId: Gt,
      prefixCls: Pt,
      holderRef: rr,
      style: _objectSpread2(_objectSpread2(_objectSpread2({}, ar), Mt), er),
      className: classNames(Bt, ir)
    }));
  });
});
Content.displayName = "Content";
var Mask$1 = function(Et) {
  var Pt = Et.prefixCls, $t = Et.style, Mt = Et.visible, Bt = Et.maskProps, Vt = Et.motionName, zt = Et.className;
  return /* @__PURE__ */ React.createElement(CSSMotion, {
    key: "mask",
    visible: Mt,
    motionName: Vt,
    leavedClassName: "".concat(Pt, "-mask-hidden")
  }, function(Ht, Wt) {
    var Gt = Ht.className, qt = Ht.style;
    return /* @__PURE__ */ React.createElement("div", _extends$2({
      ref: Wt,
      style: _objectSpread2(_objectSpread2({}, qt), $t),
      className: classNames("".concat(Pt, "-mask"), Gt, zt)
    }, Bt));
  });
}, Dialog = function(Et) {
  var Pt = Et.prefixCls, $t = Pt === void 0 ? "rc-dialog" : Pt, Mt = Et.zIndex, Bt = Et.visible, Vt = Bt === void 0 ? !1 : Bt, zt = Et.keyboard, Ht = zt === void 0 ? !0 : zt, Wt = Et.focusTriggerAfterClose, Gt = Wt === void 0 ? !0 : Wt, qt = Et.wrapStyle, Kt = Et.wrapClassName, Qt = Et.wrapProps, Xt = Et.onClose, Zt = Et.afterOpenChange, Yt = Et.afterClose, Jt = Et.transitionName, er = Et.animation, tr = Et.closable, nr = tr === void 0 ? !0 : tr, rr = Et.mask, ir = rr === void 0 ? !0 : rr, ar = Et.maskTransitionName, or = Et.maskAnimation, sr = Et.maskClosable, lr = sr === void 0 ? !0 : sr, cr = Et.maskStyle, hr = Et.maskProps, pr = Et.rootClassName, mr = Et.classNames, Er = Et.styles;
  browser$1.env.NODE_ENV !== "production" && (["wrapStyle", "bodyStyle", "maskStyle"].forEach(function(Rr) {
    warning$3(!(Rr in Et), "".concat(Rr, " is deprecated, please use styles instead."));
  }), "wrapClassName" in Et && warning$3(!1, "wrapClassName is deprecated, please use classNames instead."));
  var _r = useRef(), yr = useRef(), ur = useRef(), vr = React.useState(Vt), dr = _slicedToArray(vr, 2), br = dr[0], Cr = dr[1], Pr = useId();
  function xr() {
    contains(yr.current, document.activeElement) || (_r.current = document.activeElement);
  }
  function kr() {
    if (!contains(yr.current, document.activeElement)) {
      var Rr;
      (Rr = ur.current) === null || Rr === void 0 || Rr.focus();
    }
  }
  function Ir(Rr) {
    if (Rr)
      kr();
    else {
      if (Cr(!1), ir && _r.current && Gt) {
        try {
          _r.current.focus({
            preventScroll: !0
          });
        } catch {
        }
        _r.current = null;
      }
      br && (Yt == null || Yt());
    }
    Zt == null || Zt(Rr);
  }
  function Ar(Rr) {
    Xt == null || Xt(Rr);
  }
  var Mr = useRef(!1), Fr = useRef(), Dr = function() {
    clearTimeout(Fr.current), Mr.current = !0;
  }, zr = function() {
    Fr.current = setTimeout(function() {
      Mr.current = !1;
    });
  }, Tr = null;
  lr && (Tr = function(Or) {
    Mr.current ? Mr.current = !1 : yr.current === Or.target && Ar(Or);
  });
  function Gr(Rr) {
    if (Ht && Rr.keyCode === KeyCode.ESC) {
      Rr.stopPropagation(), Ar(Rr);
      return;
    }
    Vt && Rr.keyCode === KeyCode.TAB && ur.current.changeActive(!Rr.shiftKey);
  }
  useEffect(function() {
    Vt && (Cr(!0), xr());
  }, [Vt]), useEffect(function() {
    return function() {
      clearTimeout(Fr.current);
    };
  }, []);
  var $r = _objectSpread2(_objectSpread2(_objectSpread2({
    zIndex: Mt
  }, qt), Er == null ? void 0 : Er.wrapper), {}, {
    display: br ? null : "none"
  });
  return /* @__PURE__ */ React.createElement("div", _extends$2({
    className: classNames("".concat($t, "-root"), pr)
  }, pickAttrs(Et, {
    data: !0
  })), /* @__PURE__ */ React.createElement(Mask$1, {
    prefixCls: $t,
    visible: ir && Vt,
    motionName: getMotionName($t, ar, or),
    style: _objectSpread2(_objectSpread2({
      zIndex: Mt
    }, cr), Er == null ? void 0 : Er.mask),
    maskProps: hr,
    className: mr == null ? void 0 : mr.mask
  }), /* @__PURE__ */ React.createElement("div", _extends$2({
    tabIndex: -1,
    onKeyDown: Gr,
    className: classNames("".concat($t, "-wrap"), Kt, mr == null ? void 0 : mr.wrapper),
    ref: yr,
    onClick: Tr,
    style: $r
  }, Qt), /* @__PURE__ */ React.createElement(Content, _extends$2({}, Et, {
    onMouseDown: Dr,
    onMouseUp: zr,
    ref: ur,
    closable: nr,
    ariaId: Pr,
    prefixCls: $t,
    visible: Vt && br,
    onClose: Ar,
    onVisibleChanged: Ir,
    motionName: getMotionName($t, Jt, er)
  }))));
}, DialogWrap = function(Et) {
  var Pt = Et.visible, $t = Et.getContainer, Mt = Et.forceRender, Bt = Et.destroyOnClose, Vt = Bt === void 0 ? !1 : Bt, zt = Et.afterClose, Ht = Et.panelRef, Wt = React.useState(Pt), Gt = _slicedToArray(Wt, 2), qt = Gt[0], Kt = Gt[1], Qt = React.useMemo(function() {
    return {
      panel: Ht
    };
  }, [Ht]);
  return React.useEffect(function() {
    Pt && Kt(!0);
  }, [Pt]), !Mt && Vt && !qt ? null : /* @__PURE__ */ React.createElement(RefContext.Provider, {
    value: Qt
  }, /* @__PURE__ */ React.createElement(Portal, {
    open: Pt || Mt || qt,
    autoDestroy: !1,
    getContainer: $t,
    autoLock: Pt || qt
  }, /* @__PURE__ */ React.createElement(Dialog, _extends$2({}, Et, {
    destroyOnClose: Vt,
    afterClose: function() {
      zt == null || zt(), Kt(!1);
    }
  }))));
};
DialogWrap.displayName = "Dialog";
var HOOK_MARK = "RC_FORM_INTERNAL_HOOKS", warningFunc = function() {
  warningOnce(!1, "Can not find FormContext. Please make sure you wrap Field under Form.");
}, Context = /* @__PURE__ */ React.createContext({
  getFieldValue: warningFunc,
  getFieldsValue: warningFunc,
  getFieldError: warningFunc,
  getFieldWarning: warningFunc,
  getFieldsError: warningFunc,
  isFieldsTouched: warningFunc,
  isFieldTouched: warningFunc,
  isFieldValidating: warningFunc,
  isFieldsValidating: warningFunc,
  resetFields: warningFunc,
  setFields: warningFunc,
  setFieldValue: warningFunc,
  setFieldsValue: warningFunc,
  validateFields: warningFunc,
  submit: warningFunc,
  getInternalHooks: function() {
    return warningFunc(), {
      dispatch: warningFunc,
      initEntityValue: warningFunc,
      registerField: warningFunc,
      useSubscribe: warningFunc,
      setInitialValues: warningFunc,
      destroyForm: warningFunc,
      setCallbacks: warningFunc,
      registerWatch: warningFunc,
      getFields: warningFunc,
      setValidateMessages: warningFunc,
      setPreserve: warningFunc,
      getInitialValue: warningFunc
    };
  }
}), ListContext = /* @__PURE__ */ React.createContext(null);
function toArray$3(_t) {
  return _t == null ? [] : Array.isArray(_t) ? _t : [_t];
}
function isFormInstance(_t) {
  return _t && !!_t._init;
}
function newMessages() {
  return {
    default: "Validation error on field %s",
    required: "%s is required",
    enum: "%s must be one of %s",
    whitespace: "%s cannot be empty",
    date: {
      format: "%s date %s is invalid for format %s",
      parse: "%s date could not be parsed, %s is invalid ",
      invalid: "%s date %s is invalid"
    },
    types: {
      string: "%s is not a %s",
      method: "%s is not a %s (function)",
      array: "%s is not an %s",
      object: "%s is not an %s",
      number: "%s is not a %s",
      date: "%s is not a %s",
      boolean: "%s is not a %s",
      integer: "%s is not an %s",
      float: "%s is not a %s",
      regexp: "%s is not a valid %s",
      email: "%s is not a valid %s",
      url: "%s is not a valid %s",
      hex: "%s is not a valid %s"
    },
    string: {
      len: "%s must be exactly %s characters",
      min: "%s must be at least %s characters",
      max: "%s cannot be longer than %s characters",
      range: "%s must be between %s and %s characters"
    },
    number: {
      len: "%s must equal %s",
      min: "%s cannot be less than %s",
      max: "%s cannot be greater than %s",
      range: "%s must be between %s and %s"
    },
    array: {
      len: "%s must be exactly %s in length",
      min: "%s cannot be less than %s in length",
      max: "%s cannot be greater than %s in length",
      range: "%s must be between %s and %s in length"
    },
    pattern: {
      mismatch: "%s value %s does not match pattern %s"
    },
    clone: function() {
      var Et = JSON.parse(JSON.stringify(this));
      return Et.clone = this.clone, Et;
    }
  };
}
var messages = newMessages();
function _isNativeFunction(_t) {
  try {
    return Function.toString.call(_t).indexOf("[native code]") !== -1;
  } catch {
    return typeof _t == "function";
  }
}
function _construct(_t, Et, Pt) {
  if (_isNativeReflectConstruct())
    return Reflect.construct.apply(null, arguments);
  var $t = [null];
  $t.push.apply($t, Et);
  var Mt = new (_t.bind.apply(_t, $t))();
  return Pt && _setPrototypeOf(Mt, Pt.prototype), Mt;
}
function _wrapNativeSuper(_t) {
  var Et = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return _wrapNativeSuper = function($t) {
    if ($t === null || !_isNativeFunction($t))
      return $t;
    if (typeof $t != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (Et !== void 0) {
      if (Et.has($t))
        return Et.get($t);
      Et.set($t, Mt);
    }
    function Mt() {
      return _construct($t, arguments, _getPrototypeOf(this).constructor);
    }
    return Mt.prototype = Object.create($t.prototype, {
      constructor: {
        value: Mt,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf(Mt, $t);
  }, _wrapNativeSuper(_t);
}
var formatRegExp = /%[sdj%]/g, warning = function() {
};
typeof browser$1 < "u" && browser$1.env && browser$1.env.NODE_ENV !== "production" && typeof window < "u" && typeof document < "u" && (warning = function(Et, Pt) {
  typeof console < "u" && console.warn && typeof ASYNC_VALIDATOR_NO_WARNING > "u" && Pt.every(function($t) {
    return typeof $t == "string";
  }) && console.warn(Et, Pt);
});
function convertFieldsError(_t) {
  if (!_t || !_t.length)
    return null;
  var Et = {};
  return _t.forEach(function(Pt) {
    var $t = Pt.field;
    Et[$t] = Et[$t] || [], Et[$t].push(Pt);
  }), Et;
}
function format$1(_t) {
  for (var Et = arguments.length, Pt = new Array(Et > 1 ? Et - 1 : 0), $t = 1; $t < Et; $t++)
    Pt[$t - 1] = arguments[$t];
  var Mt = 0, Bt = Pt.length;
  if (typeof _t == "function")
    return _t.apply(null, Pt);
  if (typeof _t == "string") {
    var Vt = _t.replace(formatRegExp, function(zt) {
      if (zt === "%%")
        return "%";
      if (Mt >= Bt)
        return zt;
      switch (zt) {
        case "%s":
          return String(Pt[Mt++]);
        case "%d":
          return Number(Pt[Mt++]);
        case "%j":
          try {
            return JSON.stringify(Pt[Mt++]);
          } catch {
            return "[Circular]";
          }
          break;
        default:
          return zt;
      }
    });
    return Vt;
  }
  return _t;
}
function isNativeStringType(_t) {
  return _t === "string" || _t === "url" || _t === "hex" || _t === "email" || _t === "date" || _t === "pattern";
}
function isEmptyValue(_t, Et) {
  return !!(_t == null || Et === "array" && Array.isArray(_t) && !_t.length || isNativeStringType(Et) && typeof _t == "string" && !_t);
}
function asyncParallelArray(_t, Et, Pt) {
  var $t = [], Mt = 0, Bt = _t.length;
  function Vt(zt) {
    $t.push.apply($t, _toConsumableArray(zt || [])), Mt++, Mt === Bt && Pt($t);
  }
  _t.forEach(function(zt) {
    Et(zt, Vt);
  });
}
function asyncSerialArray(_t, Et, Pt) {
  var $t = 0, Mt = _t.length;
  function Bt(Vt) {
    if (Vt && Vt.length) {
      Pt(Vt);
      return;
    }
    var zt = $t;
    $t = $t + 1, zt < Mt ? Et(_t[zt], Bt) : Pt([]);
  }
  Bt([]);
}
function flattenObjArr(_t) {
  var Et = [];
  return Object.keys(_t).forEach(function(Pt) {
    Et.push.apply(Et, _toConsumableArray(_t[Pt] || []));
  }), Et;
}
var AsyncValidationError = /* @__PURE__ */ function(_t) {
  _inherits(Pt, _t);
  var Et = _createSuper(Pt);
  function Pt($t, Mt) {
    var Bt;
    return _classCallCheck(this, Pt), Bt = Et.call(this, "Async Validation Error"), _defineProperty(_assertThisInitialized(Bt), "errors", void 0), _defineProperty(_assertThisInitialized(Bt), "fields", void 0), Bt.errors = $t, Bt.fields = Mt, Bt;
  }
  return _createClass(Pt);
}(/* @__PURE__ */ _wrapNativeSuper(Error));
function asyncMap(_t, Et, Pt, $t, Mt) {
  if (Et.first) {
    var Bt = new Promise(function(Kt, Qt) {
      var Xt = function(Jt) {
        return $t(Jt), Jt.length ? Qt(new AsyncValidationError(Jt, convertFieldsError(Jt))) : Kt(Mt);
      }, Zt = flattenObjArr(_t);
      asyncSerialArray(Zt, Pt, Xt);
    });
    return Bt.catch(function(Kt) {
      return Kt;
    }), Bt;
  }
  var Vt = Et.firstFields === !0 ? Object.keys(_t) : Et.firstFields || [], zt = Object.keys(_t), Ht = zt.length, Wt = 0, Gt = [], qt = new Promise(function(Kt, Qt) {
    var Xt = function(Yt) {
      if (Gt.push.apply(Gt, Yt), Wt++, Wt === Ht)
        return $t(Gt), Gt.length ? Qt(new AsyncValidationError(Gt, convertFieldsError(Gt))) : Kt(Mt);
    };
    zt.length || ($t(Gt), Kt(Mt)), zt.forEach(function(Zt) {
      var Yt = _t[Zt];
      Vt.indexOf(Zt) !== -1 ? asyncSerialArray(Yt, Pt, Xt) : asyncParallelArray(Yt, Pt, Xt);
    });
  });
  return qt.catch(function(Kt) {
    return Kt;
  }), qt;
}
function isErrorObj(_t) {
  return !!(_t && _t.message !== void 0);
}
function getValue(_t, Et) {
  for (var Pt = _t, $t = 0; $t < Et.length; $t++) {
    if (Pt == null)
      return Pt;
    Pt = Pt[Et[$t]];
  }
  return Pt;
}
function complementError(_t, Et) {
  return function(Pt) {
    var $t;
    return _t.fullFields ? $t = getValue(Et, _t.fullFields) : $t = Et[Pt.field || _t.fullField], isErrorObj(Pt) ? (Pt.field = Pt.field || _t.fullField, Pt.fieldValue = $t, Pt) : {
      message: typeof Pt == "function" ? Pt() : Pt,
      fieldValue: $t,
      field: Pt.field || _t.fullField
    };
  };
}
function deepMerge(_t, Et) {
  if (Et) {
    for (var Pt in Et)
      if (Et.hasOwnProperty(Pt)) {
        var $t = Et[Pt];
        _typeof($t) === "object" && _typeof(_t[Pt]) === "object" ? _t[Pt] = _objectSpread2(_objectSpread2({}, _t[Pt]), $t) : _t[Pt] = $t;
      }
  }
  return _t;
}
var ENUM$1 = "enum", enumerable$1 = function(Et, Pt, $t, Mt, Bt) {
  Et[ENUM$1] = Array.isArray(Et[ENUM$1]) ? Et[ENUM$1] : [], Et[ENUM$1].indexOf(Pt) === -1 && Mt.push(format$1(Bt.messages[ENUM$1], Et.fullField, Et[ENUM$1].join(", ")));
}, pattern$2 = function(Et, Pt, $t, Mt, Bt) {
  if (Et.pattern) {
    if (Et.pattern instanceof RegExp)
      Et.pattern.lastIndex = 0, Et.pattern.test(Pt) || Mt.push(format$1(Bt.messages.pattern.mismatch, Et.fullField, Pt, Et.pattern));
    else if (typeof Et.pattern == "string") {
      var Vt = new RegExp(Et.pattern);
      Vt.test(Pt) || Mt.push(format$1(Bt.messages.pattern.mismatch, Et.fullField, Pt, Et.pattern));
    }
  }
}, range = function(Et, Pt, $t, Mt, Bt) {
  var Vt = typeof Et.len == "number", zt = typeof Et.min == "number", Ht = typeof Et.max == "number", Wt = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, Gt = Pt, qt = null, Kt = typeof Pt == "number", Qt = typeof Pt == "string", Xt = Array.isArray(Pt);
  if (Kt ? qt = "number" : Qt ? qt = "string" : Xt && (qt = "array"), !qt)
    return !1;
  Xt && (Gt = Pt.length), Qt && (Gt = Pt.replace(Wt, "_").length), Vt ? Gt !== Et.len && Mt.push(format$1(Bt.messages[qt].len, Et.fullField, Et.len)) : zt && !Ht && Gt < Et.min ? Mt.push(format$1(Bt.messages[qt].min, Et.fullField, Et.min)) : Ht && !zt && Gt > Et.max ? Mt.push(format$1(Bt.messages[qt].max, Et.fullField, Et.max)) : zt && Ht && (Gt < Et.min || Gt > Et.max) && Mt.push(format$1(Bt.messages[qt].range, Et.fullField, Et.min, Et.max));
}, required$1 = function(Et, Pt, $t, Mt, Bt, Vt) {
  Et.required && (!$t.hasOwnProperty(Et.field) || isEmptyValue(Pt, Vt || Et.type)) && Mt.push(format$1(Bt.messages.required, Et.fullField));
}, urlReg;
const getUrlRegex = function() {
  if (urlReg)
    return urlReg;
  var _t = "[a-fA-F\\d:]", Et = function(ir) {
    return ir && ir.includeBoundaries ? "(?:(?<=\\s|^)(?=".concat(_t, ")|(?<=").concat(_t, ")(?=\\s|$))") : "";
  }, Pt = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}", $t = "[a-fA-F\\d]{1,4}", Mt = [
    "(?:".concat($t, ":){7}(?:").concat($t, "|:)"),
    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8
    "(?:".concat($t, ":){6}(?:").concat(Pt, "|:").concat($t, "|:)"),
    // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::
    "(?:".concat($t, ":){5}(?::").concat(Pt, "|(?::").concat($t, "){1,2}|:)"),
    // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::
    "(?:".concat($t, ":){4}(?:(?::").concat($t, "){0,1}:").concat(Pt, "|(?::").concat($t, "){1,3}|:)"),
    // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::
    "(?:".concat($t, ":){3}(?:(?::").concat($t, "){0,2}:").concat(Pt, "|(?::").concat($t, "){1,4}|:)"),
    // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::
    "(?:".concat($t, ":){2}(?:(?::").concat($t, "){0,3}:").concat(Pt, "|(?::").concat($t, "){1,5}|:)"),
    // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::
    "(?:".concat($t, ":){1}(?:(?::").concat($t, "){0,4}:").concat(Pt, "|(?::").concat($t, "){1,6}|:)"),
    // 1::              1::3:4:5:6:7:8   1::8            1::
    "(?::(?:(?::".concat($t, "){0,5}:").concat(Pt, "|(?::").concat($t, "){1,7}|:))")
    // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::
  ], Bt = "(?:%[0-9a-zA-Z]{1,})?", Vt = "(?:".concat(Mt.join("|"), ")").concat(Bt), zt = new RegExp("(?:^".concat(Pt, "$)|(?:^").concat(Vt, "$)")), Ht = new RegExp("^".concat(Pt, "$")), Wt = new RegExp("^".concat(Vt, "$")), Gt = function(ir) {
    return ir && ir.exact ? zt : new RegExp("(?:".concat(Et(ir)).concat(Pt).concat(Et(ir), ")|(?:").concat(Et(ir)).concat(Vt).concat(Et(ir), ")"), "g");
  };
  Gt.v4 = function(rr) {
    return rr && rr.exact ? Ht : new RegExp("".concat(Et(rr)).concat(Pt).concat(Et(rr)), "g");
  }, Gt.v6 = function(rr) {
    return rr && rr.exact ? Wt : new RegExp("".concat(Et(rr)).concat(Vt).concat(Et(rr)), "g");
  };
  var qt = "(?:(?:[a-z]+:)?//)", Kt = "(?:\\S+(?::\\S*)?@)?", Qt = Gt.v4().source, Xt = Gt.v6().source, Zt = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)", Yt = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*", Jt = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))", er = "(?::\\d{2,5})?", tr = '(?:[/?#][^\\s"]*)?', nr = "(?:".concat(qt, "|www\\.)").concat(Kt, "(?:localhost|").concat(Qt, "|").concat(Xt, "|").concat(Zt).concat(Yt).concat(Jt, ")").concat(er).concat(tr);
  return urlReg = new RegExp("(?:^".concat(nr, "$)"), "i"), urlReg;
};
var pattern$1 = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
  // url: new RegExp(
  //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
  //   'i',
  // ),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
}, types = {
  integer: function(Et) {
    return types.number(Et) && parseInt(Et, 10) === Et;
  },
  float: function(Et) {
    return types.number(Et) && !types.integer(Et);
  },
  array: function(Et) {
    return Array.isArray(Et);
  },
  regexp: function(Et) {
    if (Et instanceof RegExp)
      return !0;
    try {
      return !!new RegExp(Et);
    } catch {
      return !1;
    }
  },
  date: function(Et) {
    return typeof Et.getTime == "function" && typeof Et.getMonth == "function" && typeof Et.getYear == "function" && !isNaN(Et.getTime());
  },
  number: function(Et) {
    return isNaN(Et) ? !1 : typeof Et == "number";
  },
  object: function(Et) {
    return _typeof(Et) === "object" && !types.array(Et);
  },
  method: function(Et) {
    return typeof Et == "function";
  },
  email: function(Et) {
    return typeof Et == "string" && Et.length <= 320 && !!Et.match(pattern$1.email);
  },
  url: function(Et) {
    return typeof Et == "string" && Et.length <= 2048 && !!Et.match(getUrlRegex());
  },
  hex: function(Et) {
    return typeof Et == "string" && !!Et.match(pattern$1.hex);
  }
}, type$1 = function(Et, Pt, $t, Mt, Bt) {
  if (Et.required && Pt === void 0) {
    required$1(Et, Pt, $t, Mt, Bt);
    return;
  }
  var Vt = ["integer", "float", "array", "regexp", "object", "method", "email", "number", "date", "url", "hex"], zt = Et.type;
  Vt.indexOf(zt) > -1 ? types[zt](Pt) || Mt.push(format$1(Bt.messages.types[zt], Et.fullField, Et.type)) : zt && _typeof(Pt) !== Et.type && Mt.push(format$1(Bt.messages.types[zt], Et.fullField, Et.type));
}, whitespace = function(Et, Pt, $t, Mt, Bt) {
  (/^\s+$/.test(Pt) || Pt === "") && Mt.push(format$1(Bt.messages.whitespace, Et.fullField));
};
const rules = {
  required: required$1,
  whitespace,
  type: type$1,
  range,
  enum: enumerable$1,
  pattern: pattern$2
};
var any = function(Et, Pt, $t, Mt, Bt) {
  var Vt = [], zt = Et.required || !Et.required && Mt.hasOwnProperty(Et.field);
  if (zt) {
    if (isEmptyValue(Pt) && !Et.required)
      return $t();
    rules.required(Et, Pt, Mt, Vt, Bt);
  }
  $t(Vt);
}, array = function(Et, Pt, $t, Mt, Bt) {
  var Vt = [], zt = Et.required || !Et.required && Mt.hasOwnProperty(Et.field);
  if (zt) {
    if (Pt == null && !Et.required)
      return $t();
    rules.required(Et, Pt, Mt, Vt, Bt, "array"), Pt != null && (rules.type(Et, Pt, Mt, Vt, Bt), rules.range(Et, Pt, Mt, Vt, Bt));
  }
  $t(Vt);
}, boolean = function(Et, Pt, $t, Mt, Bt) {
  var Vt = [], zt = Et.required || !Et.required && Mt.hasOwnProperty(Et.field);
  if (zt) {
    if (isEmptyValue(Pt) && !Et.required)
      return $t();
    rules.required(Et, Pt, Mt, Vt, Bt), Pt !== void 0 && rules.type(Et, Pt, Mt, Vt, Bt);
  }
  $t(Vt);
}, date = function(Et, Pt, $t, Mt, Bt) {
  var Vt = [], zt = Et.required || !Et.required && Mt.hasOwnProperty(Et.field);
  if (zt) {
    if (isEmptyValue(Pt, "date") && !Et.required)
      return $t();
    if (rules.required(Et, Pt, Mt, Vt, Bt), !isEmptyValue(Pt, "date")) {
      var Ht;
      Pt instanceof Date ? Ht = Pt : Ht = new Date(Pt), rules.type(Et, Ht, Mt, Vt, Bt), Ht && rules.range(Et, Ht.getTime(), Mt, Vt, Bt);
    }
  }
  $t(Vt);
}, ENUM = "enum", enumerable = function(Et, Pt, $t, Mt, Bt) {
  var Vt = [], zt = Et.required || !Et.required && Mt.hasOwnProperty(Et.field);
  if (zt) {
    if (isEmptyValue(Pt) && !Et.required)
      return $t();
    rules.required(Et, Pt, Mt, Vt, Bt), Pt !== void 0 && rules[ENUM](Et, Pt, Mt, Vt, Bt);
  }
  $t(Vt);
}, floatFn = function(Et, Pt, $t, Mt, Bt) {
  var Vt = [], zt = Et.required || !Et.required && Mt.hasOwnProperty(Et.field);
  if (zt) {
    if (isEmptyValue(Pt) && !Et.required)
      return $t();
    rules.required(Et, Pt, Mt, Vt, Bt), Pt !== void 0 && (rules.type(Et, Pt, Mt, Vt, Bt), rules.range(Et, Pt, Mt, Vt, Bt));
  }
  $t(Vt);
}, integer = function(Et, Pt, $t, Mt, Bt) {
  var Vt = [], zt = Et.required || !Et.required && Mt.hasOwnProperty(Et.field);
  if (zt) {
    if (isEmptyValue(Pt) && !Et.required)
      return $t();
    rules.required(Et, Pt, Mt, Vt, Bt), Pt !== void 0 && (rules.type(Et, Pt, Mt, Vt, Bt), rules.range(Et, Pt, Mt, Vt, Bt));
  }
  $t(Vt);
}, method = function(Et, Pt, $t, Mt, Bt) {
  var Vt = [], zt = Et.required || !Et.required && Mt.hasOwnProperty(Et.field);
  if (zt) {
    if (isEmptyValue(Pt) && !Et.required)
      return $t();
    rules.required(Et, Pt, Mt, Vt, Bt), Pt !== void 0 && rules.type(Et, Pt, Mt, Vt, Bt);
  }
  $t(Vt);
}, number = function(Et, Pt, $t, Mt, Bt) {
  var Vt = [], zt = Et.required || !Et.required && Mt.hasOwnProperty(Et.field);
  if (zt) {
    if (Pt === "" && (Pt = void 0), isEmptyValue(Pt) && !Et.required)
      return $t();
    rules.required(Et, Pt, Mt, Vt, Bt), Pt !== void 0 && (rules.type(Et, Pt, Mt, Vt, Bt), rules.range(Et, Pt, Mt, Vt, Bt));
  }
  $t(Vt);
}, object = function(Et, Pt, $t, Mt, Bt) {
  var Vt = [], zt = Et.required || !Et.required && Mt.hasOwnProperty(Et.field);
  if (zt) {
    if (isEmptyValue(Pt) && !Et.required)
      return $t();
    rules.required(Et, Pt, Mt, Vt, Bt), Pt !== void 0 && rules.type(Et, Pt, Mt, Vt, Bt);
  }
  $t(Vt);
}, pattern = function(Et, Pt, $t, Mt, Bt) {
  var Vt = [], zt = Et.required || !Et.required && Mt.hasOwnProperty(Et.field);
  if (zt) {
    if (isEmptyValue(Pt, "string") && !Et.required)
      return $t();
    rules.required(Et, Pt, Mt, Vt, Bt), isEmptyValue(Pt, "string") || rules.pattern(Et, Pt, Mt, Vt, Bt);
  }
  $t(Vt);
}, regexp = function(Et, Pt, $t, Mt, Bt) {
  var Vt = [], zt = Et.required || !Et.required && Mt.hasOwnProperty(Et.field);
  if (zt) {
    if (isEmptyValue(Pt) && !Et.required)
      return $t();
    rules.required(Et, Pt, Mt, Vt, Bt), isEmptyValue(Pt) || rules.type(Et, Pt, Mt, Vt, Bt);
  }
  $t(Vt);
}, required = function(Et, Pt, $t, Mt, Bt) {
  var Vt = [], zt = Array.isArray(Pt) ? "array" : _typeof(Pt);
  rules.required(Et, Pt, Mt, Vt, Bt, zt), $t(Vt);
}, string = function(Et, Pt, $t, Mt, Bt) {
  var Vt = [], zt = Et.required || !Et.required && Mt.hasOwnProperty(Et.field);
  if (zt) {
    if (isEmptyValue(Pt, "string") && !Et.required)
      return $t();
    rules.required(Et, Pt, Mt, Vt, Bt, "string"), isEmptyValue(Pt, "string") || (rules.type(Et, Pt, Mt, Vt, Bt), rules.range(Et, Pt, Mt, Vt, Bt), rules.pattern(Et, Pt, Mt, Vt, Bt), Et.whitespace === !0 && rules.whitespace(Et, Pt, Mt, Vt, Bt));
  }
  $t(Vt);
}, type = function(Et, Pt, $t, Mt, Bt) {
  var Vt = Et.type, zt = [], Ht = Et.required || !Et.required && Mt.hasOwnProperty(Et.field);
  if (Ht) {
    if (isEmptyValue(Pt, Vt) && !Et.required)
      return $t();
    rules.required(Et, Pt, Mt, zt, Bt, Vt), isEmptyValue(Pt, Vt) || rules.type(Et, Pt, Mt, zt, Bt);
  }
  $t(zt);
};
const validators$2 = {
  string,
  method,
  number,
  boolean,
  regexp,
  integer,
  float: floatFn,
  array,
  object,
  enum: enumerable,
  pattern,
  date,
  url: type,
  hex: type,
  email: type,
  required,
  any
};
var Schema = /* @__PURE__ */ function() {
  function _t(Et) {
    _classCallCheck(this, _t), _defineProperty(this, "rules", null), _defineProperty(this, "_messages", messages), this.define(Et);
  }
  return _createClass(_t, [{
    key: "define",
    value: function(Pt) {
      var $t = this;
      if (!Pt)
        throw new Error("Cannot configure a schema with no rules");
      if (_typeof(Pt) !== "object" || Array.isArray(Pt))
        throw new Error("Rules must be an object");
      this.rules = {}, Object.keys(Pt).forEach(function(Mt) {
        var Bt = Pt[Mt];
        $t.rules[Mt] = Array.isArray(Bt) ? Bt : [Bt];
      });
    }
  }, {
    key: "messages",
    value: function(Pt) {
      return Pt && (this._messages = deepMerge(newMessages(), Pt)), this._messages;
    }
  }, {
    key: "validate",
    value: function(Pt) {
      var $t = this, Mt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Bt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {
      }, Vt = Pt, zt = Mt, Ht = Bt;
      if (typeof zt == "function" && (Ht = zt, zt = {}), !this.rules || Object.keys(this.rules).length === 0)
        return Ht && Ht(null, Vt), Promise.resolve(Vt);
      function Wt(Xt) {
        var Zt = [], Yt = {};
        function Jt(tr) {
          if (Array.isArray(tr)) {
            var nr;
            Zt = (nr = Zt).concat.apply(nr, _toConsumableArray(tr));
          } else
            Zt.push(tr);
        }
        for (var er = 0; er < Xt.length; er++)
          Jt(Xt[er]);
        Zt.length ? (Yt = convertFieldsError(Zt), Ht(Zt, Yt)) : Ht(null, Vt);
      }
      if (zt.messages) {
        var Gt = this.messages();
        Gt === messages && (Gt = newMessages()), deepMerge(Gt, zt.messages), zt.messages = Gt;
      } else
        zt.messages = this.messages();
      var qt = {}, Kt = zt.keys || Object.keys(this.rules);
      Kt.forEach(function(Xt) {
        var Zt = $t.rules[Xt], Yt = Vt[Xt];
        Zt.forEach(function(Jt) {
          var er = Jt;
          typeof er.transform == "function" && (Vt === Pt && (Vt = _objectSpread2({}, Vt)), Yt = Vt[Xt] = er.transform(Yt), Yt != null && (er.type = er.type || (Array.isArray(Yt) ? "array" : _typeof(Yt)))), typeof er == "function" ? er = {
            validator: er
          } : er = _objectSpread2({}, er), er.validator = $t.getValidationMethod(er), er.validator && (er.field = Xt, er.fullField = er.fullField || Xt, er.type = $t.getType(er), qt[Xt] = qt[Xt] || [], qt[Xt].push({
            rule: er,
            value: Yt,
            source: Vt,
            field: Xt
          }));
        });
      });
      var Qt = {};
      return asyncMap(qt, zt, function(Xt, Zt) {
        var Yt = Xt.rule, Jt = (Yt.type === "object" || Yt.type === "array") && (_typeof(Yt.fields) === "object" || _typeof(Yt.defaultField) === "object");
        Jt = Jt && (Yt.required || !Yt.required && Xt.value), Yt.field = Xt.field;
        function er(ar, or) {
          return _objectSpread2(_objectSpread2({}, or), {}, {
            fullField: "".concat(Yt.fullField, ".").concat(ar),
            fullFields: Yt.fullFields ? [].concat(_toConsumableArray(Yt.fullFields), [ar]) : [ar]
          });
        }
        function tr() {
          var ar = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], or = Array.isArray(ar) ? ar : [ar];
          !zt.suppressWarning && or.length && _t.warning("async-validator:", or), or.length && Yt.message !== void 0 && (or = [].concat(Yt.message));
          var sr = or.map(complementError(Yt, Vt));
          if (zt.first && sr.length)
            return Qt[Yt.field] = 1, Zt(sr);
          if (!Jt)
            Zt(sr);
          else {
            if (Yt.required && !Xt.value)
              return Yt.message !== void 0 ? sr = [].concat(Yt.message).map(complementError(Yt, Vt)) : zt.error && (sr = [zt.error(Yt, format$1(zt.messages.required, Yt.field))]), Zt(sr);
            var lr = {};
            Yt.defaultField && Object.keys(Xt.value).map(function(pr) {
              lr[pr] = Yt.defaultField;
            }), lr = _objectSpread2(_objectSpread2({}, lr), Xt.rule.fields);
            var cr = {};
            Object.keys(lr).forEach(function(pr) {
              var mr = lr[pr], Er = Array.isArray(mr) ? mr : [mr];
              cr[pr] = Er.map(er.bind(null, pr));
            });
            var hr = new _t(cr);
            hr.messages(zt.messages), Xt.rule.options && (Xt.rule.options.messages = zt.messages, Xt.rule.options.error = zt.error), hr.validate(Xt.value, Xt.rule.options || zt, function(pr) {
              var mr = [];
              sr && sr.length && mr.push.apply(mr, _toConsumableArray(sr)), pr && pr.length && mr.push.apply(mr, _toConsumableArray(pr)), Zt(mr.length ? mr : null);
            });
          }
        }
        var nr;
        if (Yt.asyncValidator)
          nr = Yt.asyncValidator(Yt, Xt.value, tr, Xt.source, zt);
        else if (Yt.validator) {
          try {
            nr = Yt.validator(Yt, Xt.value, tr, Xt.source, zt);
          } catch (ar) {
            var rr, ir;
            (rr = (ir = console).error) === null || rr === void 0 || rr.call(ir, ar), zt.suppressValidatorError || setTimeout(function() {
              throw ar;
            }, 0), tr(ar.message);
          }
          nr === !0 ? tr() : nr === !1 ? tr(typeof Yt.message == "function" ? Yt.message(Yt.fullField || Yt.field) : Yt.message || "".concat(Yt.fullField || Yt.field, " fails")) : nr instanceof Array ? tr(nr) : nr instanceof Error && tr(nr.message);
        }
        nr && nr.then && nr.then(function() {
          return tr();
        }, function(ar) {
          return tr(ar);
        });
      }, function(Xt) {
        Wt(Xt);
      }, Vt);
    }
  }, {
    key: "getType",
    value: function(Pt) {
      if (Pt.type === void 0 && Pt.pattern instanceof RegExp && (Pt.type = "pattern"), typeof Pt.validator != "function" && Pt.type && !validators$2.hasOwnProperty(Pt.type))
        throw new Error(format$1("Unknown rule type %s", Pt.type));
      return Pt.type || "string";
    }
  }, {
    key: "getValidationMethod",
    value: function(Pt) {
      if (typeof Pt.validator == "function")
        return Pt.validator;
      var $t = Object.keys(Pt), Mt = $t.indexOf("message");
      return Mt !== -1 && $t.splice(Mt, 1), $t.length === 1 && $t[0] === "required" ? validators$2.required : validators$2[this.getType(Pt)] || void 0;
    }
  }]), _t;
}();
_defineProperty(Schema, "register", function(Et, Pt) {
  if (typeof Pt != "function")
    throw new Error("Cannot register a validator by type, validator is not a function");
  validators$2[Et] = Pt;
});
_defineProperty(Schema, "warning", warning);
_defineProperty(Schema, "messages", messages);
_defineProperty(Schema, "validators", validators$2);
var typeTemplate = "'${name}' is not a valid ${type}", defaultValidateMessages = {
  default: "Validation error on field '${name}'",
  required: "'${name}' is required",
  enum: "'${name}' must be one of [${enum}]",
  whitespace: "'${name}' cannot be empty",
  date: {
    format: "'${name}' is invalid for format date",
    parse: "'${name}' could not be parsed as date",
    invalid: "'${name}' is invalid date"
  },
  types: {
    string: typeTemplate,
    method: typeTemplate,
    array: typeTemplate,
    object: typeTemplate,
    number: typeTemplate,
    date: typeTemplate,
    boolean: typeTemplate,
    integer: typeTemplate,
    float: typeTemplate,
    regexp: typeTemplate,
    email: typeTemplate,
    url: typeTemplate,
    hex: typeTemplate
  },
  string: {
    len: "'${name}' must be exactly ${len} characters",
    min: "'${name}' must be at least ${min} characters",
    max: "'${name}' cannot be longer than ${max} characters",
    range: "'${name}' must be between ${min} and ${max} characters"
  },
  number: {
    len: "'${name}' must equal ${len}",
    min: "'${name}' cannot be less than ${min}",
    max: "'${name}' cannot be greater than ${max}",
    range: "'${name}' must be between ${min} and ${max}"
  },
  array: {
    len: "'${name}' must be exactly ${len} in length",
    min: "'${name}' cannot be less than ${min} in length",
    max: "'${name}' cannot be greater than ${max} in length",
    range: "'${name}' must be between ${min} and ${max} in length"
  },
  pattern: {
    mismatch: "'${name}' does not match pattern ${pattern}"
  }
}, AsyncValidator = Schema;
function replaceMessage(_t, Et) {
  return _t.replace(/\\?\$\{\w+\}/g, function(Pt) {
    if (Pt.startsWith("\\"))
      return Pt.slice(1);
    var $t = Pt.slice(2, -1);
    return Et[$t];
  });
}
var CODE_LOGIC_ERROR = "CODE_LOGIC_ERROR";
function validateRule(_t, Et, Pt, $t, Mt) {
  return _validateRule.apply(this, arguments);
}
function _validateRule() {
  return _validateRule = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _t(Et, Pt, $t, Mt, Bt) {
    var Vt, zt, Ht, Wt, Gt, qt, Kt, Qt, Xt;
    return _regeneratorRuntime().wrap(function(Yt) {
      for (; ; )
        switch (Yt.prev = Yt.next) {
          case 0:
            return Vt = _objectSpread2({}, $t), delete Vt.ruleIndex, AsyncValidator.warning = function() {
            }, Vt.validator && (zt = Vt.validator, Vt.validator = function() {
              try {
                return zt.apply(void 0, arguments);
              } catch (Jt) {
                return console.error(Jt), Promise.reject(CODE_LOGIC_ERROR);
              }
            }), Ht = null, Vt && Vt.type === "array" && Vt.defaultField && (Ht = Vt.defaultField, delete Vt.defaultField), Wt = new AsyncValidator(_defineProperty({}, Et, [Vt])), Gt = merge$2(defaultValidateMessages, Mt.validateMessages), Wt.messages(Gt), qt = [], Yt.prev = 10, Yt.next = 13, Promise.resolve(Wt.validate(_defineProperty({}, Et, Pt), _objectSpread2({}, Mt)));
          case 13:
            Yt.next = 18;
            break;
          case 15:
            Yt.prev = 15, Yt.t0 = Yt.catch(10), Yt.t0.errors && (qt = Yt.t0.errors.map(function(Jt, er) {
              var tr = Jt.message, nr = tr === CODE_LOGIC_ERROR ? Gt.default : tr;
              return /* @__PURE__ */ React.isValidElement(nr) ? (
                // Wrap ReactNode with `key`
                /* @__PURE__ */ React.cloneElement(nr, {
                  key: "error_".concat(er)
                })
              ) : nr;
            }));
          case 18:
            if (!(!qt.length && Ht)) {
              Yt.next = 23;
              break;
            }
            return Yt.next = 21, Promise.all(Pt.map(function(Jt, er) {
              return validateRule("".concat(Et, ".").concat(er), Jt, Ht, Mt, Bt);
            }));
          case 21:
            return Kt = Yt.sent, Yt.abrupt("return", Kt.reduce(function(Jt, er) {
              return [].concat(_toConsumableArray(Jt), _toConsumableArray(er));
            }, []));
          case 23:
            return Qt = _objectSpread2(_objectSpread2({}, $t), {}, {
              name: Et,
              enum: ($t.enum || []).join(", ")
            }, Bt), Xt = qt.map(function(Jt) {
              return typeof Jt == "string" ? replaceMessage(Jt, Qt) : Jt;
            }), Yt.abrupt("return", Xt);
          case 26:
          case "end":
            return Yt.stop();
        }
    }, _t, null, [[10, 15]]);
  })), _validateRule.apply(this, arguments);
}
function validateRules(_t, Et, Pt, $t, Mt, Bt) {
  var Vt = _t.join("."), zt = Pt.map(function(Gt, qt) {
    var Kt = Gt.validator, Qt = _objectSpread2(_objectSpread2({}, Gt), {}, {
      ruleIndex: qt
    });
    return Kt && (Qt.validator = function(Xt, Zt, Yt) {
      var Jt = !1, er = function() {
        for (var rr = arguments.length, ir = new Array(rr), ar = 0; ar < rr; ar++)
          ir[ar] = arguments[ar];
        Promise.resolve().then(function() {
          warningOnce(!Jt, "Your validator function has already return a promise. `callback` will be ignored."), Jt || Yt.apply(void 0, ir);
        });
      }, tr = Kt(Xt, Zt, er);
      Jt = tr && typeof tr.then == "function" && typeof tr.catch == "function", warningOnce(Jt, "`callback` is deprecated. Please return a promise instead."), Jt && tr.then(function() {
        Yt();
      }).catch(function(nr) {
        Yt(nr || " ");
      });
    }), Qt;
  }).sort(function(Gt, qt) {
    var Kt = Gt.warningOnly, Qt = Gt.ruleIndex, Xt = qt.warningOnly, Zt = qt.ruleIndex;
    return !!Kt == !!Xt ? Qt - Zt : Kt ? 1 : -1;
  }), Ht;
  if (Mt === !0)
    Ht = new Promise(/* @__PURE__ */ function() {
      var Gt = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function qt(Kt, Qt) {
        var Xt, Zt, Yt;
        return _regeneratorRuntime().wrap(function(er) {
          for (; ; )
            switch (er.prev = er.next) {
              case 0:
                Xt = 0;
              case 1:
                if (!(Xt < zt.length)) {
                  er.next = 12;
                  break;
                }
                return Zt = zt[Xt], er.next = 5, validateRule(Vt, Et, Zt, $t, Bt);
              case 5:
                if (Yt = er.sent, !Yt.length) {
                  er.next = 9;
                  break;
                }
                return Qt([{
                  errors: Yt,
                  rule: Zt
                }]), er.abrupt("return");
              case 9:
                Xt += 1, er.next = 1;
                break;
              case 12:
                Kt([]);
              case 13:
              case "end":
                return er.stop();
            }
        }, qt);
      }));
      return function(qt, Kt) {
        return Gt.apply(this, arguments);
      };
    }());
  else {
    var Wt = zt.map(function(Gt) {
      return validateRule(Vt, Et, Gt, $t, Bt).then(function(qt) {
        return {
          errors: qt,
          rule: Gt
        };
      });
    });
    Ht = (Mt ? finishOnFirstFailed(Wt) : finishOnAllFailed(Wt)).then(function(Gt) {
      return Promise.reject(Gt);
    });
  }
  return Ht.catch(function(Gt) {
    return Gt;
  }), Ht;
}
function finishOnAllFailed(_t) {
  return _finishOnAllFailed.apply(this, arguments);
}
function _finishOnAllFailed() {
  return _finishOnAllFailed = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _t(Et) {
    return _regeneratorRuntime().wrap(function($t) {
      for (; ; )
        switch ($t.prev = $t.next) {
          case 0:
            return $t.abrupt("return", Promise.all(Et).then(function(Mt) {
              var Bt, Vt = (Bt = []).concat.apply(Bt, _toConsumableArray(Mt));
              return Vt;
            }));
          case 1:
          case "end":
            return $t.stop();
        }
    }, _t);
  })), _finishOnAllFailed.apply(this, arguments);
}
function finishOnFirstFailed(_t) {
  return _finishOnFirstFailed.apply(this, arguments);
}
function _finishOnFirstFailed() {
  return _finishOnFirstFailed = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _t(Et) {
    var Pt;
    return _regeneratorRuntime().wrap(function(Mt) {
      for (; ; )
        switch (Mt.prev = Mt.next) {
          case 0:
            return Pt = 0, Mt.abrupt("return", new Promise(function(Bt) {
              Et.forEach(function(Vt) {
                Vt.then(function(zt) {
                  zt.errors.length && Bt([zt]), Pt += 1, Pt === Et.length && Bt([]);
                });
              });
            }));
          case 2:
          case "end":
            return Mt.stop();
        }
    }, _t);
  })), _finishOnFirstFailed.apply(this, arguments);
}
function getNamePath(_t) {
  return toArray$3(_t);
}
function cloneByNamePathList(_t, Et) {
  var Pt = {};
  return Et.forEach(function($t) {
    var Mt = get$3(_t, $t);
    Pt = set$2(Pt, $t, Mt);
  }), Pt;
}
function containsNamePath(_t, Et) {
  var Pt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  return _t && _t.some(function($t) {
    return matchNamePath(Et, $t, Pt);
  });
}
function matchNamePath(_t, Et) {
  var Pt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  return !_t || !Et || !Pt && _t.length !== Et.length ? !1 : Et.every(function($t, Mt) {
    return _t[Mt] === $t;
  });
}
function isSimilar(_t, Et) {
  if (_t === Et)
    return !0;
  if (!_t && Et || _t && !Et || !_t || !Et || _typeof(_t) !== "object" || _typeof(Et) !== "object")
    return !1;
  var Pt = Object.keys(_t), $t = Object.keys(Et), Mt = new Set([].concat(Pt, $t));
  return _toConsumableArray(Mt).every(function(Bt) {
    var Vt = _t[Bt], zt = Et[Bt];
    return typeof Vt == "function" && typeof zt == "function" ? !0 : Vt === zt;
  });
}
function defaultGetValueFromEvent(_t) {
  var Et = arguments.length <= 1 ? void 0 : arguments[1];
  return Et && Et.target && _typeof(Et.target) === "object" && _t in Et.target ? Et.target[_t] : Et;
}
function move(_t, Et, Pt) {
  var $t = _t.length;
  if (Et < 0 || Et >= $t || Pt < 0 || Pt >= $t)
    return _t;
  var Mt = _t[Et], Bt = Et - Pt;
  return Bt > 0 ? [].concat(_toConsumableArray(_t.slice(0, Pt)), [Mt], _toConsumableArray(_t.slice(Pt, Et)), _toConsumableArray(_t.slice(Et + 1, $t))) : Bt < 0 ? [].concat(_toConsumableArray(_t.slice(0, Et)), _toConsumableArray(_t.slice(Et + 1, Pt + 1)), [Mt], _toConsumableArray(_t.slice(Pt + 1, $t))) : _t;
}
var _excluded$j = ["name"], EMPTY_ERRORS = [];
function requireUpdate(_t, Et, Pt, $t, Mt, Bt) {
  return typeof _t == "function" ? _t(Et, Pt, "source" in Bt ? {
    source: Bt.source
  } : {}) : $t !== Mt;
}
var Field = /* @__PURE__ */ function(_t) {
  _inherits(Pt, _t);
  var Et = _createSuper(Pt);
  function Pt($t) {
    var Mt;
    if (_classCallCheck(this, Pt), Mt = Et.call(this, $t), _defineProperty(_assertThisInitialized(Mt), "state", {
      resetCount: 0
    }), _defineProperty(_assertThisInitialized(Mt), "cancelRegisterFunc", null), _defineProperty(_assertThisInitialized(Mt), "mounted", !1), _defineProperty(_assertThisInitialized(Mt), "touched", !1), _defineProperty(_assertThisInitialized(Mt), "dirty", !1), _defineProperty(_assertThisInitialized(Mt), "validatePromise", void 0), _defineProperty(_assertThisInitialized(Mt), "prevValidating", void 0), _defineProperty(_assertThisInitialized(Mt), "errors", EMPTY_ERRORS), _defineProperty(_assertThisInitialized(Mt), "warnings", EMPTY_ERRORS), _defineProperty(_assertThisInitialized(Mt), "cancelRegister", function() {
      var Ht = Mt.props, Wt = Ht.preserve, Gt = Ht.isListField, qt = Ht.name;
      Mt.cancelRegisterFunc && Mt.cancelRegisterFunc(Gt, Wt, getNamePath(qt)), Mt.cancelRegisterFunc = null;
    }), _defineProperty(_assertThisInitialized(Mt), "getNamePath", function() {
      var Ht = Mt.props, Wt = Ht.name, Gt = Ht.fieldContext, qt = Gt.prefixName, Kt = qt === void 0 ? [] : qt;
      return Wt !== void 0 ? [].concat(_toConsumableArray(Kt), _toConsumableArray(Wt)) : [];
    }), _defineProperty(_assertThisInitialized(Mt), "getRules", function() {
      var Ht = Mt.props, Wt = Ht.rules, Gt = Wt === void 0 ? [] : Wt, qt = Ht.fieldContext;
      return Gt.map(function(Kt) {
        return typeof Kt == "function" ? Kt(qt) : Kt;
      });
    }), _defineProperty(_assertThisInitialized(Mt), "refresh", function() {
      Mt.mounted && Mt.setState(function(Ht) {
        var Wt = Ht.resetCount;
        return {
          resetCount: Wt + 1
        };
      });
    }), _defineProperty(_assertThisInitialized(Mt), "metaCache", null), _defineProperty(_assertThisInitialized(Mt), "triggerMetaEvent", function(Ht) {
      var Wt = Mt.props.onMetaChange;
      if (Wt) {
        var Gt = _objectSpread2(_objectSpread2({}, Mt.getMeta()), {}, {
          destroy: Ht
        });
        isEqual(Mt.metaCache, Gt) || Wt(Gt), Mt.metaCache = Gt;
      } else
        Mt.metaCache = null;
    }), _defineProperty(_assertThisInitialized(Mt), "onStoreChange", function(Ht, Wt, Gt) {
      var qt = Mt.props, Kt = qt.shouldUpdate, Qt = qt.dependencies, Xt = Qt === void 0 ? [] : Qt, Zt = qt.onReset, Yt = Gt.store, Jt = Mt.getNamePath(), er = Mt.getValue(Ht), tr = Mt.getValue(Yt), nr = Wt && containsNamePath(Wt, Jt);
      switch (Gt.type === "valueUpdate" && Gt.source === "external" && !isEqual(er, tr) && (Mt.touched = !0, Mt.dirty = !0, Mt.validatePromise = null, Mt.errors = EMPTY_ERRORS, Mt.warnings = EMPTY_ERRORS, Mt.triggerMetaEvent()), Gt.type) {
        case "reset":
          if (!Wt || nr) {
            Mt.touched = !1, Mt.dirty = !1, Mt.validatePromise = void 0, Mt.errors = EMPTY_ERRORS, Mt.warnings = EMPTY_ERRORS, Mt.triggerMetaEvent(), Zt == null || Zt(), Mt.refresh();
            return;
          }
          break;
        case "remove": {
          if (Kt && requireUpdate(Kt, Ht, Yt, er, tr, Gt)) {
            Mt.reRender();
            return;
          }
          break;
        }
        case "setField": {
          var rr = Gt.data;
          if (nr) {
            "touched" in rr && (Mt.touched = rr.touched), "validating" in rr && !("originRCField" in rr) && (Mt.validatePromise = rr.validating ? Promise.resolve([]) : null), "errors" in rr && (Mt.errors = rr.errors || EMPTY_ERRORS), "warnings" in rr && (Mt.warnings = rr.warnings || EMPTY_ERRORS), Mt.dirty = !0, Mt.triggerMetaEvent(), Mt.reRender();
            return;
          } else if ("value" in rr && containsNamePath(Wt, Jt, !0)) {
            Mt.reRender();
            return;
          }
          if (Kt && !Jt.length && requireUpdate(Kt, Ht, Yt, er, tr, Gt)) {
            Mt.reRender();
            return;
          }
          break;
        }
        case "dependenciesUpdate": {
          var ir = Xt.map(getNamePath);
          if (ir.some(function(ar) {
            return containsNamePath(Gt.relatedFields, ar);
          })) {
            Mt.reRender();
            return;
          }
          break;
        }
        default:
          if (nr || (!Xt.length || Jt.length || Kt) && requireUpdate(Kt, Ht, Yt, er, tr, Gt)) {
            Mt.reRender();
            return;
          }
          break;
      }
      Kt === !0 && Mt.reRender();
    }), _defineProperty(_assertThisInitialized(Mt), "validateRules", function(Ht) {
      var Wt = Mt.getNamePath(), Gt = Mt.getValue(), qt = Ht || {}, Kt = qt.triggerName, Qt = qt.validateOnly, Xt = Qt === void 0 ? !1 : Qt, Zt = Promise.resolve().then(/* @__PURE__ */ _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function Yt() {
        var Jt, er, tr, nr, rr, ir, ar;
        return _regeneratorRuntime().wrap(function(sr) {
          for (; ; )
            switch (sr.prev = sr.next) {
              case 0:
                if (Mt.mounted) {
                  sr.next = 2;
                  break;
                }
                return sr.abrupt("return", []);
              case 2:
                if (Jt = Mt.props, er = Jt.validateFirst, tr = er === void 0 ? !1 : er, nr = Jt.messageVariables, rr = Jt.validateDebounce, ir = Mt.getRules(), Kt && (ir = ir.filter(function(lr) {
                  return lr;
                }).filter(function(lr) {
                  var cr = lr.validateTrigger;
                  if (!cr)
                    return !0;
                  var hr = toArray$3(cr);
                  return hr.includes(Kt);
                })), !(rr && Kt)) {
                  sr.next = 10;
                  break;
                }
                return sr.next = 8, new Promise(function(lr) {
                  setTimeout(lr, rr);
                });
              case 8:
                if (Mt.validatePromise === Zt) {
                  sr.next = 10;
                  break;
                }
                return sr.abrupt("return", []);
              case 10:
                return ar = validateRules(Wt, Gt, ir, Ht, tr, nr), ar.catch(function(lr) {
                  return lr;
                }).then(function() {
                  var lr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : EMPTY_ERRORS;
                  if (Mt.validatePromise === Zt) {
                    var cr;
                    Mt.validatePromise = null;
                    var hr = [], pr = [];
                    (cr = lr.forEach) === null || cr === void 0 || cr.call(lr, function(mr) {
                      var Er = mr.rule.warningOnly, _r = mr.errors, yr = _r === void 0 ? EMPTY_ERRORS : _r;
                      Er ? pr.push.apply(pr, _toConsumableArray(yr)) : hr.push.apply(hr, _toConsumableArray(yr));
                    }), Mt.errors = hr, Mt.warnings = pr, Mt.triggerMetaEvent(), Mt.reRender();
                  }
                }), sr.abrupt("return", ar);
              case 13:
              case "end":
                return sr.stop();
            }
        }, Yt);
      })));
      return Xt || (Mt.validatePromise = Zt, Mt.dirty = !0, Mt.errors = EMPTY_ERRORS, Mt.warnings = EMPTY_ERRORS, Mt.triggerMetaEvent(), Mt.reRender()), Zt;
    }), _defineProperty(_assertThisInitialized(Mt), "isFieldValidating", function() {
      return !!Mt.validatePromise;
    }), _defineProperty(_assertThisInitialized(Mt), "isFieldTouched", function() {
      return Mt.touched;
    }), _defineProperty(_assertThisInitialized(Mt), "isFieldDirty", function() {
      if (Mt.dirty || Mt.props.initialValue !== void 0)
        return !0;
      var Ht = Mt.props.fieldContext, Wt = Ht.getInternalHooks(HOOK_MARK), Gt = Wt.getInitialValue;
      return Gt(Mt.getNamePath()) !== void 0;
    }), _defineProperty(_assertThisInitialized(Mt), "getErrors", function() {
      return Mt.errors;
    }), _defineProperty(_assertThisInitialized(Mt), "getWarnings", function() {
      return Mt.warnings;
    }), _defineProperty(_assertThisInitialized(Mt), "isListField", function() {
      return Mt.props.isListField;
    }), _defineProperty(_assertThisInitialized(Mt), "isList", function() {
      return Mt.props.isList;
    }), _defineProperty(_assertThisInitialized(Mt), "isPreserve", function() {
      return Mt.props.preserve;
    }), _defineProperty(_assertThisInitialized(Mt), "getMeta", function() {
      Mt.prevValidating = Mt.isFieldValidating();
      var Ht = {
        touched: Mt.isFieldTouched(),
        validating: Mt.prevValidating,
        errors: Mt.errors,
        warnings: Mt.warnings,
        name: Mt.getNamePath(),
        validated: Mt.validatePromise === null
      };
      return Ht;
    }), _defineProperty(_assertThisInitialized(Mt), "getOnlyChild", function(Ht) {
      if (typeof Ht == "function") {
        var Wt = Mt.getMeta();
        return _objectSpread2(_objectSpread2({}, Mt.getOnlyChild(Ht(Mt.getControlled(), Wt, Mt.props.fieldContext))), {}, {
          isFunction: !0
        });
      }
      var Gt = toArray$4(Ht);
      return Gt.length !== 1 || !/* @__PURE__ */ React.isValidElement(Gt[0]) ? {
        child: Gt,
        isFunction: !1
      } : {
        child: Gt[0],
        isFunction: !1
      };
    }), _defineProperty(_assertThisInitialized(Mt), "getValue", function(Ht) {
      var Wt = Mt.props.fieldContext.getFieldsValue, Gt = Mt.getNamePath();
      return get$3(Ht || Wt(!0), Gt);
    }), _defineProperty(_assertThisInitialized(Mt), "getControlled", function() {
      var Ht = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, Wt = Mt.props, Gt = Wt.name, qt = Wt.trigger, Kt = Wt.validateTrigger, Qt = Wt.getValueFromEvent, Xt = Wt.normalize, Zt = Wt.valuePropName, Yt = Wt.getValueProps, Jt = Wt.fieldContext, er = Kt !== void 0 ? Kt : Jt.validateTrigger, tr = Mt.getNamePath(), nr = Jt.getInternalHooks, rr = Jt.getFieldsValue, ir = nr(HOOK_MARK), ar = ir.dispatch, or = Mt.getValue(), sr = Yt || function(mr) {
        return _defineProperty({}, Zt, mr);
      }, lr = Ht[qt], cr = Gt !== void 0 ? sr(or) : {};
      browser$1.env.NODE_ENV !== "production" && cr && Object.keys(cr).forEach(function(mr) {
        warningOnce(typeof cr[mr] != "function", "It's not recommended to generate dynamic function prop by `getValueProps`. Please pass it to child component directly (prop: ".concat(mr, ")"));
      });
      var hr = _objectSpread2(_objectSpread2({}, Ht), cr);
      hr[qt] = function() {
        Mt.touched = !0, Mt.dirty = !0, Mt.triggerMetaEvent();
        for (var mr, Er = arguments.length, _r = new Array(Er), yr = 0; yr < Er; yr++)
          _r[yr] = arguments[yr];
        Qt ? mr = Qt.apply(void 0, _r) : mr = defaultGetValueFromEvent.apply(void 0, [Zt].concat(_r)), Xt && (mr = Xt(mr, or, rr(!0))), mr !== or && ar({
          type: "updateValue",
          namePath: tr,
          value: mr
        }), lr && lr.apply(void 0, _r);
      };
      var pr = toArray$3(er || []);
      return pr.forEach(function(mr) {
        var Er = hr[mr];
        hr[mr] = function() {
          Er && Er.apply(void 0, arguments);
          var _r = Mt.props.rules;
          _r && _r.length && ar({
            type: "validateField",
            namePath: tr,
            triggerName: mr
          });
        };
      }), hr;
    }), $t.fieldContext) {
      var Bt = $t.fieldContext.getInternalHooks, Vt = Bt(HOOK_MARK), zt = Vt.initEntityValue;
      zt(_assertThisInitialized(Mt));
    }
    return Mt;
  }
  return _createClass(Pt, [{
    key: "componentDidMount",
    value: function() {
      var Mt = this.props, Bt = Mt.shouldUpdate, Vt = Mt.fieldContext;
      if (this.mounted = !0, Vt) {
        var zt = Vt.getInternalHooks, Ht = zt(HOOK_MARK), Wt = Ht.registerField;
        this.cancelRegisterFunc = Wt(this);
      }
      Bt === !0 && this.reRender();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.cancelRegister(), this.triggerMetaEvent(!0), this.mounted = !1;
    }
  }, {
    key: "reRender",
    value: function() {
      this.mounted && this.forceUpdate();
    }
  }, {
    key: "render",
    value: function() {
      var Mt = this.state.resetCount, Bt = this.props.children, Vt = this.getOnlyChild(Bt), zt = Vt.child, Ht = Vt.isFunction, Wt;
      return Ht ? Wt = zt : /* @__PURE__ */ React.isValidElement(zt) ? Wt = /* @__PURE__ */ React.cloneElement(zt, this.getControlled(zt.props)) : (warningOnce(!zt, "`children` of Field is not validate ReactElement."), Wt = zt), /* @__PURE__ */ React.createElement(React.Fragment, {
        key: Mt
      }, Wt);
    }
  }]), Pt;
}(React.Component);
_defineProperty(Field, "contextType", Context);
_defineProperty(Field, "defaultProps", {
  trigger: "onChange",
  valuePropName: "value"
});
function WrapperField(_t) {
  var Et, Pt = _t.name, $t = _objectWithoutProperties$2(_t, _excluded$j), Mt = React.useContext(Context), Bt = React.useContext(ListContext), Vt = Pt !== void 0 ? getNamePath(Pt) : void 0, zt = (Et = $t.isListField) !== null && Et !== void 0 ? Et : !!Bt, Ht = "keep";
  return zt || (Ht = "_".concat((Vt || []).join("_"))), browser$1.env.NODE_ENV !== "production" && $t.preserve === !1 && zt && Vt.length <= 1 && warningOnce(!1, "`preserve` should not apply on Form.List fields."), /* @__PURE__ */ React.createElement(Field, _extends$2({
    key: Ht,
    name: Vt,
    isListField: zt
  }, $t, {
    fieldContext: Mt
  }));
}
function List(_t) {
  var Et = _t.name, Pt = _t.initialValue, $t = _t.children, Mt = _t.rules, Bt = _t.validateTrigger, Vt = _t.isListField, zt = React.useContext(Context), Ht = React.useContext(ListContext), Wt = React.useRef({
    keys: [],
    id: 0
  }), Gt = Wt.current, qt = React.useMemo(function() {
    var Zt = getNamePath(zt.prefixName) || [];
    return [].concat(_toConsumableArray(Zt), _toConsumableArray(getNamePath(Et)));
  }, [zt.prefixName, Et]), Kt = React.useMemo(function() {
    return _objectSpread2(_objectSpread2({}, zt), {}, {
      prefixName: qt
    });
  }, [zt, qt]), Qt = React.useMemo(function() {
    return {
      getKey: function(Yt) {
        var Jt = qt.length, er = Yt[Jt];
        return [Gt.keys[er], Yt.slice(Jt + 1)];
      }
    };
  }, [qt]);
  if (typeof $t != "function")
    return warningOnce(!1, "Form.List only accepts function as children."), null;
  var Xt = function(Yt, Jt, er) {
    var tr = er.source;
    return tr === "internal" ? !1 : Yt !== Jt;
  };
  return /* @__PURE__ */ React.createElement(ListContext.Provider, {
    value: Qt
  }, /* @__PURE__ */ React.createElement(Context.Provider, {
    value: Kt
  }, /* @__PURE__ */ React.createElement(WrapperField, {
    name: [],
    shouldUpdate: Xt,
    rules: Mt,
    validateTrigger: Bt,
    initialValue: Pt,
    isList: !0,
    isListField: Vt ?? !!Ht
  }, function(Zt, Yt) {
    var Jt = Zt.value, er = Jt === void 0 ? [] : Jt, tr = Zt.onChange, nr = zt.getFieldValue, rr = function() {
      var sr = nr(qt || []);
      return sr || [];
    }, ir = {
      add: function(sr, lr) {
        var cr = rr();
        lr >= 0 && lr <= cr.length ? (Gt.keys = [].concat(_toConsumableArray(Gt.keys.slice(0, lr)), [Gt.id], _toConsumableArray(Gt.keys.slice(lr))), tr([].concat(_toConsumableArray(cr.slice(0, lr)), [sr], _toConsumableArray(cr.slice(lr))))) : (browser$1.env.NODE_ENV !== "production" && (lr < 0 || lr > cr.length) && warningOnce(!1, "The second parameter of the add function should be a valid positive number."), Gt.keys = [].concat(_toConsumableArray(Gt.keys), [Gt.id]), tr([].concat(_toConsumableArray(cr), [sr]))), Gt.id += 1;
      },
      remove: function(sr) {
        var lr = rr(), cr = new Set(Array.isArray(sr) ? sr : [sr]);
        cr.size <= 0 || (Gt.keys = Gt.keys.filter(function(hr, pr) {
          return !cr.has(pr);
        }), tr(lr.filter(function(hr, pr) {
          return !cr.has(pr);
        })));
      },
      move: function(sr, lr) {
        if (sr !== lr) {
          var cr = rr();
          sr < 0 || sr >= cr.length || lr < 0 || lr >= cr.length || (Gt.keys = move(Gt.keys, sr, lr), tr(move(cr, sr, lr)));
        }
      }
    }, ar = er || [];
    return Array.isArray(ar) || (ar = [], browser$1.env.NODE_ENV !== "production" && warningOnce(!1, "Current value of '".concat(qt.join(" > "), "' is not an array type."))), $t(ar.map(function(or, sr) {
      var lr = Gt.keys[sr];
      return lr === void 0 && (Gt.keys[sr] = Gt.id, lr = Gt.keys[sr], Gt.id += 1), {
        name: sr,
        key: lr,
        isListField: !0
      };
    }), ir, Yt);
  })));
}
function allPromiseFinish(_t) {
  var Et = !1, Pt = _t.length, $t = [];
  return _t.length ? new Promise(function(Mt, Bt) {
    _t.forEach(function(Vt, zt) {
      Vt.catch(function(Ht) {
        return Et = !0, Ht;
      }).then(function(Ht) {
        Pt -= 1, $t[zt] = Ht, !(Pt > 0) && (Et && Bt($t), Mt($t));
      });
    });
  }) : Promise.resolve([]);
}
var SPLIT = "__@field_split__";
function normalize(_t) {
  return _t.map(function(Et) {
    return "".concat(_typeof(Et), ":").concat(Et);
  }).join(SPLIT);
}
var NameMap = /* @__PURE__ */ function() {
  function _t() {
    _classCallCheck(this, _t), _defineProperty(this, "kvs", /* @__PURE__ */ new Map());
  }
  return _createClass(_t, [{
    key: "set",
    value: function(Pt, $t) {
      this.kvs.set(normalize(Pt), $t);
    }
  }, {
    key: "get",
    value: function(Pt) {
      return this.kvs.get(normalize(Pt));
    }
  }, {
    key: "update",
    value: function(Pt, $t) {
      var Mt = this.get(Pt), Bt = $t(Mt);
      Bt ? this.set(Pt, Bt) : this.delete(Pt);
    }
  }, {
    key: "delete",
    value: function(Pt) {
      this.kvs.delete(normalize(Pt));
    }
    // Since we only use this in test, let simply realize this
  }, {
    key: "map",
    value: function(Pt) {
      return _toConsumableArray(this.kvs.entries()).map(function($t) {
        var Mt = _slicedToArray($t, 2), Bt = Mt[0], Vt = Mt[1], zt = Bt.split(SPLIT);
        return Pt({
          key: zt.map(function(Ht) {
            var Wt = Ht.match(/^([^:]*):(.*)$/), Gt = _slicedToArray(Wt, 3), qt = Gt[1], Kt = Gt[2];
            return qt === "number" ? Number(Kt) : Kt;
          }),
          value: Vt
        });
      });
    }
  }, {
    key: "toJSON",
    value: function() {
      var Pt = {};
      return this.map(function($t) {
        var Mt = $t.key, Bt = $t.value;
        return Pt[Mt.join(".")] = Bt, null;
      }), Pt;
    }
  }]), _t;
}(), _excluded$i = ["name"], FormStore = /* @__PURE__ */ _createClass(function _t(Et) {
  var Pt = this;
  _classCallCheck(this, _t), _defineProperty(this, "formHooked", !1), _defineProperty(this, "forceRootUpdate", void 0), _defineProperty(this, "subscribable", !0), _defineProperty(this, "store", {}), _defineProperty(this, "fieldEntities", []), _defineProperty(this, "initialValues", {}), _defineProperty(this, "callbacks", {}), _defineProperty(this, "validateMessages", null), _defineProperty(this, "preserve", null), _defineProperty(this, "lastValidatePromise", null), _defineProperty(this, "getForm", function() {
    return {
      getFieldValue: Pt.getFieldValue,
      getFieldsValue: Pt.getFieldsValue,
      getFieldError: Pt.getFieldError,
      getFieldWarning: Pt.getFieldWarning,
      getFieldsError: Pt.getFieldsError,
      isFieldsTouched: Pt.isFieldsTouched,
      isFieldTouched: Pt.isFieldTouched,
      isFieldValidating: Pt.isFieldValidating,
      isFieldsValidating: Pt.isFieldsValidating,
      resetFields: Pt.resetFields,
      setFields: Pt.setFields,
      setFieldValue: Pt.setFieldValue,
      setFieldsValue: Pt.setFieldsValue,
      validateFields: Pt.validateFields,
      submit: Pt.submit,
      _init: !0,
      getInternalHooks: Pt.getInternalHooks
    };
  }), _defineProperty(this, "getInternalHooks", function($t) {
    return $t === HOOK_MARK ? (Pt.formHooked = !0, {
      dispatch: Pt.dispatch,
      initEntityValue: Pt.initEntityValue,
      registerField: Pt.registerField,
      useSubscribe: Pt.useSubscribe,
      setInitialValues: Pt.setInitialValues,
      destroyForm: Pt.destroyForm,
      setCallbacks: Pt.setCallbacks,
      setValidateMessages: Pt.setValidateMessages,
      getFields: Pt.getFields,
      setPreserve: Pt.setPreserve,
      getInitialValue: Pt.getInitialValue,
      registerWatch: Pt.registerWatch
    }) : (warningOnce(!1, "`getInternalHooks` is internal usage. Should not call directly."), null);
  }), _defineProperty(this, "useSubscribe", function($t) {
    Pt.subscribable = $t;
  }), _defineProperty(this, "prevWithoutPreserves", null), _defineProperty(this, "setInitialValues", function($t, Mt) {
    if (Pt.initialValues = $t || {}, Mt) {
      var Bt, Vt = merge$2($t, Pt.store);
      (Bt = Pt.prevWithoutPreserves) === null || Bt === void 0 || Bt.map(function(zt) {
        var Ht = zt.key;
        Vt = set$2(Vt, Ht, get$3($t, Ht));
      }), Pt.prevWithoutPreserves = null, Pt.updateStore(Vt);
    }
  }), _defineProperty(this, "destroyForm", function($t) {
    if ($t)
      Pt.updateStore({});
    else {
      var Mt = new NameMap();
      Pt.getFieldEntities(!0).forEach(function(Bt) {
        Pt.isMergedPreserve(Bt.isPreserve()) || Mt.set(Bt.getNamePath(), !0);
      }), Pt.prevWithoutPreserves = Mt;
    }
  }), _defineProperty(this, "getInitialValue", function($t) {
    var Mt = get$3(Pt.initialValues, $t);
    return $t.length ? merge$2(Mt) : Mt;
  }), _defineProperty(this, "setCallbacks", function($t) {
    Pt.callbacks = $t;
  }), _defineProperty(this, "setValidateMessages", function($t) {
    Pt.validateMessages = $t;
  }), _defineProperty(this, "setPreserve", function($t) {
    Pt.preserve = $t;
  }), _defineProperty(this, "watchList", []), _defineProperty(this, "registerWatch", function($t) {
    return Pt.watchList.push($t), function() {
      Pt.watchList = Pt.watchList.filter(function(Mt) {
        return Mt !== $t;
      });
    };
  }), _defineProperty(this, "notifyWatch", function() {
    var $t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    if (Pt.watchList.length) {
      var Mt = Pt.getFieldsValue(), Bt = Pt.getFieldsValue(!0);
      Pt.watchList.forEach(function(Vt) {
        Vt(Mt, Bt, $t);
      });
    }
  }), _defineProperty(this, "timeoutId", null), _defineProperty(this, "warningUnhooked", function() {
    browser$1.env.NODE_ENV !== "production" && !Pt.timeoutId && typeof window < "u" && (Pt.timeoutId = setTimeout(function() {
      Pt.timeoutId = null, Pt.formHooked || warningOnce(!1, "Instance created by `useForm` is not connected to any Form element. Forget to pass `form` prop?");
    }));
  }), _defineProperty(this, "updateStore", function($t) {
    Pt.store = $t;
  }), _defineProperty(this, "getFieldEntities", function() {
    var $t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    return $t ? Pt.fieldEntities.filter(function(Mt) {
      return Mt.getNamePath().length;
    }) : Pt.fieldEntities;
  }), _defineProperty(this, "getFieldsMap", function() {
    var $t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, Mt = new NameMap();
    return Pt.getFieldEntities($t).forEach(function(Bt) {
      var Vt = Bt.getNamePath();
      Mt.set(Vt, Bt);
    }), Mt;
  }), _defineProperty(this, "getFieldEntitiesForNamePathList", function($t) {
    if (!$t)
      return Pt.getFieldEntities(!0);
    var Mt = Pt.getFieldsMap(!0);
    return $t.map(function(Bt) {
      var Vt = getNamePath(Bt);
      return Mt.get(Vt) || {
        INVALIDATE_NAME_PATH: getNamePath(Bt)
      };
    });
  }), _defineProperty(this, "getFieldsValue", function($t, Mt) {
    Pt.warningUnhooked();
    var Bt, Vt, zt;
    if ($t === !0 || Array.isArray($t) ? (Bt = $t, Vt = Mt) : $t && _typeof($t) === "object" && (zt = $t.strict, Vt = $t.filter), Bt === !0 && !Vt)
      return Pt.store;
    var Ht = Pt.getFieldEntitiesForNamePathList(Array.isArray(Bt) ? Bt : null), Wt = [];
    return Ht.forEach(function(Gt) {
      var qt, Kt, Qt = "INVALIDATE_NAME_PATH" in Gt ? Gt.INVALIDATE_NAME_PATH : Gt.getNamePath();
      if (zt) {
        var Xt, Zt;
        if ((Xt = (Zt = Gt).isList) !== null && Xt !== void 0 && Xt.call(Zt))
          return;
      } else if (!Bt && (qt = (Kt = Gt).isListField) !== null && qt !== void 0 && qt.call(Kt))
        return;
      if (!Vt)
        Wt.push(Qt);
      else {
        var Yt = "getMeta" in Gt ? Gt.getMeta() : null;
        Vt(Yt) && Wt.push(Qt);
      }
    }), cloneByNamePathList(Pt.store, Wt.map(getNamePath));
  }), _defineProperty(this, "getFieldValue", function($t) {
    Pt.warningUnhooked();
    var Mt = getNamePath($t);
    return get$3(Pt.store, Mt);
  }), _defineProperty(this, "getFieldsError", function($t) {
    Pt.warningUnhooked();
    var Mt = Pt.getFieldEntitiesForNamePathList($t);
    return Mt.map(function(Bt, Vt) {
      return Bt && !("INVALIDATE_NAME_PATH" in Bt) ? {
        name: Bt.getNamePath(),
        errors: Bt.getErrors(),
        warnings: Bt.getWarnings()
      } : {
        name: getNamePath($t[Vt]),
        errors: [],
        warnings: []
      };
    });
  }), _defineProperty(this, "getFieldError", function($t) {
    Pt.warningUnhooked();
    var Mt = getNamePath($t), Bt = Pt.getFieldsError([Mt])[0];
    return Bt.errors;
  }), _defineProperty(this, "getFieldWarning", function($t) {
    Pt.warningUnhooked();
    var Mt = getNamePath($t), Bt = Pt.getFieldsError([Mt])[0];
    return Bt.warnings;
  }), _defineProperty(this, "isFieldsTouched", function() {
    Pt.warningUnhooked();
    for (var $t = arguments.length, Mt = new Array($t), Bt = 0; Bt < $t; Bt++)
      Mt[Bt] = arguments[Bt];
    var Vt = Mt[0], zt = Mt[1], Ht, Wt = !1;
    Mt.length === 0 ? Ht = null : Mt.length === 1 ? Array.isArray(Vt) ? (Ht = Vt.map(getNamePath), Wt = !1) : (Ht = null, Wt = Vt) : (Ht = Vt.map(getNamePath), Wt = zt);
    var Gt = Pt.getFieldEntities(!0), qt = function(Yt) {
      return Yt.isFieldTouched();
    };
    if (!Ht)
      return Wt ? Gt.every(function(Zt) {
        return qt(Zt) || Zt.isList();
      }) : Gt.some(qt);
    var Kt = new NameMap();
    Ht.forEach(function(Zt) {
      Kt.set(Zt, []);
    }), Gt.forEach(function(Zt) {
      var Yt = Zt.getNamePath();
      Ht.forEach(function(Jt) {
        Jt.every(function(er, tr) {
          return Yt[tr] === er;
        }) && Kt.update(Jt, function(er) {
          return [].concat(_toConsumableArray(er), [Zt]);
        });
      });
    });
    var Qt = function(Yt) {
      return Yt.some(qt);
    }, Xt = Kt.map(function(Zt) {
      var Yt = Zt.value;
      return Yt;
    });
    return Wt ? Xt.every(Qt) : Xt.some(Qt);
  }), _defineProperty(this, "isFieldTouched", function($t) {
    return Pt.warningUnhooked(), Pt.isFieldsTouched([$t]);
  }), _defineProperty(this, "isFieldsValidating", function($t) {
    Pt.warningUnhooked();
    var Mt = Pt.getFieldEntities();
    if (!$t)
      return Mt.some(function(Vt) {
        return Vt.isFieldValidating();
      });
    var Bt = $t.map(getNamePath);
    return Mt.some(function(Vt) {
      var zt = Vt.getNamePath();
      return containsNamePath(Bt, zt) && Vt.isFieldValidating();
    });
  }), _defineProperty(this, "isFieldValidating", function($t) {
    return Pt.warningUnhooked(), Pt.isFieldsValidating([$t]);
  }), _defineProperty(this, "resetWithFieldInitialValue", function() {
    var $t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, Mt = new NameMap(), Bt = Pt.getFieldEntities(!0);
    Bt.forEach(function(Ht) {
      var Wt = Ht.props.initialValue, Gt = Ht.getNamePath();
      if (Wt !== void 0) {
        var qt = Mt.get(Gt) || /* @__PURE__ */ new Set();
        qt.add({
          entity: Ht,
          value: Wt
        }), Mt.set(Gt, qt);
      }
    });
    var Vt = function(Wt) {
      Wt.forEach(function(Gt) {
        var qt = Gt.props.initialValue;
        if (qt !== void 0) {
          var Kt = Gt.getNamePath(), Qt = Pt.getInitialValue(Kt);
          if (Qt !== void 0)
            warningOnce(!1, "Form already set 'initialValues' with path '".concat(Kt.join("."), "'. Field can not overwrite it."));
          else {
            var Xt = Mt.get(Kt);
            if (Xt && Xt.size > 1)
              warningOnce(!1, "Multiple Field with path '".concat(Kt.join("."), "' set 'initialValue'. Can not decide which one to pick."));
            else if (Xt) {
              var Zt = Pt.getFieldValue(Kt), Yt = Gt.isListField();
              !Yt && (!$t.skipExist || Zt === void 0) && Pt.updateStore(set$2(Pt.store, Kt, _toConsumableArray(Xt)[0].value));
            }
          }
        }
      });
    }, zt;
    $t.entities ? zt = $t.entities : $t.namePathList ? (zt = [], $t.namePathList.forEach(function(Ht) {
      var Wt = Mt.get(Ht);
      if (Wt) {
        var Gt;
        (Gt = zt).push.apply(Gt, _toConsumableArray(_toConsumableArray(Wt).map(function(qt) {
          return qt.entity;
        })));
      }
    })) : zt = Bt, Vt(zt);
  }), _defineProperty(this, "resetFields", function($t) {
    Pt.warningUnhooked();
    var Mt = Pt.store;
    if (!$t) {
      Pt.updateStore(merge$2(Pt.initialValues)), Pt.resetWithFieldInitialValue(), Pt.notifyObservers(Mt, null, {
        type: "reset"
      }), Pt.notifyWatch();
      return;
    }
    var Bt = $t.map(getNamePath);
    Bt.forEach(function(Vt) {
      var zt = Pt.getInitialValue(Vt);
      Pt.updateStore(set$2(Pt.store, Vt, zt));
    }), Pt.resetWithFieldInitialValue({
      namePathList: Bt
    }), Pt.notifyObservers(Mt, Bt, {
      type: "reset"
    }), Pt.notifyWatch(Bt);
  }), _defineProperty(this, "setFields", function($t) {
    Pt.warningUnhooked();
    var Mt = Pt.store, Bt = [];
    $t.forEach(function(Vt) {
      var zt = Vt.name, Ht = _objectWithoutProperties$2(Vt, _excluded$i), Wt = getNamePath(zt);
      Bt.push(Wt), "value" in Ht && Pt.updateStore(set$2(Pt.store, Wt, Ht.value)), Pt.notifyObservers(Mt, [Wt], {
        type: "setField",
        data: Vt
      });
    }), Pt.notifyWatch(Bt);
  }), _defineProperty(this, "getFields", function() {
    var $t = Pt.getFieldEntities(!0), Mt = $t.map(function(Bt) {
      var Vt = Bt.getNamePath(), zt = Bt.getMeta(), Ht = _objectSpread2(_objectSpread2({}, zt), {}, {
        name: Vt,
        value: Pt.getFieldValue(Vt)
      });
      return Object.defineProperty(Ht, "originRCField", {
        value: !0
      }), Ht;
    });
    return Mt;
  }), _defineProperty(this, "initEntityValue", function($t) {
    var Mt = $t.props.initialValue;
    if (Mt !== void 0) {
      var Bt = $t.getNamePath(), Vt = get$3(Pt.store, Bt);
      Vt === void 0 && Pt.updateStore(set$2(Pt.store, Bt, Mt));
    }
  }), _defineProperty(this, "isMergedPreserve", function($t) {
    var Mt = $t !== void 0 ? $t : Pt.preserve;
    return Mt ?? !0;
  }), _defineProperty(this, "registerField", function($t) {
    Pt.fieldEntities.push($t);
    var Mt = $t.getNamePath();
    if (Pt.notifyWatch([Mt]), $t.props.initialValue !== void 0) {
      var Bt = Pt.store;
      Pt.resetWithFieldInitialValue({
        entities: [$t],
        skipExist: !0
      }), Pt.notifyObservers(Bt, [$t.getNamePath()], {
        type: "valueUpdate",
        source: "internal"
      });
    }
    return function(Vt, zt) {
      var Ht = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
      if (Pt.fieldEntities = Pt.fieldEntities.filter(function(qt) {
        return qt !== $t;
      }), !Pt.isMergedPreserve(zt) && (!Vt || Ht.length > 1)) {
        var Wt = Vt ? void 0 : Pt.getInitialValue(Mt);
        if (Mt.length && Pt.getFieldValue(Mt) !== Wt && Pt.fieldEntities.every(function(qt) {
          return (
            // Only reset when no namePath exist
            !matchNamePath(qt.getNamePath(), Mt)
          );
        })) {
          var Gt = Pt.store;
          Pt.updateStore(set$2(Gt, Mt, Wt, !0)), Pt.notifyObservers(Gt, [Mt], {
            type: "remove"
          }), Pt.triggerDependenciesUpdate(Gt, Mt);
        }
      }
      Pt.notifyWatch([Mt]);
    };
  }), _defineProperty(this, "dispatch", function($t) {
    switch ($t.type) {
      case "updateValue": {
        var Mt = $t.namePath, Bt = $t.value;
        Pt.updateValue(Mt, Bt);
        break;
      }
      case "validateField": {
        var Vt = $t.namePath, zt = $t.triggerName;
        Pt.validateFields([Vt], {
          triggerName: zt
        });
        break;
      }
    }
  }), _defineProperty(this, "notifyObservers", function($t, Mt, Bt) {
    if (Pt.subscribable) {
      var Vt = _objectSpread2(_objectSpread2({}, Bt), {}, {
        store: Pt.getFieldsValue(!0)
      });
      Pt.getFieldEntities().forEach(function(zt) {
        var Ht = zt.onStoreChange;
        Ht($t, Mt, Vt);
      });
    } else
      Pt.forceRootUpdate();
  }), _defineProperty(this, "triggerDependenciesUpdate", function($t, Mt) {
    var Bt = Pt.getDependencyChildrenFields(Mt);
    return Bt.length && Pt.validateFields(Bt), Pt.notifyObservers($t, Bt, {
      type: "dependenciesUpdate",
      relatedFields: [Mt].concat(_toConsumableArray(Bt))
    }), Bt;
  }), _defineProperty(this, "updateValue", function($t, Mt) {
    var Bt = getNamePath($t), Vt = Pt.store;
    Pt.updateStore(set$2(Pt.store, Bt, Mt)), Pt.notifyObservers(Vt, [Bt], {
      type: "valueUpdate",
      source: "internal"
    }), Pt.notifyWatch([Bt]);
    var zt = Pt.triggerDependenciesUpdate(Vt, Bt), Ht = Pt.callbacks.onValuesChange;
    if (Ht) {
      var Wt = cloneByNamePathList(Pt.store, [Bt]);
      Ht(Wt, Pt.getFieldsValue());
    }
    Pt.triggerOnFieldsChange([Bt].concat(_toConsumableArray(zt)));
  }), _defineProperty(this, "setFieldsValue", function($t) {
    Pt.warningUnhooked();
    var Mt = Pt.store;
    if ($t) {
      var Bt = merge$2(Pt.store, $t);
      Pt.updateStore(Bt);
    }
    Pt.notifyObservers(Mt, null, {
      type: "valueUpdate",
      source: "external"
    }), Pt.notifyWatch();
  }), _defineProperty(this, "setFieldValue", function($t, Mt) {
    Pt.setFields([{
      name: $t,
      value: Mt,
      errors: [],
      warnings: []
    }]);
  }), _defineProperty(this, "getDependencyChildrenFields", function($t) {
    var Mt = /* @__PURE__ */ new Set(), Bt = [], Vt = new NameMap();
    Pt.getFieldEntities().forEach(function(Ht) {
      var Wt = Ht.props.dependencies;
      (Wt || []).forEach(function(Gt) {
        var qt = getNamePath(Gt);
        Vt.update(qt, function() {
          var Kt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : /* @__PURE__ */ new Set();
          return Kt.add(Ht), Kt;
        });
      });
    });
    var zt = function Ht(Wt) {
      var Gt = Vt.get(Wt) || /* @__PURE__ */ new Set();
      Gt.forEach(function(qt) {
        if (!Mt.has(qt)) {
          Mt.add(qt);
          var Kt = qt.getNamePath();
          qt.isFieldDirty() && Kt.length && (Bt.push(Kt), Ht(Kt));
        }
      });
    };
    return zt($t), Bt;
  }), _defineProperty(this, "triggerOnFieldsChange", function($t, Mt) {
    var Bt = Pt.callbacks.onFieldsChange;
    if (Bt) {
      var Vt = Pt.getFields();
      if (Mt) {
        var zt = new NameMap();
        Mt.forEach(function(Wt) {
          var Gt = Wt.name, qt = Wt.errors;
          zt.set(Gt, qt);
        }), Vt.forEach(function(Wt) {
          Wt.errors = zt.get(Wt.name) || Wt.errors;
        });
      }
      var Ht = Vt.filter(function(Wt) {
        var Gt = Wt.name;
        return containsNamePath($t, Gt);
      });
      Ht.length && Bt(Ht, Vt);
    }
  }), _defineProperty(this, "validateFields", function($t, Mt) {
    Pt.warningUnhooked();
    var Bt, Vt;
    Array.isArray($t) || typeof $t == "string" || typeof Mt == "string" ? (Bt = $t, Vt = Mt) : Vt = $t;
    var zt = !!Bt, Ht = zt ? Bt.map(getNamePath) : [], Wt = [], Gt = String(Date.now()), qt = /* @__PURE__ */ new Set(), Kt = Vt || {}, Qt = Kt.recursive, Xt = Kt.dirty;
    Pt.getFieldEntities(!0).forEach(function(er) {
      if (zt || Ht.push(er.getNamePath()), !(!er.props.rules || !er.props.rules.length) && !(Xt && !er.isFieldDirty())) {
        var tr = er.getNamePath();
        if (qt.add(tr.join(Gt)), !zt || containsNamePath(Ht, tr, Qt)) {
          var nr = er.validateRules(_objectSpread2({
            validateMessages: _objectSpread2(_objectSpread2({}, defaultValidateMessages), Pt.validateMessages)
          }, Vt));
          Wt.push(nr.then(function() {
            return {
              name: tr,
              errors: [],
              warnings: []
            };
          }).catch(function(rr) {
            var ir, ar = [], or = [];
            return (ir = rr.forEach) === null || ir === void 0 || ir.call(rr, function(sr) {
              var lr = sr.rule.warningOnly, cr = sr.errors;
              lr ? or.push.apply(or, _toConsumableArray(cr)) : ar.push.apply(ar, _toConsumableArray(cr));
            }), ar.length ? Promise.reject({
              name: tr,
              errors: ar,
              warnings: or
            }) : {
              name: tr,
              errors: ar,
              warnings: or
            };
          }));
        }
      }
    });
    var Zt = allPromiseFinish(Wt);
    Pt.lastValidatePromise = Zt, Zt.catch(function(er) {
      return er;
    }).then(function(er) {
      var tr = er.map(function(nr) {
        var rr = nr.name;
        return rr;
      });
      Pt.notifyObservers(Pt.store, tr, {
        type: "validateFinish"
      }), Pt.triggerOnFieldsChange(tr, er);
    });
    var Yt = Zt.then(function() {
      return Pt.lastValidatePromise === Zt ? Promise.resolve(Pt.getFieldsValue(Ht)) : Promise.reject([]);
    }).catch(function(er) {
      var tr = er.filter(function(nr) {
        return nr && nr.errors.length;
      });
      return Promise.reject({
        values: Pt.getFieldsValue(Ht),
        errorFields: tr,
        outOfDate: Pt.lastValidatePromise !== Zt
      });
    });
    Yt.catch(function(er) {
      return er;
    });
    var Jt = Ht.filter(function(er) {
      return qt.has(er.join(Gt));
    });
    return Pt.triggerOnFieldsChange(Jt), Yt;
  }), _defineProperty(this, "submit", function() {
    Pt.warningUnhooked(), Pt.validateFields().then(function($t) {
      var Mt = Pt.callbacks.onFinish;
      if (Mt)
        try {
          Mt($t);
        } catch (Bt) {
          console.error(Bt);
        }
    }).catch(function($t) {
      var Mt = Pt.callbacks.onFinishFailed;
      Mt && Mt($t);
    });
  }), this.forceRootUpdate = Et;
});
function useForm(_t) {
  var Et = React.useRef(), Pt = React.useState({}), $t = _slicedToArray(Pt, 2), Mt = $t[1];
  if (!Et.current)
    if (_t)
      Et.current = _t;
    else {
      var Bt = function() {
        Mt({});
      }, Vt = new FormStore(Bt);
      Et.current = Vt.getForm();
    }
  return [Et.current];
}
var FormContext = /* @__PURE__ */ React.createContext({
  triggerFormChange: function() {
  },
  triggerFormFinish: function() {
  },
  registerForm: function() {
  },
  unregisterForm: function() {
  }
}), FormProvider = function(Et) {
  var Pt = Et.validateMessages, $t = Et.onFormChange, Mt = Et.onFormFinish, Bt = Et.children, Vt = React.useContext(FormContext), zt = React.useRef({});
  return /* @__PURE__ */ React.createElement(FormContext.Provider, {
    value: _objectSpread2(_objectSpread2({}, Vt), {}, {
      validateMessages: _objectSpread2(_objectSpread2({}, Vt.validateMessages), Pt),
      // =========================================================
      // =                  Global Form Control                  =
      // =========================================================
      triggerFormChange: function(Wt, Gt) {
        $t && $t(Wt, {
          changedFields: Gt,
          forms: zt.current
        }), Vt.triggerFormChange(Wt, Gt);
      },
      triggerFormFinish: function(Wt, Gt) {
        Mt && Mt(Wt, {
          values: Gt,
          forms: zt.current
        }), Vt.triggerFormFinish(Wt, Gt);
      },
      registerForm: function(Wt, Gt) {
        Wt && (zt.current = _objectSpread2(_objectSpread2({}, zt.current), {}, _defineProperty({}, Wt, Gt))), Vt.registerForm(Wt, Gt);
      },
      unregisterForm: function(Wt) {
        var Gt = _objectSpread2({}, zt.current);
        delete Gt[Wt], zt.current = Gt, Vt.unregisterForm(Wt);
      }
    })
  }, Bt);
}, _excluded$h = ["name", "initialValues", "fields", "form", "preserve", "children", "component", "validateMessages", "validateTrigger", "onValuesChange", "onFieldsChange", "onFinish", "onFinishFailed", "clearOnDestroy"], Form = function(Et, Pt) {
  var $t = Et.name, Mt = Et.initialValues, Bt = Et.fields, Vt = Et.form, zt = Et.preserve, Ht = Et.children, Wt = Et.component, Gt = Wt === void 0 ? "form" : Wt, qt = Et.validateMessages, Kt = Et.validateTrigger, Qt = Kt === void 0 ? "onChange" : Kt, Xt = Et.onValuesChange, Zt = Et.onFieldsChange, Yt = Et.onFinish, Jt = Et.onFinishFailed, er = Et.clearOnDestroy, tr = _objectWithoutProperties$2(Et, _excluded$h), nr = React.useRef(null), rr = React.useContext(FormContext), ir = useForm(Vt), ar = _slicedToArray(ir, 1), or = ar[0], sr = or.getInternalHooks(HOOK_MARK), lr = sr.useSubscribe, cr = sr.setInitialValues, hr = sr.setCallbacks, pr = sr.setValidateMessages, mr = sr.setPreserve, Er = sr.destroyForm;
  React.useImperativeHandle(Pt, function() {
    return _objectSpread2(_objectSpread2({}, or), {}, {
      nativeElement: nr.current
    });
  }), React.useEffect(function() {
    return rr.registerForm($t, or), function() {
      rr.unregisterForm($t);
    };
  }, [rr, or, $t]), pr(_objectSpread2(_objectSpread2({}, rr.validateMessages), qt)), hr({
    onValuesChange: Xt,
    onFieldsChange: function(xr) {
      if (rr.triggerFormChange($t, xr), Zt) {
        for (var kr = arguments.length, Ir = new Array(kr > 1 ? kr - 1 : 0), Ar = 1; Ar < kr; Ar++)
          Ir[Ar - 1] = arguments[Ar];
        Zt.apply(void 0, [xr].concat(Ir));
      }
    },
    onFinish: function(xr) {
      rr.triggerFormFinish($t, xr), Yt && Yt(xr);
    },
    onFinishFailed: Jt
  }), mr(zt);
  var _r = React.useRef(null);
  cr(Mt, !_r.current), _r.current || (_r.current = !0), React.useEffect(
    function() {
      return function() {
        return Er(er);
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  var yr, ur = typeof Ht == "function";
  if (ur) {
    var vr = or.getFieldsValue(!0);
    yr = Ht(vr, or);
  } else
    yr = Ht;
  lr(!ur);
  var dr = React.useRef();
  React.useEffect(function() {
    isSimilar(dr.current || [], Bt || []) || or.setFields(Bt || []), dr.current = Bt;
  }, [Bt, or]);
  var br = React.useMemo(function() {
    return _objectSpread2(_objectSpread2({}, or), {}, {
      validateTrigger: Qt
    });
  }, [or, Qt]), Cr = /* @__PURE__ */ React.createElement(ListContext.Provider, {
    value: null
  }, /* @__PURE__ */ React.createElement(Context.Provider, {
    value: br
  }, yr));
  return Gt === !1 ? Cr : /* @__PURE__ */ React.createElement(Gt, _extends$2({}, tr, {
    ref: nr,
    onSubmit: function(xr) {
      xr.preventDefault(), xr.stopPropagation(), or.submit();
    },
    onReset: function(xr) {
      var kr;
      xr.preventDefault(), or.resetFields(), (kr = tr.onReset) === null || kr === void 0 || kr.call(tr, xr);
    }
  }), Cr);
};
function stringify$1(_t) {
  try {
    return JSON.stringify(_t);
  } catch {
    return Math.random();
  }
}
var useWatchWarning = browser$1.env.NODE_ENV !== "production" ? function(_t) {
  var Et = _t.join("__RC_FIELD_FORM_SPLIT__"), Pt = useRef(Et);
  warningOnce(Pt.current === Et, "`useWatch` is not support dynamic `namePath`. Please provide static instead.");
} : function() {
};
function useWatch$1() {
  for (var _t = arguments.length, Et = new Array(_t), Pt = 0; Pt < _t; Pt++)
    Et[Pt] = arguments[Pt];
  var $t = Et[0], Mt = Et[1], Bt = Mt === void 0 ? {} : Mt, Vt = isFormInstance(Bt) ? {
    form: Bt
  } : Bt, zt = Vt.form, Ht = useState(), Wt = _slicedToArray(Ht, 2), Gt = Wt[0], qt = Wt[1], Kt = useMemo$1(function() {
    return stringify$1(Gt);
  }, [Gt]), Qt = useRef(Kt);
  Qt.current = Kt;
  var Xt = useContext(Context), Zt = zt || Xt, Yt = Zt && Zt._init;
  browser$1.env.NODE_ENV !== "production" && warningOnce(Et.length === 2 ? zt ? Yt : !0 : Yt, "useWatch requires a form instance since it can not auto detect from context.");
  var Jt = getNamePath($t), er = useRef(Jt);
  return er.current = Jt, useWatchWarning(Jt), useEffect(
    function() {
      if (Yt) {
        var tr = Zt.getFieldsValue, nr = Zt.getInternalHooks, rr = nr(HOOK_MARK), ir = rr.registerWatch, ar = function(cr, hr) {
          var pr = Vt.preserve ? hr : cr;
          return typeof $t == "function" ? $t(pr) : get$3(pr, er.current);
        }, or = ir(function(lr, cr) {
          var hr = ar(lr, cr), pr = stringify$1(hr);
          Qt.current !== pr && (Qt.current = pr, qt(hr));
        }), sr = ar(tr(), tr(!0));
        return Gt !== sr && qt(sr), or;
      }
    },
    // We do not need re-register since namePath content is the same
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [Yt]
  ), Gt;
}
var InternalForm = /* @__PURE__ */ React.forwardRef(Form), RefForm = InternalForm;
RefForm.FormProvider = FormProvider;
RefForm.Field = WrapperField;
RefForm.List = List;
RefForm.useForm = useForm;
RefForm.useWatch = useWatch$1;
const FormItemInputContext = /* @__PURE__ */ React.createContext({});
browser$1.env.NODE_ENV !== "production" && (FormItemInputContext.displayName = "FormItemInputContext");
const NoFormStyle = (_t) => {
  let {
    children: Et,
    status: Pt,
    override: $t
  } = _t;
  const Mt = React.useContext(FormItemInputContext), Bt = React.useMemo(() => {
    const Vt = Object.assign({}, Mt);
    return $t && delete Vt.isFormItemInput, Pt && (delete Vt.status, delete Vt.hasFeedback, delete Vt.feedbackIcon), Vt;
  }, [Pt, $t, Mt]);
  return /* @__PURE__ */ React.createElement(FormItemInputContext.Provider, {
    value: Bt
  }, Et);
}, ContextIsolator = (_t) => {
  const {
    space: Et,
    form: Pt,
    children: $t
  } = _t;
  if ($t == null)
    return null;
  let Mt = $t;
  return Pt && (Mt = /* @__PURE__ */ React__default.createElement(NoFormStyle, {
    override: !0,
    status: !0
  }, Mt)), Et && (Mt = /* @__PURE__ */ React__default.createElement(NoCompactStyle, null, Mt)), Mt;
};
function pickClosable(_t) {
  if (_t)
    return {
      closable: _t.closable,
      closeIcon: _t.closeIcon
    };
}
function useClosableConfig(_t) {
  const {
    closable: Et,
    closeIcon: Pt
  } = _t || {};
  return React__default.useMemo(() => {
    if (
      // If `closable`, whatever rest be should be true
      !Et && (Et === !1 || Pt === !1 || Pt === null)
    )
      return !1;
    if (Et === void 0 && Pt === void 0)
      return null;
    let $t = {
      closeIcon: typeof Pt != "boolean" && Pt !== null ? Pt : void 0
    };
    return Et && typeof Et == "object" && ($t = Object.assign(Object.assign({}, $t), Et)), $t;
  }, [Et, Pt]);
}
function assignWithoutUndefined() {
  const _t = {};
  for (var Et = arguments.length, Pt = new Array(Et), $t = 0; $t < Et; $t++)
    Pt[$t] = arguments[$t];
  return Pt.forEach((Mt) => {
    Mt && Object.keys(Mt).forEach((Bt) => {
      Mt[Bt] !== void 0 && (_t[Bt] = Mt[Bt]);
    });
  }), _t;
}
const EmptyFallbackCloseCollection = {};
function useClosable(_t, Et) {
  let Pt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : EmptyFallbackCloseCollection;
  const $t = useClosableConfig(_t), Mt = useClosableConfig(Et), Bt = typeof $t != "boolean" ? !!($t != null && $t.disabled) : !1, Vt = React__default.useMemo(() => Object.assign({
    closeIcon: /* @__PURE__ */ React__default.createElement(RefIcon$6, null)
  }, Pt), [Pt]), zt = React__default.useMemo(() => $t === !1 ? !1 : $t ? assignWithoutUndefined(Vt, Mt, $t) : Mt === !1 ? !1 : Mt ? assignWithoutUndefined(Vt, Mt) : Vt.closable ? Vt : !1, [$t, Mt, Vt]);
  return React__default.useMemo(() => {
    if (zt === !1)
      return [!1, null, Bt];
    const {
      closeIconRender: Ht
    } = Vt, {
      closeIcon: Wt
    } = zt;
    let Gt = Wt;
    if (Gt != null) {
      Ht && (Gt = Ht(Wt));
      const qt = pickAttrs(zt, !0);
      Object.keys(qt).length && (Gt = /* @__PURE__ */ React__default.isValidElement(Gt) ? /* @__PURE__ */ React__default.cloneElement(Gt, qt) : /* @__PURE__ */ React__default.createElement("span", Object.assign({}, qt), Gt));
    }
    return [!0, Gt, Bt];
  }, [zt, Vt]);
}
const canUseDocElement = () => canUseDom() && window.document.documentElement, Element$1 = (_t) => {
  const {
    prefixCls: Et,
    className: Pt,
    style: $t,
    size: Mt,
    shape: Bt
  } = _t, Vt = classNames({
    [`${Et}-lg`]: Mt === "large",
    [`${Et}-sm`]: Mt === "small"
  }), zt = classNames({
    [`${Et}-circle`]: Bt === "circle",
    [`${Et}-square`]: Bt === "square",
    [`${Et}-round`]: Bt === "round"
  }), Ht = React.useMemo(() => typeof Mt == "number" ? {
    width: Mt,
    height: Mt,
    lineHeight: `${Mt}px`
  } : {}, [Mt]);
  return /* @__PURE__ */ React.createElement("span", {
    className: classNames(Et, Vt, zt, Pt),
    style: Object.assign(Object.assign({}, Ht), $t)
  });
}, skeletonClsLoading = new Keyframe("ant-skeleton-loading", {
  "0%": {
    backgroundPosition: "100% 50%"
  },
  "100%": {
    backgroundPosition: "0 50%"
  }
}), genSkeletonElementCommonSize = (_t) => ({
  height: _t,
  lineHeight: unit$1(_t)
}), genSkeletonElementAvatarSize = (_t) => Object.assign({
  width: _t
}, genSkeletonElementCommonSize(_t)), genSkeletonColor = (_t) => ({
  background: _t.skeletonLoadingBackground,
  backgroundSize: "400% 100%",
  animationName: skeletonClsLoading,
  animationDuration: _t.skeletonLoadingMotionDuration,
  animationTimingFunction: "ease",
  animationIterationCount: "infinite"
}), genSkeletonElementInputSize = (_t, Et) => Object.assign({
  width: Et(_t).mul(5).equal(),
  minWidth: Et(_t).mul(5).equal()
}, genSkeletonElementCommonSize(_t)), genSkeletonElementAvatar = (_t) => {
  const {
    skeletonAvatarCls: Et,
    gradientFromColor: Pt,
    controlHeight: $t,
    controlHeightLG: Mt,
    controlHeightSM: Bt
  } = _t;
  return {
    [Et]: Object.assign({
      display: "inline-block",
      verticalAlign: "top",
      background: Pt
    }, genSkeletonElementAvatarSize($t)),
    [`${Et}${Et}-circle`]: {
      borderRadius: "50%"
    },
    [`${Et}${Et}-lg`]: Object.assign({}, genSkeletonElementAvatarSize(Mt)),
    [`${Et}${Et}-sm`]: Object.assign({}, genSkeletonElementAvatarSize(Bt))
  };
}, genSkeletonElementInput = (_t) => {
  const {
    controlHeight: Et,
    borderRadiusSM: Pt,
    skeletonInputCls: $t,
    controlHeightLG: Mt,
    controlHeightSM: Bt,
    gradientFromColor: Vt,
    calc: zt
  } = _t;
  return {
    [$t]: Object.assign({
      display: "inline-block",
      verticalAlign: "top",
      background: Vt,
      borderRadius: Pt
    }, genSkeletonElementInputSize(Et, zt)),
    [`${$t}-lg`]: Object.assign({}, genSkeletonElementInputSize(Mt, zt)),
    [`${$t}-sm`]: Object.assign({}, genSkeletonElementInputSize(Bt, zt))
  };
}, genSkeletonElementImageSize = (_t) => Object.assign({
  width: _t
}, genSkeletonElementCommonSize(_t)), genSkeletonElementImage = (_t) => {
  const {
    skeletonImageCls: Et,
    imageSizeBase: Pt,
    gradientFromColor: $t,
    borderRadiusSM: Mt,
    calc: Bt
  } = _t;
  return {
    [Et]: Object.assign(Object.assign({
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      verticalAlign: "middle",
      background: $t,
      borderRadius: Mt
    }, genSkeletonElementImageSize(Bt(Pt).mul(2).equal())), {
      [`${Et}-path`]: {
        fill: "#bfbfbf"
      },
      [`${Et}-svg`]: Object.assign(Object.assign({}, genSkeletonElementImageSize(Pt)), {
        maxWidth: Bt(Pt).mul(4).equal(),
        maxHeight: Bt(Pt).mul(4).equal()
      }),
      [`${Et}-svg${Et}-svg-circle`]: {
        borderRadius: "50%"
      }
    }),
    [`${Et}${Et}-circle`]: {
      borderRadius: "50%"
    }
  };
}, genSkeletonElementButtonShape = (_t, Et, Pt) => {
  const {
    skeletonButtonCls: $t
  } = _t;
  return {
    [`${Pt}${$t}-circle`]: {
      width: Et,
      minWidth: Et,
      borderRadius: "50%"
    },
    [`${Pt}${$t}-round`]: {
      borderRadius: Et
    }
  };
}, genSkeletonElementButtonSize = (_t, Et) => Object.assign({
  width: Et(_t).mul(2).equal(),
  minWidth: Et(_t).mul(2).equal()
}, genSkeletonElementCommonSize(_t)), genSkeletonElementButton = (_t) => {
  const {
    borderRadiusSM: Et,
    skeletonButtonCls: Pt,
    controlHeight: $t,
    controlHeightLG: Mt,
    controlHeightSM: Bt,
    gradientFromColor: Vt,
    calc: zt
  } = _t;
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
    [Pt]: Object.assign({
      display: "inline-block",
      verticalAlign: "top",
      background: Vt,
      borderRadius: Et,
      width: zt($t).mul(2).equal(),
      minWidth: zt($t).mul(2).equal()
    }, genSkeletonElementButtonSize($t, zt))
  }, genSkeletonElementButtonShape(_t, $t, Pt)), {
    [`${Pt}-lg`]: Object.assign({}, genSkeletonElementButtonSize(Mt, zt))
  }), genSkeletonElementButtonShape(_t, Mt, `${Pt}-lg`)), {
    [`${Pt}-sm`]: Object.assign({}, genSkeletonElementButtonSize(Bt, zt))
  }), genSkeletonElementButtonShape(_t, Bt, `${Pt}-sm`));
}, genBaseStyle$1 = (_t) => {
  const {
    componentCls: Et,
    skeletonAvatarCls: Pt,
    skeletonTitleCls: $t,
    skeletonParagraphCls: Mt,
    skeletonButtonCls: Bt,
    skeletonInputCls: Vt,
    skeletonImageCls: zt,
    controlHeight: Ht,
    controlHeightLG: Wt,
    controlHeightSM: Gt,
    gradientFromColor: qt,
    padding: Kt,
    marginSM: Qt,
    borderRadius: Xt,
    titleHeight: Zt,
    blockRadius: Yt,
    paragraphLiHeight: Jt,
    controlHeightXS: er,
    paragraphMarginTop: tr
  } = _t;
  return {
    [Et]: {
      display: "table",
      width: "100%",
      [`${Et}-header`]: {
        display: "table-cell",
        paddingInlineEnd: Kt,
        verticalAlign: "top",
        // Avatar
        [Pt]: Object.assign({
          display: "inline-block",
          verticalAlign: "top",
          background: qt
        }, genSkeletonElementAvatarSize(Ht)),
        [`${Pt}-circle`]: {
          borderRadius: "50%"
        },
        [`${Pt}-lg`]: Object.assign({}, genSkeletonElementAvatarSize(Wt)),
        [`${Pt}-sm`]: Object.assign({}, genSkeletonElementAvatarSize(Gt))
      },
      [`${Et}-content`]: {
        display: "table-cell",
        width: "100%",
        verticalAlign: "top",
        // Title
        [$t]: {
          width: "100%",
          height: Zt,
          background: qt,
          borderRadius: Yt,
          [`+ ${Mt}`]: {
            marginBlockStart: Gt
          }
        },
        // paragraph
        [Mt]: {
          padding: 0,
          "> li": {
            width: "100%",
            height: Jt,
            listStyle: "none",
            background: qt,
            borderRadius: Yt,
            "+ li": {
              marginBlockStart: er
            }
          }
        },
        [`${Mt}> li:last-child:not(:first-child):not(:nth-child(2))`]: {
          width: "61%"
        }
      },
      [`&-round ${Et}-content`]: {
        [`${$t}, ${Mt} > li`]: {
          borderRadius: Xt
        }
      }
    },
    [`${Et}-with-avatar ${Et}-content`]: {
      // Title
      [$t]: {
        marginBlockStart: Qt,
        [`+ ${Mt}`]: {
          marginBlockStart: tr
        }
      }
    },
    // Skeleton element
    [`${Et}${Et}-element`]: Object.assign(Object.assign(Object.assign(Object.assign({
      display: "inline-block",
      width: "auto"
    }, genSkeletonElementButton(_t)), genSkeletonElementAvatar(_t)), genSkeletonElementInput(_t)), genSkeletonElementImage(_t)),
    // Skeleton Block Button, Input
    [`${Et}${Et}-block`]: {
      width: "100%",
      [Bt]: {
        width: "100%"
      },
      [Vt]: {
        width: "100%"
      }
    },
    // With active animation
    [`${Et}${Et}-active`]: {
      [`
        ${$t},
        ${Mt} > li,
        ${Pt},
        ${Bt},
        ${Vt},
        ${zt}
      `]: Object.assign({}, genSkeletonColor(_t))
    }
  };
}, prepareComponentToken$5 = (_t) => {
  const {
    colorFillContent: Et,
    colorFill: Pt
  } = _t, $t = Et, Mt = Pt;
  return {
    color: $t,
    colorGradientEnd: Mt,
    gradientFromColor: $t,
    gradientToColor: Mt,
    titleHeight: _t.controlHeight / 2,
    blockRadius: _t.borderRadiusSM,
    paragraphMarginTop: _t.marginLG + _t.marginXXS,
    paragraphLiHeight: _t.controlHeight / 2
  };
}, useStyle$5 = genStyleHooks("Skeleton", (_t) => {
  const {
    componentCls: Et,
    calc: Pt
  } = _t, $t = merge$1(_t, {
    skeletonAvatarCls: `${Et}-avatar`,
    skeletonTitleCls: `${Et}-title`,
    skeletonParagraphCls: `${Et}-paragraph`,
    skeletonButtonCls: `${Et}-button`,
    skeletonInputCls: `${Et}-input`,
    skeletonImageCls: `${Et}-image`,
    imageSizeBase: Pt(_t.controlHeight).mul(1.5).equal(),
    borderRadius: 100,
    // Large number to make capsule shape
    skeletonLoadingBackground: `linear-gradient(90deg, ${_t.gradientFromColor} 25%, ${_t.gradientToColor} 37%, ${_t.gradientFromColor} 63%)`,
    skeletonLoadingMotionDuration: "1.4s"
  });
  return [genBaseStyle$1($t)];
}, prepareComponentToken$5, {
  deprecatedTokens: [["color", "gradientFromColor"], ["colorGradientEnd", "gradientToColor"]]
}), SkeletonAvatar = (_t) => {
  const {
    prefixCls: Et,
    className: Pt,
    rootClassName: $t,
    active: Mt,
    shape: Bt = "circle",
    size: Vt = "default"
  } = _t, {
    getPrefixCls: zt
  } = React.useContext(ConfigContext), Ht = zt("skeleton", Et), [Wt, Gt, qt] = useStyle$5(Ht), Kt = omit(_t, ["prefixCls", "className"]), Qt = classNames(Ht, `${Ht}-element`, {
    [`${Ht}-active`]: Mt
  }, Pt, $t, Gt, qt);
  return Wt(/* @__PURE__ */ React.createElement("div", {
    className: Qt
  }, /* @__PURE__ */ React.createElement(Element$1, Object.assign({
    prefixCls: `${Ht}-avatar`,
    shape: Bt,
    size: Vt
  }, Kt))));
}, SkeletonButton = (_t) => {
  const {
    prefixCls: Et,
    className: Pt,
    rootClassName: $t,
    active: Mt,
    block: Bt = !1,
    size: Vt = "default"
  } = _t, {
    getPrefixCls: zt
  } = React.useContext(ConfigContext), Ht = zt("skeleton", Et), [Wt, Gt, qt] = useStyle$5(Ht), Kt = omit(_t, ["prefixCls"]), Qt = classNames(Ht, `${Ht}-element`, {
    [`${Ht}-active`]: Mt,
    [`${Ht}-block`]: Bt
  }, Pt, $t, Gt, qt);
  return Wt(/* @__PURE__ */ React.createElement("div", {
    className: Qt
  }, /* @__PURE__ */ React.createElement(Element$1, Object.assign({
    prefixCls: `${Ht}-button`,
    size: Vt
  }, Kt))));
}, path = "M365.714286 329.142857q0 45.714286-32.036571 77.677714t-77.677714 32.036571-77.677714-32.036571-32.036571-77.677714 32.036571-77.677714 77.677714-32.036571 77.677714 32.036571 32.036571 77.677714zM950.857143 548.571429l0 256-804.571429 0 0-109.714286 182.857143-182.857143 91.428571 91.428571 292.571429-292.571429zM1005.714286 146.285714l-914.285714 0q-7.460571 0-12.873143 5.412571t-5.412571 12.873143l0 694.857143q0 7.460571 5.412571 12.873143t12.873143 5.412571l914.285714 0q7.460571 0 12.873143-5.412571t5.412571-12.873143l0-694.857143q0-7.460571-5.412571-12.873143t-12.873143-5.412571zM1097.142857 164.571429l0 694.857143q0 37.741714-26.843429 64.585143t-64.585143 26.843429l-914.285714 0q-37.741714 0-64.585143-26.843429t-26.843429-64.585143l0-694.857143q0-37.741714 26.843429-64.585143t64.585143-26.843429l914.285714 0q37.741714 0 64.585143 26.843429t26.843429 64.585143z", SkeletonImage = (_t) => {
  const {
    prefixCls: Et,
    className: Pt,
    rootClassName: $t,
    style: Mt,
    active: Bt
  } = _t, {
    getPrefixCls: Vt
  } = React.useContext(ConfigContext), zt = Vt("skeleton", Et), [Ht, Wt, Gt] = useStyle$5(zt), qt = classNames(zt, `${zt}-element`, {
    [`${zt}-active`]: Bt
  }, Pt, $t, Wt, Gt);
  return Ht(/* @__PURE__ */ React.createElement("div", {
    className: qt
  }, /* @__PURE__ */ React.createElement("div", {
    className: classNames(`${zt}-image`, Pt),
    style: Mt
  }, /* @__PURE__ */ React.createElement("svg", {
    viewBox: "0 0 1098 1024",
    xmlns: "http://www.w3.org/2000/svg",
    className: `${zt}-image-svg`
  }, /* @__PURE__ */ React.createElement("title", null, "Image placeholder"), /* @__PURE__ */ React.createElement("path", {
    d: path,
    className: `${zt}-image-path`
  })))));
}, SkeletonInput = (_t) => {
  const {
    prefixCls: Et,
    className: Pt,
    rootClassName: $t,
    active: Mt,
    block: Bt,
    size: Vt = "default"
  } = _t, {
    getPrefixCls: zt
  } = React.useContext(ConfigContext), Ht = zt("skeleton", Et), [Wt, Gt, qt] = useStyle$5(Ht), Kt = omit(_t, ["prefixCls"]), Qt = classNames(Ht, `${Ht}-element`, {
    [`${Ht}-active`]: Mt,
    [`${Ht}-block`]: Bt
  }, Pt, $t, Gt, qt);
  return Wt(/* @__PURE__ */ React.createElement("div", {
    className: Qt
  }, /* @__PURE__ */ React.createElement(Element$1, Object.assign({
    prefixCls: `${Ht}-input`,
    size: Vt
  }, Kt))));
}, SkeletonNode = (_t) => {
  const {
    prefixCls: Et,
    className: Pt,
    rootClassName: $t,
    style: Mt,
    active: Bt,
    children: Vt
  } = _t, {
    getPrefixCls: zt
  } = React.useContext(ConfigContext), Ht = zt("skeleton", Et), [Wt, Gt, qt] = useStyle$5(Ht), Kt = classNames(Ht, `${Ht}-element`, {
    [`${Ht}-active`]: Bt
  }, Gt, Pt, $t, qt);
  return Wt(/* @__PURE__ */ React.createElement("div", {
    className: Kt
  }, /* @__PURE__ */ React.createElement("div", {
    className: classNames(`${Ht}-image`, Pt),
    style: Mt
  }, Vt)));
}, getWidth = (_t, Et) => {
  const {
    width: Pt,
    rows: $t = 2
  } = Et;
  if (Array.isArray(Pt))
    return Pt[_t];
  if ($t - 1 === _t)
    return Pt;
}, Paragraph = (_t) => {
  const {
    prefixCls: Et,
    className: Pt,
    style: $t,
    rows: Mt
  } = _t, Bt = _toConsumableArray(new Array(Mt)).map((Vt, zt) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ React.createElement("li", {
      key: zt,
      style: {
        width: getWidth(zt, _t)
      }
    })
  ));
  return /* @__PURE__ */ React.createElement("ul", {
    className: classNames(Et, Pt),
    style: $t
  }, Bt);
}, Title$1 = (_t) => {
  let {
    prefixCls: Et,
    className: Pt,
    width: $t,
    style: Mt
  } = _t;
  return (
    // biome-ignore lint/a11y/useHeadingContent: HOC here
    /* @__PURE__ */ React.createElement("h3", {
      className: classNames(Et, Pt),
      style: Object.assign({
        width: $t
      }, Mt)
    })
  );
};
function getComponentProps(_t) {
  return _t && typeof _t == "object" ? _t : {};
}
function getAvatarBasicProps(_t, Et) {
  return _t && !Et ? {
    size: "large",
    shape: "square"
  } : {
    size: "large",
    shape: "circle"
  };
}
function getTitleBasicProps(_t, Et) {
  return !_t && Et ? {
    width: "38%"
  } : _t && Et ? {
    width: "50%"
  } : {};
}
function getParagraphBasicProps(_t, Et) {
  const Pt = {};
  return (!_t || !Et) && (Pt.width = "61%"), !_t && Et ? Pt.rows = 3 : Pt.rows = 2, Pt;
}
const Skeleton = (_t) => {
  const {
    prefixCls: Et,
    loading: Pt,
    className: $t,
    rootClassName: Mt,
    style: Bt,
    children: Vt,
    avatar: zt = !1,
    title: Ht = !0,
    paragraph: Wt = !0,
    active: Gt,
    round: qt
  } = _t, {
    getPrefixCls: Kt,
    direction: Qt,
    skeleton: Xt
  } = React.useContext(ConfigContext), Zt = Kt("skeleton", Et), [Yt, Jt, er] = useStyle$5(Zt);
  if (Pt || !("loading" in _t)) {
    const tr = !!zt, nr = !!Ht, rr = !!Wt;
    let ir;
    if (tr) {
      const sr = Object.assign(Object.assign({
        prefixCls: `${Zt}-avatar`
      }, getAvatarBasicProps(nr, rr)), getComponentProps(zt));
      ir = /* @__PURE__ */ React.createElement("div", {
        className: `${Zt}-header`
      }, /* @__PURE__ */ React.createElement(Element$1, Object.assign({}, sr)));
    }
    let ar;
    if (nr || rr) {
      let sr;
      if (nr) {
        const cr = Object.assign(Object.assign({
          prefixCls: `${Zt}-title`
        }, getTitleBasicProps(tr, rr)), getComponentProps(Ht));
        sr = /* @__PURE__ */ React.createElement(Title$1, Object.assign({}, cr));
      }
      let lr;
      if (rr) {
        const cr = Object.assign(Object.assign({
          prefixCls: `${Zt}-paragraph`
        }, getParagraphBasicProps(tr, nr)), getComponentProps(Wt));
        lr = /* @__PURE__ */ React.createElement(Paragraph, Object.assign({}, cr));
      }
      ar = /* @__PURE__ */ React.createElement("div", {
        className: `${Zt}-content`
      }, sr, lr);
    }
    const or = classNames(Zt, {
      [`${Zt}-with-avatar`]: tr,
      [`${Zt}-active`]: Gt,
      [`${Zt}-rtl`]: Qt === "rtl",
      [`${Zt}-round`]: qt
    }, Xt == null ? void 0 : Xt.className, $t, Mt, Jt, er);
    return Yt(/* @__PURE__ */ React.createElement("div", {
      className: or,
      style: Object.assign(Object.assign({}, Xt == null ? void 0 : Xt.style), Bt)
    }, ir, ar));
  }
  return Vt ?? null;
};
Skeleton.Button = SkeletonButton;
Skeleton.Avatar = SkeletonAvatar;
Skeleton.Input = SkeletonInput;
Skeleton.Image = SkeletonImage;
Skeleton.Node = SkeletonNode;
browser$1.env.NODE_ENV !== "production" && (Skeleton.displayName = "Skeleton");
function voidFunc() {
}
const WatermarkContext = /* @__PURE__ */ React.createContext({
  add: voidFunc,
  remove: voidFunc
});
function usePanelRef(_t) {
  const Et = React.useContext(WatermarkContext), Pt = React.useRef(null);
  return useEvent((Mt) => {
    if (Mt) {
      const Bt = _t ? Mt.querySelector(_t) : Mt;
      Et.add(Bt), Pt.current = Bt;
    } else
      Et.remove(Pt.current);
  });
}
const NormalCancelBtn = () => {
  const {
    cancelButtonProps: _t,
    cancelTextLocale: Et,
    onCancel: Pt
  } = useContext(ModalContext);
  return /* @__PURE__ */ React__default.createElement(Button, Object.assign({
    onClick: Pt
  }, _t), Et);
}, NormalOkBtn = () => {
  const {
    confirmLoading: _t,
    okButtonProps: Et,
    okType: Pt,
    okTextLocale: $t,
    onOk: Mt
  } = useContext(ModalContext);
  return /* @__PURE__ */ React__default.createElement(Button, Object.assign({}, convertLegacyProps(Pt), {
    loading: _t,
    onClick: Mt
  }, Et), $t);
};
function renderCloseIcon(_t, Et) {
  return /* @__PURE__ */ React__default.createElement("span", {
    className: `${_t}-close-x`
  }, Et || /* @__PURE__ */ React__default.createElement(RefIcon$6, {
    className: `${_t}-close-icon`
  }));
}
const Footer = (_t) => {
  const {
    okText: Et,
    okType: Pt = "primary",
    cancelText: $t,
    confirmLoading: Mt,
    onOk: Bt,
    onCancel: Vt,
    okButtonProps: zt,
    cancelButtonProps: Ht,
    footer: Wt
  } = _t, [Gt] = useLocale("Modal", getConfirmLocale()), qt = Et || (Gt == null ? void 0 : Gt.okText), Kt = $t || (Gt == null ? void 0 : Gt.cancelText), Qt = {
    confirmLoading: Mt,
    okButtonProps: zt,
    cancelButtonProps: Ht,
    okTextLocale: qt,
    cancelTextLocale: Kt,
    okType: Pt,
    onOk: Bt,
    onCancel: Vt
  }, Xt = React__default.useMemo(() => Qt, _toConsumableArray(Object.values(Qt)));
  let Zt;
  return typeof Wt == "function" || typeof Wt > "u" ? (Zt = /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(NormalCancelBtn, null), /* @__PURE__ */ React__default.createElement(NormalOkBtn, null)), typeof Wt == "function" && (Zt = Wt(Zt, {
    OkBtn: NormalOkBtn,
    CancelBtn: NormalCancelBtn
  })), Zt = /* @__PURE__ */ React__default.createElement(ModalContextProvider, {
    value: Xt
  }, Zt)) : Zt = Wt, /* @__PURE__ */ React__default.createElement(DisabledContextProvider, {
    disabled: !1
  }, Zt);
}, genGridRowStyle = (_t) => {
  const {
    componentCls: Et
  } = _t;
  return {
    // Grid system
    [Et]: {
      display: "flex",
      flexFlow: "row wrap",
      minWidth: 0,
      "&::before, &::after": {
        display: "flex"
      },
      "&-no-wrap": {
        flexWrap: "nowrap"
      },
      // The origin of the X-axis
      "&-start": {
        justifyContent: "flex-start"
      },
      // The center of the X-axis
      "&-center": {
        justifyContent: "center"
      },
      // The opposite of the X-axis
      "&-end": {
        justifyContent: "flex-end"
      },
      "&-space-between": {
        justifyContent: "space-between"
      },
      "&-space-around": {
        justifyContent: "space-around"
      },
      "&-space-evenly": {
        justifyContent: "space-evenly"
      },
      // Align at the top
      "&-top": {
        alignItems: "flex-start"
      },
      // Align at the center
      "&-middle": {
        alignItems: "center"
      },
      "&-bottom": {
        alignItems: "flex-end"
      }
    }
  };
}, genGridColStyle = (_t) => {
  const {
    componentCls: Et
  } = _t;
  return {
    // Grid system
    [Et]: {
      position: "relative",
      maxWidth: "100%",
      // Prevent columns from collapsing when empty
      minHeight: 1
    }
  };
}, genLoopGridColumnsStyle = (_t, Et) => {
  const {
    prefixCls: Pt,
    componentCls: $t,
    gridColumns: Mt
  } = _t, Bt = {};
  for (let Vt = Mt; Vt >= 0; Vt--)
    Vt === 0 ? (Bt[`${$t}${Et}-${Vt}`] = {
      display: "none"
    }, Bt[`${$t}-push-${Vt}`] = {
      insetInlineStart: "auto"
    }, Bt[`${$t}-pull-${Vt}`] = {
      insetInlineEnd: "auto"
    }, Bt[`${$t}${Et}-push-${Vt}`] = {
      insetInlineStart: "auto"
    }, Bt[`${$t}${Et}-pull-${Vt}`] = {
      insetInlineEnd: "auto"
    }, Bt[`${$t}${Et}-offset-${Vt}`] = {
      marginInlineStart: 0
    }, Bt[`${$t}${Et}-order-${Vt}`] = {
      order: 0
    }) : (Bt[`${$t}${Et}-${Vt}`] = [
      // https://github.com/ant-design/ant-design/issues/44456
      // Form set `display: flex` on Col which will override `display: block`.
      // Let's get it from css variable to support override.
      {
        "--ant-display": "block",
        // Fallback to display if variable not support
        display: "block"
      },
      {
        display: "var(--ant-display)",
        flex: `0 0 ${Vt / Mt * 100}%`,
        maxWidth: `${Vt / Mt * 100}%`
      }
    ], Bt[`${$t}${Et}-push-${Vt}`] = {
      insetInlineStart: `${Vt / Mt * 100}%`
    }, Bt[`${$t}${Et}-pull-${Vt}`] = {
      insetInlineEnd: `${Vt / Mt * 100}%`
    }, Bt[`${$t}${Et}-offset-${Vt}`] = {
      marginInlineStart: `${Vt / Mt * 100}%`
    }, Bt[`${$t}${Et}-order-${Vt}`] = {
      order: Vt
    });
  return Bt[`${$t}${Et}-flex`] = {
    flex: `var(--${Pt}${Et}-flex)`
  }, Bt;
}, genGridStyle = (_t, Et) => genLoopGridColumnsStyle(_t, Et), genGridMediaStyle = (_t, Et, Pt) => ({
  [`@media (min-width: ${unit$1(Et)})`]: Object.assign({}, genGridStyle(_t, Pt))
}), prepareRowComponentToken = () => ({}), prepareColComponentToken = () => ({});
genStyleHooks("Grid", genGridRowStyle, prepareRowComponentToken);
const getMediaSize = (_t) => ({
  xs: _t.screenXSMin,
  sm: _t.screenSMMin,
  md: _t.screenMDMin,
  lg: _t.screenLGMin,
  xl: _t.screenXLMin,
  xxl: _t.screenXXLMin
});
genStyleHooks("Grid", (_t) => {
  const Et = merge$1(_t, {
    gridColumns: 24
    // Row is divided into 24 parts in Grid
  }), Pt = getMediaSize(Et);
  return delete Pt.xs, [genGridColStyle(Et), genGridStyle(Et, ""), genGridStyle(Et, "-xs"), Object.keys(Pt).map(($t) => genGridMediaStyle(Et, Pt[$t], `-${$t}`)).reduce(($t, Mt) => Object.assign(Object.assign({}, $t), Mt), {})];
}, prepareColComponentToken);
function box(_t) {
  return {
    position: _t,
    inset: 0
  };
}
const genModalMaskStyle = (_t) => {
  const {
    componentCls: Et,
    antCls: Pt
  } = _t;
  return [{
    [`${Et}-root`]: {
      [`${Et}${Pt}-zoom-enter, ${Et}${Pt}-zoom-appear`]: {
        // reset scale avoid mousePosition bug
        transform: "none",
        opacity: 0,
        animationDuration: _t.motionDurationSlow,
        // https://github.com/ant-design/ant-design/issues/11777
        userSelect: "none"
      },
      // https://github.com/ant-design/ant-design/issues/37329
      // https://github.com/ant-design/ant-design/issues/40272
      [`${Et}${Pt}-zoom-leave ${Et}-content`]: {
        pointerEvents: "none"
      },
      [`${Et}-mask`]: Object.assign(Object.assign({}, box("fixed")), {
        zIndex: _t.zIndexPopupBase,
        height: "100%",
        backgroundColor: _t.colorBgMask,
        pointerEvents: "none",
        [`${Et}-hidden`]: {
          display: "none"
        }
      }),
      [`${Et}-wrap`]: Object.assign(Object.assign({}, box("fixed")), {
        zIndex: _t.zIndexPopupBase,
        overflow: "auto",
        outline: 0,
        WebkitOverflowScrolling: "touch"
      })
    }
  }, {
    [`${Et}-root`]: initFadeMotion(_t)
  }];
}, genModalStyle = (_t) => {
  const {
    componentCls: Et
  } = _t;
  return [
    // ======================== Root =========================
    {
      [`${Et}-root`]: {
        [`${Et}-wrap-rtl`]: {
          direction: "rtl"
        },
        [`${Et}-centered`]: {
          textAlign: "center",
          "&::before": {
            display: "inline-block",
            width: 0,
            height: "100%",
            verticalAlign: "middle",
            content: '""'
          },
          [Et]: {
            top: 0,
            display: "inline-block",
            paddingBottom: 0,
            textAlign: "start",
            verticalAlign: "middle"
          }
        },
        [`@media (max-width: ${_t.screenSMMax}px)`]: {
          [Et]: {
            maxWidth: "calc(100vw - 16px)",
            margin: `${unit$1(_t.marginXS)} auto`
          },
          [`${Et}-centered`]: {
            [Et]: {
              flex: 1
            }
          }
        }
      }
    },
    // ======================== Modal ========================
    {
      [Et]: Object.assign(Object.assign({}, resetComponent(_t)), {
        pointerEvents: "none",
        position: "relative",
        top: 100,
        width: "auto",
        maxWidth: `calc(100vw - ${unit$1(_t.calc(_t.margin).mul(2).equal())})`,
        margin: "0 auto",
        paddingBottom: _t.paddingLG,
        [`${Et}-title`]: {
          margin: 0,
          color: _t.titleColor,
          fontWeight: _t.fontWeightStrong,
          fontSize: _t.titleFontSize,
          lineHeight: _t.titleLineHeight,
          wordWrap: "break-word"
        },
        [`${Et}-content`]: {
          position: "relative",
          backgroundColor: _t.contentBg,
          backgroundClip: "padding-box",
          border: 0,
          borderRadius: _t.borderRadiusLG,
          boxShadow: _t.boxShadow,
          pointerEvents: "auto",
          padding: _t.contentPadding
        },
        [`${Et}-close`]: Object.assign({
          position: "absolute",
          top: _t.calc(_t.modalHeaderHeight).sub(_t.modalCloseBtnSize).div(2).equal(),
          insetInlineEnd: _t.calc(_t.modalHeaderHeight).sub(_t.modalCloseBtnSize).div(2).equal(),
          zIndex: _t.calc(_t.zIndexPopupBase).add(10).equal(),
          padding: 0,
          color: _t.modalCloseIconColor,
          fontWeight: _t.fontWeightStrong,
          lineHeight: 1,
          textDecoration: "none",
          background: "transparent",
          borderRadius: _t.borderRadiusSM,
          width: _t.modalCloseBtnSize,
          height: _t.modalCloseBtnSize,
          border: 0,
          outline: 0,
          cursor: "pointer",
          transition: `color ${_t.motionDurationMid}, background-color ${_t.motionDurationMid}`,
          "&-x": {
            display: "flex",
            fontSize: _t.fontSizeLG,
            fontStyle: "normal",
            lineHeight: unit$1(_t.modalCloseBtnSize),
            justifyContent: "center",
            textTransform: "none",
            textRendering: "auto"
          },
          "&:disabled": {
            pointerEvents: "none"
          },
          "&:hover": {
            color: _t.modalCloseIconHoverColor,
            backgroundColor: _t.colorBgTextHover,
            textDecoration: "none"
          },
          "&:active": {
            backgroundColor: _t.colorBgTextActive
          }
        }, genFocusStyle(_t)),
        [`${Et}-header`]: {
          color: _t.colorText,
          background: _t.headerBg,
          borderRadius: `${unit$1(_t.borderRadiusLG)} ${unit$1(_t.borderRadiusLG)} 0 0`,
          marginBottom: _t.headerMarginBottom,
          padding: _t.headerPadding,
          borderBottom: _t.headerBorderBottom
        },
        [`${Et}-body`]: {
          fontSize: _t.fontSize,
          lineHeight: _t.lineHeight,
          wordWrap: "break-word",
          padding: _t.bodyPadding,
          [`${Et}-body-skeleton`]: {
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: `${unit$1(_t.margin)} auto`
          }
        },
        [`${Et}-footer`]: {
          textAlign: "end",
          background: _t.footerBg,
          marginTop: _t.footerMarginTop,
          padding: _t.footerPadding,
          borderTop: _t.footerBorderTop,
          borderRadius: _t.footerBorderRadius,
          [`> ${_t.antCls}-btn + ${_t.antCls}-btn`]: {
            marginInlineStart: _t.marginXS
          }
        },
        [`${Et}-open`]: {
          overflow: "hidden"
        }
      })
    },
    // ======================== Pure =========================
    {
      [`${Et}-pure-panel`]: {
        top: "auto",
        padding: 0,
        display: "flex",
        flexDirection: "column",
        [`${Et}-content,
          ${Et}-body,
          ${Et}-confirm-body-wrapper`]: {
          display: "flex",
          flexDirection: "column",
          flex: "auto"
        },
        [`${Et}-confirm-body`]: {
          marginBottom: "auto"
        }
      }
    }
  ];
}, genRTLStyle = (_t) => {
  const {
    componentCls: Et
  } = _t;
  return {
    [`${Et}-root`]: {
      [`${Et}-wrap-rtl`]: {
        direction: "rtl",
        [`${Et}-confirm-body`]: {
          direction: "rtl"
        }
      }
    }
  };
}, genResponsiveWidthStyle = (_t) => {
  const {
    componentCls: Et
  } = _t, Pt = getMediaSize(_t);
  delete Pt.xs;
  const $t = Object.keys(Pt).map((Mt) => ({
    [`@media (min-width: ${unit$1(Pt[Mt])})`]: {
      width: `var(--${Et.replace(".", "")}-${Mt}-width)`
    }
  }));
  return {
    [`${Et}-root`]: {
      [Et]: [{
        width: `var(--${Et.replace(".", "")}-xs-width)`
      }].concat(_toConsumableArray($t))
    }
  };
}, prepareToken$1 = (_t) => {
  const Et = _t.padding, Pt = _t.fontSizeHeading5, $t = _t.lineHeightHeading5;
  return merge$1(_t, {
    modalHeaderHeight: _t.calc(_t.calc($t).mul(Pt).equal()).add(_t.calc(Et).mul(2).equal()).equal(),
    modalFooterBorderColorSplit: _t.colorSplit,
    modalFooterBorderStyle: _t.lineType,
    modalFooterBorderWidth: _t.lineWidth,
    modalCloseIconColor: _t.colorIcon,
    modalCloseIconHoverColor: _t.colorIconHover,
    modalCloseBtnSize: _t.controlHeight,
    modalConfirmIconSize: _t.fontHeight,
    modalTitleHeight: _t.calc(_t.titleFontSize).mul(_t.titleLineHeight).equal()
  });
}, prepareComponentToken$4 = (_t) => ({
  footerBg: "transparent",
  headerBg: _t.colorBgElevated,
  titleLineHeight: _t.lineHeightHeading5,
  titleFontSize: _t.fontSizeHeading5,
  contentBg: _t.colorBgElevated,
  titleColor: _t.colorTextHeading,
  // internal
  contentPadding: _t.wireframe ? 0 : `${unit$1(_t.paddingMD)} ${unit$1(_t.paddingContentHorizontalLG)}`,
  headerPadding: _t.wireframe ? `${unit$1(_t.padding)} ${unit$1(_t.paddingLG)}` : 0,
  headerBorderBottom: _t.wireframe ? `${unit$1(_t.lineWidth)} ${_t.lineType} ${_t.colorSplit}` : "none",
  headerMarginBottom: _t.wireframe ? 0 : _t.marginXS,
  bodyPadding: _t.wireframe ? _t.paddingLG : 0,
  footerPadding: _t.wireframe ? `${unit$1(_t.paddingXS)} ${unit$1(_t.padding)}` : 0,
  footerBorderTop: _t.wireframe ? `${unit$1(_t.lineWidth)} ${_t.lineType} ${_t.colorSplit}` : "none",
  footerBorderRadius: _t.wireframe ? `0 0 ${unit$1(_t.borderRadiusLG)} ${unit$1(_t.borderRadiusLG)}` : 0,
  footerMarginTop: _t.wireframe ? 0 : _t.marginSM,
  confirmBodyPadding: _t.wireframe ? `${unit$1(_t.padding * 2)} ${unit$1(_t.padding * 2)} ${unit$1(_t.paddingLG)}` : 0,
  confirmIconMarginInlineEnd: _t.wireframe ? _t.margin : _t.marginSM,
  confirmBtnsMarginTop: _t.wireframe ? _t.marginLG : _t.marginSM
}), useStyle$4 = genStyleHooks("Modal", (_t) => {
  const Et = prepareToken$1(_t);
  return [genModalStyle(Et), genRTLStyle(Et), genModalMaskStyle(Et), initZoomMotion(Et, "zoom"), genResponsiveWidthStyle(Et)];
}, prepareComponentToken$4, {
  unitless: {
    titleLineHeight: !0
  }
});
var __rest$a = function(_t, Et) {
  var Pt = {};
  for (var $t in _t)
    Object.prototype.hasOwnProperty.call(_t, $t) && Et.indexOf($t) < 0 && (Pt[$t] = _t[$t]);
  if (_t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var Mt = 0, $t = Object.getOwnPropertySymbols(_t); Mt < $t.length; Mt++)
      Et.indexOf($t[Mt]) < 0 && Object.prototype.propertyIsEnumerable.call(_t, $t[Mt]) && (Pt[$t[Mt]] = _t[$t[Mt]]);
  return Pt;
};
let mousePosition;
const getClickPosition = (_t) => {
  mousePosition = {
    x: _t.pageX,
    y: _t.pageY
  }, setTimeout(() => {
    mousePosition = null;
  }, 100);
};
canUseDocElement() && document.documentElement.addEventListener("click", getClickPosition, !0);
const Modal$1 = (_t) => {
  var Et;
  const {
    getPopupContainer: Pt,
    getPrefixCls: $t,
    direction: Mt,
    modal: Bt
  } = React.useContext(ConfigContext), Vt = (Ir) => {
    const {
      onCancel: Ar
    } = _t;
    Ar == null || Ar(Ir);
  }, zt = (Ir) => {
    const {
      onOk: Ar
    } = _t;
    Ar == null || Ar(Ir);
  };
  if (browser$1.env.NODE_ENV !== "production") {
    const Ir = devUseWarning("Modal");
    [["visible", "open"], ["bodyStyle", "styles.body"], ["maskStyle", "styles.mask"]].forEach((Ar) => {
      let [Mr, Fr] = Ar;
      Ir.deprecated(!(Mr in _t), Mr, Fr);
    });
  }
  const {
    prefixCls: Ht,
    className: Wt,
    rootClassName: Gt,
    open: qt,
    wrapClassName: Kt,
    centered: Qt,
    getContainer: Xt,
    focusTriggerAfterClose: Zt = !0,
    style: Yt,
    // Deprecated
    visible: Jt,
    width: er = 520,
    footer: tr,
    classNames: nr,
    styles: rr,
    children: ir,
    loading: ar
  } = _t, or = __rest$a(_t, ["prefixCls", "className", "rootClassName", "open", "wrapClassName", "centered", "getContainer", "focusTriggerAfterClose", "style", "visible", "width", "footer", "classNames", "styles", "children", "loading"]), sr = $t("modal", Ht), lr = $t(), cr = useCSSVarCls(sr), [hr, pr, mr] = useStyle$4(sr, cr), Er = classNames(Kt, {
    [`${sr}-centered`]: !!Qt,
    [`${sr}-wrap-rtl`]: Mt === "rtl"
  }), _r = tr !== null && !ar ? /* @__PURE__ */ React.createElement(Footer, Object.assign({}, _t, {
    onOk: zt,
    onCancel: Vt
  })) : null, [yr, ur, vr] = useClosable(pickClosable(_t), pickClosable(Bt), {
    closable: !0,
    closeIcon: /* @__PURE__ */ React.createElement(RefIcon$6, {
      className: `${sr}-close-icon`
    }),
    closeIconRender: (Ir) => renderCloseIcon(sr, Ir)
  }), dr = usePanelRef(`.${sr}-content`), [br, Cr] = useZIndex("Modal", or.zIndex), [Pr, xr] = React.useMemo(() => er && typeof er == "object" ? [void 0, er] : [er, void 0], [er]), kr = React.useMemo(() => {
    const Ir = {};
    return xr && Object.keys(xr).forEach((Ar) => {
      const Mr = xr[Ar];
      Mr !== void 0 && (Ir[`--${sr}-${Ar}-width`] = typeof Mr == "number" ? `${Mr}px` : Mr);
    }), Ir;
  }, [xr]);
  return hr(/* @__PURE__ */ React.createElement(ContextIsolator, {
    form: !0,
    space: !0
  }, /* @__PURE__ */ React.createElement(zIndexContext.Provider, {
    value: Cr
  }, /* @__PURE__ */ React.createElement(DialogWrap, Object.assign({
    width: Pr
  }, or, {
    zIndex: br,
    getContainer: Xt === void 0 ? Pt : Xt,
    prefixCls: sr,
    rootClassName: classNames(pr, Gt, mr, cr),
    footer: _r,
    visible: qt ?? Jt,
    mousePosition: (Et = or.mousePosition) !== null && Et !== void 0 ? Et : mousePosition,
    onClose: Vt,
    closable: yr && {
      disabled: vr,
      closeIcon: ur
    },
    closeIcon: ur,
    focusTriggerAfterClose: Zt,
    transitionName: getTransitionName(lr, "zoom", _t.transitionName),
    maskTransitionName: getTransitionName(lr, "fade", _t.maskTransitionName),
    className: classNames(pr, Wt, Bt == null ? void 0 : Bt.className),
    style: Object.assign(Object.assign(Object.assign({}, Bt == null ? void 0 : Bt.style), Yt), kr),
    classNames: Object.assign(Object.assign(Object.assign({}, Bt == null ? void 0 : Bt.classNames), nr), {
      wrapper: classNames(Er, nr == null ? void 0 : nr.wrapper)
    }),
    styles: Object.assign(Object.assign({}, Bt == null ? void 0 : Bt.styles), rr),
    panelRef: dr
  }), ar ? /* @__PURE__ */ React.createElement(Skeleton, {
    active: !0,
    title: !1,
    paragraph: {
      rows: 4
    },
    className: `${sr}-body-skeleton`
  }) : ir))));
}, genModalConfirmStyle = (_t) => {
  const {
    componentCls: Et,
    titleFontSize: Pt,
    titleLineHeight: $t,
    modalConfirmIconSize: Mt,
    fontSize: Bt,
    lineHeight: Vt,
    modalTitleHeight: zt,
    fontHeight: Ht,
    confirmBodyPadding: Wt
  } = _t, Gt = `${Et}-confirm`;
  return {
    [Gt]: {
      "&-rtl": {
        direction: "rtl"
      },
      [`${_t.antCls}-modal-header`]: {
        display: "none"
      },
      [`${Gt}-body-wrapper`]: Object.assign({}, clearFix()),
      [`&${Et} ${Et}-body`]: {
        padding: Wt
      },
      // ====================== Body ======================
      [`${Gt}-body`]: {
        display: "flex",
        flexWrap: "nowrap",
        alignItems: "start",
        [`> ${_t.iconCls}`]: {
          flex: "none",
          fontSize: Mt,
          marginInlineEnd: _t.confirmIconMarginInlineEnd,
          marginTop: _t.calc(_t.calc(Ht).sub(Mt).equal()).div(2).equal()
        },
        [`&-has-title > ${_t.iconCls}`]: {
          marginTop: _t.calc(_t.calc(zt).sub(Mt).equal()).div(2).equal()
        }
      },
      [`${Gt}-paragraph`]: {
        display: "flex",
        flexDirection: "column",
        flex: "auto",
        rowGap: _t.marginXS,
        // https://github.com/ant-design/ant-design/issues/51912
        maxWidth: `calc(100% - ${unit$1(_t.marginSM)})`
      },
      // https://github.com/ant-design/ant-design/issues/48159
      [`${_t.iconCls} + ${Gt}-paragraph`]: {
        maxWidth: `calc(100% - ${unit$1(_t.calc(_t.modalConfirmIconSize).add(_t.marginSM).equal())})`
      },
      [`${Gt}-title`]: {
        color: _t.colorTextHeading,
        fontWeight: _t.fontWeightStrong,
        fontSize: Pt,
        lineHeight: $t
      },
      [`${Gt}-content`]: {
        color: _t.colorText,
        fontSize: Bt,
        lineHeight: Vt
      },
      // ===================== Footer =====================
      [`${Gt}-btns`]: {
        textAlign: "end",
        marginTop: _t.confirmBtnsMarginTop,
        [`${_t.antCls}-btn + ${_t.antCls}-btn`]: {
          marginBottom: 0,
          marginInlineStart: _t.marginXS
        }
      }
    },
    [`${Gt}-error ${Gt}-body > ${_t.iconCls}`]: {
      color: _t.colorError
    },
    [`${Gt}-warning ${Gt}-body > ${_t.iconCls},
        ${Gt}-confirm ${Gt}-body > ${_t.iconCls}`]: {
      color: _t.colorWarning
    },
    [`${Gt}-info ${Gt}-body > ${_t.iconCls}`]: {
      color: _t.colorInfo
    },
    [`${Gt}-success ${Gt}-body > ${_t.iconCls}`]: {
      color: _t.colorSuccess
    }
  };
}, Confirm = genSubStyleComponent(["Modal", "confirm"], (_t) => {
  const Et = prepareToken$1(_t);
  return [genModalConfirmStyle(Et)];
}, prepareComponentToken$4, {
  // confirm is weak than modal since no conflict here
  order: -1e3
});
var __rest$9 = function(_t, Et) {
  var Pt = {};
  for (var $t in _t)
    Object.prototype.hasOwnProperty.call(_t, $t) && Et.indexOf($t) < 0 && (Pt[$t] = _t[$t]);
  if (_t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var Mt = 0, $t = Object.getOwnPropertySymbols(_t); Mt < $t.length; Mt++)
      Et.indexOf($t[Mt]) < 0 && Object.prototype.propertyIsEnumerable.call(_t, $t[Mt]) && (Pt[$t[Mt]] = _t[$t[Mt]]);
  return Pt;
};
function ConfirmContent(_t) {
  const {
    prefixCls: Et,
    icon: Pt,
    okText: $t,
    cancelText: Mt,
    confirmPrefixCls: Bt,
    type: Vt,
    okCancel: zt,
    footer: Ht,
    // Legacy for static function usage
    locale: Wt
  } = _t, Gt = __rest$9(_t, ["prefixCls", "icon", "okText", "cancelText", "confirmPrefixCls", "type", "okCancel", "footer", "locale"]);
  if (browser$1.env.NODE_ENV !== "production") {
    const ar = devUseWarning("Modal");
    browser$1.env.NODE_ENV !== "production" && ar(!(typeof Pt == "string" && Pt.length > 2), "breaking", `\`icon\` is using ReactNode instead of string naming in v4. Please check \`${Pt}\` at https://ant.design/components/icon`);
  }
  let qt = Pt;
  if (!Pt && Pt !== null)
    switch (Vt) {
      case "info":
        qt = /* @__PURE__ */ React.createElement(RefIcon$3, null);
        break;
      case "success":
        qt = /* @__PURE__ */ React.createElement(RefIcon$9, null);
        break;
      case "error":
        qt = /* @__PURE__ */ React.createElement(RefIcon$7, null);
        break;
      default:
        qt = /* @__PURE__ */ React.createElement(RefIcon$4, null);
    }
  const Kt = zt ?? Vt === "confirm", Qt = _t.autoFocusButton === null ? !1 : _t.autoFocusButton || "ok", [Xt] = useLocale("Modal"), Zt = Wt || Xt, Yt = $t || (Kt ? Zt == null ? void 0 : Zt.okText : Zt == null ? void 0 : Zt.justOkText), Jt = Mt || (Zt == null ? void 0 : Zt.cancelText), er = Object.assign({
    autoFocusButton: Qt,
    cancelTextLocale: Jt,
    okTextLocale: Yt,
    mergedOkCancel: Kt
  }, Gt), tr = React.useMemo(() => er, _toConsumableArray(Object.values(er))), nr = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ConfirmCancelBtn, null), /* @__PURE__ */ React.createElement(ConfirmOkBtn, null)), rr = _t.title !== void 0 && _t.title !== null, ir = `${Bt}-body`;
  return /* @__PURE__ */ React.createElement("div", {
    className: `${Bt}-body-wrapper`
  }, /* @__PURE__ */ React.createElement("div", {
    className: classNames(ir, {
      [`${ir}-has-title`]: rr
    })
  }, qt, /* @__PURE__ */ React.createElement("div", {
    className: `${Bt}-paragraph`
  }, rr && /* @__PURE__ */ React.createElement("span", {
    className: `${Bt}-title`
  }, _t.title), /* @__PURE__ */ React.createElement("div", {
    className: `${Bt}-content`
  }, _t.content))), Ht === void 0 || typeof Ht == "function" ? /* @__PURE__ */ React.createElement(ModalContextProvider, {
    value: tr
  }, /* @__PURE__ */ React.createElement("div", {
    className: `${Bt}-btns`
  }, typeof Ht == "function" ? Ht(nr, {
    OkBtn: ConfirmOkBtn,
    CancelBtn: ConfirmCancelBtn
  }) : nr)) : Ht, /* @__PURE__ */ React.createElement(Confirm, {
    prefixCls: Et
  }));
}
const ConfirmDialog = (_t) => {
  const {
    close: Et,
    zIndex: Pt,
    maskStyle: $t,
    direction: Mt,
    prefixCls: Bt,
    wrapClassName: Vt,
    rootPrefixCls: zt,
    bodyStyle: Ht,
    closable: Wt = !1,
    onConfirm: Gt,
    styles: qt
  } = _t;
  if (browser$1.env.NODE_ENV !== "production") {
    const nr = devUseWarning("Modal");
    [["visible", "open"], ["bodyStyle", "styles.body"], ["maskStyle", "styles.mask"]].forEach((rr) => {
      let [ir, ar] = rr;
      nr.deprecated(!(ir in _t), ir, ar);
    });
  }
  const Kt = `${Bt}-confirm`, Qt = _t.width || 416, Xt = _t.style || {}, Zt = _t.mask === void 0 ? !0 : _t.mask, Yt = _t.maskClosable === void 0 ? !1 : _t.maskClosable, Jt = classNames(Kt, `${Kt}-${_t.type}`, {
    [`${Kt}-rtl`]: Mt === "rtl"
  }, _t.className), [, er] = useToken(), tr = React.useMemo(() => Pt !== void 0 ? Pt : er.zIndexPopupBase + CONTAINER_MAX_OFFSET, [Pt, er]);
  return /* @__PURE__ */ React.createElement(Modal$1, Object.assign({}, _t, {
    className: Jt,
    wrapClassName: classNames({
      [`${Kt}-centered`]: !!_t.centered
    }, Vt),
    onCancel: () => {
      Et == null || Et({
        triggerCancel: !0
      }), Gt == null || Gt(!1);
    },
    title: "",
    footer: null,
    transitionName: getTransitionName(zt || "", "zoom", _t.transitionName),
    maskTransitionName: getTransitionName(zt || "", "fade", _t.maskTransitionName),
    mask: Zt,
    maskClosable: Yt,
    style: Xt,
    styles: Object.assign({
      body: Ht,
      mask: $t
    }, qt),
    width: Qt,
    zIndex: tr,
    closable: Wt
  }), /* @__PURE__ */ React.createElement(ConfirmContent, Object.assign({}, _t, {
    confirmPrefixCls: Kt
  })));
}, ConfirmDialogWrapper$1 = (_t) => {
  const {
    rootPrefixCls: Et,
    iconPrefixCls: Pt,
    direction: $t,
    theme: Mt
  } = _t;
  return /* @__PURE__ */ React.createElement(ConfigProvider, {
    prefixCls: Et,
    iconPrefixCls: Pt,
    direction: $t,
    theme: Mt
  }, /* @__PURE__ */ React.createElement(ConfirmDialog, Object.assign({}, _t)));
};
browser$1.env.NODE_ENV !== "production" && (ConfirmDialog.displayName = "ConfirmDialog", ConfirmDialogWrapper$1.displayName = "ConfirmDialogWrapper");
const destroyFns = [];
let defaultRootPrefixCls = "";
function getRootPrefixCls() {
  return defaultRootPrefixCls;
}
const ConfirmDialogWrapper = (_t) => {
  var Et, Pt;
  const {
    prefixCls: $t,
    getContainer: Mt,
    direction: Bt
  } = _t, Vt = getConfirmLocale(), zt = useContext(ConfigContext), Ht = getRootPrefixCls() || zt.getPrefixCls(), Wt = $t || `${Ht}-modal`;
  let Gt = Mt;
  return Gt === !1 && (Gt = void 0, browser$1.env.NODE_ENV !== "production" && browser$1.env.NODE_ENV !== "production" && warning$1(!1, "Modal", "Static method not support `getContainer` to be `false` since it do not have context env.")), /* @__PURE__ */ React__default.createElement(ConfirmDialogWrapper$1, Object.assign({}, _t, {
    rootPrefixCls: Ht,
    prefixCls: Wt,
    iconPrefixCls: zt.iconPrefixCls,
    theme: zt.theme,
    direction: Bt ?? zt.direction,
    locale: (Pt = (Et = zt.locale) === null || Et === void 0 ? void 0 : Et.Modal) !== null && Pt !== void 0 ? Pt : Vt,
    getContainer: Gt
  }));
};
function confirm(_t) {
  const Et = globalConfig();
  browser$1.env.NODE_ENV !== "production" && !Et.holderRender && warnContext("Modal");
  const Pt = document.createDocumentFragment();
  let $t = Object.assign(Object.assign({}, _t), {
    close: Ht,
    open: !0
  }), Mt, Bt;
  function Vt() {
    for (var Gt, qt = arguments.length, Kt = new Array(qt), Qt = 0; Qt < qt; Qt++)
      Kt[Qt] = arguments[Qt];
    if (Kt.some((Yt) => Yt == null ? void 0 : Yt.triggerCancel)) {
      var Zt;
      (Gt = _t.onCancel) === null || Gt === void 0 || (Zt = Gt).call.apply(Zt, [_t, () => {
      }].concat(_toConsumableArray(Kt.slice(1))));
    }
    for (let Yt = 0; Yt < destroyFns.length; Yt++)
      if (destroyFns[Yt] === Ht) {
        destroyFns.splice(Yt, 1);
        break;
      }
    Bt();
  }
  function zt(Gt) {
    clearTimeout(Mt), Mt = setTimeout(() => {
      const qt = Et.getPrefixCls(void 0, getRootPrefixCls()), Kt = Et.getIconPrefixCls(), Qt = Et.getTheme(), Xt = /* @__PURE__ */ React__default.createElement(ConfirmDialogWrapper, Object.assign({}, Gt));
      Bt = getReactRender()(/* @__PURE__ */ React__default.createElement(ConfigProvider, {
        prefixCls: qt,
        iconPrefixCls: Kt,
        theme: Qt
      }, Et.holderRender ? Et.holderRender(Xt) : Xt), Pt);
    });
  }
  function Ht() {
    for (var Gt = arguments.length, qt = new Array(Gt), Kt = 0; Kt < Gt; Kt++)
      qt[Kt] = arguments[Kt];
    $t = Object.assign(Object.assign({}, $t), {
      open: !1,
      afterClose: () => {
        typeof _t.afterClose == "function" && _t.afterClose(), Vt.apply(this, qt);
      }
    }), $t.visible && delete $t.visible, zt($t);
  }
  function Wt(Gt) {
    typeof Gt == "function" ? $t = Gt($t) : $t = Object.assign(Object.assign({}, $t), Gt), zt($t);
  }
  return zt($t), destroyFns.push(Ht), {
    destroy: Ht,
    update: Wt
  };
}
function withWarn(_t) {
  return Object.assign(Object.assign({}, _t), {
    type: "warning"
  });
}
function withInfo(_t) {
  return Object.assign(Object.assign({}, _t), {
    type: "info"
  });
}
function withSuccess(_t) {
  return Object.assign(Object.assign({}, _t), {
    type: "success"
  });
}
function withError(_t) {
  return Object.assign(Object.assign({}, _t), {
    type: "error"
  });
}
function withConfirm(_t) {
  return Object.assign(Object.assign({}, _t), {
    type: "confirm"
  });
}
function modalGlobalConfig(_t) {
  let {
    rootPrefixCls: Et
  } = _t;
  browser$1.env.NODE_ENV !== "production" && warning$1(!1, "Modal", "Modal.config is deprecated. Please use ConfigProvider.config instead."), defaultRootPrefixCls = Et;
}
var __rest$8 = function(_t, Et) {
  var Pt = {};
  for (var $t in _t)
    Object.prototype.hasOwnProperty.call(_t, $t) && Et.indexOf($t) < 0 && (Pt[$t] = _t[$t]);
  if (_t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var Mt = 0, $t = Object.getOwnPropertySymbols(_t); Mt < $t.length; Mt++)
      Et.indexOf($t[Mt]) < 0 && Object.prototype.propertyIsEnumerable.call(_t, $t[Mt]) && (Pt[$t[Mt]] = _t[$t[Mt]]);
  return Pt;
};
const HookModal = (_t, Et) => {
  var Pt, {
    afterClose: $t,
    config: Mt
  } = _t, Bt = __rest$8(_t, ["afterClose", "config"]);
  const [Vt, zt] = React.useState(!0), [Ht, Wt] = React.useState(Mt), {
    direction: Gt,
    getPrefixCls: qt
  } = React.useContext(ConfigContext), Kt = qt("modal"), Qt = qt(), Xt = () => {
    var er;
    $t(), (er = Ht.afterClose) === null || er === void 0 || er.call(Ht);
  }, Zt = function() {
    var er;
    zt(!1);
    for (var tr = arguments.length, nr = new Array(tr), rr = 0; rr < tr; rr++)
      nr[rr] = arguments[rr];
    if (nr.some((or) => or == null ? void 0 : or.triggerCancel)) {
      var ar;
      (er = Ht.onCancel) === null || er === void 0 || (ar = er).call.apply(ar, [Ht, () => {
      }].concat(_toConsumableArray(nr.slice(1))));
    }
  };
  React.useImperativeHandle(Et, () => ({
    destroy: Zt,
    update: (er) => {
      Wt((tr) => Object.assign(Object.assign({}, tr), er));
    }
  }));
  const Yt = (Pt = Ht.okCancel) !== null && Pt !== void 0 ? Pt : Ht.type === "confirm", [Jt] = useLocale("Modal", localeValues.Modal);
  return /* @__PURE__ */ React.createElement(ConfirmDialogWrapper$1, Object.assign({
    prefixCls: Kt,
    rootPrefixCls: Qt
  }, Ht, {
    close: Zt,
    open: Vt,
    afterClose: Xt,
    okText: Ht.okText || (Yt ? Jt == null ? void 0 : Jt.okText : Jt == null ? void 0 : Jt.justOkText),
    direction: Ht.direction || Gt,
    cancelText: Ht.cancelText || (Jt == null ? void 0 : Jt.cancelText)
  }, Bt));
}, HookModal$1 = /* @__PURE__ */ React.forwardRef(HookModal);
let uuid$1 = 0;
const ElementsHolder = /* @__PURE__ */ React.memo(/* @__PURE__ */ React.forwardRef((_t, Et) => {
  const [Pt, $t] = usePatchElement();
  return React.useImperativeHandle(Et, () => ({
    patchElement: $t
  }), []), /* @__PURE__ */ React.createElement(React.Fragment, null, Pt);
}));
function useModal() {
  const _t = React.useRef(null), [Et, Pt] = React.useState([]);
  React.useEffect(() => {
    Et.length && (_toConsumableArray(Et).forEach((Vt) => {
      Vt();
    }), Pt([]));
  }, [Et]);
  const $t = React.useCallback((Bt) => function(zt) {
    var Ht;
    uuid$1 += 1;
    const Wt = /* @__PURE__ */ React.createRef();
    let Gt;
    const qt = new Promise((Yt) => {
      Gt = Yt;
    });
    let Kt = !1, Qt;
    const Xt = /* @__PURE__ */ React.createElement(HookModal$1, {
      key: `modal-${uuid$1}`,
      config: Bt(zt),
      ref: Wt,
      afterClose: () => {
        Qt == null || Qt();
      },
      isSilent: () => Kt,
      onConfirm: (Yt) => {
        Gt(Yt);
      }
    });
    return Qt = (Ht = _t.current) === null || Ht === void 0 ? void 0 : Ht.patchElement(Xt), Qt && destroyFns.push(Qt), {
      destroy: () => {
        function Yt() {
          var Jt;
          (Jt = Wt.current) === null || Jt === void 0 || Jt.destroy();
        }
        Wt.current ? Yt() : Pt((Jt) => [].concat(_toConsumableArray(Jt), [Yt]));
      },
      update: (Yt) => {
        function Jt() {
          var er;
          (er = Wt.current) === null || er === void 0 || er.update(Yt);
        }
        Wt.current ? Jt() : Pt((er) => [].concat(_toConsumableArray(er), [Jt]));
      },
      then: (Yt) => (Kt = !0, qt.then(Yt))
    };
  }, []);
  return [React.useMemo(() => ({
    info: $t(withInfo),
    success: $t(withSuccess),
    error: $t(withError),
    warning: $t(withWarn),
    confirm: $t(withConfirm)
  }), []), /* @__PURE__ */ React.createElement(ElementsHolder, {
    key: "modal-holder",
    ref: _t
  })];
}
const genNotificationPlacementStyle = (_t) => {
  const {
    componentCls: Et,
    notificationMarginEdge: Pt,
    animationMaxHeight: $t
  } = _t, Mt = `${Et}-notice`, Bt = new Keyframe("antNotificationFadeIn", {
    "0%": {
      transform: "translate3d(100%, 0, 0)",
      opacity: 0
    },
    "100%": {
      transform: "translate3d(0, 0, 0)",
      opacity: 1
    }
  }), Vt = new Keyframe("antNotificationTopFadeIn", {
    "0%": {
      top: -$t,
      opacity: 0
    },
    "100%": {
      top: 0,
      opacity: 1
    }
  }), zt = new Keyframe("antNotificationBottomFadeIn", {
    "0%": {
      bottom: _t.calc($t).mul(-1).equal(),
      opacity: 0
    },
    "100%": {
      bottom: 0,
      opacity: 1
    }
  }), Ht = new Keyframe("antNotificationLeftFadeIn", {
    "0%": {
      transform: "translate3d(-100%, 0, 0)",
      opacity: 0
    },
    "100%": {
      transform: "translate3d(0, 0, 0)",
      opacity: 1
    }
  });
  return {
    [Et]: {
      [`&${Et}-top, &${Et}-bottom`]: {
        marginInline: 0,
        [Mt]: {
          marginInline: "auto auto"
        }
      },
      [`&${Et}-top`]: {
        [`${Et}-fade-enter${Et}-fade-enter-active, ${Et}-fade-appear${Et}-fade-appear-active`]: {
          animationName: Vt
        }
      },
      [`&${Et}-bottom`]: {
        [`${Et}-fade-enter${Et}-fade-enter-active, ${Et}-fade-appear${Et}-fade-appear-active`]: {
          animationName: zt
        }
      },
      [`&${Et}-topRight, &${Et}-bottomRight`]: {
        [`${Et}-fade-enter${Et}-fade-enter-active, ${Et}-fade-appear${Et}-fade-appear-active`]: {
          animationName: Bt
        }
      },
      [`&${Et}-topLeft, &${Et}-bottomLeft`]: {
        marginRight: {
          value: 0,
          _skip_check_: !0
        },
        marginLeft: {
          value: Pt,
          _skip_check_: !0
        },
        [Mt]: {
          marginInlineEnd: "auto",
          marginInlineStart: 0
        },
        [`${Et}-fade-enter${Et}-fade-enter-active, ${Et}-fade-appear${Et}-fade-appear-active`]: {
          animationName: Ht
        }
      }
    }
  };
}, NotificationPlacements = ["top", "topLeft", "topRight", "bottom", "bottomLeft", "bottomRight"], placementAlignProperty = {
  topLeft: "left",
  topRight: "right",
  bottomLeft: "left",
  bottomRight: "right",
  top: "left",
  bottom: "left"
}, genPlacementStackStyle = (_t, Et) => {
  const {
    componentCls: Pt
  } = _t;
  return {
    [`${Pt}-${Et}`]: {
      [`&${Pt}-stack > ${Pt}-notice-wrapper`]: {
        [Et.startsWith("top") ? "top" : "bottom"]: 0,
        [placementAlignProperty[Et]]: {
          value: 0,
          _skip_check_: !0
        }
      }
    }
  };
}, genStackChildrenStyle = (_t) => {
  const Et = {};
  for (let Pt = 1; Pt < _t.notificationStackLayer; Pt++)
    Et[`&:nth-last-child(${Pt + 1})`] = {
      overflow: "hidden",
      [`& > ${_t.componentCls}-notice`]: {
        opacity: 0,
        transition: `opacity ${_t.motionDurationMid}`
      }
    };
  return Object.assign({
    [`&:not(:nth-last-child(-n+${_t.notificationStackLayer}))`]: {
      opacity: 0,
      overflow: "hidden",
      color: "transparent",
      pointerEvents: "none"
    }
  }, Et);
}, genStackedNoticeStyle = (_t) => {
  const Et = {};
  for (let Pt = 1; Pt < _t.notificationStackLayer; Pt++)
    Et[`&:nth-last-child(${Pt + 1})`] = {
      background: _t.colorBgBlur,
      backdropFilter: "blur(10px)",
      "-webkit-backdrop-filter": "blur(10px)"
    };
  return Object.assign({}, Et);
}, genStackStyle = (_t) => {
  const {
    componentCls: Et
  } = _t;
  return Object.assign({
    [`${Et}-stack`]: {
      [`& > ${Et}-notice-wrapper`]: Object.assign({
        transition: `all ${_t.motionDurationSlow}, backdrop-filter 0s`,
        position: "absolute"
      }, genStackChildrenStyle(_t))
    },
    [`${Et}-stack:not(${Et}-stack-expanded)`]: {
      [`& > ${Et}-notice-wrapper`]: Object.assign({}, genStackedNoticeStyle(_t))
    },
    [`${Et}-stack${Et}-stack-expanded`]: {
      [`& > ${Et}-notice-wrapper`]: {
        "&:not(:nth-last-child(-n + 1))": {
          opacity: 1,
          overflow: "unset",
          color: "inherit",
          pointerEvents: "auto",
          [`& > ${_t.componentCls}-notice`]: {
            opacity: 1
          }
        },
        "&:after": {
          content: '""',
          position: "absolute",
          height: _t.margin,
          width: "100%",
          insetInline: 0,
          bottom: _t.calc(_t.margin).mul(-1).equal(),
          background: "transparent",
          pointerEvents: "auto"
        }
      }
    }
  }, NotificationPlacements.map((Pt) => genPlacementStackStyle(_t, Pt)).reduce((Pt, $t) => Object.assign(Object.assign({}, Pt), $t), {}));
}, genNoticeStyle = (_t) => {
  const {
    iconCls: Et,
    componentCls: Pt,
    // .ant-notification
    boxShadow: $t,
    fontSizeLG: Mt,
    notificationMarginBottom: Bt,
    borderRadiusLG: Vt,
    colorSuccess: zt,
    colorInfo: Ht,
    colorWarning: Wt,
    colorError: Gt,
    colorTextHeading: qt,
    notificationBg: Kt,
    notificationPadding: Qt,
    notificationMarginEdge: Xt,
    notificationProgressBg: Zt,
    notificationProgressHeight: Yt,
    fontSize: Jt,
    lineHeight: er,
    width: tr,
    notificationIconSize: nr,
    colorText: rr
  } = _t, ir = `${Pt}-notice`;
  return {
    position: "relative",
    marginBottom: Bt,
    marginInlineStart: "auto",
    background: Kt,
    borderRadius: Vt,
    boxShadow: $t,
    [ir]: {
      padding: Qt,
      width: tr,
      maxWidth: `calc(100vw - ${unit$1(_t.calc(Xt).mul(2).equal())})`,
      overflow: "hidden",
      lineHeight: er,
      wordWrap: "break-word"
    },
    [`${ir}-message`]: {
      marginBottom: _t.marginXS,
      color: qt,
      fontSize: Mt,
      lineHeight: _t.lineHeightLG
    },
    [`${ir}-description`]: {
      fontSize: Jt,
      color: rr
    },
    [`${ir}-closable ${ir}-message`]: {
      paddingInlineEnd: _t.paddingLG
    },
    [`${ir}-with-icon ${ir}-message`]: {
      marginBottom: _t.marginXS,
      marginInlineStart: _t.calc(_t.marginSM).add(nr).equal(),
      fontSize: Mt
    },
    [`${ir}-with-icon ${ir}-description`]: {
      marginInlineStart: _t.calc(_t.marginSM).add(nr).equal(),
      fontSize: Jt
    },
    // Icon & color style in different selector level
    // https://github.com/ant-design/ant-design/issues/16503
    // https://github.com/ant-design/ant-design/issues/15512
    [`${ir}-icon`]: {
      position: "absolute",
      fontSize: nr,
      lineHeight: 1,
      // icon-font
      [`&-success${Et}`]: {
        color: zt
      },
      [`&-info${Et}`]: {
        color: Ht
      },
      [`&-warning${Et}`]: {
        color: Wt
      },
      [`&-error${Et}`]: {
        color: Gt
      }
    },
    [`${ir}-close`]: Object.assign({
      position: "absolute",
      top: _t.notificationPaddingVertical,
      insetInlineEnd: _t.notificationPaddingHorizontal,
      color: _t.colorIcon,
      outline: "none",
      width: _t.notificationCloseButtonSize,
      height: _t.notificationCloseButtonSize,
      borderRadius: _t.borderRadiusSM,
      transition: `background-color ${_t.motionDurationMid}, color ${_t.motionDurationMid}`,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "&:hover": {
        color: _t.colorIconHover,
        backgroundColor: _t.colorBgTextHover
      },
      "&:active": {
        backgroundColor: _t.colorBgTextActive
      }
    }, genFocusStyle(_t)),
    [`${ir}-progress`]: {
      position: "absolute",
      display: "block",
      appearance: "none",
      WebkitAppearance: "none",
      inlineSize: `calc(100% - ${unit$1(Vt)} * 2)`,
      left: {
        _skip_check_: !0,
        value: Vt
      },
      right: {
        _skip_check_: !0,
        value: Vt
      },
      bottom: 0,
      blockSize: Yt,
      border: 0,
      "&, &::-webkit-progress-bar": {
        borderRadius: Vt,
        backgroundColor: "rgba(0, 0, 0, 0.04)"
      },
      "&::-moz-progress-bar": {
        background: Zt
      },
      "&::-webkit-progress-value": {
        borderRadius: Vt,
        background: Zt
      }
    },
    [`${ir}-btn`]: {
      float: "right",
      marginTop: _t.marginSM
    }
  };
}, genNotificationStyle = (_t) => {
  const {
    componentCls: Et,
    // .ant-notification
    notificationMarginBottom: Pt,
    notificationMarginEdge: $t,
    motionDurationMid: Mt,
    motionEaseInOut: Bt
  } = _t, Vt = `${Et}-notice`, zt = new Keyframe("antNotificationFadeOut", {
    "0%": {
      maxHeight: _t.animationMaxHeight,
      marginBottom: Pt
    },
    "100%": {
      maxHeight: 0,
      marginBottom: 0,
      paddingTop: 0,
      paddingBottom: 0,
      opacity: 0
    }
  });
  return [
    // ============================ Holder ============================
    {
      [Et]: Object.assign(Object.assign({}, resetComponent(_t)), {
        position: "fixed",
        zIndex: _t.zIndexPopup,
        marginRight: {
          value: $t,
          _skip_check_: !0
        },
        [`${Et}-hook-holder`]: {
          position: "relative"
        },
        //  animation
        [`${Et}-fade-appear-prepare`]: {
          opacity: "0 !important"
        },
        [`${Et}-fade-enter, ${Et}-fade-appear`]: {
          animationDuration: _t.motionDurationMid,
          animationTimingFunction: Bt,
          animationFillMode: "both",
          opacity: 0,
          animationPlayState: "paused"
        },
        [`${Et}-fade-leave`]: {
          animationTimingFunction: Bt,
          animationFillMode: "both",
          animationDuration: Mt,
          animationPlayState: "paused"
        },
        [`${Et}-fade-enter${Et}-fade-enter-active, ${Et}-fade-appear${Et}-fade-appear-active`]: {
          animationPlayState: "running"
        },
        [`${Et}-fade-leave${Et}-fade-leave-active`]: {
          animationName: zt,
          animationPlayState: "running"
        },
        // RTL
        "&-rtl": {
          direction: "rtl",
          [`${Vt}-btn`]: {
            float: "left"
          }
        }
      })
    },
    // ============================ Notice ============================
    {
      [Et]: {
        [`${Vt}-wrapper`]: Object.assign({}, genNoticeStyle(_t))
      }
    }
  ];
}, prepareComponentToken$3 = (_t) => ({
  zIndexPopup: _t.zIndexPopupBase + CONTAINER_MAX_OFFSET + 50,
  width: 384
}), prepareNotificationToken = (_t) => {
  const Et = _t.paddingMD, Pt = _t.paddingLG;
  return merge$1(_t, {
    notificationBg: _t.colorBgElevated,
    notificationPaddingVertical: Et,
    notificationPaddingHorizontal: Pt,
    notificationIconSize: _t.calc(_t.fontSizeLG).mul(_t.lineHeightLG).equal(),
    notificationCloseButtonSize: _t.calc(_t.controlHeightLG).mul(0.55).equal(),
    notificationMarginBottom: _t.margin,
    notificationPadding: `${unit$1(_t.paddingMD)} ${unit$1(_t.paddingContentHorizontalLG)}`,
    notificationMarginEdge: _t.marginLG,
    animationMaxHeight: 150,
    notificationStackLayer: 3,
    notificationProgressHeight: 2,
    notificationProgressBg: `linear-gradient(90deg, ${_t.colorPrimaryBorderHover}, ${_t.colorPrimary})`
  });
}, useStyle$3 = genStyleHooks("Notification", (_t) => {
  const Et = prepareNotificationToken(_t);
  return [genNotificationStyle(Et), genNotificationPlacementStyle(Et), genStackStyle(Et)];
}, prepareComponentToken$3), PurePanelStyle = genSubStyleComponent(["Notification", "PurePanel"], (_t) => {
  const Et = `${_t.componentCls}-notice`, Pt = prepareNotificationToken(_t);
  return {
    [`${Et}-pure-panel`]: Object.assign(Object.assign({}, genNoticeStyle(Pt)), {
      width: Pt.width,
      maxWidth: `calc(100vw - ${unit$1(_t.calc(Pt.notificationMarginEdge).mul(2).equal())})`,
      margin: 0
    })
  };
}, prepareComponentToken$3);
var __rest$7 = function(_t, Et) {
  var Pt = {};
  for (var $t in _t)
    Object.prototype.hasOwnProperty.call(_t, $t) && Et.indexOf($t) < 0 && (Pt[$t] = _t[$t]);
  if (_t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var Mt = 0, $t = Object.getOwnPropertySymbols(_t); Mt < $t.length; Mt++)
      Et.indexOf($t[Mt]) < 0 && Object.prototype.propertyIsEnumerable.call(_t, $t[Mt]) && (Pt[$t[Mt]] = _t[$t[Mt]]);
  return Pt;
};
function getCloseIcon(_t, Et) {
  return Et === null || Et === !1 ? null : Et || /* @__PURE__ */ React.createElement(RefIcon$6, {
    className: `${_t}-close-icon`
  });
}
const typeToIcon = {
  success: RefIcon$9,
  info: RefIcon$3,
  error: RefIcon$7,
  warning: RefIcon$4
}, PureContent = (_t) => {
  const {
    prefixCls: Et,
    icon: Pt,
    type: $t,
    message: Mt,
    description: Bt,
    btn: Vt,
    role: zt = "alert"
  } = _t;
  let Ht = null;
  return Pt ? Ht = /* @__PURE__ */ React.createElement("span", {
    className: `${Et}-icon`
  }, Pt) : $t && (Ht = /* @__PURE__ */ React.createElement(typeToIcon[$t] || null, {
    className: classNames(`${Et}-icon`, `${Et}-icon-${$t}`)
  })), /* @__PURE__ */ React.createElement("div", {
    className: classNames({
      [`${Et}-with-icon`]: Ht
    }),
    role: zt
  }, Ht, /* @__PURE__ */ React.createElement("div", {
    className: `${Et}-message`
  }, Mt), /* @__PURE__ */ React.createElement("div", {
    className: `${Et}-description`
  }, Bt), Vt && /* @__PURE__ */ React.createElement("div", {
    className: `${Et}-btn`
  }, Vt));
}, PurePanel$3 = (_t) => {
  const {
    prefixCls: Et,
    className: Pt,
    icon: $t,
    type: Mt,
    message: Bt,
    description: Vt,
    btn: zt,
    closable: Ht = !0,
    closeIcon: Wt,
    className: Gt
  } = _t, qt = __rest$7(_t, ["prefixCls", "className", "icon", "type", "message", "description", "btn", "closable", "closeIcon", "className"]), {
    getPrefixCls: Kt
  } = React.useContext(ConfigContext), Qt = Et || Kt("notification"), Xt = `${Qt}-notice`, Zt = useCSSVarCls(Qt), [Yt, Jt, er] = useStyle$3(Qt, Zt);
  return Yt(/* @__PURE__ */ React.createElement("div", {
    className: classNames(`${Xt}-pure-panel`, Jt, Pt, er, Zt)
  }, /* @__PURE__ */ React.createElement(PurePanelStyle, {
    prefixCls: Qt
  }), /* @__PURE__ */ React.createElement(Notify, Object.assign({}, qt, {
    prefixCls: Qt,
    eventKey: "pure",
    duration: null,
    closable: Ht,
    className: classNames({
      notificationClassName: Gt
    }),
    closeIcon: getCloseIcon(Qt, Wt),
    content: /* @__PURE__ */ React.createElement(PureContent, {
      prefixCls: Xt,
      icon: $t,
      type: Mt,
      message: Bt,
      description: Vt,
      btn: zt
    })
  }))));
};
function getPlacementStyle(_t, Et, Pt) {
  let $t;
  switch (_t) {
    case "top":
      $t = {
        left: "50%",
        transform: "translateX(-50%)",
        right: "auto",
        top: Et,
        bottom: "auto"
      };
      break;
    case "topLeft":
      $t = {
        left: 0,
        top: Et,
        bottom: "auto"
      };
      break;
    case "topRight":
      $t = {
        right: 0,
        top: Et,
        bottom: "auto"
      };
      break;
    case "bottom":
      $t = {
        left: "50%",
        transform: "translateX(-50%)",
        right: "auto",
        top: "auto",
        bottom: Pt
      };
      break;
    case "bottomLeft":
      $t = {
        left: 0,
        top: "auto",
        bottom: Pt
      };
      break;
    default:
      $t = {
        right: 0,
        top: "auto",
        bottom: Pt
      };
      break;
  }
  return $t;
}
function getMotion$2(_t) {
  return {
    motionName: `${_t}-fade`
  };
}
var __rest$6 = function(_t, Et) {
  var Pt = {};
  for (var $t in _t)
    Object.prototype.hasOwnProperty.call(_t, $t) && Et.indexOf($t) < 0 && (Pt[$t] = _t[$t]);
  if (_t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var Mt = 0, $t = Object.getOwnPropertySymbols(_t); Mt < $t.length; Mt++)
      Et.indexOf($t[Mt]) < 0 && Object.prototype.propertyIsEnumerable.call(_t, $t[Mt]) && (Pt[$t[Mt]] = _t[$t[Mt]]);
  return Pt;
};
const DEFAULT_OFFSET = 24, DEFAULT_DURATION = 4.5, DEFAULT_PLACEMENT = "topRight", Wrapper = (_t) => {
  let {
    children: Et,
    prefixCls: Pt
  } = _t;
  const $t = useCSSVarCls(Pt), [Mt, Bt, Vt] = useStyle$3(Pt, $t);
  return Mt(/* @__PURE__ */ React__default.createElement(NotificationProvider, {
    classNames: {
      list: classNames(Bt, Vt, $t)
    }
  }, Et));
}, renderNotifications = (_t, Et) => {
  let {
    prefixCls: Pt,
    key: $t
  } = Et;
  return /* @__PURE__ */ React__default.createElement(Wrapper, {
    prefixCls: Pt,
    key: $t
  }, _t);
}, Holder = /* @__PURE__ */ React__default.forwardRef((_t, Et) => {
  const {
    top: Pt,
    bottom: $t,
    prefixCls: Mt,
    getContainer: Bt,
    maxCount: Vt,
    rtl: zt,
    onAllRemoved: Ht,
    stack: Wt,
    duration: Gt,
    pauseOnHover: qt = !0,
    showProgress: Kt
  } = _t, {
    getPrefixCls: Qt,
    getPopupContainer: Xt,
    notification: Zt,
    direction: Yt
  } = useContext(ConfigContext), [, Jt] = useToken(), er = Mt || Qt("notification"), tr = (or) => getPlacementStyle(or, Pt ?? DEFAULT_OFFSET, $t ?? DEFAULT_OFFSET), nr = () => classNames({
    [`${er}-rtl`]: zt ?? Yt === "rtl"
  }), rr = () => getMotion$2(er), [ir, ar] = useNotification$1({
    prefixCls: er,
    style: tr,
    className: nr,
    motion: rr,
    closable: !0,
    closeIcon: getCloseIcon(er),
    duration: Gt ?? DEFAULT_DURATION,
    getContainer: () => (Bt == null ? void 0 : Bt()) || (Xt == null ? void 0 : Xt()) || document.body,
    maxCount: Vt,
    pauseOnHover: qt,
    showProgress: Kt,
    onAllRemoved: Ht,
    renderNotifications,
    stack: Wt === !1 ? !1 : {
      threshold: typeof Wt == "object" ? Wt == null ? void 0 : Wt.threshold : void 0,
      offset: 8,
      gap: Jt.margin
    }
  });
  return React__default.useImperativeHandle(Et, () => Object.assign(Object.assign({}, ir), {
    prefixCls: er,
    notification: Zt
  })), ar;
});
function useInternalNotification(_t) {
  const Et = React__default.useRef(null), Pt = devUseWarning("Notification");
  return [React__default.useMemo(() => {
    const Mt = (Ht) => {
      var Wt;
      if (!Et.current) {
        browser$1.env.NODE_ENV !== "production" && Pt(!1, "usage", "You are calling notice in render which will break in React 18 concurrent mode. Please trigger in effect instead.");
        return;
      }
      const {
        open: Gt,
        prefixCls: qt,
        notification: Kt
      } = Et.current, Qt = `${qt}-notice`, {
        message: Xt,
        description: Zt,
        icon: Yt,
        type: Jt,
        btn: er,
        className: tr,
        style: nr,
        role: rr = "alert",
        closeIcon: ir,
        closable: ar
      } = Ht, or = __rest$6(Ht, ["message", "description", "icon", "type", "btn", "className", "style", "role", "closeIcon", "closable"]), sr = getCloseIcon(Qt, typeof ir < "u" ? ir : Kt == null ? void 0 : Kt.closeIcon);
      return Gt(Object.assign(Object.assign({
        // use placement from props instead of hard-coding "topRight"
        placement: (Wt = _t == null ? void 0 : _t.placement) !== null && Wt !== void 0 ? Wt : DEFAULT_PLACEMENT
      }, or), {
        content: /* @__PURE__ */ React__default.createElement(PureContent, {
          prefixCls: Qt,
          icon: Yt,
          type: Jt,
          message: Xt,
          description: Zt,
          btn: er,
          role: rr
        }),
        className: classNames(Jt && `${Qt}-${Jt}`, tr, Kt == null ? void 0 : Kt.className),
        style: Object.assign(Object.assign({}, Kt == null ? void 0 : Kt.style), nr),
        closeIcon: sr,
        closable: ar ?? !!sr
      }));
    }, Vt = {
      open: Mt,
      destroy: (Ht) => {
        var Wt, Gt;
        Ht !== void 0 ? (Wt = Et.current) === null || Wt === void 0 || Wt.close(Ht) : (Gt = Et.current) === null || Gt === void 0 || Gt.destroy();
      }
    };
    return ["success", "info", "warning", "error"].forEach((Ht) => {
      Vt[Ht] = (Wt) => Mt(Object.assign(Object.assign({}, Wt), {
        type: Ht
      }));
    }), Vt;
  }, []), /* @__PURE__ */ React__default.createElement(Holder, Object.assign({
    key: "notification-holder"
  }, _t, {
    ref: Et
  }))];
}
function useNotification(_t) {
  return useInternalNotification(_t);
}
const AppConfigContext = /* @__PURE__ */ React__default.createContext({});
function withPureRenderTheme(_t) {
  return (Et) => /* @__PURE__ */ React.createElement(ConfigProvider, {
    theme: {
      token: {
        motion: !1,
        zIndexPopupBase: 0
      }
    }
  }, /* @__PURE__ */ React.createElement(_t, Object.assign({}, Et)));
}
const isMobile = function() {
  if (typeof navigator > "u" || typeof window > "u")
    return !1;
  var _t = navigator.userAgent || navigator.vendor || window.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(_t) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(_t == null ? void 0 : _t.substr(0, 4));
};
var _excluded$g = ["prefixCls", "invalidate", "item", "renderItem", "responsive", "responsiveDisabled", "registerSize", "itemKey", "className", "style", "children", "display", "order", "component"], UNDEFINED = void 0;
function InternalItem(_t, Et) {
  var Pt = _t.prefixCls, $t = _t.invalidate, Mt = _t.item, Bt = _t.renderItem, Vt = _t.responsive, zt = _t.responsiveDisabled, Ht = _t.registerSize, Wt = _t.itemKey, Gt = _t.className, qt = _t.style, Kt = _t.children, Qt = _t.display, Xt = _t.order, Zt = _t.component, Yt = Zt === void 0 ? "div" : Zt, Jt = _objectWithoutProperties$2(_t, _excluded$g), er = Vt && !Qt;
  function tr(or) {
    Ht(Wt, or);
  }
  React.useEffect(function() {
    return function() {
      tr(null);
    };
  }, []);
  var nr = Bt && Mt !== UNDEFINED ? Bt(Mt, {
    index: Xt
  }) : Kt, rr;
  $t || (rr = {
    opacity: er ? 0 : 1,
    height: er ? 0 : UNDEFINED,
    overflowY: er ? "hidden" : UNDEFINED,
    order: Vt ? Xt : UNDEFINED,
    pointerEvents: er ? "none" : UNDEFINED,
    position: er ? "absolute" : UNDEFINED
  });
  var ir = {};
  er && (ir["aria-hidden"] = !0);
  var ar = /* @__PURE__ */ React.createElement(Yt, _extends$2({
    className: classNames(!$t && Pt, Gt),
    style: _objectSpread2(_objectSpread2({}, rr), qt)
  }, ir, Jt, {
    ref: Et
  }), nr);
  return Vt && (ar = /* @__PURE__ */ React.createElement(RefResizeObserver, {
    onResize: function(sr) {
      var lr = sr.offsetWidth;
      tr(lr);
    },
    disabled: zt
  }, ar)), ar;
}
var Item = /* @__PURE__ */ React.forwardRef(InternalItem);
Item.displayName = "Item";
function channelUpdate(_t) {
  if (typeof MessageChannel > "u")
    wrapperRaf(_t);
  else {
    var Et = new MessageChannel();
    Et.port1.onmessage = function() {
      return _t();
    }, Et.port2.postMessage(void 0);
  }
}
function useBatcher() {
  var _t = React.useRef(null), Et = function($t) {
    _t.current || (_t.current = [], channelUpdate(function() {
      unstable_batchedUpdates(function() {
        _t.current.forEach(function(Mt) {
          Mt();
        }), _t.current = null;
      });
    })), _t.current.push($t);
  };
  return Et;
}
function useEffectState(_t, Et) {
  var Pt = React.useState(Et), $t = _slicedToArray(Pt, 2), Mt = $t[0], Bt = $t[1], Vt = useEvent(function(zt) {
    _t(function() {
      Bt(zt);
    });
  });
  return [Mt, Vt];
}
var OverflowContext = /* @__PURE__ */ React__default.createContext(null), _excluded$f = ["component"], _excluded2$3 = ["className"], _excluded3$1 = ["className"], InternalRawItem = function(Et, Pt) {
  var $t = React.useContext(OverflowContext);
  if (!$t) {
    var Mt = Et.component, Bt = Mt === void 0 ? "div" : Mt, Vt = _objectWithoutProperties$2(Et, _excluded$f);
    return /* @__PURE__ */ React.createElement(Bt, _extends$2({}, Vt, {
      ref: Pt
    }));
  }
  var zt = $t.className, Ht = _objectWithoutProperties$2($t, _excluded2$3), Wt = Et.className, Gt = _objectWithoutProperties$2(Et, _excluded3$1);
  return /* @__PURE__ */ React.createElement(OverflowContext.Provider, {
    value: null
  }, /* @__PURE__ */ React.createElement(Item, _extends$2({
    ref: Pt,
    className: classNames(zt, Wt)
  }, Ht, Gt)));
}, RawItem = /* @__PURE__ */ React.forwardRef(InternalRawItem);
RawItem.displayName = "RawItem";
var _excluded$e = ["prefixCls", "data", "renderItem", "renderRawItem", "itemKey", "itemWidth", "ssr", "style", "className", "maxCount", "renderRest", "renderRawRest", "suffix", "component", "itemComponent", "onVisibleChange"], RESPONSIVE = "responsive", INVALIDATE = "invalidate";
function defaultRenderRest(_t) {
  return "+ ".concat(_t.length, " ...");
}
function Overflow(_t, Et) {
  var Pt = _t.prefixCls, $t = Pt === void 0 ? "rc-overflow" : Pt, Mt = _t.data, Bt = Mt === void 0 ? [] : Mt, Vt = _t.renderItem, zt = _t.renderRawItem, Ht = _t.itemKey, Wt = _t.itemWidth, Gt = Wt === void 0 ? 10 : Wt, qt = _t.ssr, Kt = _t.style, Qt = _t.className, Xt = _t.maxCount, Zt = _t.renderRest, Yt = _t.renderRawRest, Jt = _t.suffix, er = _t.component, tr = er === void 0 ? "div" : er, nr = _t.itemComponent, rr = _t.onVisibleChange, ir = _objectWithoutProperties$2(_t, _excluded$e), ar = qt === "full", or = useBatcher(), sr = useEffectState(or, null), lr = _slicedToArray(sr, 2), cr = lr[0], hr = lr[1], pr = cr || 0, mr = useEffectState(or, /* @__PURE__ */ new Map()), Er = _slicedToArray(mr, 2), _r = Er[0], yr = Er[1], ur = useEffectState(or, 0), vr = _slicedToArray(ur, 2), dr = vr[0], br = vr[1], Cr = useEffectState(or, 0), Pr = _slicedToArray(Cr, 2), xr = Pr[0], kr = Pr[1], Ir = useEffectState(or, 0), Ar = _slicedToArray(Ir, 2), Mr = Ar[0], Fr = Ar[1], Dr = useState(null), zr = _slicedToArray(Dr, 2), Tr = zr[0], Gr = zr[1], $r = useState(null), Rr = _slicedToArray($r, 2), Or = Rr[0], Lr = Rr[1], Hr = React.useMemo(function() {
    return Or === null && ar ? Number.MAX_SAFE_INTEGER : Or || 0;
  }, [Or, cr]), Wr = useState(!1), Kr = _slicedToArray(Wr, 2), Ur = Kr[0], Zr = Kr[1], Xr = "".concat($t, "-item"), mn = Math.max(dr, xr), an = Xt === RESPONSIVE, nn = Bt.length && an, $n = Xt === INVALIDATE, En = nn || typeof Xt == "number" && Bt.length > Xt, xn = useMemo$1(function() {
    var un = Bt;
    return nn ? cr === null && ar ? un = Bt : un = Bt.slice(0, Math.min(Bt.length, pr / Gt)) : typeof Xt == "number" && (un = Bt.slice(0, Xt)), un;
  }, [Bt, Gt, cr, Xt, nn]), qr = useMemo$1(function() {
    return nn ? Bt.slice(Hr + 1) : Bt.slice(xn.length);
  }, [Bt, xn, nn, Hr]), tn = useCallback(function(un, rn) {
    var dn;
    return typeof Ht == "function" ? Ht(un) : (dn = Ht && (un == null ? void 0 : un[Ht])) !== null && dn !== void 0 ? dn : rn;
  }, [Ht]), gr = useCallback(Vt || function(un) {
    return un;
  }, [Vt]);
  function Sr(un, rn, dn) {
    Or === un && (rn === void 0 || rn === Tr) || (Lr(un), dn || (Zr(un < Bt.length - 1), rr == null || rr(un)), rn !== void 0 && Gr(rn));
  }
  function Nr(un, rn) {
    hr(rn.clientWidth);
  }
  function jr(un, rn) {
    yr(function(dn) {
      var Mn = new Map(dn);
      return rn === null ? Mn.delete(un) : Mn.set(un, rn), Mn;
    });
  }
  function Br(un, rn) {
    kr(rn), br(xr);
  }
  function Qr(un, rn) {
    Fr(rn);
  }
  function Jr(un) {
    return _r.get(tn(xn[un], un));
  }
  useLayoutEffect(function() {
    if (pr && typeof mn == "number" && xn) {
      var un = Mr, rn = xn.length, dn = rn - 1;
      if (!rn) {
        Sr(0, null);
        return;
      }
      for (var Mn = 0; Mn < rn; Mn += 1) {
        var On = Jr(Mn);
        if (ar && (On = On || 0), On === void 0) {
          Sr(Mn - 1, void 0, !0);
          break;
        }
        if (un += On, // Only one means `totalWidth` is the final width
        dn === 0 && un <= pr || // Last two width will be the final width
        Mn === dn - 1 && un + Jr(dn) <= pr) {
          Sr(dn, null);
          break;
        } else if (un + mn > pr) {
          Sr(Mn - 1, un - On - Mr + xr);
          break;
        }
      }
      Jt && Jr(0) + Mr > pr && Gr(null);
    }
  }, [pr, _r, xr, Mr, tn, xn]);
  var gn = Ur && !!qr.length, yn = {};
  Tr !== null && nn && (yn = {
    position: "absolute",
    left: Tr,
    top: 0
  });
  var _n = {
    prefixCls: Xr,
    responsive: nn,
    component: nr,
    invalidate: $n
  }, In = zt ? function(un, rn) {
    var dn = tn(un, rn);
    return /* @__PURE__ */ React.createElement(OverflowContext.Provider, {
      key: dn,
      value: _objectSpread2(_objectSpread2({}, _n), {}, {
        order: rn,
        item: un,
        itemKey: dn,
        registerSize: jr,
        display: rn <= Hr
      })
    }, zt(un, rn));
  } : function(un, rn) {
    var dn = tn(un, rn);
    return /* @__PURE__ */ React.createElement(Item, _extends$2({}, _n, {
      order: rn,
      key: dn,
      item: un,
      renderItem: gr,
      itemKey: dn,
      registerSize: jr,
      display: rn <= Hr
    }));
  }, Tn = {
    order: gn ? Hr : Number.MAX_SAFE_INTEGER,
    className: "".concat(Xr, "-rest"),
    registerSize: Br,
    display: gn
  }, kn = Zt || defaultRenderRest, jn = Yt ? /* @__PURE__ */ React.createElement(OverflowContext.Provider, {
    value: _objectSpread2(_objectSpread2({}, _n), Tn)
  }, Yt(qr)) : /* @__PURE__ */ React.createElement(Item, _extends$2({}, _n, Tn), typeof kn == "function" ? kn(qr) : kn), An = /* @__PURE__ */ React.createElement(tr, _extends$2({
    className: classNames(!$n && $t, Qt),
    style: Kt,
    ref: Et
  }, ir), xn.map(In), En ? jn : null, Jt && /* @__PURE__ */ React.createElement(Item, _extends$2({}, _n, {
    responsive: an,
    responsiveDisabled: !nn,
    order: Hr,
    className: "".concat(Xr, "-suffix"),
    registerSize: Qr,
    display: !0,
    style: yn
  }), Jt));
  return an ? /* @__PURE__ */ React.createElement(RefResizeObserver, {
    onResize: Nr,
    disabled: !nn
  }, An) : An;
}
var ForwardOverflow = /* @__PURE__ */ React.forwardRef(Overflow);
ForwardOverflow.displayName = "Overflow";
ForwardOverflow.Item = RawItem;
ForwardOverflow.RESPONSIVE = RESPONSIVE;
ForwardOverflow.INVALIDATE = INVALIDATE;
function Arrow(_t) {
  var Et = _t.prefixCls, Pt = _t.align, $t = _t.arrow, Mt = _t.arrowPos, Bt = $t || {}, Vt = Bt.className, zt = Bt.content, Ht = Mt.x, Wt = Ht === void 0 ? 0 : Ht, Gt = Mt.y, qt = Gt === void 0 ? 0 : Gt, Kt = React.useRef();
  if (!Pt || !Pt.points)
    return null;
  var Qt = {
    position: "absolute"
  };
  if (Pt.autoArrow !== !1) {
    var Xt = Pt.points[0], Zt = Pt.points[1], Yt = Xt[0], Jt = Xt[1], er = Zt[0], tr = Zt[1];
    Yt === er || !["t", "b"].includes(Yt) ? Qt.top = qt : Yt === "t" ? Qt.top = 0 : Qt.bottom = 0, Jt === tr || !["l", "r"].includes(Jt) ? Qt.left = Wt : Jt === "l" ? Qt.left = 0 : Qt.right = 0;
  }
  return /* @__PURE__ */ React.createElement("div", {
    ref: Kt,
    className: classNames("".concat(Et, "-arrow"), Vt),
    style: Qt
  }, zt);
}
function Mask(_t) {
  var Et = _t.prefixCls, Pt = _t.open, $t = _t.zIndex, Mt = _t.mask, Bt = _t.motion;
  return Mt ? /* @__PURE__ */ React.createElement(CSSMotion, _extends$2({}, Bt, {
    motionAppear: !0,
    visible: Pt,
    removeOnLeave: !0
  }), function(Vt) {
    var zt = Vt.className;
    return /* @__PURE__ */ React.createElement("div", {
      style: {
        zIndex: $t
      },
      className: classNames("".concat(Et, "-mask"), zt)
    });
  }) : null;
}
var PopupContent = /* @__PURE__ */ React.memo(function(_t) {
  var Et = _t.children;
  return Et;
}, function(_t, Et) {
  return Et.cache;
});
browser$1.env.NODE_ENV !== "production" && (PopupContent.displayName = "PopupContent");
var Popup$1 = /* @__PURE__ */ React.forwardRef(function(_t, Et) {
  var Pt = _t.popup, $t = _t.className, Mt = _t.prefixCls, Bt = _t.style, Vt = _t.target, zt = _t.onVisibleChanged, Ht = _t.open, Wt = _t.keepDom, Gt = _t.fresh, qt = _t.onClick, Kt = _t.mask, Qt = _t.arrow, Xt = _t.arrowPos, Zt = _t.align, Yt = _t.motion, Jt = _t.maskMotion, er = _t.forceRender, tr = _t.getPopupContainer, nr = _t.autoDestroy, rr = _t.portal, ir = _t.zIndex, ar = _t.onMouseEnter, or = _t.onMouseLeave, sr = _t.onPointerEnter, lr = _t.onPointerDownCapture, cr = _t.ready, hr = _t.offsetX, pr = _t.offsetY, mr = _t.offsetR, Er = _t.offsetB, _r = _t.onAlign, yr = _t.onPrepare, ur = _t.stretch, vr = _t.targetWidth, dr = _t.targetHeight, br = typeof Pt == "function" ? Pt() : Pt, Cr = Ht || Wt, Pr = (tr == null ? void 0 : tr.length) > 0, xr = React.useState(!tr || !Pr), kr = _slicedToArray(xr, 2), Ir = kr[0], Ar = kr[1];
  if (useLayoutEffect(function() {
    !Ir && Pr && Vt && Ar(!0);
  }, [Ir, Pr, Vt]), !Ir)
    return null;
  var Mr = "auto", Fr = {
    left: "-1000vw",
    top: "-1000vh",
    right: Mr,
    bottom: Mr
  };
  if (cr || !Ht) {
    var Dr, zr = Zt.points, Tr = Zt.dynamicInset || ((Dr = Zt._experimental) === null || Dr === void 0 ? void 0 : Dr.dynamicInset), Gr = Tr && zr[0][1] === "r", $r = Tr && zr[0][0] === "b";
    Gr ? (Fr.right = mr, Fr.left = Mr) : (Fr.left = hr, Fr.right = Mr), $r ? (Fr.bottom = Er, Fr.top = Mr) : (Fr.top = pr, Fr.bottom = Mr);
  }
  var Rr = {};
  return ur && (ur.includes("height") && dr ? Rr.height = dr : ur.includes("minHeight") && dr && (Rr.minHeight = dr), ur.includes("width") && vr ? Rr.width = vr : ur.includes("minWidth") && vr && (Rr.minWidth = vr)), Ht || (Rr.pointerEvents = "none"), /* @__PURE__ */ React.createElement(rr, {
    open: er || Cr,
    getContainer: tr && function() {
      return tr(Vt);
    },
    autoDestroy: nr
  }, /* @__PURE__ */ React.createElement(Mask, {
    prefixCls: Mt,
    open: Ht,
    zIndex: ir,
    mask: Kt,
    motion: Jt
  }), /* @__PURE__ */ React.createElement(RefResizeObserver, {
    onResize: _r,
    disabled: !Ht
  }, function(Or) {
    return /* @__PURE__ */ React.createElement(CSSMotion, _extends$2({
      motionAppear: !0,
      motionEnter: !0,
      motionLeave: !0,
      removeOnLeave: !1,
      forceRender: er,
      leavedClassName: "".concat(Mt, "-hidden")
    }, Yt, {
      onAppearPrepare: yr,
      onEnterPrepare: yr,
      visible: Ht,
      onVisibleChanged: function(Hr) {
        var Wr;
        Yt == null || (Wr = Yt.onVisibleChanged) === null || Wr === void 0 || Wr.call(Yt, Hr), zt(Hr);
      }
    }), function(Lr, Hr) {
      var Wr = Lr.className, Kr = Lr.style, Ur = classNames(Mt, Wr, $t);
      return /* @__PURE__ */ React.createElement("div", {
        ref: composeRef(Or, Et, Hr),
        className: Ur,
        style: _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
          "--arrow-x": "".concat(Xt.x || 0, "px"),
          "--arrow-y": "".concat(Xt.y || 0, "px")
        }, Fr), Rr), Kr), {}, {
          boxSizing: "border-box",
          zIndex: ir
        }, Bt),
        onMouseEnter: ar,
        onMouseLeave: or,
        onPointerEnter: sr,
        onClick: qt,
        onPointerDownCapture: lr
      }, Qt && /* @__PURE__ */ React.createElement(Arrow, {
        prefixCls: Mt,
        arrow: Qt,
        arrowPos: Xt,
        align: Zt
      }), /* @__PURE__ */ React.createElement(PopupContent, {
        cache: !Ht && !Gt
      }, br));
    });
  }));
});
browser$1.env.NODE_ENV !== "production" && (Popup$1.displayName = "Popup");
var TriggerWrapper = /* @__PURE__ */ React.forwardRef(function(_t, Et) {
  var Pt = _t.children, $t = _t.getTriggerDOMNode, Mt = supportRef(Pt), Bt = React.useCallback(function(zt) {
    fillRef(Et, $t ? $t(zt) : zt);
  }, [$t]), Vt = useComposeRef(Bt, getNodeRef(Pt));
  return Mt ? /* @__PURE__ */ React.cloneElement(Pt, {
    ref: Vt
  }) : Pt;
});
browser$1.env.NODE_ENV !== "production" && (TriggerWrapper.displayName = "TriggerWrapper");
var TriggerContext = /* @__PURE__ */ React.createContext(null);
function toArray$2(_t) {
  return _t ? Array.isArray(_t) ? _t : [_t] : [];
}
function useAction(_t, Et, Pt, $t) {
  return React.useMemo(function() {
    var Mt = toArray$2(Pt ?? Et), Bt = toArray$2($t ?? Et), Vt = new Set(Mt), zt = new Set(Bt);
    return _t && (Vt.has("hover") && (Vt.delete("hover"), Vt.add("click")), zt.has("hover") && (zt.delete("hover"), zt.add("click"))), [Vt, zt];
  }, [_t, Et, Pt, $t]);
}
function isPointsEq() {
  var _t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], Et = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], Pt = arguments.length > 2 ? arguments[2] : void 0;
  return Pt ? _t[0] === Et[0] : _t[0] === Et[0] && _t[1] === Et[1];
}
function getAlignPopupClassName(_t, Et, Pt, $t) {
  for (var Mt = Pt.points, Bt = Object.keys(_t), Vt = 0; Vt < Bt.length; Vt += 1) {
    var zt, Ht = Bt[Vt];
    if (isPointsEq((zt = _t[Ht]) === null || zt === void 0 ? void 0 : zt.points, Mt, $t))
      return "".concat(Et, "-placement-").concat(Ht);
  }
  return "";
}
function getMotion$1(_t, Et, Pt, $t) {
  return Et || (Pt ? {
    motionName: "".concat(_t, "-").concat(Pt)
  } : $t ? {
    motionName: $t
  } : null);
}
function getWin(_t) {
  return _t.ownerDocument.defaultView;
}
function collectScroller(_t) {
  for (var Et = [], Pt = _t == null ? void 0 : _t.parentElement, $t = ["hidden", "scroll", "clip", "auto"]; Pt; ) {
    var Mt = getWin(Pt).getComputedStyle(Pt), Bt = Mt.overflowX, Vt = Mt.overflowY, zt = Mt.overflow;
    [Bt, Vt, zt].some(function(Ht) {
      return $t.includes(Ht);
    }) && Et.push(Pt), Pt = Pt.parentElement;
  }
  return Et;
}
function toNum(_t) {
  var Et = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  return Number.isNaN(_t) ? Et : _t;
}
function getPxValue(_t) {
  return toNum(parseFloat(_t), 0);
}
function getVisibleArea(_t, Et) {
  var Pt = _objectSpread2({}, _t);
  return (Et || []).forEach(function($t) {
    if (!($t instanceof HTMLBodyElement || $t instanceof HTMLHtmlElement)) {
      var Mt = getWin($t).getComputedStyle($t), Bt = Mt.overflow, Vt = Mt.overflowClipMargin, zt = Mt.borderTopWidth, Ht = Mt.borderBottomWidth, Wt = Mt.borderLeftWidth, Gt = Mt.borderRightWidth, qt = $t.getBoundingClientRect(), Kt = $t.offsetHeight, Qt = $t.clientHeight, Xt = $t.offsetWidth, Zt = $t.clientWidth, Yt = getPxValue(zt), Jt = getPxValue(Ht), er = getPxValue(Wt), tr = getPxValue(Gt), nr = toNum(Math.round(qt.width / Xt * 1e3) / 1e3), rr = toNum(Math.round(qt.height / Kt * 1e3) / 1e3), ir = (Xt - Zt - er - tr) * nr, ar = (Kt - Qt - Yt - Jt) * rr, or = Yt * rr, sr = Jt * rr, lr = er * nr, cr = tr * nr, hr = 0, pr = 0;
      if (Bt === "clip") {
        var mr = getPxValue(Vt);
        hr = mr * nr, pr = mr * rr;
      }
      var Er = qt.x + lr - hr, _r = qt.y + or - pr, yr = Er + qt.width + 2 * hr - lr - cr - ir, ur = _r + qt.height + 2 * pr - or - sr - ar;
      Pt.left = Math.max(Pt.left, Er), Pt.top = Math.max(Pt.top, _r), Pt.right = Math.min(Pt.right, yr), Pt.bottom = Math.min(Pt.bottom, ur);
    }
  }), Pt;
}
function getUnitOffset(_t) {
  var Et = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, Pt = "".concat(Et), $t = Pt.match(/^(.*)\%$/);
  return $t ? _t * (parseFloat($t[1]) / 100) : parseFloat(Pt);
}
function getNumberOffset(_t, Et) {
  var Pt = Et || [], $t = _slicedToArray(Pt, 2), Mt = $t[0], Bt = $t[1];
  return [getUnitOffset(_t.width, Mt), getUnitOffset(_t.height, Bt)];
}
function splitPoints() {
  var _t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  return [_t[0], _t[1]];
}
function getAlignPoint(_t, Et) {
  var Pt = Et[0], $t = Et[1], Mt, Bt;
  return Pt === "t" ? Bt = _t.y : Pt === "b" ? Bt = _t.y + _t.height : Bt = _t.y + _t.height / 2, $t === "l" ? Mt = _t.x : $t === "r" ? Mt = _t.x + _t.width : Mt = _t.x + _t.width / 2, {
    x: Mt,
    y: Bt
  };
}
function reversePoints(_t, Et) {
  var Pt = {
    t: "b",
    b: "t",
    l: "r",
    r: "l"
  };
  return _t.map(function($t, Mt) {
    return Mt === Et ? Pt[$t] || "c" : $t;
  }).join("");
}
function useAlign(_t, Et, Pt, $t, Mt, Bt, Vt) {
  var zt = React.useState({
    ready: !1,
    offsetX: 0,
    offsetY: 0,
    offsetR: 0,
    offsetB: 0,
    arrowX: 0,
    arrowY: 0,
    scaleX: 1,
    scaleY: 1,
    align: Mt[$t] || {}
  }), Ht = _slicedToArray(zt, 2), Wt = Ht[0], Gt = Ht[1], qt = React.useRef(0), Kt = React.useMemo(function() {
    return Et ? collectScroller(Et) : [];
  }, [Et]), Qt = React.useRef({}), Xt = function() {
    Qt.current = {};
  };
  _t || Xt();
  var Zt = useEvent(function() {
    if (Et && Pt && _t) {
      let ca = function(Ca, va) {
        var ya = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : mn, Pa = xr.x + Ca, ka = xr.y + va, Ma = Pa + Gr, Oa = ka + Tr, Da = Math.max(Pa, ya.left), ln = Math.max(ka, ya.top), vn = Math.min(Ma, ya.right), Gn = Math.min(Oa, ya.bottom);
        return Math.max(0, (vn - Da) * (Gn - ln));
      }, $a = function() {
        hn = xr.y + dn, wn = hn + Tr, pn = xr.x + rn, fn = pn + Gr;
      };
      var er, tr, nr, rr, ir = Et, ar = ir.ownerDocument, or = getWin(ir), sr = or.getComputedStyle(ir), lr = sr.width, cr = sr.height, hr = sr.position, pr = ir.style.left, mr = ir.style.top, Er = ir.style.right, _r = ir.style.bottom, yr = ir.style.overflow, ur = _objectSpread2(_objectSpread2({}, Mt[$t]), Bt), vr = ar.createElement("div");
      (er = ir.parentElement) === null || er === void 0 || er.appendChild(vr), vr.style.left = "".concat(ir.offsetLeft, "px"), vr.style.top = "".concat(ir.offsetTop, "px"), vr.style.position = hr, vr.style.height = "".concat(ir.offsetHeight, "px"), vr.style.width = "".concat(ir.offsetWidth, "px"), ir.style.left = "0", ir.style.top = "0", ir.style.right = "auto", ir.style.bottom = "auto", ir.style.overflow = "hidden";
      var dr;
      if (Array.isArray(Pt))
        dr = {
          x: Pt[0],
          y: Pt[1],
          width: 0,
          height: 0
        };
      else {
        var br, Cr, Pr = Pt.getBoundingClientRect();
        Pr.x = (br = Pr.x) !== null && br !== void 0 ? br : Pr.left, Pr.y = (Cr = Pr.y) !== null && Cr !== void 0 ? Cr : Pr.top, dr = {
          x: Pr.x,
          y: Pr.y,
          width: Pr.width,
          height: Pr.height
        };
      }
      var xr = ir.getBoundingClientRect();
      xr.x = (tr = xr.x) !== null && tr !== void 0 ? tr : xr.left, xr.y = (nr = xr.y) !== null && nr !== void 0 ? nr : xr.top;
      var kr = ar.documentElement, Ir = kr.clientWidth, Ar = kr.clientHeight, Mr = kr.scrollWidth, Fr = kr.scrollHeight, Dr = kr.scrollTop, zr = kr.scrollLeft, Tr = xr.height, Gr = xr.width, $r = dr.height, Rr = dr.width, Or = {
        left: 0,
        top: 0,
        right: Ir,
        bottom: Ar
      }, Lr = {
        left: -zr,
        top: -Dr,
        right: Mr - zr,
        bottom: Fr - Dr
      }, Hr = ur.htmlRegion, Wr = "visible", Kr = "visibleFirst";
      Hr !== "scroll" && Hr !== Kr && (Hr = Wr);
      var Ur = Hr === Kr, Zr = getVisibleArea(Lr, Kt), Xr = getVisibleArea(Or, Kt), mn = Hr === Wr ? Xr : Zr, an = Ur ? Xr : mn;
      ir.style.left = "auto", ir.style.top = "auto", ir.style.right = "0", ir.style.bottom = "0";
      var nn = ir.getBoundingClientRect();
      ir.style.left = pr, ir.style.top = mr, ir.style.right = Er, ir.style.bottom = _r, ir.style.overflow = yr, (rr = ir.parentElement) === null || rr === void 0 || rr.removeChild(vr);
      var $n = toNum(Math.round(Gr / parseFloat(lr) * 1e3) / 1e3), En = toNum(Math.round(Tr / parseFloat(cr) * 1e3) / 1e3);
      if ($n === 0 || En === 0 || isDOM(Pt) && !isVisible(Pt))
        return;
      var xn = ur.offset, qr = ur.targetOffset, tn = getNumberOffset(xr, xn), gr = _slicedToArray(tn, 2), Sr = gr[0], Nr = gr[1], jr = getNumberOffset(dr, qr), Br = _slicedToArray(jr, 2), Qr = Br[0], Jr = Br[1];
      dr.x -= Qr, dr.y -= Jr;
      var gn = ur.points || [], yn = _slicedToArray(gn, 2), _n = yn[0], In = yn[1], Tn = splitPoints(In), kn = splitPoints(_n), jn = getAlignPoint(dr, Tn), An = getAlignPoint(xr, kn), un = _objectSpread2({}, ur), rn = jn.x - An.x + Sr, dn = jn.y - An.y + Nr, Mn = ca(rn, dn), On = ca(rn, dn, Xr), Dn = getAlignPoint(dr, ["t", "l"]), Yn = getAlignPoint(xr, ["t", "l"]), ra = getAlignPoint(dr, ["b", "r"]), Fn = getAlignPoint(xr, ["b", "r"]), Nn = ur.overflow || {}, Hn = Nn.adjustX, wr = Nn.adjustY, Vr = Nn.shiftX, Yr = Nn.shiftY, cn = function(va) {
        return typeof va == "boolean" ? va : va >= 0;
      }, hn, wn, pn, fn;
      $a();
      var Bn = cn(wr), Rn = kn[0] === Tn[0];
      if (Bn && kn[0] === "t" && (wn > an.bottom || Qt.current.bt)) {
        var Sn = dn;
        Rn ? Sn -= Tr - $r : Sn = Dn.y - Fn.y - Nr;
        var Kn = ca(rn, Sn), Pn = ca(rn, Sn, Xr);
        // Of course use larger one
        Kn > Mn || Kn === Mn && (!Ur || // Choose recommend one
        Pn >= On) ? (Qt.current.bt = !0, dn = Sn, Nr = -Nr, un.points = [reversePoints(kn, 0), reversePoints(Tn, 0)]) : Qt.current.bt = !1;
      }
      if (Bn && kn[0] === "b" && (hn < an.top || Qt.current.tb)) {
        var sn = dn;
        Rn ? sn += Tr - $r : sn = ra.y - Yn.y - Nr;
        var bn = ca(rn, sn), Ln = ca(rn, sn, Xr);
        // Of course use larger one
        bn > Mn || bn === Mn && (!Ur || // Choose recommend one
        Ln >= On) ? (Qt.current.tb = !0, dn = sn, Nr = -Nr, un.points = [reversePoints(kn, 0), reversePoints(Tn, 0)]) : Qt.current.tb = !1;
      }
      var Wn = cn(Hn), qn = kn[1] === Tn[1];
      if (Wn && kn[1] === "l" && (fn > an.right || Qt.current.rl)) {
        var na = rn;
        qn ? na -= Gr - Rr : na = Dn.x - Fn.x - Sr;
        var Xn = ca(na, dn), sa = ca(na, dn, Xr);
        // Of course use larger one
        Xn > Mn || Xn === Mn && (!Ur || // Choose recommend one
        sa >= On) ? (Qt.current.rl = !0, rn = na, Sr = -Sr, un.points = [reversePoints(kn, 1), reversePoints(Tn, 1)]) : Qt.current.rl = !1;
      }
      if (Wn && kn[1] === "r" && (pn < an.left || Qt.current.lr)) {
        var Zn = rn;
        qn ? Zn += Gr - Rr : Zn = ra.x - Yn.x - Sr;
        var ua = ca(Zn, dn), pa = ca(Zn, dn, Xr);
        // Of course use larger one
        ua > Mn || ua === Mn && (!Ur || // Choose recommend one
        pa >= On) ? (Qt.current.lr = !0, rn = Zn, Sr = -Sr, un.points = [reversePoints(kn, 1), reversePoints(Tn, 1)]) : Qt.current.lr = !1;
      }
      $a();
      var ia = Vr === !0 ? 0 : Vr;
      typeof ia == "number" && (pn < Xr.left && (rn -= pn - Xr.left - Sr, dr.x + Rr < Xr.left + ia && (rn += dr.x - Xr.left + Rr - ia)), fn > Xr.right && (rn -= fn - Xr.right - Sr, dr.x > Xr.right - ia && (rn += dr.x - Xr.right + ia)));
      var aa = Yr === !0 ? 0 : Yr;
      typeof aa == "number" && (hn < Xr.top && (dn -= hn - Xr.top - Nr, dr.y + $r < Xr.top + aa && (dn += dr.y - Xr.top + $r - aa)), wn > Xr.bottom && (dn -= wn - Xr.bottom - Nr, dr.y > Xr.bottom - aa && (dn += dr.y - Xr.bottom + aa)));
      var ha = xr.x + rn, ma = ha + Gr, la = xr.y + dn, wa = la + Tr, _a = dr.x, Ra = _a + Rr, zn = dr.y, Vn = zn + $r, Un = Math.max(ha, _a), ta = Math.min(ma, Ra), ea = (Un + ta) / 2, ga = ea - ha, ba = Math.max(la, zn), Ea = Math.min(wa, Vn), xa = (ba + Ea) / 2, Sa = xa - la;
      Vt == null || Vt(Et, un);
      var fa = nn.right - xr.x - (rn + xr.width), oa = nn.bottom - xr.y - (dn + xr.height);
      $n === 1 && (rn = Math.round(rn), fa = Math.round(fa)), En === 1 && (dn = Math.round(dn), oa = Math.round(oa));
      var Ta = {
        ready: !0,
        offsetX: rn / $n,
        offsetY: dn / En,
        offsetR: fa / $n,
        offsetB: oa / En,
        arrowX: ga / $n,
        arrowY: Sa / En,
        scaleX: $n,
        scaleY: En,
        align: un
      };
      Gt(Ta);
    }
  }), Yt = function() {
    qt.current += 1;
    var tr = qt.current;
    Promise.resolve().then(function() {
      qt.current === tr && Zt();
    });
  }, Jt = function() {
    Gt(function(tr) {
      return _objectSpread2(_objectSpread2({}, tr), {}, {
        ready: !1
      });
    });
  };
  return useLayoutEffect(Jt, [$t]), useLayoutEffect(function() {
    _t || Jt();
  }, [_t]), [Wt.ready, Wt.offsetX, Wt.offsetY, Wt.offsetR, Wt.offsetB, Wt.arrowX, Wt.arrowY, Wt.scaleX, Wt.scaleY, Wt.align, Yt];
}
function useWatch(_t, Et, Pt, $t, Mt) {
  useLayoutEffect(function() {
    if (_t && Et && Pt) {
      let qt = function() {
        $t(), Mt();
      };
      var Bt = Et, Vt = Pt, zt = collectScroller(Bt), Ht = collectScroller(Vt), Wt = getWin(Vt), Gt = new Set([Wt].concat(_toConsumableArray(zt), _toConsumableArray(Ht)));
      return Gt.forEach(function(Kt) {
        Kt.addEventListener("scroll", qt, {
          passive: !0
        });
      }), Wt.addEventListener("resize", qt, {
        passive: !0
      }), $t(), function() {
        Gt.forEach(function(Kt) {
          Kt.removeEventListener("scroll", qt), Wt.removeEventListener("resize", qt);
        });
      };
    }
  }, [_t, Et, Pt]);
}
function useWinClick(_t, Et, Pt, $t, Mt, Bt, Vt, zt) {
  var Ht = React.useRef(_t);
  Ht.current = _t;
  var Wt = React.useRef(!1);
  React.useEffect(function() {
    if (Et && $t && (!Mt || Bt)) {
      var qt = function() {
        Wt.current = !1;
      }, Kt = function(nr) {
        var rr;
        Ht.current && !Vt(((rr = nr.composedPath) === null || rr === void 0 || (rr = rr.call(nr)) === null || rr === void 0 ? void 0 : rr[0]) || nr.target) && !Wt.current && zt(!1);
      }, Qt = getWin($t);
      Qt.addEventListener("pointerdown", qt, !0), Qt.addEventListener("mousedown", Kt, !0), Qt.addEventListener("contextmenu", Kt, !0);
      var Xt = getShadowRoot(Pt);
      if (Xt && (Xt.addEventListener("mousedown", Kt, !0), Xt.addEventListener("contextmenu", Kt, !0)), browser$1.env.NODE_ENV !== "production") {
        var Zt, Yt, Jt = Pt == null || (Zt = Pt.getRootNode) === null || Zt === void 0 ? void 0 : Zt.call(Pt), er = (Yt = $t.getRootNode) === null || Yt === void 0 ? void 0 : Yt.call($t);
        warning$3(Jt === er, "trigger element and popup element should in same shadow root.");
      }
      return function() {
        Qt.removeEventListener("pointerdown", qt, !0), Qt.removeEventListener("mousedown", Kt, !0), Qt.removeEventListener("contextmenu", Kt, !0), Xt && (Xt.removeEventListener("mousedown", Kt, !0), Xt.removeEventListener("contextmenu", Kt, !0));
      };
    }
  }, [Et, Pt, $t, Mt, Bt]);
  function Gt() {
    Wt.current = !0;
  }
  return Gt;
}
var _excluded$d = ["prefixCls", "children", "action", "showAction", "hideAction", "popupVisible", "defaultPopupVisible", "onPopupVisibleChange", "afterPopupVisibleChange", "mouseEnterDelay", "mouseLeaveDelay", "focusDelay", "blurDelay", "mask", "maskClosable", "getPopupContainer", "forceRender", "autoDestroy", "destroyPopupOnHide", "popup", "popupClassName", "popupStyle", "popupPlacement", "builtinPlacements", "popupAlign", "zIndex", "stretch", "getPopupClassNameFromAlign", "fresh", "alignPoint", "onPopupClick", "onPopupAlign", "arrow", "popupMotion", "maskMotion", "popupTransitionName", "popupAnimation", "maskTransitionName", "maskAnimation", "className", "getTriggerDOMNode"];
function generateTrigger() {
  var _t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Portal, Et = /* @__PURE__ */ React.forwardRef(function(Pt, $t) {
    var Mt = Pt.prefixCls, Bt = Mt === void 0 ? "rc-trigger-popup" : Mt, Vt = Pt.children, zt = Pt.action, Ht = zt === void 0 ? "hover" : zt, Wt = Pt.showAction, Gt = Pt.hideAction, qt = Pt.popupVisible, Kt = Pt.defaultPopupVisible, Qt = Pt.onPopupVisibleChange, Xt = Pt.afterPopupVisibleChange, Zt = Pt.mouseEnterDelay, Yt = Pt.mouseLeaveDelay, Jt = Yt === void 0 ? 0.1 : Yt, er = Pt.focusDelay, tr = Pt.blurDelay, nr = Pt.mask, rr = Pt.maskClosable, ir = rr === void 0 ? !0 : rr, ar = Pt.getPopupContainer, or = Pt.forceRender, sr = Pt.autoDestroy, lr = Pt.destroyPopupOnHide, cr = Pt.popup, hr = Pt.popupClassName, pr = Pt.popupStyle, mr = Pt.popupPlacement, Er = Pt.builtinPlacements, _r = Er === void 0 ? {} : Er, yr = Pt.popupAlign, ur = Pt.zIndex, vr = Pt.stretch, dr = Pt.getPopupClassNameFromAlign, br = Pt.fresh, Cr = Pt.alignPoint, Pr = Pt.onPopupClick, xr = Pt.onPopupAlign, kr = Pt.arrow, Ir = Pt.popupMotion, Ar = Pt.maskMotion, Mr = Pt.popupTransitionName, Fr = Pt.popupAnimation, Dr = Pt.maskTransitionName, zr = Pt.maskAnimation, Tr = Pt.className, Gr = Pt.getTriggerDOMNode, $r = _objectWithoutProperties$2(Pt, _excluded$d), Rr = sr || lr || !1, Or = React.useState(!1), Lr = _slicedToArray(Or, 2), Hr = Lr[0], Wr = Lr[1];
    useLayoutEffect(function() {
      Wr(isMobile());
    }, []);
    var Kr = React.useRef({}), Ur = React.useContext(TriggerContext), Zr = React.useMemo(function() {
      return {
        registerSubPopup: function(vn, Gn) {
          Kr.current[vn] = Gn, Ur == null || Ur.registerSubPopup(vn, Gn);
        }
      };
    }, [Ur]), Xr = useId(), mn = React.useState(null), an = _slicedToArray(mn, 2), nn = an[0], $n = an[1], En = React.useRef(null), xn = useEvent(function(ln) {
      En.current = ln, isDOM(ln) && nn !== ln && $n(ln), Ur == null || Ur.registerSubPopup(Xr, ln);
    }), qr = React.useState(null), tn = _slicedToArray(qr, 2), gr = tn[0], Sr = tn[1], Nr = React.useRef(null), jr = useEvent(function(ln) {
      isDOM(ln) && gr !== ln && (Sr(ln), Nr.current = ln);
    }), Br = React.Children.only(Vt), Qr = (Br == null ? void 0 : Br.props) || {}, Jr = {}, gn = useEvent(function(ln) {
      var vn, Gn, Jn = gr;
      return (Jn == null ? void 0 : Jn.contains(ln)) || ((vn = getShadowRoot(Jn)) === null || vn === void 0 ? void 0 : vn.host) === ln || ln === Jn || (nn == null ? void 0 : nn.contains(ln)) || ((Gn = getShadowRoot(nn)) === null || Gn === void 0 ? void 0 : Gn.host) === ln || ln === nn || Object.values(Kr.current).some(function(Qn) {
        return (Qn == null ? void 0 : Qn.contains(ln)) || ln === Qn;
      });
    }), yn = getMotion$1(Bt, Ir, Fr, Mr), _n = getMotion$1(Bt, Ar, zr, Dr), In = React.useState(Kt || !1), Tn = _slicedToArray(In, 2), kn = Tn[0], jn = Tn[1], An = qt ?? kn, un = useEvent(function(ln) {
      qt === void 0 && jn(ln);
    });
    useLayoutEffect(function() {
      jn(qt || !1);
    }, [qt]);
    var rn = React.useRef(An);
    rn.current = An;
    var dn = React.useRef([]);
    dn.current = [];
    var Mn = useEvent(function(ln) {
      var vn;
      un(ln), ((vn = dn.current[dn.current.length - 1]) !== null && vn !== void 0 ? vn : An) !== ln && (dn.current.push(ln), Qt == null || Qt(ln));
    }), On = React.useRef(), Dn = function() {
      clearTimeout(On.current);
    }, Yn = function(vn) {
      var Gn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      Dn(), Gn === 0 ? Mn(vn) : On.current = setTimeout(function() {
        Mn(vn);
      }, Gn * 1e3);
    };
    React.useEffect(function() {
      return Dn;
    }, []);
    var ra = React.useState(!1), Fn = _slicedToArray(ra, 2), Nn = Fn[0], Hn = Fn[1];
    useLayoutEffect(function(ln) {
      (!ln || An) && Hn(!0);
    }, [An]);
    var wr = React.useState(null), Vr = _slicedToArray(wr, 2), Yr = Vr[0], cn = Vr[1], hn = React.useState(null), wn = _slicedToArray(hn, 2), pn = wn[0], fn = wn[1], Bn = function(vn) {
      fn([vn.clientX, vn.clientY]);
    }, Rn = useAlign(An, nn, Cr && pn !== null ? pn : gr, mr, _r, yr, xr), Sn = _slicedToArray(Rn, 11), Kn = Sn[0], Pn = Sn[1], sn = Sn[2], bn = Sn[3], Ln = Sn[4], Wn = Sn[5], qn = Sn[6], na = Sn[7], Xn = Sn[8], sa = Sn[9], Zn = Sn[10], ua = useAction(Hr, Ht, Wt, Gt), pa = _slicedToArray(ua, 2), ia = pa[0], aa = pa[1], ha = ia.has("click"), ma = aa.has("click") || aa.has("contextMenu"), la = useEvent(function() {
      Nn || Zn();
    }), wa = function() {
      rn.current && Cr && ma && Yn(!1);
    };
    useWatch(An, gr, nn, la, wa), useLayoutEffect(function() {
      la();
    }, [pn, mr]), useLayoutEffect(function() {
      An && !(_r != null && _r[mr]) && la();
    }, [JSON.stringify(yr)]);
    var _a = React.useMemo(function() {
      var ln = getAlignPopupClassName(_r, Bt, sa, Cr);
      return classNames(ln, dr == null ? void 0 : dr(sa));
    }, [sa, dr, _r, Bt, Cr]);
    React.useImperativeHandle($t, function() {
      return {
        nativeElement: Nr.current,
        popupElement: En.current,
        forceAlign: la
      };
    });
    var Ra = React.useState(0), zn = _slicedToArray(Ra, 2), Vn = zn[0], Un = zn[1], ta = React.useState(0), ea = _slicedToArray(ta, 2), ga = ea[0], ba = ea[1], Ea = function() {
      if (vr && gr) {
        var vn = gr.getBoundingClientRect();
        Un(vn.width), ba(vn.height);
      }
    }, xa = function() {
      Ea(), la();
    }, Sa = function(vn) {
      Hn(!1), Zn(), Xt == null || Xt(vn);
    }, fa = function() {
      return new Promise(function(vn) {
        Ea(), cn(function() {
          return vn;
        });
      });
    };
    useLayoutEffect(function() {
      Yr && (Zn(), Yr(), cn(null));
    }, [Yr]);
    function oa(ln, vn, Gn, Jn) {
      Jr[ln] = function(Qn) {
        var Aa;
        Jn == null || Jn(Qn), Yn(vn, Gn);
        for (var Fa = arguments.length, Na = new Array(Fa > 1 ? Fa - 1 : 0), Ia = 1; Ia < Fa; Ia++)
          Na[Ia - 1] = arguments[Ia];
        (Aa = Qr[ln]) === null || Aa === void 0 || Aa.call.apply(Aa, [Qr, Qn].concat(Na));
      };
    }
    (ha || ma) && (Jr.onClick = function(ln) {
      var vn;
      rn.current && ma ? Yn(!1) : !rn.current && ha && (Bn(ln), Yn(!0));
      for (var Gn = arguments.length, Jn = new Array(Gn > 1 ? Gn - 1 : 0), Qn = 1; Qn < Gn; Qn++)
        Jn[Qn - 1] = arguments[Qn];
      (vn = Qr.onClick) === null || vn === void 0 || vn.call.apply(vn, [Qr, ln].concat(Jn));
    });
    var Ta = useWinClick(An, ma, gr, nn, nr, ir, gn, Yn), ca = ia.has("hover"), $a = aa.has("hover"), Ca, va;
    ca && (oa("onMouseEnter", !0, Zt, function(ln) {
      Bn(ln);
    }), oa("onPointerEnter", !0, Zt, function(ln) {
      Bn(ln);
    }), Ca = function(vn) {
      (An || Nn) && nn !== null && nn !== void 0 && nn.contains(vn.target) && Yn(!0, Zt);
    }, Cr && (Jr.onMouseMove = function(ln) {
      var vn;
      (vn = Qr.onMouseMove) === null || vn === void 0 || vn.call(Qr, ln);
    })), $a && (oa("onMouseLeave", !1, Jt), oa("onPointerLeave", !1, Jt), va = function() {
      Yn(!1, Jt);
    }), ia.has("focus") && oa("onFocus", !0, er), aa.has("focus") && oa("onBlur", !1, tr), ia.has("contextMenu") && (Jr.onContextMenu = function(ln) {
      var vn;
      rn.current && aa.has("contextMenu") ? Yn(!1) : (Bn(ln), Yn(!0)), ln.preventDefault();
      for (var Gn = arguments.length, Jn = new Array(Gn > 1 ? Gn - 1 : 0), Qn = 1; Qn < Gn; Qn++)
        Jn[Qn - 1] = arguments[Qn];
      (vn = Qr.onContextMenu) === null || vn === void 0 || vn.call.apply(vn, [Qr, ln].concat(Jn));
    }), Tr && (Jr.className = classNames(Qr.className, Tr));
    var ya = _objectSpread2(_objectSpread2({}, Qr), Jr), Pa = {}, ka = ["onContextMenu", "onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur"];
    ka.forEach(function(ln) {
      $r[ln] && (Pa[ln] = function() {
        for (var vn, Gn = arguments.length, Jn = new Array(Gn), Qn = 0; Qn < Gn; Qn++)
          Jn[Qn] = arguments[Qn];
        (vn = ya[ln]) === null || vn === void 0 || vn.call.apply(vn, [ya].concat(Jn)), $r[ln].apply($r, Jn);
      });
    });
    var Ma = /* @__PURE__ */ React.cloneElement(Br, _objectSpread2(_objectSpread2({}, ya), Pa)), Oa = {
      x: Wn,
      y: qn
    }, Da = kr ? _objectSpread2({}, kr !== !0 ? kr : {}) : null;
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(RefResizeObserver, {
      disabled: !An,
      ref: jr,
      onResize: xa
    }, /* @__PURE__ */ React.createElement(TriggerWrapper, {
      getTriggerDOMNode: Gr
    }, Ma)), /* @__PURE__ */ React.createElement(TriggerContext.Provider, {
      value: Zr
    }, /* @__PURE__ */ React.createElement(Popup$1, {
      portal: _t,
      ref: xn,
      prefixCls: Bt,
      popup: cr,
      className: classNames(hr, _a),
      style: pr,
      target: gr,
      onMouseEnter: Ca,
      onMouseLeave: va,
      onPointerEnter: Ca,
      zIndex: ur,
      open: An,
      keepDom: Nn,
      fresh: br,
      onClick: Pr,
      onPointerDownCapture: Ta,
      mask: nr,
      motion: yn,
      maskMotion: _n,
      onVisibleChanged: Sa,
      onPrepare: fa,
      forceRender: or,
      autoDestroy: Rr,
      getPopupContainer: ar,
      align: sa,
      arrow: Da,
      arrowPos: Oa,
      ready: Kn,
      offsetX: Pn,
      offsetY: sn,
      offsetR: bn,
      offsetB: Ln,
      onAlign: la,
      stretch: vr,
      targetWidth: Vn / na,
      targetHeight: ga / Xn
    })));
  });
  return browser$1.env.NODE_ENV !== "production" && (Et.displayName = "Trigger"), Et;
}
const Trigger = generateTrigger(Portal);
function Popup(_t) {
  var Et = _t.children, Pt = _t.prefixCls, $t = _t.id, Mt = _t.overlayInnerStyle, Bt = _t.bodyClassName, Vt = _t.className, zt = _t.style;
  return /* @__PURE__ */ React.createElement("div", {
    className: classNames("".concat(Pt, "-content"), Vt),
    style: zt
  }, /* @__PURE__ */ React.createElement("div", {
    className: classNames("".concat(Pt, "-inner"), Bt),
    id: $t,
    role: "tooltip",
    style: Mt
  }, typeof Et == "function" ? Et() : Et));
}
var autoAdjustOverflowTopBottom = {
  shiftX: 64,
  adjustY: 1
}, autoAdjustOverflowLeftRight = {
  adjustX: 1,
  shiftY: !0
}, targetOffset$1 = [0, 0], placements$2 = {
  left: {
    points: ["cr", "cl"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [-4, 0],
    targetOffset: targetOffset$1
  },
  right: {
    points: ["cl", "cr"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [4, 0],
    targetOffset: targetOffset$1
  },
  top: {
    points: ["bc", "tc"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, -4],
    targetOffset: targetOffset$1
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, 4],
    targetOffset: targetOffset$1
  },
  topLeft: {
    points: ["bl", "tl"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, -4],
    targetOffset: targetOffset$1
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [-4, 0],
    targetOffset: targetOffset$1
  },
  topRight: {
    points: ["br", "tr"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, -4],
    targetOffset: targetOffset$1
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [4, 0],
    targetOffset: targetOffset$1
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, 4],
    targetOffset: targetOffset$1
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [4, 0],
    targetOffset: targetOffset$1
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, 4],
    targetOffset: targetOffset$1
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [-4, 0],
    targetOffset: targetOffset$1
  }
}, _excluded$c = ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "children", "onVisibleChange", "afterVisibleChange", "transitionName", "animation", "motion", "placement", "align", "destroyTooltipOnHide", "defaultVisible", "getTooltipContainer", "overlayInnerStyle", "arrowContent", "overlay", "id", "showArrow", "classNames", "styles"], Tooltip$1 = function(Et, Pt) {
  var $t = Et.overlayClassName, Mt = Et.trigger, Bt = Mt === void 0 ? ["hover"] : Mt, Vt = Et.mouseEnterDelay, zt = Vt === void 0 ? 0 : Vt, Ht = Et.mouseLeaveDelay, Wt = Ht === void 0 ? 0.1 : Ht, Gt = Et.overlayStyle, qt = Et.prefixCls, Kt = qt === void 0 ? "rc-tooltip" : qt, Qt = Et.children, Xt = Et.onVisibleChange, Zt = Et.afterVisibleChange, Yt = Et.transitionName, Jt = Et.animation, er = Et.motion, tr = Et.placement, nr = tr === void 0 ? "right" : tr, rr = Et.align, ir = rr === void 0 ? {} : rr, ar = Et.destroyTooltipOnHide, or = ar === void 0 ? !1 : ar, sr = Et.defaultVisible, lr = Et.getTooltipContainer, cr = Et.overlayInnerStyle;
  Et.arrowContent;
  var hr = Et.overlay, pr = Et.id, mr = Et.showArrow, Er = mr === void 0 ? !0 : mr, _r = Et.classNames, yr = Et.styles, ur = _objectWithoutProperties$2(Et, _excluded$c), vr = useRef(null);
  useImperativeHandle(Pt, function() {
    return vr.current;
  });
  var dr = _objectSpread2({}, ur);
  "visible" in Et && (dr.popupVisible = Et.visible);
  var br = function() {
    return /* @__PURE__ */ React.createElement(Popup, {
      key: "content",
      prefixCls: Kt,
      id: pr,
      bodyClassName: _r == null ? void 0 : _r.body,
      overlayInnerStyle: _objectSpread2(_objectSpread2({}, cr), yr == null ? void 0 : yr.body)
    }, hr);
  };
  return /* @__PURE__ */ React.createElement(Trigger, _extends$2({
    popupClassName: classNames($t, _r == null ? void 0 : _r.root),
    prefixCls: Kt,
    popup: br,
    action: Bt,
    builtinPlacements: placements$2,
    popupPlacement: nr,
    ref: vr,
    popupAlign: ir,
    getPopupContainer: lr,
    onPopupVisibleChange: Xt,
    afterPopupVisibleChange: Zt,
    popupTransitionName: Yt,
    popupAnimation: Jt,
    popupMotion: er,
    defaultPopupVisible: sr,
    autoDestroy: or,
    mouseLeaveDelay: Wt,
    popupStyle: _objectSpread2(_objectSpread2({}, Gt), yr == null ? void 0 : yr.root),
    mouseEnterDelay: zt,
    arrow: Er
  }, dr), Qt);
};
const Tooltip$2 = /* @__PURE__ */ forwardRef(Tooltip$1);
function getArrowToken(_t) {
  const {
    sizePopupArrow: Et,
    borderRadiusXS: Pt,
    borderRadiusOuter: $t
  } = _t, Mt = Et / 2, Bt = 0, Vt = Mt, zt = $t * 1 / Math.sqrt(2), Ht = Mt - $t * (1 - 1 / Math.sqrt(2)), Wt = Mt - Pt * (1 / Math.sqrt(2)), Gt = $t * (Math.sqrt(2) - 1) + Pt * (1 / Math.sqrt(2)), qt = 2 * Mt - Wt, Kt = Gt, Qt = 2 * Mt - zt, Xt = Ht, Zt = 2 * Mt - Bt, Yt = Vt, Jt = Mt * Math.sqrt(2) + $t * (Math.sqrt(2) - 2), er = $t * (Math.sqrt(2) - 1), tr = `polygon(${er}px 100%, 50% ${er}px, ${2 * Mt - er}px 100%, ${er}px 100%)`, nr = `path('M ${Bt} ${Vt} A ${$t} ${$t} 0 0 0 ${zt} ${Ht} L ${Wt} ${Gt} A ${Pt} ${Pt} 0 0 1 ${qt} ${Kt} L ${Qt} ${Xt} A ${$t} ${$t} 0 0 0 ${Zt} ${Yt} Z')`;
  return {
    arrowShadowWidth: Jt,
    arrowPath: nr,
    arrowPolygon: tr
  };
}
const genRoundedArrow = (_t, Et, Pt) => {
  const {
    sizePopupArrow: $t,
    arrowPolygon: Mt,
    arrowPath: Bt,
    arrowShadowWidth: Vt,
    borderRadiusXS: zt,
    calc: Ht
  } = _t;
  return {
    pointerEvents: "none",
    width: $t,
    height: $t,
    overflow: "hidden",
    "&::before": {
      position: "absolute",
      bottom: 0,
      insetInlineStart: 0,
      width: $t,
      height: Ht($t).div(2).equal(),
      background: Et,
      clipPath: {
        _multi_value_: !0,
        value: [Mt, Bt]
      },
      content: '""'
    },
    "&::after": {
      content: '""',
      position: "absolute",
      width: Vt,
      height: Vt,
      bottom: 0,
      insetInline: 0,
      margin: "auto",
      borderRadius: {
        _skip_check_: !0,
        value: `0 0 ${unit$1(zt)} 0`
      },
      transform: "translateY(50%) rotate(-135deg)",
      boxShadow: Pt,
      zIndex: 0,
      background: "transparent"
    }
  };
}, MAX_VERTICAL_CONTENT_RADIUS = 8;
function getArrowOffsetToken(_t) {
  const {
    contentRadius: Et,
    limitVerticalRadius: Pt
  } = _t, $t = Et > 12 ? Et + 2 : 12;
  return {
    arrowOffsetHorizontal: $t,
    arrowOffsetVertical: Pt ? MAX_VERTICAL_CONTENT_RADIUS : $t
  };
}
function isInject(_t, Et) {
  return _t ? Et : {};
}
function getArrowStyle(_t, Et, Pt) {
  const {
    componentCls: $t,
    boxShadowPopoverArrow: Mt,
    arrowOffsetVertical: Bt,
    arrowOffsetHorizontal: Vt
  } = _t, {
    arrowDistance: zt = 0,
    arrowPlacement: Ht = {
      left: !0,
      right: !0,
      top: !0,
      bottom: !0
    }
  } = {};
  return {
    [$t]: Object.assign(Object.assign(Object.assign(Object.assign({
      // ============================ Basic ============================
      [`${$t}-arrow`]: [Object.assign(Object.assign({
        position: "absolute",
        zIndex: 1,
        display: "block"
      }, genRoundedArrow(_t, Et, Mt)), {
        "&:before": {
          background: Et
        }
      })]
    }, isInject(!!Ht.top, {
      [[`&-placement-top > ${$t}-arrow`, `&-placement-topLeft > ${$t}-arrow`, `&-placement-topRight > ${$t}-arrow`].join(",")]: {
        bottom: zt,
        transform: "translateY(100%) rotate(180deg)"
      },
      [`&-placement-top > ${$t}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateX(-50%) translateY(100%) rotate(180deg)"
      },
      "&-placement-topLeft": {
        "--arrow-offset-horizontal": Vt,
        [`> ${$t}-arrow`]: {
          left: {
            _skip_check_: !0,
            value: Vt
          }
        }
      },
      "&-placement-topRight": {
        "--arrow-offset-horizontal": `calc(100% - ${unit$1(Vt)})`,
        [`> ${$t}-arrow`]: {
          right: {
            _skip_check_: !0,
            value: Vt
          }
        }
      }
    })), isInject(!!Ht.bottom, {
      [[`&-placement-bottom > ${$t}-arrow`, `&-placement-bottomLeft > ${$t}-arrow`, `&-placement-bottomRight > ${$t}-arrow`].join(",")]: {
        top: zt,
        transform: "translateY(-100%)"
      },
      [`&-placement-bottom > ${$t}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateX(-50%) translateY(-100%)"
      },
      "&-placement-bottomLeft": {
        "--arrow-offset-horizontal": Vt,
        [`> ${$t}-arrow`]: {
          left: {
            _skip_check_: !0,
            value: Vt
          }
        }
      },
      "&-placement-bottomRight": {
        "--arrow-offset-horizontal": `calc(100% - ${unit$1(Vt)})`,
        [`> ${$t}-arrow`]: {
          right: {
            _skip_check_: !0,
            value: Vt
          }
        }
      }
    })), isInject(!!Ht.left, {
      [[`&-placement-left > ${$t}-arrow`, `&-placement-leftTop > ${$t}-arrow`, `&-placement-leftBottom > ${$t}-arrow`].join(",")]: {
        right: {
          _skip_check_: !0,
          value: zt
        },
        transform: "translateX(100%) rotate(90deg)"
      },
      [`&-placement-left > ${$t}-arrow`]: {
        top: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateY(-50%) translateX(100%) rotate(90deg)"
      },
      [`&-placement-leftTop > ${$t}-arrow`]: {
        top: Bt
      },
      [`&-placement-leftBottom > ${$t}-arrow`]: {
        bottom: Bt
      }
    })), isInject(!!Ht.right, {
      [[`&-placement-right > ${$t}-arrow`, `&-placement-rightTop > ${$t}-arrow`, `&-placement-rightBottom > ${$t}-arrow`].join(",")]: {
        left: {
          _skip_check_: !0,
          value: zt
        },
        transform: "translateX(-100%) rotate(-90deg)"
      },
      [`&-placement-right > ${$t}-arrow`]: {
        top: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateY(-50%) translateX(-100%) rotate(-90deg)"
      },
      [`&-placement-rightTop > ${$t}-arrow`]: {
        top: Bt
      },
      [`&-placement-rightBottom > ${$t}-arrow`]: {
        bottom: Bt
      }
    }))
  };
}
function getOverflowOptions(_t, Et, Pt, $t) {
  if ($t === !1)
    return {
      adjustX: !1,
      adjustY: !1
    };
  const Mt = $t && typeof $t == "object" ? $t : {}, Bt = {};
  switch (_t) {
    case "top":
    case "bottom":
      Bt.shiftX = Et.arrowOffsetHorizontal * 2 + Pt, Bt.shiftY = !0, Bt.adjustY = !0;
      break;
    case "left":
    case "right":
      Bt.shiftY = Et.arrowOffsetVertical * 2 + Pt, Bt.shiftX = !0, Bt.adjustX = !0;
      break;
  }
  const Vt = Object.assign(Object.assign({}, Bt), Mt);
  return Vt.shiftX || (Vt.adjustX = !0), Vt.shiftY || (Vt.adjustY = !0), Vt;
}
const PlacementAlignMap = {
  left: {
    points: ["cr", "cl"]
  },
  right: {
    points: ["cl", "cr"]
  },
  top: {
    points: ["bc", "tc"]
  },
  bottom: {
    points: ["tc", "bc"]
  },
  topLeft: {
    points: ["bl", "tl"]
  },
  leftTop: {
    points: ["tr", "tl"]
  },
  topRight: {
    points: ["br", "tr"]
  },
  rightTop: {
    points: ["tl", "tr"]
  },
  bottomRight: {
    points: ["tr", "br"]
  },
  rightBottom: {
    points: ["bl", "br"]
  },
  bottomLeft: {
    points: ["tl", "bl"]
  },
  leftBottom: {
    points: ["br", "bl"]
  }
}, ArrowCenterPlacementAlignMap = {
  topLeft: {
    points: ["bl", "tc"]
  },
  leftTop: {
    points: ["tr", "cl"]
  },
  topRight: {
    points: ["br", "tc"]
  },
  rightTop: {
    points: ["tl", "cr"]
  },
  bottomRight: {
    points: ["tr", "bc"]
  },
  rightBottom: {
    points: ["bl", "cr"]
  },
  bottomLeft: {
    points: ["tl", "bc"]
  },
  leftBottom: {
    points: ["br", "cl"]
  }
}, DisableAutoArrowList = /* @__PURE__ */ new Set(["topLeft", "topRight", "bottomLeft", "bottomRight", "leftTop", "leftBottom", "rightTop", "rightBottom"]);
function getPlacements(_t) {
  const {
    arrowWidth: Et,
    autoAdjustOverflow: Pt,
    arrowPointAtCenter: $t,
    offset: Mt,
    borderRadius: Bt,
    visibleFirst: Vt
  } = _t, zt = Et / 2, Ht = {};
  return Object.keys(PlacementAlignMap).forEach((Wt) => {
    const Gt = $t && ArrowCenterPlacementAlignMap[Wt] || PlacementAlignMap[Wt], qt = Object.assign(Object.assign({}, Gt), {
      offset: [0, 0],
      dynamicInset: !0
    });
    switch (Ht[Wt] = qt, DisableAutoArrowList.has(Wt) && (qt.autoArrow = !1), Wt) {
      case "top":
      case "topLeft":
      case "topRight":
        qt.offset[1] = -zt - Mt;
        break;
      case "bottom":
      case "bottomLeft":
      case "bottomRight":
        qt.offset[1] = zt + Mt;
        break;
      case "left":
      case "leftTop":
      case "leftBottom":
        qt.offset[0] = -zt - Mt;
        break;
      case "right":
      case "rightTop":
      case "rightBottom":
        qt.offset[0] = zt + Mt;
        break;
    }
    const Kt = getArrowOffsetToken({
      contentRadius: Bt,
      limitVerticalRadius: !0
    });
    if ($t)
      switch (Wt) {
        case "topLeft":
        case "bottomLeft":
          qt.offset[0] = -Kt.arrowOffsetHorizontal - zt;
          break;
        case "topRight":
        case "bottomRight":
          qt.offset[0] = Kt.arrowOffsetHorizontal + zt;
          break;
        case "leftTop":
        case "rightTop":
          qt.offset[1] = -Kt.arrowOffsetHorizontal * 2 + zt;
          break;
        case "leftBottom":
        case "rightBottom":
          qt.offset[1] = Kt.arrowOffsetHorizontal * 2 - zt;
          break;
      }
    qt.overflow = getOverflowOptions(Wt, Kt, Et, Pt), Vt && (qt.htmlRegion = "visibleFirst");
  }), Ht;
}
const genTooltipStyle = (_t) => {
  const {
    calc: Et,
    componentCls: Pt,
    // ant-tooltip
    tooltipMaxWidth: $t,
    tooltipColor: Mt,
    tooltipBg: Bt,
    tooltipBorderRadius: Vt,
    zIndexPopup: zt,
    controlHeight: Ht,
    boxShadowSecondary: Wt,
    paddingSM: Gt,
    paddingXS: qt,
    arrowOffsetHorizontal: Kt,
    sizePopupArrow: Qt
  } = _t, Xt = Et(Vt).add(Qt).add(Kt).equal(), Zt = Et(Vt).mul(2).add(Qt).equal();
  return [
    {
      [Pt]: Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(_t)), {
        position: "absolute",
        zIndex: zt,
        display: "block",
        width: "max-content",
        maxWidth: $t,
        visibility: "visible",
        // When use `autoArrow`, origin will follow the arrow position
        "--valid-offset-x": "var(--arrow-offset-horizontal, var(--arrow-x))",
        transformOrigin: ["var(--valid-offset-x, 50%)", "var(--arrow-y, 50%)"].join(" "),
        "&-hidden": {
          display: "none"
        },
        "--antd-arrow-background-color": Bt,
        // Wrapper for the tooltip content
        [`${Pt}-inner`]: {
          minWidth: Zt,
          minHeight: Ht,
          padding: `${unit$1(_t.calc(Gt).div(2).equal())} ${unit$1(qt)}`,
          color: Mt,
          textAlign: "start",
          textDecoration: "none",
          wordWrap: "break-word",
          backgroundColor: Bt,
          borderRadius: Vt,
          boxShadow: Wt,
          boxSizing: "border-box"
        },
        // Align placement should have another min width
        [["&-placement-topLeft", "&-placement-topRight", "&-placement-bottomLeft", "&-placement-bottomRight"].join(",")]: {
          minWidth: Xt
        },
        // Limit left and right placement radius
        [["&-placement-left", "&-placement-leftTop", "&-placement-leftBottom", "&-placement-right", "&-placement-rightTop", "&-placement-rightBottom"].join(",")]: {
          [`${Pt}-inner`]: {
            borderRadius: _t.min(Vt, MAX_VERTICAL_CONTENT_RADIUS)
          }
        },
        [`${Pt}-content`]: {
          position: "relative"
        }
      }), genPresetColor(_t, (Yt, Jt) => {
        let {
          darkColor: er
        } = Jt;
        return {
          [`&${Pt}-${Yt}`]: {
            [`${Pt}-inner`]: {
              backgroundColor: er
            },
            [`${Pt}-arrow`]: {
              "--antd-arrow-background-color": er
            }
          }
        };
      })), {
        // RTL
        "&-rtl": {
          direction: "rtl"
        }
      })
    },
    // Arrow Style
    getArrowStyle(_t, "var(--antd-arrow-background-color)"),
    // Pure Render
    {
      [`${Pt}-pure`]: {
        position: "relative",
        maxWidth: "none",
        margin: _t.sizePopupArrow
      }
    }
  ];
}, prepareComponentToken$2 = (_t) => Object.assign(Object.assign({
  zIndexPopup: _t.zIndexPopupBase + 70
}, getArrowOffsetToken({
  contentRadius: _t.borderRadius,
  limitVerticalRadius: !0
})), getArrowToken(merge$1(_t, {
  borderRadiusOuter: Math.min(_t.borderRadiusOuter, 4)
}))), useStyle$2 = function(_t) {
  let Et = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return genStyleHooks("Tooltip", ($t) => {
    const {
      borderRadius: Mt,
      colorTextLightSolid: Bt,
      colorBgSpotlight: Vt
    } = $t, zt = merge$1($t, {
      // default variables
      tooltipMaxWidth: 250,
      tooltipColor: Bt,
      tooltipBorderRadius: Mt,
      tooltipBg: Vt
    });
    return [genTooltipStyle(zt), initZoomMotion($t, "zoom-big-fast")];
  }, prepareComponentToken$2, {
    resetStyle: !1,
    // Popover use Tooltip as internal component. We do not need to handle this.
    injectStyle: Et
  })(_t);
}, inverseColors = PresetColors.map((_t) => `${_t}-inverse`), PresetStatusColorTypes = ["success", "processing", "error", "default", "warning"];
function isPresetColor(_t) {
  return (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0) ? [].concat(_toConsumableArray(inverseColors), _toConsumableArray(PresetColors)).includes(_t) : PresetColors.includes(_t);
}
function isPresetStatusColor(_t) {
  return PresetStatusColorTypes.includes(_t);
}
function parseColor(_t, Et) {
  const Pt = isPresetColor(Et), $t = classNames({
    [`${_t}-${Et}`]: Et && Pt
  }), Mt = {}, Bt = {};
  return Et && !Pt && (Mt.background = Et, Bt["--antd-arrow-background-color"] = Et), {
    className: $t,
    overlayStyle: Mt,
    arrowStyle: Bt
  };
}
const PurePanel$2 = (_t) => {
  const {
    prefixCls: Et,
    className: Pt,
    placement: $t = "top",
    title: Mt,
    color: Bt,
    overlayInnerStyle: Vt
  } = _t, {
    getPrefixCls: zt
  } = React.useContext(ConfigContext), Ht = zt("tooltip", Et), [Wt, Gt, qt] = useStyle$2(Ht), Kt = parseColor(Ht, Bt), Qt = Kt.arrowStyle, Xt = Object.assign(Object.assign({}, Vt), Kt.overlayStyle), Zt = classNames(Gt, qt, Ht, `${Ht}-pure`, `${Ht}-placement-${$t}`, Pt, Kt.className);
  return Wt(/* @__PURE__ */ React.createElement("div", {
    className: Zt,
    style: Qt
  }, /* @__PURE__ */ React.createElement("div", {
    className: `${Ht}-arrow`
  }), /* @__PURE__ */ React.createElement(Popup, Object.assign({}, _t, {
    className: Gt,
    prefixCls: Ht,
    overlayInnerStyle: Xt
  }), Mt)));
};
var __rest$5 = function(_t, Et) {
  var Pt = {};
  for (var $t in _t)
    Object.prototype.hasOwnProperty.call(_t, $t) && Et.indexOf($t) < 0 && (Pt[$t] = _t[$t]);
  if (_t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var Mt = 0, $t = Object.getOwnPropertySymbols(_t); Mt < $t.length; Mt++)
      Et.indexOf($t[Mt]) < 0 && Object.prototype.propertyIsEnumerable.call(_t, $t[Mt]) && (Pt[$t[Mt]] = _t[$t[Mt]]);
  return Pt;
};
const InternalTooltip = /* @__PURE__ */ React.forwardRef((_t, Et) => {
  var Pt, $t, Mt, Bt, Vt, zt;
  const {
    prefixCls: Ht,
    openClassName: Wt,
    getTooltipContainer: Gt,
    color: qt,
    overlayInnerStyle: Kt,
    children: Qt,
    afterOpenChange: Xt,
    afterVisibleChange: Zt,
    destroyTooltipOnHide: Yt,
    arrow: Jt = !0,
    title: er,
    overlay: tr,
    builtinPlacements: nr,
    arrowPointAtCenter: rr = !1,
    autoAdjustOverflow: ir = !0
  } = _t, ar = !!Jt, [, or] = useToken(), {
    getPopupContainer: sr,
    getPrefixCls: lr,
    direction: cr,
    tooltip: hr
  } = React.useContext(ConfigContext), pr = devUseWarning("Tooltip"), mr = React.useRef(null), Er = () => {
    var qr;
    (qr = mr.current) === null || qr === void 0 || qr.forceAlign();
  };
  React.useImperativeHandle(Et, () => {
    var qr;
    return {
      forceAlign: Er,
      forcePopupAlign: () => {
        pr.deprecated(!1, "forcePopupAlign", "forceAlign"), Er();
      },
      nativeElement: (qr = mr.current) === null || qr === void 0 ? void 0 : qr.nativeElement
    };
  }), browser$1.env.NODE_ENV !== "production" && ([["visible", "open"], ["defaultVisible", "defaultOpen"], ["onVisibleChange", "onOpenChange"], ["afterVisibleChange", "afterOpenChange"], ["arrowPointAtCenter", "arrow={{ pointAtCenter: true }}"], ["overlayStyle", "styles={{ root: {} }}"], ["overlayInnerStyle", "styles={{ body: {} }}"], ["overlayClassName", "classNames={{ root: {} }}"]].forEach((qr) => {
    let [tn, gr] = qr;
    pr.deprecated(!(tn in _t), tn, gr);
  }), browser$1.env.NODE_ENV !== "production" && pr(!Yt || typeof Yt == "boolean", "usage", "`destroyTooltipOnHide` no need config `keepParent` anymore. Please use `boolean` value directly."), browser$1.env.NODE_ENV !== "production" && pr(!Jt || typeof Jt == "boolean" || !("arrowPointAtCenter" in Jt), "deprecated", "`arrowPointAtCenter` in `arrow` is deprecated. Please use `pointAtCenter` instead."));
  const [_r, yr] = useMergedState(!1, {
    value: (Pt = _t.open) !== null && Pt !== void 0 ? Pt : _t.visible,
    defaultValue: ($t = _t.defaultOpen) !== null && $t !== void 0 ? $t : _t.defaultVisible
  }), ur = !er && !tr && er !== 0, vr = (qr) => {
    var tn, gr;
    yr(ur ? !1 : qr), ur || ((tn = _t.onOpenChange) === null || tn === void 0 || tn.call(_t, qr), (gr = _t.onVisibleChange) === null || gr === void 0 || gr.call(_t, qr));
  }, dr = React.useMemo(() => {
    var qr, tn;
    let gr = rr;
    return typeof Jt == "object" && (gr = (tn = (qr = Jt.pointAtCenter) !== null && qr !== void 0 ? qr : Jt.arrowPointAtCenter) !== null && tn !== void 0 ? tn : rr), nr || getPlacements({
      arrowPointAtCenter: gr,
      autoAdjustOverflow: ir,
      arrowWidth: ar ? or.sizePopupArrow : 0,
      borderRadius: or.borderRadius,
      offset: or.marginXXS,
      visibleFirst: !0
    });
  }, [rr, Jt, nr, or]), br = React.useMemo(() => er === 0 ? er : tr || er || "", [tr, er]), Cr = /* @__PURE__ */ React.createElement(ContextIsolator, {
    space: !0
  }, typeof br == "function" ? br() : br), {
    getPopupContainer: Pr,
    placement: xr = "top",
    mouseEnterDelay: kr = 0.1,
    mouseLeaveDelay: Ir = 0.1,
    overlayStyle: Ar,
    rootClassName: Mr,
    overlayClassName: Fr,
    styles: Dr,
    classNames: zr
  } = _t, Tr = __rest$5(_t, ["getPopupContainer", "placement", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "rootClassName", "overlayClassName", "styles", "classNames"]), Gr = lr("tooltip", Ht), $r = lr(), Rr = _t["data-popover-inject"];
  let Or = _r;
  !("open" in _t) && !("visible" in _t) && ur && (Or = !1);
  const Lr = /* @__PURE__ */ React.isValidElement(Qt) && !isFragment(Qt) ? Qt : /* @__PURE__ */ React.createElement("span", null, Qt), Hr = Lr.props, Wr = !Hr.className || typeof Hr.className == "string" ? classNames(Hr.className, Wt || `${Gr}-open`) : Hr.className, [Kr, Ur, Zr] = useStyle$2(Gr, !Rr), Xr = parseColor(Gr, qt), mn = Xr.arrowStyle, an = classNames(Fr, {
    [`${Gr}-rtl`]: cr === "rtl"
  }, Xr.className, Mr, Ur, Zr, hr == null ? void 0 : hr.className, (Mt = hr == null ? void 0 : hr.classNames) === null || Mt === void 0 ? void 0 : Mt.root, zr == null ? void 0 : zr.root), nn = classNames((Bt = hr == null ? void 0 : hr.classNames) === null || Bt === void 0 ? void 0 : Bt.body, zr == null ? void 0 : zr.body), [$n, En] = useZIndex("Tooltip", Tr.zIndex), xn = /* @__PURE__ */ React.createElement(Tooltip$2, Object.assign({}, Tr, {
    zIndex: $n,
    showArrow: ar,
    placement: xr,
    mouseEnterDelay: kr,
    mouseLeaveDelay: Ir,
    prefixCls: Gr,
    classNames: {
      root: an,
      body: nn
    },
    styles: {
      root: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, mn), (Vt = hr == null ? void 0 : hr.styles) === null || Vt === void 0 ? void 0 : Vt.root), hr == null ? void 0 : hr.style), Ar), Dr == null ? void 0 : Dr.root),
      body: Object.assign(Object.assign(Object.assign(Object.assign({}, (zt = hr == null ? void 0 : hr.styles) === null || zt === void 0 ? void 0 : zt.body), Kt), Dr == null ? void 0 : Dr.body), Xr.overlayStyle)
    },
    getTooltipContainer: Pr || Gt || sr,
    ref: mr,
    builtinPlacements: dr,
    overlay: Cr,
    visible: Or,
    onVisibleChange: vr,
    afterVisibleChange: Xt ?? Zt,
    arrowContent: /* @__PURE__ */ React.createElement("span", {
      className: `${Gr}-arrow-content`
    }),
    motion: {
      motionName: getTransitionName($r, "zoom-big-fast", _t.transitionName),
      motionDeadline: 1e3
    },
    destroyTooltipOnHide: !!Yt
  }), Or ? cloneElement(Lr, {
    className: Wr
  }) : Lr);
  return Kr(/* @__PURE__ */ React.createElement(zIndexContext.Provider, {
    value: En
  }, xn));
}), Tooltip = InternalTooltip;
browser$1.env.NODE_ENV !== "production" && (Tooltip.displayName = "Tooltip");
Tooltip._InternalPanelDoNotUseOrYouWillBeFired = PurePanel$2;
var ESC$1 = KeyCode.ESC, TAB = KeyCode.TAB;
function useAccessibility$1(_t) {
  var Et = _t.visible, Pt = _t.triggerRef, $t = _t.onVisibleChange, Mt = _t.autoFocus, Bt = _t.overlayRef, Vt = React.useRef(!1), zt = function() {
    if (Et) {
      var qt, Kt;
      (qt = Pt.current) === null || qt === void 0 || (Kt = qt.focus) === null || Kt === void 0 || Kt.call(qt), $t == null || $t(!1);
    }
  }, Ht = function() {
    var qt;
    return (qt = Bt.current) !== null && qt !== void 0 && qt.focus ? (Bt.current.focus(), Vt.current = !0, !0) : !1;
  }, Wt = function(qt) {
    switch (qt.keyCode) {
      case ESC$1:
        zt();
        break;
      case TAB: {
        var Kt = !1;
        Vt.current || (Kt = Ht()), Kt ? qt.preventDefault() : zt();
        break;
      }
    }
  };
  React.useEffect(function() {
    return Et ? (window.addEventListener("keydown", Wt), Mt && wrapperRaf(Ht, 3), function() {
      window.removeEventListener("keydown", Wt), Vt.current = !1;
    }) : function() {
      Vt.current = !1;
    };
  }, [Et]);
}
var Overlay = /* @__PURE__ */ forwardRef(function(_t, Et) {
  var Pt = _t.overlay, $t = _t.arrow, Mt = _t.prefixCls, Bt = useMemo$1(function() {
    var zt;
    return typeof Pt == "function" ? zt = Pt() : zt = Pt, zt;
  }, [Pt]), Vt = composeRef(Et, getNodeRef(Bt));
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, $t && /* @__PURE__ */ React__default.createElement("div", {
    className: "".concat(Mt, "-arrow")
  }), /* @__PURE__ */ React__default.cloneElement(Bt, {
    ref: supportRef(Bt) ? Vt : void 0
  }));
}), autoAdjustOverflow$1 = {
  adjustX: 1,
  adjustY: 1
}, targetOffset = [0, 0], placements$1 = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: autoAdjustOverflow$1,
    offset: [0, -4],
    targetOffset
  },
  top: {
    points: ["bc", "tc"],
    overflow: autoAdjustOverflow$1,
    offset: [0, -4],
    targetOffset
  },
  topRight: {
    points: ["br", "tr"],
    overflow: autoAdjustOverflow$1,
    offset: [0, -4],
    targetOffset
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: autoAdjustOverflow$1,
    offset: [0, 4],
    targetOffset
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: autoAdjustOverflow$1,
    offset: [0, 4],
    targetOffset
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: autoAdjustOverflow$1,
    offset: [0, 4],
    targetOffset
  }
}, _excluded$b = ["arrow", "prefixCls", "transitionName", "animation", "align", "placement", "placements", "getPopupContainer", "showAction", "hideAction", "overlayClassName", "overlayStyle", "visible", "trigger", "autoFocus", "overlay", "children", "onVisibleChange"];
function Dropdown(_t, Et) {
  var Pt, $t = _t.arrow, Mt = $t === void 0 ? !1 : $t, Bt = _t.prefixCls, Vt = Bt === void 0 ? "rc-dropdown" : Bt, zt = _t.transitionName, Ht = _t.animation, Wt = _t.align, Gt = _t.placement, qt = Gt === void 0 ? "bottomLeft" : Gt, Kt = _t.placements, Qt = Kt === void 0 ? placements$1 : Kt, Xt = _t.getPopupContainer, Zt = _t.showAction, Yt = _t.hideAction, Jt = _t.overlayClassName, er = _t.overlayStyle, tr = _t.visible, nr = _t.trigger, rr = nr === void 0 ? ["hover"] : nr, ir = _t.autoFocus, ar = _t.overlay, or = _t.children, sr = _t.onVisibleChange, lr = _objectWithoutProperties$2(_t, _excluded$b), cr = React__default.useState(), hr = _slicedToArray(cr, 2), pr = hr[0], mr = hr[1], Er = "visible" in _t ? tr : pr, _r = React__default.useRef(null), yr = React__default.useRef(null), ur = React__default.useRef(null);
  React__default.useImperativeHandle(Et, function() {
    return _r.current;
  });
  var vr = function(Mr) {
    mr(Mr), sr == null || sr(Mr);
  };
  useAccessibility$1({
    visible: Er,
    triggerRef: ur,
    onVisibleChange: vr,
    autoFocus: ir,
    overlayRef: yr
  });
  var dr = function(Mr) {
    var Fr = _t.onOverlayClick;
    mr(!1), Fr && Fr(Mr);
  }, br = function() {
    return /* @__PURE__ */ React__default.createElement(Overlay, {
      ref: yr,
      overlay: ar,
      prefixCls: Vt,
      arrow: Mt
    });
  }, Cr = function() {
    return typeof ar == "function" ? br : br();
  }, Pr = function() {
    var Mr = _t.minOverlayWidthMatchTrigger, Fr = _t.alignPoint;
    return "minOverlayWidthMatchTrigger" in _t ? Mr : !Fr;
  }, xr = function() {
    var Mr = _t.openClassName;
    return Mr !== void 0 ? Mr : "".concat(Vt, "-open");
  }, kr = /* @__PURE__ */ React__default.cloneElement(or, {
    className: classNames((Pt = or.props) === null || Pt === void 0 ? void 0 : Pt.className, Er && xr()),
    ref: supportRef(or) ? composeRef(ur, getNodeRef(or)) : void 0
  }), Ir = Yt;
  return !Ir && rr.indexOf("contextMenu") !== -1 && (Ir = ["click"]), /* @__PURE__ */ React__default.createElement(Trigger, _extends$2({
    builtinPlacements: Qt
  }, lr, {
    prefixCls: Vt,
    ref: _r,
    popupClassName: classNames(Jt, _defineProperty({}, "".concat(Vt, "-show-arrow"), Mt)),
    popupStyle: er,
    action: rr,
    showAction: Zt,
    hideAction: Ir,
    popupPlacement: qt,
    popupAlign: Wt,
    popupTransitionName: zt,
    popupAnimation: Ht,
    popupVisible: Er,
    stretch: Pr() ? "minWidth" : "",
    popup: Cr(),
    onPopupVisibleChange: vr,
    onPopupClick: dr,
    getPopupContainer: Xt
  }), kr);
}
const Dropdown$1 = /* @__PURE__ */ React__default.forwardRef(Dropdown);
var IdContext = /* @__PURE__ */ React.createContext(null);
function getMenuId(_t, Et) {
  return _t === void 0 ? null : "".concat(_t, "-").concat(Et);
}
function useMenuId(_t) {
  var Et = React.useContext(IdContext);
  return getMenuId(Et, _t);
}
var _excluded$a = ["children", "locked"], MenuContext = /* @__PURE__ */ React.createContext(null);
function mergeProps(_t, Et) {
  var Pt = _objectSpread2({}, _t);
  return Object.keys(Et).forEach(function($t) {
    var Mt = Et[$t];
    Mt !== void 0 && (Pt[$t] = Mt);
  }), Pt;
}
function InheritableContextProvider(_t) {
  var Et = _t.children, Pt = _t.locked, $t = _objectWithoutProperties$2(_t, _excluded$a), Mt = React.useContext(MenuContext), Bt = useMemo(function() {
    return mergeProps(Mt, $t);
  }, [Mt, $t], function(Vt, zt) {
    return !Pt && (Vt[0] !== zt[0] || !isEqual(Vt[1], zt[1], !0));
  });
  return /* @__PURE__ */ React.createElement(MenuContext.Provider, {
    value: Bt
  }, Et);
}
var EmptyList = [], PathRegisterContext = /* @__PURE__ */ React.createContext(null);
function useMeasure() {
  return React.useContext(PathRegisterContext);
}
var PathTrackerContext = /* @__PURE__ */ React.createContext(EmptyList);
function useFullPath(_t) {
  var Et = React.useContext(PathTrackerContext);
  return React.useMemo(function() {
    return _t !== void 0 ? [].concat(_toConsumableArray(Et), [_t]) : Et;
  }, [Et, _t]);
}
var PathUserContext = /* @__PURE__ */ React.createContext(null), PrivateContext = /* @__PURE__ */ React.createContext({});
function focusable(_t) {
  var Et = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  if (isVisible(_t)) {
    var Pt = _t.nodeName.toLowerCase(), $t = (
      // Focusable element
      ["input", "select", "textarea", "button"].includes(Pt) || // Editable element
      _t.isContentEditable || // Anchor with href element
      Pt === "a" && !!_t.getAttribute("href")
    ), Mt = _t.getAttribute("tabindex"), Bt = Number(Mt), Vt = null;
    return Mt && !Number.isNaN(Bt) ? Vt = Bt : $t && Vt === null && (Vt = 0), $t && _t.disabled && (Vt = null), Vt !== null && (Vt >= 0 || Et && Vt < 0);
  }
  return !1;
}
function getFocusNodeList(_t) {
  var Et = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, Pt = _toConsumableArray(_t.querySelectorAll("*")).filter(function($t) {
    return focusable($t, Et);
  });
  return focusable(_t, Et) && Pt.unshift(_t), Pt;
}
var LEFT = KeyCode.LEFT, RIGHT = KeyCode.RIGHT, UP = KeyCode.UP, DOWN = KeyCode.DOWN, ENTER = KeyCode.ENTER, ESC = KeyCode.ESC, HOME = KeyCode.HOME, END = KeyCode.END, ArrowKeys = [UP, DOWN, LEFT, RIGHT];
function getOffset(_t, Et, Pt, $t) {
  var Mt, Bt = "prev", Vt = "next", zt = "children", Ht = "parent";
  if (_t === "inline" && $t === ENTER)
    return {
      inlineTrigger: !0
    };
  var Wt = _defineProperty(_defineProperty({}, UP, Bt), DOWN, Vt), Gt = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, LEFT, Pt ? Vt : Bt), RIGHT, Pt ? Bt : Vt), DOWN, zt), ENTER, zt), qt = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, UP, Bt), DOWN, Vt), ENTER, zt), ESC, Ht), LEFT, Pt ? zt : Ht), RIGHT, Pt ? Ht : zt), Kt = {
    inline: Wt,
    horizontal: Gt,
    vertical: qt,
    inlineSub: Wt,
    horizontalSub: qt,
    verticalSub: qt
  }, Qt = (Mt = Kt["".concat(_t).concat(Et ? "" : "Sub")]) === null || Mt === void 0 ? void 0 : Mt[$t];
  switch (Qt) {
    case Bt:
      return {
        offset: -1,
        sibling: !0
      };
    case Vt:
      return {
        offset: 1,
        sibling: !0
      };
    case Ht:
      return {
        offset: -1,
        sibling: !1
      };
    case zt:
      return {
        offset: 1,
        sibling: !1
      };
    default:
      return null;
  }
}
function findContainerUL(_t) {
  for (var Et = _t; Et; ) {
    if (Et.getAttribute("data-menu-list"))
      return Et;
    Et = Et.parentElement;
  }
  return null;
}
function getFocusElement(_t, Et) {
  for (var Pt = _t || document.activeElement; Pt; ) {
    if (Et.has(Pt))
      return Pt;
    Pt = Pt.parentElement;
  }
  return null;
}
function getFocusableElements(_t, Et) {
  var Pt = getFocusNodeList(_t, !0);
  return Pt.filter(function($t) {
    return Et.has($t);
  });
}
function getNextFocusElement(_t, Et, Pt) {
  var $t = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
  if (!_t)
    return null;
  var Mt = getFocusableElements(_t, Et), Bt = Mt.length, Vt = Mt.findIndex(function(zt) {
    return Pt === zt;
  });
  return $t < 0 ? Vt === -1 ? Vt = Bt - 1 : Vt -= 1 : $t > 0 && (Vt += 1), Vt = (Vt + Bt) % Bt, Mt[Vt];
}
var refreshElements = function(Et, Pt) {
  var $t = /* @__PURE__ */ new Set(), Mt = /* @__PURE__ */ new Map(), Bt = /* @__PURE__ */ new Map();
  return Et.forEach(function(Vt) {
    var zt = document.querySelector("[data-menu-id='".concat(getMenuId(Pt, Vt), "']"));
    zt && ($t.add(zt), Bt.set(zt, Vt), Mt.set(Vt, zt));
  }), {
    elements: $t,
    key2element: Mt,
    element2key: Bt
  };
};
function useAccessibility(_t, Et, Pt, $t, Mt, Bt, Vt, zt, Ht, Wt) {
  var Gt = React.useRef(), qt = React.useRef();
  qt.current = Et;
  var Kt = function() {
    wrapperRaf.cancel(Gt.current);
  };
  return React.useEffect(function() {
    return function() {
      Kt();
    };
  }, []), function(Qt) {
    var Xt = Qt.which;
    if ([].concat(ArrowKeys, [ENTER, ESC, HOME, END]).includes(Xt)) {
      var Zt = Bt(), Yt = refreshElements(Zt, $t), Jt = Yt, er = Jt.elements, tr = Jt.key2element, nr = Jt.element2key, rr = tr.get(Et), ir = getFocusElement(rr, er), ar = nr.get(ir), or = getOffset(_t, Vt(ar, !0).length === 1, Pt, Xt);
      if (!or && Xt !== HOME && Xt !== END)
        return;
      (ArrowKeys.includes(Xt) || [HOME, END].includes(Xt)) && Qt.preventDefault();
      var sr = function(yr) {
        if (yr) {
          var ur = yr, vr = yr.querySelector("a");
          vr != null && vr.getAttribute("href") && (ur = vr);
          var dr = nr.get(yr);
          zt(dr), Kt(), Gt.current = wrapperRaf(function() {
            qt.current === dr && ur.focus();
          });
        }
      };
      if ([HOME, END].includes(Xt) || or.sibling || !ir) {
        var lr;
        !ir || _t === "inline" ? lr = Mt.current : lr = findContainerUL(ir);
        var cr, hr = getFocusableElements(lr, er);
        Xt === HOME ? cr = hr[0] : Xt === END ? cr = hr[hr.length - 1] : cr = getNextFocusElement(lr, er, ir, or.offset), sr(cr);
      } else if (or.inlineTrigger)
        Ht(ar);
      else if (or.offset > 0)
        Ht(ar, !0), Kt(), Gt.current = wrapperRaf(function() {
          Yt = refreshElements(Zt, $t);
          var _r = ir.getAttribute("aria-controls"), yr = document.getElementById(_r), ur = getNextFocusElement(yr, Yt.elements);
          sr(ur);
        }, 5);
      else if (or.offset < 0) {
        var pr = Vt(ar, !0), mr = pr[pr.length - 2], Er = tr.get(mr);
        Ht(mr, !1), sr(Er);
      }
    }
    Wt == null || Wt(Qt);
  };
}
function nextSlice(_t) {
  Promise.resolve().then(_t);
}
var PATH_SPLIT = "__RC_UTIL_PATH_SPLIT__", getPathStr = function(Et) {
  return Et.join(PATH_SPLIT);
}, getPathKeys = function(Et) {
  return Et.split(PATH_SPLIT);
}, OVERFLOW_KEY = "rc-menu-more";
function useKeyRecords() {
  var _t = React.useState({}), Et = _slicedToArray(_t, 2), Pt = Et[1], $t = useRef(/* @__PURE__ */ new Map()), Mt = useRef(/* @__PURE__ */ new Map()), Bt = React.useState([]), Vt = _slicedToArray(Bt, 2), zt = Vt[0], Ht = Vt[1], Wt = useRef(0), Gt = useRef(!1), qt = function() {
    Gt.current || Pt({});
  }, Kt = useCallback(function(tr, nr) {
    browser$1.env.NODE_ENV !== "production" && warningOnce(!$t.current.has(tr), "Duplicated key '".concat(tr, "' used in Menu by path [").concat(nr.join(" > "), "]"));
    var rr = getPathStr(nr);
    Mt.current.set(rr, tr), $t.current.set(tr, rr), Wt.current += 1;
    var ir = Wt.current;
    nextSlice(function() {
      ir === Wt.current && qt();
    });
  }, []), Qt = useCallback(function(tr, nr) {
    var rr = getPathStr(nr);
    Mt.current.delete(rr), $t.current.delete(tr);
  }, []), Xt = useCallback(function(tr) {
    Ht(tr);
  }, []), Zt = useCallback(function(tr, nr) {
    var rr = $t.current.get(tr) || "", ir = getPathKeys(rr);
    return nr && zt.includes(ir[0]) && ir.unshift(OVERFLOW_KEY), ir;
  }, [zt]), Yt = useCallback(function(tr, nr) {
    return tr.filter(function(rr) {
      return rr !== void 0;
    }).some(function(rr) {
      var ir = Zt(rr, !0);
      return ir.includes(nr);
    });
  }, [Zt]), Jt = function() {
    var nr = _toConsumableArray($t.current.keys());
    return zt.length && nr.push(OVERFLOW_KEY), nr;
  }, er = useCallback(function(tr) {
    var nr = "".concat($t.current.get(tr)).concat(PATH_SPLIT), rr = /* @__PURE__ */ new Set();
    return _toConsumableArray(Mt.current.keys()).forEach(function(ir) {
      ir.startsWith(nr) && rr.add(Mt.current.get(ir));
    }), rr;
  }, []);
  return React.useEffect(function() {
    return function() {
      Gt.current = !0;
    };
  }, []), {
    // Register
    registerPath: Kt,
    unregisterPath: Qt,
    refreshOverflowKeys: Xt,
    // Util
    isSubPathKey: Yt,
    getKeyPath: Zt,
    getKeys: Jt,
    getSubPathKeys: er
  };
}
function useMemoCallback(_t) {
  var Et = React.useRef(_t);
  Et.current = _t;
  var Pt = React.useCallback(function() {
    for (var $t, Mt = arguments.length, Bt = new Array(Mt), Vt = 0; Vt < Mt; Vt++)
      Bt[Vt] = arguments[Vt];
    return ($t = Et.current) === null || $t === void 0 ? void 0 : $t.call.apply($t, [Et].concat(Bt));
  }, []);
  return _t ? Pt : void 0;
}
var uniquePrefix = Math.random().toFixed(5).toString().slice(2), internalId = 0;
function useUUID(_t) {
  var Et = useMergedState(_t, {
    value: _t
  }), Pt = _slicedToArray(Et, 2), $t = Pt[0], Mt = Pt[1];
  return React.useEffect(function() {
    internalId += 1;
    var Bt = browser$1.env.NODE_ENV === "test" ? "test" : "".concat(uniquePrefix, "-").concat(internalId);
    Mt("rc-menu-uuid-".concat(Bt));
  }, []), $t;
}
function useActive(_t, Et, Pt, $t) {
  var Mt = React.useContext(MenuContext), Bt = Mt.activeKey, Vt = Mt.onActive, zt = Mt.onInactive, Ht = {
    active: Bt === _t
  };
  return Et || (Ht.onMouseEnter = function(Wt) {
    Pt == null || Pt({
      key: _t,
      domEvent: Wt
    }), Vt(_t);
  }, Ht.onMouseLeave = function(Wt) {
    $t == null || $t({
      key: _t,
      domEvent: Wt
    }), zt(_t);
  }), Ht;
}
function useDirectionStyle(_t) {
  var Et = React.useContext(MenuContext), Pt = Et.mode, $t = Et.rtl, Mt = Et.inlineIndent;
  if (Pt !== "inline")
    return null;
  var Bt = _t;
  return $t ? {
    paddingRight: Bt * Mt
  } : {
    paddingLeft: Bt * Mt
  };
}
function Icon(_t) {
  var Et = _t.icon, Pt = _t.props, $t = _t.children, Mt;
  return Et === null || Et === !1 ? null : (typeof Et == "function" ? Mt = /* @__PURE__ */ React.createElement(Et, _objectSpread2({}, Pt)) : typeof Et != "boolean" && (Mt = Et), Mt || $t || null);
}
var _excluded$9 = ["item"];
function warnItemProp(_t) {
  var Et = _t.item, Pt = _objectWithoutProperties$2(_t, _excluded$9);
  return Object.defineProperty(Pt, "item", {
    get: function() {
      return warningOnce(!1, "`info.item` is deprecated since we will move to function component that not provides React Node instance in future."), Et;
    }
  }), Pt;
}
var _excluded$8 = ["title", "attribute", "elementRef"], _excluded2$2 = ["style", "className", "eventKey", "warnKey", "disabled", "itemIcon", "children", "role", "onMouseEnter", "onMouseLeave", "onClick", "onKeyDown", "onFocus"], _excluded3 = ["active"], LegacyMenuItem = /* @__PURE__ */ function(_t) {
  _inherits(Pt, _t);
  var Et = _createSuper(Pt);
  function Pt() {
    return _classCallCheck(this, Pt), Et.apply(this, arguments);
  }
  return _createClass(Pt, [{
    key: "render",
    value: function() {
      var Mt = this.props, Bt = Mt.title, Vt = Mt.attribute, zt = Mt.elementRef, Ht = _objectWithoutProperties$2(Mt, _excluded$8), Wt = omit(Ht, ["eventKey", "popupClassName", "popupOffset", "onTitleClick"]);
      return warningOnce(!Vt, "`attribute` of Menu.Item is deprecated. Please pass attribute directly."), /* @__PURE__ */ React.createElement(ForwardOverflow.Item, _extends$2({}, Vt, {
        title: typeof Bt == "string" ? Bt : void 0
      }, Wt, {
        ref: zt
      }));
    }
  }]), Pt;
}(React.Component), InternalMenuItem = /* @__PURE__ */ React.forwardRef(function(_t, Et) {
  var Pt = _t.style, $t = _t.className, Mt = _t.eventKey, Bt = _t.warnKey, Vt = _t.disabled, zt = _t.itemIcon, Ht = _t.children, Wt = _t.role, Gt = _t.onMouseEnter, qt = _t.onMouseLeave, Kt = _t.onClick, Qt = _t.onKeyDown, Xt = _t.onFocus, Zt = _objectWithoutProperties$2(_t, _excluded2$2), Yt = useMenuId(Mt), Jt = React.useContext(MenuContext), er = Jt.prefixCls, tr = Jt.onItemClick, nr = Jt.disabled, rr = Jt.overflowDisabled, ir = Jt.itemIcon, ar = Jt.selectedKeys, or = Jt.onActive, sr = React.useContext(PrivateContext), lr = sr._internalRenderMenuItem, cr = "".concat(er, "-item"), hr = React.useRef(), pr = React.useRef(), mr = nr || Vt, Er = useComposeRef(Et, pr), _r = useFullPath(Mt);
  browser$1.env.NODE_ENV !== "production" && Bt && warningOnce(!1, "MenuItem should not leave undefined `key`.");
  var yr = function(Dr) {
    return {
      key: Mt,
      // Note: For legacy code is reversed which not like other antd component
      keyPath: _toConsumableArray(_r).reverse(),
      item: hr.current,
      domEvent: Dr
    };
  }, ur = zt || ir, vr = useActive(Mt, mr, Gt, qt), dr = vr.active, br = _objectWithoutProperties$2(vr, _excluded3), Cr = ar.includes(Mt), Pr = useDirectionStyle(_r.length), xr = function(Dr) {
    if (!mr) {
      var zr = yr(Dr);
      Kt == null || Kt(warnItemProp(zr)), tr(zr);
    }
  }, kr = function(Dr) {
    if (Qt == null || Qt(Dr), Dr.which === KeyCode.ENTER) {
      var zr = yr(Dr);
      Kt == null || Kt(warnItemProp(zr)), tr(zr);
    }
  }, Ir = function(Dr) {
    or(Mt), Xt == null || Xt(Dr);
  }, Ar = {};
  _t.role === "option" && (Ar["aria-selected"] = Cr);
  var Mr = /* @__PURE__ */ React.createElement(LegacyMenuItem, _extends$2({
    ref: hr,
    elementRef: Er,
    role: Wt === null ? "none" : Wt || "menuitem",
    tabIndex: Vt ? null : -1,
    "data-menu-id": rr && Yt ? null : Yt
  }, omit(Zt, ["extra"]), br, Ar, {
    component: "li",
    "aria-disabled": Vt,
    style: _objectSpread2(_objectSpread2({}, Pr), Pt),
    className: classNames(cr, _defineProperty(_defineProperty(_defineProperty({}, "".concat(cr, "-active"), dr), "".concat(cr, "-selected"), Cr), "".concat(cr, "-disabled"), mr), $t),
    onClick: xr,
    onKeyDown: kr,
    onFocus: Ir
  }), Ht, /* @__PURE__ */ React.createElement(Icon, {
    props: _objectSpread2(_objectSpread2({}, _t), {}, {
      isSelected: Cr
    }),
    icon: ur
  }));
  return lr && (Mr = lr(Mr, _t, {
    selected: Cr
  })), Mr;
});
function MenuItem(_t, Et) {
  var Pt = _t.eventKey, $t = useMeasure(), Mt = useFullPath(Pt);
  return React.useEffect(function() {
    if ($t)
      return $t.registerPath(Pt, Mt), function() {
        $t.unregisterPath(Pt, Mt);
      };
  }, [Mt]), $t ? null : /* @__PURE__ */ React.createElement(InternalMenuItem, _extends$2({}, _t, {
    ref: Et
  }));
}
const MenuItem$1 = /* @__PURE__ */ React.forwardRef(MenuItem);
var _excluded$7 = ["className", "children"], InternalSubMenuList = function(Et, Pt) {
  var $t = Et.className, Mt = Et.children, Bt = _objectWithoutProperties$2(Et, _excluded$7), Vt = React.useContext(MenuContext), zt = Vt.prefixCls, Ht = Vt.mode, Wt = Vt.rtl;
  return /* @__PURE__ */ React.createElement("ul", _extends$2({
    className: classNames(zt, Wt && "".concat(zt, "-rtl"), "".concat(zt, "-sub"), "".concat(zt, "-").concat(Ht === "inline" ? "inline" : "vertical"), $t),
    role: "menu"
  }, Bt, {
    "data-menu-list": !0,
    ref: Pt
  }), Mt);
}, SubMenuList = /* @__PURE__ */ React.forwardRef(InternalSubMenuList);
SubMenuList.displayName = "SubMenuList";
function parseChildren(_t, Et) {
  return toArray$4(_t).map(function(Pt, $t) {
    if (/* @__PURE__ */ React.isValidElement(Pt)) {
      var Mt, Bt, Vt = Pt.key, zt = (Mt = (Bt = Pt.props) === null || Bt === void 0 ? void 0 : Bt.eventKey) !== null && Mt !== void 0 ? Mt : Vt, Ht = zt == null;
      Ht && (zt = "tmp_key-".concat([].concat(_toConsumableArray(Et), [$t]).join("-")));
      var Wt = {
        key: zt,
        eventKey: zt
      };
      return browser$1.env.NODE_ENV !== "production" && Ht && (Wt.warnKey = !0), /* @__PURE__ */ React.cloneElement(Pt, Wt);
    }
    return Pt;
  });
}
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
}, placements = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: autoAdjustOverflow
  },
  topRight: {
    points: ["br", "tr"],
    overflow: autoAdjustOverflow
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: autoAdjustOverflow
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: autoAdjustOverflow
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: autoAdjustOverflow
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: autoAdjustOverflow
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: autoAdjustOverflow
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: autoAdjustOverflow
  }
}, placementsRtl = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: autoAdjustOverflow
  },
  topRight: {
    points: ["br", "tr"],
    overflow: autoAdjustOverflow
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: autoAdjustOverflow
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: autoAdjustOverflow
  },
  rightTop: {
    points: ["tr", "tl"],
    overflow: autoAdjustOverflow
  },
  rightBottom: {
    points: ["br", "bl"],
    overflow: autoAdjustOverflow
  },
  leftTop: {
    points: ["tl", "tr"],
    overflow: autoAdjustOverflow
  },
  leftBottom: {
    points: ["bl", "br"],
    overflow: autoAdjustOverflow
  }
};
function getMotion(_t, Et, Pt) {
  if (Et)
    return Et;
  if (Pt)
    return Pt[_t] || Pt.other;
}
var popupPlacementMap = {
  horizontal: "bottomLeft",
  vertical: "rightTop",
  "vertical-left": "rightTop",
  "vertical-right": "leftTop"
};
function PopupTrigger(_t) {
  var Et = _t.prefixCls, Pt = _t.visible, $t = _t.children, Mt = _t.popup, Bt = _t.popupStyle, Vt = _t.popupClassName, zt = _t.popupOffset, Ht = _t.disabled, Wt = _t.mode, Gt = _t.onVisibleChange, qt = React.useContext(MenuContext), Kt = qt.getPopupContainer, Qt = qt.rtl, Xt = qt.subMenuOpenDelay, Zt = qt.subMenuCloseDelay, Yt = qt.builtinPlacements, Jt = qt.triggerSubMenuAction, er = qt.forceSubMenuRender, tr = qt.rootClassName, nr = qt.motion, rr = qt.defaultMotions, ir = React.useState(!1), ar = _slicedToArray(ir, 2), or = ar[0], sr = ar[1], lr = _objectSpread2(Qt ? _objectSpread2({}, placementsRtl) : _objectSpread2({}, placements), Yt), cr = popupPlacementMap[Wt], hr = getMotion(Wt, nr, rr), pr = React.useRef(hr);
  Wt !== "inline" && (pr.current = hr);
  var mr = _objectSpread2(_objectSpread2({}, pr.current), {}, {
    leavedClassName: "".concat(Et, "-hidden"),
    removeOnLeave: !1,
    motionAppear: !0
  }), Er = React.useRef();
  return React.useEffect(function() {
    return Er.current = wrapperRaf(function() {
      sr(Pt);
    }), function() {
      wrapperRaf.cancel(Er.current);
    };
  }, [Pt]), /* @__PURE__ */ React.createElement(Trigger, {
    prefixCls: Et,
    popupClassName: classNames("".concat(Et, "-popup"), _defineProperty({}, "".concat(Et, "-rtl"), Qt), Vt, tr),
    stretch: Wt === "horizontal" ? "minWidth" : null,
    getPopupContainer: Kt,
    builtinPlacements: lr,
    popupPlacement: cr,
    popupVisible: or,
    popup: Mt,
    popupStyle: Bt,
    popupAlign: zt && {
      offset: zt
    },
    action: Ht ? [] : [Jt],
    mouseEnterDelay: Xt,
    mouseLeaveDelay: Zt,
    onPopupVisibleChange: Gt,
    forceRender: er,
    popupMotion: mr,
    fresh: !0
  }, $t);
}
function InlineSubMenuList(_t) {
  var Et = _t.id, Pt = _t.open, $t = _t.keyPath, Mt = _t.children, Bt = "inline", Vt = React.useContext(MenuContext), zt = Vt.prefixCls, Ht = Vt.forceSubMenuRender, Wt = Vt.motion, Gt = Vt.defaultMotions, qt = Vt.mode, Kt = React.useRef(!1);
  Kt.current = qt === Bt;
  var Qt = React.useState(!Kt.current), Xt = _slicedToArray(Qt, 2), Zt = Xt[0], Yt = Xt[1], Jt = Kt.current ? Pt : !1;
  React.useEffect(function() {
    Kt.current && Yt(!1);
  }, [qt]);
  var er = _objectSpread2({}, getMotion(Bt, Wt, Gt));
  $t.length > 1 && (er.motionAppear = !1);
  var tr = er.onVisibleChanged;
  return er.onVisibleChanged = function(nr) {
    return !Kt.current && !nr && Yt(!0), tr == null ? void 0 : tr(nr);
  }, Zt ? null : /* @__PURE__ */ React.createElement(InheritableContextProvider, {
    mode: Bt,
    locked: !Kt.current
  }, /* @__PURE__ */ React.createElement(CSSMotion, _extends$2({
    visible: Jt
  }, er, {
    forceRender: Ht,
    removeOnLeave: !1,
    leavedClassName: "".concat(zt, "-hidden")
  }), function(nr) {
    var rr = nr.className, ir = nr.style;
    return /* @__PURE__ */ React.createElement(SubMenuList, {
      id: Et,
      className: rr,
      style: ir
    }, Mt);
  }));
}
var _excluded$6 = ["style", "className", "title", "eventKey", "warnKey", "disabled", "internalPopupClose", "children", "itemIcon", "expandIcon", "popupClassName", "popupOffset", "popupStyle", "onClick", "onMouseEnter", "onMouseLeave", "onTitleClick", "onTitleMouseEnter", "onTitleMouseLeave"], _excluded2$1 = ["active"], InternalSubMenu = /* @__PURE__ */ React.forwardRef(function(_t, Et) {
  var Pt = _t.style, $t = _t.className, Mt = _t.title, Bt = _t.eventKey, Vt = _t.warnKey, zt = _t.disabled, Ht = _t.internalPopupClose, Wt = _t.children, Gt = _t.itemIcon, qt = _t.expandIcon, Kt = _t.popupClassName, Qt = _t.popupOffset, Xt = _t.popupStyle, Zt = _t.onClick, Yt = _t.onMouseEnter, Jt = _t.onMouseLeave, er = _t.onTitleClick, tr = _t.onTitleMouseEnter, nr = _t.onTitleMouseLeave, rr = _objectWithoutProperties$2(_t, _excluded$6), ir = useMenuId(Bt), ar = React.useContext(MenuContext), or = ar.prefixCls, sr = ar.mode, lr = ar.openKeys, cr = ar.disabled, hr = ar.overflowDisabled, pr = ar.activeKey, mr = ar.selectedKeys, Er = ar.itemIcon, _r = ar.expandIcon, yr = ar.onItemClick, ur = ar.onOpenChange, vr = ar.onActive, dr = React.useContext(PrivateContext), br = dr._internalRenderSubMenuItem, Cr = React.useContext(PathUserContext), Pr = Cr.isSubPathKey, xr = useFullPath(), kr = "".concat(or, "-submenu"), Ir = cr || zt, Ar = React.useRef(), Mr = React.useRef();
  browser$1.env.NODE_ENV !== "production" && Vt && warningOnce(!1, "SubMenu should not leave undefined `key`.");
  var Fr = Gt ?? Er, Dr = qt ?? _r, zr = lr.includes(Bt), Tr = !hr && zr, Gr = Pr(mr, Bt), $r = useActive(Bt, Ir, tr, nr), Rr = $r.active, Or = _objectWithoutProperties$2($r, _excluded2$1), Lr = React.useState(!1), Hr = _slicedToArray(Lr, 2), Wr = Hr[0], Kr = Hr[1], Ur = function(Br) {
    Ir || Kr(Br);
  }, Zr = function(Br) {
    Ur(!0), Yt == null || Yt({
      key: Bt,
      domEvent: Br
    });
  }, Xr = function(Br) {
    Ur(!1), Jt == null || Jt({
      key: Bt,
      domEvent: Br
    });
  }, mn = React.useMemo(function() {
    return Rr || (sr !== "inline" ? Wr || Pr([pr], Bt) : !1);
  }, [sr, Rr, pr, Wr, Bt, Pr]), an = useDirectionStyle(xr.length), nn = function(Br) {
    Ir || (er == null || er({
      key: Bt,
      domEvent: Br
    }), sr === "inline" && ur(Bt, !zr));
  }, $n = useMemoCallback(function(jr) {
    Zt == null || Zt(warnItemProp(jr)), yr(jr);
  }), En = function(Br) {
    sr !== "inline" && ur(Bt, Br);
  }, xn = function() {
    vr(Bt);
  }, qr = ir && "".concat(ir, "-popup"), tn = /* @__PURE__ */ React.createElement("div", _extends$2({
    role: "menuitem",
    style: an,
    className: "".concat(kr, "-title"),
    tabIndex: Ir ? null : -1,
    ref: Ar,
    title: typeof Mt == "string" ? Mt : null,
    "data-menu-id": hr && ir ? null : ir,
    "aria-expanded": Tr,
    "aria-haspopup": !0,
    "aria-controls": qr,
    "aria-disabled": Ir,
    onClick: nn,
    onFocus: xn
  }, Or), Mt, /* @__PURE__ */ React.createElement(Icon, {
    icon: sr !== "horizontal" ? Dr : void 0,
    props: _objectSpread2(_objectSpread2({}, _t), {}, {
      isOpen: Tr,
      // [Legacy] Not sure why need this mark
      isSubMenu: !0
    })
  }, /* @__PURE__ */ React.createElement("i", {
    className: "".concat(kr, "-arrow")
  }))), gr = React.useRef(sr);
  if (sr !== "inline" && xr.length > 1 ? gr.current = "vertical" : gr.current = sr, !hr) {
    var Sr = gr.current;
    tn = /* @__PURE__ */ React.createElement(PopupTrigger, {
      mode: Sr,
      prefixCls: kr,
      visible: !Ht && Tr && sr !== "inline",
      popupClassName: Kt,
      popupOffset: Qt,
      popupStyle: Xt,
      popup: /* @__PURE__ */ React.createElement(
        InheritableContextProvider,
        {
          mode: Sr === "horizontal" ? "vertical" : Sr
        },
        /* @__PURE__ */ React.createElement(SubMenuList, {
          id: qr,
          ref: Mr
        }, Wt)
      ),
      disabled: Ir,
      onVisibleChange: En
    }, tn);
  }
  var Nr = /* @__PURE__ */ React.createElement(ForwardOverflow.Item, _extends$2({
    ref: Et,
    role: "none"
  }, rr, {
    component: "li",
    style: Pt,
    className: classNames(kr, "".concat(kr, "-").concat(sr), $t, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(kr, "-open"), Tr), "".concat(kr, "-active"), mn), "".concat(kr, "-selected"), Gr), "".concat(kr, "-disabled"), Ir)),
    onMouseEnter: Zr,
    onMouseLeave: Xr
  }), tn, !hr && /* @__PURE__ */ React.createElement(InlineSubMenuList, {
    id: qr,
    open: Tr,
    keyPath: xr
  }, Wt));
  return br && (Nr = br(Nr, _t, {
    selected: Gr,
    active: mn,
    open: Tr,
    disabled: Ir
  })), /* @__PURE__ */ React.createElement(InheritableContextProvider, {
    onItemClick: $n,
    mode: sr === "horizontal" ? "vertical" : sr,
    itemIcon: Fr,
    expandIcon: Dr
  }, Nr);
}), SubMenu = /* @__PURE__ */ React.forwardRef(function(_t, Et) {
  var Pt = _t.eventKey, $t = _t.children, Mt = useFullPath(Pt), Bt = parseChildren($t, Mt), Vt = useMeasure();
  React.useEffect(function() {
    if (Vt)
      return Vt.registerPath(Pt, Mt), function() {
        Vt.unregisterPath(Pt, Mt);
      };
  }, [Mt]);
  var zt;
  return Vt ? zt = Bt : zt = /* @__PURE__ */ React.createElement(InternalSubMenu, _extends$2({
    ref: Et
  }, _t), Bt), /* @__PURE__ */ React.createElement(PathTrackerContext.Provider, {
    value: Mt
  }, zt);
});
browser$1.env.NODE_ENV !== "production" && (SubMenu.displayName = "SubMenu");
function Divider(_t) {
  var Et = _t.className, Pt = _t.style, $t = React.useContext(MenuContext), Mt = $t.prefixCls, Bt = useMeasure();
  return Bt ? null : /* @__PURE__ */ React.createElement("li", {
    role: "separator",
    className: classNames("".concat(Mt, "-item-divider"), Et),
    style: Pt
  });
}
var _excluded$5 = ["className", "title", "eventKey", "children"], InternalMenuItemGroup = /* @__PURE__ */ React.forwardRef(function(_t, Et) {
  var Pt = _t.className, $t = _t.title;
  _t.eventKey;
  var Mt = _t.children, Bt = _objectWithoutProperties$2(_t, _excluded$5), Vt = React.useContext(MenuContext), zt = Vt.prefixCls, Ht = "".concat(zt, "-item-group");
  return /* @__PURE__ */ React.createElement("li", _extends$2({
    ref: Et,
    role: "presentation"
  }, Bt, {
    onClick: function(Gt) {
      return Gt.stopPropagation();
    },
    className: classNames(Ht, Pt)
  }), /* @__PURE__ */ React.createElement("div", {
    role: "presentation",
    className: "".concat(Ht, "-title"),
    title: typeof $t == "string" ? $t : void 0
  }, $t), /* @__PURE__ */ React.createElement("ul", {
    role: "group",
    className: "".concat(Ht, "-list")
  }, Mt));
}), MenuItemGroup = /* @__PURE__ */ React.forwardRef(function(_t, Et) {
  var Pt = _t.eventKey, $t = _t.children, Mt = useFullPath(Pt), Bt = parseChildren($t, Mt), Vt = useMeasure();
  return Vt ? Bt : /* @__PURE__ */ React.createElement(InternalMenuItemGroup, _extends$2({
    ref: Et
  }, omit(_t, ["warnKey"])), Bt);
});
browser$1.env.NODE_ENV !== "production" && (MenuItemGroup.displayName = "MenuItemGroup");
var _excluded$4 = ["label", "children", "key", "type", "extra"];
function convertItemsToNodes(_t, Et, Pt) {
  var $t = Et.item, Mt = Et.group, Bt = Et.submenu, Vt = Et.divider;
  return (_t || []).map(function(zt, Ht) {
    if (zt && _typeof(zt) === "object") {
      var Wt = zt, Gt = Wt.label, qt = Wt.children, Kt = Wt.key, Qt = Wt.type, Xt = Wt.extra, Zt = _objectWithoutProperties$2(Wt, _excluded$4), Yt = Kt ?? "tmp-".concat(Ht);
      return qt || Qt === "group" ? Qt === "group" ? /* @__PURE__ */ React.createElement(Mt, _extends$2({
        key: Yt
      }, Zt, {
        title: Gt
      }), convertItemsToNodes(qt, Et, Pt)) : /* @__PURE__ */ React.createElement(Bt, _extends$2({
        key: Yt
      }, Zt, {
        title: Gt
      }), convertItemsToNodes(qt, Et, Pt)) : Qt === "divider" ? /* @__PURE__ */ React.createElement(Vt, _extends$2({
        key: Yt
      }, Zt)) : /* @__PURE__ */ React.createElement($t, _extends$2({
        key: Yt
      }, Zt, {
        extra: Xt
      }), Gt, (!!Xt || Xt === 0) && /* @__PURE__ */ React.createElement("span", {
        className: "".concat(Pt, "-item-extra")
      }, Xt));
    }
    return null;
  }).filter(function(zt) {
    return zt;
  });
}
function parseItems(_t, Et, Pt, $t, Mt) {
  var Bt = _t, Vt = _objectSpread2({
    divider: Divider,
    item: MenuItem$1,
    group: MenuItemGroup,
    submenu: SubMenu
  }, $t);
  return Et && (Bt = convertItemsToNodes(Et, Vt, Mt)), parseChildren(Bt, Pt);
}
var _excluded$3 = ["prefixCls", "rootClassName", "style", "className", "tabIndex", "items", "children", "direction", "id", "mode", "inlineCollapsed", "disabled", "disabledOverflow", "subMenuOpenDelay", "subMenuCloseDelay", "forceSubMenuRender", "defaultOpenKeys", "openKeys", "activeKey", "defaultActiveFirst", "selectable", "multiple", "defaultSelectedKeys", "selectedKeys", "onSelect", "onDeselect", "inlineIndent", "motion", "defaultMotions", "triggerSubMenuAction", "builtinPlacements", "itemIcon", "expandIcon", "overflowedIndicator", "overflowedIndicatorPopupClassName", "getPopupContainer", "onClick", "onOpenChange", "onKeyDown", "openAnimation", "openTransitionName", "_internalRenderMenuItem", "_internalRenderSubMenuItem", "_internalComponents"], EMPTY_LIST = [], Menu = /* @__PURE__ */ React.forwardRef(function(_t, Et) {
  var Pt, $t = _t, Mt = $t.prefixCls, Bt = Mt === void 0 ? "rc-menu" : Mt, Vt = $t.rootClassName, zt = $t.style, Ht = $t.className, Wt = $t.tabIndex, Gt = Wt === void 0 ? 0 : Wt, qt = $t.items, Kt = $t.children, Qt = $t.direction, Xt = $t.id, Zt = $t.mode, Yt = Zt === void 0 ? "vertical" : Zt, Jt = $t.inlineCollapsed, er = $t.disabled, tr = $t.disabledOverflow, nr = $t.subMenuOpenDelay, rr = nr === void 0 ? 0.1 : nr, ir = $t.subMenuCloseDelay, ar = ir === void 0 ? 0.1 : ir, or = $t.forceSubMenuRender, sr = $t.defaultOpenKeys, lr = $t.openKeys, cr = $t.activeKey, hr = $t.defaultActiveFirst, pr = $t.selectable, mr = pr === void 0 ? !0 : pr, Er = $t.multiple, _r = Er === void 0 ? !1 : Er, yr = $t.defaultSelectedKeys, ur = $t.selectedKeys, vr = $t.onSelect, dr = $t.onDeselect, br = $t.inlineIndent, Cr = br === void 0 ? 24 : br, Pr = $t.motion, xr = $t.defaultMotions, kr = $t.triggerSubMenuAction, Ir = kr === void 0 ? "hover" : kr, Ar = $t.builtinPlacements, Mr = $t.itemIcon, Fr = $t.expandIcon, Dr = $t.overflowedIndicator, zr = Dr === void 0 ? "..." : Dr, Tr = $t.overflowedIndicatorPopupClassName, Gr = $t.getPopupContainer, $r = $t.onClick, Rr = $t.onOpenChange, Or = $t.onKeyDown, Lr = $t.openAnimation, Hr = $t.openTransitionName, Wr = $t._internalRenderMenuItem, Kr = $t._internalRenderSubMenuItem, Ur = $t._internalComponents, Zr = _objectWithoutProperties$2($t, _excluded$3), Xr = React.useMemo(function() {
    return [parseItems(Kt, qt, EMPTY_LIST, Ur, Bt), parseItems(Kt, qt, EMPTY_LIST, {}, Bt)];
  }, [Kt, qt, Ur]), mn = _slicedToArray(Xr, 2), an = mn[0], nn = mn[1], $n = React.useState(!1), En = _slicedToArray($n, 2), xn = En[0], qr = En[1], tn = React.useRef(), gr = useUUID(Xt), Sr = Qt === "rtl";
  browser$1.env.NODE_ENV !== "production" && warningOnce(!Lr && !Hr, "`openAnimation` and `openTransitionName` is removed. Please use `motion` or `defaultMotion` instead.");
  var Nr = useMergedState(sr, {
    value: lr,
    postState: function(Vn) {
      return Vn || EMPTY_LIST;
    }
  }), jr = _slicedToArray(Nr, 2), Br = jr[0], Qr = jr[1], Jr = function(Vn) {
    var Un = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    function ta() {
      Qr(Vn), Rr == null || Rr(Vn);
    }
    Un ? flushSync(ta) : ta();
  }, gn = React.useState(Br), yn = _slicedToArray(gn, 2), _n = yn[0], In = yn[1], Tn = React.useRef(!1), kn = React.useMemo(function() {
    return (Yt === "inline" || Yt === "vertical") && Jt ? ["vertical", Jt] : [Yt, !1];
  }, [Yt, Jt]), jn = _slicedToArray(kn, 2), An = jn[0], un = jn[1], rn = An === "inline", dn = React.useState(An), Mn = _slicedToArray(dn, 2), On = Mn[0], Dn = Mn[1], Yn = React.useState(un), ra = _slicedToArray(Yn, 2), Fn = ra[0], Nn = ra[1];
  React.useEffect(function() {
    Dn(An), Nn(un), Tn.current && (rn ? Qr(_n) : Jr(EMPTY_LIST));
  }, [An, un]);
  var Hn = React.useState(0), wr = _slicedToArray(Hn, 2), Vr = wr[0], Yr = wr[1], cn = Vr >= an.length - 1 || On !== "horizontal" || tr;
  React.useEffect(function() {
    rn && In(Br);
  }, [Br]), React.useEffect(function() {
    return Tn.current = !0, function() {
      Tn.current = !1;
    };
  }, []);
  var hn = useKeyRecords(), wn = hn.registerPath, pn = hn.unregisterPath, fn = hn.refreshOverflowKeys, Bn = hn.isSubPathKey, Rn = hn.getKeyPath, Sn = hn.getKeys, Kn = hn.getSubPathKeys, Pn = React.useMemo(function() {
    return {
      registerPath: wn,
      unregisterPath: pn
    };
  }, [wn, pn]), sn = React.useMemo(function() {
    return {
      isSubPathKey: Bn
    };
  }, [Bn]);
  React.useEffect(function() {
    fn(cn ? EMPTY_LIST : an.slice(Vr + 1).map(function(zn) {
      return zn.key;
    }));
  }, [Vr, cn]);
  var bn = useMergedState(cr || hr && ((Pt = an[0]) === null || Pt === void 0 ? void 0 : Pt.key), {
    value: cr
  }), Ln = _slicedToArray(bn, 2), Wn = Ln[0], qn = Ln[1], na = useMemoCallback(function(zn) {
    qn(zn);
  }), Xn = useMemoCallback(function() {
    qn(void 0);
  });
  useImperativeHandle(Et, function() {
    return {
      list: tn.current,
      focus: function(Vn) {
        var Un, ta = Sn(), ea = refreshElements(ta, gr), ga = ea.elements, ba = ea.key2element, Ea = ea.element2key, xa = getFocusableElements(tn.current, ga), Sa = Wn ?? (xa[0] ? Ea.get(xa[0]) : (Un = an.find(function(Ta) {
          return !Ta.props.disabled;
        })) === null || Un === void 0 ? void 0 : Un.key), fa = ba.get(Sa);
        if (Sa && fa) {
          var oa;
          fa == null || (oa = fa.focus) === null || oa === void 0 || oa.call(fa, Vn);
        }
      }
    };
  });
  var sa = useMergedState(yr || [], {
    value: ur,
    // Legacy convert key to array
    postState: function(Vn) {
      return Array.isArray(Vn) ? Vn : Vn == null ? EMPTY_LIST : [Vn];
    }
  }), Zn = _slicedToArray(sa, 2), ua = Zn[0], pa = Zn[1], ia = function(Vn) {
    if (mr) {
      var Un = Vn.key, ta = ua.includes(Un), ea;
      _r ? ta ? ea = ua.filter(function(ba) {
        return ba !== Un;
      }) : ea = [].concat(_toConsumableArray(ua), [Un]) : ea = [Un], pa(ea);
      var ga = _objectSpread2(_objectSpread2({}, Vn), {}, {
        selectedKeys: ea
      });
      ta ? dr == null || dr(ga) : vr == null || vr(ga);
    }
    !_r && Br.length && On !== "inline" && Jr(EMPTY_LIST);
  }, aa = useMemoCallback(function(zn) {
    $r == null || $r(warnItemProp(zn)), ia(zn);
  }), ha = useMemoCallback(function(zn, Vn) {
    var Un = Br.filter(function(ea) {
      return ea !== zn;
    });
    if (Vn)
      Un.push(zn);
    else if (On !== "inline") {
      var ta = Kn(zn);
      Un = Un.filter(function(ea) {
        return !ta.has(ea);
      });
    }
    isEqual(Br, Un, !0) || Jr(Un, !0);
  }), ma = function(Vn, Un) {
    var ta = Un ?? !Br.includes(Vn);
    ha(Vn, ta);
  }, la = useAccessibility(On, Wn, Sr, gr, tn, Sn, Rn, qn, ma, Or);
  React.useEffect(function() {
    qr(!0);
  }, []);
  var wa = React.useMemo(function() {
    return {
      _internalRenderMenuItem: Wr,
      _internalRenderSubMenuItem: Kr
    };
  }, [Wr, Kr]), _a = On !== "horizontal" || tr ? an : (
    // Need wrap for overflow dropdown that do not response for open
    an.map(function(zn, Vn) {
      return (
        // Always wrap provider to avoid sub node re-mount
        /* @__PURE__ */ React.createElement(InheritableContextProvider, {
          key: zn.key,
          overflowDisabled: Vn > Vr
        }, zn)
      );
    })
  ), Ra = /* @__PURE__ */ React.createElement(ForwardOverflow, _extends$2({
    id: Xt,
    ref: tn,
    prefixCls: "".concat(Bt, "-overflow"),
    component: "ul",
    itemComponent: MenuItem$1,
    className: classNames(Bt, "".concat(Bt, "-root"), "".concat(Bt, "-").concat(On), Ht, _defineProperty(_defineProperty({}, "".concat(Bt, "-inline-collapsed"), Fn), "".concat(Bt, "-rtl"), Sr), Vt),
    dir: Qt,
    style: zt,
    role: "menu",
    tabIndex: Gt,
    data: _a,
    renderRawItem: function(Vn) {
      return Vn;
    },
    renderRawRest: function(Vn) {
      var Un = Vn.length, ta = Un ? an.slice(-Un) : null;
      return /* @__PURE__ */ React.createElement(SubMenu, {
        eventKey: OVERFLOW_KEY,
        title: zr,
        disabled: cn,
        internalPopupClose: Un === 0,
        popupClassName: Tr
      }, ta);
    },
    maxCount: On !== "horizontal" || tr ? ForwardOverflow.INVALIDATE : ForwardOverflow.RESPONSIVE,
    ssr: "full",
    "data-menu-list": !0,
    onVisibleChange: function(Vn) {
      Yr(Vn);
    },
    onKeyDown: la
  }, Zr));
  return /* @__PURE__ */ React.createElement(PrivateContext.Provider, {
    value: wa
  }, /* @__PURE__ */ React.createElement(IdContext.Provider, {
    value: gr
  }, /* @__PURE__ */ React.createElement(InheritableContextProvider, {
    prefixCls: Bt,
    rootClassName: Vt,
    mode: On,
    openKeys: Br,
    rtl: Sr,
    disabled: er,
    motion: xn ? Pr : null,
    defaultMotions: xn ? xr : null,
    activeKey: Wn,
    onActive: na,
    onInactive: Xn,
    selectedKeys: ua,
    inlineIndent: Cr,
    subMenuOpenDelay: rr,
    subMenuCloseDelay: ar,
    forceSubMenuRender: or,
    builtinPlacements: Ar,
    triggerSubMenuAction: Ir,
    getPopupContainer: Gr,
    itemIcon: Mr,
    expandIcon: Fr,
    onItemClick: aa,
    onOpenChange: ha
  }, /* @__PURE__ */ React.createElement(PathUserContext.Provider, {
    value: sn
  }, Ra), /* @__PURE__ */ React.createElement("div", {
    style: {
      display: "none"
    },
    "aria-hidden": !0
  }, /* @__PURE__ */ React.createElement(PathRegisterContext.Provider, {
    value: Pn
  }, nn)))));
}), ExportMenu = Menu;
ExportMenu.Item = MenuItem$1;
ExportMenu.SubMenu = SubMenu;
ExportMenu.ItemGroup = MenuItemGroup;
ExportMenu.Divider = Divider;
const TabContext = /* @__PURE__ */ createContext(null);
var useIndicator = function(Et) {
  var Pt = Et.activeTabOffset, $t = Et.horizontal, Mt = Et.rtl, Bt = Et.indicator, Vt = Bt === void 0 ? {} : Bt, zt = Vt.size, Ht = Vt.align, Wt = Ht === void 0 ? "center" : Ht, Gt = useState(), qt = _slicedToArray(Gt, 2), Kt = qt[0], Qt = qt[1], Xt = useRef(), Zt = React__default.useCallback(function(Jt) {
    return typeof zt == "function" ? zt(Jt) : typeof zt == "number" ? zt : Jt;
  }, [zt]);
  function Yt() {
    wrapperRaf.cancel(Xt.current);
  }
  return useEffect(function() {
    var Jt = {};
    if (Pt)
      if ($t) {
        Jt.width = Zt(Pt.width);
        var er = Mt ? "right" : "left";
        Wt === "start" && (Jt[er] = Pt[er]), Wt === "center" && (Jt[er] = Pt[er] + Pt.width / 2, Jt.transform = Mt ? "translateX(50%)" : "translateX(-50%)"), Wt === "end" && (Jt[er] = Pt[er] + Pt.width, Jt.transform = "translateX(-100%)");
      } else
        Jt.height = Zt(Pt.height), Wt === "start" && (Jt.top = Pt.top), Wt === "center" && (Jt.top = Pt.top + Pt.height / 2, Jt.transform = "translateY(-50%)"), Wt === "end" && (Jt.top = Pt.top + Pt.height, Jt.transform = "translateY(-100%)");
    return Yt(), Xt.current = wrapperRaf(function() {
      Qt(Jt);
    }), Yt;
  }, [Pt, $t, Mt, Wt, Zt]), {
    style: Kt
  };
}, DEFAULT_SIZE$1 = {
  width: 0,
  height: 0,
  left: 0,
  top: 0
};
function useOffsets(_t, Et, Pt) {
  return useMemo$1(function() {
    for (var $t, Mt = /* @__PURE__ */ new Map(), Bt = Et.get(($t = _t[0]) === null || $t === void 0 ? void 0 : $t.key) || DEFAULT_SIZE$1, Vt = Bt.left + Bt.width, zt = 0; zt < _t.length; zt += 1) {
      var Ht = _t[zt].key, Wt = Et.get(Ht);
      if (!Wt) {
        var Gt;
        Wt = Et.get((Gt = _t[zt - 1]) === null || Gt === void 0 ? void 0 : Gt.key) || DEFAULT_SIZE$1;
      }
      var qt = Mt.get(Ht) || _objectSpread2({}, Wt);
      qt.right = Vt - qt.left - qt.width, Mt.set(Ht, qt);
    }
    return Mt;
  }, [_t.map(function($t) {
    return $t.key;
  }).join("_"), Et, Pt]);
}
function useSyncState(_t, Et) {
  var Pt = React.useRef(_t), $t = React.useState({}), Mt = _slicedToArray($t, 2), Bt = Mt[1];
  function Vt(zt) {
    var Ht = typeof zt == "function" ? zt(Pt.current) : zt;
    Ht !== Pt.current && Et(Ht, Pt.current), Pt.current = Ht, Bt({});
  }
  return [Pt.current, Vt];
}
var MIN_SWIPE_DISTANCE = 0.1, STOP_SWIPE_DISTANCE = 0.01, REFRESH_INTERVAL = 20, SPEED_OFF_MULTIPLE = Math.pow(0.995, REFRESH_INTERVAL);
function useTouchMove(_t, Et) {
  var Pt = useState(), $t = _slicedToArray(Pt, 2), Mt = $t[0], Bt = $t[1], Vt = useState(0), zt = _slicedToArray(Vt, 2), Ht = zt[0], Wt = zt[1], Gt = useState(0), qt = _slicedToArray(Gt, 2), Kt = qt[0], Qt = qt[1], Xt = useState(), Zt = _slicedToArray(Xt, 2), Yt = Zt[0], Jt = Zt[1], er = useRef();
  function tr(sr) {
    var lr = sr.touches[0], cr = lr.screenX, hr = lr.screenY;
    Bt({
      x: cr,
      y: hr
    }), window.clearInterval(er.current);
  }
  function nr(sr) {
    if (Mt) {
      var lr = sr.touches[0], cr = lr.screenX, hr = lr.screenY;
      Bt({
        x: cr,
        y: hr
      });
      var pr = cr - Mt.x, mr = hr - Mt.y;
      Et(pr, mr);
      var Er = Date.now();
      Wt(Er), Qt(Er - Ht), Jt({
        x: pr,
        y: mr
      });
    }
  }
  function rr() {
    if (Mt && (Bt(null), Jt(null), Yt)) {
      var sr = Yt.x / Kt, lr = Yt.y / Kt, cr = Math.abs(sr), hr = Math.abs(lr);
      if (Math.max(cr, hr) < MIN_SWIPE_DISTANCE)
        return;
      var pr = sr, mr = lr;
      er.current = window.setInterval(function() {
        if (Math.abs(pr) < STOP_SWIPE_DISTANCE && Math.abs(mr) < STOP_SWIPE_DISTANCE) {
          window.clearInterval(er.current);
          return;
        }
        pr *= SPEED_OFF_MULTIPLE, mr *= SPEED_OFF_MULTIPLE, Et(pr * REFRESH_INTERVAL, mr * REFRESH_INTERVAL);
      }, REFRESH_INTERVAL);
    }
  }
  var ir = useRef();
  function ar(sr) {
    var lr = sr.deltaX, cr = sr.deltaY, hr = 0, pr = Math.abs(lr), mr = Math.abs(cr);
    pr === mr ? hr = ir.current === "x" ? lr : cr : pr > mr ? (hr = lr, ir.current = "x") : (hr = cr, ir.current = "y"), Et(-hr, -hr) && sr.preventDefault();
  }
  var or = useRef(null);
  or.current = {
    onTouchStart: tr,
    onTouchMove: nr,
    onTouchEnd: rr,
    onWheel: ar
  }, React.useEffect(function() {
    function sr(pr) {
      or.current.onTouchStart(pr);
    }
    function lr(pr) {
      or.current.onTouchMove(pr);
    }
    function cr(pr) {
      or.current.onTouchEnd(pr);
    }
    function hr(pr) {
      or.current.onWheel(pr);
    }
    return document.addEventListener("touchmove", lr, {
      passive: !1
    }), document.addEventListener("touchend", cr, {
      passive: !0
    }), _t.current.addEventListener("touchstart", sr, {
      passive: !0
    }), _t.current.addEventListener("wheel", hr, {
      passive: !1
    }), function() {
      document.removeEventListener("touchmove", lr), document.removeEventListener("touchend", cr);
    };
  }, []);
}
function useUpdate(_t) {
  var Et = useState(0), Pt = _slicedToArray(Et, 2), $t = Pt[0], Mt = Pt[1], Bt = useRef(0), Vt = useRef();
  return Vt.current = _t, useLayoutUpdateEffect(function() {
    var zt;
    (zt = Vt.current) === null || zt === void 0 || zt.call(Vt);
  }, [$t]), function() {
    Bt.current === $t && (Bt.current += 1, Mt(Bt.current));
  };
}
function useUpdateState(_t) {
  var Et = useRef([]), Pt = useState({}), $t = _slicedToArray(Pt, 2), Mt = $t[1], Bt = useRef(typeof _t == "function" ? _t() : _t), Vt = useUpdate(function() {
    var Ht = Bt.current;
    Et.current.forEach(function(Wt) {
      Ht = Wt(Ht);
    }), Et.current = [], Bt.current = Ht, Mt({});
  });
  function zt(Ht) {
    Et.current.push(Ht), Vt();
  }
  return [Bt.current, zt];
}
var DEFAULT_SIZE = {
  width: 0,
  height: 0,
  left: 0,
  top: 0,
  right: 0
};
function useVisibleRange(_t, Et, Pt, $t, Mt, Bt, Vt) {
  var zt = Vt.tabs, Ht = Vt.tabPosition, Wt = Vt.rtl, Gt, qt, Kt;
  return ["top", "bottom"].includes(Ht) ? (Gt = "width", qt = Wt ? "right" : "left", Kt = Math.abs(Pt)) : (Gt = "height", qt = "top", Kt = -Pt), useMemo$1(function() {
    if (!zt.length)
      return [0, 0];
    for (var Qt = zt.length, Xt = Qt, Zt = 0; Zt < Qt; Zt += 1) {
      var Yt = _t.get(zt[Zt].key) || DEFAULT_SIZE;
      if (Math.floor(Yt[qt] + Yt[Gt]) > Math.floor(Kt + Et)) {
        Xt = Zt - 1;
        break;
      }
    }
    for (var Jt = 0, er = Qt - 1; er >= 0; er -= 1) {
      var tr = _t.get(zt[er].key) || DEFAULT_SIZE;
      if (tr[qt] < Kt) {
        Jt = er + 1;
        break;
      }
    }
    return Jt >= Xt ? [0, 0] : [Jt, Xt];
  }, [_t, Et, $t, Mt, Bt, Kt, Ht, zt.map(function(Qt) {
    return Qt.key;
  }).join("_"), Wt]);
}
function stringify(_t) {
  var Et;
  return _t instanceof Map ? (Et = {}, _t.forEach(function(Pt, $t) {
    Et[$t] = Pt;
  })) : Et = _t, JSON.stringify(Et);
}
var RC_TABS_DOUBLE_QUOTE = "TABS_DQ";
function genDataNodeKey(_t) {
  return String(_t).replace(/"/g, RC_TABS_DOUBLE_QUOTE);
}
function getRemovable(_t, Et, Pt, $t) {
  return (
    // Only editable tabs can be removed
    !(!Pt || // Tabs cannot be removed when disabled
    $t || // closable is false
    _t === !1 || // If closable is undefined, the remove button should be hidden when closeIcon is null or false
    _t === void 0 && (Et === !1 || Et === null))
  );
}
var AddButton = /* @__PURE__ */ React.forwardRef(function(_t, Et) {
  var Pt = _t.prefixCls, $t = _t.editable, Mt = _t.locale, Bt = _t.style;
  return !$t || $t.showAdd === !1 ? null : /* @__PURE__ */ React.createElement("button", {
    ref: Et,
    type: "button",
    className: "".concat(Pt, "-nav-add"),
    style: Bt,
    "aria-label": (Mt == null ? void 0 : Mt.addAriaLabel) || "Add tab",
    onClick: function(zt) {
      $t.onEdit("add", {
        event: zt
      });
    }
  }, $t.addIcon || "+");
}), ExtraContent = /* @__PURE__ */ React.forwardRef(function(_t, Et) {
  var Pt = _t.position, $t = _t.prefixCls, Mt = _t.extra;
  if (!Mt)
    return null;
  var Bt, Vt = {};
  return _typeof(Mt) === "object" && !/* @__PURE__ */ React.isValidElement(Mt) ? Vt = Mt : Vt.right = Mt, Pt === "right" && (Bt = Vt.right), Pt === "left" && (Bt = Vt.left), Bt ? /* @__PURE__ */ React.createElement("div", {
    className: "".concat($t, "-extra-content"),
    ref: Et
  }, Bt) : null;
});
browser$1.env.NODE_ENV !== "production" && (ExtraContent.displayName = "ExtraContent");
var OperationNode = /* @__PURE__ */ React.forwardRef(function(_t, Et) {
  var Pt = _t.prefixCls, $t = _t.id, Mt = _t.tabs, Bt = _t.locale, Vt = _t.mobile, zt = _t.more, Ht = zt === void 0 ? {} : zt, Wt = _t.style, Gt = _t.className, qt = _t.editable, Kt = _t.tabBarGutter, Qt = _t.rtl, Xt = _t.removeAriaLabel, Zt = _t.onTabClick, Yt = _t.getPopupContainer, Jt = _t.popupClassName, er = useState(!1), tr = _slicedToArray(er, 2), nr = tr[0], rr = tr[1], ir = useState(null), ar = _slicedToArray(ir, 2), or = ar[0], sr = ar[1], lr = Ht.icon, cr = lr === void 0 ? "More" : lr, hr = "".concat($t, "-more-popup"), pr = "".concat(Pt, "-dropdown"), mr = or !== null ? "".concat(hr, "-").concat(or) : null, Er = Bt == null ? void 0 : Bt.dropdownAriaLabel;
  function _r(Pr, xr) {
    Pr.preventDefault(), Pr.stopPropagation(), qt.onEdit("remove", {
      key: xr,
      event: Pr
    });
  }
  var yr = /* @__PURE__ */ React.createElement(ExportMenu, {
    onClick: function(xr) {
      var kr = xr.key, Ir = xr.domEvent;
      Zt(kr, Ir), rr(!1);
    },
    prefixCls: "".concat(pr, "-menu"),
    id: hr,
    tabIndex: -1,
    role: "listbox",
    "aria-activedescendant": mr,
    selectedKeys: [or],
    "aria-label": Er !== void 0 ? Er : "expanded dropdown"
  }, Mt.map(function(Pr) {
    var xr = Pr.closable, kr = Pr.disabled, Ir = Pr.closeIcon, Ar = Pr.key, Mr = Pr.label, Fr = getRemovable(xr, Ir, qt, kr);
    return /* @__PURE__ */ React.createElement(MenuItem$1, {
      key: Ar,
      id: "".concat(hr, "-").concat(Ar),
      role: "option",
      "aria-controls": $t && "".concat($t, "-panel-").concat(Ar),
      disabled: kr
    }, /* @__PURE__ */ React.createElement("span", null, Mr), Fr && /* @__PURE__ */ React.createElement("button", {
      type: "button",
      "aria-label": Xt || "remove",
      tabIndex: 0,
      className: "".concat(pr, "-menu-item-remove"),
      onClick: function(zr) {
        zr.stopPropagation(), _r(zr, Ar);
      }
    }, Ir || qt.removeIcon || "×"));
  }));
  function ur(Pr) {
    for (var xr = Mt.filter(function(Fr) {
      return !Fr.disabled;
    }), kr = xr.findIndex(function(Fr) {
      return Fr.key === or;
    }) || 0, Ir = xr.length, Ar = 0; Ar < Ir; Ar += 1) {
      kr = (kr + Pr + Ir) % Ir;
      var Mr = xr[kr];
      if (!Mr.disabled) {
        sr(Mr.key);
        return;
      }
    }
  }
  function vr(Pr) {
    var xr = Pr.which;
    if (!nr) {
      [KeyCode.DOWN, KeyCode.SPACE, KeyCode.ENTER].includes(xr) && (rr(!0), Pr.preventDefault());
      return;
    }
    switch (xr) {
      case KeyCode.UP:
        ur(-1), Pr.preventDefault();
        break;
      case KeyCode.DOWN:
        ur(1), Pr.preventDefault();
        break;
      case KeyCode.ESC:
        rr(!1);
        break;
      case KeyCode.SPACE:
      case KeyCode.ENTER:
        or !== null && Zt(or, Pr);
        break;
    }
  }
  useEffect(function() {
    var Pr = document.getElementById(mr);
    Pr && Pr.scrollIntoView && Pr.scrollIntoView(!1);
  }, [or]), useEffect(function() {
    nr || sr(null);
  }, [nr]);
  var dr = _defineProperty({}, Qt ? "marginRight" : "marginLeft", Kt);
  Mt.length || (dr.visibility = "hidden", dr.order = 1);
  var br = classNames(_defineProperty({}, "".concat(pr, "-rtl"), Qt)), Cr = Vt ? null : /* @__PURE__ */ React.createElement(Dropdown$1, _extends$2({
    prefixCls: pr,
    overlay: yr,
    visible: Mt.length ? nr : !1,
    onVisibleChange: rr,
    overlayClassName: classNames(br, Jt),
    mouseEnterDelay: 0.1,
    mouseLeaveDelay: 0.1,
    getPopupContainer: Yt
  }, Ht), /* @__PURE__ */ React.createElement("button", {
    type: "button",
    className: "".concat(Pt, "-nav-more"),
    style: dr,
    tabIndex: -1,
    "aria-hidden": "true",
    "aria-haspopup": "listbox",
    "aria-controls": hr,
    id: "".concat($t, "-more"),
    "aria-expanded": nr,
    onKeyDown: vr
  }, cr));
  return /* @__PURE__ */ React.createElement("div", {
    className: classNames("".concat(Pt, "-nav-operations"), Gt),
    style: Wt,
    ref: Et
  }, Cr, /* @__PURE__ */ React.createElement(AddButton, {
    prefixCls: Pt,
    locale: Bt,
    editable: qt
  }));
});
const OperationNode$1 = /* @__PURE__ */ React.memo(OperationNode, function(_t, Et) {
  return (
    // https://github.com/ant-design/ant-design/issues/32544
    // We'd better remove syntactic sugar in `rc-menu` since this has perf issue
    Et.tabMoving
  );
});
var TabNode = function(Et) {
  var Pt = Et.prefixCls, $t = Et.id, Mt = Et.active, Bt = Et.focus, Vt = Et.tab, zt = Vt.key, Ht = Vt.label, Wt = Vt.disabled, Gt = Vt.closeIcon, qt = Vt.icon, Kt = Et.closable, Qt = Et.renderWrapper, Xt = Et.removeAriaLabel, Zt = Et.editable, Yt = Et.onClick, Jt = Et.onFocus, er = Et.onBlur, tr = Et.onKeyDown, nr = Et.onMouseDown, rr = Et.onMouseUp, ir = Et.style, ar = Et.tabCount, or = Et.currentPosition, sr = "".concat(Pt, "-tab"), lr = getRemovable(Kt, Gt, Zt, Wt);
  function cr(_r) {
    Wt || Yt(_r);
  }
  function hr(_r) {
    _r.preventDefault(), _r.stopPropagation(), Zt.onEdit("remove", {
      key: zt,
      event: _r
    });
  }
  var pr = React.useMemo(function() {
    return qt && typeof Ht == "string" ? /* @__PURE__ */ React.createElement("span", null, Ht) : Ht;
  }, [Ht, qt]), mr = React.useRef(null);
  React.useEffect(function() {
    Bt && mr.current && mr.current.focus();
  }, [Bt]);
  var Er = /* @__PURE__ */ React.createElement("div", {
    key: zt,
    "data-node-key": genDataNodeKey(zt),
    className: classNames(sr, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(sr, "-with-remove"), lr), "".concat(sr, "-active"), Mt), "".concat(sr, "-disabled"), Wt), "".concat(sr, "-focus"), Bt)),
    style: ir,
    onClick: cr
  }, /* @__PURE__ */ React.createElement("div", {
    ref: mr,
    role: "tab",
    "aria-selected": Mt,
    id: $t && "".concat($t, "-tab-").concat(zt),
    className: "".concat(sr, "-btn"),
    "aria-controls": $t && "".concat($t, "-panel-").concat(zt),
    "aria-disabled": Wt,
    tabIndex: Wt ? null : Mt ? 0 : -1,
    onClick: function(yr) {
      yr.stopPropagation(), cr(yr);
    },
    onKeyDown: tr,
    onMouseDown: nr,
    onMouseUp: rr,
    onFocus: Jt,
    onBlur: er
  }, Bt && /* @__PURE__ */ React.createElement("div", {
    "aria-live": "polite",
    style: {
      width: 0,
      height: 0,
      position: "absolute",
      overflow: "hidden",
      opacity: 0
    }
  }, "Tab ".concat(or, " of ").concat(ar)), qt && /* @__PURE__ */ React.createElement("span", {
    className: "".concat(sr, "-icon")
  }, qt), Ht && pr), lr && /* @__PURE__ */ React.createElement("button", {
    type: "button",
    "aria-label": Xt || "remove",
    tabIndex: Mt ? 0 : -1,
    className: "".concat(sr, "-remove"),
    onClick: function(yr) {
      yr.stopPropagation(), hr(yr);
    }
  }, Gt || Zt.removeIcon || "×"));
  return Qt ? Qt(Er) : Er;
}, getTabSize = function(Et, Pt) {
  var $t = Et.offsetWidth, Mt = Et.offsetHeight, Bt = Et.offsetTop, Vt = Et.offsetLeft, zt = Et.getBoundingClientRect(), Ht = zt.width, Wt = zt.height, Gt = zt.left, qt = zt.top;
  return Math.abs(Ht - $t) < 1 ? [Ht, Wt, Gt - Pt.left, qt - Pt.top] : [$t, Mt, Vt, Bt];
}, getSize = function(Et) {
  var Pt = Et.current || {}, $t = Pt.offsetWidth, Mt = $t === void 0 ? 0 : $t, Bt = Pt.offsetHeight, Vt = Bt === void 0 ? 0 : Bt;
  if (Et.current) {
    var zt = Et.current.getBoundingClientRect(), Ht = zt.width, Wt = zt.height;
    if (Math.abs(Ht - Mt) < 1)
      return [Ht, Wt];
  }
  return [Mt, Vt];
}, getUnitValue = function(Et, Pt) {
  return Et[Pt ? 0 : 1];
}, TabNavList = /* @__PURE__ */ React.forwardRef(function(_t, Et) {
  var Pt = _t.className, $t = _t.style, Mt = _t.id, Bt = _t.animated, Vt = _t.activeKey, zt = _t.rtl, Ht = _t.extra, Wt = _t.editable, Gt = _t.locale, qt = _t.tabPosition, Kt = _t.tabBarGutter, Qt = _t.children, Xt = _t.onTabClick, Zt = _t.onTabScroll, Yt = _t.indicator, Jt = React.useContext(TabContext), er = Jt.prefixCls, tr = Jt.tabs, nr = useRef(null), rr = useRef(null), ir = useRef(null), ar = useRef(null), or = useRef(null), sr = useRef(null), lr = useRef(null), cr = qt === "top" || qt === "bottom", hr = useSyncState(0, function(Pn, sn) {
    cr && Zt && Zt({
      direction: Pn > sn ? "left" : "right"
    });
  }), pr = _slicedToArray(hr, 2), mr = pr[0], Er = pr[1], _r = useSyncState(0, function(Pn, sn) {
    !cr && Zt && Zt({
      direction: Pn > sn ? "top" : "bottom"
    });
  }), yr = _slicedToArray(_r, 2), ur = yr[0], vr = yr[1], dr = useState([0, 0]), br = _slicedToArray(dr, 2), Cr = br[0], Pr = br[1], xr = useState([0, 0]), kr = _slicedToArray(xr, 2), Ir = kr[0], Ar = kr[1], Mr = useState([0, 0]), Fr = _slicedToArray(Mr, 2), Dr = Fr[0], zr = Fr[1], Tr = useState([0, 0]), Gr = _slicedToArray(Tr, 2), $r = Gr[0], Rr = Gr[1], Or = useUpdateState(/* @__PURE__ */ new Map()), Lr = _slicedToArray(Or, 2), Hr = Lr[0], Wr = Lr[1], Kr = useOffsets(tr, Hr, Ir[0]), Ur = getUnitValue(Cr, cr), Zr = getUnitValue(Ir, cr), Xr = getUnitValue(Dr, cr), mn = getUnitValue($r, cr), an = Math.floor(Ur) < Math.floor(Zr + Xr), nn = an ? Ur - mn : Ur - Xr, $n = "".concat(er, "-nav-operations-hidden"), En = 0, xn = 0;
  cr && zt ? (En = 0, xn = Math.max(0, Zr - nn)) : (En = Math.min(0, nn - Zr), xn = 0);
  function qr(Pn) {
    return Pn < En ? En : Pn > xn ? xn : Pn;
  }
  var tn = useRef(null), gr = useState(), Sr = _slicedToArray(gr, 2), Nr = Sr[0], jr = Sr[1];
  function Br() {
    jr(Date.now());
  }
  function Qr() {
    tn.current && clearTimeout(tn.current);
  }
  useTouchMove(ar, function(Pn, sn) {
    function bn(Ln, Wn) {
      Ln(function(qn) {
        var na = qr(qn + Wn);
        return na;
      });
    }
    return an ? (cr ? bn(Er, Pn) : bn(vr, sn), Qr(), Br(), !0) : !1;
  }), useEffect(function() {
    return Qr(), Nr && (tn.current = setTimeout(function() {
      jr(0);
    }, 100)), Qr;
  }, [Nr]);
  var Jr = useVisibleRange(
    Kr,
    // Container
    nn,
    // Transform
    cr ? mr : ur,
    // Tabs
    Zr,
    // Add
    Xr,
    // Operation
    mn,
    _objectSpread2(_objectSpread2({}, _t), {}, {
      tabs: tr
    })
  ), gn = _slicedToArray(Jr, 2), yn = gn[0], _n = gn[1], In = useEvent(function() {
    var Pn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Vt, sn = Kr.get(Pn) || {
      width: 0,
      height: 0,
      left: 0,
      right: 0,
      top: 0
    };
    if (cr) {
      var bn = mr;
      zt ? sn.right < mr ? bn = sn.right : sn.right + sn.width > mr + nn && (bn = sn.right + sn.width - nn) : sn.left < -mr ? bn = -sn.left : sn.left + sn.width > -mr + nn && (bn = -(sn.left + sn.width - nn)), vr(0), Er(qr(bn));
    } else {
      var Ln = ur;
      sn.top < -ur ? Ln = -sn.top : sn.top + sn.height > -ur + nn && (Ln = -(sn.top + sn.height - nn)), Er(0), vr(qr(Ln));
    }
  }), Tn = useState(), kn = _slicedToArray(Tn, 2), jn = kn[0], An = kn[1], un = useState(!1), rn = _slicedToArray(un, 2), dn = rn[0], Mn = rn[1], On = tr.filter(function(Pn) {
    return !Pn.disabled;
  }).map(function(Pn) {
    return Pn.key;
  }), Dn = function(sn) {
    var bn = On.indexOf(jn || Vt), Ln = On.length, Wn = (bn + sn + Ln) % Ln, qn = On[Wn];
    An(qn);
  }, Yn = function(sn) {
    var bn = sn.code, Ln = zt && cr, Wn = On[0], qn = On[On.length - 1];
    switch (bn) {
      case "ArrowLeft": {
        cr && Dn(Ln ? 1 : -1);
        break;
      }
      case "ArrowRight": {
        cr && Dn(Ln ? -1 : 1);
        break;
      }
      case "ArrowUp": {
        sn.preventDefault(), cr || Dn(-1);
        break;
      }
      case "ArrowDown": {
        sn.preventDefault(), cr || Dn(1);
        break;
      }
      case "Home": {
        sn.preventDefault(), An(Wn);
        break;
      }
      case "End": {
        sn.preventDefault(), An(qn);
        break;
      }
      case "Enter":
      case "Space": {
        sn.preventDefault(), Xt(jn, sn);
        break;
      }
      case "Backspace":
      case "Delete": {
        var na = On.indexOf(jn), Xn = tr.find(function(Zn) {
          return Zn.key === jn;
        }), sa = getRemovable(Xn == null ? void 0 : Xn.closable, Xn == null ? void 0 : Xn.closeIcon, Wt, Xn == null ? void 0 : Xn.disabled);
        sa && (sn.preventDefault(), sn.stopPropagation(), Wt.onEdit("remove", {
          key: jn,
          event: sn
        }), na === On.length - 1 ? Dn(-1) : Dn(1));
        break;
      }
    }
  }, ra = {};
  cr ? ra[zt ? "marginRight" : "marginLeft"] = Kt : ra.marginTop = Kt;
  var Fn = tr.map(function(Pn, sn) {
    var bn = Pn.key;
    return /* @__PURE__ */ React.createElement(TabNode, {
      id: Mt,
      prefixCls: er,
      key: bn,
      tab: Pn,
      style: sn === 0 ? void 0 : ra,
      closable: Pn.closable,
      editable: Wt,
      active: bn === Vt,
      focus: bn === jn,
      renderWrapper: Qt,
      removeAriaLabel: Gt == null ? void 0 : Gt.removeAriaLabel,
      tabCount: On.length,
      currentPosition: sn + 1,
      onClick: function(Wn) {
        Xt(bn, Wn);
      },
      onKeyDown: Yn,
      onFocus: function() {
        dn || An(bn), In(bn), Br(), ar.current && (zt || (ar.current.scrollLeft = 0), ar.current.scrollTop = 0);
      },
      onBlur: function() {
        An(void 0);
      },
      onMouseDown: function() {
        Mn(!0);
      },
      onMouseUp: function() {
        Mn(!1);
      }
    });
  }), Nn = function() {
    return Wr(function() {
      var sn, bn = /* @__PURE__ */ new Map(), Ln = (sn = or.current) === null || sn === void 0 ? void 0 : sn.getBoundingClientRect();
      return tr.forEach(function(Wn) {
        var qn, na = Wn.key, Xn = (qn = or.current) === null || qn === void 0 ? void 0 : qn.querySelector('[data-node-key="'.concat(genDataNodeKey(na), '"]'));
        if (Xn) {
          var sa = getTabSize(Xn, Ln), Zn = _slicedToArray(sa, 4), ua = Zn[0], pa = Zn[1], ia = Zn[2], aa = Zn[3];
          bn.set(na, {
            width: ua,
            height: pa,
            left: ia,
            top: aa
          });
        }
      }), bn;
    });
  };
  useEffect(function() {
    Nn();
  }, [tr.map(function(Pn) {
    return Pn.key;
  }).join("_")]);
  var Hn = useUpdate(function() {
    var Pn = getSize(nr), sn = getSize(rr), bn = getSize(ir);
    Pr([Pn[0] - sn[0] - bn[0], Pn[1] - sn[1] - bn[1]]);
    var Ln = getSize(lr);
    zr(Ln);
    var Wn = getSize(sr);
    Rr(Wn);
    var qn = getSize(or);
    Ar([qn[0] - Ln[0], qn[1] - Ln[1]]), Nn();
  }), wr = tr.slice(0, yn), Vr = tr.slice(_n + 1), Yr = [].concat(_toConsumableArray(wr), _toConsumableArray(Vr)), cn = Kr.get(Vt), hn = useIndicator({
    activeTabOffset: cn,
    horizontal: cr,
    indicator: Yt,
    rtl: zt
  }), wn = hn.style;
  useEffect(function() {
    In();
  }, [Vt, En, xn, stringify(cn), stringify(Kr), cr]), useEffect(function() {
    Hn();
  }, [zt]);
  var pn = !!Yr.length, fn = "".concat(er, "-nav-wrap"), Bn, Rn, Sn, Kn;
  return cr ? zt ? (Rn = mr > 0, Bn = mr !== xn) : (Bn = mr < 0, Rn = mr !== En) : (Sn = ur < 0, Kn = ur !== En), /* @__PURE__ */ React.createElement(RefResizeObserver, {
    onResize: Hn
  }, /* @__PURE__ */ React.createElement("div", {
    ref: useComposeRef(Et, nr),
    role: "tablist",
    "aria-orientation": cr ? "horizontal" : "vertical",
    className: classNames("".concat(er, "-nav"), Pt),
    style: $t,
    onKeyDown: function() {
      Br();
    }
  }, /* @__PURE__ */ React.createElement(ExtraContent, {
    ref: rr,
    position: "left",
    extra: Ht,
    prefixCls: er
  }), /* @__PURE__ */ React.createElement(RefResizeObserver, {
    onResize: Hn
  }, /* @__PURE__ */ React.createElement("div", {
    className: classNames(fn, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(fn, "-ping-left"), Bn), "".concat(fn, "-ping-right"), Rn), "".concat(fn, "-ping-top"), Sn), "".concat(fn, "-ping-bottom"), Kn)),
    ref: ar
  }, /* @__PURE__ */ React.createElement(RefResizeObserver, {
    onResize: Hn
  }, /* @__PURE__ */ React.createElement("div", {
    ref: or,
    className: "".concat(er, "-nav-list"),
    style: {
      transform: "translate(".concat(mr, "px, ").concat(ur, "px)"),
      transition: Nr ? "none" : void 0
    }
  }, Fn, /* @__PURE__ */ React.createElement(AddButton, {
    ref: lr,
    prefixCls: er,
    locale: Gt,
    editable: Wt,
    style: _objectSpread2(_objectSpread2({}, Fn.length === 0 ? void 0 : ra), {}, {
      visibility: pn ? "hidden" : null
    })
  }), /* @__PURE__ */ React.createElement("div", {
    className: classNames("".concat(er, "-ink-bar"), _defineProperty({}, "".concat(er, "-ink-bar-animated"), Bt.inkBar)),
    style: wn
  }))))), /* @__PURE__ */ React.createElement(OperationNode$1, _extends$2({}, _t, {
    removeAriaLabel: Gt == null ? void 0 : Gt.removeAriaLabel,
    ref: sr,
    prefixCls: er,
    tabs: Yr,
    className: !pn && $n,
    tabMoving: !!Nr
  })), /* @__PURE__ */ React.createElement(ExtraContent, {
    ref: ir,
    position: "right",
    extra: Ht,
    prefixCls: er
  })));
}), TabPane$1 = /* @__PURE__ */ React.forwardRef(function(_t, Et) {
  var Pt = _t.prefixCls, $t = _t.className, Mt = _t.style, Bt = _t.id, Vt = _t.active, zt = _t.tabKey, Ht = _t.children;
  return /* @__PURE__ */ React.createElement("div", {
    id: Bt && "".concat(Bt, "-panel-").concat(zt),
    role: "tabpanel",
    tabIndex: Vt ? 0 : -1,
    "aria-labelledby": Bt && "".concat(Bt, "-tab-").concat(zt),
    "aria-hidden": !Vt,
    style: Mt,
    className: classNames(Pt, Vt && "".concat(Pt, "-active"), $t),
    ref: Et
  }, Ht);
});
browser$1.env.NODE_ENV !== "production" && (TabPane$1.displayName = "TabPane");
var _excluded$2 = ["renderTabBar"], _excluded2 = ["label", "key"], TabNavListWrapper = function(Et) {
  var Pt = Et.renderTabBar, $t = _objectWithoutProperties$2(Et, _excluded$2), Mt = React.useContext(TabContext), Bt = Mt.tabs;
  if (Pt) {
    var Vt = _objectSpread2(_objectSpread2({}, $t), {}, {
      // Legacy support. We do not use this actually
      panes: Bt.map(function(zt) {
        var Ht = zt.label, Wt = zt.key, Gt = _objectWithoutProperties$2(zt, _excluded2);
        return /* @__PURE__ */ React.createElement(TabPane$1, _extends$2({
          tab: Ht,
          key: Wt,
          tabKey: Wt
        }, Gt));
      })
    });
    return Pt(Vt, TabNavList);
  }
  return /* @__PURE__ */ React.createElement(TabNavList, $t);
};
browser$1.env.NODE_ENV !== "production" && (TabNavListWrapper.displayName = "TabNavListWrapper");
var _excluded$1 = ["key", "forceRender", "style", "className", "destroyInactiveTabPane"], TabPanelList = function(Et) {
  var Pt = Et.id, $t = Et.activeKey, Mt = Et.animated, Bt = Et.tabPosition, Vt = Et.destroyInactiveTabPane, zt = React.useContext(TabContext), Ht = zt.prefixCls, Wt = zt.tabs, Gt = Mt.tabPane, qt = "".concat(Ht, "-tabpane");
  return /* @__PURE__ */ React.createElement("div", {
    className: classNames("".concat(Ht, "-content-holder"))
  }, /* @__PURE__ */ React.createElement("div", {
    className: classNames("".concat(Ht, "-content"), "".concat(Ht, "-content-").concat(Bt), _defineProperty({}, "".concat(Ht, "-content-animated"), Gt))
  }, Wt.map(function(Kt) {
    var Qt = Kt.key, Xt = Kt.forceRender, Zt = Kt.style, Yt = Kt.className, Jt = Kt.destroyInactiveTabPane, er = _objectWithoutProperties$2(Kt, _excluded$1), tr = Qt === $t;
    return /* @__PURE__ */ React.createElement(CSSMotion, _extends$2({
      key: Qt,
      visible: tr,
      forceRender: Xt,
      removeOnLeave: !!(Vt || Jt),
      leavedClassName: "".concat(qt, "-hidden")
    }, Mt.tabPaneMotion), function(nr, rr) {
      var ir = nr.style, ar = nr.className;
      return /* @__PURE__ */ React.createElement(TabPane$1, _extends$2({}, er, {
        prefixCls: qt,
        id: Pt,
        tabKey: Qt,
        animated: Gt,
        active: tr,
        style: _objectSpread2(_objectSpread2({}, Zt), ir),
        className: classNames(Yt, ar),
        ref: rr
      }));
    });
  })));
};
function useAnimateConfig$1() {
  var _t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
    inkBar: !0,
    tabPane: !1
  }, Et;
  return _t === !1 ? Et = {
    inkBar: !1,
    tabPane: !1
  } : _t === !0 ? Et = {
    inkBar: !0,
    tabPane: !1
  } : Et = _objectSpread2({
    inkBar: !0
  }, _typeof(_t) === "object" ? _t : {}), Et.tabPaneMotion && Et.tabPane === void 0 && (Et.tabPane = !0), !Et.tabPaneMotion && Et.tabPane && (browser$1.env.NODE_ENV !== "production" && warningOnce(!1, "`animated.tabPane` is true but `animated.tabPaneMotion` is not provided. Motion will not work."), Et.tabPane = !1), Et;
}
var _excluded = ["id", "prefixCls", "className", "items", "direction", "activeKey", "defaultActiveKey", "editable", "animated", "tabPosition", "tabBarGutter", "tabBarStyle", "tabBarExtraContent", "locale", "more", "destroyInactiveTabPane", "renderTabBar", "onChange", "onTabClick", "onTabScroll", "getPopupContainer", "popupClassName", "indicator"], uuid = 0, Tabs$1 = /* @__PURE__ */ React.forwardRef(function(_t, Et) {
  var Pt = _t.id, $t = _t.prefixCls, Mt = $t === void 0 ? "rc-tabs" : $t, Bt = _t.className, Vt = _t.items, zt = _t.direction, Ht = _t.activeKey, Wt = _t.defaultActiveKey, Gt = _t.editable, qt = _t.animated, Kt = _t.tabPosition, Qt = Kt === void 0 ? "top" : Kt, Xt = _t.tabBarGutter, Zt = _t.tabBarStyle, Yt = _t.tabBarExtraContent, Jt = _t.locale, er = _t.more, tr = _t.destroyInactiveTabPane, nr = _t.renderTabBar, rr = _t.onChange, ir = _t.onTabClick, ar = _t.onTabScroll, or = _t.getPopupContainer, sr = _t.popupClassName, lr = _t.indicator, cr = _objectWithoutProperties$2(_t, _excluded), hr = React.useMemo(function() {
    return (Vt || []).filter(function($r) {
      return $r && _typeof($r) === "object" && "key" in $r;
    });
  }, [Vt]), pr = zt === "rtl", mr = useAnimateConfig$1(qt), Er = useState(!1), _r = _slicedToArray(Er, 2), yr = _r[0], ur = _r[1];
  useEffect(function() {
    ur(isMobile());
  }, []);
  var vr = useMergedState(function() {
    var $r;
    return ($r = hr[0]) === null || $r === void 0 ? void 0 : $r.key;
  }, {
    value: Ht,
    defaultValue: Wt
  }), dr = _slicedToArray(vr, 2), br = dr[0], Cr = dr[1], Pr = useState(function() {
    return hr.findIndex(function($r) {
      return $r.key === br;
    });
  }), xr = _slicedToArray(Pr, 2), kr = xr[0], Ir = xr[1];
  useEffect(function() {
    var $r = hr.findIndex(function(Or) {
      return Or.key === br;
    });
    if ($r === -1) {
      var Rr;
      $r = Math.max(0, Math.min(kr, hr.length - 1)), Cr((Rr = hr[$r]) === null || Rr === void 0 ? void 0 : Rr.key);
    }
    Ir($r);
  }, [hr.map(function($r) {
    return $r.key;
  }).join("_"), br, kr]);
  var Ar = useMergedState(null, {
    value: Pt
  }), Mr = _slicedToArray(Ar, 2), Fr = Mr[0], Dr = Mr[1];
  useEffect(function() {
    Pt || (Dr("rc-tabs-".concat(browser$1.env.NODE_ENV === "test" ? "test" : uuid)), uuid += 1);
  }, []);
  function zr($r, Rr) {
    ir == null || ir($r, Rr);
    var Or = $r !== br;
    Cr($r), Or && (rr == null || rr($r));
  }
  var Tr = {
    id: Fr,
    activeKey: br,
    animated: mr,
    tabPosition: Qt,
    rtl: pr,
    mobile: yr
  }, Gr = _objectSpread2(_objectSpread2({}, Tr), {}, {
    editable: Gt,
    locale: Jt,
    more: er,
    tabBarGutter: Xt,
    onTabClick: zr,
    onTabScroll: ar,
    extra: Yt,
    style: Zt,
    panes: null,
    getPopupContainer: or,
    popupClassName: sr,
    indicator: lr
  });
  return /* @__PURE__ */ React.createElement(TabContext.Provider, {
    value: {
      tabs: hr,
      prefixCls: Mt
    }
  }, /* @__PURE__ */ React.createElement("div", _extends$2({
    ref: Et,
    id: Pt,
    className: classNames(Mt, "".concat(Mt, "-").concat(Qt), _defineProperty(_defineProperty(_defineProperty({}, "".concat(Mt, "-mobile"), yr), "".concat(Mt, "-editable"), Gt), "".concat(Mt, "-rtl"), pr), Bt)
  }, cr), /* @__PURE__ */ React.createElement(TabNavListWrapper, _extends$2({}, Gr, {
    renderTabBar: nr
  })), /* @__PURE__ */ React.createElement(TabPanelList, _extends$2({
    destroyInactiveTabPane: tr
  }, Tr, {
    animated: mr
  }))));
});
browser$1.env.NODE_ENV !== "production" && (Tabs$1.displayName = "Tabs");
const motion = {
  motionAppear: !1,
  motionEnter: !0,
  motionLeave: !0
};
function useAnimateConfig(_t) {
  let Et = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    inkBar: !0,
    tabPane: !1
  }, Pt;
  return Et === !1 ? Pt = {
    inkBar: !1,
    tabPane: !1
  } : Et === !0 ? Pt = {
    inkBar: !0,
    tabPane: !0
  } : Pt = Object.assign({
    inkBar: !0
  }, typeof Et == "object" ? Et : {}), Pt.tabPane && (Pt.tabPaneMotion = Object.assign(Object.assign({}, motion), {
    motionName: getTransitionName(_t, "switch")
  })), Pt;
}
var __rest$4 = function(_t, Et) {
  var Pt = {};
  for (var $t in _t)
    Object.prototype.hasOwnProperty.call(_t, $t) && Et.indexOf($t) < 0 && (Pt[$t] = _t[$t]);
  if (_t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var Mt = 0, $t = Object.getOwnPropertySymbols(_t); Mt < $t.length; Mt++)
      Et.indexOf($t[Mt]) < 0 && Object.prototype.propertyIsEnumerable.call(_t, $t[Mt]) && (Pt[$t[Mt]] = _t[$t[Mt]]);
  return Pt;
};
function filter(_t) {
  return _t.filter((Et) => Et);
}
function useLegacyItems(_t, Et) {
  if (browser$1.env.NODE_ENV !== "production" && devUseWarning("Tabs").deprecated(!Et, "Tabs.TabPane", "items"), _t)
    return _t;
  const Pt = toArray$4(Et).map(($t) => {
    if (/* @__PURE__ */ React.isValidElement($t)) {
      const {
        key: Mt,
        props: Bt
      } = $t, Vt = Bt || {}, {
        tab: zt
      } = Vt, Ht = __rest$4(Vt, ["tab"]);
      return Object.assign(Object.assign({
        key: String(Mt)
      }, Ht), {
        label: zt
      });
    }
    return null;
  });
  return filter(Pt);
}
const genMotionStyle = (_t) => {
  const {
    componentCls: Et,
    motionDurationSlow: Pt
  } = _t;
  return [
    {
      [Et]: {
        [`${Et}-switch`]: {
          "&-appear, &-enter": {
            transition: "none",
            "&-start": {
              opacity: 0
            },
            "&-active": {
              opacity: 1,
              transition: `opacity ${Pt}`
            }
          },
          "&-leave": {
            position: "absolute",
            transition: "none",
            inset: 0,
            "&-start": {
              opacity: 1
            },
            "&-active": {
              opacity: 0,
              transition: `opacity ${Pt}`
            }
          }
        }
      }
    },
    // Follow code may reuse in other components
    [initSlideMotion(_t, "slide-up"), initSlideMotion(_t, "slide-down")]
  ];
}, genCardStyle = (_t) => {
  const {
    componentCls: Et,
    tabsCardPadding: Pt,
    cardBg: $t,
    cardGutter: Mt,
    colorBorderSecondary: Bt,
    itemSelectedColor: Vt
  } = _t;
  return {
    [`${Et}-card`]: {
      [`> ${Et}-nav, > div > ${Et}-nav`]: {
        [`${Et}-tab`]: {
          margin: 0,
          padding: Pt,
          background: $t,
          border: `${unit$1(_t.lineWidth)} ${_t.lineType} ${Bt}`,
          transition: `all ${_t.motionDurationSlow} ${_t.motionEaseInOut}`
        },
        [`${Et}-tab-active`]: {
          color: Vt,
          background: _t.colorBgContainer
        },
        [`${Et}-tab-focus`]: Object.assign({}, genFocusOutline(_t, -3)),
        [`${Et}-ink-bar`]: {
          visibility: "hidden"
        },
        [`& ${Et}-tab${Et}-tab-focus ${Et}-tab-btn`]: {
          outline: "none"
        }
      },
      // ========================== Top & Bottom ==========================
      [`&${Et}-top, &${Et}-bottom`]: {
        [`> ${Et}-nav, > div > ${Et}-nav`]: {
          [`${Et}-tab + ${Et}-tab`]: {
            marginLeft: {
              _skip_check_: !0,
              value: unit$1(Mt)
            }
          }
        }
      },
      [`&${Et}-top`]: {
        [`> ${Et}-nav, > div > ${Et}-nav`]: {
          [`${Et}-tab`]: {
            borderRadius: `${unit$1(_t.borderRadiusLG)} ${unit$1(_t.borderRadiusLG)} 0 0`
          },
          [`${Et}-tab-active`]: {
            borderBottomColor: _t.colorBgContainer
          }
        }
      },
      [`&${Et}-bottom`]: {
        [`> ${Et}-nav, > div > ${Et}-nav`]: {
          [`${Et}-tab`]: {
            borderRadius: `0 0 ${unit$1(_t.borderRadiusLG)} ${unit$1(_t.borderRadiusLG)}`
          },
          [`${Et}-tab-active`]: {
            borderTopColor: _t.colorBgContainer
          }
        }
      },
      // ========================== Left & Right ==========================
      [`&${Et}-left, &${Et}-right`]: {
        [`> ${Et}-nav, > div > ${Et}-nav`]: {
          [`${Et}-tab + ${Et}-tab`]: {
            marginTop: unit$1(Mt)
          }
        }
      },
      [`&${Et}-left`]: {
        [`> ${Et}-nav, > div > ${Et}-nav`]: {
          [`${Et}-tab`]: {
            borderRadius: {
              _skip_check_: !0,
              value: `${unit$1(_t.borderRadiusLG)} 0 0 ${unit$1(_t.borderRadiusLG)}`
            }
          },
          [`${Et}-tab-active`]: {
            borderRightColor: {
              _skip_check_: !0,
              value: _t.colorBgContainer
            }
          }
        }
      },
      [`&${Et}-right`]: {
        [`> ${Et}-nav, > div > ${Et}-nav`]: {
          [`${Et}-tab`]: {
            borderRadius: {
              _skip_check_: !0,
              value: `0 ${unit$1(_t.borderRadiusLG)} ${unit$1(_t.borderRadiusLG)} 0`
            }
          },
          [`${Et}-tab-active`]: {
            borderLeftColor: {
              _skip_check_: !0,
              value: _t.colorBgContainer
            }
          }
        }
      }
    }
  };
}, genDropdownStyle = (_t) => {
  const {
    componentCls: Et,
    itemHoverColor: Pt,
    dropdownEdgeChildVerticalPadding: $t
  } = _t;
  return {
    [`${Et}-dropdown`]: Object.assign(Object.assign({}, resetComponent(_t)), {
      position: "absolute",
      top: -9999,
      left: {
        _skip_check_: !0,
        value: -9999
      },
      zIndex: _t.zIndexPopup,
      display: "block",
      "&-hidden": {
        display: "none"
      },
      [`${Et}-dropdown-menu`]: {
        maxHeight: _t.tabsDropdownHeight,
        margin: 0,
        padding: `${unit$1($t)} 0`,
        overflowX: "hidden",
        overflowY: "auto",
        textAlign: {
          _skip_check_: !0,
          value: "left"
        },
        listStyleType: "none",
        backgroundColor: _t.colorBgContainer,
        backgroundClip: "padding-box",
        borderRadius: _t.borderRadiusLG,
        outline: "none",
        boxShadow: _t.boxShadowSecondary,
        "&-item": Object.assign(Object.assign({}, textEllipsis), {
          display: "flex",
          alignItems: "center",
          minWidth: _t.tabsDropdownWidth,
          margin: 0,
          padding: `${unit$1(_t.paddingXXS)} ${unit$1(_t.paddingSM)}`,
          color: _t.colorText,
          fontWeight: "normal",
          fontSize: _t.fontSize,
          lineHeight: _t.lineHeight,
          cursor: "pointer",
          transition: `all ${_t.motionDurationSlow}`,
          "> span": {
            flex: 1,
            whiteSpace: "nowrap"
          },
          "&-remove": {
            flex: "none",
            marginLeft: {
              _skip_check_: !0,
              value: _t.marginSM
            },
            color: _t.colorTextDescription,
            fontSize: _t.fontSizeSM,
            background: "transparent",
            border: 0,
            cursor: "pointer",
            "&:hover": {
              color: Pt
            }
          },
          "&:hover": {
            background: _t.controlItemBgHover
          },
          "&-disabled": {
            "&, &:hover": {
              color: _t.colorTextDisabled,
              background: "transparent",
              cursor: "not-allowed"
            }
          }
        })
      }
    })
  };
}, genPositionStyle = (_t) => {
  const {
    componentCls: Et,
    margin: Pt,
    colorBorderSecondary: $t,
    horizontalMargin: Mt,
    verticalItemPadding: Bt,
    verticalItemMargin: Vt,
    calc: zt
  } = _t;
  return {
    // ========================== Top & Bottom ==========================
    [`${Et}-top, ${Et}-bottom`]: {
      flexDirection: "column",
      [`> ${Et}-nav, > div > ${Et}-nav`]: {
        margin: Mt,
        "&::before": {
          position: "absolute",
          right: {
            _skip_check_: !0,
            value: 0
          },
          left: {
            _skip_check_: !0,
            value: 0
          },
          borderBottom: `${unit$1(_t.lineWidth)} ${_t.lineType} ${$t}`,
          content: "''"
        },
        [`${Et}-ink-bar`]: {
          height: _t.lineWidthBold,
          "&-animated": {
            transition: `width ${_t.motionDurationSlow}, left ${_t.motionDurationSlow},
            right ${_t.motionDurationSlow}`
          }
        },
        [`${Et}-nav-wrap`]: {
          "&::before, &::after": {
            top: 0,
            bottom: 0,
            width: _t.controlHeight
          },
          "&::before": {
            left: {
              _skip_check_: !0,
              value: 0
            },
            boxShadow: _t.boxShadowTabsOverflowLeft
          },
          "&::after": {
            right: {
              _skip_check_: !0,
              value: 0
            },
            boxShadow: _t.boxShadowTabsOverflowRight
          },
          [`&${Et}-nav-wrap-ping-left::before`]: {
            opacity: 1
          },
          [`&${Et}-nav-wrap-ping-right::after`]: {
            opacity: 1
          }
        }
      }
    },
    [`${Et}-top`]: {
      [`> ${Et}-nav,
        > div > ${Et}-nav`]: {
        "&::before": {
          bottom: 0
        },
        [`${Et}-ink-bar`]: {
          bottom: 0
        }
      }
    },
    [`${Et}-bottom`]: {
      [`> ${Et}-nav, > div > ${Et}-nav`]: {
        order: 1,
        marginTop: Pt,
        marginBottom: 0,
        "&::before": {
          top: 0
        },
        [`${Et}-ink-bar`]: {
          top: 0
        }
      },
      [`> ${Et}-content-holder, > div > ${Et}-content-holder`]: {
        order: 0
      }
    },
    // ========================== Left & Right ==========================
    [`${Et}-left, ${Et}-right`]: {
      [`> ${Et}-nav, > div > ${Et}-nav`]: {
        flexDirection: "column",
        minWidth: zt(_t.controlHeight).mul(1.25).equal(),
        // >>>>>>>>>>> Tab
        [`${Et}-tab`]: {
          padding: Bt,
          textAlign: "center"
        },
        [`${Et}-tab + ${Et}-tab`]: {
          margin: Vt
        },
        // >>>>>>>>>>> Nav
        [`${Et}-nav-wrap`]: {
          flexDirection: "column",
          "&::before, &::after": {
            right: {
              _skip_check_: !0,
              value: 0
            },
            left: {
              _skip_check_: !0,
              value: 0
            },
            height: _t.controlHeight
          },
          "&::before": {
            top: 0,
            boxShadow: _t.boxShadowTabsOverflowTop
          },
          "&::after": {
            bottom: 0,
            boxShadow: _t.boxShadowTabsOverflowBottom
          },
          [`&${Et}-nav-wrap-ping-top::before`]: {
            opacity: 1
          },
          [`&${Et}-nav-wrap-ping-bottom::after`]: {
            opacity: 1
          }
        },
        // >>>>>>>>>>> Ink Bar
        [`${Et}-ink-bar`]: {
          width: _t.lineWidthBold,
          "&-animated": {
            transition: `height ${_t.motionDurationSlow}, top ${_t.motionDurationSlow}`
          }
        },
        [`${Et}-nav-list, ${Et}-nav-operations`]: {
          flex: "1 0 auto",
          // fix safari scroll problem
          flexDirection: "column"
        }
      }
    },
    [`${Et}-left`]: {
      [`> ${Et}-nav, > div > ${Et}-nav`]: {
        [`${Et}-ink-bar`]: {
          right: {
            _skip_check_: !0,
            value: 0
          }
        }
      },
      [`> ${Et}-content-holder, > div > ${Et}-content-holder`]: {
        marginLeft: {
          _skip_check_: !0,
          value: unit$1(zt(_t.lineWidth).mul(-1).equal())
        },
        borderLeft: {
          _skip_check_: !0,
          value: `${unit$1(_t.lineWidth)} ${_t.lineType} ${_t.colorBorder}`
        },
        [`> ${Et}-content > ${Et}-tabpane`]: {
          paddingLeft: {
            _skip_check_: !0,
            value: _t.paddingLG
          }
        }
      }
    },
    [`${Et}-right`]: {
      [`> ${Et}-nav, > div > ${Et}-nav`]: {
        order: 1,
        [`${Et}-ink-bar`]: {
          left: {
            _skip_check_: !0,
            value: 0
          }
        }
      },
      [`> ${Et}-content-holder, > div > ${Et}-content-holder`]: {
        order: 0,
        marginRight: {
          _skip_check_: !0,
          value: zt(_t.lineWidth).mul(-1).equal()
        },
        borderRight: {
          _skip_check_: !0,
          value: `${unit$1(_t.lineWidth)} ${_t.lineType} ${_t.colorBorder}`
        },
        [`> ${Et}-content > ${Et}-tabpane`]: {
          paddingRight: {
            _skip_check_: !0,
            value: _t.paddingLG
          }
        }
      }
    }
  };
}, genSizeStyle = (_t) => {
  const {
    componentCls: Et,
    cardPaddingSM: Pt,
    cardPaddingLG: $t,
    horizontalItemPaddingSM: Mt,
    horizontalItemPaddingLG: Bt
  } = _t;
  return {
    [Et]: {
      "&-small": {
        [`> ${Et}-nav`]: {
          [`${Et}-tab`]: {
            padding: Mt,
            fontSize: _t.titleFontSizeSM
          }
        }
      },
      "&-large": {
        [`> ${Et}-nav`]: {
          [`${Et}-tab`]: {
            padding: Bt,
            fontSize: _t.titleFontSizeLG
          }
        }
      }
    },
    [`${Et}-card`]: {
      [`&${Et}-small`]: {
        [`> ${Et}-nav`]: {
          [`${Et}-tab`]: {
            padding: Pt
          }
        },
        [`&${Et}-bottom`]: {
          [`> ${Et}-nav ${Et}-tab`]: {
            borderRadius: `0 0 ${unit$1(_t.borderRadius)} ${unit$1(_t.borderRadius)}`
          }
        },
        [`&${Et}-top`]: {
          [`> ${Et}-nav ${Et}-tab`]: {
            borderRadius: `${unit$1(_t.borderRadius)} ${unit$1(_t.borderRadius)} 0 0`
          }
        },
        [`&${Et}-right`]: {
          [`> ${Et}-nav ${Et}-tab`]: {
            borderRadius: {
              _skip_check_: !0,
              value: `0 ${unit$1(_t.borderRadius)} ${unit$1(_t.borderRadius)} 0`
            }
          }
        },
        [`&${Et}-left`]: {
          [`> ${Et}-nav ${Et}-tab`]: {
            borderRadius: {
              _skip_check_: !0,
              value: `${unit$1(_t.borderRadius)} 0 0 ${unit$1(_t.borderRadius)}`
            }
          }
        }
      },
      [`&${Et}-large`]: {
        [`> ${Et}-nav`]: {
          [`${Et}-tab`]: {
            padding: $t
          }
        }
      }
    }
  };
}, genTabStyle = (_t) => {
  const {
    componentCls: Et,
    itemActiveColor: Pt,
    itemHoverColor: $t,
    iconCls: Mt,
    tabsHorizontalItemMargin: Bt,
    horizontalItemPadding: Vt,
    itemSelectedColor: zt,
    itemColor: Ht
  } = _t, Wt = `${Et}-tab`;
  return {
    [Wt]: {
      position: "relative",
      WebkitTouchCallout: "none",
      WebkitTapHighlightColor: "transparent",
      display: "inline-flex",
      alignItems: "center",
      padding: Vt,
      fontSize: _t.titleFontSize,
      background: "transparent",
      border: 0,
      outline: "none",
      cursor: "pointer",
      color: Ht,
      "&-btn, &-remove": {
        "&:focus:not(:focus-visible), &:active": {
          color: Pt
        }
      },
      "&-btn": {
        outline: "none",
        transition: `all ${_t.motionDurationSlow}`,
        [`${Wt}-icon:not(:last-child)`]: {
          marginInlineEnd: _t.marginSM
        }
      },
      "&-remove": Object.assign({
        flex: "none",
        marginRight: {
          _skip_check_: !0,
          value: _t.calc(_t.marginXXS).mul(-1).equal()
        },
        marginLeft: {
          _skip_check_: !0,
          value: _t.marginXS
        },
        color: _t.colorTextDescription,
        fontSize: _t.fontSizeSM,
        background: "transparent",
        border: "none",
        outline: "none",
        cursor: "pointer",
        transition: `all ${_t.motionDurationSlow}`,
        "&:hover": {
          color: _t.colorTextHeading
        }
      }, genFocusStyle(_t)),
      "&:hover": {
        color: $t
      },
      [`&${Wt}-active ${Wt}-btn`]: {
        color: zt,
        textShadow: _t.tabsActiveTextShadow
      },
      [`&${Wt}-focus ${Wt}-btn`]: Object.assign({}, genFocusOutline(_t)),
      [`&${Wt}-disabled`]: {
        color: _t.colorTextDisabled,
        cursor: "not-allowed"
      },
      [`&${Wt}-disabled ${Wt}-btn, &${Wt}-disabled ${Et}-remove`]: {
        "&:focus, &:active": {
          color: _t.colorTextDisabled
        }
      },
      [`& ${Wt}-remove ${Mt}`]: {
        margin: 0
      },
      [`${Mt}:not(:last-child)`]: {
        marginRight: {
          _skip_check_: !0,
          value: _t.marginSM
        }
      }
    },
    [`${Wt} + ${Wt}`]: {
      margin: {
        _skip_check_: !0,
        value: Bt
      }
    }
  };
}, genRtlStyle = (_t) => {
  const {
    componentCls: Et,
    tabsHorizontalItemMarginRTL: Pt,
    iconCls: $t,
    cardGutter: Mt,
    calc: Bt
  } = _t;
  return {
    [`${Et}-rtl`]: {
      direction: "rtl",
      [`${Et}-nav`]: {
        [`${Et}-tab`]: {
          margin: {
            _skip_check_: !0,
            value: Pt
          },
          [`${Et}-tab:last-of-type`]: {
            marginLeft: {
              _skip_check_: !0,
              value: 0
            }
          },
          [$t]: {
            marginRight: {
              _skip_check_: !0,
              value: 0
            },
            marginLeft: {
              _skip_check_: !0,
              value: unit$1(_t.marginSM)
            }
          },
          [`${Et}-tab-remove`]: {
            marginRight: {
              _skip_check_: !0,
              value: unit$1(_t.marginXS)
            },
            marginLeft: {
              _skip_check_: !0,
              value: unit$1(Bt(_t.marginXXS).mul(-1).equal())
            },
            [$t]: {
              margin: 0
            }
          }
        }
      },
      [`&${Et}-left`]: {
        [`> ${Et}-nav`]: {
          order: 1
        },
        [`> ${Et}-content-holder`]: {
          order: 0
        }
      },
      [`&${Et}-right`]: {
        [`> ${Et}-nav`]: {
          order: 0
        },
        [`> ${Et}-content-holder`]: {
          order: 1
        }
      },
      // ====================== Card ======================
      [`&${Et}-card${Et}-top, &${Et}-card${Et}-bottom`]: {
        [`> ${Et}-nav, > div > ${Et}-nav`]: {
          [`${Et}-tab + ${Et}-tab`]: {
            marginRight: {
              _skip_check_: !0,
              value: Mt
            },
            marginLeft: {
              _skip_check_: !0,
              value: 0
            }
          }
        }
      }
    },
    [`${Et}-dropdown-rtl`]: {
      direction: "rtl"
    },
    [`${Et}-menu-item`]: {
      [`${Et}-dropdown-rtl`]: {
        textAlign: {
          _skip_check_: !0,
          value: "right"
        }
      }
    }
  };
}, genTabsStyle = (_t) => {
  const {
    componentCls: Et,
    tabsCardPadding: Pt,
    cardHeight: $t,
    cardGutter: Mt,
    itemHoverColor: Bt,
    itemActiveColor: Vt,
    colorBorderSecondary: zt
  } = _t;
  return {
    [Et]: Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(_t)), {
      display: "flex",
      // ========================== Navigation ==========================
      [`> ${Et}-nav, > div > ${Et}-nav`]: {
        position: "relative",
        display: "flex",
        flex: "none",
        alignItems: "center",
        [`${Et}-nav-wrap`]: {
          position: "relative",
          display: "flex",
          flex: "auto",
          alignSelf: "stretch",
          overflow: "hidden",
          whiteSpace: "nowrap",
          transform: "translate(0)",
          // Fix chrome render bug
          // >>>>> Ping shadow
          "&::before, &::after": {
            position: "absolute",
            zIndex: 1,
            opacity: 0,
            transition: `opacity ${_t.motionDurationSlow}`,
            content: "''",
            pointerEvents: "none"
          }
        },
        [`${Et}-nav-list`]: {
          position: "relative",
          display: "flex",
          transition: `opacity ${_t.motionDurationSlow}`
        },
        // >>>>>>>> Operations
        [`${Et}-nav-operations`]: {
          display: "flex",
          alignSelf: "stretch"
        },
        [`${Et}-nav-operations-hidden`]: {
          position: "absolute",
          visibility: "hidden",
          pointerEvents: "none"
        },
        [`${Et}-nav-more`]: {
          position: "relative",
          padding: Pt,
          background: "transparent",
          border: 0,
          color: _t.colorText,
          "&::after": {
            position: "absolute",
            right: {
              _skip_check_: !0,
              value: 0
            },
            bottom: 0,
            left: {
              _skip_check_: !0,
              value: 0
            },
            height: _t.calc(_t.controlHeightLG).div(8).equal(),
            transform: "translateY(100%)",
            content: "''"
          }
        },
        [`${Et}-nav-add`]: Object.assign({
          minWidth: $t,
          marginLeft: {
            _skip_check_: !0,
            value: Mt
          },
          padding: unit$1(_t.paddingXS),
          background: "transparent",
          border: `${unit$1(_t.lineWidth)} ${_t.lineType} ${zt}`,
          borderRadius: `${unit$1(_t.borderRadiusLG)} ${unit$1(_t.borderRadiusLG)} 0 0`,
          outline: "none",
          cursor: "pointer",
          color: _t.colorText,
          transition: `all ${_t.motionDurationSlow} ${_t.motionEaseInOut}`,
          "&:hover": {
            color: Bt
          },
          "&:active, &:focus:not(:focus-visible)": {
            color: Vt
          }
        }, genFocusStyle(_t, -3))
      },
      [`${Et}-extra-content`]: {
        flex: "none"
      },
      // ============================ InkBar ============================
      [`${Et}-ink-bar`]: {
        position: "absolute",
        background: _t.inkBarColor,
        pointerEvents: "none"
      }
    }), genTabStyle(_t)), {
      // =========================== TabPanes ===========================
      [`${Et}-content`]: {
        position: "relative",
        width: "100%"
      },
      [`${Et}-content-holder`]: {
        flex: "auto",
        minWidth: 0,
        minHeight: 0
      },
      [`${Et}-tabpane`]: Object.assign(Object.assign({}, genFocusStyle(_t)), {
        "&-hidden": {
          display: "none"
        }
      })
    }),
    [`${Et}-centered`]: {
      [`> ${Et}-nav, > div > ${Et}-nav`]: {
        [`${Et}-nav-wrap`]: {
          [`&:not([class*='${Et}-nav-wrap-ping']) > ${Et}-nav-list`]: {
            margin: "auto"
          }
        }
      }
    }
  };
}, prepareComponentToken$1 = (_t) => {
  const Et = _t.controlHeightLG;
  return {
    zIndexPopup: _t.zIndexPopupBase + 50,
    cardBg: _t.colorFillAlter,
    cardHeight: Et,
    // Initialize with empty string, because cardPadding will be calculated with cardHeight by default.
    cardPadding: `${(Et - Math.round(_t.fontSize * _t.lineHeight)) / 2 - _t.lineWidth}px ${_t.padding}px`,
    cardPaddingSM: `${_t.paddingXXS * 1.5}px ${_t.padding}px`,
    cardPaddingLG: `${_t.paddingXS}px ${_t.padding}px ${_t.paddingXXS * 1.5}px`,
    titleFontSize: _t.fontSize,
    titleFontSizeLG: _t.fontSizeLG,
    titleFontSizeSM: _t.fontSize,
    inkBarColor: _t.colorPrimary,
    horizontalMargin: `0 0 ${_t.margin}px 0`,
    horizontalItemGutter: 32,
    // Fixed Value
    // Initialize with empty string, because horizontalItemMargin will be calculated with horizontalItemGutter by default.
    horizontalItemMargin: "",
    horizontalItemMarginRTL: "",
    horizontalItemPadding: `${_t.paddingSM}px 0`,
    horizontalItemPaddingSM: `${_t.paddingXS}px 0`,
    horizontalItemPaddingLG: `${_t.padding}px 0`,
    verticalItemPadding: `${_t.paddingXS}px ${_t.paddingLG}px`,
    verticalItemMargin: `${_t.margin}px 0 0 0`,
    itemColor: _t.colorText,
    itemSelectedColor: _t.colorPrimary,
    itemHoverColor: _t.colorPrimaryHover,
    itemActiveColor: _t.colorPrimaryActive,
    cardGutter: _t.marginXXS / 2
  };
}, useStyle$1 = genStyleHooks("Tabs", (_t) => {
  const Et = merge$1(_t, {
    // `cardPadding` is empty by default, so we could calculate with dynamic `cardHeight`
    tabsCardPadding: _t.cardPadding,
    dropdownEdgeChildVerticalPadding: _t.paddingXXS,
    tabsActiveTextShadow: "0 0 0.25px currentcolor",
    tabsDropdownHeight: 200,
    tabsDropdownWidth: 120,
    tabsHorizontalItemMargin: `0 0 0 ${unit$1(_t.horizontalItemGutter)}`,
    tabsHorizontalItemMarginRTL: `0 0 0 ${unit$1(_t.horizontalItemGutter)}`
  });
  return [genSizeStyle(Et), genRtlStyle(Et), genPositionStyle(Et), genDropdownStyle(Et), genCardStyle(Et), genTabsStyle(Et), genMotionStyle(Et)];
}, prepareComponentToken$1), TabPane = () => null;
browser$1.env.NODE_ENV !== "production" && (TabPane.displayName = "DeprecatedTabPane");
var __rest$3 = function(_t, Et) {
  var Pt = {};
  for (var $t in _t)
    Object.prototype.hasOwnProperty.call(_t, $t) && Et.indexOf($t) < 0 && (Pt[$t] = _t[$t]);
  if (_t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var Mt = 0, $t = Object.getOwnPropertySymbols(_t); Mt < $t.length; Mt++)
      Et.indexOf($t[Mt]) < 0 && Object.prototype.propertyIsEnumerable.call(_t, $t[Mt]) && (Pt[$t[Mt]] = _t[$t[Mt]]);
  return Pt;
};
const Tabs = (_t) => {
  var Et, Pt, $t, Mt, Bt, Vt, zt, Ht, Wt, Gt, qt;
  const {
    type: Kt,
    className: Qt,
    rootClassName: Xt,
    size: Zt,
    onEdit: Yt,
    hideAdd: Jt,
    centered: er,
    addIcon: tr,
    removeIcon: nr,
    moreIcon: rr,
    more: ir,
    popupClassName: ar,
    children: or,
    items: sr,
    animated: lr,
    style: cr,
    indicatorSize: hr,
    indicator: pr
  } = _t, mr = __rest$3(_t, ["type", "className", "rootClassName", "size", "onEdit", "hideAdd", "centered", "addIcon", "removeIcon", "moreIcon", "more", "popupClassName", "children", "items", "animated", "style", "indicatorSize", "indicator"]), {
    prefixCls: Er
  } = mr, {
    direction: _r,
    tabs: yr,
    getPrefixCls: ur,
    getPopupContainer: vr
  } = React.useContext(ConfigContext), dr = ur("tabs", Er), br = useCSSVarCls(dr), [Cr, Pr, xr] = useStyle$1(dr, br);
  let kr;
  Kt === "editable-card" && (kr = {
    onEdit: (Tr, Gr) => {
      let {
        key: $r,
        event: Rr
      } = Gr;
      Yt == null || Yt(Tr === "add" ? Rr : $r, Tr);
    },
    removeIcon: (Et = nr ?? (yr == null ? void 0 : yr.removeIcon)) !== null && Et !== void 0 ? Et : /* @__PURE__ */ React.createElement(RefIcon$6, null),
    addIcon: (tr ?? (yr == null ? void 0 : yr.addIcon)) || /* @__PURE__ */ React.createElement(RefIcon, null),
    showAdd: Jt !== !0
  });
  const Ir = ur();
  if (browser$1.env.NODE_ENV !== "production") {
    const Tr = devUseWarning("Tabs");
    browser$1.env.NODE_ENV !== "production" && Tr(!("onPrevClick" in _t) && !("onNextClick" in _t), "breaking", "`onPrevClick` and `onNextClick` has been removed. Please use `onTabScroll` instead."), browser$1.env.NODE_ENV !== "production" && Tr(!(hr || yr != null && yr.indicatorSize), "deprecated", "`indicatorSize` has been deprecated. Please use `indicator={{ size: ... }}` instead.");
  }
  const Ar = useSize(Zt), Mr = useLegacyItems(sr, or), Fr = useAnimateConfig(dr, lr), Dr = Object.assign(Object.assign({}, yr == null ? void 0 : yr.style), cr), zr = {
    align: (Pt = pr == null ? void 0 : pr.align) !== null && Pt !== void 0 ? Pt : ($t = yr == null ? void 0 : yr.indicator) === null || $t === void 0 ? void 0 : $t.align,
    size: (zt = (Bt = (Mt = pr == null ? void 0 : pr.size) !== null && Mt !== void 0 ? Mt : hr) !== null && Bt !== void 0 ? Bt : (Vt = yr == null ? void 0 : yr.indicator) === null || Vt === void 0 ? void 0 : Vt.size) !== null && zt !== void 0 ? zt : yr == null ? void 0 : yr.indicatorSize
  };
  return Cr(/* @__PURE__ */ React.createElement(Tabs$1, Object.assign({
    direction: _r,
    getPopupContainer: vr
  }, mr, {
    items: Mr,
    className: classNames({
      [`${dr}-${Ar}`]: Ar,
      [`${dr}-card`]: ["card", "editable-card"].includes(Kt),
      [`${dr}-editable-card`]: Kt === "editable-card",
      [`${dr}-centered`]: er
    }, yr == null ? void 0 : yr.className, Qt, Xt, Pr, xr, br),
    popupClassName: classNames(ar, Pr, xr, br),
    style: Dr,
    editable: kr,
    more: Object.assign({
      icon: (qt = (Gt = (Wt = (Ht = yr == null ? void 0 : yr.more) === null || Ht === void 0 ? void 0 : Ht.icon) !== null && Wt !== void 0 ? Wt : yr == null ? void 0 : yr.moreIcon) !== null && Gt !== void 0 ? Gt : rr) !== null && qt !== void 0 ? qt : /* @__PURE__ */ React.createElement(RefIcon$5, null),
      transitionName: `${Ir}-slide-up`
    }, ir),
    prefixCls: dr,
    animated: Fr,
    indicator: zr
  })));
};
Tabs.TabPane = TabPane;
browser$1.env.NODE_ENV !== "production" && (Tabs.displayName = "Tabs");
var __rest$2 = function(_t, Et) {
  var Pt = {};
  for (var $t in _t)
    Object.prototype.hasOwnProperty.call(_t, $t) && Et.indexOf($t) < 0 && (Pt[$t] = _t[$t]);
  if (_t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var Mt = 0, $t = Object.getOwnPropertySymbols(_t); Mt < $t.length; Mt++)
      Et.indexOf($t[Mt]) < 0 && Object.prototype.propertyIsEnumerable.call(_t, $t[Mt]) && (Pt[$t[Mt]] = _t[$t[Mt]]);
  return Pt;
};
const PurePanel = (_t) => {
  const {
    prefixCls: Et,
    className: Pt,
    closeIcon: $t,
    closable: Mt,
    type: Bt,
    title: Vt,
    children: zt,
    footer: Ht
  } = _t, Wt = __rest$2(_t, ["prefixCls", "className", "closeIcon", "closable", "type", "title", "children", "footer"]), {
    getPrefixCls: Gt
  } = React.useContext(ConfigContext), qt = Gt(), Kt = Et || Gt("modal"), Qt = useCSSVarCls(qt), [Xt, Zt, Yt] = useStyle$4(Kt, Qt), Jt = `${Kt}-confirm`;
  let er = {};
  return Bt ? er = {
    closable: Mt ?? !1,
    title: "",
    footer: "",
    children: /* @__PURE__ */ React.createElement(ConfirmContent, Object.assign({}, _t, {
      prefixCls: Kt,
      confirmPrefixCls: Jt,
      rootPrefixCls: qt,
      content: zt
    }))
  } : er = {
    closable: Mt ?? !0,
    title: Vt,
    footer: Ht !== null && /* @__PURE__ */ React.createElement(Footer, Object.assign({}, _t)),
    children: zt
  }, Xt(/* @__PURE__ */ React.createElement(Panel, Object.assign({
    prefixCls: Kt,
    className: classNames(Zt, `${Kt}-pure-panel`, Bt && Jt, Bt && `${Jt}-${Bt}`, Pt, Yt, Qt)
  }, Wt, {
    closeIcon: renderCloseIcon(Kt, $t),
    closable: Mt
  }, er)));
}, PurePanel$1 = withPureRenderTheme(PurePanel);
function modalWarn(_t) {
  return confirm(withWarn(_t));
}
const Modal = Modal$1;
Modal.useModal = useModal;
Modal.info = function(Et) {
  return confirm(withInfo(Et));
};
Modal.success = function(Et) {
  return confirm(withSuccess(Et));
};
Modal.error = function(Et) {
  return confirm(withError(Et));
};
Modal.warning = modalWarn;
Modal.warn = modalWarn;
Modal.confirm = function(Et) {
  return confirm(withConfirm(Et));
};
Modal.destroyAll = function() {
  for (; destroyFns.length; ) {
    const Et = destroyFns.pop();
    Et && Et();
  }
};
Modal.config = modalGlobalConfig;
Modal._InternalPanelDoNotUseOrYouWillBeFired = PurePanel$1;
browser$1.env.NODE_ENV !== "production" && (Modal.displayName = "Modal");
let notification = null, act = (_t) => _t(), taskQueue = [], defaultGlobalConfig = {};
function getGlobalContext() {
  const {
    getContainer: _t,
    rtl: Et,
    maxCount: Pt,
    top: $t,
    bottom: Mt,
    showProgress: Bt,
    pauseOnHover: Vt
  } = defaultGlobalConfig, zt = (_t == null ? void 0 : _t()) || document.body;
  return {
    getContainer: () => zt,
    rtl: Et,
    maxCount: Pt,
    top: $t,
    bottom: Mt,
    showProgress: Bt,
    pauseOnHover: Vt
  };
}
const GlobalHolder = /* @__PURE__ */ React__default.forwardRef((_t, Et) => {
  const {
    notificationConfig: Pt,
    sync: $t
  } = _t, {
    getPrefixCls: Mt
  } = useContext(ConfigContext), Bt = defaultGlobalConfig.prefixCls || Mt("notification"), Vt = useContext(AppConfigContext), [zt, Ht] = useInternalNotification(Object.assign(Object.assign(Object.assign({}, Pt), {
    prefixCls: Bt
  }), Vt.notification));
  return React__default.useEffect($t, []), React__default.useImperativeHandle(Et, () => {
    const Wt = Object.assign({}, zt);
    return Object.keys(Wt).forEach((Gt) => {
      Wt[Gt] = function() {
        return $t(), zt[Gt].apply(zt, arguments);
      };
    }), {
      instance: Wt,
      sync: $t
    };
  }), Ht;
}), GlobalHolderWrapper = /* @__PURE__ */ React__default.forwardRef((_t, Et) => {
  const [Pt, $t] = React__default.useState(getGlobalContext), Mt = () => {
    $t(getGlobalContext);
  };
  React__default.useEffect(Mt, []);
  const Bt = globalConfig(), Vt = Bt.getRootPrefixCls(), zt = Bt.getIconPrefixCls(), Ht = Bt.getTheme(), Wt = /* @__PURE__ */ React__default.createElement(GlobalHolder, {
    ref: Et,
    sync: Mt,
    notificationConfig: Pt
  });
  return /* @__PURE__ */ React__default.createElement(ConfigProvider, {
    prefixCls: Vt,
    iconPrefixCls: zt,
    theme: Ht
  }, Bt.holderRender ? Bt.holderRender(Wt) : Wt);
});
function flushNotice() {
  if (!notification) {
    const _t = document.createDocumentFragment(), Et = {
      fragment: _t
    };
    notification = Et, act(() => {
      getReactRender()(/* @__PURE__ */ React__default.createElement(GlobalHolderWrapper, {
        ref: ($t) => {
          const {
            instance: Mt,
            sync: Bt
          } = $t || {};
          Promise.resolve().then(() => {
            !Et.instance && Mt && (Et.instance = Mt, Et.sync = Bt, flushNotice());
          });
        }
      }), _t);
    });
    return;
  }
  notification.instance && (taskQueue.forEach((_t) => {
    switch (_t.type) {
      case "open": {
        act(() => {
          notification.instance.open(Object.assign(Object.assign({}, defaultGlobalConfig), _t.config));
        });
        break;
      }
      case "destroy":
        act(() => {
          notification == null || notification.instance.destroy(_t.key);
        });
        break;
    }
  }), taskQueue = []);
}
function setNotificationGlobalConfig(_t) {
  defaultGlobalConfig = Object.assign(Object.assign({}, defaultGlobalConfig), _t), act(() => {
    var Et;
    (Et = notification == null ? void 0 : notification.sync) === null || Et === void 0 || Et.call(notification);
  });
}
function open(_t) {
  const Et = globalConfig();
  browser$1.env.NODE_ENV !== "production" && !Et.holderRender && warnContext("notification"), taskQueue.push({
    type: "open",
    config: _t
  }), flushNotice();
}
const destroy = (_t) => {
  taskQueue.push({
    type: "destroy",
    key: _t
  }), flushNotice();
}, methods = ["success", "info", "warning", "error"], baseStaticMethods = {
  open,
  destroy,
  config: setNotificationGlobalConfig,
  useNotification,
  _InternalPanelDoNotUseOrYouWillBeFired: PurePanel$3
}, staticMethods = baseStaticMethods;
methods.forEach((_t) => {
  staticMethods[_t] = (Et) => open(Object.assign(Object.assign({}, Et), {
    type: _t
  }));
});
browser$1.env.NODE_ENV;
browser$1.env.NODE_ENV;
const genBaseStyle = (_t) => {
  const {
    paddingXXS: Et,
    lineWidth: Pt,
    tagPaddingHorizontal: $t,
    componentCls: Mt,
    calc: Bt
  } = _t, Vt = Bt($t).sub(Pt).equal(), zt = Bt(Et).sub(Pt).equal();
  return {
    // Result
    [Mt]: Object.assign(Object.assign({}, resetComponent(_t)), {
      display: "inline-block",
      height: "auto",
      // https://github.com/ant-design/ant-design/pull/47504
      marginInlineEnd: _t.marginXS,
      paddingInline: Vt,
      fontSize: _t.tagFontSize,
      lineHeight: _t.tagLineHeight,
      whiteSpace: "nowrap",
      background: _t.defaultBg,
      border: `${unit$1(_t.lineWidth)} ${_t.lineType} ${_t.colorBorder}`,
      borderRadius: _t.borderRadiusSM,
      opacity: 1,
      transition: `all ${_t.motionDurationMid}`,
      textAlign: "start",
      position: "relative",
      // RTL
      [`&${Mt}-rtl`]: {
        direction: "rtl"
      },
      "&, a, a:hover": {
        color: _t.defaultColor
      },
      [`${Mt}-close-icon`]: {
        marginInlineStart: zt,
        fontSize: _t.tagIconSize,
        color: _t.colorTextDescription,
        cursor: "pointer",
        transition: `all ${_t.motionDurationMid}`,
        "&:hover": {
          color: _t.colorTextHeading
        }
      },
      [`&${Mt}-has-color`]: {
        borderColor: "transparent",
        [`&, a, a:hover, ${_t.iconCls}-close, ${_t.iconCls}-close:hover`]: {
          color: _t.colorTextLightSolid
        }
      },
      "&-checkable": {
        backgroundColor: "transparent",
        borderColor: "transparent",
        cursor: "pointer",
        [`&:not(${Mt}-checkable-checked):hover`]: {
          color: _t.colorPrimary,
          backgroundColor: _t.colorFillSecondary
        },
        "&:active, &-checked": {
          color: _t.colorTextLightSolid
        },
        "&-checked": {
          backgroundColor: _t.colorPrimary,
          "&:hover": {
            backgroundColor: _t.colorPrimaryHover
          }
        },
        "&:active": {
          backgroundColor: _t.colorPrimaryActive
        }
      },
      "&-hidden": {
        display: "none"
      },
      // To ensure that a space will be placed between character and `Icon`.
      [`> ${_t.iconCls} + span, > span + ${_t.iconCls}`]: {
        marginInlineStart: Vt
      }
    }),
    [`${Mt}-borderless`]: {
      borderColor: "transparent",
      background: _t.tagBorderlessBg
    }
  };
}, prepareToken = (_t) => {
  const {
    lineWidth: Et,
    fontSizeIcon: Pt,
    calc: $t
  } = _t, Mt = _t.fontSizeSM;
  return merge$1(_t, {
    tagFontSize: Mt,
    tagLineHeight: unit$1($t(_t.lineHeightSM).mul(Mt).equal()),
    tagIconSize: $t(Pt).sub($t(Et).mul(2)).equal(),
    // Tag icon is much smaller
    tagPaddingHorizontal: 8,
    // Fixed padding.
    tagBorderlessBg: _t.defaultBg
  });
}, prepareComponentToken = (_t) => ({
  defaultBg: new FastColor(_t.colorFillQuaternary).onBackground(_t.colorBgContainer).toHexString(),
  defaultColor: _t.colorText
}), useStyle = genStyleHooks("Tag", (_t) => {
  const Et = prepareToken(_t);
  return genBaseStyle(Et);
}, prepareComponentToken);
var __rest$1 = function(_t, Et) {
  var Pt = {};
  for (var $t in _t)
    Object.prototype.hasOwnProperty.call(_t, $t) && Et.indexOf($t) < 0 && (Pt[$t] = _t[$t]);
  if (_t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var Mt = 0, $t = Object.getOwnPropertySymbols(_t); Mt < $t.length; Mt++)
      Et.indexOf($t[Mt]) < 0 && Object.prototype.propertyIsEnumerable.call(_t, $t[Mt]) && (Pt[$t[Mt]] = _t[$t[Mt]]);
  return Pt;
};
const CheckableTag$1 = /* @__PURE__ */ React.forwardRef((_t, Et) => {
  const {
    prefixCls: Pt,
    style: $t,
    className: Mt,
    checked: Bt,
    onChange: Vt,
    onClick: zt
  } = _t, Ht = __rest$1(_t, ["prefixCls", "style", "className", "checked", "onChange", "onClick"]), {
    getPrefixCls: Wt,
    tag: Gt
  } = React.useContext(ConfigContext), qt = (Jt) => {
    Vt == null || Vt(!Bt), zt == null || zt(Jt);
  }, Kt = Wt("tag", Pt), [Qt, Xt, Zt] = useStyle(Kt), Yt = classNames(Kt, `${Kt}-checkable`, {
    [`${Kt}-checkable-checked`]: Bt
  }, Gt == null ? void 0 : Gt.className, Mt, Xt, Zt);
  return Qt(/* @__PURE__ */ React.createElement("span", Object.assign({}, Ht, {
    ref: Et,
    style: Object.assign(Object.assign({}, $t), Gt == null ? void 0 : Gt.style),
    className: Yt,
    onClick: qt
  })));
}), genPresetStyle = (_t) => genPresetColor(_t, (Et, Pt) => {
  let {
    textColor: $t,
    lightBorderColor: Mt,
    lightColor: Bt,
    darkColor: Vt
  } = Pt;
  return {
    [`${_t.componentCls}${_t.componentCls}-${Et}`]: {
      color: $t,
      background: Bt,
      borderColor: Mt,
      // Inverse color
      "&-inverse": {
        color: _t.colorTextLightSolid,
        background: Vt,
        borderColor: Vt
      },
      [`&${_t.componentCls}-borderless`]: {
        borderColor: "transparent"
      }
    }
  };
}), PresetCmp = genSubStyleComponent(["Tag", "preset"], (_t) => {
  const Et = prepareToken(_t);
  return genPresetStyle(Et);
}, prepareComponentToken);
function capitalize(_t) {
  return typeof _t != "string" ? _t : _t.charAt(0).toUpperCase() + _t.slice(1);
}
const genTagStatusStyle = (_t, Et, Pt) => {
  const $t = capitalize(Pt);
  return {
    [`${_t.componentCls}${_t.componentCls}-${Et}`]: {
      color: _t[`color${Pt}`],
      background: _t[`color${$t}Bg`],
      borderColor: _t[`color${$t}Border`],
      [`&${_t.componentCls}-borderless`]: {
        borderColor: "transparent"
      }
    }
  };
}, StatusCmp = genSubStyleComponent(["Tag", "status"], (_t) => {
  const Et = prepareToken(_t);
  return [genTagStatusStyle(Et, "success", "Success"), genTagStatusStyle(Et, "processing", "Info"), genTagStatusStyle(Et, "error", "Error"), genTagStatusStyle(Et, "warning", "Warning")];
}, prepareComponentToken);
var __rest = function(_t, Et) {
  var Pt = {};
  for (var $t in _t)
    Object.prototype.hasOwnProperty.call(_t, $t) && Et.indexOf($t) < 0 && (Pt[$t] = _t[$t]);
  if (_t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var Mt = 0, $t = Object.getOwnPropertySymbols(_t); Mt < $t.length; Mt++)
      Et.indexOf($t[Mt]) < 0 && Object.prototype.propertyIsEnumerable.call(_t, $t[Mt]) && (Pt[$t[Mt]] = _t[$t[Mt]]);
  return Pt;
};
const InternalTag = /* @__PURE__ */ React.forwardRef((_t, Et) => {
  const {
    prefixCls: Pt,
    className: $t,
    rootClassName: Mt,
    style: Bt,
    children: Vt,
    icon: zt,
    color: Ht,
    onClose: Wt,
    bordered: Gt = !0,
    visible: qt
  } = _t, Kt = __rest(_t, ["prefixCls", "className", "rootClassName", "style", "children", "icon", "color", "onClose", "bordered", "visible"]), {
    getPrefixCls: Qt,
    direction: Xt,
    tag: Zt
  } = React.useContext(ConfigContext), [Yt, Jt] = React.useState(!0), er = omit(Kt, ["closeIcon", "closable"]);
  browser$1.env.NODE_ENV !== "production" && devUseWarning("Tag").deprecated(!("visible" in _t), "visible", "visible && <Tag />"), React.useEffect(() => {
    qt !== void 0 && Jt(qt);
  }, [qt]);
  const tr = isPresetColor(Ht), nr = isPresetStatusColor(Ht), rr = tr || nr, ir = Object.assign(Object.assign({
    backgroundColor: Ht && !rr ? Ht : void 0
  }, Zt == null ? void 0 : Zt.style), Bt), ar = Qt("tag", Pt), [or, sr, lr] = useStyle(ar), cr = classNames(ar, Zt == null ? void 0 : Zt.className, {
    [`${ar}-${Ht}`]: rr,
    [`${ar}-has-color`]: Ht && !rr,
    [`${ar}-hidden`]: !Yt,
    [`${ar}-rtl`]: Xt === "rtl",
    [`${ar}-borderless`]: !Gt
  }, $t, Mt, sr, lr), hr = (ur) => {
    ur.stopPropagation(), Wt == null || Wt(ur), !ur.defaultPrevented && Jt(!1);
  }, [, pr] = useClosable(pickClosable(_t), pickClosable(Zt), {
    closable: !1,
    closeIconRender: (ur) => {
      const vr = /* @__PURE__ */ React.createElement("span", {
        className: `${ar}-close-icon`,
        onClick: hr
      }, ur);
      return replaceElement(ur, vr, (dr) => ({
        onClick: (br) => {
          var Cr;
          (Cr = dr == null ? void 0 : dr.onClick) === null || Cr === void 0 || Cr.call(dr, br), hr(br);
        },
        className: classNames(dr == null ? void 0 : dr.className, `${ar}-close-icon`)
      }));
    }
  }), mr = typeof Kt.onClick == "function" || Vt && Vt.type === "a", Er = zt || null, _r = Er ? /* @__PURE__ */ React.createElement(React.Fragment, null, Er, Vt && /* @__PURE__ */ React.createElement("span", null, Vt)) : Vt, yr = /* @__PURE__ */ React.createElement("span", Object.assign({}, er, {
    ref: Et,
    className: cr,
    style: ir
  }), _r, pr, tr && /* @__PURE__ */ React.createElement(PresetCmp, {
    key: "preset",
    prefixCls: ar
  }), nr && /* @__PURE__ */ React.createElement(StatusCmp, {
    key: "status",
    prefixCls: ar
  }));
  return or(mr ? /* @__PURE__ */ React.createElement(Wave, {
    component: "Tag"
  }, yr) : yr);
}), Tag = InternalTag;
browser$1.env.NODE_ENV !== "production" && (Tag.displayName = "Tag");
Tag.CheckableTag = CheckableTag$1;
const QuotaWarning = ({
  quotas: _t,
  workspaceId: Et,
  dark: Pt,
  availableOrFull: $t
}) => {
  const {
    t: Mt
  } = useTranslation(), Bt = useConfig$1(), [Vt, zt] = useState(!0), [Ht, Wt] = useState(!1), Gt = _t.length === 1 ? Mt("settings_menu.quota_warning.singular_text", {
    app: _t[0].appName
  }) : Mt("settings_menu.quota_warning.plural_text"), qt = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    Mt("settings_menu.quota_warning.manage_text", {
      app: _t.map((Qt) => Qt.appName).join(", ")
    }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { style: {
      padding: 0
    }, type: "link", onClick: () => {
      Wt(!0);
    }, children: Mt("settings_menu.quota_warning.learn_why_button") })
  ] }), Kt = () => {
    openMfe("quota-mgt", {
      workspaceId: Et ?? "",
      userLanguage: i18nInstance.language
    }, Bt.getAccountsURL() + `/app/quota?workspace=${Et}`);
  };
  return Vt && _t.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(QuotaContainer, { $dark: Pt, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "quota-container", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "header-container", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: {
          display: "flex",
          flexDirection: "row",
          marginLeft: "8px"
        }, children: _t.map((Qt) => /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: Qt.appIcon, style: {
          height: "32px",
          width: "32px",
          marginLeft: "-8px"
        }, alt: Qt.appName + "logo" }, Qt.appName)) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(RefIcon$6, { className: "close-icon", onClick: () => zt(!1) })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "body-container", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "title", children: Mt("settings_menu.quota_warning.empower_title", {
          app: _t.length === 1 ? _t[0].appName : Mt("settings_menu.quota_warning.more_apps_title")
        }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "content", children: $t === "available" ? Gt : qt })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Button, { className: "button-container", onClick: Kt, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: Mt("settings_menu.quota_warning.manage_quota_button") }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonIcon, {})
      ] })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledModalAppCard$1, { title: !1, footer: null, closable: !1, open: Ht, width: 630, style: {
      padding: 0
    }, styles: {
      body: {
        padding: 0
      }
    }, maskClosable: !0, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "header", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "title", children: Mt("settings_menu.quota_warning.about_title") }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { type: "text", className: "close", onClick: () => Wt(!1), children: /* @__PURE__ */ jsxRuntimeExports.jsx(RefIcon$6, {}) })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "body", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(QuotaSet, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: Mt("settings_menu.quota_warning.has_area_quota_text", {
            app: _t.map((Qt) => Qt.appName).join(", ")
          }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: Mt("settings_menu.quota_warning.to_free_up_quota_text") })
        ] })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "footer", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { size: "large", type: "text", onClick: () => Wt(!1), children: Mt("common.button.dismiss") }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Button, { type: "primary", size: "large", onClick: Kt, children: [
          Mt("settings_menu.quota_warning.manage_quota_button"),
          /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonIcon, { fill: "#fff" })
        ] })
      ] })
    ] })
  ] });
}, QuotaWarningGroup = React__default.memo(({
  workspaceId: _t,
  organizationId: Et,
  dark: Pt = !1
}) => {
  const [$t, Mt] = useState([]), Bt = useConfig$1(), Vt = Bt == null ? void 0 : Bt.getAPIURL(), zt = useMemo$1(() => ({
    headers: Bt == null ? void 0 : Bt.getDefaultHeaders()
  }), [Bt]);
  return useEffect(() => {
    _t && QuotaMgtService(Vt, zt).loadAppsAndContracts(_t).then(({
      fieldQuotaByApp: Ht,
      organizationQuotaByApp: Wt
    }) => {
      Mt(Object.values(Ht).map((Gt) => {
        let qt = Gt.total;
        Et && Wt[Gt.id] && (qt = Wt[Gt.id].usageByEntity[Et] ?? 0);
        let Kt = !1, Qt = !1;
        return Gt.assigned === 0 ? Kt = !0 : Gt.assigned >= qt * 0.9 && (Qt = !0), {
          appName: Gt.name,
          appIcon: Gt.icon,
          warnAvailable: Kt,
          warnFull: Qt
        };
      }));
    });
  }, [_t, Et, Vt, zt]), /* @__PURE__ */ jsxRuntimeExports.jsx(ConfigProvider, { prefixCls: "cw-elements", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(CWElementsI18NProvider, { ns: "settings-menu", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(QuotaWarning, { quotas: $t.filter((Ht) => Ht.warnAvailable), dark: Pt, workspaceId: _t, availableOrFull: "available" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(QuotaWarning, { quotas: $t.filter((Ht) => Ht.warnFull), dark: Pt, workspaceId: _t, availableOrFull: "full" })
  ] }) });
}), QuotaContainer = dt$1.div`
  .quota-container {
    font-family: 'Noto Sans', sans-serif;
    display: flex;
    flex-direction: column;
    padding: 12px 16px;
    align-items: flex-start;
    max-width: 243px;
    gap: 10px;
    margin-bottom: 12px;

    border-radius: 8px;

    ${({
  $dark: _t
}) => _t === !1 ? lt$1`
          background-color: #fff;
          border: 1px solid #c2c7d0;
        ` : lt$1`
          background-color: #232630;
          border: 1px solid #363948;
        `}

    .header-container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-bottom: 4px;

      width: 100%;

      .close-icon {
        cursor: pointer;
        color: #696f88;
        height: 18px;
        width: 18px;
      }
    }

    .body-container {
      .title {
        ${({
  $dark: _t
}) => _t === !1 ? lt$1`
              color: #14151c;
            ` : lt$1`
              color: #fff;
            `}

        font-family: Noto Sans;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px; /* 142.857% */
        letter-spacing: -0.105px;

        margin-bottom: 4px;
      }

      .content {
        ${({
  $dark: _t
}) => _t === !1 ? lt$1`
              color: #363948;
            ` : lt$1`
              color: #c2c7d0;
            `}

        font-family: Noto Sans;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
        letter-spacing: -0.105px;
      }
    }

    .button-container {
      display: flex;
      flex-direction: row;
      color: #14151c;

      cursor: pointer;

      width: 100%;
      height: 40px;

      justify-content: center;
      align-items: center;

      border-radius: 4px;
      border: 1px solid #c2c7d0;
      background: #fff;
      text-decoration: none;
      font-size: 14px;

      svg {
        margin-left: 4px;
      }

      ${({
  $dark: _t
}) => {
  if (_t)
    return lt$1`
            color: #fff;
            background-color: transparent;
            text-decoration: none;
          `;
}}

      &:hover {
        color: unset;
        background-color: unset;
        border-color: unset;
      }
    }
  }
`, StyledModalAppCard$1 = dt$1(Modal)`
  height: 429px;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    margin: -24px;
    margin-bottom: 24px;

    border-bottom: 1px solid #dfe2e7;
  }

  .body {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    gap: 8px;

    button {
      border-radius: 4px;

      &.cw-elements-btn-primary {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        background-color: #14803c;
      }
    }
  }
`, SvgArrowRighticon = (_t) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "currentColor", ..._t }, /* @__PURE__ */ React.createElement("path", { d: "M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" }));
var HoverTypes = /* @__PURE__ */ ((_t) => (_t.EXTERNAL = "EXTERNAL", _t.INTERNAL = "INTERNAL", _t))(HoverTypes || {});
const SettingsItemIconContainer = dt$1.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: ${(_t) => _t.$dark ? Neutral[80] : Blue[10]};
  color: ${(_t) => _t.$dark ? Neutral[40] : Blue[60]};
  transition: background-color 400ms ease-in-out;
  flex-shrink: 0;

  svg {
    width: 16px;
    transition: width 200ms ease-in-out;
  }
`, SettingsItemNewTabIcon = dt$1.div`
  position: absolute;
  box-sizing: border-box;
  right: 8px;
  opacity: 0;
  transition: opacity 200ms ease-in-out;
`, SettingsItemLabel = dt$1.p`
  font-size: 14px;
  line-height: 20px;
  margin: 0;
  text-align: start;
  font-family: 'Noto Sans', sans-serif;
`, hoverStyles = lt$1`
  color: ${(_t) => _t.$dark ? Neutral[10] : Neutral[100]};
  background-color: ${(_t) => _t.$dark ? Neutral[80] : Blue[10]};

  ${SettingsItemIconContainer} {
    background-color: ${(_t) => _t.$dark ? Neutral[100] : Blue[20]};
  }

  ${SettingsItemNewTabIcon} {
    opacity: 1;
  }
`, SettingsItemWrapper = dt$1.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  padding: 4px;
  cursor: pointer;
  transition: background-color 400ms ease-in-out;
  color: ${(_t) => _t.$dark ? Neutral[10] : Neutral[100]};
  border: none;
  background: none;
  text-decoration: none;
  width: 100%;

  &:hover {
    ${hoverStyles}
  }

  ${({
  $isHover: _t
}) => _t && hoverStyles};
`, SettingsItemExtraButton = dt$1.button`
  border: 0;
  display: none;
  border-radius: 4px;
  width: 32px;
  height: auto;
  align-items: center;
  justify-content: center;
  background-color: ${(_t) => _t.$dark ? Neutral[80] : Blue[10]};
  cursor: pointer;
  color: ${(_t) => _t.$dark ? "#A3A9B9" : "#0071CD"};

  &:hover {
    display: flex;
  }

  ${({
  $isHover: _t
}) => _t && lt$1`
      display: flex;
    `};
`, SettingsItem = ({
  icon: _t,
  label: Et,
  tooltipText: Pt,
  loading: $t,
  extraButtonTooltipText: Mt,
  dark: Bt = !1,
  secondButton: Vt,
  hoverType: zt = HoverTypes.EXTERNAL,
  ...Ht
}) => {
  const [Wt, Gt] = useState(!1), qt = () => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(SettingsItemIconContainer, { $dark: Bt, children: _t }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(SettingsItemLabel, { children: Et }),
    zt === HoverTypes.EXTERNAL && /* @__PURE__ */ jsxRuntimeExports.jsx(SettingsItemNewTabIcon, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(OpenInNewTab, { dark: Bt }) })
  ] }), Kt = (Xt) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip, { title: Pt, placement: "left", color: Bt ? Neutral[70] : Neutral[90], overlayInnerStyle: {
      borderRadius: 4
    }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(SettingsItemWrapper, { as: "a", href: Xt, $dark: Bt, $isHover: Wt, children: qt() }) }),
    Vt && /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip, { title: Mt, placement: "left", color: Bt ? Neutral[70] : Neutral[90], overlayInnerStyle: {
      borderRadius: 4
    }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(SettingsItemExtraButton, { onClick: Vt, $isHover: Wt, $dark: Bt, "aria-label": Mt, children: /* @__PURE__ */ jsxRuntimeExports.jsx(SvgPlusicon, { "data-testid": "extraButton" }) }) })
  ] }), Qt = (Xt) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip, { title: Pt, placement: "left", color: Bt ? Neutral[70] : Neutral[90], overlayInnerStyle: {
      borderRadius: 4
    }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(SettingsItemWrapper, { as: "button", type: "button", onClick: Xt, $dark: Bt, $isHover: Wt, children: qt() }) }),
    Vt && /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip, { title: Mt, placement: "left", color: Bt ? Neutral[70] : Neutral[90], overlayInnerStyle: {
      borderRadius: 4
    }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(SettingsItemExtraButton, { onClick: Vt, $isHover: Wt, $dark: Bt, "aria-label": Mt, children: /* @__PURE__ */ jsxRuntimeExports.jsx(SvgPlusicon, {}) }) })
  ] });
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { onMouseEnter: () => Gt(!0), onMouseLeave: () => Gt(!1), style: {
    display: "flex",
    gap: "5px"
  }, children: $t ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { "data-testid": "skeleton", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton, { avatar: {
    size: "small",
    shape: "circle"
  }, paragraph: !1, active: !0 }) }) : Ht.onClick ? Qt(Ht.onClick) : Kt(Ht.link) });
}, SettingsGroupWrapper = dt$1.div`
  color: ${(_t) => _t.theme.colors[_t.$dark, "cws_neutral_100"]};
  display: flex;
  flex-direction: column;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid
    ${(_t) => _t.theme.colors[_t.$dark ? "cws_neutral_80" : "cws_neutral_20"]};

  & + & {
    margin-top: 12px;
  }
`, SettingsGroupTitle = dt$1.base`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 4px;
  margin-bottom: 12px;
  border-radius: 4px;
  transition: background-color 400ms ease-in-out;
  cursor: default;
  border: none;
  background: none;
  text-decoration: none;
  color: ${(_t) => _t.theme.colors[_t.$dark ? "cws_neutral_00" : "cws_neutral_100"]};
  font-family: 'Noto Sans', sans-serif;

  .title {
    font-weight: 500;
    margin: 0;
    font-size: 16px;
    line-height: 24px;
    color: ${(_t) => _t.theme.colors[_t.$dark ? "cws_neutral_00" : "cws_neutral_100"]};
  }

  svg {
    color: ${(_t) => _t.theme.colors[_t.$dark ? "cws_neutral_40" : "cws_neutral_60"]};
    transition: transform 400ms ease-in-out;
    margin-left: 4px;
    font-size: 12px;
  }

  ${({
  $withAction: _t,
  theme: Et,
  $dark: Pt
}) => _t && `
    cursor: pointer;
    
    &:hover {
      background-color: ${Et.colors[Pt ? "cws_neutral_80" : "cws_blue_10"]};
    
      .title + svg {
        transform: translateX(4px);
      }
    }
  `}

  & + & {
    margin-top: 12px;
  }

  &:hover {
    .new-tab-icon {
      display: none;
    }

    .arrow-icon {
      display: inline-block;
    }
  }

  .new-tab-icon {
    display: inline-block;
  }

  .arrow-icon {
    display: none;
    height: 16px;
    width: 16px;
  }
`, SettingsGroupCustomIcon = dt$1.div`
  display: flex;
  align-items: center;
  margin-right: 4px;

  svg {
    width: 20px;
  }
`, SettingsGroupItems = dt$1.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  .cw-elements-skeleton {
    display: flex !important;
    align-items: center;

    &-title {
      margin: 0 !important;
    }
  }
`, SettingsGroup = ({
  title: _t,
  tooltipText: Et,
  icon: Pt,
  loading: $t,
  items: Mt,
  dark: Bt = !1,
  ...Vt
}) => {
  const zt = !!Vt.onClickTitle, Ht = !!Vt.titleLink, Wt = () => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    Pt && /* @__PURE__ */ jsxRuntimeExports.jsx(SettingsGroupCustomIcon, { children: Pt }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "title", children: _t }),
    !Pt && (zt || Ht) && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(OpenInNewTab, { className: "new-tab-icon" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(SvgArrowRighticon, { className: "arrow-icon" })
    ] })
  ] }), Gt = () => /* @__PURE__ */ jsxRuntimeExports.jsx(SettingsGroupTitle, { $dark: Bt, $withAction: zt, as: "button", type: "button", onClick: Vt.onClickTitle, children: Wt() }), qt = () => /* @__PURE__ */ jsxRuntimeExports.jsx(SettingsGroupTitle, { $dark: Bt, $withAction: Ht, as: "a", href: Vt.titleLink, children: Wt() }), Kt = () => /* @__PURE__ */ jsxRuntimeExports.jsx(SettingsGroupTitle, { $dark: Bt, as: "div", children: Wt() });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(SettingsGroupWrapper, { $dark: Bt, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip, { placement: "left", title: Et, color: Bt ? "#4D5165" : "#232630", overlayInnerStyle: {
      borderRadius: 4
    }, children: zt ? Gt() : Ht ? qt() : Kt() }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(SettingsGroupItems, { children: Mt.map(({
      key: Qt,
      ...Xt
    }) => /* @__PURE__ */ jsxRuntimeExports.jsx(SettingsItem, { ...Xt, loading: $t, dark: Bt }, Qt)) })
  ] });
};
function bind(_t, Et) {
  return function() {
    return _t.apply(Et, arguments);
  };
}
const { toString: toString$2 } = Object.prototype, { getPrototypeOf } = Object, kindOf = /* @__PURE__ */ ((_t) => (Et) => {
  const Pt = toString$2.call(Et);
  return _t[Pt] || (_t[Pt] = Pt.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), kindOfTest = (_t) => (_t = _t.toLowerCase(), (Et) => kindOf(Et) === _t), typeOfTest = (_t) => (Et) => typeof Et === _t, { isArray: isArray$2 } = Array, isUndefined$1 = typeOfTest("undefined");
function isBuffer$1(_t) {
  return _t !== null && !isUndefined$1(_t) && _t.constructor !== null && !isUndefined$1(_t.constructor) && isFunction$1(_t.constructor.isBuffer) && _t.constructor.isBuffer(_t);
}
const isArrayBuffer = kindOfTest("ArrayBuffer");
function isArrayBufferView(_t) {
  let Et;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? Et = ArrayBuffer.isView(_t) : Et = _t && _t.buffer && isArrayBuffer(_t.buffer), Et;
}
const isString$1 = typeOfTest("string"), isFunction$1 = typeOfTest("function"), isNumber$1 = typeOfTest("number"), isObject$1 = (_t) => _t !== null && typeof _t == "object", isBoolean = (_t) => _t === !0 || _t === !1, isPlainObject = (_t) => {
  if (kindOf(_t) !== "object")
    return !1;
  const Et = getPrototypeOf(_t);
  return (Et === null || Et === Object.prototype || Object.getPrototypeOf(Et) === null) && !(Symbol.toStringTag in _t) && !(Symbol.iterator in _t);
}, isDate$1 = kindOfTest("Date"), isFile = kindOfTest("File"), isBlob = kindOfTest("Blob"), isFileList = kindOfTest("FileList"), isStream = (_t) => isObject$1(_t) && isFunction$1(_t.pipe), isFormData = (_t) => {
  let Et;
  return _t && (typeof FormData == "function" && _t instanceof FormData || isFunction$1(_t.append) && ((Et = kindOf(_t)) === "formdata" || // detect form-data instance
  Et === "object" && isFunction$1(_t.toString) && _t.toString() === "[object FormData]"));
}, isURLSearchParams = kindOfTest("URLSearchParams"), [isReadableStream, isRequest, isResponse, isHeaders] = ["ReadableStream", "Request", "Response", "Headers"].map(kindOfTest), trim = (_t) => _t.trim ? _t.trim() : _t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function forEach(_t, Et, { allOwnKeys: Pt = !1 } = {}) {
  if (_t === null || typeof _t > "u")
    return;
  let $t, Mt;
  if (typeof _t != "object" && (_t = [_t]), isArray$2(_t))
    for ($t = 0, Mt = _t.length; $t < Mt; $t++)
      Et.call(null, _t[$t], $t, _t);
  else {
    const Bt = Pt ? Object.getOwnPropertyNames(_t) : Object.keys(_t), Vt = Bt.length;
    let zt;
    for ($t = 0; $t < Vt; $t++)
      zt = Bt[$t], Et.call(null, _t[zt], zt, _t);
  }
}
function findKey(_t, Et) {
  Et = Et.toLowerCase();
  const Pt = Object.keys(_t);
  let $t = Pt.length, Mt;
  for (; $t-- > 0; )
    if (Mt = Pt[$t], Et === Mt.toLowerCase())
      return Mt;
  return null;
}
const _global = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global$2, isContextDefined = (_t) => !isUndefined$1(_t) && _t !== _global;
function merge() {
  const { caseless: _t } = isContextDefined(this) && this || {}, Et = {}, Pt = ($t, Mt) => {
    const Bt = _t && findKey(Et, Mt) || Mt;
    isPlainObject(Et[Bt]) && isPlainObject($t) ? Et[Bt] = merge(Et[Bt], $t) : isPlainObject($t) ? Et[Bt] = merge({}, $t) : isArray$2($t) ? Et[Bt] = $t.slice() : Et[Bt] = $t;
  };
  for (let $t = 0, Mt = arguments.length; $t < Mt; $t++)
    arguments[$t] && forEach(arguments[$t], Pt);
  return Et;
}
const extend$1 = (_t, Et, Pt, { allOwnKeys: $t } = {}) => (forEach(Et, (Mt, Bt) => {
  Pt && isFunction$1(Mt) ? _t[Bt] = bind(Mt, Pt) : _t[Bt] = Mt;
}, { allOwnKeys: $t }), _t), stripBOM = (_t) => (_t.charCodeAt(0) === 65279 && (_t = _t.slice(1)), _t), inherits = (_t, Et, Pt, $t) => {
  _t.prototype = Object.create(Et.prototype, $t), _t.prototype.constructor = _t, Object.defineProperty(_t, "super", {
    value: Et.prototype
  }), Pt && Object.assign(_t.prototype, Pt);
}, toFlatObject = (_t, Et, Pt, $t) => {
  let Mt, Bt, Vt;
  const zt = {};
  if (Et = Et || {}, _t == null)
    return Et;
  do {
    for (Mt = Object.getOwnPropertyNames(_t), Bt = Mt.length; Bt-- > 0; )
      Vt = Mt[Bt], (!$t || $t(Vt, _t, Et)) && !zt[Vt] && (Et[Vt] = _t[Vt], zt[Vt] = !0);
    _t = Pt !== !1 && getPrototypeOf(_t);
  } while (_t && (!Pt || Pt(_t, Et)) && _t !== Object.prototype);
  return Et;
}, endsWith = (_t, Et, Pt) => {
  _t = String(_t), (Pt === void 0 || Pt > _t.length) && (Pt = _t.length), Pt -= Et.length;
  const $t = _t.indexOf(Et, Pt);
  return $t !== -1 && $t === Pt;
}, toArray$1 = (_t) => {
  if (!_t)
    return null;
  if (isArray$2(_t))
    return _t;
  let Et = _t.length;
  if (!isNumber$1(Et))
    return null;
  const Pt = new Array(Et);
  for (; Et-- > 0; )
    Pt[Et] = _t[Et];
  return Pt;
}, isTypedArray = /* @__PURE__ */ ((_t) => (Et) => _t && Et instanceof _t)(typeof Uint8Array < "u" && getPrototypeOf(Uint8Array)), forEachEntry = (_t, Et) => {
  const $t = (_t && _t[Symbol.iterator]).call(_t);
  let Mt;
  for (; (Mt = $t.next()) && !Mt.done; ) {
    const Bt = Mt.value;
    Et.call(_t, Bt[0], Bt[1]);
  }
}, matchAll = (_t, Et) => {
  let Pt;
  const $t = [];
  for (; (Pt = _t.exec(Et)) !== null; )
    $t.push(Pt);
  return $t;
}, isHTMLForm = kindOfTest("HTMLFormElement"), toCamelCase = (_t) => _t.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(Pt, $t, Mt) {
    return $t.toUpperCase() + Mt;
  }
), hasOwnProperty = (({ hasOwnProperty: _t }) => (Et, Pt) => _t.call(Et, Pt))(Object.prototype), isRegExp = kindOfTest("RegExp"), reduceDescriptors = (_t, Et) => {
  const Pt = Object.getOwnPropertyDescriptors(_t), $t = {};
  forEach(Pt, (Mt, Bt) => {
    let Vt;
    (Vt = Et(Mt, Bt, _t)) !== !1 && ($t[Bt] = Vt || Mt);
  }), Object.defineProperties(_t, $t);
}, freezeMethods = (_t) => {
  reduceDescriptors(_t, (Et, Pt) => {
    if (isFunction$1(_t) && ["arguments", "caller", "callee"].indexOf(Pt) !== -1)
      return !1;
    const $t = _t[Pt];
    if (isFunction$1($t)) {
      if (Et.enumerable = !1, "writable" in Et) {
        Et.writable = !1;
        return;
      }
      Et.set || (Et.set = () => {
        throw Error("Can not rewrite read-only method '" + Pt + "'");
      });
    }
  });
}, toObjectSet = (_t, Et) => {
  const Pt = {}, $t = (Mt) => {
    Mt.forEach((Bt) => {
      Pt[Bt] = !0;
    });
  };
  return isArray$2(_t) ? $t(_t) : $t(String(_t).split(Et)), Pt;
}, noop = () => {
}, toFiniteNumber = (_t, Et) => _t != null && Number.isFinite(_t = +_t) ? _t : Et, ALPHA = "abcdefghijklmnopqrstuvwxyz", DIGIT = "0123456789", ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
}, generateString = (_t = 16, Et = ALPHABET.ALPHA_DIGIT) => {
  let Pt = "";
  const { length: $t } = Et;
  for (; _t--; )
    Pt += Et[Math.random() * $t | 0];
  return Pt;
};
function isSpecCompliantForm(_t) {
  return !!(_t && isFunction$1(_t.append) && _t[Symbol.toStringTag] === "FormData" && _t[Symbol.iterator]);
}
const toJSONObject = (_t) => {
  const Et = new Array(10), Pt = ($t, Mt) => {
    if (isObject$1($t)) {
      if (Et.indexOf($t) >= 0)
        return;
      if (!("toJSON" in $t)) {
        Et[Mt] = $t;
        const Bt = isArray$2($t) ? [] : {};
        return forEach($t, (Vt, zt) => {
          const Ht = Pt(Vt, Mt + 1);
          !isUndefined$1(Ht) && (Bt[zt] = Ht);
        }), Et[Mt] = void 0, Bt;
      }
    }
    return $t;
  };
  return Pt(_t, 0);
}, isAsyncFn = kindOfTest("AsyncFunction"), isThenable = (_t) => _t && (isObject$1(_t) || isFunction$1(_t)) && isFunction$1(_t.then) && isFunction$1(_t.catch), _setImmediate = ((_t, Et) => _t ? setImmediate : Et ? ((Pt, $t) => (_global.addEventListener("message", ({ source: Mt, data: Bt }) => {
  Mt === _global && Bt === Pt && $t.length && $t.shift()();
}, !1), (Mt) => {
  $t.push(Mt), _global.postMessage(Pt, "*");
}))(`axios@${Math.random()}`, []) : (Pt) => setTimeout(Pt))(
  typeof setImmediate == "function",
  isFunction$1(_global.postMessage)
), asap = typeof queueMicrotask < "u" ? queueMicrotask.bind(_global) : typeof browser$1 < "u" && browser$1.nextTick || _setImmediate, utils$1 = {
  isArray: isArray$2,
  isArrayBuffer,
  isBuffer: isBuffer$1,
  isFormData,
  isArrayBufferView,
  isString: isString$1,
  isNumber: isNumber$1,
  isBoolean,
  isObject: isObject$1,
  isPlainObject,
  isReadableStream,
  isRequest,
  isResponse,
  isHeaders,
  isUndefined: isUndefined$1,
  isDate: isDate$1,
  isFile,
  isBlob,
  isRegExp,
  isFunction: isFunction$1,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend: extend$1,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray: toArray$1,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty,
  hasOwnProp: hasOwnProperty,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable,
  setImmediate: _setImmediate,
  asap
};
var lookup = [], revLookup = [], Arr = typeof Uint8Array < "u" ? Uint8Array : Array, inited = !1;
function init() {
  inited = !0;
  for (var _t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Et = 0, Pt = _t.length; Et < Pt; ++Et)
    lookup[Et] = _t[Et], revLookup[_t.charCodeAt(Et)] = Et;
  revLookup[45] = 62, revLookup[95] = 63;
}
function toByteArray(_t) {
  inited || init();
  var Et, Pt, $t, Mt, Bt, Vt, zt = _t.length;
  if (zt % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  Bt = _t[zt - 2] === "=" ? 2 : _t[zt - 1] === "=" ? 1 : 0, Vt = new Arr(zt * 3 / 4 - Bt), $t = Bt > 0 ? zt - 4 : zt;
  var Ht = 0;
  for (Et = 0, Pt = 0; Et < $t; Et += 4, Pt += 3)
    Mt = revLookup[_t.charCodeAt(Et)] << 18 | revLookup[_t.charCodeAt(Et + 1)] << 12 | revLookup[_t.charCodeAt(Et + 2)] << 6 | revLookup[_t.charCodeAt(Et + 3)], Vt[Ht++] = Mt >> 16 & 255, Vt[Ht++] = Mt >> 8 & 255, Vt[Ht++] = Mt & 255;
  return Bt === 2 ? (Mt = revLookup[_t.charCodeAt(Et)] << 2 | revLookup[_t.charCodeAt(Et + 1)] >> 4, Vt[Ht++] = Mt & 255) : Bt === 1 && (Mt = revLookup[_t.charCodeAt(Et)] << 10 | revLookup[_t.charCodeAt(Et + 1)] << 4 | revLookup[_t.charCodeAt(Et + 2)] >> 2, Vt[Ht++] = Mt >> 8 & 255, Vt[Ht++] = Mt & 255), Vt;
}
function tripletToBase64(_t) {
  return lookup[_t >> 18 & 63] + lookup[_t >> 12 & 63] + lookup[_t >> 6 & 63] + lookup[_t & 63];
}
function encodeChunk(_t, Et, Pt) {
  for (var $t, Mt = [], Bt = Et; Bt < Pt; Bt += 3)
    $t = (_t[Bt] << 16) + (_t[Bt + 1] << 8) + _t[Bt + 2], Mt.push(tripletToBase64($t));
  return Mt.join("");
}
function fromByteArray(_t) {
  inited || init();
  for (var Et, Pt = _t.length, $t = Pt % 3, Mt = "", Bt = [], Vt = 16383, zt = 0, Ht = Pt - $t; zt < Ht; zt += Vt)
    Bt.push(encodeChunk(_t, zt, zt + Vt > Ht ? Ht : zt + Vt));
  return $t === 1 ? (Et = _t[Pt - 1], Mt += lookup[Et >> 2], Mt += lookup[Et << 4 & 63], Mt += "==") : $t === 2 && (Et = (_t[Pt - 2] << 8) + _t[Pt - 1], Mt += lookup[Et >> 10], Mt += lookup[Et >> 4 & 63], Mt += lookup[Et << 2 & 63], Mt += "="), Bt.push(Mt), Bt.join("");
}
function read(_t, Et, Pt, $t, Mt) {
  var Bt, Vt, zt = Mt * 8 - $t - 1, Ht = (1 << zt) - 1, Wt = Ht >> 1, Gt = -7, qt = Pt ? Mt - 1 : 0, Kt = Pt ? -1 : 1, Qt = _t[Et + qt];
  for (qt += Kt, Bt = Qt & (1 << -Gt) - 1, Qt >>= -Gt, Gt += zt; Gt > 0; Bt = Bt * 256 + _t[Et + qt], qt += Kt, Gt -= 8)
    ;
  for (Vt = Bt & (1 << -Gt) - 1, Bt >>= -Gt, Gt += $t; Gt > 0; Vt = Vt * 256 + _t[Et + qt], qt += Kt, Gt -= 8)
    ;
  if (Bt === 0)
    Bt = 1 - Wt;
  else {
    if (Bt === Ht)
      return Vt ? NaN : (Qt ? -1 : 1) * (1 / 0);
    Vt = Vt + Math.pow(2, $t), Bt = Bt - Wt;
  }
  return (Qt ? -1 : 1) * Vt * Math.pow(2, Bt - $t);
}
function write(_t, Et, Pt, $t, Mt, Bt) {
  var Vt, zt, Ht, Wt = Bt * 8 - Mt - 1, Gt = (1 << Wt) - 1, qt = Gt >> 1, Kt = Mt === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, Qt = $t ? 0 : Bt - 1, Xt = $t ? 1 : -1, Zt = Et < 0 || Et === 0 && 1 / Et < 0 ? 1 : 0;
  for (Et = Math.abs(Et), isNaN(Et) || Et === 1 / 0 ? (zt = isNaN(Et) ? 1 : 0, Vt = Gt) : (Vt = Math.floor(Math.log(Et) / Math.LN2), Et * (Ht = Math.pow(2, -Vt)) < 1 && (Vt--, Ht *= 2), Vt + qt >= 1 ? Et += Kt / Ht : Et += Kt * Math.pow(2, 1 - qt), Et * Ht >= 2 && (Vt++, Ht /= 2), Vt + qt >= Gt ? (zt = 0, Vt = Gt) : Vt + qt >= 1 ? (zt = (Et * Ht - 1) * Math.pow(2, Mt), Vt = Vt + qt) : (zt = Et * Math.pow(2, qt - 1) * Math.pow(2, Mt), Vt = 0)); Mt >= 8; _t[Pt + Qt] = zt & 255, Qt += Xt, zt /= 256, Mt -= 8)
    ;
  for (Vt = Vt << Mt | zt, Wt += Mt; Wt > 0; _t[Pt + Qt] = Vt & 255, Qt += Xt, Vt /= 256, Wt -= 8)
    ;
  _t[Pt + Qt - Xt] |= Zt * 128;
}
var toString$1 = {}.toString, isArray$1 = Array.isArray || function(_t) {
  return toString$1.call(_t) == "[object Array]";
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
var INSPECT_MAX_BYTES = 50;
Buffer.TYPED_ARRAY_SUPPORT = global$2.TYPED_ARRAY_SUPPORT !== void 0 ? global$2.TYPED_ARRAY_SUPPORT : !0;
kMaxLength();
function kMaxLength() {
  return Buffer.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
}
function createBuffer(_t, Et) {
  if (kMaxLength() < Et)
    throw new RangeError("Invalid typed array length");
  return Buffer.TYPED_ARRAY_SUPPORT ? (_t = new Uint8Array(Et), _t.__proto__ = Buffer.prototype) : (_t === null && (_t = new Buffer(Et)), _t.length = Et), _t;
}
function Buffer(_t, Et, Pt) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer))
    return new Buffer(_t, Et, Pt);
  if (typeof _t == "number") {
    if (typeof Et == "string")
      throw new Error("If encoding is specified then the first argument must be a string");
    return allocUnsafe(this, _t);
  }
  return from$1(this, _t, Et, Pt);
}
Buffer.poolSize = 8192;
Buffer._augment = function(_t) {
  return _t.__proto__ = Buffer.prototype, _t;
};
function from$1(_t, Et, Pt, $t) {
  if (typeof Et == "number")
    throw new TypeError('"value" argument must not be a number');
  return typeof ArrayBuffer < "u" && Et instanceof ArrayBuffer ? fromArrayBuffer(_t, Et, Pt, $t) : typeof Et == "string" ? fromString(_t, Et, Pt) : fromObject(_t, Et);
}
Buffer.from = function(_t, Et, Pt) {
  return from$1(null, _t, Et, Pt);
};
Buffer.TYPED_ARRAY_SUPPORT && (Buffer.prototype.__proto__ = Uint8Array.prototype, Buffer.__proto__ = Uint8Array, typeof Symbol < "u" && Symbol.species && Buffer[Symbol.species]);
function assertSize(_t) {
  if (typeof _t != "number")
    throw new TypeError('"size" argument must be a number');
  if (_t < 0)
    throw new RangeError('"size" argument must not be negative');
}
function alloc(_t, Et, Pt, $t) {
  return assertSize(Et), Et <= 0 ? createBuffer(_t, Et) : Pt !== void 0 ? typeof $t == "string" ? createBuffer(_t, Et).fill(Pt, $t) : createBuffer(_t, Et).fill(Pt) : createBuffer(_t, Et);
}
Buffer.alloc = function(_t, Et, Pt) {
  return alloc(null, _t, Et, Pt);
};
function allocUnsafe(_t, Et) {
  if (assertSize(Et), _t = createBuffer(_t, Et < 0 ? 0 : checked(Et) | 0), !Buffer.TYPED_ARRAY_SUPPORT)
    for (var Pt = 0; Pt < Et; ++Pt)
      _t[Pt] = 0;
  return _t;
}
Buffer.allocUnsafe = function(_t) {
  return allocUnsafe(null, _t);
};
Buffer.allocUnsafeSlow = function(_t) {
  return allocUnsafe(null, _t);
};
function fromString(_t, Et, Pt) {
  if ((typeof Pt != "string" || Pt === "") && (Pt = "utf8"), !Buffer.isEncoding(Pt))
    throw new TypeError('"encoding" must be a valid string encoding');
  var $t = byteLength(Et, Pt) | 0;
  _t = createBuffer(_t, $t);
  var Mt = _t.write(Et, Pt);
  return Mt !== $t && (_t = _t.slice(0, Mt)), _t;
}
function fromArrayLike(_t, Et) {
  var Pt = Et.length < 0 ? 0 : checked(Et.length) | 0;
  _t = createBuffer(_t, Pt);
  for (var $t = 0; $t < Pt; $t += 1)
    _t[$t] = Et[$t] & 255;
  return _t;
}
function fromArrayBuffer(_t, Et, Pt, $t) {
  if (Et.byteLength, Pt < 0 || Et.byteLength < Pt)
    throw new RangeError("'offset' is out of bounds");
  if (Et.byteLength < Pt + ($t || 0))
    throw new RangeError("'length' is out of bounds");
  return Pt === void 0 && $t === void 0 ? Et = new Uint8Array(Et) : $t === void 0 ? Et = new Uint8Array(Et, Pt) : Et = new Uint8Array(Et, Pt, $t), Buffer.TYPED_ARRAY_SUPPORT ? (_t = Et, _t.__proto__ = Buffer.prototype) : _t = fromArrayLike(_t, Et), _t;
}
function fromObject(_t, Et) {
  if (internalIsBuffer(Et)) {
    var Pt = checked(Et.length) | 0;
    return _t = createBuffer(_t, Pt), _t.length === 0 || Et.copy(_t, 0, 0, Pt), _t;
  }
  if (Et) {
    if (typeof ArrayBuffer < "u" && Et.buffer instanceof ArrayBuffer || "length" in Et)
      return typeof Et.length != "number" || isnan(Et.length) ? createBuffer(_t, 0) : fromArrayLike(_t, Et);
    if (Et.type === "Buffer" && isArray$1(Et.data))
      return fromArrayLike(_t, Et.data);
  }
  throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function checked(_t) {
  if (_t >= kMaxLength())
    throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + kMaxLength().toString(16) + " bytes");
  return _t | 0;
}
Buffer.isBuffer = isBuffer;
function internalIsBuffer(_t) {
  return !!(_t != null && _t._isBuffer);
}
Buffer.compare = function(Et, Pt) {
  if (!internalIsBuffer(Et) || !internalIsBuffer(Pt))
    throw new TypeError("Arguments must be Buffers");
  if (Et === Pt)
    return 0;
  for (var $t = Et.length, Mt = Pt.length, Bt = 0, Vt = Math.min($t, Mt); Bt < Vt; ++Bt)
    if (Et[Bt] !== Pt[Bt]) {
      $t = Et[Bt], Mt = Pt[Bt];
      break;
    }
  return $t < Mt ? -1 : Mt < $t ? 1 : 0;
};
Buffer.isEncoding = function(Et) {
  switch (String(Et).toLowerCase()) {
    case "hex":
    case "utf8":
    case "utf-8":
    case "ascii":
    case "latin1":
    case "binary":
    case "base64":
    case "ucs2":
    case "ucs-2":
    case "utf16le":
    case "utf-16le":
      return !0;
    default:
      return !1;
  }
};
Buffer.concat = function(Et, Pt) {
  if (!isArray$1(Et))
    throw new TypeError('"list" argument must be an Array of Buffers');
  if (Et.length === 0)
    return Buffer.alloc(0);
  var $t;
  if (Pt === void 0)
    for (Pt = 0, $t = 0; $t < Et.length; ++$t)
      Pt += Et[$t].length;
  var Mt = Buffer.allocUnsafe(Pt), Bt = 0;
  for ($t = 0; $t < Et.length; ++$t) {
    var Vt = Et[$t];
    if (!internalIsBuffer(Vt))
      throw new TypeError('"list" argument must be an Array of Buffers');
    Vt.copy(Mt, Bt), Bt += Vt.length;
  }
  return Mt;
};
function byteLength(_t, Et) {
  if (internalIsBuffer(_t))
    return _t.length;
  if (typeof ArrayBuffer < "u" && typeof ArrayBuffer.isView == "function" && (ArrayBuffer.isView(_t) || _t instanceof ArrayBuffer))
    return _t.byteLength;
  typeof _t != "string" && (_t = "" + _t);
  var Pt = _t.length;
  if (Pt === 0)
    return 0;
  for (var $t = !1; ; )
    switch (Et) {
      case "ascii":
      case "latin1":
      case "binary":
        return Pt;
      case "utf8":
      case "utf-8":
      case void 0:
        return utf8ToBytes(_t).length;
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return Pt * 2;
      case "hex":
        return Pt >>> 1;
      case "base64":
        return base64ToBytes(_t).length;
      default:
        if ($t)
          return utf8ToBytes(_t).length;
        Et = ("" + Et).toLowerCase(), $t = !0;
    }
}
Buffer.byteLength = byteLength;
function slowToString(_t, Et, Pt) {
  var $t = !1;
  if ((Et === void 0 || Et < 0) && (Et = 0), Et > this.length || ((Pt === void 0 || Pt > this.length) && (Pt = this.length), Pt <= 0) || (Pt >>>= 0, Et >>>= 0, Pt <= Et))
    return "";
  for (_t || (_t = "utf8"); ; )
    switch (_t) {
      case "hex":
        return hexSlice(this, Et, Pt);
      case "utf8":
      case "utf-8":
        return utf8Slice(this, Et, Pt);
      case "ascii":
        return asciiSlice(this, Et, Pt);
      case "latin1":
      case "binary":
        return latin1Slice(this, Et, Pt);
      case "base64":
        return base64Slice(this, Et, Pt);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return utf16leSlice(this, Et, Pt);
      default:
        if ($t)
          throw new TypeError("Unknown encoding: " + _t);
        _t = (_t + "").toLowerCase(), $t = !0;
    }
}
Buffer.prototype._isBuffer = !0;
function swap(_t, Et, Pt) {
  var $t = _t[Et];
  _t[Et] = _t[Pt], _t[Pt] = $t;
}
Buffer.prototype.swap16 = function() {
  var Et = this.length;
  if (Et % 2 !== 0)
    throw new RangeError("Buffer size must be a multiple of 16-bits");
  for (var Pt = 0; Pt < Et; Pt += 2)
    swap(this, Pt, Pt + 1);
  return this;
};
Buffer.prototype.swap32 = function() {
  var Et = this.length;
  if (Et % 4 !== 0)
    throw new RangeError("Buffer size must be a multiple of 32-bits");
  for (var Pt = 0; Pt < Et; Pt += 4)
    swap(this, Pt, Pt + 3), swap(this, Pt + 1, Pt + 2);
  return this;
};
Buffer.prototype.swap64 = function() {
  var Et = this.length;
  if (Et % 8 !== 0)
    throw new RangeError("Buffer size must be a multiple of 64-bits");
  for (var Pt = 0; Pt < Et; Pt += 8)
    swap(this, Pt, Pt + 7), swap(this, Pt + 1, Pt + 6), swap(this, Pt + 2, Pt + 5), swap(this, Pt + 3, Pt + 4);
  return this;
};
Buffer.prototype.toString = function() {
  var Et = this.length | 0;
  return Et === 0 ? "" : arguments.length === 0 ? utf8Slice(this, 0, Et) : slowToString.apply(this, arguments);
};
Buffer.prototype.equals = function(Et) {
  if (!internalIsBuffer(Et))
    throw new TypeError("Argument must be a Buffer");
  return this === Et ? !0 : Buffer.compare(this, Et) === 0;
};
Buffer.prototype.inspect = function() {
  var Et = "", Pt = INSPECT_MAX_BYTES;
  return this.length > 0 && (Et = this.toString("hex", 0, Pt).match(/.{2}/g).join(" "), this.length > Pt && (Et += " ... ")), "<Buffer " + Et + ">";
};
Buffer.prototype.compare = function(Et, Pt, $t, Mt, Bt) {
  if (!internalIsBuffer(Et))
    throw new TypeError("Argument must be a Buffer");
  if (Pt === void 0 && (Pt = 0), $t === void 0 && ($t = Et ? Et.length : 0), Mt === void 0 && (Mt = 0), Bt === void 0 && (Bt = this.length), Pt < 0 || $t > Et.length || Mt < 0 || Bt > this.length)
    throw new RangeError("out of range index");
  if (Mt >= Bt && Pt >= $t)
    return 0;
  if (Mt >= Bt)
    return -1;
  if (Pt >= $t)
    return 1;
  if (Pt >>>= 0, $t >>>= 0, Mt >>>= 0, Bt >>>= 0, this === Et)
    return 0;
  for (var Vt = Bt - Mt, zt = $t - Pt, Ht = Math.min(Vt, zt), Wt = this.slice(Mt, Bt), Gt = Et.slice(Pt, $t), qt = 0; qt < Ht; ++qt)
    if (Wt[qt] !== Gt[qt]) {
      Vt = Wt[qt], zt = Gt[qt];
      break;
    }
  return Vt < zt ? -1 : zt < Vt ? 1 : 0;
};
function bidirectionalIndexOf(_t, Et, Pt, $t, Mt) {
  if (_t.length === 0)
    return -1;
  if (typeof Pt == "string" ? ($t = Pt, Pt = 0) : Pt > 2147483647 ? Pt = 2147483647 : Pt < -2147483648 && (Pt = -2147483648), Pt = +Pt, isNaN(Pt) && (Pt = Mt ? 0 : _t.length - 1), Pt < 0 && (Pt = _t.length + Pt), Pt >= _t.length) {
    if (Mt)
      return -1;
    Pt = _t.length - 1;
  } else if (Pt < 0)
    if (Mt)
      Pt = 0;
    else
      return -1;
  if (typeof Et == "string" && (Et = Buffer.from(Et, $t)), internalIsBuffer(Et))
    return Et.length === 0 ? -1 : arrayIndexOf(_t, Et, Pt, $t, Mt);
  if (typeof Et == "number")
    return Et = Et & 255, Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf == "function" ? Mt ? Uint8Array.prototype.indexOf.call(_t, Et, Pt) : Uint8Array.prototype.lastIndexOf.call(_t, Et, Pt) : arrayIndexOf(_t, [Et], Pt, $t, Mt);
  throw new TypeError("val must be string, number or Buffer");
}
function arrayIndexOf(_t, Et, Pt, $t, Mt) {
  var Bt = 1, Vt = _t.length, zt = Et.length;
  if ($t !== void 0 && ($t = String($t).toLowerCase(), $t === "ucs2" || $t === "ucs-2" || $t === "utf16le" || $t === "utf-16le")) {
    if (_t.length < 2 || Et.length < 2)
      return -1;
    Bt = 2, Vt /= 2, zt /= 2, Pt /= 2;
  }
  function Ht(Qt, Xt) {
    return Bt === 1 ? Qt[Xt] : Qt.readUInt16BE(Xt * Bt);
  }
  var Wt;
  if (Mt) {
    var Gt = -1;
    for (Wt = Pt; Wt < Vt; Wt++)
      if (Ht(_t, Wt) === Ht(Et, Gt === -1 ? 0 : Wt - Gt)) {
        if (Gt === -1 && (Gt = Wt), Wt - Gt + 1 === zt)
          return Gt * Bt;
      } else
        Gt !== -1 && (Wt -= Wt - Gt), Gt = -1;
  } else
    for (Pt + zt > Vt && (Pt = Vt - zt), Wt = Pt; Wt >= 0; Wt--) {
      for (var qt = !0, Kt = 0; Kt < zt; Kt++)
        if (Ht(_t, Wt + Kt) !== Ht(Et, Kt)) {
          qt = !1;
          break;
        }
      if (qt)
        return Wt;
    }
  return -1;
}
Buffer.prototype.includes = function(Et, Pt, $t) {
  return this.indexOf(Et, Pt, $t) !== -1;
};
Buffer.prototype.indexOf = function(Et, Pt, $t) {
  return bidirectionalIndexOf(this, Et, Pt, $t, !0);
};
Buffer.prototype.lastIndexOf = function(Et, Pt, $t) {
  return bidirectionalIndexOf(this, Et, Pt, $t, !1);
};
function hexWrite(_t, Et, Pt, $t) {
  Pt = Number(Pt) || 0;
  var Mt = _t.length - Pt;
  $t ? ($t = Number($t), $t > Mt && ($t = Mt)) : $t = Mt;
  var Bt = Et.length;
  if (Bt % 2 !== 0)
    throw new TypeError("Invalid hex string");
  $t > Bt / 2 && ($t = Bt / 2);
  for (var Vt = 0; Vt < $t; ++Vt) {
    var zt = parseInt(Et.substr(Vt * 2, 2), 16);
    if (isNaN(zt))
      return Vt;
    _t[Pt + Vt] = zt;
  }
  return Vt;
}
function utf8Write(_t, Et, Pt, $t) {
  return blitBuffer(utf8ToBytes(Et, _t.length - Pt), _t, Pt, $t);
}
function asciiWrite(_t, Et, Pt, $t) {
  return blitBuffer(asciiToBytes(Et), _t, Pt, $t);
}
function latin1Write(_t, Et, Pt, $t) {
  return asciiWrite(_t, Et, Pt, $t);
}
function base64Write(_t, Et, Pt, $t) {
  return blitBuffer(base64ToBytes(Et), _t, Pt, $t);
}
function ucs2Write(_t, Et, Pt, $t) {
  return blitBuffer(utf16leToBytes(Et, _t.length - Pt), _t, Pt, $t);
}
Buffer.prototype.write = function(Et, Pt, $t, Mt) {
  if (Pt === void 0)
    Mt = "utf8", $t = this.length, Pt = 0;
  else if ($t === void 0 && typeof Pt == "string")
    Mt = Pt, $t = this.length, Pt = 0;
  else if (isFinite(Pt))
    Pt = Pt | 0, isFinite($t) ? ($t = $t | 0, Mt === void 0 && (Mt = "utf8")) : (Mt = $t, $t = void 0);
  else
    throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
  var Bt = this.length - Pt;
  if (($t === void 0 || $t > Bt) && ($t = Bt), Et.length > 0 && ($t < 0 || Pt < 0) || Pt > this.length)
    throw new RangeError("Attempt to write outside buffer bounds");
  Mt || (Mt = "utf8");
  for (var Vt = !1; ; )
    switch (Mt) {
      case "hex":
        return hexWrite(this, Et, Pt, $t);
      case "utf8":
      case "utf-8":
        return utf8Write(this, Et, Pt, $t);
      case "ascii":
        return asciiWrite(this, Et, Pt, $t);
      case "latin1":
      case "binary":
        return latin1Write(this, Et, Pt, $t);
      case "base64":
        return base64Write(this, Et, Pt, $t);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return ucs2Write(this, Et, Pt, $t);
      default:
        if (Vt)
          throw new TypeError("Unknown encoding: " + Mt);
        Mt = ("" + Mt).toLowerCase(), Vt = !0;
    }
};
Buffer.prototype.toJSON = function() {
  return {
    type: "Buffer",
    data: Array.prototype.slice.call(this._arr || this, 0)
  };
};
function base64Slice(_t, Et, Pt) {
  return Et === 0 && Pt === _t.length ? fromByteArray(_t) : fromByteArray(_t.slice(Et, Pt));
}
function utf8Slice(_t, Et, Pt) {
  Pt = Math.min(_t.length, Pt);
  for (var $t = [], Mt = Et; Mt < Pt; ) {
    var Bt = _t[Mt], Vt = null, zt = Bt > 239 ? 4 : Bt > 223 ? 3 : Bt > 191 ? 2 : 1;
    if (Mt + zt <= Pt) {
      var Ht, Wt, Gt, qt;
      switch (zt) {
        case 1:
          Bt < 128 && (Vt = Bt);
          break;
        case 2:
          Ht = _t[Mt + 1], (Ht & 192) === 128 && (qt = (Bt & 31) << 6 | Ht & 63, qt > 127 && (Vt = qt));
          break;
        case 3:
          Ht = _t[Mt + 1], Wt = _t[Mt + 2], (Ht & 192) === 128 && (Wt & 192) === 128 && (qt = (Bt & 15) << 12 | (Ht & 63) << 6 | Wt & 63, qt > 2047 && (qt < 55296 || qt > 57343) && (Vt = qt));
          break;
        case 4:
          Ht = _t[Mt + 1], Wt = _t[Mt + 2], Gt = _t[Mt + 3], (Ht & 192) === 128 && (Wt & 192) === 128 && (Gt & 192) === 128 && (qt = (Bt & 15) << 18 | (Ht & 63) << 12 | (Wt & 63) << 6 | Gt & 63, qt > 65535 && qt < 1114112 && (Vt = qt));
      }
    }
    Vt === null ? (Vt = 65533, zt = 1) : Vt > 65535 && (Vt -= 65536, $t.push(Vt >>> 10 & 1023 | 55296), Vt = 56320 | Vt & 1023), $t.push(Vt), Mt += zt;
  }
  return decodeCodePointsArray($t);
}
var MAX_ARGUMENTS_LENGTH = 4096;
function decodeCodePointsArray(_t) {
  var Et = _t.length;
  if (Et <= MAX_ARGUMENTS_LENGTH)
    return String.fromCharCode.apply(String, _t);
  for (var Pt = "", $t = 0; $t < Et; )
    Pt += String.fromCharCode.apply(String, _t.slice($t, $t += MAX_ARGUMENTS_LENGTH));
  return Pt;
}
function asciiSlice(_t, Et, Pt) {
  var $t = "";
  Pt = Math.min(_t.length, Pt);
  for (var Mt = Et; Mt < Pt; ++Mt)
    $t += String.fromCharCode(_t[Mt] & 127);
  return $t;
}
function latin1Slice(_t, Et, Pt) {
  var $t = "";
  Pt = Math.min(_t.length, Pt);
  for (var Mt = Et; Mt < Pt; ++Mt)
    $t += String.fromCharCode(_t[Mt]);
  return $t;
}
function hexSlice(_t, Et, Pt) {
  var $t = _t.length;
  (!Et || Et < 0) && (Et = 0), (!Pt || Pt < 0 || Pt > $t) && (Pt = $t);
  for (var Mt = "", Bt = Et; Bt < Pt; ++Bt)
    Mt += toHex(_t[Bt]);
  return Mt;
}
function utf16leSlice(_t, Et, Pt) {
  for (var $t = _t.slice(Et, Pt), Mt = "", Bt = 0; Bt < $t.length; Bt += 2)
    Mt += String.fromCharCode($t[Bt] + $t[Bt + 1] * 256);
  return Mt;
}
Buffer.prototype.slice = function(Et, Pt) {
  var $t = this.length;
  Et = ~~Et, Pt = Pt === void 0 ? $t : ~~Pt, Et < 0 ? (Et += $t, Et < 0 && (Et = 0)) : Et > $t && (Et = $t), Pt < 0 ? (Pt += $t, Pt < 0 && (Pt = 0)) : Pt > $t && (Pt = $t), Pt < Et && (Pt = Et);
  var Mt;
  if (Buffer.TYPED_ARRAY_SUPPORT)
    Mt = this.subarray(Et, Pt), Mt.__proto__ = Buffer.prototype;
  else {
    var Bt = Pt - Et;
    Mt = new Buffer(Bt, void 0);
    for (var Vt = 0; Vt < Bt; ++Vt)
      Mt[Vt] = this[Vt + Et];
  }
  return Mt;
};
function checkOffset(_t, Et, Pt) {
  if (_t % 1 !== 0 || _t < 0)
    throw new RangeError("offset is not uint");
  if (_t + Et > Pt)
    throw new RangeError("Trying to access beyond buffer length");
}
Buffer.prototype.readUIntLE = function(Et, Pt, $t) {
  Et = Et | 0, Pt = Pt | 0, $t || checkOffset(Et, Pt, this.length);
  for (var Mt = this[Et], Bt = 1, Vt = 0; ++Vt < Pt && (Bt *= 256); )
    Mt += this[Et + Vt] * Bt;
  return Mt;
};
Buffer.prototype.readUIntBE = function(Et, Pt, $t) {
  Et = Et | 0, Pt = Pt | 0, $t || checkOffset(Et, Pt, this.length);
  for (var Mt = this[Et + --Pt], Bt = 1; Pt > 0 && (Bt *= 256); )
    Mt += this[Et + --Pt] * Bt;
  return Mt;
};
Buffer.prototype.readUInt8 = function(Et, Pt) {
  return Pt || checkOffset(Et, 1, this.length), this[Et];
};
Buffer.prototype.readUInt16LE = function(Et, Pt) {
  return Pt || checkOffset(Et, 2, this.length), this[Et] | this[Et + 1] << 8;
};
Buffer.prototype.readUInt16BE = function(Et, Pt) {
  return Pt || checkOffset(Et, 2, this.length), this[Et] << 8 | this[Et + 1];
};
Buffer.prototype.readUInt32LE = function(Et, Pt) {
  return Pt || checkOffset(Et, 4, this.length), (this[Et] | this[Et + 1] << 8 | this[Et + 2] << 16) + this[Et + 3] * 16777216;
};
Buffer.prototype.readUInt32BE = function(Et, Pt) {
  return Pt || checkOffset(Et, 4, this.length), this[Et] * 16777216 + (this[Et + 1] << 16 | this[Et + 2] << 8 | this[Et + 3]);
};
Buffer.prototype.readIntLE = function(Et, Pt, $t) {
  Et = Et | 0, Pt = Pt | 0, $t || checkOffset(Et, Pt, this.length);
  for (var Mt = this[Et], Bt = 1, Vt = 0; ++Vt < Pt && (Bt *= 256); )
    Mt += this[Et + Vt] * Bt;
  return Bt *= 128, Mt >= Bt && (Mt -= Math.pow(2, 8 * Pt)), Mt;
};
Buffer.prototype.readIntBE = function(Et, Pt, $t) {
  Et = Et | 0, Pt = Pt | 0, $t || checkOffset(Et, Pt, this.length);
  for (var Mt = Pt, Bt = 1, Vt = this[Et + --Mt]; Mt > 0 && (Bt *= 256); )
    Vt += this[Et + --Mt] * Bt;
  return Bt *= 128, Vt >= Bt && (Vt -= Math.pow(2, 8 * Pt)), Vt;
};
Buffer.prototype.readInt8 = function(Et, Pt) {
  return Pt || checkOffset(Et, 1, this.length), this[Et] & 128 ? (255 - this[Et] + 1) * -1 : this[Et];
};
Buffer.prototype.readInt16LE = function(Et, Pt) {
  Pt || checkOffset(Et, 2, this.length);
  var $t = this[Et] | this[Et + 1] << 8;
  return $t & 32768 ? $t | 4294901760 : $t;
};
Buffer.prototype.readInt16BE = function(Et, Pt) {
  Pt || checkOffset(Et, 2, this.length);
  var $t = this[Et + 1] | this[Et] << 8;
  return $t & 32768 ? $t | 4294901760 : $t;
};
Buffer.prototype.readInt32LE = function(Et, Pt) {
  return Pt || checkOffset(Et, 4, this.length), this[Et] | this[Et + 1] << 8 | this[Et + 2] << 16 | this[Et + 3] << 24;
};
Buffer.prototype.readInt32BE = function(Et, Pt) {
  return Pt || checkOffset(Et, 4, this.length), this[Et] << 24 | this[Et + 1] << 16 | this[Et + 2] << 8 | this[Et + 3];
};
Buffer.prototype.readFloatLE = function(Et, Pt) {
  return Pt || checkOffset(Et, 4, this.length), read(this, Et, !0, 23, 4);
};
Buffer.prototype.readFloatBE = function(Et, Pt) {
  return Pt || checkOffset(Et, 4, this.length), read(this, Et, !1, 23, 4);
};
Buffer.prototype.readDoubleLE = function(Et, Pt) {
  return Pt || checkOffset(Et, 8, this.length), read(this, Et, !0, 52, 8);
};
Buffer.prototype.readDoubleBE = function(Et, Pt) {
  return Pt || checkOffset(Et, 8, this.length), read(this, Et, !1, 52, 8);
};
function checkInt(_t, Et, Pt, $t, Mt, Bt) {
  if (!internalIsBuffer(_t))
    throw new TypeError('"buffer" argument must be a Buffer instance');
  if (Et > Mt || Et < Bt)
    throw new RangeError('"value" argument is out of bounds');
  if (Pt + $t > _t.length)
    throw new RangeError("Index out of range");
}
Buffer.prototype.writeUIntLE = function(Et, Pt, $t, Mt) {
  if (Et = +Et, Pt = Pt | 0, $t = $t | 0, !Mt) {
    var Bt = Math.pow(2, 8 * $t) - 1;
    checkInt(this, Et, Pt, $t, Bt, 0);
  }
  var Vt = 1, zt = 0;
  for (this[Pt] = Et & 255; ++zt < $t && (Vt *= 256); )
    this[Pt + zt] = Et / Vt & 255;
  return Pt + $t;
};
Buffer.prototype.writeUIntBE = function(Et, Pt, $t, Mt) {
  if (Et = +Et, Pt = Pt | 0, $t = $t | 0, !Mt) {
    var Bt = Math.pow(2, 8 * $t) - 1;
    checkInt(this, Et, Pt, $t, Bt, 0);
  }
  var Vt = $t - 1, zt = 1;
  for (this[Pt + Vt] = Et & 255; --Vt >= 0 && (zt *= 256); )
    this[Pt + Vt] = Et / zt & 255;
  return Pt + $t;
};
Buffer.prototype.writeUInt8 = function(Et, Pt, $t) {
  return Et = +Et, Pt = Pt | 0, $t || checkInt(this, Et, Pt, 1, 255, 0), Buffer.TYPED_ARRAY_SUPPORT || (Et = Math.floor(Et)), this[Pt] = Et & 255, Pt + 1;
};
function objectWriteUInt16(_t, Et, Pt, $t) {
  Et < 0 && (Et = 65535 + Et + 1);
  for (var Mt = 0, Bt = Math.min(_t.length - Pt, 2); Mt < Bt; ++Mt)
    _t[Pt + Mt] = (Et & 255 << 8 * ($t ? Mt : 1 - Mt)) >>> ($t ? Mt : 1 - Mt) * 8;
}
Buffer.prototype.writeUInt16LE = function(Et, Pt, $t) {
  return Et = +Et, Pt = Pt | 0, $t || checkInt(this, Et, Pt, 2, 65535, 0), Buffer.TYPED_ARRAY_SUPPORT ? (this[Pt] = Et & 255, this[Pt + 1] = Et >>> 8) : objectWriteUInt16(this, Et, Pt, !0), Pt + 2;
};
Buffer.prototype.writeUInt16BE = function(Et, Pt, $t) {
  return Et = +Et, Pt = Pt | 0, $t || checkInt(this, Et, Pt, 2, 65535, 0), Buffer.TYPED_ARRAY_SUPPORT ? (this[Pt] = Et >>> 8, this[Pt + 1] = Et & 255) : objectWriteUInt16(this, Et, Pt, !1), Pt + 2;
};
function objectWriteUInt32(_t, Et, Pt, $t) {
  Et < 0 && (Et = 4294967295 + Et + 1);
  for (var Mt = 0, Bt = Math.min(_t.length - Pt, 4); Mt < Bt; ++Mt)
    _t[Pt + Mt] = Et >>> ($t ? Mt : 3 - Mt) * 8 & 255;
}
Buffer.prototype.writeUInt32LE = function(Et, Pt, $t) {
  return Et = +Et, Pt = Pt | 0, $t || checkInt(this, Et, Pt, 4, 4294967295, 0), Buffer.TYPED_ARRAY_SUPPORT ? (this[Pt + 3] = Et >>> 24, this[Pt + 2] = Et >>> 16, this[Pt + 1] = Et >>> 8, this[Pt] = Et & 255) : objectWriteUInt32(this, Et, Pt, !0), Pt + 4;
};
Buffer.prototype.writeUInt32BE = function(Et, Pt, $t) {
  return Et = +Et, Pt = Pt | 0, $t || checkInt(this, Et, Pt, 4, 4294967295, 0), Buffer.TYPED_ARRAY_SUPPORT ? (this[Pt] = Et >>> 24, this[Pt + 1] = Et >>> 16, this[Pt + 2] = Et >>> 8, this[Pt + 3] = Et & 255) : objectWriteUInt32(this, Et, Pt, !1), Pt + 4;
};
Buffer.prototype.writeIntLE = function(Et, Pt, $t, Mt) {
  if (Et = +Et, Pt = Pt | 0, !Mt) {
    var Bt = Math.pow(2, 8 * $t - 1);
    checkInt(this, Et, Pt, $t, Bt - 1, -Bt);
  }
  var Vt = 0, zt = 1, Ht = 0;
  for (this[Pt] = Et & 255; ++Vt < $t && (zt *= 256); )
    Et < 0 && Ht === 0 && this[Pt + Vt - 1] !== 0 && (Ht = 1), this[Pt + Vt] = (Et / zt >> 0) - Ht & 255;
  return Pt + $t;
};
Buffer.prototype.writeIntBE = function(Et, Pt, $t, Mt) {
  if (Et = +Et, Pt = Pt | 0, !Mt) {
    var Bt = Math.pow(2, 8 * $t - 1);
    checkInt(this, Et, Pt, $t, Bt - 1, -Bt);
  }
  var Vt = $t - 1, zt = 1, Ht = 0;
  for (this[Pt + Vt] = Et & 255; --Vt >= 0 && (zt *= 256); )
    Et < 0 && Ht === 0 && this[Pt + Vt + 1] !== 0 && (Ht = 1), this[Pt + Vt] = (Et / zt >> 0) - Ht & 255;
  return Pt + $t;
};
Buffer.prototype.writeInt8 = function(Et, Pt, $t) {
  return Et = +Et, Pt = Pt | 0, $t || checkInt(this, Et, Pt, 1, 127, -128), Buffer.TYPED_ARRAY_SUPPORT || (Et = Math.floor(Et)), Et < 0 && (Et = 255 + Et + 1), this[Pt] = Et & 255, Pt + 1;
};
Buffer.prototype.writeInt16LE = function(Et, Pt, $t) {
  return Et = +Et, Pt = Pt | 0, $t || checkInt(this, Et, Pt, 2, 32767, -32768), Buffer.TYPED_ARRAY_SUPPORT ? (this[Pt] = Et & 255, this[Pt + 1] = Et >>> 8) : objectWriteUInt16(this, Et, Pt, !0), Pt + 2;
};
Buffer.prototype.writeInt16BE = function(Et, Pt, $t) {
  return Et = +Et, Pt = Pt | 0, $t || checkInt(this, Et, Pt, 2, 32767, -32768), Buffer.TYPED_ARRAY_SUPPORT ? (this[Pt] = Et >>> 8, this[Pt + 1] = Et & 255) : objectWriteUInt16(this, Et, Pt, !1), Pt + 2;
};
Buffer.prototype.writeInt32LE = function(Et, Pt, $t) {
  return Et = +Et, Pt = Pt | 0, $t || checkInt(this, Et, Pt, 4, 2147483647, -2147483648), Buffer.TYPED_ARRAY_SUPPORT ? (this[Pt] = Et & 255, this[Pt + 1] = Et >>> 8, this[Pt + 2] = Et >>> 16, this[Pt + 3] = Et >>> 24) : objectWriteUInt32(this, Et, Pt, !0), Pt + 4;
};
Buffer.prototype.writeInt32BE = function(Et, Pt, $t) {
  return Et = +Et, Pt = Pt | 0, $t || checkInt(this, Et, Pt, 4, 2147483647, -2147483648), Et < 0 && (Et = 4294967295 + Et + 1), Buffer.TYPED_ARRAY_SUPPORT ? (this[Pt] = Et >>> 24, this[Pt + 1] = Et >>> 16, this[Pt + 2] = Et >>> 8, this[Pt + 3] = Et & 255) : objectWriteUInt32(this, Et, Pt, !1), Pt + 4;
};
function checkIEEE754(_t, Et, Pt, $t, Mt, Bt) {
  if (Pt + $t > _t.length)
    throw new RangeError("Index out of range");
  if (Pt < 0)
    throw new RangeError("Index out of range");
}
function writeFloat(_t, Et, Pt, $t, Mt) {
  return Mt || checkIEEE754(_t, Et, Pt, 4), write(_t, Et, Pt, $t, 23, 4), Pt + 4;
}
Buffer.prototype.writeFloatLE = function(Et, Pt, $t) {
  return writeFloat(this, Et, Pt, !0, $t);
};
Buffer.prototype.writeFloatBE = function(Et, Pt, $t) {
  return writeFloat(this, Et, Pt, !1, $t);
};
function writeDouble(_t, Et, Pt, $t, Mt) {
  return Mt || checkIEEE754(_t, Et, Pt, 8), write(_t, Et, Pt, $t, 52, 8), Pt + 8;
}
Buffer.prototype.writeDoubleLE = function(Et, Pt, $t) {
  return writeDouble(this, Et, Pt, !0, $t);
};
Buffer.prototype.writeDoubleBE = function(Et, Pt, $t) {
  return writeDouble(this, Et, Pt, !1, $t);
};
Buffer.prototype.copy = function(Et, Pt, $t, Mt) {
  if ($t || ($t = 0), !Mt && Mt !== 0 && (Mt = this.length), Pt >= Et.length && (Pt = Et.length), Pt || (Pt = 0), Mt > 0 && Mt < $t && (Mt = $t), Mt === $t || Et.length === 0 || this.length === 0)
    return 0;
  if (Pt < 0)
    throw new RangeError("targetStart out of bounds");
  if ($t < 0 || $t >= this.length)
    throw new RangeError("sourceStart out of bounds");
  if (Mt < 0)
    throw new RangeError("sourceEnd out of bounds");
  Mt > this.length && (Mt = this.length), Et.length - Pt < Mt - $t && (Mt = Et.length - Pt + $t);
  var Bt = Mt - $t, Vt;
  if (this === Et && $t < Pt && Pt < Mt)
    for (Vt = Bt - 1; Vt >= 0; --Vt)
      Et[Vt + Pt] = this[Vt + $t];
  else if (Bt < 1e3 || !Buffer.TYPED_ARRAY_SUPPORT)
    for (Vt = 0; Vt < Bt; ++Vt)
      Et[Vt + Pt] = this[Vt + $t];
  else
    Uint8Array.prototype.set.call(Et, this.subarray($t, $t + Bt), Pt);
  return Bt;
};
Buffer.prototype.fill = function(Et, Pt, $t, Mt) {
  if (typeof Et == "string") {
    if (typeof Pt == "string" ? (Mt = Pt, Pt = 0, $t = this.length) : typeof $t == "string" && (Mt = $t, $t = this.length), Et.length === 1) {
      var Bt = Et.charCodeAt(0);
      Bt < 256 && (Et = Bt);
    }
    if (Mt !== void 0 && typeof Mt != "string")
      throw new TypeError("encoding must be a string");
    if (typeof Mt == "string" && !Buffer.isEncoding(Mt))
      throw new TypeError("Unknown encoding: " + Mt);
  } else
    typeof Et == "number" && (Et = Et & 255);
  if (Pt < 0 || this.length < Pt || this.length < $t)
    throw new RangeError("Out of range index");
  if ($t <= Pt)
    return this;
  Pt = Pt >>> 0, $t = $t === void 0 ? this.length : $t >>> 0, Et || (Et = 0);
  var Vt;
  if (typeof Et == "number")
    for (Vt = Pt; Vt < $t; ++Vt)
      this[Vt] = Et;
  else {
    var zt = internalIsBuffer(Et) ? Et : utf8ToBytes(new Buffer(Et, Mt).toString()), Ht = zt.length;
    for (Vt = 0; Vt < $t - Pt; ++Vt)
      this[Vt + Pt] = zt[Vt % Ht];
  }
  return this;
};
var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function base64clean(_t) {
  if (_t = stringtrim(_t).replace(INVALID_BASE64_RE, ""), _t.length < 2)
    return "";
  for (; _t.length % 4 !== 0; )
    _t = _t + "=";
  return _t;
}
function stringtrim(_t) {
  return _t.trim ? _t.trim() : _t.replace(/^\s+|\s+$/g, "");
}
function toHex(_t) {
  return _t < 16 ? "0" + _t.toString(16) : _t.toString(16);
}
function utf8ToBytes(_t, Et) {
  Et = Et || 1 / 0;
  for (var Pt, $t = _t.length, Mt = null, Bt = [], Vt = 0; Vt < $t; ++Vt) {
    if (Pt = _t.charCodeAt(Vt), Pt > 55295 && Pt < 57344) {
      if (!Mt) {
        if (Pt > 56319) {
          (Et -= 3) > -1 && Bt.push(239, 191, 189);
          continue;
        } else if (Vt + 1 === $t) {
          (Et -= 3) > -1 && Bt.push(239, 191, 189);
          continue;
        }
        Mt = Pt;
        continue;
      }
      if (Pt < 56320) {
        (Et -= 3) > -1 && Bt.push(239, 191, 189), Mt = Pt;
        continue;
      }
      Pt = (Mt - 55296 << 10 | Pt - 56320) + 65536;
    } else
      Mt && (Et -= 3) > -1 && Bt.push(239, 191, 189);
    if (Mt = null, Pt < 128) {
      if ((Et -= 1) < 0)
        break;
      Bt.push(Pt);
    } else if (Pt < 2048) {
      if ((Et -= 2) < 0)
        break;
      Bt.push(Pt >> 6 | 192, Pt & 63 | 128);
    } else if (Pt < 65536) {
      if ((Et -= 3) < 0)
        break;
      Bt.push(Pt >> 12 | 224, Pt >> 6 & 63 | 128, Pt & 63 | 128);
    } else if (Pt < 1114112) {
      if ((Et -= 4) < 0)
        break;
      Bt.push(Pt >> 18 | 240, Pt >> 12 & 63 | 128, Pt >> 6 & 63 | 128, Pt & 63 | 128);
    } else
      throw new Error("Invalid code point");
  }
  return Bt;
}
function asciiToBytes(_t) {
  for (var Et = [], Pt = 0; Pt < _t.length; ++Pt)
    Et.push(_t.charCodeAt(Pt) & 255);
  return Et;
}
function utf16leToBytes(_t, Et) {
  for (var Pt, $t, Mt, Bt = [], Vt = 0; Vt < _t.length && !((Et -= 2) < 0); ++Vt)
    Pt = _t.charCodeAt(Vt), $t = Pt >> 8, Mt = Pt % 256, Bt.push(Mt), Bt.push($t);
  return Bt;
}
function base64ToBytes(_t) {
  return toByteArray(base64clean(_t));
}
function blitBuffer(_t, Et, Pt, $t) {
  for (var Mt = 0; Mt < $t && !(Mt + Pt >= Et.length || Mt >= _t.length); ++Mt)
    Et[Mt + Pt] = _t[Mt];
  return Mt;
}
function isnan(_t) {
  return _t !== _t;
}
function isBuffer(_t) {
  return _t != null && (!!_t._isBuffer || isFastBuffer(_t) || isSlowBuffer(_t));
}
function isFastBuffer(_t) {
  return !!_t.constructor && typeof _t.constructor.isBuffer == "function" && _t.constructor.isBuffer(_t);
}
function isSlowBuffer(_t) {
  return typeof _t.readFloatLE == "function" && typeof _t.slice == "function" && isFastBuffer(_t.slice(0, 0));
}
function AxiosError(_t, Et, Pt, $t, Mt) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = _t, this.name = "AxiosError", Et && (this.code = Et), Pt && (this.config = Pt), $t && (this.request = $t), Mt && (this.response = Mt, this.status = Mt.status ? Mt.status : null);
}
utils$1.inherits(AxiosError, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils$1.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const prototype$1 = AxiosError.prototype, descriptors = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((_t) => {
  descriptors[_t] = { value: _t };
});
Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype$1, "isAxiosError", { value: !0 });
AxiosError.from = (_t, Et, Pt, $t, Mt, Bt) => {
  const Vt = Object.create(prototype$1);
  return utils$1.toFlatObject(_t, Vt, function(Ht) {
    return Ht !== Error.prototype;
  }, (zt) => zt !== "isAxiosError"), AxiosError.call(Vt, _t.message, Et, Pt, $t, Mt), Vt.cause = _t, Vt.name = _t.name, Bt && Object.assign(Vt, Bt), Vt;
};
const httpAdapter = null;
function isVisitable(_t) {
  return utils$1.isPlainObject(_t) || utils$1.isArray(_t);
}
function removeBrackets(_t) {
  return utils$1.endsWith(_t, "[]") ? _t.slice(0, -2) : _t;
}
function renderKey(_t, Et, Pt) {
  return _t ? _t.concat(Et).map(function(Mt, Bt) {
    return Mt = removeBrackets(Mt), !Pt && Bt ? "[" + Mt + "]" : Mt;
  }).join(Pt ? "." : "") : Et;
}
function isFlatArray(_t) {
  return utils$1.isArray(_t) && !_t.some(isVisitable);
}
const predicates = utils$1.toFlatObject(utils$1, {}, null, function(Et) {
  return /^is[A-Z]/.test(Et);
});
function toFormData(_t, Et, Pt) {
  if (!utils$1.isObject(_t))
    throw new TypeError("target must be an object");
  Et = Et || new FormData(), Pt = utils$1.toFlatObject(Pt, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(Zt, Yt) {
    return !utils$1.isUndefined(Yt[Zt]);
  });
  const $t = Pt.metaTokens, Mt = Pt.visitor || Gt, Bt = Pt.dots, Vt = Pt.indexes, Ht = (Pt.Blob || typeof Blob < "u" && Blob) && utils$1.isSpecCompliantForm(Et);
  if (!utils$1.isFunction(Mt))
    throw new TypeError("visitor must be a function");
  function Wt(Xt) {
    if (Xt === null)
      return "";
    if (utils$1.isDate(Xt))
      return Xt.toISOString();
    if (!Ht && utils$1.isBlob(Xt))
      throw new AxiosError("Blob is not supported. Use a Buffer instead.");
    return utils$1.isArrayBuffer(Xt) || utils$1.isTypedArray(Xt) ? Ht && typeof Blob == "function" ? new Blob([Xt]) : Buffer.from(Xt) : Xt;
  }
  function Gt(Xt, Zt, Yt) {
    let Jt = Xt;
    if (Xt && !Yt && typeof Xt == "object") {
      if (utils$1.endsWith(Zt, "{}"))
        Zt = $t ? Zt : Zt.slice(0, -2), Xt = JSON.stringify(Xt);
      else if (utils$1.isArray(Xt) && isFlatArray(Xt) || (utils$1.isFileList(Xt) || utils$1.endsWith(Zt, "[]")) && (Jt = utils$1.toArray(Xt)))
        return Zt = removeBrackets(Zt), Jt.forEach(function(tr, nr) {
          !(utils$1.isUndefined(tr) || tr === null) && Et.append(
            // eslint-disable-next-line no-nested-ternary
            Vt === !0 ? renderKey([Zt], nr, Bt) : Vt === null ? Zt : Zt + "[]",
            Wt(tr)
          );
        }), !1;
    }
    return isVisitable(Xt) ? !0 : (Et.append(renderKey(Yt, Zt, Bt), Wt(Xt)), !1);
  }
  const qt = [], Kt = Object.assign(predicates, {
    defaultVisitor: Gt,
    convertValue: Wt,
    isVisitable
  });
  function Qt(Xt, Zt) {
    if (!utils$1.isUndefined(Xt)) {
      if (qt.indexOf(Xt) !== -1)
        throw Error("Circular reference detected in " + Zt.join("."));
      qt.push(Xt), utils$1.forEach(Xt, function(Jt, er) {
        (!(utils$1.isUndefined(Jt) || Jt === null) && Mt.call(
          Et,
          Jt,
          utils$1.isString(er) ? er.trim() : er,
          Zt,
          Kt
        )) === !0 && Qt(Jt, Zt ? Zt.concat(er) : [er]);
      }), qt.pop();
    }
  }
  if (!utils$1.isObject(_t))
    throw new TypeError("data must be an object");
  return Qt(_t), Et;
}
function encode$1(_t) {
  const Et = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(_t).replace(/[!'()~]|%20|%00/g, function($t) {
    return Et[$t];
  });
}
function AxiosURLSearchParams(_t, Et) {
  this._pairs = [], _t && toFormData(_t, this, Et);
}
const prototype = AxiosURLSearchParams.prototype;
prototype.append = function(Et, Pt) {
  this._pairs.push([Et, Pt]);
};
prototype.toString = function(Et) {
  const Pt = Et ? function($t) {
    return Et.call(this, $t, encode$1);
  } : encode$1;
  return this._pairs.map(function(Mt) {
    return Pt(Mt[0]) + "=" + Pt(Mt[1]);
  }, "").join("&");
};
function encode(_t) {
  return encodeURIComponent(_t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function buildURL(_t, Et, Pt) {
  if (!Et)
    return _t;
  const $t = Pt && Pt.encode || encode, Mt = Pt && Pt.serialize;
  let Bt;
  if (Mt ? Bt = Mt(Et, Pt) : Bt = utils$1.isURLSearchParams(Et) ? Et.toString() : new AxiosURLSearchParams(Et, Pt).toString($t), Bt) {
    const Vt = _t.indexOf("#");
    Vt !== -1 && (_t = _t.slice(0, Vt)), _t += (_t.indexOf("?") === -1 ? "?" : "&") + Bt;
  }
  return _t;
}
class InterceptorManager {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(Et, Pt, $t) {
    return this.handlers.push({
      fulfilled: Et,
      rejected: Pt,
      synchronous: $t ? $t.synchronous : !1,
      runWhen: $t ? $t.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(Et) {
    this.handlers[Et] && (this.handlers[Et] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(Et) {
    utils$1.forEach(this.handlers, function($t) {
      $t !== null && Et($t);
    });
  }
}
const transitionalDefaults = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, URLSearchParams$1 = typeof URLSearchParams < "u" ? URLSearchParams : AxiosURLSearchParams, FormData$1 = typeof FormData < "u" ? FormData : null, Blob$1 = typeof Blob < "u" ? Blob : null, platform$1 = {
  isBrowser: !0,
  classes: {
    URLSearchParams: URLSearchParams$1,
    FormData: FormData$1,
    Blob: Blob$1
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, hasBrowserEnv = typeof window < "u" && typeof document < "u", _navigator = typeof navigator == "object" && navigator || void 0, hasStandardBrowserEnv = hasBrowserEnv && (!_navigator || ["ReactNative", "NativeScript", "NS"].indexOf(_navigator.product) < 0), hasStandardBrowserWebWorkerEnv = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", origin = hasBrowserEnv && window.location.href || "http://localhost", utils = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv,
  hasStandardBrowserEnv,
  hasStandardBrowserWebWorkerEnv,
  navigator: _navigator,
  origin
}, Symbol.toStringTag, { value: "Module" })), platform = {
  ...utils,
  ...platform$1
};
function toURLEncodedForm(_t, Et) {
  return toFormData(_t, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(Pt, $t, Mt, Bt) {
      return platform.isNode && utils$1.isBuffer(Pt) ? (this.append($t, Pt.toString("base64")), !1) : Bt.defaultVisitor.apply(this, arguments);
    }
  }, Et));
}
function parsePropPath(_t) {
  return utils$1.matchAll(/\w+|\[(\w*)]/g, _t).map((Et) => Et[0] === "[]" ? "" : Et[1] || Et[0]);
}
function arrayToObject(_t) {
  const Et = {}, Pt = Object.keys(_t);
  let $t;
  const Mt = Pt.length;
  let Bt;
  for ($t = 0; $t < Mt; $t++)
    Bt = Pt[$t], Et[Bt] = _t[Bt];
  return Et;
}
function formDataToJSON(_t) {
  function Et(Pt, $t, Mt, Bt) {
    let Vt = Pt[Bt++];
    if (Vt === "__proto__")
      return !0;
    const zt = Number.isFinite(+Vt), Ht = Bt >= Pt.length;
    return Vt = !Vt && utils$1.isArray(Mt) ? Mt.length : Vt, Ht ? (utils$1.hasOwnProp(Mt, Vt) ? Mt[Vt] = [Mt[Vt], $t] : Mt[Vt] = $t, !zt) : ((!Mt[Vt] || !utils$1.isObject(Mt[Vt])) && (Mt[Vt] = []), Et(Pt, $t, Mt[Vt], Bt) && utils$1.isArray(Mt[Vt]) && (Mt[Vt] = arrayToObject(Mt[Vt])), !zt);
  }
  if (utils$1.isFormData(_t) && utils$1.isFunction(_t.entries)) {
    const Pt = {};
    return utils$1.forEachEntry(_t, ($t, Mt) => {
      Et(parsePropPath($t), Mt, Pt, 0);
    }), Pt;
  }
  return null;
}
function stringifySafely(_t, Et, Pt) {
  if (utils$1.isString(_t))
    try {
      return (Et || JSON.parse)(_t), utils$1.trim(_t);
    } catch ($t) {
      if ($t.name !== "SyntaxError")
        throw $t;
    }
  return (Pt || JSON.stringify)(_t);
}
const defaults$1 = {
  transitional: transitionalDefaults,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(Et, Pt) {
    const $t = Pt.getContentType() || "", Mt = $t.indexOf("application/json") > -1, Bt = utils$1.isObject(Et);
    if (Bt && utils$1.isHTMLForm(Et) && (Et = new FormData(Et)), utils$1.isFormData(Et))
      return Mt ? JSON.stringify(formDataToJSON(Et)) : Et;
    if (utils$1.isArrayBuffer(Et) || utils$1.isBuffer(Et) || utils$1.isStream(Et) || utils$1.isFile(Et) || utils$1.isBlob(Et) || utils$1.isReadableStream(Et))
      return Et;
    if (utils$1.isArrayBufferView(Et))
      return Et.buffer;
    if (utils$1.isURLSearchParams(Et))
      return Pt.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), Et.toString();
    let zt;
    if (Bt) {
      if ($t.indexOf("application/x-www-form-urlencoded") > -1)
        return toURLEncodedForm(Et, this.formSerializer).toString();
      if ((zt = utils$1.isFileList(Et)) || $t.indexOf("multipart/form-data") > -1) {
        const Ht = this.env && this.env.FormData;
        return toFormData(
          zt ? { "files[]": Et } : Et,
          Ht && new Ht(),
          this.formSerializer
        );
      }
    }
    return Bt || Mt ? (Pt.setContentType("application/json", !1), stringifySafely(Et)) : Et;
  }],
  transformResponse: [function(Et) {
    const Pt = this.transitional || defaults$1.transitional, $t = Pt && Pt.forcedJSONParsing, Mt = this.responseType === "json";
    if (utils$1.isResponse(Et) || utils$1.isReadableStream(Et))
      return Et;
    if (Et && utils$1.isString(Et) && ($t && !this.responseType || Mt)) {
      const Vt = !(Pt && Pt.silentJSONParsing) && Mt;
      try {
        return JSON.parse(Et);
      } catch (zt) {
        if (Vt)
          throw zt.name === "SyntaxError" ? AxiosError.from(zt, AxiosError.ERR_BAD_RESPONSE, this, null, this.response) : zt;
      }
    }
    return Et;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },
  validateStatus: function(Et) {
    return Et >= 200 && Et < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
utils$1.forEach(["delete", "get", "head", "post", "put", "patch"], (_t) => {
  defaults$1.headers[_t] = {};
});
const ignoreDuplicateOf = utils$1.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), parseHeaders = (_t) => {
  const Et = {};
  let Pt, $t, Mt;
  return _t && _t.split(`
`).forEach(function(Vt) {
    Mt = Vt.indexOf(":"), Pt = Vt.substring(0, Mt).trim().toLowerCase(), $t = Vt.substring(Mt + 1).trim(), !(!Pt || Et[Pt] && ignoreDuplicateOf[Pt]) && (Pt === "set-cookie" ? Et[Pt] ? Et[Pt].push($t) : Et[Pt] = [$t] : Et[Pt] = Et[Pt] ? Et[Pt] + ", " + $t : $t);
  }), Et;
}, $internals = Symbol("internals");
function normalizeHeader(_t) {
  return _t && String(_t).trim().toLowerCase();
}
function normalizeValue(_t) {
  return _t === !1 || _t == null ? _t : utils$1.isArray(_t) ? _t.map(normalizeValue) : String(_t);
}
function parseTokens(_t) {
  const Et = /* @__PURE__ */ Object.create(null), Pt = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let $t;
  for (; $t = Pt.exec(_t); )
    Et[$t[1]] = $t[2];
  return Et;
}
const isValidHeaderName = (_t) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(_t.trim());
function matchHeaderValue(_t, Et, Pt, $t, Mt) {
  if (utils$1.isFunction($t))
    return $t.call(this, Et, Pt);
  if (Mt && (Et = Pt), !!utils$1.isString(Et)) {
    if (utils$1.isString($t))
      return Et.indexOf($t) !== -1;
    if (utils$1.isRegExp($t))
      return $t.test(Et);
  }
}
function formatHeader(_t) {
  return _t.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (Et, Pt, $t) => Pt.toUpperCase() + $t);
}
function buildAccessors(_t, Et) {
  const Pt = utils$1.toCamelCase(" " + Et);
  ["get", "set", "has"].forEach(($t) => {
    Object.defineProperty(_t, $t + Pt, {
      value: function(Mt, Bt, Vt) {
        return this[$t].call(this, Et, Mt, Bt, Vt);
      },
      configurable: !0
    });
  });
}
class AxiosHeaders {
  constructor(Et) {
    Et && this.set(Et);
  }
  set(Et, Pt, $t) {
    const Mt = this;
    function Bt(zt, Ht, Wt) {
      const Gt = normalizeHeader(Ht);
      if (!Gt)
        throw new Error("header name must be a non-empty string");
      const qt = utils$1.findKey(Mt, Gt);
      (!qt || Mt[qt] === void 0 || Wt === !0 || Wt === void 0 && Mt[qt] !== !1) && (Mt[qt || Ht] = normalizeValue(zt));
    }
    const Vt = (zt, Ht) => utils$1.forEach(zt, (Wt, Gt) => Bt(Wt, Gt, Ht));
    if (utils$1.isPlainObject(Et) || Et instanceof this.constructor)
      Vt(Et, Pt);
    else if (utils$1.isString(Et) && (Et = Et.trim()) && !isValidHeaderName(Et))
      Vt(parseHeaders(Et), Pt);
    else if (utils$1.isHeaders(Et))
      for (const [zt, Ht] of Et.entries())
        Bt(Ht, zt, $t);
    else
      Et != null && Bt(Pt, Et, $t);
    return this;
  }
  get(Et, Pt) {
    if (Et = normalizeHeader(Et), Et) {
      const $t = utils$1.findKey(this, Et);
      if ($t) {
        const Mt = this[$t];
        if (!Pt)
          return Mt;
        if (Pt === !0)
          return parseTokens(Mt);
        if (utils$1.isFunction(Pt))
          return Pt.call(this, Mt, $t);
        if (utils$1.isRegExp(Pt))
          return Pt.exec(Mt);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(Et, Pt) {
    if (Et = normalizeHeader(Et), Et) {
      const $t = utils$1.findKey(this, Et);
      return !!($t && this[$t] !== void 0 && (!Pt || matchHeaderValue(this, this[$t], $t, Pt)));
    }
    return !1;
  }
  delete(Et, Pt) {
    const $t = this;
    let Mt = !1;
    function Bt(Vt) {
      if (Vt = normalizeHeader(Vt), Vt) {
        const zt = utils$1.findKey($t, Vt);
        zt && (!Pt || matchHeaderValue($t, $t[zt], zt, Pt)) && (delete $t[zt], Mt = !0);
      }
    }
    return utils$1.isArray(Et) ? Et.forEach(Bt) : Bt(Et), Mt;
  }
  clear(Et) {
    const Pt = Object.keys(this);
    let $t = Pt.length, Mt = !1;
    for (; $t--; ) {
      const Bt = Pt[$t];
      (!Et || matchHeaderValue(this, this[Bt], Bt, Et, !0)) && (delete this[Bt], Mt = !0);
    }
    return Mt;
  }
  normalize(Et) {
    const Pt = this, $t = {};
    return utils$1.forEach(this, (Mt, Bt) => {
      const Vt = utils$1.findKey($t, Bt);
      if (Vt) {
        Pt[Vt] = normalizeValue(Mt), delete Pt[Bt];
        return;
      }
      const zt = Et ? formatHeader(Bt) : String(Bt).trim();
      zt !== Bt && delete Pt[Bt], Pt[zt] = normalizeValue(Mt), $t[zt] = !0;
    }), this;
  }
  concat(...Et) {
    return this.constructor.concat(this, ...Et);
  }
  toJSON(Et) {
    const Pt = /* @__PURE__ */ Object.create(null);
    return utils$1.forEach(this, ($t, Mt) => {
      $t != null && $t !== !1 && (Pt[Mt] = Et && utils$1.isArray($t) ? $t.join(", ") : $t);
    }), Pt;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([Et, Pt]) => Et + ": " + Pt).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(Et) {
    return Et instanceof this ? Et : new this(Et);
  }
  static concat(Et, ...Pt) {
    const $t = new this(Et);
    return Pt.forEach((Mt) => $t.set(Mt)), $t;
  }
  static accessor(Et) {
    const $t = (this[$internals] = this[$internals] = {
      accessors: {}
    }).accessors, Mt = this.prototype;
    function Bt(Vt) {
      const zt = normalizeHeader(Vt);
      $t[zt] || (buildAccessors(Mt, Vt), $t[zt] = !0);
    }
    return utils$1.isArray(Et) ? Et.forEach(Bt) : Bt(Et), this;
  }
}
AxiosHeaders.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
utils$1.reduceDescriptors(AxiosHeaders.prototype, ({ value: _t }, Et) => {
  let Pt = Et[0].toUpperCase() + Et.slice(1);
  return {
    get: () => _t,
    set($t) {
      this[Pt] = $t;
    }
  };
});
utils$1.freezeMethods(AxiosHeaders);
function transformData(_t, Et) {
  const Pt = this || defaults$1, $t = Et || Pt, Mt = AxiosHeaders.from($t.headers);
  let Bt = $t.data;
  return utils$1.forEach(_t, function(zt) {
    Bt = zt.call(Pt, Bt, Mt.normalize(), Et ? Et.status : void 0);
  }), Mt.normalize(), Bt;
}
function isCancel(_t) {
  return !!(_t && _t.__CANCEL__);
}
function CanceledError(_t, Et, Pt) {
  AxiosError.call(this, _t ?? "canceled", AxiosError.ERR_CANCELED, Et, Pt), this.name = "CanceledError";
}
utils$1.inherits(CanceledError, AxiosError, {
  __CANCEL__: !0
});
function settle(_t, Et, Pt) {
  const $t = Pt.config.validateStatus;
  !Pt.status || !$t || $t(Pt.status) ? _t(Pt) : Et(new AxiosError(
    "Request failed with status code " + Pt.status,
    [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(Pt.status / 100) - 4],
    Pt.config,
    Pt.request,
    Pt
  ));
}
function parseProtocol(_t) {
  const Et = /^([-+\w]{1,25})(:?\/\/|:)/.exec(_t);
  return Et && Et[1] || "";
}
function speedometer(_t, Et) {
  _t = _t || 10;
  const Pt = new Array(_t), $t = new Array(_t);
  let Mt = 0, Bt = 0, Vt;
  return Et = Et !== void 0 ? Et : 1e3, function(Ht) {
    const Wt = Date.now(), Gt = $t[Bt];
    Vt || (Vt = Wt), Pt[Mt] = Ht, $t[Mt] = Wt;
    let qt = Bt, Kt = 0;
    for (; qt !== Mt; )
      Kt += Pt[qt++], qt = qt % _t;
    if (Mt = (Mt + 1) % _t, Mt === Bt && (Bt = (Bt + 1) % _t), Wt - Vt < Et)
      return;
    const Qt = Gt && Wt - Gt;
    return Qt ? Math.round(Kt * 1e3 / Qt) : void 0;
  };
}
function throttle(_t, Et) {
  let Pt = 0, $t = 1e3 / Et, Mt, Bt;
  const Vt = (Wt, Gt = Date.now()) => {
    Pt = Gt, Mt = null, Bt && (clearTimeout(Bt), Bt = null), _t.apply(null, Wt);
  };
  return [(...Wt) => {
    const Gt = Date.now(), qt = Gt - Pt;
    qt >= $t ? Vt(Wt, Gt) : (Mt = Wt, Bt || (Bt = setTimeout(() => {
      Bt = null, Vt(Mt);
    }, $t - qt)));
  }, () => Mt && Vt(Mt)];
}
const progressEventReducer = (_t, Et, Pt = 3) => {
  let $t = 0;
  const Mt = speedometer(50, 250);
  return throttle((Bt) => {
    const Vt = Bt.loaded, zt = Bt.lengthComputable ? Bt.total : void 0, Ht = Vt - $t, Wt = Mt(Ht), Gt = Vt <= zt;
    $t = Vt;
    const qt = {
      loaded: Vt,
      total: zt,
      progress: zt ? Vt / zt : void 0,
      bytes: Ht,
      rate: Wt || void 0,
      estimated: Wt && zt && Gt ? (zt - Vt) / Wt : void 0,
      event: Bt,
      lengthComputable: zt != null,
      [Et ? "download" : "upload"]: !0
    };
    _t(qt);
  }, Pt);
}, progressEventDecorator = (_t, Et) => {
  const Pt = _t != null;
  return [($t) => Et[0]({
    lengthComputable: Pt,
    total: _t,
    loaded: $t
  }), Et[1]];
}, asyncDecorator = (_t) => (...Et) => utils$1.asap(() => _t(...Et)), isURLSameOrigin = platform.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const Et = platform.navigator && /(msie|trident)/i.test(platform.navigator.userAgent), Pt = document.createElement("a");
    let $t;
    function Mt(Bt) {
      let Vt = Bt;
      return Et && (Pt.setAttribute("href", Vt), Vt = Pt.href), Pt.setAttribute("href", Vt), {
        href: Pt.href,
        protocol: Pt.protocol ? Pt.protocol.replace(/:$/, "") : "",
        host: Pt.host,
        search: Pt.search ? Pt.search.replace(/^\?/, "") : "",
        hash: Pt.hash ? Pt.hash.replace(/^#/, "") : "",
        hostname: Pt.hostname,
        port: Pt.port,
        pathname: Pt.pathname.charAt(0) === "/" ? Pt.pathname : "/" + Pt.pathname
      };
    }
    return $t = Mt(window.location.href), function(Vt) {
      const zt = utils$1.isString(Vt) ? Mt(Vt) : Vt;
      return zt.protocol === $t.protocol && zt.host === $t.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
), cookies = platform.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(_t, Et, Pt, $t, Mt, Bt) {
      const Vt = [_t + "=" + encodeURIComponent(Et)];
      utils$1.isNumber(Pt) && Vt.push("expires=" + new Date(Pt).toGMTString()), utils$1.isString($t) && Vt.push("path=" + $t), utils$1.isString(Mt) && Vt.push("domain=" + Mt), Bt === !0 && Vt.push("secure"), document.cookie = Vt.join("; ");
    },
    read(_t) {
      const Et = document.cookie.match(new RegExp("(^|;\\s*)(" + _t + ")=([^;]*)"));
      return Et ? decodeURIComponent(Et[3]) : null;
    },
    remove(_t) {
      this.write(_t, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function isAbsoluteURL(_t) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(_t);
}
function combineURLs(_t, Et) {
  return Et ? _t.replace(/\/?\/$/, "") + "/" + Et.replace(/^\/+/, "") : _t;
}
function buildFullPath(_t, Et) {
  return _t && !isAbsoluteURL(Et) ? combineURLs(_t, Et) : Et;
}
const headersToObject = (_t) => _t instanceof AxiosHeaders ? { ..._t } : _t;
function mergeConfig(_t, Et) {
  Et = Et || {};
  const Pt = {};
  function $t(Wt, Gt, qt) {
    return utils$1.isPlainObject(Wt) && utils$1.isPlainObject(Gt) ? utils$1.merge.call({ caseless: qt }, Wt, Gt) : utils$1.isPlainObject(Gt) ? utils$1.merge({}, Gt) : utils$1.isArray(Gt) ? Gt.slice() : Gt;
  }
  function Mt(Wt, Gt, qt) {
    if (utils$1.isUndefined(Gt)) {
      if (!utils$1.isUndefined(Wt))
        return $t(void 0, Wt, qt);
    } else
      return $t(Wt, Gt, qt);
  }
  function Bt(Wt, Gt) {
    if (!utils$1.isUndefined(Gt))
      return $t(void 0, Gt);
  }
  function Vt(Wt, Gt) {
    if (utils$1.isUndefined(Gt)) {
      if (!utils$1.isUndefined(Wt))
        return $t(void 0, Wt);
    } else
      return $t(void 0, Gt);
  }
  function zt(Wt, Gt, qt) {
    if (qt in Et)
      return $t(Wt, Gt);
    if (qt in _t)
      return $t(void 0, Wt);
  }
  const Ht = {
    url: Bt,
    method: Bt,
    data: Bt,
    baseURL: Vt,
    transformRequest: Vt,
    transformResponse: Vt,
    paramsSerializer: Vt,
    timeout: Vt,
    timeoutMessage: Vt,
    withCredentials: Vt,
    withXSRFToken: Vt,
    adapter: Vt,
    responseType: Vt,
    xsrfCookieName: Vt,
    xsrfHeaderName: Vt,
    onUploadProgress: Vt,
    onDownloadProgress: Vt,
    decompress: Vt,
    maxContentLength: Vt,
    maxBodyLength: Vt,
    beforeRedirect: Vt,
    transport: Vt,
    httpAgent: Vt,
    httpsAgent: Vt,
    cancelToken: Vt,
    socketPath: Vt,
    responseEncoding: Vt,
    validateStatus: zt,
    headers: (Wt, Gt) => Mt(headersToObject(Wt), headersToObject(Gt), !0)
  };
  return utils$1.forEach(Object.keys(Object.assign({}, _t, Et)), function(Gt) {
    const qt = Ht[Gt] || Mt, Kt = qt(_t[Gt], Et[Gt], Gt);
    utils$1.isUndefined(Kt) && qt !== zt || (Pt[Gt] = Kt);
  }), Pt;
}
const resolveConfig = (_t) => {
  const Et = mergeConfig({}, _t);
  let { data: Pt, withXSRFToken: $t, xsrfHeaderName: Mt, xsrfCookieName: Bt, headers: Vt, auth: zt } = Et;
  Et.headers = Vt = AxiosHeaders.from(Vt), Et.url = buildURL(buildFullPath(Et.baseURL, Et.url), _t.params, _t.paramsSerializer), zt && Vt.set(
    "Authorization",
    "Basic " + btoa((zt.username || "") + ":" + (zt.password ? unescape(encodeURIComponent(zt.password)) : ""))
  );
  let Ht;
  if (utils$1.isFormData(Pt)) {
    if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv)
      Vt.setContentType(void 0);
    else if ((Ht = Vt.getContentType()) !== !1) {
      const [Wt, ...Gt] = Ht ? Ht.split(";").map((qt) => qt.trim()).filter(Boolean) : [];
      Vt.setContentType([Wt || "multipart/form-data", ...Gt].join("; "));
    }
  }
  if (platform.hasStandardBrowserEnv && ($t && utils$1.isFunction($t) && ($t = $t(Et)), $t || $t !== !1 && isURLSameOrigin(Et.url))) {
    const Wt = Mt && Bt && cookies.read(Bt);
    Wt && Vt.set(Mt, Wt);
  }
  return Et;
}, isXHRAdapterSupported = typeof XMLHttpRequest < "u", xhrAdapter = isXHRAdapterSupported && function(_t) {
  return new Promise(function(Pt, $t) {
    const Mt = resolveConfig(_t);
    let Bt = Mt.data;
    const Vt = AxiosHeaders.from(Mt.headers).normalize();
    let { responseType: zt, onUploadProgress: Ht, onDownloadProgress: Wt } = Mt, Gt, qt, Kt, Qt, Xt;
    function Zt() {
      Qt && Qt(), Xt && Xt(), Mt.cancelToken && Mt.cancelToken.unsubscribe(Gt), Mt.signal && Mt.signal.removeEventListener("abort", Gt);
    }
    let Yt = new XMLHttpRequest();
    Yt.open(Mt.method.toUpperCase(), Mt.url, !0), Yt.timeout = Mt.timeout;
    function Jt() {
      if (!Yt)
        return;
      const tr = AxiosHeaders.from(
        "getAllResponseHeaders" in Yt && Yt.getAllResponseHeaders()
      ), rr = {
        data: !zt || zt === "text" || zt === "json" ? Yt.responseText : Yt.response,
        status: Yt.status,
        statusText: Yt.statusText,
        headers: tr,
        config: _t,
        request: Yt
      };
      settle(function(ar) {
        Pt(ar), Zt();
      }, function(ar) {
        $t(ar), Zt();
      }, rr), Yt = null;
    }
    "onloadend" in Yt ? Yt.onloadend = Jt : Yt.onreadystatechange = function() {
      !Yt || Yt.readyState !== 4 || Yt.status === 0 && !(Yt.responseURL && Yt.responseURL.indexOf("file:") === 0) || setTimeout(Jt);
    }, Yt.onabort = function() {
      Yt && ($t(new AxiosError("Request aborted", AxiosError.ECONNABORTED, _t, Yt)), Yt = null);
    }, Yt.onerror = function() {
      $t(new AxiosError("Network Error", AxiosError.ERR_NETWORK, _t, Yt)), Yt = null;
    }, Yt.ontimeout = function() {
      let nr = Mt.timeout ? "timeout of " + Mt.timeout + "ms exceeded" : "timeout exceeded";
      const rr = Mt.transitional || transitionalDefaults;
      Mt.timeoutErrorMessage && (nr = Mt.timeoutErrorMessage), $t(new AxiosError(
        nr,
        rr.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        _t,
        Yt
      )), Yt = null;
    }, Bt === void 0 && Vt.setContentType(null), "setRequestHeader" in Yt && utils$1.forEach(Vt.toJSON(), function(nr, rr) {
      Yt.setRequestHeader(rr, nr);
    }), utils$1.isUndefined(Mt.withCredentials) || (Yt.withCredentials = !!Mt.withCredentials), zt && zt !== "json" && (Yt.responseType = Mt.responseType), Wt && ([Kt, Xt] = progressEventReducer(Wt, !0), Yt.addEventListener("progress", Kt)), Ht && Yt.upload && ([qt, Qt] = progressEventReducer(Ht), Yt.upload.addEventListener("progress", qt), Yt.upload.addEventListener("loadend", Qt)), (Mt.cancelToken || Mt.signal) && (Gt = (tr) => {
      Yt && ($t(!tr || tr.type ? new CanceledError(null, _t, Yt) : tr), Yt.abort(), Yt = null);
    }, Mt.cancelToken && Mt.cancelToken.subscribe(Gt), Mt.signal && (Mt.signal.aborted ? Gt() : Mt.signal.addEventListener("abort", Gt)));
    const er = parseProtocol(Mt.url);
    if (er && platform.protocols.indexOf(er) === -1) {
      $t(new AxiosError("Unsupported protocol " + er + ":", AxiosError.ERR_BAD_REQUEST, _t));
      return;
    }
    Yt.send(Bt || null);
  });
}, composeSignals = (_t, Et) => {
  const { length: Pt } = _t = _t ? _t.filter(Boolean) : [];
  if (Et || Pt) {
    let $t = new AbortController(), Mt;
    const Bt = function(Wt) {
      if (!Mt) {
        Mt = !0, zt();
        const Gt = Wt instanceof Error ? Wt : this.reason;
        $t.abort(Gt instanceof AxiosError ? Gt : new CanceledError(Gt instanceof Error ? Gt.message : Gt));
      }
    };
    let Vt = Et && setTimeout(() => {
      Vt = null, Bt(new AxiosError(`timeout ${Et} of ms exceeded`, AxiosError.ETIMEDOUT));
    }, Et);
    const zt = () => {
      _t && (Vt && clearTimeout(Vt), Vt = null, _t.forEach((Wt) => {
        Wt.unsubscribe ? Wt.unsubscribe(Bt) : Wt.removeEventListener("abort", Bt);
      }), _t = null);
    };
    _t.forEach((Wt) => Wt.addEventListener("abort", Bt));
    const { signal: Ht } = $t;
    return Ht.unsubscribe = () => utils$1.asap(zt), Ht;
  }
}, streamChunk = function* (_t, Et) {
  let Pt = _t.byteLength;
  if (!Et || Pt < Et) {
    yield _t;
    return;
  }
  let $t = 0, Mt;
  for (; $t < Pt; )
    Mt = $t + Et, yield _t.slice($t, Mt), $t = Mt;
}, readBytes = async function* (_t, Et) {
  for await (const Pt of readStream(_t))
    yield* streamChunk(Pt, Et);
}, readStream = async function* (_t) {
  if (_t[Symbol.asyncIterator]) {
    yield* _t;
    return;
  }
  const Et = _t.getReader();
  try {
    for (; ; ) {
      const { done: Pt, value: $t } = await Et.read();
      if (Pt)
        break;
      yield $t;
    }
  } finally {
    await Et.cancel();
  }
}, trackStream = (_t, Et, Pt, $t) => {
  const Mt = readBytes(_t, Et);
  let Bt = 0, Vt, zt = (Ht) => {
    Vt || (Vt = !0, $t && $t(Ht));
  };
  return new ReadableStream({
    async pull(Ht) {
      try {
        const { done: Wt, value: Gt } = await Mt.next();
        if (Wt) {
          zt(), Ht.close();
          return;
        }
        let qt = Gt.byteLength;
        if (Pt) {
          let Kt = Bt += qt;
          Pt(Kt);
        }
        Ht.enqueue(new Uint8Array(Gt));
      } catch (Wt) {
        throw zt(Wt), Wt;
      }
    },
    cancel(Ht) {
      return zt(Ht), Mt.return();
    }
  }, {
    highWaterMark: 2
  });
}, isFetchSupported = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", isReadableStreamSupported = isFetchSupported && typeof ReadableStream == "function", encodeText = isFetchSupported && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((_t) => (Et) => _t.encode(Et))(new TextEncoder()) : async (_t) => new Uint8Array(await new Response(_t).arrayBuffer())), test = (_t, ...Et) => {
  try {
    return !!_t(...Et);
  } catch {
    return !1;
  }
}, supportsRequestStream = isReadableStreamSupported && test(() => {
  let _t = !1;
  const Et = new Request(platform.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return _t = !0, "half";
    }
  }).headers.has("Content-Type");
  return _t && !Et;
}), DEFAULT_CHUNK_SIZE = 64 * 1024, supportsResponseStream = isReadableStreamSupported && test(() => utils$1.isReadableStream(new Response("").body)), resolvers = {
  stream: supportsResponseStream && ((_t) => _t.body)
};
isFetchSupported && ((_t) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((Et) => {
    !resolvers[Et] && (resolvers[Et] = utils$1.isFunction(_t[Et]) ? (Pt) => Pt[Et]() : (Pt, $t) => {
      throw new AxiosError(`Response type '${Et}' is not supported`, AxiosError.ERR_NOT_SUPPORT, $t);
    });
  });
})(new Response());
const getBodyLength = async (_t) => {
  if (_t == null)
    return 0;
  if (utils$1.isBlob(_t))
    return _t.size;
  if (utils$1.isSpecCompliantForm(_t))
    return (await new Request(platform.origin, {
      method: "POST",
      body: _t
    }).arrayBuffer()).byteLength;
  if (utils$1.isArrayBufferView(_t) || utils$1.isArrayBuffer(_t))
    return _t.byteLength;
  if (utils$1.isURLSearchParams(_t) && (_t = _t + ""), utils$1.isString(_t))
    return (await encodeText(_t)).byteLength;
}, resolveBodyLength = async (_t, Et) => {
  const Pt = utils$1.toFiniteNumber(_t.getContentLength());
  return Pt ?? getBodyLength(Et);
}, fetchAdapter = isFetchSupported && (async (_t) => {
  let {
    url: Et,
    method: Pt,
    data: $t,
    signal: Mt,
    cancelToken: Bt,
    timeout: Vt,
    onDownloadProgress: zt,
    onUploadProgress: Ht,
    responseType: Wt,
    headers: Gt,
    withCredentials: qt = "same-origin",
    fetchOptions: Kt
  } = resolveConfig(_t);
  Wt = Wt ? (Wt + "").toLowerCase() : "text";
  let Qt = composeSignals([Mt, Bt && Bt.toAbortSignal()], Vt), Xt;
  const Zt = Qt && Qt.unsubscribe && (() => {
    Qt.unsubscribe();
  });
  let Yt;
  try {
    if (Ht && supportsRequestStream && Pt !== "get" && Pt !== "head" && (Yt = await resolveBodyLength(Gt, $t)) !== 0) {
      let rr = new Request(Et, {
        method: "POST",
        body: $t,
        duplex: "half"
      }), ir;
      if (utils$1.isFormData($t) && (ir = rr.headers.get("content-type")) && Gt.setContentType(ir), rr.body) {
        const [ar, or] = progressEventDecorator(
          Yt,
          progressEventReducer(asyncDecorator(Ht))
        );
        $t = trackStream(rr.body, DEFAULT_CHUNK_SIZE, ar, or);
      }
    }
    utils$1.isString(qt) || (qt = qt ? "include" : "omit");
    const Jt = "credentials" in Request.prototype;
    Xt = new Request(Et, {
      ...Kt,
      signal: Qt,
      method: Pt.toUpperCase(),
      headers: Gt.normalize().toJSON(),
      body: $t,
      duplex: "half",
      credentials: Jt ? qt : void 0
    });
    let er = await fetch(Xt);
    const tr = supportsResponseStream && (Wt === "stream" || Wt === "response");
    if (supportsResponseStream && (zt || tr && Zt)) {
      const rr = {};
      ["status", "statusText", "headers"].forEach((sr) => {
        rr[sr] = er[sr];
      });
      const ir = utils$1.toFiniteNumber(er.headers.get("content-length")), [ar, or] = zt && progressEventDecorator(
        ir,
        progressEventReducer(asyncDecorator(zt), !0)
      ) || [];
      er = new Response(
        trackStream(er.body, DEFAULT_CHUNK_SIZE, ar, () => {
          or && or(), Zt && Zt();
        }),
        rr
      );
    }
    Wt = Wt || "text";
    let nr = await resolvers[utils$1.findKey(resolvers, Wt) || "text"](er, _t);
    return !tr && Zt && Zt(), await new Promise((rr, ir) => {
      settle(rr, ir, {
        data: nr,
        headers: AxiosHeaders.from(er.headers),
        status: er.status,
        statusText: er.statusText,
        config: _t,
        request: Xt
      });
    });
  } catch (Jt) {
    throw Zt && Zt(), Jt && Jt.name === "TypeError" && /fetch/i.test(Jt.message) ? Object.assign(
      new AxiosError("Network Error", AxiosError.ERR_NETWORK, _t, Xt),
      {
        cause: Jt.cause || Jt
      }
    ) : AxiosError.from(Jt, Jt && Jt.code, _t, Xt);
  }
}), knownAdapters = {
  http: httpAdapter,
  xhr: xhrAdapter,
  fetch: fetchAdapter
};
utils$1.forEach(knownAdapters, (_t, Et) => {
  if (_t) {
    try {
      Object.defineProperty(_t, "name", { value: Et });
    } catch {
    }
    Object.defineProperty(_t, "adapterName", { value: Et });
  }
});
const renderReason = (_t) => `- ${_t}`, isResolvedHandle = (_t) => utils$1.isFunction(_t) || _t === null || _t === !1, adapters = {
  getAdapter: (_t) => {
    _t = utils$1.isArray(_t) ? _t : [_t];
    const { length: Et } = _t;
    let Pt, $t;
    const Mt = {};
    for (let Bt = 0; Bt < Et; Bt++) {
      Pt = _t[Bt];
      let Vt;
      if ($t = Pt, !isResolvedHandle(Pt) && ($t = knownAdapters[(Vt = String(Pt)).toLowerCase()], $t === void 0))
        throw new AxiosError(`Unknown adapter '${Vt}'`);
      if ($t)
        break;
      Mt[Vt || "#" + Bt] = $t;
    }
    if (!$t) {
      const Bt = Object.entries(Mt).map(
        ([zt, Ht]) => `adapter ${zt} ` + (Ht === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let Vt = Et ? Bt.length > 1 ? `since :
` + Bt.map(renderReason).join(`
`) : " " + renderReason(Bt[0]) : "as no adapter specified";
      throw new AxiosError(
        "There is no suitable adapter to dispatch the request " + Vt,
        "ERR_NOT_SUPPORT"
      );
    }
    return $t;
  },
  adapters: knownAdapters
};
function throwIfCancellationRequested(_t) {
  if (_t.cancelToken && _t.cancelToken.throwIfRequested(), _t.signal && _t.signal.aborted)
    throw new CanceledError(null, _t);
}
function dispatchRequest(_t) {
  return throwIfCancellationRequested(_t), _t.headers = AxiosHeaders.from(_t.headers), _t.data = transformData.call(
    _t,
    _t.transformRequest
  ), ["post", "put", "patch"].indexOf(_t.method) !== -1 && _t.headers.setContentType("application/x-www-form-urlencoded", !1), adapters.getAdapter(_t.adapter || defaults$1.adapter)(_t).then(function($t) {
    return throwIfCancellationRequested(_t), $t.data = transformData.call(
      _t,
      _t.transformResponse,
      $t
    ), $t.headers = AxiosHeaders.from($t.headers), $t;
  }, function($t) {
    return isCancel($t) || (throwIfCancellationRequested(_t), $t && $t.response && ($t.response.data = transformData.call(
      _t,
      _t.transformResponse,
      $t.response
    ), $t.response.headers = AxiosHeaders.from($t.response.headers))), Promise.reject($t);
  });
}
const VERSION = "1.7.7", validators$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((_t, Et) => {
  validators$1[_t] = function($t) {
    return typeof $t === _t || "a" + (Et < 1 ? "n " : " ") + _t;
  };
});
const deprecatedWarnings = {};
validators$1.transitional = function(Et, Pt, $t) {
  function Mt(Bt, Vt) {
    return "[Axios v" + VERSION + "] Transitional option '" + Bt + "'" + Vt + ($t ? ". " + $t : "");
  }
  return (Bt, Vt, zt) => {
    if (Et === !1)
      throw new AxiosError(
        Mt(Vt, " has been removed" + (Pt ? " in " + Pt : "")),
        AxiosError.ERR_DEPRECATED
      );
    return Pt && !deprecatedWarnings[Vt] && (deprecatedWarnings[Vt] = !0, console.warn(
      Mt(
        Vt,
        " has been deprecated since v" + Pt + " and will be removed in the near future"
      )
    )), Et ? Et(Bt, Vt, zt) : !0;
  };
};
function assertOptions(_t, Et, Pt) {
  if (typeof _t != "object")
    throw new AxiosError("options must be an object", AxiosError.ERR_BAD_OPTION_VALUE);
  const $t = Object.keys(_t);
  let Mt = $t.length;
  for (; Mt-- > 0; ) {
    const Bt = $t[Mt], Vt = Et[Bt];
    if (Vt) {
      const zt = _t[Bt], Ht = zt === void 0 || Vt(zt, Bt, _t);
      if (Ht !== !0)
        throw new AxiosError("option " + Bt + " must be " + Ht, AxiosError.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (Pt !== !0)
      throw new AxiosError("Unknown option " + Bt, AxiosError.ERR_BAD_OPTION);
  }
}
const validator = {
  assertOptions,
  validators: validators$1
}, validators = validator.validators;
class Axios {
  constructor(Et) {
    this.defaults = Et, this.interceptors = {
      request: new InterceptorManager(),
      response: new InterceptorManager()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(Et, Pt) {
    try {
      return await this._request(Et, Pt);
    } catch ($t) {
      if ($t instanceof Error) {
        let Mt;
        Error.captureStackTrace ? Error.captureStackTrace(Mt = {}) : Mt = new Error();
        const Bt = Mt.stack ? Mt.stack.replace(/^.+\n/, "") : "";
        try {
          $t.stack ? Bt && !String($t.stack).endsWith(Bt.replace(/^.+\n.+\n/, "")) && ($t.stack += `
` + Bt) : $t.stack = Bt;
        } catch {
        }
      }
      throw $t;
    }
  }
  _request(Et, Pt) {
    typeof Et == "string" ? (Pt = Pt || {}, Pt.url = Et) : Pt = Et || {}, Pt = mergeConfig(this.defaults, Pt);
    const { transitional: $t, paramsSerializer: Mt, headers: Bt } = Pt;
    $t !== void 0 && validator.assertOptions($t, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, !1), Mt != null && (utils$1.isFunction(Mt) ? Pt.paramsSerializer = {
      serialize: Mt
    } : validator.assertOptions(Mt, {
      encode: validators.function,
      serialize: validators.function
    }, !0)), Pt.method = (Pt.method || this.defaults.method || "get").toLowerCase();
    let Vt = Bt && utils$1.merge(
      Bt.common,
      Bt[Pt.method]
    );
    Bt && utils$1.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (Xt) => {
        delete Bt[Xt];
      }
    ), Pt.headers = AxiosHeaders.concat(Vt, Bt);
    const zt = [];
    let Ht = !0;
    this.interceptors.request.forEach(function(Zt) {
      typeof Zt.runWhen == "function" && Zt.runWhen(Pt) === !1 || (Ht = Ht && Zt.synchronous, zt.unshift(Zt.fulfilled, Zt.rejected));
    });
    const Wt = [];
    this.interceptors.response.forEach(function(Zt) {
      Wt.push(Zt.fulfilled, Zt.rejected);
    });
    let Gt, qt = 0, Kt;
    if (!Ht) {
      const Xt = [dispatchRequest.bind(this), void 0];
      for (Xt.unshift.apply(Xt, zt), Xt.push.apply(Xt, Wt), Kt = Xt.length, Gt = Promise.resolve(Pt); qt < Kt; )
        Gt = Gt.then(Xt[qt++], Xt[qt++]);
      return Gt;
    }
    Kt = zt.length;
    let Qt = Pt;
    for (qt = 0; qt < Kt; ) {
      const Xt = zt[qt++], Zt = zt[qt++];
      try {
        Qt = Xt(Qt);
      } catch (Yt) {
        Zt.call(this, Yt);
        break;
      }
    }
    try {
      Gt = dispatchRequest.call(this, Qt);
    } catch (Xt) {
      return Promise.reject(Xt);
    }
    for (qt = 0, Kt = Wt.length; qt < Kt; )
      Gt = Gt.then(Wt[qt++], Wt[qt++]);
    return Gt;
  }
  getUri(Et) {
    Et = mergeConfig(this.defaults, Et);
    const Pt = buildFullPath(Et.baseURL, Et.url);
    return buildURL(Pt, Et.params, Et.paramsSerializer);
  }
}
utils$1.forEach(["delete", "get", "head", "options"], function(Et) {
  Axios.prototype[Et] = function(Pt, $t) {
    return this.request(mergeConfig($t || {}, {
      method: Et,
      url: Pt,
      data: ($t || {}).data
    }));
  };
});
utils$1.forEach(["post", "put", "patch"], function(Et) {
  function Pt($t) {
    return function(Bt, Vt, zt) {
      return this.request(mergeConfig(zt || {}, {
        method: Et,
        headers: $t ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: Bt,
        data: Vt
      }));
    };
  }
  Axios.prototype[Et] = Pt(), Axios.prototype[Et + "Form"] = Pt(!0);
});
class CancelToken {
  constructor(Et) {
    if (typeof Et != "function")
      throw new TypeError("executor must be a function.");
    let Pt;
    this.promise = new Promise(function(Bt) {
      Pt = Bt;
    });
    const $t = this;
    this.promise.then((Mt) => {
      if (!$t._listeners)
        return;
      let Bt = $t._listeners.length;
      for (; Bt-- > 0; )
        $t._listeners[Bt](Mt);
      $t._listeners = null;
    }), this.promise.then = (Mt) => {
      let Bt;
      const Vt = new Promise((zt) => {
        $t.subscribe(zt), Bt = zt;
      }).then(Mt);
      return Vt.cancel = function() {
        $t.unsubscribe(Bt);
      }, Vt;
    }, Et(function(Bt, Vt, zt) {
      $t.reason || ($t.reason = new CanceledError(Bt, Vt, zt), Pt($t.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(Et) {
    if (this.reason) {
      Et(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(Et) : this._listeners = [Et];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(Et) {
    if (!this._listeners)
      return;
    const Pt = this._listeners.indexOf(Et);
    Pt !== -1 && this._listeners.splice(Pt, 1);
  }
  toAbortSignal() {
    const Et = new AbortController(), Pt = ($t) => {
      Et.abort($t);
    };
    return this.subscribe(Pt), Et.signal.unsubscribe = () => this.unsubscribe(Pt), Et.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let Et;
    return {
      token: new CancelToken(function(Mt) {
        Et = Mt;
      }),
      cancel: Et
    };
  }
}
function spread(_t) {
  return function(Pt) {
    return _t.apply(null, Pt);
  };
}
function isAxiosError(_t) {
  return utils$1.isObject(_t) && _t.isAxiosError === !0;
}
const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(HttpStatusCode).forEach(([_t, Et]) => {
  HttpStatusCode[Et] = _t;
});
function createInstance(_t) {
  const Et = new Axios(_t), Pt = bind(Axios.prototype.request, Et);
  return utils$1.extend(Pt, Axios.prototype, Et, { allOwnKeys: !0 }), utils$1.extend(Pt, Et, null, { allOwnKeys: !0 }), Pt.create = function(Mt) {
    return createInstance(mergeConfig(_t, Mt));
  }, Pt;
}
const axios = createInstance(defaults$1);
axios.Axios = Axios;
axios.CanceledError = CanceledError;
axios.CancelToken = CancelToken;
axios.isCancel = isCancel;
axios.VERSION = VERSION;
axios.toFormData = toFormData;
axios.AxiosError = AxiosError;
axios.Cancel = axios.CanceledError;
axios.all = function(Et) {
  return Promise.all(Et);
};
axios.spread = spread;
axios.isAxiosError = isAxiosError;
axios.mergeConfig = mergeConfig;
axios.AxiosHeaders = AxiosHeaders;
axios.formToJSON = (_t) => formDataToJSON(utils$1.isHTMLForm(_t) ? new FormData(_t) : _t);
axios.getAdapter = adapters.getAdapter;
axios.HttpStatusCode = HttpStatusCode;
axios.default = axios;
const defaultValidateResult = {
  FIELD_WRITE: !1,
  MANAGE_QUOTA: !1
};
function useMenuValidate({
  workspaceId: _t,
  propertyId: Et
}) {
  const {
    cwElementsSettingsMenuCws13844UseValidateEndpoint: Pt
  } = ie(), $t = useConfig$1(), Mt = async (Vt, zt) => {
    var Wt;
    return ((Wt = (await axios.post(`${$t.getAPIURL()}/v2/internal/settings/menu/validate`, {
      workspace_id: Vt,
      property_id: zt,
      options: ["MANAGE_QUOTA", "FIELD_WRITE"]
    }, {
      headers: $t.getDefaultHeaders()
    })).data) == null ? void 0 : Wt.items.reduce((Gt, qt) => (Gt[qt.name] = qt.value, Gt), {})) ?? null;
  }, {
    data: Bt
  } = useQuery({
    queryKey: ["menuValidate", _t, Et],
    enabled: !!(_t && Pt),
    queryFn: async () => Mt(_t, Et)
  });
  return Bt ?? defaultValidateResult;
}
var define_import_meta_env_default$1 = { VITE_MAPBOX_TOKEN: "pk.eyJ1Ijoic3RyaWRlcmVuZ2luZWVyaW5nIiwiYSI6ImNsMWdnM3BrbzBiemQzaHBiaDhja2RleXAifQ.0QfwjSzZeGiEjkkA-0dH6w", VITE_CJS_IGNORE_WARNING: "true", BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 };
const ACCOUNTS_APP_ID = "ACCOUNTS_MGMT", SettingsDrawerGroups = dt$1.div`
  .group {
    transition:
      opacity 300ms ease-in-out,
      transform 300ms ease-in-out;
    opacity: 0;
    transform: translateY(20px);
  }

  .group + .group {
    margin-top: 12px;
  }

  ${({
  $show: _t
}) => _t && `
      .group {
        opacity: 1;
        transform: translateY(0);
        transition-delay: var(--delay);
      }
  `}
`, useAnalyticsWithApp = createAnalyticsHookWithAppAndComponent(""), InnerDefaultSettingsGroups = ({
  component: _t,
  workspaceId: Et,
  workspaceName: Pt,
  orgId: $t,
  orgName: Mt,
  orgCountry: Bt,
  orgSource: Vt,
  propertyId: zt,
  propertyName: Ht,
  productSettings: Wt,
  extraDelay: Gt = 0,
  dark: qt = !1,
  accountId: Kt
}) => {
  const Qt = define_import_meta_env_default$1.VITE_USE_LOCAL_MFES === "true" ? "local" : void 0, Xt = useMfe("machinery-file-uploader"), Zt = useMfe("fields/create", Qt), Yt = useMfe("members-mgt/starter", Qt), Jt = useMfe("inputs-mgt/drawer", Qt), er = useMfe("inputs-mgt/create", Qt), tr = useConfig$1(), nr = tr.getHostAppId(), {
    t: rr
  } = useTranslation(), [ir, ar] = useState({
    id: zt,
    name: Ht
  }), [or, sr] = useState(!1), [lr, cr] = useState(!1), [hr, pr] = useState(!1), mr = useAnalyticsWithApp(() => ({
    component: _t,
    workspaceId: Et,
    workspaceName: Pt,
    organizationId: $t,
    organizationName: Mt,
    farmId: ir.id,
    farmName: ir.name
  })), {
    settingsMenuEnableConnectMenu: Er,
    settingsMenuEnableConnectMenuFileUpload: _r,
    settingsMenuEnableConnectMenuIntegrationsItem: yr,
    settingMenEnableConnectMenuDataMapping: ur,
    farmSettingsCws11151EnableInputs: vr,
    farmSettingsEntitiesHallCws11468EnableMfe: dr,
    cwElementsFieldsCws11316EnableFieldsMfe: br,
    cwElementsMembersMgtCws13415UseMembersMgt: Cr,
    cwElementsInputsMgtCws12528EnableNavigationTests: Pr
  } = ie(), xr = useMenuValidate({
    workspaceId: Et,
    propertyId: ir.id
  }), {
    membersAndContantURL: kr,
    quotaMgtURL: Ir
  } = useMenuURLS({
    workspaceId: Et,
    orgId: $t
  });
  useEffect(() => {
    setTimeout(() => {
      pr(!0);
    });
  }, []);
  const Ar = useCallback((qr, tn = !1, gr = !1) => {
    let Sr = tr.getFarmSettingsURL();
    return tn ? Sr += `/app/landing-organization/${$t}` : Sr += dr ? "/app/my-cropwise" : "/app/my-organizations", tn && gr && (ir.id ? Sr += `/property/${ir.id}` : qr = "/create-farm"), Sr + qr + (nr !== ACCOUNTS_APP_ID ? `?callback_app=${nr}` : "");
  }, [$t, ir.id, nr, tr, dr]), Mr = useCallback(() => {
    dispatchEvent(new CustomEvent(SettingsMenuEventsEnum.CLOSE_MENU));
  }, []), Fr = useCallback(({
    platformBlock: qr,
    productBlock: tn,
    platformFeature: gr
  }) => {
    mr("access settings links", {
      "platform block": qr,
      "platform feature": gr,
      "product block": tn
    });
  }, [mr]), Dr = useCallback((qr, {
    platformBlock: tn,
    productBlock: gr,
    platformFeature: Sr
  }) => {
    var Nr;
    Mr(), Fr({
      platformBlock: tn,
      productBlock: gr,
      platformFeature: Sr
    }), (Nr = window.open(qr, "_blank")) == null || Nr.focus();
  }, [Mr, Fr]);
  useEffect(() => {
    function qr(tn) {
      window.dispatchEvent(new CustomEvent(DYNAMIC_SLOT_CHANGE_PROPS, {
        detail: {
          userLanguage: tn
        }
      }));
    }
    return i18nInstance.on("languageChanged", qr), () => i18nInstance.off("languageChanged", qr);
  }, []), useEffect(() => {
    window.dispatchEvent(new CustomEvent(DYNAMIC_SLOT_CHANGE_PROPS, {
      detail: {
        workspaceId: Et ?? "",
        orgId: $t ?? "",
        location: Bt ?? "",
        source: Vt ?? ""
      }
    }));
  }, [Et, $t, Bt, Vt]);
  const zr = useMemo$1(() => vr ? {
    key: "MANAGE_INPUTS",
    icon: /* @__PURE__ */ jsxRuntimeExports.jsx(SvgCwSettingsInputsicon, {}),
    label: rr("settings_menu.inputs.title"),
    tooltipText: rr("settings_menu.inputs.tooltip"),
    onClick: () => {
      Mr(), Fr({
        platformBlock: "Farm Settings",
        platformFeature: "Inputs"
      }), Pr ? (window.dispatchEvent(new CustomEvent(InputsEventsEnum.OPEN_DRAWER)), mr("access settings links - navigation tests", {
        "platform block": "Farm Settings",
        "platform feature": "Inputs"
      })) : openMfe("inputs-mgt", {
        workspaceId: Et ?? "",
        orgId: $t ?? "",
        userLanguage: i18nInstance.language,
        location: Bt ?? "",
        source: Vt ?? ""
      }, Ar("/inputs/crop-protection", !0, !1));
    },
    secondButton: Pr ? () => {
      Mr(), Gr(!0), mr("access settings links - navigation tests", {
        "platform block": "Farm Settings",
        "platform feature": "Quickly add Inputs"
      });
    } : void 0,
    extraButtonTooltipText: rr("settings_menu.inputs.extra_button_tooltip")
  } : {
    key: "MANAGE_PRODUCTS",
    icon: /* @__PURE__ */ jsxRuntimeExports.jsx(Products, { dark: qt }),
    label: rr("settings_menu.products.title"),
    tooltipText: rr("settings_menu.products.tooltip"),
    onClick: () => Dr(Ar("/resources/1", !0, !1), {
      platformBlock: "Farm Settings",
      platformFeature: "Products"
    })
  }, [Ar, qt, vr, Pr, Mr, mr, Dr, Fr, $t, rr, Et, Bt, Vt]), [Tr, Gr] = useState(!1), [$r, Rr] = useState(!1), [Or, Lr] = useState(!1), Hr = useMemo$1(() => ({
    key: "FARM_SETTINGS",
    items: [{
      key: "MANAGE_FIELDS",
      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(Field$1, { dark: qt }),
      label: rr("settings_menu.fields.title"),
      tooltipText: rr("settings_menu.fields.tooltip"),
      onClick: () => Dr(Ar("/all-fields", !0, !0), {
        platformBlock: "Farm Settings",
        platformFeature: "Fields"
      }),
      secondButton: br && (xr != null && xr.FIELD_WRITE) ? () => {
        Mr(), Rr(!0), Fr({
          platformBlock: "Farm Settings",
          platformFeature: "Quickly add Fields"
        });
      } : void 0,
      extraButtonTooltipText: rr("settings_menu.fields.extra_button_tooltip")
    }, {
      key: "MANAGE_SEASONS",
      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(CropCycles, { dark: qt }),
      label: rr("settings_menu.seasons.title"),
      tooltipText: rr("settings_menu.seasons.tooltip"),
      onClick: () => Dr(Ar("/table-view", !0, !0), {
        platformBlock: "Farm Settings",
        platformFeature: "Seasons"
      })
    }, zr],
    title: rr("settings_menu.farm_settings.title"),
    tooltipText: rr("settings_menu.farm_settings.tooltip"),
    onClickTitle: () => Dr(Ar(""), {
      platformBlock: "Farm Settings",
      platformFeature: "Farm Settings"
    })
  }), [qt, rr, zr, br, xr == null ? void 0 : xr.FIELD_WRITE, Dr, Ar, Mr, Fr]), Wr = useCallback((qr) => tr.getConnectURL() + qr + (nr !== ACCOUNTS_APP_ID ? `?callback_app=${nr}` : ""), [nr, tr]), Kr = useMemo$1(() => ({
    label: rr("settings_menu.connect.integrations_title"),
    icon: /* @__PURE__ */ jsxRuntimeExports.jsx(SvgIntegrationicon, {}),
    key: "INTEGRATIONS",
    tooltipText: rr("settings_menu.connect.integrations_tooltip"),
    onClick: () => {
      Dr(Wr("integrations"), {
        platformBlock: "Connect",
        platformFeature: "Integrations"
      });
    }
  }), [Wr, Dr, rr]), [Ur, Zr] = useState(!1), Xr = useMemo$1(() => ({
    label: rr("settings_menu.connect.file_upload_title"),
    icon: /* @__PURE__ */ jsxRuntimeExports.jsx(SvgFileUploadicon, {}),
    key: "FILE_UPLOAD",
    tooltipText: rr("settings_menu.connect.file_upload_tooltip"),
    onClick: () => {
      Xt.Mfe ? (Zr(!0), Mr(), Fr({
        platformBlock: "Connect",
        platformFeature: "File Upload"
      })) : Dr(Wr("file-upload"), {
        platformBlock: "Connect",
        platformFeature: "File Upload"
      });
    },
    hoverType: HoverTypes.INTERNAL
  }), [rr, Xt.Mfe, Fr, Mr, Dr, Wr]), mn = useMemo$1(() => ({
    label: rr("settings_menu.connect.data_matching_title"),
    icon: /* @__PURE__ */ jsxRuntimeExports.jsx(SvgDataMatchingicon, {}),
    key: "DATA_MATCHING",
    tooltipText: rr("settings_menu.connect.data_matching_tooltip"),
    onClick: () => {
      Dr(Wr("resource-mapper"), {
        platformBlock: "Connect",
        platformFeature: "Data Mapping"
      });
    },
    hoverType: HoverTypes.INTERNAL
  }), [Wr, Dr, rr]), an = useMemo$1(() => {
    const qr = [];
    return yr && qr.push(Kr), _r && qr.push(Xr), ur && qr.push(mn), {
      key: "CONNECT",
      title: rr("settings_menu.connect.title"),
      tooltipText: rr("settings_menu.connect.tooltip"),
      onClickTitle: () => {
        Dr(Wr(""), {
          platformBlock: "Connect",
          platformFeature: "Connect"
        });
      },
      items: qr
    };
  }, [yr, _r, ur, rr, Kr, Xr, mn, Dr, Wr]), nn = useMemo$1(() => `${tr.getAccountsURL()}/app/invite-members?workspace=${Et}`, [tr, Et]), $n = useMemo$1(() => {
    const qr = [{
      key: "MEMBERS_AND_CONTACTS",
      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(SvgCwSettingsPersonAddicon, {}),
      label: rr("settings_menu.members_and_contacts.title"),
      tooltipText: rr("settings_menu.members_and_contacts.tooltip"),
      onClick: () => {
        Dr(kr, {
          platformBlock: "Accounts",
          platformFeature: "Members and Contacts"
        });
      },
      secondButton: () => {
        if (Mr(), Cr) {
          Lr(!0);
          return;
        }
        Fr({
          platformBlock: "Accounts",
          platformFeature: "Quickly invite members"
        }), openMfe("invite-members", {
          workspaceId: Et ?? "",
          orgId: $t ?? "",
          userLanguage: i18nInstance.language
        }, nn);
      },
      extraButtonTooltipText: rr("settings_menu.members_and_contacts.extraButtonTooltip")
    }];
    return xr != null && xr.MANAGE_QUOTA && qr.push({
      key: "MANAGE_QUOTAS",
      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(SvgCwSettingsManageQuotasicon, {}),
      label: rr("settings_menu.manage_quotas.title"),
      tooltipText: rr("settings_menu.manage_quotas.tooltip"),
      onClick: () => {
        openMfe("quota-mgt", {
          workspaceId: Et ?? "",
          userLanguage: i18nInstance.language
        }, Ir), Mr(), Fr({
          platformBlock: "Accounts",
          platformFeature: "Manage Quotas"
        });
      },
      hoverType: HoverTypes.INTERNAL
    }), {
      key: "ACCOUNTS",
      items: qr,
      title: rr("settings_menu.accounts.title"),
      tooltipText: rr("settings_menu.accounts.tooltip"),
      onClickTitle: () => Dr(`${tr.getAccountsURL()}/app/workspaces`, {
        platformBlock: "Accounts",
        platformFeature: "Accounts"
      })
    };
  }, [rr, Dr, kr, $t, Et, nn, Fr, Mr, Ir, tr, xr == null ? void 0 : xr.MANAGE_QUOTA, Cr]);
  useEffect(() => {
    if ($t && !zt) {
      const qr = () => {
        cr(!1), sr(!0), CWElementsSharedService.getPropertiesByOrg($t).then((tn) => {
          var Sr, Nr;
          const gr = ((Nr = (Sr = tn.data) == null ? void 0 : Sr.content) == null ? void 0 : Nr[0]) ?? void 0;
          ar({
            id: gr == null ? void 0 : gr.id,
            name: gr == null ? void 0 : gr.name
          }), sr(!1);
        }).catch(() => {
          cr(!0);
        });
      };
      CWElementsConfig.getInstance().addCallbackAfterSetToken(qr);
    }
  }, [$t, zt]), useEffect(() => {
    zt && ar({
      id: zt,
      name: Ht
    });
  }, [zt, Ht]);
  const En = useMemo$1(() => {
    const qr = [];
    return lr || qr.push(Hr), nr !== ACCOUNTS_APP_ID && qr.push($n), Wt && qr.push({
      ...Wt,
      onClickTitle: () => {
        var tn;
        mr("access settings links", {
          "product block": `${Wt.title} - ${Wt.title}`
        }), (tn = Wt.onClickTitle) == null || tn.call(Wt);
      },
      items: Wt.items.map((tn) => ({
        ...tn,
        onClick: () => {
          var gr;
          mr("access settings links", {
            "product block": `${Wt.title} - ${tn.label}`
          }), (gr = tn.onClick) == null || gr.call(tn);
        }
      }))
    }), Er && qr.push(an), qr;
  }, [mr, lr, nr, Wt, Er, Hr, $n, an]);
  if (!$t)
    return null;
  const xn = !!($t && (ir.id ?? zt) && (xr != null && xr.FIELD_WRITE));
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(SettingsDrawerGroups, { $show: hr, children: [
    Jt.Mfe && /* @__PURE__ */ jsxRuntimeExports.jsx(Jt.Mfe, { userLanguage: i18nInstance.language, workspaceId: Et, orgId: $t, isCanon: !1, location: Bt ?? "", source: Vt ?? "" }),
    er.Mfe && /* @__PURE__ */ jsxRuntimeExports.jsx(er.Mfe, { userLanguage: i18nInstance.language, open: Tr, onClose: () => Gr(!1), __experimental_navigation_tests: {
      useCustomEvents: !0
    } }),
    Xt.Mfe && /* @__PURE__ */ jsxRuntimeExports.jsx(Xt.Mfe, { userLanguage: i18nInstance.language, getConfigInstance: useConfig$1, userId: Kt ?? "", orgId: $t, isOpen: Ur, onClose: () => Zr(!1) }),
    xn && Zt.Mfe && /* @__PURE__ */ jsxRuntimeExports.jsx(Zt.Mfe, { isOpen: $r, onClose: () => Rr(!1), userLanguage: i18nInstance.language, orgId: $t, propertyId: ir.id ?? zt }),
    Cr && Yt.Mfe && /* @__PURE__ */ jsxRuntimeExports.jsx(Yt.Mfe, { isOpen: Or, onClose: () => Lr(!1), userLanguage: i18nInstance.language, workspaceId: Et ?? "", getConfigInstance: useConfig$1 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(QuotaWarningGroup, { workspaceId: Et, dark: qt }),
    En.map(({
      key: qr,
      ...tn
    }, gr) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "group", style: {
      "--delay": gr * 300 + Gt + "ms"
    }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(SettingsGroup, { ...tn, loading: or, dark: qt }, qr) }, qr))
  ] });
}, client = new QueryClient(), DefaultSettingsGroups = (_t) => /* @__PURE__ */ jsxRuntimeExports.jsx(QueryClientProvider, { client, children: /* @__PURE__ */ jsxRuntimeExports.jsx(InnerDefaultSettingsGroups, { ..._t }) });
dt$1.header`
  display: flex;
  align-items: flex-start;
  margin-bottom: 24px;
`;
dt$1.div`
  display: flex;
  flex-direction: column;
  margin-left: 8px;
`;
dt$1.h1`
  font-size: ${SyngentaTheme.FontSize.Title5};
  margin: 0;
  line-height: 1.3;
`;
dt$1.p`
  font-size: ${SyngentaTheme.FontSize.Body2};
  margin: 8px 0 0;
  font-weight: ${SyngentaTheme.FontWeight.Regular};
  line-height: 1.4;
  color: ${Neutral[60]};
`;
dt$1.div`
  display: flex;
  width: 32px;
  height: 32px;
  padding: 7px;
  justify-content: center;
  border-radius: 8px;
  align-items: center;
  background-color: ${(_t) => _t.color};
  svg {
    fill: ${Blue[60]};
  }
`;
const ICON_SIZE = "18px", BUTTON_SIZE = "32px";
dt$1.span`
  clip: rect(1px, 1px, 1px, 1px);
  clippath: inset(50%);
  height: 1px;
  width: 1px;
  margin: -2px;
  overflow: hidden;
  padding: 0;
  position: absolute;
`;
dt$1.h2`
  font-size: ${SyngentaTheme.FontSize.Title6};
  line-height: 1.333;
  font-weight: 600;
  display: flex;
  gap: 12px;
  align-items: center;
  margin: 0;
`;
dt$1.button`
  border-radius: 100%;
  color: ${Neutral[60]};
  background-color: ${Neutral[0]};
  border: solid 1px ${Neutral[30]};
  width: ${BUTTON_SIZE};
  height: ${BUTTON_SIZE};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  svg {
    width: ${ICON_SIZE};
    height: ${ICON_SIZE};
  }
`;
dt$1.span`
  flex-grow: 1;
`;
const ADDON_DISTANCE = "10px";
dt$1.div`
  position: relative;

  &.is-full {
    width: 100%;
    max-width: 100%;
  }
`;
const search = lt$1`
  width: 256px;
  height: 40px;
  border-radius: 4px;
  border: 1px solid ${Neutral[30]};
  color: ${Neutral[60]};
  background-color: ${Neutral[10]};
`, inputStyles = {
  search
};
dt$1.input`
  border-radius: ${SyngentaTheme.BorderRadius.Small};
  border: solid 1px ${Neutral[30]};
  width: 100%;
  padding: 8px 10px;
  box-sizing: border-box;

  &:hover {
    border-color: ${Blue[50]};
  }

  &:focus,
  &:active {
    border-color: ${Blue[50]};
    box-shadow: 0px 0px 0px 3px rgba(0, 146, 228, 0.25);
    outline: none;
  }

  &:disabled {
    background-color: ${Neutral[20]};
    border-color: ${Neutral[30]};
    color: ${Neutral[50]};
  }

  .has-left-element & {
    padding-left: 32px;
  }

  .has-right-element & {
    padding-right: 32px;
  }

  ${({
  $styleType: _t
}) => _t ? inputStyles[_t] : ""}
`;
const AddonWraper = dt$1.span`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  color: ${Neutral[60]};
  display: flex;
  align-items: center;

  svg {
    width: 18px;
    height: 18px;
  }
`;
dt$1(AddonWraper)`
  left: ${ADDON_DISTANCE};
`;
dt$1(AddonWraper)`
  right: ${ADDON_DISTANCE};
`;
dt$1.label`
  position: relative;
  display: inline-block;
  width: 48px;
  height: 24px;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  input:checked + .slider {
    background-color: #0071cd;
  }

  input:focus + .slider {
    box-shadow: 0 0 1px #0071cd;
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(24px);
    -ms-transform: translateX(24px);
    transform: translateX(24px);
  }
`;
dt$1.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #a3a9b9;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 34px;

  &::before {
    position: absolute;
    content: '';
    height: 20px;
    width: 20px;
    left: 2px;
    bottom: 2px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
  }
`;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var extendStatics = function(_t, Et) {
  return (extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Pt, $t) {
    Pt.__proto__ = $t;
  } || function(Pt, $t) {
    for (var Mt in $t)
      Object.prototype.hasOwnProperty.call($t, Mt) && (Pt[Mt] = $t[Mt]);
  })(_t, Et);
};
function __extends(_t, Et) {
  if (typeof Et != "function" && Et !== null)
    throw new TypeError("Class extends value " + String(Et) + " is not a constructor or null");
  function Pt() {
    this.constructor = _t;
  }
  extendStatics(_t, Et), _t.prototype = Et === null ? Object.create(Et) : (Pt.prototype = Et.prototype, new Pt());
}
var __assign = function() {
  return (__assign = Object.assign || function(_t) {
    for (var Et, Pt = 1, $t = arguments.length; Pt < $t; Pt++)
      for (var Mt in Et = arguments[Pt])
        Object.prototype.hasOwnProperty.call(Et, Mt) && (_t[Mt] = Et[Mt]);
    return _t;
  }).apply(this, arguments);
};
function __awaiter(_t, Et, Pt, $t) {
  return new (Pt || (Pt = Promise))(function(Mt, Bt) {
    function Vt(Wt) {
      try {
        Ht($t.next(Wt));
      } catch (Gt) {
        Bt(Gt);
      }
    }
    function zt(Wt) {
      try {
        Ht($t.throw(Wt));
      } catch (Gt) {
        Bt(Gt);
      }
    }
    function Ht(Wt) {
      var Gt;
      Wt.done ? Mt(Wt.value) : (Gt = Wt.value, Gt instanceof Pt ? Gt : new Pt(function(qt) {
        qt(Gt);
      })).then(Vt, zt);
    }
    Ht(($t = $t.apply(_t, [])).next());
  });
}
function __generator(_t, Et) {
  var Pt, $t, Mt, Bt, Vt = { label: 0, sent: function() {
    if (1 & Mt[0])
      throw Mt[1];
    return Mt[1];
  }, trys: [], ops: [] };
  return Bt = { next: zt(0), throw: zt(1), return: zt(2) }, typeof Symbol == "function" && (Bt[Symbol.iterator] = function() {
    return this;
  }), Bt;
  function zt(Ht) {
    return function(Wt) {
      return function(Gt) {
        if (Pt)
          throw new TypeError("Generator is already executing.");
        for (; Vt; )
          try {
            if (Pt = 1, $t && (Mt = 2 & Gt[0] ? $t.return : Gt[0] ? $t.throw || ((Mt = $t.return) && Mt.call($t), 0) : $t.next) && !(Mt = Mt.call($t, Gt[1])).done)
              return Mt;
            switch ($t = 0, Mt && (Gt = [2 & Gt[0], Mt.value]), Gt[0]) {
              case 0:
              case 1:
                Mt = Gt;
                break;
              case 4:
                return Vt.label++, { value: Gt[1], done: !1 };
              case 5:
                Vt.label++, $t = Gt[1], Gt = [0];
                continue;
              case 7:
                Gt = Vt.ops.pop(), Vt.trys.pop();
                continue;
              default:
                if (Mt = Vt.trys, !((Mt = Mt.length > 0 && Mt[Mt.length - 1]) || Gt[0] !== 6 && Gt[0] !== 2)) {
                  Vt = 0;
                  continue;
                }
                if (Gt[0] === 3 && (!Mt || Gt[1] > Mt[0] && Gt[1] < Mt[3])) {
                  Vt.label = Gt[1];
                  break;
                }
                if (Gt[0] === 6 && Vt.label < Mt[1]) {
                  Vt.label = Mt[1], Mt = Gt;
                  break;
                }
                if (Mt && Vt.label < Mt[2]) {
                  Vt.label = Mt[2], Vt.ops.push(Gt);
                  break;
                }
                Mt[2] && Vt.ops.pop(), Vt.trys.pop();
                continue;
            }
            Gt = Et.call(_t, Vt);
          } catch (qt) {
            Gt = [6, qt], $t = 0;
          } finally {
            Pt = Mt = 0;
          }
        if (5 & Gt[0])
          throw Gt[1];
        return { value: Gt[0] ? Gt[1] : void 0, done: !0 };
      }([Ht, Wt]);
    };
  }
}
function createCommonjsModule(_t, Et) {
  return _t(Et = { exports: {} }, Et.exports), Et.exports;
}
var lottie = createCommonjsModule(function(module, exports) {
  typeof navigator < "u" && function(_t, Et) {
    module.exports = Et();
  }(0, function() {
    var svgNS = "http://www.w3.org/2000/svg", locationHref = "", _useWebWorker = !1, initialDefaultFrame = -999999, setWebWorker = function(_t) {
      _useWebWorker = !!_t;
    }, getWebWorker = function() {
      return _useWebWorker;
    }, setLocationHref = function(_t) {
      locationHref = _t;
    }, getLocationHref = function() {
      return locationHref;
    };
    function createTag(_t) {
      return document.createElement(_t);
    }
    function extendPrototype(_t, Et) {
      var Pt, $t, Mt = _t.length;
      for (Pt = 0; Pt < Mt; Pt += 1)
        for (var Bt in $t = _t[Pt].prototype)
          Object.prototype.hasOwnProperty.call($t, Bt) && (Et.prototype[Bt] = $t[Bt]);
    }
    function getDescriptor(_t, Et) {
      return Object.getOwnPropertyDescriptor(_t, Et);
    }
    function createProxyFunction(_t) {
      function Et() {
      }
      return Et.prototype = _t, Et;
    }
    var audioControllerFactory = function() {
      function _t(Et) {
        this.audios = [], this.audioFactory = Et, this._volume = 1, this._isMuted = !1;
      }
      return _t.prototype = { addAudio: function(Et) {
        this.audios.push(Et);
      }, pause: function() {
        var Et, Pt = this.audios.length;
        for (Et = 0; Et < Pt; Et += 1)
          this.audios[Et].pause();
      }, resume: function() {
        var Et, Pt = this.audios.length;
        for (Et = 0; Et < Pt; Et += 1)
          this.audios[Et].resume();
      }, setRate: function(Et) {
        var Pt, $t = this.audios.length;
        for (Pt = 0; Pt < $t; Pt += 1)
          this.audios[Pt].setRate(Et);
      }, createAudio: function(Et) {
        return this.audioFactory ? this.audioFactory(Et) : window.Howl ? new window.Howl({ src: [Et] }) : { isPlaying: !1, play: function() {
          this.isPlaying = !0;
        }, seek: function() {
          this.isPlaying = !1;
        }, playing: function() {
        }, rate: function() {
        }, setVolume: function() {
        } };
      }, setAudioFactory: function(Et) {
        this.audioFactory = Et;
      }, setVolume: function(Et) {
        this._volume = Et, this._updateVolume();
      }, mute: function() {
        this._isMuted = !0, this._updateVolume();
      }, unmute: function() {
        this._isMuted = !1, this._updateVolume();
      }, getVolume: function() {
        return this._volume;
      }, _updateVolume: function() {
        var Et, Pt = this.audios.length;
        for (Et = 0; Et < Pt; Et += 1)
          this.audios[Et].volume(this._volume * (this._isMuted ? 0 : 1));
      } }, function() {
        return new _t();
      };
    }(), createTypedArray = /* @__PURE__ */ function() {
      function _t(Et, Pt) {
        var $t, Mt = 0, Bt = [];
        switch (Et) {
          case "int16":
          case "uint8c":
            $t = 1;
            break;
          default:
            $t = 1.1;
        }
        for (Mt = 0; Mt < Pt; Mt += 1)
          Bt.push($t);
        return Bt;
      }
      return typeof Uint8ClampedArray == "function" && typeof Float32Array == "function" ? function(Et, Pt) {
        return Et === "float32" ? new Float32Array(Pt) : Et === "int16" ? new Int16Array(Pt) : Et === "uint8c" ? new Uint8ClampedArray(Pt) : _t(Et, Pt);
      } : _t;
    }();
    function createSizedArray(_t) {
      return Array.apply(null, { length: _t });
    }
    function _typeof$6(_t) {
      return (_typeof$6 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Et) {
        return typeof Et;
      } : function(Et) {
        return Et && typeof Symbol == "function" && Et.constructor === Symbol && Et !== Symbol.prototype ? "symbol" : typeof Et;
      })(_t);
    }
    var subframeEnabled = !0, expressionsPlugin = null, expressionsInterfaces = null, idPrefix$1 = "", isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent), bmPow = Math.pow, bmSqrt = Math.sqrt, bmFloor = Math.floor, bmMax = Math.max, bmMin = Math.min, BMMath = {};
    (function() {
      var _t, Et = ["abs", "acos", "acosh", "asin", "asinh", "atan", "atanh", "atan2", "ceil", "cbrt", "expm1", "clz32", "cos", "cosh", "exp", "floor", "fround", "hypot", "imul", "log", "log1p", "log2", "log10", "max", "min", "pow", "random", "round", "sign", "sin", "sinh", "sqrt", "tan", "tanh", "trunc", "E", "LN10", "LN2", "LOG10E", "LOG2E", "PI", "SQRT1_2", "SQRT2"], Pt = Et.length;
      for (_t = 0; _t < Pt; _t += 1)
        BMMath[Et[_t]] = Math[Et[_t]];
    })(), BMMath.random = Math.random, BMMath.abs = function(_t) {
      if (_typeof$6(_t) === "object" && _t.length) {
        var Et, Pt = createSizedArray(_t.length), $t = _t.length;
        for (Et = 0; Et < $t; Et += 1)
          Pt[Et] = Math.abs(_t[Et]);
        return Pt;
      }
      return Math.abs(_t);
    };
    var defaultCurveSegments = 150, degToRads = Math.PI / 180, roundCorner = 0.5519;
    function styleDiv(_t) {
      _t.style.position = "absolute", _t.style.top = 0, _t.style.left = 0, _t.style.display = "block", _t.style.transformOrigin = "0 0", _t.style.webkitTransformOrigin = "0 0", _t.style.backfaceVisibility = "visible", _t.style.webkitBackfaceVisibility = "visible", _t.style.transformStyle = "preserve-3d", _t.style.webkitTransformStyle = "preserve-3d", _t.style.mozTransformStyle = "preserve-3d";
    }
    function BMEnterFrameEvent(_t, Et, Pt, $t) {
      this.type = _t, this.currentTime = Et, this.totalTime = Pt, this.direction = $t < 0 ? -1 : 1;
    }
    function BMCompleteEvent(_t, Et) {
      this.type = _t, this.direction = Et < 0 ? -1 : 1;
    }
    function BMCompleteLoopEvent(_t, Et, Pt, $t) {
      this.type = _t, this.currentLoop = Pt, this.totalLoops = Et, this.direction = $t < 0 ? -1 : 1;
    }
    function BMSegmentStartEvent(_t, Et, Pt) {
      this.type = _t, this.firstFrame = Et, this.totalFrames = Pt;
    }
    function BMDestroyEvent(_t, Et) {
      this.type = _t, this.target = Et;
    }
    function BMRenderFrameErrorEvent(_t, Et) {
      this.type = "renderFrameError", this.nativeError = _t, this.currentTime = Et;
    }
    function BMConfigErrorEvent(_t) {
      this.type = "configError", this.nativeError = _t;
    }
    var createElementID = (_count = 0, function() {
      return idPrefix$1 + "__lottie_element_" + (_count += 1);
    }), _count;
    function HSVtoRGB(_t, Et, Pt) {
      var $t, Mt, Bt, Vt, zt, Ht, Wt, Gt;
      switch (Ht = Pt * (1 - Et), Wt = Pt * (1 - (zt = 6 * _t - (Vt = Math.floor(6 * _t))) * Et), Gt = Pt * (1 - (1 - zt) * Et), Vt % 6) {
        case 0:
          $t = Pt, Mt = Gt, Bt = Ht;
          break;
        case 1:
          $t = Wt, Mt = Pt, Bt = Ht;
          break;
        case 2:
          $t = Ht, Mt = Pt, Bt = Gt;
          break;
        case 3:
          $t = Ht, Mt = Wt, Bt = Pt;
          break;
        case 4:
          $t = Gt, Mt = Ht, Bt = Pt;
          break;
        case 5:
          $t = Pt, Mt = Ht, Bt = Wt;
      }
      return [$t, Mt, Bt];
    }
    function RGBtoHSV(_t, Et, Pt) {
      var $t, Mt = Math.max(_t, Et, Pt), Bt = Math.min(_t, Et, Pt), Vt = Mt - Bt, zt = Mt === 0 ? 0 : Vt / Mt, Ht = Mt / 255;
      switch (Mt) {
        case Bt:
          $t = 0;
          break;
        case _t:
          $t = Et - Pt + Vt * (Et < Pt ? 6 : 0), $t /= 6 * Vt;
          break;
        case Et:
          $t = Pt - _t + 2 * Vt, $t /= 6 * Vt;
          break;
        case Pt:
          $t = _t - Et + 4 * Vt, $t /= 6 * Vt;
      }
      return [$t, zt, Ht];
    }
    function addSaturationToRGB(_t, Et) {
      var Pt = RGBtoHSV(255 * _t[0], 255 * _t[1], 255 * _t[2]);
      return Pt[1] += Et, Pt[1] > 1 ? Pt[1] = 1 : Pt[1] <= 0 && (Pt[1] = 0), HSVtoRGB(Pt[0], Pt[1], Pt[2]);
    }
    function addBrightnessToRGB(_t, Et) {
      var Pt = RGBtoHSV(255 * _t[0], 255 * _t[1], 255 * _t[2]);
      return Pt[2] += Et, Pt[2] > 1 ? Pt[2] = 1 : Pt[2] < 0 && (Pt[2] = 0), HSVtoRGB(Pt[0], Pt[1], Pt[2]);
    }
    function addHueToRGB(_t, Et) {
      var Pt = RGBtoHSV(255 * _t[0], 255 * _t[1], 255 * _t[2]);
      return Pt[0] += Et / 360, Pt[0] > 1 ? Pt[0] -= 1 : Pt[0] < 0 && (Pt[0] += 1), HSVtoRGB(Pt[0], Pt[1], Pt[2]);
    }
    var rgbToHex = function() {
      var _t, Et, Pt = [];
      for (_t = 0; _t < 256; _t += 1)
        Et = _t.toString(16), Pt[_t] = Et.length === 1 ? "0" + Et : Et;
      return function($t, Mt, Bt) {
        return $t < 0 && ($t = 0), Mt < 0 && (Mt = 0), Bt < 0 && (Bt = 0), "#" + Pt[$t] + Pt[Mt] + Pt[Bt];
      };
    }(), setSubframeEnabled = function(_t) {
      subframeEnabled = !!_t;
    }, getSubframeEnabled = function() {
      return subframeEnabled;
    }, setExpressionsPlugin = function(_t) {
      expressionsPlugin = _t;
    }, getExpressionsPlugin = function() {
      return expressionsPlugin;
    }, setExpressionInterfaces = function(_t) {
      expressionsInterfaces = _t;
    }, getExpressionInterfaces = function() {
      return expressionsInterfaces;
    }, setDefaultCurveSegments = function(_t) {
      defaultCurveSegments = _t;
    }, getDefaultCurveSegments = function() {
      return defaultCurveSegments;
    }, setIdPrefix = function(_t) {
      idPrefix$1 = _t;
    };
    function createNS(_t) {
      return document.createElementNS(svgNS, _t);
    }
    function _typeof$5(_t) {
      return (_typeof$5 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Et) {
        return typeof Et;
      } : function(Et) {
        return Et && typeof Symbol == "function" && Et.constructor === Symbol && Et !== Symbol.prototype ? "symbol" : typeof Et;
      })(_t);
    }
    var dataManager = /* @__PURE__ */ function() {
      var _t, Et, Pt = 1, $t = [], Mt = { onmessage: function() {
      }, postMessage: function(Ht) {
        _t({ data: Ht });
      } }, Bt = { postMessage: function(Ht) {
        Mt.onmessage({ data: Ht });
      } };
      function Vt() {
        Et || ((Et = function(Ht) {
          if (window.Worker && window.Blob && getWebWorker()) {
            var Wt = new Blob(["var _workerSelf = self; self.onmessage = ", Ht.toString()], { type: "text/javascript" }), Gt = URL.createObjectURL(Wt);
            return new Worker(Gt);
          }
          return _t = Ht, Mt;
        }(function(Ht) {
          if (Bt.dataManager || (Bt.dataManager = function() {
            function Gt(ar, or) {
              var sr, lr, cr, hr, pr, mr, Er = ar.length;
              for (lr = 0; lr < Er; lr += 1)
                if ("ks" in (sr = ar[lr]) && !sr.completed) {
                  if (sr.completed = !0, sr.hasMask) {
                    var _r = sr.masksProperties;
                    for (hr = _r.length, cr = 0; cr < hr; cr += 1)
                      if (_r[cr].pt.k.i)
                        Qt(_r[cr].pt.k);
                      else
                        for (mr = _r[cr].pt.k.length, pr = 0; pr < mr; pr += 1)
                          _r[cr].pt.k[pr].s && Qt(_r[cr].pt.k[pr].s[0]), _r[cr].pt.k[pr].e && Qt(_r[cr].pt.k[pr].e[0]);
                  }
                  sr.ty === 0 ? (sr.layers = qt(sr.refId, or), Gt(sr.layers, or)) : sr.ty === 4 ? Kt(sr.shapes) : sr.ty === 5 && rr(sr);
                }
            }
            function qt(ar, or) {
              var sr = function(lr, cr) {
                for (var hr = 0, pr = cr.length; hr < pr; ) {
                  if (cr[hr].id === lr)
                    return cr[hr];
                  hr += 1;
                }
                return null;
              }(ar, or);
              return sr ? sr.layers.__used ? JSON.parse(JSON.stringify(sr.layers)) : (sr.layers.__used = !0, sr.layers) : null;
            }
            function Kt(ar) {
              var or, sr, lr;
              for (or = ar.length - 1; or >= 0; or -= 1)
                if (ar[or].ty === "sh")
                  if (ar[or].ks.k.i)
                    Qt(ar[or].ks.k);
                  else
                    for (lr = ar[or].ks.k.length, sr = 0; sr < lr; sr += 1)
                      ar[or].ks.k[sr].s && Qt(ar[or].ks.k[sr].s[0]), ar[or].ks.k[sr].e && Qt(ar[or].ks.k[sr].e[0]);
                else
                  ar[or].ty === "gr" && Kt(ar[or].it);
            }
            function Qt(ar) {
              var or, sr = ar.i.length;
              for (or = 0; or < sr; or += 1)
                ar.i[or][0] += ar.v[or][0], ar.i[or][1] += ar.v[or][1], ar.o[or][0] += ar.v[or][0], ar.o[or][1] += ar.v[or][1];
            }
            function Xt(ar, or) {
              var sr = or ? or.split(".") : [100, 100, 100];
              return ar[0] > sr[0] || !(sr[0] > ar[0]) && (ar[1] > sr[1] || !(sr[1] > ar[1]) && (ar[2] > sr[2] || !(sr[2] > ar[2]) && null));
            }
            var Zt, Yt = /* @__PURE__ */ function() {
              var ar = [4, 4, 14];
              function or(sr) {
                var lr, cr, hr, pr = sr.length;
                for (lr = 0; lr < pr; lr += 1)
                  sr[lr].ty === 5 && (cr = sr[lr], hr = void 0, hr = cr.t.d, cr.t.d = { k: [{ s: hr, t: 0 }] });
              }
              return function(sr) {
                if (Xt(ar, sr.v) && (or(sr.layers), sr.assets)) {
                  var lr, cr = sr.assets.length;
                  for (lr = 0; lr < cr; lr += 1)
                    sr.assets[lr].layers && or(sr.assets[lr].layers);
                }
              };
            }(), Jt = (Zt = [4, 7, 99], function(ar) {
              if (ar.chars && !Xt(Zt, ar.v)) {
                var or, sr = ar.chars.length;
                for (or = 0; or < sr; or += 1) {
                  var lr = ar.chars[or];
                  lr.data && lr.data.shapes && (Kt(lr.data.shapes), lr.data.ip = 0, lr.data.op = 99999, lr.data.st = 0, lr.data.sr = 1, lr.data.ks = { p: { k: [0, 0], a: 0 }, s: { k: [100, 100], a: 0 }, a: { k: [0, 0], a: 0 }, r: { k: 0, a: 0 }, o: { k: 100, a: 0 } }, ar.chars[or].t || (lr.data.shapes.push({ ty: "no" }), lr.data.shapes[0].it.push({ p: { k: [0, 0], a: 0 }, s: { k: [100, 100], a: 0 }, a: { k: [0, 0], a: 0 }, r: { k: 0, a: 0 }, o: { k: 100, a: 0 }, sk: { k: 0, a: 0 }, sa: { k: 0, a: 0 }, ty: "tr" })));
                }
              }
            }), er = /* @__PURE__ */ function() {
              var ar = [5, 7, 15];
              function or(sr) {
                var lr, cr, hr, pr = sr.length;
                for (lr = 0; lr < pr; lr += 1)
                  sr[lr].ty === 5 && (cr = sr[lr], hr = void 0, typeof (hr = cr.t.p).a == "number" && (hr.a = { a: 0, k: hr.a }), typeof hr.p == "number" && (hr.p = { a: 0, k: hr.p }), typeof hr.r == "number" && (hr.r = { a: 0, k: hr.r }));
              }
              return function(sr) {
                if (Xt(ar, sr.v) && (or(sr.layers), sr.assets)) {
                  var lr, cr = sr.assets.length;
                  for (lr = 0; lr < cr; lr += 1)
                    sr.assets[lr].layers && or(sr.assets[lr].layers);
                }
              };
            }(), tr = /* @__PURE__ */ function() {
              var ar = [4, 1, 9];
              function or(lr) {
                var cr, hr, pr, mr = lr.length;
                for (cr = 0; cr < mr; cr += 1)
                  if (lr[cr].ty === "gr")
                    or(lr[cr].it);
                  else if (lr[cr].ty === "fl" || lr[cr].ty === "st")
                    if (lr[cr].c.k && lr[cr].c.k[0].i)
                      for (pr = lr[cr].c.k.length, hr = 0; hr < pr; hr += 1)
                        lr[cr].c.k[hr].s && (lr[cr].c.k[hr].s[0] /= 255, lr[cr].c.k[hr].s[1] /= 255, lr[cr].c.k[hr].s[2] /= 255, lr[cr].c.k[hr].s[3] /= 255), lr[cr].c.k[hr].e && (lr[cr].c.k[hr].e[0] /= 255, lr[cr].c.k[hr].e[1] /= 255, lr[cr].c.k[hr].e[2] /= 255, lr[cr].c.k[hr].e[3] /= 255);
                    else
                      lr[cr].c.k[0] /= 255, lr[cr].c.k[1] /= 255, lr[cr].c.k[2] /= 255, lr[cr].c.k[3] /= 255;
              }
              function sr(lr) {
                var cr, hr = lr.length;
                for (cr = 0; cr < hr; cr += 1)
                  lr[cr].ty === 4 && or(lr[cr].shapes);
              }
              return function(lr) {
                if (Xt(ar, lr.v) && (sr(lr.layers), lr.assets)) {
                  var cr, hr = lr.assets.length;
                  for (cr = 0; cr < hr; cr += 1)
                    lr.assets[cr].layers && sr(lr.assets[cr].layers);
                }
              };
            }(), nr = /* @__PURE__ */ function() {
              var ar = [4, 4, 18];
              function or(lr) {
                var cr, hr, pr;
                for (cr = lr.length - 1; cr >= 0; cr -= 1)
                  if (lr[cr].ty === "sh")
                    if (lr[cr].ks.k.i)
                      lr[cr].ks.k.c = lr[cr].closed;
                    else
                      for (pr = lr[cr].ks.k.length, hr = 0; hr < pr; hr += 1)
                        lr[cr].ks.k[hr].s && (lr[cr].ks.k[hr].s[0].c = lr[cr].closed), lr[cr].ks.k[hr].e && (lr[cr].ks.k[hr].e[0].c = lr[cr].closed);
                  else
                    lr[cr].ty === "gr" && or(lr[cr].it);
              }
              function sr(lr) {
                var cr, hr, pr, mr, Er, _r, yr = lr.length;
                for (hr = 0; hr < yr; hr += 1) {
                  if ((cr = lr[hr]).hasMask) {
                    var ur = cr.masksProperties;
                    for (mr = ur.length, pr = 0; pr < mr; pr += 1)
                      if (ur[pr].pt.k.i)
                        ur[pr].pt.k.c = ur[pr].cl;
                      else
                        for (_r = ur[pr].pt.k.length, Er = 0; Er < _r; Er += 1)
                          ur[pr].pt.k[Er].s && (ur[pr].pt.k[Er].s[0].c = ur[pr].cl), ur[pr].pt.k[Er].e && (ur[pr].pt.k[Er].e[0].c = ur[pr].cl);
                  }
                  cr.ty === 4 && or(cr.shapes);
                }
              }
              return function(lr) {
                if (Xt(ar, lr.v) && (sr(lr.layers), lr.assets)) {
                  var cr, hr = lr.assets.length;
                  for (cr = 0; cr < hr; cr += 1)
                    lr.assets[cr].layers && sr(lr.assets[cr].layers);
                }
              };
            }();
            function rr(ar) {
              ar.t.a.length === 0 && ar.t.p;
            }
            var ir = { completeData: function(ar) {
              ar.__complete || (tr(ar), Yt(ar), Jt(ar), er(ar), nr(ar), Gt(ar.layers, ar.assets), function(or, sr) {
                if (or) {
                  var lr = 0, cr = or.length;
                  for (lr = 0; lr < cr; lr += 1)
                    or[lr].t === 1 && (or[lr].data.layers = qt(or[lr].data.refId, sr), Gt(or[lr].data.layers, sr));
                }
              }(ar.chars, ar.assets), ar.__complete = !0);
            } };
            return ir.checkColors = tr, ir.checkChars = Jt, ir.checkPathProperties = er, ir.checkShapes = nr, ir.completeLayers = Gt, ir;
          }()), Bt.assetLoader || (Bt.assetLoader = /* @__PURE__ */ function() {
            function Gt(qt) {
              var Kt = qt.getResponseHeader("content-type");
              return Kt && qt.responseType === "json" && Kt.indexOf("json") !== -1 || qt.response && _typeof$5(qt.response) === "object" ? qt.response : qt.response && typeof qt.response == "string" ? JSON.parse(qt.response) : qt.responseText ? JSON.parse(qt.responseText) : null;
            }
            return { load: function(qt, Kt, Qt, Xt) {
              var Zt, Yt = new XMLHttpRequest();
              try {
                Yt.responseType = "json";
              } catch {
              }
              Yt.onreadystatechange = function() {
                if (Yt.readyState === 4)
                  if (Yt.status === 200)
                    Zt = Gt(Yt), Qt(Zt);
                  else
                    try {
                      Zt = Gt(Yt), Qt(Zt);
                    } catch (Jt) {
                      Xt && Xt(Jt);
                    }
              };
              try {
                Yt.open(["G", "E", "T"].join(""), qt, !0);
              } catch {
                Yt.open(["G", "E", "T"].join(""), Kt + "/" + qt, !0);
              }
              Yt.send();
            } };
          }()), Ht.data.type === "loadAnimation")
            Bt.assetLoader.load(Ht.data.path, Ht.data.fullPath, function(Gt) {
              Bt.dataManager.completeData(Gt), Bt.postMessage({ id: Ht.data.id, payload: Gt, status: "success" });
            }, function() {
              Bt.postMessage({ id: Ht.data.id, status: "error" });
            });
          else if (Ht.data.type === "complete") {
            var Wt = Ht.data.animation;
            Bt.dataManager.completeData(Wt), Bt.postMessage({ id: Ht.data.id, payload: Wt, status: "success" });
          } else
            Ht.data.type === "loadData" && Bt.assetLoader.load(Ht.data.path, Ht.data.fullPath, function(Gt) {
              Bt.postMessage({ id: Ht.data.id, payload: Gt, status: "success" });
            }, function() {
              Bt.postMessage({ id: Ht.data.id, status: "error" });
            });
        })).onmessage = function(Ht) {
          var Wt = Ht.data, Gt = Wt.id, qt = $t[Gt];
          $t[Gt] = null, Wt.status === "success" ? qt.onComplete(Wt.payload) : qt.onError && qt.onError();
        });
      }
      function zt(Ht, Wt) {
        var Gt = "processId_" + (Pt += 1);
        return $t[Gt] = { onComplete: Ht, onError: Wt }, Gt;
      }
      return { loadAnimation: function(Ht, Wt, Gt) {
        Vt();
        var qt = zt(Wt, Gt);
        Et.postMessage({ type: "loadAnimation", path: Ht, fullPath: window.location.origin + window.location.pathname, id: qt });
      }, loadData: function(Ht, Wt, Gt) {
        Vt();
        var qt = zt(Wt, Gt);
        Et.postMessage({ type: "loadData", path: Ht, fullPath: window.location.origin + window.location.pathname, id: qt });
      }, completeAnimation: function(Ht, Wt, Gt) {
        Vt();
        var qt = zt(Wt, Gt);
        Et.postMessage({ type: "complete", animation: Ht, id: qt });
      } };
    }(), ImagePreloader = function() {
      var _t = function() {
        var zt = createTag("canvas");
        zt.width = 1, zt.height = 1;
        var Ht = zt.getContext("2d");
        return Ht.fillStyle = "rgba(0,0,0,0)", Ht.fillRect(0, 0, 1, 1), zt;
      }();
      function Et() {
        this.loadedAssets += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
      }
      function Pt() {
        this.loadedFootagesCount += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
      }
      function $t(zt, Ht, Wt) {
        var Gt = "";
        if (zt.e)
          Gt = zt.p;
        else if (Ht) {
          var qt = zt.p;
          qt.indexOf("images/") !== -1 && (qt = qt.split("/")[1]), Gt = Ht + qt;
        } else
          Gt = Wt, Gt += zt.u ? zt.u : "", Gt += zt.p;
        return Gt;
      }
      function Mt(zt) {
        var Ht = 0, Wt = setInterval((function() {
          (zt.getBBox().width || Ht > 500) && (this._imageLoaded(), clearInterval(Wt)), Ht += 1;
        }).bind(this), 50);
      }
      function Bt(zt) {
        var Ht = { assetData: zt }, Wt = $t(zt, this.assetsPath, this.path);
        return dataManager.loadData(Wt, (function(Gt) {
          Ht.img = Gt, this._footageLoaded();
        }).bind(this), (function() {
          Ht.img = {}, this._footageLoaded();
        }).bind(this)), Ht;
      }
      function Vt() {
        this._imageLoaded = Et.bind(this), this._footageLoaded = Pt.bind(this), this.testImageLoaded = Mt.bind(this), this.createFootageData = Bt.bind(this), this.assetsPath = "", this.path = "", this.totalImages = 0, this.totalFootages = 0, this.loadedAssets = 0, this.loadedFootagesCount = 0, this.imagesLoadedCb = null, this.images = [];
      }
      return Vt.prototype = { loadAssets: function(zt, Ht) {
        var Wt;
        this.imagesLoadedCb = Ht;
        var Gt = zt.length;
        for (Wt = 0; Wt < Gt; Wt += 1)
          zt[Wt].layers || (zt[Wt].t && zt[Wt].t !== "seq" ? zt[Wt].t === 3 && (this.totalFootages += 1, this.images.push(this.createFootageData(zt[Wt]))) : (this.totalImages += 1, this.images.push(this._createImageData(zt[Wt]))));
      }, setAssetsPath: function(zt) {
        this.assetsPath = zt || "";
      }, setPath: function(zt) {
        this.path = zt || "";
      }, loadedImages: function() {
        return this.totalImages === this.loadedAssets;
      }, loadedFootages: function() {
        return this.totalFootages === this.loadedFootagesCount;
      }, destroy: function() {
        this.imagesLoadedCb = null, this.images.length = 0;
      }, getAsset: function(zt) {
        for (var Ht = 0, Wt = this.images.length; Ht < Wt; ) {
          if (this.images[Ht].assetData === zt)
            return this.images[Ht].img;
          Ht += 1;
        }
        return null;
      }, createImgData: function(zt) {
        var Ht = $t(zt, this.assetsPath, this.path), Wt = createTag("img");
        Wt.crossOrigin = "anonymous", Wt.addEventListener("load", this._imageLoaded, !1), Wt.addEventListener("error", (function() {
          Gt.img = _t, this._imageLoaded();
        }).bind(this), !1), Wt.src = Ht;
        var Gt = { img: Wt, assetData: zt };
        return Gt;
      }, createImageData: function(zt) {
        var Ht = $t(zt, this.assetsPath, this.path), Wt = createNS("image");
        isSafari ? this.testImageLoaded(Wt) : Wt.addEventListener("load", this._imageLoaded, !1), Wt.addEventListener("error", (function() {
          Gt.img = _t, this._imageLoaded();
        }).bind(this), !1), Wt.setAttributeNS("http://www.w3.org/1999/xlink", "href", Ht), this._elementHelper.append ? this._elementHelper.append(Wt) : this._elementHelper.appendChild(Wt);
        var Gt = { img: Wt, assetData: zt };
        return Gt;
      }, imageLoaded: Et, footageLoaded: Pt, setCacheType: function(zt, Ht) {
        zt === "svg" ? (this._elementHelper = Ht, this._createImageData = this.createImageData.bind(this)) : this._createImageData = this.createImgData.bind(this);
      } }, Vt;
    }();
    function BaseEvent() {
    }
    BaseEvent.prototype = { triggerEvent: function(_t, Et) {
      if (this._cbs[_t])
        for (var Pt = this._cbs[_t], $t = 0; $t < Pt.length; $t += 1)
          Pt[$t](Et);
    }, addEventListener: function(_t, Et) {
      return this._cbs[_t] || (this._cbs[_t] = []), this._cbs[_t].push(Et), (function() {
        this.removeEventListener(_t, Et);
      }).bind(this);
    }, removeEventListener: function(_t, Et) {
      if (Et) {
        if (this._cbs[_t]) {
          for (var Pt = 0, $t = this._cbs[_t].length; Pt < $t; )
            this._cbs[_t][Pt] === Et && (this._cbs[_t].splice(Pt, 1), Pt -= 1, $t -= 1), Pt += 1;
          this._cbs[_t].length || (this._cbs[_t] = null);
        }
      } else
        this._cbs[_t] = null;
    } };
    var markerParser = /* @__PURE__ */ function() {
      function _t(Et) {
        for (var Pt, $t = Et.split(`\r
`), Mt = {}, Bt = 0, Vt = 0; Vt < $t.length; Vt += 1)
          (Pt = $t[Vt].split(":")).length === 2 && (Mt[Pt[0]] = Pt[1].trim(), Bt += 1);
        if (Bt === 0)
          throw new Error();
        return Mt;
      }
      return function(Et) {
        for (var Pt = [], $t = 0; $t < Et.length; $t += 1) {
          var Mt = Et[$t], Bt = { time: Mt.tm, duration: Mt.dr };
          try {
            Bt.payload = JSON.parse(Et[$t].cm);
          } catch {
            try {
              Bt.payload = _t(Et[$t].cm);
            } catch {
              Bt.payload = { name: Et[$t].cm };
            }
          }
          Pt.push(Bt);
        }
        return Pt;
      };
    }(), ProjectInterface = /* @__PURE__ */ function() {
      function _t(Et) {
        this.compositions.push(Et);
      }
      return function() {
        function Et(Pt) {
          for (var $t = 0, Mt = this.compositions.length; $t < Mt; ) {
            if (this.compositions[$t].data && this.compositions[$t].data.nm === Pt)
              return this.compositions[$t].prepareFrame && this.compositions[$t].data.xt && this.compositions[$t].prepareFrame(this.currentFrame), this.compositions[$t].compInterface;
            $t += 1;
          }
          return null;
        }
        return Et.compositions = [], Et.currentFrame = 0, Et.registerComposition = _t, Et;
      };
    }(), renderers = {}, registerRenderer = function(_t, Et) {
      renderers[_t] = Et;
    };
    function getRenderer(_t) {
      return renderers[_t];
    }
    function getRegisteredRenderer() {
      if (renderers.canvas)
        return "canvas";
      for (var _t in renderers)
        if (renderers[_t])
          return _t;
      return "";
    }
    function _typeof$4(_t) {
      return (_typeof$4 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Et) {
        return typeof Et;
      } : function(Et) {
        return Et && typeof Symbol == "function" && Et.constructor === Symbol && Et !== Symbol.prototype ? "symbol" : typeof Et;
      })(_t);
    }
    var AnimationItem = function() {
      this._cbs = [], this.name = "", this.path = "", this.isLoaded = !1, this.currentFrame = 0, this.currentRawFrame = 0, this.firstFrame = 0, this.totalFrames = 0, this.frameRate = 0, this.frameMult = 0, this.playSpeed = 1, this.playDirection = 1, this.playCount = 0, this.animationData = {}, this.assets = [], this.isPaused = !0, this.autoplay = !1, this.loop = !0, this.renderer = null, this.animationID = createElementID(), this.assetsPath = "", this.timeCompleted = 0, this.segmentPos = 0, this.isSubframeEnabled = getSubframeEnabled(), this.segments = [], this._idle = !0, this._completedLoop = !1, this.projectInterface = ProjectInterface(), this.imagePreloader = new ImagePreloader(), this.audioController = audioControllerFactory(), this.markers = [], this.configAnimation = this.configAnimation.bind(this), this.onSetupError = this.onSetupError.bind(this), this.onSegmentComplete = this.onSegmentComplete.bind(this), this.drawnFrameEvent = new BMEnterFrameEvent("drawnFrame", 0, 0, 0), this.expressionsPlugin = getExpressionsPlugin();
    };
    extendPrototype([BaseEvent], AnimationItem), AnimationItem.prototype.setParams = function(_t) {
      (_t.wrapper || _t.container) && (this.wrapper = _t.wrapper || _t.container);
      var Et = "svg";
      _t.animType ? Et = _t.animType : _t.renderer && (Et = _t.renderer);
      var Pt = getRenderer(Et);
      this.renderer = new Pt(this, _t.rendererSettings), this.imagePreloader.setCacheType(Et, this.renderer.globalData.defs), this.renderer.setProjectInterface(this.projectInterface), this.animType = Et, _t.loop === "" || _t.loop === null || _t.loop === void 0 || _t.loop === !0 ? this.loop = !0 : _t.loop === !1 ? this.loop = !1 : this.loop = parseInt(_t.loop, 10), this.autoplay = !("autoplay" in _t) || _t.autoplay, this.name = _t.name ? _t.name : "", this.autoloadSegments = !Object.prototype.hasOwnProperty.call(_t, "autoloadSegments") || _t.autoloadSegments, this.assetsPath = _t.assetsPath, this.initialSegment = _t.initialSegment, _t.audioFactory && this.audioController.setAudioFactory(_t.audioFactory), _t.animationData ? this.setupAnimation(_t.animationData) : _t.path && (_t.path.lastIndexOf("\\") !== -1 ? this.path = _t.path.substr(0, _t.path.lastIndexOf("\\") + 1) : this.path = _t.path.substr(0, _t.path.lastIndexOf("/") + 1), this.fileName = _t.path.substr(_t.path.lastIndexOf("/") + 1), this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf(".json")), dataManager.loadAnimation(_t.path, this.configAnimation, this.onSetupError));
    }, AnimationItem.prototype.onSetupError = function() {
      this.trigger("data_failed");
    }, AnimationItem.prototype.setupAnimation = function(_t) {
      dataManager.completeAnimation(_t, this.configAnimation);
    }, AnimationItem.prototype.setData = function(_t, Et) {
      Et && _typeof$4(Et) !== "object" && (Et = JSON.parse(Et));
      var Pt = { wrapper: _t, animationData: Et }, $t = _t.attributes;
      Pt.path = $t.getNamedItem("data-animation-path") ? $t.getNamedItem("data-animation-path").value : $t.getNamedItem("data-bm-path") ? $t.getNamedItem("data-bm-path").value : $t.getNamedItem("bm-path") ? $t.getNamedItem("bm-path").value : "", Pt.animType = $t.getNamedItem("data-anim-type") ? $t.getNamedItem("data-anim-type").value : $t.getNamedItem("data-bm-type") ? $t.getNamedItem("data-bm-type").value : $t.getNamedItem("bm-type") ? $t.getNamedItem("bm-type").value : $t.getNamedItem("data-bm-renderer") ? $t.getNamedItem("data-bm-renderer").value : $t.getNamedItem("bm-renderer") ? $t.getNamedItem("bm-renderer").value : getRegisteredRenderer() || "canvas";
      var Mt = $t.getNamedItem("data-anim-loop") ? $t.getNamedItem("data-anim-loop").value : $t.getNamedItem("data-bm-loop") ? $t.getNamedItem("data-bm-loop").value : $t.getNamedItem("bm-loop") ? $t.getNamedItem("bm-loop").value : "";
      Mt === "false" ? Pt.loop = !1 : Mt === "true" ? Pt.loop = !0 : Mt !== "" && (Pt.loop = parseInt(Mt, 10));
      var Bt = $t.getNamedItem("data-anim-autoplay") ? $t.getNamedItem("data-anim-autoplay").value : $t.getNamedItem("data-bm-autoplay") ? $t.getNamedItem("data-bm-autoplay").value : !$t.getNamedItem("bm-autoplay") || $t.getNamedItem("bm-autoplay").value;
      Pt.autoplay = Bt !== "false", Pt.name = $t.getNamedItem("data-name") ? $t.getNamedItem("data-name").value : $t.getNamedItem("data-bm-name") ? $t.getNamedItem("data-bm-name").value : $t.getNamedItem("bm-name") ? $t.getNamedItem("bm-name").value : "", ($t.getNamedItem("data-anim-prerender") ? $t.getNamedItem("data-anim-prerender").value : $t.getNamedItem("data-bm-prerender") ? $t.getNamedItem("data-bm-prerender").value : $t.getNamedItem("bm-prerender") ? $t.getNamedItem("bm-prerender").value : "") === "false" && (Pt.prerender = !1), Pt.path ? this.setParams(Pt) : this.trigger("destroy");
    }, AnimationItem.prototype.includeLayers = function(_t) {
      _t.op > this.animationData.op && (this.animationData.op = _t.op, this.totalFrames = Math.floor(_t.op - this.animationData.ip));
      var Et, Pt, $t = this.animationData.layers, Mt = $t.length, Bt = _t.layers, Vt = Bt.length;
      for (Pt = 0; Pt < Vt; Pt += 1)
        for (Et = 0; Et < Mt; ) {
          if ($t[Et].id === Bt[Pt].id) {
            $t[Et] = Bt[Pt];
            break;
          }
          Et += 1;
        }
      if ((_t.chars || _t.fonts) && (this.renderer.globalData.fontManager.addChars(_t.chars), this.renderer.globalData.fontManager.addFonts(_t.fonts, this.renderer.globalData.defs)), _t.assets)
        for (Mt = _t.assets.length, Et = 0; Et < Mt; Et += 1)
          this.animationData.assets.push(_t.assets[Et]);
      this.animationData.__complete = !1, dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
    }, AnimationItem.prototype.onSegmentComplete = function(_t) {
      this.animationData = _t;
      var Et = getExpressionsPlugin();
      Et && Et.initExpressions(this), this.loadNextSegment();
    }, AnimationItem.prototype.loadNextSegment = function() {
      var _t = this.animationData.segments;
      if (!_t || _t.length === 0 || !this.autoloadSegments)
        return this.trigger("data_ready"), void (this.timeCompleted = this.totalFrames);
      var Et = _t.shift();
      this.timeCompleted = Et.time * this.frameRate;
      var Pt = this.path + this.fileName + "_" + this.segmentPos + ".json";
      this.segmentPos += 1, dataManager.loadData(Pt, this.includeLayers.bind(this), (function() {
        this.trigger("data_failed");
      }).bind(this));
    }, AnimationItem.prototype.loadSegments = function() {
      this.animationData.segments || (this.timeCompleted = this.totalFrames), this.loadNextSegment();
    }, AnimationItem.prototype.imagesLoaded = function() {
      this.trigger("loaded_images"), this.checkLoaded();
    }, AnimationItem.prototype.preloadImages = function() {
      this.imagePreloader.setAssetsPath(this.assetsPath), this.imagePreloader.setPath(this.path), this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
    }, AnimationItem.prototype.configAnimation = function(_t) {
      if (this.renderer)
        try {
          this.animationData = _t, this.initialSegment ? (this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]), this.firstFrame = Math.round(this.initialSegment[0])) : (this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip), this.firstFrame = Math.round(this.animationData.ip)), this.renderer.configAnimation(_t), _t.assets || (_t.assets = []), this.assets = this.animationData.assets, this.frameRate = this.animationData.fr, this.frameMult = this.animationData.fr / 1e3, this.renderer.searchExtraCompositions(_t.assets), this.markers = markerParser(_t.markers || []), this.trigger("config_ready"), this.preloadImages(), this.loadSegments(), this.updaFrameModifier(), this.waitForFontsLoaded(), this.isPaused && this.audioController.pause();
        } catch (Et) {
          this.triggerConfigError(Et);
        }
    }, AnimationItem.prototype.waitForFontsLoaded = function() {
      this.renderer && (this.renderer.globalData.fontManager.isLoaded ? this.checkLoaded() : setTimeout(this.waitForFontsLoaded.bind(this), 20));
    }, AnimationItem.prototype.checkLoaded = function() {
      if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== "canvas") && this.imagePreloader.loadedFootages()) {
        this.isLoaded = !0;
        var _t = getExpressionsPlugin();
        _t && _t.initExpressions(this), this.renderer.initItems(), setTimeout((function() {
          this.trigger("DOMLoaded");
        }).bind(this), 0), this.gotoFrame(), this.autoplay && this.play();
      }
    }, AnimationItem.prototype.resize = function(_t, Et) {
      var Pt = typeof _t == "number" ? _t : void 0, $t = typeof Et == "number" ? Et : void 0;
      this.renderer.updateContainerSize(Pt, $t);
    }, AnimationItem.prototype.setSubframe = function(_t) {
      this.isSubframeEnabled = !!_t;
    }, AnimationItem.prototype.gotoFrame = function() {
      this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame, this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted && (this.currentFrame = this.timeCompleted), this.trigger("enterFrame"), this.renderFrame(), this.trigger("drawnFrame");
    }, AnimationItem.prototype.renderFrame = function() {
      if (this.isLoaded !== !1 && this.renderer)
        try {
          this.expressionsPlugin && this.expressionsPlugin.resetFrame(), this.renderer.renderFrame(this.currentFrame + this.firstFrame);
        } catch (_t) {
          this.triggerRenderFrameError(_t);
        }
    }, AnimationItem.prototype.play = function(_t) {
      _t && this.name !== _t || this.isPaused === !0 && (this.isPaused = !1, this.trigger("_play"), this.audioController.resume(), this._idle && (this._idle = !1, this.trigger("_active")));
    }, AnimationItem.prototype.pause = function(_t) {
      _t && this.name !== _t || this.isPaused === !1 && (this.isPaused = !0, this.trigger("_pause"), this._idle = !0, this.trigger("_idle"), this.audioController.pause());
    }, AnimationItem.prototype.togglePause = function(_t) {
      _t && this.name !== _t || (this.isPaused === !0 ? this.play() : this.pause());
    }, AnimationItem.prototype.stop = function(_t) {
      _t && this.name !== _t || (this.pause(), this.playCount = 0, this._completedLoop = !1, this.setCurrentRawFrameValue(0));
    }, AnimationItem.prototype.getMarkerData = function(_t) {
      for (var Et, Pt = 0; Pt < this.markers.length; Pt += 1)
        if ((Et = this.markers[Pt]).payload && Et.payload.name === _t)
          return Et;
      return null;
    }, AnimationItem.prototype.goToAndStop = function(_t, Et, Pt) {
      if (!Pt || this.name === Pt) {
        var $t = Number(_t);
        if (isNaN($t)) {
          var Mt = this.getMarkerData(_t);
          Mt && this.goToAndStop(Mt.time, !0);
        } else
          Et ? this.setCurrentRawFrameValue(_t) : this.setCurrentRawFrameValue(_t * this.frameModifier);
        this.pause();
      }
    }, AnimationItem.prototype.goToAndPlay = function(_t, Et, Pt) {
      if (!Pt || this.name === Pt) {
        var $t = Number(_t);
        if (isNaN($t)) {
          var Mt = this.getMarkerData(_t);
          Mt && (Mt.duration ? this.playSegments([Mt.time, Mt.time + Mt.duration], !0) : this.goToAndStop(Mt.time, !0));
        } else
          this.goToAndStop($t, Et, Pt);
        this.play();
      }
    }, AnimationItem.prototype.advanceTime = function(_t) {
      if (this.isPaused !== !0 && this.isLoaded !== !1) {
        var Et = this.currentRawFrame + _t * this.frameModifier, Pt = !1;
        Et >= this.totalFrames - 1 && this.frameModifier > 0 ? this.loop && this.playCount !== this.loop ? Et >= this.totalFrames ? (this.playCount += 1, this.checkSegments(Et % this.totalFrames) || (this.setCurrentRawFrameValue(Et % this.totalFrames), this._completedLoop = !0, this.trigger("loopComplete"))) : this.setCurrentRawFrameValue(Et) : this.checkSegments(Et > this.totalFrames ? Et % this.totalFrames : 0) || (Pt = !0, Et = this.totalFrames - 1) : Et < 0 ? this.checkSegments(Et % this.totalFrames) || (!this.loop || this.playCount-- <= 0 && this.loop !== !0 ? (Pt = !0, Et = 0) : (this.setCurrentRawFrameValue(this.totalFrames + Et % this.totalFrames), this._completedLoop ? this.trigger("loopComplete") : this._completedLoop = !0)) : this.setCurrentRawFrameValue(Et), Pt && (this.setCurrentRawFrameValue(Et), this.pause(), this.trigger("complete"));
      }
    }, AnimationItem.prototype.adjustSegment = function(_t, Et) {
      this.playCount = 0, _t[1] < _t[0] ? (this.frameModifier > 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(-1)), this.totalFrames = _t[0] - _t[1], this.timeCompleted = this.totalFrames, this.firstFrame = _t[1], this.setCurrentRawFrameValue(this.totalFrames - 1e-3 - Et)) : _t[1] > _t[0] && (this.frameModifier < 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(1)), this.totalFrames = _t[1] - _t[0], this.timeCompleted = this.totalFrames, this.firstFrame = _t[0], this.setCurrentRawFrameValue(1e-3 + Et)), this.trigger("segmentStart");
    }, AnimationItem.prototype.setSegment = function(_t, Et) {
      var Pt = -1;
      this.isPaused && (this.currentRawFrame + this.firstFrame < _t ? Pt = _t : this.currentRawFrame + this.firstFrame > Et && (Pt = Et - _t)), this.firstFrame = _t, this.totalFrames = Et - _t, this.timeCompleted = this.totalFrames, Pt !== -1 && this.goToAndStop(Pt, !0);
    }, AnimationItem.prototype.playSegments = function(_t, Et) {
      if (Et && (this.segments.length = 0), _typeof$4(_t[0]) === "object") {
        var Pt, $t = _t.length;
        for (Pt = 0; Pt < $t; Pt += 1)
          this.segments.push(_t[Pt]);
      } else
        this.segments.push(_t);
      this.segments.length && Et && this.adjustSegment(this.segments.shift(), 0), this.isPaused && this.play();
    }, AnimationItem.prototype.resetSegments = function(_t) {
      this.segments.length = 0, this.segments.push([this.animationData.ip, this.animationData.op]), _t && this.checkSegments(0);
    }, AnimationItem.prototype.checkSegments = function(_t) {
      return !!this.segments.length && (this.adjustSegment(this.segments.shift(), _t), !0);
    }, AnimationItem.prototype.destroy = function(_t) {
      _t && this.name !== _t || !this.renderer || (this.renderer.destroy(), this.imagePreloader.destroy(), this.trigger("destroy"), this._cbs = null, this.onEnterFrame = null, this.onLoopComplete = null, this.onComplete = null, this.onSegmentStart = null, this.onDestroy = null, this.renderer = null, this.expressionsPlugin = null, this.imagePreloader = null, this.projectInterface = null);
    }, AnimationItem.prototype.setCurrentRawFrameValue = function(_t) {
      this.currentRawFrame = _t, this.gotoFrame();
    }, AnimationItem.prototype.setSpeed = function(_t) {
      this.playSpeed = _t, this.updaFrameModifier();
    }, AnimationItem.prototype.setDirection = function(_t) {
      this.playDirection = _t < 0 ? -1 : 1, this.updaFrameModifier();
    }, AnimationItem.prototype.setLoop = function(_t) {
      this.loop = _t;
    }, AnimationItem.prototype.setVolume = function(_t, Et) {
      Et && this.name !== Et || this.audioController.setVolume(_t);
    }, AnimationItem.prototype.getVolume = function() {
      return this.audioController.getVolume();
    }, AnimationItem.prototype.mute = function(_t) {
      _t && this.name !== _t || this.audioController.mute();
    }, AnimationItem.prototype.unmute = function(_t) {
      _t && this.name !== _t || this.audioController.unmute();
    }, AnimationItem.prototype.updaFrameModifier = function() {
      this.frameModifier = this.frameMult * this.playSpeed * this.playDirection, this.audioController.setRate(this.playSpeed * this.playDirection);
    }, AnimationItem.prototype.getPath = function() {
      return this.path;
    }, AnimationItem.prototype.getAssetsPath = function(_t) {
      var Et = "";
      if (_t.e)
        Et = _t.p;
      else if (this.assetsPath) {
        var Pt = _t.p;
        Pt.indexOf("images/") !== -1 && (Pt = Pt.split("/")[1]), Et = this.assetsPath + Pt;
      } else
        Et = this.path, Et += _t.u ? _t.u : "", Et += _t.p;
      return Et;
    }, AnimationItem.prototype.getAssetData = function(_t) {
      for (var Et = 0, Pt = this.assets.length; Et < Pt; ) {
        if (_t === this.assets[Et].id)
          return this.assets[Et];
        Et += 1;
      }
      return null;
    }, AnimationItem.prototype.hide = function() {
      this.renderer.hide();
    }, AnimationItem.prototype.show = function() {
      this.renderer.show();
    }, AnimationItem.prototype.getDuration = function(_t) {
      return _t ? this.totalFrames : this.totalFrames / this.frameRate;
    }, AnimationItem.prototype.updateDocumentData = function(_t, Et, Pt) {
      try {
        this.renderer.getElementByPath(_t).updateDocumentData(Et, Pt);
      } catch {
      }
    }, AnimationItem.prototype.trigger = function(_t) {
      if (this._cbs && this._cbs[_t])
        switch (_t) {
          case "enterFrame":
            this.triggerEvent(_t, new BMEnterFrameEvent(_t, this.currentFrame, this.totalFrames, this.frameModifier));
            break;
          case "drawnFrame":
            this.drawnFrameEvent.currentTime = this.currentFrame, this.drawnFrameEvent.totalTime = this.totalFrames, this.drawnFrameEvent.direction = this.frameModifier, this.triggerEvent(_t, this.drawnFrameEvent);
            break;
          case "loopComplete":
            this.triggerEvent(_t, new BMCompleteLoopEvent(_t, this.loop, this.playCount, this.frameMult));
            break;
          case "complete":
            this.triggerEvent(_t, new BMCompleteEvent(_t, this.frameMult));
            break;
          case "segmentStart":
            this.triggerEvent(_t, new BMSegmentStartEvent(_t, this.firstFrame, this.totalFrames));
            break;
          case "destroy":
            this.triggerEvent(_t, new BMDestroyEvent(_t, this));
            break;
          default:
            this.triggerEvent(_t);
        }
      _t === "enterFrame" && this.onEnterFrame && this.onEnterFrame.call(this, new BMEnterFrameEvent(_t, this.currentFrame, this.totalFrames, this.frameMult)), _t === "loopComplete" && this.onLoopComplete && this.onLoopComplete.call(this, new BMCompleteLoopEvent(_t, this.loop, this.playCount, this.frameMult)), _t === "complete" && this.onComplete && this.onComplete.call(this, new BMCompleteEvent(_t, this.frameMult)), _t === "segmentStart" && this.onSegmentStart && this.onSegmentStart.call(this, new BMSegmentStartEvent(_t, this.firstFrame, this.totalFrames)), _t === "destroy" && this.onDestroy && this.onDestroy.call(this, new BMDestroyEvent(_t, this));
    }, AnimationItem.prototype.triggerRenderFrameError = function(_t) {
      var Et = new BMRenderFrameErrorEvent(_t, this.currentFrame);
      this.triggerEvent("error", Et), this.onError && this.onError.call(this, Et);
    }, AnimationItem.prototype.triggerConfigError = function(_t) {
      var Et = new BMConfigErrorEvent(_t, this.currentFrame);
      this.triggerEvent("error", Et), this.onError && this.onError.call(this, Et);
    };
    var animationManager = function() {
      var _t = {}, Et = [], Pt = 0, $t = 0, Mt = 0, Bt = !0, Vt = !1;
      function zt(Zt) {
        for (var Yt = 0, Jt = Zt.target; Yt < $t; )
          Et[Yt].animation === Jt && (Et.splice(Yt, 1), Yt -= 1, $t -= 1, Jt.isPaused || Gt()), Yt += 1;
      }
      function Ht(Zt, Yt) {
        if (!Zt)
          return null;
        for (var Jt = 0; Jt < $t; ) {
          if (Et[Jt].elem === Zt && Et[Jt].elem !== null)
            return Et[Jt].animation;
          Jt += 1;
        }
        var er = new AnimationItem();
        return qt(er, Zt), er.setData(Zt, Yt), er;
      }
      function Wt() {
        Mt += 1, Xt();
      }
      function Gt() {
        Mt -= 1;
      }
      function qt(Zt, Yt) {
        Zt.addEventListener("destroy", zt), Zt.addEventListener("_active", Wt), Zt.addEventListener("_idle", Gt), Et.push({ elem: Yt, animation: Zt }), $t += 1;
      }
      function Kt(Zt) {
        var Yt, Jt = Zt - Pt;
        for (Yt = 0; Yt < $t; Yt += 1)
          Et[Yt].animation.advanceTime(Jt);
        Pt = Zt, Mt && !Vt ? window.requestAnimationFrame(Kt) : Bt = !0;
      }
      function Qt(Zt) {
        Pt = Zt, window.requestAnimationFrame(Kt);
      }
      function Xt() {
        !Vt && Mt && Bt && (window.requestAnimationFrame(Qt), Bt = !1);
      }
      return _t.registerAnimation = Ht, _t.loadAnimation = function(Zt) {
        var Yt = new AnimationItem();
        return qt(Yt, null), Yt.setParams(Zt), Yt;
      }, _t.setSpeed = function(Zt, Yt) {
        var Jt;
        for (Jt = 0; Jt < $t; Jt += 1)
          Et[Jt].animation.setSpeed(Zt, Yt);
      }, _t.setDirection = function(Zt, Yt) {
        var Jt;
        for (Jt = 0; Jt < $t; Jt += 1)
          Et[Jt].animation.setDirection(Zt, Yt);
      }, _t.play = function(Zt) {
        var Yt;
        for (Yt = 0; Yt < $t; Yt += 1)
          Et[Yt].animation.play(Zt);
      }, _t.pause = function(Zt) {
        var Yt;
        for (Yt = 0; Yt < $t; Yt += 1)
          Et[Yt].animation.pause(Zt);
      }, _t.stop = function(Zt) {
        var Yt;
        for (Yt = 0; Yt < $t; Yt += 1)
          Et[Yt].animation.stop(Zt);
      }, _t.togglePause = function(Zt) {
        var Yt;
        for (Yt = 0; Yt < $t; Yt += 1)
          Et[Yt].animation.togglePause(Zt);
      }, _t.searchAnimations = function(Zt, Yt, Jt) {
        var er, tr = [].concat([].slice.call(document.getElementsByClassName("lottie")), [].slice.call(document.getElementsByClassName("bodymovin"))), nr = tr.length;
        for (er = 0; er < nr; er += 1)
          Jt && tr[er].setAttribute("data-bm-type", Jt), Ht(tr[er], Zt);
        if (Yt && nr === 0) {
          Jt || (Jt = "svg");
          var rr = document.getElementsByTagName("body")[0];
          rr.innerText = "";
          var ir = createTag("div");
          ir.style.width = "100%", ir.style.height = "100%", ir.setAttribute("data-bm-type", Jt), rr.appendChild(ir), Ht(ir, Zt);
        }
      }, _t.resize = function() {
        var Zt;
        for (Zt = 0; Zt < $t; Zt += 1)
          Et[Zt].animation.resize();
      }, _t.goToAndStop = function(Zt, Yt, Jt) {
        var er;
        for (er = 0; er < $t; er += 1)
          Et[er].animation.goToAndStop(Zt, Yt, Jt);
      }, _t.destroy = function(Zt) {
        var Yt;
        for (Yt = $t - 1; Yt >= 0; Yt -= 1)
          Et[Yt].animation.destroy(Zt);
      }, _t.freeze = function() {
        Vt = !0;
      }, _t.unfreeze = function() {
        Vt = !1, Xt();
      }, _t.setVolume = function(Zt, Yt) {
        var Jt;
        for (Jt = 0; Jt < $t; Jt += 1)
          Et[Jt].animation.setVolume(Zt, Yt);
      }, _t.mute = function(Zt) {
        var Yt;
        for (Yt = 0; Yt < $t; Yt += 1)
          Et[Yt].animation.mute(Zt);
      }, _t.unmute = function(Zt) {
        var Yt;
        for (Yt = 0; Yt < $t; Yt += 1)
          Et[Yt].animation.unmute(Zt);
      }, _t.getRegisteredAnimations = function() {
        var Zt, Yt = Et.length, Jt = [];
        for (Zt = 0; Zt < Yt; Zt += 1)
          Jt.push(Et[Zt].animation);
        return Jt;
      }, _t;
    }(), BezierFactory = function() {
      var _t = { getBezierEasing: function(Wt, Gt, qt, Kt, Qt) {
        var Xt = Qt || ("bez_" + Wt + "_" + Gt + "_" + qt + "_" + Kt).replace(/\./g, "p");
        if (Et[Xt])
          return Et[Xt];
        var Zt = new Ht([Wt, Gt, qt, Kt]);
        return Et[Xt] = Zt, Zt;
      } }, Et = {}, Pt = typeof Float32Array == "function";
      function $t(Wt, Gt) {
        return 1 - 3 * Gt + 3 * Wt;
      }
      function Mt(Wt, Gt) {
        return 3 * Gt - 6 * Wt;
      }
      function Bt(Wt) {
        return 3 * Wt;
      }
      function Vt(Wt, Gt, qt) {
        return (($t(Gt, qt) * Wt + Mt(Gt, qt)) * Wt + Bt(Gt)) * Wt;
      }
      function zt(Wt, Gt, qt) {
        return 3 * $t(Gt, qt) * Wt * Wt + 2 * Mt(Gt, qt) * Wt + Bt(Gt);
      }
      function Ht(Wt) {
        this._p = Wt, this._mSampleValues = Pt ? new Float32Array(11) : new Array(11), this._precomputed = !1, this.get = this.get.bind(this);
      }
      return Ht.prototype = { get: function(Wt) {
        var Gt = this._p[0], qt = this._p[1], Kt = this._p[2], Qt = this._p[3];
        return this._precomputed || this._precompute(), Gt === qt && Kt === Qt ? Wt : Wt === 0 ? 0 : Wt === 1 ? 1 : Vt(this._getTForX(Wt), qt, Qt);
      }, _precompute: function() {
        var Wt = this._p[0], Gt = this._p[1], qt = this._p[2], Kt = this._p[3];
        this._precomputed = !0, Wt === Gt && qt === Kt || this._calcSampleValues();
      }, _calcSampleValues: function() {
        for (var Wt = this._p[0], Gt = this._p[2], qt = 0; qt < 11; ++qt)
          this._mSampleValues[qt] = Vt(0.1 * qt, Wt, Gt);
      }, _getTForX: function(Wt) {
        for (var Gt = this._p[0], qt = this._p[2], Kt = this._mSampleValues, Qt = 0, Xt = 1; Xt !== 10 && Kt[Xt] <= Wt; ++Xt)
          Qt += 0.1;
        var Zt = Qt + 0.1 * ((Wt - Kt[--Xt]) / (Kt[Xt + 1] - Kt[Xt])), Yt = zt(Zt, Gt, qt);
        return Yt >= 1e-3 ? function(Jt, er, tr, nr) {
          for (var rr = 0; rr < 4; ++rr) {
            var ir = zt(er, tr, nr);
            if (ir === 0)
              return er;
            er -= (Vt(er, tr, nr) - Jt) / ir;
          }
          return er;
        }(Wt, Zt, Gt, qt) : Yt === 0 ? Zt : function(Jt, er, tr, nr, rr) {
          var ir, ar, or = 0;
          do
            (ir = Vt(ar = er + (tr - er) / 2, nr, rr) - Jt) > 0 ? tr = ar : er = ar;
          while (Math.abs(ir) > 1e-7 && ++or < 10);
          return ar;
        }(Wt, Qt, Qt + 0.1, Gt, qt);
      } }, _t;
    }(), pooling = { double: function(_t) {
      return _t.concat(createSizedArray(_t.length));
    } }, poolFactory = function(_t, Et, Pt) {
      var $t = 0, Mt = _t, Bt = createSizedArray(Mt);
      return { newElement: function() {
        return $t ? Bt[$t -= 1] : Et();
      }, release: function(Vt) {
        $t === Mt && (Bt = pooling.double(Bt), Mt *= 2), Pt && Pt(Vt), Bt[$t] = Vt, $t += 1;
      } };
    }, bezierLengthPool = poolFactory(8, function() {
      return { addedLength: 0, percents: createTypedArray("float32", getDefaultCurveSegments()), lengths: createTypedArray("float32", getDefaultCurveSegments()) };
    }), segmentsLengthPool = poolFactory(8, function() {
      return { lengths: [], totalLength: 0 };
    }, function(_t) {
      var Et, Pt = _t.lengths.length;
      for (Et = 0; Et < Pt; Et += 1)
        bezierLengthPool.release(_t.lengths[Et]);
      _t.lengths.length = 0;
    });
    function bezFunction() {
      var _t = Math;
      function Et(Wt, Gt, qt, Kt, Qt, Xt) {
        var Zt = Wt * Kt + Gt * Qt + qt * Xt - Qt * Kt - Xt * Wt - qt * Gt;
        return Zt > -1e-3 && Zt < 1e-3;
      }
      var Pt = function(Wt, Gt, qt, Kt) {
        var Qt, Xt, Zt, Yt, Jt, er, tr = getDefaultCurveSegments(), nr = 0, rr = [], ir = [], ar = bezierLengthPool.newElement();
        for (Zt = qt.length, Qt = 0; Qt < tr; Qt += 1) {
          for (Jt = Qt / (tr - 1), er = 0, Xt = 0; Xt < Zt; Xt += 1)
            Yt = bmPow(1 - Jt, 3) * Wt[Xt] + 3 * bmPow(1 - Jt, 2) * Jt * qt[Xt] + 3 * (1 - Jt) * bmPow(Jt, 2) * Kt[Xt] + bmPow(Jt, 3) * Gt[Xt], rr[Xt] = Yt, ir[Xt] !== null && (er += bmPow(rr[Xt] - ir[Xt], 2)), ir[Xt] = rr[Xt];
          er && (nr += er = bmSqrt(er)), ar.percents[Qt] = Jt, ar.lengths[Qt] = nr;
        }
        return ar.addedLength = nr, ar;
      };
      function $t(Wt) {
        this.segmentLength = 0, this.points = new Array(Wt);
      }
      function Mt(Wt, Gt) {
        this.partialLength = Wt, this.point = Gt;
      }
      var Bt, Vt = (Bt = {}, function(Wt, Gt, qt, Kt) {
        var Qt = (Wt[0] + "_" + Wt[1] + "_" + Gt[0] + "_" + Gt[1] + "_" + qt[0] + "_" + qt[1] + "_" + Kt[0] + "_" + Kt[1]).replace(/\./g, "p");
        if (!Bt[Qt]) {
          var Xt, Zt, Yt, Jt, er, tr, nr, rr = getDefaultCurveSegments(), ir = 0, ar = null;
          Wt.length === 2 && (Wt[0] !== Gt[0] || Wt[1] !== Gt[1]) && Et(Wt[0], Wt[1], Gt[0], Gt[1], Wt[0] + qt[0], Wt[1] + qt[1]) && Et(Wt[0], Wt[1], Gt[0], Gt[1], Gt[0] + Kt[0], Gt[1] + Kt[1]) && (rr = 2);
          var or = new $t(rr);
          for (Yt = qt.length, Xt = 0; Xt < rr; Xt += 1) {
            for (nr = createSizedArray(Yt), er = Xt / (rr - 1), tr = 0, Zt = 0; Zt < Yt; Zt += 1)
              Jt = bmPow(1 - er, 3) * Wt[Zt] + 3 * bmPow(1 - er, 2) * er * (Wt[Zt] + qt[Zt]) + 3 * (1 - er) * bmPow(er, 2) * (Gt[Zt] + Kt[Zt]) + bmPow(er, 3) * Gt[Zt], nr[Zt] = Jt, ar !== null && (tr += bmPow(nr[Zt] - ar[Zt], 2));
            ir += tr = bmSqrt(tr), or.points[Xt] = new Mt(tr, nr), ar = nr;
          }
          or.segmentLength = ir, Bt[Qt] = or;
        }
        return Bt[Qt];
      });
      function zt(Wt, Gt) {
        var qt = Gt.percents, Kt = Gt.lengths, Qt = qt.length, Xt = bmFloor((Qt - 1) * Wt), Zt = Wt * Gt.addedLength, Yt = 0;
        if (Xt === Qt - 1 || Xt === 0 || Zt === Kt[Xt])
          return qt[Xt];
        for (var Jt = Kt[Xt] > Zt ? -1 : 1, er = !0; er; )
          if (Kt[Xt] <= Zt && Kt[Xt + 1] > Zt ? (Yt = (Zt - Kt[Xt]) / (Kt[Xt + 1] - Kt[Xt]), er = !1) : Xt += Jt, Xt < 0 || Xt >= Qt - 1) {
            if (Xt === Qt - 1)
              return qt[Xt];
            er = !1;
          }
        return qt[Xt] + (qt[Xt + 1] - qt[Xt]) * Yt;
      }
      var Ht = createTypedArray("float32", 8);
      return { getSegmentsLength: function(Wt) {
        var Gt, qt = segmentsLengthPool.newElement(), Kt = Wt.c, Qt = Wt.v, Xt = Wt.o, Zt = Wt.i, Yt = Wt._length, Jt = qt.lengths, er = 0;
        for (Gt = 0; Gt < Yt - 1; Gt += 1)
          Jt[Gt] = Pt(Qt[Gt], Qt[Gt + 1], Xt[Gt], Zt[Gt + 1]), er += Jt[Gt].addedLength;
        return Kt && Yt && (Jt[Gt] = Pt(Qt[Gt], Qt[0], Xt[Gt], Zt[0]), er += Jt[Gt].addedLength), qt.totalLength = er, qt;
      }, getNewSegment: function(Wt, Gt, qt, Kt, Qt, Xt, Zt) {
        Qt < 0 ? Qt = 0 : Qt > 1 && (Qt = 1);
        var Yt, Jt = zt(Qt, Zt), er = zt(Xt = Xt > 1 ? 1 : Xt, Zt), tr = Wt.length, nr = 1 - Jt, rr = 1 - er, ir = nr * nr * nr, ar = Jt * nr * nr * 3, or = Jt * Jt * nr * 3, sr = Jt * Jt * Jt, lr = nr * nr * rr, cr = Jt * nr * rr + nr * Jt * rr + nr * nr * er, hr = Jt * Jt * rr + nr * Jt * er + Jt * nr * er, pr = Jt * Jt * er, mr = nr * rr * rr, Er = Jt * rr * rr + nr * er * rr + nr * rr * er, _r = Jt * er * rr + nr * er * er + Jt * rr * er, yr = Jt * er * er, ur = rr * rr * rr, vr = er * rr * rr + rr * er * rr + rr * rr * er, dr = er * er * rr + rr * er * er + er * rr * er, br = er * er * er;
        for (Yt = 0; Yt < tr; Yt += 1)
          Ht[4 * Yt] = _t.round(1e3 * (ir * Wt[Yt] + ar * qt[Yt] + or * Kt[Yt] + sr * Gt[Yt])) / 1e3, Ht[4 * Yt + 1] = _t.round(1e3 * (lr * Wt[Yt] + cr * qt[Yt] + hr * Kt[Yt] + pr * Gt[Yt])) / 1e3, Ht[4 * Yt + 2] = _t.round(1e3 * (mr * Wt[Yt] + Er * qt[Yt] + _r * Kt[Yt] + yr * Gt[Yt])) / 1e3, Ht[4 * Yt + 3] = _t.round(1e3 * (ur * Wt[Yt] + vr * qt[Yt] + dr * Kt[Yt] + br * Gt[Yt])) / 1e3;
        return Ht;
      }, getPointInSegment: function(Wt, Gt, qt, Kt, Qt, Xt) {
        var Zt = zt(Qt, Xt), Yt = 1 - Zt;
        return [_t.round(1e3 * (Yt * Yt * Yt * Wt[0] + (Zt * Yt * Yt + Yt * Zt * Yt + Yt * Yt * Zt) * qt[0] + (Zt * Zt * Yt + Yt * Zt * Zt + Zt * Yt * Zt) * Kt[0] + Zt * Zt * Zt * Gt[0])) / 1e3, _t.round(1e3 * (Yt * Yt * Yt * Wt[1] + (Zt * Yt * Yt + Yt * Zt * Yt + Yt * Yt * Zt) * qt[1] + (Zt * Zt * Yt + Yt * Zt * Zt + Zt * Yt * Zt) * Kt[1] + Zt * Zt * Zt * Gt[1])) / 1e3];
      }, buildBezierData: Vt, pointOnLine2D: Et, pointOnLine3D: function(Wt, Gt, qt, Kt, Qt, Xt, Zt, Yt, Jt) {
        if (qt === 0 && Xt === 0 && Jt === 0)
          return Et(Wt, Gt, Kt, Qt, Zt, Yt);
        var er, tr = _t.sqrt(_t.pow(Kt - Wt, 2) + _t.pow(Qt - Gt, 2) + _t.pow(Xt - qt, 2)), nr = _t.sqrt(_t.pow(Zt - Wt, 2) + _t.pow(Yt - Gt, 2) + _t.pow(Jt - qt, 2)), rr = _t.sqrt(_t.pow(Zt - Kt, 2) + _t.pow(Yt - Qt, 2) + _t.pow(Jt - Xt, 2));
        return (er = tr > nr ? tr > rr ? tr - nr - rr : rr - nr - tr : rr > nr ? rr - nr - tr : nr - tr - rr) > -1e-4 && er < 1e-4;
      } };
    }
    var bez = bezFunction(), initFrame = initialDefaultFrame, mathAbs = Math.abs;
    function interpolateValue(_t, Et) {
      var Pt, $t = this.offsetTime;
      this.propType === "multidimensional" && (Pt = createTypedArray("float32", this.pv.length));
      for (var Mt, Bt, Vt, zt, Ht, Wt, Gt, qt, Kt, Qt = Et.lastIndex, Xt = Qt, Zt = this.keyframes.length - 1, Yt = !0; Yt; ) {
        if (Mt = this.keyframes[Xt], Bt = this.keyframes[Xt + 1], Xt === Zt - 1 && _t >= Bt.t - $t) {
          Mt.h && (Mt = Bt), Qt = 0;
          break;
        }
        if (Bt.t - $t > _t) {
          Qt = Xt;
          break;
        }
        Xt < Zt - 1 ? Xt += 1 : (Qt = 0, Yt = !1);
      }
      Vt = this.keyframesMetadata[Xt] || {};
      var Jt, er = Bt.t - $t, tr = Mt.t - $t;
      if (Mt.to) {
        Vt.bezierData || (Vt.bezierData = bez.buildBezierData(Mt.s, Bt.s || Mt.e, Mt.to, Mt.ti));
        var nr = Vt.bezierData;
        if (_t >= er || _t < tr) {
          var rr = _t >= er ? nr.points.length - 1 : 0;
          for (Ht = nr.points[rr].point.length, zt = 0; zt < Ht; zt += 1)
            Pt[zt] = nr.points[rr].point[zt];
        } else {
          Vt.__fnct ? Kt = Vt.__fnct : (Kt = BezierFactory.getBezierEasing(Mt.o.x, Mt.o.y, Mt.i.x, Mt.i.y, Mt.n).get, Vt.__fnct = Kt), Wt = Kt((_t - tr) / (er - tr));
          var ir, ar = nr.segmentLength * Wt, or = Et.lastFrame < _t && Et._lastKeyframeIndex === Xt ? Et._lastAddedLength : 0;
          for (qt = Et.lastFrame < _t && Et._lastKeyframeIndex === Xt ? Et._lastPoint : 0, Yt = !0, Gt = nr.points.length; Yt; ) {
            if (or += nr.points[qt].partialLength, ar === 0 || Wt === 0 || qt === nr.points.length - 1) {
              for (Ht = nr.points[qt].point.length, zt = 0; zt < Ht; zt += 1)
                Pt[zt] = nr.points[qt].point[zt];
              break;
            }
            if (ar >= or && ar < or + nr.points[qt + 1].partialLength) {
              for (ir = (ar - or) / nr.points[qt + 1].partialLength, Ht = nr.points[qt].point.length, zt = 0; zt < Ht; zt += 1)
                Pt[zt] = nr.points[qt].point[zt] + (nr.points[qt + 1].point[zt] - nr.points[qt].point[zt]) * ir;
              break;
            }
            qt < Gt - 1 ? qt += 1 : Yt = !1;
          }
          Et._lastPoint = qt, Et._lastAddedLength = or - nr.points[qt].partialLength, Et._lastKeyframeIndex = Xt;
        }
      } else {
        var sr, lr, cr, hr, pr;
        if (Zt = Mt.s.length, Jt = Bt.s || Mt.e, this.sh && Mt.h !== 1)
          _t >= er ? (Pt[0] = Jt[0], Pt[1] = Jt[1], Pt[2] = Jt[2]) : _t <= tr ? (Pt[0] = Mt.s[0], Pt[1] = Mt.s[1], Pt[2] = Mt.s[2]) : quaternionToEuler(Pt, slerp(createQuaternion(Mt.s), createQuaternion(Jt), (_t - tr) / (er - tr)));
        else
          for (Xt = 0; Xt < Zt; Xt += 1)
            Mt.h !== 1 && (_t >= er ? Wt = 1 : _t < tr ? Wt = 0 : (Mt.o.x.constructor === Array ? (Vt.__fnct || (Vt.__fnct = []), Vt.__fnct[Xt] ? Kt = Vt.__fnct[Xt] : (sr = Mt.o.x[Xt] === void 0 ? Mt.o.x[0] : Mt.o.x[Xt], lr = Mt.o.y[Xt] === void 0 ? Mt.o.y[0] : Mt.o.y[Xt], cr = Mt.i.x[Xt] === void 0 ? Mt.i.x[0] : Mt.i.x[Xt], hr = Mt.i.y[Xt] === void 0 ? Mt.i.y[0] : Mt.i.y[Xt], Kt = BezierFactory.getBezierEasing(sr, lr, cr, hr).get, Vt.__fnct[Xt] = Kt)) : Vt.__fnct ? Kt = Vt.__fnct : (sr = Mt.o.x, lr = Mt.o.y, cr = Mt.i.x, hr = Mt.i.y, Kt = BezierFactory.getBezierEasing(sr, lr, cr, hr).get, Mt.keyframeMetadata = Kt), Wt = Kt((_t - tr) / (er - tr)))), Jt = Bt.s || Mt.e, pr = Mt.h === 1 ? Mt.s[Xt] : Mt.s[Xt] + (Jt[Xt] - Mt.s[Xt]) * Wt, this.propType === "multidimensional" ? Pt[Xt] = pr : Pt = pr;
      }
      return Et.lastIndex = Qt, Pt;
    }
    function slerp(_t, Et, Pt) {
      var $t, Mt, Bt, Vt, zt, Ht = [], Wt = _t[0], Gt = _t[1], qt = _t[2], Kt = _t[3], Qt = Et[0], Xt = Et[1], Zt = Et[2], Yt = Et[3];
      return (Mt = Wt * Qt + Gt * Xt + qt * Zt + Kt * Yt) < 0 && (Mt = -Mt, Qt = -Qt, Xt = -Xt, Zt = -Zt, Yt = -Yt), 1 - Mt > 1e-6 ? ($t = Math.acos(Mt), Bt = Math.sin($t), Vt = Math.sin((1 - Pt) * $t) / Bt, zt = Math.sin(Pt * $t) / Bt) : (Vt = 1 - Pt, zt = Pt), Ht[0] = Vt * Wt + zt * Qt, Ht[1] = Vt * Gt + zt * Xt, Ht[2] = Vt * qt + zt * Zt, Ht[3] = Vt * Kt + zt * Yt, Ht;
    }
    function quaternionToEuler(_t, Et) {
      var Pt = Et[0], $t = Et[1], Mt = Et[2], Bt = Et[3], Vt = Math.atan2(2 * $t * Bt - 2 * Pt * Mt, 1 - 2 * $t * $t - 2 * Mt * Mt), zt = Math.asin(2 * Pt * $t + 2 * Mt * Bt), Ht = Math.atan2(2 * Pt * Bt - 2 * $t * Mt, 1 - 2 * Pt * Pt - 2 * Mt * Mt);
      _t[0] = Vt / degToRads, _t[1] = zt / degToRads, _t[2] = Ht / degToRads;
    }
    function createQuaternion(_t) {
      var Et = _t[0] * degToRads, Pt = _t[1] * degToRads, $t = _t[2] * degToRads, Mt = Math.cos(Et / 2), Bt = Math.cos(Pt / 2), Vt = Math.cos($t / 2), zt = Math.sin(Et / 2), Ht = Math.sin(Pt / 2), Wt = Math.sin($t / 2);
      return [zt * Ht * Vt + Mt * Bt * Wt, zt * Bt * Vt + Mt * Ht * Wt, Mt * Ht * Vt - zt * Bt * Wt, Mt * Bt * Vt - zt * Ht * Wt];
    }
    function getValueAtCurrentTime() {
      var _t = this.comp.renderedFrame - this.offsetTime, Et = this.keyframes[0].t - this.offsetTime, Pt = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
      if (!(_t === this._caching.lastFrame || this._caching.lastFrame !== initFrame && (this._caching.lastFrame >= Pt && _t >= Pt || this._caching.lastFrame < Et && _t < Et))) {
        this._caching.lastFrame >= _t && (this._caching._lastKeyframeIndex = -1, this._caching.lastIndex = 0);
        var $t = this.interpolateValue(_t, this._caching);
        this.pv = $t;
      }
      return this._caching.lastFrame = _t, this.pv;
    }
    function setVValue(_t) {
      var Et;
      if (this.propType === "unidimensional")
        Et = _t * this.mult, mathAbs(this.v - Et) > 1e-5 && (this.v = Et, this._mdf = !0);
      else
        for (var Pt = 0, $t = this.v.length; Pt < $t; )
          Et = _t[Pt] * this.mult, mathAbs(this.v[Pt] - Et) > 1e-5 && (this.v[Pt] = Et, this._mdf = !0), Pt += 1;
    }
    function processEffectsSequence() {
      if (this.elem.globalData.frameId !== this.frameId && this.effectsSequence.length)
        if (this.lock)
          this.setVValue(this.pv);
        else {
          var _t;
          this.lock = !0, this._mdf = this._isFirstFrame;
          var Et = this.effectsSequence.length, Pt = this.kf ? this.pv : this.data.k;
          for (_t = 0; _t < Et; _t += 1)
            Pt = this.effectsSequence[_t](Pt);
          this.setVValue(Pt), this._isFirstFrame = !1, this.lock = !1, this.frameId = this.elem.globalData.frameId;
        }
    }
    function addEffect(_t) {
      this.effectsSequence.push(_t), this.container.addDynamicProperty(this);
    }
    function ValueProperty(_t, Et, Pt, $t) {
      this.propType = "unidimensional", this.mult = Pt || 1, this.data = Et, this.v = Pt ? Et.k * Pt : Et.k, this.pv = Et.k, this._mdf = !1, this.elem = _t, this.container = $t, this.comp = _t.comp, this.k = !1, this.kf = !1, this.vel = 0, this.effectsSequence = [], this._isFirstFrame = !0, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.addEffect = addEffect;
    }
    function MultiDimensionalProperty(_t, Et, Pt, $t) {
      var Mt;
      this.propType = "multidimensional", this.mult = Pt || 1, this.data = Et, this._mdf = !1, this.elem = _t, this.container = $t, this.comp = _t.comp, this.k = !1, this.kf = !1, this.frameId = -1;
      var Bt = Et.k.length;
      for (this.v = createTypedArray("float32", Bt), this.pv = createTypedArray("float32", Bt), this.vel = createTypedArray("float32", Bt), Mt = 0; Mt < Bt; Mt += 1)
        this.v[Mt] = Et.k[Mt] * this.mult, this.pv[Mt] = Et.k[Mt];
      this._isFirstFrame = !0, this.effectsSequence = [], this.getValue = processEffectsSequence, this.setVValue = setVValue, this.addEffect = addEffect;
    }
    function KeyframedValueProperty(_t, Et, Pt, $t) {
      this.propType = "unidimensional", this.keyframes = Et.k, this.keyframesMetadata = [], this.offsetTime = _t.data.st, this.frameId = -1, this._caching = { lastFrame: initFrame, lastIndex: 0, value: 0, _lastKeyframeIndex: -1 }, this.k = !0, this.kf = !0, this.data = Et, this.mult = Pt || 1, this.elem = _t, this.container = $t, this.comp = _t.comp, this.v = initFrame, this.pv = initFrame, this._isFirstFrame = !0, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.interpolateValue = interpolateValue, this.effectsSequence = [getValueAtCurrentTime.bind(this)], this.addEffect = addEffect;
    }
    function KeyframedMultidimensionalProperty(_t, Et, Pt, $t) {
      var Mt;
      this.propType = "multidimensional";
      var Bt, Vt, zt, Ht, Wt = Et.k.length;
      for (Mt = 0; Mt < Wt - 1; Mt += 1)
        Et.k[Mt].to && Et.k[Mt].s && Et.k[Mt + 1] && Et.k[Mt + 1].s && (Bt = Et.k[Mt].s, Vt = Et.k[Mt + 1].s, zt = Et.k[Mt].to, Ht = Et.k[Mt].ti, (Bt.length === 2 && (Bt[0] !== Vt[0] || Bt[1] !== Vt[1]) && bez.pointOnLine2D(Bt[0], Bt[1], Vt[0], Vt[1], Bt[0] + zt[0], Bt[1] + zt[1]) && bez.pointOnLine2D(Bt[0], Bt[1], Vt[0], Vt[1], Vt[0] + Ht[0], Vt[1] + Ht[1]) || Bt.length === 3 && (Bt[0] !== Vt[0] || Bt[1] !== Vt[1] || Bt[2] !== Vt[2]) && bez.pointOnLine3D(Bt[0], Bt[1], Bt[2], Vt[0], Vt[1], Vt[2], Bt[0] + zt[0], Bt[1] + zt[1], Bt[2] + zt[2]) && bez.pointOnLine3D(Bt[0], Bt[1], Bt[2], Vt[0], Vt[1], Vt[2], Vt[0] + Ht[0], Vt[1] + Ht[1], Vt[2] + Ht[2])) && (Et.k[Mt].to = null, Et.k[Mt].ti = null), Bt[0] === Vt[0] && Bt[1] === Vt[1] && zt[0] === 0 && zt[1] === 0 && Ht[0] === 0 && Ht[1] === 0 && (Bt.length === 2 || Bt[2] === Vt[2] && zt[2] === 0 && Ht[2] === 0) && (Et.k[Mt].to = null, Et.k[Mt].ti = null));
      this.effectsSequence = [getValueAtCurrentTime.bind(this)], this.data = Et, this.keyframes = Et.k, this.keyframesMetadata = [], this.offsetTime = _t.data.st, this.k = !0, this.kf = !0, this._isFirstFrame = !0, this.mult = Pt || 1, this.elem = _t, this.container = $t, this.comp = _t.comp, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.interpolateValue = interpolateValue, this.frameId = -1;
      var Gt = Et.k[0].s.length;
      for (this.v = createTypedArray("float32", Gt), this.pv = createTypedArray("float32", Gt), Mt = 0; Mt < Gt; Mt += 1)
        this.v[Mt] = initFrame, this.pv[Mt] = initFrame;
      this._caching = { lastFrame: initFrame, lastIndex: 0, value: createTypedArray("float32", Gt) }, this.addEffect = addEffect;
    }
    var PropertyFactory = { getProp: function(_t, Et, Pt, $t, Mt) {
      var Bt;
      if (Et.sid && (Et = _t.globalData.slotManager.getProp(Et)), Et.k.length)
        if (typeof Et.k[0] == "number")
          Bt = new MultiDimensionalProperty(_t, Et, $t, Mt);
        else
          switch (Pt) {
            case 0:
              Bt = new KeyframedValueProperty(_t, Et, $t, Mt);
              break;
            case 1:
              Bt = new KeyframedMultidimensionalProperty(_t, Et, $t, Mt);
          }
      else
        Bt = new ValueProperty(_t, Et, $t, Mt);
      return Bt.effectsSequence.length && Mt.addDynamicProperty(Bt), Bt;
    } };
    function DynamicPropertyContainer() {
    }
    DynamicPropertyContainer.prototype = { addDynamicProperty: function(_t) {
      this.dynamicProperties.indexOf(_t) === -1 && (this.dynamicProperties.push(_t), this.container.addDynamicProperty(this), this._isAnimated = !0);
    }, iterateDynamicProperties: function() {
      var _t;
      this._mdf = !1;
      var Et = this.dynamicProperties.length;
      for (_t = 0; _t < Et; _t += 1)
        this.dynamicProperties[_t].getValue(), this.dynamicProperties[_t]._mdf && (this._mdf = !0);
    }, initDynamicPropertyContainer: function(_t) {
      this.container = _t, this.dynamicProperties = [], this._mdf = !1, this._isAnimated = !1;
    } };
    var pointPool = poolFactory(8, function() {
      return createTypedArray("float32", 2);
    });
    function ShapePath() {
      this.c = !1, this._length = 0, this._maxLength = 8, this.v = createSizedArray(this._maxLength), this.o = createSizedArray(this._maxLength), this.i = createSizedArray(this._maxLength);
    }
    ShapePath.prototype.setPathData = function(_t, Et) {
      this.c = _t, this.setLength(Et);
      for (var Pt = 0; Pt < Et; )
        this.v[Pt] = pointPool.newElement(), this.o[Pt] = pointPool.newElement(), this.i[Pt] = pointPool.newElement(), Pt += 1;
    }, ShapePath.prototype.setLength = function(_t) {
      for (; this._maxLength < _t; )
        this.doubleArrayLength();
      this._length = _t;
    }, ShapePath.prototype.doubleArrayLength = function() {
      this.v = this.v.concat(createSizedArray(this._maxLength)), this.i = this.i.concat(createSizedArray(this._maxLength)), this.o = this.o.concat(createSizedArray(this._maxLength)), this._maxLength *= 2;
    }, ShapePath.prototype.setXYAt = function(_t, Et, Pt, $t, Mt) {
      var Bt;
      switch (this._length = Math.max(this._length, $t + 1), this._length >= this._maxLength && this.doubleArrayLength(), Pt) {
        case "v":
          Bt = this.v;
          break;
        case "i":
          Bt = this.i;
          break;
        case "o":
          Bt = this.o;
          break;
        default:
          Bt = [];
      }
      (!Bt[$t] || Bt[$t] && !Mt) && (Bt[$t] = pointPool.newElement()), Bt[$t][0] = _t, Bt[$t][1] = Et;
    }, ShapePath.prototype.setTripleAt = function(_t, Et, Pt, $t, Mt, Bt, Vt, zt) {
      this.setXYAt(_t, Et, "v", Vt, zt), this.setXYAt(Pt, $t, "o", Vt, zt), this.setXYAt(Mt, Bt, "i", Vt, zt);
    }, ShapePath.prototype.reverse = function() {
      var _t = new ShapePath();
      _t.setPathData(this.c, this._length);
      var Et = this.v, Pt = this.o, $t = this.i, Mt = 0;
      this.c && (_t.setTripleAt(Et[0][0], Et[0][1], $t[0][0], $t[0][1], Pt[0][0], Pt[0][1], 0, !1), Mt = 1);
      var Bt, Vt = this._length - 1, zt = this._length;
      for (Bt = Mt; Bt < zt; Bt += 1)
        _t.setTripleAt(Et[Vt][0], Et[Vt][1], $t[Vt][0], $t[Vt][1], Pt[Vt][0], Pt[Vt][1], Bt, !1), Vt -= 1;
      return _t;
    }, ShapePath.prototype.length = function() {
      return this._length;
    };
    var shapePool = (factory = poolFactory(4, function() {
      return new ShapePath();
    }, function(_t) {
      var Et, Pt = _t._length;
      for (Et = 0; Et < Pt; Et += 1)
        pointPool.release(_t.v[Et]), pointPool.release(_t.i[Et]), pointPool.release(_t.o[Et]), _t.v[Et] = null, _t.i[Et] = null, _t.o[Et] = null;
      _t._length = 0, _t.c = !1;
    }), factory.clone = function(_t) {
      var Et, Pt = factory.newElement(), $t = _t._length === void 0 ? _t.v.length : _t._length;
      for (Pt.setLength($t), Pt.c = _t.c, Et = 0; Et < $t; Et += 1)
        Pt.setTripleAt(_t.v[Et][0], _t.v[Et][1], _t.o[Et][0], _t.o[Et][1], _t.i[Et][0], _t.i[Et][1], Et);
      return Pt;
    }, factory), factory;
    function ShapeCollection() {
      this._length = 0, this._maxLength = 4, this.shapes = createSizedArray(this._maxLength);
    }
    ShapeCollection.prototype.addShape = function(_t) {
      this._length === this._maxLength && (this.shapes = this.shapes.concat(createSizedArray(this._maxLength)), this._maxLength *= 2), this.shapes[this._length] = _t, this._length += 1;
    }, ShapeCollection.prototype.releaseShapes = function() {
      var _t;
      for (_t = 0; _t < this._length; _t += 1)
        shapePool.release(this.shapes[_t]);
      this._length = 0;
    };
    var shapeCollectionPool = (ob = { newShapeCollection: function() {
      return _length ? pool[_length -= 1] : new ShapeCollection();
    }, release: function(_t) {
      var Et, Pt = _t._length;
      for (Et = 0; Et < Pt; Et += 1)
        shapePool.release(_t.shapes[Et]);
      _t._length = 0, _length === _maxLength && (pool = pooling.double(pool), _maxLength *= 2), pool[_length] = _t, _length += 1;
    } }, _length = 0, _maxLength = 4, pool = createSizedArray(_maxLength), ob), ob, _length, _maxLength, pool, ShapePropertyFactory = function() {
      function _t(Kt, Qt, Xt) {
        var Zt, Yt, Jt, er, tr, nr, rr, ir, ar, or = Xt.lastIndex, sr = this.keyframes;
        if (Kt < sr[0].t - this.offsetTime)
          Zt = sr[0].s[0], Jt = !0, or = 0;
        else if (Kt >= sr[sr.length - 1].t - this.offsetTime)
          Zt = sr[sr.length - 1].s ? sr[sr.length - 1].s[0] : sr[sr.length - 2].e[0], Jt = !0;
        else {
          for (var lr, cr, hr, pr = or, mr = sr.length - 1, Er = !0; Er && (lr = sr[pr], !((cr = sr[pr + 1]).t - this.offsetTime > Kt)); )
            pr < mr - 1 ? pr += 1 : Er = !1;
          if (hr = this.keyframesMetadata[pr] || {}, or = pr, !(Jt = lr.h === 1)) {
            if (Kt >= cr.t - this.offsetTime)
              ir = 1;
            else if (Kt < lr.t - this.offsetTime)
              ir = 0;
            else {
              var _r;
              hr.__fnct ? _r = hr.__fnct : (_r = BezierFactory.getBezierEasing(lr.o.x, lr.o.y, lr.i.x, lr.i.y).get, hr.__fnct = _r), ir = _r((Kt - (lr.t - this.offsetTime)) / (cr.t - this.offsetTime - (lr.t - this.offsetTime)));
            }
            Yt = cr.s ? cr.s[0] : lr.e[0];
          }
          Zt = lr.s[0];
        }
        for (nr = Qt._length, rr = Zt.i[0].length, Xt.lastIndex = or, er = 0; er < nr; er += 1)
          for (tr = 0; tr < rr; tr += 1)
            ar = Jt ? Zt.i[er][tr] : Zt.i[er][tr] + (Yt.i[er][tr] - Zt.i[er][tr]) * ir, Qt.i[er][tr] = ar, ar = Jt ? Zt.o[er][tr] : Zt.o[er][tr] + (Yt.o[er][tr] - Zt.o[er][tr]) * ir, Qt.o[er][tr] = ar, ar = Jt ? Zt.v[er][tr] : Zt.v[er][tr] + (Yt.v[er][tr] - Zt.v[er][tr]) * ir, Qt.v[er][tr] = ar;
      }
      function Et() {
        var Kt = this.comp.renderedFrame - this.offsetTime, Qt = this.keyframes[0].t - this.offsetTime, Xt = this.keyframes[this.keyframes.length - 1].t - this.offsetTime, Zt = this._caching.lastFrame;
        return Zt !== -999999 && (Zt < Qt && Kt < Qt || Zt > Xt && Kt > Xt) || (this._caching.lastIndex = Zt < Kt ? this._caching.lastIndex : 0, this.interpolateShape(Kt, this.pv, this._caching)), this._caching.lastFrame = Kt, this.pv;
      }
      function Pt() {
        this.paths = this.localShapeCollection;
      }
      function $t(Kt) {
        (function(Qt, Xt) {
          if (Qt._length !== Xt._length || Qt.c !== Xt.c)
            return !1;
          var Zt, Yt = Qt._length;
          for (Zt = 0; Zt < Yt; Zt += 1)
            if (Qt.v[Zt][0] !== Xt.v[Zt][0] || Qt.v[Zt][1] !== Xt.v[Zt][1] || Qt.o[Zt][0] !== Xt.o[Zt][0] || Qt.o[Zt][1] !== Xt.o[Zt][1] || Qt.i[Zt][0] !== Xt.i[Zt][0] || Qt.i[Zt][1] !== Xt.i[Zt][1])
              return !1;
          return !0;
        })(this.v, Kt) || (this.v = shapePool.clone(Kt), this.localShapeCollection.releaseShapes(), this.localShapeCollection.addShape(this.v), this._mdf = !0, this.paths = this.localShapeCollection);
      }
      function Mt() {
        if (this.elem.globalData.frameId !== this.frameId)
          if (this.effectsSequence.length)
            if (this.lock)
              this.setVValue(this.pv);
            else {
              var Kt, Qt;
              this.lock = !0, this._mdf = !1, Kt = this.kf ? this.pv : this.data.ks ? this.data.ks.k : this.data.pt.k;
              var Xt = this.effectsSequence.length;
              for (Qt = 0; Qt < Xt; Qt += 1)
                Kt = this.effectsSequence[Qt](Kt);
              this.setVValue(Kt), this.lock = !1, this.frameId = this.elem.globalData.frameId;
            }
          else
            this._mdf = !1;
      }
      function Bt(Kt, Qt, Xt) {
        this.propType = "shape", this.comp = Kt.comp, this.container = Kt, this.elem = Kt, this.data = Qt, this.k = !1, this.kf = !1, this._mdf = !1;
        var Zt = Xt === 3 ? Qt.pt.k : Qt.ks.k;
        this.v = shapePool.clone(Zt), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.reset = Pt, this.effectsSequence = [];
      }
      function Vt(Kt) {
        this.effectsSequence.push(Kt), this.container.addDynamicProperty(this);
      }
      function zt(Kt, Qt, Xt) {
        this.propType = "shape", this.comp = Kt.comp, this.elem = Kt, this.container = Kt, this.offsetTime = Kt.data.st, this.keyframes = Xt === 3 ? Qt.pt.k : Qt.ks.k, this.keyframesMetadata = [], this.k = !0, this.kf = !0;
        var Zt = this.keyframes[0].s[0].i.length;
        this.v = shapePool.newElement(), this.v.setPathData(this.keyframes[0].s[0].c, Zt), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.lastFrame = -999999, this.reset = Pt, this._caching = { lastFrame: -999999, lastIndex: 0 }, this.effectsSequence = [Et.bind(this)];
      }
      Bt.prototype.interpolateShape = _t, Bt.prototype.getValue = Mt, Bt.prototype.setVValue = $t, Bt.prototype.addEffect = Vt, zt.prototype.getValue = Mt, zt.prototype.interpolateShape = _t, zt.prototype.setVValue = $t, zt.prototype.addEffect = Vt;
      var Ht = function() {
        var Kt = roundCorner;
        function Qt(Xt, Zt) {
          this.v = shapePool.newElement(), this.v.setPathData(!0, 4), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.localShapeCollection.addShape(this.v), this.d = Zt.d, this.elem = Xt, this.comp = Xt.comp, this.frameId = -1, this.initDynamicPropertyContainer(Xt), this.p = PropertyFactory.getProp(Xt, Zt.p, 1, 0, this), this.s = PropertyFactory.getProp(Xt, Zt.s, 1, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertEllToPath());
        }
        return Qt.prototype = { reset: Pt, getValue: function() {
          this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertEllToPath());
        }, convertEllToPath: function() {
          var Xt = this.p.v[0], Zt = this.p.v[1], Yt = this.s.v[0] / 2, Jt = this.s.v[1] / 2, er = this.d !== 3, tr = this.v;
          tr.v[0][0] = Xt, tr.v[0][1] = Zt - Jt, tr.v[1][0] = er ? Xt + Yt : Xt - Yt, tr.v[1][1] = Zt, tr.v[2][0] = Xt, tr.v[2][1] = Zt + Jt, tr.v[3][0] = er ? Xt - Yt : Xt + Yt, tr.v[3][1] = Zt, tr.i[0][0] = er ? Xt - Yt * Kt : Xt + Yt * Kt, tr.i[0][1] = Zt - Jt, tr.i[1][0] = er ? Xt + Yt : Xt - Yt, tr.i[1][1] = Zt - Jt * Kt, tr.i[2][0] = er ? Xt + Yt * Kt : Xt - Yt * Kt, tr.i[2][1] = Zt + Jt, tr.i[3][0] = er ? Xt - Yt : Xt + Yt, tr.i[3][1] = Zt + Jt * Kt, tr.o[0][0] = er ? Xt + Yt * Kt : Xt - Yt * Kt, tr.o[0][1] = Zt - Jt, tr.o[1][0] = er ? Xt + Yt : Xt - Yt, tr.o[1][1] = Zt + Jt * Kt, tr.o[2][0] = er ? Xt - Yt * Kt : Xt + Yt * Kt, tr.o[2][1] = Zt + Jt, tr.o[3][0] = er ? Xt - Yt : Xt + Yt, tr.o[3][1] = Zt - Jt * Kt;
        } }, extendPrototype([DynamicPropertyContainer], Qt), Qt;
      }(), Wt = function() {
        function Kt(Qt, Xt) {
          this.v = shapePool.newElement(), this.v.setPathData(!0, 0), this.elem = Qt, this.comp = Qt.comp, this.data = Xt, this.frameId = -1, this.d = Xt.d, this.initDynamicPropertyContainer(Qt), Xt.sy === 1 ? (this.ir = PropertyFactory.getProp(Qt, Xt.ir, 0, 0, this), this.is = PropertyFactory.getProp(Qt, Xt.is, 0, 0.01, this), this.convertToPath = this.convertStarToPath) : this.convertToPath = this.convertPolygonToPath, this.pt = PropertyFactory.getProp(Qt, Xt.pt, 0, 0, this), this.p = PropertyFactory.getProp(Qt, Xt.p, 1, 0, this), this.r = PropertyFactory.getProp(Qt, Xt.r, 0, degToRads, this), this.or = PropertyFactory.getProp(Qt, Xt.or, 0, 0, this), this.os = PropertyFactory.getProp(Qt, Xt.os, 0, 0.01, this), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertToPath());
        }
        return Kt.prototype = { reset: Pt, getValue: function() {
          this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertToPath());
        }, convertStarToPath: function() {
          var Qt, Xt, Zt, Yt, Jt = 2 * Math.floor(this.pt.v), er = 2 * Math.PI / Jt, tr = !0, nr = this.or.v, rr = this.ir.v, ir = this.os.v, ar = this.is.v, or = 2 * Math.PI * nr / (2 * Jt), sr = 2 * Math.PI * rr / (2 * Jt), lr = -Math.PI / 2;
          lr += this.r.v;
          var cr = this.data.d === 3 ? -1 : 1;
          for (this.v._length = 0, Qt = 0; Qt < Jt; Qt += 1) {
            Zt = tr ? ir : ar, Yt = tr ? or : sr;
            var hr = (Xt = tr ? nr : rr) * Math.cos(lr), pr = Xt * Math.sin(lr), mr = hr === 0 && pr === 0 ? 0 : pr / Math.sqrt(hr * hr + pr * pr), Er = hr === 0 && pr === 0 ? 0 : -hr / Math.sqrt(hr * hr + pr * pr);
            hr += +this.p.v[0], pr += +this.p.v[1], this.v.setTripleAt(hr, pr, hr - mr * Yt * Zt * cr, pr - Er * Yt * Zt * cr, hr + mr * Yt * Zt * cr, pr + Er * Yt * Zt * cr, Qt, !0), tr = !tr, lr += er * cr;
          }
        }, convertPolygonToPath: function() {
          var Qt, Xt = Math.floor(this.pt.v), Zt = 2 * Math.PI / Xt, Yt = this.or.v, Jt = this.os.v, er = 2 * Math.PI * Yt / (4 * Xt), tr = 0.5 * -Math.PI, nr = this.data.d === 3 ? -1 : 1;
          for (tr += this.r.v, this.v._length = 0, Qt = 0; Qt < Xt; Qt += 1) {
            var rr = Yt * Math.cos(tr), ir = Yt * Math.sin(tr), ar = rr === 0 && ir === 0 ? 0 : ir / Math.sqrt(rr * rr + ir * ir), or = rr === 0 && ir === 0 ? 0 : -rr / Math.sqrt(rr * rr + ir * ir);
            rr += +this.p.v[0], ir += +this.p.v[1], this.v.setTripleAt(rr, ir, rr - ar * er * Jt * nr, ir - or * er * Jt * nr, rr + ar * er * Jt * nr, ir + or * er * Jt * nr, Qt, !0), tr += Zt * nr;
          }
          this.paths.length = 0, this.paths[0] = this.v;
        } }, extendPrototype([DynamicPropertyContainer], Kt), Kt;
      }(), Gt = function() {
        function Kt(Qt, Xt) {
          this.v = shapePool.newElement(), this.v.c = !0, this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.elem = Qt, this.comp = Qt.comp, this.frameId = -1, this.d = Xt.d, this.initDynamicPropertyContainer(Qt), this.p = PropertyFactory.getProp(Qt, Xt.p, 1, 0, this), this.s = PropertyFactory.getProp(Qt, Xt.s, 1, 0, this), this.r = PropertyFactory.getProp(Qt, Xt.r, 0, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertRectToPath());
        }
        return Kt.prototype = { convertRectToPath: function() {
          var Qt = this.p.v[0], Xt = this.p.v[1], Zt = this.s.v[0] / 2, Yt = this.s.v[1] / 2, Jt = bmMin(Zt, Yt, this.r.v), er = Jt * (1 - roundCorner);
          this.v._length = 0, this.d === 2 || this.d === 1 ? (this.v.setTripleAt(Qt + Zt, Xt - Yt + Jt, Qt + Zt, Xt - Yt + Jt, Qt + Zt, Xt - Yt + er, 0, !0), this.v.setTripleAt(Qt + Zt, Xt + Yt - Jt, Qt + Zt, Xt + Yt - er, Qt + Zt, Xt + Yt - Jt, 1, !0), Jt !== 0 ? (this.v.setTripleAt(Qt + Zt - Jt, Xt + Yt, Qt + Zt - Jt, Xt + Yt, Qt + Zt - er, Xt + Yt, 2, !0), this.v.setTripleAt(Qt - Zt + Jt, Xt + Yt, Qt - Zt + er, Xt + Yt, Qt - Zt + Jt, Xt + Yt, 3, !0), this.v.setTripleAt(Qt - Zt, Xt + Yt - Jt, Qt - Zt, Xt + Yt - Jt, Qt - Zt, Xt + Yt - er, 4, !0), this.v.setTripleAt(Qt - Zt, Xt - Yt + Jt, Qt - Zt, Xt - Yt + er, Qt - Zt, Xt - Yt + Jt, 5, !0), this.v.setTripleAt(Qt - Zt + Jt, Xt - Yt, Qt - Zt + Jt, Xt - Yt, Qt - Zt + er, Xt - Yt, 6, !0), this.v.setTripleAt(Qt + Zt - Jt, Xt - Yt, Qt + Zt - er, Xt - Yt, Qt + Zt - Jt, Xt - Yt, 7, !0)) : (this.v.setTripleAt(Qt - Zt, Xt + Yt, Qt - Zt + er, Xt + Yt, Qt - Zt, Xt + Yt, 2), this.v.setTripleAt(Qt - Zt, Xt - Yt, Qt - Zt, Xt - Yt + er, Qt - Zt, Xt - Yt, 3))) : (this.v.setTripleAt(Qt + Zt, Xt - Yt + Jt, Qt + Zt, Xt - Yt + er, Qt + Zt, Xt - Yt + Jt, 0, !0), Jt !== 0 ? (this.v.setTripleAt(Qt + Zt - Jt, Xt - Yt, Qt + Zt - Jt, Xt - Yt, Qt + Zt - er, Xt - Yt, 1, !0), this.v.setTripleAt(Qt - Zt + Jt, Xt - Yt, Qt - Zt + er, Xt - Yt, Qt - Zt + Jt, Xt - Yt, 2, !0), this.v.setTripleAt(Qt - Zt, Xt - Yt + Jt, Qt - Zt, Xt - Yt + Jt, Qt - Zt, Xt - Yt + er, 3, !0), this.v.setTripleAt(Qt - Zt, Xt + Yt - Jt, Qt - Zt, Xt + Yt - er, Qt - Zt, Xt + Yt - Jt, 4, !0), this.v.setTripleAt(Qt - Zt + Jt, Xt + Yt, Qt - Zt + Jt, Xt + Yt, Qt - Zt + er, Xt + Yt, 5, !0), this.v.setTripleAt(Qt + Zt - Jt, Xt + Yt, Qt + Zt - er, Xt + Yt, Qt + Zt - Jt, Xt + Yt, 6, !0), this.v.setTripleAt(Qt + Zt, Xt + Yt - Jt, Qt + Zt, Xt + Yt - Jt, Qt + Zt, Xt + Yt - er, 7, !0)) : (this.v.setTripleAt(Qt - Zt, Xt - Yt, Qt - Zt + er, Xt - Yt, Qt - Zt, Xt - Yt, 1, !0), this.v.setTripleAt(Qt - Zt, Xt + Yt, Qt - Zt, Xt + Yt - er, Qt - Zt, Xt + Yt, 2, !0), this.v.setTripleAt(Qt + Zt, Xt + Yt, Qt + Zt - er, Xt + Yt, Qt + Zt, Xt + Yt, 3, !0)));
        }, getValue: function() {
          this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertRectToPath());
        }, reset: Pt }, extendPrototype([DynamicPropertyContainer], Kt), Kt;
      }(), qt = { getShapeProp: function(Kt, Qt, Xt) {
        var Zt;
        return Xt === 3 || Xt === 4 ? Zt = (Xt === 3 ? Qt.pt : Qt.ks).k.length ? new zt(Kt, Qt, Xt) : new Bt(Kt, Qt, Xt) : Xt === 5 ? Zt = new Gt(Kt, Qt) : Xt === 6 ? Zt = new Ht(Kt, Qt) : Xt === 7 && (Zt = new Wt(Kt, Qt)), Zt.k && Kt.addDynamicProperty(Zt), Zt;
      }, getConstructorFunction: function() {
        return Bt;
      }, getKeyframedConstructorFunction: function() {
        return zt;
      } };
      return qt;
    }(), Matrix = /* @__PURE__ */ function() {
      var _t = Math.cos, Et = Math.sin, Pt = Math.tan, $t = Math.round;
      function Mt() {
        return this.props[0] = 1, this.props[1] = 0, this.props[2] = 0, this.props[3] = 0, this.props[4] = 0, this.props[5] = 1, this.props[6] = 0, this.props[7] = 0, this.props[8] = 0, this.props[9] = 0, this.props[10] = 1, this.props[11] = 0, this.props[12] = 0, this.props[13] = 0, this.props[14] = 0, this.props[15] = 1, this;
      }
      function Bt(ur) {
        if (ur === 0)
          return this;
        var vr = _t(ur), dr = Et(ur);
        return this._t(vr, -dr, 0, 0, dr, vr, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function Vt(ur) {
        if (ur === 0)
          return this;
        var vr = _t(ur), dr = Et(ur);
        return this._t(1, 0, 0, 0, 0, vr, -dr, 0, 0, dr, vr, 0, 0, 0, 0, 1);
      }
      function zt(ur) {
        if (ur === 0)
          return this;
        var vr = _t(ur), dr = Et(ur);
        return this._t(vr, 0, dr, 0, 0, 1, 0, 0, -dr, 0, vr, 0, 0, 0, 0, 1);
      }
      function Ht(ur) {
        if (ur === 0)
          return this;
        var vr = _t(ur), dr = Et(ur);
        return this._t(vr, -dr, 0, 0, dr, vr, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function Wt(ur, vr) {
        return this._t(1, vr, ur, 1, 0, 0);
      }
      function Gt(ur, vr) {
        return this.shear(Pt(ur), Pt(vr));
      }
      function qt(ur, vr) {
        var dr = _t(vr), br = Et(vr);
        return this._t(dr, br, 0, 0, -br, dr, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, Pt(ur), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(dr, -br, 0, 0, br, dr, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function Kt(ur, vr, dr) {
        return dr || dr === 0 || (dr = 1), ur === 1 && vr === 1 && dr === 1 ? this : this._t(ur, 0, 0, 0, 0, vr, 0, 0, 0, 0, dr, 0, 0, 0, 0, 1);
      }
      function Qt(ur, vr, dr, br, Cr, Pr, xr, kr, Ir, Ar, Mr, Fr, Dr, zr, Tr, Gr) {
        return this.props[0] = ur, this.props[1] = vr, this.props[2] = dr, this.props[3] = br, this.props[4] = Cr, this.props[5] = Pr, this.props[6] = xr, this.props[7] = kr, this.props[8] = Ir, this.props[9] = Ar, this.props[10] = Mr, this.props[11] = Fr, this.props[12] = Dr, this.props[13] = zr, this.props[14] = Tr, this.props[15] = Gr, this;
      }
      function Xt(ur, vr, dr) {
        return dr = dr || 0, ur !== 0 || vr !== 0 || dr !== 0 ? this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, ur, vr, dr, 1) : this;
      }
      function Zt(ur, vr, dr, br, Cr, Pr, xr, kr, Ir, Ar, Mr, Fr, Dr, zr, Tr, Gr) {
        var $r = this.props;
        if (ur === 1 && vr === 0 && dr === 0 && br === 0 && Cr === 0 && Pr === 1 && xr === 0 && kr === 0 && Ir === 0 && Ar === 0 && Mr === 1 && Fr === 0)
          return $r[12] = $r[12] * ur + $r[15] * Dr, $r[13] = $r[13] * Pr + $r[15] * zr, $r[14] = $r[14] * Mr + $r[15] * Tr, $r[15] *= Gr, this._identityCalculated = !1, this;
        var Rr = $r[0], Or = $r[1], Lr = $r[2], Hr = $r[3], Wr = $r[4], Kr = $r[5], Ur = $r[6], Zr = $r[7], Xr = $r[8], mn = $r[9], an = $r[10], nn = $r[11], $n = $r[12], En = $r[13], xn = $r[14], qr = $r[15];
        return $r[0] = Rr * ur + Or * Cr + Lr * Ir + Hr * Dr, $r[1] = Rr * vr + Or * Pr + Lr * Ar + Hr * zr, $r[2] = Rr * dr + Or * xr + Lr * Mr + Hr * Tr, $r[3] = Rr * br + Or * kr + Lr * Fr + Hr * Gr, $r[4] = Wr * ur + Kr * Cr + Ur * Ir + Zr * Dr, $r[5] = Wr * vr + Kr * Pr + Ur * Ar + Zr * zr, $r[6] = Wr * dr + Kr * xr + Ur * Mr + Zr * Tr, $r[7] = Wr * br + Kr * kr + Ur * Fr + Zr * Gr, $r[8] = Xr * ur + mn * Cr + an * Ir + nn * Dr, $r[9] = Xr * vr + mn * Pr + an * Ar + nn * zr, $r[10] = Xr * dr + mn * xr + an * Mr + nn * Tr, $r[11] = Xr * br + mn * kr + an * Fr + nn * Gr, $r[12] = $n * ur + En * Cr + xn * Ir + qr * Dr, $r[13] = $n * vr + En * Pr + xn * Ar + qr * zr, $r[14] = $n * dr + En * xr + xn * Mr + qr * Tr, $r[15] = $n * br + En * kr + xn * Fr + qr * Gr, this._identityCalculated = !1, this;
      }
      function Yt(ur) {
        var vr = ur.props;
        return this.transform(vr[0], vr[1], vr[2], vr[3], vr[4], vr[5], vr[6], vr[7], vr[8], vr[9], vr[10], vr[11], vr[12], vr[13], vr[14], vr[15]);
      }
      function Jt() {
        return this._identityCalculated || (this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1), this._identityCalculated = !0), this._identity;
      }
      function er(ur) {
        for (var vr = 0; vr < 16; ) {
          if (ur.props[vr] !== this.props[vr])
            return !1;
          vr += 1;
        }
        return !0;
      }
      function tr(ur) {
        var vr;
        for (vr = 0; vr < 16; vr += 1)
          ur.props[vr] = this.props[vr];
        return ur;
      }
      function nr(ur) {
        var vr;
        for (vr = 0; vr < 16; vr += 1)
          this.props[vr] = ur[vr];
      }
      function rr(ur, vr, dr) {
        return { x: ur * this.props[0] + vr * this.props[4] + dr * this.props[8] + this.props[12], y: ur * this.props[1] + vr * this.props[5] + dr * this.props[9] + this.props[13], z: ur * this.props[2] + vr * this.props[6] + dr * this.props[10] + this.props[14] };
      }
      function ir(ur, vr, dr) {
        return ur * this.props[0] + vr * this.props[4] + dr * this.props[8] + this.props[12];
      }
      function ar(ur, vr, dr) {
        return ur * this.props[1] + vr * this.props[5] + dr * this.props[9] + this.props[13];
      }
      function or(ur, vr, dr) {
        return ur * this.props[2] + vr * this.props[6] + dr * this.props[10] + this.props[14];
      }
      function sr() {
        var ur = this.props[0] * this.props[5] - this.props[1] * this.props[4], vr = this.props[5] / ur, dr = -this.props[1] / ur, br = -this.props[4] / ur, Cr = this.props[0] / ur, Pr = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / ur, xr = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / ur, kr = new Matrix();
        return kr.props[0] = vr, kr.props[1] = dr, kr.props[4] = br, kr.props[5] = Cr, kr.props[12] = Pr, kr.props[13] = xr, kr;
      }
      function lr(ur) {
        return this.getInverseMatrix().applyToPointArray(ur[0], ur[1], ur[2] || 0);
      }
      function cr(ur) {
        var vr, dr = ur.length, br = [];
        for (vr = 0; vr < dr; vr += 1)
          br[vr] = lr(ur[vr]);
        return br;
      }
      function hr(ur, vr, dr) {
        var br = createTypedArray("float32", 6);
        if (this.isIdentity())
          br[0] = ur[0], br[1] = ur[1], br[2] = vr[0], br[3] = vr[1], br[4] = dr[0], br[5] = dr[1];
        else {
          var Cr = this.props[0], Pr = this.props[1], xr = this.props[4], kr = this.props[5], Ir = this.props[12], Ar = this.props[13];
          br[0] = ur[0] * Cr + ur[1] * xr + Ir, br[1] = ur[0] * Pr + ur[1] * kr + Ar, br[2] = vr[0] * Cr + vr[1] * xr + Ir, br[3] = vr[0] * Pr + vr[1] * kr + Ar, br[4] = dr[0] * Cr + dr[1] * xr + Ir, br[5] = dr[0] * Pr + dr[1] * kr + Ar;
        }
        return br;
      }
      function pr(ur, vr, dr) {
        return this.isIdentity() ? [ur, vr, dr] : [ur * this.props[0] + vr * this.props[4] + dr * this.props[8] + this.props[12], ur * this.props[1] + vr * this.props[5] + dr * this.props[9] + this.props[13], ur * this.props[2] + vr * this.props[6] + dr * this.props[10] + this.props[14]];
      }
      function mr(ur, vr) {
        if (this.isIdentity())
          return ur + "," + vr;
        var dr = this.props;
        return Math.round(100 * (ur * dr[0] + vr * dr[4] + dr[12])) / 100 + "," + Math.round(100 * (ur * dr[1] + vr * dr[5] + dr[13])) / 100;
      }
      function Er() {
        for (var ur = 0, vr = this.props, dr = "matrix3d("; ur < 16; )
          dr += $t(1e4 * vr[ur]) / 1e4, dr += ur === 15 ? ")" : ",", ur += 1;
        return dr;
      }
      function _r(ur) {
        return ur < 1e-6 && ur > 0 || ur > -1e-6 && ur < 0 ? $t(1e4 * ur) / 1e4 : ur;
      }
      function yr() {
        var ur = this.props;
        return "matrix(" + _r(ur[0]) + "," + _r(ur[1]) + "," + _r(ur[4]) + "," + _r(ur[5]) + "," + _r(ur[12]) + "," + _r(ur[13]) + ")";
      }
      return function() {
        this.reset = Mt, this.rotate = Bt, this.rotateX = Vt, this.rotateY = zt, this.rotateZ = Ht, this.skew = Gt, this.skewFromAxis = qt, this.shear = Wt, this.scale = Kt, this.setTransform = Qt, this.translate = Xt, this.transform = Zt, this.multiply = Yt, this.applyToPoint = rr, this.applyToX = ir, this.applyToY = ar, this.applyToZ = or, this.applyToPointArray = pr, this.applyToTriplePoints = hr, this.applyToPointStringified = mr, this.toCSS = Er, this.to2dCSS = yr, this.clone = tr, this.cloneFromProps = nr, this.equals = er, this.inversePoints = cr, this.inversePoint = lr, this.getInverseMatrix = sr, this._t = this.transform, this.isIdentity = Jt, this._identity = !0, this._identityCalculated = !1, this.props = createTypedArray("float32", 16), this.reset();
      };
    }();
    function _typeof$3(_t) {
      return (_typeof$3 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Et) {
        return typeof Et;
      } : function(Et) {
        return Et && typeof Symbol == "function" && Et.constructor === Symbol && Et !== Symbol.prototype ? "symbol" : typeof Et;
      })(_t);
    }
    var lottie = {};
    function setLocation(_t) {
      setLocationHref(_t);
    }
    function searchAnimations() {
      animationManager.searchAnimations();
    }
    function setSubframeRendering(_t) {
      setSubframeEnabled(_t);
    }
    function setPrefix(_t) {
      setIdPrefix(_t);
    }
    function loadAnimation(_t) {
      return animationManager.loadAnimation(_t);
    }
    function setQuality(_t) {
      if (typeof _t == "string")
        switch (_t) {
          case "high":
            setDefaultCurveSegments(200);
            break;
          default:
          case "medium":
            setDefaultCurveSegments(50);
            break;
          case "low":
            setDefaultCurveSegments(10);
        }
      else
        !isNaN(_t) && _t > 1 && setDefaultCurveSegments(_t);
    }
    function inBrowser() {
      return typeof navigator < "u";
    }
    function installPlugin(_t, Et) {
      _t === "expressions" && setExpressionsPlugin(Et);
    }
    function getFactory(_t) {
      switch (_t) {
        case "propertyFactory":
          return PropertyFactory;
        case "shapePropertyFactory":
          return ShapePropertyFactory;
        case "matrix":
          return Matrix;
        default:
          return null;
      }
    }
    function checkReady() {
      document.readyState === "complete" && (clearInterval(readyStateCheckInterval), searchAnimations());
    }
    function getQueryVariable(_t) {
      for (var Et = queryString.split("&"), Pt = 0; Pt < Et.length; Pt += 1) {
        var $t = Et[Pt].split("=");
        if (decodeURIComponent($t[0]) == _t)
          return decodeURIComponent($t[1]);
      }
      return null;
    }
    lottie.play = animationManager.play, lottie.pause = animationManager.pause, lottie.setLocationHref = setLocation, lottie.togglePause = animationManager.togglePause, lottie.setSpeed = animationManager.setSpeed, lottie.setDirection = animationManager.setDirection, lottie.stop = animationManager.stop, lottie.searchAnimations = searchAnimations, lottie.registerAnimation = animationManager.registerAnimation, lottie.loadAnimation = loadAnimation, lottie.setSubframeRendering = setSubframeRendering, lottie.resize = animationManager.resize, lottie.goToAndStop = animationManager.goToAndStop, lottie.destroy = animationManager.destroy, lottie.setQuality = setQuality, lottie.inBrowser = inBrowser, lottie.installPlugin = installPlugin, lottie.freeze = animationManager.freeze, lottie.unfreeze = animationManager.unfreeze, lottie.setVolume = animationManager.setVolume, lottie.mute = animationManager.mute, lottie.unmute = animationManager.unmute, lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations, lottie.useWebWorker = setWebWorker, lottie.setIDPrefix = setPrefix, lottie.__getFactory = getFactory, lottie.version = "5.12.2";
    var queryString = "";
    {
      var scripts = document.getElementsByTagName("script"), index = scripts.length - 1, myScript = scripts[index] || { src: "" };
      queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, "") : "", getQueryVariable("renderer");
    }
    var readyStateCheckInterval = setInterval(checkReady, 100);
    try {
      _typeof$3(exports) !== "object" && (window.bodymovin = lottie);
    } catch (_t) {
    }
    var ShapeModifiers = function() {
      var _t = {}, Et = {};
      return _t.registerModifier = function(Pt, $t) {
        Et[Pt] || (Et[Pt] = $t);
      }, _t.getModifier = function(Pt, $t, Mt) {
        return new Et[Pt]($t, Mt);
      }, _t;
    }();
    function ShapeModifier() {
    }
    function TrimModifier() {
    }
    function PuckerAndBloatModifier() {
    }
    ShapeModifier.prototype.initModifierProperties = function() {
    }, ShapeModifier.prototype.addShapeToModifier = function() {
    }, ShapeModifier.prototype.addShape = function(_t) {
      if (!this.closed) {
        _t.sh.container.addDynamicProperty(_t.sh);
        var Et = { shape: _t.sh, data: _t, localShapeCollection: shapeCollectionPool.newShapeCollection() };
        this.shapes.push(Et), this.addShapeToModifier(Et), this._isAnimated && _t.setAsAnimated();
      }
    }, ShapeModifier.prototype.init = function(_t, Et) {
      this.shapes = [], this.elem = _t, this.initDynamicPropertyContainer(_t), this.initModifierProperties(_t, Et), this.frameId = initialDefaultFrame, this.closed = !1, this.k = !1, this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
    }, ShapeModifier.prototype.processKeys = function() {
      this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties());
    }, extendPrototype([DynamicPropertyContainer], ShapeModifier), extendPrototype([ShapeModifier], TrimModifier), TrimModifier.prototype.initModifierProperties = function(_t, Et) {
      this.s = PropertyFactory.getProp(_t, Et.s, 0, 0.01, this), this.e = PropertyFactory.getProp(_t, Et.e, 0, 0.01, this), this.o = PropertyFactory.getProp(_t, Et.o, 0, 0, this), this.sValue = 0, this.eValue = 0, this.getValue = this.processKeys, this.m = Et.m, this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
    }, TrimModifier.prototype.addShapeToModifier = function(_t) {
      _t.pathsData = [];
    }, TrimModifier.prototype.calculateShapeEdges = function(_t, Et, Pt, $t, Mt) {
      var Bt = [];
      Et <= 1 ? Bt.push({ s: _t, e: Et }) : _t >= 1 ? Bt.push({ s: _t - 1, e: Et - 1 }) : (Bt.push({ s: _t, e: 1 }), Bt.push({ s: 0, e: Et - 1 }));
      var Vt, zt, Ht = [], Wt = Bt.length;
      for (Vt = 0; Vt < Wt; Vt += 1) {
        var Gt, qt;
        (zt = Bt[Vt]).e * Mt < $t || zt.s * Mt > $t + Pt || (Gt = zt.s * Mt <= $t ? 0 : (zt.s * Mt - $t) / Pt, qt = zt.e * Mt >= $t + Pt ? 1 : (zt.e * Mt - $t) / Pt, Ht.push([Gt, qt]));
      }
      return Ht.length || Ht.push([0, 0]), Ht;
    }, TrimModifier.prototype.releasePathsData = function(_t) {
      var Et, Pt = _t.length;
      for (Et = 0; Et < Pt; Et += 1)
        segmentsLengthPool.release(_t[Et]);
      return _t.length = 0, _t;
    }, TrimModifier.prototype.processShapes = function(_t) {
      var Et, Pt, $t, Mt;
      if (this._mdf || _t) {
        var Bt = this.o.v % 360 / 360;
        if (Bt < 0 && (Bt += 1), (Et = this.s.v > 1 ? 1 + Bt : this.s.v < 0 ? 0 + Bt : this.s.v + Bt) > (Pt = this.e.v > 1 ? 1 + Bt : this.e.v < 0 ? 0 + Bt : this.e.v + Bt)) {
          var Vt = Et;
          Et = Pt, Pt = Vt;
        }
        Et = 1e-4 * Math.round(1e4 * Et), Pt = 1e-4 * Math.round(1e4 * Pt), this.sValue = Et, this.eValue = Pt;
      } else
        Et = this.sValue, Pt = this.eValue;
      var zt, Ht, Wt, Gt, qt, Kt = this.shapes.length, Qt = 0;
      if (Pt === Et)
        for (Mt = 0; Mt < Kt; Mt += 1)
          this.shapes[Mt].localShapeCollection.releaseShapes(), this.shapes[Mt].shape._mdf = !0, this.shapes[Mt].shape.paths = this.shapes[Mt].localShapeCollection, this._mdf && (this.shapes[Mt].pathsData.length = 0);
      else if (Pt === 1 && Et === 0 || Pt === 0 && Et === 1) {
        if (this._mdf)
          for (Mt = 0; Mt < Kt; Mt += 1)
            this.shapes[Mt].pathsData.length = 0, this.shapes[Mt].shape._mdf = !0;
      } else {
        var Xt, Zt, Yt = [];
        for (Mt = 0; Mt < Kt; Mt += 1)
          if ((Xt = this.shapes[Mt]).shape._mdf || this._mdf || _t || this.m === 2) {
            if (Ht = ($t = Xt.shape.paths)._length, qt = 0, !Xt.shape._mdf && Xt.pathsData.length)
              qt = Xt.totalShapeLength;
            else {
              for (Wt = this.releasePathsData(Xt.pathsData), zt = 0; zt < Ht; zt += 1)
                Gt = bez.getSegmentsLength($t.shapes[zt]), Wt.push(Gt), qt += Gt.totalLength;
              Xt.totalShapeLength = qt, Xt.pathsData = Wt;
            }
            Qt += qt, Xt.shape._mdf = !0;
          } else
            Xt.shape.paths = Xt.localShapeCollection;
        var Jt, er = Et, tr = Pt, nr = 0;
        for (Mt = Kt - 1; Mt >= 0; Mt -= 1)
          if ((Xt = this.shapes[Mt]).shape._mdf) {
            for ((Zt = Xt.localShapeCollection).releaseShapes(), this.m === 2 && Kt > 1 ? (Jt = this.calculateShapeEdges(Et, Pt, Xt.totalShapeLength, nr, Qt), nr += Xt.totalShapeLength) : Jt = [[er, tr]], Ht = Jt.length, zt = 0; zt < Ht; zt += 1) {
              er = Jt[zt][0], tr = Jt[zt][1], Yt.length = 0, tr <= 1 ? Yt.push({ s: Xt.totalShapeLength * er, e: Xt.totalShapeLength * tr }) : er >= 1 ? Yt.push({ s: Xt.totalShapeLength * (er - 1), e: Xt.totalShapeLength * (tr - 1) }) : (Yt.push({ s: Xt.totalShapeLength * er, e: Xt.totalShapeLength }), Yt.push({ s: 0, e: Xt.totalShapeLength * (tr - 1) }));
              var rr = this.addShapes(Xt, Yt[0]);
              if (Yt[0].s !== Yt[0].e) {
                if (Yt.length > 1)
                  if (Xt.shape.paths.shapes[Xt.shape.paths._length - 1].c) {
                    var ir = rr.pop();
                    this.addPaths(rr, Zt), rr = this.addShapes(Xt, Yt[1], ir);
                  } else
                    this.addPaths(rr, Zt), rr = this.addShapes(Xt, Yt[1]);
                this.addPaths(rr, Zt);
              }
            }
            Xt.shape.paths = Zt;
          }
      }
    }, TrimModifier.prototype.addPaths = function(_t, Et) {
      var Pt, $t = _t.length;
      for (Pt = 0; Pt < $t; Pt += 1)
        Et.addShape(_t[Pt]);
    }, TrimModifier.prototype.addSegment = function(_t, Et, Pt, $t, Mt, Bt, Vt) {
      Mt.setXYAt(Et[0], Et[1], "o", Bt), Mt.setXYAt(Pt[0], Pt[1], "i", Bt + 1), Vt && Mt.setXYAt(_t[0], _t[1], "v", Bt), Mt.setXYAt($t[0], $t[1], "v", Bt + 1);
    }, TrimModifier.prototype.addSegmentFromArray = function(_t, Et, Pt, $t) {
      Et.setXYAt(_t[1], _t[5], "o", Pt), Et.setXYAt(_t[2], _t[6], "i", Pt + 1), $t && Et.setXYAt(_t[0], _t[4], "v", Pt), Et.setXYAt(_t[3], _t[7], "v", Pt + 1);
    }, TrimModifier.prototype.addShapes = function(_t, Et, Pt) {
      var $t, Mt, Bt, Vt, zt, Ht, Wt, Gt, qt = _t.pathsData, Kt = _t.shape.paths.shapes, Qt = _t.shape.paths._length, Xt = 0, Zt = [], Yt = !0;
      for (Pt ? (zt = Pt._length, Gt = Pt._length) : (Pt = shapePool.newElement(), zt = 0, Gt = 0), Zt.push(Pt), $t = 0; $t < Qt; $t += 1) {
        for (Ht = qt[$t].lengths, Pt.c = Kt[$t].c, Bt = Kt[$t].c ? Ht.length : Ht.length + 1, Mt = 1; Mt < Bt; Mt += 1)
          if (Xt + (Vt = Ht[Mt - 1]).addedLength < Et.s)
            Xt += Vt.addedLength, Pt.c = !1;
          else {
            if (Xt > Et.e) {
              Pt.c = !1;
              break;
            }
            Et.s <= Xt && Et.e >= Xt + Vt.addedLength ? (this.addSegment(Kt[$t].v[Mt - 1], Kt[$t].o[Mt - 1], Kt[$t].i[Mt], Kt[$t].v[Mt], Pt, zt, Yt), Yt = !1) : (Wt = bez.getNewSegment(Kt[$t].v[Mt - 1], Kt[$t].v[Mt], Kt[$t].o[Mt - 1], Kt[$t].i[Mt], (Et.s - Xt) / Vt.addedLength, (Et.e - Xt) / Vt.addedLength, Ht[Mt - 1]), this.addSegmentFromArray(Wt, Pt, zt, Yt), Yt = !1, Pt.c = !1), Xt += Vt.addedLength, zt += 1;
          }
        if (Kt[$t].c && Ht.length) {
          if (Vt = Ht[Mt - 1], Xt <= Et.e) {
            var Jt = Ht[Mt - 1].addedLength;
            Et.s <= Xt && Et.e >= Xt + Jt ? (this.addSegment(Kt[$t].v[Mt - 1], Kt[$t].o[Mt - 1], Kt[$t].i[0], Kt[$t].v[0], Pt, zt, Yt), Yt = !1) : (Wt = bez.getNewSegment(Kt[$t].v[Mt - 1], Kt[$t].v[0], Kt[$t].o[Mt - 1], Kt[$t].i[0], (Et.s - Xt) / Jt, (Et.e - Xt) / Jt, Ht[Mt - 1]), this.addSegmentFromArray(Wt, Pt, zt, Yt), Yt = !1, Pt.c = !1);
          } else
            Pt.c = !1;
          Xt += Vt.addedLength, zt += 1;
        }
        if (Pt._length && (Pt.setXYAt(Pt.v[Gt][0], Pt.v[Gt][1], "i", Gt), Pt.setXYAt(Pt.v[Pt._length - 1][0], Pt.v[Pt._length - 1][1], "o", Pt._length - 1)), Xt > Et.e)
          break;
        $t < Qt - 1 && (Pt = shapePool.newElement(), Yt = !0, Zt.push(Pt), zt = 0);
      }
      return Zt;
    }, extendPrototype([ShapeModifier], PuckerAndBloatModifier), PuckerAndBloatModifier.prototype.initModifierProperties = function(_t, Et) {
      this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(_t, Et.a, 0, null, this), this._isAnimated = !!this.amount.effectsSequence.length;
    }, PuckerAndBloatModifier.prototype.processPath = function(_t, Et) {
      var Pt = Et / 100, $t = [0, 0], Mt = _t._length, Bt = 0;
      for (Bt = 0; Bt < Mt; Bt += 1)
        $t[0] += _t.v[Bt][0], $t[1] += _t.v[Bt][1];
      $t[0] /= Mt, $t[1] /= Mt;
      var Vt, zt, Ht, Wt, Gt, qt, Kt = shapePool.newElement();
      for (Kt.c = _t.c, Bt = 0; Bt < Mt; Bt += 1)
        Vt = _t.v[Bt][0] + ($t[0] - _t.v[Bt][0]) * Pt, zt = _t.v[Bt][1] + ($t[1] - _t.v[Bt][1]) * Pt, Ht = _t.o[Bt][0] + ($t[0] - _t.o[Bt][0]) * -Pt, Wt = _t.o[Bt][1] + ($t[1] - _t.o[Bt][1]) * -Pt, Gt = _t.i[Bt][0] + ($t[0] - _t.i[Bt][0]) * -Pt, qt = _t.i[Bt][1] + ($t[1] - _t.i[Bt][1]) * -Pt, Kt.setTripleAt(Vt, zt, Ht, Wt, Gt, qt, Bt);
      return Kt;
    }, PuckerAndBloatModifier.prototype.processShapes = function(_t) {
      var Et, Pt, $t, Mt, Bt, Vt, zt = this.shapes.length, Ht = this.amount.v;
      if (Ht !== 0)
        for (Pt = 0; Pt < zt; Pt += 1) {
          if (Vt = (Bt = this.shapes[Pt]).localShapeCollection, Bt.shape._mdf || this._mdf || _t)
            for (Vt.releaseShapes(), Bt.shape._mdf = !0, Et = Bt.shape.paths.shapes, Mt = Bt.shape.paths._length, $t = 0; $t < Mt; $t += 1)
              Vt.addShape(this.processPath(Et[$t], Ht));
          Bt.shape.paths = Bt.localShapeCollection;
        }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    var TransformPropertyFactory = function() {
      var _t = [0, 0];
      function Et(Pt, $t, Mt) {
        if (this.elem = Pt, this.frameId = -1, this.propType = "transform", this.data = $t, this.v = new Matrix(), this.pre = new Matrix(), this.appliedTransformations = 0, this.initDynamicPropertyContainer(Mt || Pt), $t.p && $t.p.s ? (this.px = PropertyFactory.getProp(Pt, $t.p.x, 0, 0, this), this.py = PropertyFactory.getProp(Pt, $t.p.y, 0, 0, this), $t.p.z && (this.pz = PropertyFactory.getProp(Pt, $t.p.z, 0, 0, this))) : this.p = PropertyFactory.getProp(Pt, $t.p || { k: [0, 0, 0] }, 1, 0, this), $t.rx) {
          if (this.rx = PropertyFactory.getProp(Pt, $t.rx, 0, degToRads, this), this.ry = PropertyFactory.getProp(Pt, $t.ry, 0, degToRads, this), this.rz = PropertyFactory.getProp(Pt, $t.rz, 0, degToRads, this), $t.or.k[0].ti) {
            var Bt, Vt = $t.or.k.length;
            for (Bt = 0; Bt < Vt; Bt += 1)
              $t.or.k[Bt].to = null, $t.or.k[Bt].ti = null;
          }
          this.or = PropertyFactory.getProp(Pt, $t.or, 1, degToRads, this), this.or.sh = !0;
        } else
          this.r = PropertyFactory.getProp(Pt, $t.r || { k: 0 }, 0, degToRads, this);
        $t.sk && (this.sk = PropertyFactory.getProp(Pt, $t.sk, 0, degToRads, this), this.sa = PropertyFactory.getProp(Pt, $t.sa, 0, degToRads, this)), this.a = PropertyFactory.getProp(Pt, $t.a || { k: [0, 0, 0] }, 1, 0, this), this.s = PropertyFactory.getProp(Pt, $t.s || { k: [100, 100, 100] }, 1, 0.01, this), $t.o ? this.o = PropertyFactory.getProp(Pt, $t.o, 0, 0.01, Pt) : this.o = { _mdf: !1, v: 1 }, this._isDirty = !0, this.dynamicProperties.length || this.getValue(!0);
      }
      return Et.prototype = { applyToMatrix: function(Pt) {
        var $t = this._mdf;
        this.iterateDynamicProperties(), this._mdf = this._mdf || $t, this.a && Pt.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.s && Pt.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && Pt.skewFromAxis(-this.sk.v, this.sa.v), this.r ? Pt.rotate(-this.r.v) : Pt.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.data.p.s ? this.data.p.z ? Pt.translate(this.px.v, this.py.v, -this.pz.v) : Pt.translate(this.px.v, this.py.v, 0) : Pt.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
      }, getValue: function(Pt) {
        if (this.elem.globalData.frameId !== this.frameId) {
          if (this._isDirty && (this.precalculateMatrix(), this._isDirty = !1), this.iterateDynamicProperties(), this._mdf || Pt) {
            var $t;
            if (this.v.cloneFromProps(this.pre.props), this.appliedTransformations < 1 && this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations < 2 && this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && this.appliedTransformations < 3 && this.v.skewFromAxis(-this.sk.v, this.sa.v), this.r && this.appliedTransformations < 4 ? this.v.rotate(-this.r.v) : !this.r && this.appliedTransformations < 4 && this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.autoOriented) {
              var Mt, Bt;
              if ($t = this.elem.globalData.frameRate, this.p && this.p.keyframes && this.p.getValueAtTime)
                this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t ? (Mt = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / $t, 0), Bt = this.p.getValueAtTime(this.p.keyframes[0].t / $t, 0)) : this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t ? (Mt = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / $t, 0), Bt = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / $t, 0)) : (Mt = this.p.pv, Bt = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / $t, this.p.offsetTime));
              else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                Mt = [], Bt = [];
                var Vt = this.px, zt = this.py;
                Vt._caching.lastFrame + Vt.offsetTime <= Vt.keyframes[0].t ? (Mt[0] = Vt.getValueAtTime((Vt.keyframes[0].t + 0.01) / $t, 0), Mt[1] = zt.getValueAtTime((zt.keyframes[0].t + 0.01) / $t, 0), Bt[0] = Vt.getValueAtTime(Vt.keyframes[0].t / $t, 0), Bt[1] = zt.getValueAtTime(zt.keyframes[0].t / $t, 0)) : Vt._caching.lastFrame + Vt.offsetTime >= Vt.keyframes[Vt.keyframes.length - 1].t ? (Mt[0] = Vt.getValueAtTime(Vt.keyframes[Vt.keyframes.length - 1].t / $t, 0), Mt[1] = zt.getValueAtTime(zt.keyframes[zt.keyframes.length - 1].t / $t, 0), Bt[0] = Vt.getValueAtTime((Vt.keyframes[Vt.keyframes.length - 1].t - 0.01) / $t, 0), Bt[1] = zt.getValueAtTime((zt.keyframes[zt.keyframes.length - 1].t - 0.01) / $t, 0)) : (Mt = [Vt.pv, zt.pv], Bt[0] = Vt.getValueAtTime((Vt._caching.lastFrame + Vt.offsetTime - 0.01) / $t, Vt.offsetTime), Bt[1] = zt.getValueAtTime((zt._caching.lastFrame + zt.offsetTime - 0.01) / $t, zt.offsetTime));
              } else
                Mt = Bt = _t;
              this.v.rotate(-Math.atan2(Mt[1] - Bt[1], Mt[0] - Bt[0]));
            }
            this.data.p && this.data.p.s ? this.data.p.z ? this.v.translate(this.px.v, this.py.v, -this.pz.v) : this.v.translate(this.px.v, this.py.v, 0) : this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
          }
          this.frameId = this.elem.globalData.frameId;
        }
      }, precalculateMatrix: function() {
        if (this.appliedTransformations = 0, this.pre.reset(), !this.a.effectsSequence.length && (this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations = 1, !this.s.effectsSequence.length)) {
          if (this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.appliedTransformations = 2, this.sk) {
            if (this.sk.effectsSequence.length || this.sa.effectsSequence.length)
              return;
            this.pre.skewFromAxis(-this.sk.v, this.sa.v), this.appliedTransformations = 3;
          }
          this.r ? this.r.effectsSequence.length || (this.pre.rotate(-this.r.v), this.appliedTransformations = 4) : this.rz.effectsSequence.length || this.ry.effectsSequence.length || this.rx.effectsSequence.length || this.or.effectsSequence.length || (this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.appliedTransformations = 4);
        }
      }, autoOrient: function() {
      } }, extendPrototype([DynamicPropertyContainer], Et), Et.prototype.addDynamicProperty = function(Pt) {
        this._addDynamicProperty(Pt), this.elem.addDynamicProperty(Pt), this._isDirty = !0;
      }, Et.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty, { getTransformProperty: function(Pt, $t, Mt) {
        return new Et(Pt, $t, Mt);
      } };
    }();
    function RepeaterModifier() {
    }
    function RoundCornersModifier() {
    }
    function floatEqual(_t, Et) {
      return 1e5 * Math.abs(_t - Et) <= Math.min(Math.abs(_t), Math.abs(Et));
    }
    function floatZero(_t) {
      return Math.abs(_t) <= 1e-5;
    }
    function lerp(_t, Et, Pt) {
      return _t * (1 - Pt) + Et * Pt;
    }
    function lerpPoint(_t, Et, Pt) {
      return [lerp(_t[0], Et[0], Pt), lerp(_t[1], Et[1], Pt)];
    }
    function quadRoots(_t, Et, Pt) {
      if (_t === 0)
        return [];
      var $t = Et * Et - 4 * _t * Pt;
      if ($t < 0)
        return [];
      var Mt = -Et / (2 * _t);
      if ($t === 0)
        return [Mt];
      var Bt = Math.sqrt($t) / (2 * _t);
      return [Mt - Bt, Mt + Bt];
    }
    function polynomialCoefficients(_t, Et, Pt, $t) {
      return [3 * Et - _t - 3 * Pt + $t, 3 * _t - 6 * Et + 3 * Pt, -3 * _t + 3 * Et, _t];
    }
    function singlePoint(_t) {
      return new PolynomialBezier(_t, _t, _t, _t, !1);
    }
    function PolynomialBezier(_t, Et, Pt, $t, Mt) {
      Mt && pointEqual(_t, Et) && (Et = lerpPoint(_t, $t, 1 / 3)), Mt && pointEqual(Pt, $t) && (Pt = lerpPoint(_t, $t, 2 / 3));
      var Bt = polynomialCoefficients(_t[0], Et[0], Pt[0], $t[0]), Vt = polynomialCoefficients(_t[1], Et[1], Pt[1], $t[1]);
      this.a = [Bt[0], Vt[0]], this.b = [Bt[1], Vt[1]], this.c = [Bt[2], Vt[2]], this.d = [Bt[3], Vt[3]], this.points = [_t, Et, Pt, $t];
    }
    function extrema(_t, Et) {
      var Pt = _t.points[0][Et], $t = _t.points[_t.points.length - 1][Et];
      if (Pt > $t) {
        var Mt = $t;
        $t = Pt, Pt = Mt;
      }
      for (var Bt = quadRoots(3 * _t.a[Et], 2 * _t.b[Et], _t.c[Et]), Vt = 0; Vt < Bt.length; Vt += 1)
        if (Bt[Vt] > 0 && Bt[Vt] < 1) {
          var zt = _t.point(Bt[Vt])[Et];
          zt < Pt ? Pt = zt : zt > $t && ($t = zt);
        }
      return { min: Pt, max: $t };
    }
    function intersectData(_t, Et, Pt) {
      var $t = _t.boundingBox();
      return { cx: $t.cx, cy: $t.cy, width: $t.width, height: $t.height, bez: _t, t: (Et + Pt) / 2, t1: Et, t2: Pt };
    }
    function splitData(_t) {
      var Et = _t.bez.split(0.5);
      return [intersectData(Et[0], _t.t1, _t.t), intersectData(Et[1], _t.t, _t.t2)];
    }
    function boxIntersect(_t, Et) {
      return 2 * Math.abs(_t.cx - Et.cx) < _t.width + Et.width && 2 * Math.abs(_t.cy - Et.cy) < _t.height + Et.height;
    }
    function intersectsImpl(_t, Et, Pt, $t, Mt, Bt) {
      if (boxIntersect(_t, Et))
        if (Pt >= Bt || _t.width <= $t && _t.height <= $t && Et.width <= $t && Et.height <= $t)
          Mt.push([_t.t, Et.t]);
        else {
          var Vt = splitData(_t), zt = splitData(Et);
          intersectsImpl(Vt[0], zt[0], Pt + 1, $t, Mt, Bt), intersectsImpl(Vt[0], zt[1], Pt + 1, $t, Mt, Bt), intersectsImpl(Vt[1], zt[0], Pt + 1, $t, Mt, Bt), intersectsImpl(Vt[1], zt[1], Pt + 1, $t, Mt, Bt);
        }
    }
    function crossProduct(_t, Et) {
      return [_t[1] * Et[2] - _t[2] * Et[1], _t[2] * Et[0] - _t[0] * Et[2], _t[0] * Et[1] - _t[1] * Et[0]];
    }
    function lineIntersection(_t, Et, Pt, $t) {
      var Mt = [_t[0], _t[1], 1], Bt = [Et[0], Et[1], 1], Vt = [Pt[0], Pt[1], 1], zt = [$t[0], $t[1], 1], Ht = crossProduct(crossProduct(Mt, Bt), crossProduct(Vt, zt));
      return floatZero(Ht[2]) ? null : [Ht[0] / Ht[2], Ht[1] / Ht[2]];
    }
    function polarOffset(_t, Et, Pt) {
      return [_t[0] + Math.cos(Et) * Pt, _t[1] - Math.sin(Et) * Pt];
    }
    function pointDistance(_t, Et) {
      return Math.hypot(_t[0] - Et[0], _t[1] - Et[1]);
    }
    function pointEqual(_t, Et) {
      return floatEqual(_t[0], Et[0]) && floatEqual(_t[1], Et[1]);
    }
    function ZigZagModifier() {
    }
    function setPoint(_t, Et, Pt, $t, Mt, Bt, Vt) {
      var zt = Pt - Math.PI / 2, Ht = Pt + Math.PI / 2, Wt = Et[0] + Math.cos(Pt) * $t * Mt, Gt = Et[1] - Math.sin(Pt) * $t * Mt;
      _t.setTripleAt(Wt, Gt, Wt + Math.cos(zt) * Bt, Gt - Math.sin(zt) * Bt, Wt + Math.cos(Ht) * Vt, Gt - Math.sin(Ht) * Vt, _t.length());
    }
    function getPerpendicularVector(_t, Et) {
      var Pt = [Et[0] - _t[0], Et[1] - _t[1]], $t = 0.5 * -Math.PI;
      return [Math.cos($t) * Pt[0] - Math.sin($t) * Pt[1], Math.sin($t) * Pt[0] + Math.cos($t) * Pt[1]];
    }
    function getProjectingAngle(_t, Et) {
      var Pt = Et === 0 ? _t.length() - 1 : Et - 1, $t = (Et + 1) % _t.length(), Mt = getPerpendicularVector(_t.v[Pt], _t.v[$t]);
      return Math.atan2(0, 1) - Math.atan2(Mt[1], Mt[0]);
    }
    function zigZagCorner(_t, Et, Pt, $t, Mt, Bt, Vt) {
      var zt = getProjectingAngle(Et, Pt), Ht = Et.v[Pt % Et._length], Wt = Et.v[Pt === 0 ? Et._length - 1 : Pt - 1], Gt = Et.v[(Pt + 1) % Et._length], qt = Bt === 2 ? Math.sqrt(Math.pow(Ht[0] - Wt[0], 2) + Math.pow(Ht[1] - Wt[1], 2)) : 0, Kt = Bt === 2 ? Math.sqrt(Math.pow(Ht[0] - Gt[0], 2) + Math.pow(Ht[1] - Gt[1], 2)) : 0;
      setPoint(_t, Et.v[Pt % Et._length], zt, Vt, $t, Kt / (2 * (Mt + 1)), qt / (2 * (Mt + 1)));
    }
    function zigZagSegment(_t, Et, Pt, $t, Mt, Bt) {
      for (var Vt = 0; Vt < $t; Vt += 1) {
        var zt = (Vt + 1) / ($t + 1), Ht = Mt === 2 ? Math.sqrt(Math.pow(Et.points[3][0] - Et.points[0][0], 2) + Math.pow(Et.points[3][1] - Et.points[0][1], 2)) : 0, Wt = Et.normalAngle(zt);
        setPoint(_t, Et.point(zt), Wt, Bt, Pt, Ht / (2 * ($t + 1)), Ht / (2 * ($t + 1))), Bt = -Bt;
      }
      return Bt;
    }
    function linearOffset(_t, Et, Pt) {
      var $t = Math.atan2(Et[0] - _t[0], Et[1] - _t[1]);
      return [polarOffset(_t, $t, Pt), polarOffset(Et, $t, Pt)];
    }
    function offsetSegment(_t, Et) {
      var Pt, $t, Mt, Bt, Vt, zt, Ht;
      Pt = (Ht = linearOffset(_t.points[0], _t.points[1], Et))[0], $t = Ht[1], Mt = (Ht = linearOffset(_t.points[1], _t.points[2], Et))[0], Bt = Ht[1], Vt = (Ht = linearOffset(_t.points[2], _t.points[3], Et))[0], zt = Ht[1];
      var Wt = lineIntersection(Pt, $t, Mt, Bt);
      Wt === null && (Wt = $t);
      var Gt = lineIntersection(Vt, zt, Mt, Bt);
      return Gt === null && (Gt = Vt), new PolynomialBezier(Pt, Wt, Gt, zt);
    }
    function joinLines(_t, Et, Pt, $t, Mt) {
      var Bt = Et.points[3], Vt = Pt.points[0];
      if ($t === 3 || pointEqual(Bt, Vt))
        return Bt;
      if ($t === 2) {
        var zt = -Et.tangentAngle(1), Ht = -Pt.tangentAngle(0) + Math.PI, Wt = lineIntersection(Bt, polarOffset(Bt, zt + Math.PI / 2, 100), Vt, polarOffset(Vt, zt + Math.PI / 2, 100)), Gt = Wt ? pointDistance(Wt, Bt) : pointDistance(Bt, Vt) / 2, qt = polarOffset(Bt, zt, 2 * Gt * roundCorner);
        return _t.setXYAt(qt[0], qt[1], "o", _t.length() - 1), qt = polarOffset(Vt, Ht, 2 * Gt * roundCorner), _t.setTripleAt(Vt[0], Vt[1], Vt[0], Vt[1], qt[0], qt[1], _t.length()), Vt;
      }
      var Kt = lineIntersection(pointEqual(Bt, Et.points[2]) ? Et.points[0] : Et.points[2], Bt, Vt, pointEqual(Vt, Pt.points[1]) ? Pt.points[3] : Pt.points[1]);
      return Kt && pointDistance(Kt, Bt) < Mt ? (_t.setTripleAt(Kt[0], Kt[1], Kt[0], Kt[1], Kt[0], Kt[1], _t.length()), Kt) : Bt;
    }
    function getIntersection(_t, Et) {
      var Pt = _t.intersections(Et);
      return Pt.length && floatEqual(Pt[0][0], 1) && Pt.shift(), Pt.length ? Pt[0] : null;
    }
    function pruneSegmentIntersection(_t, Et) {
      var Pt = _t.slice(), $t = Et.slice(), Mt = getIntersection(_t[_t.length - 1], Et[0]);
      return Mt && (Pt[_t.length - 1] = _t[_t.length - 1].split(Mt[0])[0], $t[0] = Et[0].split(Mt[1])[1]), _t.length > 1 && Et.length > 1 && (Mt = getIntersection(_t[0], Et[Et.length - 1])) ? [[_t[0].split(Mt[0])[0]], [Et[Et.length - 1].split(Mt[1])[1]]] : [Pt, $t];
    }
    function pruneIntersections(_t) {
      for (var Et, Pt = 1; Pt < _t.length; Pt += 1)
        Et = pruneSegmentIntersection(_t[Pt - 1], _t[Pt]), _t[Pt - 1] = Et[0], _t[Pt] = Et[1];
      return _t.length > 1 && (Et = pruneSegmentIntersection(_t[_t.length - 1], _t[0]), _t[_t.length - 1] = Et[0], _t[0] = Et[1]), _t;
    }
    function offsetSegmentSplit(_t, Et) {
      var Pt, $t, Mt, Bt, Vt = _t.inflectionPoints();
      if (Vt.length === 0)
        return [offsetSegment(_t, Et)];
      if (Vt.length === 1 || floatEqual(Vt[1], 1))
        return Pt = (Mt = _t.split(Vt[0]))[0], $t = Mt[1], [offsetSegment(Pt, Et), offsetSegment($t, Et)];
      Pt = (Mt = _t.split(Vt[0]))[0];
      var zt = (Vt[1] - Vt[0]) / (1 - Vt[0]);
      return Bt = (Mt = Mt[1].split(zt))[0], $t = Mt[1], [offsetSegment(Pt, Et), offsetSegment(Bt, Et), offsetSegment($t, Et)];
    }
    function OffsetPathModifier() {
    }
    function getFontProperties(_t) {
      for (var Et = _t.fStyle ? _t.fStyle.split(" ") : [], Pt = "normal", $t = "normal", Mt = Et.length, Bt = 0; Bt < Mt; Bt += 1)
        switch (Et[Bt].toLowerCase()) {
          case "italic":
            $t = "italic";
            break;
          case "bold":
            Pt = "700";
            break;
          case "black":
            Pt = "900";
            break;
          case "medium":
            Pt = "500";
            break;
          case "regular":
          case "normal":
            Pt = "400";
            break;
          case "light":
          case "thin":
            Pt = "200";
        }
      return { style: $t, weight: _t.fWeight || Pt };
    }
    extendPrototype([ShapeModifier], RepeaterModifier), RepeaterModifier.prototype.initModifierProperties = function(_t, Et) {
      this.getValue = this.processKeys, this.c = PropertyFactory.getProp(_t, Et.c, 0, null, this), this.o = PropertyFactory.getProp(_t, Et.o, 0, null, this), this.tr = TransformPropertyFactory.getTransformProperty(_t, Et.tr, this), this.so = PropertyFactory.getProp(_t, Et.tr.so, 0, 0.01, this), this.eo = PropertyFactory.getProp(_t, Et.tr.eo, 0, 0.01, this), this.data = Et, this.dynamicProperties.length || this.getValue(!0), this._isAnimated = !!this.dynamicProperties.length, this.pMatrix = new Matrix(), this.rMatrix = new Matrix(), this.sMatrix = new Matrix(), this.tMatrix = new Matrix(), this.matrix = new Matrix();
    }, RepeaterModifier.prototype.applyTransforms = function(_t, Et, Pt, $t, Mt, Bt) {
      var Vt = Bt ? -1 : 1, zt = $t.s.v[0] + (1 - $t.s.v[0]) * (1 - Mt), Ht = $t.s.v[1] + (1 - $t.s.v[1]) * (1 - Mt);
      _t.translate($t.p.v[0] * Vt * Mt, $t.p.v[1] * Vt * Mt, $t.p.v[2]), Et.translate(-$t.a.v[0], -$t.a.v[1], $t.a.v[2]), Et.rotate(-$t.r.v * Vt * Mt), Et.translate($t.a.v[0], $t.a.v[1], $t.a.v[2]), Pt.translate(-$t.a.v[0], -$t.a.v[1], $t.a.v[2]), Pt.scale(Bt ? 1 / zt : zt, Bt ? 1 / Ht : Ht), Pt.translate($t.a.v[0], $t.a.v[1], $t.a.v[2]);
    }, RepeaterModifier.prototype.init = function(_t, Et, Pt, $t) {
      for (this.elem = _t, this.arr = Et, this.pos = Pt, this.elemsData = $t, this._currentCopies = 0, this._elements = [], this._groups = [], this.frameId = -1, this.initDynamicPropertyContainer(_t), this.initModifierProperties(_t, Et[Pt]); Pt > 0; )
        Pt -= 1, this._elements.unshift(Et[Pt]);
      this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
    }, RepeaterModifier.prototype.resetElements = function(_t) {
      var Et, Pt = _t.length;
      for (Et = 0; Et < Pt; Et += 1)
        _t[Et]._processed = !1, _t[Et].ty === "gr" && this.resetElements(_t[Et].it);
    }, RepeaterModifier.prototype.cloneElements = function(_t) {
      var Et = JSON.parse(JSON.stringify(_t));
      return this.resetElements(Et), Et;
    }, RepeaterModifier.prototype.changeGroupRender = function(_t, Et) {
      var Pt, $t = _t.length;
      for (Pt = 0; Pt < $t; Pt += 1)
        _t[Pt]._render = Et, _t[Pt].ty === "gr" && this.changeGroupRender(_t[Pt].it, Et);
    }, RepeaterModifier.prototype.processShapes = function(_t) {
      var Et, Pt, $t, Mt, Bt, Vt = !1;
      if (this._mdf || _t) {
        var zt, Ht = Math.ceil(this.c.v);
        if (this._groups.length < Ht) {
          for (; this._groups.length < Ht; ) {
            var Wt = { it: this.cloneElements(this._elements), ty: "gr" };
            Wt.it.push({ a: { a: 0, ix: 1, k: [0, 0] }, nm: "Transform", o: { a: 0, ix: 7, k: 100 }, p: { a: 0, ix: 2, k: [0, 0] }, r: { a: 1, ix: 6, k: [{ s: 0, e: 0, t: 0 }, { s: 0, e: 0, t: 1 }] }, s: { a: 0, ix: 3, k: [100, 100] }, sa: { a: 0, ix: 5, k: 0 }, sk: { a: 0, ix: 4, k: 0 }, ty: "tr" }), this.arr.splice(0, 0, Wt), this._groups.splice(0, 0, Wt), this._currentCopies += 1;
          }
          this.elem.reloadShapes(), Vt = !0;
        }
        for (Bt = 0, $t = 0; $t <= this._groups.length - 1; $t += 1) {
          if (zt = Bt < Ht, this._groups[$t]._render = zt, this.changeGroupRender(this._groups[$t].it, zt), !zt) {
            var Gt = this.elemsData[$t].it, qt = Gt[Gt.length - 1];
            qt.transform.op.v !== 0 ? (qt.transform.op._mdf = !0, qt.transform.op.v = 0) : qt.transform.op._mdf = !1;
          }
          Bt += 1;
        }
        this._currentCopies = Ht;
        var Kt = this.o.v, Qt = Kt % 1, Xt = Kt > 0 ? Math.floor(Kt) : Math.ceil(Kt), Zt = this.pMatrix.props, Yt = this.rMatrix.props, Jt = this.sMatrix.props;
        this.pMatrix.reset(), this.rMatrix.reset(), this.sMatrix.reset(), this.tMatrix.reset(), this.matrix.reset();
        var er, tr, nr = 0;
        if (Kt > 0) {
          for (; nr < Xt; )
            this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), nr += 1;
          Qt && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, Qt, !1), nr += Qt);
        } else if (Kt < 0) {
          for (; nr > Xt; )
            this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !0), nr -= 1;
          Qt && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -Qt, !0), nr -= Qt);
        }
        for ($t = this.data.m === 1 ? 0 : this._currentCopies - 1, Mt = this.data.m === 1 ? 1 : -1, Bt = this._currentCopies; Bt; ) {
          if (tr = (Pt = (Et = this.elemsData[$t].it)[Et.length - 1].transform.mProps.v.props).length, Et[Et.length - 1].transform.mProps._mdf = !0, Et[Et.length - 1].transform.op._mdf = !0, Et[Et.length - 1].transform.op.v = this._currentCopies === 1 ? this.so.v : this.so.v + (this.eo.v - this.so.v) * ($t / (this._currentCopies - 1)), nr !== 0) {
            for (($t !== 0 && Mt === 1 || $t !== this._currentCopies - 1 && Mt === -1) && this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), this.matrix.transform(Yt[0], Yt[1], Yt[2], Yt[3], Yt[4], Yt[5], Yt[6], Yt[7], Yt[8], Yt[9], Yt[10], Yt[11], Yt[12], Yt[13], Yt[14], Yt[15]), this.matrix.transform(Jt[0], Jt[1], Jt[2], Jt[3], Jt[4], Jt[5], Jt[6], Jt[7], Jt[8], Jt[9], Jt[10], Jt[11], Jt[12], Jt[13], Jt[14], Jt[15]), this.matrix.transform(Zt[0], Zt[1], Zt[2], Zt[3], Zt[4], Zt[5], Zt[6], Zt[7], Zt[8], Zt[9], Zt[10], Zt[11], Zt[12], Zt[13], Zt[14], Zt[15]), er = 0; er < tr; er += 1)
              Pt[er] = this.matrix.props[er];
            this.matrix.reset();
          } else
            for (this.matrix.reset(), er = 0; er < tr; er += 1)
              Pt[er] = this.matrix.props[er];
          nr += 1, Bt -= 1, $t += Mt;
        }
      } else
        for (Bt = this._currentCopies, $t = 0, Mt = 1; Bt; )
          Pt = (Et = this.elemsData[$t].it)[Et.length - 1].transform.mProps.v.props, Et[Et.length - 1].transform.mProps._mdf = !1, Et[Et.length - 1].transform.op._mdf = !1, Bt -= 1, $t += Mt;
      return Vt;
    }, RepeaterModifier.prototype.addShape = function() {
    }, extendPrototype([ShapeModifier], RoundCornersModifier), RoundCornersModifier.prototype.initModifierProperties = function(_t, Et) {
      this.getValue = this.processKeys, this.rd = PropertyFactory.getProp(_t, Et.r, 0, null, this), this._isAnimated = !!this.rd.effectsSequence.length;
    }, RoundCornersModifier.prototype.processPath = function(_t, Et) {
      var Pt, $t = shapePool.newElement();
      $t.c = _t.c;
      var Mt, Bt, Vt, zt, Ht, Wt, Gt, qt, Kt, Qt, Xt, Zt, Yt = _t._length, Jt = 0;
      for (Pt = 0; Pt < Yt; Pt += 1)
        Mt = _t.v[Pt], Vt = _t.o[Pt], Bt = _t.i[Pt], Mt[0] === Vt[0] && Mt[1] === Vt[1] && Mt[0] === Bt[0] && Mt[1] === Bt[1] ? Pt !== 0 && Pt !== Yt - 1 || _t.c ? (zt = Pt === 0 ? _t.v[Yt - 1] : _t.v[Pt - 1], Wt = (Ht = Math.sqrt(Math.pow(Mt[0] - zt[0], 2) + Math.pow(Mt[1] - zt[1], 2))) ? Math.min(Ht / 2, Et) / Ht : 0, Gt = Xt = Mt[0] + (zt[0] - Mt[0]) * Wt, qt = Zt = Mt[1] - (Mt[1] - zt[1]) * Wt, Kt = Gt - (Gt - Mt[0]) * roundCorner, Qt = qt - (qt - Mt[1]) * roundCorner, $t.setTripleAt(Gt, qt, Kt, Qt, Xt, Zt, Jt), Jt += 1, zt = Pt === Yt - 1 ? _t.v[0] : _t.v[Pt + 1], Wt = (Ht = Math.sqrt(Math.pow(Mt[0] - zt[0], 2) + Math.pow(Mt[1] - zt[1], 2))) ? Math.min(Ht / 2, Et) / Ht : 0, Gt = Kt = Mt[0] + (zt[0] - Mt[0]) * Wt, qt = Qt = Mt[1] + (zt[1] - Mt[1]) * Wt, Xt = Gt - (Gt - Mt[0]) * roundCorner, Zt = qt - (qt - Mt[1]) * roundCorner, $t.setTripleAt(Gt, qt, Kt, Qt, Xt, Zt, Jt), Jt += 1) : ($t.setTripleAt(Mt[0], Mt[1], Vt[0], Vt[1], Bt[0], Bt[1], Jt), Jt += 1) : ($t.setTripleAt(_t.v[Pt][0], _t.v[Pt][1], _t.o[Pt][0], _t.o[Pt][1], _t.i[Pt][0], _t.i[Pt][1], Jt), Jt += 1);
      return $t;
    }, RoundCornersModifier.prototype.processShapes = function(_t) {
      var Et, Pt, $t, Mt, Bt, Vt, zt = this.shapes.length, Ht = this.rd.v;
      if (Ht !== 0)
        for (Pt = 0; Pt < zt; Pt += 1) {
          if (Vt = (Bt = this.shapes[Pt]).localShapeCollection, Bt.shape._mdf || this._mdf || _t)
            for (Vt.releaseShapes(), Bt.shape._mdf = !0, Et = Bt.shape.paths.shapes, Mt = Bt.shape.paths._length, $t = 0; $t < Mt; $t += 1)
              Vt.addShape(this.processPath(Et[$t], Ht));
          Bt.shape.paths = Bt.localShapeCollection;
        }
      this.dynamicProperties.length || (this._mdf = !1);
    }, PolynomialBezier.prototype.point = function(_t) {
      return [((this.a[0] * _t + this.b[0]) * _t + this.c[0]) * _t + this.d[0], ((this.a[1] * _t + this.b[1]) * _t + this.c[1]) * _t + this.d[1]];
    }, PolynomialBezier.prototype.derivative = function(_t) {
      return [(3 * _t * this.a[0] + 2 * this.b[0]) * _t + this.c[0], (3 * _t * this.a[1] + 2 * this.b[1]) * _t + this.c[1]];
    }, PolynomialBezier.prototype.tangentAngle = function(_t) {
      var Et = this.derivative(_t);
      return Math.atan2(Et[1], Et[0]);
    }, PolynomialBezier.prototype.normalAngle = function(_t) {
      var Et = this.derivative(_t);
      return Math.atan2(Et[0], Et[1]);
    }, PolynomialBezier.prototype.inflectionPoints = function() {
      var _t = this.a[1] * this.b[0] - this.a[0] * this.b[1];
      if (floatZero(_t))
        return [];
      var Et = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / _t, Pt = Et * Et - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / _t;
      if (Pt < 0)
        return [];
      var $t = Math.sqrt(Pt);
      return floatZero($t) ? $t > 0 && $t < 1 ? [Et] : [] : [Et - $t, Et + $t].filter(function(Mt) {
        return Mt > 0 && Mt < 1;
      });
    }, PolynomialBezier.prototype.split = function(_t) {
      if (_t <= 0)
        return [singlePoint(this.points[0]), this];
      if (_t >= 1)
        return [this, singlePoint(this.points[this.points.length - 1])];
      var Et = lerpPoint(this.points[0], this.points[1], _t), Pt = lerpPoint(this.points[1], this.points[2], _t), $t = lerpPoint(this.points[2], this.points[3], _t), Mt = lerpPoint(Et, Pt, _t), Bt = lerpPoint(Pt, $t, _t), Vt = lerpPoint(Mt, Bt, _t);
      return [new PolynomialBezier(this.points[0], Et, Mt, Vt, !0), new PolynomialBezier(Vt, Bt, $t, this.points[3], !0)];
    }, PolynomialBezier.prototype.bounds = function() {
      return { x: extrema(this, 0), y: extrema(this, 1) };
    }, PolynomialBezier.prototype.boundingBox = function() {
      var _t = this.bounds();
      return { left: _t.x.min, right: _t.x.max, top: _t.y.min, bottom: _t.y.max, width: _t.x.max - _t.x.min, height: _t.y.max - _t.y.min, cx: (_t.x.max + _t.x.min) / 2, cy: (_t.y.max + _t.y.min) / 2 };
    }, PolynomialBezier.prototype.intersections = function(_t, Et, Pt) {
      Et === void 0 && (Et = 2), Pt === void 0 && (Pt = 7);
      var $t = [];
      return intersectsImpl(intersectData(this, 0, 1), intersectData(_t, 0, 1), 0, Et, $t, Pt), $t;
    }, PolynomialBezier.shapeSegment = function(_t, Et) {
      var Pt = (Et + 1) % _t.length();
      return new PolynomialBezier(_t.v[Et], _t.o[Et], _t.i[Pt], _t.v[Pt], !0);
    }, PolynomialBezier.shapeSegmentInverted = function(_t, Et) {
      var Pt = (Et + 1) % _t.length();
      return new PolynomialBezier(_t.v[Pt], _t.i[Pt], _t.o[Et], _t.v[Et], !0);
    }, extendPrototype([ShapeModifier], ZigZagModifier), ZigZagModifier.prototype.initModifierProperties = function(_t, Et) {
      this.getValue = this.processKeys, this.amplitude = PropertyFactory.getProp(_t, Et.s, 0, null, this), this.frequency = PropertyFactory.getProp(_t, Et.r, 0, null, this), this.pointsType = PropertyFactory.getProp(_t, Et.pt, 0, null, this), this._isAnimated = this.amplitude.effectsSequence.length !== 0 || this.frequency.effectsSequence.length !== 0 || this.pointsType.effectsSequence.length !== 0;
    }, ZigZagModifier.prototype.processPath = function(_t, Et, Pt, $t) {
      var Mt = _t._length, Bt = shapePool.newElement();
      if (Bt.c = _t.c, _t.c || (Mt -= 1), Mt === 0)
        return Bt;
      var Vt = -1, zt = PolynomialBezier.shapeSegment(_t, 0);
      zigZagCorner(Bt, _t, 0, Et, Pt, $t, Vt);
      for (var Ht = 0; Ht < Mt; Ht += 1)
        Vt = zigZagSegment(Bt, zt, Et, Pt, $t, -Vt), zt = Ht !== Mt - 1 || _t.c ? PolynomialBezier.shapeSegment(_t, (Ht + 1) % Mt) : null, zigZagCorner(Bt, _t, Ht + 1, Et, Pt, $t, Vt);
      return Bt;
    }, ZigZagModifier.prototype.processShapes = function(_t) {
      var Et, Pt, $t, Mt, Bt, Vt, zt = this.shapes.length, Ht = this.amplitude.v, Wt = Math.max(0, Math.round(this.frequency.v)), Gt = this.pointsType.v;
      if (Ht !== 0)
        for (Pt = 0; Pt < zt; Pt += 1) {
          if (Vt = (Bt = this.shapes[Pt]).localShapeCollection, Bt.shape._mdf || this._mdf || _t)
            for (Vt.releaseShapes(), Bt.shape._mdf = !0, Et = Bt.shape.paths.shapes, Mt = Bt.shape.paths._length, $t = 0; $t < Mt; $t += 1)
              Vt.addShape(this.processPath(Et[$t], Ht, Wt, Gt));
          Bt.shape.paths = Bt.localShapeCollection;
        }
      this.dynamicProperties.length || (this._mdf = !1);
    }, extendPrototype([ShapeModifier], OffsetPathModifier), OffsetPathModifier.prototype.initModifierProperties = function(_t, Et) {
      this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(_t, Et.a, 0, null, this), this.miterLimit = PropertyFactory.getProp(_t, Et.ml, 0, null, this), this.lineJoin = Et.lj, this._isAnimated = this.amount.effectsSequence.length !== 0;
    }, OffsetPathModifier.prototype.processPath = function(_t, Et, Pt, $t) {
      var Mt = shapePool.newElement();
      Mt.c = _t.c;
      var Bt, Vt, zt, Ht = _t.length();
      _t.c || (Ht -= 1);
      var Wt = [];
      for (Bt = 0; Bt < Ht; Bt += 1)
        zt = PolynomialBezier.shapeSegment(_t, Bt), Wt.push(offsetSegmentSplit(zt, Et));
      if (!_t.c)
        for (Bt = Ht - 1; Bt >= 0; Bt -= 1)
          zt = PolynomialBezier.shapeSegmentInverted(_t, Bt), Wt.push(offsetSegmentSplit(zt, Et));
      Wt = pruneIntersections(Wt);
      var Gt = null, qt = null;
      for (Bt = 0; Bt < Wt.length; Bt += 1) {
        var Kt = Wt[Bt];
        for (qt && (Gt = joinLines(Mt, qt, Kt[0], Pt, $t)), qt = Kt[Kt.length - 1], Vt = 0; Vt < Kt.length; Vt += 1)
          zt = Kt[Vt], Gt && pointEqual(zt.points[0], Gt) ? Mt.setXYAt(zt.points[1][0], zt.points[1][1], "o", Mt.length() - 1) : Mt.setTripleAt(zt.points[0][0], zt.points[0][1], zt.points[1][0], zt.points[1][1], zt.points[0][0], zt.points[0][1], Mt.length()), Mt.setTripleAt(zt.points[3][0], zt.points[3][1], zt.points[3][0], zt.points[3][1], zt.points[2][0], zt.points[2][1], Mt.length()), Gt = zt.points[3];
      }
      return Wt.length && joinLines(Mt, qt, Wt[0][0], Pt, $t), Mt;
    }, OffsetPathModifier.prototype.processShapes = function(_t) {
      var Et, Pt, $t, Mt, Bt, Vt, zt = this.shapes.length, Ht = this.amount.v, Wt = this.miterLimit.v, Gt = this.lineJoin;
      if (Ht !== 0)
        for (Pt = 0; Pt < zt; Pt += 1) {
          if (Vt = (Bt = this.shapes[Pt]).localShapeCollection, Bt.shape._mdf || this._mdf || _t)
            for (Vt.releaseShapes(), Bt.shape._mdf = !0, Et = Bt.shape.paths.shapes, Mt = Bt.shape.paths._length, $t = 0; $t < Mt; $t += 1)
              Vt.addShape(this.processPath(Et[$t], Ht, Gt, Wt));
          Bt.shape.paths = Bt.localShapeCollection;
        }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    var FontManager = function() {
      var _t = { w: 0, size: 0, shapes: [], data: { shapes: [] } }, Et = [];
      Et = Et.concat([2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366, 2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379, 2380, 2381, 2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403]);
      var Pt = ["d83cdffb", "d83cdffc", "d83cdffd", "d83cdffe", "d83cdfff"];
      function $t(Ht, Wt) {
        var Gt = createTag("span");
        Gt.setAttribute("aria-hidden", !0), Gt.style.fontFamily = Wt;
        var qt = createTag("span");
        qt.innerText = "giItT1WQy@!-/#", Gt.style.position = "absolute", Gt.style.left = "-10000px", Gt.style.top = "-10000px", Gt.style.fontSize = "300px", Gt.style.fontVariant = "normal", Gt.style.fontStyle = "normal", Gt.style.fontWeight = "normal", Gt.style.letterSpacing = "0", Gt.appendChild(qt), document.body.appendChild(Gt);
        var Kt = qt.offsetWidth;
        return qt.style.fontFamily = function(Qt) {
          var Xt, Zt = Qt.split(","), Yt = Zt.length, Jt = [];
          for (Xt = 0; Xt < Yt; Xt += 1)
            Zt[Xt] !== "sans-serif" && Zt[Xt] !== "monospace" && Jt.push(Zt[Xt]);
          return Jt.join(",");
        }(Ht) + ", " + Wt, { node: qt, w: Kt, parent: Gt };
      }
      function Mt(Ht, Wt) {
        var Gt, qt = document.body && Wt ? "svg" : "canvas", Kt = getFontProperties(Ht);
        if (qt === "svg") {
          var Qt = createNS("text");
          Qt.style.fontSize = "100px", Qt.setAttribute("font-family", Ht.fFamily), Qt.setAttribute("font-style", Kt.style), Qt.setAttribute("font-weight", Kt.weight), Qt.textContent = "1", Ht.fClass ? (Qt.style.fontFamily = "inherit", Qt.setAttribute("class", Ht.fClass)) : Qt.style.fontFamily = Ht.fFamily, Wt.appendChild(Qt), Gt = Qt;
        } else {
          var Xt = new OffscreenCanvas(500, 500).getContext("2d");
          Xt.font = Kt.style + " " + Kt.weight + " 100px " + Ht.fFamily, Gt = Xt;
        }
        return { measureText: function(Zt) {
          return qt === "svg" ? (Gt.textContent = Zt, Gt.getComputedTextLength()) : Gt.measureText(Zt).width;
        } };
      }
      function Bt(Ht) {
        var Wt = 0, Gt = Ht.charCodeAt(0);
        if (Gt >= 55296 && Gt <= 56319) {
          var qt = Ht.charCodeAt(1);
          qt >= 56320 && qt <= 57343 && (Wt = 1024 * (Gt - 55296) + qt - 56320 + 65536);
        }
        return Wt;
      }
      function Vt(Ht) {
        var Wt = Bt(Ht);
        return Wt >= 127462 && Wt <= 127487;
      }
      var zt = function() {
        this.fonts = [], this.chars = null, this.typekitLoaded = 0, this.isLoaded = !1, this._warned = !1, this.initTime = Date.now(), this.setIsLoadedBinded = this.setIsLoaded.bind(this), this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
      };
      return zt.isModifier = function(Ht, Wt) {
        var Gt = Ht.toString(16) + Wt.toString(16);
        return Pt.indexOf(Gt) !== -1;
      }, zt.isZeroWidthJoiner = function(Ht) {
        return Ht === 8205;
      }, zt.isFlagEmoji = function(Ht) {
        return Vt(Ht.substr(0, 2)) && Vt(Ht.substr(2, 2));
      }, zt.isRegionalCode = Vt, zt.isCombinedCharacter = function(Ht) {
        return Et.indexOf(Ht) !== -1;
      }, zt.isRegionalFlag = function(Ht, Wt) {
        var Gt = Bt(Ht.substr(Wt, 2));
        if (Gt !== 127988)
          return !1;
        var qt = 0;
        for (Wt += 2; qt < 5; ) {
          if ((Gt = Bt(Ht.substr(Wt, 2))) < 917601 || Gt > 917626)
            return !1;
          qt += 1, Wt += 2;
        }
        return Bt(Ht.substr(Wt, 2)) === 917631;
      }, zt.isVariationSelector = function(Ht) {
        return Ht === 65039;
      }, zt.BLACK_FLAG_CODE_POINT = 127988, zt.prototype = { addChars: function(Ht) {
        if (Ht) {
          var Wt;
          this.chars || (this.chars = []);
          var Gt, qt, Kt = Ht.length, Qt = this.chars.length;
          for (Wt = 0; Wt < Kt; Wt += 1) {
            for (Gt = 0, qt = !1; Gt < Qt; )
              this.chars[Gt].style === Ht[Wt].style && this.chars[Gt].fFamily === Ht[Wt].fFamily && this.chars[Gt].ch === Ht[Wt].ch && (qt = !0), Gt += 1;
            qt || (this.chars.push(Ht[Wt]), Qt += 1);
          }
        }
      }, addFonts: function(Ht, Wt) {
        if (Ht) {
          if (this.chars)
            return this.isLoaded = !0, void (this.fonts = Ht.list);
          if (!document.body)
            return this.isLoaded = !0, Ht.list.forEach(function(nr) {
              nr.helper = Mt(nr), nr.cache = {};
            }), void (this.fonts = Ht.list);
          var Gt, qt = Ht.list, Kt = qt.length, Qt = Kt;
          for (Gt = 0; Gt < Kt; Gt += 1) {
            var Xt, Zt, Yt = !0;
            if (qt[Gt].loaded = !1, qt[Gt].monoCase = $t(qt[Gt].fFamily, "monospace"), qt[Gt].sansCase = $t(qt[Gt].fFamily, "sans-serif"), qt[Gt].fPath) {
              if (qt[Gt].fOrigin === "p" || qt[Gt].origin === 3) {
                if ((Xt = document.querySelectorAll('style[f-forigin="p"][f-family="' + qt[Gt].fFamily + '"], style[f-origin="3"][f-family="' + qt[Gt].fFamily + '"]')).length > 0 && (Yt = !1), Yt) {
                  var Jt = createTag("style");
                  Jt.setAttribute("f-forigin", qt[Gt].fOrigin), Jt.setAttribute("f-origin", qt[Gt].origin), Jt.setAttribute("f-family", qt[Gt].fFamily), Jt.type = "text/css", Jt.innerText = "@font-face {font-family: " + qt[Gt].fFamily + "; font-style: normal; src: url('" + qt[Gt].fPath + "');}", Wt.appendChild(Jt);
                }
              } else if (qt[Gt].fOrigin === "g" || qt[Gt].origin === 1) {
                for (Xt = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]'), Zt = 0; Zt < Xt.length; Zt += 1)
                  Xt[Zt].href.indexOf(qt[Gt].fPath) !== -1 && (Yt = !1);
                if (Yt) {
                  var er = createTag("link");
                  er.setAttribute("f-forigin", qt[Gt].fOrigin), er.setAttribute("f-origin", qt[Gt].origin), er.type = "text/css", er.rel = "stylesheet", er.href = qt[Gt].fPath, document.body.appendChild(er);
                }
              } else if (qt[Gt].fOrigin === "t" || qt[Gt].origin === 2) {
                for (Xt = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]'), Zt = 0; Zt < Xt.length; Zt += 1)
                  qt[Gt].fPath === Xt[Zt].src && (Yt = !1);
                if (Yt) {
                  var tr = createTag("link");
                  tr.setAttribute("f-forigin", qt[Gt].fOrigin), tr.setAttribute("f-origin", qt[Gt].origin), tr.setAttribute("rel", "stylesheet"), tr.setAttribute("href", qt[Gt].fPath), Wt.appendChild(tr);
                }
              }
            } else
              qt[Gt].loaded = !0, Qt -= 1;
            qt[Gt].helper = Mt(qt[Gt], Wt), qt[Gt].cache = {}, this.fonts.push(qt[Gt]);
          }
          Qt === 0 ? this.isLoaded = !0 : setTimeout(this.checkLoadedFonts.bind(this), 100);
        } else
          this.isLoaded = !0;
      }, getCharData: function(Ht, Wt, Gt) {
        for (var qt = 0, Kt = this.chars.length; qt < Kt; ) {
          if (this.chars[qt].ch === Ht && this.chars[qt].style === Wt && this.chars[qt].fFamily === Gt)
            return this.chars[qt];
          qt += 1;
        }
        return (typeof Ht == "string" && Ht.charCodeAt(0) !== 13 || !Ht) && console && console.warn && !this._warned && (this._warned = !0), _t;
      }, getFontByName: function(Ht) {
        for (var Wt = 0, Gt = this.fonts.length; Wt < Gt; ) {
          if (this.fonts[Wt].fName === Ht)
            return this.fonts[Wt];
          Wt += 1;
        }
        return this.fonts[0];
      }, measureText: function(Ht, Wt, Gt) {
        var qt = this.getFontByName(Wt), Kt = Ht;
        if (!qt.cache[Kt]) {
          var Qt = qt.helper;
          if (Ht === " ") {
            var Xt = Qt.measureText("|" + Ht + "|"), Zt = Qt.measureText("||");
            qt.cache[Kt] = (Xt - Zt) / 100;
          } else
            qt.cache[Kt] = Qt.measureText(Ht) / 100;
        }
        return qt.cache[Kt] * Gt;
      }, checkLoadedFonts: function() {
        var Ht, Wt, Gt, qt = this.fonts.length, Kt = qt;
        for (Ht = 0; Ht < qt; Ht += 1)
          this.fonts[Ht].loaded ? Kt -= 1 : this.fonts[Ht].fOrigin === "n" || this.fonts[Ht].origin === 0 ? this.fonts[Ht].loaded = !0 : (Wt = this.fonts[Ht].monoCase.node, Gt = this.fonts[Ht].monoCase.w, Wt.offsetWidth !== Gt ? (Kt -= 1, this.fonts[Ht].loaded = !0) : (Wt = this.fonts[Ht].sansCase.node, Gt = this.fonts[Ht].sansCase.w, Wt.offsetWidth !== Gt && (Kt -= 1, this.fonts[Ht].loaded = !0)), this.fonts[Ht].loaded && (this.fonts[Ht].sansCase.parent.parentNode.removeChild(this.fonts[Ht].sansCase.parent), this.fonts[Ht].monoCase.parent.parentNode.removeChild(this.fonts[Ht].monoCase.parent)));
        Kt !== 0 && Date.now() - this.initTime < 5e3 ? setTimeout(this.checkLoadedFontsBinded, 20) : setTimeout(this.setIsLoadedBinded, 10);
      }, setIsLoaded: function() {
        this.isLoaded = !0;
      } }, zt;
    }();
    function SlotManager(_t) {
      this.animationData = _t;
    }
    function slotFactory(_t) {
      return new SlotManager(_t);
    }
    function RenderableElement() {
    }
    SlotManager.prototype.getProp = function(_t) {
      return this.animationData.slots && this.animationData.slots[_t.sid] ? Object.assign(_t, this.animationData.slots[_t.sid].p) : _t;
    }, RenderableElement.prototype = { initRenderable: function() {
      this.isInRange = !1, this.hidden = !1, this.isTransparent = !1, this.renderableComponents = [];
    }, addRenderableComponent: function(_t) {
      this.renderableComponents.indexOf(_t) === -1 && this.renderableComponents.push(_t);
    }, removeRenderableComponent: function(_t) {
      this.renderableComponents.indexOf(_t) !== -1 && this.renderableComponents.splice(this.renderableComponents.indexOf(_t), 1);
    }, prepareRenderableFrame: function(_t) {
      this.checkLayerLimits(_t);
    }, checkTransparency: function() {
      this.finalTransform.mProp.o.v <= 0 ? !this.isTransparent && this.globalData.renderConfig.hideOnTransparent && (this.isTransparent = !0, this.hide()) : this.isTransparent && (this.isTransparent = !1, this.show());
    }, checkLayerLimits: function(_t) {
      this.data.ip - this.data.st <= _t && this.data.op - this.data.st > _t ? this.isInRange !== !0 && (this.globalData._mdf = !0, this._mdf = !0, this.isInRange = !0, this.show()) : this.isInRange !== !1 && (this.globalData._mdf = !0, this.isInRange = !1, this.hide());
    }, renderRenderable: function() {
      var _t, Et = this.renderableComponents.length;
      for (_t = 0; _t < Et; _t += 1)
        this.renderableComponents[_t].renderFrame(this._isFirstFrame);
    }, sourceRectAtTime: function() {
      return { top: 0, left: 0, width: 100, height: 100 };
    }, getLayerSize: function() {
      return this.data.ty === 5 ? { w: this.data.textData.width, h: this.data.textData.height } : { w: this.data.width, h: this.data.height };
    } };
    var getBlendMode = (blendModeEnums = { 0: "source-over", 1: "multiply", 2: "screen", 3: "overlay", 4: "darken", 5: "lighten", 6: "color-dodge", 7: "color-burn", 8: "hard-light", 9: "soft-light", 10: "difference", 11: "exclusion", 12: "hue", 13: "saturation", 14: "color", 15: "luminosity" }, function(_t) {
      return blendModeEnums[_t] || "";
    }), blendModeEnums;
    function SliderEffect(_t, Et, Pt) {
      this.p = PropertyFactory.getProp(Et, _t.v, 0, 0, Pt);
    }
    function AngleEffect(_t, Et, Pt) {
      this.p = PropertyFactory.getProp(Et, _t.v, 0, 0, Pt);
    }
    function ColorEffect(_t, Et, Pt) {
      this.p = PropertyFactory.getProp(Et, _t.v, 1, 0, Pt);
    }
    function PointEffect(_t, Et, Pt) {
      this.p = PropertyFactory.getProp(Et, _t.v, 1, 0, Pt);
    }
    function LayerIndexEffect(_t, Et, Pt) {
      this.p = PropertyFactory.getProp(Et, _t.v, 0, 0, Pt);
    }
    function MaskIndexEffect(_t, Et, Pt) {
      this.p = PropertyFactory.getProp(Et, _t.v, 0, 0, Pt);
    }
    function CheckboxEffect(_t, Et, Pt) {
      this.p = PropertyFactory.getProp(Et, _t.v, 0, 0, Pt);
    }
    function NoValueEffect() {
      this.p = {};
    }
    function EffectsManager(_t, Et) {
      var Pt, $t = _t.ef || [];
      this.effectElements = [];
      var Mt, Bt = $t.length;
      for (Pt = 0; Pt < Bt; Pt += 1)
        Mt = new GroupEffect($t[Pt], Et), this.effectElements.push(Mt);
    }
    function GroupEffect(_t, Et) {
      this.init(_t, Et);
    }
    function BaseElement() {
    }
    function FrameElement() {
    }
    function FootageElement(_t, Et, Pt) {
      this.initFrame(), this.initRenderable(), this.assetData = Et.getAssetData(_t.refId), this.footageData = Et.imageLoader.getAsset(this.assetData), this.initBaseData(_t, Et, Pt);
    }
    function AudioElement(_t, Et, Pt) {
      this.initFrame(), this.initRenderable(), this.assetData = Et.getAssetData(_t.refId), this.initBaseData(_t, Et, Pt), this._isPlaying = !1, this._canPlay = !1;
      var $t = this.globalData.getAssetsPath(this.assetData);
      this.audio = this.globalData.audioController.createAudio($t), this._currentTime = 0, this.globalData.audioController.addAudio(this), this._volumeMultiplier = 1, this._volume = 1, this._previousVolume = null, this.tm = _t.tm ? PropertyFactory.getProp(this, _t.tm, 0, Et.frameRate, this) : { _placeholder: !0 }, this.lv = PropertyFactory.getProp(this, _t.au && _t.au.lv ? _t.au.lv : { k: [100] }, 1, 0.01, this);
    }
    function BaseRenderer() {
    }
    extendPrototype([DynamicPropertyContainer], GroupEffect), GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties, GroupEffect.prototype.init = function(_t, Et) {
      var Pt;
      this.data = _t, this.effectElements = [], this.initDynamicPropertyContainer(Et);
      var $t, Mt = this.data.ef.length, Bt = this.data.ef;
      for (Pt = 0; Pt < Mt; Pt += 1) {
        switch ($t = null, Bt[Pt].ty) {
          case 0:
            $t = new SliderEffect(Bt[Pt], Et, this);
            break;
          case 1:
            $t = new AngleEffect(Bt[Pt], Et, this);
            break;
          case 2:
            $t = new ColorEffect(Bt[Pt], Et, this);
            break;
          case 3:
            $t = new PointEffect(Bt[Pt], Et, this);
            break;
          case 4:
          case 7:
            $t = new CheckboxEffect(Bt[Pt], Et, this);
            break;
          case 10:
            $t = new LayerIndexEffect(Bt[Pt], Et, this);
            break;
          case 11:
            $t = new MaskIndexEffect(Bt[Pt], Et, this);
            break;
          case 5:
            $t = new EffectsManager(Bt[Pt], Et);
            break;
          default:
            $t = new NoValueEffect(Bt[Pt]);
        }
        $t && this.effectElements.push($t);
      }
    }, BaseElement.prototype = { checkMasks: function() {
      if (!this.data.hasMask)
        return !1;
      for (var _t = 0, Et = this.data.masksProperties.length; _t < Et; ) {
        if (this.data.masksProperties[_t].mode !== "n" && this.data.masksProperties[_t].cl !== !1)
          return !0;
        _t += 1;
      }
      return !1;
    }, initExpressions: function() {
      var _t = getExpressionInterfaces();
      if (_t) {
        var Et = _t("layer"), Pt = _t("effects"), $t = _t("shape"), Mt = _t("text"), Bt = _t("comp");
        this.layerInterface = Et(this), this.data.hasMask && this.maskManager && this.layerInterface.registerMaskInterface(this.maskManager);
        var Vt = Pt.createEffectsInterface(this, this.layerInterface);
        this.layerInterface.registerEffectsInterface(Vt), this.data.ty === 0 || this.data.xt ? this.compInterface = Bt(this) : this.data.ty === 4 ? (this.layerInterface.shapeInterface = $t(this.shapesData, this.itemsData, this.layerInterface), this.layerInterface.content = this.layerInterface.shapeInterface) : this.data.ty === 5 && (this.layerInterface.textInterface = Mt(this), this.layerInterface.text = this.layerInterface.textInterface);
      }
    }, setBlendMode: function() {
      var _t = getBlendMode(this.data.bm);
      (this.baseElement || this.layerElement).style["mix-blend-mode"] = _t;
    }, initBaseData: function(_t, Et, Pt) {
      this.globalData = Et, this.comp = Pt, this.data = _t, this.layerId = createElementID(), this.data.sr || (this.data.sr = 1), this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
    }, getType: function() {
      return this.type;
    }, sourceRectAtTime: function() {
    } }, FrameElement.prototype = { initFrame: function() {
      this._isFirstFrame = !1, this.dynamicProperties = [], this._mdf = !1;
    }, prepareProperties: function(_t, Et) {
      var Pt, $t = this.dynamicProperties.length;
      for (Pt = 0; Pt < $t; Pt += 1)
        (Et || this._isParent && this.dynamicProperties[Pt].propType === "transform") && (this.dynamicProperties[Pt].getValue(), this.dynamicProperties[Pt]._mdf && (this.globalData._mdf = !0, this._mdf = !0));
    }, addDynamicProperty: function(_t) {
      this.dynamicProperties.indexOf(_t) === -1 && this.dynamicProperties.push(_t);
    } }, FootageElement.prototype.prepareFrame = function() {
    }, extendPrototype([RenderableElement, BaseElement, FrameElement], FootageElement), FootageElement.prototype.getBaseElement = function() {
      return null;
    }, FootageElement.prototype.renderFrame = function() {
    }, FootageElement.prototype.destroy = function() {
    }, FootageElement.prototype.initExpressions = function() {
      var _t = getExpressionInterfaces();
      if (_t) {
        var Et = _t("footage");
        this.layerInterface = Et(this);
      }
    }, FootageElement.prototype.getFootageData = function() {
      return this.footageData;
    }, AudioElement.prototype.prepareFrame = function(_t) {
      if (this.prepareRenderableFrame(_t, !0), this.prepareProperties(_t, !0), this.tm._placeholder)
        this._currentTime = _t / this.data.sr;
      else {
        var Et = this.tm.v;
        this._currentTime = Et;
      }
      this._volume = this.lv.v[0];
      var Pt = this._volume * this._volumeMultiplier;
      this._previousVolume !== Pt && (this._previousVolume = Pt, this.audio.volume(Pt));
    }, extendPrototype([RenderableElement, BaseElement, FrameElement], AudioElement), AudioElement.prototype.renderFrame = function() {
      this.isInRange && this._canPlay && (this._isPlaying ? (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1) && this.audio.seek(this._currentTime / this.globalData.frameRate) : (this.audio.play(), this.audio.seek(this._currentTime / this.globalData.frameRate), this._isPlaying = !0));
    }, AudioElement.prototype.show = function() {
    }, AudioElement.prototype.hide = function() {
      this.audio.pause(), this._isPlaying = !1;
    }, AudioElement.prototype.pause = function() {
      this.audio.pause(), this._isPlaying = !1, this._canPlay = !1;
    }, AudioElement.prototype.resume = function() {
      this._canPlay = !0;
    }, AudioElement.prototype.setRate = function(_t) {
      this.audio.rate(_t);
    }, AudioElement.prototype.volume = function(_t) {
      this._volumeMultiplier = _t, this._previousVolume = _t * this._volume, this.audio.volume(this._previousVolume);
    }, AudioElement.prototype.getBaseElement = function() {
      return null;
    }, AudioElement.prototype.destroy = function() {
    }, AudioElement.prototype.sourceRectAtTime = function() {
    }, AudioElement.prototype.initExpressions = function() {
    }, BaseRenderer.prototype.checkLayers = function(_t) {
      var Et, Pt, $t = this.layers.length;
      for (this.completeLayers = !0, Et = $t - 1; Et >= 0; Et -= 1)
        this.elements[Et] || (Pt = this.layers[Et]).ip - Pt.st <= _t - this.layers[Et].st && Pt.op - Pt.st > _t - this.layers[Et].st && this.buildItem(Et), this.completeLayers = !!this.elements[Et] && this.completeLayers;
      this.checkPendingElements();
    }, BaseRenderer.prototype.createItem = function(_t) {
      switch (_t.ty) {
        case 2:
          return this.createImage(_t);
        case 0:
          return this.createComp(_t);
        case 1:
          return this.createSolid(_t);
        case 3:
          return this.createNull(_t);
        case 4:
          return this.createShape(_t);
        case 5:
          return this.createText(_t);
        case 6:
          return this.createAudio(_t);
        case 13:
          return this.createCamera(_t);
        case 15:
          return this.createFootage(_t);
        default:
          return this.createNull(_t);
      }
    }, BaseRenderer.prototype.createCamera = function() {
      throw new Error("You're using a 3d camera. Try the html renderer.");
    }, BaseRenderer.prototype.createAudio = function(_t) {
      return new AudioElement(_t, this.globalData, this);
    }, BaseRenderer.prototype.createFootage = function(_t) {
      return new FootageElement(_t, this.globalData, this);
    }, BaseRenderer.prototype.buildAllItems = function() {
      var _t, Et = this.layers.length;
      for (_t = 0; _t < Et; _t += 1)
        this.buildItem(_t);
      this.checkPendingElements();
    }, BaseRenderer.prototype.includeLayers = function(_t) {
      var Et;
      this.completeLayers = !1;
      var Pt, $t = _t.length, Mt = this.layers.length;
      for (Et = 0; Et < $t; Et += 1)
        for (Pt = 0; Pt < Mt; ) {
          if (this.layers[Pt].id === _t[Et].id) {
            this.layers[Pt] = _t[Et];
            break;
          }
          Pt += 1;
        }
    }, BaseRenderer.prototype.setProjectInterface = function(_t) {
      this.globalData.projectInterface = _t;
    }, BaseRenderer.prototype.initItems = function() {
      this.globalData.progressiveLoad || this.buildAllItems();
    }, BaseRenderer.prototype.buildElementParenting = function(_t, Et, Pt) {
      for (var $t = this.elements, Mt = this.layers, Bt = 0, Vt = Mt.length; Bt < Vt; )
        Mt[Bt].ind == Et && ($t[Bt] && $t[Bt] !== !0 ? (Pt.push($t[Bt]), $t[Bt].setAsParent(), Mt[Bt].parent !== void 0 ? this.buildElementParenting(_t, Mt[Bt].parent, Pt) : _t.setHierarchy(Pt)) : (this.buildItem(Bt), this.addPendingElement(_t))), Bt += 1;
    }, BaseRenderer.prototype.addPendingElement = function(_t) {
      this.pendingElements.push(_t);
    }, BaseRenderer.prototype.searchExtraCompositions = function(_t) {
      var Et, Pt = _t.length;
      for (Et = 0; Et < Pt; Et += 1)
        if (_t[Et].xt) {
          var $t = this.createComp(_t[Et]);
          $t.initExpressions(), this.globalData.projectInterface.registerComposition($t);
        }
    }, BaseRenderer.prototype.getElementById = function(_t) {
      var Et, Pt = this.elements.length;
      for (Et = 0; Et < Pt; Et += 1)
        if (this.elements[Et].data.ind === _t)
          return this.elements[Et];
      return null;
    }, BaseRenderer.prototype.getElementByPath = function(_t) {
      var Et, Pt = _t.shift();
      if (typeof Pt == "number")
        Et = this.elements[Pt];
      else {
        var $t, Mt = this.elements.length;
        for ($t = 0; $t < Mt; $t += 1)
          if (this.elements[$t].data.nm === Pt) {
            Et = this.elements[$t];
            break;
          }
      }
      return _t.length === 0 ? Et : Et.getElementByPath(_t);
    }, BaseRenderer.prototype.setupGlobalData = function(_t, Et) {
      this.globalData.fontManager = new FontManager(), this.globalData.slotManager = slotFactory(_t), this.globalData.fontManager.addChars(_t.chars), this.globalData.fontManager.addFonts(_t.fonts, Et), this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem), this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem), this.globalData.imageLoader = this.animationItem.imagePreloader, this.globalData.audioController = this.animationItem.audioController, this.globalData.frameId = 0, this.globalData.frameRate = _t.fr, this.globalData.nm = _t.nm, this.globalData.compSize = { w: _t.w, h: _t.h };
    };
    var effectTypes = { TRANSFORM_EFFECT: "transformEFfect" };
    function TransformElement() {
    }
    function MaskElement(_t, Et, Pt) {
      this.data = _t, this.element = Et, this.globalData = Pt, this.storedData = [], this.masksProperties = this.data.masksProperties || [], this.maskElement = null;
      var $t, Mt, Bt = this.globalData.defs, Vt = this.masksProperties ? this.masksProperties.length : 0;
      this.viewData = createSizedArray(Vt), this.solidPath = "";
      var zt, Ht, Wt, Gt, qt, Kt, Qt = this.masksProperties, Xt = 0, Zt = [], Yt = createElementID(), Jt = "clipPath", er = "clip-path";
      for ($t = 0; $t < Vt; $t += 1)
        if ((Qt[$t].mode !== "a" && Qt[$t].mode !== "n" || Qt[$t].inv || Qt[$t].o.k !== 100 || Qt[$t].o.x) && (Jt = "mask", er = "mask"), Qt[$t].mode !== "s" && Qt[$t].mode !== "i" || Xt !== 0 ? Wt = null : ((Wt = createNS("rect")).setAttribute("fill", "#ffffff"), Wt.setAttribute("width", this.element.comp.data.w || 0), Wt.setAttribute("height", this.element.comp.data.h || 0), Zt.push(Wt)), Mt = createNS("path"), Qt[$t].mode === "n")
          this.viewData[$t] = { op: PropertyFactory.getProp(this.element, Qt[$t].o, 0, 0.01, this.element), prop: ShapePropertyFactory.getShapeProp(this.element, Qt[$t], 3), elem: Mt, lastPath: "" }, Bt.appendChild(Mt);
        else {
          var tr;
          if (Xt += 1, Mt.setAttribute("fill", Qt[$t].mode === "s" ? "#000000" : "#ffffff"), Mt.setAttribute("clip-rule", "nonzero"), Qt[$t].x.k !== 0 ? (Jt = "mask", er = "mask", Kt = PropertyFactory.getProp(this.element, Qt[$t].x, 0, null, this.element), tr = createElementID(), (Gt = createNS("filter")).setAttribute("id", tr), (qt = createNS("feMorphology")).setAttribute("operator", "erode"), qt.setAttribute("in", "SourceGraphic"), qt.setAttribute("radius", "0"), Gt.appendChild(qt), Bt.appendChild(Gt), Mt.setAttribute("stroke", Qt[$t].mode === "s" ? "#000000" : "#ffffff")) : (qt = null, Kt = null), this.storedData[$t] = { elem: Mt, x: Kt, expan: qt, lastPath: "", lastOperator: "", filterId: tr, lastRadius: 0 }, Qt[$t].mode === "i") {
            Ht = Zt.length;
            var nr = createNS("g");
            for (zt = 0; zt < Ht; zt += 1)
              nr.appendChild(Zt[zt]);
            var rr = createNS("mask");
            rr.setAttribute("mask-type", "alpha"), rr.setAttribute("id", Yt + "_" + Xt), rr.appendChild(Mt), Bt.appendChild(rr), nr.setAttribute("mask", "url(" + getLocationHref() + "#" + Yt + "_" + Xt + ")"), Zt.length = 0, Zt.push(nr);
          } else
            Zt.push(Mt);
          Qt[$t].inv && !this.solidPath && (this.solidPath = this.createLayerSolidPath()), this.viewData[$t] = { elem: Mt, lastPath: "", op: PropertyFactory.getProp(this.element, Qt[$t].o, 0, 0.01, this.element), prop: ShapePropertyFactory.getShapeProp(this.element, Qt[$t], 3), invRect: Wt }, this.viewData[$t].prop.k || this.drawPath(Qt[$t], this.viewData[$t].prop.v, this.viewData[$t]);
        }
      for (this.maskElement = createNS(Jt), Vt = Zt.length, $t = 0; $t < Vt; $t += 1)
        this.maskElement.appendChild(Zt[$t]);
      Xt > 0 && (this.maskElement.setAttribute("id", Yt), this.element.maskedElement.setAttribute(er, "url(" + getLocationHref() + "#" + Yt + ")"), Bt.appendChild(this.maskElement)), this.viewData.length && this.element.addRenderableComponent(this);
    }
    TransformElement.prototype = { initTransform: function() {
      var _t = new Matrix();
      this.finalTransform = { mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : { o: 0 }, _matMdf: !1, _localMatMdf: !1, _opMdf: !1, mat: _t, localMat: _t, localOpacity: 1 }, this.data.ao && (this.finalTransform.mProp.autoOriented = !0), this.data.ty;
    }, renderTransform: function() {
      if (this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame, this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame, this.hierarchy) {
        var _t, Et = this.finalTransform.mat, Pt = 0, $t = this.hierarchy.length;
        if (!this.finalTransform._matMdf)
          for (; Pt < $t; ) {
            if (this.hierarchy[Pt].finalTransform.mProp._mdf) {
              this.finalTransform._matMdf = !0;
              break;
            }
            Pt += 1;
          }
        if (this.finalTransform._matMdf)
          for (_t = this.finalTransform.mProp.v.props, Et.cloneFromProps(_t), Pt = 0; Pt < $t; Pt += 1)
            Et.multiply(this.hierarchy[Pt].finalTransform.mProp.v);
      }
      this.finalTransform._matMdf && (this.finalTransform._localMatMdf = this.finalTransform._matMdf), this.finalTransform._opMdf && (this.finalTransform.localOpacity = this.finalTransform.mProp.o.v);
    }, renderLocalTransform: function() {
      if (this.localTransforms) {
        var _t = 0, Et = this.localTransforms.length;
        if (this.finalTransform._localMatMdf = this.finalTransform._matMdf, !this.finalTransform._localMatMdf || !this.finalTransform._opMdf)
          for (; _t < Et; )
            this.localTransforms[_t]._mdf && (this.finalTransform._localMatMdf = !0), this.localTransforms[_t]._opMdf && !this.finalTransform._opMdf && (this.finalTransform.localOpacity = this.finalTransform.mProp.o.v, this.finalTransform._opMdf = !0), _t += 1;
        if (this.finalTransform._localMatMdf) {
          var Pt = this.finalTransform.localMat;
          for (this.localTransforms[0].matrix.clone(Pt), _t = 1; _t < Et; _t += 1) {
            var $t = this.localTransforms[_t].matrix;
            Pt.multiply($t);
          }
          Pt.multiply(this.finalTransform.mat);
        }
        if (this.finalTransform._opMdf) {
          var Mt = this.finalTransform.localOpacity;
          for (_t = 0; _t < Et; _t += 1)
            Mt *= 0.01 * this.localTransforms[_t].opacity;
          this.finalTransform.localOpacity = Mt;
        }
      }
    }, searchEffectTransforms: function() {
      if (this.renderableEffectsManager) {
        var _t = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
        if (_t.length) {
          this.localTransforms = [], this.finalTransform.localMat = new Matrix();
          var Et = 0, Pt = _t.length;
          for (Et = 0; Et < Pt; Et += 1)
            this.localTransforms.push(_t[Et]);
        }
      }
    }, globalToLocal: function(_t) {
      var Et = [];
      Et.push(this.finalTransform);
      for (var Pt, $t = !0, Mt = this.comp; $t; )
        Mt.finalTransform ? (Mt.data.hasMask && Et.splice(0, 0, Mt.finalTransform), Mt = Mt.comp) : $t = !1;
      var Bt, Vt = Et.length;
      for (Pt = 0; Pt < Vt; Pt += 1)
        Bt = Et[Pt].mat.applyToPointArray(0, 0, 0), _t = [_t[0] - Bt[0], _t[1] - Bt[1], 0];
      return _t;
    }, mHelper: new Matrix() }, MaskElement.prototype.getMaskProperty = function(_t) {
      return this.viewData[_t].prop;
    }, MaskElement.prototype.renderFrame = function(_t) {
      var Et, Pt = this.element.finalTransform.mat, $t = this.masksProperties.length;
      for (Et = 0; Et < $t; Et += 1)
        if ((this.viewData[Et].prop._mdf || _t) && this.drawPath(this.masksProperties[Et], this.viewData[Et].prop.v, this.viewData[Et]), (this.viewData[Et].op._mdf || _t) && this.viewData[Et].elem.setAttribute("fill-opacity", this.viewData[Et].op.v), this.masksProperties[Et].mode !== "n" && (this.viewData[Et].invRect && (this.element.finalTransform.mProp._mdf || _t) && this.viewData[Et].invRect.setAttribute("transform", Pt.getInverseMatrix().to2dCSS()), this.storedData[Et].x && (this.storedData[Et].x._mdf || _t))) {
          var Mt = this.storedData[Et].expan;
          this.storedData[Et].x.v < 0 ? (this.storedData[Et].lastOperator !== "erode" && (this.storedData[Et].lastOperator = "erode", this.storedData[Et].elem.setAttribute("filter", "url(" + getLocationHref() + "#" + this.storedData[Et].filterId + ")")), Mt.setAttribute("radius", -this.storedData[Et].x.v)) : (this.storedData[Et].lastOperator !== "dilate" && (this.storedData[Et].lastOperator = "dilate", this.storedData[Et].elem.setAttribute("filter", null)), this.storedData[Et].elem.setAttribute("stroke-width", 2 * this.storedData[Et].x.v));
        }
    }, MaskElement.prototype.getMaskelement = function() {
      return this.maskElement;
    }, MaskElement.prototype.createLayerSolidPath = function() {
      var _t = "M0,0 ";
      return _t += " h" + this.globalData.compSize.w, _t += " v" + this.globalData.compSize.h, _t += " h-" + this.globalData.compSize.w, _t += " v-" + this.globalData.compSize.h + " ";
    }, MaskElement.prototype.drawPath = function(_t, Et, Pt) {
      var $t, Mt, Bt = " M" + Et.v[0][0] + "," + Et.v[0][1];
      for (Mt = Et._length, $t = 1; $t < Mt; $t += 1)
        Bt += " C" + Et.o[$t - 1][0] + "," + Et.o[$t - 1][1] + " " + Et.i[$t][0] + "," + Et.i[$t][1] + " " + Et.v[$t][0] + "," + Et.v[$t][1];
      if (Et.c && Mt > 1 && (Bt += " C" + Et.o[$t - 1][0] + "," + Et.o[$t - 1][1] + " " + Et.i[0][0] + "," + Et.i[0][1] + " " + Et.v[0][0] + "," + Et.v[0][1]), Pt.lastPath !== Bt) {
        var Vt = "";
        Pt.elem && (Et.c && (Vt = _t.inv ? this.solidPath + Bt : Bt), Pt.elem.setAttribute("d", Vt)), Pt.lastPath = Bt;
      }
    }, MaskElement.prototype.destroy = function() {
      this.element = null, this.globalData = null, this.maskElement = null, this.data = null, this.masksProperties = null;
    };
    var filtersFactory = function() {
      var _t = {};
      return _t.createFilter = function(Et, Pt) {
        var $t = createNS("filter");
        return $t.setAttribute("id", Et), Pt !== !0 && ($t.setAttribute("filterUnits", "objectBoundingBox"), $t.setAttribute("x", "0%"), $t.setAttribute("y", "0%"), $t.setAttribute("width", "100%"), $t.setAttribute("height", "100%")), $t;
      }, _t.createAlphaToLuminanceFilter = function() {
        var Et = createNS("feColorMatrix");
        return Et.setAttribute("type", "matrix"), Et.setAttribute("color-interpolation-filters", "sRGB"), Et.setAttribute("values", "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1"), Et;
      }, _t;
    }(), featureSupport = function() {
      var _t = { maskType: !0, svgLumaHidden: !0, offscreenCanvas: typeof OffscreenCanvas < "u" };
      return (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) && (_t.maskType = !1), /firefox/i.test(navigator.userAgent) && (_t.svgLumaHidden = !1), _t;
    }(), registeredEffects$1 = {}, idPrefix = "filter_result_";
    function SVGEffects(_t) {
      var Et, Pt, $t = "SourceGraphic", Mt = _t.data.ef ? _t.data.ef.length : 0, Bt = createElementID(), Vt = filtersFactory.createFilter(Bt, !0), zt = 0;
      for (this.filters = [], Et = 0; Et < Mt; Et += 1) {
        Pt = null;
        var Ht = _t.data.ef[Et].ty;
        registeredEffects$1[Ht] && (Pt = new registeredEffects$1[Ht].effect(Vt, _t.effectsManager.effectElements[Et], _t, idPrefix + zt, $t), $t = idPrefix + zt, registeredEffects$1[Ht].countsAsEffect && (zt += 1)), Pt && this.filters.push(Pt);
      }
      zt && (_t.globalData.defs.appendChild(Vt), _t.layerElement.setAttribute("filter", "url(" + getLocationHref() + "#" + Bt + ")")), this.filters.length && _t.addRenderableComponent(this);
    }
    function registerEffect$1(_t, Et, Pt) {
      registeredEffects$1[_t] = { effect: Et, countsAsEffect: Pt };
    }
    function SVGBaseElement() {
    }
    function HierarchyElement() {
    }
    function RenderableDOMElement() {
    }
    function IImageElement(_t, Et, Pt) {
      this.assetData = Et.getAssetData(_t.refId), this.assetData && this.assetData.sid && (this.assetData = Et.slotManager.getProp(this.assetData)), this.initElement(_t, Et, Pt), this.sourceRect = { top: 0, left: 0, width: this.assetData.w, height: this.assetData.h };
    }
    function ProcessedElement(_t, Et) {
      this.elem = _t, this.pos = Et;
    }
    function IShapeElement() {
    }
    SVGEffects.prototype.renderFrame = function(_t) {
      var Et, Pt = this.filters.length;
      for (Et = 0; Et < Pt; Et += 1)
        this.filters[Et].renderFrame(_t);
    }, SVGEffects.prototype.getEffects = function(_t) {
      var Et, Pt = this.filters.length, $t = [];
      for (Et = 0; Et < Pt; Et += 1)
        this.filters[Et].type === _t && $t.push(this.filters[Et]);
      return $t;
    }, SVGBaseElement.prototype = { initRendererElement: function() {
      this.layerElement = createNS("g");
    }, createContainerElements: function() {
      this.matteElement = createNS("g"), this.transformedElement = this.layerElement, this.maskedElement = this.layerElement, this._sizeChanged = !1;
      var _t = null;
      if (this.data.td) {
        this.matteMasks = {};
        var Et = createNS("g");
        Et.setAttribute("id", this.layerId), Et.appendChild(this.layerElement), _t = Et, this.globalData.defs.appendChild(Et);
      } else
        this.data.tt ? (this.matteElement.appendChild(this.layerElement), _t = this.matteElement, this.baseElement = this.matteElement) : this.baseElement = this.layerElement;
      if (this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), this.data.ty === 0 && !this.data.hd) {
        var Pt = createNS("clipPath"), $t = createNS("path");
        $t.setAttribute("d", "M0,0 L" + this.data.w + ",0 L" + this.data.w + "," + this.data.h + " L0," + this.data.h + "z");
        var Mt = createElementID();
        if (Pt.setAttribute("id", Mt), Pt.appendChild($t), this.globalData.defs.appendChild(Pt), this.checkMasks()) {
          var Bt = createNS("g");
          Bt.setAttribute("clip-path", "url(" + getLocationHref() + "#" + Mt + ")"), Bt.appendChild(this.layerElement), this.transformedElement = Bt, _t ? _t.appendChild(this.transformedElement) : this.baseElement = this.transformedElement;
        } else
          this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + Mt + ")");
      }
      this.data.bm !== 0 && this.setBlendMode();
    }, renderElement: function() {
      this.finalTransform._localMatMdf && this.transformedElement.setAttribute("transform", this.finalTransform.localMat.to2dCSS()), this.finalTransform._opMdf && this.transformedElement.setAttribute("opacity", this.finalTransform.localOpacity);
    }, destroyBaseElement: function() {
      this.layerElement = null, this.matteElement = null, this.maskManager.destroy();
    }, getBaseElement: function() {
      return this.data.hd ? null : this.baseElement;
    }, createRenderableComponents: function() {
      this.maskManager = new MaskElement(this.data, this, this.globalData), this.renderableEffectsManager = new SVGEffects(this), this.searchEffectTransforms();
    }, getMatte: function(_t) {
      if (this.matteMasks || (this.matteMasks = {}), !this.matteMasks[_t]) {
        var Et, Pt, $t, Mt, Bt = this.layerId + "_" + _t;
        if (_t === 1 || _t === 3) {
          var Vt = createNS("mask");
          Vt.setAttribute("id", Bt), Vt.setAttribute("mask-type", _t === 3 ? "luminance" : "alpha"), ($t = createNS("use")).setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), Vt.appendChild($t), this.globalData.defs.appendChild(Vt), featureSupport.maskType || _t !== 1 || (Vt.setAttribute("mask-type", "luminance"), Et = createElementID(), Pt = filtersFactory.createFilter(Et), this.globalData.defs.appendChild(Pt), Pt.appendChild(filtersFactory.createAlphaToLuminanceFilter()), (Mt = createNS("g")).appendChild($t), Vt.appendChild(Mt), Mt.setAttribute("filter", "url(" + getLocationHref() + "#" + Et + ")"));
        } else if (_t === 2) {
          var zt = createNS("mask");
          zt.setAttribute("id", Bt), zt.setAttribute("mask-type", "alpha");
          var Ht = createNS("g");
          zt.appendChild(Ht), Et = createElementID(), Pt = filtersFactory.createFilter(Et);
          var Wt = createNS("feComponentTransfer");
          Wt.setAttribute("in", "SourceGraphic"), Pt.appendChild(Wt);
          var Gt = createNS("feFuncA");
          Gt.setAttribute("type", "table"), Gt.setAttribute("tableValues", "1.0 0.0"), Wt.appendChild(Gt), this.globalData.defs.appendChild(Pt);
          var qt = createNS("rect");
          qt.setAttribute("width", this.comp.data.w), qt.setAttribute("height", this.comp.data.h), qt.setAttribute("x", "0"), qt.setAttribute("y", "0"), qt.setAttribute("fill", "#ffffff"), qt.setAttribute("opacity", "0"), Ht.setAttribute("filter", "url(" + getLocationHref() + "#" + Et + ")"), Ht.appendChild(qt), ($t = createNS("use")).setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), Ht.appendChild($t), featureSupport.maskType || (zt.setAttribute("mask-type", "luminance"), Pt.appendChild(filtersFactory.createAlphaToLuminanceFilter()), Mt = createNS("g"), Ht.appendChild(qt), Mt.appendChild(this.layerElement), Ht.appendChild(Mt)), this.globalData.defs.appendChild(zt);
        }
        this.matteMasks[_t] = Bt;
      }
      return this.matteMasks[_t];
    }, setMatte: function(_t) {
      this.matteElement && this.matteElement.setAttribute("mask", "url(" + getLocationHref() + "#" + _t + ")");
    } }, HierarchyElement.prototype = { initHierarchy: function() {
      this.hierarchy = [], this._isParent = !1, this.checkParenting();
    }, setHierarchy: function(_t) {
      this.hierarchy = _t;
    }, setAsParent: function() {
      this._isParent = !0;
    }, checkParenting: function() {
      this.data.parent !== void 0 && this.comp.buildElementParenting(this, this.data.parent, []);
    } }, extendPrototype([RenderableElement, createProxyFunction({ initElement: function(_t, Et, Pt) {
      this.initFrame(), this.initBaseData(_t, Et, Pt), this.initTransform(_t, Et, Pt), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide();
    }, hide: function() {
      this.hidden || this.isInRange && !this.isTransparent || ((this.baseElement || this.layerElement).style.display = "none", this.hidden = !0);
    }, show: function() {
      this.isInRange && !this.isTransparent && (this.data.hd || ((this.baseElement || this.layerElement).style.display = "block"), this.hidden = !1, this._isFirstFrame = !0);
    }, renderFrame: function() {
      this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderLocalTransform(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
    }, renderInnerContent: function() {
    }, prepareFrame: function(_t) {
      this._mdf = !1, this.prepareRenderableFrame(_t), this.prepareProperties(_t, this.isInRange), this.checkTransparency();
    }, destroy: function() {
      this.innerElem = null, this.destroyBaseElement();
    } })], RenderableDOMElement), extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], IImageElement), IImageElement.prototype.createContent = function() {
      var _t = this.globalData.getAssetsPath(this.assetData);
      this.innerElem = createNS("image"), this.innerElem.setAttribute("width", this.assetData.w + "px"), this.innerElem.setAttribute("height", this.assetData.h + "px"), this.innerElem.setAttribute("preserveAspectRatio", this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio), this.innerElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", _t), this.layerElement.appendChild(this.innerElem);
    }, IImageElement.prototype.sourceRectAtTime = function() {
      return this.sourceRect;
    }, IShapeElement.prototype = { addShapeToModifiers: function(_t) {
      var Et, Pt = this.shapeModifiers.length;
      for (Et = 0; Et < Pt; Et += 1)
        this.shapeModifiers[Et].addShape(_t);
    }, isShapeInAnimatedModifiers: function(_t) {
      for (var Et = this.shapeModifiers.length; 0 < Et; )
        if (this.shapeModifiers[0].isAnimatedWithShape(_t))
          return !0;
      return !1;
    }, renderModifiers: function() {
      if (this.shapeModifiers.length) {
        var _t, Et = this.shapes.length;
        for (_t = 0; _t < Et; _t += 1)
          this.shapes[_t].sh.reset();
        for (_t = (Et = this.shapeModifiers.length) - 1; _t >= 0 && !this.shapeModifiers[_t].processShapes(this._isFirstFrame); _t -= 1)
          ;
      }
    }, searchProcessedElement: function(_t) {
      for (var Et = this.processedElements, Pt = 0, $t = Et.length; Pt < $t; ) {
        if (Et[Pt].elem === _t)
          return Et[Pt].pos;
        Pt += 1;
      }
      return 0;
    }, addProcessedElement: function(_t, Et) {
      for (var Pt = this.processedElements, $t = Pt.length; $t; )
        if (Pt[$t -= 1].elem === _t)
          return void (Pt[$t].pos = Et);
      Pt.push(new ProcessedElement(_t, Et));
    }, prepareFrame: function(_t) {
      this.prepareRenderableFrame(_t), this.prepareProperties(_t, this.isInRange);
    } };
    var lineCapEnum = { 1: "butt", 2: "round", 3: "square" }, lineJoinEnum = { 1: "miter", 2: "round", 3: "bevel" };
    function SVGShapeData(_t, Et, Pt) {
      this.caches = [], this.styles = [], this.transformers = _t, this.lStr = "", this.sh = Pt, this.lvl = Et, this._isAnimated = !!Pt.k;
      for (var $t = 0, Mt = _t.length; $t < Mt; ) {
        if (_t[$t].mProps.dynamicProperties.length) {
          this._isAnimated = !0;
          break;
        }
        $t += 1;
      }
    }
    function SVGStyleData(_t, Et) {
      this.data = _t, this.type = _t.ty, this.d = "", this.lvl = Et, this._mdf = !1, this.closed = _t.hd === !0, this.pElem = createNS("path"), this.msElem = null;
    }
    function DashProperty(_t, Et, Pt, $t) {
      var Mt;
      this.elem = _t, this.frameId = -1, this.dataProps = createSizedArray(Et.length), this.renderer = Pt, this.k = !1, this.dashStr = "", this.dashArray = createTypedArray("float32", Et.length ? Et.length - 1 : 0), this.dashoffset = createTypedArray("float32", 1), this.initDynamicPropertyContainer($t);
      var Bt, Vt = Et.length || 0;
      for (Mt = 0; Mt < Vt; Mt += 1)
        Bt = PropertyFactory.getProp(_t, Et[Mt].v, 0, 0, this), this.k = Bt.k || this.k, this.dataProps[Mt] = { n: Et[Mt].n, p: Bt };
      this.k || this.getValue(!0), this._isAnimated = this.k;
    }
    function SVGStrokeStyleData(_t, Et, Pt) {
      this.initDynamicPropertyContainer(_t), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(_t, Et.o, 0, 0.01, this), this.w = PropertyFactory.getProp(_t, Et.w, 0, null, this), this.d = new DashProperty(_t, Et.d || {}, "svg", this), this.c = PropertyFactory.getProp(_t, Et.c, 1, 255, this), this.style = Pt, this._isAnimated = !!this._isAnimated;
    }
    function SVGFillStyleData(_t, Et, Pt) {
      this.initDynamicPropertyContainer(_t), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(_t, Et.o, 0, 0.01, this), this.c = PropertyFactory.getProp(_t, Et.c, 1, 255, this), this.style = Pt;
    }
    function SVGNoStyleData(_t, Et, Pt) {
      this.initDynamicPropertyContainer(_t), this.getValue = this.iterateDynamicProperties, this.style = Pt;
    }
    function GradientProperty(_t, Et, Pt) {
      this.data = Et, this.c = createTypedArray("uint8c", 4 * Et.p);
      var $t = Et.k.k[0].s ? Et.k.k[0].s.length - 4 * Et.p : Et.k.k.length - 4 * Et.p;
      this.o = createTypedArray("float32", $t), this._cmdf = !1, this._omdf = !1, this._collapsable = this.checkCollapsable(), this._hasOpacity = $t, this.initDynamicPropertyContainer(Pt), this.prop = PropertyFactory.getProp(_t, Et.k, 1, null, this), this.k = this.prop.k, this.getValue(!0);
    }
    function SVGGradientFillStyleData(_t, Et, Pt) {
      this.initDynamicPropertyContainer(_t), this.getValue = this.iterateDynamicProperties, this.initGradientData(_t, Et, Pt);
    }
    function SVGGradientStrokeStyleData(_t, Et, Pt) {
      this.initDynamicPropertyContainer(_t), this.getValue = this.iterateDynamicProperties, this.w = PropertyFactory.getProp(_t, Et.w, 0, null, this), this.d = new DashProperty(_t, Et.d || {}, "svg", this), this.initGradientData(_t, Et, Pt), this._isAnimated = !!this._isAnimated;
    }
    function ShapeGroupData() {
      this.it = [], this.prevViewData = [], this.gr = createNS("g");
    }
    function SVGTransformData(_t, Et, Pt) {
      this.transform = { mProps: _t, op: Et, container: Pt }, this.elements = [], this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
    }
    SVGShapeData.prototype.setAsAnimated = function() {
      this._isAnimated = !0;
    }, SVGStyleData.prototype.reset = function() {
      this.d = "", this._mdf = !1;
    }, DashProperty.prototype.getValue = function(_t) {
      if ((this.elem.globalData.frameId !== this.frameId || _t) && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf = this._mdf || _t, this._mdf)) {
        var Et = 0, Pt = this.dataProps.length;
        for (this.renderer === "svg" && (this.dashStr = ""), Et = 0; Et < Pt; Et += 1)
          this.dataProps[Et].n !== "o" ? this.renderer === "svg" ? this.dashStr += " " + this.dataProps[Et].p.v : this.dashArray[Et] = this.dataProps[Et].p.v : this.dashoffset[0] = this.dataProps[Et].p.v;
      }
    }, extendPrototype([DynamicPropertyContainer], DashProperty), extendPrototype([DynamicPropertyContainer], SVGStrokeStyleData), extendPrototype([DynamicPropertyContainer], SVGFillStyleData), extendPrototype([DynamicPropertyContainer], SVGNoStyleData), GradientProperty.prototype.comparePoints = function(_t, Et) {
      for (var Pt = 0, $t = this.o.length / 2; Pt < $t; ) {
        if (Math.abs(_t[4 * Pt] - _t[4 * Et + 2 * Pt]) > 0.01)
          return !1;
        Pt += 1;
      }
      return !0;
    }, GradientProperty.prototype.checkCollapsable = function() {
      if (this.o.length / 2 != this.c.length / 4)
        return !1;
      if (this.data.k.k[0].s)
        for (var _t = 0, Et = this.data.k.k.length; _t < Et; ) {
          if (!this.comparePoints(this.data.k.k[_t].s, this.data.p))
            return !1;
          _t += 1;
        }
      else if (!this.comparePoints(this.data.k.k, this.data.p))
        return !1;
      return !0;
    }, GradientProperty.prototype.getValue = function(_t) {
      if (this.prop.getValue(), this._mdf = !1, this._cmdf = !1, this._omdf = !1, this.prop._mdf || _t) {
        var Et, Pt, $t, Mt = 4 * this.data.p;
        for (Et = 0; Et < Mt; Et += 1)
          Pt = Et % 4 == 0 ? 100 : 255, $t = Math.round(this.prop.v[Et] * Pt), this.c[Et] !== $t && (this.c[Et] = $t, this._cmdf = !_t);
        if (this.o.length)
          for (Mt = this.prop.v.length, Et = 4 * this.data.p; Et < Mt; Et += 1)
            Pt = Et % 2 == 0 ? 100 : 1, $t = Et % 2 == 0 ? Math.round(100 * this.prop.v[Et]) : this.prop.v[Et], this.o[Et - 4 * this.data.p] !== $t && (this.o[Et - 4 * this.data.p] = $t, this._omdf = !_t);
        this._mdf = !_t;
      }
    }, extendPrototype([DynamicPropertyContainer], GradientProperty), SVGGradientFillStyleData.prototype.initGradientData = function(_t, Et, Pt) {
      this.o = PropertyFactory.getProp(_t, Et.o, 0, 0.01, this), this.s = PropertyFactory.getProp(_t, Et.s, 1, null, this), this.e = PropertyFactory.getProp(_t, Et.e, 1, null, this), this.h = PropertyFactory.getProp(_t, Et.h || { k: 0 }, 0, 0.01, this), this.a = PropertyFactory.getProp(_t, Et.a || { k: 0 }, 0, degToRads, this), this.g = new GradientProperty(_t, Et.g, this), this.style = Pt, this.stops = [], this.setGradientData(Pt.pElem, Et), this.setGradientOpacity(Et, Pt), this._isAnimated = !!this._isAnimated;
    }, SVGGradientFillStyleData.prototype.setGradientData = function(_t, Et) {
      var Pt = createElementID(), $t = createNS(Et.t === 1 ? "linearGradient" : "radialGradient");
      $t.setAttribute("id", Pt), $t.setAttribute("spreadMethod", "pad"), $t.setAttribute("gradientUnits", "userSpaceOnUse");
      var Mt, Bt, Vt, zt = [];
      for (Vt = 4 * Et.g.p, Bt = 0; Bt < Vt; Bt += 4)
        Mt = createNS("stop"), $t.appendChild(Mt), zt.push(Mt);
      _t.setAttribute(Et.ty === "gf" ? "fill" : "stroke", "url(" + getLocationHref() + "#" + Pt + ")"), this.gf = $t, this.cst = zt;
    }, SVGGradientFillStyleData.prototype.setGradientOpacity = function(_t, Et) {
      if (this.g._hasOpacity && !this.g._collapsable) {
        var Pt, $t, Mt, Bt = createNS("mask"), Vt = createNS("path");
        Bt.appendChild(Vt);
        var zt = createElementID(), Ht = createElementID();
        Bt.setAttribute("id", Ht);
        var Wt = createNS(_t.t === 1 ? "linearGradient" : "radialGradient");
        Wt.setAttribute("id", zt), Wt.setAttribute("spreadMethod", "pad"), Wt.setAttribute("gradientUnits", "userSpaceOnUse"), Mt = _t.g.k.k[0].s ? _t.g.k.k[0].s.length : _t.g.k.k.length;
        var Gt = this.stops;
        for ($t = 4 * _t.g.p; $t < Mt; $t += 2)
          (Pt = createNS("stop")).setAttribute("stop-color", "rgb(255,255,255)"), Wt.appendChild(Pt), Gt.push(Pt);
        Vt.setAttribute(_t.ty === "gf" ? "fill" : "stroke", "url(" + getLocationHref() + "#" + zt + ")"), _t.ty === "gs" && (Vt.setAttribute("stroke-linecap", lineCapEnum[_t.lc || 2]), Vt.setAttribute("stroke-linejoin", lineJoinEnum[_t.lj || 2]), _t.lj === 1 && Vt.setAttribute("stroke-miterlimit", _t.ml)), this.of = Wt, this.ms = Bt, this.ost = Gt, this.maskId = Ht, Et.msElem = Vt;
      }
    }, extendPrototype([DynamicPropertyContainer], SVGGradientFillStyleData), extendPrototype([SVGGradientFillStyleData, DynamicPropertyContainer], SVGGradientStrokeStyleData);
    var buildShapeString = function(_t, Et, Pt, $t) {
      if (Et === 0)
        return "";
      var Mt, Bt = _t.o, Vt = _t.i, zt = _t.v, Ht = " M" + $t.applyToPointStringified(zt[0][0], zt[0][1]);
      for (Mt = 1; Mt < Et; Mt += 1)
        Ht += " C" + $t.applyToPointStringified(Bt[Mt - 1][0], Bt[Mt - 1][1]) + " " + $t.applyToPointStringified(Vt[Mt][0], Vt[Mt][1]) + " " + $t.applyToPointStringified(zt[Mt][0], zt[Mt][1]);
      return Pt && Et && (Ht += " C" + $t.applyToPointStringified(Bt[Mt - 1][0], Bt[Mt - 1][1]) + " " + $t.applyToPointStringified(Vt[0][0], Vt[0][1]) + " " + $t.applyToPointStringified(zt[0][0], zt[0][1]), Ht += "z"), Ht;
    }, SVGElementsRenderer = function() {
      var _t = new Matrix(), Et = new Matrix();
      function Pt(Wt, Gt, qt) {
        (qt || Gt.transform.op._mdf) && Gt.transform.container.setAttribute("opacity", Gt.transform.op.v), (qt || Gt.transform.mProps._mdf) && Gt.transform.container.setAttribute("transform", Gt.transform.mProps.v.to2dCSS());
      }
      function $t() {
      }
      function Mt(Wt, Gt, qt) {
        var Kt, Qt, Xt, Zt, Yt, Jt, er, tr, nr, rr, ir = Gt.styles.length, ar = Gt.lvl;
        for (Jt = 0; Jt < ir; Jt += 1) {
          if (Zt = Gt.sh._mdf || qt, Gt.styles[Jt].lvl < ar) {
            for (tr = Et.reset(), nr = ar - Gt.styles[Jt].lvl, rr = Gt.transformers.length - 1; !Zt && nr > 0; )
              Zt = Gt.transformers[rr].mProps._mdf || Zt, nr -= 1, rr -= 1;
            if (Zt)
              for (nr = ar - Gt.styles[Jt].lvl, rr = Gt.transformers.length - 1; nr > 0; )
                tr.multiply(Gt.transformers[rr].mProps.v), nr -= 1, rr -= 1;
          } else
            tr = _t;
          if (Qt = (er = Gt.sh.paths)._length, Zt) {
            for (Xt = "", Kt = 0; Kt < Qt; Kt += 1)
              (Yt = er.shapes[Kt]) && Yt._length && (Xt += buildShapeString(Yt, Yt._length, Yt.c, tr));
            Gt.caches[Jt] = Xt;
          } else
            Xt = Gt.caches[Jt];
          Gt.styles[Jt].d += Wt.hd === !0 ? "" : Xt, Gt.styles[Jt]._mdf = Zt || Gt.styles[Jt]._mdf;
        }
      }
      function Bt(Wt, Gt, qt) {
        var Kt = Gt.style;
        (Gt.c._mdf || qt) && Kt.pElem.setAttribute("fill", "rgb(" + bmFloor(Gt.c.v[0]) + "," + bmFloor(Gt.c.v[1]) + "," + bmFloor(Gt.c.v[2]) + ")"), (Gt.o._mdf || qt) && Kt.pElem.setAttribute("fill-opacity", Gt.o.v);
      }
      function Vt(Wt, Gt, qt) {
        zt(Wt, Gt, qt), Ht(Wt, Gt, qt);
      }
      function zt(Wt, Gt, qt) {
        var Kt, Qt, Xt, Zt, Yt, Jt = Gt.gf, er = Gt.g._hasOpacity, tr = Gt.s.v, nr = Gt.e.v;
        if (Gt.o._mdf || qt) {
          var rr = Wt.ty === "gf" ? "fill-opacity" : "stroke-opacity";
          Gt.style.pElem.setAttribute(rr, Gt.o.v);
        }
        if (Gt.s._mdf || qt) {
          var ir = Wt.t === 1 ? "x1" : "cx", ar = ir === "x1" ? "y1" : "cy";
          Jt.setAttribute(ir, tr[0]), Jt.setAttribute(ar, tr[1]), er && !Gt.g._collapsable && (Gt.of.setAttribute(ir, tr[0]), Gt.of.setAttribute(ar, tr[1]));
        }
        if (Gt.g._cmdf || qt) {
          Kt = Gt.cst;
          var or = Gt.g.c;
          for (Xt = Kt.length, Qt = 0; Qt < Xt; Qt += 1)
            (Zt = Kt[Qt]).setAttribute("offset", or[4 * Qt] + "%"), Zt.setAttribute("stop-color", "rgb(" + or[4 * Qt + 1] + "," + or[4 * Qt + 2] + "," + or[4 * Qt + 3] + ")");
        }
        if (er && (Gt.g._omdf || qt)) {
          var sr = Gt.g.o;
          for (Xt = (Kt = Gt.g._collapsable ? Gt.cst : Gt.ost).length, Qt = 0; Qt < Xt; Qt += 1)
            Zt = Kt[Qt], Gt.g._collapsable || Zt.setAttribute("offset", sr[2 * Qt] + "%"), Zt.setAttribute("stop-opacity", sr[2 * Qt + 1]);
        }
        if (Wt.t === 1)
          (Gt.e._mdf || qt) && (Jt.setAttribute("x2", nr[0]), Jt.setAttribute("y2", nr[1]), er && !Gt.g._collapsable && (Gt.of.setAttribute("x2", nr[0]), Gt.of.setAttribute("y2", nr[1])));
        else if ((Gt.s._mdf || Gt.e._mdf || qt) && (Yt = Math.sqrt(Math.pow(tr[0] - nr[0], 2) + Math.pow(tr[1] - nr[1], 2)), Jt.setAttribute("r", Yt), er && !Gt.g._collapsable && Gt.of.setAttribute("r", Yt)), Gt.e._mdf || Gt.h._mdf || Gt.a._mdf || qt) {
          Yt || (Yt = Math.sqrt(Math.pow(tr[0] - nr[0], 2) + Math.pow(tr[1] - nr[1], 2)));
          var lr = Math.atan2(nr[1] - tr[1], nr[0] - tr[0]), cr = Gt.h.v;
          cr >= 1 ? cr = 0.99 : cr <= -1 && (cr = -0.99);
          var hr = Yt * cr, pr = Math.cos(lr + Gt.a.v) * hr + tr[0], mr = Math.sin(lr + Gt.a.v) * hr + tr[1];
          Jt.setAttribute("fx", pr), Jt.setAttribute("fy", mr), er && !Gt.g._collapsable && (Gt.of.setAttribute("fx", pr), Gt.of.setAttribute("fy", mr));
        }
      }
      function Ht(Wt, Gt, qt) {
        var Kt = Gt.style, Qt = Gt.d;
        Qt && (Qt._mdf || qt) && Qt.dashStr && (Kt.pElem.setAttribute("stroke-dasharray", Qt.dashStr), Kt.pElem.setAttribute("stroke-dashoffset", Qt.dashoffset[0])), Gt.c && (Gt.c._mdf || qt) && Kt.pElem.setAttribute("stroke", "rgb(" + bmFloor(Gt.c.v[0]) + "," + bmFloor(Gt.c.v[1]) + "," + bmFloor(Gt.c.v[2]) + ")"), (Gt.o._mdf || qt) && Kt.pElem.setAttribute("stroke-opacity", Gt.o.v), (Gt.w._mdf || qt) && (Kt.pElem.setAttribute("stroke-width", Gt.w.v), Kt.msElem && Kt.msElem.setAttribute("stroke-width", Gt.w.v));
      }
      return { createRenderFunction: function(Wt) {
        switch (Wt.ty) {
          case "fl":
            return Bt;
          case "gf":
            return zt;
          case "gs":
            return Vt;
          case "st":
            return Ht;
          case "sh":
          case "el":
          case "rc":
          case "sr":
            return Mt;
          case "tr":
            return Pt;
          case "no":
            return $t;
          default:
            return null;
        }
      } };
    }();
    function SVGShapeElement(_t, Et, Pt) {
      this.shapes = [], this.shapesData = _t.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.initElement(_t, Et, Pt), this.prevViewData = [];
    }
    function LetterProps(_t, Et, Pt, $t, Mt, Bt) {
      this.o = _t, this.sw = Et, this.sc = Pt, this.fc = $t, this.m = Mt, this.p = Bt, this._mdf = { o: !0, sw: !!Et, sc: !!Pt, fc: !!$t, m: !0, p: !0 };
    }
    function TextProperty(_t, Et) {
      this._frameId = initialDefaultFrame, this.pv = "", this.v = "", this.kf = !1, this._isFirstFrame = !0, this._mdf = !1, Et.d && Et.d.sid && (Et.d = _t.globalData.slotManager.getProp(Et.d)), this.data = Et, this.elem = _t, this.comp = this.elem.comp, this.keysIndex = 0, this.canResize = !1, this.minimumFontSize = 1, this.effectsSequence = [], this.currentData = { ascent: 0, boxWidth: this.defaultBoxWidth, f: "", fStyle: "", fWeight: "", fc: "", j: "", justifyOffset: "", l: [], lh: 0, lineWidths: [], ls: "", of: "", s: "", sc: "", sw: 0, t: 0, tr: 0, sz: 0, ps: null, fillColorAnim: !1, strokeColorAnim: !1, strokeWidthAnim: !1, yOffset: 0, finalSize: 0, finalText: [], finalLineHeight: 0, __complete: !1 }, this.copyData(this.currentData, this.data.d.k[0].s), this.searchProperty() || this.completeTextData(this.currentData);
    }
    extendPrototype([BaseElement, TransformElement, SVGBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableDOMElement], SVGShapeElement), SVGShapeElement.prototype.initSecondaryElement = function() {
    }, SVGShapeElement.prototype.identityMatrix = new Matrix(), SVGShapeElement.prototype.buildExpressionInterface = function() {
    }, SVGShapeElement.prototype.createContent = function() {
      this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes();
    }, SVGShapeElement.prototype.filterUniqueShapes = function() {
      var _t, Et, Pt, $t, Mt = this.shapes.length, Bt = this.stylesList.length, Vt = [], zt = !1;
      for (Pt = 0; Pt < Bt; Pt += 1) {
        for ($t = this.stylesList[Pt], zt = !1, Vt.length = 0, _t = 0; _t < Mt; _t += 1)
          (Et = this.shapes[_t]).styles.indexOf($t) !== -1 && (Vt.push(Et), zt = Et._isAnimated || zt);
        Vt.length > 1 && zt && this.setShapesAsAnimated(Vt);
      }
    }, SVGShapeElement.prototype.setShapesAsAnimated = function(_t) {
      var Et, Pt = _t.length;
      for (Et = 0; Et < Pt; Et += 1)
        _t[Et].setAsAnimated();
    }, SVGShapeElement.prototype.createStyleElement = function(_t, Et) {
      var Pt, $t = new SVGStyleData(_t, Et), Mt = $t.pElem;
      return _t.ty === "st" ? Pt = new SVGStrokeStyleData(this, _t, $t) : _t.ty === "fl" ? Pt = new SVGFillStyleData(this, _t, $t) : _t.ty === "gf" || _t.ty === "gs" ? (Pt = new (_t.ty === "gf" ? SVGGradientFillStyleData : SVGGradientStrokeStyleData)(this, _t, $t), this.globalData.defs.appendChild(Pt.gf), Pt.maskId && (this.globalData.defs.appendChild(Pt.ms), this.globalData.defs.appendChild(Pt.of), Mt.setAttribute("mask", "url(" + getLocationHref() + "#" + Pt.maskId + ")"))) : _t.ty === "no" && (Pt = new SVGNoStyleData(this, _t, $t)), _t.ty !== "st" && _t.ty !== "gs" || (Mt.setAttribute("stroke-linecap", lineCapEnum[_t.lc || 2]), Mt.setAttribute("stroke-linejoin", lineJoinEnum[_t.lj || 2]), Mt.setAttribute("fill-opacity", "0"), _t.lj === 1 && Mt.setAttribute("stroke-miterlimit", _t.ml)), _t.r === 2 && Mt.setAttribute("fill-rule", "evenodd"), _t.ln && Mt.setAttribute("id", _t.ln), _t.cl && Mt.setAttribute("class", _t.cl), _t.bm && (Mt.style["mix-blend-mode"] = getBlendMode(_t.bm)), this.stylesList.push($t), this.addToAnimatedContents(_t, Pt), Pt;
    }, SVGShapeElement.prototype.createGroupElement = function(_t) {
      var Et = new ShapeGroupData();
      return _t.ln && Et.gr.setAttribute("id", _t.ln), _t.cl && Et.gr.setAttribute("class", _t.cl), _t.bm && (Et.gr.style["mix-blend-mode"] = getBlendMode(_t.bm)), Et;
    }, SVGShapeElement.prototype.createTransformElement = function(_t, Et) {
      var Pt = TransformPropertyFactory.getTransformProperty(this, _t, this), $t = new SVGTransformData(Pt, Pt.o, Et);
      return this.addToAnimatedContents(_t, $t), $t;
    }, SVGShapeElement.prototype.createShapeElement = function(_t, Et, Pt) {
      var $t = 4;
      _t.ty === "rc" ? $t = 5 : _t.ty === "el" ? $t = 6 : _t.ty === "sr" && ($t = 7);
      var Mt = new SVGShapeData(Et, Pt, ShapePropertyFactory.getShapeProp(this, _t, $t, this));
      return this.shapes.push(Mt), this.addShapeToModifiers(Mt), this.addToAnimatedContents(_t, Mt), Mt;
    }, SVGShapeElement.prototype.addToAnimatedContents = function(_t, Et) {
      for (var Pt = 0, $t = this.animatedContents.length; Pt < $t; ) {
        if (this.animatedContents[Pt].element === Et)
          return;
        Pt += 1;
      }
      this.animatedContents.push({ fn: SVGElementsRenderer.createRenderFunction(_t), element: Et, data: _t });
    }, SVGShapeElement.prototype.setElementStyles = function(_t) {
      var Et, Pt = _t.styles, $t = this.stylesList.length;
      for (Et = 0; Et < $t; Et += 1)
        this.stylesList[Et].closed || Pt.push(this.stylesList[Et]);
    }, SVGShapeElement.prototype.reloadShapes = function() {
      var _t;
      this._isFirstFrame = !0;
      var Et = this.itemsData.length;
      for (_t = 0; _t < Et; _t += 1)
        this.prevViewData[_t] = this.itemsData[_t];
      for (this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes(), Et = this.dynamicProperties.length, _t = 0; _t < Et; _t += 1)
        this.dynamicProperties[_t].getValue();
      this.renderModifiers();
    }, SVGShapeElement.prototype.searchShapes = function(_t, Et, Pt, $t, Mt, Bt, Vt) {
      var zt, Ht, Wt, Gt, qt, Kt, Qt = [].concat(Bt), Xt = _t.length - 1, Zt = [], Yt = [];
      for (zt = Xt; zt >= 0; zt -= 1) {
        if ((Kt = this.searchProcessedElement(_t[zt])) ? Et[zt] = Pt[Kt - 1] : _t[zt]._render = Vt, _t[zt].ty === "fl" || _t[zt].ty === "st" || _t[zt].ty === "gf" || _t[zt].ty === "gs" || _t[zt].ty === "no")
          Kt ? Et[zt].style.closed = !1 : Et[zt] = this.createStyleElement(_t[zt], Mt), _t[zt]._render && Et[zt].style.pElem.parentNode !== $t && $t.appendChild(Et[zt].style.pElem), Zt.push(Et[zt].style);
        else if (_t[zt].ty === "gr") {
          if (Kt)
            for (Wt = Et[zt].it.length, Ht = 0; Ht < Wt; Ht += 1)
              Et[zt].prevViewData[Ht] = Et[zt].it[Ht];
          else
            Et[zt] = this.createGroupElement(_t[zt]);
          this.searchShapes(_t[zt].it, Et[zt].it, Et[zt].prevViewData, Et[zt].gr, Mt + 1, Qt, Vt), _t[zt]._render && Et[zt].gr.parentNode !== $t && $t.appendChild(Et[zt].gr);
        } else
          _t[zt].ty === "tr" ? (Kt || (Et[zt] = this.createTransformElement(_t[zt], $t)), Gt = Et[zt].transform, Qt.push(Gt)) : _t[zt].ty === "sh" || _t[zt].ty === "rc" || _t[zt].ty === "el" || _t[zt].ty === "sr" ? (Kt || (Et[zt] = this.createShapeElement(_t[zt], Qt, Mt)), this.setElementStyles(Et[zt])) : _t[zt].ty === "tm" || _t[zt].ty === "rd" || _t[zt].ty === "ms" || _t[zt].ty === "pb" || _t[zt].ty === "zz" || _t[zt].ty === "op" ? (Kt ? (qt = Et[zt]).closed = !1 : ((qt = ShapeModifiers.getModifier(_t[zt].ty)).init(this, _t[zt]), Et[zt] = qt, this.shapeModifiers.push(qt)), Yt.push(qt)) : _t[zt].ty === "rp" && (Kt ? (qt = Et[zt]).closed = !0 : (qt = ShapeModifiers.getModifier(_t[zt].ty), Et[zt] = qt, qt.init(this, _t, zt, Et), this.shapeModifiers.push(qt), Vt = !1), Yt.push(qt));
        this.addProcessedElement(_t[zt], zt + 1);
      }
      for (Xt = Zt.length, zt = 0; zt < Xt; zt += 1)
        Zt[zt].closed = !0;
      for (Xt = Yt.length, zt = 0; zt < Xt; zt += 1)
        Yt[zt].closed = !0;
    }, SVGShapeElement.prototype.renderInnerContent = function() {
      var _t;
      this.renderModifiers();
      var Et = this.stylesList.length;
      for (_t = 0; _t < Et; _t += 1)
        this.stylesList[_t].reset();
      for (this.renderShape(), _t = 0; _t < Et; _t += 1)
        (this.stylesList[_t]._mdf || this._isFirstFrame) && (this.stylesList[_t].msElem && (this.stylesList[_t].msElem.setAttribute("d", this.stylesList[_t].d), this.stylesList[_t].d = "M0 0" + this.stylesList[_t].d), this.stylesList[_t].pElem.setAttribute("d", this.stylesList[_t].d || "M0 0"));
    }, SVGShapeElement.prototype.renderShape = function() {
      var _t, Et, Pt = this.animatedContents.length;
      for (_t = 0; _t < Pt; _t += 1)
        Et = this.animatedContents[_t], (this._isFirstFrame || Et.element._isAnimated) && Et.data !== !0 && Et.fn(Et.data, Et.element, this._isFirstFrame);
    }, SVGShapeElement.prototype.destroy = function() {
      this.destroyBaseElement(), this.shapesData = null, this.itemsData = null;
    }, LetterProps.prototype.update = function(_t, Et, Pt, $t, Mt, Bt) {
      this._mdf.o = !1, this._mdf.sw = !1, this._mdf.sc = !1, this._mdf.fc = !1, this._mdf.m = !1, this._mdf.p = !1;
      var Vt = !1;
      return this.o !== _t && (this.o = _t, this._mdf.o = !0, Vt = !0), this.sw !== Et && (this.sw = Et, this._mdf.sw = !0, Vt = !0), this.sc !== Pt && (this.sc = Pt, this._mdf.sc = !0, Vt = !0), this.fc !== $t && (this.fc = $t, this._mdf.fc = !0, Vt = !0), this.m !== Mt && (this.m = Mt, this._mdf.m = !0, Vt = !0), !Bt.length || this.p[0] === Bt[0] && this.p[1] === Bt[1] && this.p[4] === Bt[4] && this.p[5] === Bt[5] && this.p[12] === Bt[12] && this.p[13] === Bt[13] || (this.p = Bt, this._mdf.p = !0, Vt = !0), Vt;
    }, TextProperty.prototype.defaultBoxWidth = [0, 0], TextProperty.prototype.copyData = function(_t, Et) {
      for (var Pt in Et)
        Object.prototype.hasOwnProperty.call(Et, Pt) && (_t[Pt] = Et[Pt]);
      return _t;
    }, TextProperty.prototype.setCurrentData = function(_t) {
      _t.__complete || this.completeTextData(_t), this.currentData = _t, this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth, this._mdf = !0;
    }, TextProperty.prototype.searchProperty = function() {
      return this.searchKeyframes();
    }, TextProperty.prototype.searchKeyframes = function() {
      return this.kf = this.data.d.k.length > 1, this.kf && this.addEffect(this.getKeyframeValue.bind(this)), this.kf;
    }, TextProperty.prototype.addEffect = function(_t) {
      this.effectsSequence.push(_t), this.elem.addDynamicProperty(this);
    }, TextProperty.prototype.getValue = function(_t) {
      if (this.elem.globalData.frameId !== this.frameId && this.effectsSequence.length || _t) {
        this.currentData.t = this.data.d.k[this.keysIndex].s.t;
        var Et = this.currentData, Pt = this.keysIndex;
        if (this.lock)
          this.setCurrentData(this.currentData);
        else {
          var $t;
          this.lock = !0, this._mdf = !1;
          var Mt = this.effectsSequence.length, Bt = _t || this.data.d.k[this.keysIndex].s;
          for ($t = 0; $t < Mt; $t += 1)
            Bt = Pt !== this.keysIndex ? this.effectsSequence[$t](Bt, Bt.t) : this.effectsSequence[$t](this.currentData, Bt.t);
          Et !== Bt && this.setCurrentData(Bt), this.v = this.currentData, this.pv = this.v, this.lock = !1, this.frameId = this.elem.globalData.frameId;
        }
      }
    }, TextProperty.prototype.getKeyframeValue = function() {
      for (var _t = this.data.d.k, Et = this.elem.comp.renderedFrame, Pt = 0, $t = _t.length; Pt <= $t - 1 && !(Pt === $t - 1 || _t[Pt + 1].t > Et); )
        Pt += 1;
      return this.keysIndex !== Pt && (this.keysIndex = Pt), this.data.d.k[this.keysIndex].s;
    }, TextProperty.prototype.buildFinalText = function(_t) {
      for (var Et, Pt, $t = [], Mt = 0, Bt = _t.length, Vt = !1, zt = !1, Ht = ""; Mt < Bt; )
        Vt = zt, zt = !1, Et = _t.charCodeAt(Mt), Ht = _t.charAt(Mt), FontManager.isCombinedCharacter(Et) ? Vt = !0 : Et >= 55296 && Et <= 56319 ? FontManager.isRegionalFlag(_t, Mt) ? Ht = _t.substr(Mt, 14) : (Pt = _t.charCodeAt(Mt + 1)) >= 56320 && Pt <= 57343 && (FontManager.isModifier(Et, Pt) ? (Ht = _t.substr(Mt, 2), Vt = !0) : Ht = FontManager.isFlagEmoji(_t.substr(Mt, 4)) ? _t.substr(Mt, 4) : _t.substr(Mt, 2)) : Et > 56319 ? (Pt = _t.charCodeAt(Mt + 1), FontManager.isVariationSelector(Et) && (Vt = !0)) : FontManager.isZeroWidthJoiner(Et) && (Vt = !0, zt = !0), Vt ? ($t[$t.length - 1] += Ht, Vt = !1) : $t.push(Ht), Mt += Ht.length;
      return $t;
    }, TextProperty.prototype.completeTextData = function(_t) {
      _t.__complete = !0;
      var Et, Pt, $t, Mt, Bt, Vt, zt, Ht = this.elem.globalData.fontManager, Wt = this.data, Gt = [], qt = 0, Kt = Wt.m.g, Qt = 0, Xt = 0, Zt = 0, Yt = [], Jt = 0, er = 0, tr = Ht.getFontByName(_t.f), nr = 0, rr = getFontProperties(tr);
      _t.fWeight = rr.weight, _t.fStyle = rr.style, _t.finalSize = _t.s, _t.finalText = this.buildFinalText(_t.t), Pt = _t.finalText.length, _t.finalLineHeight = _t.lh;
      var ir, ar = _t.tr / 1e3 * _t.finalSize;
      if (_t.sz)
        for (var or, sr, lr = !0, cr = _t.sz[0], hr = _t.sz[1]; lr; ) {
          or = 0, Jt = 0, Pt = (sr = this.buildFinalText(_t.t)).length, ar = _t.tr / 1e3 * _t.finalSize;
          var pr = -1;
          for (Et = 0; Et < Pt; Et += 1)
            ir = sr[Et].charCodeAt(0), $t = !1, sr[Et] === " " ? pr = Et : ir !== 13 && ir !== 3 || (Jt = 0, $t = !0, or += _t.finalLineHeight || 1.2 * _t.finalSize), Ht.chars ? (zt = Ht.getCharData(sr[Et], tr.fStyle, tr.fFamily), nr = $t ? 0 : zt.w * _t.finalSize / 100) : nr = Ht.measureText(sr[Et], _t.f, _t.finalSize), Jt + nr > cr && sr[Et] !== " " ? (pr === -1 ? Pt += 1 : Et = pr, or += _t.finalLineHeight || 1.2 * _t.finalSize, sr.splice(Et, pr === Et ? 1 : 0, "\r"), pr = -1, Jt = 0) : (Jt += nr, Jt += ar);
          or += tr.ascent * _t.finalSize / 100, this.canResize && _t.finalSize > this.minimumFontSize && hr < or ? (_t.finalSize -= 1, _t.finalLineHeight = _t.finalSize * _t.lh / _t.s) : (_t.finalText = sr, Pt = _t.finalText.length, lr = !1);
        }
      Jt = -ar, nr = 0;
      var mr, Er = 0;
      for (Et = 0; Et < Pt; Et += 1)
        if ($t = !1, (ir = (mr = _t.finalText[Et]).charCodeAt(0)) === 13 || ir === 3 ? (Er = 0, Yt.push(Jt), er = Jt > er ? Jt : er, Jt = -2 * ar, Mt = "", $t = !0, Zt += 1) : Mt = mr, Ht.chars ? (zt = Ht.getCharData(mr, tr.fStyle, Ht.getFontByName(_t.f).fFamily), nr = $t ? 0 : zt.w * _t.finalSize / 100) : nr = Ht.measureText(Mt, _t.f, _t.finalSize), mr === " " ? Er += nr + ar : (Jt += nr + ar + Er, Er = 0), Gt.push({ l: nr, an: nr, add: Qt, n: $t, anIndexes: [], val: Mt, line: Zt, animatorJustifyOffset: 0 }), Kt == 2) {
          if (Qt += nr, Mt === "" || Mt === " " || Et === Pt - 1) {
            for (Mt !== "" && Mt !== " " || (Qt -= nr); Xt <= Et; )
              Gt[Xt].an = Qt, Gt[Xt].ind = qt, Gt[Xt].extra = nr, Xt += 1;
            qt += 1, Qt = 0;
          }
        } else if (Kt == 3) {
          if (Qt += nr, Mt === "" || Et === Pt - 1) {
            for (Mt === "" && (Qt -= nr); Xt <= Et; )
              Gt[Xt].an = Qt, Gt[Xt].ind = qt, Gt[Xt].extra = nr, Xt += 1;
            Qt = 0, qt += 1;
          }
        } else
          Gt[qt].ind = qt, Gt[qt].extra = 0, qt += 1;
      if (_t.l = Gt, er = Jt > er ? Jt : er, Yt.push(Jt), _t.sz)
        _t.boxWidth = _t.sz[0], _t.justifyOffset = 0;
      else
        switch (_t.boxWidth = er, _t.j) {
          case 1:
            _t.justifyOffset = -_t.boxWidth;
            break;
          case 2:
            _t.justifyOffset = -_t.boxWidth / 2;
            break;
          default:
            _t.justifyOffset = 0;
        }
      _t.lineWidths = Yt;
      var _r, yr, ur, vr, dr = Wt.a;
      Vt = dr.length;
      var br = [];
      for (Bt = 0; Bt < Vt; Bt += 1) {
        for ((_r = dr[Bt]).a.sc && (_t.strokeColorAnim = !0), _r.a.sw && (_t.strokeWidthAnim = !0), (_r.a.fc || _r.a.fh || _r.a.fs || _r.a.fb) && (_t.fillColorAnim = !0), vr = 0, ur = _r.s.b, Et = 0; Et < Pt; Et += 1)
          (yr = Gt[Et]).anIndexes[Bt] = vr, (ur == 1 && yr.val !== "" || ur == 2 && yr.val !== "" && yr.val !== " " || ur == 3 && (yr.n || yr.val == " " || Et == Pt - 1) || ur == 4 && (yr.n || Et == Pt - 1)) && (_r.s.rn === 1 && br.push(vr), vr += 1);
        Wt.a[Bt].s.totalChars = vr;
        var Cr, Pr = -1;
        if (_r.s.rn === 1)
          for (Et = 0; Et < Pt; Et += 1)
            Pr != (yr = Gt[Et]).anIndexes[Bt] && (Pr = yr.anIndexes[Bt], Cr = br.splice(Math.floor(Math.random() * br.length), 1)[0]), yr.anIndexes[Bt] = Cr;
      }
      _t.yOffset = _t.finalLineHeight || 1.2 * _t.finalSize, _t.ls = _t.ls || 0, _t.ascent = tr.ascent * _t.finalSize / 100;
    }, TextProperty.prototype.updateDocumentData = function(_t, Et) {
      Et = Et === void 0 ? this.keysIndex : Et;
      var Pt = this.copyData({}, this.data.d.k[Et].s);
      Pt = this.copyData(Pt, _t), this.data.d.k[Et].s = Pt, this.recalculate(Et), this.setCurrentData(Pt), this.elem.addDynamicProperty(this);
    }, TextProperty.prototype.recalculate = function(_t) {
      var Et = this.data.d.k[_t].s;
      Et.__complete = !1, this.keysIndex = 0, this._isFirstFrame = !0, this.getValue(Et);
    }, TextProperty.prototype.canResizeFont = function(_t) {
      this.canResize = _t, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
    }, TextProperty.prototype.setMinimumFontSize = function(_t) {
      this.minimumFontSize = Math.floor(_t) || 1, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
    };
    var TextSelectorProp = function() {
      var _t = Math.max, Et = Math.min, Pt = Math.floor;
      function $t(Mt, Bt) {
        this._currentTextLength = -1, this.k = !1, this.data = Bt, this.elem = Mt, this.comp = Mt.comp, this.finalS = 0, this.finalE = 0, this.initDynamicPropertyContainer(Mt), this.s = PropertyFactory.getProp(Mt, Bt.s || { k: 0 }, 0, 0, this), this.e = "e" in Bt ? PropertyFactory.getProp(Mt, Bt.e, 0, 0, this) : { v: 100 }, this.o = PropertyFactory.getProp(Mt, Bt.o || { k: 0 }, 0, 0, this), this.xe = PropertyFactory.getProp(Mt, Bt.xe || { k: 0 }, 0, 0, this), this.ne = PropertyFactory.getProp(Mt, Bt.ne || { k: 0 }, 0, 0, this), this.sm = PropertyFactory.getProp(Mt, Bt.sm || { k: 100 }, 0, 0, this), this.a = PropertyFactory.getProp(Mt, Bt.a, 0, 0.01, this), this.dynamicProperties.length || this.getValue();
      }
      return $t.prototype = { getMult: function(Mt) {
        this._currentTextLength !== this.elem.textProperty.currentData.l.length && this.getValue();
        var Bt = 0, Vt = 0, zt = 1, Ht = 1;
        this.ne.v > 0 ? Bt = this.ne.v / 100 : Vt = -this.ne.v / 100, this.xe.v > 0 ? zt = 1 - this.xe.v / 100 : Ht = 1 + this.xe.v / 100;
        var Wt = BezierFactory.getBezierEasing(Bt, Vt, zt, Ht).get, Gt = 0, qt = this.finalS, Kt = this.finalE, Qt = this.data.sh;
        if (Qt === 2)
          Gt = Wt(Gt = Kt === qt ? Mt >= Kt ? 1 : 0 : _t(0, Et(0.5 / (Kt - qt) + (Mt - qt) / (Kt - qt), 1)));
        else if (Qt === 3)
          Gt = Wt(Gt = Kt === qt ? Mt >= Kt ? 0 : 1 : 1 - _t(0, Et(0.5 / (Kt - qt) + (Mt - qt) / (Kt - qt), 1)));
        else if (Qt === 4)
          Kt === qt ? Gt = 0 : (Gt = _t(0, Et(0.5 / (Kt - qt) + (Mt - qt) / (Kt - qt), 1))) < 0.5 ? Gt *= 2 : Gt = 1 - 2 * (Gt - 0.5), Gt = Wt(Gt);
        else if (Qt === 5) {
          if (Kt === qt)
            Gt = 0;
          else {
            var Xt = Kt - qt, Zt = -Xt / 2 + (Mt = Et(_t(0, Mt + 0.5 - qt), Kt - qt)), Yt = Xt / 2;
            Gt = Math.sqrt(1 - Zt * Zt / (Yt * Yt));
          }
          Gt = Wt(Gt);
        } else
          Qt === 6 ? (Kt === qt ? Gt = 0 : (Mt = Et(_t(0, Mt + 0.5 - qt), Kt - qt), Gt = (1 + Math.cos(Math.PI + 2 * Math.PI * Mt / (Kt - qt))) / 2), Gt = Wt(Gt)) : (Mt >= Pt(qt) && (Gt = _t(0, Et(Mt - qt < 0 ? Et(Kt, 1) - (qt - Mt) : Kt - Mt, 1))), Gt = Wt(Gt));
        if (this.sm.v !== 100) {
          var Jt = 0.01 * this.sm.v;
          Jt === 0 && (Jt = 1e-8);
          var er = 0.5 - 0.5 * Jt;
          Gt < er ? Gt = 0 : (Gt = (Gt - er) / Jt) > 1 && (Gt = 1);
        }
        return Gt * this.a.v;
      }, getValue: function(Mt) {
        this.iterateDynamicProperties(), this._mdf = Mt || this._mdf, this._currentTextLength = this.elem.textProperty.currentData.l.length || 0, Mt && this.data.r === 2 && (this.e.v = this._currentTextLength);
        var Bt = this.data.r === 2 ? 1 : 100 / this.data.totalChars, Vt = this.o.v / Bt, zt = this.s.v / Bt + Vt, Ht = this.e.v / Bt + Vt;
        if (zt > Ht) {
          var Wt = zt;
          zt = Ht, Ht = Wt;
        }
        this.finalS = zt, this.finalE = Ht;
      } }, extendPrototype([DynamicPropertyContainer], $t), { getTextSelectorProp: function(Mt, Bt, Vt) {
        return new $t(Mt, Bt);
      } };
    }();
    function TextAnimatorDataProperty(_t, Et, Pt) {
      var $t = { propType: !1 }, Mt = PropertyFactory.getProp, Bt = Et.a;
      this.a = { r: Bt.r ? Mt(_t, Bt.r, 0, degToRads, Pt) : $t, rx: Bt.rx ? Mt(_t, Bt.rx, 0, degToRads, Pt) : $t, ry: Bt.ry ? Mt(_t, Bt.ry, 0, degToRads, Pt) : $t, sk: Bt.sk ? Mt(_t, Bt.sk, 0, degToRads, Pt) : $t, sa: Bt.sa ? Mt(_t, Bt.sa, 0, degToRads, Pt) : $t, s: Bt.s ? Mt(_t, Bt.s, 1, 0.01, Pt) : $t, a: Bt.a ? Mt(_t, Bt.a, 1, 0, Pt) : $t, o: Bt.o ? Mt(_t, Bt.o, 0, 0.01, Pt) : $t, p: Bt.p ? Mt(_t, Bt.p, 1, 0, Pt) : $t, sw: Bt.sw ? Mt(_t, Bt.sw, 0, 0, Pt) : $t, sc: Bt.sc ? Mt(_t, Bt.sc, 1, 0, Pt) : $t, fc: Bt.fc ? Mt(_t, Bt.fc, 1, 0, Pt) : $t, fh: Bt.fh ? Mt(_t, Bt.fh, 0, 0, Pt) : $t, fs: Bt.fs ? Mt(_t, Bt.fs, 0, 0.01, Pt) : $t, fb: Bt.fb ? Mt(_t, Bt.fb, 0, 0.01, Pt) : $t, t: Bt.t ? Mt(_t, Bt.t, 0, 0, Pt) : $t }, this.s = TextSelectorProp.getTextSelectorProp(_t, Et.s, Pt), this.s.t = Et.s.t;
    }
    function TextAnimatorProperty(_t, Et, Pt) {
      this._isFirstFrame = !0, this._hasMaskedPath = !1, this._frameId = -1, this._textData = _t, this._renderType = Et, this._elem = Pt, this._animatorsData = createSizedArray(this._textData.a.length), this._pathData = {}, this._moreOptions = { alignment: {} }, this.renderedLetters = [], this.lettersChangedFlag = !1, this.initDynamicPropertyContainer(Pt);
    }
    function ITextElement() {
    }
    TextAnimatorProperty.prototype.searchProperties = function() {
      var _t, Et, Pt = this._textData.a.length, $t = PropertyFactory.getProp;
      for (_t = 0; _t < Pt; _t += 1)
        Et = this._textData.a[_t], this._animatorsData[_t] = new TextAnimatorDataProperty(this._elem, Et, this);
      this._textData.p && "m" in this._textData.p ? (this._pathData = { a: $t(this._elem, this._textData.p.a, 0, 0, this), f: $t(this._elem, this._textData.p.f, 0, 0, this), l: $t(this._elem, this._textData.p.l, 0, 0, this), r: $t(this._elem, this._textData.p.r, 0, 0, this), p: $t(this._elem, this._textData.p.p, 0, 0, this), m: this._elem.maskManager.getMaskProperty(this._textData.p.m) }, this._hasMaskedPath = !0) : this._hasMaskedPath = !1, this._moreOptions.alignment = $t(this._elem, this._textData.m.a, 1, 0, this);
    }, TextAnimatorProperty.prototype.getMeasures = function(_t, Et) {
      if (this.lettersChangedFlag = Et, this._mdf || this._isFirstFrame || Et || this._hasMaskedPath && this._pathData.m._mdf) {
        this._isFirstFrame = !1;
        var Pt, $t, Mt, Bt, Vt, zt, Ht, Wt, Gt, qt, Kt, Qt, Xt, Zt, Yt, Jt, er, tr, nr, rr = this._moreOptions.alignment.v, ir = this._animatorsData, ar = this._textData, or = this.mHelper, sr = this._renderType, lr = this.renderedLetters.length, cr = _t.l;
        if (this._hasMaskedPath) {
          if (nr = this._pathData.m, !this._pathData.n || this._pathData._mdf) {
            var hr, pr = nr.v;
            for (this._pathData.r.v && (pr = pr.reverse()), Vt = { tLength: 0, segments: [] }, Bt = pr._length - 1, Jt = 0, Mt = 0; Mt < Bt; Mt += 1)
              hr = bez.buildBezierData(pr.v[Mt], pr.v[Mt + 1], [pr.o[Mt][0] - pr.v[Mt][0], pr.o[Mt][1] - pr.v[Mt][1]], [pr.i[Mt + 1][0] - pr.v[Mt + 1][0], pr.i[Mt + 1][1] - pr.v[Mt + 1][1]]), Vt.tLength += hr.segmentLength, Vt.segments.push(hr), Jt += hr.segmentLength;
            Mt = Bt, nr.v.c && (hr = bez.buildBezierData(pr.v[Mt], pr.v[0], [pr.o[Mt][0] - pr.v[Mt][0], pr.o[Mt][1] - pr.v[Mt][1]], [pr.i[0][0] - pr.v[0][0], pr.i[0][1] - pr.v[0][1]]), Vt.tLength += hr.segmentLength, Vt.segments.push(hr), Jt += hr.segmentLength), this._pathData.pi = Vt;
          }
          if (Vt = this._pathData.pi, zt = this._pathData.f.v, Kt = 0, qt = 1, Wt = 0, Gt = !0, Zt = Vt.segments, zt < 0 && nr.v.c)
            for (Vt.tLength < Math.abs(zt) && (zt = -Math.abs(zt) % Vt.tLength), qt = (Xt = Zt[Kt = Zt.length - 1].points).length - 1; zt < 0; )
              zt += Xt[qt].partialLength, (qt -= 1) < 0 && (qt = (Xt = Zt[Kt -= 1].points).length - 1);
          Qt = (Xt = Zt[Kt].points)[qt - 1], Yt = (Ht = Xt[qt]).partialLength;
        }
        Bt = cr.length, Pt = 0, $t = 0;
        var mr, Er, _r, yr, ur, vr = 1.2 * _t.finalSize * 0.714, dr = !0;
        _r = ir.length;
        var br, Cr, Pr, xr, kr, Ir, Ar, Mr, Fr, Dr, zr, Tr, Gr = -1, $r = zt, Rr = Kt, Or = qt, Lr = -1, Hr = "", Wr = this.defaultPropsArray;
        if (_t.j === 2 || _t.j === 1) {
          var Kr = 0, Ur = 0, Zr = _t.j === 2 ? -0.5 : -1, Xr = 0, mn = !0;
          for (Mt = 0; Mt < Bt; Mt += 1)
            if (cr[Mt].n) {
              for (Kr && (Kr += Ur); Xr < Mt; )
                cr[Xr].animatorJustifyOffset = Kr, Xr += 1;
              Kr = 0, mn = !0;
            } else {
              for (Er = 0; Er < _r; Er += 1)
                (mr = ir[Er].a).t.propType && (mn && _t.j === 2 && (Ur += mr.t.v * Zr), (ur = ir[Er].s.getMult(cr[Mt].anIndexes[Er], ar.a[Er].s.totalChars)).length ? Kr += mr.t.v * ur[0] * Zr : Kr += mr.t.v * ur * Zr);
              mn = !1;
            }
          for (Kr && (Kr += Ur); Xr < Mt; )
            cr[Xr].animatorJustifyOffset = Kr, Xr += 1;
        }
        for (Mt = 0; Mt < Bt; Mt += 1) {
          if (or.reset(), xr = 1, cr[Mt].n)
            Pt = 0, $t += _t.yOffset, $t += dr ? 1 : 0, zt = $r, dr = !1, this._hasMaskedPath && (qt = Or, Qt = (Xt = Zt[Kt = Rr].points)[qt - 1], Yt = (Ht = Xt[qt]).partialLength, Wt = 0), Hr = "", zr = "", Fr = "", Tr = "", Wr = this.defaultPropsArray;
          else {
            if (this._hasMaskedPath) {
              if (Lr !== cr[Mt].line) {
                switch (_t.j) {
                  case 1:
                    zt += Jt - _t.lineWidths[cr[Mt].line];
                    break;
                  case 2:
                    zt += (Jt - _t.lineWidths[cr[Mt].line]) / 2;
                }
                Lr = cr[Mt].line;
              }
              Gr !== cr[Mt].ind && (cr[Gr] && (zt += cr[Gr].extra), zt += cr[Mt].an / 2, Gr = cr[Mt].ind), zt += rr[0] * cr[Mt].an * 5e-3;
              var an = 0;
              for (Er = 0; Er < _r; Er += 1)
                (mr = ir[Er].a).p.propType && ((ur = ir[Er].s.getMult(cr[Mt].anIndexes[Er], ar.a[Er].s.totalChars)).length ? an += mr.p.v[0] * ur[0] : an += mr.p.v[0] * ur), mr.a.propType && ((ur = ir[Er].s.getMult(cr[Mt].anIndexes[Er], ar.a[Er].s.totalChars)).length ? an += mr.a.v[0] * ur[0] : an += mr.a.v[0] * ur);
              for (Gt = !0, this._pathData.a.v && (zt = 0.5 * cr[0].an + (Jt - this._pathData.f.v - 0.5 * cr[0].an - 0.5 * cr[cr.length - 1].an) * Gr / (Bt - 1), zt += this._pathData.f.v); Gt; )
                Wt + Yt >= zt + an || !Xt ? (er = (zt + an - Wt) / Ht.partialLength, Cr = Qt.point[0] + (Ht.point[0] - Qt.point[0]) * er, Pr = Qt.point[1] + (Ht.point[1] - Qt.point[1]) * er, or.translate(-rr[0] * cr[Mt].an * 5e-3, -rr[1] * vr * 0.01), Gt = !1) : Xt && (Wt += Ht.partialLength, (qt += 1) >= Xt.length && (qt = 0, Zt[Kt += 1] ? Xt = Zt[Kt].points : nr.v.c ? (qt = 0, Xt = Zt[Kt = 0].points) : (Wt -= Ht.partialLength, Xt = null)), Xt && (Qt = Ht, Yt = (Ht = Xt[qt]).partialLength));
              br = cr[Mt].an / 2 - cr[Mt].add, or.translate(-br, 0, 0);
            } else
              br = cr[Mt].an / 2 - cr[Mt].add, or.translate(-br, 0, 0), or.translate(-rr[0] * cr[Mt].an * 5e-3, -rr[1] * vr * 0.01, 0);
            for (Er = 0; Er < _r; Er += 1)
              (mr = ir[Er].a).t.propType && (ur = ir[Er].s.getMult(cr[Mt].anIndexes[Er], ar.a[Er].s.totalChars), Pt === 0 && _t.j === 0 || (this._hasMaskedPath ? ur.length ? zt += mr.t.v * ur[0] : zt += mr.t.v * ur : ur.length ? Pt += mr.t.v * ur[0] : Pt += mr.t.v * ur));
            for (_t.strokeWidthAnim && (Ir = _t.sw || 0), _t.strokeColorAnim && (kr = _t.sc ? [_t.sc[0], _t.sc[1], _t.sc[2]] : [0, 0, 0]), _t.fillColorAnim && _t.fc && (Ar = [_t.fc[0], _t.fc[1], _t.fc[2]]), Er = 0; Er < _r; Er += 1)
              (mr = ir[Er].a).a.propType && ((ur = ir[Er].s.getMult(cr[Mt].anIndexes[Er], ar.a[Er].s.totalChars)).length ? or.translate(-mr.a.v[0] * ur[0], -mr.a.v[1] * ur[1], mr.a.v[2] * ur[2]) : or.translate(-mr.a.v[0] * ur, -mr.a.v[1] * ur, mr.a.v[2] * ur));
            for (Er = 0; Er < _r; Er += 1)
              (mr = ir[Er].a).s.propType && ((ur = ir[Er].s.getMult(cr[Mt].anIndexes[Er], ar.a[Er].s.totalChars)).length ? or.scale(1 + (mr.s.v[0] - 1) * ur[0], 1 + (mr.s.v[1] - 1) * ur[1], 1) : or.scale(1 + (mr.s.v[0] - 1) * ur, 1 + (mr.s.v[1] - 1) * ur, 1));
            for (Er = 0; Er < _r; Er += 1) {
              if (mr = ir[Er].a, ur = ir[Er].s.getMult(cr[Mt].anIndexes[Er], ar.a[Er].s.totalChars), mr.sk.propType && (ur.length ? or.skewFromAxis(-mr.sk.v * ur[0], mr.sa.v * ur[1]) : or.skewFromAxis(-mr.sk.v * ur, mr.sa.v * ur)), mr.r.propType && (ur.length ? or.rotateZ(-mr.r.v * ur[2]) : or.rotateZ(-mr.r.v * ur)), mr.ry.propType && (ur.length ? or.rotateY(mr.ry.v * ur[1]) : or.rotateY(mr.ry.v * ur)), mr.rx.propType && (ur.length ? or.rotateX(mr.rx.v * ur[0]) : or.rotateX(mr.rx.v * ur)), mr.o.propType && (ur.length ? xr += (mr.o.v * ur[0] - xr) * ur[0] : xr += (mr.o.v * ur - xr) * ur), _t.strokeWidthAnim && mr.sw.propType && (ur.length ? Ir += mr.sw.v * ur[0] : Ir += mr.sw.v * ur), _t.strokeColorAnim && mr.sc.propType)
                for (Mr = 0; Mr < 3; Mr += 1)
                  ur.length ? kr[Mr] += (mr.sc.v[Mr] - kr[Mr]) * ur[0] : kr[Mr] += (mr.sc.v[Mr] - kr[Mr]) * ur;
              if (_t.fillColorAnim && _t.fc) {
                if (mr.fc.propType)
                  for (Mr = 0; Mr < 3; Mr += 1)
                    ur.length ? Ar[Mr] += (mr.fc.v[Mr] - Ar[Mr]) * ur[0] : Ar[Mr] += (mr.fc.v[Mr] - Ar[Mr]) * ur;
                mr.fh.propType && (Ar = ur.length ? addHueToRGB(Ar, mr.fh.v * ur[0]) : addHueToRGB(Ar, mr.fh.v * ur)), mr.fs.propType && (Ar = ur.length ? addSaturationToRGB(Ar, mr.fs.v * ur[0]) : addSaturationToRGB(Ar, mr.fs.v * ur)), mr.fb.propType && (Ar = ur.length ? addBrightnessToRGB(Ar, mr.fb.v * ur[0]) : addBrightnessToRGB(Ar, mr.fb.v * ur));
              }
            }
            for (Er = 0; Er < _r; Er += 1)
              (mr = ir[Er].a).p.propType && (ur = ir[Er].s.getMult(cr[Mt].anIndexes[Er], ar.a[Er].s.totalChars), this._hasMaskedPath ? ur.length ? or.translate(0, mr.p.v[1] * ur[0], -mr.p.v[2] * ur[1]) : or.translate(0, mr.p.v[1] * ur, -mr.p.v[2] * ur) : ur.length ? or.translate(mr.p.v[0] * ur[0], mr.p.v[1] * ur[1], -mr.p.v[2] * ur[2]) : or.translate(mr.p.v[0] * ur, mr.p.v[1] * ur, -mr.p.v[2] * ur));
            if (_t.strokeWidthAnim && (Fr = Ir < 0 ? 0 : Ir), _t.strokeColorAnim && (Dr = "rgb(" + Math.round(255 * kr[0]) + "," + Math.round(255 * kr[1]) + "," + Math.round(255 * kr[2]) + ")"), _t.fillColorAnim && _t.fc && (zr = "rgb(" + Math.round(255 * Ar[0]) + "," + Math.round(255 * Ar[1]) + "," + Math.round(255 * Ar[2]) + ")"), this._hasMaskedPath) {
              if (or.translate(0, -_t.ls), or.translate(0, rr[1] * vr * 0.01 + $t, 0), this._pathData.p.v) {
                tr = (Ht.point[1] - Qt.point[1]) / (Ht.point[0] - Qt.point[0]);
                var nn = 180 * Math.atan(tr) / Math.PI;
                Ht.point[0] < Qt.point[0] && (nn += 180), or.rotate(-nn * Math.PI / 180);
              }
              or.translate(Cr, Pr, 0), zt -= rr[0] * cr[Mt].an * 5e-3, cr[Mt + 1] && Gr !== cr[Mt + 1].ind && (zt += cr[Mt].an / 2, zt += 1e-3 * _t.tr * _t.finalSize);
            } else {
              switch (or.translate(Pt, $t, 0), _t.ps && or.translate(_t.ps[0], _t.ps[1] + _t.ascent, 0), _t.j) {
                case 1:
                  or.translate(cr[Mt].animatorJustifyOffset + _t.justifyOffset + (_t.boxWidth - _t.lineWidths[cr[Mt].line]), 0, 0);
                  break;
                case 2:
                  or.translate(cr[Mt].animatorJustifyOffset + _t.justifyOffset + (_t.boxWidth - _t.lineWidths[cr[Mt].line]) / 2, 0, 0);
              }
              or.translate(0, -_t.ls), or.translate(br, 0, 0), or.translate(rr[0] * cr[Mt].an * 5e-3, rr[1] * vr * 0.01, 0), Pt += cr[Mt].l + 1e-3 * _t.tr * _t.finalSize;
            }
            sr === "html" ? Hr = or.toCSS() : sr === "svg" ? Hr = or.to2dCSS() : Wr = [or.props[0], or.props[1], or.props[2], or.props[3], or.props[4], or.props[5], or.props[6], or.props[7], or.props[8], or.props[9], or.props[10], or.props[11], or.props[12], or.props[13], or.props[14], or.props[15]], Tr = xr;
          }
          lr <= Mt ? (yr = new LetterProps(Tr, Fr, Dr, zr, Hr, Wr), this.renderedLetters.push(yr), lr += 1, this.lettersChangedFlag = !0) : (yr = this.renderedLetters[Mt], this.lettersChangedFlag = yr.update(Tr, Fr, Dr, zr, Hr, Wr) || this.lettersChangedFlag);
        }
      }
    }, TextAnimatorProperty.prototype.getValue = function() {
      this._elem.globalData.frameId !== this._frameId && (this._frameId = this._elem.globalData.frameId, this.iterateDynamicProperties());
    }, TextAnimatorProperty.prototype.mHelper = new Matrix(), TextAnimatorProperty.prototype.defaultPropsArray = [], extendPrototype([DynamicPropertyContainer], TextAnimatorProperty), ITextElement.prototype.initElement = function(_t, Et, Pt) {
      this.lettersChangedFlag = !0, this.initFrame(), this.initBaseData(_t, Et, Pt), this.textProperty = new TextProperty(this, _t.t, this.dynamicProperties), this.textAnimator = new TextAnimatorProperty(_t.t, this.renderType, this), this.initTransform(_t, Et, Pt), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide(), this.textAnimator.searchProperties(this.dynamicProperties);
    }, ITextElement.prototype.prepareFrame = function(_t) {
      this._mdf = !1, this.prepareRenderableFrame(_t), this.prepareProperties(_t, this.isInRange);
    }, ITextElement.prototype.createPathShape = function(_t, Et) {
      var Pt, $t, Mt = Et.length, Bt = "";
      for (Pt = 0; Pt < Mt; Pt += 1)
        Et[Pt].ty === "sh" && ($t = Et[Pt].ks.k, Bt += buildShapeString($t, $t.i.length, !0, _t));
      return Bt;
    }, ITextElement.prototype.updateDocumentData = function(_t, Et) {
      this.textProperty.updateDocumentData(_t, Et);
    }, ITextElement.prototype.canResizeFont = function(_t) {
      this.textProperty.canResizeFont(_t);
    }, ITextElement.prototype.setMinimumFontSize = function(_t) {
      this.textProperty.setMinimumFontSize(_t);
    }, ITextElement.prototype.applyTextPropertiesToMatrix = function(_t, Et, Pt, $t, Mt) {
      switch (_t.ps && Et.translate(_t.ps[0], _t.ps[1] + _t.ascent, 0), Et.translate(0, -_t.ls, 0), _t.j) {
        case 1:
          Et.translate(_t.justifyOffset + (_t.boxWidth - _t.lineWidths[Pt]), 0, 0);
          break;
        case 2:
          Et.translate(_t.justifyOffset + (_t.boxWidth - _t.lineWidths[Pt]) / 2, 0, 0);
      }
      Et.translate($t, Mt, 0);
    }, ITextElement.prototype.buildColor = function(_t) {
      return "rgb(" + Math.round(255 * _t[0]) + "," + Math.round(255 * _t[1]) + "," + Math.round(255 * _t[2]) + ")";
    }, ITextElement.prototype.emptyProp = new LetterProps(), ITextElement.prototype.destroy = function() {
    }, ITextElement.prototype.validateText = function() {
      (this.textProperty._mdf || this.textProperty._isFirstFrame) && (this.buildNewText(), this.textProperty._isFirstFrame = !1, this.textProperty._mdf = !1);
    };
    var emptyShapeData = { shapes: [] };
    function SVGTextLottieElement(_t, Et, Pt) {
      this.textSpans = [], this.renderType = "svg", this.initElement(_t, Et, Pt);
    }
    function ISolidElement(_t, Et, Pt) {
      this.initElement(_t, Et, Pt);
    }
    function NullElement(_t, Et, Pt) {
      this.initFrame(), this.initBaseData(_t, Et, Pt), this.initFrame(), this.initTransform(_t, Et, Pt), this.initHierarchy();
    }
    function SVGRendererBase() {
    }
    function ICompElement() {
    }
    function SVGCompElement(_t, Et, Pt) {
      this.layers = _t.layers, this.supports3d = !0, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(_t, Et, Pt), this.tm = _t.tm ? PropertyFactory.getProp(this, _t.tm, 0, Et.frameRate, this) : { _placeholder: !0 };
    }
    function SVGRenderer(_t, Et) {
      this.animationItem = _t, this.layers = null, this.renderedFrame = -1, this.svgElement = createNS("svg");
      var Pt = "";
      if (Et && Et.title) {
        var $t = createNS("title"), Mt = createElementID();
        $t.setAttribute("id", Mt), $t.textContent = Et.title, this.svgElement.appendChild($t), Pt += Mt;
      }
      if (Et && Et.description) {
        var Bt = createNS("desc"), Vt = createElementID();
        Bt.setAttribute("id", Vt), Bt.textContent = Et.description, this.svgElement.appendChild(Bt), Pt += " " + Vt;
      }
      Pt && this.svgElement.setAttribute("aria-labelledby", Pt);
      var zt = createNS("defs");
      this.svgElement.appendChild(zt);
      var Ht = createNS("g");
      this.svgElement.appendChild(Ht), this.layerElement = Ht, this.renderConfig = { preserveAspectRatio: Et && Et.preserveAspectRatio || "xMidYMid meet", imagePreserveAspectRatio: Et && Et.imagePreserveAspectRatio || "xMidYMid slice", contentVisibility: Et && Et.contentVisibility || "visible", progressiveLoad: Et && Et.progressiveLoad || !1, hideOnTransparent: !(Et && Et.hideOnTransparent === !1), viewBoxOnly: Et && Et.viewBoxOnly || !1, viewBoxSize: Et && Et.viewBoxSize || !1, className: Et && Et.className || "", id: Et && Et.id || "", focusable: Et && Et.focusable, filterSize: { width: Et && Et.filterSize && Et.filterSize.width || "100%", height: Et && Et.filterSize && Et.filterSize.height || "100%", x: Et && Et.filterSize && Et.filterSize.x || "0%", y: Et && Et.filterSize && Et.filterSize.y || "0%" }, width: Et && Et.width, height: Et && Et.height, runExpressions: !Et || Et.runExpressions === void 0 || Et.runExpressions }, this.globalData = { _mdf: !1, frameNum: -1, defs: zt, renderConfig: this.renderConfig }, this.elements = [], this.pendingElements = [], this.destroyed = !1, this.rendererType = "svg";
    }
    function ShapeTransformManager() {
      this.sequences = {}, this.sequenceList = [], this.transform_key_count = 0;
    }
    extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], SVGTextLottieElement), SVGTextLottieElement.prototype.createContent = function() {
      this.data.singleShape && !this.globalData.fontManager.chars && (this.textContainer = createNS("text"));
    }, SVGTextLottieElement.prototype.buildTextContents = function(_t) {
      for (var Et = 0, Pt = _t.length, $t = [], Mt = ""; Et < Pt; )
        _t[Et] === "\r" || _t[Et] === "" ? ($t.push(Mt), Mt = "") : Mt += _t[Et], Et += 1;
      return $t.push(Mt), $t;
    }, SVGTextLottieElement.prototype.buildShapeData = function(_t, Et) {
      if (_t.shapes && _t.shapes.length) {
        var Pt = _t.shapes[0];
        if (Pt.it) {
          var $t = Pt.it[Pt.it.length - 1];
          $t.s && ($t.s.k[0] = Et, $t.s.k[1] = Et);
        }
      }
      return _t;
    }, SVGTextLottieElement.prototype.buildNewText = function() {
      var _t, Et;
      this.addDynamicProperty(this);
      var Pt = this.textProperty.currentData;
      this.renderedLetters = createSizedArray(Pt ? Pt.l.length : 0), Pt.fc ? this.layerElement.setAttribute("fill", this.buildColor(Pt.fc)) : this.layerElement.setAttribute("fill", "rgba(0,0,0,0)"), Pt.sc && (this.layerElement.setAttribute("stroke", this.buildColor(Pt.sc)), this.layerElement.setAttribute("stroke-width", Pt.sw)), this.layerElement.setAttribute("font-size", Pt.finalSize);
      var $t = this.globalData.fontManager.getFontByName(Pt.f);
      if ($t.fClass)
        this.layerElement.setAttribute("class", $t.fClass);
      else {
        this.layerElement.setAttribute("font-family", $t.fFamily);
        var Mt = Pt.fWeight, Bt = Pt.fStyle;
        this.layerElement.setAttribute("font-style", Bt), this.layerElement.setAttribute("font-weight", Mt);
      }
      this.layerElement.setAttribute("aria-label", Pt.t);
      var Vt, zt = Pt.l || [], Ht = !!this.globalData.fontManager.chars;
      Et = zt.length;
      var Wt = this.mHelper, Gt = this.data.singleShape, qt = 0, Kt = 0, Qt = !0, Xt = 1e-3 * Pt.tr * Pt.finalSize;
      if (!Gt || Ht || Pt.sz) {
        var Zt, Yt = this.textSpans.length;
        for (_t = 0; _t < Et; _t += 1) {
          if (this.textSpans[_t] || (this.textSpans[_t] = { span: null, childSpan: null, glyph: null }), !Ht || !Gt || _t === 0) {
            if (Vt = Yt > _t ? this.textSpans[_t].span : createNS(Ht ? "g" : "text"), Yt <= _t) {
              if (Vt.setAttribute("stroke-linecap", "butt"), Vt.setAttribute("stroke-linejoin", "round"), Vt.setAttribute("stroke-miterlimit", "4"), this.textSpans[_t].span = Vt, Ht) {
                var Jt = createNS("g");
                Vt.appendChild(Jt), this.textSpans[_t].childSpan = Jt;
              }
              this.textSpans[_t].span = Vt, this.layerElement.appendChild(Vt);
            }
            Vt.style.display = "inherit";
          }
          if (Wt.reset(), Gt && (zt[_t].n && (qt = -Xt, Kt += Pt.yOffset, Kt += Qt ? 1 : 0, Qt = !1), this.applyTextPropertiesToMatrix(Pt, Wt, zt[_t].line, qt, Kt), qt += zt[_t].l || 0, qt += Xt), Ht) {
            var er;
            if ((Zt = this.globalData.fontManager.getCharData(Pt.finalText[_t], $t.fStyle, this.globalData.fontManager.getFontByName(Pt.f).fFamily)).t === 1)
              er = new SVGCompElement(Zt.data, this.globalData, this);
            else {
              var tr = emptyShapeData;
              Zt.data && Zt.data.shapes && (tr = this.buildShapeData(Zt.data, Pt.finalSize)), er = new SVGShapeElement(tr, this.globalData, this);
            }
            if (this.textSpans[_t].glyph) {
              var nr = this.textSpans[_t].glyph;
              this.textSpans[_t].childSpan.removeChild(nr.layerElement), nr.destroy();
            }
            this.textSpans[_t].glyph = er, er._debug = !0, er.prepareFrame(0), er.renderFrame(), this.textSpans[_t].childSpan.appendChild(er.layerElement), Zt.t === 1 && this.textSpans[_t].childSpan.setAttribute("transform", "scale(" + Pt.finalSize / 100 + "," + Pt.finalSize / 100 + ")");
          } else
            Gt && Vt.setAttribute("transform", "translate(" + Wt.props[12] + "," + Wt.props[13] + ")"), Vt.textContent = zt[_t].val, Vt.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve");
        }
        Gt && Vt && Vt.setAttribute("d", "");
      } else {
        var rr = this.textContainer, ir = "start";
        switch (Pt.j) {
          case 1:
            ir = "end";
            break;
          case 2:
            ir = "middle";
            break;
          default:
            ir = "start";
        }
        rr.setAttribute("text-anchor", ir), rr.setAttribute("letter-spacing", Xt);
        var ar = this.buildTextContents(Pt.finalText);
        for (Et = ar.length, Kt = Pt.ps ? Pt.ps[1] + Pt.ascent : 0, _t = 0; _t < Et; _t += 1)
          (Vt = this.textSpans[_t].span || createNS("tspan")).textContent = ar[_t], Vt.setAttribute("x", 0), Vt.setAttribute("y", Kt), Vt.style.display = "inherit", rr.appendChild(Vt), this.textSpans[_t] || (this.textSpans[_t] = { span: null, glyph: null }), this.textSpans[_t].span = Vt, Kt += Pt.finalLineHeight;
        this.layerElement.appendChild(rr);
      }
      for (; _t < this.textSpans.length; )
        this.textSpans[_t].span.style.display = "none", _t += 1;
      this._sizeChanged = !0;
    }, SVGTextLottieElement.prototype.sourceRectAtTime = function() {
      if (this.prepareFrame(this.comp.renderedFrame - this.data.st), this.renderInnerContent(), this._sizeChanged) {
        this._sizeChanged = !1;
        var _t = this.layerElement.getBBox();
        this.bbox = { top: _t.y, left: _t.x, width: _t.width, height: _t.height };
      }
      return this.bbox;
    }, SVGTextLottieElement.prototype.getValue = function() {
      var _t, Et, Pt = this.textSpans.length;
      for (this.renderedFrame = this.comp.renderedFrame, _t = 0; _t < Pt; _t += 1)
        (Et = this.textSpans[_t].glyph) && (Et.prepareFrame(this.comp.renderedFrame - this.data.st), Et._mdf && (this._mdf = !0));
    }, SVGTextLottieElement.prototype.renderInnerContent = function() {
      if (this.validateText(), (!this.data.singleShape || this._mdf) && (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)) {
        var _t, Et;
        this._sizeChanged = !0;
        var Pt, $t, Mt, Bt = this.textAnimator.renderedLetters, Vt = this.textProperty.currentData.l;
        for (Et = Vt.length, _t = 0; _t < Et; _t += 1)
          Vt[_t].n || (Pt = Bt[_t], $t = this.textSpans[_t].span, (Mt = this.textSpans[_t].glyph) && Mt.renderFrame(), Pt._mdf.m && $t.setAttribute("transform", Pt.m), Pt._mdf.o && $t.setAttribute("opacity", Pt.o), Pt._mdf.sw && $t.setAttribute("stroke-width", Pt.sw), Pt._mdf.sc && $t.setAttribute("stroke", Pt.sc), Pt._mdf.fc && $t.setAttribute("fill", Pt.fc));
      }
    }, extendPrototype([IImageElement], ISolidElement), ISolidElement.prototype.createContent = function() {
      var _t = createNS("rect");
      _t.setAttribute("width", this.data.sw), _t.setAttribute("height", this.data.sh), _t.setAttribute("fill", this.data.sc), this.layerElement.appendChild(_t);
    }, NullElement.prototype.prepareFrame = function(_t) {
      this.prepareProperties(_t, !0);
    }, NullElement.prototype.renderFrame = function() {
    }, NullElement.prototype.getBaseElement = function() {
      return null;
    }, NullElement.prototype.destroy = function() {
    }, NullElement.prototype.sourceRectAtTime = function() {
    }, NullElement.prototype.hide = function() {
    }, extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement], NullElement), extendPrototype([BaseRenderer], SVGRendererBase), SVGRendererBase.prototype.createNull = function(_t) {
      return new NullElement(_t, this.globalData, this);
    }, SVGRendererBase.prototype.createShape = function(_t) {
      return new SVGShapeElement(_t, this.globalData, this);
    }, SVGRendererBase.prototype.createText = function(_t) {
      return new SVGTextLottieElement(_t, this.globalData, this);
    }, SVGRendererBase.prototype.createImage = function(_t) {
      return new IImageElement(_t, this.globalData, this);
    }, SVGRendererBase.prototype.createSolid = function(_t) {
      return new ISolidElement(_t, this.globalData, this);
    }, SVGRendererBase.prototype.configAnimation = function(_t) {
      this.svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg"), this.svgElement.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink"), this.renderConfig.viewBoxSize ? this.svgElement.setAttribute("viewBox", this.renderConfig.viewBoxSize) : this.svgElement.setAttribute("viewBox", "0 0 " + _t.w + " " + _t.h), this.renderConfig.viewBoxOnly || (this.svgElement.setAttribute("width", _t.w), this.svgElement.setAttribute("height", _t.h), this.svgElement.style.width = "100%", this.svgElement.style.height = "100%", this.svgElement.style.transform = "translate3d(0,0,0)", this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility), this.renderConfig.width && this.svgElement.setAttribute("width", this.renderConfig.width), this.renderConfig.height && this.svgElement.setAttribute("height", this.renderConfig.height), this.renderConfig.className && this.svgElement.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.svgElement.setAttribute("id", this.renderConfig.id), this.renderConfig.focusable !== void 0 && this.svgElement.setAttribute("focusable", this.renderConfig.focusable), this.svgElement.setAttribute("preserveAspectRatio", this.renderConfig.preserveAspectRatio), this.animationItem.wrapper.appendChild(this.svgElement);
      var Et = this.globalData.defs;
      this.setupGlobalData(_t, Et), this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.data = _t;
      var Pt = createNS("clipPath"), $t = createNS("rect");
      $t.setAttribute("width", _t.w), $t.setAttribute("height", _t.h), $t.setAttribute("x", 0), $t.setAttribute("y", 0);
      var Mt = createElementID();
      Pt.setAttribute("id", Mt), Pt.appendChild($t), this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + Mt + ")"), Et.appendChild(Pt), this.layers = _t.layers, this.elements = createSizedArray(_t.layers.length);
    }, SVGRendererBase.prototype.destroy = function() {
      var _t;
      this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.layerElement = null, this.globalData.defs = null;
      var Et = this.layers ? this.layers.length : 0;
      for (_t = 0; _t < Et; _t += 1)
        this.elements[_t] && this.elements[_t].destroy && this.elements[_t].destroy();
      this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
    }, SVGRendererBase.prototype.updateContainerSize = function() {
    }, SVGRendererBase.prototype.findIndexByInd = function(_t) {
      var Et = 0, Pt = this.layers.length;
      for (Et = 0; Et < Pt; Et += 1)
        if (this.layers[Et].ind === _t)
          return Et;
      return -1;
    }, SVGRendererBase.prototype.buildItem = function(_t) {
      var Et = this.elements;
      if (!Et[_t] && this.layers[_t].ty !== 99) {
        Et[_t] = !0;
        var Pt = this.createItem(this.layers[_t]);
        if (Et[_t] = Pt, getExpressionsPlugin() && (this.layers[_t].ty === 0 && this.globalData.projectInterface.registerComposition(Pt), Pt.initExpressions()), this.appendElementInPos(Pt, _t), this.layers[_t].tt) {
          var $t = "tp" in this.layers[_t] ? this.findIndexByInd(this.layers[_t].tp) : _t - 1;
          if ($t === -1)
            return;
          if (this.elements[$t] && this.elements[$t] !== !0) {
            var Mt = Et[$t].getMatte(this.layers[_t].tt);
            Pt.setMatte(Mt);
          } else
            this.buildItem($t), this.addPendingElement(Pt);
        }
      }
    }, SVGRendererBase.prototype.checkPendingElements = function() {
      for (; this.pendingElements.length; ) {
        var _t = this.pendingElements.pop();
        if (_t.checkParenting(), _t.data.tt)
          for (var Et = 0, Pt = this.elements.length; Et < Pt; ) {
            if (this.elements[Et] === _t) {
              var $t = "tp" in _t.data ? this.findIndexByInd(_t.data.tp) : Et - 1, Mt = this.elements[$t].getMatte(this.layers[Et].tt);
              _t.setMatte(Mt);
              break;
            }
            Et += 1;
          }
      }
    }, SVGRendererBase.prototype.renderFrame = function(_t) {
      if (this.renderedFrame !== _t && !this.destroyed) {
        var Et;
        _t === null ? _t = this.renderedFrame : this.renderedFrame = _t, this.globalData.frameNum = _t, this.globalData.frameId += 1, this.globalData.projectInterface.currentFrame = _t, this.globalData._mdf = !1;
        var Pt = this.layers.length;
        for (this.completeLayers || this.checkLayers(_t), Et = Pt - 1; Et >= 0; Et -= 1)
          (this.completeLayers || this.elements[Et]) && this.elements[Et].prepareFrame(_t - this.layers[Et].st);
        if (this.globalData._mdf)
          for (Et = 0; Et < Pt; Et += 1)
            (this.completeLayers || this.elements[Et]) && this.elements[Et].renderFrame();
      }
    }, SVGRendererBase.prototype.appendElementInPos = function(_t, Et) {
      var Pt = _t.getBaseElement();
      if (Pt) {
        for (var $t, Mt = 0; Mt < Et; )
          this.elements[Mt] && this.elements[Mt] !== !0 && this.elements[Mt].getBaseElement() && ($t = this.elements[Mt].getBaseElement()), Mt += 1;
        $t ? this.layerElement.insertBefore(Pt, $t) : this.layerElement.appendChild(Pt);
      }
    }, SVGRendererBase.prototype.hide = function() {
      this.layerElement.style.display = "none";
    }, SVGRendererBase.prototype.show = function() {
      this.layerElement.style.display = "block";
    }, extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement, RenderableDOMElement], ICompElement), ICompElement.prototype.initElement = function(_t, Et, Pt) {
      this.initFrame(), this.initBaseData(_t, Et, Pt), this.initTransform(_t, Et, Pt), this.initRenderable(), this.initHierarchy(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), !this.data.xt && Et.progressiveLoad || this.buildAllItems(), this.hide();
    }, ICompElement.prototype.prepareFrame = function(_t) {
      if (this._mdf = !1, this.prepareRenderableFrame(_t), this.prepareProperties(_t, this.isInRange), this.isInRange || this.data.xt) {
        if (this.tm._placeholder)
          this.renderedFrame = _t / this.data.sr;
        else {
          var Et = this.tm.v;
          Et === this.data.op && (Et = this.data.op - 1), this.renderedFrame = Et;
        }
        var Pt, $t = this.elements.length;
        for (this.completeLayers || this.checkLayers(this.renderedFrame), Pt = $t - 1; Pt >= 0; Pt -= 1)
          (this.completeLayers || this.elements[Pt]) && (this.elements[Pt].prepareFrame(this.renderedFrame - this.layers[Pt].st), this.elements[Pt]._mdf && (this._mdf = !0));
      }
    }, ICompElement.prototype.renderInnerContent = function() {
      var _t, Et = this.layers.length;
      for (_t = 0; _t < Et; _t += 1)
        (this.completeLayers || this.elements[_t]) && this.elements[_t].renderFrame();
    }, ICompElement.prototype.setElements = function(_t) {
      this.elements = _t;
    }, ICompElement.prototype.getElements = function() {
      return this.elements;
    }, ICompElement.prototype.destroyElements = function() {
      var _t, Et = this.layers.length;
      for (_t = 0; _t < Et; _t += 1)
        this.elements[_t] && this.elements[_t].destroy();
    }, ICompElement.prototype.destroy = function() {
      this.destroyElements(), this.destroyBaseElement();
    }, extendPrototype([SVGRendererBase, ICompElement, SVGBaseElement], SVGCompElement), SVGCompElement.prototype.createComp = function(_t) {
      return new SVGCompElement(_t, this.globalData, this);
    }, extendPrototype([SVGRendererBase], SVGRenderer), SVGRenderer.prototype.createComp = function(_t) {
      return new SVGCompElement(_t, this.globalData, this);
    }, ShapeTransformManager.prototype = { addTransformSequence: function(_t) {
      var Et, Pt = _t.length, $t = "_";
      for (Et = 0; Et < Pt; Et += 1)
        $t += _t[Et].transform.key + "_";
      var Mt = this.sequences[$t];
      return Mt || (Mt = { transforms: [].concat(_t), finalTransform: new Matrix(), _mdf: !1 }, this.sequences[$t] = Mt, this.sequenceList.push(Mt)), Mt;
    }, processSequence: function(_t, Et) {
      for (var Pt = 0, $t = _t.transforms.length, Mt = Et; Pt < $t && !Et; ) {
        if (_t.transforms[Pt].transform.mProps._mdf) {
          Mt = !0;
          break;
        }
        Pt += 1;
      }
      if (Mt)
        for (_t.finalTransform.reset(), Pt = $t - 1; Pt >= 0; Pt -= 1)
          _t.finalTransform.multiply(_t.transforms[Pt].transform.mProps.v);
      _t._mdf = Mt;
    }, processSequences: function(_t) {
      var Et, Pt = this.sequenceList.length;
      for (Et = 0; Et < Pt; Et += 1)
        this.processSequence(this.sequenceList[Et], _t);
    }, getNewKey: function() {
      return this.transform_key_count += 1, "_" + this.transform_key_count;
    } };
    var lumaLoader = function() {
      var _t = "__lottie_element_luma_buffer", Et = null, Pt = null, $t = null;
      function Mt() {
        var Bt, Vt, zt;
        Et || (Bt = createNS("svg"), Vt = createNS("filter"), zt = createNS("feColorMatrix"), Vt.setAttribute("id", _t), zt.setAttribute("type", "matrix"), zt.setAttribute("color-interpolation-filters", "sRGB"), zt.setAttribute("values", "0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0"), Vt.appendChild(zt), Bt.appendChild(Vt), Bt.setAttribute("id", _t + "_svg"), featureSupport.svgLumaHidden && (Bt.style.display = "none"), $t = Bt, document.body.appendChild($t), Et = createTag("canvas"), (Pt = Et.getContext("2d")).filter = "url(#" + _t + ")", Pt.fillStyle = "rgba(0,0,0,0)", Pt.fillRect(0, 0, 1, 1));
      }
      return { load: Mt, get: function(Bt) {
        return Et || Mt(), Et.width = Bt.width, Et.height = Bt.height, Pt.filter = "url(#" + _t + ")", Et;
      } };
    };
    function createCanvas(_t, Et) {
      if (featureSupport.offscreenCanvas)
        return new OffscreenCanvas(_t, Et);
      var Pt = createTag("canvas");
      return Pt.width = _t, Pt.height = Et, Pt;
    }
    var assetLoader = { loadLumaCanvas: lumaLoader.load, getLumaCanvas: lumaLoader.get, createCanvas }, registeredEffects = {};
    function CVEffects(_t) {
      var Et, Pt, $t = _t.data.ef ? _t.data.ef.length : 0;
      for (this.filters = [], Et = 0; Et < $t; Et += 1) {
        Pt = null;
        var Mt = _t.data.ef[Et].ty;
        registeredEffects[Mt] && (Pt = new registeredEffects[Mt].effect(_t.effectsManager.effectElements[Et], _t)), Pt && this.filters.push(Pt);
      }
      this.filters.length && _t.addRenderableComponent(this);
    }
    function registerEffect(_t, Et) {
      registeredEffects[_t] = { effect: Et };
    }
    function CVMaskElement(_t, Et) {
      var Pt;
      this.data = _t, this.element = Et, this.masksProperties = this.data.masksProperties || [], this.viewData = createSizedArray(this.masksProperties.length);
      var $t = this.masksProperties.length, Mt = !1;
      for (Pt = 0; Pt < $t; Pt += 1)
        this.masksProperties[Pt].mode !== "n" && (Mt = !0), this.viewData[Pt] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[Pt], 3);
      this.hasMasks = Mt, Mt && this.element.addRenderableComponent(this);
    }
    function CVBaseElement() {
    }
    CVEffects.prototype.renderFrame = function(_t) {
      var Et, Pt = this.filters.length;
      for (Et = 0; Et < Pt; Et += 1)
        this.filters[Et].renderFrame(_t);
    }, CVEffects.prototype.getEffects = function(_t) {
      var Et, Pt = this.filters.length, $t = [];
      for (Et = 0; Et < Pt; Et += 1)
        this.filters[Et].type === _t && $t.push(this.filters[Et]);
      return $t;
    }, CVMaskElement.prototype.renderFrame = function() {
      if (this.hasMasks) {
        var _t, Et, Pt, $t, Mt = this.element.finalTransform.mat, Bt = this.element.canvasContext, Vt = this.masksProperties.length;
        for (Bt.beginPath(), _t = 0; _t < Vt; _t += 1)
          if (this.masksProperties[_t].mode !== "n") {
            var zt;
            this.masksProperties[_t].inv && (Bt.moveTo(0, 0), Bt.lineTo(this.element.globalData.compSize.w, 0), Bt.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h), Bt.lineTo(0, this.element.globalData.compSize.h), Bt.lineTo(0, 0)), $t = this.viewData[_t].v, Et = Mt.applyToPointArray($t.v[0][0], $t.v[0][1], 0), Bt.moveTo(Et[0], Et[1]);
            var Ht = $t._length;
            for (zt = 1; zt < Ht; zt += 1)
              Pt = Mt.applyToTriplePoints($t.o[zt - 1], $t.i[zt], $t.v[zt]), Bt.bezierCurveTo(Pt[0], Pt[1], Pt[2], Pt[3], Pt[4], Pt[5]);
            Pt = Mt.applyToTriplePoints($t.o[zt - 1], $t.i[0], $t.v[0]), Bt.bezierCurveTo(Pt[0], Pt[1], Pt[2], Pt[3], Pt[4], Pt[5]);
          }
        this.element.globalData.renderer.save(!0), Bt.clip();
      }
    }, CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty, CVMaskElement.prototype.destroy = function() {
      this.element = null;
    };
    var operationsMap = { 1: "source-in", 2: "source-out", 3: "source-in", 4: "source-out" };
    function CVShapeData(_t, Et, Pt, $t) {
      this.styledShapes = [], this.tr = [0, 0, 0, 0, 0, 0];
      var Mt, Bt = 4;
      Et.ty === "rc" ? Bt = 5 : Et.ty === "el" ? Bt = 6 : Et.ty === "sr" && (Bt = 7), this.sh = ShapePropertyFactory.getShapeProp(_t, Et, Bt, _t);
      var Vt, zt = Pt.length;
      for (Mt = 0; Mt < zt; Mt += 1)
        Pt[Mt].closed || (Vt = { transforms: $t.addTransformSequence(Pt[Mt].transforms), trNodes: [] }, this.styledShapes.push(Vt), Pt[Mt].elements.push(Vt));
    }
    function CVShapeElement(_t, Et, Pt) {
      this.shapes = [], this.shapesData = _t.shapes, this.stylesList = [], this.itemsData = [], this.prevViewData = [], this.shapeModifiers = [], this.processedElements = [], this.transformsManager = new ShapeTransformManager(), this.initElement(_t, Et, Pt);
    }
    function CVTextElement(_t, Et, Pt) {
      this.textSpans = [], this.yOffset = 0, this.fillColorAnim = !1, this.strokeColorAnim = !1, this.strokeWidthAnim = !1, this.stroke = !1, this.fill = !1, this.justifyOffset = 0, this.currentRender = null, this.renderType = "canvas", this.values = { fill: "rgba(0,0,0,0)", stroke: "rgba(0,0,0,0)", sWidth: 0, fValue: "" }, this.initElement(_t, Et, Pt);
    }
    function CVImageElement(_t, Et, Pt) {
      this.assetData = Et.getAssetData(_t.refId), this.img = Et.imageLoader.getAsset(this.assetData), this.initElement(_t, Et, Pt);
    }
    function CVSolidElement(_t, Et, Pt) {
      this.initElement(_t, Et, Pt);
    }
    function CanvasRendererBase() {
    }
    function CanvasContext() {
      this.opacity = -1, this.transform = createTypedArray("float32", 16), this.fillStyle = "", this.strokeStyle = "", this.lineWidth = "", this.lineCap = "", this.lineJoin = "", this.miterLimit = "", this.id = Math.random();
    }
    function CVContextData() {
      var _t;
      for (this.stack = [], this.cArrPos = 0, this.cTr = new Matrix(), _t = 0; _t < 15; _t += 1) {
        var Et = new CanvasContext();
        this.stack[_t] = Et;
      }
      this._length = 15, this.nativeContext = null, this.transformMat = new Matrix(), this.currentOpacity = 1, this.currentFillStyle = "", this.appliedFillStyle = "", this.currentStrokeStyle = "", this.appliedStrokeStyle = "", this.currentLineWidth = "", this.appliedLineWidth = "", this.currentLineCap = "", this.appliedLineCap = "", this.currentLineJoin = "", this.appliedLineJoin = "", this.appliedMiterLimit = "", this.currentMiterLimit = "";
    }
    function CVCompElement(_t, Et, Pt) {
      this.completeLayers = !1, this.layers = _t.layers, this.pendingElements = [], this.elements = createSizedArray(this.layers.length), this.initElement(_t, Et, Pt), this.tm = _t.tm ? PropertyFactory.getProp(this, _t.tm, 0, Et.frameRate, this) : { _placeholder: !0 };
    }
    function CanvasRenderer(_t, Et) {
      this.animationItem = _t, this.renderConfig = { clearCanvas: !Et || Et.clearCanvas === void 0 || Et.clearCanvas, context: Et && Et.context || null, progressiveLoad: Et && Et.progressiveLoad || !1, preserveAspectRatio: Et && Et.preserveAspectRatio || "xMidYMid meet", imagePreserveAspectRatio: Et && Et.imagePreserveAspectRatio || "xMidYMid slice", contentVisibility: Et && Et.contentVisibility || "visible", className: Et && Et.className || "", id: Et && Et.id || "", runExpressions: !Et || Et.runExpressions === void 0 || Et.runExpressions }, this.renderConfig.dpr = Et && Et.dpr || 1, this.animationItem.wrapper && (this.renderConfig.dpr = Et && Et.dpr || window.devicePixelRatio || 1), this.renderedFrame = -1, this.globalData = { frameNum: -1, _mdf: !1, renderConfig: this.renderConfig, currentGlobalAlpha: -1 }, this.contextData = new CVContextData(), this.elements = [], this.pendingElements = [], this.transformMat = new Matrix(), this.completeLayers = !1, this.rendererType = "canvas", this.renderConfig.clearCanvas && (this.ctxTransform = this.contextData.transform.bind(this.contextData), this.ctxOpacity = this.contextData.opacity.bind(this.contextData), this.ctxFillStyle = this.contextData.fillStyle.bind(this.contextData), this.ctxStrokeStyle = this.contextData.strokeStyle.bind(this.contextData), this.ctxLineWidth = this.contextData.lineWidth.bind(this.contextData), this.ctxLineCap = this.contextData.lineCap.bind(this.contextData), this.ctxLineJoin = this.contextData.lineJoin.bind(this.contextData), this.ctxMiterLimit = this.contextData.miterLimit.bind(this.contextData), this.ctxFill = this.contextData.fill.bind(this.contextData), this.ctxFillRect = this.contextData.fillRect.bind(this.contextData), this.ctxStroke = this.contextData.stroke.bind(this.contextData), this.save = this.contextData.save.bind(this.contextData));
    }
    function HBaseElement() {
    }
    function HSolidElement(_t, Et, Pt) {
      this.initElement(_t, Et, Pt);
    }
    function HShapeElement(_t, Et, Pt) {
      this.shapes = [], this.shapesData = _t.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.shapesContainer = createNS("g"), this.initElement(_t, Et, Pt), this.prevViewData = [], this.currentBBox = { x: 999999, y: -999999, h: 0, w: 0 };
    }
    function HTextElement(_t, Et, Pt) {
      this.textSpans = [], this.textPaths = [], this.currentBBox = { x: 999999, y: -999999, h: 0, w: 0 }, this.renderType = "svg", this.isMasked = !1, this.initElement(_t, Et, Pt);
    }
    function HCameraElement(_t, Et, Pt) {
      this.initFrame(), this.initBaseData(_t, Et, Pt), this.initHierarchy();
      var $t = PropertyFactory.getProp;
      if (this.pe = $t(this, _t.pe, 0, 0, this), _t.ks.p.s ? (this.px = $t(this, _t.ks.p.x, 1, 0, this), this.py = $t(this, _t.ks.p.y, 1, 0, this), this.pz = $t(this, _t.ks.p.z, 1, 0, this)) : this.p = $t(this, _t.ks.p, 1, 0, this), _t.ks.a && (this.a = $t(this, _t.ks.a, 1, 0, this)), _t.ks.or.k.length && _t.ks.or.k[0].to) {
        var Mt, Bt = _t.ks.or.k.length;
        for (Mt = 0; Mt < Bt; Mt += 1)
          _t.ks.or.k[Mt].to = null, _t.ks.or.k[Mt].ti = null;
      }
      this.or = $t(this, _t.ks.or, 1, degToRads, this), this.or.sh = !0, this.rx = $t(this, _t.ks.rx, 0, degToRads, this), this.ry = $t(this, _t.ks.ry, 0, degToRads, this), this.rz = $t(this, _t.ks.rz, 0, degToRads, this), this.mat = new Matrix(), this._prevMat = new Matrix(), this._isFirstFrame = !0, this.finalTransform = { mProp: this };
    }
    function HImageElement(_t, Et, Pt) {
      this.assetData = Et.getAssetData(_t.refId), this.initElement(_t, Et, Pt);
    }
    function HybridRendererBase(_t, Et) {
      this.animationItem = _t, this.layers = null, this.renderedFrame = -1, this.renderConfig = { className: Et && Et.className || "", imagePreserveAspectRatio: Et && Et.imagePreserveAspectRatio || "xMidYMid slice", hideOnTransparent: !(Et && Et.hideOnTransparent === !1), filterSize: { width: Et && Et.filterSize && Et.filterSize.width || "400%", height: Et && Et.filterSize && Et.filterSize.height || "400%", x: Et && Et.filterSize && Et.filterSize.x || "-100%", y: Et && Et.filterSize && Et.filterSize.y || "-100%" } }, this.globalData = { _mdf: !1, frameNum: -1, renderConfig: this.renderConfig }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
    }
    function HCompElement(_t, Et, Pt) {
      this.layers = _t.layers, this.supports3d = !_t.hasMask, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(_t, Et, Pt), this.tm = _t.tm ? PropertyFactory.getProp(this, _t.tm, 0, Et.frameRate, this) : { _placeholder: !0 };
    }
    function HybridRenderer(_t, Et) {
      this.animationItem = _t, this.layers = null, this.renderedFrame = -1, this.renderConfig = { className: Et && Et.className || "", imagePreserveAspectRatio: Et && Et.imagePreserveAspectRatio || "xMidYMid slice", hideOnTransparent: !(Et && Et.hideOnTransparent === !1), filterSize: { width: Et && Et.filterSize && Et.filterSize.width || "400%", height: Et && Et.filterSize && Et.filterSize.height || "400%", x: Et && Et.filterSize && Et.filterSize.x || "-100%", y: Et && Et.filterSize && Et.filterSize.y || "-100%" }, runExpressions: !Et || Et.runExpressions === void 0 || Et.runExpressions }, this.globalData = { _mdf: !1, frameNum: -1, renderConfig: this.renderConfig }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
    }
    CVBaseElement.prototype = { createElements: function() {
    }, initRendererElement: function() {
    }, createContainerElements: function() {
      if (this.data.tt >= 1) {
        this.buffers = [];
        var _t = this.globalData.canvasContext, Et = assetLoader.createCanvas(_t.canvas.width, _t.canvas.height);
        this.buffers.push(Et);
        var Pt = assetLoader.createCanvas(_t.canvas.width, _t.canvas.height);
        this.buffers.push(Pt), this.data.tt >= 3 && !document._isProxy && assetLoader.loadLumaCanvas();
      }
      this.canvasContext = this.globalData.canvasContext, this.transformCanvas = this.globalData.transformCanvas, this.renderableEffectsManager = new CVEffects(this), this.searchEffectTransforms();
    }, createContent: function() {
    }, setBlendMode: function() {
      var _t = this.globalData;
      if (_t.blendMode !== this.data.bm) {
        _t.blendMode = this.data.bm;
        var Et = getBlendMode(this.data.bm);
        _t.canvasContext.globalCompositeOperation = Et;
      }
    }, createRenderableComponents: function() {
      this.maskManager = new CVMaskElement(this.data, this), this.transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
    }, hideElement: function() {
      this.hidden || this.isInRange && !this.isTransparent || (this.hidden = !0);
    }, showElement: function() {
      this.isInRange && !this.isTransparent && (this.hidden = !1, this._isFirstFrame = !0, this.maskManager._isFirstFrame = !0);
    }, clearCanvas: function(_t) {
      _t.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w * this.transformCanvas.sx, this.transformCanvas.h * this.transformCanvas.sy);
    }, prepareLayer: function() {
      if (this.data.tt >= 1) {
        var _t = this.buffers[0].getContext("2d");
        this.clearCanvas(_t), _t.drawImage(this.canvasContext.canvas, 0, 0), this.currentTransform = this.canvasContext.getTransform(), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.setTransform(this.currentTransform);
      }
    }, exitLayer: function() {
      if (this.data.tt >= 1) {
        var _t = this.buffers[1], Et = _t.getContext("2d");
        if (this.clearCanvas(Et), Et.drawImage(this.canvasContext.canvas, 0, 0), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.setTransform(this.currentTransform), this.comp.getElementById("tp" in this.data ? this.data.tp : this.data.ind - 1).renderFrame(!0), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.data.tt >= 3 && !document._isProxy) {
          var Pt = assetLoader.getLumaCanvas(this.canvasContext.canvas);
          Pt.getContext("2d").drawImage(this.canvasContext.canvas, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.drawImage(Pt, 0, 0);
        }
        this.canvasContext.globalCompositeOperation = operationsMap[this.data.tt], this.canvasContext.drawImage(_t, 0, 0), this.canvasContext.globalCompositeOperation = "destination-over", this.canvasContext.drawImage(this.buffers[0], 0, 0), this.canvasContext.setTransform(this.currentTransform), this.canvasContext.globalCompositeOperation = "source-over";
      }
    }, renderFrame: function(_t) {
      if (!this.hidden && !this.data.hd && (this.data.td !== 1 || _t)) {
        this.renderTransform(), this.renderRenderable(), this.renderLocalTransform(), this.setBlendMode();
        var Et = this.data.ty === 0;
        this.prepareLayer(), this.globalData.renderer.save(Et), this.globalData.renderer.ctxTransform(this.finalTransform.localMat.props), this.globalData.renderer.ctxOpacity(this.finalTransform.localOpacity), this.renderInnerContent(), this.globalData.renderer.restore(Et), this.exitLayer(), this.maskManager.hasMasks && this.globalData.renderer.restore(!0), this._isFirstFrame && (this._isFirstFrame = !1);
      }
    }, destroy: function() {
      this.canvasContext = null, this.data = null, this.globalData = null, this.maskManager.destroy();
    }, mHelper: new Matrix() }, CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement, CVBaseElement.prototype.show = CVBaseElement.prototype.showElement, CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated, extendPrototype([BaseElement, TransformElement, CVBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableElement], CVShapeElement), CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement, CVShapeElement.prototype.transformHelper = { opacity: 1, _opMdf: !1 }, CVShapeElement.prototype.dashResetter = [], CVShapeElement.prototype.createContent = function() {
      this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []);
    }, CVShapeElement.prototype.createStyleElement = function(_t, Et) {
      var Pt = { data: _t, type: _t.ty, preTransforms: this.transformsManager.addTransformSequence(Et), transforms: [], elements: [], closed: _t.hd === !0 }, $t = {};
      if (_t.ty === "fl" || _t.ty === "st" ? ($t.c = PropertyFactory.getProp(this, _t.c, 1, 255, this), $t.c.k || (Pt.co = "rgb(" + bmFloor($t.c.v[0]) + "," + bmFloor($t.c.v[1]) + "," + bmFloor($t.c.v[2]) + ")")) : _t.ty !== "gf" && _t.ty !== "gs" || ($t.s = PropertyFactory.getProp(this, _t.s, 1, null, this), $t.e = PropertyFactory.getProp(this, _t.e, 1, null, this), $t.h = PropertyFactory.getProp(this, _t.h || { k: 0 }, 0, 0.01, this), $t.a = PropertyFactory.getProp(this, _t.a || { k: 0 }, 0, degToRads, this), $t.g = new GradientProperty(this, _t.g, this)), $t.o = PropertyFactory.getProp(this, _t.o, 0, 0.01, this), _t.ty === "st" || _t.ty === "gs") {
        if (Pt.lc = lineCapEnum[_t.lc || 2], Pt.lj = lineJoinEnum[_t.lj || 2], _t.lj == 1 && (Pt.ml = _t.ml), $t.w = PropertyFactory.getProp(this, _t.w, 0, null, this), $t.w.k || (Pt.wi = $t.w.v), _t.d) {
          var Mt = new DashProperty(this, _t.d, "canvas", this);
          $t.d = Mt, $t.d.k || (Pt.da = $t.d.dashArray, Pt.do = $t.d.dashoffset[0]);
        }
      } else
        Pt.r = _t.r === 2 ? "evenodd" : "nonzero";
      return this.stylesList.push(Pt), $t.style = Pt, $t;
    }, CVShapeElement.prototype.createGroupElement = function() {
      return { it: [], prevViewData: [] };
    }, CVShapeElement.prototype.createTransformElement = function(_t) {
      return { transform: { opacity: 1, _opMdf: !1, key: this.transformsManager.getNewKey(), op: PropertyFactory.getProp(this, _t.o, 0, 0.01, this), mProps: TransformPropertyFactory.getTransformProperty(this, _t, this) } };
    }, CVShapeElement.prototype.createShapeElement = function(_t) {
      var Et = new CVShapeData(this, _t, this.stylesList, this.transformsManager);
      return this.shapes.push(Et), this.addShapeToModifiers(Et), Et;
    }, CVShapeElement.prototype.reloadShapes = function() {
      var _t;
      this._isFirstFrame = !0;
      var Et = this.itemsData.length;
      for (_t = 0; _t < Et; _t += 1)
        this.prevViewData[_t] = this.itemsData[_t];
      for (this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []), Et = this.dynamicProperties.length, _t = 0; _t < Et; _t += 1)
        this.dynamicProperties[_t].getValue();
      this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame);
    }, CVShapeElement.prototype.addTransformToStyleList = function(_t) {
      var Et, Pt = this.stylesList.length;
      for (Et = 0; Et < Pt; Et += 1)
        this.stylesList[Et].closed || this.stylesList[Et].transforms.push(_t);
    }, CVShapeElement.prototype.removeTransformFromStyleList = function() {
      var _t, Et = this.stylesList.length;
      for (_t = 0; _t < Et; _t += 1)
        this.stylesList[_t].closed || this.stylesList[_t].transforms.pop();
    }, CVShapeElement.prototype.closeStyles = function(_t) {
      var Et, Pt = _t.length;
      for (Et = 0; Et < Pt; Et += 1)
        _t[Et].closed = !0;
    }, CVShapeElement.prototype.searchShapes = function(_t, Et, Pt, $t, Mt) {
      var Bt, Vt, zt, Ht, Wt, Gt, qt = _t.length - 1, Kt = [], Qt = [], Xt = [].concat(Mt);
      for (Bt = qt; Bt >= 0; Bt -= 1) {
        if ((Ht = this.searchProcessedElement(_t[Bt])) ? Et[Bt] = Pt[Ht - 1] : _t[Bt]._shouldRender = $t, _t[Bt].ty === "fl" || _t[Bt].ty === "st" || _t[Bt].ty === "gf" || _t[Bt].ty === "gs")
          Ht ? Et[Bt].style.closed = !1 : Et[Bt] = this.createStyleElement(_t[Bt], Xt), Kt.push(Et[Bt].style);
        else if (_t[Bt].ty === "gr") {
          if (Ht)
            for (zt = Et[Bt].it.length, Vt = 0; Vt < zt; Vt += 1)
              Et[Bt].prevViewData[Vt] = Et[Bt].it[Vt];
          else
            Et[Bt] = this.createGroupElement(_t[Bt]);
          this.searchShapes(_t[Bt].it, Et[Bt].it, Et[Bt].prevViewData, $t, Xt);
        } else
          _t[Bt].ty === "tr" ? (Ht || (Gt = this.createTransformElement(_t[Bt]), Et[Bt] = Gt), Xt.push(Et[Bt]), this.addTransformToStyleList(Et[Bt])) : _t[Bt].ty === "sh" || _t[Bt].ty === "rc" || _t[Bt].ty === "el" || _t[Bt].ty === "sr" ? Ht || (Et[Bt] = this.createShapeElement(_t[Bt])) : _t[Bt].ty === "tm" || _t[Bt].ty === "rd" || _t[Bt].ty === "pb" || _t[Bt].ty === "zz" || _t[Bt].ty === "op" ? (Ht ? (Wt = Et[Bt]).closed = !1 : ((Wt = ShapeModifiers.getModifier(_t[Bt].ty)).init(this, _t[Bt]), Et[Bt] = Wt, this.shapeModifiers.push(Wt)), Qt.push(Wt)) : _t[Bt].ty === "rp" && (Ht ? (Wt = Et[Bt]).closed = !0 : (Wt = ShapeModifiers.getModifier(_t[Bt].ty), Et[Bt] = Wt, Wt.init(this, _t, Bt, Et), this.shapeModifiers.push(Wt), $t = !1), Qt.push(Wt));
        this.addProcessedElement(_t[Bt], Bt + 1);
      }
      for (this.removeTransformFromStyleList(), this.closeStyles(Kt), qt = Qt.length, Bt = 0; Bt < qt; Bt += 1)
        Qt[Bt].closed = !0;
    }, CVShapeElement.prototype.renderInnerContent = function() {
      this.transformHelper.opacity = 1, this.transformHelper._opMdf = !1, this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame), this.renderShape(this.transformHelper, this.shapesData, this.itemsData, !0);
    }, CVShapeElement.prototype.renderShapeTransform = function(_t, Et) {
      (_t._opMdf || Et.op._mdf || this._isFirstFrame) && (Et.opacity = _t.opacity, Et.opacity *= Et.op.v, Et._opMdf = !0);
    }, CVShapeElement.prototype.drawLayer = function() {
      var _t, Et, Pt, $t, Mt, Bt, Vt, zt, Ht, Wt = this.stylesList.length, Gt = this.globalData.renderer, qt = this.globalData.canvasContext;
      for (_t = 0; _t < Wt; _t += 1)
        if (((zt = (Ht = this.stylesList[_t]).type) !== "st" && zt !== "gs" || Ht.wi !== 0) && Ht.data._shouldRender && Ht.coOp !== 0 && this.globalData.currentGlobalAlpha !== 0) {
          for (Gt.save(), Bt = Ht.elements, zt === "st" || zt === "gs" ? (Gt.ctxStrokeStyle(zt === "st" ? Ht.co : Ht.grd), Gt.ctxLineWidth(Ht.wi), Gt.ctxLineCap(Ht.lc), Gt.ctxLineJoin(Ht.lj), Gt.ctxMiterLimit(Ht.ml || 0)) : Gt.ctxFillStyle(zt === "fl" ? Ht.co : Ht.grd), Gt.ctxOpacity(Ht.coOp), zt !== "st" && zt !== "gs" && qt.beginPath(), Gt.ctxTransform(Ht.preTransforms.finalTransform.props), Pt = Bt.length, Et = 0; Et < Pt; Et += 1) {
            for (zt !== "st" && zt !== "gs" || (qt.beginPath(), Ht.da && (qt.setLineDash(Ht.da), qt.lineDashOffset = Ht.do)), Mt = (Vt = Bt[Et].trNodes).length, $t = 0; $t < Mt; $t += 1)
              Vt[$t].t === "m" ? qt.moveTo(Vt[$t].p[0], Vt[$t].p[1]) : Vt[$t].t === "c" ? qt.bezierCurveTo(Vt[$t].pts[0], Vt[$t].pts[1], Vt[$t].pts[2], Vt[$t].pts[3], Vt[$t].pts[4], Vt[$t].pts[5]) : qt.closePath();
            zt !== "st" && zt !== "gs" || (Gt.ctxStroke(), Ht.da && qt.setLineDash(this.dashResetter));
          }
          zt !== "st" && zt !== "gs" && this.globalData.renderer.ctxFill(Ht.r), Gt.restore();
        }
    }, CVShapeElement.prototype.renderShape = function(_t, Et, Pt, $t) {
      var Mt, Bt;
      for (Bt = _t, Mt = Et.length - 1; Mt >= 0; Mt -= 1)
        Et[Mt].ty === "tr" ? (Bt = Pt[Mt].transform, this.renderShapeTransform(_t, Bt)) : Et[Mt].ty === "sh" || Et[Mt].ty === "el" || Et[Mt].ty === "rc" || Et[Mt].ty === "sr" ? this.renderPath(Et[Mt], Pt[Mt]) : Et[Mt].ty === "fl" ? this.renderFill(Et[Mt], Pt[Mt], Bt) : Et[Mt].ty === "st" ? this.renderStroke(Et[Mt], Pt[Mt], Bt) : Et[Mt].ty === "gf" || Et[Mt].ty === "gs" ? this.renderGradientFill(Et[Mt], Pt[Mt], Bt) : Et[Mt].ty === "gr" ? this.renderShape(Bt, Et[Mt].it, Pt[Mt].it) : Et[Mt].ty;
      $t && this.drawLayer();
    }, CVShapeElement.prototype.renderStyledShape = function(_t, Et) {
      if (this._isFirstFrame || Et._mdf || _t.transforms._mdf) {
        var Pt, $t, Mt, Bt = _t.trNodes, Vt = Et.paths, zt = Vt._length;
        Bt.length = 0;
        var Ht = _t.transforms.finalTransform;
        for (Mt = 0; Mt < zt; Mt += 1) {
          var Wt = Vt.shapes[Mt];
          if (Wt && Wt.v) {
            for ($t = Wt._length, Pt = 1; Pt < $t; Pt += 1)
              Pt === 1 && Bt.push({ t: "m", p: Ht.applyToPointArray(Wt.v[0][0], Wt.v[0][1], 0) }), Bt.push({ t: "c", pts: Ht.applyToTriplePoints(Wt.o[Pt - 1], Wt.i[Pt], Wt.v[Pt]) });
            $t === 1 && Bt.push({ t: "m", p: Ht.applyToPointArray(Wt.v[0][0], Wt.v[0][1], 0) }), Wt.c && $t && (Bt.push({ t: "c", pts: Ht.applyToTriplePoints(Wt.o[Pt - 1], Wt.i[0], Wt.v[0]) }), Bt.push({ t: "z" }));
          }
        }
        _t.trNodes = Bt;
      }
    }, CVShapeElement.prototype.renderPath = function(_t, Et) {
      if (_t.hd !== !0 && _t._shouldRender) {
        var Pt, $t = Et.styledShapes.length;
        for (Pt = 0; Pt < $t; Pt += 1)
          this.renderStyledShape(Et.styledShapes[Pt], Et.sh);
      }
    }, CVShapeElement.prototype.renderFill = function(_t, Et, Pt) {
      var $t = Et.style;
      (Et.c._mdf || this._isFirstFrame) && ($t.co = "rgb(" + bmFloor(Et.c.v[0]) + "," + bmFloor(Et.c.v[1]) + "," + bmFloor(Et.c.v[2]) + ")"), (Et.o._mdf || Pt._opMdf || this._isFirstFrame) && ($t.coOp = Et.o.v * Pt.opacity);
    }, CVShapeElement.prototype.renderGradientFill = function(_t, Et, Pt) {
      var $t, Mt = Et.style;
      if (!Mt.grd || Et.g._mdf || Et.s._mdf || Et.e._mdf || _t.t !== 1 && (Et.h._mdf || Et.a._mdf)) {
        var Bt, Vt = this.globalData.canvasContext, zt = Et.s.v, Ht = Et.e.v;
        if (_t.t === 1)
          $t = Vt.createLinearGradient(zt[0], zt[1], Ht[0], Ht[1]);
        else {
          var Wt = Math.sqrt(Math.pow(zt[0] - Ht[0], 2) + Math.pow(zt[1] - Ht[1], 2)), Gt = Math.atan2(Ht[1] - zt[1], Ht[0] - zt[0]), qt = Et.h.v;
          qt >= 1 ? qt = 0.99 : qt <= -1 && (qt = -0.99);
          var Kt = Wt * qt, Qt = Math.cos(Gt + Et.a.v) * Kt + zt[0], Xt = Math.sin(Gt + Et.a.v) * Kt + zt[1];
          $t = Vt.createRadialGradient(Qt, Xt, 0, zt[0], zt[1], Wt);
        }
        var Zt = _t.g.p, Yt = Et.g.c, Jt = 1;
        for (Bt = 0; Bt < Zt; Bt += 1)
          Et.g._hasOpacity && Et.g._collapsable && (Jt = Et.g.o[2 * Bt + 1]), $t.addColorStop(Yt[4 * Bt] / 100, "rgba(" + Yt[4 * Bt + 1] + "," + Yt[4 * Bt + 2] + "," + Yt[4 * Bt + 3] + "," + Jt + ")");
        Mt.grd = $t;
      }
      Mt.coOp = Et.o.v * Pt.opacity;
    }, CVShapeElement.prototype.renderStroke = function(_t, Et, Pt) {
      var $t = Et.style, Mt = Et.d;
      Mt && (Mt._mdf || this._isFirstFrame) && ($t.da = Mt.dashArray, $t.do = Mt.dashoffset[0]), (Et.c._mdf || this._isFirstFrame) && ($t.co = "rgb(" + bmFloor(Et.c.v[0]) + "," + bmFloor(Et.c.v[1]) + "," + bmFloor(Et.c.v[2]) + ")"), (Et.o._mdf || Pt._opMdf || this._isFirstFrame) && ($t.coOp = Et.o.v * Pt.opacity), (Et.w._mdf || this._isFirstFrame) && ($t.wi = Et.w.v);
    }, CVShapeElement.prototype.destroy = function() {
      this.shapesData = null, this.globalData = null, this.canvasContext = null, this.stylesList.length = 0, this.itemsData.length = 0;
    }, extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement, ITextElement], CVTextElement), CVTextElement.prototype.tHelper = createTag("canvas").getContext("2d"), CVTextElement.prototype.buildNewText = function() {
      var _t = this.textProperty.currentData;
      this.renderedLetters = createSizedArray(_t.l ? _t.l.length : 0);
      var Et = !1;
      _t.fc ? (Et = !0, this.values.fill = this.buildColor(_t.fc)) : this.values.fill = "rgba(0,0,0,0)", this.fill = Et;
      var Pt = !1;
      _t.sc && (Pt = !0, this.values.stroke = this.buildColor(_t.sc), this.values.sWidth = _t.sw);
      var $t, Mt, Bt, Vt, zt, Ht, Wt, Gt, qt, Kt, Qt, Xt, Zt = this.globalData.fontManager.getFontByName(_t.f), Yt = _t.l, Jt = this.mHelper;
      this.stroke = Pt, this.values.fValue = _t.finalSize + "px " + this.globalData.fontManager.getFontByName(_t.f).fFamily, Mt = _t.finalText.length;
      var er = this.data.singleShape, tr = 1e-3 * _t.tr * _t.finalSize, nr = 0, rr = 0, ir = !0, ar = 0;
      for ($t = 0; $t < Mt; $t += 1) {
        Vt = (Bt = this.globalData.fontManager.getCharData(_t.finalText[$t], Zt.fStyle, this.globalData.fontManager.getFontByName(_t.f).fFamily)) && Bt.data || {}, Jt.reset(), er && Yt[$t].n && (nr = -tr, rr += _t.yOffset, rr += ir ? 1 : 0, ir = !1), qt = (Wt = Vt.shapes ? Vt.shapes[0].it : []).length, Jt.scale(_t.finalSize / 100, _t.finalSize / 100), er && this.applyTextPropertiesToMatrix(_t, Jt, Yt[$t].line, nr, rr), Qt = createSizedArray(qt - 1);
        var or = 0;
        for (Gt = 0; Gt < qt; Gt += 1)
          if (Wt[Gt].ty === "sh") {
            for (Ht = Wt[Gt].ks.k.i.length, Kt = Wt[Gt].ks.k, Xt = [], zt = 1; zt < Ht; zt += 1)
              zt === 1 && Xt.push(Jt.applyToX(Kt.v[0][0], Kt.v[0][1], 0), Jt.applyToY(Kt.v[0][0], Kt.v[0][1], 0)), Xt.push(Jt.applyToX(Kt.o[zt - 1][0], Kt.o[zt - 1][1], 0), Jt.applyToY(Kt.o[zt - 1][0], Kt.o[zt - 1][1], 0), Jt.applyToX(Kt.i[zt][0], Kt.i[zt][1], 0), Jt.applyToY(Kt.i[zt][0], Kt.i[zt][1], 0), Jt.applyToX(Kt.v[zt][0], Kt.v[zt][1], 0), Jt.applyToY(Kt.v[zt][0], Kt.v[zt][1], 0));
            Xt.push(Jt.applyToX(Kt.o[zt - 1][0], Kt.o[zt - 1][1], 0), Jt.applyToY(Kt.o[zt - 1][0], Kt.o[zt - 1][1], 0), Jt.applyToX(Kt.i[0][0], Kt.i[0][1], 0), Jt.applyToY(Kt.i[0][0], Kt.i[0][1], 0), Jt.applyToX(Kt.v[0][0], Kt.v[0][1], 0), Jt.applyToY(Kt.v[0][0], Kt.v[0][1], 0)), Qt[or] = Xt, or += 1;
          }
        er && (nr += Yt[$t].l, nr += tr), this.textSpans[ar] ? this.textSpans[ar].elem = Qt : this.textSpans[ar] = { elem: Qt }, ar += 1;
      }
    }, CVTextElement.prototype.renderInnerContent = function() {
      var _t, Et, Pt, $t, Mt, Bt;
      this.validateText(), this.canvasContext.font = this.values.fValue, this.globalData.renderer.ctxLineCap("butt"), this.globalData.renderer.ctxLineJoin("miter"), this.globalData.renderer.ctxMiterLimit(4), this.data.singleShape || this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
      var Vt, zt = this.textAnimator.renderedLetters, Ht = this.textProperty.currentData.l;
      Et = Ht.length;
      var Wt, Gt, qt = null, Kt = null, Qt = null, Xt = this.globalData.renderer;
      for (_t = 0; _t < Et; _t += 1)
        if (!Ht[_t].n) {
          if ((Vt = zt[_t]) && (Xt.save(), Xt.ctxTransform(Vt.p), Xt.ctxOpacity(Vt.o)), this.fill) {
            for (Vt && Vt.fc ? qt !== Vt.fc && (Xt.ctxFillStyle(Vt.fc), qt = Vt.fc) : qt !== this.values.fill && (qt = this.values.fill, Xt.ctxFillStyle(this.values.fill)), $t = (Wt = this.textSpans[_t].elem).length, this.globalData.canvasContext.beginPath(), Pt = 0; Pt < $t; Pt += 1)
              for (Bt = (Gt = Wt[Pt]).length, this.globalData.canvasContext.moveTo(Gt[0], Gt[1]), Mt = 2; Mt < Bt; Mt += 6)
                this.globalData.canvasContext.bezierCurveTo(Gt[Mt], Gt[Mt + 1], Gt[Mt + 2], Gt[Mt + 3], Gt[Mt + 4], Gt[Mt + 5]);
            this.globalData.canvasContext.closePath(), Xt.ctxFill();
          }
          if (this.stroke) {
            for (Vt && Vt.sw ? Qt !== Vt.sw && (Qt = Vt.sw, Xt.ctxLineWidth(Vt.sw)) : Qt !== this.values.sWidth && (Qt = this.values.sWidth, Xt.ctxLineWidth(this.values.sWidth)), Vt && Vt.sc ? Kt !== Vt.sc && (Kt = Vt.sc, Xt.ctxStrokeStyle(Vt.sc)) : Kt !== this.values.stroke && (Kt = this.values.stroke, Xt.ctxStrokeStyle(this.values.stroke)), $t = (Wt = this.textSpans[_t].elem).length, this.globalData.canvasContext.beginPath(), Pt = 0; Pt < $t; Pt += 1)
              for (Bt = (Gt = Wt[Pt]).length, this.globalData.canvasContext.moveTo(Gt[0], Gt[1]), Mt = 2; Mt < Bt; Mt += 6)
                this.globalData.canvasContext.bezierCurveTo(Gt[Mt], Gt[Mt + 1], Gt[Mt + 2], Gt[Mt + 3], Gt[Mt + 4], Gt[Mt + 5]);
            this.globalData.canvasContext.closePath(), Xt.ctxStroke();
          }
          Vt && this.globalData.renderer.restore();
        }
    }, extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVImageElement), CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVImageElement.prototype.createContent = function() {
      if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
        var _t = createTag("canvas");
        _t.width = this.assetData.w, _t.height = this.assetData.h;
        var Et, Pt, $t = _t.getContext("2d"), Mt = this.img.width, Bt = this.img.height, Vt = Mt / Bt, zt = this.assetData.w / this.assetData.h, Ht = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
        Vt > zt && Ht === "xMidYMid slice" || Vt < zt && Ht !== "xMidYMid slice" ? Et = (Pt = Bt) * zt : Pt = (Et = Mt) / zt, $t.drawImage(this.img, (Mt - Et) / 2, (Bt - Pt) / 2, Et, Pt, 0, 0, this.assetData.w, this.assetData.h), this.img = _t;
      }
    }, CVImageElement.prototype.renderInnerContent = function() {
      this.canvasContext.drawImage(this.img, 0, 0);
    }, CVImageElement.prototype.destroy = function() {
      this.img = null;
    }, extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVSolidElement), CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVSolidElement.prototype.renderInnerContent = function() {
      this.globalData.renderer.ctxFillStyle(this.data.sc), this.globalData.renderer.ctxFillRect(0, 0, this.data.sw, this.data.sh);
    }, extendPrototype([BaseRenderer], CanvasRendererBase), CanvasRendererBase.prototype.createShape = function(_t) {
      return new CVShapeElement(_t, this.globalData, this);
    }, CanvasRendererBase.prototype.createText = function(_t) {
      return new CVTextElement(_t, this.globalData, this);
    }, CanvasRendererBase.prototype.createImage = function(_t) {
      return new CVImageElement(_t, this.globalData, this);
    }, CanvasRendererBase.prototype.createSolid = function(_t) {
      return new CVSolidElement(_t, this.globalData, this);
    }, CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, CanvasRendererBase.prototype.ctxTransform = function(_t) {
      _t[0] === 1 && _t[1] === 0 && _t[4] === 0 && _t[5] === 1 && _t[12] === 0 && _t[13] === 0 || this.canvasContext.transform(_t[0], _t[1], _t[4], _t[5], _t[12], _t[13]);
    }, CanvasRendererBase.prototype.ctxOpacity = function(_t) {
      this.canvasContext.globalAlpha *= _t < 0 ? 0 : _t;
    }, CanvasRendererBase.prototype.ctxFillStyle = function(_t) {
      this.canvasContext.fillStyle = _t;
    }, CanvasRendererBase.prototype.ctxStrokeStyle = function(_t) {
      this.canvasContext.strokeStyle = _t;
    }, CanvasRendererBase.prototype.ctxLineWidth = function(_t) {
      this.canvasContext.lineWidth = _t;
    }, CanvasRendererBase.prototype.ctxLineCap = function(_t) {
      this.canvasContext.lineCap = _t;
    }, CanvasRendererBase.prototype.ctxLineJoin = function(_t) {
      this.canvasContext.lineJoin = _t;
    }, CanvasRendererBase.prototype.ctxMiterLimit = function(_t) {
      this.canvasContext.miterLimit = _t;
    }, CanvasRendererBase.prototype.ctxFill = function(_t) {
      this.canvasContext.fill(_t);
    }, CanvasRendererBase.prototype.ctxFillRect = function(_t, Et, Pt, $t) {
      this.canvasContext.fillRect(_t, Et, Pt, $t);
    }, CanvasRendererBase.prototype.ctxStroke = function() {
      this.canvasContext.stroke();
    }, CanvasRendererBase.prototype.reset = function() {
      this.renderConfig.clearCanvas ? this.contextData.reset() : this.canvasContext.restore();
    }, CanvasRendererBase.prototype.save = function() {
      this.canvasContext.save();
    }, CanvasRendererBase.prototype.restore = function(_t) {
      this.renderConfig.clearCanvas ? (_t && (this.globalData.blendMode = "source-over"), this.contextData.restore(_t)) : this.canvasContext.restore();
    }, CanvasRendererBase.prototype.configAnimation = function(_t) {
      if (this.animationItem.wrapper) {
        this.animationItem.container = createTag("canvas");
        var Et = this.animationItem.container.style;
        Et.width = "100%", Et.height = "100%";
        var Pt = "0px 0px 0px";
        Et.transformOrigin = Pt, Et.mozTransformOrigin = Pt, Et.webkitTransformOrigin = Pt, Et["-webkit-transform"] = Pt, Et.contentVisibility = this.renderConfig.contentVisibility, this.animationItem.wrapper.appendChild(this.animationItem.container), this.canvasContext = this.animationItem.container.getContext("2d"), this.renderConfig.className && this.animationItem.container.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.animationItem.container.setAttribute("id", this.renderConfig.id);
      } else
        this.canvasContext = this.renderConfig.context;
      this.contextData.setContext(this.canvasContext), this.data = _t, this.layers = _t.layers, this.transformCanvas = { w: _t.w, h: _t.h, sx: 0, sy: 0, tx: 0, ty: 0 }, this.setupGlobalData(_t, document.body), this.globalData.canvasContext = this.canvasContext, this.globalData.renderer = this, this.globalData.isDashed = !1, this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.globalData.transformCanvas = this.transformCanvas, this.elements = createSizedArray(_t.layers.length), this.updateContainerSize();
    }, CanvasRendererBase.prototype.updateContainerSize = function(_t, Et) {
      var Pt, $t, Mt, Bt;
      if (this.reset(), _t ? (Pt = _t, $t = Et, this.canvasContext.canvas.width = Pt, this.canvasContext.canvas.height = $t) : (this.animationItem.wrapper && this.animationItem.container ? (Pt = this.animationItem.wrapper.offsetWidth, $t = this.animationItem.wrapper.offsetHeight) : (Pt = this.canvasContext.canvas.width, $t = this.canvasContext.canvas.height), this.canvasContext.canvas.width = Pt * this.renderConfig.dpr, this.canvasContext.canvas.height = $t * this.renderConfig.dpr), this.renderConfig.preserveAspectRatio.indexOf("meet") !== -1 || this.renderConfig.preserveAspectRatio.indexOf("slice") !== -1) {
        var Vt = this.renderConfig.preserveAspectRatio.split(" "), zt = Vt[1] || "meet", Ht = Vt[0] || "xMidYMid", Wt = Ht.substr(0, 4), Gt = Ht.substr(4);
        Mt = Pt / $t, (Bt = this.transformCanvas.w / this.transformCanvas.h) > Mt && zt === "meet" || Bt < Mt && zt === "slice" ? (this.transformCanvas.sx = Pt / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = Pt / (this.transformCanvas.w / this.renderConfig.dpr)) : (this.transformCanvas.sx = $t / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.sy = $t / (this.transformCanvas.h / this.renderConfig.dpr)), this.transformCanvas.tx = Wt === "xMid" && (Bt < Mt && zt === "meet" || Bt > Mt && zt === "slice") ? (Pt - this.transformCanvas.w * ($t / this.transformCanvas.h)) / 2 * this.renderConfig.dpr : Wt === "xMax" && (Bt < Mt && zt === "meet" || Bt > Mt && zt === "slice") ? (Pt - this.transformCanvas.w * ($t / this.transformCanvas.h)) * this.renderConfig.dpr : 0, this.transformCanvas.ty = Gt === "YMid" && (Bt > Mt && zt === "meet" || Bt < Mt && zt === "slice") ? ($t - this.transformCanvas.h * (Pt / this.transformCanvas.w)) / 2 * this.renderConfig.dpr : Gt === "YMax" && (Bt > Mt && zt === "meet" || Bt < Mt && zt === "slice") ? ($t - this.transformCanvas.h * (Pt / this.transformCanvas.w)) * this.renderConfig.dpr : 0;
      } else
        this.renderConfig.preserveAspectRatio === "none" ? (this.transformCanvas.sx = Pt / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = $t / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.tx = 0, this.transformCanvas.ty = 0) : (this.transformCanvas.sx = this.renderConfig.dpr, this.transformCanvas.sy = this.renderConfig.dpr, this.transformCanvas.tx = 0, this.transformCanvas.ty = 0);
      this.transformCanvas.props = [this.transformCanvas.sx, 0, 0, 0, 0, this.transformCanvas.sy, 0, 0, 0, 0, 1, 0, this.transformCanvas.tx, this.transformCanvas.ty, 0, 1], this.ctxTransform(this.transformCanvas.props), this.canvasContext.beginPath(), this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h), this.canvasContext.closePath(), this.canvasContext.clip(), this.renderFrame(this.renderedFrame, !0);
    }, CanvasRendererBase.prototype.destroy = function() {
      var _t;
      for (this.renderConfig.clearCanvas && this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), _t = (this.layers ? this.layers.length : 0) - 1; _t >= 0; _t -= 1)
        this.elements[_t] && this.elements[_t].destroy && this.elements[_t].destroy();
      this.elements.length = 0, this.globalData.canvasContext = null, this.animationItem.container = null, this.destroyed = !0;
    }, CanvasRendererBase.prototype.renderFrame = function(_t, Et) {
      if ((this.renderedFrame !== _t || this.renderConfig.clearCanvas !== !0 || Et) && !this.destroyed && _t !== -1) {
        var Pt;
        this.renderedFrame = _t, this.globalData.frameNum = _t - this.animationItem._isFirstFrame, this.globalData.frameId += 1, this.globalData._mdf = !this.renderConfig.clearCanvas || Et, this.globalData.projectInterface.currentFrame = _t;
        var $t = this.layers.length;
        for (this.completeLayers || this.checkLayers(_t), Pt = $t - 1; Pt >= 0; Pt -= 1)
          (this.completeLayers || this.elements[Pt]) && this.elements[Pt].prepareFrame(_t - this.layers[Pt].st);
        if (this.globalData._mdf) {
          for (this.renderConfig.clearCanvas === !0 ? this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h) : this.save(), Pt = $t - 1; Pt >= 0; Pt -= 1)
            (this.completeLayers || this.elements[Pt]) && this.elements[Pt].renderFrame();
          this.renderConfig.clearCanvas !== !0 && this.restore();
        }
      }
    }, CanvasRendererBase.prototype.buildItem = function(_t) {
      var Et = this.elements;
      if (!Et[_t] && this.layers[_t].ty !== 99) {
        var Pt = this.createItem(this.layers[_t], this, this.globalData);
        Et[_t] = Pt, Pt.initExpressions();
      }
    }, CanvasRendererBase.prototype.checkPendingElements = function() {
      for (; this.pendingElements.length; )
        this.pendingElements.pop().checkParenting();
    }, CanvasRendererBase.prototype.hide = function() {
      this.animationItem.container.style.display = "none";
    }, CanvasRendererBase.prototype.show = function() {
      this.animationItem.container.style.display = "block";
    }, CVContextData.prototype.duplicate = function() {
      var _t = 2 * this._length, Et = 0;
      for (Et = this._length; Et < _t; Et += 1)
        this.stack[Et] = new CanvasContext();
      this._length = _t;
    }, CVContextData.prototype.reset = function() {
      this.cArrPos = 0, this.cTr.reset(), this.stack[this.cArrPos].opacity = 1;
    }, CVContextData.prototype.restore = function(_t) {
      this.cArrPos -= 1;
      var Et, Pt = this.stack[this.cArrPos], $t = Pt.transform, Mt = this.cTr.props;
      for (Et = 0; Et < 16; Et += 1)
        Mt[Et] = $t[Et];
      if (_t) {
        this.nativeContext.restore();
        var Bt = this.stack[this.cArrPos + 1];
        this.appliedFillStyle = Bt.fillStyle, this.appliedStrokeStyle = Bt.strokeStyle, this.appliedLineWidth = Bt.lineWidth, this.appliedLineCap = Bt.lineCap, this.appliedLineJoin = Bt.lineJoin, this.appliedMiterLimit = Bt.miterLimit;
      }
      this.nativeContext.setTransform($t[0], $t[1], $t[4], $t[5], $t[12], $t[13]), (_t || Pt.opacity !== -1 && this.currentOpacity !== Pt.opacity) && (this.nativeContext.globalAlpha = Pt.opacity, this.currentOpacity = Pt.opacity), this.currentFillStyle = Pt.fillStyle, this.currentStrokeStyle = Pt.strokeStyle, this.currentLineWidth = Pt.lineWidth, this.currentLineCap = Pt.lineCap, this.currentLineJoin = Pt.lineJoin, this.currentMiterLimit = Pt.miterLimit;
    }, CVContextData.prototype.save = function(_t) {
      _t && this.nativeContext.save();
      var Et = this.cTr.props;
      this._length <= this.cArrPos && this.duplicate();
      var Pt, $t = this.stack[this.cArrPos];
      for (Pt = 0; Pt < 16; Pt += 1)
        $t.transform[Pt] = Et[Pt];
      this.cArrPos += 1;
      var Mt = this.stack[this.cArrPos];
      Mt.opacity = $t.opacity, Mt.fillStyle = $t.fillStyle, Mt.strokeStyle = $t.strokeStyle, Mt.lineWidth = $t.lineWidth, Mt.lineCap = $t.lineCap, Mt.lineJoin = $t.lineJoin, Mt.miterLimit = $t.miterLimit;
    }, CVContextData.prototype.setOpacity = function(_t) {
      this.stack[this.cArrPos].opacity = _t;
    }, CVContextData.prototype.setContext = function(_t) {
      this.nativeContext = _t;
    }, CVContextData.prototype.fillStyle = function(_t) {
      this.stack[this.cArrPos].fillStyle !== _t && (this.currentFillStyle = _t, this.stack[this.cArrPos].fillStyle = _t);
    }, CVContextData.prototype.strokeStyle = function(_t) {
      this.stack[this.cArrPos].strokeStyle !== _t && (this.currentStrokeStyle = _t, this.stack[this.cArrPos].strokeStyle = _t);
    }, CVContextData.prototype.lineWidth = function(_t) {
      this.stack[this.cArrPos].lineWidth !== _t && (this.currentLineWidth = _t, this.stack[this.cArrPos].lineWidth = _t);
    }, CVContextData.prototype.lineCap = function(_t) {
      this.stack[this.cArrPos].lineCap !== _t && (this.currentLineCap = _t, this.stack[this.cArrPos].lineCap = _t);
    }, CVContextData.prototype.lineJoin = function(_t) {
      this.stack[this.cArrPos].lineJoin !== _t && (this.currentLineJoin = _t, this.stack[this.cArrPos].lineJoin = _t);
    }, CVContextData.prototype.miterLimit = function(_t) {
      this.stack[this.cArrPos].miterLimit !== _t && (this.currentMiterLimit = _t, this.stack[this.cArrPos].miterLimit = _t);
    }, CVContextData.prototype.transform = function(_t) {
      this.transformMat.cloneFromProps(_t);
      var Et = this.cTr;
      this.transformMat.multiply(Et), Et.cloneFromProps(this.transformMat.props);
      var Pt = Et.props;
      this.nativeContext.setTransform(Pt[0], Pt[1], Pt[4], Pt[5], Pt[12], Pt[13]);
    }, CVContextData.prototype.opacity = function(_t) {
      var Et = this.stack[this.cArrPos].opacity;
      Et *= _t < 0 ? 0 : _t, this.stack[this.cArrPos].opacity !== Et && (this.currentOpacity !== _t && (this.nativeContext.globalAlpha = _t, this.currentOpacity = _t), this.stack[this.cArrPos].opacity = Et);
    }, CVContextData.prototype.fill = function(_t) {
      this.appliedFillStyle !== this.currentFillStyle && (this.appliedFillStyle = this.currentFillStyle, this.nativeContext.fillStyle = this.appliedFillStyle), this.nativeContext.fill(_t);
    }, CVContextData.prototype.fillRect = function(_t, Et, Pt, $t) {
      this.appliedFillStyle !== this.currentFillStyle && (this.appliedFillStyle = this.currentFillStyle, this.nativeContext.fillStyle = this.appliedFillStyle), this.nativeContext.fillRect(_t, Et, Pt, $t);
    }, CVContextData.prototype.stroke = function() {
      this.appliedStrokeStyle !== this.currentStrokeStyle && (this.appliedStrokeStyle = this.currentStrokeStyle, this.nativeContext.strokeStyle = this.appliedStrokeStyle), this.appliedLineWidth !== this.currentLineWidth && (this.appliedLineWidth = this.currentLineWidth, this.nativeContext.lineWidth = this.appliedLineWidth), this.appliedLineCap !== this.currentLineCap && (this.appliedLineCap = this.currentLineCap, this.nativeContext.lineCap = this.appliedLineCap), this.appliedLineJoin !== this.currentLineJoin && (this.appliedLineJoin = this.currentLineJoin, this.nativeContext.lineJoin = this.appliedLineJoin), this.appliedMiterLimit !== this.currentMiterLimit && (this.appliedMiterLimit = this.currentMiterLimit, this.nativeContext.miterLimit = this.appliedMiterLimit), this.nativeContext.stroke();
    }, extendPrototype([CanvasRendererBase, ICompElement, CVBaseElement], CVCompElement), CVCompElement.prototype.renderInnerContent = function() {
      var _t, Et = this.canvasContext;
      for (Et.beginPath(), Et.moveTo(0, 0), Et.lineTo(this.data.w, 0), Et.lineTo(this.data.w, this.data.h), Et.lineTo(0, this.data.h), Et.lineTo(0, 0), Et.clip(), _t = this.layers.length - 1; _t >= 0; _t -= 1)
        (this.completeLayers || this.elements[_t]) && this.elements[_t].renderFrame();
    }, CVCompElement.prototype.destroy = function() {
      var _t;
      for (_t = this.layers.length - 1; _t >= 0; _t -= 1)
        this.elements[_t] && this.elements[_t].destroy();
      this.layers = null, this.elements = null;
    }, CVCompElement.prototype.createComp = function(_t) {
      return new CVCompElement(_t, this.globalData, this);
    }, extendPrototype([CanvasRendererBase], CanvasRenderer), CanvasRenderer.prototype.createComp = function(_t) {
      return new CVCompElement(_t, this.globalData, this);
    }, HBaseElement.prototype = { checkBlendMode: function() {
    }, initRendererElement: function() {
      this.baseElement = createTag(this.data.tg || "div"), this.data.hasMask ? (this.svgElement = createNS("svg"), this.layerElement = createNS("g"), this.maskedElement = this.layerElement, this.svgElement.appendChild(this.layerElement), this.baseElement.appendChild(this.svgElement)) : this.layerElement = this.baseElement, styleDiv(this.baseElement);
    }, createContainerElements: function() {
      this.renderableEffectsManager = new CVEffects(this), this.transformedElement = this.baseElement, this.maskedElement = this.layerElement, this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), this.data.bm !== 0 && this.setBlendMode();
    }, renderElement: function() {
      var _t = this.transformedElement ? this.transformedElement.style : {};
      if (this.finalTransform._matMdf) {
        var Et = this.finalTransform.mat.toCSS();
        _t.transform = Et, _t.webkitTransform = Et;
      }
      this.finalTransform._opMdf && (_t.opacity = this.finalTransform.mProp.o.v);
    }, renderFrame: function() {
      this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
    }, destroy: function() {
      this.layerElement = null, this.transformedElement = null, this.matteElement && (this.matteElement = null), this.maskManager && (this.maskManager.destroy(), this.maskManager = null);
    }, createRenderableComponents: function() {
      this.maskManager = new MaskElement(this.data, this, this.globalData);
    }, addEffects: function() {
    }, setMatte: function() {
    } }, HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement, HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy, HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting, extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], HSolidElement), HSolidElement.prototype.createContent = function() {
      var _t;
      this.data.hasMask ? ((_t = createNS("rect")).setAttribute("width", this.data.sw), _t.setAttribute("height", this.data.sh), _t.setAttribute("fill", this.data.sc), this.svgElement.setAttribute("width", this.data.sw), this.svgElement.setAttribute("height", this.data.sh)) : ((_t = createTag("div")).style.width = this.data.sw + "px", _t.style.height = this.data.sh + "px", _t.style.backgroundColor = this.data.sc), this.layerElement.appendChild(_t);
    }, extendPrototype([BaseElement, TransformElement, HSolidElement, SVGShapeElement, HBaseElement, HierarchyElement, FrameElement, RenderableElement], HShapeElement), HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent, HShapeElement.prototype.createContent = function() {
      var _t;
      if (this.baseElement.style.fontSize = 0, this.data.hasMask)
        this.layerElement.appendChild(this.shapesContainer), _t = this.svgElement;
      else {
        _t = createNS("svg");
        var Et = this.comp.data ? this.comp.data : this.globalData.compSize;
        _t.setAttribute("width", Et.w), _t.setAttribute("height", Et.h), _t.appendChild(this.shapesContainer), this.layerElement.appendChild(_t);
      }
      this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], !0), this.filterUniqueShapes(), this.shapeCont = _t;
    }, HShapeElement.prototype.getTransformedPoint = function(_t, Et) {
      var Pt, $t = _t.length;
      for (Pt = 0; Pt < $t; Pt += 1)
        Et = _t[Pt].mProps.v.applyToPointArray(Et[0], Et[1], 0);
      return Et;
    }, HShapeElement.prototype.calculateShapeBoundingBox = function(_t, Et) {
      var Pt, $t, Mt, Bt, Vt, zt = _t.sh.v, Ht = _t.transformers, Wt = zt._length;
      if (!(Wt <= 1)) {
        for (Pt = 0; Pt < Wt - 1; Pt += 1)
          $t = this.getTransformedPoint(Ht, zt.v[Pt]), Mt = this.getTransformedPoint(Ht, zt.o[Pt]), Bt = this.getTransformedPoint(Ht, zt.i[Pt + 1]), Vt = this.getTransformedPoint(Ht, zt.v[Pt + 1]), this.checkBounds($t, Mt, Bt, Vt, Et);
        zt.c && ($t = this.getTransformedPoint(Ht, zt.v[Pt]), Mt = this.getTransformedPoint(Ht, zt.o[Pt]), Bt = this.getTransformedPoint(Ht, zt.i[0]), Vt = this.getTransformedPoint(Ht, zt.v[0]), this.checkBounds($t, Mt, Bt, Vt, Et));
      }
    }, HShapeElement.prototype.checkBounds = function(_t, Et, Pt, $t, Mt) {
      this.getBoundsOfCurve(_t, Et, Pt, $t);
      var Bt = this.shapeBoundingBox;
      Mt.x = bmMin(Bt.left, Mt.x), Mt.xMax = bmMax(Bt.right, Mt.xMax), Mt.y = bmMin(Bt.top, Mt.y), Mt.yMax = bmMax(Bt.bottom, Mt.yMax);
    }, HShapeElement.prototype.shapeBoundingBox = { left: 0, right: 0, top: 0, bottom: 0 }, HShapeElement.prototype.tempBoundingBox = { x: 0, xMax: 0, y: 0, yMax: 0, width: 0, height: 0 }, HShapeElement.prototype.getBoundsOfCurve = function(_t, Et, Pt, $t) {
      for (var Mt, Bt, Vt, zt, Ht, Wt, Gt, qt = [[_t[0], $t[0]], [_t[1], $t[1]]], Kt = 0; Kt < 2; ++Kt)
        Bt = 6 * _t[Kt] - 12 * Et[Kt] + 6 * Pt[Kt], Mt = -3 * _t[Kt] + 9 * Et[Kt] - 9 * Pt[Kt] + 3 * $t[Kt], Vt = 3 * Et[Kt] - 3 * _t[Kt], Bt |= 0, Vt |= 0, (Mt |= 0) === 0 && Bt === 0 || (Mt === 0 ? (zt = -Vt / Bt) > 0 && zt < 1 && qt[Kt].push(this.calculateF(zt, _t, Et, Pt, $t, Kt)) : (Ht = Bt * Bt - 4 * Vt * Mt) >= 0 && ((Wt = (-Bt + bmSqrt(Ht)) / (2 * Mt)) > 0 && Wt < 1 && qt[Kt].push(this.calculateF(Wt, _t, Et, Pt, $t, Kt)), (Gt = (-Bt - bmSqrt(Ht)) / (2 * Mt)) > 0 && Gt < 1 && qt[Kt].push(this.calculateF(Gt, _t, Et, Pt, $t, Kt))));
      this.shapeBoundingBox.left = bmMin.apply(null, qt[0]), this.shapeBoundingBox.top = bmMin.apply(null, qt[1]), this.shapeBoundingBox.right = bmMax.apply(null, qt[0]), this.shapeBoundingBox.bottom = bmMax.apply(null, qt[1]);
    }, HShapeElement.prototype.calculateF = function(_t, Et, Pt, $t, Mt, Bt) {
      return bmPow(1 - _t, 3) * Et[Bt] + 3 * bmPow(1 - _t, 2) * _t * Pt[Bt] + 3 * (1 - _t) * bmPow(_t, 2) * $t[Bt] + bmPow(_t, 3) * Mt[Bt];
    }, HShapeElement.prototype.calculateBoundingBox = function(_t, Et) {
      var Pt, $t = _t.length;
      for (Pt = 0; Pt < $t; Pt += 1)
        _t[Pt] && _t[Pt].sh ? this.calculateShapeBoundingBox(_t[Pt], Et) : _t[Pt] && _t[Pt].it ? this.calculateBoundingBox(_t[Pt].it, Et) : _t[Pt] && _t[Pt].style && _t[Pt].w && this.expandStrokeBoundingBox(_t[Pt].w, Et);
    }, HShapeElement.prototype.expandStrokeBoundingBox = function(_t, Et) {
      var Pt = 0;
      if (_t.keyframes) {
        for (var $t = 0; $t < _t.keyframes.length; $t += 1) {
          var Mt = _t.keyframes[$t].s;
          Mt > Pt && (Pt = Mt);
        }
        Pt *= _t.mult;
      } else
        Pt = _t.v * _t.mult;
      Et.x -= Pt, Et.xMax += Pt, Et.y -= Pt, Et.yMax += Pt;
    }, HShapeElement.prototype.currentBoxContains = function(_t) {
      return this.currentBBox.x <= _t.x && this.currentBBox.y <= _t.y && this.currentBBox.width + this.currentBBox.x >= _t.x + _t.width && this.currentBBox.height + this.currentBBox.y >= _t.y + _t.height;
    }, HShapeElement.prototype.renderInnerContent = function() {
      if (this._renderShapeFrame(), !this.hidden && (this._isFirstFrame || this._mdf)) {
        var _t = this.tempBoundingBox, Et = 999999;
        if (_t.x = Et, _t.xMax = -Et, _t.y = Et, _t.yMax = -Et, this.calculateBoundingBox(this.itemsData, _t), _t.width = _t.xMax < _t.x ? 0 : _t.xMax - _t.x, _t.height = _t.yMax < _t.y ? 0 : _t.yMax - _t.y, this.currentBoxContains(_t))
          return;
        var Pt = !1;
        if (this.currentBBox.w !== _t.width && (this.currentBBox.w = _t.width, this.shapeCont.setAttribute("width", _t.width), Pt = !0), this.currentBBox.h !== _t.height && (this.currentBBox.h = _t.height, this.shapeCont.setAttribute("height", _t.height), Pt = !0), Pt || this.currentBBox.x !== _t.x || this.currentBBox.y !== _t.y) {
          this.currentBBox.w = _t.width, this.currentBBox.h = _t.height, this.currentBBox.x = _t.x, this.currentBBox.y = _t.y, this.shapeCont.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h);
          var $t = this.shapeCont.style, Mt = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
          $t.transform = Mt, $t.webkitTransform = Mt;
        }
      }
    }, extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], HTextElement), HTextElement.prototype.createContent = function() {
      if (this.isMasked = this.checkMasks(), this.isMasked) {
        this.renderType = "svg", this.compW = this.comp.data.w, this.compH = this.comp.data.h, this.svgElement.setAttribute("width", this.compW), this.svgElement.setAttribute("height", this.compH);
        var _t = createNS("g");
        this.maskedElement.appendChild(_t), this.innerElem = _t;
      } else
        this.renderType = "html", this.innerElem = this.layerElement;
      this.checkParenting();
    }, HTextElement.prototype.buildNewText = function() {
      var _t = this.textProperty.currentData;
      this.renderedLetters = createSizedArray(_t.l ? _t.l.length : 0);
      var Et = this.innerElem.style, Pt = _t.fc ? this.buildColor(_t.fc) : "rgba(0,0,0,0)";
      Et.fill = Pt, Et.color = Pt, _t.sc && (Et.stroke = this.buildColor(_t.sc), Et.strokeWidth = _t.sw + "px");
      var $t, Mt, Bt = this.globalData.fontManager.getFontByName(_t.f);
      if (!this.globalData.fontManager.chars)
        if (Et.fontSize = _t.finalSize + "px", Et.lineHeight = _t.finalSize + "px", Bt.fClass)
          this.innerElem.className = Bt.fClass;
        else {
          Et.fontFamily = Bt.fFamily;
          var Vt = _t.fWeight, zt = _t.fStyle;
          Et.fontStyle = zt, Et.fontWeight = Vt;
        }
      var Ht, Wt, Gt, qt = _t.l;
      Mt = qt.length;
      var Kt, Qt = this.mHelper, Xt = "", Zt = 0;
      for ($t = 0; $t < Mt; $t += 1) {
        if (this.globalData.fontManager.chars ? (this.textPaths[Zt] ? Ht = this.textPaths[Zt] : ((Ht = createNS("path")).setAttribute("stroke-linecap", lineCapEnum[1]), Ht.setAttribute("stroke-linejoin", lineJoinEnum[2]), Ht.setAttribute("stroke-miterlimit", "4")), this.isMasked || (this.textSpans[Zt] ? Gt = (Wt = this.textSpans[Zt]).children[0] : ((Wt = createTag("div")).style.lineHeight = 0, (Gt = createNS("svg")).appendChild(Ht), styleDiv(Wt)))) : this.isMasked ? Ht = this.textPaths[Zt] ? this.textPaths[Zt] : createNS("text") : this.textSpans[Zt] ? (Wt = this.textSpans[Zt], Ht = this.textPaths[Zt]) : (styleDiv(Wt = createTag("span")), styleDiv(Ht = createTag("span")), Wt.appendChild(Ht)), this.globalData.fontManager.chars) {
          var Yt, Jt = this.globalData.fontManager.getCharData(_t.finalText[$t], Bt.fStyle, this.globalData.fontManager.getFontByName(_t.f).fFamily);
          if (Yt = Jt ? Jt.data : null, Qt.reset(), Yt && Yt.shapes && Yt.shapes.length && (Kt = Yt.shapes[0].it, Qt.scale(_t.finalSize / 100, _t.finalSize / 100), Xt = this.createPathShape(Qt, Kt), Ht.setAttribute("d", Xt)), this.isMasked)
            this.innerElem.appendChild(Ht);
          else {
            if (this.innerElem.appendChild(Wt), Yt && Yt.shapes) {
              document.body.appendChild(Gt);
              var er = Gt.getBBox();
              Gt.setAttribute("width", er.width + 2), Gt.setAttribute("height", er.height + 2), Gt.setAttribute("viewBox", er.x - 1 + " " + (er.y - 1) + " " + (er.width + 2) + " " + (er.height + 2));
              var tr = Gt.style, nr = "translate(" + (er.x - 1) + "px," + (er.y - 1) + "px)";
              tr.transform = nr, tr.webkitTransform = nr, qt[$t].yOffset = er.y - 1;
            } else
              Gt.setAttribute("width", 1), Gt.setAttribute("height", 1);
            Wt.appendChild(Gt);
          }
        } else if (Ht.textContent = qt[$t].val, Ht.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"), this.isMasked)
          this.innerElem.appendChild(Ht);
        else {
          this.innerElem.appendChild(Wt);
          var rr = Ht.style, ir = "translate3d(0," + -_t.finalSize / 1.2 + "px,0)";
          rr.transform = ir, rr.webkitTransform = ir;
        }
        this.isMasked ? this.textSpans[Zt] = Ht : this.textSpans[Zt] = Wt, this.textSpans[Zt].style.display = "block", this.textPaths[Zt] = Ht, Zt += 1;
      }
      for (; Zt < this.textSpans.length; )
        this.textSpans[Zt].style.display = "none", Zt += 1;
    }, HTextElement.prototype.renderInnerContent = function() {
      var _t;
      if (this.validateText(), this.data.singleShape) {
        if (!this._isFirstFrame && !this.lettersChangedFlag)
          return;
        if (this.isMasked && this.finalTransform._matMdf) {
          this.svgElement.setAttribute("viewBox", -this.finalTransform.mProp.p.v[0] + " " + -this.finalTransform.mProp.p.v[1] + " " + this.compW + " " + this.compH), _t = this.svgElement.style;
          var Et = "translate(" + -this.finalTransform.mProp.p.v[0] + "px," + -this.finalTransform.mProp.p.v[1] + "px)";
          _t.transform = Et, _t.webkitTransform = Et;
        }
      }
      if (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag) {
        var Pt, $t, Mt, Bt, Vt, zt = 0, Ht = this.textAnimator.renderedLetters, Wt = this.textProperty.currentData.l;
        for ($t = Wt.length, Pt = 0; Pt < $t; Pt += 1)
          Wt[Pt].n ? zt += 1 : (Bt = this.textSpans[Pt], Vt = this.textPaths[Pt], Mt = Ht[zt], zt += 1, Mt._mdf.m && (this.isMasked ? Bt.setAttribute("transform", Mt.m) : (Bt.style.webkitTransform = Mt.m, Bt.style.transform = Mt.m)), Bt.style.opacity = Mt.o, Mt.sw && Mt._mdf.sw && Vt.setAttribute("stroke-width", Mt.sw), Mt.sc && Mt._mdf.sc && Vt.setAttribute("stroke", Mt.sc), Mt.fc && Mt._mdf.fc && (Vt.setAttribute("fill", Mt.fc), Vt.style.color = Mt.fc));
        if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
          var Gt = this.innerElem.getBBox();
          if (this.currentBBox.w !== Gt.width && (this.currentBBox.w = Gt.width, this.svgElement.setAttribute("width", Gt.width)), this.currentBBox.h !== Gt.height && (this.currentBBox.h = Gt.height, this.svgElement.setAttribute("height", Gt.height)), this.currentBBox.w !== Gt.width + 2 || this.currentBBox.h !== Gt.height + 2 || this.currentBBox.x !== Gt.x - 1 || this.currentBBox.y !== Gt.y - 1) {
            this.currentBBox.w = Gt.width + 2, this.currentBBox.h = Gt.height + 2, this.currentBBox.x = Gt.x - 1, this.currentBBox.y = Gt.y - 1, this.svgElement.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h), _t = this.svgElement.style;
            var qt = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
            _t.transform = qt, _t.webkitTransform = qt;
          }
        }
      }
    }, extendPrototype([BaseElement, FrameElement, HierarchyElement], HCameraElement), HCameraElement.prototype.setup = function() {
      var _t, Et, Pt, $t, Mt = this.comp.threeDElements.length;
      for (_t = 0; _t < Mt; _t += 1)
        if ((Et = this.comp.threeDElements[_t]).type === "3d") {
          Pt = Et.perspectiveElem.style, $t = Et.container.style;
          var Bt = this.pe.v + "px", Vt = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
          Pt.perspective = Bt, Pt.webkitPerspective = Bt, $t.transformOrigin = "0px 0px 0px", $t.mozTransformOrigin = "0px 0px 0px", $t.webkitTransformOrigin = "0px 0px 0px", Pt.transform = Vt, Pt.webkitTransform = Vt;
        }
    }, HCameraElement.prototype.createElements = function() {
    }, HCameraElement.prototype.hide = function() {
    }, HCameraElement.prototype.renderFrame = function() {
      var _t, Et, Pt = this._isFirstFrame;
      if (this.hierarchy)
        for (Et = this.hierarchy.length, _t = 0; _t < Et; _t += 1)
          Pt = this.hierarchy[_t].finalTransform.mProp._mdf || Pt;
      if (Pt || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
        if (this.mat.reset(), this.hierarchy)
          for (_t = Et = this.hierarchy.length - 1; _t >= 0; _t -= 1) {
            var $t = this.hierarchy[_t].finalTransform.mProp;
            this.mat.translate(-$t.p.v[0], -$t.p.v[1], $t.p.v[2]), this.mat.rotateX(-$t.or.v[0]).rotateY(-$t.or.v[1]).rotateZ($t.or.v[2]), this.mat.rotateX(-$t.rx.v).rotateY(-$t.ry.v).rotateZ($t.rz.v), this.mat.scale(1 / $t.s.v[0], 1 / $t.s.v[1], 1 / $t.s.v[2]), this.mat.translate($t.a.v[0], $t.a.v[1], $t.a.v[2]);
          }
        if (this.p ? this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]) : this.mat.translate(-this.px.v, -this.py.v, this.pz.v), this.a) {
          var Mt;
          Mt = this.p ? [this.p.v[0] - this.a.v[0], this.p.v[1] - this.a.v[1], this.p.v[2] - this.a.v[2]] : [this.px.v - this.a.v[0], this.py.v - this.a.v[1], this.pz.v - this.a.v[2]];
          var Bt = Math.sqrt(Math.pow(Mt[0], 2) + Math.pow(Mt[1], 2) + Math.pow(Mt[2], 2)), Vt = [Mt[0] / Bt, Mt[1] / Bt, Mt[2] / Bt], zt = Math.sqrt(Vt[2] * Vt[2] + Vt[0] * Vt[0]), Ht = Math.atan2(Vt[1], zt), Wt = Math.atan2(Vt[0], -Vt[2]);
          this.mat.rotateY(Wt).rotateX(-Ht);
        }
        this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v), this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]), this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0), this.mat.translate(0, 0, this.pe.v);
        var Gt = !this._prevMat.equals(this.mat);
        if ((Gt || this.pe._mdf) && this.comp.threeDElements) {
          var qt, Kt, Qt;
          for (Et = this.comp.threeDElements.length, _t = 0; _t < Et; _t += 1)
            if ((qt = this.comp.threeDElements[_t]).type === "3d") {
              if (Gt) {
                var Xt = this.mat.toCSS();
                (Qt = qt.container.style).transform = Xt, Qt.webkitTransform = Xt;
              }
              this.pe._mdf && ((Kt = qt.perspectiveElem.style).perspective = this.pe.v + "px", Kt.webkitPerspective = this.pe.v + "px");
            }
          this.mat.clone(this._prevMat);
        }
      }
      this._isFirstFrame = !1;
    }, HCameraElement.prototype.prepareFrame = function(_t) {
      this.prepareProperties(_t, !0);
    }, HCameraElement.prototype.destroy = function() {
    }, HCameraElement.prototype.getBaseElement = function() {
      return null;
    }, extendPrototype([BaseElement, TransformElement, HBaseElement, HSolidElement, HierarchyElement, FrameElement, RenderableElement], HImageElement), HImageElement.prototype.createContent = function() {
      var _t = this.globalData.getAssetsPath(this.assetData), Et = new Image();
      this.data.hasMask ? (this.imageElem = createNS("image"), this.imageElem.setAttribute("width", this.assetData.w + "px"), this.imageElem.setAttribute("height", this.assetData.h + "px"), this.imageElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", _t), this.layerElement.appendChild(this.imageElem), this.baseElement.setAttribute("width", this.assetData.w), this.baseElement.setAttribute("height", this.assetData.h)) : this.layerElement.appendChild(Et), Et.crossOrigin = "anonymous", Et.src = _t, this.data.ln && this.baseElement.setAttribute("id", this.data.ln);
    }, extendPrototype([BaseRenderer], HybridRendererBase), HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem, HybridRendererBase.prototype.checkPendingElements = function() {
      for (; this.pendingElements.length; )
        this.pendingElements.pop().checkParenting();
    }, HybridRendererBase.prototype.appendElementInPos = function(_t, Et) {
      var Pt = _t.getBaseElement();
      if (Pt) {
        var $t = this.layers[Et];
        if ($t.ddd && this.supports3d)
          this.addTo3dContainer(Pt, Et);
        else if (this.threeDElements)
          this.addTo3dContainer(Pt, Et);
        else {
          for (var Mt, Bt, Vt = 0; Vt < Et; )
            this.elements[Vt] && this.elements[Vt] !== !0 && this.elements[Vt].getBaseElement && (Bt = this.elements[Vt], Mt = (this.layers[Vt].ddd ? this.getThreeDContainerByPos(Vt) : Bt.getBaseElement()) || Mt), Vt += 1;
          Mt ? $t.ddd && this.supports3d || this.layerElement.insertBefore(Pt, Mt) : $t.ddd && this.supports3d || this.layerElement.appendChild(Pt);
        }
      }
    }, HybridRendererBase.prototype.createShape = function(_t) {
      return this.supports3d ? new HShapeElement(_t, this.globalData, this) : new SVGShapeElement(_t, this.globalData, this);
    }, HybridRendererBase.prototype.createText = function(_t) {
      return this.supports3d ? new HTextElement(_t, this.globalData, this) : new SVGTextLottieElement(_t, this.globalData, this);
    }, HybridRendererBase.prototype.createCamera = function(_t) {
      return this.camera = new HCameraElement(_t, this.globalData, this), this.camera;
    }, HybridRendererBase.prototype.createImage = function(_t) {
      return this.supports3d ? new HImageElement(_t, this.globalData, this) : new IImageElement(_t, this.globalData, this);
    }, HybridRendererBase.prototype.createSolid = function(_t) {
      return this.supports3d ? new HSolidElement(_t, this.globalData, this) : new ISolidElement(_t, this.globalData, this);
    }, HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, HybridRendererBase.prototype.getThreeDContainerByPos = function(_t) {
      for (var Et = 0, Pt = this.threeDElements.length; Et < Pt; ) {
        if (this.threeDElements[Et].startPos <= _t && this.threeDElements[Et].endPos >= _t)
          return this.threeDElements[Et].perspectiveElem;
        Et += 1;
      }
      return null;
    }, HybridRendererBase.prototype.createThreeDContainer = function(_t, Et) {
      var Pt, $t, Mt = createTag("div");
      styleDiv(Mt);
      var Bt = createTag("div");
      if (styleDiv(Bt), Et === "3d") {
        (Pt = Mt.style).width = this.globalData.compSize.w + "px", Pt.height = this.globalData.compSize.h + "px", Pt.webkitTransformOrigin = "50% 50%", Pt.mozTransformOrigin = "50% 50%", Pt.transformOrigin = "50% 50%";
        var Vt = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
        ($t = Bt.style).transform = Vt, $t.webkitTransform = Vt;
      }
      Mt.appendChild(Bt);
      var zt = { container: Bt, perspectiveElem: Mt, startPos: _t, endPos: _t, type: Et };
      return this.threeDElements.push(zt), zt;
    }, HybridRendererBase.prototype.build3dContainers = function() {
      var _t, Et, Pt = this.layers.length, $t = "";
      for (_t = 0; _t < Pt; _t += 1)
        this.layers[_t].ddd && this.layers[_t].ty !== 3 ? ($t !== "3d" && ($t = "3d", Et = this.createThreeDContainer(_t, "3d")), Et.endPos = Math.max(Et.endPos, _t)) : ($t !== "2d" && ($t = "2d", Et = this.createThreeDContainer(_t, "2d")), Et.endPos = Math.max(Et.endPos, _t));
      for (_t = (Pt = this.threeDElements.length) - 1; _t >= 0; _t -= 1)
        this.resizerElem.appendChild(this.threeDElements[_t].perspectiveElem);
    }, HybridRendererBase.prototype.addTo3dContainer = function(_t, Et) {
      for (var Pt = 0, $t = this.threeDElements.length; Pt < $t; ) {
        if (Et <= this.threeDElements[Pt].endPos) {
          for (var Mt, Bt = this.threeDElements[Pt].startPos; Bt < Et; )
            this.elements[Bt] && this.elements[Bt].getBaseElement && (Mt = this.elements[Bt].getBaseElement()), Bt += 1;
          Mt ? this.threeDElements[Pt].container.insertBefore(_t, Mt) : this.threeDElements[Pt].container.appendChild(_t);
          break;
        }
        Pt += 1;
      }
    }, HybridRendererBase.prototype.configAnimation = function(_t) {
      var Et = createTag("div"), Pt = this.animationItem.wrapper, $t = Et.style;
      $t.width = _t.w + "px", $t.height = _t.h + "px", this.resizerElem = Et, styleDiv(Et), $t.transformStyle = "flat", $t.mozTransformStyle = "flat", $t.webkitTransformStyle = "flat", this.renderConfig.className && Et.setAttribute("class", this.renderConfig.className), Pt.appendChild(Et), $t.overflow = "hidden";
      var Mt = createNS("svg");
      Mt.setAttribute("width", "1"), Mt.setAttribute("height", "1"), styleDiv(Mt), this.resizerElem.appendChild(Mt);
      var Bt = createNS("defs");
      Mt.appendChild(Bt), this.data = _t, this.setupGlobalData(_t, Mt), this.globalData.defs = Bt, this.layers = _t.layers, this.layerElement = this.resizerElem, this.build3dContainers(), this.updateContainerSize();
    }, HybridRendererBase.prototype.destroy = function() {
      var _t;
      this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.animationItem.container = null, this.globalData.defs = null;
      var Et = this.layers ? this.layers.length : 0;
      for (_t = 0; _t < Et; _t += 1)
        this.elements[_t] && this.elements[_t].destroy && this.elements[_t].destroy();
      this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
    }, HybridRendererBase.prototype.updateContainerSize = function() {
      var _t, Et, Pt, $t, Mt = this.animationItem.wrapper.offsetWidth, Bt = this.animationItem.wrapper.offsetHeight, Vt = Mt / Bt;
      this.globalData.compSize.w / this.globalData.compSize.h > Vt ? (_t = Mt / this.globalData.compSize.w, Et = Mt / this.globalData.compSize.w, Pt = 0, $t = (Bt - this.globalData.compSize.h * (Mt / this.globalData.compSize.w)) / 2) : (_t = Bt / this.globalData.compSize.h, Et = Bt / this.globalData.compSize.h, Pt = (Mt - this.globalData.compSize.w * (Bt / this.globalData.compSize.h)) / 2, $t = 0);
      var zt = this.resizerElem.style;
      zt.webkitTransform = "matrix3d(" + _t + ",0,0,0,0," + Et + ",0,0,0,0,1,0," + Pt + "," + $t + ",0,1)", zt.transform = zt.webkitTransform;
    }, HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame, HybridRendererBase.prototype.hide = function() {
      this.resizerElem.style.display = "none";
    }, HybridRendererBase.prototype.show = function() {
      this.resizerElem.style.display = "block";
    }, HybridRendererBase.prototype.initItems = function() {
      if (this.buildAllItems(), this.camera)
        this.camera.setup();
      else {
        var _t, Et = this.globalData.compSize.w, Pt = this.globalData.compSize.h, $t = this.threeDElements.length;
        for (_t = 0; _t < $t; _t += 1) {
          var Mt = this.threeDElements[_t].perspectiveElem.style;
          Mt.webkitPerspective = Math.sqrt(Math.pow(Et, 2) + Math.pow(Pt, 2)) + "px", Mt.perspective = Mt.webkitPerspective;
        }
      }
    }, HybridRendererBase.prototype.searchExtraCompositions = function(_t) {
      var Et, Pt = _t.length, $t = createTag("div");
      for (Et = 0; Et < Pt; Et += 1)
        if (_t[Et].xt) {
          var Mt = this.createComp(_t[Et], $t, this.globalData.comp, null);
          Mt.initExpressions(), this.globalData.projectInterface.registerComposition(Mt);
        }
    }, extendPrototype([HybridRendererBase, ICompElement, HBaseElement], HCompElement), HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements, HCompElement.prototype.createContainerElements = function() {
      this._createBaseContainerElements(), this.data.hasMask ? (this.svgElement.setAttribute("width", this.data.w), this.svgElement.setAttribute("height", this.data.h), this.transformedElement = this.baseElement) : this.transformedElement = this.layerElement;
    }, HCompElement.prototype.addTo3dContainer = function(_t, Et) {
      for (var Pt, $t = 0; $t < Et; )
        this.elements[$t] && this.elements[$t].getBaseElement && (Pt = this.elements[$t].getBaseElement()), $t += 1;
      Pt ? this.layerElement.insertBefore(_t, Pt) : this.layerElement.appendChild(_t);
    }, HCompElement.prototype.createComp = function(_t) {
      return this.supports3d ? new HCompElement(_t, this.globalData, this) : new SVGCompElement(_t, this.globalData, this);
    }, extendPrototype([HybridRendererBase], HybridRenderer), HybridRenderer.prototype.createComp = function(_t) {
      return this.supports3d ? new HCompElement(_t, this.globalData, this) : new SVGCompElement(_t, this.globalData, this);
    };
    var CompExpressionInterface = function(_t) {
      function Et(Pt) {
        for (var $t = 0, Mt = _t.layers.length; $t < Mt; ) {
          if (_t.layers[$t].nm === Pt || _t.layers[$t].ind === Pt)
            return _t.elements[$t].layerInterface;
          $t += 1;
        }
        return null;
      }
      return Object.defineProperty(Et, "_name", { value: _t.data.nm }), Et.layer = Et, Et.pixelAspect = 1, Et.height = _t.data.h || _t.globalData.compSize.h, Et.width = _t.data.w || _t.globalData.compSize.w, Et.pixelAspect = 1, Et.frameDuration = 1 / _t.globalData.frameRate, Et.displayStartTime = 0, Et.numLayers = _t.layers.length, Et;
    };
    function _typeof$2(_t) {
      return (_typeof$2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Et) {
        return typeof Et;
      } : function(Et) {
        return Et && typeof Symbol == "function" && Et.constructor === Symbol && Et !== Symbol.prototype ? "symbol" : typeof Et;
      })(_t);
    }
    function seedRandom(_t, Et) {
      var Pt = this, $t = Et.pow(256, 6), Mt = Et.pow(2, 52), Bt = 2 * Mt;
      function Vt(Gt) {
        var qt, Kt = Gt.length, Qt = this, Xt = 0, Zt = Qt.i = Qt.j = 0, Yt = Qt.S = [];
        for (Kt || (Gt = [Kt++]); Xt < 256; )
          Yt[Xt] = Xt++;
        for (Xt = 0; Xt < 256; Xt++)
          Yt[Xt] = Yt[Zt = 255 & Zt + Gt[Xt % Kt] + (qt = Yt[Xt])], Yt[Zt] = qt;
        Qt.g = function(Jt) {
          for (var er, tr = 0, nr = Qt.i, rr = Qt.j, ir = Qt.S; Jt--; )
            er = ir[nr = 255 & nr + 1], tr = 256 * tr + ir[255 & (ir[nr] = ir[rr = 255 & rr + er]) + (ir[rr] = er)];
          return Qt.i = nr, Qt.j = rr, tr;
        };
      }
      function zt(Gt, qt) {
        return qt.i = Gt.i, qt.j = Gt.j, qt.S = Gt.S.slice(), qt;
      }
      function Ht(Gt, qt) {
        for (var Kt, Qt = Gt + "", Xt = 0; Xt < Qt.length; )
          qt[255 & Xt] = 255 & (Kt ^= 19 * qt[255 & Xt]) + Qt.charCodeAt(Xt++);
        return Wt(qt);
      }
      function Wt(Gt) {
        return String.fromCharCode.apply(0, Gt);
      }
      Et.seedrandom = function(Gt, qt, Kt) {
        var Qt = [], Xt = Ht(function Jt(er, tr) {
          var nr, rr = [], ir = _typeof$2(er);
          if (tr && ir == "object")
            for (nr in er)
              try {
                rr.push(Jt(er[nr], tr - 1));
              } catch {
              }
          return rr.length ? rr : ir == "string" ? er : er + "\0";
        }((qt = qt === !0 ? { entropy: !0 } : qt || {}).entropy ? [Gt, Wt(_t)] : Gt === null ? function() {
          try {
            var Jt = new Uint8Array(256);
            return (Pt.crypto || Pt.msCrypto).getRandomValues(Jt), Wt(Jt);
          } catch {
            var er = Pt.navigator, tr = er && er.plugins;
            return [+/* @__PURE__ */ new Date(), Pt, tr, Pt.screen, Wt(_t)];
          }
        }() : Gt, 3), Qt), Zt = new Vt(Qt), Yt = function() {
          for (var Jt = Zt.g(6), er = $t, tr = 0; Jt < Mt; )
            Jt = 256 * (Jt + tr), er *= 256, tr = Zt.g(1);
          for (; Jt >= Bt; )
            Jt /= 2, er /= 2, tr >>>= 1;
          return (Jt + tr) / er;
        };
        return Yt.int32 = function() {
          return 0 | Zt.g(4);
        }, Yt.quick = function() {
          return Zt.g(4) / 4294967296;
        }, Yt.double = Yt, Ht(Wt(Zt.S), _t), (qt.pass || Kt || function(Jt, er, tr, nr) {
          return nr && (nr.S && zt(nr, Zt), Jt.state = function() {
            return zt(Zt, {});
          }), tr ? (Et.random = Jt, er) : Jt;
        })(Yt, Xt, "global" in qt ? qt.global : this == Et, qt.state);
      }, Ht(Et.random(), _t);
    }
    function initialize$2(_t) {
      seedRandom([], _t);
    }
    var propTypes = { SHAPE: "shape" };
    function _typeof$1(_t) {
      return (_typeof$1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Et) {
        return typeof Et;
      } : function(Et) {
        return Et && typeof Symbol == "function" && Et.constructor === Symbol && Et !== Symbol.prototype ? "symbol" : typeof Et;
      })(_t);
    }
    var ExpressionManager = function() {
      var ob = {}, Math = BMMath, window = null, document = null, XMLHttpRequest = null, fetch = null, frames = null, _lottieGlobal = {};
      function resetFrame() {
        _lottieGlobal = {};
      }
      function $bm_isInstanceOfArray(_t) {
        return _t.constructor === Array || _t.constructor === Float32Array;
      }
      function isNumerable(_t, Et) {
        return _t === "number" || Et instanceof Number || _t === "boolean" || _t === "string";
      }
      function $bm_neg(_t) {
        var Et = _typeof$1(_t);
        if (Et === "number" || _t instanceof Number || Et === "boolean")
          return -_t;
        if ($bm_isInstanceOfArray(_t)) {
          var Pt, $t = _t.length, Mt = [];
          for (Pt = 0; Pt < $t; Pt += 1)
            Mt[Pt] = -_t[Pt];
          return Mt;
        }
        return _t.propType ? _t.v : -_t;
      }
      initialize$2(BMMath);
      var easeInBez = BezierFactory.getBezierEasing(0.333, 0, 0.833, 0.833, "easeIn").get, easeOutBez = BezierFactory.getBezierEasing(0.167, 0.167, 0.667, 1, "easeOut").get, easeInOutBez = BezierFactory.getBezierEasing(0.33, 0, 0.667, 1, "easeInOut").get;
      function sum(_t, Et) {
        var Pt = _typeof$1(_t), $t = _typeof$1(Et);
        if (isNumerable(Pt, _t) && isNumerable($t, Et) || Pt === "string" || $t === "string")
          return _t + Et;
        if ($bm_isInstanceOfArray(_t) && isNumerable($t, Et))
          return (_t = _t.slice(0))[0] += Et, _t;
        if (isNumerable(Pt, _t) && $bm_isInstanceOfArray(Et))
          return (Et = Et.slice(0))[0] = _t + Et[0], Et;
        if ($bm_isInstanceOfArray(_t) && $bm_isInstanceOfArray(Et)) {
          for (var Mt = 0, Bt = _t.length, Vt = Et.length, zt = []; Mt < Bt || Mt < Vt; )
            (typeof _t[Mt] == "number" || _t[Mt] instanceof Number) && (typeof Et[Mt] == "number" || Et[Mt] instanceof Number) ? zt[Mt] = _t[Mt] + Et[Mt] : zt[Mt] = Et[Mt] === void 0 ? _t[Mt] : _t[Mt] || Et[Mt], Mt += 1;
          return zt;
        }
        return 0;
      }
      var add = sum;
      function sub(_t, Et) {
        var Pt = _typeof$1(_t), $t = _typeof$1(Et);
        if (isNumerable(Pt, _t) && isNumerable($t, Et))
          return Pt === "string" && (_t = parseInt(_t, 10)), $t === "string" && (Et = parseInt(Et, 10)), _t - Et;
        if ($bm_isInstanceOfArray(_t) && isNumerable($t, Et))
          return (_t = _t.slice(0))[0] -= Et, _t;
        if (isNumerable(Pt, _t) && $bm_isInstanceOfArray(Et))
          return (Et = Et.slice(0))[0] = _t - Et[0], Et;
        if ($bm_isInstanceOfArray(_t) && $bm_isInstanceOfArray(Et)) {
          for (var Mt = 0, Bt = _t.length, Vt = Et.length, zt = []; Mt < Bt || Mt < Vt; )
            (typeof _t[Mt] == "number" || _t[Mt] instanceof Number) && (typeof Et[Mt] == "number" || Et[Mt] instanceof Number) ? zt[Mt] = _t[Mt] - Et[Mt] : zt[Mt] = Et[Mt] === void 0 ? _t[Mt] : _t[Mt] || Et[Mt], Mt += 1;
          return zt;
        }
        return 0;
      }
      function mul(_t, Et) {
        var Pt, $t, Mt, Bt = _typeof$1(_t), Vt = _typeof$1(Et);
        if (isNumerable(Bt, _t) && isNumerable(Vt, Et))
          return _t * Et;
        if ($bm_isInstanceOfArray(_t) && isNumerable(Vt, Et)) {
          for (Mt = _t.length, Pt = createTypedArray("float32", Mt), $t = 0; $t < Mt; $t += 1)
            Pt[$t] = _t[$t] * Et;
          return Pt;
        }
        if (isNumerable(Bt, _t) && $bm_isInstanceOfArray(Et)) {
          for (Mt = Et.length, Pt = createTypedArray("float32", Mt), $t = 0; $t < Mt; $t += 1)
            Pt[$t] = _t * Et[$t];
          return Pt;
        }
        return 0;
      }
      function div(_t, Et) {
        var Pt, $t, Mt, Bt = _typeof$1(_t), Vt = _typeof$1(Et);
        if (isNumerable(Bt, _t) && isNumerable(Vt, Et))
          return _t / Et;
        if ($bm_isInstanceOfArray(_t) && isNumerable(Vt, Et)) {
          for (Mt = _t.length, Pt = createTypedArray("float32", Mt), $t = 0; $t < Mt; $t += 1)
            Pt[$t] = _t[$t] / Et;
          return Pt;
        }
        if (isNumerable(Bt, _t) && $bm_isInstanceOfArray(Et)) {
          for (Mt = Et.length, Pt = createTypedArray("float32", Mt), $t = 0; $t < Mt; $t += 1)
            Pt[$t] = _t / Et[$t];
          return Pt;
        }
        return 0;
      }
      function mod(_t, Et) {
        return typeof _t == "string" && (_t = parseInt(_t, 10)), typeof Et == "string" && (Et = parseInt(Et, 10)), _t % Et;
      }
      var $bm_sum = sum, $bm_sub = sub, $bm_mul = mul, $bm_div = div, $bm_mod = mod;
      function clamp(_t, Et, Pt) {
        if (Et > Pt) {
          var $t = Pt;
          Pt = Et, Et = $t;
        }
        return Math.min(Math.max(_t, Et), Pt);
      }
      function radiansToDegrees(_t) {
        return _t / degToRads;
      }
      var radians_to_degrees = radiansToDegrees;
      function degreesToRadians(_t) {
        return _t * degToRads;
      }
      var degrees_to_radians = radiansToDegrees, helperLengthArray = [0, 0, 0, 0, 0, 0];
      function length(_t, Et) {
        if (typeof _t == "number" || _t instanceof Number)
          return Et = Et || 0, Math.abs(_t - Et);
        var Pt;
        Et || (Et = helperLengthArray);
        var $t = Math.min(_t.length, Et.length), Mt = 0;
        for (Pt = 0; Pt < $t; Pt += 1)
          Mt += Math.pow(Et[Pt] - _t[Pt], 2);
        return Math.sqrt(Mt);
      }
      function normalize(_t) {
        return div(_t, length(_t));
      }
      function rgbToHsl(_t) {
        var Et, Pt, $t = _t[0], Mt = _t[1], Bt = _t[2], Vt = Math.max($t, Mt, Bt), zt = Math.min($t, Mt, Bt), Ht = (Vt + zt) / 2;
        if (Vt === zt)
          Et = 0, Pt = 0;
        else {
          var Wt = Vt - zt;
          switch (Pt = Ht > 0.5 ? Wt / (2 - Vt - zt) : Wt / (Vt + zt), Vt) {
            case $t:
              Et = (Mt - Bt) / Wt + (Mt < Bt ? 6 : 0);
              break;
            case Mt:
              Et = (Bt - $t) / Wt + 2;
              break;
            case Bt:
              Et = ($t - Mt) / Wt + 4;
          }
          Et /= 6;
        }
        return [Et, Pt, Ht, _t[3]];
      }
      function hue2rgb(_t, Et, Pt) {
        return Pt < 0 && (Pt += 1), Pt > 1 && (Pt -= 1), Pt < 1 / 6 ? _t + 6 * (Et - _t) * Pt : Pt < 0.5 ? Et : Pt < 2 / 3 ? _t + (Et - _t) * (2 / 3 - Pt) * 6 : _t;
      }
      function hslToRgb(_t) {
        var Et, Pt, $t, Mt = _t[0], Bt = _t[1], Vt = _t[2];
        if (Bt === 0)
          Et = Vt, $t = Vt, Pt = Vt;
        else {
          var zt = Vt < 0.5 ? Vt * (1 + Bt) : Vt + Bt - Vt * Bt, Ht = 2 * Vt - zt;
          Et = hue2rgb(Ht, zt, Mt + 1 / 3), Pt = hue2rgb(Ht, zt, Mt), $t = hue2rgb(Ht, zt, Mt - 1 / 3);
        }
        return [Et, Pt, $t, _t[3]];
      }
      function linear(_t, Et, Pt, $t, Mt) {
        if ($t !== void 0 && Mt !== void 0 || ($t = Et, Mt = Pt, Et = 0, Pt = 1), Pt < Et) {
          var Bt = Pt;
          Pt = Et, Et = Bt;
        }
        if (_t <= Et)
          return $t;
        if (_t >= Pt)
          return Mt;
        var Vt, zt = Pt === Et ? 0 : (_t - Et) / (Pt - Et);
        if (!$t.length)
          return $t + (Mt - $t) * zt;
        var Ht = $t.length, Wt = createTypedArray("float32", Ht);
        for (Vt = 0; Vt < Ht; Vt += 1)
          Wt[Vt] = $t[Vt] + (Mt[Vt] - $t[Vt]) * zt;
        return Wt;
      }
      function random(_t, Et) {
        if (Et === void 0 && (_t === void 0 ? (_t = 0, Et = 1) : (Et = _t, _t = void 0)), Et.length) {
          var Pt, $t = Et.length;
          _t || (_t = createTypedArray("float32", $t));
          var Mt = createTypedArray("float32", $t), Bt = BMMath.random();
          for (Pt = 0; Pt < $t; Pt += 1)
            Mt[Pt] = _t[Pt] + Bt * (Et[Pt] - _t[Pt]);
          return Mt;
        }
        return _t === void 0 && (_t = 0), _t + BMMath.random() * (Et - _t);
      }
      function createPath(_t, Et, Pt, $t) {
        var Mt, Bt = _t.length, Vt = shapePool.newElement();
        Vt.setPathData(!!$t, Bt);
        var zt, Ht, Wt = [0, 0];
        for (Mt = 0; Mt < Bt; Mt += 1)
          zt = Et && Et[Mt] ? Et[Mt] : Wt, Ht = Pt && Pt[Mt] ? Pt[Mt] : Wt, Vt.setTripleAt(_t[Mt][0], _t[Mt][1], Ht[0] + _t[Mt][0], Ht[1] + _t[Mt][1], zt[0] + _t[Mt][0], zt[1] + _t[Mt][1], Mt, !0);
        return Vt;
      }
      function initiateExpression(elem, data, property) {
        function noOp(_t) {
          return _t;
        }
        if (!elem.globalData.renderConfig.runExpressions)
          return noOp;
        var val = data.x, needsVelocity = /velocity(?![\w\d])/.test(val), _needsRandom = val.indexOf("random") !== -1, elemType = elem.data.ty, transform, $bm_transform, content, effect, thisProperty = property;
        thisProperty.valueAtTime = thisProperty.getValueAtTime, Object.defineProperty(thisProperty, "value", { get: function() {
          return thisProperty.v;
        } }), elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate, elem.comp.displayStartTime = 0;
        var inPoint = elem.data.ip / elem.comp.globalData.frameRate, outPoint = elem.data.op / elem.comp.globalData.frameRate, width = elem.data.sw ? elem.data.sw : 0, height = elem.data.sh ? elem.data.sh : 0, name = elem.data.nm, loopIn, loop_in, loopOut, loop_out, smooth, toWorld, fromWorld, fromComp, toComp, fromCompToSurface, position, rotation, anchorPoint, scale, thisLayer, thisComp, mask, valueAtTime, velocityAtTime, scoped_bm_rt, expression_function = eval("[function _expression_function(){" + val + ";scoped_bm_rt=$bm_rt}]")[0], numKeys = property.kf ? data.k.length : 0, active = !this.data || this.data.hd !== !0, wiggle = (function(_t, Et) {
          var Pt, $t, Mt = this.pv.length ? this.pv.length : 1, Bt = createTypedArray("float32", Mt), Vt = Math.floor(5 * time);
          for (Pt = 0, $t = 0; Pt < Vt; ) {
            for ($t = 0; $t < Mt; $t += 1)
              Bt[$t] += -Et + 2 * Et * BMMath.random();
            Pt += 1;
          }
          var zt = 5 * time, Ht = zt - Math.floor(zt), Wt = createTypedArray("float32", Mt);
          if (Mt > 1) {
            for ($t = 0; $t < Mt; $t += 1)
              Wt[$t] = this.pv[$t] + Bt[$t] + (-Et + 2 * Et * BMMath.random()) * Ht;
            return Wt;
          }
          return this.pv + Bt[0] + (-Et + 2 * Et * BMMath.random()) * Ht;
        }).bind(this);
        function loopInDuration(_t, Et) {
          return loopIn(_t, Et, !0);
        }
        function loopOutDuration(_t, Et) {
          return loopOut(_t, Et, !0);
        }
        thisProperty.loopIn && (loopIn = thisProperty.loopIn.bind(thisProperty), loop_in = loopIn), thisProperty.loopOut && (loopOut = thisProperty.loopOut.bind(thisProperty), loop_out = loopOut), thisProperty.smooth && (smooth = thisProperty.smooth.bind(thisProperty)), this.getValueAtTime && (valueAtTime = this.getValueAtTime.bind(this)), this.getVelocityAtTime && (velocityAtTime = this.getVelocityAtTime.bind(this));
        var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface), time, velocity, value, text, textIndex, textTotal, selectorValue;
        function lookAt(_t, Et) {
          var Pt = [Et[0] - _t[0], Et[1] - _t[1], Et[2] - _t[2]], $t = Math.atan2(Pt[0], Math.sqrt(Pt[1] * Pt[1] + Pt[2] * Pt[2])) / degToRads;
          return [-Math.atan2(Pt[1], Pt[2]) / degToRads, $t, 0];
        }
        function easeOut(_t, Et, Pt, $t, Mt) {
          return applyEase(easeOutBez, _t, Et, Pt, $t, Mt);
        }
        function easeIn(_t, Et, Pt, $t, Mt) {
          return applyEase(easeInBez, _t, Et, Pt, $t, Mt);
        }
        function ease(_t, Et, Pt, $t, Mt) {
          return applyEase(easeInOutBez, _t, Et, Pt, $t, Mt);
        }
        function applyEase(_t, Et, Pt, $t, Mt, Bt) {
          Mt === void 0 ? (Mt = Pt, Bt = $t) : Et = (Et - Pt) / ($t - Pt), Et > 1 ? Et = 1 : Et < 0 && (Et = 0);
          var Vt = _t(Et);
          if ($bm_isInstanceOfArray(Mt)) {
            var zt, Ht = Mt.length, Wt = createTypedArray("float32", Ht);
            for (zt = 0; zt < Ht; zt += 1)
              Wt[zt] = (Bt[zt] - Mt[zt]) * Vt + Mt[zt];
            return Wt;
          }
          return (Bt - Mt) * Vt + Mt;
        }
        function nearestKey(_t) {
          var Et, Pt, $t, Mt = data.k.length;
          if (data.k.length && typeof data.k[0] != "number")
            if (Pt = -1, (_t *= elem.comp.globalData.frameRate) < data.k[0].t)
              Pt = 1, $t = data.k[0].t;
            else {
              for (Et = 0; Et < Mt - 1; Et += 1) {
                if (_t === data.k[Et].t) {
                  Pt = Et + 1, $t = data.k[Et].t;
                  break;
                }
                if (_t > data.k[Et].t && _t < data.k[Et + 1].t) {
                  _t - data.k[Et].t > data.k[Et + 1].t - _t ? (Pt = Et + 2, $t = data.k[Et + 1].t) : (Pt = Et + 1, $t = data.k[Et].t);
                  break;
                }
              }
              Pt === -1 && (Pt = Et + 1, $t = data.k[Et].t);
            }
          else
            Pt = 0, $t = 0;
          var Bt = {};
          return Bt.index = Pt, Bt.time = $t / elem.comp.globalData.frameRate, Bt;
        }
        function key(_t) {
          var Et, Pt, $t;
          if (!data.k.length || typeof data.k[0] == "number")
            throw new Error("The property has no keyframe at index " + _t);
          _t -= 1, Et = { time: data.k[_t].t / elem.comp.globalData.frameRate, value: [] };
          var Mt = Object.prototype.hasOwnProperty.call(data.k[_t], "s") ? data.k[_t].s : data.k[_t - 1].e;
          for ($t = Mt.length, Pt = 0; Pt < $t; Pt += 1)
            Et[Pt] = Mt[Pt], Et.value[Pt] = Mt[Pt];
          return Et;
        }
        function framesToTime(_t, Et) {
          return Et || (Et = elem.comp.globalData.frameRate), _t / Et;
        }
        function timeToFrames(_t, Et) {
          return _t || _t === 0 || (_t = time), Et || (Et = elem.comp.globalData.frameRate), _t * Et;
        }
        function seedRandom(_t) {
          BMMath.seedrandom(randSeed + _t);
        }
        function sourceRectAtTime() {
          return elem.sourceRectAtTime();
        }
        function substring(_t, Et) {
          return typeof value == "string" ? Et === void 0 ? value.substring(_t) : value.substring(_t, Et) : "";
        }
        function substr(_t, Et) {
          return typeof value == "string" ? Et === void 0 ? value.substr(_t) : value.substr(_t, Et) : "";
        }
        function posterizeTime(_t) {
          time = _t === 0 ? 0 : Math.floor(time * _t) / _t, value = valueAtTime(time);
        }
        var index = elem.data.ind;
        !elem.hierarchy || elem.hierarchy.length;
        var parent, randSeed = Math.floor(1e6 * Math.random()), globalData = elem.globalData;
        function executeExpression(_t) {
          return value = _t, this.frameExpressionId === elem.globalData.frameId && this.propType !== "textSelector" ? value : (this.propType === "textSelector" && (textIndex = this.textIndex, textTotal = this.textTotal, selectorValue = this.selectorValue), thisLayer || (text = elem.layerInterface.text, thisLayer = elem.layerInterface, thisComp = elem.comp.compInterface, toWorld = thisLayer.toWorld.bind(thisLayer), fromWorld = thisLayer.fromWorld.bind(thisLayer), fromComp = thisLayer.fromComp.bind(thisLayer), toComp = thisLayer.toComp.bind(thisLayer), mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null, fromCompToSurface = fromComp), transform || (transform = elem.layerInterface("ADBE Transform Group"), $bm_transform = transform, transform && (anchorPoint = transform.anchorPoint)), elemType !== 4 || content || (content = thisLayer("ADBE Root Vectors Group")), effect || (effect = thisLayer(4)), !(!elem.hierarchy || !elem.hierarchy.length) && !parent && (parent = elem.hierarchy[0].layerInterface), time = this.comp.renderedFrame / this.comp.globalData.frameRate, _needsRandom && seedRandom(randSeed + time), needsVelocity && (velocity = velocityAtTime(time)), expression_function(), this.frameExpressionId = elem.globalData.frameId, scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt);
        }
        return executeExpression.__preventDeadCodeRemoval = [$bm_transform, anchorPoint, time, velocity, inPoint, outPoint, width, height, name, loop_in, loop_out, smooth, toComp, fromCompToSurface, toWorld, fromWorld, mask, position, rotation, scale, thisComp, numKeys, active, wiggle, loopInDuration, loopOutDuration, comp, lookAt, easeOut, easeIn, ease, nearestKey, key, text, textIndex, textTotal, selectorValue, framesToTime, timeToFrames, sourceRectAtTime, substring, substr, posterizeTime, index, globalData], executeExpression;
      }
      return ob.initiateExpression = initiateExpression, ob.__preventDeadCodeRemoval = [window, document, XMLHttpRequest, fetch, frames, $bm_neg, add, $bm_sum, $bm_sub, $bm_mul, $bm_div, $bm_mod, clamp, radians_to_degrees, degreesToRadians, degrees_to_radians, normalize, rgbToHsl, hslToRgb, linear, random, createPath, _lottieGlobal], ob.resetFrame = resetFrame, ob;
    }(), Expressions = function() {
      var _t = {};
      return _t.initExpressions = function(Et) {
        var Pt = 0, $t = [];
        Et.renderer.compInterface = CompExpressionInterface(Et.renderer), Et.renderer.globalData.projectInterface.registerComposition(Et.renderer), Et.renderer.globalData.pushExpression = function() {
          Pt += 1;
        }, Et.renderer.globalData.popExpression = function() {
          (Pt -= 1) === 0 && function() {
            var Mt, Bt = $t.length;
            for (Mt = 0; Mt < Bt; Mt += 1)
              $t[Mt].release();
            $t.length = 0;
          }();
        }, Et.renderer.globalData.registerExpressionProperty = function(Mt) {
          $t.indexOf(Mt) === -1 && $t.push(Mt);
        };
      }, _t.resetFrame = ExpressionManager.resetFrame, _t;
    }(), MaskManagerInterface = function() {
      function _t(Et, Pt) {
        this._mask = Et, this._data = Pt;
      }
      return Object.defineProperty(_t.prototype, "maskPath", { get: function() {
        return this._mask.prop.k && this._mask.prop.getValue(), this._mask.prop;
      } }), Object.defineProperty(_t.prototype, "maskOpacity", { get: function() {
        return this._mask.op.k && this._mask.op.getValue(), 100 * this._mask.op.v;
      } }), function(Et) {
        var Pt, $t = createSizedArray(Et.viewData.length), Mt = Et.viewData.length;
        for (Pt = 0; Pt < Mt; Pt += 1)
          $t[Pt] = new _t(Et.viewData[Pt], Et.masksProperties[Pt]);
        return function(Bt) {
          for (Pt = 0; Pt < Mt; ) {
            if (Et.masksProperties[Pt].nm === Bt)
              return $t[Pt];
            Pt += 1;
          }
          return null;
        };
      };
    }(), ExpressionPropertyInterface = /* @__PURE__ */ function() {
      var _t = { pv: 0, v: 0, mult: 1 }, Et = { pv: [0, 0, 0], v: [0, 0, 0], mult: 1 };
      function Pt(Mt, Bt, Vt) {
        Object.defineProperty(Mt, "velocity", { get: function() {
          return Bt.getVelocityAtTime(Bt.comp.currentFrame);
        } }), Mt.numKeys = Bt.keyframes ? Bt.keyframes.length : 0, Mt.key = function(zt) {
          if (!Mt.numKeys)
            return 0;
          var Ht = "";
          Ht = "s" in Bt.keyframes[zt - 1] ? Bt.keyframes[zt - 1].s : "e" in Bt.keyframes[zt - 2] ? Bt.keyframes[zt - 2].e : Bt.keyframes[zt - 2].s;
          var Wt = Vt === "unidimensional" ? new Number(Ht) : Object.assign({}, Ht);
          return Wt.time = Bt.keyframes[zt - 1].t / Bt.elem.comp.globalData.frameRate, Wt.value = Vt === "unidimensional" ? Ht[0] : Ht, Wt;
        }, Mt.valueAtTime = Bt.getValueAtTime, Mt.speedAtTime = Bt.getSpeedAtTime, Mt.velocityAtTime = Bt.getVelocityAtTime, Mt.propertyGroup = Bt.propertyGroup;
      }
      function $t() {
        return _t;
      }
      return function(Mt) {
        return Mt ? Mt.propType === "unidimensional" ? function(Bt) {
          Bt && "pv" in Bt || (Bt = _t);
          var Vt = 1 / Bt.mult, zt = Bt.pv * Vt, Ht = new Number(zt);
          return Ht.value = zt, Pt(Ht, Bt, "unidimensional"), function() {
            return Bt.k && Bt.getValue(), zt = Bt.v * Vt, Ht.value !== zt && ((Ht = new Number(zt)).value = zt, Pt(Ht, Bt, "unidimensional")), Ht;
          };
        }(Mt) : function(Bt) {
          Bt && "pv" in Bt || (Bt = Et);
          var Vt = 1 / Bt.mult, zt = Bt.data && Bt.data.l || Bt.pv.length, Ht = createTypedArray("float32", zt), Wt = createTypedArray("float32", zt);
          return Ht.value = Wt, Pt(Ht, Bt, "multidimensional"), function() {
            Bt.k && Bt.getValue();
            for (var Gt = 0; Gt < zt; Gt += 1)
              Wt[Gt] = Bt.v[Gt] * Vt, Ht[Gt] = Wt[Gt];
            return Ht;
          };
        }(Mt) : $t;
      };
    }(), TransformExpressionInterface = function(_t) {
      function Et(Vt) {
        switch (Vt) {
          case "scale":
          case "Scale":
          case "ADBE Scale":
          case 6:
            return Et.scale;
          case "rotation":
          case "Rotation":
          case "ADBE Rotation":
          case "ADBE Rotate Z":
          case 10:
            return Et.rotation;
          case "ADBE Rotate X":
            return Et.xRotation;
          case "ADBE Rotate Y":
            return Et.yRotation;
          case "position":
          case "Position":
          case "ADBE Position":
          case 2:
            return Et.position;
          case "ADBE Position_0":
            return Et.xPosition;
          case "ADBE Position_1":
            return Et.yPosition;
          case "ADBE Position_2":
            return Et.zPosition;
          case "anchorPoint":
          case "AnchorPoint":
          case "Anchor Point":
          case "ADBE AnchorPoint":
          case 1:
            return Et.anchorPoint;
          case "opacity":
          case "Opacity":
          case 11:
            return Et.opacity;
          default:
            return null;
        }
      }
      var Pt, $t, Mt, Bt;
      return Object.defineProperty(Et, "rotation", { get: ExpressionPropertyInterface(_t.r || _t.rz) }), Object.defineProperty(Et, "zRotation", { get: ExpressionPropertyInterface(_t.rz || _t.r) }), Object.defineProperty(Et, "xRotation", { get: ExpressionPropertyInterface(_t.rx) }), Object.defineProperty(Et, "yRotation", { get: ExpressionPropertyInterface(_t.ry) }), Object.defineProperty(Et, "scale", { get: ExpressionPropertyInterface(_t.s) }), _t.p ? Bt = ExpressionPropertyInterface(_t.p) : (Pt = ExpressionPropertyInterface(_t.px), $t = ExpressionPropertyInterface(_t.py), _t.pz && (Mt = ExpressionPropertyInterface(_t.pz))), Object.defineProperty(Et, "position", { get: function() {
        return _t.p ? Bt() : [Pt(), $t(), Mt ? Mt() : 0];
      } }), Object.defineProperty(Et, "xPosition", { get: ExpressionPropertyInterface(_t.px) }), Object.defineProperty(Et, "yPosition", { get: ExpressionPropertyInterface(_t.py) }), Object.defineProperty(Et, "zPosition", { get: ExpressionPropertyInterface(_t.pz) }), Object.defineProperty(Et, "anchorPoint", { get: ExpressionPropertyInterface(_t.a) }), Object.defineProperty(Et, "opacity", { get: ExpressionPropertyInterface(_t.o) }), Object.defineProperty(Et, "skew", { get: ExpressionPropertyInterface(_t.sk) }), Object.defineProperty(Et, "skewAxis", { get: ExpressionPropertyInterface(_t.sa) }), Object.defineProperty(Et, "orientation", { get: ExpressionPropertyInterface(_t.or) }), Et;
    }, LayerExpressionInterface = /* @__PURE__ */ function() {
      function _t(Wt) {
        var Gt = new Matrix();
        return Wt !== void 0 ? this._elem.finalTransform.mProp.getValueAtTime(Wt).clone(Gt) : this._elem.finalTransform.mProp.applyToMatrix(Gt), Gt;
      }
      function Et(Wt, Gt) {
        var qt = this.getMatrix(Gt);
        return qt.props[12] = 0, qt.props[13] = 0, qt.props[14] = 0, this.applyPoint(qt, Wt);
      }
      function Pt(Wt, Gt) {
        var qt = this.getMatrix(Gt);
        return this.applyPoint(qt, Wt);
      }
      function $t(Wt, Gt) {
        var qt = this.getMatrix(Gt);
        return qt.props[12] = 0, qt.props[13] = 0, qt.props[14] = 0, this.invertPoint(qt, Wt);
      }
      function Mt(Wt, Gt) {
        var qt = this.getMatrix(Gt);
        return this.invertPoint(qt, Wt);
      }
      function Bt(Wt, Gt) {
        if (this._elem.hierarchy && this._elem.hierarchy.length) {
          var qt, Kt = this._elem.hierarchy.length;
          for (qt = 0; qt < Kt; qt += 1)
            this._elem.hierarchy[qt].finalTransform.mProp.applyToMatrix(Wt);
        }
        return Wt.applyToPointArray(Gt[0], Gt[1], Gt[2] || 0);
      }
      function Vt(Wt, Gt) {
        if (this._elem.hierarchy && this._elem.hierarchy.length) {
          var qt, Kt = this._elem.hierarchy.length;
          for (qt = 0; qt < Kt; qt += 1)
            this._elem.hierarchy[qt].finalTransform.mProp.applyToMatrix(Wt);
        }
        return Wt.inversePoint(Gt);
      }
      function zt(Wt) {
        var Gt = new Matrix();
        if (Gt.reset(), this._elem.finalTransform.mProp.applyToMatrix(Gt), this._elem.hierarchy && this._elem.hierarchy.length) {
          var qt, Kt = this._elem.hierarchy.length;
          for (qt = 0; qt < Kt; qt += 1)
            this._elem.hierarchy[qt].finalTransform.mProp.applyToMatrix(Gt);
          return Gt.inversePoint(Wt);
        }
        return Gt.inversePoint(Wt);
      }
      function Ht() {
        return [1, 1, 1, 1];
      }
      return function(Wt) {
        var Gt;
        function qt(Qt) {
          switch (Qt) {
            case "ADBE Root Vectors Group":
            case "Contents":
            case 2:
              return qt.shapeInterface;
            case 1:
            case 6:
            case "Transform":
            case "transform":
            case "ADBE Transform Group":
              return Gt;
            case 4:
            case "ADBE Effect Parade":
            case "effects":
            case "Effects":
              return qt.effect;
            case "ADBE Text Properties":
              return qt.textInterface;
            default:
              return null;
          }
        }
        qt.getMatrix = _t, qt.invertPoint = Vt, qt.applyPoint = Bt, qt.toWorld = Pt, qt.toWorldVec = Et, qt.fromWorld = Mt, qt.fromWorldVec = $t, qt.toComp = Pt, qt.fromComp = zt, qt.sampleImage = Ht, qt.sourceRectAtTime = Wt.sourceRectAtTime.bind(Wt), qt._elem = Wt;
        var Kt = getDescriptor(Gt = TransformExpressionInterface(Wt.finalTransform.mProp), "anchorPoint");
        return Object.defineProperties(qt, { hasParent: { get: function() {
          return Wt.hierarchy.length;
        } }, parent: { get: function() {
          return Wt.hierarchy[0].layerInterface;
        } }, rotation: getDescriptor(Gt, "rotation"), scale: getDescriptor(Gt, "scale"), position: getDescriptor(Gt, "position"), opacity: getDescriptor(Gt, "opacity"), anchorPoint: Kt, anchor_point: Kt, transform: { get: function() {
          return Gt;
        } }, active: { get: function() {
          return Wt.isInRange;
        } } }), qt.startTime = Wt.data.st, qt.index = Wt.data.ind, qt.source = Wt.data.refId, qt.height = Wt.data.ty === 0 ? Wt.data.h : 100, qt.width = Wt.data.ty === 0 ? Wt.data.w : 100, qt.inPoint = Wt.data.ip / Wt.comp.globalData.frameRate, qt.outPoint = Wt.data.op / Wt.comp.globalData.frameRate, qt._name = Wt.data.nm, qt.registerMaskInterface = function(Qt) {
          qt.mask = new MaskManagerInterface(Qt, Wt);
        }, qt.registerEffectsInterface = function(Qt) {
          qt.effect = Qt;
        }, qt;
      };
    }(), propertyGroupFactory = function(_t, Et) {
      return function(Pt) {
        return (Pt = Pt === void 0 ? 1 : Pt) <= 0 ? _t : Et(Pt - 1);
      };
    }, PropertyInterface = function(_t, Et) {
      var Pt = { _name: _t };
      return function($t) {
        return ($t = $t === void 0 ? 1 : $t) <= 0 ? Pt : Et($t - 1);
      };
    }, EffectsExpressionInterface = /* @__PURE__ */ function() {
      function _t(Pt, $t, Mt, Bt) {
        function Vt(qt) {
          for (var Kt = Pt.ef, Qt = 0, Xt = Kt.length; Qt < Xt; ) {
            if (qt === Kt[Qt].nm || qt === Kt[Qt].mn || qt === Kt[Qt].ix)
              return Kt[Qt].ty === 5 ? Wt[Qt] : Wt[Qt]();
            Qt += 1;
          }
          throw new Error();
        }
        var zt, Ht = propertyGroupFactory(Vt, Mt), Wt = [], Gt = Pt.ef.length;
        for (zt = 0; zt < Gt; zt += 1)
          Pt.ef[zt].ty === 5 ? Wt.push(_t(Pt.ef[zt], $t.effectElements[zt], $t.effectElements[zt].propertyGroup, Bt)) : Wt.push(Et($t.effectElements[zt], Pt.ef[zt].ty, Bt, Ht));
        return Pt.mn === "ADBE Color Control" && Object.defineProperty(Vt, "color", { get: function() {
          return Wt[0]();
        } }), Object.defineProperties(Vt, { numProperties: { get: function() {
          return Pt.np;
        } }, _name: { value: Pt.nm }, propertyGroup: { value: Ht } }), Vt.enabled = Pt.en !== 0, Vt.active = Vt.enabled, Vt;
      }
      function Et(Pt, $t, Mt, Bt) {
        var Vt = ExpressionPropertyInterface(Pt.p);
        return Pt.p.setGroupProperty && Pt.p.setGroupProperty(PropertyInterface("", Bt)), function() {
          return $t === 10 ? Mt.comp.compInterface(Pt.p.v) : Vt();
        };
      }
      return { createEffectsInterface: function(Pt, $t) {
        if (Pt.effectsManager) {
          var Mt, Bt = [], Vt = Pt.data.ef, zt = Pt.effectsManager.effectElements.length;
          for (Mt = 0; Mt < zt; Mt += 1)
            Bt.push(_t(Vt[Mt], Pt.effectsManager.effectElements[Mt], $t, Pt));
          var Ht = Pt.data.ef || [], Wt = function(Gt) {
            for (Mt = 0, zt = Ht.length; Mt < zt; ) {
              if (Gt === Ht[Mt].nm || Gt === Ht[Mt].mn || Gt === Ht[Mt].ix)
                return Bt[Mt];
              Mt += 1;
            }
            return null;
          };
          return Object.defineProperty(Wt, "numProperties", { get: function() {
            return Ht.length;
          } }), Wt;
        }
        return null;
      } };
    }(), ShapePathInterface = function(_t, Et, Pt) {
      var $t = Et.sh;
      function Mt(Vt) {
        return Vt === "Shape" || Vt === "shape" || Vt === "Path" || Vt === "path" || Vt === "ADBE Vector Shape" || Vt === 2 ? Mt.path : null;
      }
      var Bt = propertyGroupFactory(Mt, Pt);
      return $t.setGroupProperty(PropertyInterface("Path", Bt)), Object.defineProperties(Mt, { path: { get: function() {
        return $t.k && $t.getValue(), $t;
      } }, shape: { get: function() {
        return $t.k && $t.getValue(), $t;
      } }, _name: { value: _t.nm }, ix: { value: _t.ix }, propertyIndex: { value: _t.ix }, mn: { value: _t.mn }, propertyGroup: { value: Pt } }), Mt;
    }, ShapeExpressionInterface = /* @__PURE__ */ function() {
      function _t(Qt, Xt, Zt) {
        var Yt, Jt = [], er = Qt ? Qt.length : 0;
        for (Yt = 0; Yt < er; Yt += 1)
          Qt[Yt].ty === "gr" ? Jt.push(Et(Qt[Yt], Xt[Yt], Zt)) : Qt[Yt].ty === "fl" ? Jt.push(Pt(Qt[Yt], Xt[Yt], Zt)) : Qt[Yt].ty === "st" ? Jt.push(Bt(Qt[Yt], Xt[Yt], Zt)) : Qt[Yt].ty === "tm" ? Jt.push(Vt(Qt[Yt], Xt[Yt], Zt)) : Qt[Yt].ty === "tr" || (Qt[Yt].ty === "el" ? Jt.push(Ht(Qt[Yt], Xt[Yt], Zt)) : Qt[Yt].ty === "sr" ? Jt.push(Wt(Qt[Yt], Xt[Yt], Zt)) : Qt[Yt].ty === "sh" ? Jt.push(ShapePathInterface(Qt[Yt], Xt[Yt], Zt)) : Qt[Yt].ty === "rc" ? Jt.push(Gt(Qt[Yt], Xt[Yt], Zt)) : Qt[Yt].ty === "rd" ? Jt.push(qt(Qt[Yt], Xt[Yt], Zt)) : Qt[Yt].ty === "rp" ? Jt.push(Kt(Qt[Yt], Xt[Yt], Zt)) : Qt[Yt].ty === "gf" ? Jt.push($t(Qt[Yt], Xt[Yt], Zt)) : Jt.push(Mt(Qt[Yt], Xt[Yt])));
        return Jt;
      }
      function Et(Qt, Xt, Zt) {
        var Yt = function(tr) {
          switch (tr) {
            case "ADBE Vectors Group":
            case "Contents":
            case 2:
              return Yt.content;
            default:
              return Yt.transform;
          }
        };
        Yt.propertyGroup = propertyGroupFactory(Yt, Zt);
        var Jt = function(tr, nr, rr) {
          var ir, ar = function(sr) {
            for (var lr = 0, cr = ir.length; lr < cr; ) {
              if (ir[lr]._name === sr || ir[lr].mn === sr || ir[lr].propertyIndex === sr || ir[lr].ix === sr || ir[lr].ind === sr)
                return ir[lr];
              lr += 1;
            }
            return typeof sr == "number" ? ir[sr - 1] : null;
          };
          ar.propertyGroup = propertyGroupFactory(ar, rr), ir = _t(tr.it, nr.it, ar.propertyGroup), ar.numProperties = ir.length;
          var or = zt(tr.it[tr.it.length - 1], nr.it[nr.it.length - 1], ar.propertyGroup);
          return ar.transform = or, ar.propertyIndex = tr.cix, ar._name = tr.nm, ar;
        }(Qt, Xt, Yt.propertyGroup), er = zt(Qt.it[Qt.it.length - 1], Xt.it[Xt.it.length - 1], Yt.propertyGroup);
        return Yt.content = Jt, Yt.transform = er, Object.defineProperty(Yt, "_name", { get: function() {
          return Qt.nm;
        } }), Yt.numProperties = Qt.np, Yt.propertyIndex = Qt.ix, Yt.nm = Qt.nm, Yt.mn = Qt.mn, Yt;
      }
      function Pt(Qt, Xt, Zt) {
        function Yt(Jt) {
          return Jt === "Color" || Jt === "color" ? Yt.color : Jt === "Opacity" || Jt === "opacity" ? Yt.opacity : null;
        }
        return Object.defineProperties(Yt, { color: { get: ExpressionPropertyInterface(Xt.c) }, opacity: { get: ExpressionPropertyInterface(Xt.o) }, _name: { value: Qt.nm }, mn: { value: Qt.mn } }), Xt.c.setGroupProperty(PropertyInterface("Color", Zt)), Xt.o.setGroupProperty(PropertyInterface("Opacity", Zt)), Yt;
      }
      function $t(Qt, Xt, Zt) {
        function Yt(Jt) {
          return Jt === "Start Point" || Jt === "start point" ? Yt.startPoint : Jt === "End Point" || Jt === "end point" ? Yt.endPoint : Jt === "Opacity" || Jt === "opacity" ? Yt.opacity : null;
        }
        return Object.defineProperties(Yt, { startPoint: { get: ExpressionPropertyInterface(Xt.s) }, endPoint: { get: ExpressionPropertyInterface(Xt.e) }, opacity: { get: ExpressionPropertyInterface(Xt.o) }, type: { get: function() {
          return "a";
        } }, _name: { value: Qt.nm }, mn: { value: Qt.mn } }), Xt.s.setGroupProperty(PropertyInterface("Start Point", Zt)), Xt.e.setGroupProperty(PropertyInterface("End Point", Zt)), Xt.o.setGroupProperty(PropertyInterface("Opacity", Zt)), Yt;
      }
      function Mt() {
        return function() {
          return null;
        };
      }
      function Bt(Qt, Xt, Zt) {
        var Yt, Jt = propertyGroupFactory(ir, Zt), er = propertyGroupFactory(rr, Jt);
        function tr(ar) {
          Object.defineProperty(rr, Qt.d[ar].nm, { get: ExpressionPropertyInterface(Xt.d.dataProps[ar].p) });
        }
        var nr = Qt.d ? Qt.d.length : 0, rr = {};
        for (Yt = 0; Yt < nr; Yt += 1)
          tr(Yt), Xt.d.dataProps[Yt].p.setGroupProperty(er);
        function ir(ar) {
          return ar === "Color" || ar === "color" ? ir.color : ar === "Opacity" || ar === "opacity" ? ir.opacity : ar === "Stroke Width" || ar === "stroke width" ? ir.strokeWidth : null;
        }
        return Object.defineProperties(ir, { color: { get: ExpressionPropertyInterface(Xt.c) }, opacity: { get: ExpressionPropertyInterface(Xt.o) }, strokeWidth: { get: ExpressionPropertyInterface(Xt.w) }, dash: { get: function() {
          return rr;
        } }, _name: { value: Qt.nm }, mn: { value: Qt.mn } }), Xt.c.setGroupProperty(PropertyInterface("Color", Jt)), Xt.o.setGroupProperty(PropertyInterface("Opacity", Jt)), Xt.w.setGroupProperty(PropertyInterface("Stroke Width", Jt)), ir;
      }
      function Vt(Qt, Xt, Zt) {
        function Yt(er) {
          return er === Qt.e.ix || er === "End" || er === "end" ? Yt.end : er === Qt.s.ix ? Yt.start : er === Qt.o.ix ? Yt.offset : null;
        }
        var Jt = propertyGroupFactory(Yt, Zt);
        return Yt.propertyIndex = Qt.ix, Xt.s.setGroupProperty(PropertyInterface("Start", Jt)), Xt.e.setGroupProperty(PropertyInterface("End", Jt)), Xt.o.setGroupProperty(PropertyInterface("Offset", Jt)), Yt.propertyIndex = Qt.ix, Yt.propertyGroup = Zt, Object.defineProperties(Yt, { start: { get: ExpressionPropertyInterface(Xt.s) }, end: { get: ExpressionPropertyInterface(Xt.e) }, offset: { get: ExpressionPropertyInterface(Xt.o) }, _name: { value: Qt.nm } }), Yt.mn = Qt.mn, Yt;
      }
      function zt(Qt, Xt, Zt) {
        function Yt(er) {
          return Qt.a.ix === er || er === "Anchor Point" ? Yt.anchorPoint : Qt.o.ix === er || er === "Opacity" ? Yt.opacity : Qt.p.ix === er || er === "Position" ? Yt.position : Qt.r.ix === er || er === "Rotation" || er === "ADBE Vector Rotation" ? Yt.rotation : Qt.s.ix === er || er === "Scale" ? Yt.scale : Qt.sk && Qt.sk.ix === er || er === "Skew" ? Yt.skew : Qt.sa && Qt.sa.ix === er || er === "Skew Axis" ? Yt.skewAxis : null;
        }
        var Jt = propertyGroupFactory(Yt, Zt);
        return Xt.transform.mProps.o.setGroupProperty(PropertyInterface("Opacity", Jt)), Xt.transform.mProps.p.setGroupProperty(PropertyInterface("Position", Jt)), Xt.transform.mProps.a.setGroupProperty(PropertyInterface("Anchor Point", Jt)), Xt.transform.mProps.s.setGroupProperty(PropertyInterface("Scale", Jt)), Xt.transform.mProps.r.setGroupProperty(PropertyInterface("Rotation", Jt)), Xt.transform.mProps.sk && (Xt.transform.mProps.sk.setGroupProperty(PropertyInterface("Skew", Jt)), Xt.transform.mProps.sa.setGroupProperty(PropertyInterface("Skew Angle", Jt))), Xt.transform.op.setGroupProperty(PropertyInterface("Opacity", Jt)), Object.defineProperties(Yt, { opacity: { get: ExpressionPropertyInterface(Xt.transform.mProps.o) }, position: { get: ExpressionPropertyInterface(Xt.transform.mProps.p) }, anchorPoint: { get: ExpressionPropertyInterface(Xt.transform.mProps.a) }, scale: { get: ExpressionPropertyInterface(Xt.transform.mProps.s) }, rotation: { get: ExpressionPropertyInterface(Xt.transform.mProps.r) }, skew: { get: ExpressionPropertyInterface(Xt.transform.mProps.sk) }, skewAxis: { get: ExpressionPropertyInterface(Xt.transform.mProps.sa) }, _name: { value: Qt.nm } }), Yt.ty = "tr", Yt.mn = Qt.mn, Yt.propertyGroup = Zt, Yt;
      }
      function Ht(Qt, Xt, Zt) {
        function Yt(tr) {
          return Qt.p.ix === tr ? Yt.position : Qt.s.ix === tr ? Yt.size : null;
        }
        var Jt = propertyGroupFactory(Yt, Zt);
        Yt.propertyIndex = Qt.ix;
        var er = Xt.sh.ty === "tm" ? Xt.sh.prop : Xt.sh;
        return er.s.setGroupProperty(PropertyInterface("Size", Jt)), er.p.setGroupProperty(PropertyInterface("Position", Jt)), Object.defineProperties(Yt, { size: { get: ExpressionPropertyInterface(er.s) }, position: { get: ExpressionPropertyInterface(er.p) }, _name: { value: Qt.nm } }), Yt.mn = Qt.mn, Yt;
      }
      function Wt(Qt, Xt, Zt) {
        function Yt(tr) {
          return Qt.p.ix === tr ? Yt.position : Qt.r.ix === tr ? Yt.rotation : Qt.pt.ix === tr ? Yt.points : Qt.or.ix === tr || tr === "ADBE Vector Star Outer Radius" ? Yt.outerRadius : Qt.os.ix === tr ? Yt.outerRoundness : !Qt.ir || Qt.ir.ix !== tr && tr !== "ADBE Vector Star Inner Radius" ? Qt.is && Qt.is.ix === tr ? Yt.innerRoundness : null : Yt.innerRadius;
        }
        var Jt = propertyGroupFactory(Yt, Zt), er = Xt.sh.ty === "tm" ? Xt.sh.prop : Xt.sh;
        return Yt.propertyIndex = Qt.ix, er.or.setGroupProperty(PropertyInterface("Outer Radius", Jt)), er.os.setGroupProperty(PropertyInterface("Outer Roundness", Jt)), er.pt.setGroupProperty(PropertyInterface("Points", Jt)), er.p.setGroupProperty(PropertyInterface("Position", Jt)), er.r.setGroupProperty(PropertyInterface("Rotation", Jt)), Qt.ir && (er.ir.setGroupProperty(PropertyInterface("Inner Radius", Jt)), er.is.setGroupProperty(PropertyInterface("Inner Roundness", Jt))), Object.defineProperties(Yt, { position: { get: ExpressionPropertyInterface(er.p) }, rotation: { get: ExpressionPropertyInterface(er.r) }, points: { get: ExpressionPropertyInterface(er.pt) }, outerRadius: { get: ExpressionPropertyInterface(er.or) }, outerRoundness: { get: ExpressionPropertyInterface(er.os) }, innerRadius: { get: ExpressionPropertyInterface(er.ir) }, innerRoundness: { get: ExpressionPropertyInterface(er.is) }, _name: { value: Qt.nm } }), Yt.mn = Qt.mn, Yt;
      }
      function Gt(Qt, Xt, Zt) {
        function Yt(tr) {
          return Qt.p.ix === tr ? Yt.position : Qt.r.ix === tr ? Yt.roundness : Qt.s.ix === tr || tr === "Size" || tr === "ADBE Vector Rect Size" ? Yt.size : null;
        }
        var Jt = propertyGroupFactory(Yt, Zt), er = Xt.sh.ty === "tm" ? Xt.sh.prop : Xt.sh;
        return Yt.propertyIndex = Qt.ix, er.p.setGroupProperty(PropertyInterface("Position", Jt)), er.s.setGroupProperty(PropertyInterface("Size", Jt)), er.r.setGroupProperty(PropertyInterface("Rotation", Jt)), Object.defineProperties(Yt, { position: { get: ExpressionPropertyInterface(er.p) }, roundness: { get: ExpressionPropertyInterface(er.r) }, size: { get: ExpressionPropertyInterface(er.s) }, _name: { value: Qt.nm } }), Yt.mn = Qt.mn, Yt;
      }
      function qt(Qt, Xt, Zt) {
        function Yt(tr) {
          return Qt.r.ix === tr || tr === "Round Corners 1" ? Yt.radius : null;
        }
        var Jt = propertyGroupFactory(Yt, Zt), er = Xt;
        return Yt.propertyIndex = Qt.ix, er.rd.setGroupProperty(PropertyInterface("Radius", Jt)), Object.defineProperties(Yt, { radius: { get: ExpressionPropertyInterface(er.rd) }, _name: { value: Qt.nm } }), Yt.mn = Qt.mn, Yt;
      }
      function Kt(Qt, Xt, Zt) {
        function Yt(tr) {
          return Qt.c.ix === tr || tr === "Copies" ? Yt.copies : Qt.o.ix === tr || tr === "Offset" ? Yt.offset : null;
        }
        var Jt = propertyGroupFactory(Yt, Zt), er = Xt;
        return Yt.propertyIndex = Qt.ix, er.c.setGroupProperty(PropertyInterface("Copies", Jt)), er.o.setGroupProperty(PropertyInterface("Offset", Jt)), Object.defineProperties(Yt, { copies: { get: ExpressionPropertyInterface(er.c) }, offset: { get: ExpressionPropertyInterface(er.o) }, _name: { value: Qt.nm } }), Yt.mn = Qt.mn, Yt;
      }
      return function(Qt, Xt, Zt) {
        var Yt;
        function Jt(er) {
          if (typeof er == "number")
            return (er = er === void 0 ? 1 : er) === 0 ? Zt : Yt[er - 1];
          for (var tr = 0, nr = Yt.length; tr < nr; ) {
            if (Yt[tr]._name === er)
              return Yt[tr];
            tr += 1;
          }
          return null;
        }
        return Jt.propertyGroup = propertyGroupFactory(Jt, function() {
          return Zt;
        }), Yt = _t(Qt, Xt, Jt.propertyGroup), Jt.numProperties = Yt.length, Jt._name = "Contents", Jt;
      };
    }(), TextExpressionInterface = function(_t) {
      var Et;
      function Pt($t) {
        switch ($t) {
          case "ADBE Text Document":
            return Pt.sourceText;
          default:
            return null;
        }
      }
      return Object.defineProperty(Pt, "sourceText", { get: function() {
        _t.textProperty.getValue();
        var $t = _t.textProperty.currentData.t;
        return Et && $t === Et.value || ((Et = new String($t)).value = $t || new String($t), Object.defineProperty(Et, "style", { get: function() {
          return { fillColor: _t.textProperty.currentData.fc };
        } })), Et;
      } }), Pt;
    };
    function _typeof(_t) {
      return (_typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Et) {
        return typeof Et;
      } : function(Et) {
        return Et && typeof Symbol == "function" && Et.constructor === Symbol && Et !== Symbol.prototype ? "symbol" : typeof Et;
      })(_t);
    }
    var FootageInterface = (dataInterfaceFactory = function(_t) {
      function Et(Pt) {
        return Pt === "Outline" ? Et.outlineInterface() : null;
      }
      return Et._name = "Outline", Et.outlineInterface = function(Pt) {
        var $t = "", Mt = Pt.getFootageData();
        function Bt(Vt) {
          if (Mt[Vt])
            return $t = Vt, _typeof(Mt = Mt[Vt]) === "object" ? Bt : Mt;
          var zt = Vt.indexOf($t);
          if (zt !== -1) {
            var Ht = parseInt(Vt.substr(zt + $t.length), 10);
            return _typeof(Mt = Mt[Ht]) === "object" ? Bt : Mt;
          }
          return "";
        }
        return function() {
          return $t = "", Mt = Pt.getFootageData(), Bt;
        };
      }(_t), Et;
    }, function(_t) {
      function Et(Pt) {
        return Pt === "Data" ? Et.dataInterface : null;
      }
      return Et._name = "Data", Et.dataInterface = dataInterfaceFactory(_t), Et;
    }), dataInterfaceFactory, interfaces = { layer: LayerExpressionInterface, effects: EffectsExpressionInterface, comp: CompExpressionInterface, shape: ShapeExpressionInterface, text: TextExpressionInterface, footage: FootageInterface };
    function getInterface(_t) {
      return interfaces[_t] || null;
    }
    var expressionHelpers = { searchExpressions: function(_t, Et, Pt) {
      Et.x && (Pt.k = !0, Pt.x = !0, Pt.initiateExpression = ExpressionManager.initiateExpression, Pt.effectsSequence.push(Pt.initiateExpression(_t, Et, Pt).bind(Pt)));
    }, getSpeedAtTime: function(_t) {
      var Et = this.getValueAtTime(_t), Pt = this.getValueAtTime(_t + -0.01), $t = 0;
      if (Et.length) {
        var Mt;
        for (Mt = 0; Mt < Et.length; Mt += 1)
          $t += Math.pow(Pt[Mt] - Et[Mt], 2);
        $t = 100 * Math.sqrt($t);
      } else
        $t = 0;
      return $t;
    }, getVelocityAtTime: function(_t) {
      if (this.vel !== void 0)
        return this.vel;
      var Et, Pt, $t = this.getValueAtTime(_t), Mt = this.getValueAtTime(_t + -1e-3);
      if ($t.length)
        for (Et = createTypedArray("float32", $t.length), Pt = 0; Pt < $t.length; Pt += 1)
          Et[Pt] = (Mt[Pt] - $t[Pt]) / -1e-3;
      else
        Et = (Mt - $t) / -1e-3;
      return Et;
    }, getValueAtTime: function(_t) {
      return _t *= this.elem.globalData.frameRate, (_t -= this.offsetTime) !== this._cachingAtTime.lastFrame && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < _t ? this._cachingAtTime.lastIndex : 0, this._cachingAtTime.value = this.interpolateValue(_t, this._cachingAtTime), this._cachingAtTime.lastFrame = _t), this._cachingAtTime.value;
    }, getStaticValueAtTime: function() {
      return this.pv;
    }, setGroupProperty: function(_t) {
      this.propertyGroup = _t;
    } };
    function addPropertyDecorator() {
      function _t(qt, Kt, Qt) {
        if (!this.k || !this.keyframes)
          return this.pv;
        qt = qt ? qt.toLowerCase() : "";
        var Xt, Zt, Yt, Jt, er, tr = this.comp.renderedFrame, nr = this.keyframes, rr = nr[nr.length - 1].t;
        if (tr <= rr)
          return this.pv;
        if (Qt ? Zt = rr - (Xt = Kt ? Math.abs(rr - this.elem.comp.globalData.frameRate * Kt) : Math.max(0, rr - this.elem.data.ip)) : ((!Kt || Kt > nr.length - 1) && (Kt = nr.length - 1), Xt = rr - (Zt = nr[nr.length - 1 - Kt].t)), qt === "pingpong") {
          if (Math.floor((tr - Zt) / Xt) % 2 != 0)
            return this.getValueAtTime((Xt - (tr - Zt) % Xt + Zt) / this.comp.globalData.frameRate, 0);
        } else {
          if (qt === "offset") {
            var ir = this.getValueAtTime(Zt / this.comp.globalData.frameRate, 0), ar = this.getValueAtTime(rr / this.comp.globalData.frameRate, 0), or = this.getValueAtTime(((tr - Zt) % Xt + Zt) / this.comp.globalData.frameRate, 0), sr = Math.floor((tr - Zt) / Xt);
            if (this.pv.length) {
              for (Jt = (er = new Array(ir.length)).length, Yt = 0; Yt < Jt; Yt += 1)
                er[Yt] = (ar[Yt] - ir[Yt]) * sr + or[Yt];
              return er;
            }
            return (ar - ir) * sr + or;
          }
          if (qt === "continue") {
            var lr = this.getValueAtTime(rr / this.comp.globalData.frameRate, 0), cr = this.getValueAtTime((rr - 1e-3) / this.comp.globalData.frameRate, 0);
            if (this.pv.length) {
              for (Jt = (er = new Array(lr.length)).length, Yt = 0; Yt < Jt; Yt += 1)
                er[Yt] = lr[Yt] + (lr[Yt] - cr[Yt]) * ((tr - rr) / this.comp.globalData.frameRate) / 5e-4;
              return er;
            }
            return lr + (tr - rr) / 1e-3 * (lr - cr);
          }
        }
        return this.getValueAtTime(((tr - Zt) % Xt + Zt) / this.comp.globalData.frameRate, 0);
      }
      function Et(qt, Kt, Qt) {
        if (!this.k)
          return this.pv;
        qt = qt ? qt.toLowerCase() : "";
        var Xt, Zt, Yt, Jt, er, tr = this.comp.renderedFrame, nr = this.keyframes, rr = nr[0].t;
        if (tr >= rr)
          return this.pv;
        if (Qt ? Zt = rr + (Xt = Kt ? Math.abs(this.elem.comp.globalData.frameRate * Kt) : Math.max(0, this.elem.data.op - rr)) : ((!Kt || Kt > nr.length - 1) && (Kt = nr.length - 1), Xt = (Zt = nr[Kt].t) - rr), qt === "pingpong") {
          if (Math.floor((rr - tr) / Xt) % 2 == 0)
            return this.getValueAtTime(((rr - tr) % Xt + rr) / this.comp.globalData.frameRate, 0);
        } else {
          if (qt === "offset") {
            var ir = this.getValueAtTime(rr / this.comp.globalData.frameRate, 0), ar = this.getValueAtTime(Zt / this.comp.globalData.frameRate, 0), or = this.getValueAtTime((Xt - (rr - tr) % Xt + rr) / this.comp.globalData.frameRate, 0), sr = Math.floor((rr - tr) / Xt) + 1;
            if (this.pv.length) {
              for (Jt = (er = new Array(ir.length)).length, Yt = 0; Yt < Jt; Yt += 1)
                er[Yt] = or[Yt] - (ar[Yt] - ir[Yt]) * sr;
              return er;
            }
            return or - (ar - ir) * sr;
          }
          if (qt === "continue") {
            var lr = this.getValueAtTime(rr / this.comp.globalData.frameRate, 0), cr = this.getValueAtTime((rr + 1e-3) / this.comp.globalData.frameRate, 0);
            if (this.pv.length) {
              for (Jt = (er = new Array(lr.length)).length, Yt = 0; Yt < Jt; Yt += 1)
                er[Yt] = lr[Yt] + (lr[Yt] - cr[Yt]) * (rr - tr) / 1e-3;
              return er;
            }
            return lr + (lr - cr) * (rr - tr) / 1e-3;
          }
        }
        return this.getValueAtTime((Xt - ((rr - tr) % Xt + rr)) / this.comp.globalData.frameRate, 0);
      }
      function Pt(qt, Kt) {
        if (!this.k)
          return this.pv;
        if (qt = 0.5 * (qt || 0.4), (Kt = Math.floor(Kt || 5)) <= 1)
          return this.pv;
        var Qt, Xt, Zt = this.comp.renderedFrame / this.comp.globalData.frameRate, Yt = Zt - qt, Jt = Kt > 1 ? (Zt + qt - Yt) / (Kt - 1) : 1, er = 0, tr = 0;
        for (Qt = this.pv.length ? createTypedArray("float32", this.pv.length) : 0; er < Kt; ) {
          if (Xt = this.getValueAtTime(Yt + er * Jt), this.pv.length)
            for (tr = 0; tr < this.pv.length; tr += 1)
              Qt[tr] += Xt[tr];
          else
            Qt += Xt;
          er += 1;
        }
        if (this.pv.length)
          for (tr = 0; tr < this.pv.length; tr += 1)
            Qt[tr] /= Kt;
        else
          Qt /= Kt;
        return Qt;
      }
      function $t(qt) {
        this._transformCachingAtTime || (this._transformCachingAtTime = { v: new Matrix() });
        var Kt = this._transformCachingAtTime.v;
        if (Kt.cloneFromProps(this.pre.props), this.appliedTransformations < 1) {
          var Qt = this.a.getValueAtTime(qt);
          Kt.translate(-Qt[0] * this.a.mult, -Qt[1] * this.a.mult, Qt[2] * this.a.mult);
        }
        if (this.appliedTransformations < 2) {
          var Xt = this.s.getValueAtTime(qt);
          Kt.scale(Xt[0] * this.s.mult, Xt[1] * this.s.mult, Xt[2] * this.s.mult);
        }
        if (this.sk && this.appliedTransformations < 3) {
          var Zt = this.sk.getValueAtTime(qt), Yt = this.sa.getValueAtTime(qt);
          Kt.skewFromAxis(-Zt * this.sk.mult, Yt * this.sa.mult);
        }
        if (this.r && this.appliedTransformations < 4) {
          var Jt = this.r.getValueAtTime(qt);
          Kt.rotate(-Jt * this.r.mult);
        } else if (!this.r && this.appliedTransformations < 4) {
          var er = this.rz.getValueAtTime(qt), tr = this.ry.getValueAtTime(qt), nr = this.rx.getValueAtTime(qt), rr = this.or.getValueAtTime(qt);
          Kt.rotateZ(-er * this.rz.mult).rotateY(tr * this.ry.mult).rotateX(nr * this.rx.mult).rotateZ(-rr[2] * this.or.mult).rotateY(rr[1] * this.or.mult).rotateX(rr[0] * this.or.mult);
        }
        if (this.data.p && this.data.p.s) {
          var ir = this.px.getValueAtTime(qt), ar = this.py.getValueAtTime(qt);
          if (this.data.p.z) {
            var or = this.pz.getValueAtTime(qt);
            Kt.translate(ir * this.px.mult, ar * this.py.mult, -or * this.pz.mult);
          } else
            Kt.translate(ir * this.px.mult, ar * this.py.mult, 0);
        } else {
          var sr = this.p.getValueAtTime(qt);
          Kt.translate(sr[0] * this.p.mult, sr[1] * this.p.mult, -sr[2] * this.p.mult);
        }
        return Kt;
      }
      function Mt() {
        return this.v.clone(new Matrix());
      }
      var Bt = TransformPropertyFactory.getTransformProperty;
      TransformPropertyFactory.getTransformProperty = function(qt, Kt, Qt) {
        var Xt = Bt(qt, Kt, Qt);
        return Xt.dynamicProperties.length ? Xt.getValueAtTime = $t.bind(Xt) : Xt.getValueAtTime = Mt.bind(Xt), Xt.setGroupProperty = expressionHelpers.setGroupProperty, Xt;
      };
      var Vt = PropertyFactory.getProp;
      PropertyFactory.getProp = function(qt, Kt, Qt, Xt, Zt) {
        var Yt = Vt(qt, Kt, Qt, Xt, Zt);
        Yt.kf ? Yt.getValueAtTime = expressionHelpers.getValueAtTime.bind(Yt) : Yt.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(Yt), Yt.setGroupProperty = expressionHelpers.setGroupProperty, Yt.loopOut = _t, Yt.loopIn = Et, Yt.smooth = Pt, Yt.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(Yt), Yt.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(Yt), Yt.numKeys = Kt.a === 1 ? Kt.k.length : 0, Yt.propertyIndex = Kt.ix;
        var Jt = 0;
        return Qt !== 0 && (Jt = createTypedArray("float32", Kt.a === 1 ? Kt.k[0].s.length : Kt.k.length)), Yt._cachingAtTime = { lastFrame: initialDefaultFrame, lastIndex: 0, value: Jt }, expressionHelpers.searchExpressions(qt, Kt, Yt), Yt.k && Zt.addDynamicProperty(Yt), Yt;
      };
      var zt = ShapePropertyFactory.getConstructorFunction(), Ht = ShapePropertyFactory.getKeyframedConstructorFunction();
      function Wt() {
      }
      Wt.prototype = { vertices: function(qt, Kt) {
        this.k && this.getValue();
        var Qt, Xt = this.v;
        Kt !== void 0 && (Xt = this.getValueAtTime(Kt, 0));
        var Zt = Xt._length, Yt = Xt[qt], Jt = Xt.v, er = createSizedArray(Zt);
        for (Qt = 0; Qt < Zt; Qt += 1)
          er[Qt] = qt === "i" || qt === "o" ? [Yt[Qt][0] - Jt[Qt][0], Yt[Qt][1] - Jt[Qt][1]] : [Yt[Qt][0], Yt[Qt][1]];
        return er;
      }, points: function(qt) {
        return this.vertices("v", qt);
      }, inTangents: function(qt) {
        return this.vertices("i", qt);
      }, outTangents: function(qt) {
        return this.vertices("o", qt);
      }, isClosed: function() {
        return this.v.c;
      }, pointOnPath: function(qt, Kt) {
        var Qt = this.v;
        Kt !== void 0 && (Qt = this.getValueAtTime(Kt, 0)), this._segmentsLength || (this._segmentsLength = bez.getSegmentsLength(Qt));
        for (var Xt, Zt = this._segmentsLength, Yt = Zt.lengths, Jt = Zt.totalLength * qt, er = 0, tr = Yt.length, nr = 0; er < tr; ) {
          if (nr + Yt[er].addedLength > Jt) {
            var rr = er, ir = Qt.c && er === tr - 1 ? 0 : er + 1, ar = (Jt - nr) / Yt[er].addedLength;
            Xt = bez.getPointInSegment(Qt.v[rr], Qt.v[ir], Qt.o[rr], Qt.i[ir], ar, Yt[er]);
            break;
          }
          nr += Yt[er].addedLength, er += 1;
        }
        return Xt || (Xt = Qt.c ? [Qt.v[0][0], Qt.v[0][1]] : [Qt.v[Qt._length - 1][0], Qt.v[Qt._length - 1][1]]), Xt;
      }, vectorOnPath: function(qt, Kt, Qt) {
        qt == 1 ? qt = this.v.c : qt == 0 && (qt = 0.999);
        var Xt = this.pointOnPath(qt, Kt), Zt = this.pointOnPath(qt + 1e-3, Kt), Yt = Zt[0] - Xt[0], Jt = Zt[1] - Xt[1], er = Math.sqrt(Math.pow(Yt, 2) + Math.pow(Jt, 2));
        return er === 0 ? [0, 0] : Qt === "tangent" ? [Yt / er, Jt / er] : [-Jt / er, Yt / er];
      }, tangentOnPath: function(qt, Kt) {
        return this.vectorOnPath(qt, Kt, "tangent");
      }, normalOnPath: function(qt, Kt) {
        return this.vectorOnPath(qt, Kt, "normal");
      }, setGroupProperty: expressionHelpers.setGroupProperty, getValueAtTime: expressionHelpers.getStaticValueAtTime }, extendPrototype([Wt], zt), extendPrototype([Wt], Ht), Ht.prototype.getValueAtTime = function(qt) {
        return this._cachingAtTime || (this._cachingAtTime = { shapeValue: shapePool.clone(this.pv), lastIndex: 0, lastTime: initialDefaultFrame }), qt *= this.elem.globalData.frameRate, (qt -= this.offsetTime) !== this._cachingAtTime.lastTime && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < qt ? this._caching.lastIndex : 0, this._cachingAtTime.lastTime = qt, this.interpolateShape(qt, this._cachingAtTime.shapeValue, this._cachingAtTime)), this._cachingAtTime.shapeValue;
      }, Ht.prototype.initiateExpression = ExpressionManager.initiateExpression;
      var Gt = ShapePropertyFactory.getShapeProp;
      ShapePropertyFactory.getShapeProp = function(qt, Kt, Qt, Xt, Zt) {
        var Yt = Gt(qt, Kt, Qt, Xt, Zt);
        return Yt.propertyIndex = Kt.ix, Yt.lock = !1, Qt === 3 ? expressionHelpers.searchExpressions(qt, Kt.pt, Yt) : Qt === 4 && expressionHelpers.searchExpressions(qt, Kt.ks, Yt), Yt.k && qt.addDynamicProperty(Yt), Yt;
      };
    }
    function initialize$1() {
      addPropertyDecorator();
    }
    function addDecorator() {
      TextProperty.prototype.getExpressionValue = function(_t, Et) {
        var Pt = this.calculateExpression(Et);
        if (_t.t !== Pt) {
          var $t = {};
          return this.copyData($t, _t), $t.t = Pt.toString(), $t.__complete = !1, $t;
        }
        return _t;
      }, TextProperty.prototype.searchProperty = function() {
        var _t = this.searchKeyframes(), Et = this.searchExpressions();
        return this.kf = _t || Et, this.kf;
      }, TextProperty.prototype.searchExpressions = function() {
        return this.data.d.x ? (this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this), this.addEffect(this.getExpressionValue.bind(this)), !0) : null;
      };
    }
    function initialize() {
      addDecorator();
    }
    function SVGComposableEffect() {
    }
    SVGComposableEffect.prototype = { createMergeNode: function(_t, Et) {
      var Pt, $t, Mt = createNS("feMerge");
      for (Mt.setAttribute("result", _t), $t = 0; $t < Et.length; $t += 1)
        (Pt = createNS("feMergeNode")).setAttribute("in", Et[$t]), Mt.appendChild(Pt), Mt.appendChild(Pt);
      return Mt;
    } };
    var linearFilterValue = "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0";
    function SVGTintFilter(_t, Et, Pt, $t, Mt) {
      this.filterManager = Et;
      var Bt = createNS("feColorMatrix");
      Bt.setAttribute("type", "matrix"), Bt.setAttribute("color-interpolation-filters", "linearRGB"), Bt.setAttribute("values", linearFilterValue + " 1 0"), this.linearFilter = Bt, Bt.setAttribute("result", $t + "_tint_1"), _t.appendChild(Bt), (Bt = createNS("feColorMatrix")).setAttribute("type", "matrix"), Bt.setAttribute("color-interpolation-filters", "sRGB"), Bt.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), Bt.setAttribute("result", $t + "_tint_2"), _t.appendChild(Bt), this.matrixFilter = Bt;
      var Vt = this.createMergeNode($t, [Mt, $t + "_tint_1", $t + "_tint_2"]);
      _t.appendChild(Vt);
    }
    function SVGFillFilter(_t, Et, Pt, $t) {
      this.filterManager = Et;
      var Mt = createNS("feColorMatrix");
      Mt.setAttribute("type", "matrix"), Mt.setAttribute("color-interpolation-filters", "sRGB"), Mt.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), Mt.setAttribute("result", $t), _t.appendChild(Mt), this.matrixFilter = Mt;
    }
    function SVGStrokeEffect(_t, Et, Pt) {
      this.initialized = !1, this.filterManager = Et, this.elem = Pt, this.paths = [];
    }
    function SVGTritoneFilter(_t, Et, Pt, $t) {
      this.filterManager = Et;
      var Mt = createNS("feColorMatrix");
      Mt.setAttribute("type", "matrix"), Mt.setAttribute("color-interpolation-filters", "linearRGB"), Mt.setAttribute("values", "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"), _t.appendChild(Mt);
      var Bt = createNS("feComponentTransfer");
      Bt.setAttribute("color-interpolation-filters", "sRGB"), Bt.setAttribute("result", $t), this.matrixFilter = Bt;
      var Vt = createNS("feFuncR");
      Vt.setAttribute("type", "table"), Bt.appendChild(Vt), this.feFuncR = Vt;
      var zt = createNS("feFuncG");
      zt.setAttribute("type", "table"), Bt.appendChild(zt), this.feFuncG = zt;
      var Ht = createNS("feFuncB");
      Ht.setAttribute("type", "table"), Bt.appendChild(Ht), this.feFuncB = Ht, _t.appendChild(Bt);
    }
    function SVGProLevelsFilter(_t, Et, Pt, $t) {
      this.filterManager = Et;
      var Mt = this.filterManager.effectElements, Bt = createNS("feComponentTransfer");
      (Mt[10].p.k || Mt[10].p.v !== 0 || Mt[11].p.k || Mt[11].p.v !== 1 || Mt[12].p.k || Mt[12].p.v !== 1 || Mt[13].p.k || Mt[13].p.v !== 0 || Mt[14].p.k || Mt[14].p.v !== 1) && (this.feFuncR = this.createFeFunc("feFuncR", Bt)), (Mt[17].p.k || Mt[17].p.v !== 0 || Mt[18].p.k || Mt[18].p.v !== 1 || Mt[19].p.k || Mt[19].p.v !== 1 || Mt[20].p.k || Mt[20].p.v !== 0 || Mt[21].p.k || Mt[21].p.v !== 1) && (this.feFuncG = this.createFeFunc("feFuncG", Bt)), (Mt[24].p.k || Mt[24].p.v !== 0 || Mt[25].p.k || Mt[25].p.v !== 1 || Mt[26].p.k || Mt[26].p.v !== 1 || Mt[27].p.k || Mt[27].p.v !== 0 || Mt[28].p.k || Mt[28].p.v !== 1) && (this.feFuncB = this.createFeFunc("feFuncB", Bt)), (Mt[31].p.k || Mt[31].p.v !== 0 || Mt[32].p.k || Mt[32].p.v !== 1 || Mt[33].p.k || Mt[33].p.v !== 1 || Mt[34].p.k || Mt[34].p.v !== 0 || Mt[35].p.k || Mt[35].p.v !== 1) && (this.feFuncA = this.createFeFunc("feFuncA", Bt)), (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) && (Bt.setAttribute("color-interpolation-filters", "sRGB"), _t.appendChild(Bt)), (Mt[3].p.k || Mt[3].p.v !== 0 || Mt[4].p.k || Mt[4].p.v !== 1 || Mt[5].p.k || Mt[5].p.v !== 1 || Mt[6].p.k || Mt[6].p.v !== 0 || Mt[7].p.k || Mt[7].p.v !== 1) && ((Bt = createNS("feComponentTransfer")).setAttribute("color-interpolation-filters", "sRGB"), Bt.setAttribute("result", $t), _t.appendChild(Bt), this.feFuncRComposed = this.createFeFunc("feFuncR", Bt), this.feFuncGComposed = this.createFeFunc("feFuncG", Bt), this.feFuncBComposed = this.createFeFunc("feFuncB", Bt));
    }
    function SVGDropShadowEffect(_t, Et, Pt, $t, Mt) {
      var Bt = Et.container.globalData.renderConfig.filterSize, Vt = Et.data.fs || Bt;
      _t.setAttribute("x", Vt.x || Bt.x), _t.setAttribute("y", Vt.y || Bt.y), _t.setAttribute("width", Vt.width || Bt.width), _t.setAttribute("height", Vt.height || Bt.height), this.filterManager = Et;
      var zt = createNS("feGaussianBlur");
      zt.setAttribute("in", "SourceAlpha"), zt.setAttribute("result", $t + "_drop_shadow_1"), zt.setAttribute("stdDeviation", "0"), this.feGaussianBlur = zt, _t.appendChild(zt);
      var Ht = createNS("feOffset");
      Ht.setAttribute("dx", "25"), Ht.setAttribute("dy", "0"), Ht.setAttribute("in", $t + "_drop_shadow_1"), Ht.setAttribute("result", $t + "_drop_shadow_2"), this.feOffset = Ht, _t.appendChild(Ht);
      var Wt = createNS("feFlood");
      Wt.setAttribute("flood-color", "#00ff00"), Wt.setAttribute("flood-opacity", "1"), Wt.setAttribute("result", $t + "_drop_shadow_3"), this.feFlood = Wt, _t.appendChild(Wt);
      var Gt = createNS("feComposite");
      Gt.setAttribute("in", $t + "_drop_shadow_3"), Gt.setAttribute("in2", $t + "_drop_shadow_2"), Gt.setAttribute("operator", "in"), Gt.setAttribute("result", $t + "_drop_shadow_4"), _t.appendChild(Gt);
      var qt = this.createMergeNode($t, [$t + "_drop_shadow_4", Mt]);
      _t.appendChild(qt);
    }
    extendPrototype([SVGComposableEffect], SVGTintFilter), SVGTintFilter.prototype.renderFrame = function(_t) {
      if (_t || this.filterManager._mdf) {
        var Et = this.filterManager.effectElements[0].p.v, Pt = this.filterManager.effectElements[1].p.v, $t = this.filterManager.effectElements[2].p.v / 100;
        this.linearFilter.setAttribute("values", linearFilterValue + " " + $t + " 0"), this.matrixFilter.setAttribute("values", Pt[0] - Et[0] + " 0 0 0 " + Et[0] + " " + (Pt[1] - Et[1]) + " 0 0 0 " + Et[1] + " " + (Pt[2] - Et[2]) + " 0 0 0 " + Et[2] + " 0 0 0 1 0");
      }
    }, SVGFillFilter.prototype.renderFrame = function(_t) {
      if (_t || this.filterManager._mdf) {
        var Et = this.filterManager.effectElements[2].p.v, Pt = this.filterManager.effectElements[6].p.v;
        this.matrixFilter.setAttribute("values", "0 0 0 0 " + Et[0] + " 0 0 0 0 " + Et[1] + " 0 0 0 0 " + Et[2] + " 0 0 0 " + Pt + " 0");
      }
    }, SVGStrokeEffect.prototype.initialize = function() {
      var _t, Et, Pt, $t, Mt = this.elem.layerElement.children || this.elem.layerElement.childNodes;
      for (this.filterManager.effectElements[1].p.v === 1 ? ($t = this.elem.maskManager.masksProperties.length, Pt = 0) : $t = (Pt = this.filterManager.effectElements[0].p.v - 1) + 1, (Et = createNS("g")).setAttribute("fill", "none"), Et.setAttribute("stroke-linecap", "round"), Et.setAttribute("stroke-dashoffset", 1); Pt < $t; Pt += 1)
        _t = createNS("path"), Et.appendChild(_t), this.paths.push({ p: _t, m: Pt });
      if (this.filterManager.effectElements[10].p.v === 3) {
        var Bt = createNS("mask"), Vt = createElementID();
        Bt.setAttribute("id", Vt), Bt.setAttribute("mask-type", "alpha"), Bt.appendChild(Et), this.elem.globalData.defs.appendChild(Bt);
        var zt = createNS("g");
        for (zt.setAttribute("mask", "url(" + getLocationHref() + "#" + Vt + ")"); Mt[0]; )
          zt.appendChild(Mt[0]);
        this.elem.layerElement.appendChild(zt), this.masker = Bt, Et.setAttribute("stroke", "#fff");
      } else if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
        if (this.filterManager.effectElements[10].p.v === 2)
          for (Mt = this.elem.layerElement.children || this.elem.layerElement.childNodes; Mt.length; )
            this.elem.layerElement.removeChild(Mt[0]);
        this.elem.layerElement.appendChild(Et), this.elem.layerElement.removeAttribute("mask"), Et.setAttribute("stroke", "#fff");
      }
      this.initialized = !0, this.pathMasker = Et;
    }, SVGStrokeEffect.prototype.renderFrame = function(_t) {
      var Et;
      this.initialized || this.initialize();
      var Pt, $t, Mt = this.paths.length;
      for (Et = 0; Et < Mt; Et += 1)
        if (this.paths[Et].m !== -1 && (Pt = this.elem.maskManager.viewData[this.paths[Et].m], $t = this.paths[Et].p, (_t || this.filterManager._mdf || Pt.prop._mdf) && $t.setAttribute("d", Pt.lastPath), _t || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || Pt.prop._mdf)) {
          var Bt;
          if (this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100) {
            var Vt = 0.01 * Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v), zt = 0.01 * Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v), Ht = $t.getTotalLength();
            Bt = "0 0 0 " + Ht * Vt + " ";
            var Wt, Gt = Ht * (zt - Vt), qt = 1 + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * 0.01, Kt = Math.floor(Gt / qt);
            for (Wt = 0; Wt < Kt; Wt += 1)
              Bt += "1 " + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * 0.01 + " ";
            Bt += "0 " + 10 * Ht + " 0 0";
          } else
            Bt = "1 " + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * 0.01;
          $t.setAttribute("stroke-dasharray", Bt);
        }
      if ((_t || this.filterManager.effectElements[4].p._mdf) && this.pathMasker.setAttribute("stroke-width", 2 * this.filterManager.effectElements[4].p.v), (_t || this.filterManager.effectElements[6].p._mdf) && this.pathMasker.setAttribute("opacity", this.filterManager.effectElements[6].p.v), (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) && (_t || this.filterManager.effectElements[3].p._mdf)) {
        var Qt = this.filterManager.effectElements[3].p.v;
        this.pathMasker.setAttribute("stroke", "rgb(" + bmFloor(255 * Qt[0]) + "," + bmFloor(255 * Qt[1]) + "," + bmFloor(255 * Qt[2]) + ")");
      }
    }, SVGTritoneFilter.prototype.renderFrame = function(_t) {
      if (_t || this.filterManager._mdf) {
        var Et = this.filterManager.effectElements[0].p.v, Pt = this.filterManager.effectElements[1].p.v, $t = this.filterManager.effectElements[2].p.v, Mt = $t[0] + " " + Pt[0] + " " + Et[0], Bt = $t[1] + " " + Pt[1] + " " + Et[1], Vt = $t[2] + " " + Pt[2] + " " + Et[2];
        this.feFuncR.setAttribute("tableValues", Mt), this.feFuncG.setAttribute("tableValues", Bt), this.feFuncB.setAttribute("tableValues", Vt);
      }
    }, SVGProLevelsFilter.prototype.createFeFunc = function(_t, Et) {
      var Pt = createNS(_t);
      return Pt.setAttribute("type", "table"), Et.appendChild(Pt), Pt;
    }, SVGProLevelsFilter.prototype.getTableValue = function(_t, Et, Pt, $t, Mt) {
      for (var Bt, Vt, zt = 0, Ht = Math.min(_t, Et), Wt = Math.max(_t, Et), Gt = Array.call(null, { length: 256 }), qt = 0, Kt = Mt - $t, Qt = Et - _t; zt <= 256; )
        Vt = (Bt = zt / 256) <= Ht ? Qt < 0 ? Mt : $t : Bt >= Wt ? Qt < 0 ? $t : Mt : $t + Kt * Math.pow((Bt - _t) / Qt, 1 / Pt), Gt[qt] = Vt, qt += 1, zt += 256 / 255;
      return Gt.join(" ");
    }, SVGProLevelsFilter.prototype.renderFrame = function(_t) {
      if (_t || this.filterManager._mdf) {
        var Et, Pt = this.filterManager.effectElements;
        this.feFuncRComposed && (_t || Pt[3].p._mdf || Pt[4].p._mdf || Pt[5].p._mdf || Pt[6].p._mdf || Pt[7].p._mdf) && (Et = this.getTableValue(Pt[3].p.v, Pt[4].p.v, Pt[5].p.v, Pt[6].p.v, Pt[7].p.v), this.feFuncRComposed.setAttribute("tableValues", Et), this.feFuncGComposed.setAttribute("tableValues", Et), this.feFuncBComposed.setAttribute("tableValues", Et)), this.feFuncR && (_t || Pt[10].p._mdf || Pt[11].p._mdf || Pt[12].p._mdf || Pt[13].p._mdf || Pt[14].p._mdf) && (Et = this.getTableValue(Pt[10].p.v, Pt[11].p.v, Pt[12].p.v, Pt[13].p.v, Pt[14].p.v), this.feFuncR.setAttribute("tableValues", Et)), this.feFuncG && (_t || Pt[17].p._mdf || Pt[18].p._mdf || Pt[19].p._mdf || Pt[20].p._mdf || Pt[21].p._mdf) && (Et = this.getTableValue(Pt[17].p.v, Pt[18].p.v, Pt[19].p.v, Pt[20].p.v, Pt[21].p.v), this.feFuncG.setAttribute("tableValues", Et)), this.feFuncB && (_t || Pt[24].p._mdf || Pt[25].p._mdf || Pt[26].p._mdf || Pt[27].p._mdf || Pt[28].p._mdf) && (Et = this.getTableValue(Pt[24].p.v, Pt[25].p.v, Pt[26].p.v, Pt[27].p.v, Pt[28].p.v), this.feFuncB.setAttribute("tableValues", Et)), this.feFuncA && (_t || Pt[31].p._mdf || Pt[32].p._mdf || Pt[33].p._mdf || Pt[34].p._mdf || Pt[35].p._mdf) && (Et = this.getTableValue(Pt[31].p.v, Pt[32].p.v, Pt[33].p.v, Pt[34].p.v, Pt[35].p.v), this.feFuncA.setAttribute("tableValues", Et));
      }
    }, extendPrototype([SVGComposableEffect], SVGDropShadowEffect), SVGDropShadowEffect.prototype.renderFrame = function(_t) {
      if (_t || this.filterManager._mdf) {
        if ((_t || this.filterManager.effectElements[4].p._mdf) && this.feGaussianBlur.setAttribute("stdDeviation", this.filterManager.effectElements[4].p.v / 4), _t || this.filterManager.effectElements[0].p._mdf) {
          var Et = this.filterManager.effectElements[0].p.v;
          this.feFlood.setAttribute("flood-color", rgbToHex(Math.round(255 * Et[0]), Math.round(255 * Et[1]), Math.round(255 * Et[2])));
        }
        if ((_t || this.filterManager.effectElements[1].p._mdf) && this.feFlood.setAttribute("flood-opacity", this.filterManager.effectElements[1].p.v / 255), _t || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
          var Pt = this.filterManager.effectElements[3].p.v, $t = (this.filterManager.effectElements[2].p.v - 90) * degToRads, Mt = Pt * Math.cos($t), Bt = Pt * Math.sin($t);
          this.feOffset.setAttribute("dx", Mt), this.feOffset.setAttribute("dy", Bt);
        }
      }
    };
    var _svgMatteSymbols = [];
    function SVGMatte3Effect(_t, Et, Pt) {
      this.initialized = !1, this.filterManager = Et, this.filterElem = _t, this.elem = Pt, Pt.matteElement = createNS("g"), Pt.matteElement.appendChild(Pt.layerElement), Pt.matteElement.appendChild(Pt.transformedElement), Pt.baseElement = Pt.matteElement;
    }
    function SVGGaussianBlurEffect(_t, Et, Pt, $t) {
      _t.setAttribute("x", "-100%"), _t.setAttribute("y", "-100%"), _t.setAttribute("width", "300%"), _t.setAttribute("height", "300%"), this.filterManager = Et;
      var Mt = createNS("feGaussianBlur");
      Mt.setAttribute("result", $t), _t.appendChild(Mt), this.feGaussianBlur = Mt;
    }
    function TransformEffect() {
    }
    function SVGTransformEffect(_t, Et) {
      this.init(Et);
    }
    function CVTransformEffect(_t) {
      this.init(_t);
    }
    return SVGMatte3Effect.prototype.findSymbol = function(_t) {
      for (var Et = 0, Pt = _svgMatteSymbols.length; Et < Pt; ) {
        if (_svgMatteSymbols[Et] === _t)
          return _svgMatteSymbols[Et];
        Et += 1;
      }
      return null;
    }, SVGMatte3Effect.prototype.replaceInParent = function(_t, Et) {
      var Pt = _t.layerElement.parentNode;
      if (Pt) {
        for (var $t, Mt = Pt.children, Bt = 0, Vt = Mt.length; Bt < Vt && Mt[Bt] !== _t.layerElement; )
          Bt += 1;
        Bt <= Vt - 2 && ($t = Mt[Bt + 1]);
        var zt = createNS("use");
        zt.setAttribute("href", "#" + Et), $t ? Pt.insertBefore(zt, $t) : Pt.appendChild(zt);
      }
    }, SVGMatte3Effect.prototype.setElementAsMask = function(_t, Et) {
      if (!this.findSymbol(Et)) {
        var Pt = createElementID(), $t = createNS("mask");
        $t.setAttribute("id", Et.layerId), $t.setAttribute("mask-type", "alpha"), _svgMatteSymbols.push(Et);
        var Mt = _t.globalData.defs;
        Mt.appendChild($t);
        var Bt = createNS("symbol");
        Bt.setAttribute("id", Pt), this.replaceInParent(Et, Pt), Bt.appendChild(Et.layerElement), Mt.appendChild(Bt);
        var Vt = createNS("use");
        Vt.setAttribute("href", "#" + Pt), $t.appendChild(Vt), Et.data.hd = !1, Et.show();
      }
      _t.setMatte(Et.layerId);
    }, SVGMatte3Effect.prototype.initialize = function() {
      for (var _t = this.filterManager.effectElements[0].p.v, Et = this.elem.comp.elements, Pt = 0, $t = Et.length; Pt < $t; )
        Et[Pt] && Et[Pt].data.ind === _t && this.setElementAsMask(this.elem, Et[Pt]), Pt += 1;
      this.initialized = !0;
    }, SVGMatte3Effect.prototype.renderFrame = function() {
      this.initialized || this.initialize();
    }, SVGGaussianBlurEffect.prototype.renderFrame = function(_t) {
      if (_t || this.filterManager._mdf) {
        var Et = 0.3 * this.filterManager.effectElements[0].p.v, Pt = this.filterManager.effectElements[1].p.v, $t = Pt == 3 ? 0 : Et, Mt = Pt == 2 ? 0 : Et;
        this.feGaussianBlur.setAttribute("stdDeviation", $t + " " + Mt);
        var Bt = this.filterManager.effectElements[2].p.v == 1 ? "wrap" : "duplicate";
        this.feGaussianBlur.setAttribute("edgeMode", Bt);
      }
    }, TransformEffect.prototype.init = function(_t) {
      this.effectsManager = _t, this.type = effectTypes.TRANSFORM_EFFECT, this.matrix = new Matrix(), this.opacity = -1, this._mdf = !1, this._opMdf = !1;
    }, TransformEffect.prototype.renderFrame = function(_t) {
      if (this._opMdf = !1, this._mdf = !1, _t || this.effectsManager._mdf) {
        var Et = this.effectsManager.effectElements, Pt = Et[0].p.v, $t = Et[1].p.v, Mt = Et[2].p.v === 1, Bt = Et[3].p.v, Vt = Mt ? Bt : Et[4].p.v, zt = Et[5].p.v, Ht = Et[6].p.v, Wt = Et[7].p.v;
        this.matrix.reset(), this.matrix.translate(-Pt[0], -Pt[1], Pt[2]), this.matrix.scale(0.01 * Vt, 0.01 * Bt, 1), this.matrix.rotate(-Wt * degToRads), this.matrix.skewFromAxis(-zt * degToRads, (Ht + 90) * degToRads), this.matrix.translate($t[0], $t[1], 0), this._mdf = !0, this.opacity !== Et[8].p.v && (this.opacity = Et[8].p.v, this._opMdf = !0);
      }
    }, extendPrototype([TransformEffect], SVGTransformEffect), extendPrototype([TransformEffect], CVTransformEffect), registerRenderer("canvas", CanvasRenderer), registerRenderer("html", HybridRenderer), registerRenderer("svg", SVGRenderer), ShapeModifiers.registerModifier("tm", TrimModifier), ShapeModifiers.registerModifier("pb", PuckerAndBloatModifier), ShapeModifiers.registerModifier("rp", RepeaterModifier), ShapeModifiers.registerModifier("rd", RoundCornersModifier), ShapeModifiers.registerModifier("zz", ZigZagModifier), ShapeModifiers.registerModifier("op", OffsetPathModifier), setExpressionsPlugin(Expressions), setExpressionInterfaces(getInterface), initialize$1(), initialize(), registerEffect$1(20, SVGTintFilter, !0), registerEffect$1(21, SVGFillFilter, !0), registerEffect$1(22, SVGStrokeEffect, !1), registerEffect$1(23, SVGTritoneFilter, !0), registerEffect$1(24, SVGProLevelsFilter, !0), registerEffect$1(25, SVGDropShadowEffect, !0), registerEffect$1(28, SVGMatte3Effect, !1), registerEffect$1(29, SVGGaussianBlurEffect, !0), registerEffect$1(35, SVGTransformEffect, !1), registerEffect(35, CVTransformEffect), lottie;
  });
}), REACT_LOTTIE_PLAYER_VERSION = "3.5.4", LOTTIE_WEB_VERSION = "^5.12.2", PlayerState, PlayerEvent;
function parseSrc(_t) {
  if (typeof _t == "object")
    return _t;
  try {
    return JSON.parse(_t);
  } catch {
  }
  try {
    return new URL(_t).toString();
  } catch {
  }
  return _t;
}
(function(_t) {
  _t.Loading = "loading", _t.Playing = "playing", _t.Paused = "paused", _t.Stopped = "stopped", _t.Frozen = "frozen", _t.Error = "error";
})(PlayerState || (PlayerState = {})), function(_t) {
  _t.Load = "load", _t.InstanceSaved = "instanceSaved", _t.Error = "error", _t.Ready = "ready", _t.Play = "play", _t.Pause = "pause", _t.Stop = "stop", _t.Freeze = "freeze", _t.Loop = "loop", _t.Complete = "complete", _t.Frame = "frame";
}(PlayerEvent || (PlayerEvent = {}));
var defaultOptions = { clearCanvas: !1, hideOnTransparent: !0, progressiveLoad: !0 }, Player = function(_t) {
  function Et(Pt) {
    var $t = _t.call(this, Pt) || this;
    return $t.container = null, $t.unmounted = !1, $t.handleBgChange = function(Mt) {
      $t.setState({ background: Mt });
    }, $t.triggerDownload = function(Mt, Bt) {
      var Vt = document.createElement("a");
      Vt.href = Mt, Vt.download = Bt, document.body.appendChild(Vt), Vt.click(), document.body.removeChild(Vt);
    }, $t.snapshot = function(Mt) {
      var Bt;
      Mt === void 0 && (Mt = !0);
      var Vt = $t.props.id ? $t.props.id : "lottie", zt = document.getElementById(Vt);
      if ($t.props.renderer === "svg") {
        if (zt) {
          var Ht = zt.querySelector("svg");
          if (Ht) {
            var Wt = new XMLSerializer().serializeToString(Ht);
            Bt = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(Wt);
          }
        }
        Mt && $t.triggerDownload(Bt, "snapshot.svg");
      } else if ($t.props.renderer === "canvas") {
        if (zt) {
          var Gt = zt.querySelector("canvas");
          Gt && (Bt = Gt.toDataURL("image/png"));
        }
        Mt && $t.triggerDownload(Bt, "snapshot.png");
      }
      return Bt;
    }, typeof window < "u" && (window.lottie = lottie), $t.state = { animationData: null, background: "transparent", containerRef: React.createRef(), debug: !0, instance: null, playerState: PlayerState.Loading, seeker: 0 }, $t;
  }
  return __extends(Et, _t), Et.getDerivedStateFromProps = function(Pt, $t) {
    return __awaiter(this, void 0, void 0, function() {
      return __generator(this, function(Mt) {
        return Pt.background !== $t.background ? [2, { background: Pt.background }] : [2, null];
      });
    });
  }, Et.prototype.getVersions = function() {
    return { lottieWebVersion: LOTTIE_WEB_VERSION, lottiePlayerVersion: REACT_LOTTIE_PLAYER_VERSION };
  }, Et.prototype.componentDidMount = function() {
    return __awaiter(this, void 0, void 0, function() {
      return __generator(this, function(Pt) {
        switch (Pt.label) {
          case 0:
            return this.unmounted ? [3, 2] : [4, this.createLottie()];
          case 1:
            Pt.sent(), Pt.label = 2;
          case 2:
            return [2];
        }
      });
    });
  }, Et.prototype.componentWillUnmount = function() {
    this.unmounted = !0, this.state.instance && this.state.instance.destroy();
  }, Et.prototype.componentDidUpdate = function(Pt) {
    return __awaiter(this, void 0, void 0, function() {
      return __generator(this, function($t) {
        switch ($t.label) {
          case 0:
            return this.props.src === Pt.src ? [3, 2] : (this.state.instance && this.state.instance.destroy(), [4, this.createLottie()]);
          case 1:
            $t.sent(), $t.label = 2;
          case 2:
            return [2];
        }
      });
    });
  }, Et.prototype.render = function() {
    var Pt = this, $t = this.props, Mt = $t.children, Bt = $t.loop, Vt = $t.style, zt = $t.onBackgroundChange, Ht = $t.className, Wt = this.state, Gt = Wt.animationData, qt = Wt.instance, Kt = Wt.playerState, Qt = Wt.seeker, Xt = Wt.debug, Zt = Wt.background;
    return React.createElement("div", { className: "lf-player-container" }, this.state.playerState === PlayerState.Error ? React.createElement("div", { className: "lf-error" }, React.createElement("span", { "aria-label": "error-symbol", role: "img" }, "⚠️")) : React.createElement("div", { id: this.props.id ? this.props.id : "lottie", ref: function(Yt) {
      return Pt.container = Yt;
    }, style: __assign({ background: Zt, margin: "0 auto", outline: "none", overflow: "hidden" }, Vt), className: Ht }), React.Children.map(Mt, function(Yt) {
      return React.isValidElement(Yt) ? React.cloneElement(Yt, { animationData: Gt, background: Zt, debug: Xt, instance: qt, loop: Bt, pause: function() {
        return Pt.pause();
      }, play: function() {
        return Pt.play();
      }, playerState: Kt, seeker: Qt, setBackground: function(Jt) {
        Pt.setState({ background: Jt }), typeof zt == "function" && zt(Jt);
      }, setSeeker: function(Jt, er) {
        return Pt.setSeeker(Jt, er);
      }, stop: function() {
        return Pt.stop();
      }, toggleDebug: function() {
        return Pt.toggleDebug();
      }, setLoop: function(Jt) {
        return Pt.setLoop(Jt);
      }, colorChangedEvent: function(Jt) {
        Pt.handleBgChange(Jt);
      }, snapshot: function() {
        Pt.snapshot();
      } }) : null;
    }));
  }, Et.prototype.toggleDebug = function() {
    this.setState({ debug: !this.state.debug });
  }, Et.prototype.createLottie = function() {
    return __awaiter(this, void 0, void 0, function() {
      var Pt, $t, Mt, Bt, Vt, zt, Ht, Wt, Gt, qt, Kt, Qt, Xt, Zt, Yt = this;
      return __generator(this, function(Jt) {
        switch (Jt.label) {
          case 0:
            if (Pt = this.props, $t = Pt.autoplay, Mt = Pt.direction, Bt = Pt.loop, Vt = Pt.lottieRef, zt = Pt.renderer, Ht = Pt.speed, Wt = Pt.src, Gt = Pt.background, qt = Pt.rendererSettings, Kt = Pt.hover, Qt = this.state.instance, !Wt || !this.container)
              return [2];
            Jt.label = 1;
          case 1:
            return Jt.trys.push([1, 5, , 6]), typeof (Xt = parseSrc(Wt)) != "string" ? [3, 4] : [4, fetch(Xt).catch(function() {
              throw Yt.setState({ playerState: PlayerState.Error }), Yt.triggerEvent(PlayerEvent.Error), new Error("@LottieFiles/lottie-react: Animation data could not be fetched.");
            })];
          case 2:
            return [4, Jt.sent().json().catch(function() {
              throw Yt.setState({ playerState: PlayerState.Error }), Yt.triggerEvent(PlayerEvent.Error), new Error("@LottieFiles/lottie-react: Animation data could not be fetched.");
            })];
          case 3:
            Xt = Jt.sent(), Jt.label = 4;
          case 4:
            return Qt && Qt.destroy(), Zt = lottie.loadAnimation({ rendererSettings: qt || defaultOptions, animationData: Xt, autoplay: $t || !1, container: this.container, loop: Bt || !1, renderer: zt }), Ht && Zt.setSpeed(Ht), this.setState({ animationData: Xt }), this.setState({ instance: Zt }, function() {
              Yt.triggerEvent(PlayerEvent.InstanceSaved), typeof Vt == "function" && Vt(Zt), $t && Yt.play();
            }), Zt.addEventListener("enterFrame", function() {
              Yt.triggerEvent(PlayerEvent.Frame), Yt.setState({ seeker: Math.floor(Zt.currentFrame) });
            }), Zt.addEventListener("DOMLoaded", function() {
              Yt.triggerEvent(PlayerEvent.Load);
            }), Zt.addEventListener("data_ready", function() {
              Yt.triggerEvent(PlayerEvent.Ready);
            }), Zt.addEventListener("data_failed", function() {
              Yt.setState({ playerState: PlayerState.Error }), Yt.triggerEvent(PlayerEvent.Error);
            }), Zt.addEventListener("loopComplete", function() {
              Yt.triggerEvent(PlayerEvent.Loop);
            }), Zt.addEventListener("complete", function() {
              Yt.triggerEvent(PlayerEvent.Complete), Yt.setState({ playerState: PlayerState.Paused }), Yt.props.keepLastFrame && !Yt.props.loop || Yt.setSeeker(0);
            }), this.container && (this.container.addEventListener("mouseenter", function() {
              Kt && Yt.state.playerState !== PlayerState.Playing && (Yt.props.keepLastFrame && Yt.stop(), Yt.play());
            }), this.container.addEventListener("mouseleave", function() {
              Kt && Yt.state.playerState === PlayerState.Playing && Yt.stop();
            })), Ht && this.setPlayerSpeed(Ht), Mt && this.setPlayerDirection(Mt), Gt && this.setState({ background: Gt }), [3, 6];
          case 5:
            return Jt.sent(), this.setState({ playerState: PlayerState.Error }), this.triggerEvent(PlayerEvent.Error), [3, 6];
          case 6:
            return [2];
        }
      });
    });
  }, Et.prototype.play = function() {
    var Pt = this.state.instance;
    Pt && (this.triggerEvent(PlayerEvent.Play), Pt.play(), this.setState({ playerState: PlayerState.Playing }));
  }, Et.prototype.pause = function() {
    var Pt = this.state.instance;
    Pt && (this.triggerEvent(PlayerEvent.Pause), Pt.pause(), this.setState({ playerState: PlayerState.Paused }));
  }, Et.prototype.stop = function() {
    var Pt = this.state.instance;
    Pt && (this.triggerEvent(PlayerEvent.Stop), Pt.stop(), this.setState({ playerState: PlayerState.Stopped }));
  }, Et.prototype.setPlayerSpeed = function(Pt) {
    var $t = this.state.instance;
    $t && $t.setSpeed(Pt);
  }, Et.prototype.setPlayerDirection = function(Pt) {
    var $t = this.state.instance;
    $t && $t.setDirection(Pt);
  }, Et.prototype.setSeeker = function(Pt, $t) {
    $t === void 0 && ($t = !1);
    var Mt = this.state, Bt = Mt.instance, Vt = Mt.playerState;
    Bt && ($t && Vt === PlayerState.Playing ? Bt.goToAndPlay(Pt, !0) : (Bt.goToAndStop(Pt, !0), this.triggerEvent(PlayerEvent.Pause), this.setState({ playerState: PlayerState.Paused })));
  }, Et.prototype.setLoop = function(Pt) {
    var $t = this.state.instance;
    $t && ($t.loop = Pt, this.setState({ instance: $t }));
  }, Et.prototype.triggerEvent = function(Pt) {
    var $t = this.props.onEvent;
    $t && $t(Pt);
  }, Et.defaultProps = { loop: !1 }, Et;
}(React.Component);
function styleInject(_t, Et) {
  Et === void 0 && (Et = {});
  var Pt = Et.insertAt;
  if (typeof document < "u") {
    var $t = document.head || document.getElementsByTagName("head")[0], Mt = document.createElement("style");
    Mt.type = "text/css", Pt === "top" && $t.firstChild ? $t.insertBefore(Mt, $t.firstChild) : $t.appendChild(Mt), Mt.styleSheet ? Mt.styleSheet.cssText = _t : Mt.appendChild(document.createTextNode(_t));
  }
}
var css_248z = `.lf-progress {
  -webkit-appearance: none;
  -moz-apperance: none;
  width: 100%;
  /* margin: 0 10px; */
  height: 4px;
  border-radius: 3px;
  cursor: pointer;
}
.lf-progress:focus {
  outline: none;
  border: none;
}
.lf-progress::-moz-range-track {
  cursor: pointer;
  background: none;
  border: none;
  outline: none;
}
.lf-progress::-webkit-slider-thumb {
  -webkit-appearance: none !important;
  height: 13px;
  width: 13px;
  border: 0;
  border-radius: 50%;
  background: #0fccce;
  cursor: pointer;
}
.lf-progress::-moz-range-thumb {
  -moz-appearance: none !important;
  height: 13px;
  width: 13px;
  border: 0;
  border-radius: 50%;
  background: #0fccce;
  cursor: pointer;
}
.lf-progress::-ms-track {
  width: 100%;
  height: 3px;
  cursor: pointer;
  background: transparent;
  border-color: transparent;
  color: transparent;
}
.lf-progress::-ms-fill-lower {
  background: #ccc;
  border-radius: 3px;
}
.lf-progress::-ms-fill-upper {
  background: #ccc;
  border-radius: 3px;
}
.lf-progress::-ms-thumb {
  border: 0;
  height: 15px;
  width: 15px;
  border-radius: 50%;
  background: #0fccce;
  cursor: pointer;
}
.lf-progress:focus::-ms-fill-lower {
  background: #ccc;
}
.lf-progress:focus::-ms-fill-upper {
  background: #ccc;
}
.lf-player-container :focus {
  outline: 0;
}
.lf-popover {
  position: relative;
}

.lf-popover-content {
  display: inline-block;
  position: absolute;
  opacity: 1;
  visibility: visible;
  transform: translate(0, -10px);
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
  transition: all 0.3s cubic-bezier(0.75, -0.02, 0.2, 0.97);
}

.lf-popover-content.hidden {
  opacity: 0;
  visibility: hidden;
  transform: translate(0, 0px);
}

.lf-player-btn-container {
  display: flex;
  align-items: center;
}
.lf-player-btn {
  cursor: pointer;
  fill: #999;
  width: 14px;
}

.lf-player-btn.active {
  fill: #555;
}

.lf-popover {
  position: relative;
}

.lf-popover-content {
  display: inline-block;
  position: absolute;
  background-color: #ffffff;
  opacity: 1;

  transform: translate(0, -10px);
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
  transition: all 0.3s cubic-bezier(0.75, -0.02, 0.2, 0.97);
  padding: 10px;
}

.lf-popover-content.hidden {
  opacity: 0;
  visibility: hidden;
  transform: translate(0, 0px);
}

.lf-arrow {
  position: absolute;
  z-index: -1;
  content: '';
  bottom: -9px;
  border-style: solid;
  border-width: 10px 10px 0px 10px;
}

.lf-left-align,
.lf-left-align .lfarrow {
  left: 0;
  right: unset;
}

.lf-right-align,
.lf-right-align .lf-arrow {
  right: 0;
  left: unset;
}

.lf-text-input {
  border: 1px #ccc solid;
  border-radius: 5px;
  padding: 3px;
  width: 60px;
  margin: 0;
}

.lf-color-picker {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 90px;
}

.lf-color-selectors {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.lf-color-component {
  display: flex;
  flex-direction: row;
  font-size: 12px;
  align-items: center;
  justify-content: center;
}

.lf-color-component strong {
  width: 40px;
}

.lf-color-component input[type='range'] {
  margin: 0 0 0 10px;
}

.lf-color-component input[type='number'] {
  width: 50px;
  margin: 0 0 0 10px;
}

.lf-color-preview {
  font-size: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding-left: 5px;
}

.lf-preview {
  height: 60px;
  width: 60px;
}

.lf-popover-snapshot {
  width: 150px;
}
.lf-popover-snapshot h5 {
  margin: 5px 0 10px 0;
  font-size: 0.75rem;
}
.lf-popover-snapshot a {
  display: block;
  text-decoration: none;
}
.lf-popover-snapshot a:before {
  content: '⥼';
  margin-right: 5px;
}
.lf-popover-snapshot .lf-note {
  display: block;
  margin-top: 10px;
  color: #999;
}
.lf-player-controls > div {
  margin-right: 5px;
  margin-left: 5px;
}
.lf-player-controls > div:first-child {
  margin-left: 0px;
}
.lf-player-controls > div:last-child {
  margin-right: 0px;
}
`;
styleInject(css_248z);
var ColorPicker = function(_t) {
  function Et() {
    var Pt = _t !== null && _t.apply(this, arguments) || this;
    return Pt.state = { red: 0, green: 0, blue: 0, rgba: null, hex: "#000000", colorComponents: [] }, Pt.handleChange = function($t, Mt) {
      if ($t === "r") {
        var Bt = "#" + (256 | Mt).toString(16).slice(1) + (256 | Pt.state.green).toString(16).slice(1) + (256 | Pt.state.blue).toString(16).slice(1);
        Pt.setState({ hex: Bt });
      } else
        $t === "g" ? (Bt = "#" + (256 | Pt.state.red).toString(16).slice(1) + (256 | Mt).toString(16).slice(1) + (256 | Pt.state.blue).toString(16).slice(1), Pt.setState({ hex: Bt })) : $t === "b" && (Bt = "#" + (256 | Pt.state.red).toString(16).slice(1) + (256 | Pt.state.green).toString(16).slice(1) + (256 | Mt).toString(16).slice(1), Pt.setState({ hex: Bt }));
    }, Pt.parseColor = function($t) {
      var Mt;
      if (typeof $t == "string") {
        if ($t[0] === "#") {
          var Bt = $t.length === 4 ? [$t.slice(1, 2), $t.slice(2, 3), $t.slice(3, 4)].map(function(Vt) {
            return parseInt("" + Vt + Vt, 16);
          }) : [$t.slice(1, 3), $t.slice(3, 5), $t.slice(5, 7)].map(function(Vt) {
            return parseInt(Vt, 16);
          });
          Pt.setState({ colorComponents: Bt });
        } else
          $t.startsWith("rgb") && (Bt = (Mt = $t.match(/\d+/g)) === null || Mt === void 0 ? void 0 : Mt.map(function(Vt) {
            return parseInt(Vt);
          })) !== void 0 && Pt.setState({ colorComponents: Bt });
        Pt.state.colorComponents.length && (Pt.setState({ red: Pt.state.colorComponents[0] }), Pt.setState({ green: Pt.state.colorComponents[1] }), Pt.setState({ blue: Pt.state.colorComponents[2] }));
      }
    }, Pt;
  }
  return __extends(Et, _t), Et.prototype.componentDidUpdate = function(Pt, $t) {
    return this.props.colorChangedEvent && this.state.hex !== $t.hex && this.props.colorChangedEvent(this.state.hex), !0;
  }, Et.prototype.render = function() {
    var Pt = this;
    return React.createElement("div", { className: "lf-color-picker" }, React.createElement("div", { className: "lf-color-selectors" }, React.createElement("div", { className: "lf-color-component" }, React.createElement("strong", null, "Red"), React.createElement("input", { type: "range", min: "0", max: "255", value: this.state.red, onChange: function($t) {
      Pt.setState({ red: $t.target.value }), Pt.handleChange("r", $t.target.value);
    } }), React.createElement("input", { className: "lf-text-input", type: "number", min: "0", max: "255", value: this.state.red, onChange: function($t) {
      Pt.setState({ red: $t.target.value }), Pt.handleChange("r", $t.target.value);
    } })), React.createElement("div", { className: "lf-color-component" }, React.createElement("strong", null, "Green"), React.createElement("input", { type: "range", min: "0", max: "255", value: this.state.green, onChange: function($t) {
      Pt.setState({ green: $t.target.value }), Pt.handleChange("g", $t.target.value);
    } }), React.createElement("input", { className: "lf-text-input", type: "number", min: "0", max: "255", value: this.state.green, onChange: function($t) {
      Pt.setState({ green: $t.target.value }), Pt.handleChange("g", $t.target.value);
    } })), React.createElement("div", { className: "lf-color-component" }, React.createElement("strong", null, "Blue"), React.createElement("input", { type: "range", min: "0", max: "255", value: this.state.blue, onChange: function($t) {
      Pt.setState({ blue: $t.target.value }), Pt.handleChange("b", $t.target.value);
    } }), React.createElement("input", { className: "lf-text-input", type: "number", min: "0", max: "255", value: this.state.blue, onChange: function($t) {
      Pt.setState({ blue: $t.target.value }), Pt.handleChange("b", $t.target.value);
    } }))), React.createElement("div", { className: "lf-color-preview" }, React.createElement("div", { className: "lf-preview", style: { background: "rgb(" + this.state.red + ", " + this.state.green + ", " + this.state.blue + ")" } }), React.createElement("div", null, React.createElement("input", { className: "lf-text-input", type: "text", value: this.state.hex, onChange: function($t) {
      Pt.setState({ hex: $t.target.value }), Pt.parseColor($t.target.value);
    } }))));
  }, Et;
}(React.Component), Popover = function(_t) {
  var Et = _t.children, Pt = _t.icon, $t = useState(null), Mt = $t[0], Bt = $t[1], Vt = useState(null), zt = Vt[0], Ht = Vt[1], Wt = useState(null), Gt = Wt[0], qt = Wt[1], Kt = useState(!1), Qt = Kt[0], Xt = Kt[1];
  return useEffect(function() {
    if (Mt && zt) {
      var Zt = Mt.getBoundingClientRect(), Yt = zt.getBoundingClientRect(), Jt = Zt.left + Yt.width > window.innerWidth ? -1 : 0;
      qt(Jt);
    }
  }, [Gt, zt, Mt]), React.createElement("div", { className: "lf-popover", onMouseOver: function() {
    Xt(!0);
  }, onMouseLeave: function() {
    Xt(!1);
  }, ref: function(Zt) {
    Bt(Zt);
  } }, React.createElement("div", { className: " lf-player-btn" }, Pt), React.createElement("div", { className: "lf-popover-content", ref: function(Zt) {
    Ht(Zt);
  }, style: { bottom: "22px", right: "0px", zIndex: 2, visibility: Qt ? "visible" : "hidden" } }, Et));
}, Seeker = function(_t) {
  function Et(Pt) {
    var $t = _t.call(this, Pt) || this;
    return $t.inputRef = React.createRef(), $t.handleChange = function() {
      return function(Mt) {
        var Bt = Mt.target.value, Vt = Math.floor(Bt / 100 * $t.props.max);
        $t.props.onChange(Vt);
      };
    }, $t.state = { value: 0 }, $t;
  }
  return __extends(Et, _t), Et.prototype.render = function() {
    var Pt = this.props.value / this.props.max * 100, $t = { backgroundImage: "-webkit-gradient(linear, left top, right top, color-stop(" + Pt + "%, rgba(15, 204, 206, 0.4)), color-stop(" + Pt + "%, #DAE1E7))" }, Mt = { position: "absolute", left: 0, marginTop: "8px", width: "20px", display: "block", border: "0px", backgroundColor: this.props.darkTheme ? "#505050" : "rgb(218, 225, 231)", color: this.props.darkTheme ? "#B9B9B9" : "#555", padding: "2px", textAlign: "center", borderRadius: "3px", fontSize: "8px", fontWeight: "bold" }, Bt = { position: "absolute", right: 0, marginTop: "8px", width: "20px", display: "block", border: "0px", backgroundColor: this.props.darkTheme ? "#505050" : "rgb(218, 225, 231)", color: this.props.darkTheme ? "#B9B9B9" : "#555", padding: "2px", textAlign: "center", borderRadius: "3px", fontSize: "8px", fontWeight: "bold" };
    return React.createElement("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", width: "100%", marginRight: "5px", marginLeft: "5px", position: "relative" } }, React.createElement("input", { ref: this.inputRef, id: "track", className: "lf-progress", name: "progress", "aria-label": "progress", type: "range", min: "0", max: "100", step: "0.1", value: Pt, onInput: this.handleChange(), onChange: this.handleChange(), style: $t }), this.props.showLabels && React.createElement("div", { style: { display: "flex", justifyContent: "space-between" } }, React.createElement("div", { style: Mt }, this.props.min), React.createElement("div", { style: Bt }, this.props.max)));
  }, Et;
}(React.Component), ControlButtonStyle = { display: "inline-flex", cursor: "pointer" };
(function(_t) {
  function Et(Pt) {
    var $t = _t.call(this, Pt) || this;
    return $t.state = { activeFrame: 0, mouseDown: !1 }, $t;
  }
  return __extends(Et, _t), Et.prototype.render = function() {
    var Pt = this, $t = this.props, Mt = $t.instance, Bt = $t.playerState, Vt = $t.seeker, zt = $t.setLoop, Ht = $t.setSeeker, Wt = $t.play, Gt = $t.pause, qt = $t.stop, Kt = $t.visible, Qt = $t.buttons;
    if (!Mt || !Kt)
      return null;
    var Xt = !Qt || Qt.includes("play"), Zt = !Qt || Qt.includes("stop"), Yt = !Qt || Qt.includes("repeat"), Jt = !Qt || Qt.includes("frame"), er = !Qt || Qt.includes("background"), tr = !Qt || Qt.includes("snapshot"), nr = { width: 14, height: 14, viewBox: "0 0 24 24" }, rr = Math.round(Mt.currentFrame);
    return React.createElement("div", { className: "lf-player-controls", style: { display: "flex", justifyContent: "space-between", height: "60px", alignItems: "center", backgroundColor: this.props.transparentTheme ? "transparent" : this.props.darkTheme ? "#3C3C3C" : "#ffffff", paddingLeft: "10px", paddingRight: "10px" } }, Xt && React.createElement("div", { role: "button", "aria-label": Bt === PlayerState.Playing ? PlayerEvent.Pause : PlayerEvent.Play, tabIndex: 0, onClick: function() {
      Bt === PlayerState.Playing ? typeof Gt == "function" && Gt() : typeof Wt == "function" && Wt();
    }, onKeyDown: function() {
      Bt === PlayerState.Playing ? typeof Gt == "function" && Gt() : typeof Wt == "function" && Wt();
    }, className: "lf-player-btn", style: ControlButtonStyle }, Bt === PlayerState.Playing ? React.createElement("svg", __assign({}, nr), React.createElement("rect", { height: "22.9", rx: "1.9", width: "7.6", x: "14", y: ".5" }), React.createElement("rect", { height: "22.9", rx: "1.9", width: "7.6", x: "2", y: ".5" })) : React.createElement("svg", __assign({}, nr), React.createElement("path", { d: "M2 3.4C2 1.9 3.5 1 4.8 1.8l16.5 9.6c1.2.7 1.2 2.5 0 3.2L4.8 24.2C3.5 25 2 24.1 2 22.6V3.4z" }))), Zt && React.createElement("div", { tabIndex: 0, role: "button", "aria-label": PlayerEvent.Stop, onClick: function() {
      return qt && qt();
    }, onKeyDown: function() {
      return qt && qt();
    }, className: Bt === PlayerState.Stopped ? "lf-player-btn active" : "lf-player-btn", style: ControlButtonStyle }, React.createElement("svg", __assign({}, nr), React.createElement("path", { d: `M2 3.667A1.67 1.67 0 0 1 3.667 2h16.666A1.67 1.67 0 0 1 22 3.667v16.666A1.67 1.67 0 0 1 20.333
            22H3.667A1.67 1.67 0 0 1 2 20.333z` }))), React.createElement(Seeker, { min: 0, step: 1, max: Mt ? Mt.totalFrames : 1, value: Vt || 0, onChange: function(ir) {
      Ht && Pt.setState({ activeFrame: ir }, function() {
        Ht(ir, !1);
      });
    }, onChangeEnd: function(ir) {
      Ht && Pt.setState({ activeFrame: ir }, function() {
        Ht(ir, !1);
      });
    }, showLabels: this.props.showLabels, darkTheme: this.props.darkTheme }), Jt && React.createElement("div", { role: "button", className: "lf-player-btn-container" }, React.createElement("input", { style: { outline: "none", border: this.props.darkTheme ? "1px #505050 solid" : "1px #ccc solid", borderRadius: "3px", width: "40px", textAlign: "center", backgroundColor: this.props.darkTheme ? "#505050" : "#ffffff", color: this.props.darkTheme ? "#B9B9B9" : "#999", fontSize: "0.7rem", padding: "0", fontFamily: "inherit" }, type: "text", value: rr, readOnly: !0 })), Yt && React.createElement("div", { role: "button", "aria-label": PlayerEvent.Loop, tabIndex: 0, onClick: function() {
      Mt && zt && zt(!Mt.loop);
    }, onKeyDown: function() {
      Mt && zt && zt(!Mt.loop);
    }, className: Mt.loop ? "lf-player-btn active" : "lf-player-btn", style: ControlButtonStyle }, React.createElement("svg", __assign({}, nr), React.createElement("path", { d: `M12.5 16.8137h-.13v1.8939h4.9696c3.6455 0 6.6113-2.9658 6.6113-6.6116
            0-3.64549-2.9658-6.61131-6.6113-6.61131-.5231 0-.947.42391-.947.94696 0 .52304.4239.94696.947.94696 2.6011 0
            4.7174 2.11634 4.7174 4.71739 0 2.6014-2.1166 4.7177-4.7174 4.7177H12.5zM13.6025
            5.61469v-.13H7.48137C3.83582 5.48469.87 8.45051.87 12.096c0 3.6509 3.17269 6.6117 6.81304 6.6117.52304 0
            .94696-.424.94696-.947 0-.5231-.42392-.947-.94696-.947-2.60804 0-4.91907-2.1231-4.91907-4.7176 0-2.60115
            2.11634-4.71744 4.7174-4.71744h6.12113V5.61469z`, stroke: "#8795A1", strokeWidth: ".26" }), React.createElement("path", { d: `M11.1482
            2.20355h0l-.001-.00116c-.3412-.40061-.9405-.44558-1.33668-.0996h-.00001c-.39526.34519-.43936.94795-.09898
            1.34767l2.51487 3.03683-2.51894 3.06468c-.33872.40088-.29282 1.00363.10347
            1.34723l.08517-.0982-.08517.0982c.17853.1549.39807.2308.61647.2308.2671 0 .5328-.114.72-.3347h0l.0011-.0014
            3.0435-3.68655.0006-.00068c.3035-.35872.3025-.88754-.0019-1.24526l-3.0425-3.65786zM13.9453
            21.7965h0l.001.0011c.3413.4006.9407.4456 1.337.0996h0c.3953-.3452.4395-.9479.099-1.3477l-2.5154-3.0368
            2.5195-3.0647c.3388-.4008.2929-1.0036-.1035-1.3472l-.0852.0982.0852-.0982c-.1786-.1549-.3981-.2308-.6166-.2308-.2671
            0-.5329.114-.7202.3347h0l-.0011.0014-3.0442
            3.6865c-.0001.0003-.0003.0005-.0005.0007-.3036.3587-.3027.8876.0019 1.2453l3.0431 3.6579z`, fill: "#8795A1", stroke: "#8795A1", strokeWidth: ".26" }))), er && React.createElement(Popover, { icon: React.createElement("svg", __assign({}, nr), React.createElement("path", { d: `M12 3.1L6.1 8.6a7.6 7.6 0 00-2.2 4 7.2 7.2 0 00.4 4.4 7.9 7.9 0 003 3.5 8.7 8.7 0 004.7 1.3c1.6 0
            3.2-.5 4.6-1.3s2.4-2 3-3.5a7.2 7.2 0 00.5-4.5 7.6 7.6 0 00-2.2-4L12 3.2zM12 0l7.5 7a9.8 9.8 0 013 5.1
            9.3 9.3 0 01-.6 5.8c-.9 1.8-2.2 3.3-4 4.4A11.2 11.2 0 0112 24a11.2 11.2 0
            01-6-1.7c-1.7-1-3-2.6-3.9-4.4a9.3 9.3 0 01-.6-5.8c.4-2 1.5-3.7 3-5L12 0zM6 14h12c0 1.5-.7 3-1.8 4s-2.6
            1.6-4.2 1.6S9 19 7.8 18s-1.7-2.5-1.7-4z` })) }, React.createElement("div", { slot: "content", className: "lf-popover popover-background" }, React.createElement(ColorPicker, { colorChangedEvent: this.props.colorChangedEvent }))), tr && React.createElement(Popover, { icon: React.createElement("svg", __assign({}, nr), React.createElement("path", { clipRule: "evenodd", d: `M0 3.01A2.983 2.983 0 012.983.027H16.99a2.983 2.983 0 012.983 2.983v14.008a2.982 2.982 0 01-2.983
              2.983H2.983A2.983 2.983 0 010 17.018zm2.983-.941a.941.941 0 00-.942.94v14.01c0
              .52.422.94.942.94H16.99a.94.94 0 00.941-.94V3.008a.941.941 0 00-.94-.94H2.981z`, fillRule: "evenodd" }), React.createElement("path", { d: "M12.229 7.945l-2.07 4.598-2.586-2.605-2.414 2.758v2.146h9.656V11.93z" }), React.createElement("circle", { cx: "7.444", cy: "6.513", r: "2.032" }), React.createElement("path", { d: `M9.561 23.916h11.25a2.929 2.929 0 002.926-2.927V9.954a1.06 1.06 0 10-2.122 0v11.035a.805.805 0
              01-.803.804H9.562a1.061 1.061 0 100 2.123z`, stroke: "#8795a1", strokeWidth: ".215" })) }, React.createElement("div", { slot: "content", className: "lf-popover lf-popover-snapshot", onWheel: function(ir) {
      Ht && Ht(rr + (ir.deltaY > 0 ? -1 : 1), !1);
    } }, React.createElement("h5", null, "Frame ", rr), React.createElement("div", { style: { cursor: "pointer", color: "#0FCCCE" }, onClick: this.props.snapshot }, "Download SVG"), React.createElement("div", { style: { cursor: "pointer", color: "#0FCCCE" }, onClick: this.props.snapshot }, "Download PNG"), React.createElement("i", { className: "lf-note" }, "Scroll with mousewheel to find exact frame"))));
  }, Et;
})(React.Component);
const AccessAccountWrapper = dt$1.a`
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  border-radius: 4px;
  padding: 4px 12px 4px 4px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: ${(_t) => _t.theme.colors.cws_neutral_90};
  transition: background-color 300ms ease-in-out, color 300ms ease-in-out;
  color: ${(_t) => _t.theme.colors.cws_neutral_10};
  cursor: pointer;
  font-size: 14px;
  text-decoration: none;
  margin-top: 12px;

  &:hover {
    background-color: ${(_t) => _t.theme.colors.cws_neutral_80};
    color: ${(_t) => _t.theme.colors.cws_neutral_00};
  }
`, AccessAccountAvatar = dt$1.div`
  width: 24px;
  height: 24px;
  border-radius: 12px;
  border: 1px solid ${(_t) => _t.theme.colors.cws_neutral_80};
  background-color: ${(_t) => _t.theme.colors.cws_neutral_90};
  margin-right: 8px;
  color: ${(_t) => _t.theme.colors.cws_neutral_30};
  font-size: 12px;
  line-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`, AccessAccount = ({
  avatar: _t
}) => {
  const {
    t: Et
  } = useTranslation(), $t = useConfig$1().getAccountsURL();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(AccessAccountWrapper, { href: $t && `${$t}/app/workspaces`, target: "_blank", rel: "noreferrer", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(AccessAccountAvatar, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: _t }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: Et("sidebar.access_account") })
  ] });
};
var lib = {}, propTypes$2 = { exports: {} }, reactIs = { exports: {} }, reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min)
    return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var _t = typeof Symbol == "function" && Symbol.for, Et = _t ? Symbol.for("react.element") : 60103, Pt = _t ? Symbol.for("react.portal") : 60106, $t = _t ? Symbol.for("react.fragment") : 60107, Mt = _t ? Symbol.for("react.strict_mode") : 60108, Bt = _t ? Symbol.for("react.profiler") : 60114, Vt = _t ? Symbol.for("react.provider") : 60109, zt = _t ? Symbol.for("react.context") : 60110, Ht = _t ? Symbol.for("react.async_mode") : 60111, Wt = _t ? Symbol.for("react.concurrent_mode") : 60111, Gt = _t ? Symbol.for("react.forward_ref") : 60112, qt = _t ? Symbol.for("react.suspense") : 60113, Kt = _t ? Symbol.for("react.suspense_list") : 60120, Qt = _t ? Symbol.for("react.memo") : 60115, Xt = _t ? Symbol.for("react.lazy") : 60116, Zt = _t ? Symbol.for("react.block") : 60121, Yt = _t ? Symbol.for("react.fundamental") : 60117, Jt = _t ? Symbol.for("react.responder") : 60118, er = _t ? Symbol.for("react.scope") : 60119;
  function tr(rr) {
    if (typeof rr == "object" && rr !== null) {
      var ir = rr.$$typeof;
      switch (ir) {
        case Et:
          switch (rr = rr.type, rr) {
            case Ht:
            case Wt:
            case $t:
            case Bt:
            case Mt:
            case qt:
              return rr;
            default:
              switch (rr = rr && rr.$$typeof, rr) {
                case zt:
                case Gt:
                case Xt:
                case Qt:
                case Vt:
                  return rr;
                default:
                  return ir;
              }
          }
        case Pt:
          return ir;
      }
    }
  }
  function nr(rr) {
    return tr(rr) === Wt;
  }
  return reactIs_production_min.AsyncMode = Ht, reactIs_production_min.ConcurrentMode = Wt, reactIs_production_min.ContextConsumer = zt, reactIs_production_min.ContextProvider = Vt, reactIs_production_min.Element = Et, reactIs_production_min.ForwardRef = Gt, reactIs_production_min.Fragment = $t, reactIs_production_min.Lazy = Xt, reactIs_production_min.Memo = Qt, reactIs_production_min.Portal = Pt, reactIs_production_min.Profiler = Bt, reactIs_production_min.StrictMode = Mt, reactIs_production_min.Suspense = qt, reactIs_production_min.isAsyncMode = function(rr) {
    return nr(rr) || tr(rr) === Ht;
  }, reactIs_production_min.isConcurrentMode = nr, reactIs_production_min.isContextConsumer = function(rr) {
    return tr(rr) === zt;
  }, reactIs_production_min.isContextProvider = function(rr) {
    return tr(rr) === Vt;
  }, reactIs_production_min.isElement = function(rr) {
    return typeof rr == "object" && rr !== null && rr.$$typeof === Et;
  }, reactIs_production_min.isForwardRef = function(rr) {
    return tr(rr) === Gt;
  }, reactIs_production_min.isFragment = function(rr) {
    return tr(rr) === $t;
  }, reactIs_production_min.isLazy = function(rr) {
    return tr(rr) === Xt;
  }, reactIs_production_min.isMemo = function(rr) {
    return tr(rr) === Qt;
  }, reactIs_production_min.isPortal = function(rr) {
    return tr(rr) === Pt;
  }, reactIs_production_min.isProfiler = function(rr) {
    return tr(rr) === Bt;
  }, reactIs_production_min.isStrictMode = function(rr) {
    return tr(rr) === Mt;
  }, reactIs_production_min.isSuspense = function(rr) {
    return tr(rr) === qt;
  }, reactIs_production_min.isValidElementType = function(rr) {
    return typeof rr == "string" || typeof rr == "function" || rr === $t || rr === Wt || rr === Bt || rr === Mt || rr === qt || rr === Kt || typeof rr == "object" && rr !== null && (rr.$$typeof === Xt || rr.$$typeof === Qt || rr.$$typeof === Vt || rr.$$typeof === zt || rr.$$typeof === Gt || rr.$$typeof === Yt || rr.$$typeof === Jt || rr.$$typeof === er || rr.$$typeof === Zt);
  }, reactIs_production_min.typeOf = tr, reactIs_production_min;
}
var reactIs_development = {}, hasRequiredReactIs_development;
function requireReactIs_development() {
  return hasRequiredReactIs_development || (hasRequiredReactIs_development = 1, browser$1.env.NODE_ENV !== "production" && function() {
    var _t = typeof Symbol == "function" && Symbol.for, Et = _t ? Symbol.for("react.element") : 60103, Pt = _t ? Symbol.for("react.portal") : 60106, $t = _t ? Symbol.for("react.fragment") : 60107, Mt = _t ? Symbol.for("react.strict_mode") : 60108, Bt = _t ? Symbol.for("react.profiler") : 60114, Vt = _t ? Symbol.for("react.provider") : 60109, zt = _t ? Symbol.for("react.context") : 60110, Ht = _t ? Symbol.for("react.async_mode") : 60111, Wt = _t ? Symbol.for("react.concurrent_mode") : 60111, Gt = _t ? Symbol.for("react.forward_ref") : 60112, qt = _t ? Symbol.for("react.suspense") : 60113, Kt = _t ? Symbol.for("react.suspense_list") : 60120, Qt = _t ? Symbol.for("react.memo") : 60115, Xt = _t ? Symbol.for("react.lazy") : 60116, Zt = _t ? Symbol.for("react.block") : 60121, Yt = _t ? Symbol.for("react.fundamental") : 60117, Jt = _t ? Symbol.for("react.responder") : 60118, er = _t ? Symbol.for("react.scope") : 60119;
    function tr(Tr) {
      return typeof Tr == "string" || typeof Tr == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      Tr === $t || Tr === Wt || Tr === Bt || Tr === Mt || Tr === qt || Tr === Kt || typeof Tr == "object" && Tr !== null && (Tr.$$typeof === Xt || Tr.$$typeof === Qt || Tr.$$typeof === Vt || Tr.$$typeof === zt || Tr.$$typeof === Gt || Tr.$$typeof === Yt || Tr.$$typeof === Jt || Tr.$$typeof === er || Tr.$$typeof === Zt);
    }
    function nr(Tr) {
      if (typeof Tr == "object" && Tr !== null) {
        var Gr = Tr.$$typeof;
        switch (Gr) {
          case Et:
            var $r = Tr.type;
            switch ($r) {
              case Ht:
              case Wt:
              case $t:
              case Bt:
              case Mt:
              case qt:
                return $r;
              default:
                var Rr = $r && $r.$$typeof;
                switch (Rr) {
                  case zt:
                  case Gt:
                  case Xt:
                  case Qt:
                  case Vt:
                    return Rr;
                  default:
                    return Gr;
                }
            }
          case Pt:
            return Gr;
        }
      }
    }
    var rr = Ht, ir = Wt, ar = zt, or = Vt, sr = Et, lr = Gt, cr = $t, hr = Xt, pr = Qt, mr = Pt, Er = Bt, _r = Mt, yr = qt, ur = !1;
    function vr(Tr) {
      return ur || (ur = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), dr(Tr) || nr(Tr) === Ht;
    }
    function dr(Tr) {
      return nr(Tr) === Wt;
    }
    function br(Tr) {
      return nr(Tr) === zt;
    }
    function Cr(Tr) {
      return nr(Tr) === Vt;
    }
    function Pr(Tr) {
      return typeof Tr == "object" && Tr !== null && Tr.$$typeof === Et;
    }
    function xr(Tr) {
      return nr(Tr) === Gt;
    }
    function kr(Tr) {
      return nr(Tr) === $t;
    }
    function Ir(Tr) {
      return nr(Tr) === Xt;
    }
    function Ar(Tr) {
      return nr(Tr) === Qt;
    }
    function Mr(Tr) {
      return nr(Tr) === Pt;
    }
    function Fr(Tr) {
      return nr(Tr) === Bt;
    }
    function Dr(Tr) {
      return nr(Tr) === Mt;
    }
    function zr(Tr) {
      return nr(Tr) === qt;
    }
    reactIs_development.AsyncMode = rr, reactIs_development.ConcurrentMode = ir, reactIs_development.ContextConsumer = ar, reactIs_development.ContextProvider = or, reactIs_development.Element = sr, reactIs_development.ForwardRef = lr, reactIs_development.Fragment = cr, reactIs_development.Lazy = hr, reactIs_development.Memo = pr, reactIs_development.Portal = mr, reactIs_development.Profiler = Er, reactIs_development.StrictMode = _r, reactIs_development.Suspense = yr, reactIs_development.isAsyncMode = vr, reactIs_development.isConcurrentMode = dr, reactIs_development.isContextConsumer = br, reactIs_development.isContextProvider = Cr, reactIs_development.isElement = Pr, reactIs_development.isForwardRef = xr, reactIs_development.isFragment = kr, reactIs_development.isLazy = Ir, reactIs_development.isMemo = Ar, reactIs_development.isPortal = Mr, reactIs_development.isProfiler = Fr, reactIs_development.isStrictMode = Dr, reactIs_development.isSuspense = zr, reactIs_development.isValidElementType = tr, reactIs_development.typeOf = nr;
  }()), reactIs_development;
}
var hasRequiredReactIs;
function requireReactIs() {
  return hasRequiredReactIs || (hasRequiredReactIs = 1, browser$1.env.NODE_ENV === "production" ? reactIs.exports = requireReactIs_production_min() : reactIs.exports = requireReactIs_development()), reactIs.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign, hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign)
    return objectAssign;
  hasRequiredObjectAssign = 1;
  var _t = Object.getOwnPropertySymbols, Et = Object.prototype.hasOwnProperty, Pt = Object.prototype.propertyIsEnumerable;
  function $t(Bt) {
    if (Bt == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(Bt);
  }
  function Mt() {
    try {
      if (!Object.assign)
        return !1;
      var Bt = new String("abc");
      if (Bt[5] = "de", Object.getOwnPropertyNames(Bt)[0] === "5")
        return !1;
      for (var Vt = {}, zt = 0; zt < 10; zt++)
        Vt["_" + String.fromCharCode(zt)] = zt;
      var Ht = Object.getOwnPropertyNames(Vt).map(function(Gt) {
        return Vt[Gt];
      });
      if (Ht.join("") !== "0123456789")
        return !1;
      var Wt = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(Gt) {
        Wt[Gt] = Gt;
      }), Object.keys(Object.assign({}, Wt)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return objectAssign = Mt() ? Object.assign : function(Bt, Vt) {
    for (var zt, Ht = $t(Bt), Wt, Gt = 1; Gt < arguments.length; Gt++) {
      zt = Object(arguments[Gt]);
      for (var qt in zt)
        Et.call(zt, qt) && (Ht[qt] = zt[qt]);
      if (_t) {
        Wt = _t(zt);
        for (var Kt = 0; Kt < Wt.length; Kt++)
          Pt.call(zt, Wt[Kt]) && (Ht[Wt[Kt]] = zt[Wt[Kt]]);
      }
    }
    return Ht;
  }, objectAssign;
}
var ReactPropTypesSecret_1, hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret)
    return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var _t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ReactPropTypesSecret_1 = _t, ReactPropTypesSecret_1;
}
var has, hasRequiredHas;
function requireHas() {
  return hasRequiredHas || (hasRequiredHas = 1, has = Function.call.bind(Object.prototype.hasOwnProperty)), has;
}
var checkPropTypes_1, hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes)
    return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var _t = function() {
  };
  if (browser$1.env.NODE_ENV !== "production") {
    var Et = requireReactPropTypesSecret(), Pt = {}, $t = requireHas();
    _t = function(Bt) {
      var Vt = "Warning: " + Bt;
      typeof console < "u" && console.error(Vt);
      try {
        throw new Error(Vt);
      } catch {
      }
    };
  }
  function Mt(Bt, Vt, zt, Ht, Wt) {
    if (browser$1.env.NODE_ENV !== "production") {
      for (var Gt in Bt)
        if ($t(Bt, Gt)) {
          var qt;
          try {
            if (typeof Bt[Gt] != "function") {
              var Kt = Error(
                (Ht || "React class") + ": " + zt + " type `" + Gt + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof Bt[Gt] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw Kt.name = "Invariant Violation", Kt;
            }
            qt = Bt[Gt](Vt, Gt, Ht, zt, null, Et);
          } catch (Xt) {
            qt = Xt;
          }
          if (qt && !(qt instanceof Error) && _t(
            (Ht || "React class") + ": type specification of " + zt + " `" + Gt + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof qt + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), qt instanceof Error && !(qt.message in Pt)) {
            Pt[qt.message] = !0;
            var Qt = Wt ? Wt() : "";
            _t(
              "Failed " + zt + " type: " + qt.message + (Qt ?? "")
            );
          }
        }
    }
  }
  return Mt.resetWarningCache = function() {
    browser$1.env.NODE_ENV !== "production" && (Pt = {});
  }, checkPropTypes_1 = Mt, checkPropTypes_1;
}
var factoryWithTypeCheckers, hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers)
    return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var _t = requireReactIs(), Et = requireObjectAssign(), Pt = requireReactPropTypesSecret(), $t = requireHas(), Mt = requireCheckPropTypes(), Bt = function() {
  };
  browser$1.env.NODE_ENV !== "production" && (Bt = function(zt) {
    var Ht = "Warning: " + zt;
    typeof console < "u" && console.error(Ht);
    try {
      throw new Error(Ht);
    } catch {
    }
  });
  function Vt() {
    return null;
  }
  return factoryWithTypeCheckers = function(zt, Ht) {
    var Wt = typeof Symbol == "function" && Symbol.iterator, Gt = "@@iterator";
    function qt(dr) {
      var br = dr && (Wt && dr[Wt] || dr[Gt]);
      if (typeof br == "function")
        return br;
    }
    var Kt = "<<anonymous>>", Qt = {
      array: Jt("array"),
      bigint: Jt("bigint"),
      bool: Jt("boolean"),
      func: Jt("function"),
      number: Jt("number"),
      object: Jt("object"),
      string: Jt("string"),
      symbol: Jt("symbol"),
      any: er(),
      arrayOf: tr,
      element: nr(),
      elementType: rr(),
      instanceOf: ir,
      node: lr(),
      objectOf: or,
      oneOf: ar,
      oneOfType: sr,
      shape: hr,
      exact: pr
    };
    function Xt(dr, br) {
      return dr === br ? dr !== 0 || 1 / dr === 1 / br : dr !== dr && br !== br;
    }
    function Zt(dr, br) {
      this.message = dr, this.data = br && typeof br == "object" ? br : {}, this.stack = "";
    }
    Zt.prototype = Error.prototype;
    function Yt(dr) {
      if (browser$1.env.NODE_ENV !== "production")
        var br = {}, Cr = 0;
      function Pr(kr, Ir, Ar, Mr, Fr, Dr, zr) {
        if (Mr = Mr || Kt, Dr = Dr || Ar, zr !== Pt) {
          if (Ht) {
            var Tr = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw Tr.name = "Invariant Violation", Tr;
          } else if (browser$1.env.NODE_ENV !== "production" && typeof console < "u") {
            var Gr = Mr + ":" + Ar;
            !br[Gr] && // Avoid spamming the console because they are often not actionable except for lib authors
            Cr < 3 && (Bt(
              "You are manually calling a React.PropTypes validation function for the `" + Dr + "` prop on `" + Mr + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), br[Gr] = !0, Cr++);
          }
        }
        return Ir[Ar] == null ? kr ? Ir[Ar] === null ? new Zt("The " + Fr + " `" + Dr + "` is marked as required " + ("in `" + Mr + "`, but its value is `null`.")) : new Zt("The " + Fr + " `" + Dr + "` is marked as required in " + ("`" + Mr + "`, but its value is `undefined`.")) : null : dr(Ir, Ar, Mr, Fr, Dr);
      }
      var xr = Pr.bind(null, !1);
      return xr.isRequired = Pr.bind(null, !0), xr;
    }
    function Jt(dr) {
      function br(Cr, Pr, xr, kr, Ir, Ar) {
        var Mr = Cr[Pr], Fr = _r(Mr);
        if (Fr !== dr) {
          var Dr = yr(Mr);
          return new Zt(
            "Invalid " + kr + " `" + Ir + "` of type " + ("`" + Dr + "` supplied to `" + xr + "`, expected ") + ("`" + dr + "`."),
            { expectedType: dr }
          );
        }
        return null;
      }
      return Yt(br);
    }
    function er() {
      return Yt(Vt);
    }
    function tr(dr) {
      function br(Cr, Pr, xr, kr, Ir) {
        if (typeof dr != "function")
          return new Zt("Property `" + Ir + "` of component `" + xr + "` has invalid PropType notation inside arrayOf.");
        var Ar = Cr[Pr];
        if (!Array.isArray(Ar)) {
          var Mr = _r(Ar);
          return new Zt("Invalid " + kr + " `" + Ir + "` of type " + ("`" + Mr + "` supplied to `" + xr + "`, expected an array."));
        }
        for (var Fr = 0; Fr < Ar.length; Fr++) {
          var Dr = dr(Ar, Fr, xr, kr, Ir + "[" + Fr + "]", Pt);
          if (Dr instanceof Error)
            return Dr;
        }
        return null;
      }
      return Yt(br);
    }
    function nr() {
      function dr(br, Cr, Pr, xr, kr) {
        var Ir = br[Cr];
        if (!zt(Ir)) {
          var Ar = _r(Ir);
          return new Zt("Invalid " + xr + " `" + kr + "` of type " + ("`" + Ar + "` supplied to `" + Pr + "`, expected a single ReactElement."));
        }
        return null;
      }
      return Yt(dr);
    }
    function rr() {
      function dr(br, Cr, Pr, xr, kr) {
        var Ir = br[Cr];
        if (!_t.isValidElementType(Ir)) {
          var Ar = _r(Ir);
          return new Zt("Invalid " + xr + " `" + kr + "` of type " + ("`" + Ar + "` supplied to `" + Pr + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return Yt(dr);
    }
    function ir(dr) {
      function br(Cr, Pr, xr, kr, Ir) {
        if (!(Cr[Pr] instanceof dr)) {
          var Ar = dr.name || Kt, Mr = vr(Cr[Pr]);
          return new Zt("Invalid " + kr + " `" + Ir + "` of type " + ("`" + Mr + "` supplied to `" + xr + "`, expected ") + ("instance of `" + Ar + "`."));
        }
        return null;
      }
      return Yt(br);
    }
    function ar(dr) {
      if (!Array.isArray(dr))
        return browser$1.env.NODE_ENV !== "production" && (arguments.length > 1 ? Bt(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : Bt("Invalid argument supplied to oneOf, expected an array.")), Vt;
      function br(Cr, Pr, xr, kr, Ir) {
        for (var Ar = Cr[Pr], Mr = 0; Mr < dr.length; Mr++)
          if (Xt(Ar, dr[Mr]))
            return null;
        var Fr = JSON.stringify(dr, function(zr, Tr) {
          var Gr = yr(Tr);
          return Gr === "symbol" ? String(Tr) : Tr;
        });
        return new Zt("Invalid " + kr + " `" + Ir + "` of value `" + String(Ar) + "` " + ("supplied to `" + xr + "`, expected one of " + Fr + "."));
      }
      return Yt(br);
    }
    function or(dr) {
      function br(Cr, Pr, xr, kr, Ir) {
        if (typeof dr != "function")
          return new Zt("Property `" + Ir + "` of component `" + xr + "` has invalid PropType notation inside objectOf.");
        var Ar = Cr[Pr], Mr = _r(Ar);
        if (Mr !== "object")
          return new Zt("Invalid " + kr + " `" + Ir + "` of type " + ("`" + Mr + "` supplied to `" + xr + "`, expected an object."));
        for (var Fr in Ar)
          if ($t(Ar, Fr)) {
            var Dr = dr(Ar, Fr, xr, kr, Ir + "." + Fr, Pt);
            if (Dr instanceof Error)
              return Dr;
          }
        return null;
      }
      return Yt(br);
    }
    function sr(dr) {
      if (!Array.isArray(dr))
        return browser$1.env.NODE_ENV !== "production" && Bt("Invalid argument supplied to oneOfType, expected an instance of array."), Vt;
      for (var br = 0; br < dr.length; br++) {
        var Cr = dr[br];
        if (typeof Cr != "function")
          return Bt(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ur(Cr) + " at index " + br + "."
          ), Vt;
      }
      function Pr(xr, kr, Ir, Ar, Mr) {
        for (var Fr = [], Dr = 0; Dr < dr.length; Dr++) {
          var zr = dr[Dr], Tr = zr(xr, kr, Ir, Ar, Mr, Pt);
          if (Tr == null)
            return null;
          Tr.data && $t(Tr.data, "expectedType") && Fr.push(Tr.data.expectedType);
        }
        var Gr = Fr.length > 0 ? ", expected one of type [" + Fr.join(", ") + "]" : "";
        return new Zt("Invalid " + Ar + " `" + Mr + "` supplied to " + ("`" + Ir + "`" + Gr + "."));
      }
      return Yt(Pr);
    }
    function lr() {
      function dr(br, Cr, Pr, xr, kr) {
        return mr(br[Cr]) ? null : new Zt("Invalid " + xr + " `" + kr + "` supplied to " + ("`" + Pr + "`, expected a ReactNode."));
      }
      return Yt(dr);
    }
    function cr(dr, br, Cr, Pr, xr) {
      return new Zt(
        (dr || "React class") + ": " + br + " type `" + Cr + "." + Pr + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + xr + "`."
      );
    }
    function hr(dr) {
      function br(Cr, Pr, xr, kr, Ir) {
        var Ar = Cr[Pr], Mr = _r(Ar);
        if (Mr !== "object")
          return new Zt("Invalid " + kr + " `" + Ir + "` of type `" + Mr + "` " + ("supplied to `" + xr + "`, expected `object`."));
        for (var Fr in dr) {
          var Dr = dr[Fr];
          if (typeof Dr != "function")
            return cr(xr, kr, Ir, Fr, yr(Dr));
          var zr = Dr(Ar, Fr, xr, kr, Ir + "." + Fr, Pt);
          if (zr)
            return zr;
        }
        return null;
      }
      return Yt(br);
    }
    function pr(dr) {
      function br(Cr, Pr, xr, kr, Ir) {
        var Ar = Cr[Pr], Mr = _r(Ar);
        if (Mr !== "object")
          return new Zt("Invalid " + kr + " `" + Ir + "` of type `" + Mr + "` " + ("supplied to `" + xr + "`, expected `object`."));
        var Fr = Et({}, Cr[Pr], dr);
        for (var Dr in Fr) {
          var zr = dr[Dr];
          if ($t(dr, Dr) && typeof zr != "function")
            return cr(xr, kr, Ir, Dr, yr(zr));
          if (!zr)
            return new Zt(
              "Invalid " + kr + " `" + Ir + "` key `" + Dr + "` supplied to `" + xr + "`.\nBad object: " + JSON.stringify(Cr[Pr], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(dr), null, "  ")
            );
          var Tr = zr(Ar, Dr, xr, kr, Ir + "." + Dr, Pt);
          if (Tr)
            return Tr;
        }
        return null;
      }
      return Yt(br);
    }
    function mr(dr) {
      switch (typeof dr) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !dr;
        case "object":
          if (Array.isArray(dr))
            return dr.every(mr);
          if (dr === null || zt(dr))
            return !0;
          var br = qt(dr);
          if (br) {
            var Cr = br.call(dr), Pr;
            if (br !== dr.entries) {
              for (; !(Pr = Cr.next()).done; )
                if (!mr(Pr.value))
                  return !1;
            } else
              for (; !(Pr = Cr.next()).done; ) {
                var xr = Pr.value;
                if (xr && !mr(xr[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function Er(dr, br) {
      return dr === "symbol" ? !0 : br ? br["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && br instanceof Symbol : !1;
    }
    function _r(dr) {
      var br = typeof dr;
      return Array.isArray(dr) ? "array" : dr instanceof RegExp ? "object" : Er(br, dr) ? "symbol" : br;
    }
    function yr(dr) {
      if (typeof dr > "u" || dr === null)
        return "" + dr;
      var br = _r(dr);
      if (br === "object") {
        if (dr instanceof Date)
          return "date";
        if (dr instanceof RegExp)
          return "regexp";
      }
      return br;
    }
    function ur(dr) {
      var br = yr(dr);
      switch (br) {
        case "array":
        case "object":
          return "an " + br;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + br;
        default:
          return br;
      }
    }
    function vr(dr) {
      return !dr.constructor || !dr.constructor.name ? Kt : dr.constructor.name;
    }
    return Qt.checkPropTypes = Mt, Qt.resetWarningCache = Mt.resetWarningCache, Qt.PropTypes = Qt, Qt;
  }, factoryWithTypeCheckers;
}
var factoryWithThrowingShims, hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims)
    return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var _t = requireReactPropTypesSecret();
  function Et() {
  }
  function Pt() {
  }
  return Pt.resetWarningCache = Et, factoryWithThrowingShims = function() {
    function $t(Vt, zt, Ht, Wt, Gt, qt) {
      if (qt !== _t) {
        var Kt = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw Kt.name = "Invariant Violation", Kt;
      }
    }
    $t.isRequired = $t;
    function Mt() {
      return $t;
    }
    var Bt = {
      array: $t,
      bigint: $t,
      bool: $t,
      func: $t,
      number: $t,
      object: $t,
      string: $t,
      symbol: $t,
      any: $t,
      arrayOf: Mt,
      element: $t,
      elementType: $t,
      instanceOf: Mt,
      node: $t,
      objectOf: Mt,
      oneOf: Mt,
      oneOfType: Mt,
      shape: Mt,
      exact: Mt,
      checkPropTypes: Pt,
      resetWarningCache: Et
    };
    return Bt.PropTypes = Bt, Bt;
  }, factoryWithThrowingShims;
}
if (browser$1.env.NODE_ENV !== "production") {
  var ReactIs = requireReactIs(), throwOnDirectAccess = !0;
  propTypes$2.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else
  propTypes$2.exports = requireFactoryWithThrowingShims()();
var propTypesExports = propTypes$2.exports, ErrorCorrectLevel = {
  L: 1,
  M: 0,
  Q: 3,
  H: 2
}, mode$1 = {
  MODE_NUMBER: 1,
  MODE_ALPHA_NUM: 2,
  MODE_8BIT_BYTE: 4,
  MODE_KANJI: 8
}, mode = mode$1;
function QR8bitByte(_t) {
  this.mode = mode.MODE_8BIT_BYTE, this.data = _t;
}
QR8bitByte.prototype = {
  getLength: function(_t) {
    return this.data.length;
  },
  write: function(_t) {
    for (var Et = 0; Et < this.data.length; Et++)
      _t.put(this.data.charCodeAt(Et), 8);
  }
};
var _8BitByte = QR8bitByte, ECL = ErrorCorrectLevel;
function QRRSBlock(_t, Et) {
  this.totalCount = _t, this.dataCount = Et;
}
QRRSBlock.RS_BLOCK_TABLE = [
  // L
  // M
  // Q
  // H
  // 1
  [1, 26, 19],
  [1, 26, 16],
  [1, 26, 13],
  [1, 26, 9],
  // 2
  [1, 44, 34],
  [1, 44, 28],
  [1, 44, 22],
  [1, 44, 16],
  // 3
  [1, 70, 55],
  [1, 70, 44],
  [2, 35, 17],
  [2, 35, 13],
  // 4		
  [1, 100, 80],
  [2, 50, 32],
  [2, 50, 24],
  [4, 25, 9],
  // 5
  [1, 134, 108],
  [2, 67, 43],
  [2, 33, 15, 2, 34, 16],
  [2, 33, 11, 2, 34, 12],
  // 6
  [2, 86, 68],
  [4, 43, 27],
  [4, 43, 19],
  [4, 43, 15],
  // 7		
  [2, 98, 78],
  [4, 49, 31],
  [2, 32, 14, 4, 33, 15],
  [4, 39, 13, 1, 40, 14],
  // 8
  [2, 121, 97],
  [2, 60, 38, 2, 61, 39],
  [4, 40, 18, 2, 41, 19],
  [4, 40, 14, 2, 41, 15],
  // 9
  [2, 146, 116],
  [3, 58, 36, 2, 59, 37],
  [4, 36, 16, 4, 37, 17],
  [4, 36, 12, 4, 37, 13],
  // 10		
  [2, 86, 68, 2, 87, 69],
  [4, 69, 43, 1, 70, 44],
  [6, 43, 19, 2, 44, 20],
  [6, 43, 15, 2, 44, 16],
  // 11
  [4, 101, 81],
  [1, 80, 50, 4, 81, 51],
  [4, 50, 22, 4, 51, 23],
  [3, 36, 12, 8, 37, 13],
  // 12
  [2, 116, 92, 2, 117, 93],
  [6, 58, 36, 2, 59, 37],
  [4, 46, 20, 6, 47, 21],
  [7, 42, 14, 4, 43, 15],
  // 13
  [4, 133, 107],
  [8, 59, 37, 1, 60, 38],
  [8, 44, 20, 4, 45, 21],
  [12, 33, 11, 4, 34, 12],
  // 14
  [3, 145, 115, 1, 146, 116],
  [4, 64, 40, 5, 65, 41],
  [11, 36, 16, 5, 37, 17],
  [11, 36, 12, 5, 37, 13],
  // 15
  [5, 109, 87, 1, 110, 88],
  [5, 65, 41, 5, 66, 42],
  [5, 54, 24, 7, 55, 25],
  [11, 36, 12],
  // 16
  [5, 122, 98, 1, 123, 99],
  [7, 73, 45, 3, 74, 46],
  [15, 43, 19, 2, 44, 20],
  [3, 45, 15, 13, 46, 16],
  // 17
  [1, 135, 107, 5, 136, 108],
  [10, 74, 46, 1, 75, 47],
  [1, 50, 22, 15, 51, 23],
  [2, 42, 14, 17, 43, 15],
  // 18
  [5, 150, 120, 1, 151, 121],
  [9, 69, 43, 4, 70, 44],
  [17, 50, 22, 1, 51, 23],
  [2, 42, 14, 19, 43, 15],
  // 19
  [3, 141, 113, 4, 142, 114],
  [3, 70, 44, 11, 71, 45],
  [17, 47, 21, 4, 48, 22],
  [9, 39, 13, 16, 40, 14],
  // 20
  [3, 135, 107, 5, 136, 108],
  [3, 67, 41, 13, 68, 42],
  [15, 54, 24, 5, 55, 25],
  [15, 43, 15, 10, 44, 16],
  // 21
  [4, 144, 116, 4, 145, 117],
  [17, 68, 42],
  [17, 50, 22, 6, 51, 23],
  [19, 46, 16, 6, 47, 17],
  // 22
  [2, 139, 111, 7, 140, 112],
  [17, 74, 46],
  [7, 54, 24, 16, 55, 25],
  [34, 37, 13],
  // 23
  [4, 151, 121, 5, 152, 122],
  [4, 75, 47, 14, 76, 48],
  [11, 54, 24, 14, 55, 25],
  [16, 45, 15, 14, 46, 16],
  // 24
  [6, 147, 117, 4, 148, 118],
  [6, 73, 45, 14, 74, 46],
  [11, 54, 24, 16, 55, 25],
  [30, 46, 16, 2, 47, 17],
  // 25
  [8, 132, 106, 4, 133, 107],
  [8, 75, 47, 13, 76, 48],
  [7, 54, 24, 22, 55, 25],
  [22, 45, 15, 13, 46, 16],
  // 26
  [10, 142, 114, 2, 143, 115],
  [19, 74, 46, 4, 75, 47],
  [28, 50, 22, 6, 51, 23],
  [33, 46, 16, 4, 47, 17],
  // 27
  [8, 152, 122, 4, 153, 123],
  [22, 73, 45, 3, 74, 46],
  [8, 53, 23, 26, 54, 24],
  [12, 45, 15, 28, 46, 16],
  // 28
  [3, 147, 117, 10, 148, 118],
  [3, 73, 45, 23, 74, 46],
  [4, 54, 24, 31, 55, 25],
  [11, 45, 15, 31, 46, 16],
  // 29
  [7, 146, 116, 7, 147, 117],
  [21, 73, 45, 7, 74, 46],
  [1, 53, 23, 37, 54, 24],
  [19, 45, 15, 26, 46, 16],
  // 30
  [5, 145, 115, 10, 146, 116],
  [19, 75, 47, 10, 76, 48],
  [15, 54, 24, 25, 55, 25],
  [23, 45, 15, 25, 46, 16],
  // 31
  [13, 145, 115, 3, 146, 116],
  [2, 74, 46, 29, 75, 47],
  [42, 54, 24, 1, 55, 25],
  [23, 45, 15, 28, 46, 16],
  // 32
  [17, 145, 115],
  [10, 74, 46, 23, 75, 47],
  [10, 54, 24, 35, 55, 25],
  [19, 45, 15, 35, 46, 16],
  // 33
  [17, 145, 115, 1, 146, 116],
  [14, 74, 46, 21, 75, 47],
  [29, 54, 24, 19, 55, 25],
  [11, 45, 15, 46, 46, 16],
  // 34
  [13, 145, 115, 6, 146, 116],
  [14, 74, 46, 23, 75, 47],
  [44, 54, 24, 7, 55, 25],
  [59, 46, 16, 1, 47, 17],
  // 35
  [12, 151, 121, 7, 152, 122],
  [12, 75, 47, 26, 76, 48],
  [39, 54, 24, 14, 55, 25],
  [22, 45, 15, 41, 46, 16],
  // 36
  [6, 151, 121, 14, 152, 122],
  [6, 75, 47, 34, 76, 48],
  [46, 54, 24, 10, 55, 25],
  [2, 45, 15, 64, 46, 16],
  // 37
  [17, 152, 122, 4, 153, 123],
  [29, 74, 46, 14, 75, 47],
  [49, 54, 24, 10, 55, 25],
  [24, 45, 15, 46, 46, 16],
  // 38
  [4, 152, 122, 18, 153, 123],
  [13, 74, 46, 32, 75, 47],
  [48, 54, 24, 14, 55, 25],
  [42, 45, 15, 32, 46, 16],
  // 39
  [20, 147, 117, 4, 148, 118],
  [40, 75, 47, 7, 76, 48],
  [43, 54, 24, 22, 55, 25],
  [10, 45, 15, 67, 46, 16],
  // 40
  [19, 148, 118, 6, 149, 119],
  [18, 75, 47, 31, 76, 48],
  [34, 54, 24, 34, 55, 25],
  [20, 45, 15, 61, 46, 16]
];
QRRSBlock.getRSBlocks = function(_t, Et) {
  var Pt = QRRSBlock.getRsBlockTable(_t, Et);
  if (Pt == null)
    throw new Error("bad rs block @ typeNumber:" + _t + "/errorCorrectLevel:" + Et);
  for (var $t = Pt.length / 3, Mt = new Array(), Bt = 0; Bt < $t; Bt++)
    for (var Vt = Pt[Bt * 3 + 0], zt = Pt[Bt * 3 + 1], Ht = Pt[Bt * 3 + 2], Wt = 0; Wt < Vt; Wt++)
      Mt.push(new QRRSBlock(zt, Ht));
  return Mt;
};
QRRSBlock.getRsBlockTable = function(_t, Et) {
  switch (Et) {
    case ECL.L:
      return QRRSBlock.RS_BLOCK_TABLE[(_t - 1) * 4 + 0];
    case ECL.M:
      return QRRSBlock.RS_BLOCK_TABLE[(_t - 1) * 4 + 1];
    case ECL.Q:
      return QRRSBlock.RS_BLOCK_TABLE[(_t - 1) * 4 + 2];
    case ECL.H:
      return QRRSBlock.RS_BLOCK_TABLE[(_t - 1) * 4 + 3];
    default:
      return;
  }
};
var RSBlock$1 = QRRSBlock;
function QRBitBuffer() {
  this.buffer = new Array(), this.length = 0;
}
QRBitBuffer.prototype = {
  get: function(_t) {
    var Et = Math.floor(_t / 8);
    return (this.buffer[Et] >>> 7 - _t % 8 & 1) == 1;
  },
  put: function(_t, Et) {
    for (var Pt = 0; Pt < Et; Pt++)
      this.putBit((_t >>> Et - Pt - 1 & 1) == 1);
  },
  getLengthInBits: function() {
    return this.length;
  },
  putBit: function(_t) {
    var Et = Math.floor(this.length / 8);
    this.buffer.length <= Et && this.buffer.push(0), _t && (this.buffer[Et] |= 128 >>> this.length % 8), this.length++;
  }
};
var BitBuffer$1 = QRBitBuffer, QRMath = {
  glog: function(_t) {
    if (_t < 1)
      throw new Error("glog(" + _t + ")");
    return QRMath.LOG_TABLE[_t];
  },
  gexp: function(_t) {
    for (; _t < 0; )
      _t += 255;
    for (; _t >= 256; )
      _t -= 255;
    return QRMath.EXP_TABLE[_t];
  },
  EXP_TABLE: new Array(256),
  LOG_TABLE: new Array(256)
};
for (var i = 0; i < 8; i++)
  QRMath.EXP_TABLE[i] = 1 << i;
for (var i = 8; i < 256; i++)
  QRMath.EXP_TABLE[i] = QRMath.EXP_TABLE[i - 4] ^ QRMath.EXP_TABLE[i - 5] ^ QRMath.EXP_TABLE[i - 6] ^ QRMath.EXP_TABLE[i - 8];
for (var i = 0; i < 255; i++)
  QRMath.LOG_TABLE[QRMath.EXP_TABLE[i]] = i;
var math$2 = QRMath, math$1 = math$2;
function QRPolynomial(_t, Et) {
  if (_t.length == null)
    throw new Error(_t.length + "/" + Et);
  for (var Pt = 0; Pt < _t.length && _t[Pt] == 0; )
    Pt++;
  this.num = new Array(_t.length - Pt + Et);
  for (var $t = 0; $t < _t.length - Pt; $t++)
    this.num[$t] = _t[$t + Pt];
}
QRPolynomial.prototype = {
  get: function(_t) {
    return this.num[_t];
  },
  getLength: function() {
    return this.num.length;
  },
  multiply: function(_t) {
    for (var Et = new Array(this.getLength() + _t.getLength() - 1), Pt = 0; Pt < this.getLength(); Pt++)
      for (var $t = 0; $t < _t.getLength(); $t++)
        Et[Pt + $t] ^= math$1.gexp(math$1.glog(this.get(Pt)) + math$1.glog(_t.get($t)));
    return new QRPolynomial(Et, 0);
  },
  mod: function(_t) {
    if (this.getLength() - _t.getLength() < 0)
      return this;
    for (var Et = math$1.glog(this.get(0)) - math$1.glog(_t.get(0)), Pt = new Array(this.getLength()), $t = 0; $t < this.getLength(); $t++)
      Pt[$t] = this.get($t);
    for (var $t = 0; $t < _t.getLength(); $t++)
      Pt[$t] ^= math$1.gexp(math$1.glog(_t.get($t)) + Et);
    return new QRPolynomial(Pt, 0).mod(_t);
  }
};
var Polynomial$2 = QRPolynomial, Mode = mode$1, Polynomial$1 = Polynomial$2, math = math$2, QRMaskPattern = {
  PATTERN000: 0,
  PATTERN001: 1,
  PATTERN010: 2,
  PATTERN011: 3,
  PATTERN100: 4,
  PATTERN101: 5,
  PATTERN110: 6,
  PATTERN111: 7
}, QRUtil = {
  PATTERN_POSITION_TABLE: [
    [],
    [6, 18],
    [6, 22],
    [6, 26],
    [6, 30],
    [6, 34],
    [6, 22, 38],
    [6, 24, 42],
    [6, 26, 46],
    [6, 28, 50],
    [6, 30, 54],
    [6, 32, 58],
    [6, 34, 62],
    [6, 26, 46, 66],
    [6, 26, 48, 70],
    [6, 26, 50, 74],
    [6, 30, 54, 78],
    [6, 30, 56, 82],
    [6, 30, 58, 86],
    [6, 34, 62, 90],
    [6, 28, 50, 72, 94],
    [6, 26, 50, 74, 98],
    [6, 30, 54, 78, 102],
    [6, 28, 54, 80, 106],
    [6, 32, 58, 84, 110],
    [6, 30, 58, 86, 114],
    [6, 34, 62, 90, 118],
    [6, 26, 50, 74, 98, 122],
    [6, 30, 54, 78, 102, 126],
    [6, 26, 52, 78, 104, 130],
    [6, 30, 56, 82, 108, 134],
    [6, 34, 60, 86, 112, 138],
    [6, 30, 58, 86, 114, 142],
    [6, 34, 62, 90, 118, 146],
    [6, 30, 54, 78, 102, 126, 150],
    [6, 24, 50, 76, 102, 128, 154],
    [6, 28, 54, 80, 106, 132, 158],
    [6, 32, 58, 84, 110, 136, 162],
    [6, 26, 54, 82, 110, 138, 166],
    [6, 30, 58, 86, 114, 142, 170]
  ],
  G15: 1335,
  G18: 7973,
  G15_MASK: 21522,
  getBCHTypeInfo: function(_t) {
    for (var Et = _t << 10; QRUtil.getBCHDigit(Et) - QRUtil.getBCHDigit(QRUtil.G15) >= 0; )
      Et ^= QRUtil.G15 << QRUtil.getBCHDigit(Et) - QRUtil.getBCHDigit(QRUtil.G15);
    return (_t << 10 | Et) ^ QRUtil.G15_MASK;
  },
  getBCHTypeNumber: function(_t) {
    for (var Et = _t << 12; QRUtil.getBCHDigit(Et) - QRUtil.getBCHDigit(QRUtil.G18) >= 0; )
      Et ^= QRUtil.G18 << QRUtil.getBCHDigit(Et) - QRUtil.getBCHDigit(QRUtil.G18);
    return _t << 12 | Et;
  },
  getBCHDigit: function(_t) {
    for (var Et = 0; _t != 0; )
      Et++, _t >>>= 1;
    return Et;
  },
  getPatternPosition: function(_t) {
    return QRUtil.PATTERN_POSITION_TABLE[_t - 1];
  },
  getMask: function(_t, Et, Pt) {
    switch (_t) {
      case QRMaskPattern.PATTERN000:
        return (Et + Pt) % 2 == 0;
      case QRMaskPattern.PATTERN001:
        return Et % 2 == 0;
      case QRMaskPattern.PATTERN010:
        return Pt % 3 == 0;
      case QRMaskPattern.PATTERN011:
        return (Et + Pt) % 3 == 0;
      case QRMaskPattern.PATTERN100:
        return (Math.floor(Et / 2) + Math.floor(Pt / 3)) % 2 == 0;
      case QRMaskPattern.PATTERN101:
        return Et * Pt % 2 + Et * Pt % 3 == 0;
      case QRMaskPattern.PATTERN110:
        return (Et * Pt % 2 + Et * Pt % 3) % 2 == 0;
      case QRMaskPattern.PATTERN111:
        return (Et * Pt % 3 + (Et + Pt) % 2) % 2 == 0;
      default:
        throw new Error("bad maskPattern:" + _t);
    }
  },
  getErrorCorrectPolynomial: function(_t) {
    for (var Et = new Polynomial$1([1], 0), Pt = 0; Pt < _t; Pt++)
      Et = Et.multiply(new Polynomial$1([1, math.gexp(Pt)], 0));
    return Et;
  },
  getLengthInBits: function(_t, Et) {
    if (1 <= Et && Et < 10)
      switch (_t) {
        case Mode.MODE_NUMBER:
          return 10;
        case Mode.MODE_ALPHA_NUM:
          return 9;
        case Mode.MODE_8BIT_BYTE:
          return 8;
        case Mode.MODE_KANJI:
          return 8;
        default:
          throw new Error("mode:" + _t);
      }
    else if (Et < 27)
      switch (_t) {
        case Mode.MODE_NUMBER:
          return 12;
        case Mode.MODE_ALPHA_NUM:
          return 11;
        case Mode.MODE_8BIT_BYTE:
          return 16;
        case Mode.MODE_KANJI:
          return 10;
        default:
          throw new Error("mode:" + _t);
      }
    else if (Et < 41)
      switch (_t) {
        case Mode.MODE_NUMBER:
          return 14;
        case Mode.MODE_ALPHA_NUM:
          return 13;
        case Mode.MODE_8BIT_BYTE:
          return 16;
        case Mode.MODE_KANJI:
          return 12;
        default:
          throw new Error("mode:" + _t);
      }
    else
      throw new Error("type:" + Et);
  },
  getLostPoint: function(_t) {
    for (var Et = _t.getModuleCount(), Pt = 0, $t = 0; $t < Et; $t++)
      for (var Mt = 0; Mt < Et; Mt++) {
        for (var Bt = 0, Vt = _t.isDark($t, Mt), zt = -1; zt <= 1; zt++)
          if (!($t + zt < 0 || Et <= $t + zt))
            for (var Ht = -1; Ht <= 1; Ht++)
              Mt + Ht < 0 || Et <= Mt + Ht || zt == 0 && Ht == 0 || Vt == _t.isDark($t + zt, Mt + Ht) && Bt++;
        Bt > 5 && (Pt += 3 + Bt - 5);
      }
    for (var $t = 0; $t < Et - 1; $t++)
      for (var Mt = 0; Mt < Et - 1; Mt++) {
        var Wt = 0;
        _t.isDark($t, Mt) && Wt++, _t.isDark($t + 1, Mt) && Wt++, _t.isDark($t, Mt + 1) && Wt++, _t.isDark($t + 1, Mt + 1) && Wt++, (Wt == 0 || Wt == 4) && (Pt += 3);
      }
    for (var $t = 0; $t < Et; $t++)
      for (var Mt = 0; Mt < Et - 6; Mt++)
        _t.isDark($t, Mt) && !_t.isDark($t, Mt + 1) && _t.isDark($t, Mt + 2) && _t.isDark($t, Mt + 3) && _t.isDark($t, Mt + 4) && !_t.isDark($t, Mt + 5) && _t.isDark($t, Mt + 6) && (Pt += 40);
    for (var Mt = 0; Mt < Et; Mt++)
      for (var $t = 0; $t < Et - 6; $t++)
        _t.isDark($t, Mt) && !_t.isDark($t + 1, Mt) && _t.isDark($t + 2, Mt) && _t.isDark($t + 3, Mt) && _t.isDark($t + 4, Mt) && !_t.isDark($t + 5, Mt) && _t.isDark($t + 6, Mt) && (Pt += 40);
    for (var Gt = 0, Mt = 0; Mt < Et; Mt++)
      for (var $t = 0; $t < Et; $t++)
        _t.isDark($t, Mt) && Gt++;
    var qt = Math.abs(100 * Gt / Et / Et - 50) / 5;
    return Pt += qt * 10, Pt;
  }
}, util$1 = QRUtil, BitByte = _8BitByte, RSBlock = RSBlock$1, BitBuffer = BitBuffer$1, util = util$1, Polynomial = Polynomial$2;
function QRCode$1(_t, Et) {
  this.typeNumber = _t, this.errorCorrectLevel = Et, this.modules = null, this.moduleCount = 0, this.dataCache = null, this.dataList = [];
}
var proto$3 = QRCode$1.prototype;
proto$3.addData = function(_t) {
  var Et = new BitByte(_t);
  this.dataList.push(Et), this.dataCache = null;
};
proto$3.isDark = function(_t, Et) {
  if (_t < 0 || this.moduleCount <= _t || Et < 0 || this.moduleCount <= Et)
    throw new Error(_t + "," + Et);
  return this.modules[_t][Et];
};
proto$3.getModuleCount = function() {
  return this.moduleCount;
};
proto$3.make = function() {
  if (this.typeNumber < 1) {
    var _t = 1;
    for (_t = 1; _t < 40; _t++) {
      for (var Et = RSBlock.getRSBlocks(_t, this.errorCorrectLevel), Pt = new BitBuffer(), $t = 0, Mt = 0; Mt < Et.length; Mt++)
        $t += Et[Mt].dataCount;
      for (var Mt = 0; Mt < this.dataList.length; Mt++) {
        var Bt = this.dataList[Mt];
        Pt.put(Bt.mode, 4), Pt.put(Bt.getLength(), util.getLengthInBits(Bt.mode, _t)), Bt.write(Pt);
      }
      if (Pt.getLengthInBits() <= $t * 8)
        break;
    }
    this.typeNumber = _t;
  }
  this.makeImpl(!1, this.getBestMaskPattern());
};
proto$3.makeImpl = function(_t, Et) {
  this.moduleCount = this.typeNumber * 4 + 17, this.modules = new Array(this.moduleCount);
  for (var Pt = 0; Pt < this.moduleCount; Pt++) {
    this.modules[Pt] = new Array(this.moduleCount);
    for (var $t = 0; $t < this.moduleCount; $t++)
      this.modules[Pt][$t] = null;
  }
  this.setupPositionProbePattern(0, 0), this.setupPositionProbePattern(this.moduleCount - 7, 0), this.setupPositionProbePattern(0, this.moduleCount - 7), this.setupPositionAdjustPattern(), this.setupTimingPattern(), this.setupTypeInfo(_t, Et), this.typeNumber >= 7 && this.setupTypeNumber(_t), this.dataCache == null && (this.dataCache = QRCode$1.createData(this.typeNumber, this.errorCorrectLevel, this.dataList)), this.mapData(this.dataCache, Et);
};
proto$3.setupPositionProbePattern = function(_t, Et) {
  for (var Pt = -1; Pt <= 7; Pt++)
    if (!(_t + Pt <= -1 || this.moduleCount <= _t + Pt))
      for (var $t = -1; $t <= 7; $t++)
        Et + $t <= -1 || this.moduleCount <= Et + $t || (0 <= Pt && Pt <= 6 && ($t == 0 || $t == 6) || 0 <= $t && $t <= 6 && (Pt == 0 || Pt == 6) || 2 <= Pt && Pt <= 4 && 2 <= $t && $t <= 4 ? this.modules[_t + Pt][Et + $t] = !0 : this.modules[_t + Pt][Et + $t] = !1);
};
proto$3.getBestMaskPattern = function() {
  for (var _t = 0, Et = 0, Pt = 0; Pt < 8; Pt++) {
    this.makeImpl(!0, Pt);
    var $t = util.getLostPoint(this);
    (Pt == 0 || _t > $t) && (_t = $t, Et = Pt);
  }
  return Et;
};
proto$3.createMovieClip = function(_t, Et, Pt) {
  var $t = _t.createEmptyMovieClip(Et, Pt), Mt = 1;
  this.make();
  for (var Bt = 0; Bt < this.modules.length; Bt++)
    for (var Vt = Bt * Mt, zt = 0; zt < this.modules[Bt].length; zt++) {
      var Ht = zt * Mt, Wt = this.modules[Bt][zt];
      Wt && ($t.beginFill(0, 100), $t.moveTo(Ht, Vt), $t.lineTo(Ht + Mt, Vt), $t.lineTo(Ht + Mt, Vt + Mt), $t.lineTo(Ht, Vt + Mt), $t.endFill());
    }
  return $t;
};
proto$3.setupTimingPattern = function() {
  for (var _t = 8; _t < this.moduleCount - 8; _t++)
    this.modules[_t][6] == null && (this.modules[_t][6] = _t % 2 == 0);
  for (var Et = 8; Et < this.moduleCount - 8; Et++)
    this.modules[6][Et] == null && (this.modules[6][Et] = Et % 2 == 0);
};
proto$3.setupPositionAdjustPattern = function() {
  for (var _t = util.getPatternPosition(this.typeNumber), Et = 0; Et < _t.length; Et++)
    for (var Pt = 0; Pt < _t.length; Pt++) {
      var $t = _t[Et], Mt = _t[Pt];
      if (this.modules[$t][Mt] == null)
        for (var Bt = -2; Bt <= 2; Bt++)
          for (var Vt = -2; Vt <= 2; Vt++)
            Bt == -2 || Bt == 2 || Vt == -2 || Vt == 2 || Bt == 0 && Vt == 0 ? this.modules[$t + Bt][Mt + Vt] = !0 : this.modules[$t + Bt][Mt + Vt] = !1;
    }
};
proto$3.setupTypeNumber = function(_t) {
  for (var Et = util.getBCHTypeNumber(this.typeNumber), Pt = 0; Pt < 18; Pt++) {
    var $t = !_t && (Et >> Pt & 1) == 1;
    this.modules[Math.floor(Pt / 3)][Pt % 3 + this.moduleCount - 8 - 3] = $t;
  }
  for (var Pt = 0; Pt < 18; Pt++) {
    var $t = !_t && (Et >> Pt & 1) == 1;
    this.modules[Pt % 3 + this.moduleCount - 8 - 3][Math.floor(Pt / 3)] = $t;
  }
};
proto$3.setupTypeInfo = function(_t, Et) {
  for (var Pt = this.errorCorrectLevel << 3 | Et, $t = util.getBCHTypeInfo(Pt), Mt = 0; Mt < 15; Mt++) {
    var Bt = !_t && ($t >> Mt & 1) == 1;
    Mt < 6 ? this.modules[Mt][8] = Bt : Mt < 8 ? this.modules[Mt + 1][8] = Bt : this.modules[this.moduleCount - 15 + Mt][8] = Bt;
  }
  for (var Mt = 0; Mt < 15; Mt++) {
    var Bt = !_t && ($t >> Mt & 1) == 1;
    Mt < 8 ? this.modules[8][this.moduleCount - Mt - 1] = Bt : Mt < 9 ? this.modules[8][15 - Mt - 1 + 1] = Bt : this.modules[8][15 - Mt - 1] = Bt;
  }
  this.modules[this.moduleCount - 8][8] = !_t;
};
proto$3.mapData = function(_t, Et) {
  for (var Pt = -1, $t = this.moduleCount - 1, Mt = 7, Bt = 0, Vt = this.moduleCount - 1; Vt > 0; Vt -= 2)
    for (Vt == 6 && Vt--; ; ) {
      for (var zt = 0; zt < 2; zt++)
        if (this.modules[$t][Vt - zt] == null) {
          var Ht = !1;
          Bt < _t.length && (Ht = (_t[Bt] >>> Mt & 1) == 1);
          var Wt = util.getMask(Et, $t, Vt - zt);
          Wt && (Ht = !Ht), this.modules[$t][Vt - zt] = Ht, Mt--, Mt == -1 && (Bt++, Mt = 7);
        }
      if ($t += Pt, $t < 0 || this.moduleCount <= $t) {
        $t -= Pt, Pt = -Pt;
        break;
      }
    }
};
QRCode$1.PAD0 = 236;
QRCode$1.PAD1 = 17;
QRCode$1.createData = function(_t, Et, Pt) {
  for (var $t = RSBlock.getRSBlocks(_t, Et), Mt = new BitBuffer(), Bt = 0; Bt < Pt.length; Bt++) {
    var Vt = Pt[Bt];
    Mt.put(Vt.mode, 4), Mt.put(Vt.getLength(), util.getLengthInBits(Vt.mode, _t)), Vt.write(Mt);
  }
  for (var zt = 0, Bt = 0; Bt < $t.length; Bt++)
    zt += $t[Bt].dataCount;
  if (Mt.getLengthInBits() > zt * 8)
    throw new Error("code length overflow. (" + Mt.getLengthInBits() + ">" + zt * 8 + ")");
  for (Mt.getLengthInBits() + 4 <= zt * 8 && Mt.put(0, 4); Mt.getLengthInBits() % 8 != 0; )
    Mt.putBit(!1);
  for (; !(Mt.getLengthInBits() >= zt * 8 || (Mt.put(QRCode$1.PAD0, 8), Mt.getLengthInBits() >= zt * 8)); )
    Mt.put(QRCode$1.PAD1, 8);
  return QRCode$1.createBytes(Mt, $t);
};
QRCode$1.createBytes = function(_t, Et) {
  for (var Pt = 0, $t = 0, Mt = 0, Bt = new Array(Et.length), Vt = new Array(Et.length), zt = 0; zt < Et.length; zt++) {
    var Ht = Et[zt].dataCount, Wt = Et[zt].totalCount - Ht;
    $t = Math.max($t, Ht), Mt = Math.max(Mt, Wt), Bt[zt] = new Array(Ht);
    for (var Gt = 0; Gt < Bt[zt].length; Gt++)
      Bt[zt][Gt] = 255 & _t.buffer[Gt + Pt];
    Pt += Ht;
    var qt = util.getErrorCorrectPolynomial(Wt), Kt = new Polynomial(Bt[zt], qt.getLength() - 1), Qt = Kt.mod(qt);
    Vt[zt] = new Array(qt.getLength() - 1);
    for (var Gt = 0; Gt < Vt[zt].length; Gt++) {
      var Xt = Gt + Qt.getLength() - Vt[zt].length;
      Vt[zt][Gt] = Xt >= 0 ? Qt.get(Xt) : 0;
    }
  }
  for (var Zt = 0, Gt = 0; Gt < Et.length; Gt++)
    Zt += Et[Gt].totalCount;
  for (var Yt = new Array(Zt), Jt = 0, Gt = 0; Gt < $t; Gt++)
    for (var zt = 0; zt < Et.length; zt++)
      Gt < Bt[zt].length && (Yt[Jt++] = Bt[zt][Gt]);
  for (var Gt = 0; Gt < Mt; Gt++)
    for (var zt = 0; zt < Et.length; zt++)
      Gt < Vt[zt].length && (Yt[Jt++] = Vt[zt][Gt]);
  return Yt;
};
var QRCode_1 = QRCode$1, QRCodeSvg$1 = {};
Object.defineProperty(QRCodeSvg$1, "__esModule", {
  value: !0
});
var _extends$1 = Object.assign || function(_t) {
  for (var Et = 1; Et < arguments.length; Et++) {
    var Pt = arguments[Et];
    for (var $t in Pt)
      Object.prototype.hasOwnProperty.call(Pt, $t) && (_t[$t] = Pt[$t]);
  }
  return _t;
}, _propTypes$1 = propTypesExports, _propTypes2$1 = _interopRequireDefault$1(_propTypes$1), _react$1 = React__default, _react2$1 = _interopRequireDefault$1(_react$1);
function _interopRequireDefault$1(_t) {
  return _t && _t.__esModule ? _t : { default: _t };
}
function _objectWithoutProperties$1(_t, Et) {
  var Pt = {};
  for (var $t in _t)
    Et.indexOf($t) >= 0 || Object.prototype.hasOwnProperty.call(_t, $t) && (Pt[$t] = _t[$t]);
  return Pt;
}
var propTypes$1 = {
  bgColor: _propTypes2$1.default.oneOfType([_propTypes2$1.default.object, _propTypes2$1.default.string]).isRequired,
  bgD: _propTypes2$1.default.string.isRequired,
  fgColor: _propTypes2$1.default.oneOfType([_propTypes2$1.default.object, _propTypes2$1.default.string]).isRequired,
  fgD: _propTypes2$1.default.string.isRequired,
  size: _propTypes2$1.default.number.isRequired,
  title: _propTypes2$1.default.string,
  viewBoxSize: _propTypes2$1.default.number.isRequired,
  xmlns: _propTypes2$1.default.string
}, QRCodeSvg = (0, _react$1.forwardRef)(function(_t, Et) {
  var Pt = _t.bgColor, $t = _t.bgD, Mt = _t.fgD, Bt = _t.fgColor, Vt = _t.size, zt = _t.title, Ht = _t.viewBoxSize, Wt = _t.xmlns, Gt = Wt === void 0 ? "http://www.w3.org/2000/svg" : Wt, qt = _objectWithoutProperties$1(_t, ["bgColor", "bgD", "fgD", "fgColor", "size", "title", "viewBoxSize", "xmlns"]);
  return _react2$1.default.createElement(
    "svg",
    _extends$1({}, qt, { height: Vt, ref: Et, viewBox: "0 0 " + Ht + " " + Ht, width: Vt, xmlns: Gt }),
    zt ? _react2$1.default.createElement(
      "title",
      null,
      zt
    ) : null,
    _react2$1.default.createElement("path", { d: $t, fill: Pt }),
    _react2$1.default.createElement("path", { d: Mt, fill: Bt })
  );
});
QRCodeSvg.displayName = "QRCodeSvg";
QRCodeSvg.propTypes = propTypes$1;
QRCodeSvg$1.default = QRCodeSvg;
Object.defineProperty(lib, "__esModule", {
  value: !0
});
lib.QRCode = void 0;
var _extends = Object.assign || function(_t) {
  for (var Et = 1; Et < arguments.length; Et++) {
    var Pt = arguments[Et];
    for (var $t in Pt)
      Object.prototype.hasOwnProperty.call(Pt, $t) && (_t[$t] = Pt[$t]);
  }
  return _t;
}, _propTypes = propTypesExports, _propTypes2 = _interopRequireDefault(_propTypes), _ErrorCorrectLevel = ErrorCorrectLevel, _ErrorCorrectLevel2 = _interopRequireDefault(_ErrorCorrectLevel), _QRCode = QRCode_1, _QRCode2 = _interopRequireDefault(_QRCode), _react = React__default, _react2 = _interopRequireDefault(_react), _QRCodeSvg = QRCodeSvg$1, _QRCodeSvg2 = _interopRequireDefault(_QRCodeSvg);
function _interopRequireDefault(_t) {
  return _t && _t.__esModule ? _t : { default: _t };
}
function _objectWithoutProperties(_t, Et) {
  var Pt = {};
  for (var $t in _t)
    Et.indexOf($t) >= 0 || Object.prototype.hasOwnProperty.call(_t, $t) && (Pt[$t] = _t[$t]);
  return Pt;
}
var propTypes = {
  bgColor: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
  fgColor: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
  level: _propTypes2.default.string,
  size: _propTypes2.default.number,
  value: _propTypes2.default.string.isRequired
}, QRCode = (0, _react.forwardRef)(function(_t, Et) {
  var Pt = _t.bgColor, $t = Pt === void 0 ? "#FFFFFF" : Pt, Mt = _t.fgColor, Bt = Mt === void 0 ? "#000000" : Mt, Vt = _t.level, zt = Vt === void 0 ? "L" : Vt, Ht = _t.size, Wt = Ht === void 0 ? 256 : Ht, Gt = _t.value, qt = _objectWithoutProperties(_t, ["bgColor", "fgColor", "level", "size", "value"]), Kt = new _QRCode2.default(-1, _ErrorCorrectLevel2.default[zt]);
  Kt.addData(Gt), Kt.make();
  var Qt = Kt.modules;
  return _react2.default.createElement(_QRCodeSvg2.default, _extends({}, qt, {
    bgColor: $t,
    bgD: Qt.map(function(Xt, Zt) {
      return Xt.map(function(Yt, Jt) {
        return Yt ? "" : "M " + Jt + " " + Zt + " l 1 0 0 1 -1 0 Z";
      }).join(" ");
    }).join(" "),
    fgColor: Bt,
    fgD: Qt.map(function(Xt, Zt) {
      return Xt.map(function(Yt, Jt) {
        return Yt ? "M " + Jt + " " + Zt + " l 1 0 0 1 -1 0 Z" : "";
      }).join(" ");
    }).join(" "),
    ref: Et,
    size: Wt,
    viewBoxSize: Qt.length
  }));
});
lib.QRCode = QRCode;
QRCode.displayName = "QRCode";
QRCode.propTypes = propTypes;
var _default = lib.default = QRCode;
const fontFamily$1 = lt$1`
  * {
    font-family: 'Noto Sans', sans-serif;
  }

  * > * {
    font-family: 'Noto Sans', sans-serif;
  }
`, MainWrapper$1 = dt$1.div`
  ${fontFamily$1}
`, WithProviders = ({
  children: _t
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(MainWrapper$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ot$1, { theme: theme$1, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ConfigProvider, { prefixCls: "cw-elements", theme: {
  components: {},
  token: {
    fontFamily: "'Noto Sans', sans-serif"
  }
}, children: _t }) }) }), theme$1 = {
  colors: {
    base_dark_blue: "#00a0be",
    base_light_blue: "#00b5d8",
    base_dark_green: "#749204",
    base_light_green: "#aab400",
    base_light_green_2: "#cbcf6e",
    base_orange: "#eb8205",
    base_yellow: "#ffca41",
    base_yellow_2: "#ffd17e",
    base_red: "#d91e3f",
    base_dark_grey: "#c1c5c8",
    base_light_grey: "#f2f4f6",
    base_white: "#ffffff",
    base_black: "#2f3031",
    base_purple_heart: "#882d8e",
    base_iris: "#4b57d1",
    base_dark_orchid: "#ac38c0",
    base_field_drab: "#7b5d21",
    base_flame: "#df4c29",
    base_steel_blue: "#3c7ea1",
    base_dark_tan: "#977c42",
    base_deep_carrot_orange: "#dc7237",
    base_bleu_de_france: "#4396ef",
    base_old_rose: "#cb7b80",
    base_cadet_blue: "#53a491",
    base_cornflower_blue: "#6f93e3",
    base_persian_pink: "#e977b3",
    base_brass: "#bba536",
    base_olivine: "#9eaa75",
    base_tiger_eye: "#e89d3c",
    base_mantis: "#73c461",
    base_apple_green: "#a3bc10",
    base_sky_blue: "#81bddb",
    base_bright_ube: "#c2a5f5",
    base_medium_turquoise: "#69d5d1",
    base_june_bud: "#b9d950",
    base_light_green_3: "#7dea99",
    base_straw: "#e3d66d",
    base_medium_spring_bud: "#d7dd9d",
    base_gainsboro: "#d9e3e4",
    cws_blue_10: "#EAF6FF",
    cws_blue_20: "#C6E6FF",
    cws_blue_30: "#82CFFF",
    cws_blue_40: "#31B4F2",
    cws_blue_50: "#0092E4",
    cws_blue_60: "#0071CD",
    cws_blue_70: "#005693",
    cws_blue_80: "#003B69",
    cws_blue_90: "#002747",
    cws_blue_100: "#00172D",
    cws_green_10: "#DFFBE8",
    cws_green_20: "#C3EAD1",
    cws_green_30: "#90D6AA",
    cws_green_40: "#5EBB7F",
    cws_green_50: "#19A04B",
    cws_green_60: "#14803C",
    cws_green_70: "#0C612C",
    cws_green_80: "#06431C",
    cws_green_90: "#032D10",
    cws_green_100: "#011B07",
    cws_red_10: "#FFF1F1",
    cws_red_20: "#FFD9D9",
    cws_red_30: "#FFB3B3",
    cws_red_40: "#F98989",
    cws_red_50: "#EB4B4B",
    cws_red_60: "#CF3537",
    cws_red_70: "#9C2628",
    cws_red_80: "#70191A",
    cws_red_90: "#4C0E0F",
    cws_red_100: "#300606",
    cws_orange_10: "#FFF1ED",
    cws_orange_20: "#FFDACE",
    cws_orange_30: "#FFB59D",
    cws_orange_40: "#FF785A",
    cws_orange_50: "#EE5B3A",
    cws_orange_60: "#C1462B",
    cws_orange_70: "#92331E",
    cws_orange_80: "#682213",
    cws_orange_90: "#48150A",
    cws_orange_100: "#2D0A04",
    cws_yellow_10: "#FFF3DD",
    cws_yellow_20: "#FFE4AE",
    cws_yellow_30: "#F0C355",
    cws_yellow_40: "#E99921",
    cws_yellow_50: "#C17E19",
    cws_yellow_60: "#9A6412",
    cws_yellow_70: "#744A0B",
    cws_yellow_80: "#523305",
    cws_yellow_90: "#372102",
    cws_yellow_100: "#221201",
    cws_teal_10: "#E0F9F7",
    cws_teal_20: "#A9EFE8",
    cws_teal_30: "#5FD2C8",
    cws_teal_40: "#46BBB0",
    cws_teal_50: "#2B9C92",
    cws_teal_60: "#217C74",
    cws_teal_70: "#165C56",
    cws_teal_80: "#0D413C",
    cws_teal_90: "#062B27",
    cws_teal_100: "#021917",
    cws_purple_10: "#F6F2FE",
    cws_purple_20: "#E7DDFC",
    cws_purple_30: "#D2BDF9",
    cws_purple_40: "#BA99F6",
    cws_purple_50: "#9664F0",
    cws_purple_60: "#8354D6",
    cws_purple_70: "#643AAA",
    cws_purple_80: "#462779",
    cws_purple_90: "#2E1954",
    cws_purple_100: "#1C0D35",
    cws_pink_10: "#FFF1F3",
    cws_pink_20: "#FFD8DF",
    cws_pink_30: "#FFB2C1",
    cws_pink_40: "#FF7D96",
    cws_pink_50: "#E85D78",
    cws_pink_60: "#BB485D",
    cws_pink_70: "#8D3545",
    cws_pink_80: "#65232F",
    cws_pink_90: "#45161E",
    cws_pink_100: "#2B0A10",
    cws_neutral_00: "#FFFFFF",
    cws_neutral_10: "#F3F4F6",
    cws_neutral_20: "#DFE2E7",
    cws_neutral_30: "#C2C7D0",
    cws_neutral_40: "#A3A9B9",
    cws_neutral_50: "#868CA2",
    cws_neutral_60: "#696F88",
    cws_neutral_70: "#4D5165",
    cws_neutral_80: "#363948",
    cws_neutral_90: "#232630",
    cws_neutral_100: "#14151C"
  }
}, AppCardContent = dt$1.div`
  border-radius: 8px;
  min-height: 125px;
  display: flex;
  flex-direction: column;

  ${({
  $darkMode: _t
}) => _t === !1 ? lt$1`
        background-color: ${(Et) => Et.theme.colors.cws_neutral_00};
      ` : lt$1`
        background-color: ${(Et) => Et.theme.colors.cws_neutral_80};
      `}

  @media screen and (max-width: 1600px) {
    min-height: 100px;
  }
`, AppCardBg = dt$1.div`
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  height: 60px;
  border-radius: 8px 8px 0 0;

  ${({
  $darkMode: _t
}) => _t === !1 ? lt$1`
        background-color: ${(Et) => Et.theme.colors.cws_neutral_00};
      ` : lt$1`
        background-color: ${(Et) => Et.theme.colors.cws_neutral_80};
      `}

  @media screen and (max-width: 1600px) {
    height: 48px;
  }
`, AppCardName = dt$1.div`
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 300ms ease-in-out;
  border-radius: 0 0 8px 8px;
  padding: 16px;
  flex: 1;

  ${({
  $darkMode: _t
}) => _t === !1 ? lt$1`
        background-color: ${(Et) => Et.theme.colors.cws_neutral_00};
        color: ${(Et) => Et.theme.colors.cws_neutral_70};
      ` : lt$1`
        background-color: ${(Et) => Et.theme.colors.cws_neutral_80};
        color: ${(Et) => Et.theme.colors.cws_neutral_00};
      `}
`, AppCardLogo = dt$1.div`
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  border-width: 2px;
  border-style: solid;
  border-color: ${(_t) => _t.theme.colors.cws_neutral_80};
  transition: border-color 300ms ease-in-out;
  position: absolute;
  top: 15px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #00004b;

  img {
    width: 46px;
  }

  svg {
    width: 46px;
    height: 46px;
  }

  @media screen and (max-width: 1600px) {
    height: 48px;
    width: 48px;
    top: 10px;

    img {
      width: 40px;
    }

    svg {
      width: 40px;
      height: 40px;
    }
  }
`, AppCardLogoModal = dt$1.div`
  img {
    width: 58px;
    height: 58px;
  }

  svg {
    width: 58px;
    height: 58px;
  }
`, PhoneCardLogo = dt$1.div`
  position: absolute;
  top: 36px;
  left: 50%;
  width: 48px;
  z-index: 1 !important;
`, AppCardWrapper = dt$1.base`
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  transition:
    transform 300ms ease-in-out,
    background-color 300ms ease-in-out;
  position: relative;
  display: inline-block;
  width: 210px;
  min-height: 125px;
  border-radius: 16px;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 1 !important;

  ${({
  $darkMode: _t
}) => {
  if (_t !== !1)
    return lt$1`
        &:hover {
          transform: scale(1.05);
          background-color: ${(Et) => Et.theme.colors.cws_neutral_70};
          color: ${(Et) => Et.theme.colors.cws_neutral_00};

          ${AppCardName} {
            background-color: ${(Et) => Et.theme.colors.cws_neutral_70};
            color: ${(Et) => Et.theme.colors.cws_neutral_00};
          }
        }
      `;
}}

  @media screen and (max-width: 1600px) {
    width: 168px;
    min-height: 100px;
  }
`, StyledModalAppCard = dt$1(Modal)`
  .cw-elements-modal-content {
    padding: 0px;
    width: 889px;
    z-index: 99999 !important;

    ${({
  $darkMode: _t
}) => _t === !1 ? lt$1`
          background-color: ${(Et) => Et.theme.colors.cws_neutral_00} !important;
          color: ${(Et) => Et.theme.colors.cws_neutral_80} !important;
        ` : lt$1`
          background-color: ${(Et) => Et.theme.colors.cws_neutral_80} !important;
          color: ${(Et) => Et.theme.colors.cws_neutral_20} !important;
        `}
  }

  .cw-elements-modal-body {
    padding: 0px;
    text-align: left;

    div.header {
      padding: 16px 16px 16px 24px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      border-bottom: 1px solid #4d5165;

      ${({
  $darkMode: _t
}) => {
  if (_t === !1)
    return lt$1`
            border-bottom: 1px solid ${(Et) => Et.theme.colors.cws_neutral_20};
          `;
}}

      div.title {
        /* Semibold / 16px | 24px */
        font-family: 'Noto Sans', sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px; /* 150% */
        letter-spacing: -0.12px;
      }

      div.close {
        margin-right: 3px;
        cursor: pointer;
      }
    }

    div.body {
      display: flex;
      flex-direction: row;

      div.leftContainer {
        width: 50%;
        border-right: 1px solid #4d5165;

        ${({
  $darkMode: _t
}) => {
  if (_t === !1)
    return lt$1`
              border-right: 1px solid ${(Et) => Et.theme.colors.cws_neutral_20};
            `;
}}

        div.logo {
          padding: 24px 16px 0px 24px;
          display: flex;

          div.name {
            margin-top: 10px;
          }
        }

        div.content {
          padding: 12px 16px 24px 24px;
        }
      }

      div.right {
        width: 50%;

        .tabContainer {
          margin-top: 80px;
          margin-bottom: 10px;
        }
      }
    }
  }
`, StyledTabsAppCard = dt$1(Tabs)`
  .cw-elements-tabs {
    margin: 10px;
  }

  .cw-elements-tabs-tab {
    ${({
  $darkMode: _t
}) => _t === !1 ? lt$1`
          color: ${(Et) => Et.theme.colors.cws_neutral_80} !important;
        ` : lt$1`
          color: ${(Et) => Et.theme.colors.cws_neutral_20} !important;
        `}
  }

  .cw-elements-tabs-nav::before {
    border-bottom: 1px solid #4d5165;

    ${({
  $darkMode: _t
}) => {
  if (_t === !1)
    return lt$1`
          border-bottom: 1px solid ${(Et) => Et.theme.colors.cws_neutral_20};
        `;
}}
  }

  .cw-elements-tabs-nav-wrap {
    margin-left: 25px;
  }

  .cw-elements-tabs-nav-list {
    width: 400px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
  }

  .cw-elements-tabs-tab {
    width: 150px;
    justify-content: center;
  }

  .cw-elements-tabs-tab-active {
    width: 150px;
    justify-content: center;
    border-bottom: solid 1px #fff;

    ${({
  $darkMode: _t
}) => {
  if (_t === !1)
    return lt$1`
          border-bottom: 1px solid ${(Et) => Et.theme.colors.cws_neutral_80};
        `;
}}
  }
`, StyledTooltip = dt$1(Tooltip)``, StyledTabContent = dt$1.div`
  display: flex;
  flex-direction: row;
  margin-left: 15px;

  .content_container {
    margin-left: 20px;
    margin-top: 25px;
    width: 200px;
    height: 225px;
  }

  .qrcode_container {
    width: 180px;
    height: 180px;
    border-radius: 8px;
    background-color: #fff;
  }

  ${({
  $darkMode: _t
}) => _t === !1 ? lt$1`
        color: ${(Et) => Et.theme.colors.cws_neutral_80} !important;
      ` : lt$1`
        color: ${(Et) => Et.theme.colors.cws_neutral_20} !important;
      `}
`, StyledButton = dt$1(Button)`
  width: 205px;
  height: 40px;
  margin-top: 10px;

  ${({
  $darkMode: _t
}) => _t === !1 ? lt$1`
        color: ${(Et) => Et.theme.colors.cws_neutral_80} !important;
        border: 1px solid ${(Et) => Et.theme.colors.cws_neutral_30} !important;
      ` : lt$1`
        color: ${(Et) => Et.theme.colors.cws_neutral_20} !important;
        border: 1px solid ${(Et) => Et.theme.colors.cws_neutral_20} !important;
      `}
`, StyledOkButton = dt$1(Button)`
  background-color: var(--green-green-60, #14803c) !important;
  width: 52px;
  height: 40px;
  margin-top: 10px;
  margin-bottom: 25px;
  color: #fff !important;
`, AppCardContainer = dt$1.div`
  width: 210px;

  @media screen and (max-width: 1600px) {
    width: 168px;
  }
`, StyledModalCopied = dt$1.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -25px;
  right: -200px;
  width: 149px;
  height: 48px;
  border-radius: 4px;

  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.15);

  ${({
  $darkMode: _t
}) => _t === !1 ? lt$1`
        background-color: ${(Et) => Et.theme.colors.cws_neutral_00} !important;
        color: ${(Et) => Et.theme.colors.cws_neutral_80} !important;
      ` : lt$1`
        background-color: ${(Et) => Et.theme.colors.cws_neutral_80} !important;
        color: ${(Et) => Et.theme.colors.cws_neutral_20} !important;
      `}
`, AddDivNameContainer = dt$1.div`
  display: flex;
  flex-direction: row;
  text-align: center;
  font-family: 'Noto Sans';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  letter-spacing: -0.105px;
`, AppDivMobile = dt$1.div`
  margin-left: 5px;

  ${({
  $darkMode: _t
}) => _t === !1 ? lt$1`
        color: ${(Et) => Et.theme.colors.cws_neutral_60} !important;
      ` : lt$1`
        color: ${(Et) => Et.theme.colors.cws_neutral_40} !important;
      `}
`, LogoMobileContainer = dt$1.div`
  .logoContainer {
    .logoChildren {
      height: 48px;
      width: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 10px;
      border-width: 2px;
      border-style: solid;
      border-color: ${(_t) => _t.theme.colors.cws_neutral_80};
      padding: 0px;
      background-color: #00004b;

      img {
        width: 42px;
        height: 42px;
      }
    }

    .phoneContainer {
      position: absolute;
      top: 108px;
      left: 58px;

      svg {
        width: 18px;
        height: 22px;
      }
    }
  }
`;
function Close() {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M14.25 4.8075L13.1925 3.75L9 7.9425L4.8075 3.75L3.75 4.8075L7.9425 9L3.75 13.1925L4.8075 14.25L9 10.0575L13.1925 14.25L14.25 13.1925L10.0575 9L14.25 4.8075Z", fill: "white" }) });
}
function CloseInvert() {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M14.25 4.8075L13.1925 3.75L9 7.9425L4.8075 3.75L3.75 4.8075L7.9425 9L3.75 13.1925L4.8075 14.25L9 10.0575L13.1925 14.25L14.25 13.1925L10.0575 9L14.25 4.8075Z", fill: "black" }) });
}
function Leaf$2() {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { width: "36", height: "36", viewBox: "0 0 200 200", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M170.521 32.1008C163.563 32.9748 143.193 35.6639 123.025 40.2353C95.6638 46.4538 70.5882 56.2353 53.4454 72.1008C42.3529 82.3529 35.0588 93.6134 31.4285 109.916C27.5966 127.227 29.8151 146.387 35.7311 167.63C42.4874 166.118 48.7395 165.748 55.4622 165.277C65.1092 164.605 77.1428 163.731 89.9159 161.546C109.042 158.252 122.319 151.563 134.319 135.361C144.807 121.244 148.134 101.445 151.126 87.3277C155.16 68.4706 159.193 55.7983 162.924 47.1597C165.244 41.916 166.857 38.0504 170.521 32.1008ZM125.613 133.815C117.815 143.361 108.706 149.647 92.7059 152.975C115.496 141.714 121.748 119.697 125.21 107.361C127.227 100.101 129.109 90.3529 131.193 81.1428C133.95 68.7395 138.252 53.5126 143.193 44.2017C147.193 43.4958 155.328 42.1849 156.538 41.9832C153.244 49.2101 148.101 61.916 142.555 89.9496C137.882 113.311 132.807 125.008 125.613 133.815ZM75.1596 65.8151C56.9411 81.7143 51.9664 96.7059 49.479 110.218C46.7227 125.378 49.2437 142.319 52.3025 156.403C48.3697 157.311 43.563 158.185 41.6134 158.588C37.5462 143.529 35.8655 126.555 39.0924 111.933C44.2353 88.7395 58.6554 75.8991 75.1596 65.8151ZM57.3109 110.857C60.4706 94.1512 69.7479 75.4958 94.7899 59.126C75.8655 78.5882 71.1596 90.7227 68.2017 105.412C65.8487 117.109 66.9243 133.008 70.084 147.798C66.9243 150.319 63.0252 152.168 59.8991 153.647C56.4033 138.689 55.2269 121.815 57.3109 110.857ZM76.8739 142.017C74.9243 130.958 73.8487 118.151 75.6302 108.336C79.2941 87.6975 91.4622 70.3529 109.748 55.7311C106.42 64.4034 103.966 75.0588 102.622 81.2437C99.6638 95.0252 97.3109 107.731 93.2437 117.882C88.5378 129.613 83.6975 135.731 76.8739 142.017ZM68.3697 156.269C83.0252 149.916 93.5126 137.815 99.6975 122.857C104.739 110.622 106.924 99.0252 109.849 85.0084C111.126 78.9244 115.025 62.1512 119.664 51.0252C122.824 49.647 128.84 47.6639 133.613 46.3865C128.773 56.9748 125.042 71.7311 122.42 83.9664C117.983 104.571 114.79 120.874 105.109 133.681C95.7311 146.017 82.4874 152.706 68.3697 156.269Z", fill: "#73DC78" }) });
}
function Phone() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: "22", height: "26", viewBox: "0 0 22 26", fill: "none", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { filter: "url(#filter0_b_7505_12583)", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "1.2002", y: "1.42578", width: "18.9", height: "23.1", rx: "4", fill: "#00004B" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.0998 6.23828H8.1998C7.18305 6.23828 6.3623 7.05903 6.3623 8.07578V17.8758C6.3623 18.8925 7.18305 19.7133 8.1998 19.7133H13.0998C14.1166 19.7133 14.9373 18.8925 14.9373 17.8758V8.07578C14.9373 7.05903 14.1166 6.23828 13.0998 6.23828ZM13.7121 16.6508H7.58713V8.07578H13.7121V16.6508ZM9.42463 18.4869H11.8746V17.8744H9.42463V18.4869Z", fill: "#73DC78" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "1.2002", y: "1.42578", width: "18.9", height: "23.1", rx: "4", stroke: "#4D5165", strokeWidth: "2" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("defs", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("filter", { id: "filter0_b_7505_12583", x: "-3.9998", y: "-3.77422", width: "29.3004", height: "33.5016", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feGaussianBlur", { in: "BackgroundImageFix", stdDeviation: "2.1" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feComposite", { in2: "SourceAlpha", operator: "in", result: "effect1_backgroundBlur_7505_12583" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_backgroundBlur_7505_12583", result: "shape" })
    ] }) })
  ] });
}
function PhoneBlue$1() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "24", viewBox: "0 0 20 24", fill: "none", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { filter: "url(#filter0_b_7701_24187)", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "1", y: "1", width: "18", height: "22", rx: "4", fill: "#00004B" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "1", y: "1", width: "18", height: "22", rx: "4", stroke: "#363948", strokeWidth: "2" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.3337 5.58203H7.66699C6.69866 5.58203 5.91699 6.3637 5.91699 7.33203V16.6654C5.91699 17.6337 6.69866 18.4154 7.66699 18.4154H12.3337C13.302 18.4154 14.0837 17.6337 14.0837 16.6654V7.33203C14.0837 6.3637 13.302 5.58203 12.3337 5.58203ZM12.917 15.4987H7.08366V7.33203H12.917V15.4987ZM8.83366 17.2487H11.167V16.6654H8.83366V17.2487Z", fill: "#73DC78" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("defs", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("filter", { id: "filter0_b_7701_24187", x: "-4", y: "-4", width: "28", height: "32", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feGaussianBlur", { in: "BackgroundImageFix", stdDeviation: "2" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feComposite", { in2: "SourceAlpha", operator: "in", result: "effect1_backgroundBlur_7701_24187" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_backgroundBlur_7701_24187", result: "shape" })
    ] }) })
  ] });
}
function PhoneBlue() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "25", viewBox: "0 0 20 25", fill: "none", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { filter: "url(#filter0_b_16576_33796)", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M1 5.47498C1 3.26584 2.79086 1.47498 5 1.47498H15C17.2091 1.47498 19 3.26584 19 5.47498V19.475C19 21.6841 17.2091 23.475 15 23.475H5C2.79086 23.475 1 21.6841 1 19.475V5.47498Z", fill: "#00004B" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M1 5.47498C1 3.26584 2.79086 1.47498 5 1.47498H15C17.2091 1.47498 19 3.26584 19 5.47498V19.475C19 21.6841 17.2091 23.475 15 23.475H5C2.79086 23.475 1 21.6841 1 19.475V5.47498Z", stroke: "white", strokeWidth: "2" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.3337 6.05835H7.66699C6.69866 6.05835 5.91699 6.84002 5.91699 7.80835V17.1417C5.91699 18.11 6.69866 18.8917 7.66699 18.8917H12.3337C13.302 18.8917 14.0837 18.11 14.0837 17.1417V7.80835C14.0837 6.84002 13.302 6.05835 12.3337 6.05835ZM12.917 15.975H7.08366V7.80835H12.917V15.975ZM8.83366 17.725H11.167V17.1417H8.83366V17.725Z", fill: "#73DC78" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("defs", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("filter", { id: "filter0_b_16576_33796", x: "-4", y: "-3.52502", width: "28", height: "32", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feGaussianBlur", { in: "BackgroundImageFix", stdDeviation: "2" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feComposite", { in2: "SourceAlpha", operator: "in", result: "effect1_backgroundBlur_16576_33796" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_backgroundBlur_16576_33796", result: "shape" })
    ] }) })
  ] });
}
function IconChecked() {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM10 14.1681L16.59 7.57812L18 8.99813L10 16.9981L6 12.9981L7.41 11.5881L10 14.1681Z", fill: "#19A04B" }) });
}
const useDefaultIcon$1 = (_t) => {
  const [Et, Pt] = useState({
    src: _t,
    error: !1
  });
  return useEffect(() => {
    Pt({
      src: _t,
      error: !1
    });
  }, [_t]), {
    imgSrc: Et,
    onImgError: () => {
      Et.error || Pt({
        src: /* @__PURE__ */ jsxRuntimeExports.jsx(Leaf$2, {}),
        error: !0
      });
    }
  };
}, AppCardCP = ({
  name: _t,
  logo: Et,
  background: Pt,
  workspaceId: $t,
  orgId: Mt,
  propertyId: Bt,
  apple_store_uri: Vt,
  play_store_uri: zt,
  darkMode: Ht,
  detailed_description: Wt,
  textAbout: Gt,
  textMobile: qt,
  textQRCode: Kt,
  textCopiedLink: Qt,
  textCopyLinkButton: Xt,
  textOkButton: Zt,
  textDiscoverAndDownloadTooltip: Yt,
  textOpenInNewTabTooltip: Jt,
  ...er
}) => {
  const {
    t: tr
  } = useTranslation(), {
    imgSrc: nr,
    onImgError: rr
  } = useDefaultIcon$1(Et), ir = (br, Cr) => br || Cr;
  Gt = Gt || tr("app_card.modal.about_text"), qt = qt || tr("app_card.modal.mobile_title"), Kt = Kt || tr("app_card.modal.scan_qr_code_text"), Qt = Qt || tr("app_card.modal.link_copied_notification"), Xt = Xt || tr("app_card.modal.copy_link_button"), Zt = Zt || tr("app_card.modal.ok");
  const ar = () => /* @__PURE__ */ jsxRuntimeExports.jsxs(AppCardContent, { $darkMode: Ht, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(AppCardBg, { style: {
      backgroundImage: `url(${Pt})`
    }, $darkMode: Ht }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(AppCardName, { $darkMode: Ht, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(AddDivNameContainer, { children: [
      _t,
      /* @__PURE__ */ jsxRuntimeExports.jsx(AppDivMobile, { $darkMode: Ht, children: ir(Vt, zt) && qt })
    ] }) }),
    ir(Vt, zt) && /* @__PURE__ */ jsxRuntimeExports.jsx(PhoneCardLogo, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Phone, {}) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(AppCardLogo, { children: typeof nr.src == "string" ? /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: nr.src, alt: `${_t} logo`, onError: rr }) : nr.error ? nr.src : /* @__PURE__ */ jsxRuntimeExports.jsx(Leaf$2, {}) })
  ] }), [or, sr] = useState(!1), [lr, cr] = useState(!1), hr = () => {
    sr(!or);
  }, pr = (br) => {
    navigator.clipboard.writeText(br ?? ""), cr(!0);
  }, mr = () => {
    sr(!or), cr(!1);
  }, Er = (br) => /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledTabContent, { $darkMode: Ht, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "qrcode_container", children: br && /* @__PURE__ */ jsxRuntimeExports.jsx(_default, { size: 256, style: {
      height: "auto",
      maxWidth: "160px",
      width: "160px",
      margin: "10px"
    }, value: br, viewBox: "0 0 256 256" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "content_container", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: {
        height: "105px"
      }, children: Kt }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledButton, { onClick: () => pr(br), type: "primary", ghost: !0, $darkMode: Ht, children: Xt }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: {
        position: "absolute",
        bottom: "-10px",
        right: "24px"
      }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledOkButton, { type: "primary", onClick: () => mr(), children: Zt }) })
    ] })
  ] }), _r = [{
    key: "1",
    label: "Google Play",
    children: Er(zt)
  }, {
    key: "2",
    label: "App Store",
    children: Er(Vt)
  }], yr = (br) => {
    let Cr = br;
    return zt || (Cr = br.filter((Pr) => Pr.key !== "1")), Vt || (Cr = br.filter((Pr) => Pr.key !== "2")), Cr;
  }, ur = () => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: or && /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledModalAppCard, { title: !1, footer: null, closable: !1, open: !0, width: 920, style: {
    padding: 0
  }, bodyStyle: {
    padding: 0
  }, maskClosable: !0, $darkMode: Ht, children: [
    lr && /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledModalCopied, { $darkMode: Ht, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: {
        marginTop: "4px"
      }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconChecked, {}) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: {
        marginTop: "-1px",
        marginLeft: "5px"
      }, children: Qt })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "header", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "title", children: [
        Gt,
        " ",
        _t,
        " ",
        qt
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "close", onClick: mr, children: Ht !== !1 ? /* @__PURE__ */ jsxRuntimeExports.jsx(Close, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(CloseInvert, {}) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "body", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "leftContainer", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "logo", children: /* @__PURE__ */ jsxRuntimeExports.jsx(AppCardLogoModal, { children: ir(Vt, zt) ? /* @__PURE__ */ jsxRuntimeExports.jsx(LogoMobileContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "logoContainer", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "logoChildren", children: typeof nr.src == "string" ? /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: nr.src, alt: `${_t} logo`, onError: rr }) : nr.error ? nr.src : /* @__PURE__ */ jsxRuntimeExports.jsx(Leaf$2, {}) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "phoneContainer", children: Ht !== !1 ? /* @__PURE__ */ jsxRuntimeExports.jsx(PhoneBlue$1, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(PhoneBlue, {}) })
        ] }) }) : typeof nr.src == "string" ? /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: nr.src, alt: `${_t} logo`, onError: rr }) : nr.error ? nr.src : /* @__PURE__ */ jsxRuntimeExports.jsx(Leaf$2, {}) }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "content", children: Wt })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "right", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "tabContainer", children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTabsAppCard, { defaultActiveKey: "1", items: yr(_r), $darkMode: Ht }) }) })
    ] })
  ] }) }), vr = () => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: ir(Vt, zt) ? /* @__PURE__ */ jsxRuntimeExports.jsx(AppCardWrapper, { as: "button", onClick: hr, $darkMode: Ht, children: ar() }) : /* @__PURE__ */ jsxRuntimeExports.jsx(AppCardWrapper, { as: "button", onClick: er.onClick, $darkMode: Ht, children: ar() }) }), dr = () => /* @__PURE__ */ jsxRuntimeExports.jsx(AppCardWrapper, { as: "a", href: er.link, target: "_blank", rel: "noreferrer", children: ar() });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(AppCardContainer, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTooltip, { title: ir(Vt, zt) ? Yt || tr("app_card.tooltip.discover_and_download") : Jt || tr("common.tooltip.open_in_new_tab"), placement: "bottom", color: "#4D5165", overlayInnerStyle: Ht ? {
      borderRadius: 4,
      backgroundColor: "#4D5165",
      color: "#FFF"
    } : {
      borderRadius: 4,
      backgroundColor: "#232630",
      color: "#FFF"
    }, mouseEnterDelay: 0.3, children: er.onClick ? vr() : dr() }),
    ur()
  ] });
};
function AppCard(_t) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(WithProviders, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(AppCardCP, { ..._t }) });
}
const Text = dt$1.span`
  font-size: 16px;
  line-height: 24px;
  color: ${(_t) => _t.theme.colors.cws_neutral_60};

  ${({
  $bold: _t
}) => _t && lt$1`
      font-weight: 600;
      color: ${(Et) => Et.theme.colors.cws_neutral_100};
    `}
`;
dt$1(Text).attrs(() => ({
  $bold: !0
}))`
  margin-right: 4px;

  ${({
  $large: _t
}) => _t && lt$1`
      font-size: 24px;
      line-height: 32px;
    `}
`;
dt$1.div`
  &,
  img,
  svg {
    height: 20px;
    width: auto;
  }
`;
const ActionContainer = dt$1.div`
  border: 1px solid ${(_t) => _t.theme.colors.cws_neutral_30};
  background-color: ${(_t) => _t.theme.colors.cws_neutral_00};
  border-radius: 4px;
  width: 30px;
  height: 30px;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;
`;
dt$1.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 4px;
`;
dt$1.div`
  margin: 2px;
  outline: 2px solid ${(_t) => _t.theme.colors.cws_neutral_20};
  border-radius: 16px;
  padding: 12px 12px 16px 16px;
  cursor: pointer;

  display: flex;
  gap: 16px;

  .cw-elements-progress-text {
    font-weight: 600 !important;
    color: ${(_t) => _t.theme.colors.cws_neutral_60} !important;
  }

  .cw-elements-progress-circle-trail {
    stroke-width: 3px;
  }

  .cw-elements-progress-circle-path {
    stroke-width: 5px;
  }

  &,
  ${ActionContainer} {
    transition: 100ms ease-in-out all;
  }

  &:hover {
    outline-width: 1px;
    background-color: ${theme$1.colors.cws_neutral_10};
  }

  ${({
  $active: _t,
  theme: Et
}) => _t && lt$1`
      background-color: ${Et.colors.cws_blue_10};
      outline-color: ${Et.colors.cws_blue_40};

      ${ActionContainer} {
        background-color: ${Et.colors.cws_blue_10};
        border-color: ${Et.colors.cws_blue_30};

        svg {
          fill: ${Et.colors.cws_blue_60};
        }
      }

      .cw-elements-progress-circle-trail {
        stroke: ${Et.colors.cws_blue_20} !important;
      }

      &:hover {
        outline-width: 1px;
        background-color: ${Et.colors.cws_blue_20};

        ${ActionContainer} {
          background-color: ${Et.colors.cws_blue_20};
        }

        .cw-elements-progress-circle-trail {
          stroke: ${Et.colors.cws_blue_30} !important;
        }
      }
    `}
`;
dt$1.div`
  cursor: pointer;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid rgba(194, 199, 208, 1);
  background: #fff;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
`;
dt$1.div`
  position: absolute;
  top: 0;
  width: 86px;
  height: 100%;
  transition: opacity 300ms ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${(_t) => _t.$show ? 1 : 0};
  pointer-events: ${(_t) => _t.$show ? "auto" : "none"};

  &.left {
    left: 0;
    background: linear-gradient(-270deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
  }

  &.right {
    right: 0;
    background: linear-gradient(270deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
  }
`;
dt$1.div`
  position: relative;
`;
dt$1.div`
  display: grid;
  grid-auto-flow: column;
  grid-gap: 24px;
  grid-auto-columns: minmax(
    ${(_t) => _t.$minWidth}px,
    ${(_t) => _t.$maxWidth ? `${_t.$maxWidth}px` : "auto"}
  );

  overflow-x: scroll;
  scroll-snap-type: x mandatory;

  scrollbar-width: none;
  margin-bottom: 0;
  padding-bottom: 0;

  &::-webkit-scrollbar {
    display: none;
  }
`;
dt$1.div`
  scroll-snap-align: center;
`;
const TitleContainer = dt$1.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  margin-bottom: 4px;
`, IconContainer = dt$1.div`
  display: flex;
  justify-content: center;
  width: 90px;
  height: 38px;
  align-items: center;
  padding: 12px 10px;
  background-color: ${(_t) => _t.theme.colors.cws_neutral_00};
  border-radius: 10px;
  margin-bottom: 10px;
  box-sizing: initial;

  @media screen and (max-width: 1600px) {
    width: 60px;
    height: 25px;
  }
`, Title = dt$1.span`
  font-size: 14px;
  line-height: 20px;
  color: ${(_t) => _t.theme.colors.cws_neutral_100};
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  text-align: center;
  margin-top: -8px;

  ${({
  $darkMode: _t
}) => _t && lt$1`
      color: ${(Et) => Et.theme.colors.cws_neutral_00};
    `}
`, SingleTagContainer = dt$1.div`
  border-radius: 4px;
  padding: 0 5px;
  font-size: 12px;
  margin-right: 5px;
  height: fit-content;
  font-weight: bold;
  ${({
  $bgColor: _t
}) => _t && lt$1`
      background-color: ${_t};
    `}
  ${({
  $color: _t
}) => _t && lt$1`
      color: ${_t};
    `}
`, IntegrationCardContainer = dt$1.div`
  border-radius: 8px;
  padding: 0 8px;
  background-color: ${(_t) => _t.theme.colors.cws_neutral_00};
  max-width: 194px; // width - 2x padding
  max-height: 140px;
  height: 140px;
  width: 194px; // width - 2x padding
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  overflow: hidden;

  box-sizing: initial;

  ${({
  $clickable: _t
}) => _t ? lt$1`
        cursor: pointer;
      ` : lt$1`
        cursor: default;
      `}

  &:hover {
    .icon-title-container,
    .tags-description-container {
      animation: rotateIn 180ms ease-out;
      transform: translateY(-140px);
    }
  }

  ${({
  $darkMode: _t
}) => _t ? lt$1`
        background-color: ${(Et) => Et.theme.colors.cws_neutral_80};
      ` : lt$1`
      outline: 1px solid ${(Et) => Et.theme.colors.cws_neutral_20};
    `}

  .icon-title-container {
    height: 60px;
    margin: 135px 0 85px 0;
    width: 100%;
    animation: rotateOut 180ms ease-out;
  }

  .tags-description-container {
    display: flex;
    justify-content: start;
    width: 100%;
    height: 142px;
    flex-direction: column;
    animation: rotateOut 180ms ease-out;
    ${({
  $darkMode: _t
}) => _t && lt$1`
        color: ${(Et) => Et.theme.colors.cws_neutral_00};
      `}

    .tags {
      display: flex;
      flex-direction: row;
      height: 16px;
      margin-top: -10px;
      margin-bottom: 10px;
    }

    .description {
      font-size: 12px;
      max-height: 64px;
      max-width: 210px;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: -0.09px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      min-height: 60px;
    }
  }

  @keyframes rotateIn {
    from {
      transform: translateY(0px);
    }
    to {
      transform: translateY(-140px);
    }
  }

  @keyframes rotateOut {
    from {
      transform: translateY(-140px);
    }
    to {
      transform: translateY(0px);
    }
  }

  @media screen and (max-width: 1600px) {
    height: 112px;
    width: 152px;
  }
`, tagTypes = ["free", "beta", "paid"];
function IntegrationCardCP(_t) {
  const {
    colors: Et
  } = useContext(et$1), Pt = useAnalytics(), $t = {
    free: {
      bgColor: Et.cws_blue_20,
      color: Et.cws_blue_70
    },
    beta: {
      bgColor: Et.cws_red_20,
      color: Et.cws_red_70
    },
    paid: {
      bgColor: Et.cws_green_20,
      color: Et.cws_green_70
    }
  }, Mt = () => {
    Pt(`Accessed ${_t.title} integration page`), _t.onClick && _t.onClick();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip, { title: _t.clickable ? _t.tooltip : "", color: Et.cws_neutral_70, placement: "bottom", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(IntegrationCardContainer, { $darkMode: _t.darkMode, $clickable: _t.clickable, onClick: Mt, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "icon-title-container", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(TitleContainer, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(IconContainer, { children: typeof _t.icon == "string" ? /* @__PURE__ */ jsxRuntimeExports.jsx("img", { alt: "integrationIcon", src: _t.icon, style: {
        height: "25px",
        width: "60px"
      } }) : _t.icon }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Title, { $darkMode: _t.darkMode, children: _t.title })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "tags-description-container", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "tags", children: _t.tags.map((Bt) => {
        if (tagTypes.includes(Bt)) {
          const {
            bgColor: Vt,
            color: zt
          } = $t[Bt];
          return /* @__PURE__ */ jsxRuntimeExports.jsx(SingleTagContainer, { $bgColor: Vt, $color: zt, children: Bt.toLocaleUpperCase() }, Bt);
        }
      }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "description", children: _t.description })
    ] })
  ] }) });
}
function IntegrationCard(_t) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(WithProviders, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(IntegrationCardCP, { ..._t }) });
}
const AppGroupWrapper = dt$1.div`
  margin-bottom: 40px;
  // Padding to fit App card scale on hover 168 * 0,05
  padding: 0px 8.4px 40px 8.4px;

  &:not(:last-of-type) {
    border-bottom: 1px solid ${(_t) => _t.theme.colors.cws_neutral_80};
  }
`, AppGroupTitle = dt$1.div`
  font-size: 20px;
  line-height: 28px;
  color: ${(_t) => _t.theme.colors.cws_neutral_00};
  margin-bottom: 24px;
`, AppGroupApps = dt$1.div`
  display: flex;
  justify-items: start;
  gap: 24px;
  flex-wrap: wrap;
  max-width: 912px; // a max of 4 apps + 3 gaps
`, sortAppProps = (_t) => _t.sort((Et, Pt) => {
  const $t = Et.name.toLocaleLowerCase(), Mt = Pt.name.toLocaleLowerCase();
  return $t < Mt ? -1 : $t > Mt ? 1 : 0;
}), AppGroup = ({
  title: _t,
  loading: Et,
  apps: Pt
}) => {
  const $t = [], Mt = [];
  Pt.forEach((Vt) => {
    (Vt.play_store_uri || Vt.apple_store_uri) && $t.push(Vt), Vt.site_uri !== "" && Vt.site_uri !== null && Mt.push({
      ...Vt,
      play_store_uri: "",
      apple_store_uri: ""
    });
  });
  const Bt = [...sortAppProps(Mt), ...sortAppProps($t)];
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(AppGroupWrapper, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(AppGroupTitle, { children: _t }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(AppGroupApps, { children: Et ? /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton, { active: !0 }) : Bt.map((Vt, zt) => /* @__PURE__ */ jsxRuntimeExports.jsx(AppCard, { ...Vt }, `${zt}-${Vt.name}`)) })
  ] });
};
function Leaf$1() {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { width: "36", height: "36", viewBox: "0 0 200 200", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M170.521 32.1008C163.563 32.9748 143.193 35.6639 123.025 40.2353C95.6638 46.4538 70.5882 56.2353 53.4454 72.1008C42.3529 82.3529 35.0588 93.6134 31.4285 109.916C27.5966 127.227 29.8151 146.387 35.7311 167.63C42.4874 166.118 48.7395 165.748 55.4622 165.277C65.1092 164.605 77.1428 163.731 89.9159 161.546C109.042 158.252 122.319 151.563 134.319 135.361C144.807 121.244 148.134 101.445 151.126 87.3277C155.16 68.4706 159.193 55.7983 162.924 47.1597C165.244 41.916 166.857 38.0504 170.521 32.1008ZM125.613 133.815C117.815 143.361 108.706 149.647 92.7059 152.975C115.496 141.714 121.748 119.697 125.21 107.361C127.227 100.101 129.109 90.3529 131.193 81.1428C133.95 68.7395 138.252 53.5126 143.193 44.2017C147.193 43.4958 155.328 42.1849 156.538 41.9832C153.244 49.2101 148.101 61.916 142.555 89.9496C137.882 113.311 132.807 125.008 125.613 133.815ZM75.1596 65.8151C56.9411 81.7143 51.9664 96.7059 49.479 110.218C46.7227 125.378 49.2437 142.319 52.3025 156.403C48.3697 157.311 43.563 158.185 41.6134 158.588C37.5462 143.529 35.8655 126.555 39.0924 111.933C44.2353 88.7395 58.6554 75.8991 75.1596 65.8151ZM57.3109 110.857C60.4706 94.1512 69.7479 75.4958 94.7899 59.126C75.8655 78.5882 71.1596 90.7227 68.2017 105.412C65.8487 117.109 66.9243 133.008 70.084 147.798C66.9243 150.319 63.0252 152.168 59.8991 153.647C56.4033 138.689 55.2269 121.815 57.3109 110.857ZM76.8739 142.017C74.9243 130.958 73.8487 118.151 75.6302 108.336C79.2941 87.6975 91.4622 70.3529 109.748 55.7311C106.42 64.4034 103.966 75.0588 102.622 81.2437C99.6638 95.0252 97.3109 107.731 93.2437 117.882C88.5378 129.613 83.6975 135.731 76.8739 142.017ZM68.3697 156.269C83.0252 149.916 93.5126 137.815 99.6975 122.857C104.739 110.622 106.924 99.0252 109.849 85.0084C111.126 78.9244 115.025 62.1512 119.664 51.0252C122.824 49.647 128.84 47.6639 133.613 46.3865C128.773 56.9748 125.042 71.7311 122.42 83.9664C117.983 104.571 114.79 120.874 105.109 133.681C95.7311 146.017 82.4874 152.706 68.3697 156.269Z", fill: "#73DC78" }) });
}
const useHeaderMargin = (_t) => {
  var $t, Mt;
  const [Et, Pt] = useState(_t ? document.querySelector(_t) : null);
  return useLayoutEffect$1(() => {
    Pt(_t ? document.querySelector(_t) : null);
  }, [_t]), Et ? ((Mt = ($t = Et.getBoundingClientRect) == null ? void 0 : $t.call(Et)) == null ? void 0 : Mt.height) ?? 0 : 0;
}, useDefaultIcon = (_t) => {
  const [Et, Pt] = useState({
    src: _t,
    error: !1
  });
  return useEffect(() => {
    Pt({
      src: _t,
      error: !1
    });
  }, [_t]), {
    imgSrc: Et,
    onImgError: () => {
      Et.error || Pt({
        src: /* @__PURE__ */ jsxRuntimeExports.jsx(Leaf$1, {}),
        error: !0
      });
    }
  };
};
function Leaf() {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { width: "16", height: "16", viewBox: "0 0 200 200", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M170.521 32.1008C163.563 32.9748 143.193 35.6639 123.025 40.2353C95.6638 46.4538 70.5882 56.2353 53.4454 72.1008C42.3529 82.3529 35.0588 93.6134 31.4285 109.916C27.5966 127.227 29.8151 146.387 35.7311 167.63C42.4874 166.118 48.7395 165.748 55.4622 165.277C65.1092 164.605 77.1428 163.731 89.9159 161.546C109.042 158.252 122.319 151.563 134.319 135.361C144.807 121.244 148.134 101.445 151.126 87.3277C155.16 68.4706 159.193 55.7983 162.924 47.1597C165.244 41.916 166.857 38.0504 170.521 32.1008ZM125.613 133.815C117.815 143.361 108.706 149.647 92.7059 152.975C115.496 141.714 121.748 119.697 125.21 107.361C127.227 100.101 129.109 90.3529 131.193 81.1428C133.95 68.7395 138.252 53.5126 143.193 44.2017C147.193 43.4958 155.328 42.1849 156.538 41.9832C153.244 49.2101 148.101 61.916 142.555 89.9496C137.882 113.311 132.807 125.008 125.613 133.815ZM75.1596 65.8151C56.9411 81.7143 51.9664 96.7059 49.479 110.218C46.7227 125.378 49.2437 142.319 52.3025 156.403C48.3697 157.311 43.563 158.185 41.6134 158.588C37.5462 143.529 35.8655 126.555 39.0924 111.933C44.2353 88.7395 58.6554 75.8991 75.1596 65.8151ZM57.3109 110.857C60.4706 94.1512 69.7479 75.4958 94.7899 59.126C75.8655 78.5882 71.1596 90.7227 68.2017 105.412C65.8487 117.109 66.9243 133.008 70.084 147.798C66.9243 150.319 63.0252 152.168 59.8991 153.647C56.4033 138.689 55.2269 121.815 57.3109 110.857ZM76.8739 142.017C74.9243 130.958 73.8487 118.151 75.6302 108.336C79.2941 87.6975 91.4622 70.3529 109.748 55.7311C106.42 64.4034 103.966 75.0588 102.622 81.2437C99.6638 95.0252 97.3109 107.731 93.2437 117.882C88.5378 129.613 83.6975 135.731 76.8739 142.017ZM68.3697 156.269C83.0252 149.916 93.5126 137.815 99.6975 122.857C104.739 110.622 106.924 99.0252 109.849 85.0084C111.126 78.9244 115.025 62.1512 119.664 51.0252C122.824 49.647 128.84 47.6639 133.613 46.3865C128.773 56.9748 125.042 71.7311 122.42 83.9664C117.983 104.571 114.79 120.874 105.109 133.681C95.7311 146.017 82.4874 152.706 68.3697 156.269Z", fill: "#73DC78" }) });
}
const {
  CheckableTag
} = Tag, CheckableTagStyled = dt$1(CheckableTag)`
  font-size: 14px;
  color: ${(_t) => _t.theme.colors.cws_neutral_00};
  gap: 4px;
  padding: 2px 8px;
  margin: 0px;
  border-radius: 4px;
  border: 1px solid var(--neutral-neutral-80, #363948);

  &:hover {
    color: ${(_t) => _t.theme.colors.cws_neutral_00} !important;
  }
`, IntegrationFilterWrapper = dt$1.div`
  margin: 20px 0;
  display: flex;
  gap: 10px;
  font-size: 14px;
`, FilterContainer = dt$1.div`
  border-radius: 4px;
  width: fit-content;
  height: fit-content;
  cursor: pointer;
  border: 1px solid #232630;

  &:hover {
    border: 1px solid ${(_t) => _t.theme.colors.cws_neutral_00};
  }
  &:active {
    background-color: ${(_t) => _t.theme.colors.cws_blue_70};
  }
  .cw-elements-tag-checkable-checked {
    background-color: ${(_t) => _t.theme.colors.cws_blue_70};
  }
  .cw-elements-tag-checkable-checked:hover {
    background-color: #0071cd !important;
  }
`, integrationsClasses = {
  ag_insights: "integrations.classes.ag_insights",
  erp: "integrations.classes.erp",
  weather: "integrations.classes.weather",
  machinery: "integrations.classes.machinery",
  trap: "integrations.classes.trap"
}, CheckableClassTag = ({
  integrationClass: _t,
  classKey: Et,
  isClassChecked: Pt,
  currentAppLogo: $t,
  handleChange: Mt
}) => {
  const {
    t: Bt
  } = useTranslation(), {
    imgSrc: Vt,
    onImgError: zt
  } = useDefaultIcon($t);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FilterContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(CheckableTagStyled, { checked: Pt, onChange: (Ht) => Mt(Et, Ht), children: [
    Pt && /* @__PURE__ */ jsxRuntimeExports.jsx(RefIcon$8, { style: {
      marginRight: "5px",
      width: "12px",
      height: "12px"
    } }),
    Bt(_t),
    typeof $t == "string" && !Vt.error ? /* @__PURE__ */ jsxRuntimeExports.jsx("img", { alt: "currentAppLogo", src: $t, width: 16, height: 16, style: {
      marginLeft: "5px"
    }, onError: zt }) : Vt.error ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: {
      marginLeft: "5px"
    }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Leaf, {}) }) : ""
  ] }) }, Et);
}, IntegrationFilter = ({
  currentAppLogo: _t,
  checkedTags: Et,
  setCheckedTags: Pt
}) => {
  const {
    t: $t
  } = useTranslation(), Mt = (Bt, Vt) => {
    const zt = Vt ? [...Et, Bt] : Et.filter((Ht) => Ht !== Bt);
    Pt(zt);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(IntegrationFilterWrapper, { children: [
    _t && /* @__PURE__ */ jsxRuntimeExports.jsx(CheckableClassTag, { integrationClass: $t("integrations.filter.active_in"), classKey: "integrations.filter.active_in", isClassChecked: Et.includes("integrations.filter.active_in"), handleChange: Mt, currentAppLogo: _t }),
    Object.keys(integrationsClasses).map((Bt) => /* @__PURE__ */ jsxRuntimeExports.jsx(CheckableClassTag, { integrationClass: integrationsClasses[Bt], classKey: Bt, isClassChecked: Et.includes(Bt), handleChange: Mt }, Bt))
  ] });
};
function Empty() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: "280", height: "57", viewBox: "0 0 280 57", fill: "none", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "128.443", y: "13.6523", width: "40", height: "40", rx: "8", transform: "rotate(4 128.443 13.6523)", fill: "#232630" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "128.443", y: "13.6523", width: "40", height: "40", rx: "8", transform: "rotate(4 128.443 13.6523)", stroke: "#4D5165", strokeLinecap: "round", strokeDasharray: "4 4" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M153.284 28.7531L152.976 33.159L155.313 35.5779L152.819 35.4035L152.354 42.054L147.366 41.7052L147.715 36.7174L146.052 36.6011L145.703 41.5889L140.716 41.2401L141.181 34.5897L138.687 34.4153L147.523 27.5149L150.639 30.7401L150.79 28.5787L153.284 28.7531ZM149.145 40.1588L150.808 40.2751L151.262 33.7826L147.367 29.7511L142.949 33.2013L142.495 39.6938L144.157 39.8101L144.506 34.8222L149.494 35.171L149.145 40.1588ZM147.232 31.6714C148.147 31.7354 148.843 32.5358 148.779 33.4503L145.453 33.2178C145.517 32.3033 146.318 31.6075 147.232 31.6714Z", fill: "#868CA2" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "85.9297", y: "5.38281", width: "32", height: "32", rx: "6", transform: "rotate(-8 85.9297 5.38281)", fill: "#232630" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "85.9297", y: "5.38281", width: "32", height: "32", rx: "6", transform: "rotate(-8 85.9297 5.38281)", stroke: "#4D5165", strokeLinecap: "round", strokeDasharray: "4 4" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { clipPath: "url(#clip0_7838_11158)", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M100.718 19.5943L99.7938 19.7242C98.2754 19.9376 96.8448 18.8596 96.6314 17.3412C96.4273 15.8888 97.4393 14.4674 98.8824 14.1973C99.3374 13.1235 100.367 12.3056 101.555 12.1386C103.338 11.8881 105.088 13.3251 105.348 15.1736L104.16 15.3406C103.983 14.0863 102.835 13.1032 101.647 13.2702C100.789 13.3908 100.071 14.0303 99.852 14.8689L99.7849 15.3496L99.3795 15.3392L99.3135 15.3485L99.2475 15.3578C98.3232 15.4877 97.6991 16.3159 97.8197 17.1742C97.9403 18.0324 98.7686 18.6565 99.6268 18.5359L100.551 18.406L100.718 19.5943Z", fill: "#868CA2" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M99.852 14.8689C100.071 14.0303 100.789 13.3908 101.647 13.2702C102.835 13.1032 103.983 14.0863 104.16 15.3406L105.348 15.1736C105.316 14.9498 105.263 14.732 105.191 14.5225C104.664 13.0019 103.122 11.9184 101.555 12.1386C100.367 12.3056 99.3374 13.1235 98.8824 14.1973C97.4393 14.4674 96.4273 15.8888 96.6314 17.3412C96.8448 18.8596 98.2754 19.9376 99.7938 19.7242L100.718 19.5943L100.551 18.406L99.6268 18.5359C98.7686 18.6565 97.9403 18.0324 97.8197 17.1742C97.6991 16.3159 98.3232 15.4877 99.2475 15.3578L99.3795 15.3392L99.7849 15.3496L99.852 14.8689Z", fill: "#868CA2" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M104.195 24.6963L103.007 24.8633L103.202 26.2497L104.39 26.0826L104.195 24.6963Z", fill: "#868CA2" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M107.496 24.2314L106.308 24.3984L106.502 25.7848L107.691 25.6178L107.496 24.2314Z", fill: "#868CA2" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M108.413 23.0944L101.679 24.0408C100.227 24.2449 98.9376 23.2143 98.7428 21.8279C98.5665 20.5736 99.2762 19.3967 100.427 18.9656C100.356 17.0233 101.86 15.2636 103.84 14.9853C105.292 14.7812 106.724 15.3878 107.561 16.5494C109.352 16.3649 110.943 17.6224 111.193 19.4049C111.444 21.1874 110.196 22.8439 108.413 23.0944ZM101.113 20.0137C100.321 20.125 99.7537 20.878 99.8651 21.6702C99.9764 22.4624 100.729 23.0298 101.522 22.9185L108.255 21.9721C109.444 21.8051 110.238 20.751 110.071 19.5626C109.904 18.3743 108.85 17.58 107.662 17.747C107.662 17.747 107.596 17.7562 107.53 17.7655C107.464 17.7748 107.464 17.7748 107.398 17.7841L107.011 17.9058L106.757 17.5375C106.146 16.5461 105.063 16.0251 103.941 16.1829C102.423 16.3963 101.345 17.8269 101.558 19.3453L101.641 19.9395L101.113 20.0137Z", fill: "#868CA2" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "255.34", y: "4.44531", width: "24", height: "24", rx: "6", transform: "rotate(8 255.34 4.44531)", fill: "#232630" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "255.34", y: "4.44531", width: "24", height: "24", rx: "6", transform: "rotate(8 255.34 4.44531)", stroke: "#373B4A", strokeLinecap: "round", strokeDasharray: "4 4" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "212.922", y: "24.1523", width: "32", height: "32", rx: "6", transform: "rotate(-4 212.922 24.1523)", fill: "#232630" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "212.922", y: "24.1523", width: "32", height: "32", rx: "6", transform: "rotate(-4 212.922 24.1523)", stroke: "#3C4551", strokeLinecap: "round", strokeDasharray: "4 4" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "42.2012", y: "13.0234", width: "40", height: "40", rx: "8", transform: "rotate(6 42.2012 13.0234)", fill: "#232630" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "42.2012", y: "13.0234", width: "40", height: "40", rx: "8", transform: "rotate(6 42.2012 13.0234)", stroke: "#4D5165", strokeLinecap: "round", strokeDasharray: "4 4" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("g", { clipPath: "url(#clip1_7838_11158)", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M62.7491 32.782L63.7084 31.1483L65.4967 30.557L63.8704 29.6068L63.2717 27.8093L62.3289 29.4448L60.5241 30.0343L62.1669 30.9863L62.7491 32.782ZM67.8088 32.4758C66.6071 32.3495 65.8103 33.4724 65.9906 34.3879L62.7384 37.0291C62.4976 36.9284 62.1329 36.8901 61.8765 36.9385L59.9852 34.603C60.3602 33.7459 59.8152 32.4736 58.6052 32.3464C57.4035 32.2201 56.5985 33.3421 56.7862 34.2668L52.6107 37.6405C51.7526 37.2738 50.4886 37.8197 50.3623 39.0214C50.2665 39.933 50.934 40.7573 51.8457 40.8531C53.0474 40.9794 53.8441 39.8566 53.6638 38.941L57.8319 35.5582C58.0727 35.6589 58.4374 35.6972 58.6938 35.6488L60.5851 37.9843C60.2101 38.8414 60.7551 40.1137 61.9651 40.2409C63.1668 40.3672 63.9718 39.2452 63.7841 38.3205L67.0438 35.6885C67.9018 36.0552 69.1658 35.5093 69.2921 34.3076C69.3879 33.3959 68.7204 32.5716 67.8088 32.4758ZM53.6326 31.8238L53.044 33.4378L52.8038 31.7367L51.1899 31.1481L52.8909 30.9079L53.4795 29.2939L53.7197 30.995L55.3337 31.5836L53.6326 31.8238Z", fill: "#868CA2" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "0.923828", y: "6.15625", width: "32", height: "32", rx: "6", transform: "rotate(-4 0.923828 6.15625)", fill: "#232630" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "0.923828", y: "6.15625", width: "32", height: "32", rx: "6", transform: "rotate(-4 0.923828 6.15625)", stroke: "#4D5165", strokeLinecap: "round", strokeDasharray: "4 4" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("g", { clipPath: "url(#clip2_7838_11158)", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M24.4646 17.8746L24.7464 21.9047C25.188 22.2949 25.4808 22.8491 25.5249 23.4809C25.6147 24.7645 24.6436 25.8816 23.36 25.9714C22.0765 26.0611 20.9594 25.09 20.8696 23.8065C20.8637 23.7217 20.869 23.6361 20.8743 23.5505C20.8761 23.522 20.8778 23.4935 20.8792 23.465L17.4475 23.7049C17.4207 23.8939 17.3805 24.0839 17.3261 24.2614L16.7089 24.0373L16.5907 24.353L17.2012 24.5776C16.9032 25.2868 16.3761 25.8716 15.6925 26.2268L15.4165 25.6246L15.1123 25.7662L15.3807 26.3556C15.0685 26.4776 14.7344 26.5745 14.382 26.5992C13.9563 26.6289 13.538 26.5713 13.162 26.4506L13.3861 25.8334L13.0704 25.7152L12.8458 26.3257C12.1366 26.0277 11.5518 25.5006 11.1966 24.817L11.7988 24.541L11.6572 24.2368L11.0678 24.5052C10.9458 24.193 10.8489 23.8589 10.8242 23.5065C10.7945 23.0808 10.8521 22.6625 10.9728 22.2865L11.59 22.5106L11.7082 22.1949L11.0977 21.9703C11.3957 21.2611 11.9228 20.6763 12.6064 20.3211L12.8824 20.9233L13.1866 20.7817L12.9182 20.1923C13.2304 20.0703 13.5645 19.9734 13.9169 19.9487C14.3426 19.919 14.7609 19.9766 15.1369 20.0973L14.9128 20.7145L15.2285 20.8327L15.4531 20.2222C15.6187 20.2975 15.7782 20.3799 15.932 20.4761L17.2886 20.3813C18.0202 20.3301 18.5769 19.6897 18.5257 18.9582L18.4192 17.4352L17.665 16.7796L16.7928 17.7828L16.2876 17.3437L18.4711 14.8319L18.9763 15.2711L18.1041 16.2744L18.8584 16.93L23.0415 16.6375C23.7731 16.5863 24.4134 17.143 24.4646 17.8746ZM12.1543 23.4135C12.2315 24.5174 13.185 25.3463 14.289 25.2691C15.3929 25.1919 16.2218 24.2384 16.1446 23.1344C16.0674 22.0305 15.1139 21.2016 14.0099 21.2788C12.906 21.356 12.0771 22.3095 12.1543 23.4135ZM17.2311 22.0427C17.2722 22.1534 17.3067 22.2646 17.3417 22.3824L21.4583 22.0946C21.8485 21.6529 22.4027 21.3602 23.0345 21.3161C23.1223 21.3099 23.211 21.3158 23.2965 21.3215C23.321 21.3231 23.3454 21.3247 23.3694 21.3261L23.1345 17.9676L19.8093 18.2001L19.8558 18.8652C19.9586 20.3349 18.8514 21.6086 17.3817 21.7113L17.1023 21.7309L16.5001 22.0069L16.6417 22.3111L17.2311 22.0427ZM22.1997 23.7135C22.2383 24.2654 22.7151 24.6799 23.267 24.6413C23.819 24.6027 24.2334 24.1259 24.1948 23.5739C24.1562 23.022 23.6795 22.6075 23.1275 22.6461C22.5755 22.6847 22.1611 23.1615 22.1997 23.7135ZM15.8655 19.144L12.5403 19.3765C12.1745 19.4021 11.8544 19.1237 11.8288 18.758C11.8032 18.3922 12.0815 18.072 12.4473 18.0464L14.4424 17.9069C15.174 17.8557 15.8144 18.4124 15.8655 19.144Z", fill: "#868CA2" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "177.383", y: "0.929688", width: "32", height: "32", rx: "6", transform: "rotate(8 177.383 0.929688)", fill: "#232630" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "177.383", y: "0.929688", width: "32", height: "32", rx: "6", transform: "rotate(8 177.383 0.929688)", stroke: "#4D5165", strokeLinecap: "round", strokeDasharray: "4 4" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M192.021 11.7384L196.496 18.2137L189.979 26.2623L185.934 16.7292L192.021 11.7384ZM191.753 13.6398L187.509 17.1198L190.33 23.767L194.874 18.155L191.753 13.6398Z", fill: "#868CA2" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("defs", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("clipPath", { id: "clip0_7838_11158", children: /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "16", height: "16", fill: "white", transform: "translate(94.9648 12.1914) rotate(-8)" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("clipPath", { id: "clip1_7838_11158", children: /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "20", height: "20", fill: "white", transform: "translate(51.1016 24.0156) rotate(6)" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("clipPath", { id: "clip2_7838_11158", children: /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "16", height: "16", fill: "white", transform: "translate(9.46191 13.5781) rotate(-4)" }) })
    ] })
  ] });
}
function Square() {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "18", viewBox: "0 0 16 18", fill: "none", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.33333 5.33333V14.6667H12.6667V10H14V14.6667C14 15.4 13.4 16 12.6667 16H3.33333C2.59333 16 2 15.4 2 14.6667V5.33333C2 4.6 2.59333 4 3.33333 4H8V5.33333H3.33333ZM9.33333 5.33333V4H14V8.66667H12.6667V6.27333L6.11333 12.8267L5.17333 11.8867L11.7267 5.33333H9.33333Z", fill: "#A3A9B9" }) });
}
const IntegrationGroupWrapper = dt$1.div`
  margin-bottom: 40px;
  padding: 0 8.4px;
`, IntegrationGroupTitle = dt$1.div`
  display: flex;
  flex-direction: row;
  cursor: pointer;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.12px;
  border-radius: 4px;
  padding: 0 4px;
  color: ${(_t) => _t.theme.colors.cws_neutral_00};
  margin-bottom: 24px;

  &:hover {
    background-color: #363948;
  }

  .square {
    margin-left: 3px;
    margin-top: 2px;
  }
`, IntegrationGroupContainer = dt$1.div`
  display: flex;
  justify-items: start;
  gap: 24px;
  flex-wrap: wrap;
  max-width: 912px; // a max of 4 integrations + 3 gaps
`, IntegrationGroup = ({
  title: _t,
  loading: Et,
  integrations: Pt,
  currentAppLogo: $t,
  checkedTags: Mt,
  setCheckedTags: Bt,
  empty: Vt
}) => {
  const {
    t: zt
  } = useTranslation(), Ht = useConfig$1();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(IntegrationGroupWrapper, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip, { placement: "left", title: zt("integrations.pop_up.open_connect"), color: "#4D5165", overlayInnerStyle: {
      borderRadius: 4
    }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(IntegrationGroupTitle, { onClick: () => {
      window.open(Ht.getConnectURL());
    }, children: [
      _t,
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "square", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Square, {}) })
    ] }) }),
    Et ? Vt ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: {
        marginBottom: "20px"
      }, children: zt("integrations.empty.select_org") }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Empty, {})
    ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton, { active: !0 }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(IntegrationFilter, { currentAppLogo: $t, checkedTags: Mt, setCheckedTags: Bt }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(IntegrationGroupContainer, { children: Et ? /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton, { active: !0 }) : Pt.filter((Wt) => Wt.visible).map((Wt) => /* @__PURE__ */ jsxRuntimeExports.jsx(IntegrationCard, { ...Wt }, Wt.title)) })
    ] })
  ] });
}, FARM_SETTINGS_ID = "43524f50-5749-5345-4253-434149554249", TYPE_MODULE = "MODULE", SvgNoAccess = (_t) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", ..._t }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#prefix__prefix__clip0_4513_241169)" }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#prefix__prefix__clip1_4513_241169)" }, /* @__PURE__ */ React.createElement("rect", { x: -384, y: -1411, width: 1688, height: 1688, rx: 844, fill: "#0092E4" }), /* @__PURE__ */ React.createElement("path", { d: "M241.168 226.553c-31.878 23.378-69.137 69.137-69.137 93.78l672.883 17.675s-54.077-17.215-104.731-42.318C689.528 270.587 591.186 167.001 417.774 167c-60.238 0-125.267 21.905-176.606 59.553z", fill: "#fff", stroke: "#E8EAED", strokeWidth: 0.718 }), /* @__PURE__ */ React.createElement("path", { d: "M503.516 232.013c-48.314 11.213-105.416 48.196-143.065 95.843h525.711s-13.006-22.017-41.071-43.444c-41.071-31.356-92.444-47.8-132.112-55.793-69.137-13.932-142.38-12.175-209.463 3.394z", fill: "#093", stroke: "#093", strokeWidth: 0.718 }), /* @__PURE__ */ React.createElement("mask", { id: "prefix__prefix__a", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 359, y: 218, width: 528, height: 111 }, /* @__PURE__ */ React.createElement("path", { d: "M503.516 232.013c-48.314 11.213-105.416 48.196-143.065 95.843h525.711s-13.006-22.017-41.071-43.444c-41.071-31.356-92.444-47.8-132.112-55.793-69.137-13.932-142.38-12.175-209.463 3.394z", fill: "#00004B", stroke: "#00004B", strokeWidth: 0.718 })), /* @__PURE__ */ React.createElement("g", { mask: "url(#prefix__prefix__a)", stroke: "#73DC78", strokeWidth: 0.718 }, /* @__PURE__ */ React.createElement("path", { d: "M829.595 303.016c-5.879 9.009-9.148 21.453-9.148 27.479h17.642s1.503-13.956 11.761-25.31c11.108-12.293 17.642-14.221 28.097-16.632l-9.148-12.293c-2.178-.241-4.574 0-12.414 2.893-7.465 2.753-18.296 10.847-26.79 23.863z" }), /* @__PURE__ */ React.createElement("path", { d: "M805.388 333.21c-1.369-1.357.685-23.08 7.53-36.656 7.56-14.995 25.327-33.262 42.44-38.013 13.69-3.802 14.375-3.847 13.006-3.395l-15.06-12.218c-10.724 1.81-24.126 9.636-37.648 20.364-10.267 8.146-25.226 31.905-26.696 51.59-1.095 14.663-.914 18.328-.001 18.328h16.429z" }), /* @__PURE__ */ React.createElement("path", { d: "M778.008 287.729c-6.091 16.97-8.828 42.086-7.459 43.444H754.12c-.913 0-1.096-.271-.001-14.934 1.623-21.722 11.568-54.304 32.104-70.597 13.522-10.728 18.71-9.051 29.434-10.861l10.953 7.467s-4.108-.543-10.953 1.358c-17.113 4.752-31.98 28.328-37.649 44.123z" }), /* @__PURE__ */ React.createElement("path", { d: "M742.412 285.693c-6.09 16.97-8.827 42.086-7.459 43.444h-16.429c-.912 0-1.096-.272 0-14.934 1.622-21.722 13.62-63.807 34.156-80.1 13.522-10.729 16.658.452 27.382-1.358l10.952 7.467s-8.899-4.616-15.745-2.715c-17.113 4.751-27.188 32.401-32.857 48.196zm-36.965-.712c-5.476 20.398-7.529 44.835-6.16 46.193l-17.727-2.749c0 4.106-1.096-.272-.001-14.934 2.279-30.513 16.359-73.956 36.894-90.249 13.522-10.728 5.02-1.584 15.744-3.394l10.268 5.431s1.369 1.493-5.476 3.394c-17.113 4.751-29.192 40.106-33.542 56.308zm-44.493 9.536c-2.409 20.973-3.006 35.182-1.637 36.539l-17.728 1.475c0 4.107-1.853.83-1.855-19.686-.001-30.596 13.005-78.063 38.332-100.464 12.924-11.431 6.389-2.263 17.113-4.073l11.637 4.073s-1.369 4.208-8.214 6.109c-17.113 4.752-35.325 55.814-37.648 76.027z" }), /* @__PURE__ */ React.createElement("path", { d: "M622.351 331.476c-1.368-1.357-3.353-12.521 0-41.71 4.524-39.371 18.75-72.214 35.863-76.965 6.845-1.901 11.637 0 11.637 0l-11.637-4.073c-10.724 1.81-9.702-9.751-23.957 0-21.22 14.514-35.597 66.783-35.595 107.512.001 20.515 5.962 20.818 5.962 16.711l17.727-1.475z" }), /* @__PURE__ */ React.createElement("path", { d: "M581.283 332.299c-1.369-1.357-5.138-14.023-1.785-43.212 4.524-39.371 16.257-74.785 33.37-79.536 6.845-1.901 15.915 4.073 15.915 4.073l-11.637-4.073c-10.724 1.81-14.494-12.351-28.749-2.601-21.22 14.514-30.806 69.384-30.803 110.113.001 20.515 5.961 20.818 5.961 16.711l17.728-1.475z" }), /* @__PURE__ */ React.createElement("path", { d: "M540.211 333.041c-1.369-1.357-5.138-14.023-1.785-43.212 4.523-39.372 9.583-74.785 26.696-79.536 6.846-1.901 22.588 4.073 22.588 4.073l-11.637-4.073c-10.724 1.81-21.607-11.735-35.862-1.985-21.22 14.514-23.692 68.768-23.69 109.497.002 20.515 5.962 20.818 5.962 16.711l17.728-1.475z" }), /* @__PURE__ */ React.createElement("path", { d: "M499.141 332.532c-1.369-1.357-5.139-14.023-1.785-43.212 4.523-39.371 9.583-74.784 26.696-79.536 6.845-1.901 22.588 4.073 22.588 4.073l-11.637-4.073c-10.724 1.81-21.607-11.735-35.862-1.985-21.221 14.514-23.692 68.768-23.69 109.497.001 20.515 5.962 20.818 5.962 16.711l17.728-1.475z" }), /* @__PURE__ */ React.createElement("path", { d: "M455.33 336.605c-1.369-1.357 0 0 0-48.197 0-28.51 7.798-69.8 24.911-74.551 6.845-1.901 22.588 4.073 22.588 4.073l-11.637-4.073c-10.724 1.81-14.493-9.751-28.748 0-21.22 14.514-24.842 48.756-28.066 104.419-1.186 20.482 3.224 23.911 3.224 19.804l17.728-1.475z" }), /* @__PURE__ */ React.createElement("path", { d: "M415.632 355.448c-1.29-1.359-4.842-14.036-1.682-43.251 4.923-45.511 9.03-74.851 25.156-79.607 6.451-1.902 21.286 4.076 21.286 4.076l-10.966-4.076c-10.106 1.812-14.948-14.633-28.381-4.874-19.996 14.527-27.739 71.717-27.736 112.482.001 20.534 5.617 20.837 5.617 16.726l16.706-1.476z" }), /* @__PURE__ */ React.createElement("path", { d: "M375.928 360.879c-1.289-1.359-4.841-14.036-1.681-43.251 4.922-45.511 9.03-74.851 25.156-79.607 6.451-1.903 21.285 4.076 21.285 4.076l-10.965-4.076c-10.106 1.811-14.948-14.633-28.381-4.874-19.996 14.527-27.739 71.716-27.737 112.481.002 20.534 5.618 20.837 5.618 16.727l16.705-1.476z" })), /* @__PURE__ */ React.createElement("path", { d: "M206.436 232.014c-48.314 11.213-105.416 48.196-143.065 95.843h525.711s-13.006-22.017-41.071-43.444c-41.071-31.356-92.444-47.8-132.112-55.793-69.137-13.932-142.38-12.175-209.463 3.394z", fill: "#73DC78", stroke: "#73DC78", strokeWidth: 0.718 }), /* @__PURE__ */ React.createElement("mask", { id: "prefix__prefix__b", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 62, y: 220, width: 528, height: 110 }, /* @__PURE__ */ React.createElement("path", { d: "M206.436 233.382c-48.314 11.213-105.416 48.196-143.065 95.844h525.711s-13.006-22.018-41.071-43.445c-41.071-31.356-92.444-47.799-132.112-55.793-69.137-13.932-142.38-12.175-209.463 3.394z", fill: "#00004B", stroke: "#00004B", strokeWidth: 0.718 })), /* @__PURE__ */ React.createElement("g", { mask: "url(#prefix__prefix__b)", stroke: "#00004B", strokeWidth: 0.718 }, /* @__PURE__ */ React.createElement("path", { d: "M508.31 334.578c-1.369-1.357.685-23.079 7.53-36.656 7.56-14.995 25.327-33.262 42.44-38.013 13.69-3.802 14.375-3.847 13.006-3.394l-15.06-12.219c-10.724 1.81-24.126 9.636-37.648 20.364-10.267 8.146-25.226 31.905-26.696 51.59-1.095 14.663-.914 18.328-.001 18.328h16.429z" }), /* @__PURE__ */ React.createElement("path", { d: "M480.93 289.098c-6.091 16.97-8.828 42.087-7.459 43.444h-16.429c-.913 0-1.096-.271-.001-14.934 1.623-21.722 11.568-54.304 32.104-70.597 13.522-10.728 18.71-9.05 29.434-10.861l10.952 7.467s-4.107-.543-10.952 1.358c-17.113 4.752-31.98 28.328-37.649 44.123z" }), /* @__PURE__ */ React.createElement("path", { d: "M445.334 287.062c-6.09 16.97-8.827 42.086-7.459 43.444h-16.429c-.912 0-1.096-.272 0-14.934 1.622-21.722 13.62-63.807 34.156-80.1 13.522-10.729 16.657.452 27.382-1.358l10.952 7.467s-8.9-4.616-15.745-2.715c-17.113 4.752-27.188 32.401-32.857 48.196zm-36.965-.712c-5.476 20.398-7.529 44.835-6.16 46.193l-17.728-2.749c.001 4.107-1.096-.272 0-14.934 2.279-30.513 16.359-73.956 36.894-90.249 13.522-10.728 5.02-1.584 15.744-3.394l10.268 5.431s1.369 1.493-5.476 3.394c-17.113 4.752-29.192 40.107-33.542 56.308zm-44.493 9.536c-2.409 20.974-3.006 35.182-1.638 36.539l-17.727 1.475c0 4.107-1.854.83-1.855-19.686-.002-30.596 13.005-78.063 38.332-100.464 12.924-11.431 6.389-2.263 17.113-4.073l11.637 4.073s-1.369 4.208-8.214 6.109c-17.113 4.752-35.325 55.814-37.648 76.027z" }), /* @__PURE__ */ React.createElement("path", { d: "M325.273 332.845c-1.368-1.357-3.353-12.521 0-41.71 4.524-39.371 18.75-72.213 35.863-76.965 6.845-1.901 11.637 0 11.637 0l-11.637-4.073c-10.724 1.81-9.702-9.75-23.957 0-21.22 14.514-35.597 66.783-35.595 107.512.001 20.515 5.962 20.818 5.961 16.711l17.728-1.475z" }), /* @__PURE__ */ React.createElement("path", { d: "M284.205 333.669c-1.369-1.358-5.138-14.024-1.785-43.213 4.524-39.371 16.257-74.784 33.37-79.536 6.845-1.901 15.914 4.073 15.914 4.073l-11.636-4.073c-10.725 1.81-14.494-12.351-28.749-2.601-21.22 14.514-30.806 69.384-30.803 110.113.001 20.515 5.961 20.818 5.961 16.711l17.728-1.474z" }), /* @__PURE__ */ React.createElement("path", { d: "M243.131 334.409c-1.369-1.357-5.138-14.023-1.785-43.212 4.523-39.371 9.583-74.784 26.696-79.536 6.845-1.901 22.588 4.073 22.588 4.073l-11.637-4.073c-10.724 1.81-21.607-11.735-35.862-1.985-21.22 14.514-23.692 68.768-23.69 109.497.002 20.515 5.962 20.818 5.962 16.711l17.728-1.475z" }), /* @__PURE__ */ React.createElement("path", { d: "M202.06 333.901c-1.368-1.358-5.138-14.024-1.784-43.213 4.523-39.371 9.583-74.784 26.696-79.536 6.845-1.901 22.588 4.073 22.588 4.073l-11.637-4.073c-10.724 1.81-21.607-11.735-35.863-1.985-21.22 14.514-23.691 68.768-23.689 109.497.001 20.515 5.962 20.818 5.962 16.711l17.727-1.474z" }), /* @__PURE__ */ React.createElement("path", { d: "M158.252 337.974c-1.369-1.357 0 0 0-48.197 0-28.51 7.798-69.799 24.911-74.551 6.845-1.901 22.588 4.073 22.588 4.073l-11.637-4.073c-10.724 1.81-14.493-9.75-28.748 0-21.221 14.514-24.842 48.756-28.066 104.419-1.186 20.482 3.224 23.911 3.224 19.804l17.728-1.475z" }), /* @__PURE__ */ React.createElement("path", { d: "M118.552 356.817c-1.29-1.359-4.842-14.036-1.682-43.251 4.922-45.511 9.03-74.851 25.156-79.607 6.451-1.902 21.285 4.077 21.285 4.077l-10.965-4.077c-10.106 1.812-14.948-14.633-28.381-4.874-19.996 14.527-27.739 71.717-27.737 112.482.002 20.534 5.618 20.837 5.618 16.726l16.706-1.476z" }), /* @__PURE__ */ React.createElement("path", { d: "M78.85 362.248c-1.29-1.359-4.841-14.036-1.681-43.251 4.922-45.511 9.03-74.851 25.156-79.607 6.451-1.903 21.285 4.076 21.285 4.076l-10.965-4.076c-10.106 1.812-14.948-14.633-28.381-4.874-19.996 14.527-27.739 71.716-27.737 112.482.002 20.533 5.618 20.836 5.618 16.726l16.705-1.476z" })), /* @__PURE__ */ React.createElement("path", { opacity: 0.9, d: "M45.481 315.125C7.87 340.104-59.008 288.932-88 298.242v32.174l993.238 8.667c-21.94-20.281-76.847-40.265-111.577-30.119-52.708 15.398-65.171 13.013-173.305-21.36-61.465-19.538-94.029 5.804-125.372 21.763-31.344 15.959-65.396-32.013-165.336-6.218-53.538 13.819-65.821-24.659-113.619-19.605-25.712 2.719-50.149 23.923-77.574 9.501-33.847-17.799-49.093-7.063-92.974 22.08z", fill: "#E8EAED" }), /* @__PURE__ */ React.createElement("path", { opacity: 0.9, d: "M72.179 302.803c-37.635 34.109-85.99-10.498-115 2.214l.001 43.934 977.494 7.929c-33.542-.272-61.862-64.326-113.037-58.96-67.676 7.097-49.833 46.936-158.033 0-82.142-35.633-117.812 8.803-154.017 17.888-65.714 16.49-82.142-58.184-156.846-23.254-51.451 24.057-65.861-33.672-113.688-26.771-25.728 3.713-27.839 51.83-55.281 32.137-33.867-24.304-67.686-34.912-111.593 4.883z", fill: "#E8EAED" }), /* @__PURE__ */ React.createElement("rect", { x: 586.12, y: 191.37, width: 3.481, height: 6.573, rx: 1.74, transform: "rotate(-62.403 586.12 191.37)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.66, y: -0.254, width: 3.481, height: 6.573, rx: 1.74, transform: "scale(-1 1) rotate(-66.015 -192.863 623.104)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 607.958, y: 199.888, width: 3.481, height: 6.573, rx: 1.74, transform: "rotate(-74.77 607.958 199.888)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 619.716, y: 203.731, width: 3.481, height: 6.573, rx: 1.74, transform: "rotate(-81.66 619.716 203.731)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 631.5, y: 205.979, width: 3.481, height: 6.573, rx: 1.74, transform: "rotate(-90 631.5 205.979)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.59, y: -0.389, width: 3.481, height: 6.573, rx: 1.74, transform: "scale(-1 1) rotate(-78.381 -207.233 506.311)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.564, y: -0.427, width: 3.481, height: 6.573, rx: 1.74, transform: "scale(-1 1) rotate(-82.102 -207.806 475.02)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 576.311, y: 186.061, width: 3.481, height: 6.573, rx: 1.74, transform: "rotate(-61.435 576.311 186.061)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.664, y: -0.242, width: 3.481, height: 6.573, rx: 1.74, transform: "scale(-1 1) rotate(-65.046 -198.804 638.565)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 596.664, y: 196.03, width: 3.481, height: 6.573, rx: 1.74, transform: "rotate(-68.612 596.664 196.03)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.629, y: -0.323, width: 3.481, height: 6.573, rx: 1.74, transform: "scale(-1 1) rotate(-72.223 -200.619 560.327)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 566.497, y: 180.001, width: 3.481, height: 6.573, rx: 1.74, transform: "rotate(-60.7 566.497 180.001)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.667, y: -0.234, width: 3.481, height: 6.573, rx: 1.74, transform: "scale(-1 1) rotate(-64.312 -206.093 651.72)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 556.681, y: 174.716, width: 3.481, height: 6.573, rx: 1.74, transform: "rotate(-60.7 556.681 174.716)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.667, y: -0.234, width: 3.481, height: 6.573, rx: 1.74, transform: "scale(-1 1) rotate(-64.312 -214.86 657.448)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 614.018, y: 200.138, width: 1.387, height: 6.573, rx: 0.694, transform: "rotate(-70.984 614.018 200.138)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 625.762, y: 203.252, width: 1.387, height: 6.573, rx: 0.694, transform: "rotate(-77.874 625.762 203.252)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.572, y: -0.415, width: 1.387, height: 6.573, rx: 0.694, transform: "scale(-1 1) rotate(-80.941 -209.543 484.866)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.544, y: -0.451, width: 1.387, height: 6.573, rx: 0.694, transform: "scale(-1 1) rotate(-84.661 -210.007 455.205)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 581.597, y: 187.996, width: 1.387, height: 6.573, rx: 0.694, transform: "rotate(-61.295 581.597 187.996)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.665, y: -0.241, width: 1.387, height: 6.573, rx: 0.694, transform: "scale(-1 1) rotate(-64.906 -194.448 636.595)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 602.694, y: 197.108, width: 1.386, height: 6.573, rx: 0.693, transform: "rotate(-71.099 602.694 197.108)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.614, y: -0.35, width: 1.386, height: 6.573, rx: 0.693, transform: "scale(-1 1) rotate(-74.71 -203.134 536.275)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 571.797, y: 181.897, width: 1.387, height: 6.573, rx: 0.694, transform: "rotate(-55.414 571.797 181.897)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.686, y: -0.171, width: 1.387, height: 6.573, rx: 0.694, transform: "scale(-1 1) rotate(-59.025 -185.876 709.639)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 591.365, y: 193.333, width: 1.387, height: 6.573, rx: 0.694, transform: "rotate(-71.208 591.365 193.333)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.635, y: -0.312, width: 1.387, height: 6.573, rx: 0.694, transform: "scale(-1 1) rotate(-71.167 -202.472 571.883)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 562.047, y: 176.298, width: 1.387, height: 6.573, rx: 0.694, transform: "rotate(-59.834 562.047 176.298)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.671, y: -0.224, width: 1.387, height: 6.573, rx: 0.694, transform: "scale(-1 1) rotate(-63.445 -208.712 663.3)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.671, y: -0.224, width: 1.387, height: 6.573, rx: 0.694, transform: "scale(-1 1) rotate(-63.445 -217.442 669.023)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 769.12, y: 191.37, width: 3.481, height: 6.573, rx: 1.74, transform: "rotate(-62.403 769.12 191.37)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.66, y: -0.254, width: 3.481, height: 6.573, rx: 1.74, transform: "scale(-1 1) rotate(-66.015 -284.363 763.963)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 790.958, y: 199.888, width: 3.481, height: 6.573, rx: 1.74, transform: "rotate(-74.77 790.958 199.888)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 802.716, y: 203.731, width: 3.481, height: 6.573, rx: 1.74, transform: "rotate(-81.66 802.716 203.731)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 814.5, y: 205.979, width: 3.481, height: 6.573, rx: 1.74, transform: "rotate(-90 814.5 205.979)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.59, y: -0.389, width: 3.481, height: 6.573, rx: 1.74, transform: "scale(-1 1) rotate(-78.381 -298.733 618.539)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.564, y: -0.427, width: 3.481, height: 6.573, rx: 1.74, transform: "scale(-1 1) rotate(-82.102 -299.306 580.09)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 759.311, y: 186.061, width: 3.481, height: 6.573, rx: 1.74, transform: "rotate(-61.435 759.311 186.061)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.664, y: -0.242, width: 3.481, height: 6.573, rx: 1.74, transform: "scale(-1 1) rotate(-65.046 -290.304 782.063)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 779.664, y: 196.03, width: 3.481, height: 6.573, rx: 1.74, transform: "rotate(-68.612 779.664 196.03)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.629, y: -0.323, width: 3.481, height: 6.573, rx: 1.74, transform: "scale(-1 1) rotate(-72.223 -292.119 685.751)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 749.497, y: 180.001, width: 3.481, height: 6.573, rx: 1.74, transform: "rotate(-60.7 749.497 180.001)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.667, y: -0.234, width: 3.481, height: 6.573, rx: 1.74, transform: "scale(-1 1) rotate(-64.312 -297.593 797.269)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 739.681, y: 174.716, width: 3.481, height: 6.573, rx: 1.74, transform: "rotate(-60.7 739.681 174.716)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.667, y: -0.234, width: 3.481, height: 6.573, rx: 1.74, transform: "scale(-1 1) rotate(-64.312 -306.36 802.997)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 797.018, y: 200.138, width: 1.387, height: 6.573, rx: 0.694, transform: "rotate(-70.984 797.018 200.138)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 808.762, y: 203.252, width: 1.387, height: 6.573, rx: 0.694, transform: "rotate(-77.874 808.762 203.252)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.572, y: -0.415, width: 1.387, height: 6.573, rx: 0.694, transform: "scale(-1 1) rotate(-80.941 -301.043 592.11)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.544, y: -0.451, width: 1.387, height: 6.573, rx: 0.694, transform: "scale(-1 1) rotate(-84.661 -301.507 555.654)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 764.597, y: 187.996, width: 1.387, height: 6.573, rx: 0.694, transform: "rotate(-61.295 764.597 187.996)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.665, y: -0.241, width: 1.387, height: 6.573, rx: 0.694, transform: "scale(-1 1) rotate(-64.906 -285.948 780.48)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 785.694, y: 197.108, width: 1.386, height: 6.573, rx: 0.693, transform: "rotate(-71.099 785.694 197.108)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.614, y: -0.35, width: 1.386, height: 6.573, rx: 0.693, transform: "scale(-1 1) rotate(-74.71 -294.634 656.147)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 754.797, y: 181.897, width: 1.387, height: 6.573, rx: 0.694, transform: "rotate(-55.414 754.797 181.897)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.686, y: -0.171, width: 1.387, height: 6.573, rx: 0.694, transform: "scale(-1 1) rotate(-59.025 -277.376 871.28)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 774.365, y: 193.333, width: 1.387, height: 6.573, rx: 0.694, transform: "rotate(-71.208 774.365 193.333)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.635, y: -0.312, width: 1.387, height: 6.573, rx: 0.694, transform: "scale(-1 1) rotate(-71.167 -293.972 699.765)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 745.047, y: 176.298, width: 1.387, height: 6.573, rx: 0.694, transform: "rotate(-59.834 745.047 176.298)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.671, y: -0.224, width: 1.387, height: 6.573, rx: 0.694, transform: "scale(-1 1) rotate(-63.445 -300.212 811.32)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.671, y: -0.224, width: 1.387, height: 6.573, rx: 0.694, transform: "scale(-1 1) rotate(-63.445 -308.942 817.042)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 228.12, y: 195.37, width: 3.481, height: 6.573, rx: 1.74, transform: "rotate(-62.403 228.12 195.37)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.66, y: -0.254, width: 3.481, height: 6.573, rx: 1.74, transform: "scale(-1 1) rotate(-66.015 -10.784 349.545)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 249.958, y: 203.888, width: 3.481, height: 6.573, rx: 1.74, transform: "rotate(-74.77 249.958 203.888)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 261.716, y: 207.731, width: 3.481, height: 6.573, rx: 1.74, transform: "rotate(-81.66 261.716 207.731)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 273.5, y: 209.979, width: 3.481, height: 6.573, rx: 1.74, transform: "rotate(-90 273.5 209.979)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.59, y: -0.389, width: 3.481, height: 6.573, rx: 1.74, transform: "scale(-1 1) rotate(-78.381 -25.78 288.762)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.564, y: -0.427, width: 3.481, height: 6.573, rx: 1.74, transform: "scale(-1 1) rotate(-82.102 -26.51 271.473)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 218.311, y: 190.061, width: 3.481, height: 6.573, rx: 1.74, transform: "rotate(-61.435 218.311 190.061)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.664, y: -0.242, width: 3.481, height: 6.573, rx: 1.74, transform: "scale(-1 1) rotate(-65.046 -16.668 359.842)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 238.664, y: 200.03, width: 3.481, height: 6.573, rx: 1.74, transform: "rotate(-68.612 238.664 200.03)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.629, y: -0.323, width: 3.481, height: 6.573, rx: 1.74, transform: "scale(-1 1) rotate(-72.223 -18.877 316.962)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 208.497, y: 184.001, width: 3.481, height: 6.573, rx: 1.74, transform: "rotate(-60.7 208.497 184.001)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.667, y: -0.234, width: 3.481, height: 6.573, rx: 1.74, transform: "scale(-1 1) rotate(-64.312 -23.912 368.986)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 198.681, y: 178.716, width: 3.481, height: 6.573, rx: 1.74, transform: "rotate(-60.7 198.681 178.716)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.667, y: -0.234, width: 3.481, height: 6.573, rx: 1.74, transform: "scale(-1 1) rotate(-64.312 -32.68 374.714)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 256.018, y: 204.138, width: 1.387, height: 6.573, rx: 0.694, transform: "rotate(-70.984 256.018 204.138)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 267.762, y: 207.252, width: 1.387, height: 6.573, rx: 0.694, transform: "rotate(-77.874 267.762 207.252)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.572, y: -0.415, width: 1.387, height: 6.573, rx: 0.694, transform: "scale(-1 1) rotate(-80.941 -28.2 277.066)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.544, y: -0.451, width: 1.387, height: 6.573, rx: 0.694, transform: "scale(-1 1) rotate(-84.661 -28.811 260.699)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 223.597, y: 191.996, width: 1.387, height: 6.573, rx: 0.694, transform: "rotate(-61.295 223.597 191.996)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.665, y: -0.241, width: 1.387, height: 6.573, rx: 0.694, transform: "scale(-1 1) rotate(-64.906 -12.303 357.112)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 244.694, y: 201.108, width: 1.386, height: 6.573, rx: 0.693, transform: "rotate(-71.099 244.694 201.108)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.614, y: -0.35, width: 1.386, height: 6.573, rx: 0.693, transform: "scale(-1 1) rotate(-74.71 -21.514 303.77)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 213.797, y: 185.897, width: 1.387, height: 6.573, rx: 0.694, transform: "rotate(-55.414 213.797 185.897)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.686, y: -0.171, width: 1.387, height: 6.573, rx: 0.694, transform: "scale(-1 1) rotate(-59.025 -3.343 395.42)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 233.365, y: 197.333, width: 1.387, height: 6.573, rx: 0.694, transform: "rotate(-71.208 233.365 197.333)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.635, y: -0.312, width: 1.387, height: 6.573, rx: 0.694, transform: "scale(-1 1) rotate(-71.167 -20.677 323.708)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 204.047, y: 180.298, width: 1.387, height: 6.573, rx: 0.694, transform: "rotate(-59.834 204.047 180.298)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.671, y: -0.224, width: 1.387, height: 6.573, rx: 0.694, transform: "scale(-1 1) rotate(-63.445 -26.477 375.73)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.671, y: -0.224, width: 1.387, height: 6.573, rx: 0.694, transform: "scale(-1 1) rotate(-63.445 -35.206 381.454)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 45.12, y: 195.37, width: 3.481, height: 6.573, rx: 1.74, transform: "rotate(-62.403 45.12 195.37)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.66, y: -0.254, width: 3.481, height: 6.573, rx: 1.74, transform: "scale(-1 1) rotate(-66.015 80.716 208.687)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 66.957, y: 203.888, width: 3.481, height: 6.573, rx: 1.74, transform: "rotate(-74.77 66.957 203.888)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 78.716, y: 207.731, width: 3.481, height: 6.573, rx: 1.74, transform: "rotate(-81.66 78.716 207.731)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 90.5, y: 209.979, width: 3.481, height: 6.573, rx: 1.74, transform: "rotate(-90 90.5 209.979)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.59, y: -0.389, width: 3.481, height: 6.573, rx: 1.74, transform: "scale(-1 1) rotate(-78.381 65.72 176.534)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.564, y: -0.427, width: 3.481, height: 6.573, rx: 1.74, transform: "scale(-1 1) rotate(-82.102 64.99 166.402)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 35.311, y: 190.061, width: 3.481, height: 6.573, rx: 1.74, transform: "rotate(-61.435 35.311 190.061)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.664, y: -0.242, width: 3.481, height: 6.573, rx: 1.74, transform: "scale(-1 1) rotate(-65.046 74.832 216.345)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 55.663, y: 200.03, width: 3.481, height: 6.573, rx: 1.74, transform: "rotate(-68.612 55.663 200.03)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.629, y: -0.323, width: 3.481, height: 6.573, rx: 1.74, transform: "scale(-1 1) rotate(-72.223 72.623 191.538)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 25.497, y: 184.001, width: 3.481, height: 6.573, rx: 1.74, transform: "rotate(-60.7 25.497 184.001)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.667, y: -0.234, width: 3.481, height: 6.573, rx: 1.74, transform: "scale(-1 1) rotate(-64.312 67.588 223.437)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 15.681, y: 178.716, width: 3.481, height: 6.573, rx: 1.74, transform: "rotate(-60.7 15.68 178.716)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.667, y: -0.234, width: 3.481, height: 6.573, rx: 1.74, transform: "scale(-1 1) rotate(-64.312 58.82 229.165)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 73.018, y: 204.138, width: 1.387, height: 6.573, rx: 0.694, transform: "rotate(-70.984 73.018 204.138)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 84.762, y: 207.252, width: 1.387, height: 6.573, rx: 0.694, transform: "rotate(-77.874 84.762 207.252)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.572, y: -0.415, width: 1.387, height: 6.573, rx: 0.694, transform: "scale(-1 1) rotate(-80.941 63.3 169.821)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.544, y: -0.451, width: 1.387, height: 6.573, rx: 0.694, transform: "scale(-1 1) rotate(-84.661 62.689 160.25)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 40.597, y: 191.996, width: 1.387, height: 6.573, rx: 0.694, transform: "rotate(-61.295 40.597 191.996)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.665, y: -0.241, width: 1.387, height: 6.573, rx: 0.694, transform: "scale(-1 1) rotate(-64.906 79.197 213.226)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 61.694, y: 201.108, width: 1.386, height: 6.573, rx: 0.693, transform: "rotate(-71.099 61.694 201.108)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.614, y: -0.35, width: 1.386, height: 6.573, rx: 0.693, transform: "scale(-1 1) rotate(-74.71 69.986 183.899)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 30.797, y: 185.897, width: 1.387, height: 6.573, rx: 0.694, transform: "rotate(-55.414 30.797 185.897)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.686, y: -0.171, width: 1.387, height: 6.573, rx: 0.694, transform: "scale(-1 1) rotate(-59.025 88.157 233.778)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 50.365, y: 197.333, width: 1.387, height: 6.573, rx: 0.694, transform: "rotate(-71.208 50.365 197.333)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.635, y: -0.312, width: 1.387, height: 6.573, rx: 0.694, transform: "scale(-1 1) rotate(-71.167 70.823 195.825)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 21.047, y: 180.298, width: 1.387, height: 6.573, rx: 0.694, transform: "rotate(-59.834 21.047 180.298)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.671, y: -0.224, width: 1.387, height: 6.573, rx: 0.694, transform: "scale(-1 1) rotate(-63.445 65.023 227.71)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.671, y: -0.224, width: 1.387, height: 6.573, rx: 0.694, transform: "scale(-1 1) rotate(-63.445 56.293 233.434)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 410.509, y: 187.193, width: 3.481, height: 6.573, rx: 1.74, transform: "rotate(-62.403 410.509 187.193)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.66, y: -0.254, width: 3.481, height: 6.573, rx: 1.74, transform: "scale(-1 1) rotate(-66.015 -105.771 481.993)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 432.344, y: 195.711, width: 3.481, height: 6.573, rx: 1.74, transform: "rotate(-74.77 432.344 195.711)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.59, y: -0.389, width: 3.481, height: 6.573, rx: 1.74, transform: "scale(-1 1) rotate(-78.381 -119.487 393.458)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 400.696, y: 181.883, width: 3.481, height: 6.573, rx: 1.74, transform: "rotate(-61.435 400.696 181.883)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.664, y: -0.242, width: 3.481, height: 6.573, rx: 1.74, transform: "scale(-1 1) rotate(-65.046 -111.772 494.85)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 421.052, y: 191.853, width: 3.481, height: 6.573, rx: 1.74, transform: "rotate(-68.612 421.052 191.853)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.629, y: -0.323, width: 3.481, height: 6.573, rx: 1.74, transform: "scale(-1 1) rotate(-72.223 -113.176 434.451)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 390.884, y: 175.823, width: 3.481, height: 6.573, rx: 1.74, transform: "rotate(-60.7 390.884 175.823)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.667, y: -0.234, width: 3.481, height: 6.573, rx: 1.74, transform: "scale(-1 1) rotate(-64.312 -119.109 505.981)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 381.067, y: 170.538, width: 3.481, height: 6.573, rx: 1.74, transform: "rotate(-60.7 381.067 170.538)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.667, y: -0.234, width: 3.481, height: 6.573, rx: 1.74, transform: "scale(-1 1) rotate(-64.312 -127.876 511.71)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 438.405, y: 195.962, width: 1.387, height: 6.573, rx: 0.694, transform: "rotate(-70.984 438.405 195.962)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.572, y: -0.415, width: 1.387, height: 6.573, rx: 0.694, transform: "scale(-1 1) rotate(-80.941 -121.683 376.931)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 405.981, y: 183.819, width: 1.387, height: 6.573, rx: 0.694, transform: "rotate(-61.295 405.981 183.819)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.665, y: -0.241, width: 1.387, height: 6.573, rx: 0.694, transform: "scale(-1 1) rotate(-64.906 -107.425 492.495)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 427.08, y: 192.931, width: 1.386, height: 6.573, rx: 0.693, transform: "rotate(-71.099 427.08 192.931)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.614, y: -0.35, width: 1.386, height: 6.573, rx: 0.693, transform: "scale(-1 1) rotate(-74.71 -115.564 415.878)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 396.184, y: 177.72, width: 1.387, height: 6.573, rx: 0.694, transform: "rotate(-55.414 396.184 177.72)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.686, y: -0.171, width: 1.387, height: 6.573, rx: 0.694, transform: "scale(-1 1) rotate(-59.025 -99.257 548.017)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 415.754, y: 189.156, width: 1.387, height: 6.573, rx: 0.694, transform: "rotate(-71.208 415.754 189.156)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.635, y: -0.312, width: 1.387, height: 6.573, rx: 0.694, transform: "scale(-1 1) rotate(-71.167 -115.086 443.581)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: 386.434, y: 172.122, width: 1.387, height: 6.573, rx: 0.694, transform: "rotate(-59.834 386.434 172.122)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.671, y: -0.224, width: 1.387, height: 6.573, rx: 0.694, transform: "scale(-1 1) rotate(-63.445 -121.785 515.122)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("rect", { x: -0.671, y: -0.224, width: 1.387, height: 6.573, rx: 0.694, transform: "scale(-1 1) rotate(-63.445 -130.515 520.844)", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("path", { d: "M446.682 197.054c-.409-.342-2.134-1.031-2.632.237-.616 1.571 4.348 4.416 5.602 3.287 1.403-1.264-.578-2.223-.545-1.847m17.569-1.164c.448-.29 2.244-.765 2.584.554.421 1.634-4.851 3.857-5.96 2.583-1.239-1.424 1.408-2.573 1.653-2.17", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("path", { d: "M444.309 224.98v-15.896a2.5 2.5 0 012.5-2.5h19.671a2.5 2.5 0 012.5 2.5v15.896a2.5 2.5 0 01-2.5 2.5h-19.671a2.5 2.5 0 01-2.5-2.5z", fill: "#00004B", stroke: "#00004B" }), /* @__PURE__ */ React.createElement("path", { d: "M467.48 211.635h-21.671v-7.061c0-5.984 4.851-10.836 10.835-10.836 5.985 0 10.836 4.852 10.836 10.836v7.061z", stroke: "#00004B", strokeWidth: 4 }), /* @__PURE__ */ React.createElement("path", { d: "M459 214.444c0 1.35-1.119 2.445-2.5 2.445s-2.5-1.095-2.5-2.445c0-1.35 1.119-2.444 2.5-2.444s2.5 1.094 2.5 2.444z", fill: "#868CA2" }), /* @__PURE__ */ React.createElement("path", { d: "M455.818 214.667h1.364L459 220h-5l1.818-5.333z", fill: "#868CA2" }), /* @__PURE__ */ React.createElement("path", { d: "M559.332 276.304h-20.386a2.99 2.99 0 01-3.001-3.007c.219-37.767-.019-108.562-.019-112.138 0-4.908 7.173-6.041 8.683-6.041 3.398 0 3.02 1.133 3.775 1.51.755.378 2.643-.377 4.53 0l3.88.685a2.993 2.993 0 012.48 3.014c-.496 22.264-1.104 63.122.058 66.898 1.208 3.927.504 9.69 0 12.081v36.998z", fill: "#00004B", stroke: "#696F88" }), /* @__PURE__ */ React.createElement("mask", { id: "prefix__prefix__c", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 535, y: 154, width: 25, height: 123 }, /* @__PURE__ */ React.createElement("path", { d: "M558.849 276H536c.246-36.815 0-111.3 0-114.969 0-4.9 8.048-6.031 9.213-6.031.369 0 3.686 3.016 5.528 1.508.257-.211 1.106.377 2.211.377l3.216.411a2.992 2.992 0 012.621 3.033c-.484 22.257-1.072 62.905.06 66.668 1.179 3.92.491 9.675 0 12.062V276z", fill: "#00004B", stroke: "#C2C7D0" })), /* @__PURE__ */ React.createElement("g", { mask: "url(#prefix__prefix__c)", stroke: "#696F88" }, /* @__PURE__ */ React.createElement("path", { d: "M538.568 158.741c1.259 1.887 5.135 9.438 3.021 10.948-2.115 1.51-7.677.629-10.194 0m17.744-10.571c-1.007 2.14-4.681 10.269-5.285 13.591-.755 4.153-6.041 3.02-11.704 0m0 4.531c1.888.377 7.173 2.265 9.439 6.795 2.265 4.53 5.285 9.816 6.04 6.418.755-3.398-3.02-9.816-1.51-12.458 1.51-2.643 9.816-16.234 6.795-19.632m8.306 3.776c-2.014 1.761-6.267 5.889-7.173 8.305-1.133 3.02-4.153 9.061-3.775 13.591.377 4.53 1.132 27.182-2.643 30.202-3.775 3.02-4.908 26.804-1.51 30.202 3.398 3.398 5.663 28.692-1.51 39.64m4.53 0c2.391-7.55 6.72-24.086 4.908-29.824-2.265-7.173 4.153-1.133 4.153 2.642 0 3.02 2.768 7.802 4.152 9.816m-8.305 18.876c.126-3.901.755-12.005 2.265-13.213 1.888-1.51 6.04-.755 6.04 1.132m-29.446-90.228c3.901 2.517 11.703 8.607 11.703 12.836 0 5.285-7.551 22.651-4.153 30.579 3.398 7.928-8.306 21.897-10.948 20.764" }), /* @__PURE__ */ React.createElement("path", { d: "M534.038 190.075c2.265 1.51 6.494 4.984 5.286 6.796-1.511 2.265-6.041 14.346-5.286 17.743m-.755 21.519c2.014-1.258 5.814-4.455 4.908-7.173-1.133-3.397-4.153-7.928-4.153-10.193m28.314-46.058c-1.887 3.524-5.889 13.742-6.795 26.427-1.133 15.856-4.908 21.519-6.041 26.804-1.132 5.285-1.72 19.162 9.983 22.56m2.853-42.946c-1.384 5.537-4.681 16.988-6.795 18.498-2.643 1.888-2.265 18.499 6.795 16.989m1.133-21.519c-1.133 1.636-3.549 5.663-4.153 8.683-.755 3.775-.378 6.796 3.02 7.173m-30.202 13.969c2.769-2.517 8.759-6.041 10.571 0 2.265 7.55 5.663 16.611 2.265 23.029-3.397 6.417-6.418 10.57-7.55 11.703m-3.776-29.825c1.007-1.761 3.625-4.228 6.041 0 3.02 5.286 1.888 12.836 1.51 15.856-.378 3.021-1.873 6.463-5.212 8.39m-2.339-19.338c1.762 1.133 4.984 4.153 3.776 7.173-1.208 3.02-.43 3.41-1.437 4.165" })), /* @__PURE__ */ React.createElement("path", { d: "M741.407 276.304h-20.386a2.992 2.992 0 01-3.002-3.007c.22-37.767-.019-108.562-.019-112.138 0-4.908 7.173-6.041 8.683-6.041 3.398 0 3.02 1.133 3.775 1.51.755.378 2.643-.377 4.531 0l3.879.685a2.993 2.993 0 012.48 3.014c-.496 22.264-1.103 63.122.059 66.898 1.208 3.927.503 9.69 0 12.081v36.998z", fill: "#00004B", stroke: "#696F88" }), /* @__PURE__ */ React.createElement("mask", { id: "prefix__prefix__d", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 717, y: 154, width: 26, height: 123 }, /* @__PURE__ */ React.createElement("path", { d: "M740.923 276h-22.849c.246-36.815 0-111.3 0-114.969 0-4.9 8.048-6.031 9.213-6.031.369 0 3.686 3.016 5.528 1.508.258-.211 1.106.377 2.212.377l3.216.411a2.992 2.992 0 012.62 3.033c-.483 22.257-1.072 62.905.06 66.668 1.179 3.92.491 9.675 0 12.062V276z", fill: "#00004B", stroke: "#C2C7D0" })), /* @__PURE__ */ React.createElement("g", { mask: "url(#prefix__prefix__d)", stroke: "#696F88" }, /* @__PURE__ */ React.createElement("path", { d: "M720.643 158.741c1.258 1.887 5.134 9.438 3.02 10.948-2.114 1.51-7.677.629-10.193 0m17.743-10.571c-1.006 2.14-4.681 10.269-5.285 13.591-.755 4.153-6.04 3.02-11.703 0m0 4.531c1.887.377 7.173 2.265 9.438 6.795 2.265 4.53 5.285 9.816 6.04 6.418.755-3.398-3.02-9.816-1.51-12.458 1.51-2.643 9.816-16.234 6.796-19.632m8.305 3.776c-2.013 1.761-6.267 5.889-7.173 8.305-1.132 3.02-4.153 9.061-3.775 13.591.377 4.53 1.132 27.182-2.643 30.202-3.775 3.02-4.908 26.804-1.51 30.202 3.398 3.398 5.663 28.692-1.51 39.64m4.53 0c2.391-7.55 6.72-24.086 4.908-29.824-2.265-7.173 4.153-1.133 4.153 2.642 0 3.02 2.768 7.802 4.153 9.816m-8.306 18.876c.126-3.901.755-12.005 2.265-13.213 1.888-1.51 6.041-.755 6.041 1.132M714.98 183.28c3.901 2.517 11.703 8.607 11.703 12.836 0 5.285-7.55 22.651-4.153 30.579 3.398 7.928-8.305 21.897-10.948 20.764" }), /* @__PURE__ */ React.createElement("path", { d: "M716.112 190.075c2.266 1.51 6.494 4.984 5.286 6.796-1.51 2.265-6.041 14.346-5.286 17.743m-.755 21.519c2.014-1.258 5.814-4.455 4.908-7.173-1.132-3.397-4.153-7.928-4.153-10.193m28.315-46.058c-1.888 3.524-5.89 13.742-6.796 26.427-1.133 15.856-4.908 21.519-6.04 26.804-1.133 5.285-1.721 19.162 9.982 22.56m2.854-42.946c-1.385 5.537-4.682 16.988-6.796 18.498-2.643 1.888-2.265 18.499 6.796 16.989m1.132-21.519c-1.132 1.636-3.549 5.663-4.153 8.683-.755 3.775-.377 6.796 3.021 7.173m-30.202 13.969c2.768-2.517 8.758-6.041 10.57 0 2.265 7.55 5.663 16.611 2.265 23.029-3.397 6.417-6.417 10.57-7.55 11.703m-3.775-29.825c1.006-1.761 3.624-4.228 6.04 0 3.02 5.286 1.888 12.836 1.51 15.856-.377 3.021-1.873 6.463-5.212 8.39m-2.338-19.338c1.761 1.133 4.983 4.153 3.775 7.173-1.208 3.02-.43 3.41-1.437 4.165" })), /* @__PURE__ */ React.createElement("path", { d: "M200.407 280.304h-20.386a2.992 2.992 0 01-3.002-3.007c.22-37.767-.019-108.562-.019-112.138 0-4.908 7.173-6.041 8.683-6.041 3.398 0 3.02 1.133 3.775 1.51.755.378 2.643-.377 4.531 0l3.879.685a2.993 2.993 0 012.48 3.014c-.496 22.264-1.103 63.122.059 66.898 1.208 3.927.503 9.69 0 12.081v36.998z", fill: "#00004B", stroke: "#696F88" }), /* @__PURE__ */ React.createElement("mask", { id: "prefix__prefix__e", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 176, y: 158, width: 26, height: 123 }, /* @__PURE__ */ React.createElement("path", { d: "M199.923 280h-22.849c.246-36.815 0-111.3 0-114.969 0-4.9 8.048-6.031 9.213-6.031.369 0 3.686 3.016 5.528 1.508.258-.211 1.106.377 2.212.377l3.216.411a2.992 2.992 0 012.62 3.033c-.483 22.257-1.072 62.905.06 66.668 1.179 3.92.491 9.675 0 12.062V280z", fill: "#00004B", stroke: "#C2C7D0" })), /* @__PURE__ */ React.createElement("g", { mask: "url(#prefix__prefix__e)", stroke: "#696F88" }, /* @__PURE__ */ React.createElement("path", { d: "M179.643 162.741c1.258 1.887 5.134 9.438 3.02 10.948-2.114 1.51-7.677.629-10.193 0m17.743-10.571c-1.006 2.14-4.681 10.269-5.285 13.591-.755 4.153-6.04 3.02-11.703 0m0 4.531c1.887.377 7.173 2.265 9.438 6.795 2.265 4.53 5.285 9.816 6.04 6.418.755-3.398-3.02-9.816-1.51-12.458 1.51-2.643 9.816-16.234 6.796-19.632m8.305 3.776c-2.013 1.761-6.267 5.889-7.173 8.305-1.132 3.02-4.153 9.061-3.775 13.591.377 4.53 1.132 27.182-2.643 30.202-3.775 3.02-4.908 26.804-1.51 30.202 3.398 3.398 5.663 28.692-1.51 39.64m4.53 0c2.391-7.55 6.72-24.086 4.908-29.824-2.265-7.173 4.153-1.133 4.153 2.642 0 3.02 2.768 7.802 4.153 9.816m-8.306 18.876c.126-3.901.755-12.005 2.265-13.213 1.888-1.51 6.041-.755 6.041 1.132M173.98 187.28c3.901 2.517 11.703 8.607 11.703 12.836 0 5.285-7.55 22.651-4.153 30.579 3.398 7.928-8.305 21.897-10.948 20.764" }), /* @__PURE__ */ React.createElement("path", { d: "M175.112 194.075c2.266 1.51 6.494 4.984 5.286 6.796-1.51 2.265-6.041 14.346-5.286 17.743m-.755 21.519c2.014-1.258 5.814-4.455 4.908-7.173-1.132-3.397-4.153-7.928-4.153-10.193m28.315-46.058c-1.888 3.524-5.89 13.742-6.796 26.427-1.133 15.856-4.908 21.519-6.04 26.804-1.133 5.285-1.721 19.162 9.982 22.56m2.854-42.946c-1.385 5.537-4.682 16.988-6.796 18.498-2.643 1.888-2.265 18.499 6.796 16.989m1.132-21.519c-1.132 1.636-3.549 5.663-4.153 8.683-.755 3.775-.377 6.796 3.021 7.173m-30.202 13.969c2.768-2.517 8.758-6.041 10.57 0 2.265 7.55 5.663 16.611 2.265 23.029-3.397 6.417-6.417 10.57-7.55 11.703m-3.775-29.825c1.006-1.761 3.624-4.228 6.04 0 3.02 5.286 1.888 12.836 1.51 15.856-.377 3.021-1.873 6.463-5.212 8.39m-2.338-19.338c1.761 1.133 4.983 4.153 3.775 7.173-1.208 3.02-.43 3.41-1.437 4.165" })), /* @__PURE__ */ React.createElement("path", { d: "M17.407 280.304H-2.98a2.992 2.992 0 01-3.002-3.007C-5.761 239.53-6 168.735-6 165.159c0-4.908 7.173-6.041 8.683-6.041 3.398 0 3.02 1.133 3.775 1.51.755.378 2.643-.377 4.53 0l3.88.685a2.993 2.993 0 012.48 3.014c-.496 22.264-1.103 63.122.059 66.898 1.208 3.927.503 9.69 0 12.081v36.998z", fill: "#00004B", stroke: "#696F88" }), /* @__PURE__ */ React.createElement("mask", { id: "prefix__prefix__f", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: -7, y: 158, width: 26, height: 123 }, /* @__PURE__ */ React.createElement("path", { d: "M16.923 280H-5.926c.246-36.815 0-111.3 0-114.969 0-4.9 8.048-6.031 9.213-6.031.369 0 3.686 3.016 5.528 1.508.258-.211 1.106.377 2.212.377l3.216.411a2.992 2.992 0 012.62 3.033c-.483 22.257-1.072 62.905.06 66.668 1.18 3.92.491 9.675 0 12.062V280z", fill: "#00004B", stroke: "#C2C7D0" })), /* @__PURE__ */ React.createElement("g", { mask: "url(#prefix__prefix__f)", stroke: "#696F88" }, /* @__PURE__ */ React.createElement("path", { d: "M-3.357 162.741c1.258 1.887 5.134 9.438 3.02 10.948-2.114 1.51-7.677.629-10.193 0m17.743-10.571c-1.006 2.14-4.681 10.269-5.285 13.591-.755 4.153-6.04 3.02-11.703 0m0 4.531c1.887.377 7.173 2.265 9.438 6.795 2.265 4.53 5.285 9.816 6.04 6.418.755-3.398-3.02-9.816-1.51-12.458 1.51-2.643 9.816-16.234 6.796-19.632m8.305 3.776c-2.013 1.761-6.267 5.889-7.173 8.305-1.132 3.02-4.153 9.061-3.775 13.591.377 4.53 1.132 27.182-2.643 30.202-3.775 3.02-4.908 26.804-1.51 30.202 3.398 3.398 5.663 28.692-1.51 39.64m4.53 0c2.391-7.55 6.72-24.086 4.908-29.824-2.265-7.173 4.153-1.133 4.153 2.642 0 3.02 2.768 7.802 4.153 9.816m-8.306 18.876c.126-3.901.755-12.005 2.265-13.213 1.888-1.51 6.04-.755 6.04 1.132M-9.02 187.28c3.9 2.517 11.703 8.607 11.703 12.836 0 5.285-7.55 22.651-4.153 30.579 3.398 7.928-8.305 21.897-10.948 20.764" }), /* @__PURE__ */ React.createElement("path", { d: "M20.427 176.709c-1.888 3.524-5.89 13.742-6.796 26.427-1.133 15.856-4.908 21.519-6.04 26.804-1.133 5.285-1.72 19.162 9.982 22.56m2.854-42.946c-1.385 5.537-4.682 16.988-6.796 18.498-2.643 1.888-2.265 18.499 6.796 16.989m1.132-21.519c-1.132 1.636-3.549 5.663-4.153 8.683-.755 3.775-.377 6.796 3.02 7.173m-30.201 13.969c2.768-2.517 8.758-6.041 10.57 0 2.265 7.55 5.663 16.611 2.265 23.029-3.397 6.417-6.417 10.57-7.55 11.703m-3.775-29.825c1.006-1.761 3.624-4.228 6.04 0 3.02 5.286 1.888 12.836 1.51 15.856-.377 3.021-1.873 6.463-5.212 8.39m-2.338-19.338c1.761 1.133 4.983 4.153 3.775 7.173-1.208 3.02-.43 3.41-1.437 4.165" })), /* @__PURE__ */ React.createElement("path", { d: "M924.407 276.304h-20.386a2.992 2.992 0 01-3.002-3.007c.22-37.767-.019-108.562-.019-112.138 0-4.908 7.173-6.041 8.683-6.041 3.398 0 3.02 1.133 3.775 1.51.755.378 2.643-.377 4.531 0l3.879.685a2.993 2.993 0 012.48 3.014c-.496 22.264-1.103 63.122.059 66.898 1.208 3.927.503 9.69 0 12.081v36.998z", fill: "#00004B", stroke: "#696F88" }), /* @__PURE__ */ React.createElement("mask", { id: "prefix__prefix__g", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 900, y: 154, width: 26, height: 123 }, /* @__PURE__ */ React.createElement("path", { d: "M923.923 276h-22.849c.246-36.815 0-111.3 0-114.969 0-4.9 8.048-6.031 9.213-6.031.369 0 3.686 3.016 5.528 1.508.258-.211 1.106.377 2.212.377l3.216.411a2.992 2.992 0 012.62 3.033c-.483 22.257-1.072 62.905.06 66.668 1.179 3.92.491 9.675 0 12.062V276z", fill: "#00004B", stroke: "#C2C7D0" })), /* @__PURE__ */ React.createElement("g", { mask: "url(#prefix__prefix__g)", stroke: "#696F88" }, /* @__PURE__ */ React.createElement("path", { d: "M903.643 158.741c1.258 1.887 5.134 9.438 3.02 10.948-2.114 1.51-7.677.629-10.193 0m17.743-10.571c-1.006 2.14-4.681 10.269-5.285 13.591-.755 4.153-6.04 3.02-11.703 0m0 4.531c1.887.377 7.173 2.265 9.438 6.795 2.265 4.53 5.285 9.816 6.04 6.418.755-3.398-3.02-9.816-1.51-12.458 1.51-2.643 9.816-16.234 6.796-19.632m8.305 3.776c-2.013 1.761-6.267 5.889-7.173 8.305-1.132 3.02-4.153 9.061-3.775 13.591.377 4.53 1.132 27.182-2.643 30.202-3.775 3.02-4.908 26.804-1.51 30.202 3.398 3.398 5.663 28.692-1.51 39.64m4.53 0c2.391-7.55 6.72-24.086 4.908-29.824-2.265-7.173 4.153-1.133 4.153 2.642 0 3.02 2.768 7.802 4.153 9.816m-8.306 18.876c.126-3.901.755-12.005 2.265-13.213 1.888-1.51 6.041-.755 6.041 1.132M897.98 183.28c3.901 2.517 11.703 8.607 11.703 12.836 0 5.285-7.55 22.651-4.153 30.579 3.398 7.928-8.305 21.897-10.948 20.764" }), /* @__PURE__ */ React.createElement("path", { d: "M899.112 190.075c2.266 1.51 6.494 4.984 5.286 6.796-1.51 2.265-6.041 14.346-5.286 17.743m-.755 21.519c2.014-1.258 5.814-4.455 4.908-7.173-1.132-3.397-4.153-7.928-4.153-10.193m28.315-46.058c-1.888 3.524-5.89 13.742-6.796 26.427-1.133 15.856-4.908 21.519-6.04 26.804-1.133 5.285-1.721 19.162 9.982 22.56m2.854-42.946c-1.385 5.537-4.682 16.988-6.796 18.498-2.643 1.888-2.265 18.499 6.796 16.989m1.132-21.519c-1.132 1.636-3.549 5.663-4.153 8.683-.755 3.775-.377 6.796 3.021 7.173m-30.202 13.969c2.768-2.517 8.758-6.041 10.57 0 2.265 7.55 5.663 16.611 2.265 23.029-3.397 6.417-6.417 10.57-7.55 11.703m-3.775-29.825c1.006-1.761 3.624-4.228 6.04 0 3.02 5.286 1.888 12.836 1.51 15.856-.377 3.021-1.873 6.463-5.212 8.39m-2.338-19.338c1.761 1.133 4.983 4.153 3.775 7.173-1.208 3.02-.43 3.41-1.437 4.165" })), /* @__PURE__ */ React.createElement("path", { d: "M383.407 280.304H360c.252-36.872 0-111.471 0-115.145 0-4.908 10.193-4.53 10.571-3.398.377 1.133 2.642 4.153 3.775 3.398.639-.426 1.441-1.503 2.034-2.41.393-.6 1.052-.988 1.769-.988h2.187a2.991 2.991 0 013.001 3.056c-.494 22.368-1.084 62.66.07 66.409 1.208 3.926.503 9.69 0 12.081v36.997z", fill: "#00004B", stroke: "#696F88" }), /* @__PURE__ */ React.createElement("mask", { id: "prefix__prefix__h", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 359, y: 160, width: 26, height: 121 }, /* @__PURE__ */ React.createElement("path", { d: "M383.407 280.304H360c.252-36.872 0-111.471 0-115.145 0-4.908 10.193-4.53 10.571-3.398.377 1.133 2.642 4.153 3.775 3.398.639-.426 1.441-1.503 2.034-2.41.393-.6 1.052-.988 1.769-.988h2.187a2.991 2.991 0 013.001 3.056c-.494 22.368-1.084 62.66.07 66.409 1.208 3.926.503 9.69 0 12.081v36.997z", fill: "#00004B", stroke: "#000" })), /* @__PURE__ */ React.createElement("g", { mask: "url(#prefix__prefix__h)", stroke: "#696F88" }, /* @__PURE__ */ React.createElement("path", { d: "M388.313 236.888c-3.398-.755-10.344-4.228-10.948-12.08-.755-9.816 2.265-14.724 0-19.632-2.265-4.907-8.306-12.08-9.816-16.988-1.51-4.908-7.173-14.346-4.53-20.387 2.114-4.832 2.391-11.325 2.265-13.968m.001 131.002c-2.265-4.657-6.947-15.252-7.551-20.387m12.081 18.121c-2.517-3.901-7.097-14.421-5.285-25.294 2.265-13.591 4.908-26.049 3.398-30.202-1.511-4.153-2.643-23.406-9.061-30.957m13.591 86.453c-2.517-5.033-7.249-16.686-6.041-23.029 1.511-7.928 3.398-9.438 3.398-12.08 0-2.643-1.132-10.949.755-10.949 1.888 0 .755 6.418 3.775 7.928 3.021 1.51 5.286 10.571 3.776 12.836-1.51 2.265-6.041 16.611-3.776 26.049m6.041 0c-1.51-3.901-3.926-13.137-1.51-18.876 2.416-5.738 5.537-11.451 6.795-13.591m-15.101 15.101c-.251-4.53-.226-13.893 1.888-15.101 2.643-1.51 1.653 13.214-1.888 15.101z" }), /* @__PURE__ */ React.createElement("path", { d: "M357.357 211.972c2.643 3.775 7.55 13.365 6.04 21.519-1.51 8.155-4.656 15.479-6.04 18.121m-2.265-72.862c4.656 4.53 14.27 16.158 15.478 26.427 1.51 12.836 1.133 23.784 6.418 29.069 5.286 5.286 9.061 12.836 8.683 13.969m-16.234-90.229c-1.258 5.411-3.02 17.744 0 23.784 3.775 7.551 6.796 19.631 15.856 18.121m-12.458-40.772c-1.259 4.152-3.02 14.195 0 21.141 3.775 8.683 7.173 12.836 11.703 7.928m.755-6.418c-3.02 1.133-8.985 1.737-8.683-4.908 3.02-10.193 6.04-9.815 3.02-12.836-2.416-2.416-1.007-5.788 0-7.172" }), /* @__PURE__ */ React.createElement("path", { d: "M390.499 161c-3.267 1.399-11.98 13.93-10.17 16.867 1.809 2.937 6.534-.524 8.67-2.622m-2.95 31.064c-2.391 2.139-6.947 7.626-6.041 12.458 1.133 6.04 3.02 9.438 7.173 9.816" })), /* @__PURE__ */ React.createElement("path", { d: "M444.05 197.29c-.617 1.571 4.347 4.416 5.602 3.287m19.608-2.457c.422 1.634-4.851 3.857-5.959 2.583", stroke: "#4D5165" }), /* @__PURE__ */ React.createElement("path", { d: "M432.517 189.584c1.285-13.41-1.99-36.553-1.99-36.553-2.762-.854-7.142.132-10.67.664-5.745.866-9.95 1.181-9.95 1.181.183 8.271-6.312 51.45 1.922 62.97 13.852 19.379 18.896-9.564 20.688-28.262z", fill: "#fff", stroke: "#00004B", strokeWidth: 2.093 }), /* @__PURE__ */ React.createElement("path", { d: "M419.883 108.129c6.541-5.233 18.342-7.849 27.535-7.849 1.956 3.972 4.664 11.774 11.774 11.774 11.205 0 11.774-9.158 14.391-11.774 2.444-.497 13.099-.091 18.863 1.536 22.789 6.429 16.459 20.704 29.541 50.793-3.924 2.616 3.421 1.13-9.157 3.925-11.774 2.616-15.699 2.616-15.699 2.616 1.308 35.322 3.925 100.734 3.925 100.734l-81.173 1.417s7.912-90.641 7.912-98.226l-20.932-3.925c6.541-40.617 1.994-42.2 13.02-51.021z", fill: "#DFE2E7", stroke: "#00004B", strokeWidth: 2.616 }), /* @__PURE__ */ React.createElement("path", { d: "M526.696 189.587c-1.109-13.425-8.43-35.623-8.43-35.623-2.869-.351-7.005 1.395-10.384 2.543-5.5 1.869-9.583 2.923-9.583 2.923 1.644 8.109 2.896 51.756 13.039 61.635 17.063 16.621 16.904-12.757 15.358-31.478z", fill: "#fff", stroke: "#00004B", strokeWidth: 2.093 }), /* @__PURE__ */ React.createElement("path", { d: "M512.776 180.611c-7.648 20.55-5.793 32.924-1.018 41.091 1.605 2.744 9.712 6.46 12.986 1.588 6.546-9.743 8.218-29.308 10.124-44.89 1.112-9.09.884-17.728 1.189-20.219.305-2.49 2.236-5.517.315-10.808-1.92-5.29-8.336-8.53-11.627-2.613-3.291 5.917-3.875 3.646-.843 10.336 1.56 3.442-6.971 14.352-11.126 25.515z", fill: "#fff", stroke: "#00004B", strokeWidth: 2.093 }), /* @__PURE__ */ React.createElement("path", { d: "M474.774 100.698c-2.744-1.727-6.592-10.322-2.744-12.314 4.811-2.489 10.348-10.58 10.348-15.16 0-9.722 6.109-1.362 6.108-13.202-.001-6.806-5.554-6.596-6.07-3.788-.042-2.593-.43-9.49-2.409-13.099-5.233-9.544-26.165-10.465-34.014-2.616-3.83 3.83-8.311 10.082-7.166 27.256.845 12.684 12.77 19.427 13.739 21.754 1.337 3.212-2.649 9.86-5.265 11.169l4.908 7.14c4.066 5.915 12.744 6.075 17.025.314l5.54-7.454z", fill: "#fff", stroke: "#00004B", strokeWidth: 2.616 }), /* @__PURE__ */ React.createElement("path", { d: "M499.746 242.876c-.098-7.001-1.473-17.007-2.617-34.014v-15.699l-3.582-34.014-62.795-22.24-2.959 22.24c-2.517 12.055-3.924 30.089-5.233 49.713-.97 14.553-1.973 39.669-2.819 45.216-.845 5.548-10.379 62.687-10.148 79.291l.848 60.882c.102 7.38 5.079 46.441 6.887 65.791l22.239.726c5.233-11.192 6.438-30.476 6.315-39.331-.155-11.07-2.757-65.469-1.079-77.486 1.342-9.614 7.365-45.312 10.209-61.959.637 1.529 3.898 13.305 5.065 19.502 3.986 21.165 8.839 51.347 8.955 59.649.092 6.642-.683 66.193 3.241 97.591 12.322 1.366 25.349 4.804 28.781 0 6.542-9.158 4.609-117.476 4.48-126.7-.128-9.225-5.583-74.399-5.788-89.158z", fill: "#00004B" }), /* @__PURE__ */ React.createElement("path", { d: "M429.025 143.46l-1.308 16.702c-2.517 12.055-3.925 30.089-5.233 49.712-.97 14.553-1.973 39.669-2.819 45.217-.845 5.548-10.38 62.687-10.148 79.291l.847 60.882c.103 7.379 6.465 42.812 8.272 62.162h20.932c-.133-9.532 6.361-26.121 6.237-34.977-.154-11.069-2.757-65.468-1.079-77.486 1.343-9.614 7.366-45.311 10.21-61.958.636 1.529 3.898 13.304 5.065 19.501 3.986 21.165 8.839 51.348 8.955 59.65.092 6.641-1.915 65.181 4.626 97.886 12.321 1.367 23.127 3.755 26.164-1.308 7.85-13.082 5.84-116.464 5.712-125.688-.129-9.225-5.583-74.398-5.788-89.157-.098-7.001-1.474-17.008-2.617-34.015v-15.698l-3.924-41.558", stroke: "#00004B", strokeWidth: 2.616 }), /* @__PURE__ */ React.createElement("path", { d: "M489.197 143c-.042-3.043-1.341-30.01-.594-42.63l-10.89.152c-.405 15.075 1.477 42.457 0 42.478-1.476.02-23.093 1.881-37.806-.856l27.472 14.39 22.684 7.939a2.616 2.616 0 003.481-2.469v-14.628c-.88 3.088.373 7.75-1.235 7.378-2.958-.685-3.038-6.416-3.112-11.754z", fill: "#00004B" }), /* @__PURE__ */ React.createElement("path", { d: "M497.055 193.173l-3.417-45.788c-.88 3.088.373 7.75-1.235 7.377-2.958-.685-3.038-6.416-3.112-11.754-.043-3.043-1.341-30.01-.594-42.629l-10.89.151c-.405 15.076 1.476 42.457 0 42.478-1.476.021-23.6 1.882-38.313-.855", stroke: "#00004B", strokeWidth: 2.616 }), /* @__PURE__ */ React.createElement("path", { d: "M440.454 132.775c-.042-2.952.736-22.563 1.53-31.8l-9.177.128c.148-.22.555-1.376-.048-.128-.717 1.486-.907 26.694-2.008 35.936l1.308 1.308 5.233 2.616 3.162 1.309c-.022-1.538.041-6.417 0-9.369zm-8.71-29.883c-.005-.046-.012-.046-.023.004l.023-.004z", fill: "#00004B" }), /* @__PURE__ */ React.createElement("path", { d: "M440.802 142.152c-.021-1.537-.213-6.417-.255-9.369-.041-2.952.737-22.562 1.531-31.8l-10.357 1.913m-4.001 57.571c1.102-9.241 4.355-59.183 4.001-57.571m0 0c-.133.605-1.132 1.785 0 0z", stroke: "#00004B", strokeWidth: 2.616 }), /* @__PURE__ */ React.createElement("path", { d: "M457.375 50.883c7.196-1.415 14.391-4.685 16.789-7.027.8 2.342 0 4.685 3.198 11.712.726 1.595 3.198 5.465 3.198 5.465s4.797-6.17 4.797-11.712c0-4.684-2.398-9.37-5.596-10.15 0-5.466-6.396-10.931-11.193-11.712-6.006-.978-13.591-.781-23.185 5.465-4.797 3.123-7.994 4.685-17.588 4.685.799 2.343 1.919 5.154 3.198 7.027.809 1.186 3.198 5.423 6.396 6.247 1.412.6 3.227 1.282 5.596 1.562 2.164.254 11.861-1.065 14.39-1.562z", fill: "#00004B", stroke: "#00004B", strokeWidth: 2.616 }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M464.486 73.777c-2.507-2.707-3.708-2.273-4.697-2.214-.989.059-2.225.713-3.214 2.012-.989-1.299-2.225-1.95-3.214-2.012-.989-.062-2.19-.505-4.697 2.214-3.256 3.16-5.16-1.009-5.16-1.009s-.477 5.399 5.076 6.41c5.553 1.011 7.995-2.81 7.995-2.81s2.443 3.821 7.998 2.81c5.555-1.011 5.075-6.397 5.075-6.397s-1.903 4.155-5.162.996z", fill: "#00004B" }), /* @__PURE__ */ React.createElement("g", { style: {
  backgroundColor: "red",
  transformOrigin: "58% 60%",
  animation: "noHand 0.4s infinite alternate ease-out"
}, stroke: "#00004B" }, /* @__PURE__ */ React.createElement("path", { d: "M528.148 132.379l-.001-.314a89.516 89.516 0 00-.096-3.858c-.069-1.452-.187-2.999-.388-4.336-.1-.667-.223-1.302-.378-1.856-.15-.537-.35-1.075-.638-1.497h0l-.005-.007c-.628-.905-1.821-1.203-2.761-1.153-.994.053-2.184.514-2.774 1.691h0l-.004.006c-.237.482-.395 1.212-.519 1.975-.13.806-.242 1.797-.34 2.891-.194 2.191-.335 4.861-.435 7.437a360.065 360.065 0 00-.235 9.155l-.008.619-.001.087-.005.02a19.801 19.801 0 00-.349 1.889c-.166 1.217-.287 2.885-.092 4.645.196 1.756.714 3.665 1.88 5.305 1.182 1.663 2.981 2.979 5.595 3.593 2.536.598 5.699.839 8.521.227 2.83-.613 5.489-2.136 6.6-5.192h.001c.922-2.539 1.587-6.505 1.879-9.999.147-1.758.203-3.436.143-4.796-.03-.679-.09-1.302-.19-1.827-.092-.487-.243-1.034-.541-1.443v-.002c-.463-.633-1.258-1.024-1.882-1.232a4.987 4.987 0 00-1.035-.231c-.317-.033-.716-.037-1.089.086l-.019.006-.02.007a.558.558 0 01-.023.009c-.653-.933-1.865-1.328-2.827-1.455-.992-.132-2.186-.042-3.041.453a1.834 1.834 0 00-.107-.11l-.017-.016-.017-.016c-.586-.516-1.325-.742-1.983-.84-.67-.099-1.364-.082-1.967-.026-.294.027-.575.064-.832.105zm10.244 2.136l.003-.001-.003.001z", fill: "#fff", strokeWidth: 2.184 }), /* @__PURE__ */ React.createElement("path", { d: "M528.529 132.986c-1.745 4.361-4.184 11.774.002 11.774m5.235-11.774c-1.745 4.361-4.191 11.774-.005 11.774m6.231-10.466c-1.744 4.361-3.883 11.774.303 11.774", strokeWidth: 2.093, strokeLinecap: "round", strokeLinejoin: "round" })))), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "prefix__prefix__clip0_4513_241169" }, /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M0 0h920v276H0z" })), /* @__PURE__ */ React.createElement("clipPath", { id: "prefix__prefix__clip1_4513_241169" }, /* @__PURE__ */ React.createElement("rect", { x: -384, y: -1411, width: 1688, height: 1688, rx: 844, fill: "#fff" }))), /* @__PURE__ */ React.createElement("style", null, `
    @keyframes noHand {
      0% {
        transform: rotate(-10deg);
      }

      60% {
        transform: none;
      }
    }
  `)), fontFamily = lt$1`
  * {
    font-family: 'Noto Sans', sans-serif;
  }

  * > * {
    font-family: 'Noto Sans', sans-serif;
  }
`, baseWrapperCSS = lt$1`
  opacity: 0;
  transform: translateY(20px);
  transition:
    opacity 300ms ease-in-out,
    transform 300ms ease-in-out;
`, LeftWrapper = dt$1.div`
  ${baseWrapperCSS}
  display: inline-block;
  flex: 1;
  margin: 72px auto 0px;
  padding: 0 2rem;
  overflow: auto;
  opacity: 0;
  transition-delay: 300ms;
  &::-webkit-scrollbar {
    display: none;
  }
`, RightWrapper = dt$1.div`
  ${baseWrapperCSS}
  border-left: 1px solid ${(_t) => _t.theme.colors.cws_neutral_80};
  padding: 72px 72px 24px 24px;
  overflow: auto;
  opacity: 0;
  transition-delay: 600ms;
`, DrawerWrapper = dt$1.div`
  ${fontFamily}
  background-color: ${(_t) => _t.theme.colors.cws_neutral_90};
  position: fixed;
  z-index: 999;
  left: 0;
  top: 0;
  right: 0;
  transition: transform 300ms ease-in-out;
  overflow: hidden;
  color: ${(_t) => _t.theme.colors.cws_neutral_00};

  display: flex;
  justify-content: space-between;

  ${({
  $visible: _t
}) => _t && `
    ${LeftWrapper}, ${RightWrapper} {
      opacity: 1;
      transform: translateY(0);
    }
  `}
`, BtnWrapper = dt$1.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border-radius: 4px;
  transition:
    background-color ease-in-out 300ms,
    color ease-in-out 300ms;
  cursor: pointer;

  svg path {
    fill: #696f88;
  }

  &:hover {
    background-color: ${(_t) => _t.theme.colors.cws_neutral_10};
  }

  &:focus {
    outline-color: #c0e3f9;
  }

  &:active {
    background-color: ${(_t) => _t.theme.colors.cws_neutral_20};
  }

  ${({
  $opened: _t,
  theme: Et
}) => _t && `
    svg path {
      fill: #A3A9B9;
    }

    &:hover {
      background-color: ${Et.colors.cws_neutral_80} !important;
    }
  `}
`, CloseWrapper = dt$1.div`
  margin: 24px 36px;
  border: 1px solid ${(_t) => _t.theme.colors.cws_neutral_00};
  color: ${(_t) => _t.theme.colors.cws_neutral_00};
  width: 40px;
  height: 40px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition:
    border-color ease-in-out 300ms,
    color ease-in-out 300ms;
  cursor: pointer;

  &:hover {
    border-color: ${(_t) => _t.theme.colors.cws_neutral_40};
    color: ${(_t) => _t.theme.colors.cws_neutral_40};
  }

  &:focus {
    outline-color: #c0e3f9;
  }

  &:active {
    border-color: ${(_t) => _t.theme.colors.cws_neutral_20};
  }
`, MainWrapper = dt$1.div`
  ${fontFamily}
`, StyledModal = dt$1(Modal)`
  .cw-elements-modal-content {
    padding: 0 0 24px;
  }

  .cw-elements-modal-body {
    padding: 0px;
    padding-bottom: 26px;
    text-align: center;

    p.small {
      font-size: 12px;
      margin-top: 10px;
      margin-bottom: 0px;
      color: #696f88;
      font-weight: 400;
    }

    p.title {
      font-size: 20px;
      color: #14803c;
      font-weight: 600;
    }

    p.regular {
      font-size: 16px;
      color: #14151c;
      font-weight: 400;
    }

    div.buttons-container {
      margin-left: auto;
      margin-right: auto;
      width: 290px;
      justify-content: space-between;
      align-self: center;
      display: flex;
    }
  }
`, StyledNoAccess = dt$1(SvgNoAccess)`
  width: 920px;
  height: 276px;
  border-radius: 6px;
`, GoToAccountsBtn = dt$1(Button)`
  background-color: ${(_t) => _t.theme.colors.cws_green_60};
  border-color: ${(_t) => _t.theme.colors.cws_green_60};

  &:hover {
    background-color: ${(_t) => _t.theme.colors.cws_green_70} !important;
    border-color: ${(_t) => _t.theme.colors.cws_green_70} !important;
  }
`, LogoutBtn = dt$1(Button)`
  border-color: #c2c7d0 !important;
  border-radius: 4px !important;
  color: #14151c !important;

  &:hover {
    background-color: ${(_t) => _t.theme.colors.cws_neutral_10} !important;
  }
`, AppIcon = dt$1.img`
  width: 38px !important;
  height: 38px;
  margin: 12px;
`, nm = "animated apps", v = "5.9.6", fr$1 = 60, ip = 0, op = 42.720001065172255, w = 24, h = 24, ddd = 0, markers = [], assets = [
  {
    nm: "[GROUP] Rectangle 9 - Null / Rectangle 9 / Rectangle 8 - Null / Rectangle 8 / Rectangle 7 - Null / Rectangle 7 / Rectangle 6 - Null / Rectangle 6 / Rectangle 5 - Null / Rectangle 5 / Rectangle 4 - Null / Rectangle 4 / Rectangle 3 - Null / Rectangle 3 / Rectangle 2 - Null / Rectangle 2 / Rectangle 1 - Null / Rectangle 1",
    fr: 60,
    id: "lh9nem9gzky3c3r95ai",
    layers: [
      {
        ty: 3,
        ddd: 0,
        ind: 71937,
        hd: !1,
        nm: "Group 2 - Null",
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          o: {
            a: 1,
            k: [
              {
                t: 0.06000000284984708,
                s: [
                  0
                ],
                o: {
                  x: [
                    0
                  ],
                  y: [
                    0
                  ]
                },
                i: {
                  x: [
                    0.15
                  ],
                  y: [
                    1
                  ]
                }
              },
              {
                t: 12.060000181663781,
                s: [
                  100
                ]
              }
            ]
          },
          p: {
            a: 1,
            k: [
              {
                t: 12.120000184513628,
                s: [
                  24,
                  6
                ],
                o: {
                  x: [
                    0.42
                  ],
                  y: [
                    0
                  ]
                },
                i: {
                  x: [
                    0.58
                  ],
                  y: [
                    1
                  ]
                },
                ti: [
                  0,
                  0
                ],
                to: [
                  0,
                  0
                ]
              },
              {
                t: 30.120000899769366,
                s: [
                  6,
                  6
                ],
                o: {
                  x: [
                    0.5
                  ],
                  y: [
                    0.35
                  ]
                },
                i: {
                  x: [
                    0.15
                  ],
                  y: [
                    1
                  ]
                },
                ti: [
                  0,
                  0
                ],
                to: [
                  0,
                  0
                ]
              },
              {
                t: 30.72000088635832,
                s: [
                  6,
                  6
                ],
                o: {
                  x: [
                    0.42
                  ],
                  y: [
                    0
                  ]
                },
                i: {
                  x: [
                    0.58
                  ],
                  y: [
                    1
                  ]
                },
                ti: [
                  0,
                  0
                ],
                to: [
                  0,
                  0
                ]
              },
              {
                t: 42.720001065172255,
                s: [
                  4,
                  4
                ]
              }
            ]
          },
          r: {
            a: 0,
            k: 0
          },
          s: {
            a: 0,
            k: [
              100,
              100
            ]
          },
          sk: {
            a: 0,
            k: 0
          },
          sa: {
            a: 0,
            k: 0
          }
        },
        st: 0,
        ip: 0,
        op: 42.720001065172255,
        bm: 0,
        sr: 1
      },
      {
        ty: 3,
        ddd: 0,
        ind: 41425,
        hd: !1,
        nm: "Rectangle 9 - Null",
        parent: 71937,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          o: {
            a: 0,
            k: 100
          },
          p: {
            a: 1,
            k: [
              {
                t: 30.72000088635832,
                s: [
                  8,
                  8
                ],
                o: {
                  x: [
                    0.42
                  ],
                  y: [
                    0
                  ]
                },
                i: {
                  x: [
                    0.58
                  ],
                  y: [
                    1
                  ]
                },
                ti: [
                  0,
                  0
                ],
                to: [
                  0,
                  0
                ]
              },
              {
                t: 42.720001065172255,
                s: [
                  12,
                  12
                ]
              }
            ]
          },
          r: {
            a: 0,
            k: 0
          },
          s: {
            a: 0,
            k: [
              100,
              100
            ]
          },
          sk: {
            a: 0,
            k: 0
          },
          sa: {
            a: 0,
            k: 0
          }
        },
        st: 0,
        ip: 0,
        op: 42.720001065172255,
        bm: 0,
        sr: 1
      },
      {
        ty: 4,
        ddd: 0,
        ind: 62561,
        hd: !1,
        nm: "Rectangle 9",
        parent: 41425,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          s: {
            a: 0,
            k: [
              100,
              100
            ]
          },
          sk: {
            a: 0,
            k: 0
          },
          sa: {
            a: 0,
            k: 0
          },
          r: {
            a: 0,
            k: 0
          },
          o: {
            a: 0,
            k: 100
          }
        },
        st: 0,
        ip: 0,
        op: 42.720001065172255,
        bm: 0,
        sr: 1,
        shapes: [
          {
            ty: "gr",
            nm: "Group",
            hd: !1,
            np: 3,
            it: [
              {
                ty: "sh",
                nm: "Path",
                hd: !1,
                ks: {
                  a: 0,
                  k: {
                    c: !0,
                    v: [
                      [
                        0,
                        0
                      ],
                      [
                        4,
                        0
                      ],
                      [
                        4,
                        2
                      ],
                      [
                        2,
                        4
                      ],
                      [
                        0,
                        4
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        1,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        1
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ]
                  }
                }
              },
              {
                ty: "fl",
                o: {
                  a: 0,
                  k: 100
                },
                c: {
                  a: 0,
                  k: [
                    0.4117647058823529,
                    0.43529411764705883,
                    0.5333333333333333,
                    1
                  ]
                },
                nm: "Fill",
                hd: !1,
                r: 1
              },
              {
                ty: "tr",
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ]
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ]
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ]
                },
                sk: {
                  a: 0,
                  k: 0
                },
                sa: {
                  a: 0,
                  k: 0
                },
                r: {
                  a: 0,
                  k: 0
                },
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ],
        ef: []
      },
      {
        ty: 3,
        ddd: 0,
        ind: 57091,
        hd: !1,
        nm: "Rectangle 8 - Null",
        parent: 71937,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          o: {
            a: 0,
            k: 100
          },
          p: {
            a: 1,
            k: [
              {
                t: 30.72000088635832,
                s: [
                  8,
                  4
                ],
                o: {
                  x: [
                    0.42
                  ],
                  y: [
                    0
                  ]
                },
                i: {
                  x: [
                    0.58
                  ],
                  y: [
                    1
                  ]
                },
                ti: [
                  0,
                  0
                ],
                to: [
                  0,
                  0
                ]
              },
              {
                t: 42.720001065172255,
                s: [
                  12,
                  6
                ]
              }
            ]
          },
          r: {
            a: 0,
            k: 0
          },
          s: {
            a: 0,
            k: [
              100,
              100
            ]
          },
          sk: {
            a: 0,
            k: 0
          },
          sa: {
            a: 0,
            k: 0
          }
        },
        st: 0,
        ip: 0,
        op: 42.720001065172255,
        bm: 0,
        sr: 1
      },
      {
        ty: 4,
        ddd: 0,
        ind: 31477,
        hd: !1,
        nm: "Rectangle 8",
        parent: 57091,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          s: {
            a: 0,
            k: [
              100,
              100
            ]
          },
          sk: {
            a: 0,
            k: 0
          },
          sa: {
            a: 0,
            k: 0
          },
          r: {
            a: 0,
            k: 0
          },
          o: {
            a: 0,
            k: 100
          }
        },
        st: 0,
        ip: 0,
        op: 42.720001065172255,
        bm: 0,
        sr: 1,
        shapes: [
          {
            ty: "gr",
            nm: "Group",
            hd: !1,
            np: 3,
            it: [
              {
                ty: "sh",
                nm: "Path",
                hd: !1,
                ks: {
                  a: 0,
                  k: {
                    c: !0,
                    v: [
                      [
                        0,
                        4
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        4,
                        0
                      ],
                      [
                        4,
                        4
                      ],
                      [
                        0,
                        4
                      ]
                    ],
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ]
                  }
                }
              },
              {
                ty: "fl",
                o: {
                  a: 0,
                  k: 100
                },
                c: {
                  a: 0,
                  k: [
                    0.4117647058823529,
                    0.43529411764705883,
                    0.5333333333333333,
                    1
                  ]
                },
                nm: "Fill",
                hd: !1,
                r: 1
              },
              {
                ty: "tr",
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ]
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ]
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ]
                },
                sk: {
                  a: 0,
                  k: 0
                },
                sa: {
                  a: 0,
                  k: 0
                },
                r: {
                  a: 0,
                  k: 0
                },
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ],
        ef: []
      },
      {
        ty: 3,
        ddd: 0,
        ind: 55483,
        hd: !1,
        nm: "Rectangle 7 - Null",
        parent: 71937,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          o: {
            a: 0,
            k: 100
          },
          p: {
            a: 1,
            k: [
              {
                t: 30.72000088635832,
                s: [
                  8,
                  0
                ],
                o: {
                  x: [
                    0.42
                  ],
                  y: [
                    0
                  ]
                },
                i: {
                  x: [
                    0.58
                  ],
                  y: [
                    1
                  ]
                },
                ti: [
                  0,
                  0
                ],
                to: [
                  0,
                  0
                ]
              },
              {
                t: 42.720001065172255,
                s: [
                  12,
                  0
                ]
              }
            ]
          },
          r: {
            a: 0,
            k: 0
          },
          s: {
            a: 0,
            k: [
              100,
              100
            ]
          },
          sk: {
            a: 0,
            k: 0
          },
          sa: {
            a: 0,
            k: 0
          }
        },
        st: 0,
        ip: 0,
        op: 42.720001065172255,
        bm: 0,
        sr: 1
      },
      {
        ty: 4,
        ddd: 0,
        ind: 51103,
        hd: !1,
        nm: "Rectangle 7",
        parent: 55483,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          s: {
            a: 0,
            k: [
              100,
              100
            ]
          },
          sk: {
            a: 0,
            k: 0
          },
          sa: {
            a: 0,
            k: 0
          },
          r: {
            a: 0,
            k: 0
          },
          o: {
            a: 0,
            k: 100
          }
        },
        st: 0,
        ip: 0,
        op: 42.720001065172255,
        bm: 0,
        sr: 1,
        shapes: [
          {
            ty: "gr",
            nm: "Group",
            hd: !1,
            np: 3,
            it: [
              {
                ty: "sh",
                nm: "Path",
                hd: !1,
                ks: {
                  a: 0,
                  k: {
                    c: !0,
                    v: [
                      [
                        0,
                        0
                      ],
                      [
                        2,
                        0
                      ],
                      [
                        4,
                        2
                      ],
                      [
                        4,
                        4
                      ],
                      [
                        0,
                        4
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -1
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        1,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ]
                  }
                }
              },
              {
                ty: "fl",
                o: {
                  a: 0,
                  k: 100
                },
                c: {
                  a: 0,
                  k: [
                    0.4117647058823529,
                    0.43529411764705883,
                    0.5333333333333333,
                    1
                  ]
                },
                nm: "Fill",
                hd: !1,
                r: 1
              },
              {
                ty: "tr",
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ]
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ]
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ]
                },
                sk: {
                  a: 0,
                  k: 0
                },
                sa: {
                  a: 0,
                  k: 0
                },
                r: {
                  a: 0,
                  k: 0
                },
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ],
        ef: []
      },
      {
        ty: 3,
        ddd: 0,
        ind: 50807,
        hd: !1,
        nm: "Rectangle 6 - Null",
        parent: 71937,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          o: {
            a: 0,
            k: 100
          },
          p: {
            a: 1,
            k: [
              {
                t: 30.72000088635832,
                s: [
                  4,
                  8
                ],
                o: {
                  x: [
                    0.42
                  ],
                  y: [
                    0
                  ]
                },
                i: {
                  x: [
                    0.58
                  ],
                  y: [
                    1
                  ]
                },
                ti: [
                  0,
                  0
                ],
                to: [
                  0,
                  0
                ]
              },
              {
                t: 42.720001065172255,
                s: [
                  6,
                  12
                ]
              }
            ]
          },
          r: {
            a: 0,
            k: 0
          },
          s: {
            a: 0,
            k: [
              100,
              100
            ]
          },
          sk: {
            a: 0,
            k: 0
          },
          sa: {
            a: 0,
            k: 0
          }
        },
        st: 0,
        ip: 0,
        op: 42.720001065172255,
        bm: 0,
        sr: 1
      },
      {
        ty: 4,
        ddd: 0,
        ind: 14307,
        hd: !1,
        nm: "Rectangle 6",
        parent: 50807,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          s: {
            a: 0,
            k: [
              100,
              100
            ]
          },
          sk: {
            a: 0,
            k: 0
          },
          sa: {
            a: 0,
            k: 0
          },
          r: {
            a: 0,
            k: 0
          },
          o: {
            a: 0,
            k: 100
          }
        },
        st: 0,
        ip: 0,
        op: 42.720001065172255,
        bm: 0,
        sr: 1,
        shapes: [
          {
            ty: "gr",
            nm: "Group",
            hd: !1,
            np: 3,
            it: [
              {
                ty: "sh",
                nm: "Path",
                hd: !1,
                ks: {
                  a: 0,
                  k: {
                    c: !0,
                    v: [
                      [
                        0,
                        4
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        4,
                        0
                      ],
                      [
                        4,
                        4
                      ],
                      [
                        0,
                        4
                      ]
                    ],
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ]
                  }
                }
              },
              {
                ty: "fl",
                o: {
                  a: 0,
                  k: 100
                },
                c: {
                  a: 0,
                  k: [
                    0.4117647058823529,
                    0.43529411764705883,
                    0.5333333333333333,
                    1
                  ]
                },
                nm: "Fill",
                hd: !1,
                r: 1
              },
              {
                ty: "tr",
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ]
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ]
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ]
                },
                sk: {
                  a: 0,
                  k: 0
                },
                sa: {
                  a: 0,
                  k: 0
                },
                r: {
                  a: 0,
                  k: 0
                },
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ],
        ef: []
      },
      {
        ty: 3,
        ddd: 0,
        ind: 67340,
        hd: !1,
        nm: "Rectangle 5 - Null",
        parent: 71937,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          o: {
            a: 0,
            k: 100
          },
          p: {
            a: 1,
            k: [
              {
                t: 30.72000088635832,
                s: [
                  4,
                  4
                ],
                o: {
                  x: [
                    0.42
                  ],
                  y: [
                    0
                  ]
                },
                i: {
                  x: [
                    0.58
                  ],
                  y: [
                    1
                  ]
                },
                ti: [
                  0,
                  0
                ],
                to: [
                  0,
                  0
                ]
              },
              {
                t: 42.720001065172255,
                s: [
                  6,
                  6
                ]
              }
            ]
          },
          r: {
            a: 0,
            k: 0
          },
          s: {
            a: 0,
            k: [
              100,
              100
            ]
          },
          sk: {
            a: 0,
            k: 0
          },
          sa: {
            a: 0,
            k: 0
          }
        },
        st: 0,
        ip: 0,
        op: 42.720001065172255,
        bm: 0,
        sr: 1
      },
      {
        ty: 4,
        ddd: 0,
        ind: 37752,
        hd: !1,
        nm: "Rectangle 5",
        parent: 67340,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          s: {
            a: 0,
            k: [
              100,
              100
            ]
          },
          sk: {
            a: 0,
            k: 0
          },
          sa: {
            a: 0,
            k: 0
          },
          r: {
            a: 0,
            k: 0
          },
          o: {
            a: 0,
            k: 100
          }
        },
        st: 0,
        ip: 0,
        op: 42.720001065172255,
        bm: 0,
        sr: 1,
        shapes: [
          {
            ty: "gr",
            nm: "Group",
            hd: !1,
            np: 3,
            it: [
              {
                ty: "sh",
                nm: "Path",
                hd: !1,
                ks: {
                  a: 0,
                  k: {
                    c: !0,
                    v: [
                      [
                        0,
                        4
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        4,
                        0
                      ],
                      [
                        4,
                        4
                      ],
                      [
                        0,
                        4
                      ]
                    ],
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ]
                  }
                }
              },
              {
                ty: "fl",
                o: {
                  a: 0,
                  k: 100
                },
                c: {
                  a: 0,
                  k: [
                    0.4117647058823529,
                    0.43529411764705883,
                    0.5333333333333333,
                    1
                  ]
                },
                nm: "Fill",
                hd: !1,
                r: 1
              },
              {
                ty: "tr",
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ]
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ]
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ]
                },
                sk: {
                  a: 0,
                  k: 0
                },
                sa: {
                  a: 0,
                  k: 0
                },
                r: {
                  a: 0,
                  k: 0
                },
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ],
        ef: []
      },
      {
        ty: 3,
        ddd: 0,
        ind: 4755,
        hd: !1,
        nm: "Rectangle 4 - Null",
        parent: 71937,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          o: {
            a: 0,
            k: 100
          },
          p: {
            a: 1,
            k: [
              {
                t: 30.72000088635832,
                s: [
                  4,
                  0
                ],
                o: {
                  x: [
                    0.42
                  ],
                  y: [
                    0
                  ]
                },
                i: {
                  x: [
                    0.58
                  ],
                  y: [
                    1
                  ]
                },
                ti: [
                  0,
                  0
                ],
                to: [
                  0,
                  0
                ]
              },
              {
                t: 42.720001065172255,
                s: [
                  6,
                  0
                ]
              }
            ]
          },
          r: {
            a: 0,
            k: 0
          },
          s: {
            a: 0,
            k: [
              100,
              100
            ]
          },
          sk: {
            a: 0,
            k: 0
          },
          sa: {
            a: 0,
            k: 0
          }
        },
        st: 0,
        ip: 0,
        op: 42.720001065172255,
        bm: 0,
        sr: 1
      },
      {
        ty: 4,
        ddd: 0,
        ind: 7504,
        hd: !1,
        nm: "Rectangle 4",
        parent: 4755,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          s: {
            a: 0,
            k: [
              100,
              100
            ]
          },
          sk: {
            a: 0,
            k: 0
          },
          sa: {
            a: 0,
            k: 0
          },
          r: {
            a: 0,
            k: 0
          },
          o: {
            a: 0,
            k: 100
          }
        },
        st: 0,
        ip: 0,
        op: 42.720001065172255,
        bm: 0,
        sr: 1,
        shapes: [
          {
            ty: "gr",
            nm: "Group",
            hd: !1,
            np: 3,
            it: [
              {
                ty: "sh",
                nm: "Path",
                hd: !1,
                ks: {
                  a: 0,
                  k: {
                    c: !0,
                    v: [
                      [
                        0,
                        4
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        4,
                        0
                      ],
                      [
                        4,
                        4
                      ],
                      [
                        0,
                        4
                      ]
                    ],
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ]
                  }
                }
              },
              {
                ty: "fl",
                o: {
                  a: 0,
                  k: 100
                },
                c: {
                  a: 0,
                  k: [
                    0.4117647058823529,
                    0.43529411764705883,
                    0.5333333333333333,
                    1
                  ]
                },
                nm: "Fill",
                hd: !1,
                r: 1
              },
              {
                ty: "tr",
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ]
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ]
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ]
                },
                sk: {
                  a: 0,
                  k: 0
                },
                sa: {
                  a: 0,
                  k: 0
                },
                r: {
                  a: 0,
                  k: 0
                },
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ],
        ef: []
      },
      {
        ty: 3,
        ddd: 0,
        ind: 70353,
        hd: !1,
        nm: "Rectangle 3 - Null",
        parent: 71937,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          o: {
            a: 0,
            k: 100
          },
          p: {
            a: 1,
            k: [
              {
                t: 30.72000088635832,
                s: [
                  0,
                  8
                ],
                o: {
                  x: [
                    0.42
                  ],
                  y: [
                    0
                  ]
                },
                i: {
                  x: [
                    0.58
                  ],
                  y: [
                    1
                  ]
                },
                ti: [
                  0,
                  0
                ],
                to: [
                  0,
                  0
                ]
              },
              {
                t: 42.720001065172255,
                s: [
                  0,
                  12
                ]
              }
            ]
          },
          r: {
            a: 0,
            k: 0
          },
          s: {
            a: 0,
            k: [
              100,
              100
            ]
          },
          sk: {
            a: 0,
            k: 0
          },
          sa: {
            a: 0,
            k: 0
          }
        },
        st: 0,
        ip: 0,
        op: 42.720001065172255,
        bm: 0,
        sr: 1
      },
      {
        ty: 4,
        ddd: 0,
        ind: 77964,
        hd: !1,
        nm: "Rectangle 3",
        parent: 70353,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          s: {
            a: 0,
            k: [
              100,
              100
            ]
          },
          sk: {
            a: 0,
            k: 0
          },
          sa: {
            a: 0,
            k: 0
          },
          r: {
            a: 0,
            k: 0
          },
          o: {
            a: 0,
            k: 100
          }
        },
        st: 0,
        ip: 0,
        op: 42.720001065172255,
        bm: 0,
        sr: 1,
        shapes: [
          {
            ty: "gr",
            nm: "Group",
            hd: !1,
            np: 3,
            it: [
              {
                ty: "sh",
                nm: "Path",
                hd: !1,
                ks: {
                  a: 0,
                  k: {
                    c: !0,
                    v: [
                      [
                        0,
                        0
                      ],
                      [
                        4,
                        0
                      ],
                      [
                        4,
                        4
                      ],
                      [
                        2,
                        4
                      ],
                      [
                        0,
                        2
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        1
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -1,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ]
                  }
                }
              },
              {
                ty: "fl",
                o: {
                  a: 0,
                  k: 100
                },
                c: {
                  a: 0,
                  k: [
                    0.4117647058823529,
                    0.43529411764705883,
                    0.5333333333333333,
                    1
                  ]
                },
                nm: "Fill",
                hd: !1,
                r: 1
              },
              {
                ty: "tr",
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ]
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ]
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ]
                },
                sk: {
                  a: 0,
                  k: 0
                },
                sa: {
                  a: 0,
                  k: 0
                },
                r: {
                  a: 0,
                  k: 0
                },
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ],
        ef: []
      },
      {
        ty: 3,
        ddd: 0,
        ind: 52755,
        hd: !1,
        nm: "Rectangle 2 - Null",
        parent: 71937,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          o: {
            a: 0,
            k: 100
          },
          p: {
            a: 1,
            k: [
              {
                t: 30.72000088635832,
                s: [
                  0,
                  4
                ],
                o: {
                  x: [
                    0.42
                  ],
                  y: [
                    0
                  ]
                },
                i: {
                  x: [
                    0.58
                  ],
                  y: [
                    1
                  ]
                },
                ti: [
                  0,
                  0
                ],
                to: [
                  0,
                  0
                ]
              },
              {
                t: 42.720001065172255,
                s: [
                  0,
                  6
                ]
              }
            ]
          },
          r: {
            a: 0,
            k: 0
          },
          s: {
            a: 0,
            k: [
              100,
              100
            ]
          },
          sk: {
            a: 0,
            k: 0
          },
          sa: {
            a: 0,
            k: 0
          }
        },
        st: 0,
        ip: 0,
        op: 42.720001065172255,
        bm: 0,
        sr: 1
      },
      {
        ty: 4,
        ddd: 0,
        ind: 54541,
        hd: !1,
        nm: "Rectangle 2",
        parent: 52755,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          s: {
            a: 0,
            k: [
              100,
              100
            ]
          },
          sk: {
            a: 0,
            k: 0
          },
          sa: {
            a: 0,
            k: 0
          },
          r: {
            a: 0,
            k: 0
          },
          o: {
            a: 0,
            k: 100
          }
        },
        st: 0,
        ip: 0,
        op: 42.720001065172255,
        bm: 0,
        sr: 1,
        shapes: [
          {
            ty: "gr",
            nm: "Group",
            hd: !1,
            np: 3,
            it: [
              {
                ty: "sh",
                nm: "Path",
                hd: !1,
                ks: {
                  a: 0,
                  k: {
                    c: !0,
                    v: [
                      [
                        0,
                        4
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        4,
                        0
                      ],
                      [
                        4,
                        4
                      ],
                      [
                        0,
                        4
                      ]
                    ],
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ]
                  }
                }
              },
              {
                ty: "fl",
                o: {
                  a: 0,
                  k: 100
                },
                c: {
                  a: 0,
                  k: [
                    0.4117647058823529,
                    0.43529411764705883,
                    0.5333333333333333,
                    1
                  ]
                },
                nm: "Fill",
                hd: !1,
                r: 1
              },
              {
                ty: "tr",
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ]
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ]
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ]
                },
                sk: {
                  a: 0,
                  k: 0
                },
                sa: {
                  a: 0,
                  k: 0
                },
                r: {
                  a: 0,
                  k: 0
                },
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ],
        ef: []
      },
      {
        ty: 3,
        ddd: 0,
        ind: 63193,
        hd: !1,
        nm: "Rectangle 1 - Null",
        parent: 71937,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          o: {
            a: 0,
            k: 100
          },
          p: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          r: {
            a: 0,
            k: 0
          },
          s: {
            a: 0,
            k: [
              100,
              100
            ]
          },
          sk: {
            a: 0,
            k: 0
          },
          sa: {
            a: 0,
            k: 0
          }
        },
        st: 0,
        ip: 0,
        op: 42.720001065172255,
        bm: 0,
        sr: 1
      },
      {
        ty: 4,
        ddd: 0,
        ind: 39824,
        hd: !1,
        nm: "Rectangle 1",
        parent: 63193,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          s: {
            a: 0,
            k: [
              100,
              100
            ]
          },
          sk: {
            a: 0,
            k: 0
          },
          sa: {
            a: 0,
            k: 0
          },
          r: {
            a: 0,
            k: 0
          },
          o: {
            a: 0,
            k: 100
          }
        },
        st: 0,
        ip: 0,
        op: 42.720001065172255,
        bm: 0,
        sr: 1,
        shapes: [
          {
            ty: "gr",
            nm: "Group",
            hd: !1,
            np: 3,
            it: [
              {
                ty: "sh",
                nm: "Path",
                hd: !1,
                ks: {
                  a: 0,
                  k: {
                    c: !0,
                    v: [
                      [
                        0,
                        2
                      ],
                      [
                        2,
                        0
                      ],
                      [
                        4,
                        0
                      ],
                      [
                        4,
                        4
                      ],
                      [
                        0,
                        4
                      ],
                      [
                        0,
                        2
                      ]
                    ],
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        -1,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    o: [
                      [
                        0,
                        -1
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ]
                  }
                }
              },
              {
                ty: "fl",
                o: {
                  a: 0,
                  k: 100
                },
                c: {
                  a: 0,
                  k: [
                    0.4117647058823529,
                    0.43529411764705883,
                    0.5333333333333333,
                    1
                  ]
                },
                nm: "Fill",
                hd: !1,
                r: 1
              },
              {
                ty: "tr",
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ]
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ]
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ]
                },
                sk: {
                  a: 0,
                  k: 0
                },
                sa: {
                  a: 0,
                  k: 0
                },
                r: {
                  a: 0,
                  k: 0
                },
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ],
        ef: []
      }
    ]
  },
  {
    nm: "[GROUP] Rectangle 9 - Null / Rectangle 9 / Rectangle 8 - Null / Rectangle 8 / Rectangle 7 - Null / Rectangle 7 / Rectangle 6 - Null / Rectangle 6 / Rectangle 5 - Null / Rectangle 5 / Rectangle 4 - Null / Rectangle 4 / Rectangle 3 - Null / Rectangle 3 / Rectangle 2 - Null / Rectangle 2 / Rectangle 1 - Null / Rectangle 1",
    fr: 60,
    id: "lh9nem9vxgbcbr7vhfa",
    layers: [
      {
        ty: 3,
        ddd: 0,
        ind: 52093,
        hd: !1,
        nm: "Group 1 - Null",
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          o: {
            a: 1,
            k: [
              {
                t: 30.72000088635832,
                s: [
                  100
                ],
                o: {
                  x: [
                    0.42
                  ],
                  y: [
                    0
                  ]
                },
                i: {
                  x: [
                    0.15
                  ],
                  y: [
                    1
                  ]
                }
              },
              {
                t: 42.720001065172255,
                s: [
                  0
                ]
              }
            ]
          },
          p: {
            a: 1,
            k: [
              {
                t: 0.06000000284984708,
                s: [
                  4,
                  4
                ],
                o: {
                  x: [
                    0
                  ],
                  y: [
                    0
                  ]
                },
                i: {
                  x: [
                    0.58
                  ],
                  y: [
                    1
                  ]
                },
                ti: [
                  0,
                  0
                ],
                to: [
                  0,
                  0
                ]
              },
              {
                t: 12.060000181663781,
                s: [
                  6,
                  6
                ],
                o: {
                  x: [
                    0.5
                  ],
                  y: [
                    0.35
                  ]
                },
                i: {
                  x: [
                    0.15
                  ],
                  y: [
                    1
                  ]
                },
                ti: [
                  0,
                  0
                ],
                to: [
                  0,
                  0
                ]
              },
              {
                t: 12.120000184513628,
                s: [
                  6,
                  6
                ],
                o: {
                  x: [
                    0.42
                  ],
                  y: [
                    0
                  ]
                },
                i: {
                  x: [
                    0.58
                  ],
                  y: [
                    1
                  ]
                },
                ti: [
                  0,
                  0
                ],
                to: [
                  0,
                  0
                ]
              },
              {
                t: 30.120000899769366,
                s: [
                  -12,
                  6
                ]
              }
            ]
          },
          r: {
            a: 0,
            k: 0
          },
          s: {
            a: 0,
            k: [
              100,
              100
            ]
          },
          sk: {
            a: 0,
            k: 0
          },
          sa: {
            a: 0,
            k: 0
          }
        },
        st: 0,
        ip: 0,
        op: 42.720001065172255,
        bm: 0,
        sr: 1
      },
      {
        ty: 3,
        ddd: 0,
        ind: 40654,
        hd: !1,
        nm: "Rectangle 9 - Null",
        parent: 52093,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          o: {
            a: 0,
            k: 100
          },
          p: {
            a: 1,
            k: [
              {
                t: 0.06000000284984708,
                s: [
                  12,
                  12
                ],
                o: {
                  x: [
                    0
                  ],
                  y: [
                    0
                  ]
                },
                i: {
                  x: [
                    0.58
                  ],
                  y: [
                    1
                  ]
                },
                ti: [
                  0,
                  0
                ],
                to: [
                  0,
                  0
                ]
              },
              {
                t: 12.060000181663781,
                s: [
                  8,
                  8
                ]
              }
            ]
          },
          r: {
            a: 0,
            k: 0
          },
          s: {
            a: 0,
            k: [
              100,
              100
            ]
          },
          sk: {
            a: 0,
            k: 0
          },
          sa: {
            a: 0,
            k: 0
          }
        },
        st: 0,
        ip: 0,
        op: 42.720001065172255,
        bm: 0,
        sr: 1
      },
      {
        ty: 4,
        ddd: 0,
        ind: 2781,
        hd: !1,
        nm: "Rectangle 9",
        parent: 40654,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          s: {
            a: 0,
            k: [
              100,
              100
            ]
          },
          sk: {
            a: 0,
            k: 0
          },
          sa: {
            a: 0,
            k: 0
          },
          r: {
            a: 0,
            k: 0
          },
          o: {
            a: 0,
            k: 100
          }
        },
        st: 0,
        ip: 0,
        op: 42.720001065172255,
        bm: 0,
        sr: 1,
        shapes: [
          {
            ty: "gr",
            nm: "Group",
            hd: !1,
            np: 3,
            it: [
              {
                ty: "sh",
                nm: "Path",
                hd: !1,
                ks: {
                  a: 0,
                  k: {
                    c: !0,
                    v: [
                      [
                        0,
                        4
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        4,
                        0
                      ],
                      [
                        4,
                        4
                      ],
                      [
                        0,
                        4
                      ]
                    ],
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ]
                  }
                }
              },
              {
                ty: "fl",
                o: {
                  a: 0,
                  k: 100
                },
                c: {
                  a: 0,
                  k: [
                    0.4117647058823529,
                    0.43529411764705883,
                    0.5333333333333333,
                    1
                  ]
                },
                nm: "Fill",
                hd: !1,
                r: 1
              },
              {
                ty: "tr",
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ]
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ]
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ]
                },
                sk: {
                  a: 0,
                  k: 0
                },
                sa: {
                  a: 0,
                  k: 0
                },
                r: {
                  a: 0,
                  k: 0
                },
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ],
        ef: []
      },
      {
        ty: 3,
        ddd: 0,
        ind: 69151,
        hd: !1,
        nm: "Rectangle 8 - Null",
        parent: 52093,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          o: {
            a: 0,
            k: 100
          },
          p: {
            a: 1,
            k: [
              {
                t: 0.06000000284984708,
                s: [
                  12,
                  6
                ],
                o: {
                  x: [
                    0
                  ],
                  y: [
                    0
                  ]
                },
                i: {
                  x: [
                    0.58
                  ],
                  y: [
                    1
                  ]
                },
                ti: [
                  0,
                  0
                ],
                to: [
                  0,
                  0
                ]
              },
              {
                t: 12.060000181663781,
                s: [
                  8,
                  4
                ]
              }
            ]
          },
          r: {
            a: 0,
            k: 0
          },
          s: {
            a: 0,
            k: [
              100,
              100
            ]
          },
          sk: {
            a: 0,
            k: 0
          },
          sa: {
            a: 0,
            k: 0
          }
        },
        st: 0,
        ip: 0,
        op: 42.720001065172255,
        bm: 0,
        sr: 1
      },
      {
        ty: 4,
        ddd: 0,
        ind: 91860,
        hd: !1,
        nm: "Rectangle 8",
        parent: 69151,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          s: {
            a: 0,
            k: [
              100,
              100
            ]
          },
          sk: {
            a: 0,
            k: 0
          },
          sa: {
            a: 0,
            k: 0
          },
          r: {
            a: 0,
            k: 0
          },
          o: {
            a: 0,
            k: 100
          }
        },
        st: 0,
        ip: 0,
        op: 42.720001065172255,
        bm: 0,
        sr: 1,
        shapes: [
          {
            ty: "gr",
            nm: "Group",
            hd: !1,
            np: 3,
            it: [
              {
                ty: "sh",
                nm: "Path",
                hd: !1,
                ks: {
                  a: 0,
                  k: {
                    c: !0,
                    v: [
                      [
                        0,
                        4
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        4,
                        0
                      ],
                      [
                        4,
                        4
                      ],
                      [
                        0,
                        4
                      ]
                    ],
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ]
                  }
                }
              },
              {
                ty: "fl",
                o: {
                  a: 0,
                  k: 100
                },
                c: {
                  a: 0,
                  k: [
                    0.4117647058823529,
                    0.43529411764705883,
                    0.5333333333333333,
                    1
                  ]
                },
                nm: "Fill",
                hd: !1,
                r: 1
              },
              {
                ty: "tr",
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ]
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ]
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ]
                },
                sk: {
                  a: 0,
                  k: 0
                },
                sa: {
                  a: 0,
                  k: 0
                },
                r: {
                  a: 0,
                  k: 0
                },
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ],
        ef: []
      },
      {
        ty: 3,
        ddd: 0,
        ind: 72496,
        hd: !1,
        nm: "Rectangle 7 - Null",
        parent: 52093,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          o: {
            a: 0,
            k: 100
          },
          p: {
            a: 1,
            k: [
              {
                t: 0.06000000284984708,
                s: [
                  12,
                  0
                ],
                o: {
                  x: [
                    0
                  ],
                  y: [
                    0
                  ]
                },
                i: {
                  x: [
                    0.58
                  ],
                  y: [
                    1
                  ]
                },
                ti: [
                  0,
                  0
                ],
                to: [
                  0,
                  0
                ]
              },
              {
                t: 12.060000181663781,
                s: [
                  8,
                  0
                ]
              }
            ]
          },
          r: {
            a: 0,
            k: 0
          },
          s: {
            a: 0,
            k: [
              100,
              100
            ]
          },
          sk: {
            a: 0,
            k: 0
          },
          sa: {
            a: 0,
            k: 0
          }
        },
        st: 0,
        ip: 0,
        op: 42.720001065172255,
        bm: 0,
        sr: 1
      },
      {
        ty: 4,
        ddd: 0,
        ind: 93649,
        hd: !1,
        nm: "Rectangle 7",
        parent: 72496,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          s: {
            a: 0,
            k: [
              100,
              100
            ]
          },
          sk: {
            a: 0,
            k: 0
          },
          sa: {
            a: 0,
            k: 0
          },
          r: {
            a: 0,
            k: 0
          },
          o: {
            a: 0,
            k: 100
          }
        },
        st: 0,
        ip: 0,
        op: 42.720001065172255,
        bm: 0,
        sr: 1,
        shapes: [
          {
            ty: "gr",
            nm: "Group",
            hd: !1,
            np: 3,
            it: [
              {
                ty: "sh",
                nm: "Path",
                hd: !1,
                ks: {
                  a: 0,
                  k: {
                    c: !0,
                    v: [
                      [
                        0,
                        4
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        4,
                        0
                      ],
                      [
                        4,
                        4
                      ],
                      [
                        0,
                        4
                      ]
                    ],
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ]
                  }
                }
              },
              {
                ty: "fl",
                o: {
                  a: 0,
                  k: 100
                },
                c: {
                  a: 0,
                  k: [
                    0.4117647058823529,
                    0.43529411764705883,
                    0.5333333333333333,
                    1
                  ]
                },
                nm: "Fill",
                hd: !1,
                r: 1
              },
              {
                ty: "tr",
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ]
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ]
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ]
                },
                sk: {
                  a: 0,
                  k: 0
                },
                sa: {
                  a: 0,
                  k: 0
                },
                r: {
                  a: 0,
                  k: 0
                },
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ],
        ef: []
      },
      {
        ty: 3,
        ddd: 0,
        ind: 11637,
        hd: !1,
        nm: "Rectangle 6 - Null",
        parent: 52093,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          o: {
            a: 0,
            k: 100
          },
          p: {
            a: 1,
            k: [
              {
                t: 0.06000000284984708,
                s: [
                  6,
                  12
                ],
                o: {
                  x: [
                    0
                  ],
                  y: [
                    0
                  ]
                },
                i: {
                  x: [
                    0.58
                  ],
                  y: [
                    1
                  ]
                },
                ti: [
                  0,
                  0
                ],
                to: [
                  0,
                  0
                ]
              },
              {
                t: 12.060000181663781,
                s: [
                  4,
                  8
                ]
              }
            ]
          },
          r: {
            a: 0,
            k: 0
          },
          s: {
            a: 0,
            k: [
              100,
              100
            ]
          },
          sk: {
            a: 0,
            k: 0
          },
          sa: {
            a: 0,
            k: 0
          }
        },
        st: 0,
        ip: 0,
        op: 42.720001065172255,
        bm: 0,
        sr: 1
      },
      {
        ty: 4,
        ddd: 0,
        ind: 84475,
        hd: !1,
        nm: "Rectangle 6",
        parent: 11637,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          s: {
            a: 0,
            k: [
              100,
              100
            ]
          },
          sk: {
            a: 0,
            k: 0
          },
          sa: {
            a: 0,
            k: 0
          },
          r: {
            a: 0,
            k: 0
          },
          o: {
            a: 0,
            k: 100
          }
        },
        st: 0,
        ip: 0,
        op: 42.720001065172255,
        bm: 0,
        sr: 1,
        shapes: [
          {
            ty: "gr",
            nm: "Group",
            hd: !1,
            np: 3,
            it: [
              {
                ty: "sh",
                nm: "Path",
                hd: !1,
                ks: {
                  a: 0,
                  k: {
                    c: !0,
                    v: [
                      [
                        0,
                        4
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        4,
                        0
                      ],
                      [
                        4,
                        4
                      ],
                      [
                        0,
                        4
                      ]
                    ],
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ]
                  }
                }
              },
              {
                ty: "fl",
                o: {
                  a: 0,
                  k: 100
                },
                c: {
                  a: 0,
                  k: [
                    0.4117647058823529,
                    0.43529411764705883,
                    0.5333333333333333,
                    1
                  ]
                },
                nm: "Fill",
                hd: !1,
                r: 1
              },
              {
                ty: "tr",
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ]
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ]
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ]
                },
                sk: {
                  a: 0,
                  k: 0
                },
                sa: {
                  a: 0,
                  k: 0
                },
                r: {
                  a: 0,
                  k: 0
                },
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ],
        ef: []
      },
      {
        ty: 3,
        ddd: 0,
        ind: 32735,
        hd: !1,
        nm: "Rectangle 5 - Null",
        parent: 52093,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          o: {
            a: 0,
            k: 100
          },
          p: {
            a: 1,
            k: [
              {
                t: 0.06000000284984708,
                s: [
                  6,
                  6
                ],
                o: {
                  x: [
                    0
                  ],
                  y: [
                    0
                  ]
                },
                i: {
                  x: [
                    0.58
                  ],
                  y: [
                    1
                  ]
                },
                ti: [
                  0,
                  0
                ],
                to: [
                  0,
                  0
                ]
              },
              {
                t: 12.060000181663781,
                s: [
                  4,
                  4
                ]
              }
            ]
          },
          r: {
            a: 0,
            k: 0
          },
          s: {
            a: 0,
            k: [
              100,
              100
            ]
          },
          sk: {
            a: 0,
            k: 0
          },
          sa: {
            a: 0,
            k: 0
          }
        },
        st: 0,
        ip: 0,
        op: 42.720001065172255,
        bm: 0,
        sr: 1
      },
      {
        ty: 4,
        ddd: 0,
        ind: 15713,
        hd: !1,
        nm: "Rectangle 5",
        parent: 32735,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          s: {
            a: 0,
            k: [
              100,
              100
            ]
          },
          sk: {
            a: 0,
            k: 0
          },
          sa: {
            a: 0,
            k: 0
          },
          r: {
            a: 0,
            k: 0
          },
          o: {
            a: 0,
            k: 100
          }
        },
        st: 0,
        ip: 0,
        op: 42.720001065172255,
        bm: 0,
        sr: 1,
        shapes: [
          {
            ty: "gr",
            nm: "Group",
            hd: !1,
            np: 3,
            it: [
              {
                ty: "sh",
                nm: "Path",
                hd: !1,
                ks: {
                  a: 0,
                  k: {
                    c: !0,
                    v: [
                      [
                        0,
                        4
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        4,
                        0
                      ],
                      [
                        4,
                        4
                      ],
                      [
                        0,
                        4
                      ]
                    ],
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ]
                  }
                }
              },
              {
                ty: "fl",
                o: {
                  a: 0,
                  k: 100
                },
                c: {
                  a: 0,
                  k: [
                    0.4117647058823529,
                    0.43529411764705883,
                    0.5333333333333333,
                    1
                  ]
                },
                nm: "Fill",
                hd: !1,
                r: 1
              },
              {
                ty: "tr",
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ]
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ]
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ]
                },
                sk: {
                  a: 0,
                  k: 0
                },
                sa: {
                  a: 0,
                  k: 0
                },
                r: {
                  a: 0,
                  k: 0
                },
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ],
        ef: []
      },
      {
        ty: 3,
        ddd: 0,
        ind: 66370,
        hd: !1,
        nm: "Rectangle 4 - Null",
        parent: 52093,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          o: {
            a: 0,
            k: 100
          },
          p: {
            a: 1,
            k: [
              {
                t: 0.06000000284984708,
                s: [
                  6,
                  0
                ],
                o: {
                  x: [
                    0
                  ],
                  y: [
                    0
                  ]
                },
                i: {
                  x: [
                    0.58
                  ],
                  y: [
                    1
                  ]
                },
                ti: [
                  0,
                  0
                ],
                to: [
                  0,
                  0
                ]
              },
              {
                t: 12.060000181663781,
                s: [
                  4,
                  0
                ]
              }
            ]
          },
          r: {
            a: 0,
            k: 0
          },
          s: {
            a: 0,
            k: [
              100,
              100
            ]
          },
          sk: {
            a: 0,
            k: 0
          },
          sa: {
            a: 0,
            k: 0
          }
        },
        st: 0,
        ip: 0,
        op: 42.720001065172255,
        bm: 0,
        sr: 1
      },
      {
        ty: 4,
        ddd: 0,
        ind: 45359,
        hd: !1,
        nm: "Rectangle 4",
        parent: 66370,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          s: {
            a: 0,
            k: [
              100,
              100
            ]
          },
          sk: {
            a: 0,
            k: 0
          },
          sa: {
            a: 0,
            k: 0
          },
          r: {
            a: 0,
            k: 0
          },
          o: {
            a: 0,
            k: 100
          }
        },
        st: 0,
        ip: 0,
        op: 42.720001065172255,
        bm: 0,
        sr: 1,
        shapes: [
          {
            ty: "gr",
            nm: "Group",
            hd: !1,
            np: 3,
            it: [
              {
                ty: "sh",
                nm: "Path",
                hd: !1,
                ks: {
                  a: 0,
                  k: {
                    c: !0,
                    v: [
                      [
                        0,
                        4
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        4,
                        0
                      ],
                      [
                        4,
                        4
                      ],
                      [
                        0,
                        4
                      ]
                    ],
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ]
                  }
                }
              },
              {
                ty: "fl",
                o: {
                  a: 0,
                  k: 100
                },
                c: {
                  a: 0,
                  k: [
                    0.4117647058823529,
                    0.43529411764705883,
                    0.5333333333333333,
                    1
                  ]
                },
                nm: "Fill",
                hd: !1,
                r: 1
              },
              {
                ty: "tr",
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ]
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ]
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ]
                },
                sk: {
                  a: 0,
                  k: 0
                },
                sa: {
                  a: 0,
                  k: 0
                },
                r: {
                  a: 0,
                  k: 0
                },
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ],
        ef: []
      },
      {
        ty: 3,
        ddd: 0,
        ind: 15396,
        hd: !1,
        nm: "Rectangle 3 - Null",
        parent: 52093,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          o: {
            a: 0,
            k: 100
          },
          p: {
            a: 1,
            k: [
              {
                t: 0.06000000284984708,
                s: [
                  0,
                  12
                ],
                o: {
                  x: [
                    0
                  ],
                  y: [
                    0
                  ]
                },
                i: {
                  x: [
                    0.58
                  ],
                  y: [
                    1
                  ]
                },
                ti: [
                  0,
                  0
                ],
                to: [
                  0,
                  0
                ]
              },
              {
                t: 12.060000181663781,
                s: [
                  0,
                  8
                ]
              }
            ]
          },
          r: {
            a: 0,
            k: 0
          },
          s: {
            a: 0,
            k: [
              100,
              100
            ]
          },
          sk: {
            a: 0,
            k: 0
          },
          sa: {
            a: 0,
            k: 0
          }
        },
        st: 0,
        ip: 0,
        op: 42.720001065172255,
        bm: 0,
        sr: 1
      },
      {
        ty: 4,
        ddd: 0,
        ind: 27630,
        hd: !1,
        nm: "Rectangle 3",
        parent: 15396,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          s: {
            a: 0,
            k: [
              100,
              100
            ]
          },
          sk: {
            a: 0,
            k: 0
          },
          sa: {
            a: 0,
            k: 0
          },
          r: {
            a: 0,
            k: 0
          },
          o: {
            a: 0,
            k: 100
          }
        },
        st: 0,
        ip: 0,
        op: 42.720001065172255,
        bm: 0,
        sr: 1,
        shapes: [
          {
            ty: "gr",
            nm: "Group",
            hd: !1,
            np: 3,
            it: [
              {
                ty: "sh",
                nm: "Path",
                hd: !1,
                ks: {
                  a: 0,
                  k: {
                    c: !0,
                    v: [
                      [
                        0,
                        4
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        4,
                        0
                      ],
                      [
                        4,
                        4
                      ],
                      [
                        0,
                        4
                      ]
                    ],
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ]
                  }
                }
              },
              {
                ty: "fl",
                o: {
                  a: 0,
                  k: 100
                },
                c: {
                  a: 0,
                  k: [
                    0.4117647058823529,
                    0.43529411764705883,
                    0.5333333333333333,
                    1
                  ]
                },
                nm: "Fill",
                hd: !1,
                r: 1
              },
              {
                ty: "tr",
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ]
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ]
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ]
                },
                sk: {
                  a: 0,
                  k: 0
                },
                sa: {
                  a: 0,
                  k: 0
                },
                r: {
                  a: 0,
                  k: 0
                },
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ],
        ef: []
      },
      {
        ty: 3,
        ddd: 0,
        ind: 49655,
        hd: !1,
        nm: "Rectangle 2 - Null",
        parent: 52093,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          o: {
            a: 0,
            k: 100
          },
          p: {
            a: 1,
            k: [
              {
                t: 0.06000000284984708,
                s: [
                  0,
                  6
                ],
                o: {
                  x: [
                    0
                  ],
                  y: [
                    0
                  ]
                },
                i: {
                  x: [
                    0.58
                  ],
                  y: [
                    1
                  ]
                },
                ti: [
                  0,
                  0
                ],
                to: [
                  0,
                  0
                ]
              },
              {
                t: 12.060000181663781,
                s: [
                  0,
                  4
                ]
              }
            ]
          },
          r: {
            a: 0,
            k: 0
          },
          s: {
            a: 0,
            k: [
              100,
              100
            ]
          },
          sk: {
            a: 0,
            k: 0
          },
          sa: {
            a: 0,
            k: 0
          }
        },
        st: 0,
        ip: 0,
        op: 42.720001065172255,
        bm: 0,
        sr: 1
      },
      {
        ty: 4,
        ddd: 0,
        ind: 94990,
        hd: !1,
        nm: "Rectangle 2",
        parent: 49655,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          s: {
            a: 0,
            k: [
              100,
              100
            ]
          },
          sk: {
            a: 0,
            k: 0
          },
          sa: {
            a: 0,
            k: 0
          },
          r: {
            a: 0,
            k: 0
          },
          o: {
            a: 0,
            k: 100
          }
        },
        st: 0,
        ip: 0,
        op: 42.720001065172255,
        bm: 0,
        sr: 1,
        shapes: [
          {
            ty: "gr",
            nm: "Group",
            hd: !1,
            np: 3,
            it: [
              {
                ty: "sh",
                nm: "Path",
                hd: !1,
                ks: {
                  a: 0,
                  k: {
                    c: !0,
                    v: [
                      [
                        0,
                        4
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        4,
                        0
                      ],
                      [
                        4,
                        4
                      ],
                      [
                        0,
                        4
                      ]
                    ],
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ]
                  }
                }
              },
              {
                ty: "fl",
                o: {
                  a: 0,
                  k: 100
                },
                c: {
                  a: 0,
                  k: [
                    0.4117647058823529,
                    0.43529411764705883,
                    0.5333333333333333,
                    1
                  ]
                },
                nm: "Fill",
                hd: !1,
                r: 1
              },
              {
                ty: "tr",
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ]
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ]
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ]
                },
                sk: {
                  a: 0,
                  k: 0
                },
                sa: {
                  a: 0,
                  k: 0
                },
                r: {
                  a: 0,
                  k: 0
                },
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ],
        ef: []
      },
      {
        ty: 3,
        ddd: 0,
        ind: 77120,
        hd: !1,
        nm: "Rectangle 1 - Null",
        parent: 52093,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          o: {
            a: 0,
            k: 100
          },
          p: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          r: {
            a: 0,
            k: 0
          },
          s: {
            a: 0,
            k: [
              100,
              100
            ]
          },
          sk: {
            a: 0,
            k: 0
          },
          sa: {
            a: 0,
            k: 0
          }
        },
        st: 0,
        ip: 0,
        op: 42.720001065172255,
        bm: 0,
        sr: 1
      },
      {
        ty: 4,
        ddd: 0,
        ind: 91011,
        hd: !1,
        nm: "Rectangle 1",
        parent: 77120,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          s: {
            a: 0,
            k: [
              100,
              100
            ]
          },
          sk: {
            a: 0,
            k: 0
          },
          sa: {
            a: 0,
            k: 0
          },
          r: {
            a: 0,
            k: 0
          },
          o: {
            a: 0,
            k: 100
          }
        },
        st: 0,
        ip: 0,
        op: 42.720001065172255,
        bm: 0,
        sr: 1,
        shapes: [
          {
            ty: "gr",
            nm: "Group",
            hd: !1,
            np: 3,
            it: [
              {
                ty: "sh",
                nm: "Path",
                hd: !1,
                ks: {
                  a: 0,
                  k: {
                    c: !0,
                    v: [
                      [
                        0,
                        4
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        4,
                        0
                      ],
                      [
                        4,
                        4
                      ],
                      [
                        0,
                        4
                      ]
                    ],
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ]
                  }
                }
              },
              {
                ty: "fl",
                o: {
                  a: 0,
                  k: 100
                },
                c: {
                  a: 0,
                  k: [
                    0.4117647058823529,
                    0.43529411764705883,
                    0.5333333333333333,
                    1
                  ]
                },
                nm: "Fill",
                hd: !1,
                r: 1
              },
              {
                ty: "tr",
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ]
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ]
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ]
                },
                sk: {
                  a: 0,
                  k: 0
                },
                sa: {
                  a: 0,
                  k: 0
                },
                r: {
                  a: 0,
                  k: 0
                },
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ],
        ef: []
      }
    ]
  },
  {
    nm: "[FRAME] animated apps - Null / Group 2 / Group 1",
    fr: 60,
    id: "lh9nem9dxyvwco1i5uh",
    layers: [
      {
        ty: 3,
        ddd: 0,
        ind: 61670,
        hd: !1,
        nm: "animated apps - Null",
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          o: {
            a: 0,
            k: 100
          },
          p: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          r: {
            a: 0,
            k: 0
          },
          s: {
            a: 0,
            k: [
              100,
              100
            ]
          },
          sk: {
            a: 0,
            k: 0
          },
          sa: {
            a: 0,
            k: 0
          }
        },
        st: 0,
        ip: 0,
        op: 42.720001065172255,
        bm: 0,
        sr: 1
      },
      {
        ddd: 0,
        ty: 0,
        nm: "Group 2",
        refId: "lh9nem9gzky3c3r95ai",
        sr: 1,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          s: {
            a: 0,
            k: [
              100,
              100
            ]
          },
          sk: {
            a: 0,
            k: 0
          },
          sa: {
            a: 0,
            k: 0
          },
          r: {
            a: 0,
            k: 0
          },
          o: {
            a: 1,
            k: [
              {
                t: 0.06000000284984708,
                s: [
                  0
                ],
                o: {
                  x: [
                    0
                  ],
                  y: [
                    0
                  ]
                },
                i: {
                  x: [
                    0.15
                  ],
                  y: [
                    1
                  ]
                }
              },
              {
                t: 12.060000181663781,
                s: [
                  100
                ]
              }
            ]
          }
        },
        ao: 0,
        w: 24,
        h: 24,
        ip: 0,
        op: 42.720001065172255,
        st: 0,
        hd: !1
      },
      {
        ddd: 0,
        ty: 0,
        nm: "Group 1",
        refId: "lh9nem9vxgbcbr7vhfa",
        sr: 1,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              0
            ]
          },
          s: {
            a: 0,
            k: [
              100,
              100
            ]
          },
          sk: {
            a: 0,
            k: 0
          },
          sa: {
            a: 0,
            k: 0
          },
          r: {
            a: 0,
            k: 0
          },
          o: {
            a: 1,
            k: [
              {
                t: 30.72000088635832,
                s: [
                  100
                ],
                o: {
                  x: [
                    0.42
                  ],
                  y: [
                    0
                  ]
                },
                i: {
                  x: [
                    0.15
                  ],
                  y: [
                    1
                  ]
                }
              },
              {
                t: 42.720001065172255,
                s: [
                  0
                ]
              }
            ]
          }
        },
        ao: 0,
        w: 24,
        h: 24,
        ip: 0,
        op: 42.720001065172255,
        st: 0,
        hd: !1
      }
    ]
  }
], layers = [
  {
    ddd: 0,
    ty: 0,
    nm: "animated apps",
    refId: "lh9nem9dxyvwco1i5uh",
    sr: 1,
    ks: {
      a: {
        a: 0,
        k: [
          0,
          0
        ]
      },
      p: {
        a: 0,
        k: [
          0,
          0
        ]
      },
      s: {
        a: 0,
        k: [
          100,
          100
        ]
      },
      sk: {
        a: 0,
        k: 0
      },
      sa: {
        a: 0,
        k: 0
      },
      r: {
        a: 0,
        k: 0
      },
      o: {
        a: 0,
        k: 100
      }
    },
    ao: 0,
    w: 24,
    h: 24,
    ip: 0,
    op: 42.720001065172255,
    st: 0,
    hd: !1
  }
], meta = {
  a: "",
  d: "",
  tc: "",
  g: "Aninix"
}, animatedDeckIcon = {
  nm,
  v,
  fr: fr$1,
  ip,
  op,
  w,
  h,
  ddd,
  markers,
  assets,
  layers,
  meta
}, bg = {}, __vite_glob_0_0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: bg
}, Symbol.toStringTag, { value: "Module" })), da = {}, __vite_glob_0_1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: da
}, Symbol.toStringTag, { value: "Module" })), app_card$5 = {
  modal: {
    about_text: "Über",
    copy_link_button: "Link kopieren",
    link_copied_notification: "Link kopiert",
    mobile_title: "Mobil",
    ok: "Ok",
    scan_qr_code_text: "Scannen Sie den QR-Code mit der Kamera Ihres Handys oder klicken Sie unten, um den Link zu kopieren"
  },
  tooltip: {
    discover_and_download: "Entdecken und herunterladen"
  }
}, apps$5 = {
  title: "Cropwise Apps"
}, common$5 = {
  button: {
    dismiss: "Abbrechen "
  },
  tooltip: {
    open_in_new_tab: "In einem neuem Tab öffnen"
  }
}, integrations$5 = {
  classes: {
    erp: "ERP",
    machinery: "Maschinen",
    trap: "Falle",
    weather: "Wetter"
  },
  empty: {
    select_org: "Wählen Sie ein Unternehmen, um Integrationen anzuzeigen"
  },
  filter: {
    active_in: "Aktiv in"
  },
  pop_up: {
    open_connect: "Cropwise Connect öffnen"
  },
  title: "Integrationen"
}, no_access_modal$5 = {
  popup: {
    contact_support_to_upgrade_plan: "Wenden Sie sich an den Support, um Ihren Produktplan zu aktualisieren und",
    go_to_cropwise: "Zu Cropwise Accounts",
    got_it: "Alles klar!",
    logout: "Abmelden",
    no_access: "Sie haben keinen Zugang zu",
    start_using: "loslegen mit",
    this_application: "diese Anwendung",
    workspace: "Arbeitsbereich",
    yet: "noch nicht!"
  }
}, notifications$5 = {
  error: {
    no_data: "Es konnten keine Daten abgerufen werden. Versuchen Sie es in ein paar Minuten erneut oder kontaktieren Sie den Support.",
    title: "Fehler"
  },
  no_access: {
    no_active: "Leider gibt es keine aktive",
    plan_for: "Plan für",
    this_organization: "Diese Organisation hat keine",
    try_another_organization: "Versuchen Sie eine andere Organisation oder kontaktieren Sie uns, um einen Produktplan freizuschalten."
  }
}, settings_menu$5 = {
  crop_cycles: {
    title: "Anbausaisons",
    tooltip: `Beenden Sie die aktuelle Saison, beginnen Sie eine neue
und wählen Sie Felder für jede Kultur aus`
  },
  edit_and_manage: "Bearbeiten und Verwalten",
  equipments: {
    title: "Ausrüstung"
  }
}, de = {
  app_card: app_card$5,
  apps: apps$5,
  common: common$5,
  integrations: integrations$5,
  no_access_modal: no_access_modal$5,
  notifications: notifications$5,
  settings_menu: settings_menu$5
}, __vite_glob_0_2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  app_card: app_card$5,
  apps: apps$5,
  common: common$5,
  default: de,
  integrations: integrations$5,
  no_access_modal: no_access_modal$5,
  notifications: notifications$5,
  settings_menu: settings_menu$5
}, Symbol.toStringTag, { value: "Module" })), el = {}, __vite_glob_0_3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: el
}, Symbol.toStringTag, { value: "Module" })), app_card$4 = {
  modal: {
    about_text: "About",
    copy_link_button: "Copy Link",
    link_copied_notification: "Link Copied",
    mobile_title: "Mobile",
    ok: "OK",
    scan_qr_code_text: "Scan the QR code with your phone's camera or click below to copy link"
  },
  tooltip: {
    discover_and_download: "Discover and download"
  }
}, apps$4 = {
  title: "Cropwise Apps"
}, common$4 = {
  button: {
    dismiss: "Dismiss"
  },
  tooltip: {
    open_in_new_tab: "Open in a new tab"
  }
}, integrations$4 = {
  classes: {
    ag_insights: "Ag Insights",
    erp: "ERP",
    machinery: "Machinery",
    trap: "Trap",
    weather: "Weather"
  },
  empty: {
    select_org: "Select an organization to view integrations"
  },
  filter: {
    active_in: "Active in"
  },
  pop_up: {
    open_connect: "Open Cropwise Connect"
  },
  title: "Integrations"
}, no_access_modal$4 = {
  popup: {
    contact_support_to_upgrade_plan: "Contact support to upgrade your plan and",
    go_to_cropwise: "Go to Cropwise Accounts",
    got_it: "Got it!",
    logout: "Log out",
    no_access: "You don't have access to",
    start_using: "start using",
    this_application: "this application",
    workspace: "Workspace",
    yet: "yet!"
  }
}, notifications$4 = {
  error: {
    no_data: "Could not get data. Try again in a few minutes or contact support.",
    title: "Error"
  },
  no_access: {
    no_active: "Sorry, there is no active",
    plan_for: "plan for",
    this_organization: "This organization doesn't have",
    try_another_organization: "Try another organization or contact us to hire a plan."
  }
}, settings_menu$4 = {
  accounts: {
    title: "Accounts",
    tooltip: "Manage all info related to your Cropwise account"
  },
  connect: {
    data_matching_title: "Data matching",
    data_matching_tooltip: "Open Connect data matching",
    file_upload_title: "File Upload",
    file_upload_tooltip: "Open File Upload",
    integrations_title: "Integrations",
    integrations_tooltip: "Open Cropwise Integrations",
    title: "Connect",
    tooltip: "Open Cropwise Connect"
  },
  crop_cycles: {
    title: "Seasons",
    tooltip: `End the current season, start a new one 
and select fields for each crop`
  },
  divisions: {
    title: "Divisions",
    tooltip: "Group organizations into different sectors, stores or staff members"
  },
  edit_and_manage: "Edit and Manage",
  equipments: {
    title: "Equipment",
    tooltip: "Add and edit equipment such as planters"
  },
  farm_settings: {
    title: "Farm Settings",
    tooltip: `
Find all the options for editing the farm and getting the most out of Cropwise apps`
  },
  fields: {
    extra_button_tooltip: "Quickly add fields",
    title: "Fields",
    tooltip: "Create new, edit shapes and see editing history"
  },
  inputs: {
    title: "Inputs",
    tooltip: "Create or edit products like pesticides, varieties, regulators and fuel"
  },
  invite_members: {
    title: "Invite Members",
    tooltip: "Invite coworkers to access the farm"
  },
  is_running_low: "is running low",
  manage_quotas: {
    title: "Manage quota",
    tooltip: "Check and edit the hectares available for using Cropwise apps"
  },
  members_and_contacts: {
    extraButtonTooltip: "Quickly invite members",
    title: "Members & Contacts",
    tooltip: "Edit the contact list and members of the organization"
  },
  members: {
    title: "Members",
    tooltip: "See who has access to the farm and edit what each member can see"
  },
  products: {
    title: "Products",
    tooltip: "Add and edit products such as varieties, insecticides and fuel"
  },
  quota: "quota",
  quota_warning: {
    about_title: "About quotas",
    empower_title: "Empower your fields with {{ app }}",
    has_area_quota_text: "Your organization has an area quota to use {{ app }}. Currently this quota is 90% or more used.",
    learn_why_button: "Learn why.",
    manage_quota_button: "Manage quota",
    manage_text: "Manage quota if you'd like to use {{ app }} with more fields.",
    more_apps_title: "more Cropwise apps",
    plural_text: "Your organization has available quotas.",
    singular_text: "Your organization has available {{app}} quota.",
    to_free_up_quota_text: "To free up quota, unassign other fields, or request more quota."
  },
  seasons: {
    title: "Seasons",
    tooltip: "Create or edit crop cycles and agronomic data "
  }
}, sidebar$4 = {
  access_account: "Access your Cropwise Account"
}, en = {
  app_card: app_card$4,
  apps: apps$4,
  common: common$4,
  integrations: integrations$4,
  no_access_modal: no_access_modal$4,
  notifications: notifications$4,
  settings_menu: settings_menu$4,
  sidebar: sidebar$4
}, __vite_glob_0_4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  app_card: app_card$4,
  apps: apps$4,
  common: common$4,
  default: en,
  integrations: integrations$4,
  no_access_modal: no_access_modal$4,
  notifications: notifications$4,
  settings_menu: settings_menu$4,
  sidebar: sidebar$4
}, Symbol.toStringTag, { value: "Module" })), app_card$3 = {
  modal: {
    about_text: "Acerca de",
    copy_link_button: "Copiar enlace",
    link_copied_notification: "Enlace copiado",
    mobile_title: "Móvil",
    ok: "Ok",
    scan_qr_code_text: "Escanee el código QR con la cámara de su teléfono móvil o haga clic abajo para copiar el enlace"
  },
  tooltip: {
    discover_and_download: "Descubrir y descargar"
  }
}, apps$3 = {
  title: "Aplicaciones Cropwise"
}, common$3 = {
  button: {
    dismiss: "Descartar"
  },
  tooltip: {
    open_in_new_tab: "Abrir en una nueva pestaña"
  }
}, integrations$3 = {
  classes: {
    ag_insights: "Aprendizajes agrícolas",
    erp: "ERP",
    machinery: "Maquinaria",
    trap: "Trampa",
    weather: "Tiempo"
  },
  empty: {
    select_org: "Seleccione una organización para ver las integraciones"
  },
  filter: {
    active_in: "Activo en"
  },
  pop_up: {
    open_connect: "Abrir Cropwise Connect"
  },
  title: "Integraciones"
}, no_access_modal$3 = {
  popup: {
    contact_support_to_upgrade_plan: "Póngase en contacto con el servicio de asistencia para actualizar su plan y",
    go_to_cropwise: "Ir a Cuentas Cropwise",
    got_it: "¡Ya lo tengo!",
    logout: "Cerrar sesión",
    no_access: "No tiene acceso a",
    start_using: "Empiece a utilizar",
    this_application: "Esta solicitud",
    workspace: "Espacio de trabajo o weokspace",
    yet: "¡todavía!"
  }
}, notifications$3 = {
  error: {
    no_data: "No se han podido obtener datos. Vuelve a intentarlo en unos minutos o ponte en contacto con el servicio de asistencia.",
    title: "Error"
  },
  no_access: {
    no_active: "Lo sentimos, no está activo",
    plan_for: "Plan de",
    this_organization: "Esta organización no tiene",
    try_another_organization: "Pruebe con otra organización o póngase en contacto con nosotros para contratar un plan"
  }
}, settings_menu$3 = {
  accounts: {
    title: "Cuentas",
    tooltip: "Gestione toda la información relacionada con su cuenta de Cropwise"
  },
  connect: {
    data_matching_title: "Coincidencia de datos",
    data_matching_tooltip: "Coincidencia de datos de Open Connect",
    file_upload_title: "Carga de archivos",
    file_upload_tooltip: "Abrir carga de archivos",
    integrations_title: "Integraciones",
    integrations_tooltip: "Integraciones abiertas en Cropwise",
    title: "Conectar",
    tooltip: "Abrir conexión Cropwise"
  },
  crop_cycles: {
    title: "Ciclos de cultivos",
    tooltip: "Cree o edite ciclos de cultivos y datos agronómicos"
  },
  divisions: {
    title: "Divisiones",
    tooltip: "Agrupe las organizaciones en diferentes sectores, almacenes o miembros del personal"
  },
  edit_and_manage: "Editar y administrar",
  equipments: {
    title: "Equipos",
    tooltip: "Cree o edite vehículos e implementos"
  },
  farm_settings: {
    title: "Configuración de la explotación",
    tooltip: "Cree y administre su explotación digital para utilizar los productos Cropwise"
  },
  fields: {
    extra_button_tooltip: "Añada parcelas rápidamente",
    title: "Parcelas",
    tooltip: "Cree y edite parcelas y vea los cambios a lo largo del tiempo"
  },
  inputs: {
    title: "Inputs",
    tooltip: "Cree o edite productos como fitosanitarios, variedades, reguladores y combustible"
  },
  invite_members: {
    title: "Invitar usuarios",
    tooltip: "Invite a miembros y personalice sus roles"
  },
  is_running_low: "Se está agotando",
  manage_quotas: {
    title: "Gestionar la cuota",
    tooltip: "Verifique y edite las hectáreas disponibles para usar las aplicaciones de Cropwise"
  },
  members_and_contacts: {
    extraButtonTooltip: "Invitar rápidamente a miembros",
    title: "Miembros y contactos",
    tooltip: "Editar la lista de contactos y los miembros de la organización"
  },
  members: {
    title: "Miembros",
    tooltip: "Editar miembros y sus roles"
  },
  products: {
    title: "Productos",
    tooltip: "Cree o edite productos como fitosanitarios, variedades, reguladores y combustible"
  },
  quota: "Cuota",
  quota_warning: {
    about_title: "Sobre las cuotas",
    empower_title: "Potencie sus explotaciones con {{ app }}",
    has_area_quota_text: "Su organización tiene una cuota de área para utilizar {{ app }}. Actualmente esta cuota está utilizada en un 90% o más",
    learn_why_button: "Sepa por qué",
    manage_quota_button: "Gestionar la cuota",
    manage_text: "Gestione la cuota si desea utilizar {{ app }} con más explotaciones",
    more_apps_title: "Más aplicaciones de Cropwise",
    plural_text: "Su organización dispone de cuotas",
    singular_text: "Su organización dispone de la cuota {{ app }}",
    to_free_up_quota_text: "Para liberar cuota, desasigne otras explotaciones o solicite más cuota"
  },
  seasons: {
    title: "Campañas",
    tooltip: "Cree o edite campañas y datos agronómicos"
  }
}, sidebar$3 = {
  access_account: "Acceda ahora a su Cuenta Cropwise "
}, es419 = {
  app_card: app_card$3,
  apps: apps$3,
  common: common$3,
  integrations: integrations$3,
  no_access_modal: no_access_modal$3,
  notifications: notifications$3,
  settings_menu: settings_menu$3,
  sidebar: sidebar$3
}, __vite_glob_0_5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  app_card: app_card$3,
  apps: apps$3,
  common: common$3,
  default: es419,
  integrations: integrations$3,
  no_access_modal: no_access_modal$3,
  notifications: notifications$3,
  settings_menu: settings_menu$3,
  sidebar: sidebar$3
}, Symbol.toStringTag, { value: "Module" })), app_card$2 = {
  modal: {
    about_text: "Acerca de",
    copy_link_button: "Copiar link",
    link_copied_notification: "Enlace copiado",
    mobile_title: "Móvil",
    ok: "Ok",
    scan_qr_code_text: "Escanee el código QR con la cámara de su teléfono o haga clic a continuación para copiar el enlace"
  },
  tooltip: {
    discover_and_download: "Descubre y descarga"
  }
}, apps$2 = {
  title: "Aplicaciones Cropwise"
}, common$2 = {
  button: {
    dismiss: "Cancelar"
  },
  tooltip: {
    open_in_new_tab: "Abrir en una nueva pestaña"
  }
}, integrations$2 = {
  classes: {
    ag_insights: "Perspectivas agrícolas",
    erp: "ERP",
    machinery: "Maquinaria",
    trap: "Trampa",
    weather: "Clima"
  },
  empty: {
    select_org: "Seleccione una organización para ver las integraciones"
  },
  filter: {
    active_in: "Activo en"
  },
  pop_up: {
    open_connect: "Abrir conexión Cropwise"
  },
  title: "Integraciones"
}, no_access_modal$2 = {
  popup: {
    contact_support_to_upgrade_plan: "Póngase en contacto con el equipo de sorporte para actualizar su plan y",
    go_to_cropwise: "Ir a Cuentas de Cropwise",
    got_it: "¡Entendido!",
    logout: "Cerrar sesión",
    no_access: "No tiene acceso a ",
    start_using: "Empezar a usar",
    this_application: "Esta aplicación",
    workspace: "Espacio de trabajo",
    yet: "¡aún!"
  }
}, notifications$2 = {
  error: {
    no_data: "No se pudieron obtener datos. Vuelva a intentarlo en unos minutos o comuníquese con el soporte.",
    title: "Error"
  },
  no_access: {
    no_active: "Lo siento, no hay ninguno activo",
    plan_for: "Plan para",
    this_organization: "Esta organización no tiene",
    try_another_organization: "Pruebe con otra organización o contáctenos para contratar un plan"
  }
}, settings_menu$2 = {
  accounts: {
    title: "Cuentas ",
    tooltip: "Gestione toda la información relacionada con su cuenta de Cropwise"
  },
  connect: {
    data_matching_title: "Coincidencia de datos",
    data_matching_tooltip: "Conexión abierta en coincidencia de datos ",
    file_upload_title: "Carga de archivos",
    file_upload_tooltip: "Abrir carga de archivos",
    integrations_title: "Integraciones",
    integrations_tooltip: "Integraciones abiertas de Cropwise",
    title: "Conectar",
    tooltip: "Abrir conexión Cropwise"
  },
  crop_cycles: {
    title: "Campañas",
    tooltip: "Cree o edite ciclos de cultivos y datos agronómicos"
  },
  divisions: {
    title: "Divisiones",
    tooltip: "Agrupar organizaciones en diferentes sectores, almacenes o miembros del personal"
  },
  edit_and_manage: "Editar y administrar",
  equipments: {
    title: "Equipos",
    tooltip: "Crear o editar vehículos e implementos"
  },
  farm_settings: {
    title: "Configuración de la explotación",
    tooltip: "Cree y administre su explotación digital para utilizar los productos Cropwise"
  },
  fields: {
    extra_button_tooltip: "Añadir parcelas rápidamente",
    title: "Parcelas",
    tooltip: "Cree y edite parcelas y vea los cambios a lo largo del tiempo"
  },
  inputs: {
    title: "Insumos",
    tooltip: "Cree o edite productos como fitosanitarios, variedades, reguladores de crecimiento y combustible"
  },
  invite_members: {
    title: "Invitar usuarios",
    tooltip: "Invite a miembros y personalice sus roles"
  },
  is_running_low: "Se está agotando",
  manage_quotas: {
    title: "Gestione su quota",
    tooltip: "Compruebe y edite las hectáreas disponibles para utilizar las aplicaciones Cropwise"
  },
  members_and_contacts: {
    extraButtonTooltip: "Invitar rápidamente a los miembros",
    title: "Miembros y contactos",
    tooltip: "Editar la lista de contactos y miembros de la organización"
  },
  members: {
    title: "Miembros",
    tooltip: "Editar miembros y sus roles"
  },
  products: {
    title: "Productos",
    tooltip: "Cree o edite productos como fitosanitarios, variedades, reguladores de crecimiento y combustible"
  },
  quota: "Cuota",
  quota_warning: {
    about_title: "Acerca de las cuotas",
    empower_title: "Potencie sus emplotaciones con {{ app }}",
    has_area_quota_text: "Su organización tiene una cuota de área para usar {{ app }} . Actualmente esta cuota se utiliza en un 90% o más",
    learn_why_button: "Saber por qué",
    manage_quota_button: "Gestione su quota",
    manage_text: "Administre la cuota si desea utilizar {{ app }} con más explotaciones",
    more_apps_title: "Más aplicaciones de Cropwise",
    plural_text: "Su organización dispone de cuotas",
    singular_text: "Su organización dispone de la cuota {{ app }}",
    to_free_up_quota_text: "Para liberar cuota, desasignar otras explotaciones o solicitar más cuota"
  },
  seasons: {
    title: "Campañas",
    tooltip: "Cree o edite campañas y datos agronómicos"
  }
}, sidebar$2 = {
  access_account: "Acceda a su Cuenta Cropwise "
}, es = {
  app_card: app_card$2,
  apps: apps$2,
  common: common$2,
  integrations: integrations$2,
  no_access_modal: no_access_modal$2,
  notifications: notifications$2,
  settings_menu: settings_menu$2,
  sidebar: sidebar$2
}, __vite_glob_0_6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  app_card: app_card$2,
  apps: apps$2,
  common: common$2,
  default: es,
  integrations: integrations$2,
  no_access_modal: no_access_modal$2,
  notifications: notifications$2,
  settings_menu: settings_menu$2,
  sidebar: sidebar$2
}, Symbol.toStringTag, { value: "Module" })), app_card$1 = {
  modal: {
    about_text: "A propos",
    copy_link_button: "Copier le lien",
    link_copied_notification: "Lien copié",
    mobile_title: "Mobile",
    ok: "Ok",
    scan_qr_code_text: "Scannez le code QR avec l'appareil photo de votre téléphone ou cliquez ci-dessous pour copier le lien"
  },
  tooltip: {
    discover_and_download: "Découvrez et téléchargez"
  }
}, apps$1 = {
  title: "Applications Cropwise"
}, common$1 = {
  button: {
    dismiss: "Annuler"
  },
  tooltip: {
    open_in_new_tab: "Ouvrir dans un nouvel onglet"
  }
}, integrations$1 = {
  classes: {
    ag_insights: "Perspectives sur l’agriculture",
    erp: "ERP",
    machinery: "Equipement",
    trap: "Piège",
    weather: "Météo"
  },
  empty: {
    select_org: "Sélectionnez une organisation pour afficher les intégrations"
  },
  filter: {
    active_in: "Actif dans"
  },
  pop_up: {
    open_connect: "Ouvrir Cropwise Connect"
  },
  title: "Intégrations"
}, no_access_modal$1 = {
  popup: {
    contact_support_to_upgrade_plan: "Contactez l'assistance pour mettre à niveau votre forfait et",
    go_to_cropwise: "Accédez aux comptes Cropwise",
    got_it: "Ok !",
    logout: "Se déconnecter",
    no_access: "Vous n'avez pas accès à",
    start_using: "commencez à utiliser",
    this_application: "cette application",
    workspace: "Espace de travail",
    yet: "encore!"
  }
}, notifications$1 = {
  error: {
    no_data: "Impossible d'obtenir des données. Réessayez dans quelques minutes ou contactez l'assistance.",
    title: "Erreur"
  },
  no_access: {
    no_active: "Désolé, il n'y a pas d'actif",
    plan_for: "planifier pour",
    this_organization: "Cette organisation n'a pas",
    try_another_organization: "Essayez une autre organisation ou contactez-nous pour souscrire à une licence."
  }
}, settings_menu$1 = {
  accounts: {
    title: "Comptes",
    tooltip: "Gérez toutes les informations relatives à votre compte Cropwise"
  },
  connect: {
    data_matching_title: "Correspondance des données",
    data_matching_tooltip: "Correspondance des données Open Connect",
    file_upload_title: "Téléchargement de fichiers",
    file_upload_tooltip: "Ouvrir le téléchargement de fichiers",
    integrations_title: "Intégrations",
    integrations_tooltip: "Ouvrir Cropwise Integration",
    title: "Connecter",
    tooltip: "Ouvrir Cropwise Connect"
  },
  crop_cycles: {
    title: "Campagnes",
    tooltip: "Créez ou modifiez des cycles culturaux et des données agronomiques."
  },
  divisions: {
    title: "Sections",
    tooltip: "Regroupez les organisations en différentes sections, magasins ou membres du personnel"
  },
  edit_and_manage: "Modifier et gérer",
  equipments: {
    title: "Équipements",
    tooltip: "Créez ou modifiez des véhicules et des outils."
  },
  farm_settings: {
    title: "Configuration de l'exploitation",
    tooltip: `Créez et gérez votre exploitation numérique pour utiliser les produits Cropwise.
`
  },
  fields: {
    extra_button_tooltip: "Ajouter rapidement des parcelles",
    title: "Parcelles",
    tooltip: "Créez et modifiez des parcelles et observez les changements au fil du temps."
  },
  inputs: {
    title: "Intrants",
    tooltip: "Créez ou modifiez des produits tels que des pesticides, des variétés, des régulateurs et des carburants."
  },
  invite_members: {
    title: "Inviter des membres",
    tooltip: "Invitez des membres et personnalisez leurs rôles."
  },
  is_running_low: "s'affaiblit",
  manage_quotas: {
    title: "Gérer les quotas",
    tooltip: "Vérifiez et modifiez les hectares disponibles pour l’utilisation des applications Cropwise"
  },
  members_and_contacts: {
    extraButtonTooltip: "Inviter rapidement des utilisateurs",
    title: "Membres et contacts",
    tooltip: "Modifier la liste de contacts et les membres de l’organisation"
  },
  members: {
    title: `Membres
`,
    tooltip: "Modifiez les membres et leurs rôles."
  },
  products: {
    title: "Produits",
    tooltip: "Créez ou modifiez des produits tels que des pesticides, des variétés, des régulateurs et des carburants."
  },
  quota: "quota",
  quota_warning: {
    about_title: "A propos des quotas",
    empower_title: "Renforcez vos champs avec {{ app }}",
    has_area_quota_text: "Votre organisation dispose d'un quota de zone à utiliser {{ app }} . Actuellement, ce quota est utilisé à 90 % ou plus.",
    learn_why_button: "Apprenez pourquoi",
    manage_quota_button: "Gérer les quotas",
    manage_text: "Gérez vos quota si vous souhaitez utiliser {{ app }} avec plus de parcelles.",
    more_apps_title: "plus d'applications Cropwise",
    plural_text: "Votre organisation a des quotas disponibles.",
    singular_text: "Votre structure est disponible {{app}}",
    to_free_up_quota_text: "Pour libérer un quota, désattribuez d'autres parcelles ou demandez plus de quota."
  },
  seasons: {
    title: "Saisons",
    tooltip: "Créez ou modifiez des cycles de culture et des données agronomiques."
  }
}, sidebar$1 = {
  access_account: "Accédez à votre compte Cropwise"
}, fr = {
  app_card: app_card$1,
  apps: apps$1,
  common: common$1,
  integrations: integrations$1,
  no_access_modal: no_access_modal$1,
  notifications: notifications$1,
  settings_menu: settings_menu$1,
  sidebar: sidebar$1
}, __vite_glob_0_7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  app_card: app_card$1,
  apps: apps$1,
  common: common$1,
  default: fr,
  integrations: integrations$1,
  no_access_modal: no_access_modal$1,
  notifications: notifications$1,
  settings_menu: settings_menu$1,
  sidebar: sidebar$1
}, Symbol.toStringTag, { value: "Module" })), hu = {}, __vite_glob_0_8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: hu
}, Symbol.toStringTag, { value: "Module" })), it = {}, __vite_glob_0_9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: it
}, Symbol.toStringTag, { value: "Module" })), ja = {}, __vite_glob_0_10 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ja
}, Symbol.toStringTag, { value: "Module" })), nl = {}, __vite_glob_0_11 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: nl
}, Symbol.toStringTag, { value: "Module" })), pl = {}, __vite_glob_0_12 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: pl
}, Symbol.toStringTag, { value: "Module" })), app_card = {
  modal: {
    about_text: "Sobre",
    copy_link_button: "Copiar o link",
    link_copied_notification: "Link Copiado",
    mobile_title: "App",
    ok: "OK",
    scan_qr_code_text: "Aponte a câmera do seu celular para o QR Code ou clique abaixo para copiar o link"
  },
  tooltip: {
    discover_and_download: "Descubra e baixe"
  }
}, apps = {
  title: "Aplicativos Cropwise"
}, common = {
  button: {
    dismiss: "Fechar"
  },
  tooltip: {
    open_in_new_tab: "Abrir em uma nova aba"
  }
}, integrations = {
  classes: {
    ag_insights: "Ag Insights",
    erp: "ERP",
    machinery: "Maquinário",
    trap: "Armadilhas",
    weather: "Clima"
  },
  empty: {
    select_org: "Select an organization to view integrations"
  },
  filter: {
    active_in: "Ativo em"
  },
  pop_up: {
    open_connect: "Abrir Cropwise Connect"
  },
  title: "Integrações"
}, no_access_modal = {
  popup: {
    contact_support_to_upgrade_plan: "Entre em contato com o suporte para alterar seu plano e ",
    go_to_cropwise: "Ir para Cropwise Accounts",
    got_it: "Entendi!",
    logout: "Sair",
    no_access: "Você não tem acesso a",
    start_using: "comece a usar",
    this_application: "this application",
    workspace: "Workspace",
    yet: "yet!"
  }
}, notifications = {
  error: {
    no_data: "Não foi possível obter dados. Tente novamente em alguns minutos ou entre em contato com o suporte.",
    title: "Erro"
  },
  no_access: {
    no_active: "Desculpe, não há plano ativo",
    plan_for: "para",
    this_organization: "Essa organização não tem",
    try_another_organization: "Tente outra organização ou contate-nos para contratar um plano."
  }
}, settings_menu = {
  accounts: {
    title: "Contas",
    tooltip: "Gerencie todas as informações relacionadas à sua conta Cropwise"
  },
  connect: {
    data_matching_title: "Combinar Dados",
    data_matching_tooltip: "Gerencie aplicativos, serviços e dados conectados ao Cropwise",
    file_upload_title: "Carregamento de arquivos",
    file_upload_tooltip: "Adicione operações de máquinas",
    integrations_title: "Integrações",
    integrations_tooltip: "Acesse os aplicativos e serviços integrados ao Cropwise",
    title: "Connect",
    tooltip: "Gerencie aplicativos, serviços e dados conectados ao Cropwise"
  },
  crop_cycles: {
    title: "Safras",
    tooltip: `Encerrar a safra atual, iniciar safra nova
e selecionar talhões para cada cultura`
  },
  divisions: {
    title: "Divisões",
    tooltip: "Agrupe organizações em diferentes setores, lojas ou membros da equipe"
  },
  edit_and_manage: "Editar e Gerenciar",
  equipments: {
    title: "Equipamentos",
    tooltip: "Adicionar e editar equipamentos como plantadeiras"
  },
  farm_settings: {
    title: "Configurações",
    tooltip: "Aqui você encontra as opções para editar a fazenda e aproveitar ao máximo os aplicativos Cropwise"
  },
  fields: {
    extra_button_tooltip: "Adicione talhões rapidamente",
    title: "Talhões",
    tooltip: "Criar novos, mudar formato, ver o histórico de edições"
  },
  inputs: {
    title: "Insumos",
    tooltip: "Crie ou edite produtos como pesticidas, variedades, reguladores e combustível "
  },
  invite_members: {
    title: "Convidar Membros",
    tooltip: "Convide pessoas para acessar a propriedade"
  },
  is_running_low: "está acabando",
  manage_quotas: {
    title: "Gerenciar quotas",
    tooltip: "Verifique e edite os hectares disponíveis para usar os apps Cropwise"
  },
  members_and_contacts: {
    extraButtonTooltip: "Convidar membros rapidamente",
    title: "Membros & Contatos",
    tooltip: "Convide membros e customize suas permissões"
  },
  members: {
    title: "Membros",
    tooltip: "Veja quem tem acesso à propriedade e edite o que cada membro pode ver"
  },
  products: {
    title: "Produtos",
    tooltip: "Adicionar e editar produtos, como variedades, inseticidas e combustível"
  },
  quota: "cota",
  quota_warning: {
    about_title: "Sobre cotas",
    empower_title: "Capacite seus talhões com {{ app }}",
    has_area_quota_text: "Sua organização tem uma cota de área para usar {{ app }}. Atualmente essa cota está 90% ou mais usada.",
    learn_why_button: "Saiba por quê.",
    manage_quota_button: "Gerenciar cota",
    manage_text: "Gerencia a(s) cota(s) se quiser usar {{ app }} com mais talhões.",
    more_apps_title: "mais apps Cropwise",
    plural_text: "Sua organização tem cota disponível.",
    singular_text: "A sua organização tem cota disponível no {{ app }}.",
    to_free_up_quota_text: "Para liberar cota, dessasocie talhões ou adquira mais cota."
  },
  seasons: {
    title: "Safras",
    tooltip: "Crie ou edite safras e informações agronômicas "
  }
}, sidebar = {
  access_account: "Acesse sua conta Cropwise"
}, ptBR = {
  app_card,
  apps,
  common,
  integrations,
  no_access_modal,
  notifications,
  settings_menu,
  sidebar
}, __vite_glob_0_13 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  app_card,
  apps,
  common,
  default: ptBR,
  integrations,
  no_access_modal,
  notifications,
  settings_menu,
  sidebar
}, Symbol.toStringTag, { value: "Module" })), ro = {}, __vite_glob_0_14 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ro
}, Symbol.toStringTag, { value: "Module" })), sv = {}, __vite_glob_0_15 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sv
}, Symbol.toStringTag, { value: "Module" })), uk = {}, __vite_glob_0_16 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: uk
}, Symbol.toStringTag, { value: "Module" }));
var webfontloader = { exports: {} };
(function(_t) {
  (function() {
    function Et(gr, Sr, Nr) {
      return gr.call.apply(gr.bind, arguments);
    }
    function Pt(gr, Sr, Nr) {
      if (!gr)
        throw Error();
      if (2 < arguments.length) {
        var jr = Array.prototype.slice.call(arguments, 2);
        return function() {
          var Br = Array.prototype.slice.call(arguments);
          return Array.prototype.unshift.apply(Br, jr), gr.apply(Sr, Br);
        };
      }
      return function() {
        return gr.apply(Sr, arguments);
      };
    }
    function $t(gr, Sr, Nr) {
      return $t = Function.prototype.bind && Function.prototype.bind.toString().indexOf("native code") != -1 ? Et : Pt, $t.apply(null, arguments);
    }
    var Mt = Date.now || function() {
      return +/* @__PURE__ */ new Date();
    };
    function Bt(gr, Sr) {
      this.a = gr, this.o = Sr || gr, this.c = this.o.document;
    }
    var Vt = !!window.FontFace;
    function zt(gr, Sr, Nr, jr) {
      if (Sr = gr.c.createElement(Sr), Nr)
        for (var Br in Nr)
          Nr.hasOwnProperty(Br) && (Br == "style" ? Sr.style.cssText = Nr[Br] : Sr.setAttribute(Br, Nr[Br]));
      return jr && Sr.appendChild(gr.c.createTextNode(jr)), Sr;
    }
    function Ht(gr, Sr, Nr) {
      gr = gr.c.getElementsByTagName(Sr)[0], gr || (gr = document.documentElement), gr.insertBefore(Nr, gr.lastChild);
    }
    function Wt(gr) {
      gr.parentNode && gr.parentNode.removeChild(gr);
    }
    function Gt(gr, Sr, Nr) {
      Sr = Sr || [], Nr = Nr || [];
      for (var jr = gr.className.split(/\s+/), Br = 0; Br < Sr.length; Br += 1) {
        for (var Qr = !1, Jr = 0; Jr < jr.length; Jr += 1)
          if (Sr[Br] === jr[Jr]) {
            Qr = !0;
            break;
          }
        Qr || jr.push(Sr[Br]);
      }
      for (Sr = [], Br = 0; Br < jr.length; Br += 1) {
        for (Qr = !1, Jr = 0; Jr < Nr.length; Jr += 1)
          if (jr[Br] === Nr[Jr]) {
            Qr = !0;
            break;
          }
        Qr || Sr.push(jr[Br]);
      }
      gr.className = Sr.join(" ").replace(/\s+/g, " ").replace(/^\s+|\s+$/, "");
    }
    function qt(gr, Sr) {
      for (var Nr = gr.className.split(/\s+/), jr = 0, Br = Nr.length; jr < Br; jr++)
        if (Nr[jr] == Sr)
          return !0;
      return !1;
    }
    function Kt(gr) {
      return gr.o.location.hostname || gr.a.location.hostname;
    }
    function Qt(gr, Sr, Nr) {
      function jr() {
        gn && Br && Qr && (gn(Jr), gn = null);
      }
      Sr = zt(gr, "link", { rel: "stylesheet", href: Sr, media: "all" });
      var Br = !1, Qr = !0, Jr = null, gn = Nr || null;
      Vt ? (Sr.onload = function() {
        Br = !0, jr();
      }, Sr.onerror = function() {
        Br = !0, Jr = Error("Stylesheet failed to load"), jr();
      }) : setTimeout(function() {
        Br = !0, jr();
      }, 0), Ht(gr, "head", Sr);
    }
    function Xt(gr, Sr, Nr, jr) {
      var Br = gr.c.getElementsByTagName("head")[0];
      if (Br) {
        var Qr = zt(gr, "script", { src: Sr }), Jr = !1;
        return Qr.onload = Qr.onreadystatechange = function() {
          Jr || this.readyState && this.readyState != "loaded" && this.readyState != "complete" || (Jr = !0, Nr && Nr(null), Qr.onload = Qr.onreadystatechange = null, Qr.parentNode.tagName == "HEAD" && Br.removeChild(Qr));
        }, Br.appendChild(Qr), setTimeout(function() {
          Jr || (Jr = !0, Nr && Nr(Error("Script load timeout")));
        }, jr || 5e3), Qr;
      }
      return null;
    }
    function Zt() {
      this.a = 0, this.c = null;
    }
    function Yt(gr) {
      return gr.a++, function() {
        gr.a--, er(gr);
      };
    }
    function Jt(gr, Sr) {
      gr.c = Sr, er(gr);
    }
    function er(gr) {
      gr.a == 0 && gr.c && (gr.c(), gr.c = null);
    }
    function tr(gr) {
      this.a = gr || "-";
    }
    tr.prototype.c = function(gr) {
      for (var Sr = [], Nr = 0; Nr < arguments.length; Nr++)
        Sr.push(arguments[Nr].replace(/[\W_]+/g, "").toLowerCase());
      return Sr.join(this.a);
    };
    function nr(gr, Sr) {
      this.c = gr, this.f = 4, this.a = "n";
      var Nr = (Sr || "n4").match(/^([nio])([1-9])$/i);
      Nr && (this.a = Nr[1], this.f = parseInt(Nr[2], 10));
    }
    function rr(gr) {
      return or(gr) + " " + (gr.f + "00") + " 300px " + ir(gr.c);
    }
    function ir(gr) {
      var Sr = [];
      gr = gr.split(/,\s*/);
      for (var Nr = 0; Nr < gr.length; Nr++) {
        var jr = gr[Nr].replace(/['"]/g, "");
        jr.indexOf(" ") != -1 || /^\d/.test(jr) ? Sr.push("'" + jr + "'") : Sr.push(jr);
      }
      return Sr.join(",");
    }
    function ar(gr) {
      return gr.a + gr.f;
    }
    function or(gr) {
      var Sr = "normal";
      return gr.a === "o" ? Sr = "oblique" : gr.a === "i" && (Sr = "italic"), Sr;
    }
    function sr(gr) {
      var Sr = 4, Nr = "n", jr = null;
      return gr && ((jr = gr.match(/(normal|oblique|italic)/i)) && jr[1] && (Nr = jr[1].substr(0, 1).toLowerCase()), (jr = gr.match(/([1-9]00|normal|bold)/i)) && jr[1] && (/bold/i.test(jr[1]) ? Sr = 7 : /[1-9]00/.test(jr[1]) && (Sr = parseInt(jr[1].substr(0, 1), 10)))), Nr + Sr;
    }
    function lr(gr, Sr) {
      this.c = gr, this.f = gr.o.document.documentElement, this.h = Sr, this.a = new tr("-"), this.j = Sr.events !== !1, this.g = Sr.classes !== !1;
    }
    function cr(gr) {
      gr.g && Gt(gr.f, [gr.a.c("wf", "loading")]), pr(gr, "loading");
    }
    function hr(gr) {
      if (gr.g) {
        var Sr = qt(gr.f, gr.a.c("wf", "active")), Nr = [], jr = [gr.a.c("wf", "loading")];
        Sr || Nr.push(gr.a.c("wf", "inactive")), Gt(gr.f, Nr, jr);
      }
      pr(gr, "inactive");
    }
    function pr(gr, Sr, Nr) {
      gr.j && gr.h[Sr] && (Nr ? gr.h[Sr](Nr.c, ar(Nr)) : gr.h[Sr]());
    }
    function mr() {
      this.c = {};
    }
    function Er(gr, Sr, Nr) {
      var jr = [], Br;
      for (Br in Sr)
        if (Sr.hasOwnProperty(Br)) {
          var Qr = gr.c[Br];
          Qr && jr.push(Qr(Sr[Br], Nr));
        }
      return jr;
    }
    function _r(gr, Sr) {
      this.c = gr, this.f = Sr, this.a = zt(this.c, "span", { "aria-hidden": "true" }, this.f);
    }
    function yr(gr) {
      Ht(gr.c, "body", gr.a);
    }
    function ur(gr) {
      return "display:block;position:absolute;top:-9999px;left:-9999px;font-size:300px;width:auto;height:auto;line-height:normal;margin:0;padding:0;font-variant:normal;white-space:nowrap;font-family:" + ir(gr.c) + ";" + ("font-style:" + or(gr) + ";font-weight:" + (gr.f + "00") + ";");
    }
    function vr(gr, Sr, Nr, jr, Br, Qr) {
      this.g = gr, this.j = Sr, this.a = jr, this.c = Nr, this.f = Br || 3e3, this.h = Qr || void 0;
    }
    vr.prototype.start = function() {
      var gr = this.c.o.document, Sr = this, Nr = Mt(), jr = new Promise(function(Jr, gn) {
        function yn() {
          Mt() - Nr >= Sr.f ? gn() : gr.fonts.load(rr(Sr.a), Sr.h).then(function(_n) {
            1 <= _n.length ? Jr() : setTimeout(yn, 25);
          }, function() {
            gn();
          });
        }
        yn();
      }), Br = null, Qr = new Promise(function(Jr, gn) {
        Br = setTimeout(gn, Sr.f);
      });
      Promise.race([Qr, jr]).then(function() {
        Br && (clearTimeout(Br), Br = null), Sr.g(Sr.a);
      }, function() {
        Sr.j(Sr.a);
      });
    };
    function dr(gr, Sr, Nr, jr, Br, Qr, Jr) {
      this.v = gr, this.B = Sr, this.c = Nr, this.a = jr, this.s = Jr || "BESbswy", this.f = {}, this.w = Br || 3e3, this.u = Qr || null, this.m = this.j = this.h = this.g = null, this.g = new _r(this.c, this.s), this.h = new _r(this.c, this.s), this.j = new _r(this.c, this.s), this.m = new _r(this.c, this.s), gr = new nr(this.a.c + ",serif", ar(this.a)), gr = ur(gr), this.g.a.style.cssText = gr, gr = new nr(this.a.c + ",sans-serif", ar(this.a)), gr = ur(gr), this.h.a.style.cssText = gr, gr = new nr("serif", ar(this.a)), gr = ur(gr), this.j.a.style.cssText = gr, gr = new nr("sans-serif", ar(this.a)), gr = ur(gr), this.m.a.style.cssText = gr, yr(this.g), yr(this.h), yr(this.j), yr(this.m);
    }
    var br = { D: "serif", C: "sans-serif" }, Cr = null;
    function Pr() {
      if (Cr === null) {
        var gr = /AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent);
        Cr = !!gr && (536 > parseInt(gr[1], 10) || parseInt(gr[1], 10) === 536 && 11 >= parseInt(gr[2], 10));
      }
      return Cr;
    }
    dr.prototype.start = function() {
      this.f.serif = this.j.a.offsetWidth, this.f["sans-serif"] = this.m.a.offsetWidth, this.A = Mt(), kr(this);
    };
    function xr(gr, Sr, Nr) {
      for (var jr in br)
        if (br.hasOwnProperty(jr) && Sr === gr.f[br[jr]] && Nr === gr.f[br[jr]])
          return !0;
      return !1;
    }
    function kr(gr) {
      var Sr = gr.g.a.offsetWidth, Nr = gr.h.a.offsetWidth, jr;
      (jr = Sr === gr.f.serif && Nr === gr.f["sans-serif"]) || (jr = Pr() && xr(gr, Sr, Nr)), jr ? Mt() - gr.A >= gr.w ? Pr() && xr(gr, Sr, Nr) && (gr.u === null || gr.u.hasOwnProperty(gr.a.c)) ? Ar(gr, gr.v) : Ar(gr, gr.B) : Ir(gr) : Ar(gr, gr.v);
    }
    function Ir(gr) {
      setTimeout($t(function() {
        kr(this);
      }, gr), 50);
    }
    function Ar(gr, Sr) {
      setTimeout($t(function() {
        Wt(this.g.a), Wt(this.h.a), Wt(this.j.a), Wt(this.m.a), Sr(this.a);
      }, gr), 0);
    }
    function Mr(gr, Sr, Nr) {
      this.c = gr, this.a = Sr, this.f = 0, this.m = this.j = !1, this.s = Nr;
    }
    var Fr = null;
    Mr.prototype.g = function(gr) {
      var Sr = this.a;
      Sr.g && Gt(Sr.f, [Sr.a.c("wf", gr.c, ar(gr).toString(), "active")], [Sr.a.c("wf", gr.c, ar(gr).toString(), "loading"), Sr.a.c("wf", gr.c, ar(gr).toString(), "inactive")]), pr(Sr, "fontactive", gr), this.m = !0, Dr(this);
    }, Mr.prototype.h = function(gr) {
      var Sr = this.a;
      if (Sr.g) {
        var Nr = qt(Sr.f, Sr.a.c("wf", gr.c, ar(gr).toString(), "active")), jr = [], Br = [Sr.a.c("wf", gr.c, ar(gr).toString(), "loading")];
        Nr || jr.push(Sr.a.c("wf", gr.c, ar(gr).toString(), "inactive")), Gt(Sr.f, jr, Br);
      }
      pr(Sr, "fontinactive", gr), Dr(this);
    };
    function Dr(gr) {
      --gr.f == 0 && gr.j && (gr.m ? (gr = gr.a, gr.g && Gt(gr.f, [gr.a.c("wf", "active")], [gr.a.c("wf", "loading"), gr.a.c("wf", "inactive")]), pr(gr, "active")) : hr(gr.a));
    }
    function zr(gr) {
      this.j = gr, this.a = new mr(), this.h = 0, this.f = this.g = !0;
    }
    zr.prototype.load = function(gr) {
      this.c = new Bt(this.j, gr.context || this.j), this.g = gr.events !== !1, this.f = gr.classes !== !1, Gr(this, new lr(this.c, gr), gr);
    };
    function Tr(gr, Sr, Nr, jr, Br) {
      var Qr = --gr.h == 0;
      (gr.f || gr.g) && setTimeout(function() {
        var Jr = Br || null, gn = jr || null || {};
        if (Nr.length === 0 && Qr)
          hr(Sr.a);
        else {
          Sr.f += Nr.length, Qr && (Sr.j = Qr);
          var yn, _n = [];
          for (yn = 0; yn < Nr.length; yn++) {
            var In = Nr[yn], Tn = gn[In.c], kn = Sr.a, jn = In;
            if (kn.g && Gt(kn.f, [kn.a.c("wf", jn.c, ar(jn).toString(), "loading")]), pr(kn, "fontloading", jn), kn = null, Fr === null)
              if (window.FontFace) {
                var jn = /Gecko.*Firefox\/(\d+)/.exec(window.navigator.userAgent), An = /OS X.*Version\/10\..*Safari/.exec(window.navigator.userAgent) && /Apple/.exec(window.navigator.vendor);
                Fr = jn ? 42 < parseInt(jn[1], 10) : !An;
              } else
                Fr = !1;
            Fr ? kn = new vr($t(Sr.g, Sr), $t(Sr.h, Sr), Sr.c, In, Sr.s, Tn) : kn = new dr($t(Sr.g, Sr), $t(Sr.h, Sr), Sr.c, In, Sr.s, Jr, Tn), _n.push(kn);
          }
          for (yn = 0; yn < _n.length; yn++)
            _n[yn].start();
        }
      }, 0);
    }
    function Gr(gr, Sr, Nr) {
      var Br = [], jr = Nr.timeout;
      cr(Sr);
      var Br = Er(gr.a, Nr, gr.c), Qr = new Mr(gr.c, Sr, jr);
      for (gr.h = Br.length, Sr = 0, Nr = Br.length; Sr < Nr; Sr++)
        Br[Sr].load(function(Jr, gn, yn) {
          Tr(gr, Qr, Jr, gn, yn);
        });
    }
    function $r(gr, Sr) {
      this.c = gr, this.a = Sr;
    }
    $r.prototype.load = function(gr) {
      function Sr() {
        if (Qr["__mti_fntLst" + jr]) {
          var Jr = Qr["__mti_fntLst" + jr](), gn = [], yn;
          if (Jr)
            for (var _n = 0; _n < Jr.length; _n++) {
              var In = Jr[_n].fontfamily;
              Jr[_n].fontStyle != null && Jr[_n].fontWeight != null ? (yn = Jr[_n].fontStyle + Jr[_n].fontWeight, gn.push(new nr(In, yn))) : gn.push(new nr(In));
            }
          gr(gn);
        } else
          setTimeout(function() {
            Sr();
          }, 50);
      }
      var Nr = this, jr = Nr.a.projectId, Br = Nr.a.version;
      if (jr) {
        var Qr = Nr.c.o;
        Xt(this.c, (Nr.a.api || "https://fast.fonts.net/jsapi") + "/" + jr + ".js" + (Br ? "?v=" + Br : ""), function(Jr) {
          Jr ? gr([]) : (Qr["__MonotypeConfiguration__" + jr] = function() {
            return Nr.a;
          }, Sr());
        }).id = "__MonotypeAPIScript__" + jr;
      } else
        gr([]);
    };
    function Rr(gr, Sr) {
      this.c = gr, this.a = Sr;
    }
    Rr.prototype.load = function(gr) {
      var Sr, Nr, jr = this.a.urls || [], Br = this.a.families || [], Qr = this.a.testStrings || {}, Jr = new Zt();
      for (Sr = 0, Nr = jr.length; Sr < Nr; Sr++)
        Qt(this.c, jr[Sr], Yt(Jr));
      var gn = [];
      for (Sr = 0, Nr = Br.length; Sr < Nr; Sr++)
        if (jr = Br[Sr].split(":"), jr[1])
          for (var yn = jr[1].split(","), _n = 0; _n < yn.length; _n += 1)
            gn.push(new nr(jr[0], yn[_n]));
        else
          gn.push(new nr(jr[0]));
      Jt(Jr, function() {
        gr(gn, Qr);
      });
    };
    function Or(gr, Sr) {
      gr ? this.c = gr : this.c = Lr, this.a = [], this.f = [], this.g = Sr || "";
    }
    var Lr = "https://fonts.googleapis.com/css";
    function Hr(gr, Sr) {
      for (var Nr = Sr.length, jr = 0; jr < Nr; jr++) {
        var Br = Sr[jr].split(":");
        Br.length == 3 && gr.f.push(Br.pop());
        var Qr = "";
        Br.length == 2 && Br[1] != "" && (Qr = ":"), gr.a.push(Br.join(Qr));
      }
    }
    function Wr(gr) {
      if (gr.a.length == 0)
        throw Error("No fonts to load!");
      if (gr.c.indexOf("kit=") != -1)
        return gr.c;
      for (var Sr = gr.a.length, Nr = [], jr = 0; jr < Sr; jr++)
        Nr.push(gr.a[jr].replace(/ /g, "+"));
      return Sr = gr.c + "?family=" + Nr.join("%7C"), 0 < gr.f.length && (Sr += "&subset=" + gr.f.join(",")), 0 < gr.g.length && (Sr += "&text=" + encodeURIComponent(gr.g)), Sr;
    }
    function Kr(gr) {
      this.f = gr, this.a = [], this.c = {};
    }
    var Ur = { latin: "BESbswy", "latin-ext": "çöüğş", cyrillic: "йяЖ", greek: "αβΣ", khmer: "កខគ", Hanuman: "កខគ" }, Zr = { thin: "1", extralight: "2", "extra-light": "2", ultralight: "2", "ultra-light": "2", light: "3", regular: "4", book: "4", medium: "5", "semi-bold": "6", semibold: "6", "demi-bold": "6", demibold: "6", bold: "7", "extra-bold": "8", extrabold: "8", "ultra-bold": "8", ultrabold: "8", black: "9", heavy: "9", l: "3", r: "4", b: "7" }, Xr = { i: "i", italic: "i", n: "n", normal: "n" }, mn = /^(thin|(?:(?:extra|ultra)-?)?light|regular|book|medium|(?:(?:semi|demi|extra|ultra)-?)?bold|black|heavy|l|r|b|[1-9]00)?(n|i|normal|italic)?$/;
    function an(gr) {
      for (var Sr = gr.f.length, Nr = 0; Nr < Sr; Nr++) {
        var jr = gr.f[Nr].split(":"), Br = jr[0].replace(/\+/g, " "), Qr = ["n4"];
        if (2 <= jr.length) {
          var Jr, gn = jr[1];
          if (Jr = [], gn)
            for (var gn = gn.split(","), yn = gn.length, _n = 0; _n < yn; _n++) {
              var In;
              if (In = gn[_n], In.match(/^[\w-]+$/)) {
                var Tn = mn.exec(In.toLowerCase());
                if (Tn == null)
                  In = "";
                else {
                  if (In = Tn[2], In = In == null || In == "" ? "n" : Xr[In], Tn = Tn[1], Tn == null || Tn == "")
                    Tn = "4";
                  else
                    var kn = Zr[Tn], Tn = kn || (isNaN(Tn) ? "4" : Tn.substr(0, 1));
                  In = [In, Tn].join("");
                }
              } else
                In = "";
              In && Jr.push(In);
            }
          0 < Jr.length && (Qr = Jr), jr.length == 3 && (jr = jr[2], Jr = [], jr = jr ? jr.split(",") : Jr, 0 < jr.length && (jr = Ur[jr[0]]) && (gr.c[Br] = jr));
        }
        for (gr.c[Br] || (jr = Ur[Br]) && (gr.c[Br] = jr), jr = 0; jr < Qr.length; jr += 1)
          gr.a.push(new nr(Br, Qr[jr]));
      }
    }
    function nn(gr, Sr) {
      this.c = gr, this.a = Sr;
    }
    var $n = { Arimo: !0, Cousine: !0, Tinos: !0 };
    nn.prototype.load = function(gr) {
      var Sr = new Zt(), Nr = this.c, jr = new Or(this.a.api, this.a.text), Br = this.a.families;
      Hr(jr, Br);
      var Qr = new Kr(Br);
      an(Qr), Qt(Nr, Wr(jr), Yt(Sr)), Jt(Sr, function() {
        gr(Qr.a, Qr.c, $n);
      });
    };
    function En(gr, Sr) {
      this.c = gr, this.a = Sr;
    }
    En.prototype.load = function(gr) {
      var Sr = this.a.id, Nr = this.c.o;
      Sr ? Xt(this.c, (this.a.api || "https://use.typekit.net") + "/" + Sr + ".js", function(jr) {
        if (jr)
          gr([]);
        else if (Nr.Typekit && Nr.Typekit.config && Nr.Typekit.config.fn) {
          jr = Nr.Typekit.config.fn;
          for (var Br = [], Qr = 0; Qr < jr.length; Qr += 2)
            for (var Jr = jr[Qr], gn = jr[Qr + 1], yn = 0; yn < gn.length; yn++)
              Br.push(new nr(Jr, gn[yn]));
          try {
            Nr.Typekit.load({ events: !1, classes: !1, async: !0 });
          } catch {
          }
          gr(Br);
        }
      }, 2e3) : gr([]);
    };
    function xn(gr, Sr) {
      this.c = gr, this.f = Sr, this.a = [];
    }
    xn.prototype.load = function(gr) {
      var Sr = this.f.id, Nr = this.c.o, jr = this;
      Sr ? (Nr.__webfontfontdeckmodule__ || (Nr.__webfontfontdeckmodule__ = {}), Nr.__webfontfontdeckmodule__[Sr] = function(Br, Qr) {
        for (var Jr = 0, gn = Qr.fonts.length; Jr < gn; ++Jr) {
          var yn = Qr.fonts[Jr];
          jr.a.push(new nr(yn.name, sr("font-weight:" + yn.weight + ";font-style:" + yn.style)));
        }
        gr(jr.a);
      }, Xt(this.c, (this.f.api || "https://f.fontdeck.com/s/css/js/") + Kt(this.c) + "/" + Sr + ".js", function(Br) {
        Br && gr([]);
      })) : gr([]);
    };
    var qr = new zr(window);
    qr.a.c.custom = function(gr, Sr) {
      return new Rr(Sr, gr);
    }, qr.a.c.fontdeck = function(gr, Sr) {
      return new xn(Sr, gr);
    }, qr.a.c.monotype = function(gr, Sr) {
      return new $r(Sr, gr);
    }, qr.a.c.typekit = function(gr, Sr) {
      return new En(Sr, gr);
    }, qr.a.c.google = function(gr, Sr) {
      return new nn(Sr, gr);
    };
    var tn = { load: $t(qr.load, qr) };
    _t.exports ? _t.exports = tn : (window.WebFont = tn, window.WebFontConfig && qr.load(window.WebFontConfig));
  })();
})(webfontloader);
var webfontloaderExports = webfontloader.exports;
const WebFont = /* @__PURE__ */ getDefaultExportFromCjs(webfontloaderExports);
var define_import_meta_env_default = { VITE_MAPBOX_TOKEN: "pk.eyJ1Ijoic3RyaWRlcmVuZ2luZWVyaW5nIiwiYSI6ImNsMWdnM3BrbzBiemQzaHBiaDhja2RleXAifQ.0QfwjSzZeGiEjkkA-0dH6w", VITE_CJS_IGNORE_WARNING: "true", BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 };
async function loadInitialAssets() {
  WebFont.load({
    google: {
      families: ["Noto Sans:400,600"]
    }
  });
  let _t;
  define_import_meta_env_default && (_t = /* @__PURE__ */ Object.assign({
    "../translations/bg.json": __vite_glob_0_0,
    "../translations/da.json": __vite_glob_0_1,
    "../translations/de.json": __vite_glob_0_2,
    "../translations/el.json": __vite_glob_0_3,
    "../translations/en.json": __vite_glob_0_4,
    "../translations/es-419.json": __vite_glob_0_5,
    "../translations/es.json": __vite_glob_0_6,
    "../translations/fr.json": __vite_glob_0_7,
    "../translations/hu.json": __vite_glob_0_8,
    "../translations/it.json": __vite_glob_0_9,
    "../translations/ja.json": __vite_glob_0_10,
    "../translations/nl.json": __vite_glob_0_11,
    "../translations/pl.json": __vite_glob_0_12,
    "../translations/pt-BR.json": __vite_glob_0_13,
    "../translations/ro.json": __vite_glob_0_14,
    "../translations/sv.json": __vite_glob_0_15,
    "../translations/uk.json": __vite_glob_0_16
  }), loadPackageTranslations("deck-of-apps", _t));
}
const theme = {
  colors: {
    base_dark_blue: "#00a0be",
    base_light_blue: "#00b5d8",
    base_dark_green: "#749204",
    base_light_green: "#aab400",
    base_light_green_2: "#cbcf6e",
    base_orange: "#eb8205",
    base_yellow: "#ffca41",
    base_yellow_2: "#ffd17e",
    base_red: "#d91e3f",
    base_dark_grey: "#c1c5c8",
    base_light_grey: "#f2f4f6",
    base_white: "#ffffff",
    base_black: "#2f3031",
    base_purple_heart: "#882d8e",
    base_iris: "#4b57d1",
    base_dark_orchid: "#ac38c0",
    base_field_drab: "#7b5d21",
    base_flame: "#df4c29",
    base_steel_blue: "#3c7ea1",
    base_dark_tan: "#977c42",
    base_deep_carrot_orange: "#dc7237",
    base_bleu_de_france: "#4396ef",
    base_old_rose: "#cb7b80",
    base_cadet_blue: "#53a491",
    base_cornflower_blue: "#6f93e3",
    base_persian_pink: "#e977b3",
    base_brass: "#bba536",
    base_olivine: "#9eaa75",
    base_tiger_eye: "#e89d3c",
    base_mantis: "#73c461",
    base_apple_green: "#a3bc10",
    base_sky_blue: "#81bddb",
    base_bright_ube: "#c2a5f5",
    base_medium_turquoise: "#69d5d1",
    base_june_bud: "#b9d950",
    base_light_green_3: "#7dea99",
    base_straw: "#e3d66d",
    base_medium_spring_bud: "#d7dd9d",
    base_gainsboro: "#d9e3e4",
    cws_blue_10: "#EAF6FF",
    cws_blue_20: "#C6E6FF",
    cws_blue_30: "#82CFFF",
    cws_blue_40: "#31B4F2",
    cws_blue_50: "#0092E4",
    cws_blue_60: "#0071CD",
    cws_blue_70: "#005693",
    cws_blue_80: "#003B69",
    cws_blue_90: "#002747",
    cws_blue_100: "#00172D",
    cws_green_10: "#DFFBE8",
    cws_green_20: "#C3EAD1",
    cws_green_30: "#90D6AA",
    cws_green_40: "#5EBB7F",
    cws_green_50: "#19A04B",
    cws_green_60: "#14803C",
    cws_green_70: "#0C612C",
    cws_green_80: "#06431C",
    cws_green_90: "#032D10",
    cws_green_100: "#011B07",
    cws_red_10: "#FFF1F1",
    cws_red_20: "#FFD9D9",
    cws_red_30: "#FFB3B3",
    cws_red_40: "#F98989",
    cws_red_50: "#EB4B4B",
    cws_red_60: "#CF3537",
    cws_red_70: "#9C2628",
    cws_red_80: "#70191A",
    cws_red_90: "#4C0E0F",
    cws_red_100: "#300606",
    cws_orange_10: "#FFF1ED",
    cws_orange_20: "#FFDACE",
    cws_orange_30: "#FFB59D",
    cws_orange_40: "#FF785A",
    cws_orange_50: "#EE5B3A",
    cws_orange_60: "#C1462B",
    cws_orange_70: "#92331E",
    cws_orange_80: "#682213",
    cws_orange_90: "#48150A",
    cws_orange_100: "#2D0A04",
    cws_yellow_10: "#FFF3DD",
    cws_yellow_20: "#FFE4AE",
    cws_yellow_30: "#F0C355",
    cws_yellow_40: "#E99921",
    cws_yellow_50: "#C17E19",
    cws_yellow_60: "#9A6412",
    cws_yellow_70: "#744A0B",
    cws_yellow_80: "#523305",
    cws_yellow_90: "#372102",
    cws_yellow_100: "#221201",
    cws_teal_10: "#E0F9F7",
    cws_teal_20: "#A9EFE8",
    cws_teal_30: "#5FD2C8",
    cws_teal_40: "#46BBB0",
    cws_teal_50: "#2B9C92",
    cws_teal_60: "#217C74",
    cws_teal_70: "#165C56",
    cws_teal_80: "#0D413C",
    cws_teal_90: "#062B27",
    cws_teal_100: "#021917",
    cws_purple_10: "#F6F2FE",
    cws_purple_20: "#E7DDFC",
    cws_purple_30: "#D2BDF9",
    cws_purple_40: "#BA99F6",
    cws_purple_50: "#9664F0",
    cws_purple_60: "#8354D6",
    cws_purple_70: "#643AAA",
    cws_purple_80: "#462779",
    cws_purple_90: "#2E1954",
    cws_purple_100: "#1C0D35",
    cws_pink_10: "#FFF1F3",
    cws_pink_20: "#FFD8DF",
    cws_pink_30: "#FFB2C1",
    cws_pink_40: "#FF7D96",
    cws_pink_50: "#E85D78",
    cws_pink_60: "#BB485D",
    cws_pink_70: "#8D3545",
    cws_pink_80: "#65232F",
    cws_pink_90: "#45161E",
    cws_pink_100: "#2B0A10",
    cws_neutral_00: "#FFFFFF",
    cws_neutral_10: "#F3F4F6",
    cws_neutral_20: "#DFE2E7",
    cws_neutral_30: "#C2C7D0",
    cws_neutral_40: "#A3A9B9",
    cws_neutral_50: "#868CA2",
    cws_neutral_60: "#696F88",
    cws_neutral_70: "#4D5165",
    cws_neutral_80: "#363948",
    cws_neutral_90: "#232630",
    cws_neutral_100: "#14151C"
  }
}, Cn = class Cn {
};
Cn.config = useConfig$1(), Cn.getAppsByWorkspace = async () => {
  if (Cn.$getAppsByWorkspace === void 0) {
    const Et = `${Cn.config.getAPIURL()}/v2/store/workspaces/apps?filter_by_language=false`;
    Cn.$getAppsByWorkspace = request.get(Et, {
      headers: {
        ...Cn.config.getDefaultHeaders(),
        ...Cn.config.getLanguageHeaders()
      }
    }).then((Pt) => Pt.data);
  }
  return Cn.$getAppsByWorkspace;
}, Cn.$getWorkspaceDetails = {}, Cn.getWorkspaceDetails = async (Et) => (Cn.$getWorkspaceDetails[Et] === void 0 && (Cn.$getWorkspaceDetails[Et] = request.get(`${Cn.config.getAPIURL()}/v2/workspaces/${Et}`, {
  headers: {
    ...Cn.config.getDefaultHeaders()
  }
}).then((Pt) => Pt.data)), Cn.$getWorkspaceDetails[Et]), Cn.$getOrgDetails = {}, Cn.getOrgDetails = async (Et) => (Cn.$getOrgDetails[Et] === void 0 && (Cn.$getOrgDetails[Et] = request.get(`${Cn.config.getAPIURL()}/v2/orgs/${Et}?attributes=licensing_accounts`, {
  headers: {
    ...Cn.config.getDefaultHeaders()
  }
}).then((Pt) => Pt.data)), Cn.$getOrgDetails[Et]), Cn.$getPropertyDetails = {}, Cn.getPropertyDetails = async (Et) => (Cn.$getPropertyDetails[Et] === void 0 && (Cn.$getPropertyDetails[Et] = request.get(`${Cn.config.getAPIURL()}/v2/properties/${Et}`, {
  headers: {
    ...Cn.config.getDefaultHeaders()
  }
}).then((Pt) => Pt.data)), Cn.$getPropertyDetails[Et]), Cn.getConnectIntegrations = async () => (Cn.$getConnectIntegrations === void 0 && (Cn.$getConnectIntegrations = request.get(`${Cn.config.getConnectAPIURL()}/valet/v2/connect_integrations`, {
  headers: {
    ...Cn.config.getDefaultHeaders()
  }
}).then((Et) => Et.data)), Cn.$getConnectIntegrations), Cn.$getLicensingStatusByOrg = {}, Cn.getLicensingStatusByOrg = async (Et) => (Cn.$getLicensingStatusByOrg[Et] === void 0 && (Cn.$getLicensingStatusByOrg[Et] = request.get(`${Cn.config.getAPIURL()}/v2/licensing/status?org=${Et}&only_valid_contracts=true`, {
  headers: {
    ...Cn.config.getDefaultHeaders()
  }
}).then((Pt) => Pt.data)), Cn.$getLicensingStatusByOrg[Et]);
let DeckOfAppsService = Cn;
const useAppsData = ({
  currentWorkspaceId: _t,
  currentOrgId: Et,
  currentPropertyId: Pt,
  storeApps: $t,
  loadingDataFromApp: Mt
}) => {
  const Bt = useConfig$1(), Vt = Bt.getToken(), zt = Bt.getHostAppId(), {
    t: Ht
  } = useTranslation(), [Wt, Gt] = useState(!1), [qt, Kt] = useState(), [Qt, Xt] = useState(), [Zt, Yt] = useState(), [Jt, er] = useState(), [tr, nr] = useState([]), [rr, ir] = useState({
    currentApp: !1,
    currentOrg: !1,
    currentProperty: !1,
    apps: !1
  }), [ar, or] = useState({
    currentApp: !1,
    currentOrg: !1,
    currentPropertyId: !1,
    apps: !1
  }), sr = useCallback((hr) => {
    ir((pr) => ({
      ...pr,
      [hr]: !pr[hr]
    }));
  }, []), lr = useCallback((hr) => {
    or((pr) => ({
      ...pr,
      [hr]: !pr[hr]
    }));
  }, []), cr = useCallback(() => {
    staticMethods.open({
      message: `${Ht("notifications.no_access.this_organization")} ${Jt == null ? void 0 : Jt.name}`,
      style: {
        borderLeftWidth: 3,
        borderLeftStyle: "solid",
        borderLeftColor: "red",
        width: 440
      },
      duration: 0,
      description: `${Ht("notifications.no_access.no_active")} ${Jt == null ? void 0 : Jt.name} ${Ht("notifications.no_access.plan_for")} ${Qt == null ? void 0 : Qt.name}. ${Ht("notifications.no_access.try_another_organization")}`,
      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(RefIcon$2, { style: {
        color: "#cf3537"
      } })
    });
  }, [Jt == null ? void 0 : Jt.name, Qt == null ? void 0 : Qt.name, Ht]);
  return useEffect(() => {
    if (zt) {
      const hr = () => {
        sr("currentApp"), CWElementsSharedService.getAppDetails(zt).then((pr) => {
          er(pr);
        }).finally(() => {
          sr("currentApp");
        }).catch();
      };
      Bt.addCallbackAfterSetToken(hr);
    } else
      er(void 0);
  }, [Bt, zt, sr]), useEffect(() => {
    _t && DeckOfAppsService.getWorkspaceDetails(_t).then((hr) => {
      Kt(hr);
    });
  }, [_t]), useEffect(() => {
    Et ? (sr("currentOrg"), DeckOfAppsService.getOrgDetails(Et).then((hr) => {
      Xt(hr);
    }).finally(() => {
      sr("currentOrg");
    }).catch()) : Xt(void 0);
  }, [Et, sr]), useEffect(() => {
    Pt ? (sr("currentProperty"), DeckOfAppsService.getPropertyDetails(Pt).then((hr) => {
      Yt(hr);
    }).finally(() => {
      sr("currentProperty");
    }).catch()) : Yt(void 0);
  }, [Pt, sr]), useEffect(() => {
    const hr = async () => {
      const {
        content: pr
      } = await DeckOfAppsService.getAppsByWorkspace(), mr = /* @__PURE__ */ new Map();
      return pr.forEach((Er) => {
        Er.workspace_apps.forEach((_r) => {
          var ur;
          let yr = [Er.workspace_id];
          mr.has(_r.id) && (yr = [...yr, ...((ur = mr.get(_r.id)) == null ? void 0 : ur.workspaces) ?? []]), mr.set(_r.id, {
            ..._r,
            workspaces: yr
          });
        });
      }), new Array(...mr.values());
    };
    Mt && $t ? nr($t) : Vt && (sr("apps"), hr().then((pr) => {
      nr(pr);
    }).finally(() => {
      sr("apps");
    }).catch());
  }, [Vt, $t, Mt, sr]), useEffect(() => {
    if (Jt && Qt && (tr == null ? void 0 : tr.length) > 0 && (!ar.apps || !ar.currentApp || !ar.currentOrg)) {
      const hr = zt === FARM_SETTINGS_ID || !!tr.find((pr) => pr.id === zt);
      if (Gt(hr), hr) {
        const pr = Qt.workspace_id;
        zt === FARM_SETTINGS_ID || !!tr.find((Er) => {
          var _r;
          return ((_r = Er.workspaces) == null ? void 0 : _r.includes(pr)) && Er.id === zt;
        }) || cr();
      }
      lr("apps"), lr("currentApp"), lr("currentOrg");
    }
  }, [ar, Jt, Qt, tr, zt, cr, lr]), {
    loaded: ar,
    loading: rr,
    hasAccess: Wt,
    currentAppInfo: Jt,
    appsInfo: tr,
    currentWorkspaceInfo: qt,
    currentOrgInfo: Qt,
    currentPropertyInfo: Zt
  };
};
function commonjsRequire(_t) {
  throw new Error('Could not dynamically require "' + _t + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var hookCallback;
function hooks() {
  return hookCallback.apply(null, arguments);
}
function setHookCallback(_t) {
  hookCallback = _t;
}
function isArray(_t) {
  return _t instanceof Array || Object.prototype.toString.call(_t) === "[object Array]";
}
function isObject(_t) {
  return _t != null && Object.prototype.toString.call(_t) === "[object Object]";
}
function hasOwnProp(_t, Et) {
  return Object.prototype.hasOwnProperty.call(_t, Et);
}
function isObjectEmpty(_t) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(_t).length === 0;
  var Et;
  for (Et in _t)
    if (hasOwnProp(_t, Et))
      return !1;
  return !0;
}
function isUndefined(_t) {
  return _t === void 0;
}
function isNumber(_t) {
  return typeof _t == "number" || Object.prototype.toString.call(_t) === "[object Number]";
}
function isDate(_t) {
  return _t instanceof Date || Object.prototype.toString.call(_t) === "[object Date]";
}
function map(_t, Et) {
  var Pt = [], $t, Mt = _t.length;
  for ($t = 0; $t < Mt; ++$t)
    Pt.push(Et(_t[$t], $t));
  return Pt;
}
function extend(_t, Et) {
  for (var Pt in Et)
    hasOwnProp(Et, Pt) && (_t[Pt] = Et[Pt]);
  return hasOwnProp(Et, "toString") && (_t.toString = Et.toString), hasOwnProp(Et, "valueOf") && (_t.valueOf = Et.valueOf), _t;
}
function createUTC(_t, Et, Pt, $t) {
  return createLocalOrUTC(_t, Et, Pt, $t, !0).utc();
}
function defaultParsingFlags() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function getParsingFlags(_t) {
  return _t._pf == null && (_t._pf = defaultParsingFlags()), _t._pf;
}
var some;
Array.prototype.some ? some = Array.prototype.some : some = function(_t) {
  var Et = Object(this), Pt = Et.length >>> 0, $t;
  for ($t = 0; $t < Pt; $t++)
    if ($t in Et && _t.call(this, Et[$t], $t, Et))
      return !0;
  return !1;
};
function isValid(_t) {
  var Et = null, Pt = !1, $t = _t._d && !isNaN(_t._d.getTime());
  if ($t && (Et = getParsingFlags(_t), Pt = some.call(Et.parsedDateParts, function(Mt) {
    return Mt != null;
  }), $t = Et.overflow < 0 && !Et.empty && !Et.invalidEra && !Et.invalidMonth && !Et.invalidWeekday && !Et.weekdayMismatch && !Et.nullInput && !Et.invalidFormat && !Et.userInvalidated && (!Et.meridiem || Et.meridiem && Pt), _t._strict && ($t = $t && Et.charsLeftOver === 0 && Et.unusedTokens.length === 0 && Et.bigHour === void 0)), Object.isFrozen == null || !Object.isFrozen(_t))
    _t._isValid = $t;
  else
    return $t;
  return _t._isValid;
}
function createInvalid(_t) {
  var Et = createUTC(NaN);
  return _t != null ? extend(getParsingFlags(Et), _t) : getParsingFlags(Et).userInvalidated = !0, Et;
}
var momentProperties = hooks.momentProperties = [], updateInProgress = !1;
function copyConfig(_t, Et) {
  var Pt, $t, Mt, Bt = momentProperties.length;
  if (isUndefined(Et._isAMomentObject) || (_t._isAMomentObject = Et._isAMomentObject), isUndefined(Et._i) || (_t._i = Et._i), isUndefined(Et._f) || (_t._f = Et._f), isUndefined(Et._l) || (_t._l = Et._l), isUndefined(Et._strict) || (_t._strict = Et._strict), isUndefined(Et._tzm) || (_t._tzm = Et._tzm), isUndefined(Et._isUTC) || (_t._isUTC = Et._isUTC), isUndefined(Et._offset) || (_t._offset = Et._offset), isUndefined(Et._pf) || (_t._pf = getParsingFlags(Et)), isUndefined(Et._locale) || (_t._locale = Et._locale), Bt > 0)
    for (Pt = 0; Pt < Bt; Pt++)
      $t = momentProperties[Pt], Mt = Et[$t], isUndefined(Mt) || (_t[$t] = Mt);
  return _t;
}
function Moment(_t) {
  copyConfig(this, _t), this._d = new Date(_t._d != null ? _t._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), updateInProgress === !1 && (updateInProgress = !0, hooks.updateOffset(this), updateInProgress = !1);
}
function isMoment(_t) {
  return _t instanceof Moment || _t != null && _t._isAMomentObject != null;
}
function warn(_t) {
  hooks.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + _t);
}
function deprecate(_t, Et) {
  var Pt = !0;
  return extend(function() {
    if (hooks.deprecationHandler != null && hooks.deprecationHandler(null, _t), Pt) {
      var $t = [], Mt, Bt, Vt, zt = arguments.length;
      for (Bt = 0; Bt < zt; Bt++) {
        if (Mt = "", typeof arguments[Bt] == "object") {
          Mt += `
[` + Bt + "] ";
          for (Vt in arguments[0])
            hasOwnProp(arguments[0], Vt) && (Mt += Vt + ": " + arguments[0][Vt] + ", ");
          Mt = Mt.slice(0, -2);
        } else
          Mt = arguments[Bt];
        $t.push(Mt);
      }
      warn(
        _t + `
Arguments: ` + Array.prototype.slice.call($t).join("") + `
` + new Error().stack
      ), Pt = !1;
    }
    return Et.apply(this, arguments);
  }, Et);
}
var deprecations = {};
function deprecateSimple(_t, Et) {
  hooks.deprecationHandler != null && hooks.deprecationHandler(_t, Et), deprecations[_t] || (warn(Et), deprecations[_t] = !0);
}
hooks.suppressDeprecationWarnings = !1;
hooks.deprecationHandler = null;
function isFunction(_t) {
  return typeof Function < "u" && _t instanceof Function || Object.prototype.toString.call(_t) === "[object Function]";
}
function set(_t) {
  var Et, Pt;
  for (Pt in _t)
    hasOwnProp(_t, Pt) && (Et = _t[Pt], isFunction(Et) ? this[Pt] = Et : this["_" + Pt] = Et);
  this._config = _t, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function mergeConfigs(_t, Et) {
  var Pt = extend({}, _t), $t;
  for ($t in Et)
    hasOwnProp(Et, $t) && (isObject(_t[$t]) && isObject(Et[$t]) ? (Pt[$t] = {}, extend(Pt[$t], _t[$t]), extend(Pt[$t], Et[$t])) : Et[$t] != null ? Pt[$t] = Et[$t] : delete Pt[$t]);
  for ($t in _t)
    hasOwnProp(_t, $t) && !hasOwnProp(Et, $t) && isObject(_t[$t]) && (Pt[$t] = extend({}, Pt[$t]));
  return Pt;
}
function Locale(_t) {
  _t != null && this.set(_t);
}
var keys;
Object.keys ? keys = Object.keys : keys = function(_t) {
  var Et, Pt = [];
  for (Et in _t)
    hasOwnProp(_t, Et) && Pt.push(Et);
  return Pt;
};
var defaultCalendar = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function calendar(_t, Et, Pt) {
  var $t = this._calendar[_t] || this._calendar.sameElse;
  return isFunction($t) ? $t.call(Et, Pt) : $t;
}
function zeroFill(_t, Et, Pt) {
  var $t = "" + Math.abs(_t), Mt = Et - $t.length, Bt = _t >= 0;
  return (Bt ? Pt ? "+" : "" : "-") + Math.pow(10, Math.max(0, Mt)).toString().substr(1) + $t;
}
var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
function addFormatToken(_t, Et, Pt, $t) {
  var Mt = $t;
  typeof $t == "string" && (Mt = function() {
    return this[$t]();
  }), _t && (formatTokenFunctions[_t] = Mt), Et && (formatTokenFunctions[Et[0]] = function() {
    return zeroFill(Mt.apply(this, arguments), Et[1], Et[2]);
  }), Pt && (formatTokenFunctions[Pt] = function() {
    return this.localeData().ordinal(
      Mt.apply(this, arguments),
      _t
    );
  });
}
function removeFormattingTokens(_t) {
  return _t.match(/\[[\s\S]/) ? _t.replace(/^\[|\]$/g, "") : _t.replace(/\\/g, "");
}
function makeFormatFunction(_t) {
  var Et = _t.match(formattingTokens), Pt, $t;
  for (Pt = 0, $t = Et.length; Pt < $t; Pt++)
    formatTokenFunctions[Et[Pt]] ? Et[Pt] = formatTokenFunctions[Et[Pt]] : Et[Pt] = removeFormattingTokens(Et[Pt]);
  return function(Mt) {
    var Bt = "", Vt;
    for (Vt = 0; Vt < $t; Vt++)
      Bt += isFunction(Et[Vt]) ? Et[Vt].call(Mt, _t) : Et[Vt];
    return Bt;
  };
}
function formatMoment(_t, Et) {
  return _t.isValid() ? (Et = expandFormat(Et, _t.localeData()), formatFunctions[Et] = formatFunctions[Et] || makeFormatFunction(Et), formatFunctions[Et](_t)) : _t.localeData().invalidDate();
}
function expandFormat(_t, Et) {
  var Pt = 5;
  function $t(Mt) {
    return Et.longDateFormat(Mt) || Mt;
  }
  for (localFormattingTokens.lastIndex = 0; Pt >= 0 && localFormattingTokens.test(_t); )
    _t = _t.replace(
      localFormattingTokens,
      $t
    ), localFormattingTokens.lastIndex = 0, Pt -= 1;
  return _t;
}
var defaultLongDateFormat = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function longDateFormat(_t) {
  var Et = this._longDateFormat[_t], Pt = this._longDateFormat[_t.toUpperCase()];
  return Et || !Pt ? Et : (this._longDateFormat[_t] = Pt.match(formattingTokens).map(function($t) {
    return $t === "MMMM" || $t === "MM" || $t === "DD" || $t === "dddd" ? $t.slice(1) : $t;
  }).join(""), this._longDateFormat[_t]);
}
var defaultInvalidDate = "Invalid date";
function invalidDate() {
  return this._invalidDate;
}
var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
function ordinal(_t) {
  return this._ordinal.replace("%d", _t);
}
var defaultRelativeTime = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function relativeTime(_t, Et, Pt, $t) {
  var Mt = this._relativeTime[Pt];
  return isFunction(Mt) ? Mt(_t, Et, Pt, $t) : Mt.replace(/%d/i, _t);
}
function pastFuture(_t, Et) {
  var Pt = this._relativeTime[_t > 0 ? "future" : "past"];
  return isFunction(Pt) ? Pt(Et) : Pt.replace(/%s/i, Et);
}
var aliases = {
  D: "date",
  dates: "date",
  date: "date",
  d: "day",
  days: "day",
  day: "day",
  e: "weekday",
  weekdays: "weekday",
  weekday: "weekday",
  E: "isoWeekday",
  isoweekdays: "isoWeekday",
  isoweekday: "isoWeekday",
  DDD: "dayOfYear",
  dayofyears: "dayOfYear",
  dayofyear: "dayOfYear",
  h: "hour",
  hours: "hour",
  hour: "hour",
  ms: "millisecond",
  milliseconds: "millisecond",
  millisecond: "millisecond",
  m: "minute",
  minutes: "minute",
  minute: "minute",
  M: "month",
  months: "month",
  month: "month",
  Q: "quarter",
  quarters: "quarter",
  quarter: "quarter",
  s: "second",
  seconds: "second",
  second: "second",
  gg: "weekYear",
  weekyears: "weekYear",
  weekyear: "weekYear",
  GG: "isoWeekYear",
  isoweekyears: "isoWeekYear",
  isoweekyear: "isoWeekYear",
  w: "week",
  weeks: "week",
  week: "week",
  W: "isoWeek",
  isoweeks: "isoWeek",
  isoweek: "isoWeek",
  y: "year",
  years: "year",
  year: "year"
};
function normalizeUnits(_t) {
  return typeof _t == "string" ? aliases[_t] || aliases[_t.toLowerCase()] : void 0;
}
function normalizeObjectUnits(_t) {
  var Et = {}, Pt, $t;
  for ($t in _t)
    hasOwnProp(_t, $t) && (Pt = normalizeUnits($t), Pt && (Et[Pt] = _t[$t]));
  return Et;
}
var priorities = {
  date: 9,
  day: 11,
  weekday: 11,
  isoWeekday: 11,
  dayOfYear: 4,
  hour: 13,
  millisecond: 16,
  minute: 14,
  month: 8,
  quarter: 7,
  second: 15,
  weekYear: 1,
  isoWeekYear: 1,
  week: 5,
  isoWeek: 5,
  year: 1
};
function getPrioritizedUnits(_t) {
  var Et = [], Pt;
  for (Pt in _t)
    hasOwnProp(_t, Pt) && Et.push({ unit: Pt, priority: priorities[Pt] });
  return Et.sort(function($t, Mt) {
    return $t.priority - Mt.priority;
  }), Et;
}
var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
regexes = {};
function addRegexToken(_t, Et, Pt) {
  regexes[_t] = isFunction(Et) ? Et : function($t, Mt) {
    return $t && Pt ? Pt : Et;
  };
}
function getParseRegexForToken(_t, Et) {
  return hasOwnProp(regexes, _t) ? regexes[_t](Et._strict, Et._locale) : new RegExp(unescapeFormat(_t));
}
function unescapeFormat(_t) {
  return regexEscape(
    _t.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(Et, Pt, $t, Mt, Bt) {
        return Pt || $t || Mt || Bt;
      }
    )
  );
}
function regexEscape(_t) {
  return _t.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function absFloor(_t) {
  return _t < 0 ? Math.ceil(_t) || 0 : Math.floor(_t);
}
function toInt(_t) {
  var Et = +_t, Pt = 0;
  return Et !== 0 && isFinite(Et) && (Pt = absFloor(Et)), Pt;
}
var tokens = {};
function addParseToken(_t, Et) {
  var Pt, $t = Et, Mt;
  for (typeof _t == "string" && (_t = [_t]), isNumber(Et) && ($t = function(Bt, Vt) {
    Vt[Et] = toInt(Bt);
  }), Mt = _t.length, Pt = 0; Pt < Mt; Pt++)
    tokens[_t[Pt]] = $t;
}
function addWeekParseToken(_t, Et) {
  addParseToken(_t, function(Pt, $t, Mt, Bt) {
    Mt._w = Mt._w || {}, Et(Pt, Mt._w, Mt, Bt);
  });
}
function addTimeToArrayFromToken(_t, Et, Pt) {
  Et != null && hasOwnProp(tokens, _t) && tokens[_t](Et, Pt._a, Pt, _t);
}
function isLeapYear(_t) {
  return _t % 4 === 0 && _t % 100 !== 0 || _t % 400 === 0;
}
var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
addFormatToken("Y", 0, 0, function() {
  var _t = this.year();
  return _t <= 9999 ? zeroFill(_t, 4) : "+" + _t;
});
addFormatToken(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
addFormatToken(0, ["YYYY", 4], 0, "year");
addFormatToken(0, ["YYYYY", 5], 0, "year");
addFormatToken(0, ["YYYYYY", 6, !0], 0, "year");
addRegexToken("Y", matchSigned);
addRegexToken("YY", match1to2, match2);
addRegexToken("YYYY", match1to4, match4);
addRegexToken("YYYYY", match1to6, match6);
addRegexToken("YYYYYY", match1to6, match6);
addParseToken(["YYYYY", "YYYYYY"], YEAR);
addParseToken("YYYY", function(_t, Et) {
  Et[YEAR] = _t.length === 2 ? hooks.parseTwoDigitYear(_t) : toInt(_t);
});
addParseToken("YY", function(_t, Et) {
  Et[YEAR] = hooks.parseTwoDigitYear(_t);
});
addParseToken("Y", function(_t, Et) {
  Et[YEAR] = parseInt(_t, 10);
});
function daysInYear(_t) {
  return isLeapYear(_t) ? 366 : 365;
}
hooks.parseTwoDigitYear = function(_t) {
  return toInt(_t) + (toInt(_t) > 68 ? 1900 : 2e3);
};
var getSetYear = makeGetSet("FullYear", !0);
function getIsLeapYear() {
  return isLeapYear(this.year());
}
function makeGetSet(_t, Et) {
  return function(Pt) {
    return Pt != null ? (set$1(this, _t, Pt), hooks.updateOffset(this, Et), this) : get(this, _t);
  };
}
function get(_t, Et) {
  if (!_t.isValid())
    return NaN;
  var Pt = _t._d, $t = _t._isUTC;
  switch (Et) {
    case "Milliseconds":
      return $t ? Pt.getUTCMilliseconds() : Pt.getMilliseconds();
    case "Seconds":
      return $t ? Pt.getUTCSeconds() : Pt.getSeconds();
    case "Minutes":
      return $t ? Pt.getUTCMinutes() : Pt.getMinutes();
    case "Hours":
      return $t ? Pt.getUTCHours() : Pt.getHours();
    case "Date":
      return $t ? Pt.getUTCDate() : Pt.getDate();
    case "Day":
      return $t ? Pt.getUTCDay() : Pt.getDay();
    case "Month":
      return $t ? Pt.getUTCMonth() : Pt.getMonth();
    case "FullYear":
      return $t ? Pt.getUTCFullYear() : Pt.getFullYear();
    default:
      return NaN;
  }
}
function set$1(_t, Et, Pt) {
  var $t, Mt, Bt, Vt, zt;
  if (!(!_t.isValid() || isNaN(Pt))) {
    switch ($t = _t._d, Mt = _t._isUTC, Et) {
      case "Milliseconds":
        return void (Mt ? $t.setUTCMilliseconds(Pt) : $t.setMilliseconds(Pt));
      case "Seconds":
        return void (Mt ? $t.setUTCSeconds(Pt) : $t.setSeconds(Pt));
      case "Minutes":
        return void (Mt ? $t.setUTCMinutes(Pt) : $t.setMinutes(Pt));
      case "Hours":
        return void (Mt ? $t.setUTCHours(Pt) : $t.setHours(Pt));
      case "Date":
        return void (Mt ? $t.setUTCDate(Pt) : $t.setDate(Pt));
      case "FullYear":
        break;
      default:
        return;
    }
    Bt = Pt, Vt = _t.month(), zt = _t.date(), zt = zt === 29 && Vt === 1 && !isLeapYear(Bt) ? 28 : zt, Mt ? $t.setUTCFullYear(Bt, Vt, zt) : $t.setFullYear(Bt, Vt, zt);
  }
}
function stringGet(_t) {
  return _t = normalizeUnits(_t), isFunction(this[_t]) ? this[_t]() : this;
}
function stringSet(_t, Et) {
  if (typeof _t == "object") {
    _t = normalizeObjectUnits(_t);
    var Pt = getPrioritizedUnits(_t), $t, Mt = Pt.length;
    for ($t = 0; $t < Mt; $t++)
      this[Pt[$t].unit](_t[Pt[$t].unit]);
  } else if (_t = normalizeUnits(_t), isFunction(this[_t]))
    return this[_t](Et);
  return this;
}
function mod(_t, Et) {
  return (_t % Et + Et) % Et;
}
var indexOf;
Array.prototype.indexOf ? indexOf = Array.prototype.indexOf : indexOf = function(_t) {
  var Et;
  for (Et = 0; Et < this.length; ++Et)
    if (this[Et] === _t)
      return Et;
  return -1;
};
function daysInMonth(_t, Et) {
  if (isNaN(_t) || isNaN(Et))
    return NaN;
  var Pt = mod(Et, 12);
  return _t += (Et - Pt) / 12, Pt === 1 ? isLeapYear(_t) ? 29 : 28 : 31 - Pt % 7 % 2;
}
addFormatToken("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
addFormatToken("MMM", 0, 0, function(_t) {
  return this.localeData().monthsShort(this, _t);
});
addFormatToken("MMMM", 0, 0, function(_t) {
  return this.localeData().months(this, _t);
});
addRegexToken("M", match1to2, match1to2NoLeadingZero);
addRegexToken("MM", match1to2, match2);
addRegexToken("MMM", function(_t, Et) {
  return Et.monthsShortRegex(_t);
});
addRegexToken("MMMM", function(_t, Et) {
  return Et.monthsRegex(_t);
});
addParseToken(["M", "MM"], function(_t, Et) {
  Et[MONTH] = toInt(_t) - 1;
});
addParseToken(["MMM", "MMMM"], function(_t, Et, Pt, $t) {
  var Mt = Pt._locale.monthsParse(_t, $t, Pt._strict);
  Mt != null ? Et[MONTH] = Mt : getParsingFlags(Pt).invalidMonth = _t;
});
var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
function localeMonths(_t, Et) {
  return _t ? isArray(this._months) ? this._months[_t.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(Et) ? "format" : "standalone"][_t.month()] : isArray(this._months) ? this._months : this._months.standalone;
}
function localeMonthsShort(_t, Et) {
  return _t ? isArray(this._monthsShort) ? this._monthsShort[_t.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(Et) ? "format" : "standalone"][_t.month()] : isArray(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function handleStrictParse(_t, Et, Pt) {
  var $t, Mt, Bt, Vt = _t.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], $t = 0; $t < 12; ++$t)
      Bt = createUTC([2e3, $t]), this._shortMonthsParse[$t] = this.monthsShort(
        Bt,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[$t] = this.months(Bt, "").toLocaleLowerCase();
  return Pt ? Et === "MMM" ? (Mt = indexOf.call(this._shortMonthsParse, Vt), Mt !== -1 ? Mt : null) : (Mt = indexOf.call(this._longMonthsParse, Vt), Mt !== -1 ? Mt : null) : Et === "MMM" ? (Mt = indexOf.call(this._shortMonthsParse, Vt), Mt !== -1 ? Mt : (Mt = indexOf.call(this._longMonthsParse, Vt), Mt !== -1 ? Mt : null)) : (Mt = indexOf.call(this._longMonthsParse, Vt), Mt !== -1 ? Mt : (Mt = indexOf.call(this._shortMonthsParse, Vt), Mt !== -1 ? Mt : null));
}
function localeMonthsParse(_t, Et, Pt) {
  var $t, Mt, Bt;
  if (this._monthsParseExact)
    return handleStrictParse.call(this, _t, Et, Pt);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), $t = 0; $t < 12; $t++) {
    if (Mt = createUTC([2e3, $t]), Pt && !this._longMonthsParse[$t] && (this._longMonthsParse[$t] = new RegExp(
      "^" + this.months(Mt, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[$t] = new RegExp(
      "^" + this.monthsShort(Mt, "").replace(".", "") + "$",
      "i"
    )), !Pt && !this._monthsParse[$t] && (Bt = "^" + this.months(Mt, "") + "|^" + this.monthsShort(Mt, ""), this._monthsParse[$t] = new RegExp(Bt.replace(".", ""), "i")), Pt && Et === "MMMM" && this._longMonthsParse[$t].test(_t))
      return $t;
    if (Pt && Et === "MMM" && this._shortMonthsParse[$t].test(_t))
      return $t;
    if (!Pt && this._monthsParse[$t].test(_t))
      return $t;
  }
}
function setMonth(_t, Et) {
  if (!_t.isValid())
    return _t;
  if (typeof Et == "string") {
    if (/^\d+$/.test(Et))
      Et = toInt(Et);
    else if (Et = _t.localeData().monthsParse(Et), !isNumber(Et))
      return _t;
  }
  var Pt = Et, $t = _t.date();
  return $t = $t < 29 ? $t : Math.min($t, daysInMonth(_t.year(), Pt)), _t._isUTC ? _t._d.setUTCMonth(Pt, $t) : _t._d.setMonth(Pt, $t), _t;
}
function getSetMonth(_t) {
  return _t != null ? (setMonth(this, _t), hooks.updateOffset(this, !0), this) : get(this, "Month");
}
function getDaysInMonth() {
  return daysInMonth(this.year(), this.month());
}
function monthsShortRegex(_t) {
  return this._monthsParseExact ? (hasOwnProp(this, "_monthsRegex") || computeMonthsParse.call(this), _t ? this._monthsShortStrictRegex : this._monthsShortRegex) : (hasOwnProp(this, "_monthsShortRegex") || (this._monthsShortRegex = defaultMonthsShortRegex), this._monthsShortStrictRegex && _t ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function monthsRegex(_t) {
  return this._monthsParseExact ? (hasOwnProp(this, "_monthsRegex") || computeMonthsParse.call(this), _t ? this._monthsStrictRegex : this._monthsRegex) : (hasOwnProp(this, "_monthsRegex") || (this._monthsRegex = defaultMonthsRegex), this._monthsStrictRegex && _t ? this._monthsStrictRegex : this._monthsRegex);
}
function computeMonthsParse() {
  function _t(Ht, Wt) {
    return Wt.length - Ht.length;
  }
  var Et = [], Pt = [], $t = [], Mt, Bt, Vt, zt;
  for (Mt = 0; Mt < 12; Mt++)
    Bt = createUTC([2e3, Mt]), Vt = regexEscape(this.monthsShort(Bt, "")), zt = regexEscape(this.months(Bt, "")), Et.push(Vt), Pt.push(zt), $t.push(zt), $t.push(Vt);
  Et.sort(_t), Pt.sort(_t), $t.sort(_t), this._monthsRegex = new RegExp("^(" + $t.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + Pt.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + Et.join("|") + ")",
    "i"
  );
}
function createDate(_t, Et, Pt, $t, Mt, Bt, Vt) {
  var zt;
  return _t < 100 && _t >= 0 ? (zt = new Date(_t + 400, Et, Pt, $t, Mt, Bt, Vt), isFinite(zt.getFullYear()) && zt.setFullYear(_t)) : zt = new Date(_t, Et, Pt, $t, Mt, Bt, Vt), zt;
}
function createUTCDate(_t) {
  var Et, Pt;
  return _t < 100 && _t >= 0 ? (Pt = Array.prototype.slice.call(arguments), Pt[0] = _t + 400, Et = new Date(Date.UTC.apply(null, Pt)), isFinite(Et.getUTCFullYear()) && Et.setUTCFullYear(_t)) : Et = new Date(Date.UTC.apply(null, arguments)), Et;
}
function firstWeekOffset(_t, Et, Pt) {
  var $t = 7 + Et - Pt, Mt = (7 + createUTCDate(_t, 0, $t).getUTCDay() - Et) % 7;
  return -Mt + $t - 1;
}
function dayOfYearFromWeeks(_t, Et, Pt, $t, Mt) {
  var Bt = (7 + Pt - $t) % 7, Vt = firstWeekOffset(_t, $t, Mt), zt = 1 + 7 * (Et - 1) + Bt + Vt, Ht, Wt;
  return zt <= 0 ? (Ht = _t - 1, Wt = daysInYear(Ht) + zt) : zt > daysInYear(_t) ? (Ht = _t + 1, Wt = zt - daysInYear(_t)) : (Ht = _t, Wt = zt), {
    year: Ht,
    dayOfYear: Wt
  };
}
function weekOfYear(_t, Et, Pt) {
  var $t = firstWeekOffset(_t.year(), Et, Pt), Mt = Math.floor((_t.dayOfYear() - $t - 1) / 7) + 1, Bt, Vt;
  return Mt < 1 ? (Vt = _t.year() - 1, Bt = Mt + weeksInYear(Vt, Et, Pt)) : Mt > weeksInYear(_t.year(), Et, Pt) ? (Bt = Mt - weeksInYear(_t.year(), Et, Pt), Vt = _t.year() + 1) : (Vt = _t.year(), Bt = Mt), {
    week: Bt,
    year: Vt
  };
}
function weeksInYear(_t, Et, Pt) {
  var $t = firstWeekOffset(_t, Et, Pt), Mt = firstWeekOffset(_t + 1, Et, Pt);
  return (daysInYear(_t) - $t + Mt) / 7;
}
addFormatToken("w", ["ww", 2], "wo", "week");
addFormatToken("W", ["WW", 2], "Wo", "isoWeek");
addRegexToken("w", match1to2, match1to2NoLeadingZero);
addRegexToken("ww", match1to2, match2);
addRegexToken("W", match1to2, match1to2NoLeadingZero);
addRegexToken("WW", match1to2, match2);
addWeekParseToken(
  ["w", "ww", "W", "WW"],
  function(_t, Et, Pt, $t) {
    Et[$t.substr(0, 1)] = toInt(_t);
  }
);
function localeWeek(_t) {
  return weekOfYear(_t, this._week.dow, this._week.doy).week;
}
var defaultLocaleWeek = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function localeFirstDayOfWeek() {
  return this._week.dow;
}
function localeFirstDayOfYear() {
  return this._week.doy;
}
function getSetWeek(_t) {
  var Et = this.localeData().week(this);
  return _t == null ? Et : this.add((_t - Et) * 7, "d");
}
function getSetISOWeek(_t) {
  var Et = weekOfYear(this, 1, 4).week;
  return _t == null ? Et : this.add((_t - Et) * 7, "d");
}
addFormatToken("d", 0, "do", "day");
addFormatToken("dd", 0, 0, function(_t) {
  return this.localeData().weekdaysMin(this, _t);
});
addFormatToken("ddd", 0, 0, function(_t) {
  return this.localeData().weekdaysShort(this, _t);
});
addFormatToken("dddd", 0, 0, function(_t) {
  return this.localeData().weekdays(this, _t);
});
addFormatToken("e", 0, 0, "weekday");
addFormatToken("E", 0, 0, "isoWeekday");
addRegexToken("d", match1to2);
addRegexToken("e", match1to2);
addRegexToken("E", match1to2);
addRegexToken("dd", function(_t, Et) {
  return Et.weekdaysMinRegex(_t);
});
addRegexToken("ddd", function(_t, Et) {
  return Et.weekdaysShortRegex(_t);
});
addRegexToken("dddd", function(_t, Et) {
  return Et.weekdaysRegex(_t);
});
addWeekParseToken(["dd", "ddd", "dddd"], function(_t, Et, Pt, $t) {
  var Mt = Pt._locale.weekdaysParse(_t, $t, Pt._strict);
  Mt != null ? Et.d = Mt : getParsingFlags(Pt).invalidWeekday = _t;
});
addWeekParseToken(["d", "e", "E"], function(_t, Et, Pt, $t) {
  Et[$t] = toInt(_t);
});
function parseWeekday(_t, Et) {
  return typeof _t != "string" ? _t : isNaN(_t) ? (_t = Et.weekdaysParse(_t), typeof _t == "number" ? _t : null) : parseInt(_t, 10);
}
function parseIsoWeekday(_t, Et) {
  return typeof _t == "string" ? Et.weekdaysParse(_t) % 7 || 7 : isNaN(_t) ? null : _t;
}
function shiftWeekdays(_t, Et) {
  return _t.slice(Et, 7).concat(_t.slice(0, Et));
}
var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
function localeWeekdays(_t, Et) {
  var Pt = isArray(this._weekdays) ? this._weekdays : this._weekdays[_t && _t !== !0 && this._weekdays.isFormat.test(Et) ? "format" : "standalone"];
  return _t === !0 ? shiftWeekdays(Pt, this._week.dow) : _t ? Pt[_t.day()] : Pt;
}
function localeWeekdaysShort(_t) {
  return _t === !0 ? shiftWeekdays(this._weekdaysShort, this._week.dow) : _t ? this._weekdaysShort[_t.day()] : this._weekdaysShort;
}
function localeWeekdaysMin(_t) {
  return _t === !0 ? shiftWeekdays(this._weekdaysMin, this._week.dow) : _t ? this._weekdaysMin[_t.day()] : this._weekdaysMin;
}
function handleStrictParse$1(_t, Et, Pt) {
  var $t, Mt, Bt, Vt = _t.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], $t = 0; $t < 7; ++$t)
      Bt = createUTC([2e3, 1]).day($t), this._minWeekdaysParse[$t] = this.weekdaysMin(
        Bt,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[$t] = this.weekdaysShort(
        Bt,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[$t] = this.weekdays(Bt, "").toLocaleLowerCase();
  return Pt ? Et === "dddd" ? (Mt = indexOf.call(this._weekdaysParse, Vt), Mt !== -1 ? Mt : null) : Et === "ddd" ? (Mt = indexOf.call(this._shortWeekdaysParse, Vt), Mt !== -1 ? Mt : null) : (Mt = indexOf.call(this._minWeekdaysParse, Vt), Mt !== -1 ? Mt : null) : Et === "dddd" ? (Mt = indexOf.call(this._weekdaysParse, Vt), Mt !== -1 || (Mt = indexOf.call(this._shortWeekdaysParse, Vt), Mt !== -1) ? Mt : (Mt = indexOf.call(this._minWeekdaysParse, Vt), Mt !== -1 ? Mt : null)) : Et === "ddd" ? (Mt = indexOf.call(this._shortWeekdaysParse, Vt), Mt !== -1 || (Mt = indexOf.call(this._weekdaysParse, Vt), Mt !== -1) ? Mt : (Mt = indexOf.call(this._minWeekdaysParse, Vt), Mt !== -1 ? Mt : null)) : (Mt = indexOf.call(this._minWeekdaysParse, Vt), Mt !== -1 || (Mt = indexOf.call(this._weekdaysParse, Vt), Mt !== -1) ? Mt : (Mt = indexOf.call(this._shortWeekdaysParse, Vt), Mt !== -1 ? Mt : null));
}
function localeWeekdaysParse(_t, Et, Pt) {
  var $t, Mt, Bt;
  if (this._weekdaysParseExact)
    return handleStrictParse$1.call(this, _t, Et, Pt);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), $t = 0; $t < 7; $t++) {
    if (Mt = createUTC([2e3, 1]).day($t), Pt && !this._fullWeekdaysParse[$t] && (this._fullWeekdaysParse[$t] = new RegExp(
      "^" + this.weekdays(Mt, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[$t] = new RegExp(
      "^" + this.weekdaysShort(Mt, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[$t] = new RegExp(
      "^" + this.weekdaysMin(Mt, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[$t] || (Bt = "^" + this.weekdays(Mt, "") + "|^" + this.weekdaysShort(Mt, "") + "|^" + this.weekdaysMin(Mt, ""), this._weekdaysParse[$t] = new RegExp(Bt.replace(".", ""), "i")), Pt && Et === "dddd" && this._fullWeekdaysParse[$t].test(_t))
      return $t;
    if (Pt && Et === "ddd" && this._shortWeekdaysParse[$t].test(_t))
      return $t;
    if (Pt && Et === "dd" && this._minWeekdaysParse[$t].test(_t))
      return $t;
    if (!Pt && this._weekdaysParse[$t].test(_t))
      return $t;
  }
}
function getSetDayOfWeek(_t) {
  if (!this.isValid())
    return _t != null ? this : NaN;
  var Et = get(this, "Day");
  return _t != null ? (_t = parseWeekday(_t, this.localeData()), this.add(_t - Et, "d")) : Et;
}
function getSetLocaleDayOfWeek(_t) {
  if (!this.isValid())
    return _t != null ? this : NaN;
  var Et = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return _t == null ? Et : this.add(_t - Et, "d");
}
function getSetISODayOfWeek(_t) {
  if (!this.isValid())
    return _t != null ? this : NaN;
  if (_t != null) {
    var Et = parseIsoWeekday(_t, this.localeData());
    return this.day(this.day() % 7 ? Et : Et - 7);
  } else
    return this.day() || 7;
}
function weekdaysRegex(_t) {
  return this._weekdaysParseExact ? (hasOwnProp(this, "_weekdaysRegex") || computeWeekdaysParse.call(this), _t ? this._weekdaysStrictRegex : this._weekdaysRegex) : (hasOwnProp(this, "_weekdaysRegex") || (this._weekdaysRegex = defaultWeekdaysRegex), this._weekdaysStrictRegex && _t ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function weekdaysShortRegex(_t) {
  return this._weekdaysParseExact ? (hasOwnProp(this, "_weekdaysRegex") || computeWeekdaysParse.call(this), _t ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (hasOwnProp(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = defaultWeekdaysShortRegex), this._weekdaysShortStrictRegex && _t ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function weekdaysMinRegex(_t) {
  return this._weekdaysParseExact ? (hasOwnProp(this, "_weekdaysRegex") || computeWeekdaysParse.call(this), _t ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (hasOwnProp(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = defaultWeekdaysMinRegex), this._weekdaysMinStrictRegex && _t ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function computeWeekdaysParse() {
  function _t(Gt, qt) {
    return qt.length - Gt.length;
  }
  var Et = [], Pt = [], $t = [], Mt = [], Bt, Vt, zt, Ht, Wt;
  for (Bt = 0; Bt < 7; Bt++)
    Vt = createUTC([2e3, 1]).day(Bt), zt = regexEscape(this.weekdaysMin(Vt, "")), Ht = regexEscape(this.weekdaysShort(Vt, "")), Wt = regexEscape(this.weekdays(Vt, "")), Et.push(zt), Pt.push(Ht), $t.push(Wt), Mt.push(zt), Mt.push(Ht), Mt.push(Wt);
  Et.sort(_t), Pt.sort(_t), $t.sort(_t), Mt.sort(_t), this._weekdaysRegex = new RegExp("^(" + Mt.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + $t.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + Pt.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + Et.join("|") + ")",
    "i"
  );
}
function hFormat() {
  return this.hours() % 12 || 12;
}
function kFormat() {
  return this.hours() || 24;
}
addFormatToken("H", ["HH", 2], 0, "hour");
addFormatToken("h", ["hh", 2], 0, hFormat);
addFormatToken("k", ["kk", 2], 0, kFormat);
addFormatToken("hmm", 0, 0, function() {
  return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});
addFormatToken("hmmss", 0, 0, function() {
  return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
});
addFormatToken("Hmm", 0, 0, function() {
  return "" + this.hours() + zeroFill(this.minutes(), 2);
});
addFormatToken("Hmmss", 0, 0, function() {
  return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
});
function meridiem(_t, Et) {
  addFormatToken(_t, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      Et
    );
  });
}
meridiem("a", !0);
meridiem("A", !1);
function matchMeridiem(_t, Et) {
  return Et._meridiemParse;
}
addRegexToken("a", matchMeridiem);
addRegexToken("A", matchMeridiem);
addRegexToken("H", match1to2, match1to2HasZero);
addRegexToken("h", match1to2, match1to2NoLeadingZero);
addRegexToken("k", match1to2, match1to2NoLeadingZero);
addRegexToken("HH", match1to2, match2);
addRegexToken("hh", match1to2, match2);
addRegexToken("kk", match1to2, match2);
addRegexToken("hmm", match3to4);
addRegexToken("hmmss", match5to6);
addRegexToken("Hmm", match3to4);
addRegexToken("Hmmss", match5to6);
addParseToken(["H", "HH"], HOUR);
addParseToken(["k", "kk"], function(_t, Et, Pt) {
  var $t = toInt(_t);
  Et[HOUR] = $t === 24 ? 0 : $t;
});
addParseToken(["a", "A"], function(_t, Et, Pt) {
  Pt._isPm = Pt._locale.isPM(_t), Pt._meridiem = _t;
});
addParseToken(["h", "hh"], function(_t, Et, Pt) {
  Et[HOUR] = toInt(_t), getParsingFlags(Pt).bigHour = !0;
});
addParseToken("hmm", function(_t, Et, Pt) {
  var $t = _t.length - 2;
  Et[HOUR] = toInt(_t.substr(0, $t)), Et[MINUTE] = toInt(_t.substr($t)), getParsingFlags(Pt).bigHour = !0;
});
addParseToken("hmmss", function(_t, Et, Pt) {
  var $t = _t.length - 4, Mt = _t.length - 2;
  Et[HOUR] = toInt(_t.substr(0, $t)), Et[MINUTE] = toInt(_t.substr($t, 2)), Et[SECOND] = toInt(_t.substr(Mt)), getParsingFlags(Pt).bigHour = !0;
});
addParseToken("Hmm", function(_t, Et, Pt) {
  var $t = _t.length - 2;
  Et[HOUR] = toInt(_t.substr(0, $t)), Et[MINUTE] = toInt(_t.substr($t));
});
addParseToken("Hmmss", function(_t, Et, Pt) {
  var $t = _t.length - 4, Mt = _t.length - 2;
  Et[HOUR] = toInt(_t.substr(0, $t)), Et[MINUTE] = toInt(_t.substr($t, 2)), Et[SECOND] = toInt(_t.substr(Mt));
});
function localeIsPM(_t) {
  return (_t + "").toLowerCase().charAt(0) === "p";
}
var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, getSetHour = makeGetSet("Hours", !0);
function localeMeridiem(_t, Et, Pt) {
  return _t > 11 ? Pt ? "pm" : "PM" : Pt ? "am" : "AM";
}
var baseConfig = {
  calendar: defaultCalendar,
  longDateFormat: defaultLongDateFormat,
  invalidDate: defaultInvalidDate,
  ordinal: defaultOrdinal,
  dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
  relativeTime: defaultRelativeTime,
  months: defaultLocaleMonths,
  monthsShort: defaultLocaleMonthsShort,
  week: defaultLocaleWeek,
  weekdays: defaultLocaleWeekdays,
  weekdaysMin: defaultLocaleWeekdaysMin,
  weekdaysShort: defaultLocaleWeekdaysShort,
  meridiemParse: defaultLocaleMeridiemParse
}, locales = {}, localeFamilies = {}, globalLocale;
function commonPrefix(_t, Et) {
  var Pt, $t = Math.min(_t.length, Et.length);
  for (Pt = 0; Pt < $t; Pt += 1)
    if (_t[Pt] !== Et[Pt])
      return Pt;
  return $t;
}
function normalizeLocale(_t) {
  return _t && _t.toLowerCase().replace("_", "-");
}
function chooseLocale(_t) {
  for (var Et = 0, Pt, $t, Mt, Bt; Et < _t.length; ) {
    for (Bt = normalizeLocale(_t[Et]).split("-"), Pt = Bt.length, $t = normalizeLocale(_t[Et + 1]), $t = $t ? $t.split("-") : null; Pt > 0; ) {
      if (Mt = loadLocale(Bt.slice(0, Pt).join("-")), Mt)
        return Mt;
      if ($t && $t.length >= Pt && commonPrefix(Bt, $t) >= Pt - 1)
        break;
      Pt--;
    }
    Et++;
  }
  return globalLocale;
}
function isLocaleNameSane(_t) {
  return !!(_t && _t.match("^[^/\\\\]*$"));
}
function loadLocale(_t) {
  var Et = null, Pt;
  if (locales[_t] === void 0 && typeof module < "u" && module && module.exports && isLocaleNameSane(_t))
    try {
      Et = globalLocale._abbr, Pt = commonjsRequire, Pt("./locale/" + _t), getSetGlobalLocale(Et);
    } catch {
      locales[_t] = null;
    }
  return locales[_t];
}
function getSetGlobalLocale(_t, Et) {
  var Pt;
  return _t && (isUndefined(Et) ? Pt = getLocale(_t) : Pt = defineLocale(_t, Et), Pt ? globalLocale = Pt : typeof console < "u" && console.warn && console.warn(
    "Locale " + _t + " not found. Did you forget to load it?"
  )), globalLocale._abbr;
}
function defineLocale(_t, Et) {
  if (Et !== null) {
    var Pt, $t = baseConfig;
    if (Et.abbr = _t, locales[_t] != null)
      deprecateSimple(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), $t = locales[_t]._config;
    else if (Et.parentLocale != null)
      if (locales[Et.parentLocale] != null)
        $t = locales[Et.parentLocale]._config;
      else if (Pt = loadLocale(Et.parentLocale), Pt != null)
        $t = Pt._config;
      else
        return localeFamilies[Et.parentLocale] || (localeFamilies[Et.parentLocale] = []), localeFamilies[Et.parentLocale].push({
          name: _t,
          config: Et
        }), null;
    return locales[_t] = new Locale(mergeConfigs($t, Et)), localeFamilies[_t] && localeFamilies[_t].forEach(function(Mt) {
      defineLocale(Mt.name, Mt.config);
    }), getSetGlobalLocale(_t), locales[_t];
  } else
    return delete locales[_t], null;
}
function updateLocale(_t, Et) {
  if (Et != null) {
    var Pt, $t, Mt = baseConfig;
    locales[_t] != null && locales[_t].parentLocale != null ? locales[_t].set(mergeConfigs(locales[_t]._config, Et)) : ($t = loadLocale(_t), $t != null && (Mt = $t._config), Et = mergeConfigs(Mt, Et), $t == null && (Et.abbr = _t), Pt = new Locale(Et), Pt.parentLocale = locales[_t], locales[_t] = Pt), getSetGlobalLocale(_t);
  } else
    locales[_t] != null && (locales[_t].parentLocale != null ? (locales[_t] = locales[_t].parentLocale, _t === getSetGlobalLocale() && getSetGlobalLocale(_t)) : locales[_t] != null && delete locales[_t]);
  return locales[_t];
}
function getLocale(_t) {
  var Et;
  if (_t && _t._locale && _t._locale._abbr && (_t = _t._locale._abbr), !_t)
    return globalLocale;
  if (!isArray(_t)) {
    if (Et = loadLocale(_t), Et)
      return Et;
    _t = [_t];
  }
  return chooseLocale(_t);
}
function listLocales() {
  return keys(locales);
}
function checkOverflow(_t) {
  var Et, Pt = _t._a;
  return Pt && getParsingFlags(_t).overflow === -2 && (Et = Pt[MONTH] < 0 || Pt[MONTH] > 11 ? MONTH : Pt[DATE] < 1 || Pt[DATE] > daysInMonth(Pt[YEAR], Pt[MONTH]) ? DATE : Pt[HOUR] < 0 || Pt[HOUR] > 24 || Pt[HOUR] === 24 && (Pt[MINUTE] !== 0 || Pt[SECOND] !== 0 || Pt[MILLISECOND] !== 0) ? HOUR : Pt[MINUTE] < 0 || Pt[MINUTE] > 59 ? MINUTE : Pt[SECOND] < 0 || Pt[SECOND] > 59 ? SECOND : Pt[MILLISECOND] < 0 || Pt[MILLISECOND] > 999 ? MILLISECOND : -1, getParsingFlags(_t)._overflowDayOfYear && (Et < YEAR || Et > DATE) && (Et = DATE), getParsingFlags(_t)._overflowWeeks && Et === -1 && (Et = WEEK), getParsingFlags(_t)._overflowWeekday && Et === -1 && (Et = WEEKDAY), getParsingFlags(_t).overflow = Et), _t;
}
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], isoTimes = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function configFromISO(_t) {
  var Et, Pt, $t = _t._i, Mt = extendedIsoRegex.exec($t) || basicIsoRegex.exec($t), Bt, Vt, zt, Ht, Wt = isoDates.length, Gt = isoTimes.length;
  if (Mt) {
    for (getParsingFlags(_t).iso = !0, Et = 0, Pt = Wt; Et < Pt; Et++)
      if (isoDates[Et][1].exec(Mt[1])) {
        Vt = isoDates[Et][0], Bt = isoDates[Et][2] !== !1;
        break;
      }
    if (Vt == null) {
      _t._isValid = !1;
      return;
    }
    if (Mt[3]) {
      for (Et = 0, Pt = Gt; Et < Pt; Et++)
        if (isoTimes[Et][1].exec(Mt[3])) {
          zt = (Mt[2] || " ") + isoTimes[Et][0];
          break;
        }
      if (zt == null) {
        _t._isValid = !1;
        return;
      }
    }
    if (!Bt && zt != null) {
      _t._isValid = !1;
      return;
    }
    if (Mt[4])
      if (tzRegex.exec(Mt[4]))
        Ht = "Z";
      else {
        _t._isValid = !1;
        return;
      }
    _t._f = Vt + (zt || "") + (Ht || ""), configFromStringAndFormat(_t);
  } else
    _t._isValid = !1;
}
function extractFromRFC2822Strings(_t, Et, Pt, $t, Mt, Bt) {
  var Vt = [
    untruncateYear(_t),
    defaultLocaleMonthsShort.indexOf(Et),
    parseInt(Pt, 10),
    parseInt($t, 10),
    parseInt(Mt, 10)
  ];
  return Bt && Vt.push(parseInt(Bt, 10)), Vt;
}
function untruncateYear(_t) {
  var Et = parseInt(_t, 10);
  return Et <= 49 ? 2e3 + Et : Et <= 999 ? 1900 + Et : Et;
}
function preprocessRFC2822(_t) {
  return _t.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function checkWeekday(_t, Et, Pt) {
  if (_t) {
    var $t = defaultLocaleWeekdaysShort.indexOf(_t), Mt = new Date(
      Et[0],
      Et[1],
      Et[2]
    ).getDay();
    if ($t !== Mt)
      return getParsingFlags(Pt).weekdayMismatch = !0, Pt._isValid = !1, !1;
  }
  return !0;
}
function calculateOffset(_t, Et, Pt) {
  if (_t)
    return obsOffsets[_t];
  if (Et)
    return 0;
  var $t = parseInt(Pt, 10), Mt = $t % 100, Bt = ($t - Mt) / 100;
  return Bt * 60 + Mt;
}
function configFromRFC2822(_t) {
  var Et = rfc2822.exec(preprocessRFC2822(_t._i)), Pt;
  if (Et) {
    if (Pt = extractFromRFC2822Strings(
      Et[4],
      Et[3],
      Et[2],
      Et[5],
      Et[6],
      Et[7]
    ), !checkWeekday(Et[1], Pt, _t))
      return;
    _t._a = Pt, _t._tzm = calculateOffset(Et[8], Et[9], Et[10]), _t._d = createUTCDate.apply(null, _t._a), _t._d.setUTCMinutes(_t._d.getUTCMinutes() - _t._tzm), getParsingFlags(_t).rfc2822 = !0;
  } else
    _t._isValid = !1;
}
function configFromString(_t) {
  var Et = aspNetJsonRegex.exec(_t._i);
  if (Et !== null) {
    _t._d = /* @__PURE__ */ new Date(+Et[1]);
    return;
  }
  if (configFromISO(_t), _t._isValid === !1)
    delete _t._isValid;
  else
    return;
  if (configFromRFC2822(_t), _t._isValid === !1)
    delete _t._isValid;
  else
    return;
  _t._strict ? _t._isValid = !1 : hooks.createFromInputFallback(_t);
}
hooks.createFromInputFallback = deprecate(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(_t) {
    _t._d = /* @__PURE__ */ new Date(_t._i + (_t._useUTC ? " UTC" : ""));
  }
);
function defaults(_t, Et, Pt) {
  return _t ?? Et ?? Pt;
}
function currentDateArray(_t) {
  var Et = new Date(hooks.now());
  return _t._useUTC ? [
    Et.getUTCFullYear(),
    Et.getUTCMonth(),
    Et.getUTCDate()
  ] : [Et.getFullYear(), Et.getMonth(), Et.getDate()];
}
function configFromArray(_t) {
  var Et, Pt, $t = [], Mt, Bt, Vt;
  if (!_t._d) {
    for (Mt = currentDateArray(_t), _t._w && _t._a[DATE] == null && _t._a[MONTH] == null && dayOfYearFromWeekInfo(_t), _t._dayOfYear != null && (Vt = defaults(_t._a[YEAR], Mt[YEAR]), (_t._dayOfYear > daysInYear(Vt) || _t._dayOfYear === 0) && (getParsingFlags(_t)._overflowDayOfYear = !0), Pt = createUTCDate(Vt, 0, _t._dayOfYear), _t._a[MONTH] = Pt.getUTCMonth(), _t._a[DATE] = Pt.getUTCDate()), Et = 0; Et < 3 && _t._a[Et] == null; ++Et)
      _t._a[Et] = $t[Et] = Mt[Et];
    for (; Et < 7; Et++)
      _t._a[Et] = $t[Et] = _t._a[Et] == null ? Et === 2 ? 1 : 0 : _t._a[Et];
    _t._a[HOUR] === 24 && _t._a[MINUTE] === 0 && _t._a[SECOND] === 0 && _t._a[MILLISECOND] === 0 && (_t._nextDay = !0, _t._a[HOUR] = 0), _t._d = (_t._useUTC ? createUTCDate : createDate).apply(
      null,
      $t
    ), Bt = _t._useUTC ? _t._d.getUTCDay() : _t._d.getDay(), _t._tzm != null && _t._d.setUTCMinutes(_t._d.getUTCMinutes() - _t._tzm), _t._nextDay && (_t._a[HOUR] = 24), _t._w && typeof _t._w.d < "u" && _t._w.d !== Bt && (getParsingFlags(_t).weekdayMismatch = !0);
  }
}
function dayOfYearFromWeekInfo(_t) {
  var Et, Pt, $t, Mt, Bt, Vt, zt, Ht, Wt;
  Et = _t._w, Et.GG != null || Et.W != null || Et.E != null ? (Bt = 1, Vt = 4, Pt = defaults(
    Et.GG,
    _t._a[YEAR],
    weekOfYear(createLocal(), 1, 4).year
  ), $t = defaults(Et.W, 1), Mt = defaults(Et.E, 1), (Mt < 1 || Mt > 7) && (Ht = !0)) : (Bt = _t._locale._week.dow, Vt = _t._locale._week.doy, Wt = weekOfYear(createLocal(), Bt, Vt), Pt = defaults(Et.gg, _t._a[YEAR], Wt.year), $t = defaults(Et.w, Wt.week), Et.d != null ? (Mt = Et.d, (Mt < 0 || Mt > 6) && (Ht = !0)) : Et.e != null ? (Mt = Et.e + Bt, (Et.e < 0 || Et.e > 6) && (Ht = !0)) : Mt = Bt), $t < 1 || $t > weeksInYear(Pt, Bt, Vt) ? getParsingFlags(_t)._overflowWeeks = !0 : Ht != null ? getParsingFlags(_t)._overflowWeekday = !0 : (zt = dayOfYearFromWeeks(Pt, $t, Mt, Bt, Vt), _t._a[YEAR] = zt.year, _t._dayOfYear = zt.dayOfYear);
}
hooks.ISO_8601 = function() {
};
hooks.RFC_2822 = function() {
};
function configFromStringAndFormat(_t) {
  if (_t._f === hooks.ISO_8601) {
    configFromISO(_t);
    return;
  }
  if (_t._f === hooks.RFC_2822) {
    configFromRFC2822(_t);
    return;
  }
  _t._a = [], getParsingFlags(_t).empty = !0;
  var Et = "" + _t._i, Pt, $t, Mt, Bt, Vt, zt = Et.length, Ht = 0, Wt, Gt;
  for (Mt = expandFormat(_t._f, _t._locale).match(formattingTokens) || [], Gt = Mt.length, Pt = 0; Pt < Gt; Pt++)
    Bt = Mt[Pt], $t = (Et.match(getParseRegexForToken(Bt, _t)) || [])[0], $t && (Vt = Et.substr(0, Et.indexOf($t)), Vt.length > 0 && getParsingFlags(_t).unusedInput.push(Vt), Et = Et.slice(
      Et.indexOf($t) + $t.length
    ), Ht += $t.length), formatTokenFunctions[Bt] ? ($t ? getParsingFlags(_t).empty = !1 : getParsingFlags(_t).unusedTokens.push(Bt), addTimeToArrayFromToken(Bt, $t, _t)) : _t._strict && !$t && getParsingFlags(_t).unusedTokens.push(Bt);
  getParsingFlags(_t).charsLeftOver = zt - Ht, Et.length > 0 && getParsingFlags(_t).unusedInput.push(Et), _t._a[HOUR] <= 12 && getParsingFlags(_t).bigHour === !0 && _t._a[HOUR] > 0 && (getParsingFlags(_t).bigHour = void 0), getParsingFlags(_t).parsedDateParts = _t._a.slice(0), getParsingFlags(_t).meridiem = _t._meridiem, _t._a[HOUR] = meridiemFixWrap(
    _t._locale,
    _t._a[HOUR],
    _t._meridiem
  ), Wt = getParsingFlags(_t).era, Wt !== null && (_t._a[YEAR] = _t._locale.erasConvertYear(Wt, _t._a[YEAR])), configFromArray(_t), checkOverflow(_t);
}
function meridiemFixWrap(_t, Et, Pt) {
  var $t;
  return Pt == null ? Et : _t.meridiemHour != null ? _t.meridiemHour(Et, Pt) : (_t.isPM != null && ($t = _t.isPM(Pt), $t && Et < 12 && (Et += 12), !$t && Et === 12 && (Et = 0)), Et);
}
function configFromStringAndArray(_t) {
  var Et, Pt, $t, Mt, Bt, Vt, zt = !1, Ht = _t._f.length;
  if (Ht === 0) {
    getParsingFlags(_t).invalidFormat = !0, _t._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (Mt = 0; Mt < Ht; Mt++)
    Bt = 0, Vt = !1, Et = copyConfig({}, _t), _t._useUTC != null && (Et._useUTC = _t._useUTC), Et._f = _t._f[Mt], configFromStringAndFormat(Et), isValid(Et) && (Vt = !0), Bt += getParsingFlags(Et).charsLeftOver, Bt += getParsingFlags(Et).unusedTokens.length * 10, getParsingFlags(Et).score = Bt, zt ? Bt < $t && ($t = Bt, Pt = Et) : ($t == null || Bt < $t || Vt) && ($t = Bt, Pt = Et, Vt && (zt = !0));
  extend(_t, Pt || Et);
}
function configFromObject(_t) {
  if (!_t._d) {
    var Et = normalizeObjectUnits(_t._i), Pt = Et.day === void 0 ? Et.date : Et.day;
    _t._a = map(
      [Et.year, Et.month, Pt, Et.hour, Et.minute, Et.second, Et.millisecond],
      function($t) {
        return $t && parseInt($t, 10);
      }
    ), configFromArray(_t);
  }
}
function createFromConfig(_t) {
  var Et = new Moment(checkOverflow(prepareConfig(_t)));
  return Et._nextDay && (Et.add(1, "d"), Et._nextDay = void 0), Et;
}
function prepareConfig(_t) {
  var Et = _t._i, Pt = _t._f;
  return _t._locale = _t._locale || getLocale(_t._l), Et === null || Pt === void 0 && Et === "" ? createInvalid({ nullInput: !0 }) : (typeof Et == "string" && (_t._i = Et = _t._locale.preparse(Et)), isMoment(Et) ? new Moment(checkOverflow(Et)) : (isDate(Et) ? _t._d = Et : isArray(Pt) ? configFromStringAndArray(_t) : Pt ? configFromStringAndFormat(_t) : configFromInput(_t), isValid(_t) || (_t._d = null), _t));
}
function configFromInput(_t) {
  var Et = _t._i;
  isUndefined(Et) ? _t._d = new Date(hooks.now()) : isDate(Et) ? _t._d = new Date(Et.valueOf()) : typeof Et == "string" ? configFromString(_t) : isArray(Et) ? (_t._a = map(Et.slice(0), function(Pt) {
    return parseInt(Pt, 10);
  }), configFromArray(_t)) : isObject(Et) ? configFromObject(_t) : isNumber(Et) ? _t._d = new Date(Et) : hooks.createFromInputFallback(_t);
}
function createLocalOrUTC(_t, Et, Pt, $t, Mt) {
  var Bt = {};
  return (Et === !0 || Et === !1) && ($t = Et, Et = void 0), (Pt === !0 || Pt === !1) && ($t = Pt, Pt = void 0), (isObject(_t) && isObjectEmpty(_t) || isArray(_t) && _t.length === 0) && (_t = void 0), Bt._isAMomentObject = !0, Bt._useUTC = Bt._isUTC = Mt, Bt._l = Pt, Bt._i = _t, Bt._f = Et, Bt._strict = $t, createFromConfig(Bt);
}
function createLocal(_t, Et, Pt, $t) {
  return createLocalOrUTC(_t, Et, Pt, $t, !1);
}
var prototypeMin = deprecate(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var _t = createLocal.apply(null, arguments);
    return this.isValid() && _t.isValid() ? _t < this ? this : _t : createInvalid();
  }
), prototypeMax = deprecate(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var _t = createLocal.apply(null, arguments);
    return this.isValid() && _t.isValid() ? _t > this ? this : _t : createInvalid();
  }
);
function pickBy(_t, Et) {
  var Pt, $t;
  if (Et.length === 1 && isArray(Et[0]) && (Et = Et[0]), !Et.length)
    return createLocal();
  for (Pt = Et[0], $t = 1; $t < Et.length; ++$t)
    (!Et[$t].isValid() || Et[$t][_t](Pt)) && (Pt = Et[$t]);
  return Pt;
}
function min() {
  var _t = [].slice.call(arguments, 0);
  return pickBy("isBefore", _t);
}
function max() {
  var _t = [].slice.call(arguments, 0);
  return pickBy("isAfter", _t);
}
var now = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, ordering = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function isDurationValid(_t) {
  var Et, Pt = !1, $t, Mt = ordering.length;
  for (Et in _t)
    if (hasOwnProp(_t, Et) && !(indexOf.call(ordering, Et) !== -1 && (_t[Et] == null || !isNaN(_t[Et]))))
      return !1;
  for ($t = 0; $t < Mt; ++$t)
    if (_t[ordering[$t]]) {
      if (Pt)
        return !1;
      parseFloat(_t[ordering[$t]]) !== toInt(_t[ordering[$t]]) && (Pt = !0);
    }
  return !0;
}
function isValid$1() {
  return this._isValid;
}
function createInvalid$1() {
  return createDuration(NaN);
}
function Duration(_t) {
  var Et = normalizeObjectUnits(_t), Pt = Et.year || 0, $t = Et.quarter || 0, Mt = Et.month || 0, Bt = Et.week || Et.isoWeek || 0, Vt = Et.day || 0, zt = Et.hour || 0, Ht = Et.minute || 0, Wt = Et.second || 0, Gt = Et.millisecond || 0;
  this._isValid = isDurationValid(Et), this._milliseconds = +Gt + Wt * 1e3 + // 1000
  Ht * 6e4 + // 1000 * 60
  zt * 1e3 * 60 * 60, this._days = +Vt + Bt * 7, this._months = +Mt + $t * 3 + Pt * 12, this._data = {}, this._locale = getLocale(), this._bubble();
}
function isDuration(_t) {
  return _t instanceof Duration;
}
function absRound(_t) {
  return _t < 0 ? Math.round(-1 * _t) * -1 : Math.round(_t);
}
function compareArrays(_t, Et, Pt) {
  var $t = Math.min(_t.length, Et.length), Mt = Math.abs(_t.length - Et.length), Bt = 0, Vt;
  for (Vt = 0; Vt < $t; Vt++)
    toInt(_t[Vt]) !== toInt(Et[Vt]) && Bt++;
  return Bt + Mt;
}
function offset(_t, Et) {
  addFormatToken(_t, 0, 0, function() {
    var Pt = this.utcOffset(), $t = "+";
    return Pt < 0 && (Pt = -Pt, $t = "-"), $t + zeroFill(~~(Pt / 60), 2) + Et + zeroFill(~~Pt % 60, 2);
  });
}
offset("Z", ":");
offset("ZZ", "");
addRegexToken("Z", matchShortOffset);
addRegexToken("ZZ", matchShortOffset);
addParseToken(["Z", "ZZ"], function(_t, Et, Pt) {
  Pt._useUTC = !0, Pt._tzm = offsetFromString(matchShortOffset, _t);
});
var chunkOffset = /([\+\-]|\d\d)/gi;
function offsetFromString(_t, Et) {
  var Pt = (Et || "").match(_t), $t, Mt, Bt;
  return Pt === null ? null : ($t = Pt[Pt.length - 1] || [], Mt = ($t + "").match(chunkOffset) || ["-", 0, 0], Bt = +(Mt[1] * 60) + toInt(Mt[2]), Bt === 0 ? 0 : Mt[0] === "+" ? Bt : -Bt);
}
function cloneWithOffset(_t, Et) {
  var Pt, $t;
  return Et._isUTC ? (Pt = Et.clone(), $t = (isMoment(_t) || isDate(_t) ? _t.valueOf() : createLocal(_t).valueOf()) - Pt.valueOf(), Pt._d.setTime(Pt._d.valueOf() + $t), hooks.updateOffset(Pt, !1), Pt) : createLocal(_t).local();
}
function getDateOffset(_t) {
  return -Math.round(_t._d.getTimezoneOffset());
}
hooks.updateOffset = function() {
};
function getSetOffset(_t, Et, Pt) {
  var $t = this._offset || 0, Mt;
  if (!this.isValid())
    return _t != null ? this : NaN;
  if (_t != null) {
    if (typeof _t == "string") {
      if (_t = offsetFromString(matchShortOffset, _t), _t === null)
        return this;
    } else
      Math.abs(_t) < 16 && !Pt && (_t = _t * 60);
    return !this._isUTC && Et && (Mt = getDateOffset(this)), this._offset = _t, this._isUTC = !0, Mt != null && this.add(Mt, "m"), $t !== _t && (!Et || this._changeInProgress ? addSubtract(
      this,
      createDuration(_t - $t, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, hooks.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? $t : getDateOffset(this);
}
function getSetZone(_t, Et) {
  return _t != null ? (typeof _t != "string" && (_t = -_t), this.utcOffset(_t, Et), this) : -this.utcOffset();
}
function setOffsetToUTC(_t) {
  return this.utcOffset(0, _t);
}
function setOffsetToLocal(_t) {
  return this._isUTC && (this.utcOffset(0, _t), this._isUTC = !1, _t && this.subtract(getDateOffset(this), "m")), this;
}
function setOffsetToParsedOffset() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var _t = offsetFromString(matchOffset, this._i);
    _t != null ? this.utcOffset(_t) : this.utcOffset(0, !0);
  }
  return this;
}
function hasAlignedHourOffset(_t) {
  return this.isValid() ? (_t = _t ? createLocal(_t).utcOffset() : 0, (this.utcOffset() - _t) % 60 === 0) : !1;
}
function isDaylightSavingTime() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function isDaylightSavingTimeShifted() {
  if (!isUndefined(this._isDSTShifted))
    return this._isDSTShifted;
  var _t = {}, Et;
  return copyConfig(_t, this), _t = prepareConfig(_t), _t._a ? (Et = _t._isUTC ? createUTC(_t._a) : createLocal(_t._a), this._isDSTShifted = this.isValid() && compareArrays(_t._a, Et.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function isLocal() {
  return this.isValid() ? !this._isUTC : !1;
}
function isUtcOffset() {
  return this.isValid() ? this._isUTC : !1;
}
function isUtc() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function createDuration(_t, Et) {
  var Pt = _t, $t = null, Mt, Bt, Vt;
  return isDuration(_t) ? Pt = {
    ms: _t._milliseconds,
    d: _t._days,
    M: _t._months
  } : isNumber(_t) || !isNaN(+_t) ? (Pt = {}, Et ? Pt[Et] = +_t : Pt.milliseconds = +_t) : ($t = aspNetRegex.exec(_t)) ? (Mt = $t[1] === "-" ? -1 : 1, Pt = {
    y: 0,
    d: toInt($t[DATE]) * Mt,
    h: toInt($t[HOUR]) * Mt,
    m: toInt($t[MINUTE]) * Mt,
    s: toInt($t[SECOND]) * Mt,
    ms: toInt(absRound($t[MILLISECOND] * 1e3)) * Mt
    // the millisecond decimal point is included in the match
  }) : ($t = isoRegex.exec(_t)) ? (Mt = $t[1] === "-" ? -1 : 1, Pt = {
    y: parseIso($t[2], Mt),
    M: parseIso($t[3], Mt),
    w: parseIso($t[4], Mt),
    d: parseIso($t[5], Mt),
    h: parseIso($t[6], Mt),
    m: parseIso($t[7], Mt),
    s: parseIso($t[8], Mt)
  }) : Pt == null ? Pt = {} : typeof Pt == "object" && ("from" in Pt || "to" in Pt) && (Vt = momentsDifference(
    createLocal(Pt.from),
    createLocal(Pt.to)
  ), Pt = {}, Pt.ms = Vt.milliseconds, Pt.M = Vt.months), Bt = new Duration(Pt), isDuration(_t) && hasOwnProp(_t, "_locale") && (Bt._locale = _t._locale), isDuration(_t) && hasOwnProp(_t, "_isValid") && (Bt._isValid = _t._isValid), Bt;
}
createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;
function parseIso(_t, Et) {
  var Pt = _t && parseFloat(_t.replace(",", "."));
  return (isNaN(Pt) ? 0 : Pt) * Et;
}
function positiveMomentsDifference(_t, Et) {
  var Pt = {};
  return Pt.months = Et.month() - _t.month() + (Et.year() - _t.year()) * 12, _t.clone().add(Pt.months, "M").isAfter(Et) && --Pt.months, Pt.milliseconds = +Et - +_t.clone().add(Pt.months, "M"), Pt;
}
function momentsDifference(_t, Et) {
  var Pt;
  return _t.isValid() && Et.isValid() ? (Et = cloneWithOffset(Et, _t), _t.isBefore(Et) ? Pt = positiveMomentsDifference(_t, Et) : (Pt = positiveMomentsDifference(Et, _t), Pt.milliseconds = -Pt.milliseconds, Pt.months = -Pt.months), Pt) : { milliseconds: 0, months: 0 };
}
function createAdder(_t, Et) {
  return function(Pt, $t) {
    var Mt, Bt;
    return $t !== null && !isNaN(+$t) && (deprecateSimple(
      Et,
      "moment()." + Et + "(period, number) is deprecated. Please use moment()." + Et + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), Bt = Pt, Pt = $t, $t = Bt), Mt = createDuration(Pt, $t), addSubtract(this, Mt, _t), this;
  };
}
function addSubtract(_t, Et, Pt, $t) {
  var Mt = Et._milliseconds, Bt = absRound(Et._days), Vt = absRound(Et._months);
  _t.isValid() && ($t = $t ?? !0, Vt && setMonth(_t, get(_t, "Month") + Vt * Pt), Bt && set$1(_t, "Date", get(_t, "Date") + Bt * Pt), Mt && _t._d.setTime(_t._d.valueOf() + Mt * Pt), $t && hooks.updateOffset(_t, Bt || Vt));
}
var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
function isString(_t) {
  return typeof _t == "string" || _t instanceof String;
}
function isMomentInput(_t) {
  return isMoment(_t) || isDate(_t) || isString(_t) || isNumber(_t) || isNumberOrStringArray(_t) || isMomentInputObject(_t) || _t === null || _t === void 0;
}
function isMomentInputObject(_t) {
  var Et = isObject(_t) && !isObjectEmpty(_t), Pt = !1, $t = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], Mt, Bt, Vt = $t.length;
  for (Mt = 0; Mt < Vt; Mt += 1)
    Bt = $t[Mt], Pt = Pt || hasOwnProp(_t, Bt);
  return Et && Pt;
}
function isNumberOrStringArray(_t) {
  var Et = isArray(_t), Pt = !1;
  return Et && (Pt = _t.filter(function($t) {
    return !isNumber($t) && isString(_t);
  }).length === 0), Et && Pt;
}
function isCalendarSpec(_t) {
  var Et = isObject(_t) && !isObjectEmpty(_t), Pt = !1, $t = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], Mt, Bt;
  for (Mt = 0; Mt < $t.length; Mt += 1)
    Bt = $t[Mt], Pt = Pt || hasOwnProp(_t, Bt);
  return Et && Pt;
}
function getCalendarFormat(_t, Et) {
  var Pt = _t.diff(Et, "days", !0);
  return Pt < -6 ? "sameElse" : Pt < -1 ? "lastWeek" : Pt < 0 ? "lastDay" : Pt < 1 ? "sameDay" : Pt < 2 ? "nextDay" : Pt < 7 ? "nextWeek" : "sameElse";
}
function calendar$1(_t, Et) {
  arguments.length === 1 && (arguments[0] ? isMomentInput(arguments[0]) ? (_t = arguments[0], Et = void 0) : isCalendarSpec(arguments[0]) && (Et = arguments[0], _t = void 0) : (_t = void 0, Et = void 0));
  var Pt = _t || createLocal(), $t = cloneWithOffset(Pt, this).startOf("day"), Mt = hooks.calendarFormat(this, $t) || "sameElse", Bt = Et && (isFunction(Et[Mt]) ? Et[Mt].call(this, Pt) : Et[Mt]);
  return this.format(
    Bt || this.localeData().calendar(Mt, this, createLocal(Pt))
  );
}
function clone() {
  return new Moment(this);
}
function isAfter(_t, Et) {
  var Pt = isMoment(_t) ? _t : createLocal(_t);
  return this.isValid() && Pt.isValid() ? (Et = normalizeUnits(Et) || "millisecond", Et === "millisecond" ? this.valueOf() > Pt.valueOf() : Pt.valueOf() < this.clone().startOf(Et).valueOf()) : !1;
}
function isBefore(_t, Et) {
  var Pt = isMoment(_t) ? _t : createLocal(_t);
  return this.isValid() && Pt.isValid() ? (Et = normalizeUnits(Et) || "millisecond", Et === "millisecond" ? this.valueOf() < Pt.valueOf() : this.clone().endOf(Et).valueOf() < Pt.valueOf()) : !1;
}
function isBetween(_t, Et, Pt, $t) {
  var Mt = isMoment(_t) ? _t : createLocal(_t), Bt = isMoment(Et) ? Et : createLocal(Et);
  return this.isValid() && Mt.isValid() && Bt.isValid() ? ($t = $t || "()", ($t[0] === "(" ? this.isAfter(Mt, Pt) : !this.isBefore(Mt, Pt)) && ($t[1] === ")" ? this.isBefore(Bt, Pt) : !this.isAfter(Bt, Pt))) : !1;
}
function isSame(_t, Et) {
  var Pt = isMoment(_t) ? _t : createLocal(_t), $t;
  return this.isValid() && Pt.isValid() ? (Et = normalizeUnits(Et) || "millisecond", Et === "millisecond" ? this.valueOf() === Pt.valueOf() : ($t = Pt.valueOf(), this.clone().startOf(Et).valueOf() <= $t && $t <= this.clone().endOf(Et).valueOf())) : !1;
}
function isSameOrAfter(_t, Et) {
  return this.isSame(_t, Et) || this.isAfter(_t, Et);
}
function isSameOrBefore(_t, Et) {
  return this.isSame(_t, Et) || this.isBefore(_t, Et);
}
function diff(_t, Et, Pt) {
  var $t, Mt, Bt;
  if (!this.isValid())
    return NaN;
  if ($t = cloneWithOffset(_t, this), !$t.isValid())
    return NaN;
  switch (Mt = ($t.utcOffset() - this.utcOffset()) * 6e4, Et = normalizeUnits(Et), Et) {
    case "year":
      Bt = monthDiff(this, $t) / 12;
      break;
    case "month":
      Bt = monthDiff(this, $t);
      break;
    case "quarter":
      Bt = monthDiff(this, $t) / 3;
      break;
    case "second":
      Bt = (this - $t) / 1e3;
      break;
    case "minute":
      Bt = (this - $t) / 6e4;
      break;
    case "hour":
      Bt = (this - $t) / 36e5;
      break;
    case "day":
      Bt = (this - $t - Mt) / 864e5;
      break;
    case "week":
      Bt = (this - $t - Mt) / 6048e5;
      break;
    default:
      Bt = this - $t;
  }
  return Pt ? Bt : absFloor(Bt);
}
function monthDiff(_t, Et) {
  if (_t.date() < Et.date())
    return -monthDiff(Et, _t);
  var Pt = (Et.year() - _t.year()) * 12 + (Et.month() - _t.month()), $t = _t.clone().add(Pt, "months"), Mt, Bt;
  return Et - $t < 0 ? (Mt = _t.clone().add(Pt - 1, "months"), Bt = (Et - $t) / ($t - Mt)) : (Mt = _t.clone().add(Pt + 1, "months"), Bt = (Et - $t) / (Mt - $t)), -(Pt + Bt) || 0;
}
hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function toString() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function toISOString(_t) {
  if (!this.isValid())
    return null;
  var Et = _t !== !0, Pt = Et ? this.clone().utc() : this;
  return Pt.year() < 0 || Pt.year() > 9999 ? formatMoment(
    Pt,
    Et ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : isFunction(Date.prototype.toISOString) ? Et ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", formatMoment(Pt, "Z")) : formatMoment(
    Pt,
    Et ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function inspect() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var _t = "moment", Et = "", Pt, $t, Mt, Bt;
  return this.isLocal() || (_t = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", Et = "Z"), Pt = "[" + _t + '("]', $t = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", Mt = "-MM-DD[T]HH:mm:ss.SSS", Bt = Et + '[")]', this.format(Pt + $t + Mt + Bt);
}
function format(_t) {
  _t || (_t = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat);
  var Et = formatMoment(this, _t);
  return this.localeData().postformat(Et);
}
function from(_t, Et) {
  return this.isValid() && (isMoment(_t) && _t.isValid() || createLocal(_t).isValid()) ? createDuration({ to: this, from: _t }).locale(this.locale()).humanize(!Et) : this.localeData().invalidDate();
}
function fromNow(_t) {
  return this.from(createLocal(), _t);
}
function to(_t, Et) {
  return this.isValid() && (isMoment(_t) && _t.isValid() || createLocal(_t).isValid()) ? createDuration({ from: this, to: _t }).locale(this.locale()).humanize(!Et) : this.localeData().invalidDate();
}
function toNow(_t) {
  return this.to(createLocal(), _t);
}
function locale(_t) {
  var Et;
  return _t === void 0 ? this._locale._abbr : (Et = getLocale(_t), Et != null && (this._locale = Et), this);
}
var lang = deprecate(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(_t) {
    return _t === void 0 ? this.localeData() : this.locale(_t);
  }
);
function localeData() {
  return this._locale;
}
var MS_PER_SECOND = 1e3, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
function mod$1(_t, Et) {
  return (_t % Et + Et) % Et;
}
function localStartOfDate(_t, Et, Pt) {
  return _t < 100 && _t >= 0 ? new Date(_t + 400, Et, Pt) - MS_PER_400_YEARS : new Date(_t, Et, Pt).valueOf();
}
function utcStartOfDate(_t, Et, Pt) {
  return _t < 100 && _t >= 0 ? Date.UTC(_t + 400, Et, Pt) - MS_PER_400_YEARS : Date.UTC(_t, Et, Pt);
}
function startOf(_t) {
  var Et, Pt;
  if (_t = normalizeUnits(_t), _t === void 0 || _t === "millisecond" || !this.isValid())
    return this;
  switch (Pt = this._isUTC ? utcStartOfDate : localStartOfDate, _t) {
    case "year":
      Et = Pt(this.year(), 0, 1);
      break;
    case "quarter":
      Et = Pt(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      Et = Pt(this.year(), this.month(), 1);
      break;
    case "week":
      Et = Pt(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      Et = Pt(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      Et = Pt(this.year(), this.month(), this.date());
      break;
    case "hour":
      Et = this._d.valueOf(), Et -= mod$1(
        Et + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
        MS_PER_HOUR
      );
      break;
    case "minute":
      Et = this._d.valueOf(), Et -= mod$1(Et, MS_PER_MINUTE);
      break;
    case "second":
      Et = this._d.valueOf(), Et -= mod$1(Et, MS_PER_SECOND);
      break;
  }
  return this._d.setTime(Et), hooks.updateOffset(this, !0), this;
}
function endOf(_t) {
  var Et, Pt;
  if (_t = normalizeUnits(_t), _t === void 0 || _t === "millisecond" || !this.isValid())
    return this;
  switch (Pt = this._isUTC ? utcStartOfDate : localStartOfDate, _t) {
    case "year":
      Et = Pt(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      Et = Pt(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      Et = Pt(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      Et = Pt(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      Et = Pt(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      Et = Pt(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      Et = this._d.valueOf(), Et += MS_PER_HOUR - mod$1(
        Et + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
        MS_PER_HOUR
      ) - 1;
      break;
    case "minute":
      Et = this._d.valueOf(), Et += MS_PER_MINUTE - mod$1(Et, MS_PER_MINUTE) - 1;
      break;
    case "second":
      Et = this._d.valueOf(), Et += MS_PER_SECOND - mod$1(Et, MS_PER_SECOND) - 1;
      break;
  }
  return this._d.setTime(Et), hooks.updateOffset(this, !0), this;
}
function valueOf() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function unix() {
  return Math.floor(this.valueOf() / 1e3);
}
function toDate() {
  return new Date(this.valueOf());
}
function toArray() {
  var _t = this;
  return [
    _t.year(),
    _t.month(),
    _t.date(),
    _t.hour(),
    _t.minute(),
    _t.second(),
    _t.millisecond()
  ];
}
function toObject() {
  var _t = this;
  return {
    years: _t.year(),
    months: _t.month(),
    date: _t.date(),
    hours: _t.hours(),
    minutes: _t.minutes(),
    seconds: _t.seconds(),
    milliseconds: _t.milliseconds()
  };
}
function toJSON() {
  return this.isValid() ? this.toISOString() : null;
}
function isValid$2() {
  return isValid(this);
}
function parsingFlags() {
  return extend({}, getParsingFlags(this));
}
function invalidAt() {
  return getParsingFlags(this).overflow;
}
function creationData() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
addFormatToken("N", 0, 0, "eraAbbr");
addFormatToken("NN", 0, 0, "eraAbbr");
addFormatToken("NNN", 0, 0, "eraAbbr");
addFormatToken("NNNN", 0, 0, "eraName");
addFormatToken("NNNNN", 0, 0, "eraNarrow");
addFormatToken("y", ["y", 1], "yo", "eraYear");
addFormatToken("y", ["yy", 2], 0, "eraYear");
addFormatToken("y", ["yyy", 3], 0, "eraYear");
addFormatToken("y", ["yyyy", 4], 0, "eraYear");
addRegexToken("N", matchEraAbbr);
addRegexToken("NN", matchEraAbbr);
addRegexToken("NNN", matchEraAbbr);
addRegexToken("NNNN", matchEraName);
addRegexToken("NNNNN", matchEraNarrow);
addParseToken(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(_t, Et, Pt, $t) {
    var Mt = Pt._locale.erasParse(_t, $t, Pt._strict);
    Mt ? getParsingFlags(Pt).era = Mt : getParsingFlags(Pt).invalidEra = _t;
  }
);
addRegexToken("y", matchUnsigned);
addRegexToken("yy", matchUnsigned);
addRegexToken("yyy", matchUnsigned);
addRegexToken("yyyy", matchUnsigned);
addRegexToken("yo", matchEraYearOrdinal);
addParseToken(["y", "yy", "yyy", "yyyy"], YEAR);
addParseToken(["yo"], function(_t, Et, Pt, $t) {
  var Mt;
  Pt._locale._eraYearOrdinalRegex && (Mt = _t.match(Pt._locale._eraYearOrdinalRegex)), Pt._locale.eraYearOrdinalParse ? Et[YEAR] = Pt._locale.eraYearOrdinalParse(_t, Mt) : Et[YEAR] = parseInt(_t, 10);
});
function localeEras(_t, Et) {
  var Pt, $t, Mt, Bt = this._eras || getLocale("en")._eras;
  for (Pt = 0, $t = Bt.length; Pt < $t; ++Pt) {
    switch (typeof Bt[Pt].since) {
      case "string":
        Mt = hooks(Bt[Pt].since).startOf("day"), Bt[Pt].since = Mt.valueOf();
        break;
    }
    switch (typeof Bt[Pt].until) {
      case "undefined":
        Bt[Pt].until = 1 / 0;
        break;
      case "string":
        Mt = hooks(Bt[Pt].until).startOf("day").valueOf(), Bt[Pt].until = Mt.valueOf();
        break;
    }
  }
  return Bt;
}
function localeErasParse(_t, Et, Pt) {
  var $t, Mt, Bt = this.eras(), Vt, zt, Ht;
  for (_t = _t.toUpperCase(), $t = 0, Mt = Bt.length; $t < Mt; ++$t)
    if (Vt = Bt[$t].name.toUpperCase(), zt = Bt[$t].abbr.toUpperCase(), Ht = Bt[$t].narrow.toUpperCase(), Pt)
      switch (Et) {
        case "N":
        case "NN":
        case "NNN":
          if (zt === _t)
            return Bt[$t];
          break;
        case "NNNN":
          if (Vt === _t)
            return Bt[$t];
          break;
        case "NNNNN":
          if (Ht === _t)
            return Bt[$t];
          break;
      }
    else if ([Vt, zt, Ht].indexOf(_t) >= 0)
      return Bt[$t];
}
function localeErasConvertYear(_t, Et) {
  var Pt = _t.since <= _t.until ? 1 : -1;
  return Et === void 0 ? hooks(_t.since).year() : hooks(_t.since).year() + (Et - _t.offset) * Pt;
}
function getEraName() {
  var _t, Et, Pt, $t = this.localeData().eras();
  for (_t = 0, Et = $t.length; _t < Et; ++_t)
    if (Pt = this.clone().startOf("day").valueOf(), $t[_t].since <= Pt && Pt <= $t[_t].until || $t[_t].until <= Pt && Pt <= $t[_t].since)
      return $t[_t].name;
  return "";
}
function getEraNarrow() {
  var _t, Et, Pt, $t = this.localeData().eras();
  for (_t = 0, Et = $t.length; _t < Et; ++_t)
    if (Pt = this.clone().startOf("day").valueOf(), $t[_t].since <= Pt && Pt <= $t[_t].until || $t[_t].until <= Pt && Pt <= $t[_t].since)
      return $t[_t].narrow;
  return "";
}
function getEraAbbr() {
  var _t, Et, Pt, $t = this.localeData().eras();
  for (_t = 0, Et = $t.length; _t < Et; ++_t)
    if (Pt = this.clone().startOf("day").valueOf(), $t[_t].since <= Pt && Pt <= $t[_t].until || $t[_t].until <= Pt && Pt <= $t[_t].since)
      return $t[_t].abbr;
  return "";
}
function getEraYear() {
  var _t, Et, Pt, $t, Mt = this.localeData().eras();
  for (_t = 0, Et = Mt.length; _t < Et; ++_t)
    if (Pt = Mt[_t].since <= Mt[_t].until ? 1 : -1, $t = this.clone().startOf("day").valueOf(), Mt[_t].since <= $t && $t <= Mt[_t].until || Mt[_t].until <= $t && $t <= Mt[_t].since)
      return (this.year() - hooks(Mt[_t].since).year()) * Pt + Mt[_t].offset;
  return this.year();
}
function erasNameRegex(_t) {
  return hasOwnProp(this, "_erasNameRegex") || computeErasParse.call(this), _t ? this._erasNameRegex : this._erasRegex;
}
function erasAbbrRegex(_t) {
  return hasOwnProp(this, "_erasAbbrRegex") || computeErasParse.call(this), _t ? this._erasAbbrRegex : this._erasRegex;
}
function erasNarrowRegex(_t) {
  return hasOwnProp(this, "_erasNarrowRegex") || computeErasParse.call(this), _t ? this._erasNarrowRegex : this._erasRegex;
}
function matchEraAbbr(_t, Et) {
  return Et.erasAbbrRegex(_t);
}
function matchEraName(_t, Et) {
  return Et.erasNameRegex(_t);
}
function matchEraNarrow(_t, Et) {
  return Et.erasNarrowRegex(_t);
}
function matchEraYearOrdinal(_t, Et) {
  return Et._eraYearOrdinalRegex || matchUnsigned;
}
function computeErasParse() {
  var _t = [], Et = [], Pt = [], $t = [], Mt, Bt, Vt, zt, Ht, Wt = this.eras();
  for (Mt = 0, Bt = Wt.length; Mt < Bt; ++Mt)
    Vt = regexEscape(Wt[Mt].name), zt = regexEscape(Wt[Mt].abbr), Ht = regexEscape(Wt[Mt].narrow), Et.push(Vt), _t.push(zt), Pt.push(Ht), $t.push(Vt), $t.push(zt), $t.push(Ht);
  this._erasRegex = new RegExp("^(" + $t.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + Et.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + _t.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + Pt.join("|") + ")",
    "i"
  );
}
addFormatToken(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
addFormatToken(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function addWeekYearFormatToken(_t, Et) {
  addFormatToken(0, [_t, _t.length], 0, Et);
}
addWeekYearFormatToken("gggg", "weekYear");
addWeekYearFormatToken("ggggg", "weekYear");
addWeekYearFormatToken("GGGG", "isoWeekYear");
addWeekYearFormatToken("GGGGG", "isoWeekYear");
addRegexToken("G", matchSigned);
addRegexToken("g", matchSigned);
addRegexToken("GG", match1to2, match2);
addRegexToken("gg", match1to2, match2);
addRegexToken("GGGG", match1to4, match4);
addRegexToken("gggg", match1to4, match4);
addRegexToken("GGGGG", match1to6, match6);
addRegexToken("ggggg", match1to6, match6);
addWeekParseToken(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(_t, Et, Pt, $t) {
    Et[$t.substr(0, 2)] = toInt(_t);
  }
);
addWeekParseToken(["gg", "GG"], function(_t, Et, Pt, $t) {
  Et[$t] = hooks.parseTwoDigitYear(_t);
});
function getSetWeekYear(_t) {
  return getSetWeekYearHelper.call(
    this,
    _t,
    this.week(),
    this.weekday() + this.localeData()._week.dow,
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function getSetISOWeekYear(_t) {
  return getSetWeekYearHelper.call(
    this,
    _t,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function getISOWeeksInYear() {
  return weeksInYear(this.year(), 1, 4);
}
function getISOWeeksInISOWeekYear() {
  return weeksInYear(this.isoWeekYear(), 1, 4);
}
function getWeeksInYear() {
  var _t = this.localeData()._week;
  return weeksInYear(this.year(), _t.dow, _t.doy);
}
function getWeeksInWeekYear() {
  var _t = this.localeData()._week;
  return weeksInYear(this.weekYear(), _t.dow, _t.doy);
}
function getSetWeekYearHelper(_t, Et, Pt, $t, Mt) {
  var Bt;
  return _t == null ? weekOfYear(this, $t, Mt).year : (Bt = weeksInYear(_t, $t, Mt), Et > Bt && (Et = Bt), setWeekAll.call(this, _t, Et, Pt, $t, Mt));
}
function setWeekAll(_t, Et, Pt, $t, Mt) {
  var Bt = dayOfYearFromWeeks(_t, Et, Pt, $t, Mt), Vt = createUTCDate(Bt.year, 0, Bt.dayOfYear);
  return this.year(Vt.getUTCFullYear()), this.month(Vt.getUTCMonth()), this.date(Vt.getUTCDate()), this;
}
addFormatToken("Q", 0, "Qo", "quarter");
addRegexToken("Q", match1);
addParseToken("Q", function(_t, Et) {
  Et[MONTH] = (toInt(_t) - 1) * 3;
});
function getSetQuarter(_t) {
  return _t == null ? Math.ceil((this.month() + 1) / 3) : this.month((_t - 1) * 3 + this.month() % 3);
}
addFormatToken("D", ["DD", 2], "Do", "date");
addRegexToken("D", match1to2, match1to2NoLeadingZero);
addRegexToken("DD", match1to2, match2);
addRegexToken("Do", function(_t, Et) {
  return _t ? Et._dayOfMonthOrdinalParse || Et._ordinalParse : Et._dayOfMonthOrdinalParseLenient;
});
addParseToken(["D", "DD"], DATE);
addParseToken("Do", function(_t, Et) {
  Et[DATE] = toInt(_t.match(match1to2)[0]);
});
var getSetDayOfMonth = makeGetSet("Date", !0);
addFormatToken("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
addRegexToken("DDD", match1to3);
addRegexToken("DDDD", match3);
addParseToken(["DDD", "DDDD"], function(_t, Et, Pt) {
  Pt._dayOfYear = toInt(_t);
});
function getSetDayOfYear(_t) {
  var Et = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return _t == null ? Et : this.add(_t - Et, "d");
}
addFormatToken("m", ["mm", 2], 0, "minute");
addRegexToken("m", match1to2, match1to2HasZero);
addRegexToken("mm", match1to2, match2);
addParseToken(["m", "mm"], MINUTE);
var getSetMinute = makeGetSet("Minutes", !1);
addFormatToken("s", ["ss", 2], 0, "second");
addRegexToken("s", match1to2, match1to2HasZero);
addRegexToken("ss", match1to2, match2);
addParseToken(["s", "ss"], SECOND);
var getSetSecond = makeGetSet("Seconds", !1);
addFormatToken("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
addFormatToken(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
addFormatToken(0, ["SSS", 3], 0, "millisecond");
addFormatToken(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
addFormatToken(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
addFormatToken(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
addFormatToken(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
addFormatToken(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
addFormatToken(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
addRegexToken("S", match1to3, match1);
addRegexToken("SS", match1to3, match2);
addRegexToken("SSS", match1to3, match3);
var token, getSetMillisecond;
for (token = "SSSS"; token.length <= 9; token += "S")
  addRegexToken(token, matchUnsigned);
function parseMs(_t, Et) {
  Et[MILLISECOND] = toInt(("0." + _t) * 1e3);
}
for (token = "S"; token.length <= 9; token += "S")
  addParseToken(token, parseMs);
getSetMillisecond = makeGetSet("Milliseconds", !1);
addFormatToken("z", 0, 0, "zoneAbbr");
addFormatToken("zz", 0, 0, "zoneName");
function getZoneAbbr() {
  return this._isUTC ? "UTC" : "";
}
function getZoneName() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var proto = Moment.prototype;
proto.add = add;
proto.calendar = calendar$1;
proto.clone = clone;
proto.diff = diff;
proto.endOf = endOf;
proto.format = format;
proto.from = from;
proto.fromNow = fromNow;
proto.to = to;
proto.toNow = toNow;
proto.get = stringGet;
proto.invalidAt = invalidAt;
proto.isAfter = isAfter;
proto.isBefore = isBefore;
proto.isBetween = isBetween;
proto.isSame = isSame;
proto.isSameOrAfter = isSameOrAfter;
proto.isSameOrBefore = isSameOrBefore;
proto.isValid = isValid$2;
proto.lang = lang;
proto.locale = locale;
proto.localeData = localeData;
proto.max = prototypeMax;
proto.min = prototypeMin;
proto.parsingFlags = parsingFlags;
proto.set = stringSet;
proto.startOf = startOf;
proto.subtract = subtract;
proto.toArray = toArray;
proto.toObject = toObject;
proto.toDate = toDate;
proto.toISOString = toISOString;
proto.inspect = inspect;
typeof Symbol < "u" && Symbol.for != null && (proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
proto.toJSON = toJSON;
proto.toString = toString;
proto.unix = unix;
proto.valueOf = valueOf;
proto.creationData = creationData;
proto.eraName = getEraName;
proto.eraNarrow = getEraNarrow;
proto.eraAbbr = getEraAbbr;
proto.eraYear = getEraYear;
proto.year = getSetYear;
proto.isLeapYear = getIsLeapYear;
proto.weekYear = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;
proto.quarter = proto.quarters = getSetQuarter;
proto.month = getSetMonth;
proto.daysInMonth = getDaysInMonth;
proto.week = proto.weeks = getSetWeek;
proto.isoWeek = proto.isoWeeks = getSetISOWeek;
proto.weeksInYear = getWeeksInYear;
proto.weeksInWeekYear = getWeeksInWeekYear;
proto.isoWeeksInYear = getISOWeeksInYear;
proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
proto.date = getSetDayOfMonth;
proto.day = proto.days = getSetDayOfWeek;
proto.weekday = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear = getSetDayOfYear;
proto.hour = proto.hours = getSetHour;
proto.minute = proto.minutes = getSetMinute;
proto.second = proto.seconds = getSetSecond;
proto.millisecond = proto.milliseconds = getSetMillisecond;
proto.utcOffset = getSetOffset;
proto.utc = setOffsetToUTC;
proto.local = setOffsetToLocal;
proto.parseZone = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST = isDaylightSavingTime;
proto.isLocal = isLocal;
proto.isUtcOffset = isUtcOffset;
proto.isUtc = isUtc;
proto.isUTC = isUtc;
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;
proto.dates = deprecate(
  "dates accessor is deprecated. Use date instead.",
  getSetDayOfMonth
);
proto.months = deprecate(
  "months accessor is deprecated. Use month instead",
  getSetMonth
);
proto.years = deprecate(
  "years accessor is deprecated. Use year instead",
  getSetYear
);
proto.zone = deprecate(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  getSetZone
);
proto.isDSTShifted = deprecate(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  isDaylightSavingTimeShifted
);
function createUnix(_t) {
  return createLocal(_t * 1e3);
}
function createInZone() {
  return createLocal.apply(null, arguments).parseZone();
}
function preParsePostFormat(_t) {
  return _t;
}
var proto$1 = Locale.prototype;
proto$1.calendar = calendar;
proto$1.longDateFormat = longDateFormat;
proto$1.invalidDate = invalidDate;
proto$1.ordinal = ordinal;
proto$1.preparse = preParsePostFormat;
proto$1.postformat = preParsePostFormat;
proto$1.relativeTime = relativeTime;
proto$1.pastFuture = pastFuture;
proto$1.set = set;
proto$1.eras = localeEras;
proto$1.erasParse = localeErasParse;
proto$1.erasConvertYear = localeErasConvertYear;
proto$1.erasAbbrRegex = erasAbbrRegex;
proto$1.erasNameRegex = erasNameRegex;
proto$1.erasNarrowRegex = erasNarrowRegex;
proto$1.months = localeMonths;
proto$1.monthsShort = localeMonthsShort;
proto$1.monthsParse = localeMonthsParse;
proto$1.monthsRegex = monthsRegex;
proto$1.monthsShortRegex = monthsShortRegex;
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;
proto$1.weekdays = localeWeekdays;
proto$1.weekdaysMin = localeWeekdaysMin;
proto$1.weekdaysShort = localeWeekdaysShort;
proto$1.weekdaysParse = localeWeekdaysParse;
proto$1.weekdaysRegex = weekdaysRegex;
proto$1.weekdaysShortRegex = weekdaysShortRegex;
proto$1.weekdaysMinRegex = weekdaysMinRegex;
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;
function get$1(_t, Et, Pt, $t) {
  var Mt = getLocale(), Bt = createUTC().set($t, Et);
  return Mt[Pt](Bt, _t);
}
function listMonthsImpl(_t, Et, Pt) {
  if (isNumber(_t) && (Et = _t, _t = void 0), _t = _t || "", Et != null)
    return get$1(_t, Et, Pt, "month");
  var $t, Mt = [];
  for ($t = 0; $t < 12; $t++)
    Mt[$t] = get$1(_t, $t, Pt, "month");
  return Mt;
}
function listWeekdaysImpl(_t, Et, Pt, $t) {
  typeof _t == "boolean" ? (isNumber(Et) && (Pt = Et, Et = void 0), Et = Et || "") : (Et = _t, Pt = Et, _t = !1, isNumber(Et) && (Pt = Et, Et = void 0), Et = Et || "");
  var Mt = getLocale(), Bt = _t ? Mt._week.dow : 0, Vt, zt = [];
  if (Pt != null)
    return get$1(Et, (Pt + Bt) % 7, $t, "day");
  for (Vt = 0; Vt < 7; Vt++)
    zt[Vt] = get$1(Et, (Vt + Bt) % 7, $t, "day");
  return zt;
}
function listMonths(_t, Et) {
  return listMonthsImpl(_t, Et, "months");
}
function listMonthsShort(_t, Et) {
  return listMonthsImpl(_t, Et, "monthsShort");
}
function listWeekdays(_t, Et, Pt) {
  return listWeekdaysImpl(_t, Et, Pt, "weekdays");
}
function listWeekdaysShort(_t, Et, Pt) {
  return listWeekdaysImpl(_t, Et, Pt, "weekdaysShort");
}
function listWeekdaysMin(_t, Et, Pt) {
  return listWeekdaysImpl(_t, Et, Pt, "weekdaysMin");
}
getSetGlobalLocale("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(_t) {
    var Et = _t % 10, Pt = toInt(_t % 100 / 10) === 1 ? "th" : Et === 1 ? "st" : Et === 2 ? "nd" : Et === 3 ? "rd" : "th";
    return _t + Pt;
  }
});
hooks.lang = deprecate(
  "moment.lang is deprecated. Use moment.locale instead.",
  getSetGlobalLocale
);
hooks.langData = deprecate(
  "moment.langData is deprecated. Use moment.localeData instead.",
  getLocale
);
var mathAbs = Math.abs;
function abs() {
  var _t = this._data;
  return this._milliseconds = mathAbs(this._milliseconds), this._days = mathAbs(this._days), this._months = mathAbs(this._months), _t.milliseconds = mathAbs(_t.milliseconds), _t.seconds = mathAbs(_t.seconds), _t.minutes = mathAbs(_t.minutes), _t.hours = mathAbs(_t.hours), _t.months = mathAbs(_t.months), _t.years = mathAbs(_t.years), this;
}
function addSubtract$1(_t, Et, Pt, $t) {
  var Mt = createDuration(Et, Pt);
  return _t._milliseconds += $t * Mt._milliseconds, _t._days += $t * Mt._days, _t._months += $t * Mt._months, _t._bubble();
}
function add$1(_t, Et) {
  return addSubtract$1(this, _t, Et, 1);
}
function subtract$1(_t, Et) {
  return addSubtract$1(this, _t, Et, -1);
}
function absCeil(_t) {
  return _t < 0 ? Math.floor(_t) : Math.ceil(_t);
}
function bubble() {
  var _t = this._milliseconds, Et = this._days, Pt = this._months, $t = this._data, Mt, Bt, Vt, zt, Ht;
  return _t >= 0 && Et >= 0 && Pt >= 0 || _t <= 0 && Et <= 0 && Pt <= 0 || (_t += absCeil(monthsToDays(Pt) + Et) * 864e5, Et = 0, Pt = 0), $t.milliseconds = _t % 1e3, Mt = absFloor(_t / 1e3), $t.seconds = Mt % 60, Bt = absFloor(Mt / 60), $t.minutes = Bt % 60, Vt = absFloor(Bt / 60), $t.hours = Vt % 24, Et += absFloor(Vt / 24), Ht = absFloor(daysToMonths(Et)), Pt += Ht, Et -= absCeil(monthsToDays(Ht)), zt = absFloor(Pt / 12), Pt %= 12, $t.days = Et, $t.months = Pt, $t.years = zt, this;
}
function daysToMonths(_t) {
  return _t * 4800 / 146097;
}
function monthsToDays(_t) {
  return _t * 146097 / 4800;
}
function as(_t) {
  if (!this.isValid())
    return NaN;
  var Et, Pt, $t = this._milliseconds;
  if (_t = normalizeUnits(_t), _t === "month" || _t === "quarter" || _t === "year")
    switch (Et = this._days + $t / 864e5, Pt = this._months + daysToMonths(Et), _t) {
      case "month":
        return Pt;
      case "quarter":
        return Pt / 3;
      case "year":
        return Pt / 12;
    }
  else
    switch (Et = this._days + Math.round(monthsToDays(this._months)), _t) {
      case "week":
        return Et / 7 + $t / 6048e5;
      case "day":
        return Et + $t / 864e5;
      case "hour":
        return Et * 24 + $t / 36e5;
      case "minute":
        return Et * 1440 + $t / 6e4;
      case "second":
        return Et * 86400 + $t / 1e3;
      case "millisecond":
        return Math.floor(Et * 864e5) + $t;
      default:
        throw new Error("Unknown unit " + _t);
    }
}
function makeAs(_t) {
  return function() {
    return this.as(_t);
  };
}
var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y"), valueOf$1 = asMilliseconds;
function clone$1() {
  return createDuration(this);
}
function get$2(_t) {
  return _t = normalizeUnits(_t), this.isValid() ? this[_t + "s"]() : NaN;
}
function makeGetter(_t) {
  return function() {
    return this.isValid() ? this._data[_t] : NaN;
  };
}
var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
function weeks() {
  return absFloor(this.days() / 7);
}
var round = Math.round, thresholds = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function substituteTimeAgo(_t, Et, Pt, $t, Mt) {
  return Mt.relativeTime(Et || 1, !!Pt, _t, $t);
}
function relativeTime$1(_t, Et, Pt, $t) {
  var Mt = createDuration(_t).abs(), Bt = round(Mt.as("s")), Vt = round(Mt.as("m")), zt = round(Mt.as("h")), Ht = round(Mt.as("d")), Wt = round(Mt.as("M")), Gt = round(Mt.as("w")), qt = round(Mt.as("y")), Kt = Bt <= Pt.ss && ["s", Bt] || Bt < Pt.s && ["ss", Bt] || Vt <= 1 && ["m"] || Vt < Pt.m && ["mm", Vt] || zt <= 1 && ["h"] || zt < Pt.h && ["hh", zt] || Ht <= 1 && ["d"] || Ht < Pt.d && ["dd", Ht];
  return Pt.w != null && (Kt = Kt || Gt <= 1 && ["w"] || Gt < Pt.w && ["ww", Gt]), Kt = Kt || Wt <= 1 && ["M"] || Wt < Pt.M && ["MM", Wt] || qt <= 1 && ["y"] || ["yy", qt], Kt[2] = Et, Kt[3] = +_t > 0, Kt[4] = $t, substituteTimeAgo.apply(null, Kt);
}
function getSetRelativeTimeRounding(_t) {
  return _t === void 0 ? round : typeof _t == "function" ? (round = _t, !0) : !1;
}
function getSetRelativeTimeThreshold(_t, Et) {
  return thresholds[_t] === void 0 ? !1 : Et === void 0 ? thresholds[_t] : (thresholds[_t] = Et, _t === "s" && (thresholds.ss = Et - 1), !0);
}
function humanize(_t, Et) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var Pt = !1, $t = thresholds, Mt, Bt;
  return typeof _t == "object" && (Et = _t, _t = !1), typeof _t == "boolean" && (Pt = _t), typeof Et == "object" && ($t = Object.assign({}, thresholds, Et), Et.s != null && Et.ss == null && ($t.ss = Et.s - 1)), Mt = this.localeData(), Bt = relativeTime$1(this, !Pt, $t, Mt), Pt && (Bt = Mt.pastFuture(+this, Bt)), Mt.postformat(Bt);
}
var abs$1 = Math.abs;
function sign(_t) {
  return (_t > 0) - (_t < 0) || +_t;
}
function toISOString$1() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var _t = abs$1(this._milliseconds) / 1e3, Et = abs$1(this._days), Pt = abs$1(this._months), $t, Mt, Bt, Vt, zt = this.asSeconds(), Ht, Wt, Gt, qt;
  return zt ? ($t = absFloor(_t / 60), Mt = absFloor($t / 60), _t %= 60, $t %= 60, Bt = absFloor(Pt / 12), Pt %= 12, Vt = _t ? _t.toFixed(3).replace(/\.?0+$/, "") : "", Ht = zt < 0 ? "-" : "", Wt = sign(this._months) !== sign(zt) ? "-" : "", Gt = sign(this._days) !== sign(zt) ? "-" : "", qt = sign(this._milliseconds) !== sign(zt) ? "-" : "", Ht + "P" + (Bt ? Wt + Bt + "Y" : "") + (Pt ? Wt + Pt + "M" : "") + (Et ? Gt + Et + "D" : "") + (Mt || $t || _t ? "T" : "") + (Mt ? qt + Mt + "H" : "") + ($t ? qt + $t + "M" : "") + (_t ? qt + Vt + "S" : "")) : "P0D";
}
var proto$2 = Duration.prototype;
proto$2.isValid = isValid$1;
proto$2.abs = abs;
proto$2.add = add$1;
proto$2.subtract = subtract$1;
proto$2.as = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds = asSeconds;
proto$2.asMinutes = asMinutes;
proto$2.asHours = asHours;
proto$2.asDays = asDays;
proto$2.asWeeks = asWeeks;
proto$2.asMonths = asMonths;
proto$2.asQuarters = asQuarters;
proto$2.asYears = asYears;
proto$2.valueOf = valueOf$1;
proto$2._bubble = bubble;
proto$2.clone = clone$1;
proto$2.get = get$2;
proto$2.milliseconds = milliseconds;
proto$2.seconds = seconds;
proto$2.minutes = minutes;
proto$2.hours = hours;
proto$2.days = days;
proto$2.weeks = weeks;
proto$2.months = months;
proto$2.years = years;
proto$2.humanize = humanize;
proto$2.toISOString = toISOString$1;
proto$2.toString = toISOString$1;
proto$2.toJSON = toISOString$1;
proto$2.locale = locale;
proto$2.localeData = localeData;
proto$2.toIsoString = deprecate(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  toISOString$1
);
proto$2.lang = lang;
addFormatToken("X", 0, 0, "unix");
addFormatToken("x", 0, 0, "valueOf");
addRegexToken("x", matchSigned);
addRegexToken("X", matchTimestamp);
addParseToken("X", function(_t, Et, Pt) {
  Pt._d = new Date(parseFloat(_t) * 1e3);
});
addParseToken("x", function(_t, Et, Pt) {
  Pt._d = new Date(toInt(_t));
});
//! moment.js
hooks.version = "2.30.1";
setHookCallback(createLocal);
hooks.fn = proto;
hooks.min = min;
hooks.max = max;
hooks.now = now;
hooks.utc = createUTC;
hooks.unix = createUnix;
hooks.months = listMonths;
hooks.isDate = isDate;
hooks.locale = getSetGlobalLocale;
hooks.invalid = createInvalid;
hooks.duration = createDuration;
hooks.isMoment = isMoment;
hooks.weekdays = listWeekdays;
hooks.parseZone = createInZone;
hooks.localeData = getLocale;
hooks.isDuration = isDuration;
hooks.monthsShort = listMonthsShort;
hooks.weekdaysMin = listWeekdaysMin;
hooks.defineLocale = defineLocale;
hooks.updateLocale = updateLocale;
hooks.locales = listLocales;
hooks.weekdaysShort = listWeekdaysShort;
hooks.normalizeUnits = normalizeUnits;
hooks.relativeTimeRounding = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat = getCalendarFormat;
hooks.prototype = proto;
hooks.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
const createConnectUrl = (_t, Et, Pt, $t) => {
  const Bt = CWElementsConfig.getInstance().getConnectURL(), Vt = Et.toLowerCase().replace(/ /g, "_"), zt = `integrations/${_t}.${Vt}`, Ht = new URLSearchParams({
    org_id: Pt
  });
  return `${Bt}${zt}?${Ht.toString()}`;
}, replaceStringParam = (_t, Et, Pt) => {
  if (_t === "")
    return "";
  const $t = `[${Et}]`;
  return Pt ? _t.split($t).join(Pt) : _t;
}, createSetupUrl = (_t, Et, Pt) => {
  if (Et.includes("[property-id]") && _t === "")
    return "";
  const $t = replaceStringParam(Et, "org-id", Pt);
  return replaceStringParam($t, "property-id", _t);
}, checkPropertyId = (_t, Et) => {
  var $t;
  return Et === void 0 || Et === "" ? (($t = _t == null ? void 0 : _t.content[0]) == null ? void 0 : $t.id) ?? "" : Et;
}, useIntegrationsData = ({
  currentOrgId: _t,
  currentOrgCountry: Et,
  callbackAppId: Pt,
  propertyId: $t
}) => {
  const Bt = useConfig$1().getToken(), [Vt, zt] = useState([]), [Ht, Wt] = useState(!1), [Gt, qt] = useState([]), [Kt, Qt] = staticMethods.useNotification(), {
    t: Xt,
    i18n: {
      language: Zt
    }
  } = useTranslation(), {
    cwElementsDeckOfAppsCws11266EnableConnectIntegration: Yt
  } = ie(), Jt = useCallback((Er) => {
    Kt[Er]({
      message: Xt("notifications.error.title"),
      description: Xt("notifications.error.no_data")
    });
  }, [Kt, Xt]), er = useCallback(async () => DeckOfAppsService.getConnectIntegrations().then((Er) => Er).catch((Er) => (Jt("error"), console.error(Er), null)), [Jt]), tr = useCallback(async () => _t ? DeckOfAppsService.getLicensingStatusByOrg(_t).then((Er) => Er).catch((Er) => (Jt("error"), console.error(Er), null)) : null, [_t, Jt]), nr = useCallback(async () => _t ? CWElementsSharedService.getPropertiesByOrg(_t).then((Er) => Er.data).catch() : {
    content: []
  }, [_t]), rr = (Er) => {
    switch (Er) {
      case "module":
        return 2;
      case "product-level":
        return 1;
      case "native":
        return 0;
      default:
        return -1;
    }
  }, [ir, ar] = useState(null), [or, sr] = useState([]), [lr, cr] = useState(!1), [hr, pr] = useState(!1), mr = useCallback((Er, _r) => {
    var ur, vr;
    const yr = Er && Yt.includes(Er.id);
    if (yr) {
      const dr = createConnectUrl(Er == null ? void 0 : Er.partner_enum, Er == null ? void 0 : Er.name, _t ?? "");
      return yr && ((ur = window.open(dr, "_blank")) == null ? void 0 : ur.focus());
    }
    return (Er == null ? void 0 : Er.setup_url) && _t && ((vr = window.open(createSetupUrl(_r, Er == null ? void 0 : Er.setup_url, _t), "_blank")) == null ? void 0 : vr.focus());
  }, [_t, Yt]);
  return useEffect(() => {
    const Er = (vr) => vr[Zt], _r = (vr, dr) => vr == null ? void 0 : vr.map((br) => {
      const Cr = !!(br != null && br.name) && !!(br != null && br.partner_enum);
      return {
        icon: br.icon,
        title: br.name,
        tags: br.tags,
        description: Er(br.description),
        tooltip: Xt("common.tooltip.open_in_new_tab"),
        darkMode: !0,
        onClick: () => mr(br, dr),
        clickable: Cr,
        visible: Cr,
        isConfigured: (br == null ? void 0 : br.is_configured) ?? !1,
        classes: br.classes,
        source: br == null ? void 0 : br.source,
        orderedSource: br != null && br.source ? rr(br == null ? void 0 : br.source) : -1
      };
    }).sort((br, Cr) => br.isConfigured.toString().localeCompare(Cr.isConfigured.toString()) || br.orderedSource.toString().localeCompare(Cr.orderedSource.toString()) || br.title.toString().localeCompare(Cr.title.toString())).sort((br, Cr) => br.classes.includes("ag_insights") ? -1 : Cr.classes.includes("ag_insights") ? 1 : 0), yr = (vr, dr) => {
      const br = hooks(/* @__PURE__ */ new Date()), Pr = dr.apps.filter((xr) => hooks(xr.contract.end) > br).map((xr) => xr.plan).map((xr) => xr.entitlements.map((kr) => kr.key)).flat();
      return vr.filter((xr) => xr.entitlement_key && Pr.includes(xr.entitlement_key) || xr.entitlement_key === "integration.enable");
    }, ur = async () => {
      const vr = () => $t ? {
        content: []
      } : nr(), [dr, br, Cr] = await Promise.all([ir ? or : er(), ir !== _t ? tr() : lr, ir !== _t ? vr() : hr]);
      if (dr && br) {
        ir !== _t && (sr(dr), cr(br), pr(Cr), ar(_t));
        const Pr = yr(dr, br), xr = Et ? Pr.filter((Mr) => Mr.countries.includes(Et)) : Pr, kr = Gt.length > 0, Ir = checkPropertyId(Cr, $t), Ar = kr ? xr.filter((Mr) => {
          const Fr = Mr.supported_applications.map((zr) => zr.id), Dr = Mr.classes.filter((zr) => Gt.includes(zr)).length > 0;
          return Pt && Gt.includes("integrations.filter.active_in") ? Dr || Fr.includes(Pt) : Dr;
        }) : xr;
        zt(_r(Ar, Ir));
      }
      Wt(!1);
    };
    Bt && _t && (Wt(!0), ur());
  }, [Bt, _t, Et, $t, Pt, Gt, ir, er, or, tr, lr, nr, hr, Xt, Zt, mr]), {
    integrationsData: Vt,
    loading: Ht,
    checkedTags: Gt,
    notificationHolder: Qt,
    setCheckedTags: qt
  };
};
loadInitialAssets();
const InnerDeckOfApps = ({
  headerSelector: _t,
  workspaceId: Et,
  orgId: Pt,
  propertyId: $t,
  storeApps: Mt,
  loadingDataFromApp: Bt = !1,
  canChangeHeaderZIndex: Vt = !0,
  afterVisibleChange: zt,
  onLogout: Ht,
  startOpen: Wt
  // tslint:disable-next-line: no-big-function
}) => {
  const {
    t: Gt
  } = useTranslation(), qt = useConfig$1();
  useInitLaunchDarkly(qt), useInitAnalytics();
  const Kt = qt.getHostAppId(), Qt = useRef(null), Xt = useRef(null), Zt = useHeaderMargin(_t), [Yt, Jt] = useState(Wt ?? !1), [er, tr] = useState(!1), {
    loaded: nr,
    loading: rr,
    hasAccess: ir,
    currentAppInfo: ar,
    appsInfo: or,
    currentWorkspaceInfo: sr,
    currentOrgInfo: lr,
    currentPropertyInfo: cr
  } = useAppsData({
    callbackAppId: Kt,
    currentWorkspaceId: Et,
    currentOrgId: Pt,
    currentPropertyId: $t,
    storeApps: Mt,
    loadingDataFromApp: Bt
  }), {
    loading: hr,
    integrationsData: pr,
    checkedTags: mr,
    setCheckedTags: Er,
    notificationHolder: _r
  } = useIntegrationsData({
    currentOrgId: Pt,
    currentOrgCountry: lr == null ? void 0 : lr.country,
    callbackAppId: Kt,
    propertyId: $t
  }), yr = useMemo$1(() => ({
    workspaceId: Et,
    workspaceName: sr == null ? void 0 : sr.name,
    organizationId: Pt,
    organizationName: lr == null ? void 0 : lr.name,
    farmId: $t,
    farmName: cr == null ? void 0 : cr.name,
    product: Kt
  }), [Et, sr == null ? void 0 : sr.name, Pt, $t, lr == null ? void 0 : lr.name, cr == null ? void 0 : cr.name, Kt]), [ur, vr] = useState(), dr = useAnalytics();
  useLayoutEffect$1(() => {
    if (Xt != null && Xt.current) {
      const {
        clientHeight: $r,
        scrollHeight: Rr
      } = Xt.current;
      if ($r && Rr) {
        const Or = $r < Rr;
        tr(Or);
      }
    }
  }, [Xt, Yt]), useLayoutEffect$1(() => {
    if (Vt && _t) {
      const $r = document.querySelector(_t);
      if ($r) {
        const Rr = getComputedStyle($r).position, Or = getComputedStyle($r).zIndex;
        Rr === "static" && ($r.style.position = "relative"), Or === "auto" && ($r.style.zIndex = "1000");
      }
    }
  }, [Vt, _t]), useEffect(() => {
    const $r = async () => {
      const Rr = await CWElementsSharedService.getCurrentUser();
      Rr && vr(Rr);
    };
    qt.addCallbackAfterSetToken(() => $r().catch());
  }, [qt]), useEffect(() => {
    function $r() {
      Jt(!1), setTimeout(() => {
        zt == null || zt(!1);
      }, 100);
    }
    return window.addEventListener(MFE_OPENED, $r), () => window.removeEventListener(MFE_OPENED, $r);
  }, [zt]);
  const br = useCallback(() => {
    Jt(!Yt), setTimeout(() => {
      zt == null || zt(!Yt);
    }, 100), dr("Opened Deck of Apps Component", yr);
  }, [Yt, yr, zt, dr]), Cr = useCallback(($r, Rr) => {
    var Or;
    dr($r, yr), (Or = window.open(Rr, "_blank")) == null || Or.focus();
  }, [dr, yr]), Pr = useCallback(($r) => {
    const Rr = new URLSearchParams();
    Et && Rr.set("workspace", Et), Pt && Rr.set("organization", Pt), $t && Rr.set("farm", $t);
    const Or = Rr.toString();
    return Or ? `${$r}?${Or}` : $r;
  }, [Pt, $t, Et]), xr = ($r) => {
    const Rr = $r.split(" "), Or = Rr[0], Lr = Rr[Rr.length - 1];
    return Rr.length >= 2 ? `${Or.charAt(0).toUpperCase()}${Lr.charAt(0).toUpperCase()}` : Or.charAt(0).toUpperCase();
  }, [kr, Ir] = useState(0), [Ar, Mr] = useState(!0), Fr = ($r) => {
    const Rr = $r.target.scrollTop;
    kr === 0 && Ir(Rr), kr < Rr ? (Mr(!0), Ir(Rr)) : (Mr(!1), Ir(Rr)), tr(!Ar);
  }, Dr = () => lr && !hr && !(pr.length > 0 || mr.length > 0), zr = ($r) => $r.site_uri === "" || $r.site_uri === null ? !!($r.apple_store_uri || $r.play_store_uri) : !0, Tr = () => Pt === void 0 ? !0 : !(lr && !hr && (pr.length > 0 || mr.length > 0) && Pt !== void 0), Gr = useMemo$1(() => or.reduce(($r, Rr) => {
    if (Rr.id === FARM_SETTINGS_ID || Rr.type === TYPE_MODULE || !zr(Rr))
      return $r;
    const {
      name: Lr,
      image_uri: Hr,
      site_uri: Wr,
      icon_uri: Kr,
      apple_store_uri: Ur,
      play_store_uri: Zr,
      detailed_description: Xr,
      site_uri: mn
    } = Rr;
    return $r.push({
      name: Lr,
      logo: Kr,
      background: Hr,
      onClick: () => Wr && Cr("Deck of Apps - Go to other Product", Pr(Wr)),
      workspaceId: Et,
      orgId: Pt,
      propertyId: $t,
      apple_store_uri: Ur,
      play_store_uri: Zr,
      detailed_description: Xr,
      site_uri: mn
    }), $r;
  }, []), [or, Cr, Et, Pt, $t, Pr]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MainWrapper, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ot$1, { theme, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ConfigProvider, { prefixCls: "cw-elements", children: [
    _r,
    /* @__PURE__ */ jsxRuntimeExports.jsx(BtnWrapper, { $opened: Yt, onClick: br, onMouseEnter: () => {
      var $r;
      return ($r = Qt.current) == null ? void 0 : $r.play();
    }, "data-testid": "deckOfAppsButton", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Player, { ref: Qt, hover: !0, src: animatedDeckIcon, style: {
      width: "24px",
      height: "24px",
      zIndex: 0
    } }) }),
    nr.apps && nr.currentApp && ir === !1 && /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledModal, { title: !1, footer: null, closable: !1, open: ir === !1, width: 920, style: {
      padding: 0
    }, styles: {
      body: {
        padding: 0
      }
    }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledNoAccess, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(NoAccessContent, { currentAppInfo: ar, workspaceId: Et, onLogout: Ht })
    ] }),
    createPortal(/* @__PURE__ */ jsxRuntimeExports.jsxs(DrawerWrapper, { $visible: Yt, "aria-hidden": !Yt, role: "dialog", "aria-label": "deck of apps", style: {
      marginTop: Zt,
      height: `calc(100vh - ${Zt}px)`,
      pointerEvents: Yt ? "auto" : "none",
      transform: Yt ? "translateY(0)" : `translateY(calc(-100% - ${2 * Zt}px))`
    }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(LeftWrapper, { ref: Xt, onScroll: Fr, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(AppGroup, { title: Gt("apps.title"), loading: rr.apps, apps: Gr }),
        Pt === void 0 || !Dr() && /* @__PURE__ */ jsxRuntimeExports.jsx(IntegrationGroup, { title: Gt("integrations.title"), loading: hr, integrations: pr, currentAppLogo: ar == null ? void 0 : ar.icon_uri, checkedTags: mr, setCheckedTags: Er, empty: Tr() }),
        er && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: {
          position: "sticky",
          bottom: "0px",
          height: "130px",
          background: "linear-gradient(180deg, rgba(35, 38, 48, 0) 0%, rgba(35, 38, 48, 0.8) 100%)"
        } })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(RightWrapper, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(DefaultSettingsGroups, { component: "Deck of Apps", workspaceId: Et, workspaceName: sr == null ? void 0 : sr.name, orgId: Pt, orgName: lr == null ? void 0 : lr.name, orgCountry: lr == null ? void 0 : lr.country, orgSource: lr == null ? void 0 : lr.source, propertyId: $t, propertyName: cr == null ? void 0 : cr.name, dark: !0, accountId: ur == null ? void 0 : ur.id }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "cws-deck-of-apps-access-account", children: /* @__PURE__ */ jsxRuntimeExports.jsx(AccessAccount, { avatar: ur ? xr(ur.name) : "" }) })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(CloseWrapper, { onClick: br, children: /* @__PURE__ */ jsxRuntimeExports.jsx(RefIcon$6, {}) })
    ] }), document.body)
  ] }) }) });
}, NoAccessContent = ({
  currentAppInfo: _t,
  workspaceId: Et,
  onLogout: Pt
}) => {
  const $t = useConfig$1(), {
    t: Mt
  } = useTranslation(), {
    imgSrc: Bt,
    onImgError: Vt
  } = useDefaultIcon(_t == null ? void 0 : _t.icon_uri), zt = useCallback(() => {
    const Ht = Et ? `?id=${Et}` : "";
    window.location.href = `${$t.getAccountsURL()}${Ht}`;
  }, [Et, $t]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    Bt.error ? Bt.src : /* @__PURE__ */ jsxRuntimeExports.jsx(AppIcon, { src: Bt.src, onError: Vt, alt: "" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "title", children: `${Mt("no_access_modal.popup.no_access")} ${(_t == null ? void 0 : _t.name) || Mt("no_access_modal.popup.this_application")} ${Mt("no_access_modal.popup.yet")}` }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "regular", children: [
      Mt("no_access_modal.popup.contact_support_to_upgrade_plan"),
      /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
      `${Mt("no_access_modal.popup.start_using")} ${(_t == null ? void 0 : _t.name) || Mt("no_access_modal.popup.this_application")}.`
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "buttons-container", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(LogoutBtn, { type: "default", onClick: Pt, children: Mt("no_access_modal.popup.logout") }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(GoToAccountsBtn, { type: "primary", onClick: zt, children: Mt("no_access_modal.popup.go_to_cropwise") })
    ] })
  ] });
}, DeckOfApps = (_t) => {
  const Et = useConfig$1();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CWElementsI18NProvider, { ns: "deck-of-apps", children: /* @__PURE__ */ jsxRuntimeExports.jsx(K, { clientSideID: Et.getLaunchDarklyClientID(), children: /* @__PURE__ */ jsxRuntimeExports.jsx(InnerDeckOfApps, { ..._t }) }) });
};
export {
  DeckOfApps
};
